/**
 * Borrowed from documentReady node module
 *
 * jQuery 3 changes the behavior of the $(document).ready to always run asynchronously.
 * Previously, if the document was ready at the time of the function being called, it would run immediately.
 *
 * We are providing the older method approach here to keep the loading order consistent with
 * previous jQuery versions, avoiding the library altogether.
 **/
function documentReady(callback) {
  if (typeof document === 'undefined') {
    throw new Error('document-ready only runs in the browser');
  }
  var state = document.readyState;
  if (state === 'complete' || state === 'interactive') {
    return setTimeout(callback, 0);
  }

  document.addEventListener('DOMContentLoaded', function onLoad() {
    callback();
  });
};
/*!
 * jQuery JavaScript Library v3.6.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-08-26T17:52Z
 */
( function( global, factory ) {

  "use strict";

  if ( typeof module === "object" && typeof module.exports === "object" ) {

    // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ?
      factory( global, true ) :
      function( w ) {
        if ( !w.document ) {
          throw new Error( "jQuery requires a window with a document" );
        }
        return factory( w );
      };
  } else {
    factory( global );
  }

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
  "use strict";

  var arr = [];

  var getProto = Object.getPrototypeOf;

  var slice = arr.slice;

  var flat = arr.flat ? function( array ) {
    return arr.flat.call( array );
  } : function( array ) {
    return arr.concat.apply( [], array );
  };


  var push = arr.push;

  var indexOf = arr.indexOf;

  var class2type = {};

  var toString = class2type.toString;

  var hasOwn = class2type.hasOwnProperty;

  var fnToString = hasOwn.toString;

  var ObjectFunctionString = fnToString.call( Object );

  var support = {};

  var isFunction = function isFunction( obj ) {

    // Support: Chrome <=57, Firefox <=52
    // In some browsers, typeof returns "function" for HTML <object> elements
    // (i.e., `typeof document.createElement( "object" ) === "function"`).
    // We don't want to classify *any* DOM node as a function.
    // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
    // Plus for old WebKit, typeof returns "function" for HTML collections
    // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
    return typeof obj === "function" && typeof obj.nodeType !== "number" &&
      typeof obj.item !== "function";
  };


  var isWindow = function isWindow( obj ) {
    return obj != null && obj === obj.window;
  };


  var document = window.document;



  var preservedScriptAttributes = {
    type: true,
    src: true,
    nonce: true,
    noModule: true
  };

  function DOMEval( code, node, doc ) {
    doc = doc || document;

    var i, val,
      script = doc.createElement( "script" );

    script.text = code;
    if ( node ) {
      for ( i in preservedScriptAttributes ) {

        // Support: Firefox 64+, Edge 18+
        // Some browsers don't support the "nonce" property on scripts.
        // On the other hand, just using `getAttribute` is not enough as
        // the `nonce` attribute is reset to an empty string whenever it
        // becomes browsing-context connected.
        // See https://github.com/whatwg/html/issues/2369
        // See https://html.spec.whatwg.org/#nonce-attributes
        // The `node.getAttribute` check was added for the sake of
        // `jQuery.globalEval` so that it can fake a nonce-containing node
        // via an object.
        val = node[ i ] || node.getAttribute && node.getAttribute( i );
        if ( val ) {
          script.setAttribute( i, val );
        }
      }
    }
    doc.head.appendChild( script ).parentNode.removeChild( script );
  }


  function toType( obj ) {
    if ( obj == null ) {
      return obj + "";
    }

    // Support: Android <=2.3 only (functionish RegExp)
    return typeof obj === "object" || typeof obj === "function" ?
      class2type[ toString.call( obj ) ] || "object" :
      typeof obj;
  }
  /* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



  var
    version = "3.6.1",

    // Define a local copy of jQuery
    jQuery = function( selector, context ) {

      // The jQuery object is actually just the init constructor 'enhanced'
      // Need init if jQuery is called (just allow error to be thrown if not included)
      return new jQuery.fn.init( selector, context );
    };

  jQuery.fn = jQuery.prototype = {

    // The current version of jQuery being used
    jquery: version,

    constructor: jQuery,

    // The default length of a jQuery object is 0
    length: 0,

    toArray: function() {
      return slice.call( this );
    },

    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function( num ) {

      // Return all the elements in a clean array
      if ( num == null ) {
        return slice.call( this );
      }

      // Return just the one element from the set
      return num < 0 ? this[ num + this.length ] : this[ num ];
    },

    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function( elems ) {

      // Build a new jQuery matched element set
      var ret = jQuery.merge( this.constructor(), elems );

      // Add the old object onto the stack (as a reference)
      ret.prevObject = this;

      // Return the newly-formed element set
      return ret;
    },

    // Execute a callback for every element in the matched set.
    each: function( callback ) {
      return jQuery.each( this, callback );
    },

    map: function( callback ) {
      return this.pushStack( jQuery.map( this, function( elem, i ) {
        return callback.call( elem, i, elem );
      } ) );
    },

    slice: function() {
      return this.pushStack( slice.apply( this, arguments ) );
    },

    first: function() {
      return this.eq( 0 );
    },

    last: function() {
      return this.eq( -1 );
    },

    even: function() {
      return this.pushStack( jQuery.grep( this, function( _elem, i ) {
        return ( i + 1 ) % 2;
      } ) );
    },

    odd: function() {
      return this.pushStack( jQuery.grep( this, function( _elem, i ) {
        return i % 2;
      } ) );
    },

    eq: function( i ) {
      var len = this.length,
        j = +i + ( i < 0 ? len : 0 );
      return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
    },

    end: function() {
      return this.prevObject || this.constructor();
    },

    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: push,
    sort: arr.sort,
    splice: arr.splice
  };

  jQuery.extend = jQuery.fn.extend = function() {
    var options, name, src, copy, copyIsArray, clone,
      target = arguments[ 0 ] || {},
      i = 1,
      length = arguments.length,
      deep = false;

    // Handle a deep copy situation
    if ( typeof target === "boolean" ) {
      deep = target;

      // Skip the boolean and the target
      target = arguments[ i ] || {};
      i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if ( typeof target !== "object" && !isFunction( target ) ) {
      target = {};
    }

    // Extend jQuery itself if only one argument is passed
    if ( i === length ) {
      target = this;
      i--;
    }

    for ( ; i < length; i++ ) {

      // Only deal with non-null/undefined values
      if ( ( options = arguments[ i ] ) != null ) {

        // Extend the base object
        for ( name in options ) {
          copy = options[ name ];

          // Prevent Object.prototype pollution
          // Prevent never-ending loop
          if ( name === "__proto__" || target === copy ) {
            continue;
          }

          // Recurse if we're merging plain objects or arrays
          if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
            ( copyIsArray = Array.isArray( copy ) ) ) ) {
            src = target[ name ];

            // Ensure proper type for the source value
            if ( copyIsArray && !Array.isArray( src ) ) {
              clone = [];
            } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
              clone = {};
            } else {
              clone = src;
            }
            copyIsArray = false;

            // Never move original objects, clone them
            target[ name ] = jQuery.extend( deep, clone, copy );

            // Don't bring in undefined values
          } else if ( copy !== undefined ) {
            target[ name ] = copy;
          }
        }
      }
    }

    // Return the modified object
    return target;
  };

  jQuery.extend( {

    // Unique for each copy of jQuery on the page
    expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

    // Assume jQuery is ready without the ready module
    isReady: true,

    error: function( msg ) {
      throw new Error( msg );
    },

    noop: function() {},

    isPlainObject: function( obj ) {
      var proto, Ctor;

      // Detect obvious negatives
      // Use toString instead of jQuery.type to catch host objects
      if ( !obj || toString.call( obj ) !== "[object Object]" ) {
        return false;
      }

      proto = getProto( obj );

      // Objects with no prototype (e.g., `Object.create( null )`) are plain
      if ( !proto ) {
        return true;
      }

      // Objects with prototype are plain iff they were constructed by a global Object function
      Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
      return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
    },

    isEmptyObject: function( obj ) {
      var name;

      for ( name in obj ) {
        return false;
      }
      return true;
    },

    // Evaluates a script in a provided context; falls back to the global one
    // if not specified.
    globalEval: function( code, options, doc ) {
      DOMEval( code, { nonce: options && options.nonce }, doc );
    },

    each: function( obj, callback ) {
      var length, i = 0;

      if ( isArrayLike( obj ) ) {
        length = obj.length;
        for ( ; i < length; i++ ) {
          if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
            break;
          }
        }
      } else {
        for ( i in obj ) {
          if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
            break;
          }
        }
      }

      return obj;
    },

    // results is for internal usage only
    makeArray: function( arr, results ) {
      var ret = results || [];

      if ( arr != null ) {
        if ( isArrayLike( Object( arr ) ) ) {
          jQuery.merge( ret,
            typeof arr === "string" ?
              [ arr ] : arr
          );
        } else {
          push.call( ret, arr );
        }
      }

      return ret;
    },

    inArray: function( elem, arr, i ) {
      return arr == null ? -1 : indexOf.call( arr, elem, i );
    },

    // Support: Android <=4.0 only, PhantomJS 1 only
    // push.apply(_, arraylike) throws on ancient WebKit
    merge: function( first, second ) {
      var len = +second.length,
        j = 0,
        i = first.length;

      for ( ; j < len; j++ ) {
        first[ i++ ] = second[ j ];
      }

      first.length = i;

      return first;
    },

    grep: function( elems, callback, invert ) {
      var callbackInverse,
        matches = [],
        i = 0,
        length = elems.length,
        callbackExpect = !invert;

      // Go through the array, only saving the items
      // that pass the validator function
      for ( ; i < length; i++ ) {
        callbackInverse = !callback( elems[ i ], i );
        if ( callbackInverse !== callbackExpect ) {
          matches.push( elems[ i ] );
        }
      }

      return matches;
    },

    // arg is for internal usage only
    map: function( elems, callback, arg ) {
      var length, value,
        i = 0,
        ret = [];

      // Go through the array, translating each of the items to their new values
      if ( isArrayLike( elems ) ) {
        length = elems.length;
        for ( ; i < length; i++ ) {
          value = callback( elems[ i ], i, arg );

          if ( value != null ) {
            ret.push( value );
          }
        }

        // Go through every key on the object,
      } else {
        for ( i in elems ) {
          value = callback( elems[ i ], i, arg );

          if ( value != null ) {
            ret.push( value );
          }
        }
      }

      // Flatten any nested arrays
      return flat( ret );
    },

    // A global GUID counter for objects
    guid: 1,

    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: support
  } );

  if ( typeof Symbol === "function" ) {
    jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
  }

// Populate the class2type map
  jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
    function( _i, name ) {
      class2type[ "[object " + name + "]" ] = name.toLowerCase();
    } );

  function isArrayLike( obj ) {

    // Support: real iOS 8.2 only (not reproducible in simulator)
    // `in` check used to prevent JIT error (gh-2145)
    // hasOwn isn't used here due to false negatives
    // regarding Nodelist length in IE
    var length = !!obj && "length" in obj && obj.length,
      type = toType( obj );

    if ( isFunction( obj ) || isWindow( obj ) ) {
      return false;
    }

    return type === "array" || length === 0 ||
      typeof length === "number" && length > 0 && ( length - 1 ) in obj;
  }
  var Sizzle =
    /*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
    ( function( window ) {
      var i,
        support,
        Expr,
        getText,
        isXML,
        tokenize,
        compile,
        select,
        outermostContext,
        sortInput,
        hasDuplicate,

        // Local document vars
        setDocument,
        document,
        docElem,
        documentIsHTML,
        rbuggyQSA,
        rbuggyMatches,
        matches,
        contains,

        // Instance-specific data
        expando = "sizzle" + 1 * new Date(),
        preferredDoc = window.document,
        dirruns = 0,
        done = 0,
        classCache = createCache(),
        tokenCache = createCache(),
        compilerCache = createCache(),
        nonnativeSelectorCache = createCache(),
        sortOrder = function( a, b ) {
          if ( a === b ) {
            hasDuplicate = true;
          }
          return 0;
        },

        // Instance methods
        hasOwn = ( {} ).hasOwnProperty,
        arr = [],
        pop = arr.pop,
        pushNative = arr.push,
        push = arr.push,
        slice = arr.slice,

        // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function( list, elem ) {
          var i = 0,
            len = list.length;
          for ( ; i < len; i++ ) {
            if ( list[ i ] === elem ) {
              return i;
            }
          }
          return -1;
        },

        booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
          "ismap|loop|multiple|open|readonly|required|scoped",

        // Regular expressions

        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]",

        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
          "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

        // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

          // Operator (capture 2)
          "*([*^$|!~]?=)" + whitespace +

          // "Attribute values must be CSS identifiers [capture 5]
          // or strings [capture 3 or capture 4]"
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
          whitespace + "*\\]",

        pseudos = ":(" + identifier + ")(?:\\((" +

          // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
          // 1. quoted (capture 3; capture 4 or capture 5)
          "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

          // 2. simple (capture 6)
          "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

          // 3. anything else (capture 2)
          ".*" +
          ")\\)|)",

        // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp( whitespace + "+", "g" ),
        rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
          whitespace + "+$", "g" ),

        rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
        rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
          "*" ),
        rdescend = new RegExp( whitespace + "|>" ),

        rpseudo = new RegExp( pseudos ),
        ridentifier = new RegExp( "^" + identifier + "$" ),

        matchExpr = {
          "ID": new RegExp( "^#(" + identifier + ")" ),
          "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
          "TAG": new RegExp( "^(" + identifier + "|[*])" ),
          "ATTR": new RegExp( "^" + attributes ),
          "PSEUDO": new RegExp( "^" + pseudos ),
          "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
            whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
          "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

          // For use in libraries implementing .is()
          // We use this for POS matching in `select`
          "needsContext": new RegExp( "^" + whitespace +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
            "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
        },

        rhtml = /HTML$/i,
        rinputs = /^(?:input|select|textarea|button)$/i,
        rheader = /^h\d$/i,

        rnative = /^[^{]+\{\s*\[native \w/,

        // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

        rsibling = /[+~]/,

        // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
        funescape = function( escape, nonHex ) {
          var high = "0x" + escape.slice( 1 ) - 0x10000;

          return nonHex ?

            // Strip the backslash prefix from a non-hex escape sequence
            nonHex :

            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ?
              String.fromCharCode( high + 0x10000 ) :
              String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
        },

        // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        fcssescape = function( ch, asCodePoint ) {
          if ( asCodePoint ) {

            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if ( ch === "\0" ) {
              return "\uFFFD";
            }

            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice( 0, -1 ) + "\\" +
              ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
          }

          // Other potentially-special ASCII characters get backslash-escaped
          return "\\" + ch;
        },

        // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
          setDocument();
        },

        inDisabledFieldset = addCombinator(
          function( elem ) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
          },
          { dir: "parentNode", next: "legend" }
        );

// Optimize for push.apply( _, NodeList )
      try {
        push.apply(
          ( arr = slice.call( preferredDoc.childNodes ) ),
          preferredDoc.childNodes
        );

        // Support: Android<4.0
        // Detect silently failing push.apply
        // eslint-disable-next-line no-unused-expressions
        arr[ preferredDoc.childNodes.length ].nodeType;
      } catch ( e ) {
        push = { apply: arr.length ?

            // Leverage slice if possible
            function( target, els ) {
              pushNative.apply( target, slice.call( els ) );
            } :

            // Support: IE<9
            // Otherwise append directly
            function( target, els ) {
              var j = target.length,
                i = 0;

              // Can't trust NodeList.length
              while ( ( target[ j++ ] = els[ i++ ] ) ) {}
              target.length = j - 1;
            }
        };
      }

      function Sizzle( selector, context, results, seed ) {
        var m, i, elem, nid, match, groups, newSelector,
          newContext = context && context.ownerDocument,

          // nodeType defaults to 9, since context defaults to document
          nodeType = context ? context.nodeType : 9;

        results = results || [];

        // Return early from calls with invalid selector or context
        if ( typeof selector !== "string" || !selector ||
          nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

          return results;
        }

        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if ( !seed ) {
          setDocument( context );
          context = context || document;

          if ( documentIsHTML ) {

            // If the selector is sufficiently simple, try using a "get*By*" DOM method
            // (excepting DocumentFragment context, where the methods don't exist)
            if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

              // ID selector
              if ( ( m = match[ 1 ] ) ) {

                // Document context
                if ( nodeType === 9 ) {
                  if ( ( elem = context.getElementById( m ) ) ) {

                    // Support: IE, Opera, Webkit
                    // TODO: identify versions
                    // getElementById can match elements by name instead of ID
                    if ( elem.id === m ) {
                      results.push( elem );
                      return results;
                    }
                  } else {
                    return results;
                  }

                  // Element context
                } else {

                  // Support: IE, Opera, Webkit
                  // TODO: identify versions
                  // getElementById can match elements by name instead of ID
                  if ( newContext && ( elem = newContext.getElementById( m ) ) &&
                    contains( context, elem ) &&
                    elem.id === m ) {

                    results.push( elem );
                    return results;
                  }
                }

                // Type selector
              } else if ( match[ 2 ] ) {
                push.apply( results, context.getElementsByTagName( selector ) );
                return results;

                // Class selector
              } else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
                context.getElementsByClassName ) {

                push.apply( results, context.getElementsByClassName( m ) );
                return results;
              }
            }

            // Take advantage of querySelectorAll
            if ( support.qsa &&
              !nonnativeSelectorCache[ selector + " " ] &&
              ( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

              // Support: IE 8 only
              // Exclude object elements
              ( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

              newSelector = selector;
              newContext = context;

              // qSA considers elements outside a scoping root when evaluating child or
              // descendant combinators, which is not what we want.
              // In such cases, we work around the behavior by prefixing every selector in the
              // list with an ID selector referencing the scope context.
              // The technique has to be used as well when a leading combinator is used
              // as such selectors are not recognized by querySelectorAll.
              // Thanks to Andrew Dupont for this technique.
              if ( nodeType === 1 &&
                ( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

                // Expand context for sibling selectors
                newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                  context;

                // We can use :scope instead of the ID hack if the browser
                // supports it & if we're not changing the context.
                if ( newContext !== context || !support.scope ) {

                  // Capture the context ID, setting it first if necessary
                  if ( ( nid = context.getAttribute( "id" ) ) ) {
                    nid = nid.replace( rcssescape, fcssescape );
                  } else {
                    context.setAttribute( "id", ( nid = expando ) );
                  }
                }

                // Prefix every selector in the list
                groups = tokenize( selector );
                i = groups.length;
                while ( i-- ) {
                  groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
                    toSelector( groups[ i ] );
                }
                newSelector = groups.join( "," );
              }

              try {
                push.apply( results,
                  newContext.querySelectorAll( newSelector )
                );
                return results;
              } catch ( qsaError ) {
                nonnativeSelectorCache( selector, true );
              } finally {
                if ( nid === expando ) {
                  context.removeAttribute( "id" );
                }
              }
            }
          }
        }

        // All others
        return select( selector.replace( rtrim, "$1" ), context, results, seed );
      }

      /**
       * Create key-value caches of limited size
       * @returns {function(string, object)} Returns the Object data after storing it on itself with
       *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
       *	deleting the oldest entry
       */
      function createCache() {
        var keys = [];

        function cache( key, value ) {

          // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
          if ( keys.push( key + " " ) > Expr.cacheLength ) {

            // Only keep the most recent entries
            delete cache[ keys.shift() ];
          }
          return ( cache[ key + " " ] = value );
        }
        return cache;
      }

      /**
       * Mark a function for special use by Sizzle
       * @param {Function} fn The function to mark
       */
      function markFunction( fn ) {
        fn[ expando ] = true;
        return fn;
      }

      /**
       * Support testing using an element
       * @param {Function} fn Passed the created element and returns a boolean result
       */
      function assert( fn ) {
        var el = document.createElement( "fieldset" );

        try {
          return !!fn( el );
        } catch ( e ) {
          return false;
        } finally {

          // Remove from its parent by default
          if ( el.parentNode ) {
            el.parentNode.removeChild( el );
          }

          // release memory in IE
          el = null;
        }
      }

      /**
       * Adds the same handler for all of the specified attrs
       * @param {String} attrs Pipe-separated list of attributes
       * @param {Function} handler The method that will be applied
       */
      function addHandle( attrs, handler ) {
        var arr = attrs.split( "|" ),
          i = arr.length;

        while ( i-- ) {
          Expr.attrHandle[ arr[ i ] ] = handler;
        }
      }

      /**
       * Checks document order of two siblings
       * @param {Element} a
       * @param {Element} b
       * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
       */
      function siblingCheck( a, b ) {
        var cur = b && a,
          diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
            a.sourceIndex - b.sourceIndex;

        // Use IE sourceIndex if available on both nodes
        if ( diff ) {
          return diff;
        }

        // Check if b follows a
        if ( cur ) {
          while ( ( cur = cur.nextSibling ) ) {
            if ( cur === b ) {
              return -1;
            }
          }
        }

        return a ? 1 : -1;
      }

      /**
       * Returns a function to use in pseudos for input types
       * @param {String} type
       */
      function createInputPseudo( type ) {
        return function( elem ) {
          var name = elem.nodeName.toLowerCase();
          return name === "input" && elem.type === type;
        };
      }

      /**
       * Returns a function to use in pseudos for buttons
       * @param {String} type
       */
      function createButtonPseudo( type ) {
        return function( elem ) {
          var name = elem.nodeName.toLowerCase();
          return ( name === "input" || name === "button" ) && elem.type === type;
        };
      }

      /**
       * Returns a function to use in pseudos for :enabled/:disabled
       * @param {Boolean} disabled true for :disabled; false for :enabled
       */
      function createDisabledPseudo( disabled ) {

        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function( elem ) {

          // Only certain elements can match :enabled or :disabled
          // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
          // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
          if ( "form" in elem ) {

            // Check for inherited disabledness on relevant non-disabled elements:
            // * listed form-associated elements in a disabled fieldset
            //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
            //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
            // * option elements in a disabled optgroup
            //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
            // All such elements have a "form" property.
            if ( elem.parentNode && elem.disabled === false ) {

              // Option elements defer to a parent optgroup if present
              if ( "label" in elem ) {
                if ( "label" in elem.parentNode ) {
                  return elem.parentNode.disabled === disabled;
                } else {
                  return elem.disabled === disabled;
                }
              }

              // Support: IE 6 - 11
              // Use the isDisabled shortcut property to check for disabled fieldset ancestors
              return elem.isDisabled === disabled ||

                // Where there is no isDisabled, check manually
                /* jshint -W018 */
                elem.isDisabled !== !disabled &&
                inDisabledFieldset( elem ) === disabled;
            }

            return elem.disabled === disabled;

            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
          } else if ( "label" in elem ) {
            return elem.disabled === disabled;
          }

          // Remaining elements are neither :enabled nor :disabled
          return false;
        };
      }

      /**
       * Returns a function to use in pseudos for positionals
       * @param {Function} fn
       */
      function createPositionalPseudo( fn ) {
        return markFunction( function( argument ) {
          argument = +argument;
          return markFunction( function( seed, matches ) {
            var j,
              matchIndexes = fn( [], seed.length, argument ),
              i = matchIndexes.length;

            // Match elements found at the specified indexes
            while ( i-- ) {
              if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
                seed[ j ] = !( matches[ j ] = seed[ j ] );
              }
            }
          } );
        } );
      }

      /**
       * Checks a node for validity as a Sizzle context
       * @param {Element|Object=} context
       * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
       */
      function testContext( context ) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
      }

// Expose support vars for convenience
      support = Sizzle.support = {};

      /**
       * Detects XML nodes
       * @param {Element|Object} elem An element or a document
       * @returns {Boolean} True iff elem is a non-HTML XML node
       */
      isXML = Sizzle.isXML = function( elem ) {
        var namespace = elem && elem.namespaceURI,
          docElem = elem && ( elem.ownerDocument || elem ).documentElement;

        // Support: IE <=8
        // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
        // https://bugs.jquery.com/ticket/4833
        return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
      };

      /**
       * Sets document-related variables once based on the current document
       * @param {Element|Object} [doc] An element or document object to use to set the document
       * @returns {Object} Returns the current document
       */
      setDocument = Sizzle.setDocument = function( node ) {
        var hasCompare, subWindow,
          doc = node ? node.ownerDocument || node : preferredDoc;

        // Return early if doc is invalid or already selected
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
          return document;
        }

        // Update global variables
        document = doc;
        docElem = document.documentElement;
        documentIsHTML = !isXML( document );

        // Support: IE 9 - 11+, Edge 12 - 18+
        // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if ( preferredDoc != document &&
          ( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

          // Support: IE 11, Edge
          if ( subWindow.addEventListener ) {
            subWindow.addEventListener( "unload", unloadHandler, false );

            // Support: IE 9 - 10 only
          } else if ( subWindow.attachEvent ) {
            subWindow.attachEvent( "onunload", unloadHandler );
          }
        }

        // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
        // Safari 4 - 5 only, Opera <=11.6 - 12.x only
        // IE/Edge & older browsers don't support the :scope pseudo-class.
        // Support: Safari 6.0 only
        // Safari 6.0 supports :scope but it's an alias of :root there.
        support.scope = assert( function( el ) {
          docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
          return typeof el.querySelectorAll !== "undefined" &&
            !el.querySelectorAll( ":scope fieldset div" ).length;
        } );

        /* Attributes
	---------------------------------------------------------------------- */

        // Support: IE<8
        // Verify that getAttribute really returns attributes and not properties
        // (excepting IE8 booleans)
        support.attributes = assert( function( el ) {
          el.className = "i";
          return !el.getAttribute( "className" );
        } );

        /* getElement(s)By*
	---------------------------------------------------------------------- */

        // Check if getElementsByTagName("*") returns only elements
        support.getElementsByTagName = assert( function( el ) {
          el.appendChild( document.createComment( "" ) );
          return !el.getElementsByTagName( "*" ).length;
        } );

        // Support: IE<9
        support.getElementsByClassName = rnative.test( document.getElementsByClassName );

        // Support: IE<10
        // Check if getElementById returns elements by name
        // The broken getElementById methods don't pick up programmatically-set names,
        // so use a roundabout getElementsByName test
        support.getById = assert( function( el ) {
          docElem.appendChild( el ).id = expando;
          return !document.getElementsByName || !document.getElementsByName( expando ).length;
        } );

        // ID filter and find
        if ( support.getById ) {
          Expr.filter[ "ID" ] = function( id ) {
            var attrId = id.replace( runescape, funescape );
            return function( elem ) {
              return elem.getAttribute( "id" ) === attrId;
            };
          };
          Expr.find[ "ID" ] = function( id, context ) {
            if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
              var elem = context.getElementById( id );
              return elem ? [ elem ] : [];
            }
          };
        } else {
          Expr.filter[ "ID" ] =  function( id ) {
            var attrId = id.replace( runescape, funescape );
            return function( elem ) {
              var node = typeof elem.getAttributeNode !== "undefined" &&
                elem.getAttributeNode( "id" );
              return node && node.value === attrId;
            };
          };

          // Support: IE 6 - 7 only
          // getElementById is not reliable as a find shortcut
          Expr.find[ "ID" ] = function( id, context ) {
            if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
              var node, i, elems,
                elem = context.getElementById( id );

              if ( elem ) {

                // Verify the id attribute
                node = elem.getAttributeNode( "id" );
                if ( node && node.value === id ) {
                  return [ elem ];
                }

                // Fall back on getElementsByName
                elems = context.getElementsByName( id );
                i = 0;
                while ( ( elem = elems[ i++ ] ) ) {
                  node = elem.getAttributeNode( "id" );
                  if ( node && node.value === id ) {
                    return [ elem ];
                  }
                }
              }

              return [];
            }
          };
        }

        // Tag
        Expr.find[ "TAG" ] = support.getElementsByTagName ?
          function( tag, context ) {
            if ( typeof context.getElementsByTagName !== "undefined" ) {
              return context.getElementsByTagName( tag );

              // DocumentFragment nodes don't have gEBTN
            } else if ( support.qsa ) {
              return context.querySelectorAll( tag );
            }
          } :

          function( tag, context ) {
            var elem,
              tmp = [],
              i = 0,

              // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
              results = context.getElementsByTagName( tag );

            // Filter out possible comments
            if ( tag === "*" ) {
              while ( ( elem = results[ i++ ] ) ) {
                if ( elem.nodeType === 1 ) {
                  tmp.push( elem );
                }
              }

              return tmp;
            }
            return results;
          };

        // Class
        Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
          if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
            return context.getElementsByClassName( className );
          }
        };

        /* QSA/matchesSelector
	---------------------------------------------------------------------- */

        // QSA and matchesSelector support

        // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
        rbuggyMatches = [];

        // qSa(:focus) reports false when true (Chrome 21)
        // We allow this because of a bug in IE8/9 that throws an error
        // whenever `document.activeElement` is accessed on an iframe
        // So, we allow :focus to pass through QSA all the time to avoid the IE error
        // See https://bugs.jquery.com/ticket/13378
        rbuggyQSA = [];

        if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

          // Build QSA regex
          // Regex strategy adopted from Diego Perini
          assert( function( el ) {

            var input;

            // Select is set to empty string on purpose
            // This is to test IE's treatment of not explicitly
            // setting a boolean content attribute,
            // since its presence should be enough
            // https://bugs.jquery.com/ticket/12359
            docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
              "<select id='" + expando + "-\r\\' msallowcapture=''>" +
              "<option selected=''></option></select>";

            // Support: IE8, Opera 11-12.16
            // Nothing should be selected when empty strings follow ^= or $= or *=
            // The test attribute must be unknown in Opera but "safe" for WinRT
            // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
            if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
              rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
            }

            // Support: IE8
            // Boolean attributes and "value" are not treated correctly
            if ( !el.querySelectorAll( "[selected]" ).length ) {
              rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
            }

            // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
            if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
              rbuggyQSA.push( "~=" );
            }

            // Support: IE 11+, Edge 15 - 18+
            // IE 11/Edge don't find elements on a `[name='']` query in some cases.
            // Adding a temporary attribute to the document before the selection works
            // around the issue.
            // Interestingly, IE 10 & older don't seem to have the issue.
            input = document.createElement( "input" );
            input.setAttribute( "name", "" );
            el.appendChild( input );
            if ( !el.querySelectorAll( "[name='']" ).length ) {
              rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
                whitespace + "*(?:''|\"\")" );
            }

            // Webkit/Opera - :checked should return selected option elements
            // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
            // IE8 throws error here and will not see later tests
            if ( !el.querySelectorAll( ":checked" ).length ) {
              rbuggyQSA.push( ":checked" );
            }

            // Support: Safari 8+, iOS 8+
            // https://bugs.webkit.org/show_bug.cgi?id=136851
            // In-page `selector#id sibling-combinator selector` fails
            if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
              rbuggyQSA.push( ".#.+[+~]" );
            }

            // Support: Firefox <=3.6 - 5 only
            // Old Firefox doesn't throw on a badly-escaped identifier.
            el.querySelectorAll( "\\\f" );
            rbuggyQSA.push( "[\\r\\n\\f]" );
          } );

          assert( function( el ) {
            el.innerHTML = "<a href='' disabled='disabled'></a>" +
              "<select disabled='disabled'><option/></select>";

            // Support: Windows 8 Native Apps
            // The type and name attributes are restricted during .innerHTML assignment
            var input = document.createElement( "input" );
            input.setAttribute( "type", "hidden" );
            el.appendChild( input ).setAttribute( "name", "D" );

            // Support: IE8
            // Enforce case-sensitivity of name attribute
            if ( el.querySelectorAll( "[name=d]" ).length ) {
              rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
            }

            // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
            // IE8 throws error here and will not see later tests
            if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
              rbuggyQSA.push( ":enabled", ":disabled" );
            }

            // Support: IE9-11+
            // IE's :disabled selector does not pick up the children of disabled fieldsets
            docElem.appendChild( el ).disabled = true;
            if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
              rbuggyQSA.push( ":enabled", ":disabled" );
            }

            // Support: Opera 10 - 11 only
            // Opera 10-11 does not throw on post-comma invalid pseudos
            el.querySelectorAll( "*,:x" );
            rbuggyQSA.push( ",.*:" );
          } );
        }

        if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
          docElem.webkitMatchesSelector ||
          docElem.mozMatchesSelector ||
          docElem.oMatchesSelector ||
          docElem.msMatchesSelector ) ) ) ) {

          assert( function( el ) {

            // Check to see if it's possible to do matchesSelector
            // on a disconnected node (IE 9)
            support.disconnectedMatch = matches.call( el, "*" );

            // This should fail with an exception
            // Gecko does not error, returns false instead
            matches.call( el, "[s!='']:x" );
            rbuggyMatches.push( "!=", pseudos );
          } );
        }

        rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
        rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

        /* Contains
	---------------------------------------------------------------------- */
        hasCompare = rnative.test( docElem.compareDocumentPosition );

        // Element contains another
        // Purposefully self-exclusive
        // As in, an element does not contain itself
        contains = hasCompare || rnative.test( docElem.contains ) ?
          function( a, b ) {
            var adown = a.nodeType === 9 ? a.documentElement : a,
              bup = b && b.parentNode;
            return a === bup || !!( bup && bup.nodeType === 1 && (
              adown.contains ?
                adown.contains( bup ) :
                a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
            ) );
          } :
          function( a, b ) {
            if ( b ) {
              while ( ( b = b.parentNode ) ) {
                if ( b === a ) {
                  return true;
                }
              }
            }
            return false;
          };

        /* Sorting
	---------------------------------------------------------------------- */

        // Document order sorting
        sortOrder = hasCompare ?
          function( a, b ) {

            // Flag for duplicate removal
            if ( a === b ) {
              hasDuplicate = true;
              return 0;
            }

            // Sort on method existence if only one input has compareDocumentPosition
            var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
            if ( compare ) {
              return compare;
            }

            // Calculate position if both inputs belong to the same document
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
              a.compareDocumentPosition( b ) :

              // Otherwise we know they are disconnected
              1;

            // Disconnected nodes
            if ( compare & 1 ||
              ( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

              // Choose the first element that is related to our preferred document
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if ( a == document || a.ownerDocument == preferredDoc &&
                contains( preferredDoc, a ) ) {
                return -1;
              }

              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if ( b == document || b.ownerDocument == preferredDoc &&
                contains( preferredDoc, b ) ) {
                return 1;
              }

              // Maintain original order
              return sortInput ?
                ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                0;
            }

            return compare & 4 ? -1 : 1;
          } :
          function( a, b ) {

            // Exit early if the nodes are identical
            if ( a === b ) {
              hasDuplicate = true;
              return 0;
            }

            var cur,
              i = 0,
              aup = a.parentNode,
              bup = b.parentNode,
              ap = [ a ],
              bp = [ b ];

            // Parentless nodes are either documents or disconnected
            if ( !aup || !bup ) {

              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              /* eslint-disable eqeqeq */
              return a == document ? -1 :
                b == document ? 1 :
                  /* eslint-enable eqeqeq */
                  aup ? -1 :
                    bup ? 1 :
                      sortInput ?
                        ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                        0;

              // If the nodes are siblings, we can do a quick check
            } else if ( aup === bup ) {
              return siblingCheck( a, b );
            }

            // Otherwise we need full lists of their ancestors for comparison
            cur = a;
            while ( ( cur = cur.parentNode ) ) {
              ap.unshift( cur );
            }
            cur = b;
            while ( ( cur = cur.parentNode ) ) {
              bp.unshift( cur );
            }

            // Walk down the tree looking for a discrepancy
            while ( ap[ i ] === bp[ i ] ) {
              i++;
            }

            return i ?

              // Do a sibling check if the nodes have a common ancestor
              siblingCheck( ap[ i ], bp[ i ] ) :

              // Otherwise nodes in our document sort first
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              /* eslint-disable eqeqeq */
              ap[ i ] == preferredDoc ? -1 :
                bp[ i ] == preferredDoc ? 1 :
                  /* eslint-enable eqeqeq */
                  0;
          };

        return document;
      };

      Sizzle.matches = function( expr, elements ) {
        return Sizzle( expr, null, null, elements );
      };

      Sizzle.matchesSelector = function( elem, expr ) {
        setDocument( elem );

        if ( support.matchesSelector && documentIsHTML &&
          !nonnativeSelectorCache[ expr + " " ] &&
          ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
          ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

          try {
            var ret = matches.call( elem, expr );

            // IE 9's matchesSelector returns false on disconnected nodes
            if ( ret || support.disconnectedMatch ||

              // As well, disconnected nodes are said to be in a document
              // fragment in IE 9
              elem.document && elem.document.nodeType !== 11 ) {
              return ret;
            }
          } catch ( e ) {
            nonnativeSelectorCache( expr, true );
          }
        }

        return Sizzle( expr, document, null, [ elem ] ).length > 0;
      };

      Sizzle.contains = function( context, elem ) {

        // Set document vars if needed
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if ( ( context.ownerDocument || context ) != document ) {
          setDocument( context );
        }
        return contains( context, elem );
      };

      Sizzle.attr = function( elem, name ) {

        // Set document vars if needed
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if ( ( elem.ownerDocument || elem ) != document ) {
          setDocument( elem );
        }

        var fn = Expr.attrHandle[ name.toLowerCase() ],

          // Don't get fooled by Object.prototype properties (jQuery #13807)
          val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
            fn( elem, name, !documentIsHTML ) :
            undefined;

        return val !== undefined ?
          val :
          support.attributes || !documentIsHTML ?
            elem.getAttribute( name ) :
            ( val = elem.getAttributeNode( name ) ) && val.specified ?
              val.value :
              null;
      };

      Sizzle.escape = function( sel ) {
        return ( sel + "" ).replace( rcssescape, fcssescape );
      };

      Sizzle.error = function( msg ) {
        throw new Error( "Syntax error, unrecognized expression: " + msg );
      };

      /**
       * Document sorting and removing duplicates
       * @param {ArrayLike} results
       */
      Sizzle.uniqueSort = function( results ) {
        var elem,
          duplicates = [],
          j = 0,
          i = 0;

        // Unless we *know* we can detect duplicates, assume their presence
        hasDuplicate = !support.detectDuplicates;
        sortInput = !support.sortStable && results.slice( 0 );
        results.sort( sortOrder );

        if ( hasDuplicate ) {
          while ( ( elem = results[ i++ ] ) ) {
            if ( elem === results[ i ] ) {
              j = duplicates.push( i );
            }
          }
          while ( j-- ) {
            results.splice( duplicates[ j ], 1 );
          }
        }

        // Clear input after sorting to release objects
        // See https://github.com/jquery/sizzle/pull/225
        sortInput = null;

        return results;
      };

      /**
       * Utility function for retrieving the text value of an array of DOM nodes
       * @param {Array|Element} elem
       */
      getText = Sizzle.getText = function( elem ) {
        var node,
          ret = "",
          i = 0,
          nodeType = elem.nodeType;

        if ( !nodeType ) {

          // If no nodeType, this is expected to be an array
          while ( ( node = elem[ i++ ] ) ) {

            // Do not traverse comment nodes
            ret += getText( node );
          }
        } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

          // Use textContent for elements
          // innerText usage removed for consistency of new lines (jQuery #11153)
          if ( typeof elem.textContent === "string" ) {
            return elem.textContent;
          } else {

            // Traverse its children
            for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
              ret += getText( elem );
            }
          }
        } else if ( nodeType === 3 || nodeType === 4 ) {
          return elem.nodeValue;
        }

        // Do not include comment or processing instruction nodes

        return ret;
      };

      Expr = Sizzle.selectors = {

        // Can be adjusted by the user
        cacheLength: 50,

        createPseudo: markFunction,

        match: matchExpr,

        attrHandle: {},

        find: {},

        relative: {
          ">": { dir: "parentNode", first: true },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: true },
          "~": { dir: "previousSibling" }
        },

        preFilter: {
          "ATTR": function( match ) {
            match[ 1 ] = match[ 1 ].replace( runescape, funescape );

            // Move the given value to match[3] whether quoted or unquoted
            match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
              match[ 5 ] || "" ).replace( runescape, funescape );

            if ( match[ 2 ] === "~=" ) {
              match[ 3 ] = " " + match[ 3 ] + " ";
            }

            return match.slice( 0, 4 );
          },

          "CHILD": function( match ) {

            /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
            match[ 1 ] = match[ 1 ].toLowerCase();

            if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

              // nth-* requires argument
              if ( !match[ 3 ] ) {
                Sizzle.error( match[ 0 ] );
              }

              // numeric x and y parameters for Expr.filter.CHILD
              // remember that false/true cast respectively to 0/1
              match[ 4 ] = +( match[ 4 ] ?
                match[ 5 ] + ( match[ 6 ] || 1 ) :
                2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
              match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

              // other types prohibit arguments
            } else if ( match[ 3 ] ) {
              Sizzle.error( match[ 0 ] );
            }

            return match;
          },

          "PSEUDO": function( match ) {
            var excess,
              unquoted = !match[ 6 ] && match[ 2 ];

            if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
              return null;
            }

            // Accept quoted arguments as-is
            if ( match[ 3 ] ) {
              match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

              // Strip excess characters from unquoted arguments
            } else if ( unquoted && rpseudo.test( unquoted ) &&

              // Get excess from tokenize (recursively)
              ( excess = tokenize( unquoted, true ) ) &&

              // advance to the next closing parenthesis
              ( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

              // excess is a negative index
              match[ 0 ] = match[ 0 ].slice( 0, excess );
              match[ 2 ] = unquoted.slice( 0, excess );
            }

            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice( 0, 3 );
          }
        },

        filter: {

          "TAG": function( nodeNameSelector ) {
            var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
            return nodeNameSelector === "*" ?
              function() {
                return true;
              } :
              function( elem ) {
                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
              };
          },

          "CLASS": function( className ) {
            var pattern = classCache[ className + " " ];

            return pattern ||
              ( pattern = new RegExp( "(^|" + whitespace +
                ")" + className + "(" + whitespace + "|$)" ) ) && classCache(
                className, function( elem ) {
                  return pattern.test(
                    typeof elem.className === "string" && elem.className ||
                    typeof elem.getAttribute !== "undefined" &&
                    elem.getAttribute( "class" ) ||
                    ""
                  );
                } );
          },

          "ATTR": function( name, operator, check ) {
            return function( elem ) {
              var result = Sizzle.attr( elem, name );

              if ( result == null ) {
                return operator === "!=";
              }
              if ( !operator ) {
                return true;
              }

              result += "";

              /* eslint-disable max-len */

              return operator === "=" ? result === check :
                operator === "!=" ? result !== check :
                  operator === "^=" ? check && result.indexOf( check ) === 0 :
                    operator === "*=" ? check && result.indexOf( check ) > -1 :
                      operator === "$=" ? check && result.slice( -check.length ) === check :
                        operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                          operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                            false;
              /* eslint-enable max-len */

            };
          },

          "CHILD": function( type, what, _argument, first, last ) {
            var simple = type.slice( 0, 3 ) !== "nth",
              forward = type.slice( -4 ) !== "last",
              ofType = what === "of-type";

            return first === 1 && last === 0 ?

              // Shortcut for :nth-*(n)
              function( elem ) {
                return !!elem.parentNode;
              } :

              function( elem, _context, xml ) {
                var cache, uniqueCache, outerCache, node, nodeIndex, start,
                  dir = simple !== forward ? "nextSibling" : "previousSibling",
                  parent = elem.parentNode,
                  name = ofType && elem.nodeName.toLowerCase(),
                  useCache = !xml && !ofType,
                  diff = false;

                if ( parent ) {

                  // :(first|last|only)-(child|of-type)
                  if ( simple ) {
                    while ( dir ) {
                      node = elem;
                      while ( ( node = node[ dir ] ) ) {
                        if ( ofType ?
                          node.nodeName.toLowerCase() === name :
                          node.nodeType === 1 ) {

                          return false;
                        }
                      }

                      // Reverse direction for :only-* (if we haven't yet done so)
                      start = dir = type === "only" && !start && "nextSibling";
                    }
                    return true;
                  }

                  start = [ forward ? parent.firstChild : parent.lastChild ];

                  // non-xml :nth-child(...) stores cache data on `parent`
                  if ( forward && useCache ) {

                    // Seek `elem` from a previously-cached index

                    // ...in a gzip-friendly way
                    node = parent;
                    outerCache = node[ expando ] || ( node[ expando ] = {} );

                    // Support: IE <9 only
                    // Defend against cloned attroperties (jQuery gh-1709)
                    uniqueCache = outerCache[ node.uniqueID ] ||
                      ( outerCache[ node.uniqueID ] = {} );

                    cache = uniqueCache[ type ] || [];
                    nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                    diff = nodeIndex && cache[ 2 ];
                    node = nodeIndex && parent.childNodes[ nodeIndex ];

                    while ( ( node = ++nodeIndex && node && node[ dir ] ||

                      // Fallback to seeking `elem` from the start
                      ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                      // When found, cache indexes on `parent` and break
                      if ( node.nodeType === 1 && ++diff && node === elem ) {
                        uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                        break;
                      }
                    }

                  } else {

                    // Use previously-cached element index if available
                    if ( useCache ) {

                      // ...in a gzip-friendly way
                      node = elem;
                      outerCache = node[ expando ] || ( node[ expando ] = {} );

                      // Support: IE <9 only
                      // Defend against cloned attroperties (jQuery gh-1709)
                      uniqueCache = outerCache[ node.uniqueID ] ||
                        ( outerCache[ node.uniqueID ] = {} );

                      cache = uniqueCache[ type ] || [];
                      nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                      diff = nodeIndex;
                    }

                    // xml :nth-child(...)
                    // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                    if ( diff === false ) {

                      // Use the same loop as above to seek `elem` from the start
                      while ( ( node = ++nodeIndex && node && node[ dir ] ||
                        ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                        if ( ( ofType ?
                            node.nodeName.toLowerCase() === name :
                            node.nodeType === 1 ) &&
                          ++diff ) {

                          // Cache the index of each encountered element
                          if ( useCache ) {
                            outerCache = node[ expando ] ||
                              ( node[ expando ] = {} );

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache = outerCache[ node.uniqueID ] ||
                              ( outerCache[ node.uniqueID ] = {} );

                            uniqueCache[ type ] = [ dirruns, diff ];
                          }

                          if ( node === elem ) {
                            break;
                          }
                        }
                      }
                    }
                  }

                  // Incorporate the offset, then check against cycle size
                  diff -= last;
                  return diff === first || ( diff % first === 0 && diff / first >= 0 );
                }
              };
          },

          "PSEUDO": function( pseudo, argument ) {

            // pseudo-class names are case-insensitive
            // http://www.w3.org/TR/selectors/#pseudo-classes
            // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
            // Remember that setFilters inherits from pseudos
            var args,
              fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                Sizzle.error( "unsupported pseudo: " + pseudo );

            // The user may use createPseudo to indicate that
            // arguments are needed to create the filter function
            // just as Sizzle does
            if ( fn[ expando ] ) {
              return fn( argument );
            }

            // But maintain support for old signatures
            if ( fn.length > 1 ) {
              args = [ pseudo, pseudo, "", argument ];
              return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                markFunction( function( seed, matches ) {
                  var idx,
                    matched = fn( seed, argument ),
                    i = matched.length;
                  while ( i-- ) {
                    idx = indexOf( seed, matched[ i ] );
                    seed[ idx ] = !( matches[ idx ] = matched[ i ] );
                  }
                } ) :
                function( elem ) {
                  return fn( elem, 0, args );
                };
            }

            return fn;
          }
        },

        pseudos: {

          // Potentially complex pseudos
          "not": markFunction( function( selector ) {

            // Trim the selector passed to compile
            // to avoid treating leading and trailing
            // spaces as combinators
            var input = [],
              results = [],
              matcher = compile( selector.replace( rtrim, "$1" ) );

            return matcher[ expando ] ?
              markFunction( function( seed, matches, _context, xml ) {
                var elem,
                  unmatched = matcher( seed, null, xml, [] ),
                  i = seed.length;

                // Match elements unmatched by `matcher`
                while ( i-- ) {
                  if ( ( elem = unmatched[ i ] ) ) {
                    seed[ i ] = !( matches[ i ] = elem );
                  }
                }
              } ) :
              function( elem, _context, xml ) {
                input[ 0 ] = elem;
                matcher( input, null, xml, results );

                // Don't keep the element (issue #299)
                input[ 0 ] = null;
                return !results.pop();
              };
          } ),

          "has": markFunction( function( selector ) {
            return function( elem ) {
              return Sizzle( selector, elem ).length > 0;
            };
          } ),

          "contains": markFunction( function( text ) {
            text = text.replace( runescape, funescape );
            return function( elem ) {
              return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
            };
          } ),

          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // http://www.w3.org/TR/selectors/#lang-pseudo
          "lang": markFunction( function( lang ) {

            // lang value must be a valid identifier
            if ( !ridentifier.test( lang || "" ) ) {
              Sizzle.error( "unsupported lang: " + lang );
            }
            lang = lang.replace( runescape, funescape ).toLowerCase();
            return function( elem ) {
              var elemLang;
              do {
                if ( ( elemLang = documentIsHTML ?
                  elem.lang :
                  elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

                  elemLang = elemLang.toLowerCase();
                  return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                }
              } while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
              return false;
            };
          } ),

          // Miscellaneous
          "target": function( elem ) {
            var hash = window.location && window.location.hash;
            return hash && hash.slice( 1 ) === elem.id;
          },

          "root": function( elem ) {
            return elem === docElem;
          },

          "focus": function( elem ) {
            return elem === document.activeElement &&
              ( !document.hasFocus || document.hasFocus() ) &&
              !!( elem.type || elem.href || ~elem.tabIndex );
          },

          // Boolean properties
          "enabled": createDisabledPseudo( false ),
          "disabled": createDisabledPseudo( true ),

          "checked": function( elem ) {

            // In CSS3, :checked should return both checked and selected elements
            // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
            var nodeName = elem.nodeName.toLowerCase();
            return ( nodeName === "input" && !!elem.checked ) ||
              ( nodeName === "option" && !!elem.selected );
          },

          "selected": function( elem ) {

            // Accessing this property makes selected-by-default
            // options in Safari work properly
            if ( elem.parentNode ) {
              // eslint-disable-next-line no-unused-expressions
              elem.parentNode.selectedIndex;
            }

            return elem.selected === true;
          },

          // Contents
          "empty": function( elem ) {

            // http://www.w3.org/TR/selectors/#empty-pseudo
            // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
            //   but not by others (comment: 8; processing instruction: 7; etc.)
            // nodeType < 6 works because attributes (2) do not appear as children
            for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
              if ( elem.nodeType < 6 ) {
                return false;
              }
            }
            return true;
          },

          "parent": function( elem ) {
            return !Expr.pseudos[ "empty" ]( elem );
          },

          // Element/input types
          "header": function( elem ) {
            return rheader.test( elem.nodeName );
          },

          "input": function( elem ) {
            return rinputs.test( elem.nodeName );
          },

          "button": function( elem ) {
            var name = elem.nodeName.toLowerCase();
            return name === "input" && elem.type === "button" || name === "button";
          },

          "text": function( elem ) {
            var attr;
            return elem.nodeName.toLowerCase() === "input" &&
              elem.type === "text" &&

              // Support: IE<8
              // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
              ( ( attr = elem.getAttribute( "type" ) ) == null ||
                attr.toLowerCase() === "text" );
          },

          // Position-in-collection
          "first": createPositionalPseudo( function() {
            return [ 0 ];
          } ),

          "last": createPositionalPseudo( function( _matchIndexes, length ) {
            return [ length - 1 ];
          } ),

          "eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
            return [ argument < 0 ? argument + length : argument ];
          } ),

          "even": createPositionalPseudo( function( matchIndexes, length ) {
            var i = 0;
            for ( ; i < length; i += 2 ) {
              matchIndexes.push( i );
            }
            return matchIndexes;
          } ),

          "odd": createPositionalPseudo( function( matchIndexes, length ) {
            var i = 1;
            for ( ; i < length; i += 2 ) {
              matchIndexes.push( i );
            }
            return matchIndexes;
          } ),

          "lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
            var i = argument < 0 ?
              argument + length :
              argument > length ?
                length :
                argument;
            for ( ; --i >= 0; ) {
              matchIndexes.push( i );
            }
            return matchIndexes;
          } ),

          "gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
            var i = argument < 0 ? argument + length : argument;
            for ( ; ++i < length; ) {
              matchIndexes.push( i );
            }
            return matchIndexes;
          } )
        }
      };

      Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
      for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
        Expr.pseudos[ i ] = createInputPseudo( i );
      }
      for ( i in { submit: true, reset: true } ) {
        Expr.pseudos[ i ] = createButtonPseudo( i );
      }

// Easy API for creating new setFilters
      function setFilters() {}
      setFilters.prototype = Expr.filters = Expr.pseudos;
      Expr.setFilters = new setFilters();

      tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
        var matched, match, tokens, type,
          soFar, groups, preFilters,
          cached = tokenCache[ selector + " " ];

        if ( cached ) {
          return parseOnly ? 0 : cached.slice( 0 );
        }

        soFar = selector;
        groups = [];
        preFilters = Expr.preFilter;

        while ( soFar ) {

          // Comma and first run
          if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
            if ( match ) {

              // Don't consume trailing commas as valid
              soFar = soFar.slice( match[ 0 ].length ) || soFar;
            }
            groups.push( ( tokens = [] ) );
          }

          matched = false;

          // Combinators
          if ( ( match = rcombinators.exec( soFar ) ) ) {
            matched = match.shift();
            tokens.push( {
              value: matched,

              // Cast descendant combinators to space
              type: match[ 0 ].replace( rtrim, " " )
            } );
            soFar = soFar.slice( matched.length );
          }

          // Filters
          for ( type in Expr.filter ) {
            if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
              ( match = preFilters[ type ]( match ) ) ) ) {
              matched = match.shift();
              tokens.push( {
                value: matched,
                type: type,
                matches: match
              } );
              soFar = soFar.slice( matched.length );
            }
          }

          if ( !matched ) {
            break;
          }
        }

        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        return parseOnly ?
          soFar.length :
          soFar ?
            Sizzle.error( selector ) :

            // Cache the tokens
            tokenCache( selector, groups ).slice( 0 );
      };

      function toSelector( tokens ) {
        var i = 0,
          len = tokens.length,
          selector = "";
        for ( ; i < len; i++ ) {
          selector += tokens[ i ].value;
        }
        return selector;
      }

      function addCombinator( matcher, combinator, base ) {
        var dir = combinator.dir,
          skip = combinator.next,
          key = skip || dir,
          checkNonElements = base && key === "parentNode",
          doneName = done++;

        return combinator.first ?

          // Check against closest ancestor/preceding element
          function( elem, context, xml ) {
            while ( ( elem = elem[ dir ] ) ) {
              if ( elem.nodeType === 1 || checkNonElements ) {
                return matcher( elem, context, xml );
              }
            }
            return false;
          } :

          // Check against all ancestor/preceding elements
          function( elem, context, xml ) {
            var oldCache, uniqueCache, outerCache,
              newCache = [ dirruns, doneName ];

            // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
            if ( xml ) {
              while ( ( elem = elem[ dir ] ) ) {
                if ( elem.nodeType === 1 || checkNonElements ) {
                  if ( matcher( elem, context, xml ) ) {
                    return true;
                  }
                }
              }
            } else {
              while ( ( elem = elem[ dir ] ) ) {
                if ( elem.nodeType === 1 || checkNonElements ) {
                  outerCache = elem[ expando ] || ( elem[ expando ] = {} );

                  // Support: IE <9 only
                  // Defend against cloned attroperties (jQuery gh-1709)
                  uniqueCache = outerCache[ elem.uniqueID ] ||
                    ( outerCache[ elem.uniqueID ] = {} );

                  if ( skip && skip === elem.nodeName.toLowerCase() ) {
                    elem = elem[ dir ] || elem;
                  } else if ( ( oldCache = uniqueCache[ key ] ) &&
                    oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

                    // Assign to newCache so results back-propagate to previous elements
                    return ( newCache[ 2 ] = oldCache[ 2 ] );
                  } else {

                    // Reuse newcache so results back-propagate to previous elements
                    uniqueCache[ key ] = newCache;

                    // A match means we're done; a fail means we have to keep checking
                    if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
                      return true;
                    }
                  }
                }
              }
            }
            return false;
          };
      }

      function elementMatcher( matchers ) {
        return matchers.length > 1 ?
          function( elem, context, xml ) {
            var i = matchers.length;
            while ( i-- ) {
              if ( !matchers[ i ]( elem, context, xml ) ) {
                return false;
              }
            }
            return true;
          } :
          matchers[ 0 ];
      }

      function multipleContexts( selector, contexts, results ) {
        var i = 0,
          len = contexts.length;
        for ( ; i < len; i++ ) {
          Sizzle( selector, contexts[ i ], results );
        }
        return results;
      }

      function condense( unmatched, map, filter, context, xml ) {
        var elem,
          newUnmatched = [],
          i = 0,
          len = unmatched.length,
          mapped = map != null;

        for ( ; i < len; i++ ) {
          if ( ( elem = unmatched[ i ] ) ) {
            if ( !filter || filter( elem, context, xml ) ) {
              newUnmatched.push( elem );
              if ( mapped ) {
                map.push( i );
              }
            }
          }
        }

        return newUnmatched;
      }

      function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
        if ( postFilter && !postFilter[ expando ] ) {
          postFilter = setMatcher( postFilter );
        }
        if ( postFinder && !postFinder[ expando ] ) {
          postFinder = setMatcher( postFinder, postSelector );
        }
        return markFunction( function( seed, results, context, xml ) {
          var temp, i, elem,
            preMap = [],
            postMap = [],
            preexisting = results.length,

            // Get initial elements from seed or context
            elems = seed || multipleContexts(
              selector || "*",
              context.nodeType ? [ context ] : context,
              []
            ),

            // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && ( seed || !selector ) ?
              condense( elems, preMap, preFilter, context, xml ) :
              elems,

            matcherOut = matcher ?

              // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
              postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

                // ...intermediate processing is necessary
                [] :

                // ...otherwise use results directly
                results :
              matcherIn;

          // Find primary matches
          if ( matcher ) {
            matcher( matcherIn, matcherOut, context, xml );
          }

          // Apply postFilter
          if ( postFilter ) {
            temp = condense( matcherOut, postMap );
            postFilter( temp, [], context, xml );

            // Un-match failing elements by moving them back to matcherIn
            i = temp.length;
            while ( i-- ) {
              if ( ( elem = temp[ i ] ) ) {
                matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
              }
            }
          }

          if ( seed ) {
            if ( postFinder || preFilter ) {
              if ( postFinder ) {

                // Get the final matcherOut by condensing this intermediate into postFinder contexts
                temp = [];
                i = matcherOut.length;
                while ( i-- ) {
                  if ( ( elem = matcherOut[ i ] ) ) {

                    // Restore matcherIn since elem is not yet a final match
                    temp.push( ( matcherIn[ i ] = elem ) );
                  }
                }
                postFinder( null, ( matcherOut = [] ), temp, xml );
              }

              // Move matched elements from seed to results to keep them synchronized
              i = matcherOut.length;
              while ( i-- ) {
                if ( ( elem = matcherOut[ i ] ) &&
                  ( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

                  seed[ temp ] = !( results[ temp ] = elem );
                }
              }
            }

            // Add elements to results, through postFinder if defined
          } else {
            matcherOut = condense(
              matcherOut === results ?
                matcherOut.splice( preexisting, matcherOut.length ) :
                matcherOut
            );
            if ( postFinder ) {
              postFinder( null, results, matcherOut, xml );
            } else {
              push.apply( results, matcherOut );
            }
          }
        } );
      }

      function matcherFromTokens( tokens ) {
        var checkContext, matcher, j,
          len = tokens.length,
          leadingRelative = Expr.relative[ tokens[ 0 ].type ],
          implicitRelative = leadingRelative || Expr.relative[ " " ],
          i = leadingRelative ? 1 : 0,

          // The foundational matcher ensures that elements are reachable from top-level context(s)
          matchContext = addCombinator( function( elem ) {
            return elem === checkContext;
          }, implicitRelative, true ),
          matchAnyContext = addCombinator( function( elem ) {
            return indexOf( checkContext, elem ) > -1;
          }, implicitRelative, true ),
          matchers = [ function( elem, context, xml ) {
            var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
              ( checkContext = context ).nodeType ?
                matchContext( elem, context, xml ) :
                matchAnyContext( elem, context, xml ) );

            // Avoid hanging onto element (issue #299)
            checkContext = null;
            return ret;
          } ];

        for ( ; i < len; i++ ) {
          if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
            matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
          } else {
            matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

            // Return special upon seeing a positional matcher
            if ( matcher[ expando ] ) {

              // Find the next relative operator (if any) for proper handling
              j = ++i;
              for ( ; j < len; j++ ) {
                if ( Expr.relative[ tokens[ j ].type ] ) {
                  break;
                }
              }
              return setMatcher(
                i > 1 && elementMatcher( matchers ),
                i > 1 && toSelector(

                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  tokens
                    .slice( 0, i - 1 )
                    .concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
                ).replace( rtrim, "$1" ),
                matcher,
                i < j && matcherFromTokens( tokens.slice( i, j ) ),
                j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
                j < len && toSelector( tokens )
              );
            }
            matchers.push( matcher );
          }
        }

        return elementMatcher( matchers );
      }

      function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
        var bySet = setMatchers.length > 0,
          byElement = elementMatchers.length > 0,
          superMatcher = function( seed, context, xml, results, outermost ) {
            var elem, j, matcher,
              matchedCount = 0,
              i = "0",
              unmatched = seed && [],
              setMatched = [],
              contextBackup = outermostContext,

              // We must always have either seed elements or outermost context
              elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

              // Use integer dirruns iff this is the outermost matcher
              dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
              len = elems.length;

            if ( outermost ) {

              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              outermostContext = context == document || context || outermost;
            }

            // Add elements passing elementMatchers directly to results
            // Support: IE<9, Safari
            // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
            for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
              if ( byElement && elem ) {
                j = 0;

                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ( !context && elem.ownerDocument != document ) {
                  setDocument( elem );
                  xml = !documentIsHTML;
                }
                while ( ( matcher = elementMatchers[ j++ ] ) ) {
                  if ( matcher( elem, context || document, xml ) ) {
                    results.push( elem );
                    break;
                  }
                }
                if ( outermost ) {
                  dirruns = dirrunsUnique;
                }
              }

              // Track unmatched elements for set filters
              if ( bySet ) {

                // They will have gone through all possible matchers
                if ( ( elem = !matcher && elem ) ) {
                  matchedCount--;
                }

                // Lengthen the array for every element, matched or not
                if ( seed ) {
                  unmatched.push( elem );
                }
              }
            }

            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;

            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if ( bySet && i !== matchedCount ) {
              j = 0;
              while ( ( matcher = setMatchers[ j++ ] ) ) {
                matcher( unmatched, setMatched, context, xml );
              }

              if ( seed ) {

                // Reintegrate element matches to eliminate the need for sorting
                if ( matchedCount > 0 ) {
                  while ( i-- ) {
                    if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
                      setMatched[ i ] = pop.call( results );
                    }
                  }
                }

                // Discard index placeholder values to get only actual matches
                setMatched = condense( setMatched );
              }

              // Add matches to results
              push.apply( results, setMatched );

              // Seedless set matches succeeding multiple successful matchers stipulate sorting
              if ( outermost && !seed && setMatched.length > 0 &&
                ( matchedCount + setMatchers.length ) > 1 ) {

                Sizzle.uniqueSort( results );
              }
            }

            // Override manipulation of globals by nested matchers
            if ( outermost ) {
              dirruns = dirrunsUnique;
              outermostContext = contextBackup;
            }

            return unmatched;
          };

        return bySet ?
          markFunction( superMatcher ) :
          superMatcher;
      }

      compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
        var i,
          setMatchers = [],
          elementMatchers = [],
          cached = compilerCache[ selector + " " ];

        if ( !cached ) {

          // Generate a function of recursive functions that can be used to check each element
          if ( !match ) {
            match = tokenize( selector );
          }
          i = match.length;
          while ( i-- ) {
            cached = matcherFromTokens( match[ i ] );
            if ( cached[ expando ] ) {
              setMatchers.push( cached );
            } else {
              elementMatchers.push( cached );
            }
          }

          // Cache the compiled function
          cached = compilerCache(
            selector,
            matcherFromGroupMatchers( elementMatchers, setMatchers )
          );

          // Save selector and tokenization
          cached.selector = selector;
        }
        return cached;
      };

      /**
       * A low-level selection function that works with Sizzle's compiled
       *  selector functions
       * @param {String|Function} selector A selector or a pre-compiled
       *  selector function built with Sizzle.compile
       * @param {Element} context
       * @param {Array} [results]
       * @param {Array} [seed] A set of elements to match against
       */
      select = Sizzle.select = function( selector, context, results, seed ) {
        var i, tokens, token, type, find,
          compiled = typeof selector === "function" && selector,
          match = !seed && tokenize( ( selector = compiled.selector || selector ) );

        results = results || [];

        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if ( match.length === 1 ) {

          // Reduce context if the leading compound selector is an ID
          tokens = match[ 0 ] = match[ 0 ].slice( 0 );
          if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
            context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

            context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
              .replace( runescape, funescape ), context ) || [] )[ 0 ];
            if ( !context ) {
              return results;

              // Precompiled matchers will still verify ancestry, so step up a level
            } else if ( compiled ) {
              context = context.parentNode;
            }

            selector = selector.slice( tokens.shift().value.length );
          }

          // Fetch a seed set for right-to-left matching
          i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
          while ( i-- ) {
            token = tokens[ i ];

            // Abort if we hit a combinator
            if ( Expr.relative[ ( type = token.type ) ] ) {
              break;
            }
            if ( ( find = Expr.find[ type ] ) ) {

              // Search, expanding context for leading sibling combinators
              if ( ( seed = find(
                token.matches[ 0 ].replace( runescape, funescape ),
                rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
                context
              ) ) ) {

                // If seed is empty or no tokens remain, we can return early
                tokens.splice( i, 1 );
                selector = seed.length && toSelector( tokens );
                if ( !selector ) {
                  push.apply( results, seed );
                  return results;
                }

                break;
              }
            }
          }
        }

        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        ( compiled || compile( selector, match ) )(
          seed,
          context,
          !documentIsHTML,
          results,
          !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
        );
        return results;
      };

// One-time assignments

// Sort stability
      support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
      support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
      setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
      support.sortDetached = assert( function( el ) {

        // Should return 1, but returns 4 (following)
        return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
      } );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
      if ( !assert( function( el ) {
        el.innerHTML = "<a href='#'></a>";
        return el.firstChild.getAttribute( "href" ) === "#";
      } ) ) {
        addHandle( "type|href|height|width", function( elem, name, isXML ) {
          if ( !isXML ) {
            return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
          }
        } );
      }

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
      if ( !support.attributes || !assert( function( el ) {
        el.innerHTML = "<input/>";
        el.firstChild.setAttribute( "value", "" );
        return el.firstChild.getAttribute( "value" ) === "";
      } ) ) {
        addHandle( "value", function( elem, _name, isXML ) {
          if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
            return elem.defaultValue;
          }
        } );
      }

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
      if ( !assert( function( el ) {
        return el.getAttribute( "disabled" ) == null;
      } ) ) {
        addHandle( booleans, function( elem, name, isXML ) {
          var val;
          if ( !isXML ) {
            return elem[ name ] === true ? name.toLowerCase() :
              ( val = elem.getAttributeNode( name ) ) && val.specified ?
                val.value :
                null;
          }
        } );
      }

      return Sizzle;

    } )( window );



  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors;

// Deprecated
  jQuery.expr[ ":" ] = jQuery.expr.pseudos;
  jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;
  jQuery.escapeSelector = Sizzle.escape;




  var dir = function( elem, dir, until ) {
    var matched = [],
      truncate = until !== undefined;

    while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
      if ( elem.nodeType === 1 ) {
        if ( truncate && jQuery( elem ).is( until ) ) {
          break;
        }
        matched.push( elem );
      }
    }
    return matched;
  };


  var siblings = function( n, elem ) {
    var matched = [];

    for ( ; n; n = n.nextSibling ) {
      if ( n.nodeType === 1 && n !== elem ) {
        matched.push( n );
      }
    }

    return matched;
  };


  var rneedsContext = jQuery.expr.match.needsContext;



  function nodeName( elem, name ) {

    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

  }
  var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
  function winnow( elements, qualifier, not ) {
    if ( isFunction( qualifier ) ) {
      return jQuery.grep( elements, function( elem, i ) {
        return !!qualifier.call( elem, i, elem ) !== not;
      } );
    }

    // Single element
    if ( qualifier.nodeType ) {
      return jQuery.grep( elements, function( elem ) {
        return ( elem === qualifier ) !== not;
      } );
    }

    // Arraylike of elements (jQuery, arguments, Array)
    if ( typeof qualifier !== "string" ) {
      return jQuery.grep( elements, function( elem ) {
        return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
      } );
    }

    // Filtered directly for both simple and complex selectors
    return jQuery.filter( qualifier, elements, not );
  }

  jQuery.filter = function( expr, elems, not ) {
    var elem = elems[ 0 ];

    if ( not ) {
      expr = ":not(" + expr + ")";
    }

    if ( elems.length === 1 && elem.nodeType === 1 ) {
      return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
    }

    return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
      return elem.nodeType === 1;
    } ) );
  };

  jQuery.fn.extend( {
    find: function( selector ) {
      var i, ret,
        len = this.length,
        self = this;

      if ( typeof selector !== "string" ) {
        return this.pushStack( jQuery( selector ).filter( function() {
          for ( i = 0; i < len; i++ ) {
            if ( jQuery.contains( self[ i ], this ) ) {
              return true;
            }
          }
        } ) );
      }

      ret = this.pushStack( [] );

      for ( i = 0; i < len; i++ ) {
        jQuery.find( selector, self[ i ], ret );
      }

      return len > 1 ? jQuery.uniqueSort( ret ) : ret;
    },
    filter: function( selector ) {
      return this.pushStack( winnow( this, selector || [], false ) );
    },
    not: function( selector ) {
      return this.pushStack( winnow( this, selector || [], true ) );
    },
    is: function( selector ) {
      return !!winnow(
        this,

        // If this is a positional/relative selector, check membership in the returned set
        // so $("p:first").is("p:last") won't return true for a doc with two "p".
        typeof selector === "string" && rneedsContext.test( selector ) ?
          jQuery( selector ) :
          selector || [],
        false
      ).length;
    }
  } );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
  var rootjQuery,

    // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

    init = jQuery.fn.init = function( selector, context, root ) {
      var match, elem;

      // HANDLE: $(""), $(null), $(undefined), $(false)
      if ( !selector ) {
        return this;
      }

      // Method init() accepts an alternate rootjQuery
      // so migrate can support jQuery.sub (gh-2101)
      root = root || rootjQuery;

      // Handle HTML strings
      if ( typeof selector === "string" ) {
        if ( selector[ 0 ] === "<" &&
          selector[ selector.length - 1 ] === ">" &&
          selector.length >= 3 ) {

          // Assume that strings that start and end with <> are HTML and skip the regex check
          match = [ null, selector, null ];

        } else {
          match = rquickExpr.exec( selector );
        }

        // Match html or make sure no context is specified for #id
        if ( match && ( match[ 1 ] || !context ) ) {

          // HANDLE: $(html) -> $(array)
          if ( match[ 1 ] ) {
            context = context instanceof jQuery ? context[ 0 ] : context;

            // Option to run scripts is true for back-compat
            // Intentionally let the error be thrown if parseHTML is not present
            jQuery.merge( this, jQuery.parseHTML(
              match[ 1 ],
              context && context.nodeType ? context.ownerDocument || context : document,
              true
            ) );

            // HANDLE: $(html, props)
            if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
              for ( match in context ) {

                // Properties of context are called as methods if possible
                if ( isFunction( this[ match ] ) ) {
                  this[ match ]( context[ match ] );

                  // ...and otherwise set as attributes
                } else {
                  this.attr( match, context[ match ] );
                }
              }
            }

            return this;

            // HANDLE: $(#id)
          } else {
            elem = document.getElementById( match[ 2 ] );

            if ( elem ) {

              // Inject the element directly into the jQuery object
              this[ 0 ] = elem;
              this.length = 1;
            }
            return this;
          }

          // HANDLE: $(expr, $(...))
        } else if ( !context || context.jquery ) {
          return ( context || root ).find( selector );

          // HANDLE: $(expr, context)
          // (which is just equivalent to: $(context).find(expr)
        } else {
          return this.constructor( context ).find( selector );
        }

        // HANDLE: $(DOMElement)
      } else if ( selector.nodeType ) {
        this[ 0 ] = selector;
        this.length = 1;
        return this;

        // HANDLE: $(function)
        // Shortcut for document ready
      } else if ( isFunction( selector ) ) {
        return root.ready !== undefined ?
          root.ready( selector ) :

          // Execute immediately if ready is not present
          selector( jQuery );
      }

      return jQuery.makeArray( selector, this );
    };

// Give the init function the jQuery prototype for later instantiation
  init.prototype = jQuery.fn;

// Initialize central reference
  rootjQuery = jQuery( document );


  var rparentsprev = /^(?:parents|prev(?:Until|All))/,

    // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
      children: true,
      contents: true,
      next: true,
      prev: true
    };

  jQuery.fn.extend( {
    has: function( target ) {
      var targets = jQuery( target, this ),
        l = targets.length;

      return this.filter( function() {
        var i = 0;
        for ( ; i < l; i++ ) {
          if ( jQuery.contains( this, targets[ i ] ) ) {
            return true;
          }
        }
      } );
    },

    closest: function( selectors, context ) {
      var cur,
        i = 0,
        l = this.length,
        matched = [],
        targets = typeof selectors !== "string" && jQuery( selectors );

      // Positional selectors never match, since there's no _selection_ context
      if ( !rneedsContext.test( selectors ) ) {
        for ( ; i < l; i++ ) {
          for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

            // Always skip document fragments
            if ( cur.nodeType < 11 && ( targets ?
              targets.index( cur ) > -1 :

              // Don't pass non-elements to Sizzle
              cur.nodeType === 1 &&
              jQuery.find.matchesSelector( cur, selectors ) ) ) {

              matched.push( cur );
              break;
            }
          }
        }
      }

      return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
    },

    // Determine the position of an element within the set
    index: function( elem ) {

      // No argument, return index in parent
      if ( !elem ) {
        return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
      }

      // Index in selector
      if ( typeof elem === "string" ) {
        return indexOf.call( jQuery( elem ), this[ 0 ] );
      }

      // Locate the position of the desired element
      return indexOf.call( this,

        // If it receives a jQuery object, the first element is used
        elem.jquery ? elem[ 0 ] : elem
      );
    },

    add: function( selector, context ) {
      return this.pushStack(
        jQuery.uniqueSort(
          jQuery.merge( this.get(), jQuery( selector, context ) )
        )
      );
    },

    addBack: function( selector ) {
      return this.add( selector == null ?
        this.prevObject : this.prevObject.filter( selector )
      );
    }
  } );

  function sibling( cur, dir ) {
    while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
    return cur;
  }

  jQuery.each( {
    parent: function( elem ) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function( elem ) {
      return dir( elem, "parentNode" );
    },
    parentsUntil: function( elem, _i, until ) {
      return dir( elem, "parentNode", until );
    },
    next: function( elem ) {
      return sibling( elem, "nextSibling" );
    },
    prev: function( elem ) {
      return sibling( elem, "previousSibling" );
    },
    nextAll: function( elem ) {
      return dir( elem, "nextSibling" );
    },
    prevAll: function( elem ) {
      return dir( elem, "previousSibling" );
    },
    nextUntil: function( elem, _i, until ) {
      return dir( elem, "nextSibling", until );
    },
    prevUntil: function( elem, _i, until ) {
      return dir( elem, "previousSibling", until );
    },
    siblings: function( elem ) {
      return siblings( ( elem.parentNode || {} ).firstChild, elem );
    },
    children: function( elem ) {
      return siblings( elem.firstChild );
    },
    contents: function( elem ) {
      if ( elem.contentDocument != null &&

        // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        getProto( elem.contentDocument ) ) {

        return elem.contentDocument;
      }

      // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
      // Treat the template element as a regular one in browsers that
      // don't support it.
      if ( nodeName( elem, "template" ) ) {
        elem = elem.content || elem;
      }

      return jQuery.merge( [], elem.childNodes );
    }
  }, function( name, fn ) {
    jQuery.fn[ name ] = function( until, selector ) {
      var matched = jQuery.map( this, fn, until );

      if ( name.slice( -5 ) !== "Until" ) {
        selector = until;
      }

      if ( selector && typeof selector === "string" ) {
        matched = jQuery.filter( selector, matched );
      }

      if ( this.length > 1 ) {

        // Remove duplicates
        if ( !guaranteedUnique[ name ] ) {
          jQuery.uniqueSort( matched );
        }

        // Reverse order for parents* and prev-derivatives
        if ( rparentsprev.test( name ) ) {
          matched.reverse();
        }
      }

      return this.pushStack( matched );
    };
  } );
  var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
  function createOptions( options ) {
    var object = {};
    jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
      object[ flag ] = true;
    } );
    return object;
  }

  /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
  jQuery.Callbacks = function( options ) {

    // Convert options from String-formatted to Object-formatted if needed
    // (we check in cache first)
    options = typeof options === "string" ?
      createOptions( options ) :
      jQuery.extend( {}, options );

    var // Flag to know if list is currently firing
      firing,

      // Last fire value for non-forgettable lists
      memory,

      // Flag to know if list was already fired
      fired,

      // Flag to prevent firing
      locked,

      // Actual callback list
      list = [],

      // Queue of execution data for repeatable lists
      queue = [],

      // Index of currently firing callback (modified by add/remove as needed)
      firingIndex = -1,

      // Fire callbacks
      fire = function() {

        // Enforce single-firing
        locked = locked || options.once;

        // Execute callbacks for all pending executions,
        // respecting firingIndex overrides and runtime changes
        fired = firing = true;
        for ( ; queue.length; firingIndex = -1 ) {
          memory = queue.shift();
          while ( ++firingIndex < list.length ) {

            // Run callback and check for early termination
            if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
              options.stopOnFalse ) {

              // Jump to end and forget the data so .add doesn't re-fire
              firingIndex = list.length;
              memory = false;
            }
          }
        }

        // Forget the data if we're done with it
        if ( !options.memory ) {
          memory = false;
        }

        firing = false;

        // Clean up if we're done firing for good
        if ( locked ) {

          // Keep an empty list if we have data for future add calls
          if ( memory ) {
            list = [];

            // Otherwise, this object is spent
          } else {
            list = "";
          }
        }
      },

      // Actual Callbacks object
      self = {

        // Add a callback or a collection of callbacks to the list
        add: function() {
          if ( list ) {

            // If we have memory from a past run, we should fire after adding
            if ( memory && !firing ) {
              firingIndex = list.length - 1;
              queue.push( memory );
            }

            ( function add( args ) {
              jQuery.each( args, function( _, arg ) {
                if ( isFunction( arg ) ) {
                  if ( !options.unique || !self.has( arg ) ) {
                    list.push( arg );
                  }
                } else if ( arg && arg.length && toType( arg ) !== "string" ) {

                  // Inspect recursively
                  add( arg );
                }
              } );
            } )( arguments );

            if ( memory && !firing ) {
              fire();
            }
          }
          return this;
        },

        // Remove a callback from the list
        remove: function() {
          jQuery.each( arguments, function( _, arg ) {
            var index;
            while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
              list.splice( index, 1 );

              // Handle firing indexes
              if ( index <= firingIndex ) {
                firingIndex--;
              }
            }
          } );
          return this;
        },

        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function( fn ) {
          return fn ?
            jQuery.inArray( fn, list ) > -1 :
            list.length > 0;
        },

        // Remove all callbacks from the list
        empty: function() {
          if ( list ) {
            list = [];
          }
          return this;
        },

        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          locked = queue = [];
          list = memory = "";
          return this;
        },
        disabled: function() {
          return !list;
        },

        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          locked = queue = [];
          if ( !memory && !firing ) {
            list = memory = "";
          }
          return this;
        },
        locked: function() {
          return !!locked;
        },

        // Call all callbacks with the given context and arguments
        fireWith: function( context, args ) {
          if ( !locked ) {
            args = args || [];
            args = [ context, args.slice ? args.slice() : args ];
            queue.push( args );
            if ( !firing ) {
              fire();
            }
          }
          return this;
        },

        // Call all the callbacks with the given arguments
        fire: function() {
          self.fireWith( this, arguments );
          return this;
        },

        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!fired;
        }
      };

    return self;
  };


  function Identity( v ) {
    return v;
  }
  function Thrower( ex ) {
    throw ex;
  }

  function adoptValue( value, resolve, reject, noValue ) {
    var method;

    try {

      // Check for promise aspect first to privilege synchronous behavior
      if ( value && isFunction( ( method = value.promise ) ) ) {
        method.call( value ).done( resolve ).fail( reject );

        // Other thenables
      } else if ( value && isFunction( ( method = value.then ) ) ) {
        method.call( value, resolve, reject );

        // Other non-thenables
      } else {

        // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
        // * false: [ value ].slice( 0 ) => resolve( value )
        // * true: [ value ].slice( 1 ) => resolve()
        resolve.apply( undefined, [ value ].slice( noValue ) );
      }

      // For Promises/A+, convert exceptions into rejections
      // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
      // Deferred#then to conditionally suppress rejection.
    } catch ( value ) {

      // Support: Android 4.0 only
      // Strict mode functions invoked without .call/.apply get global-object context
      reject.apply( undefined, [ value ] );
    }
  }

  jQuery.extend( {

    Deferred: function( func ) {
      var tuples = [

          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [ "notify", "progress", jQuery.Callbacks( "memory" ),
            jQuery.Callbacks( "memory" ), 2 ],
          [ "resolve", "done", jQuery.Callbacks( "once memory" ),
            jQuery.Callbacks( "once memory" ), 0, "resolved" ],
          [ "reject", "fail", jQuery.Callbacks( "once memory" ),
            jQuery.Callbacks( "once memory" ), 1, "rejected" ]
        ],
        state = "pending",
        promise = {
          state: function() {
            return state;
          },
          always: function() {
            deferred.done( arguments ).fail( arguments );
            return this;
          },
          "catch": function( fn ) {
            return promise.then( null, fn );
          },

          // Keep pipe for back-compat
          pipe: function( /* fnDone, fnFail, fnProgress */ ) {
            var fns = arguments;

            return jQuery.Deferred( function( newDefer ) {
              jQuery.each( tuples, function( _i, tuple ) {

                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                deferred[ tuple[ 1 ] ]( function() {
                  var returned = fn && fn.apply( this, arguments );
                  if ( returned && isFunction( returned.promise ) ) {
                    returned.promise()
                      .progress( newDefer.notify )
                      .done( newDefer.resolve )
                      .fail( newDefer.reject );
                  } else {
                    newDefer[ tuple[ 0 ] + "With" ](
                      this,
                      fn ? [ returned ] : arguments
                    );
                  }
                } );
              } );
              fns = null;
            } ).promise();
          },
          then: function( onFulfilled, onRejected, onProgress ) {
            var maxDepth = 0;
            function resolve( depth, deferred, handler, special ) {
              return function() {
                var that = this,
                  args = arguments,
                  mightThrow = function() {
                    var returned, then;

                    // Support: Promises/A+ section 2.3.3.3.3
                    // https://promisesaplus.com/#point-59
                    // Ignore double-resolution attempts
                    if ( depth < maxDepth ) {
                      return;
                    }

                    returned = handler.apply( that, args );

                    // Support: Promises/A+ section 2.3.1
                    // https://promisesaplus.com/#point-48
                    if ( returned === deferred.promise() ) {
                      throw new TypeError( "Thenable self-resolution" );
                    }

                    // Support: Promises/A+ sections 2.3.3.1, 3.5
                    // https://promisesaplus.com/#point-54
                    // https://promisesaplus.com/#point-75
                    // Retrieve `then` only once
                    then = returned &&

                      // Support: Promises/A+ section 2.3.4
                      // https://promisesaplus.com/#point-64
                      // Only check objects and functions for thenability
                      ( typeof returned === "object" ||
                        typeof returned === "function" ) &&
                      returned.then;

                    // Handle a returned thenable
                    if ( isFunction( then ) ) {

                      // Special processors (notify) just wait for resolution
                      if ( special ) {
                        then.call(
                          returned,
                          resolve( maxDepth, deferred, Identity, special ),
                          resolve( maxDepth, deferred, Thrower, special )
                        );

                        // Normal processors (resolve) also hook into progress
                      } else {

                        // ...and disregard older resolution values
                        maxDepth++;

                        then.call(
                          returned,
                          resolve( maxDepth, deferred, Identity, special ),
                          resolve( maxDepth, deferred, Thrower, special ),
                          resolve( maxDepth, deferred, Identity,
                            deferred.notifyWith )
                        );
                      }

                      // Handle all other returned values
                    } else {

                      // Only substitute handlers pass on context
                      // and multiple values (non-spec behavior)
                      if ( handler !== Identity ) {
                        that = undefined;
                        args = [ returned ];
                      }

                      // Process the value(s)
                      // Default process is resolve
                      ( special || deferred.resolveWith )( that, args );
                    }
                  },

                  // Only normal processors (resolve) catch and reject exceptions
                  process = special ?
                    mightThrow :
                    function() {
                      try {
                        mightThrow();
                      } catch ( e ) {

                        if ( jQuery.Deferred.exceptionHook ) {
                          jQuery.Deferred.exceptionHook( e,
                            process.stackTrace );
                        }

                        // Support: Promises/A+ section 2.3.3.3.4.1
                        // https://promisesaplus.com/#point-61
                        // Ignore post-resolution exceptions
                        if ( depth + 1 >= maxDepth ) {

                          // Only substitute handlers pass on context
                          // and multiple values (non-spec behavior)
                          if ( handler !== Thrower ) {
                            that = undefined;
                            args = [ e ];
                          }

                          deferred.rejectWith( that, args );
                        }
                      }
                    };

                // Support: Promises/A+ section 2.3.3.3.1
                // https://promisesaplus.com/#point-57
                // Re-resolve promises immediately to dodge false rejection from
                // subsequent errors
                if ( depth ) {
                  process();
                } else {

                  // Call an optional hook to record the stack, in case of exception
                  // since it's otherwise lost when execution goes async
                  if ( jQuery.Deferred.getStackHook ) {
                    process.stackTrace = jQuery.Deferred.getStackHook();
                  }
                  window.setTimeout( process );
                }
              };
            }

            return jQuery.Deferred( function( newDefer ) {

              // progress_handlers.add( ... )
              tuples[ 0 ][ 3 ].add(
                resolve(
                  0,
                  newDefer,
                  isFunction( onProgress ) ?
                    onProgress :
                    Identity,
                  newDefer.notifyWith
                )
              );

              // fulfilled_handlers.add( ... )
              tuples[ 1 ][ 3 ].add(
                resolve(
                  0,
                  newDefer,
                  isFunction( onFulfilled ) ?
                    onFulfilled :
                    Identity
                )
              );

              // rejected_handlers.add( ... )
              tuples[ 2 ][ 3 ].add(
                resolve(
                  0,
                  newDefer,
                  isFunction( onRejected ) ?
                    onRejected :
                    Thrower
                )
              );
            } ).promise();
          },

          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function( obj ) {
            return obj != null ? jQuery.extend( obj, promise ) : promise;
          }
        },
        deferred = {};

      // Add list-specific methods
      jQuery.each( tuples, function( i, tuple ) {
        var list = tuple[ 2 ],
          stateString = tuple[ 5 ];

        // promise.progress = list.add
        // promise.done = list.add
        // promise.fail = list.add
        promise[ tuple[ 1 ] ] = list.add;

        // Handle state
        if ( stateString ) {
          list.add(
            function() {

              // state = "resolved" (i.e., fulfilled)
              // state = "rejected"
              state = stateString;
            },

            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            tuples[ 3 - i ][ 2 ].disable,

            // rejected_handlers.disable
            // fulfilled_handlers.disable
            tuples[ 3 - i ][ 3 ].disable,

            // progress_callbacks.lock
            tuples[ 0 ][ 2 ].lock,

            // progress_handlers.lock
            tuples[ 0 ][ 3 ].lock
          );
        }

        // progress_handlers.fire
        // fulfilled_handlers.fire
        // rejected_handlers.fire
        list.add( tuple[ 3 ].fire );

        // deferred.notify = function() { deferred.notifyWith(...) }
        // deferred.resolve = function() { deferred.resolveWith(...) }
        // deferred.reject = function() { deferred.rejectWith(...) }
        deferred[ tuple[ 0 ] ] = function() {
          deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
          return this;
        };

        // deferred.notifyWith = list.fireWith
        // deferred.resolveWith = list.fireWith
        // deferred.rejectWith = list.fireWith
        deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
      } );

      // Make the deferred a promise
      promise.promise( deferred );

      // Call given func if any
      if ( func ) {
        func.call( deferred, deferred );
      }

      // All done!
      return deferred;
    },

    // Deferred helper
    when: function( singleValue ) {
      var

        // count of uncompleted subordinates
        remaining = arguments.length,

        // count of unprocessed arguments
        i = remaining,

        // subordinate fulfillment data
        resolveContexts = Array( i ),
        resolveValues = slice.call( arguments ),

        // the primary Deferred
        primary = jQuery.Deferred(),

        // subordinate callback factory
        updateFunc = function( i ) {
          return function( value ) {
            resolveContexts[ i ] = this;
            resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
            if ( !( --remaining ) ) {
              primary.resolveWith( resolveContexts, resolveValues );
            }
          };
        };

      // Single- and empty arguments are adopted like Promise.resolve
      if ( remaining <= 1 ) {
        adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
          !remaining );

        // Use .then() to unwrap secondary thenables (cf. gh-3000)
        if ( primary.state() === "pending" ||
          isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

          return primary.then();
        }
      }

      // Multiple arguments are aggregated like Promise.all array elements
      while ( i-- ) {
        adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
      }

      return primary.promise();
    }
  } );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
  var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

  jQuery.Deferred.exceptionHook = function( error, stack ) {

    // Support: IE 8 - 9 only
    // Console exists when dev tools are open, which can happen at any time
    if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
      window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
    }
  };




  jQuery.readyException = function( error ) {
    window.setTimeout( function() {
      throw error;
    } );
  };




// The deferred used on DOM ready
  var readyList = jQuery.Deferred();

  jQuery.fn.ready = function( fn ) {

    readyList
      .then( fn )

      // Wrap jQuery.readyException in a function so that the lookup
      // happens at the time of error handling instead of callback
      // registration.
      .catch( function( error ) {
        jQuery.readyException( error );
      } );

    return this;
  };

  jQuery.extend( {

    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: false,

    // A counter to track how many items to wait for before
    // the ready event fires. See trac-6781
    readyWait: 1,

    // Handle when the DOM is ready
    ready: function( wait ) {

      // Abort if there are pending holds or we're already ready
      if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
        return;
      }

      // Remember that the DOM is ready
      jQuery.isReady = true;

      // If a normal DOM Ready event fired, decrement, and wait if need be
      if ( wait !== true && --jQuery.readyWait > 0 ) {
        return;
      }

      // If there are functions bound, to execute
      readyList.resolveWith( document, [ jQuery ] );
    }
  } );

  jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
  function completed() {
    document.removeEventListener( "DOMContentLoaded", completed );
    window.removeEventListener( "load", completed );
    jQuery.ready();
  }

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
  if ( document.readyState === "complete" ||
    ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

    // Handle it asynchronously to allow scripts the opportunity to delay ready
    window.setTimeout( jQuery.ready );

  } else {

    // Use the handy event callback
    document.addEventListener( "DOMContentLoaded", completed );

    // A fallback to window.onload, that will always work
    window.addEventListener( "load", completed );
  }




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
  var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
    var i = 0,
      len = elems.length,
      bulk = key == null;

    // Sets many values
    if ( toType( key ) === "object" ) {
      chainable = true;
      for ( i in key ) {
        access( elems, fn, i, key[ i ], true, emptyGet, raw );
      }

      // Sets one value
    } else if ( value !== undefined ) {
      chainable = true;

      if ( !isFunction( value ) ) {
        raw = true;
      }

      if ( bulk ) {

        // Bulk operations run against the entire set
        if ( raw ) {
          fn.call( elems, value );
          fn = null;

          // ...except when executing function values
        } else {
          bulk = fn;
          fn = function( elem, _key, value ) {
            return bulk.call( jQuery( elem ), value );
          };
        }
      }

      if ( fn ) {
        for ( ; i < len; i++ ) {
          fn(
            elems[ i ], key, raw ?
              value :
              value.call( elems[ i ], i, fn( elems[ i ], key ) )
          );
        }
      }
    }

    if ( chainable ) {
      return elems;
    }

    // Gets
    if ( bulk ) {
      return fn.call( elems );
    }

    return len ? fn( elems[ 0 ], key ) : emptyGet;
  };


// Matches dashed string for camelizing
  var rmsPrefix = /^-ms-/,
    rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
  function fcamelCase( _all, letter ) {
    return letter.toUpperCase();
  }

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
  function camelCase( string ) {
    return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
  }
  var acceptData = function( owner ) {

    // Accepts only:
    //  - Node
    //    - Node.ELEMENT_NODE
    //    - Node.DOCUMENT_NODE
    //  - Object
    //    - Any
    return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
  };




  function Data() {
    this.expando = jQuery.expando + Data.uid++;
  }

  Data.uid = 1;

  Data.prototype = {

    cache: function( owner ) {

      // Check if the owner object already has a cache
      var value = owner[ this.expando ];

      // If not, create one
      if ( !value ) {
        value = {};

        // We can accept data for non-element nodes in modern browsers,
        // but we should not, see trac-8335.
        // Always return an empty object.
        if ( acceptData( owner ) ) {

          // If it is a node unlikely to be stringify-ed or looped over
          // use plain assignment
          if ( owner.nodeType ) {
            owner[ this.expando ] = value;

            // Otherwise secure it in a non-enumerable property
            // configurable must be true to allow the property to be
            // deleted when data is removed
          } else {
            Object.defineProperty( owner, this.expando, {
              value: value,
              configurable: true
            } );
          }
        }
      }

      return value;
    },
    set: function( owner, data, value ) {
      var prop,
        cache = this.cache( owner );

      // Handle: [ owner, key, value ] args
      // Always use camelCase key (gh-2257)
      if ( typeof data === "string" ) {
        cache[ camelCase( data ) ] = value;

        // Handle: [ owner, { properties } ] args
      } else {

        // Copy the properties one-by-one to the cache object
        for ( prop in data ) {
          cache[ camelCase( prop ) ] = data[ prop ];
        }
      }
      return cache;
    },
    get: function( owner, key ) {
      return key === undefined ?
        this.cache( owner ) :

        // Always use camelCase key (gh-2257)
        owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
    },
    access: function( owner, key, value ) {

      // In cases where either:
      //
      //   1. No key was specified
      //   2. A string key was specified, but no value provided
      //
      // Take the "read" path and allow the get method to determine
      // which value to return, respectively either:
      //
      //   1. The entire cache object
      //   2. The data stored at the key
      //
      if ( key === undefined ||
        ( ( key && typeof key === "string" ) && value === undefined ) ) {

        return this.get( owner, key );
      }

      // When the key is not a string, or both a key and value
      // are specified, set or extend (existing objects) with either:
      //
      //   1. An object of properties
      //   2. A key and value
      //
      this.set( owner, key, value );

      // Since the "set" path can have two possible entry points
      // return the expected data based on which path was taken[*]
      return value !== undefined ? value : key;
    },
    remove: function( owner, key ) {
      var i,
        cache = owner[ this.expando ];

      if ( cache === undefined ) {
        return;
      }

      if ( key !== undefined ) {

        // Support array or space separated string of keys
        if ( Array.isArray( key ) ) {

          // If key is an array of keys...
          // We always set camelCase keys, so remove that.
          key = key.map( camelCase );
        } else {
          key = camelCase( key );

          // If a key with the spaces exists, use it.
          // Otherwise, create an array by matching non-whitespace
          key = key in cache ?
            [ key ] :
            ( key.match( rnothtmlwhite ) || [] );
        }

        i = key.length;

        while ( i-- ) {
          delete cache[ key[ i ] ];
        }
      }

      // Remove the expando if there's no more data
      if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

        // Support: Chrome <=35 - 45
        // Webkit & Blink performance suffers when deleting properties
        // from DOM nodes, so set to undefined instead
        // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
        if ( owner.nodeType ) {
          owner[ this.expando ] = undefined;
        } else {
          delete owner[ this.expando ];
        }
      }
    },
    hasData: function( owner ) {
      var cache = owner[ this.expando ];
      return cache !== undefined && !jQuery.isEmptyObject( cache );
    }
  };
  var dataPriv = new Data();

  var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    rmultiDash = /[A-Z]/g;

  function getData( data ) {
    if ( data === "true" ) {
      return true;
    }

    if ( data === "false" ) {
      return false;
    }

    if ( data === "null" ) {
      return null;
    }

    // Only convert to a number if it doesn't change the string
    if ( data === +data + "" ) {
      return +data;
    }

    if ( rbrace.test( data ) ) {
      return JSON.parse( data );
    }

    return data;
  }

  function dataAttr( elem, key, data ) {
    var name;

    // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute
    if ( data === undefined && elem.nodeType === 1 ) {
      name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
      data = elem.getAttribute( name );

      if ( typeof data === "string" ) {
        try {
          data = getData( data );
        } catch ( e ) {}

        // Make sure we set the data so it isn't changed later
        dataUser.set( elem, key, data );
      } else {
        data = undefined;
      }
    }
    return data;
  }

  jQuery.extend( {
    hasData: function( elem ) {
      return dataUser.hasData( elem ) || dataPriv.hasData( elem );
    },

    data: function( elem, name, data ) {
      return dataUser.access( elem, name, data );
    },

    removeData: function( elem, name ) {
      dataUser.remove( elem, name );
    },

    // TODO: Now that all calls to _data and _removeData have been replaced
    // with direct calls to dataPriv methods, these can be deprecated.
    _data: function( elem, name, data ) {
      return dataPriv.access( elem, name, data );
    },

    _removeData: function( elem, name ) {
      dataPriv.remove( elem, name );
    }
  } );

  jQuery.fn.extend( {
    data: function( key, value ) {
      var i, name, data,
        elem = this[ 0 ],
        attrs = elem && elem.attributes;

      // Gets all values
      if ( key === undefined ) {
        if ( this.length ) {
          data = dataUser.get( elem );

          if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
            i = attrs.length;
            while ( i-- ) {

              // Support: IE 11 only
              // The attrs elements can be null (trac-14894)
              if ( attrs[ i ] ) {
                name = attrs[ i ].name;
                if ( name.indexOf( "data-" ) === 0 ) {
                  name = camelCase( name.slice( 5 ) );
                  dataAttr( elem, name, data[ name ] );
                }
              }
            }
            dataPriv.set( elem, "hasDataAttrs", true );
          }
        }

        return data;
      }

      // Sets multiple values
      if ( typeof key === "object" ) {
        return this.each( function() {
          dataUser.set( this, key );
        } );
      }

      return access( this, function( value ) {
        var data;

        // The calling jQuery object (element matches) is not empty
        // (and therefore has an element appears at this[ 0 ]) and the
        // `value` parameter was not undefined. An empty jQuery object
        // will result in `undefined` for elem = this[ 0 ] which will
        // throw an exception if an attempt to read a data cache is made.
        if ( elem && value === undefined ) {

          // Attempt to get data from the cache
          // The key will always be camelCased in Data
          data = dataUser.get( elem, key );
          if ( data !== undefined ) {
            return data;
          }

          // Attempt to "discover" the data in
          // HTML5 custom data-* attrs
          data = dataAttr( elem, key );
          if ( data !== undefined ) {
            return data;
          }

          // We tried really hard, but the data doesn't exist.
          return;
        }

        // Set the data...
        this.each( function() {

          // We always store the camelCased key
          dataUser.set( this, key, value );
        } );
      }, null, value, arguments.length > 1, null, true );
    },

    removeData: function( key ) {
      return this.each( function() {
        dataUser.remove( this, key );
      } );
    }
  } );


  jQuery.extend( {
    queue: function( elem, type, data ) {
      var queue;

      if ( elem ) {
        type = ( type || "fx" ) + "queue";
        queue = dataPriv.get( elem, type );

        // Speed up dequeue by getting out quickly if this is just a lookup
        if ( data ) {
          if ( !queue || Array.isArray( data ) ) {
            queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
          } else {
            queue.push( data );
          }
        }
        return queue || [];
      }
    },

    dequeue: function( elem, type ) {
      type = type || "fx";

      var queue = jQuery.queue( elem, type ),
        startLength = queue.length,
        fn = queue.shift(),
        hooks = jQuery._queueHooks( elem, type ),
        next = function() {
          jQuery.dequeue( elem, type );
        };

      // If the fx queue is dequeued, always remove the progress sentinel
      if ( fn === "inprogress" ) {
        fn = queue.shift();
        startLength--;
      }

      if ( fn ) {

        // Add a progress sentinel to prevent the fx queue from being
        // automatically dequeued
        if ( type === "fx" ) {
          queue.unshift( "inprogress" );
        }

        // Clear up the last queue stop function
        delete hooks.stop;
        fn.call( elem, next, hooks );
      }

      if ( !startLength && hooks ) {
        hooks.empty.fire();
      }
    },

    // Not public - generate a queueHooks object, or return the current one
    _queueHooks: function( elem, type ) {
      var key = type + "queueHooks";
      return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
        empty: jQuery.Callbacks( "once memory" ).add( function() {
          dataPriv.remove( elem, [ type + "queue", key ] );
        } )
      } );
    }
  } );

  jQuery.fn.extend( {
    queue: function( type, data ) {
      var setter = 2;

      if ( typeof type !== "string" ) {
        data = type;
        type = "fx";
        setter--;
      }

      if ( arguments.length < setter ) {
        return jQuery.queue( this[ 0 ], type );
      }

      return data === undefined ?
        this :
        this.each( function() {
          var queue = jQuery.queue( this, type, data );

          // Ensure a hooks for this queue
          jQuery._queueHooks( this, type );

          if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
            jQuery.dequeue( this, type );
          }
        } );
    },
    dequeue: function( type ) {
      return this.each( function() {
        jQuery.dequeue( this, type );
      } );
    },
    clearQueue: function( type ) {
      return this.queue( type || "fx", [] );
    },

    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function( type, obj ) {
      var tmp,
        count = 1,
        defer = jQuery.Deferred(),
        elements = this,
        i = this.length,
        resolve = function() {
          if ( !( --count ) ) {
            defer.resolveWith( elements, [ elements ] );
          }
        };

      if ( typeof type !== "string" ) {
        obj = type;
        type = undefined;
      }
      type = type || "fx";

      while ( i-- ) {
        tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
        if ( tmp && tmp.empty ) {
          count++;
          tmp.empty.add( resolve );
        }
      }
      resolve();
      return defer.promise( obj );
    }
  } );
  var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

  var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


  var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

  var documentElement = document.documentElement;



  var isAttached = function( elem ) {
      return jQuery.contains( elem.ownerDocument, elem );
    },
    composed = { composed: true };

  // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
  // Check attachment across shadow DOM boundaries when possible (gh-3504)
  // Support: iOS 10.0-10.2 only
  // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
  // leading to errors. We need to check for `getRootNode`.
  if ( documentElement.getRootNode ) {
    isAttached = function( elem ) {
      return jQuery.contains( elem.ownerDocument, elem ) ||
        elem.getRootNode( composed ) === elem.ownerDocument;
    };
  }
  var isHiddenWithinTree = function( elem, el ) {

    // isHiddenWithinTree might be called from jQuery#filter function;
    // in that case, element will be second argument
    elem = el || elem;

    // Inline style trumps all
    return elem.style.display === "none" ||
      elem.style.display === "" &&

      // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      isAttached( elem ) &&

      jQuery.css( elem, "display" ) === "none";
  };



  function adjustCSS( elem, prop, valueParts, tween ) {
    var adjusted, scale,
      maxIterations = 20,
      currentValue = tween ?
        function() {
          return tween.cur();
        } :
        function() {
          return jQuery.css( elem, prop, "" );
        },
      initial = currentValue(),
      unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

      // Starting value computation is required for potential unit mismatches
      initialInUnit = elem.nodeType &&
        ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
        rcssNum.exec( jQuery.css( elem, prop ) );

    if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

      // Support: Firefox <=54
      // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
      initial = initial / 2;

      // Trust units reported by jQuery.css
      unit = unit || initialInUnit[ 3 ];

      // Iteratively approximate from a nonzero starting point
      initialInUnit = +initial || 1;

      while ( maxIterations-- ) {

        // Evaluate and update our best guess (doubling guesses that zero out).
        // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
        jQuery.style( elem, prop, initialInUnit + unit );
        if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
          maxIterations = 0;
        }
        initialInUnit = initialInUnit / scale;

      }

      initialInUnit = initialInUnit * 2;
      jQuery.style( elem, prop, initialInUnit + unit );

      // Make sure we update the tween properties later on
      valueParts = valueParts || [];
    }

    if ( valueParts ) {
      initialInUnit = +initialInUnit || +initial || 0;

      // Apply relative offset (+=/-=) if specified
      adjusted = valueParts[ 1 ] ?
        initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
        +valueParts[ 2 ];
      if ( tween ) {
        tween.unit = unit;
        tween.start = initialInUnit;
        tween.end = adjusted;
      }
    }
    return adjusted;
  }


  var defaultDisplayMap = {};

  function getDefaultDisplay( elem ) {
    var temp,
      doc = elem.ownerDocument,
      nodeName = elem.nodeName,
      display = defaultDisplayMap[ nodeName ];

    if ( display ) {
      return display;
    }

    temp = doc.body.appendChild( doc.createElement( nodeName ) );
    display = jQuery.css( temp, "display" );

    temp.parentNode.removeChild( temp );

    if ( display === "none" ) {
      display = "block";
    }
    defaultDisplayMap[ nodeName ] = display;

    return display;
  }

  function showHide( elements, show ) {
    var display, elem,
      values = [],
      index = 0,
      length = elements.length;

    // Determine new display value for elements that need to change
    for ( ; index < length; index++ ) {
      elem = elements[ index ];
      if ( !elem.style ) {
        continue;
      }

      display = elem.style.display;
      if ( show ) {

        // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
        // check is required in this first loop unless we have a nonempty display value (either
        // inline or about-to-be-restored)
        if ( display === "none" ) {
          values[ index ] = dataPriv.get( elem, "display" ) || null;
          if ( !values[ index ] ) {
            elem.style.display = "";
          }
        }
        if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
          values[ index ] = getDefaultDisplay( elem );
        }
      } else {
        if ( display !== "none" ) {
          values[ index ] = "none";

          // Remember what we're overwriting
          dataPriv.set( elem, "display", display );
        }
      }
    }

    // Set the display of the elements in a second loop to avoid constant reflow
    for ( index = 0; index < length; index++ ) {
      if ( values[ index ] != null ) {
        elements[ index ].style.display = values[ index ];
      }
    }

    return elements;
  }

  jQuery.fn.extend( {
    show: function() {
      return showHide( this, true );
    },
    hide: function() {
      return showHide( this );
    },
    toggle: function( state ) {
      if ( typeof state === "boolean" ) {
        return state ? this.show() : this.hide();
      }

      return this.each( function() {
        if ( isHiddenWithinTree( this ) ) {
          jQuery( this ).show();
        } else {
          jQuery( this ).hide();
        }
      } );
    }
  } );
  var rcheckableType = ( /^(?:checkbox|radio)$/i );

  var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

  var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



  ( function() {
    var fragment = document.createDocumentFragment(),
      div = fragment.appendChild( document.createElement( "div" ) ),
      input = document.createElement( "input" );

    // Support: Android 4.0 - 4.3 only
    // Check state lost if the name is set (trac-11217)
    // Support: Windows Web Apps (WWA)
    // `name` and `type` must use .setAttribute for WWA (trac-14901)
    input.setAttribute( "type", "radio" );
    input.setAttribute( "checked", "checked" );
    input.setAttribute( "name", "t" );

    div.appendChild( input );

    // Support: Android <=4.1 only
    // Older WebKit doesn't clone checked state correctly in fragments
    support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

    // Support: IE <=11 only
    // Make sure textarea (and checkbox) defaultValue is properly cloned
    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

    // Support: IE <=9 only
    // IE <=9 replaces <option> tags with their contents when inserted outside of
    // the select element.
    div.innerHTML = "<option></option>";
    support.option = !!div.lastChild;
  } )();


// We have to close these tags to support XHTML (trac-13200)
  var wrapMap = {

    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do. So we cannot shorten
    // this by omitting <tbody> or other required elements.
    thead: [ 1, "<table>", "</table>" ],
    col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
    tr: [ 2, "<table><tbody>", "</tbody></table>" ],
    td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

    _default: [ 0, "", "" ]
  };

  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

// Support: IE <=9 only
  if ( !support.option ) {
    wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
  }


  function getAll( context, tag ) {

    // Support: IE <=9 - 11 only
    // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
    var ret;

    if ( typeof context.getElementsByTagName !== "undefined" ) {
      ret = context.getElementsByTagName( tag || "*" );

    } else if ( typeof context.querySelectorAll !== "undefined" ) {
      ret = context.querySelectorAll( tag || "*" );

    } else {
      ret = [];
    }

    if ( tag === undefined || tag && nodeName( context, tag ) ) {
      return jQuery.merge( [ context ], ret );
    }

    return ret;
  }


// Mark scripts as having already been evaluated
  function setGlobalEval( elems, refElements ) {
    var i = 0,
      l = elems.length;

    for ( ; i < l; i++ ) {
      dataPriv.set(
        elems[ i ],
        "globalEval",
        !refElements || dataPriv.get( refElements[ i ], "globalEval" )
      );
    }
  }


  var rhtml = /<|&#?\w+;/;

  function buildFragment( elems, context, scripts, selection, ignored ) {
    var elem, tmp, tag, wrap, attached, j,
      fragment = context.createDocumentFragment(),
      nodes = [],
      i = 0,
      l = elems.length;

    for ( ; i < l; i++ ) {
      elem = elems[ i ];

      if ( elem || elem === 0 ) {

        // Add nodes directly
        if ( toType( elem ) === "object" ) {

          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

          // Convert non-html into a text node
        } else if ( !rhtml.test( elem ) ) {
          nodes.push( context.createTextNode( elem ) );

          // Convert html into DOM nodes
        } else {
          tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

          // Deserialize a standard representation
          tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
          wrap = wrapMap[ tag ] || wrapMap._default;
          tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

          // Descend through wrappers to the right content
          j = wrap[ 0 ];
          while ( j-- ) {
            tmp = tmp.lastChild;
          }

          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge( nodes, tmp.childNodes );

          // Remember the top-level container
          tmp = fragment.firstChild;

          // Ensure the created nodes are orphaned (trac-12392)
          tmp.textContent = "";
        }
      }
    }

    // Remove wrapper from fragment
    fragment.textContent = "";

    i = 0;
    while ( ( elem = nodes[ i++ ] ) ) {

      // Skip elements already in the context collection (trac-4087)
      if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
        if ( ignored ) {
          ignored.push( elem );
        }
        continue;
      }

      attached = isAttached( elem );

      // Append to fragment
      tmp = getAll( fragment.appendChild( elem ), "script" );

      // Preserve script evaluation history
      if ( attached ) {
        setGlobalEval( tmp );
      }

      // Capture executables
      if ( scripts ) {
        j = 0;
        while ( ( elem = tmp[ j++ ] ) ) {
          if ( rscriptType.test( elem.type || "" ) ) {
            scripts.push( elem );
          }
        }
      }
    }

    return fragment;
  }


  var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

  function returnTrue() {
    return true;
  }

  function returnFalse() {
    return false;
  }

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
  function expectSync( elem, type ) {
    return ( elem === safeActiveElement() ) === ( type === "focus" );
  }

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch ( err ) { }
  }

  function on( elem, types, selector, data, fn, one ) {
    var origFn, type;

    // Types can be a map of types/handlers
    if ( typeof types === "object" ) {

      // ( types-Object, selector, data )
      if ( typeof selector !== "string" ) {

        // ( types-Object, data )
        data = data || selector;
        selector = undefined;
      }
      for ( type in types ) {
        on( elem, type, selector, data, types[ type ], one );
      }
      return elem;
    }

    if ( data == null && fn == null ) {

      // ( types, fn )
      fn = selector;
      data = selector = undefined;
    } else if ( fn == null ) {
      if ( typeof selector === "string" ) {

        // ( types, selector, fn )
        fn = data;
        data = undefined;
      } else {

        // ( types, data, fn )
        fn = data;
        data = selector;
        selector = undefined;
      }
    }
    if ( fn === false ) {
      fn = returnFalse;
    } else if ( !fn ) {
      return elem;
    }

    if ( one === 1 ) {
      origFn = fn;
      fn = function( event ) {

        // Can use an empty set, since event contains the info
        jQuery().off( event );
        return origFn.apply( this, arguments );
      };

      // Use same guid so caller can remove using origFn
      fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
    }
    return elem.each( function() {
      jQuery.event.add( this, types, fn, data, selector );
    } );
  }

  /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
  jQuery.event = {

    global: {},

    add: function( elem, types, handler, data, selector ) {

      var handleObjIn, eventHandle, tmp,
        events, t, handleObj,
        special, handlers, type, namespaces, origType,
        elemData = dataPriv.get( elem );

      // Only attach events to objects that accept data
      if ( !acceptData( elem ) ) {
        return;
      }

      // Caller can pass in an object of custom data in lieu of the handler
      if ( handler.handler ) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      }

      // Ensure that invalid selectors throw exceptions at attach time
      // Evaluate against documentElement in case elem is a non-element node (e.g., document)
      if ( selector ) {
        jQuery.find.matchesSelector( documentElement, selector );
      }

      // Make sure that the handler has a unique ID, used to find/remove it later
      if ( !handler.guid ) {
        handler.guid = jQuery.guid++;
      }

      // Init the element's event structure and main handler, if this is the first
      if ( !( events = elemData.events ) ) {
        events = elemData.events = Object.create( null );
      }
      if ( !( eventHandle = elemData.handle ) ) {
        eventHandle = elemData.handle = function( e ) {

          // Discard the second event of a jQuery.event.trigger() and
          // when an event is called after a page has unloaded
          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
            jQuery.event.dispatch.apply( elem, arguments ) : undefined;
        };
      }

      // Handle multiple events separated by a space
      types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
      t = types.length;
      while ( t-- ) {
        tmp = rtypenamespace.exec( types[ t ] ) || [];
        type = origType = tmp[ 1 ];
        namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

        // There *must* be a type, no attaching namespace-only handlers
        if ( !type ) {
          continue;
        }

        // If event changes its type, use the special event handlers for the changed type
        special = jQuery.event.special[ type ] || {};

        // If selector defined, determine special event api type, otherwise given type
        type = ( selector ? special.delegateType : special.bindType ) || type;

        // Update special based on newly reset type
        special = jQuery.event.special[ type ] || {};

        // handleObj is passed to all event handlers
        handleObj = jQuery.extend( {
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
          namespace: namespaces.join( "." )
        }, handleObjIn );

        // Init the event handler queue if we're the first
        if ( !( handlers = events[ type ] ) ) {
          handlers = events[ type ] = [];
          handlers.delegateCount = 0;

          // Only use addEventListener if the special events handler returns false
          if ( !special.setup ||
            special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

            if ( elem.addEventListener ) {
              elem.addEventListener( type, eventHandle );
            }
          }
        }

        if ( special.add ) {
          special.add.call( elem, handleObj );

          if ( !handleObj.handler.guid ) {
            handleObj.handler.guid = handler.guid;
          }
        }

        // Add to the element's handler list, delegates in front
        if ( selector ) {
          handlers.splice( handlers.delegateCount++, 0, handleObj );
        } else {
          handlers.push( handleObj );
        }

        // Keep track of which events have ever been used, for event optimization
        jQuery.event.global[ type ] = true;
      }

    },

    // Detach an event or set of events from an element
    remove: function( elem, types, handler, selector, mappedTypes ) {

      var j, origCount, tmp,
        events, t, handleObj,
        special, handlers, type, namespaces, origType,
        elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

      if ( !elemData || !( events = elemData.events ) ) {
        return;
      }

      // Once for each type.namespace in types; type may be omitted
      types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
      t = types.length;
      while ( t-- ) {
        tmp = rtypenamespace.exec( types[ t ] ) || [];
        type = origType = tmp[ 1 ];
        namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

        // Unbind all events (on this namespace, if provided) for the element
        if ( !type ) {
          for ( type in events ) {
            jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
          }
          continue;
        }

        special = jQuery.event.special[ type ] || {};
        type = ( selector ? special.delegateType : special.bindType ) || type;
        handlers = events[ type ] || [];
        tmp = tmp[ 2 ] &&
          new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

        // Remove matching events
        origCount = j = handlers.length;
        while ( j-- ) {
          handleObj = handlers[ j ];

          if ( ( mappedTypes || origType === handleObj.origType ) &&
            ( !handler || handler.guid === handleObj.guid ) &&
            ( !tmp || tmp.test( handleObj.namespace ) ) &&
            ( !selector || selector === handleObj.selector ||
              selector === "**" && handleObj.selector ) ) {
            handlers.splice( j, 1 );

            if ( handleObj.selector ) {
              handlers.delegateCount--;
            }
            if ( special.remove ) {
              special.remove.call( elem, handleObj );
            }
          }
        }

        // Remove generic event handler if we removed something and no more handlers exist
        // (avoids potential for endless recursion during removal of special event handlers)
        if ( origCount && !handlers.length ) {
          if ( !special.teardown ||
            special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

            jQuery.removeEvent( elem, type, elemData.handle );
          }

          delete events[ type ];
        }
      }

      // Remove data and the expando if it's no longer used
      if ( jQuery.isEmptyObject( events ) ) {
        dataPriv.remove( elem, "handle events" );
      }
    },

    dispatch: function( nativeEvent ) {

      var i, j, ret, matched, handleObj, handlerQueue,
        args = new Array( arguments.length ),

        // Make a writable jQuery.Event from the native event object
        event = jQuery.event.fix( nativeEvent ),

        handlers = (
          dataPriv.get( this, "events" ) || Object.create( null )
        )[ event.type ] || [],
        special = jQuery.event.special[ event.type ] || {};

      // Use the fix-ed jQuery.Event rather than the (read-only) native event
      args[ 0 ] = event;

      for ( i = 1; i < arguments.length; i++ ) {
        args[ i ] = arguments[ i ];
      }

      event.delegateTarget = this;

      // Call the preDispatch hook for the mapped type, and let it bail if desired
      if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
        return;
      }

      // Determine handlers
      handlerQueue = jQuery.event.handlers.call( this, event, handlers );

      // Run delegates first; they may want to stop propagation beneath us
      i = 0;
      while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
        event.currentTarget = matched.elem;

        j = 0;
        while ( ( handleObj = matched.handlers[ j++ ] ) &&
        !event.isImmediatePropagationStopped() ) {

          // If the event is namespaced, then each handler is only invoked if it is
          // specially universal or its namespaces are a superset of the event's.
          if ( !event.rnamespace || handleObj.namespace === false ||
            event.rnamespace.test( handleObj.namespace ) ) {

            event.handleObj = handleObj;
            event.data = handleObj.data;

            ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
              handleObj.handler ).apply( matched.elem, args );

            if ( ret !== undefined ) {
              if ( ( event.result = ret ) === false ) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      }

      // Call the postDispatch hook for the mapped type
      if ( special.postDispatch ) {
        special.postDispatch.call( this, event );
      }

      return event.result;
    },

    handlers: function( event, handlers ) {
      var i, handleObj, sel, matchedHandlers, matchedSelectors,
        handlerQueue = [],
        delegateCount = handlers.delegateCount,
        cur = event.target;

      // Find delegate handlers
      if ( delegateCount &&

        // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        cur.nodeType &&

        // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !( event.type === "click" && event.button >= 1 ) ) {

        for ( ; cur !== this; cur = cur.parentNode || this ) {

          // Don't check non-elements (trac-13208)
          // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
          if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
            matchedHandlers = [];
            matchedSelectors = {};
            for ( i = 0; i < delegateCount; i++ ) {
              handleObj = handlers[ i ];

              // Don't conflict with Object.prototype properties (trac-13203)
              sel = handleObj.selector + " ";

              if ( matchedSelectors[ sel ] === undefined ) {
                matchedSelectors[ sel ] = handleObj.needsContext ?
                  jQuery( sel, this ).index( cur ) > -1 :
                  jQuery.find( sel, this, null, [ cur ] ).length;
              }
              if ( matchedSelectors[ sel ] ) {
                matchedHandlers.push( handleObj );
              }
            }
            if ( matchedHandlers.length ) {
              handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
            }
          }
        }
      }

      // Add the remaining (directly-bound) handlers
      cur = this;
      if ( delegateCount < handlers.length ) {
        handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
      }

      return handlerQueue;
    },

    addProp: function( name, hook ) {
      Object.defineProperty( jQuery.Event.prototype, name, {
        enumerable: true,
        configurable: true,

        get: isFunction( hook ) ?
          function() {
            if ( this.originalEvent ) {
              return hook( this.originalEvent );
            }
          } :
          function() {
            if ( this.originalEvent ) {
              return this.originalEvent[ name ];
            }
          },

        set: function( value ) {
          Object.defineProperty( this, name, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: value
          } );
        }
      } );
    },

    fix: function( originalEvent ) {
      return originalEvent[ jQuery.expando ] ?
        originalEvent :
        new jQuery.Event( originalEvent );
    },

    special: {
      load: {

        // Prevent triggered image.load events from bubbling to window.load
        noBubble: true
      },
      click: {

        // Utilize native event to ensure correct state for checkable inputs
        setup: function( data ) {

          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data;

          // Claim the first handler
          if ( rcheckableType.test( el.type ) &&
            el.click && nodeName( el, "input" ) ) {

            // dataPriv.set( el, "click", ... )
            leverageNative( el, "click", returnTrue );
          }

          // Return false to allow normal processing in the caller
          return false;
        },
        trigger: function( data ) {

          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data;

          // Force setup before triggering a click
          if ( rcheckableType.test( el.type ) &&
            el.click && nodeName( el, "input" ) ) {

            leverageNative( el, "click" );
          }

          // Return non-false to allow normal event-path propagation
          return true;
        },

        // For cross-browser consistency, suppress native .click() on links
        // Also prevent it if we're currently inside a leveraged native-event stack
        _default: function( event ) {
          var target = event.target;
          return rcheckableType.test( target.type ) &&
            target.click && nodeName( target, "input" ) &&
            dataPriv.get( target, "click" ) ||
            nodeName( target, "a" );
        }
      },

      beforeunload: {
        postDispatch: function( event ) {

          // Support: Firefox 20+
          // Firefox doesn't alert if the returnValue field is not set.
          if ( event.result !== undefined && event.originalEvent ) {
            event.originalEvent.returnValue = event.result;
          }
        }
      }
    }
  };

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
  function leverageNative( el, type, expectSync ) {

    // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
    if ( !expectSync ) {
      if ( dataPriv.get( el, type ) === undefined ) {
        jQuery.event.add( el, type, returnTrue );
      }
      return;
    }

    // Register the controller as a special universal handler for all event namespaces
    dataPriv.set( el, type, false );
    jQuery.event.add( el, type, {
      namespace: false,
      handler: function( event ) {
        var notAsync, result,
          saved = dataPriv.get( this, type );

        if ( ( event.isTrigger & 1 ) && this[ type ] ) {

          // Interrupt processing of the outer synthetic .trigger()ed event
          // Saved data should be false in such cases, but might be a leftover capture object
          // from an async native handler (gh-4350)
          if ( !saved.length ) {

            // Store arguments for use when handling the inner native event
            // There will always be at least one argument (an event object), so this array
            // will not be confused with a leftover capture object.
            saved = slice.call( arguments );
            dataPriv.set( this, type, saved );

            // Trigger the native event and capture its result
            // Support: IE <=9 - 11+
            // focus() and blur() are asynchronous
            notAsync = expectSync( this, type );
            this[ type ]();
            result = dataPriv.get( this, type );
            if ( saved !== result || notAsync ) {
              dataPriv.set( this, type, false );
            } else {
              result = {};
            }
            if ( saved !== result ) {

              // Cancel the outer synthetic event
              event.stopImmediatePropagation();
              event.preventDefault();

              // Support: Chrome 86+
              // In Chrome, if an element having a focusout handler is blurred by
              // clicking outside of it, it invokes the handler synchronously. If
              // that handler calls `.remove()` on the element, the data is cleared,
              // leaving `result` undefined. We need to guard against this.
              return result && result.value;
            }

            // If this is an inner synthetic event for an event with a bubbling surrogate
            // (focus or blur), assume that the surrogate already propagated from triggering the
            // native event and prevent that from happening again here.
            // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
            // bubbling surrogate propagates *after* the non-bubbling base), but that seems
            // less bad than duplication.
          } else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
            event.stopPropagation();
          }

          // If this is a native event triggered above, everything is now in order
          // Fire an inner synthetic event with the original arguments
        } else if ( saved.length ) {

          // ...and capture the result
          dataPriv.set( this, type, {
            value: jQuery.event.trigger(

              // Support: IE <=9 - 11+
              // Extend with the prototype to reset the above stopImmediatePropagation()
              jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
              saved.slice( 1 ),
              this
            )
          } );

          // Abort handling of the native event
          event.stopImmediatePropagation();
        }
      }
    } );
  }

  jQuery.removeEvent = function( elem, type, handle ) {

    // This "if" is needed for plain objects
    if ( elem.removeEventListener ) {
      elem.removeEventListener( type, handle );
    }
  };

  jQuery.Event = function( src, props ) {

    // Allow instantiation without the 'new' keyword
    if ( !( this instanceof jQuery.Event ) ) {
      return new jQuery.Event( src, props );
    }

    // Event object
    if ( src && src.type ) {
      this.originalEvent = src;
      this.type = src.type;

      // Events bubbling up the document may have been marked as prevented
      // by a handler lower down the tree; reflect the correct value.
      this.isDefaultPrevented = src.defaultPrevented ||
      src.defaultPrevented === undefined &&

      // Support: Android <=2.3 only
      src.returnValue === false ?
        returnTrue :
        returnFalse;

      // Create target properties
      // Support: Safari <=6 - 7 only
      // Target should not be a text node (trac-504, trac-13143)
      this.target = ( src.target && src.target.nodeType === 3 ) ?
        src.target.parentNode :
        src.target;

      this.currentTarget = src.currentTarget;
      this.relatedTarget = src.relatedTarget;

      // Event type
    } else {
      this.type = src;
    }

    // Put explicitly provided properties onto the event object
    if ( props ) {
      jQuery.extend( this, props );
    }

    // Create a timestamp if incoming event doesn't have one
    this.timeStamp = src && src.timeStamp || Date.now();

    // Mark it as fixed
    this[ jQuery.expando ] = true;
  };

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
  jQuery.Event.prototype = {
    constructor: jQuery.Event,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    isSimulated: false,

    preventDefault: function() {
      var e = this.originalEvent;

      this.isDefaultPrevented = returnTrue;

      if ( e && !this.isSimulated ) {
        e.preventDefault();
      }
    },
    stopPropagation: function() {
      var e = this.originalEvent;

      this.isPropagationStopped = returnTrue;

      if ( e && !this.isSimulated ) {
        e.stopPropagation();
      }
    },
    stopImmediatePropagation: function() {
      var e = this.originalEvent;

      this.isImmediatePropagationStopped = returnTrue;

      if ( e && !this.isSimulated ) {
        e.stopImmediatePropagation();
      }

      this.stopPropagation();
    }
  };

// Includes all common event props including KeyEvent and MouseEvent specific props
  jQuery.each( {
    altKey: true,
    bubbles: true,
    cancelable: true,
    changedTouches: true,
    ctrlKey: true,
    detail: true,
    eventPhase: true,
    metaKey: true,
    pageX: true,
    pageY: true,
    shiftKey: true,
    view: true,
    "char": true,
    code: true,
    charCode: true,
    key: true,
    keyCode: true,
    button: true,
    buttons: true,
    clientX: true,
    clientY: true,
    offsetX: true,
    offsetY: true,
    pointerId: true,
    pointerType: true,
    screenX: true,
    screenY: true,
    targetTouches: true,
    toElement: true,
    touches: true,
    which: true
  }, jQuery.event.addProp );

  jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
    jQuery.event.special[ type ] = {

      // Utilize native event if possible so blur/focus sequence is correct
      setup: function() {

        // Claim the first handler
        // dataPriv.set( this, "focus", ... )
        // dataPriv.set( this, "blur", ... )
        leverageNative( this, type, expectSync );

        // Return false to allow normal processing in the caller
        return false;
      },
      trigger: function() {

        // Force setup before trigger
        leverageNative( this, type );

        // Return non-false to allow normal event-path propagation
        return true;
      },

      // Suppress native focus or blur if we're currently inside
      // a leveraged native-event stack
      _default: function( event ) {
        return dataPriv.get( event.target, type );
      },

      delegateType: delegateType
    };
  } );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
  jQuery.each( {
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function( orig, fix ) {
    jQuery.event.special[ orig ] = {
      delegateType: fix,
      bindType: fix,

      handle: function( event ) {
        var ret,
          target = this,
          related = event.relatedTarget,
          handleObj = event.handleObj;

        // For mouseenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply( this, arguments );
          event.type = fix;
        }
        return ret;
      }
    };
  } );

  jQuery.fn.extend( {

    on: function( types, selector, data, fn ) {
      return on( this, types, selector, data, fn );
    },
    one: function( types, selector, data, fn ) {
      return on( this, types, selector, data, fn, 1 );
    },
    off: function( types, selector, fn ) {
      var handleObj, type;
      if ( types && types.preventDefault && types.handleObj ) {

        // ( event )  dispatched jQuery.Event
        handleObj = types.handleObj;
        jQuery( types.delegateTarget ).off(
          handleObj.namespace ?
            handleObj.origType + "." + handleObj.namespace :
            handleObj.origType,
          handleObj.selector,
          handleObj.handler
        );
        return this;
      }
      if ( typeof types === "object" ) {

        // ( types-object [, selector] )
        for ( type in types ) {
          this.off( type, selector, types[ type ] );
        }
        return this;
      }
      if ( selector === false || typeof selector === "function" ) {

        // ( types [, fn] )
        fn = selector;
        selector = undefined;
      }
      if ( fn === false ) {
        fn = returnFalse;
      }
      return this.each( function() {
        jQuery.event.remove( this, types, fn, selector );
      } );
    }
  } );


  var

    // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i,

    // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

    rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
  function manipulationTarget( elem, content ) {
    if ( nodeName( elem, "table" ) &&
      nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

      return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
    }

    return elem;
  }

// Replace/restore the type attribute of script elements for safe DOM manipulation
  function disableScript( elem ) {
    elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
    return elem;
  }
  function restoreScript( elem ) {
    if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
      elem.type = elem.type.slice( 5 );
    } else {
      elem.removeAttribute( "type" );
    }

    return elem;
  }

  function cloneCopyEvent( src, dest ) {
    var i, l, type, pdataOld, udataOld, udataCur, events;

    if ( dest.nodeType !== 1 ) {
      return;
    }

    // 1. Copy private data: events, handlers, etc.
    if ( dataPriv.hasData( src ) ) {
      pdataOld = dataPriv.get( src );
      events = pdataOld.events;

      if ( events ) {
        dataPriv.remove( dest, "handle events" );

        for ( type in events ) {
          for ( i = 0, l = events[ type ].length; i < l; i++ ) {
            jQuery.event.add( dest, type, events[ type ][ i ] );
          }
        }
      }
    }

    // 2. Copy user data
    if ( dataUser.hasData( src ) ) {
      udataOld = dataUser.access( src );
      udataCur = jQuery.extend( {}, udataOld );

      dataUser.set( dest, udataCur );
    }
  }

// Fix IE bugs, see support tests
  function fixInput( src, dest ) {
    var nodeName = dest.nodeName.toLowerCase();

    // Fails to persist the checked state of a cloned checkbox or radio button.
    if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
      dest.checked = src.checked;

      // Fails to return the selected option to the default selected state when cloning options
    } else if ( nodeName === "input" || nodeName === "textarea" ) {
      dest.defaultValue = src.defaultValue;
    }
  }

  function domManip( collection, args, callback, ignored ) {

    // Flatten any nested arrays
    args = flat( args );

    var fragment, first, scripts, hasScripts, node, doc,
      i = 0,
      l = collection.length,
      iNoClone = l - 1,
      value = args[ 0 ],
      valueIsFunction = isFunction( value );

    // We can't cloneNode fragments that contain checked, in WebKit
    if ( valueIsFunction ||
      ( l > 1 && typeof value === "string" &&
        !support.checkClone && rchecked.test( value ) ) ) {
      return collection.each( function( index ) {
        var self = collection.eq( index );
        if ( valueIsFunction ) {
          args[ 0 ] = value.call( this, index, self.html() );
        }
        domManip( self, args, callback, ignored );
      } );
    }

    if ( l ) {
      fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
      first = fragment.firstChild;

      if ( fragment.childNodes.length === 1 ) {
        fragment = first;
      }

      // Require either new content or an interest in ignored elements to invoke the callback
      if ( first || ignored ) {
        scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
        hasScripts = scripts.length;

        // Use the original fragment for the last item
        // instead of the first because it can end up
        // being emptied incorrectly in certain situations (trac-8070).
        for ( ; i < l; i++ ) {
          node = fragment;

          if ( i !== iNoClone ) {
            node = jQuery.clone( node, true, true );

            // Keep references to cloned scripts for later restoration
            if ( hasScripts ) {

              // Support: Android <=4.0 only, PhantomJS 1 only
              // push.apply(_, arraylike) throws on ancient WebKit
              jQuery.merge( scripts, getAll( node, "script" ) );
            }
          }

          callback.call( collection[ i ], node, i );
        }

        if ( hasScripts ) {
          doc = scripts[ scripts.length - 1 ].ownerDocument;

          // Reenable scripts
          jQuery.map( scripts, restoreScript );

          // Evaluate executable scripts on first document insertion
          for ( i = 0; i < hasScripts; i++ ) {
            node = scripts[ i ];
            if ( rscriptType.test( node.type || "" ) &&
              !dataPriv.access( node, "globalEval" ) &&
              jQuery.contains( doc, node ) ) {

              if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

                // Optional AJAX dependency, but won't run scripts if not present
                if ( jQuery._evalUrl && !node.noModule ) {
                  jQuery._evalUrl( node.src, {
                    nonce: node.nonce || node.getAttribute( "nonce" )
                  }, doc );
                }
              } else {

                // Unwrap a CDATA section containing script contents. This shouldn't be
                // needed as in XML documents they're already not visible when
                // inspecting element contents and in HTML documents they have no
                // meaning but we're preserving that logic for backwards compatibility.
                // This will be removed completely in 4.0. See gh-4904.
                DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
              }
            }
          }
        }
      }
    }

    return collection;
  }

  function remove( elem, selector, keepData ) {
    var node,
      nodes = selector ? jQuery.filter( selector, elem ) : elem,
      i = 0;

    for ( ; ( node = nodes[ i ] ) != null; i++ ) {
      if ( !keepData && node.nodeType === 1 ) {
        jQuery.cleanData( getAll( node ) );
      }

      if ( node.parentNode ) {
        if ( keepData && isAttached( node ) ) {
          setGlobalEval( getAll( node, "script" ) );
        }
        node.parentNode.removeChild( node );
      }
    }

    return elem;
  }

  jQuery.extend( {
    htmlPrefilter: function( html ) {
      return html;
    },

    clone: function( elem, dataAndEvents, deepDataAndEvents ) {
      var i, l, srcElements, destElements,
        clone = elem.cloneNode( true ),
        inPage = isAttached( elem );

      // Fix IE cloning issues
      if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
        !jQuery.isXMLDoc( elem ) ) {

        // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
        destElements = getAll( clone );
        srcElements = getAll( elem );

        for ( i = 0, l = srcElements.length; i < l; i++ ) {
          fixInput( srcElements[ i ], destElements[ i ] );
        }
      }

      // Copy the events from the original to the clone
      if ( dataAndEvents ) {
        if ( deepDataAndEvents ) {
          srcElements = srcElements || getAll( elem );
          destElements = destElements || getAll( clone );

          for ( i = 0, l = srcElements.length; i < l; i++ ) {
            cloneCopyEvent( srcElements[ i ], destElements[ i ] );
          }
        } else {
          cloneCopyEvent( elem, clone );
        }
      }

      // Preserve script evaluation history
      destElements = getAll( clone, "script" );
      if ( destElements.length > 0 ) {
        setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
      }

      // Return the cloned set
      return clone;
    },

    cleanData: function( elems ) {
      var data, elem, type,
        special = jQuery.event.special,
        i = 0;

      for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
        if ( acceptData( elem ) ) {
          if ( ( data = elem[ dataPriv.expando ] ) ) {
            if ( data.events ) {
              for ( type in data.events ) {
                if ( special[ type ] ) {
                  jQuery.event.remove( elem, type );

                  // This is a shortcut to avoid jQuery.event.remove's overhead
                } else {
                  jQuery.removeEvent( elem, type, data.handle );
                }
              }
            }

            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[ dataPriv.expando ] = undefined;
          }
          if ( elem[ dataUser.expando ] ) {

            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[ dataUser.expando ] = undefined;
          }
        }
      }
    }
  } );

  jQuery.fn.extend( {
    detach: function( selector ) {
      return remove( this, selector, true );
    },

    remove: function( selector ) {
      return remove( this, selector );
    },

    text: function( value ) {
      return access( this, function( value ) {
        return value === undefined ?
          jQuery.text( this ) :
          this.empty().each( function() {
            if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
              this.textContent = value;
            }
          } );
      }, null, value, arguments.length );
    },

    append: function() {
      return domManip( this, arguments, function( elem ) {
        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
          var target = manipulationTarget( this, elem );
          target.appendChild( elem );
        }
      } );
    },

    prepend: function() {
      return domManip( this, arguments, function( elem ) {
        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
          var target = manipulationTarget( this, elem );
          target.insertBefore( elem, target.firstChild );
        }
      } );
    },

    before: function() {
      return domManip( this, arguments, function( elem ) {
        if ( this.parentNode ) {
          this.parentNode.insertBefore( elem, this );
        }
      } );
    },

    after: function() {
      return domManip( this, arguments, function( elem ) {
        if ( this.parentNode ) {
          this.parentNode.insertBefore( elem, this.nextSibling );
        }
      } );
    },

    empty: function() {
      var elem,
        i = 0;

      for ( ; ( elem = this[ i ] ) != null; i++ ) {
        if ( elem.nodeType === 1 ) {

          // Prevent memory leaks
          jQuery.cleanData( getAll( elem, false ) );

          // Remove any remaining nodes
          elem.textContent = "";
        }
      }

      return this;
    },

    clone: function( dataAndEvents, deepDataAndEvents ) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

      return this.map( function() {
        return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
      } );
    },

    html: function( value ) {
      return access( this, function( value ) {
        var elem = this[ 0 ] || {},
          i = 0,
          l = this.length;

        if ( value === undefined && elem.nodeType === 1 ) {
          return elem.innerHTML;
        }

        // See if we can take a shortcut and just use innerHTML
        if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
          !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

          value = jQuery.htmlPrefilter( value );

          try {
            for ( ; i < l; i++ ) {
              elem = this[ i ] || {};

              // Remove element nodes and prevent memory leaks
              if ( elem.nodeType === 1 ) {
                jQuery.cleanData( getAll( elem, false ) );
                elem.innerHTML = value;
              }
            }

            elem = 0;

            // If using innerHTML throws an exception, use the fallback method
          } catch ( e ) {}
        }

        if ( elem ) {
          this.empty().append( value );
        }
      }, null, value, arguments.length );
    },

    replaceWith: function() {
      var ignored = [];

      // Make the changes, replacing each non-ignored context element with the new content
      return domManip( this, arguments, function( elem ) {
        var parent = this.parentNode;

        if ( jQuery.inArray( this, ignored ) < 0 ) {
          jQuery.cleanData( getAll( this ) );
          if ( parent ) {
            parent.replaceChild( elem, this );
          }
        }

        // Force callback invocation
      }, ignored );
    }
  } );

  jQuery.each( {
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function( name, original ) {
    jQuery.fn[ name ] = function( selector ) {
      var elems,
        ret = [],
        insert = jQuery( selector ),
        last = insert.length - 1,
        i = 0;

      for ( ; i <= last; i++ ) {
        elems = i === last ? this : this.clone( true );
        jQuery( insert[ i ] )[ original ]( elems );

        // Support: Android <=4.0 only, PhantomJS 1 only
        // .get() because push.apply(_, arraylike) throws on ancient WebKit
        push.apply( ret, elems.get() );
      }

      return this.pushStack( ret );
    };
  } );
  var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

  var rcustomProp = /^--/;


  var getStyles = function( elem ) {

    // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
    // IE throws on elements created in popups
    // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
    var view = elem.ownerDocument.defaultView;

    if ( !view || !view.opener ) {
      view = window;
    }

    return view.getComputedStyle( elem );
  };

  var swap = function( elem, options, callback ) {
    var ret, name,
      old = {};

    // Remember the old values, and insert the new ones
    for ( name in options ) {
      old[ name ] = elem.style[ name ];
      elem.style[ name ] = options[ name ];
    }

    ret = callback.call( elem );

    // Revert the old values
    for ( name in options ) {
      elem.style[ name ] = old[ name ];
    }

    return ret;
  };


  var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

  var whitespace = "[\\x20\\t\\r\\n\\f]";


  var rtrimCSS = new RegExp(
    "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
    "g"
  );




  ( function() {

    // Executing both pixelPosition & boxSizingReliable tests require only one layout
    // so they're executed at the same time to save the second computation.
    function computeStyleTests() {

      // This is a singleton, we need to execute it only once
      if ( !div ) {
        return;
      }

      container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
        "margin-top:1px;padding:0;border:0";
      div.style.cssText =
        "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
        "margin:auto;border:1px;padding:1px;" +
        "width:60%;top:1%";
      documentElement.appendChild( container ).appendChild( div );

      var divStyle = window.getComputedStyle( div );
      pixelPositionVal = divStyle.top !== "1%";

      // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
      reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

      // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
      // Some styles come back with percentage values, even though they shouldn't
      div.style.right = "60%";
      pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

      // Support: IE 9 - 11 only
      // Detect misreporting of content dimensions for box-sizing:border-box elements
      boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

      // Support: IE 9 only
      // Detect overflow:scroll screwiness (gh-3699)
      // Support: Chrome <=64
      // Don't get tricked when zoom affects offsetWidth (gh-4029)
      div.style.position = "absolute";
      scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

      documentElement.removeChild( container );

      // Nullify the div so it wouldn't be stored in the memory and
      // it will also be a sign that checks already performed
      div = null;
    }

    function roundPixelMeasures( measure ) {
      return Math.round( parseFloat( measure ) );
    }

    var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
      reliableTrDimensionsVal, reliableMarginLeftVal,
      container = document.createElement( "div" ),
      div = document.createElement( "div" );

    // Finish early in limited (non-browser) environments
    if ( !div.style ) {
      return;
    }

    // Support: IE <=9 - 11 only
    // Style of cloned element affects source element cloned (trac-8908)
    div.style.backgroundClip = "content-box";
    div.cloneNode( true ).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";

    jQuery.extend( support, {
      boxSizingReliable: function() {
        computeStyleTests();
        return boxSizingReliableVal;
      },
      pixelBoxStyles: function() {
        computeStyleTests();
        return pixelBoxStylesVal;
      },
      pixelPosition: function() {
        computeStyleTests();
        return pixelPositionVal;
      },
      reliableMarginLeft: function() {
        computeStyleTests();
        return reliableMarginLeftVal;
      },
      scrollboxSize: function() {
        computeStyleTests();
        return scrollboxSizeVal;
      },

      // Support: IE 9 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Behavior in IE 9 is more subtle than in newer versions & it passes
      // some versions of this test; make sure not to make it pass there!
      //
      // Support: Firefox 70+
      // Only Firefox includes border widths
      // in computed dimensions. (gh-4529)
      reliableTrDimensions: function() {
        var table, tr, trChild, trStyle;
        if ( reliableTrDimensionsVal == null ) {
          table = document.createElement( "table" );
          tr = document.createElement( "tr" );
          trChild = document.createElement( "div" );

          table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
          tr.style.cssText = "border:1px solid";

          // Support: Chrome 86+
          // Height set through cssText does not get applied.
          // Computed height then comes back as 0.
          tr.style.height = "1px";
          trChild.style.height = "9px";

          // Support: Android 8 Chrome 86+
          // In our bodyBackground.html iframe,
          // display for all div elements is set to "inline",
          // which causes a problem only in Android 8 Chrome 86.
          // Ensuring the div is display: block
          // gets around this issue.
          trChild.style.display = "block";

          documentElement
            .appendChild( table )
            .appendChild( tr )
            .appendChild( trChild );

          trStyle = window.getComputedStyle( tr );
          reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
            parseInt( trStyle.borderTopWidth, 10 ) +
            parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

          documentElement.removeChild( table );
        }
        return reliableTrDimensionsVal;
      }
    } );
  } )();


  function curCSS( elem, name, computed ) {
    var width, minWidth, maxWidth, ret,
      isCustomProp = rcustomProp.test( name ),

      // Support: Firefox 51+
      // Retrieving style before computed somehow
      // fixes an issue with getting wrong values
      // on detached elements
      style = elem.style;

    computed = computed || getStyles( elem );

    // getPropertyValue is needed for:
    //   .css('filter') (IE 9 only, trac-12537)
    //   .css('--customProperty) (gh-3144)
    if ( computed ) {
      ret = computed.getPropertyValue( name ) || computed[ name ];

      // trim whitespace for custom property (issue gh-4926)
      if ( isCustomProp ) {

        // rtrim treats U+000D CARRIAGE RETURN and U+000C FORM FEED
        // as whitespace while CSS does not, but this is not a problem
        // because CSS preprocessing replaces them with U+000A LINE FEED
        // (which *is* CSS whitespace)
        // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
        ret = ret.replace( rtrimCSS, "$1" );
      }

      if ( ret === "" && !isAttached( elem ) ) {
        ret = jQuery.style( elem, name );
      }

      // A tribute to the "awesome hack by Dean Edwards"
      // Android Browser returns percentage for some values,
      // but width seems to be reliably pixels.
      // This is against the CSSOM draft spec:
      // https://drafts.csswg.org/cssom/#resolved-values
      if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

        // Remember the original values
        width = style.width;
        minWidth = style.minWidth;
        maxWidth = style.maxWidth;

        // Put in the new values to get a computed value out
        style.minWidth = style.maxWidth = style.width = ret;
        ret = computed.width;

        // Revert the changed values
        style.width = width;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }
    }

    return ret !== undefined ?

      // Support: IE <=9 - 11 only
      // IE returns zIndex value as an integer.
      ret + "" :
      ret;
  }


  function addGetHookIf( conditionFn, hookFn ) {

    // Define the hook, we'll check on the first run if it's really needed.
    return {
      get: function() {
        if ( conditionFn() ) {

          // Hook not needed (or it's not possible to use it due
          // to missing dependency), remove it.
          delete this.get;
          return;
        }

        // Hook needed; redefine it so that the support test is not executed again.
        return ( this.get = hookFn ).apply( this, arguments );
      }
    };
  }


  var cssPrefixes = [ "Webkit", "Moz", "ms" ],
    emptyStyle = document.createElement( "div" ).style,
    vendorProps = {};

// Return a vendor-prefixed property or undefined
  function vendorPropName( name ) {

    // Check for vendor prefixed names
    var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
      i = cssPrefixes.length;

    while ( i-- ) {
      name = cssPrefixes[ i ] + capName;
      if ( name in emptyStyle ) {
        return name;
      }
    }
  }

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
  function finalPropName( name ) {
    var final = jQuery.cssProps[ name ] || vendorProps[ name ];

    if ( final ) {
      return final;
    }
    if ( name in emptyStyle ) {
      return name;
    }
    return vendorProps[ name ] = vendorPropName( name ) || name;
  }


  var

    // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/,
    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
    cssNormalTransform = {
      letterSpacing: "0",
      fontWeight: "400"
    };

  function setPositiveNumber( _elem, value, subtract ) {

    // Any relative (+/-) values have already been
    // normalized at this point
    var matches = rcssNum.exec( value );
    return matches ?

      // Guard against undefined "subtract", e.g., when used as in cssHooks
      Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
      value;
  }

  function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
    var i = dimension === "width" ? 1 : 0,
      extra = 0,
      delta = 0;

    // Adjustment may not be necessary
    if ( box === ( isBorderBox ? "border" : "content" ) ) {
      return 0;
    }

    for ( ; i < 4; i += 2 ) {

      // Both box models exclude margin
      if ( box === "margin" ) {
        delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
      }

      // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
      if ( !isBorderBox ) {

        // Add padding
        delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

        // For "border" or "margin", add border
        if ( box !== "padding" ) {
          delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

          // But still keep track of it otherwise
        } else {
          extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
        }

        // If we get here with a border-box (content + padding + border), we're seeking "content" or
        // "padding" or "margin"
      } else {

        // For "content", subtract padding
        if ( box === "content" ) {
          delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
        }

        // For "content" or "padding", subtract border
        if ( box !== "margin" ) {
          delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
        }
      }
    }

    // Account for positive content-box scroll gutter when requested by providing computedVal
    if ( !isBorderBox && computedVal >= 0 ) {

      // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
      // Assuming integer scroll gutter, subtract the rest and round down
      delta += Math.max( 0, Math.ceil(
        elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
        computedVal -
        delta -
        extra -
        0.5

        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
      ) ) || 0;
    }

    return delta;
  }

  function getWidthOrHeight( elem, dimension, extra ) {

    // Start with computed style
    var styles = getStyles( elem ),

      // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
      // Fake content-box until we know it's needed to know the true value.
      boxSizingNeeded = !support.boxSizingReliable() || extra,
      isBorderBox = boxSizingNeeded &&
        jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
      valueIsBorderBox = isBorderBox,

      val = curCSS( elem, dimension, styles ),
      offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

    // Support: Firefox <=54
    // Return a confounding non-pixel value or feign ignorance, as appropriate.
    if ( rnumnonpx.test( val ) ) {
      if ( !extra ) {
        return val;
      }
      val = "auto";
    }


    // Support: IE 9 - 11 only
    // Use offsetWidth/offsetHeight for when box sizing is unreliable.
    // In those cases, the computed value can be trusted to be border-box.
    if ( ( !support.boxSizingReliable() && isBorderBox ||

        // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

        // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" ||

        // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

      // Make sure the element is visible & connected
      elem.getClientRects().length ) {

      isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

      // Where available, offsetWidth/offsetHeight approximate border box dimensions.
      // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
      // retrieved value as a content box dimension.
      valueIsBorderBox = offsetProp in elem;
      if ( valueIsBorderBox ) {
        val = elem[ offsetProp ];
      }
    }

    // Normalize "" and auto
    val = parseFloat( val ) || 0;

    // Adjust for the element's box model
    return ( val +
      boxModelAdjustment(
        elem,
        dimension,
        extra || ( isBorderBox ? "border" : "content" ),
        valueIsBorderBox,
        styles,

        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val
      )
    ) + "px";
  }

  jQuery.extend( {

    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {
      opacity: {
        get: function( elem, computed ) {
          if ( computed ) {

            // We should always get a number back from opacity
            var ret = curCSS( elem, "opacity" );
            return ret === "" ? "1" : ret;
          }
        }
      }
    },

    // Don't automatically add "px" to these possibly-unitless properties
    cssNumber: {
      "animationIterationCount": true,
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "gridArea": true,
      "gridColumn": true,
      "gridColumnEnd": true,
      "gridColumnStart": true,
      "gridRow": true,
      "gridRowEnd": true,
      "gridRowStart": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },

    // Add in properties whose names you wish to fix before
    // setting or getting the value
    cssProps: {},

    // Get and set the style property on a DOM Node
    style: function( elem, name, value, extra ) {

      // Don't set styles on text and comment nodes
      if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
        return;
      }

      // Make sure that we're working with the right name
      var ret, type, hooks,
        origName = camelCase( name ),
        isCustomProp = rcustomProp.test( name ),
        style = elem.style;

      // Make sure that we're working with the right name. We don't
      // want to query the value if it is a CSS custom property
      // since they are user-defined.
      if ( !isCustomProp ) {
        name = finalPropName( origName );
      }

      // Gets hook for the prefixed version, then unprefixed version
      hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

      // Check if we're setting a value
      if ( value !== undefined ) {
        type = typeof value;

        // Convert "+=" or "-=" to relative numbers (trac-7345)
        if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
          value = adjustCSS( elem, name, ret );

          // Fixes bug trac-9237
          type = "number";
        }

        // Make sure that null and NaN values aren't set (trac-7116)
        if ( value == null || value !== value ) {
          return;
        }

        // If a number was passed in, add the unit (except for certain CSS properties)
        // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
        // "px" to a few hardcoded values.
        if ( type === "number" && !isCustomProp ) {
          value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
        }

        // background-* props affect original clone's values
        if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
          style[ name ] = "inherit";
        }

        // If a hook was provided, use that value, otherwise just set the specified value
        if ( !hooks || !( "set" in hooks ) ||
          ( value = hooks.set( elem, value, extra ) ) !== undefined ) {

          if ( isCustomProp ) {
            style.setProperty( name, value );
          } else {
            style[ name ] = value;
          }
        }

      } else {

        // If a hook was provided get the non-computed value from there
        if ( hooks && "get" in hooks &&
          ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

          return ret;
        }

        // Otherwise just get the value from the style object
        return style[ name ];
      }
    },

    css: function( elem, name, extra, styles ) {
      var val, num, hooks,
        origName = camelCase( name ),
        isCustomProp = rcustomProp.test( name );

      // Make sure that we're working with the right name. We don't
      // want to modify the value if it is a CSS custom property
      // since they are user-defined.
      if ( !isCustomProp ) {
        name = finalPropName( origName );
      }

      // Try prefixed name followed by the unprefixed name
      hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

      // If a hook was provided get the computed value from there
      if ( hooks && "get" in hooks ) {
        val = hooks.get( elem, true, extra );
      }

      // Otherwise, if a way to get the computed value exists, use that
      if ( val === undefined ) {
        val = curCSS( elem, name, styles );
      }

      // Convert "normal" to computed value
      if ( val === "normal" && name in cssNormalTransform ) {
        val = cssNormalTransform[ name ];
      }

      // Make numeric if forced or a qualifier was provided and val looks numeric
      if ( extra === "" || extra ) {
        num = parseFloat( val );
        return extra === true || isFinite( num ) ? num || 0 : val;
      }

      return val;
    }
  } );

  jQuery.each( [ "height", "width" ], function( _i, dimension ) {
    jQuery.cssHooks[ dimension ] = {
      get: function( elem, computed, extra ) {
        if ( computed ) {

          // Certain elements can have dimension info if we invisibly show them
          // but it must have a current display style that would benefit
          return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

          // Support: Safari 8+
          // Table columns in Safari have non-zero offsetWidth & zero
          // getBoundingClientRect().width unless display is changed.
          // Support: IE <=11 only
          // Running getBoundingClientRect on a disconnected node
          // in IE throws an error.
          ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
            swap( elem, cssShow, function() {
              return getWidthOrHeight( elem, dimension, extra );
            } ) :
            getWidthOrHeight( elem, dimension, extra );
        }
      },

      set: function( elem, value, extra ) {
        var matches,
          styles = getStyles( elem ),

          // Only read styles.position if the test has a chance to fail
          // to avoid forcing a reflow.
          scrollboxSizeBuggy = !support.scrollboxSize() &&
            styles.position === "absolute",

          // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
          boxSizingNeeded = scrollboxSizeBuggy || extra,
          isBorderBox = boxSizingNeeded &&
            jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
          subtract = extra ?
            boxModelAdjustment(
              elem,
              dimension,
              extra,
              isBorderBox,
              styles
            ) :
            0;

        // Account for unreliable border-box dimensions by comparing offset* to computed and
        // faking a content-box to get border and padding (gh-3699)
        if ( isBorderBox && scrollboxSizeBuggy ) {
          subtract -= Math.ceil(
            elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
            parseFloat( styles[ dimension ] ) -
            boxModelAdjustment( elem, dimension, "border", false, styles ) -
            0.5
          );
        }

        // Convert to pixels if value adjustment is needed
        if ( subtract && ( matches = rcssNum.exec( value ) ) &&
          ( matches[ 3 ] || "px" ) !== "px" ) {

          elem.style[ dimension ] = value;
          value = jQuery.css( elem, dimension );
        }

        return setPositiveNumber( elem, value, subtract );
      }
    };
  } );

  jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
    function( elem, computed ) {
      if ( computed ) {
        return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
          elem.getBoundingClientRect().left -
          swap( elem, { marginLeft: 0 }, function() {
            return elem.getBoundingClientRect().left;
          } )
        ) + "px";
      }
    }
  );

// These hooks are used by animate to expand properties
  jQuery.each( {
    margin: "",
    padding: "",
    border: "Width"
  }, function( prefix, suffix ) {
    jQuery.cssHooks[ prefix + suffix ] = {
      expand: function( value ) {
        var i = 0,
          expanded = {},

          // Assumes a single number if not a string
          parts = typeof value === "string" ? value.split( " " ) : [ value ];

        for ( ; i < 4; i++ ) {
          expanded[ prefix + cssExpand[ i ] + suffix ] =
            parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
        }

        return expanded;
      }
    };

    if ( prefix !== "margin" ) {
      jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
    }
  } );

  jQuery.fn.extend( {
    css: function( name, value ) {
      return access( this, function( elem, name, value ) {
        var styles, len,
          map = {},
          i = 0;

        if ( Array.isArray( name ) ) {
          styles = getStyles( elem );
          len = name.length;

          for ( ; i < len; i++ ) {
            map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
          }

          return map;
        }

        return value !== undefined ?
          jQuery.style( elem, name, value ) :
          jQuery.css( elem, name );
      }, name, value, arguments.length > 1 );
    }
  } );


  function Tween( elem, options, prop, end, easing ) {
    return new Tween.prototype.init( elem, options, prop, end, easing );
  }
  jQuery.Tween = Tween;

  Tween.prototype = {
    constructor: Tween,
    init: function( elem, options, prop, end, easing, unit ) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || jQuery.easing._default;
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
    },
    cur: function() {
      var hooks = Tween.propHooks[ this.prop ];

      return hooks && hooks.get ?
        hooks.get( this ) :
        Tween.propHooks._default.get( this );
    },
    run: function( percent ) {
      var eased,
        hooks = Tween.propHooks[ this.prop ];

      if ( this.options.duration ) {
        this.pos = eased = jQuery.easing[ this.easing ](
          percent, this.options.duration * percent, 0, 1, this.options.duration
        );
      } else {
        this.pos = eased = percent;
      }
      this.now = ( this.end - this.start ) * eased + this.start;

      if ( this.options.step ) {
        this.options.step.call( this.elem, this.now, this );
      }

      if ( hooks && hooks.set ) {
        hooks.set( this );
      } else {
        Tween.propHooks._default.set( this );
      }
      return this;
    }
  };

  Tween.prototype.init.prototype = Tween.prototype;

  Tween.propHooks = {
    _default: {
      get: function( tween ) {
        var result;

        // Use a property on the element directly when it is not a DOM element,
        // or when there is no matching style property that exists.
        if ( tween.elem.nodeType !== 1 ||
          tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
          return tween.elem[ tween.prop ];
        }

        // Passing an empty string as a 3rd parameter to .css will automatically
        // attempt a parseFloat and fallback to a string if the parse fails.
        // Simple values such as "10px" are parsed to Float;
        // complex values such as "rotate(1rad)" are returned as-is.
        result = jQuery.css( tween.elem, tween.prop, "" );

        // Empty strings, null, undefined and "auto" are converted to 0.
        return !result || result === "auto" ? 0 : result;
      },
      set: function( tween ) {

        // Use step hook for back compat.
        // Use cssHook if its there.
        // Use .style if available and use plain properties where available.
        if ( jQuery.fx.step[ tween.prop ] ) {
          jQuery.fx.step[ tween.prop ]( tween );
        } else if ( tween.elem.nodeType === 1 && (
          jQuery.cssHooks[ tween.prop ] ||
          tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
          jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
        } else {
          tween.elem[ tween.prop ] = tween.now;
        }
      }
    }
  };

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
    set: function( tween ) {
      if ( tween.elem.nodeType && tween.elem.parentNode ) {
        tween.elem[ tween.prop ] = tween.now;
      }
    }
  };

  jQuery.easing = {
    linear: function( p ) {
      return p;
    },
    swing: function( p ) {
      return 0.5 - Math.cos( p * Math.PI ) / 2;
    },
    _default: "swing"
  };

  jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
  jQuery.fx.step = {};




  var
    fxNow, inProgress,
    rfxtypes = /^(?:toggle|show|hide)$/,
    rrun = /queueHooks$/;

  function schedule() {
    if ( inProgress ) {
      if ( document.hidden === false && window.requestAnimationFrame ) {
        window.requestAnimationFrame( schedule );
      } else {
        window.setTimeout( schedule, jQuery.fx.interval );
      }

      jQuery.fx.tick();
    }
  }

// Animations created synchronously will run synchronously
  function createFxNow() {
    window.setTimeout( function() {
      fxNow = undefined;
    } );
    return ( fxNow = Date.now() );
  }

// Generate parameters to create a standard animation
  function genFx( type, includeWidth ) {
    var which,
      i = 0,
      attrs = { height: type };

    // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for ( ; i < 4; i += 2 - includeWidth ) {
      which = cssExpand[ i ];
      attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
    }

    if ( includeWidth ) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }

  function createTween( value, prop, animation ) {
    var tween,
      collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
      index = 0,
      length = collection.length;
    for ( ; index < length; index++ ) {
      if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

        // We're done with this property
        return tween;
      }
    }
  }

  function defaultPrefilter( elem, props, opts ) {
    var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
      isBox = "width" in props || "height" in props,
      anim = this,
      orig = {},
      style = elem.style,
      hidden = elem.nodeType && isHiddenWithinTree( elem ),
      dataShow = dataPriv.get( elem, "fxshow" );

    // Queue-skipping animations hijack the fx hooks
    if ( !opts.queue ) {
      hooks = jQuery._queueHooks( elem, "fx" );
      if ( hooks.unqueued == null ) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;
        hooks.empty.fire = function() {
          if ( !hooks.unqueued ) {
            oldfire();
          }
        };
      }
      hooks.unqueued++;

      anim.always( function() {

        // Ensure the complete handler is called before this completes
        anim.always( function() {
          hooks.unqueued--;
          if ( !jQuery.queue( elem, "fx" ).length ) {
            hooks.empty.fire();
          }
        } );
      } );
    }

    // Detect show/hide animations
    for ( prop in props ) {
      value = props[ prop ];
      if ( rfxtypes.test( value ) ) {
        delete props[ prop ];
        toggle = toggle || value === "toggle";
        if ( value === ( hidden ? "hide" : "show" ) ) {

          // Pretend to be hidden if this is a "show" and
          // there is still data from a stopped show/hide
          if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
            hidden = true;

            // Ignore all other no-op show/hide data
          } else {
            continue;
          }
        }
        orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
      }
    }

    // Bail out if this is a no-op like .hide().hide()
    propTween = !jQuery.isEmptyObject( props );
    if ( !propTween && jQuery.isEmptyObject( orig ) ) {
      return;
    }

    // Restrict "overflow" and "display" styles during box animations
    if ( isBox && elem.nodeType === 1 ) {

      // Support: IE <=9 - 11, Edge 12 - 15
      // Record all 3 overflow attributes because IE does not infer the shorthand
      // from identically-valued overflowX and overflowY and Edge just mirrors
      // the overflowX value there.
      opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

      // Identify a display type, preferring old show/hide data over the CSS cascade
      restoreDisplay = dataShow && dataShow.display;
      if ( restoreDisplay == null ) {
        restoreDisplay = dataPriv.get( elem, "display" );
      }
      display = jQuery.css( elem, "display" );
      if ( display === "none" ) {
        if ( restoreDisplay ) {
          display = restoreDisplay;
        } else {

          // Get nonempty value(s) by temporarily forcing visibility
          showHide( [ elem ], true );
          restoreDisplay = elem.style.display || restoreDisplay;
          display = jQuery.css( elem, "display" );
          showHide( [ elem ] );
        }
      }

      // Animate inline elements as inline-block
      if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
        if ( jQuery.css( elem, "float" ) === "none" ) {

          // Restore the original display value at the end of pure show/hide animations
          if ( !propTween ) {
            anim.done( function() {
              style.display = restoreDisplay;
            } );
            if ( restoreDisplay == null ) {
              display = style.display;
              restoreDisplay = display === "none" ? "" : display;
            }
          }
          style.display = "inline-block";
        }
      }
    }

    if ( opts.overflow ) {
      style.overflow = "hidden";
      anim.always( function() {
        style.overflow = opts.overflow[ 0 ];
        style.overflowX = opts.overflow[ 1 ];
        style.overflowY = opts.overflow[ 2 ];
      } );
    }

    // Implement show/hide animations
    propTween = false;
    for ( prop in orig ) {

      // General show/hide setup for this element animation
      if ( !propTween ) {
        if ( dataShow ) {
          if ( "hidden" in dataShow ) {
            hidden = dataShow.hidden;
          }
        } else {
          dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
        }

        // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
        if ( toggle ) {
          dataShow.hidden = !hidden;
        }

        // Show elements before animating them
        if ( hidden ) {
          showHide( [ elem ], true );
        }

        /* eslint-disable no-loop-func */

        anim.done( function() {

          /* eslint-enable no-loop-func */

          // The final step of a "hide" animation is actually hiding the element
          if ( !hidden ) {
            showHide( [ elem ] );
          }
          dataPriv.remove( elem, "fxshow" );
          for ( prop in orig ) {
            jQuery.style( elem, prop, orig[ prop ] );
          }
        } );
      }

      // Per-property setup
      propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
      if ( !( prop in dataShow ) ) {
        dataShow[ prop ] = propTween.start;
        if ( hidden ) {
          propTween.end = propTween.start;
          propTween.start = 0;
        }
      }
    }
  }

  function propFilter( props, specialEasing ) {
    var index, name, easing, value, hooks;

    // camelCase, specialEasing and expand cssHook pass
    for ( index in props ) {
      name = camelCase( index );
      easing = specialEasing[ name ];
      value = props[ index ];
      if ( Array.isArray( value ) ) {
        easing = value[ 1 ];
        value = props[ index ] = value[ 0 ];
      }

      if ( index !== name ) {
        props[ name ] = value;
        delete props[ index ];
      }

      hooks = jQuery.cssHooks[ name ];
      if ( hooks && "expand" in hooks ) {
        value = hooks.expand( value );
        delete props[ name ];

        // Not quite $.extend, this won't overwrite existing keys.
        // Reusing 'index' because we have the correct "name"
        for ( index in value ) {
          if ( !( index in props ) ) {
            props[ index ] = value[ index ];
            specialEasing[ index ] = easing;
          }
        }
      } else {
        specialEasing[ name ] = easing;
      }
    }
  }

  function Animation( elem, properties, options ) {
    var result,
      stopped,
      index = 0,
      length = Animation.prefilters.length,
      deferred = jQuery.Deferred().always( function() {

        // Don't match elem in the :animated selector
        delete tick.elem;
      } ),
      tick = function() {
        if ( stopped ) {
          return false;
        }
        var currentTime = fxNow || createFxNow(),
          remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

          // Support: Android 2.3 only
          // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
          temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;

        for ( ; index < length; index++ ) {
          animation.tweens[ index ].run( percent );
        }

        deferred.notifyWith( elem, [ animation, percent, remaining ] );

        // If there's more to do, yield
        if ( percent < 1 && length ) {
          return remaining;
        }

        // If this was an empty animation, synthesize a final progress notification
        if ( !length ) {
          deferred.notifyWith( elem, [ animation, 1, 0 ] );
        }

        // Resolve the animation and report its conclusion
        deferred.resolveWith( elem, [ animation ] );
        return false;
      },
      animation = deferred.promise( {
        elem: elem,
        props: jQuery.extend( {}, properties ),
        opts: jQuery.extend( true, {
          specialEasing: {},
          easing: jQuery.easing._default
        }, options ),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function( prop, end ) {
          var tween = jQuery.Tween( elem, animation.opts, prop, end,
            animation.opts.specialEasing[ prop ] || animation.opts.easing );
          animation.tweens.push( tween );
          return tween;
        },
        stop: function( gotoEnd ) {
          var index = 0,

            // If we are going to the end, we want to run all the tweens
            // otherwise we skip this part
            length = gotoEnd ? animation.tweens.length : 0;
          if ( stopped ) {
            return this;
          }
          stopped = true;
          for ( ; index < length; index++ ) {
            animation.tweens[ index ].run( 1 );
          }

          // Resolve when we played the last frame; otherwise, reject
          if ( gotoEnd ) {
            deferred.notifyWith( elem, [ animation, 1, 0 ] );
            deferred.resolveWith( elem, [ animation, gotoEnd ] );
          } else {
            deferred.rejectWith( elem, [ animation, gotoEnd ] );
          }
          return this;
        }
      } ),
      props = animation.props;

    propFilter( props, animation.opts.specialEasing );

    for ( ; index < length; index++ ) {
      result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
      if ( result ) {
        if ( isFunction( result.stop ) ) {
          jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
            result.stop.bind( result );
        }
        return result;
      }
    }

    jQuery.map( props, createTween, animation );

    if ( isFunction( animation.opts.start ) ) {
      animation.opts.start.call( elem, animation );
    }

    // Attach callbacks from options
    animation
      .progress( animation.opts.progress )
      .done( animation.opts.done, animation.opts.complete )
      .fail( animation.opts.fail )
      .always( animation.opts.always );

    jQuery.fx.timer(
      jQuery.extend( tick, {
        elem: elem,
        anim: animation,
        queue: animation.opts.queue
      } )
    );

    return animation;
  }

  jQuery.Animation = jQuery.extend( Animation, {

    tweeners: {
      "*": [ function( prop, value ) {
        var tween = this.createTween( prop, value );
        adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
        return tween;
      } ]
    },

    tweener: function( props, callback ) {
      if ( isFunction( props ) ) {
        callback = props;
        props = [ "*" ];
      } else {
        props = props.match( rnothtmlwhite );
      }

      var prop,
        index = 0,
        length = props.length;

      for ( ; index < length; index++ ) {
        prop = props[ index ];
        Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
        Animation.tweeners[ prop ].unshift( callback );
      }
    },

    prefilters: [ defaultPrefilter ],

    prefilter: function( callback, prepend ) {
      if ( prepend ) {
        Animation.prefilters.unshift( callback );
      } else {
        Animation.prefilters.push( callback );
      }
    }
  } );

  jQuery.speed = function( speed, easing, fn ) {
    var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
      complete: fn || !fn && easing ||
        isFunction( speed ) && speed,
      duration: speed,
      easing: fn && easing || easing && !isFunction( easing ) && easing
    };

    // Go to the end state if fx are off
    if ( jQuery.fx.off ) {
      opt.duration = 0;

    } else {
      if ( typeof opt.duration !== "number" ) {
        if ( opt.duration in jQuery.fx.speeds ) {
          opt.duration = jQuery.fx.speeds[ opt.duration ];

        } else {
          opt.duration = jQuery.fx.speeds._default;
        }
      }
    }

    // Normalize opt.queue - true/undefined/null -> "fx"
    if ( opt.queue == null || opt.queue === true ) {
      opt.queue = "fx";
    }

    // Queueing
    opt.old = opt.complete;

    opt.complete = function() {
      if ( isFunction( opt.old ) ) {
        opt.old.call( this );
      }

      if ( opt.queue ) {
        jQuery.dequeue( this, opt.queue );
      }
    };

    return opt;
  };

  jQuery.fn.extend( {
    fadeTo: function( speed, to, easing, callback ) {

      // Show any hidden elements after setting opacity to 0
      return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

        // Animate to the value specified
        .end().animate( { opacity: to }, speed, easing, callback );
    },
    animate: function( prop, speed, easing, callback ) {
      var empty = jQuery.isEmptyObject( prop ),
        optall = jQuery.speed( speed, easing, callback ),
        doAnimation = function() {

          // Operate on a copy of prop so per-property easing won't be lost
          var anim = Animation( this, jQuery.extend( {}, prop ), optall );

          // Empty animations, or finishing resolves immediately
          if ( empty || dataPriv.get( this, "finish" ) ) {
            anim.stop( true );
          }
        };

      doAnimation.finish = doAnimation;

      return empty || optall.queue === false ?
        this.each( doAnimation ) :
        this.queue( optall.queue, doAnimation );
    },
    stop: function( type, clearQueue, gotoEnd ) {
      var stopQueue = function( hooks ) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop( gotoEnd );
      };

      if ( typeof type !== "string" ) {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }
      if ( clearQueue ) {
        this.queue( type || "fx", [] );
      }

      return this.each( function() {
        var dequeue = true,
          index = type != null && type + "queueHooks",
          timers = jQuery.timers,
          data = dataPriv.get( this );

        if ( index ) {
          if ( data[ index ] && data[ index ].stop ) {
            stopQueue( data[ index ] );
          }
        } else {
          for ( index in data ) {
            if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
              stopQueue( data[ index ] );
            }
          }
        }

        for ( index = timers.length; index--; ) {
          if ( timers[ index ].elem === this &&
            ( type == null || timers[ index ].queue === type ) ) {

            timers[ index ].anim.stop( gotoEnd );
            dequeue = false;
            timers.splice( index, 1 );
          }
        }

        // Start the next in the queue if the last step wasn't forced.
        // Timers currently will call their complete callbacks, which
        // will dequeue but only if they were gotoEnd.
        if ( dequeue || !gotoEnd ) {
          jQuery.dequeue( this, type );
        }
      } );
    },
    finish: function( type ) {
      if ( type !== false ) {
        type = type || "fx";
      }
      return this.each( function() {
        var index,
          data = dataPriv.get( this ),
          queue = data[ type + "queue" ],
          hooks = data[ type + "queueHooks" ],
          timers = jQuery.timers,
          length = queue ? queue.length : 0;

        // Enable finishing flag on private data
        data.finish = true;

        // Empty the queue first
        jQuery.queue( this, type, [] );

        if ( hooks && hooks.stop ) {
          hooks.stop.call( this, true );
        }

        // Look for any active animations, and finish them
        for ( index = timers.length; index--; ) {
          if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
            timers[ index ].anim.stop( true );
            timers.splice( index, 1 );
          }
        }

        // Look for any animations in the old queue and finish them
        for ( index = 0; index < length; index++ ) {
          if ( queue[ index ] && queue[ index ].finish ) {
            queue[ index ].finish.call( this );
          }
        }

        // Turn off finishing flag
        delete data.finish;
      } );
    }
  } );

  jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
    var cssFn = jQuery.fn[ name ];
    jQuery.fn[ name ] = function( speed, easing, callback ) {
      return speed == null || typeof speed === "boolean" ?
        cssFn.apply( this, arguments ) :
        this.animate( genFx( name, true ), speed, easing, callback );
    };
  } );

// Generate shortcuts for custom animations
  jQuery.each( {
    slideDown: genFx( "show" ),
    slideUp: genFx( "hide" ),
    slideToggle: genFx( "toggle" ),
    fadeIn: { opacity: "show" },
    fadeOut: { opacity: "hide" },
    fadeToggle: { opacity: "toggle" }
  }, function( name, props ) {
    jQuery.fn[ name ] = function( speed, easing, callback ) {
      return this.animate( props, speed, easing, callback );
    };
  } );

  jQuery.timers = [];
  jQuery.fx.tick = function() {
    var timer,
      i = 0,
      timers = jQuery.timers;

    fxNow = Date.now();

    for ( ; i < timers.length; i++ ) {
      timer = timers[ i ];

      // Run the timer and safely remove it when done (allowing for external removal)
      if ( !timer() && timers[ i ] === timer ) {
        timers.splice( i--, 1 );
      }
    }

    if ( !timers.length ) {
      jQuery.fx.stop();
    }
    fxNow = undefined;
  };

  jQuery.fx.timer = function( timer ) {
    jQuery.timers.push( timer );
    jQuery.fx.start();
  };

  jQuery.fx.interval = 13;
  jQuery.fx.start = function() {
    if ( inProgress ) {
      return;
    }

    inProgress = true;
    schedule();
  };

  jQuery.fx.stop = function() {
    inProgress = null;
  };

  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,

    // Default speed
    _default: 400
  };


// Based off of the plugin by Clint Helfers, with permission.
  jQuery.fn.delay = function( time, type ) {
    time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
    type = type || "fx";

    return this.queue( type, function( next, hooks ) {
      var timeout = window.setTimeout( next, time );
      hooks.stop = function() {
        window.clearTimeout( timeout );
      };
    } );
  };


  ( function() {
    var input = document.createElement( "input" ),
      select = document.createElement( "select" ),
      opt = select.appendChild( document.createElement( "option" ) );

    input.type = "checkbox";

    // Support: Android <=4.3 only
    // Default value for a checkbox should be "on"
    support.checkOn = input.value !== "";

    // Support: IE <=11 only
    // Must access selectedIndex to make default options select
    support.optSelected = opt.selected;

    // Support: IE <=11 only
    // An input loses its value after becoming a radio
    input = document.createElement( "input" );
    input.value = "t";
    input.type = "radio";
    support.radioValue = input.value === "t";
  } )();


  var boolHook,
    attrHandle = jQuery.expr.attrHandle;

  jQuery.fn.extend( {
    attr: function( name, value ) {
      return access( this, jQuery.attr, name, value, arguments.length > 1 );
    },

    removeAttr: function( name ) {
      return this.each( function() {
        jQuery.removeAttr( this, name );
      } );
    }
  } );

  jQuery.extend( {
    attr: function( elem, name, value ) {
      var ret, hooks,
        nType = elem.nodeType;

      // Don't get/set attributes on text, comment and attribute nodes
      if ( nType === 3 || nType === 8 || nType === 2 ) {
        return;
      }

      // Fallback to prop when attributes are not supported
      if ( typeof elem.getAttribute === "undefined" ) {
        return jQuery.prop( elem, name, value );
      }

      // Attribute hooks are determined by the lowercase version
      // Grab necessary hook if one is defined
      if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
        hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
          ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
      }

      if ( value !== undefined ) {
        if ( value === null ) {
          jQuery.removeAttr( elem, name );
          return;
        }

        if ( hooks && "set" in hooks &&
          ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
          return ret;
        }

        elem.setAttribute( name, value + "" );
        return value;
      }

      if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
        return ret;
      }

      ret = jQuery.find.attr( elem, name );

      // Non-existent attributes return null, we normalize to undefined
      return ret == null ? undefined : ret;
    },

    attrHooks: {
      type: {
        set: function( elem, value ) {
          if ( !support.radioValue && value === "radio" &&
            nodeName( elem, "input" ) ) {
            var val = elem.value;
            elem.setAttribute( "type", value );
            if ( val ) {
              elem.value = val;
            }
            return value;
          }
        }
      }
    },

    removeAttr: function( elem, value ) {
      var name,
        i = 0,

        // Attribute names can contain non-HTML whitespace characters
        // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
        attrNames = value && value.match( rnothtmlwhite );

      if ( attrNames && elem.nodeType === 1 ) {
        while ( ( name = attrNames[ i++ ] ) ) {
          elem.removeAttribute( name );
        }
      }
    }
  } );

// Hooks for boolean attributes
  boolHook = {
    set: function( elem, value, name ) {
      if ( value === false ) {

        // Remove boolean attributes when set to false
        jQuery.removeAttr( elem, name );
      } else {
        elem.setAttribute( name, name );
      }
      return name;
    }
  };

  jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
    var getter = attrHandle[ name ] || jQuery.find.attr;

    attrHandle[ name ] = function( elem, name, isXML ) {
      var ret, handle,
        lowercaseName = name.toLowerCase();

      if ( !isXML ) {

        // Avoid an infinite loop by temporarily removing this function from the getter
        handle = attrHandle[ lowercaseName ];
        attrHandle[ lowercaseName ] = ret;
        ret = getter( elem, name, isXML ) != null ?
          lowercaseName :
          null;
        attrHandle[ lowercaseName ] = handle;
      }
      return ret;
    };
  } );




  var rfocusable = /^(?:input|select|textarea|button)$/i,
    rclickable = /^(?:a|area)$/i;

  jQuery.fn.extend( {
    prop: function( name, value ) {
      return access( this, jQuery.prop, name, value, arguments.length > 1 );
    },

    removeProp: function( name ) {
      return this.each( function() {
        delete this[ jQuery.propFix[ name ] || name ];
      } );
    }
  } );

  jQuery.extend( {
    prop: function( elem, name, value ) {
      var ret, hooks,
        nType = elem.nodeType;

      // Don't get/set properties on text, comment and attribute nodes
      if ( nType === 3 || nType === 8 || nType === 2 ) {
        return;
      }

      if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

        // Fix name and attach hooks
        name = jQuery.propFix[ name ] || name;
        hooks = jQuery.propHooks[ name ];
      }

      if ( value !== undefined ) {
        if ( hooks && "set" in hooks &&
          ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
          return ret;
        }

        return ( elem[ name ] = value );
      }

      if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
        return ret;
      }

      return elem[ name ];
    },

    propHooks: {
      tabIndex: {
        get: function( elem ) {

          // Support: IE <=9 - 11 only
          // elem.tabIndex doesn't always return the
          // correct value when it hasn't been explicitly set
          // Use proper attribute retrieval (trac-12072)
          var tabindex = jQuery.find.attr( elem, "tabindex" );

          if ( tabindex ) {
            return parseInt( tabindex, 10 );
          }

          if (
            rfocusable.test( elem.nodeName ) ||
            rclickable.test( elem.nodeName ) &&
            elem.href
          ) {
            return 0;
          }

          return -1;
        }
      }
    },

    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  } );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
  if ( !support.optSelected ) {
    jQuery.propHooks.selected = {
      get: function( elem ) {

        /* eslint no-unused-expressions: "off" */

        var parent = elem.parentNode;
        if ( parent && parent.parentNode ) {
          parent.parentNode.selectedIndex;
        }
        return null;
      },
      set: function( elem ) {

        /* eslint no-unused-expressions: "off" */

        var parent = elem.parentNode;
        if ( parent ) {
          parent.selectedIndex;

          if ( parent.parentNode ) {
            parent.parentNode.selectedIndex;
          }
        }
      }
    };
  }

  jQuery.each( [
    "tabIndex",
    "readOnly",
    "maxLength",
    "cellSpacing",
    "cellPadding",
    "rowSpan",
    "colSpan",
    "useMap",
    "frameBorder",
    "contentEditable"
  ], function() {
    jQuery.propFix[ this.toLowerCase() ] = this;
  } );




  // Strip and collapse whitespace according to HTML spec
  // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
  function stripAndCollapse( value ) {
    var tokens = value.match( rnothtmlwhite ) || [];
    return tokens.join( " " );
  }


  function getClass( elem ) {
    return elem.getAttribute && elem.getAttribute( "class" ) || "";
  }

  function classesToArray( value ) {
    if ( Array.isArray( value ) ) {
      return value;
    }
    if ( typeof value === "string" ) {
      return value.match( rnothtmlwhite ) || [];
    }
    return [];
  }

  jQuery.fn.extend( {
    addClass: function( value ) {
      var classNames, cur, curValue, className, i, finalValue;

      if ( isFunction( value ) ) {
        return this.each( function( j ) {
          jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
        } );
      }

      classNames = classesToArray( value );

      if ( classNames.length ) {
        return this.each( function() {
          curValue = getClass( this );
          cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

          if ( cur ) {
            for ( i = 0; i < classNames.length; i++ ) {
              className = classNames[ i ];
              if ( cur.indexOf( " " + className + " " ) < 0 ) {
                cur += className + " ";
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = stripAndCollapse( cur );
            if ( curValue !== finalValue ) {
              this.setAttribute( "class", finalValue );
            }
          }
        } );
      }

      return this;
    },

    removeClass: function( value ) {
      var classNames, cur, curValue, className, i, finalValue;

      if ( isFunction( value ) ) {
        return this.each( function( j ) {
          jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
        } );
      }

      if ( !arguments.length ) {
        return this.attr( "class", "" );
      }

      classNames = classesToArray( value );

      if ( classNames.length ) {
        return this.each( function() {
          curValue = getClass( this );

          // This expression is here for better compressibility (see addClass)
          cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

          if ( cur ) {
            for ( i = 0; i < classNames.length; i++ ) {
              className = classNames[ i ];

              // Remove *all* instances
              while ( cur.indexOf( " " + className + " " ) > -1 ) {
                cur = cur.replace( " " + className + " ", " " );
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = stripAndCollapse( cur );
            if ( curValue !== finalValue ) {
              this.setAttribute( "class", finalValue );
            }
          }
        } );
      }

      return this;
    },

    toggleClass: function( value, stateVal ) {
      var classNames, className, i, self,
        type = typeof value,
        isValidValue = type === "string" || Array.isArray( value );

      if ( isFunction( value ) ) {
        return this.each( function( i ) {
          jQuery( this ).toggleClass(
            value.call( this, i, getClass( this ), stateVal ),
            stateVal
          );
        } );
      }

      if ( typeof stateVal === "boolean" && isValidValue ) {
        return stateVal ? this.addClass( value ) : this.removeClass( value );
      }

      classNames = classesToArray( value );

      return this.each( function() {
        if ( isValidValue ) {

          // Toggle individual class names
          self = jQuery( this );

          for ( i = 0; i < classNames.length; i++ ) {
            className = classNames[ i ];

            // Check each className given, space separated list
            if ( self.hasClass( className ) ) {
              self.removeClass( className );
            } else {
              self.addClass( className );
            }
          }

          // Toggle whole class name
        } else if ( value === undefined || type === "boolean" ) {
          className = getClass( this );
          if ( className ) {

            // Store className if set
            dataPriv.set( this, "__className__", className );
          }

          // If the element has a class name or if we're passed `false`,
          // then remove the whole classname (if there was one, the above saved it).
          // Otherwise bring back whatever was previously saved (if anything),
          // falling back to the empty string if nothing was stored.
          if ( this.setAttribute ) {
            this.setAttribute( "class",
              className || value === false ?
                "" :
                dataPriv.get( this, "__className__" ) || ""
            );
          }
        }
      } );
    },

    hasClass: function( selector ) {
      var className, elem,
        i = 0;

      className = " " + selector + " ";
      while ( ( elem = this[ i++ ] ) ) {
        if ( elem.nodeType === 1 &&
          ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
          return true;
        }
      }

      return false;
    }
  } );




  var rreturn = /\r/g;

  jQuery.fn.extend( {
    val: function( value ) {
      var hooks, ret, valueIsFunction,
        elem = this[ 0 ];

      if ( !arguments.length ) {
        if ( elem ) {
          hooks = jQuery.valHooks[ elem.type ] ||
            jQuery.valHooks[ elem.nodeName.toLowerCase() ];

          if ( hooks &&
            "get" in hooks &&
            ( ret = hooks.get( elem, "value" ) ) !== undefined
          ) {
            return ret;
          }

          ret = elem.value;

          // Handle most common string cases
          if ( typeof ret === "string" ) {
            return ret.replace( rreturn, "" );
          }

          // Handle cases where value is null/undef or number
          return ret == null ? "" : ret;
        }

        return;
      }

      valueIsFunction = isFunction( value );

      return this.each( function( i ) {
        var val;

        if ( this.nodeType !== 1 ) {
          return;
        }

        if ( valueIsFunction ) {
          val = value.call( this, i, jQuery( this ).val() );
        } else {
          val = value;
        }

        // Treat null/undefined as ""; convert numbers to string
        if ( val == null ) {
          val = "";

        } else if ( typeof val === "number" ) {
          val += "";

        } else if ( Array.isArray( val ) ) {
          val = jQuery.map( val, function( value ) {
            return value == null ? "" : value + "";
          } );
        }

        hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

        // If set returns undefined, fall back to normal setting
        if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
          this.value = val;
        }
      } );
    }
  } );

  jQuery.extend( {
    valHooks: {
      option: {
        get: function( elem ) {

          var val = jQuery.find.attr( elem, "value" );
          return val != null ?
            val :

            // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse( jQuery.text( elem ) );
        }
      },
      select: {
        get: function( elem ) {
          var value, option, i,
            options = elem.options,
            index = elem.selectedIndex,
            one = elem.type === "select-one",
            values = one ? null : [],
            max = one ? index + 1 : options.length;

          if ( index < 0 ) {
            i = max;

          } else {
            i = one ? index : 0;
          }

          // Loop through all the selected options
          for ( ; i < max; i++ ) {
            option = options[ i ];

            // Support: IE <=9 only
            // IE8-9 doesn't update selected after form reset (trac-2551)
            if ( ( option.selected || i === index ) &&

              // Don't return options that are disabled or in a disabled optgroup
              !option.disabled &&
              ( !option.parentNode.disabled ||
                !nodeName( option.parentNode, "optgroup" ) ) ) {

              // Get the specific value for the option
              value = jQuery( option ).val();

              // We don't need an array for one selects
              if ( one ) {
                return value;
              }

              // Multi-Selects return an array
              values.push( value );
            }
          }

          return values;
        },

        set: function( elem, value ) {
          var optionSet, option,
            options = elem.options,
            values = jQuery.makeArray( value ),
            i = options.length;

          while ( i-- ) {
            option = options[ i ];

            /* eslint-disable no-cond-assign */

            if ( option.selected =
              jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
            ) {
              optionSet = true;
            }

            /* eslint-enable no-cond-assign */
          }

          // Force browsers to behave consistently when non-matching value is set
          if ( !optionSet ) {
            elem.selectedIndex = -1;
          }
          return values;
        }
      }
    }
  } );

// Radios and checkboxes getter/setter
  jQuery.each( [ "radio", "checkbox" ], function() {
    jQuery.valHooks[ this ] = {
      set: function( elem, value ) {
        if ( Array.isArray( value ) ) {
          return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
        }
      }
    };
    if ( !support.checkOn ) {
      jQuery.valHooks[ this ].get = function( elem ) {
        return elem.getAttribute( "value" ) === null ? "on" : elem.value;
      };
    }
  } );




// Return jQuery for attributes-only inclusion


  support.focusin = "onfocusin" in window;


  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
    stopPropagationCallback = function( e ) {
      e.stopPropagation();
    };

  jQuery.extend( jQuery.event, {

    trigger: function( event, data, elem, onlyHandlers ) {

      var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
        eventPath = [ elem || document ],
        type = hasOwn.call( event, "type" ) ? event.type : event,
        namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

      cur = lastElement = tmp = elem = elem || document;

      // Don't do events on text and comment nodes
      if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
        return;
      }

      // focus/blur morphs to focusin/out; ensure we're not firing them right now
      if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
        return;
      }

      if ( type.indexOf( "." ) > -1 ) {

        // Namespaced trigger; create a regexp to match event type in handle()
        namespaces = type.split( "." );
        type = namespaces.shift();
        namespaces.sort();
      }
      ontype = type.indexOf( ":" ) < 0 && "on" + type;

      // Caller can pass in a jQuery.Event object, Object, or just an event type string
      event = event[ jQuery.expando ] ?
        event :
        new jQuery.Event( type, typeof event === "object" && event );

      // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join( "." );
      event.rnamespace = event.namespace ?
        new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
        null;

      // Clean up the event in case it is being reused
      event.result = undefined;
      if ( !event.target ) {
        event.target = elem;
      }

      // Clone any incoming data and prepend the event, creating the handler arg list
      data = data == null ?
        [ event ] :
        jQuery.makeArray( data, [ event ] );

      // Allow special events to draw outside the lines
      special = jQuery.event.special[ type ] || {};
      if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
        return;
      }

      // Determine event propagation path in advance, per W3C events spec (trac-9951)
      // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
      if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

        bubbleType = special.delegateType || type;
        if ( !rfocusMorph.test( bubbleType + type ) ) {
          cur = cur.parentNode;
        }
        for ( ; cur; cur = cur.parentNode ) {
          eventPath.push( cur );
          tmp = cur;
        }

        // Only add window if we got to document (e.g., not plain obj or detached DOM)
        if ( tmp === ( elem.ownerDocument || document ) ) {
          eventPath.push( tmp.defaultView || tmp.parentWindow || window );
        }
      }

      // Fire handlers on the event path
      i = 0;
      while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
        lastElement = cur;
        event.type = i > 1 ?
          bubbleType :
          special.bindType || type;

        // jQuery handler
        handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
          dataPriv.get( cur, "handle" );
        if ( handle ) {
          handle.apply( cur, data );
        }

        // Native handler
        handle = ontype && cur[ ontype ];
        if ( handle && handle.apply && acceptData( cur ) ) {
          event.result = handle.apply( cur, data );
          if ( event.result === false ) {
            event.preventDefault();
          }
        }
      }
      event.type = type;

      // If nobody prevented the default action, do it now
      if ( !onlyHandlers && !event.isDefaultPrevented() ) {

        if ( ( !special._default ||
            special._default.apply( eventPath.pop(), data ) === false ) &&
          acceptData( elem ) ) {

          // Call a native DOM method on the target with the same name as the event.
          // Don't do default actions on window, that's where global variables be (trac-6170)
          if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

            // Don't re-trigger an onFOO event when we call its FOO() method
            tmp = elem[ ontype ];

            if ( tmp ) {
              elem[ ontype ] = null;
            }

            // Prevent re-triggering of the same event, since we already bubbled it above
            jQuery.event.triggered = type;

            if ( event.isPropagationStopped() ) {
              lastElement.addEventListener( type, stopPropagationCallback );
            }

            elem[ type ]();

            if ( event.isPropagationStopped() ) {
              lastElement.removeEventListener( type, stopPropagationCallback );
            }

            jQuery.event.triggered = undefined;

            if ( tmp ) {
              elem[ ontype ] = tmp;
            }
          }
        }
      }

      return event.result;
    },

    // Piggyback on a donor event to simulate a different one
    // Used only for `focus(in | out)` events
    simulate: function( type, elem, event ) {
      var e = jQuery.extend(
        new jQuery.Event(),
        event,
        {
          type: type,
          isSimulated: true
        }
      );

      jQuery.event.trigger( e, null, elem );
    }

  } );

  jQuery.fn.extend( {

    trigger: function( type, data ) {
      return this.each( function() {
        jQuery.event.trigger( type, data, this );
      } );
    },
    triggerHandler: function( type, data ) {
      var elem = this[ 0 ];
      if ( elem ) {
        return jQuery.event.trigger( type, data, elem, true );
      }
    }
  } );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
  if ( !support.focusin ) {
    jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

      // Attach a single capturing handler on the document while someone wants focusin/focusout
      var handler = function( event ) {
        jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
      };

      jQuery.event.special[ fix ] = {
        setup: function() {

          // Handle: regular nodes (via `this.ownerDocument`), window
          // (via `this.document`) & document (via `this`).
          var doc = this.ownerDocument || this.document || this,
            attaches = dataPriv.access( doc, fix );

          if ( !attaches ) {
            doc.addEventListener( orig, handler, true );
          }
          dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
        },
        teardown: function() {
          var doc = this.ownerDocument || this.document || this,
            attaches = dataPriv.access( doc, fix ) - 1;

          if ( !attaches ) {
            doc.removeEventListener( orig, handler, true );
            dataPriv.remove( doc, fix );

          } else {
            dataPriv.access( doc, fix, attaches );
          }
        }
      };
    } );
  }
  var location = window.location;

  var nonce = { guid: Date.now() };

  var rquery = ( /\?/ );



// Cross-browser xml parsing
  jQuery.parseXML = function( data ) {
    var xml, parserErrorElem;
    if ( !data || typeof data !== "string" ) {
      return null;
    }

    // Support: IE 9 - 11 only
    // IE throws on parseFromString with invalid input.
    try {
      xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
    } catch ( e ) {}

    parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
    if ( !xml || parserErrorElem ) {
      jQuery.error( "Invalid XML: " + (
        parserErrorElem ?
          jQuery.map( parserErrorElem.childNodes, function( el ) {
            return el.textContent;
          } ).join( "\n" ) :
          data
      ) );
    }
    return xml;
  };


  var
    rbracket = /\[\]$/,
    rCRLF = /\r?\n/g,
    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
    rsubmittable = /^(?:input|select|textarea|keygen)/i;

  function buildParams( prefix, obj, traditional, add ) {
    var name;

    if ( Array.isArray( obj ) ) {

      // Serialize array item.
      jQuery.each( obj, function( i, v ) {
        if ( traditional || rbracket.test( prefix ) ) {

          // Treat each array item as a scalar.
          add( prefix, v );

        } else {

          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(
            prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
            v,
            traditional,
            add
          );
        }
      } );

    } else if ( !traditional && toType( obj ) === "object" ) {

      // Serialize object item.
      for ( name in obj ) {
        buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
      }

    } else {

      // Serialize scalar item.
      add( prefix, obj );
    }
  }

// Serialize an array of form elements or a set of
// key/values into a query string
  jQuery.param = function( a, traditional ) {
    var prefix,
      s = [],
      add = function( key, valueOrFunction ) {

        // If value is a function, invoke it and use its return value
        var value = isFunction( valueOrFunction ) ?
          valueOrFunction() :
          valueOrFunction;

        s[ s.length ] = encodeURIComponent( key ) + "=" +
          encodeURIComponent( value == null ? "" : value );
      };

    if ( a == null ) {
      return "";
    }

    // If an array was passed in, assume that it is an array of form elements.
    if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

      // Serialize the form elements
      jQuery.each( a, function() {
        add( this.name, this.value );
      } );

    } else {

      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for ( prefix in a ) {
        buildParams( prefix, a[ prefix ], traditional, add );
      }
    }

    // Return the resulting serialization
    return s.join( "&" );
  };

  jQuery.fn.extend( {
    serialize: function() {
      return jQuery.param( this.serializeArray() );
    },
    serializeArray: function() {
      return this.map( function() {

        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop( this, "elements" );
        return elements ? jQuery.makeArray( elements ) : this;
      } ).filter( function() {
        var type = this.type;

        // Use .is( ":disabled" ) so that fieldset[disabled] works
        return this.name && !jQuery( this ).is( ":disabled" ) &&
          rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
          ( this.checked || !rcheckableType.test( type ) );
      } ).map( function( _i, elem ) {
        var val = jQuery( this ).val();

        if ( val == null ) {
          return null;
        }

        if ( Array.isArray( val ) ) {
          return jQuery.map( val, function( val ) {
            return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
          } );
        }

        return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
      } ).get();
    }
  } );


  var
    r20 = /%20/g,
    rhash = /#.*$/,
    rantiCache = /([?&])_=[^&]*/,
    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

    // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    rnoContent = /^(?:GET|HEAD)$/,
    rprotocol = /^\/\//,

    /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
    prefilters = {},

    /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
    transports = {},

    // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat( "*" ),

    // Anchor tag for parsing the document origin
    originAnchor = document.createElement( "a" );

  originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
  function addToPrefiltersOrTransports( structure ) {

    // dataTypeExpression is optional and defaults to "*"
    return function( dataTypeExpression, func ) {

      if ( typeof dataTypeExpression !== "string" ) {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }

      var dataType,
        i = 0,
        dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

      if ( isFunction( func ) ) {

        // For each dataType in the dataTypeExpression
        while ( ( dataType = dataTypes[ i++ ] ) ) {

          // Prepend if requested
          if ( dataType[ 0 ] === "+" ) {
            dataType = dataType.slice( 1 ) || "*";
            ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

            // Otherwise append
          } else {
            ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
          }
        }
      }
    };
  }

// Base inspection function for prefilters and transports
  function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

    var inspected = {},
      seekingTransport = ( structure === transports );

    function inspect( dataType ) {
      var selected;
      inspected[ dataType ] = true;
      jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
        var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
        if ( typeof dataTypeOrTransport === "string" &&
          !seekingTransport && !inspected[ dataTypeOrTransport ] ) {

          options.dataTypes.unshift( dataTypeOrTransport );
          inspect( dataTypeOrTransport );
          return false;
        } else if ( seekingTransport ) {
          return !( selected = dataTypeOrTransport );
        }
      } );
      return selected;
    }

    return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
  }

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
  function ajaxExtend( target, src ) {
    var key, deep,
      flatOptions = jQuery.ajaxSettings.flatOptions || {};

    for ( key in src ) {
      if ( src[ key ] !== undefined ) {
        ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
      }
    }
    if ( deep ) {
      jQuery.extend( true, target, deep );
    }

    return target;
  }

  /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
  function ajaxHandleResponses( s, jqXHR, responses ) {

    var ct, type, finalDataType, firstDataType,
      contents = s.contents,
      dataTypes = s.dataTypes;

    // Remove auto dataType and get content-type in the process
    while ( dataTypes[ 0 ] === "*" ) {
      dataTypes.shift();
      if ( ct === undefined ) {
        ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
      }
    }

    // Check if we're dealing with a known content-type
    if ( ct ) {
      for ( type in contents ) {
        if ( contents[ type ] && contents[ type ].test( ct ) ) {
          dataTypes.unshift( type );
          break;
        }
      }
    }

    // Check to see if we have a response for the expected dataType
    if ( dataTypes[ 0 ] in responses ) {
      finalDataType = dataTypes[ 0 ];
    } else {

      // Try convertible dataTypes
      for ( type in responses ) {
        if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
          finalDataType = type;
          break;
        }
        if ( !firstDataType ) {
          firstDataType = type;
        }
      }

      // Or just use first one
      finalDataType = finalDataType || firstDataType;
    }

    // If we found a dataType
    // We add the dataType to the list if needed
    // and return the corresponding response
    if ( finalDataType ) {
      if ( finalDataType !== dataTypes[ 0 ] ) {
        dataTypes.unshift( finalDataType );
      }
      return responses[ finalDataType ];
    }
  }

  /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
  function ajaxConvert( s, response, jqXHR, isSuccess ) {
    var conv2, current, conv, tmp, prev,
      converters = {},

      // Work with a copy of dataTypes in case we need to modify it for conversion
      dataTypes = s.dataTypes.slice();

    // Create converters map with lowercased keys
    if ( dataTypes[ 1 ] ) {
      for ( conv in s.converters ) {
        converters[ conv.toLowerCase() ] = s.converters[ conv ];
      }
    }

    current = dataTypes.shift();

    // Convert to each sequential dataType
    while ( current ) {

      if ( s.responseFields[ current ] ) {
        jqXHR[ s.responseFields[ current ] ] = response;
      }

      // Apply the dataFilter if provided
      if ( !prev && isSuccess && s.dataFilter ) {
        response = s.dataFilter( response, s.dataType );
      }

      prev = current;
      current = dataTypes.shift();

      if ( current ) {

        // There's only work to do if current dataType is non-auto
        if ( current === "*" ) {

          current = prev;

          // Convert response if prev dataType is non-auto and differs from current
        } else if ( prev !== "*" && prev !== current ) {

          // Seek a direct converter
          conv = converters[ prev + " " + current ] || converters[ "* " + current ];

          // If none found, seek a pair
          if ( !conv ) {
            for ( conv2 in converters ) {

              // If conv2 outputs current
              tmp = conv2.split( " " );
              if ( tmp[ 1 ] === current ) {

                // If prev can be converted to accepted input
                conv = converters[ prev + " " + tmp[ 0 ] ] ||
                  converters[ "* " + tmp[ 0 ] ];
                if ( conv ) {

                  // Condense equivalence converters
                  if ( conv === true ) {
                    conv = converters[ conv2 ];

                    // Otherwise, insert the intermediate dataType
                  } else if ( converters[ conv2 ] !== true ) {
                    current = tmp[ 0 ];
                    dataTypes.unshift( tmp[ 1 ] );
                  }
                  break;
                }
              }
            }
          }

          // Apply converter (if not an equivalence)
          if ( conv !== true ) {

            // Unless errors are allowed to bubble, catch and return them
            if ( conv && s.throws ) {
              response = conv( response );
            } else {
              try {
                response = conv( response );
              } catch ( e ) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }

    return { state: "success", data: response };
  }

  jQuery.extend( {

    // Counter for holding the number of active queries
    active: 0,

    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},

    ajaxSettings: {
      url: location.href,
      type: "GET",
      isLocal: rlocalProtocol.test( location.protocol ),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",

      /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },

      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },

      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },

      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {

        // Convert anything to text
        "* text": String,

        // Text to html (true = no transformation)
        "text html": true,

        // Evaluate text as a json expression
        "text json": JSON.parse,

        // Parse text as xml
        "text xml": jQuery.parseXML
      },

      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: true,
        context: true
      }
    },

    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function( target, settings ) {
      return settings ?

        // Building a settings object
        ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

        // Extending ajaxSettings
        ajaxExtend( jQuery.ajaxSettings, target );
    },

    ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
    ajaxTransport: addToPrefiltersOrTransports( transports ),

    // Main method
    ajax: function( url, options ) {

      // If url is an object, simulate pre-1.5 signature
      if ( typeof url === "object" ) {
        options = url;
        url = undefined;
      }

      // Force options to be an object
      options = options || {};

      var transport,

        // URL without anti-cache param
        cacheURL,

        // Response headers
        responseHeadersString,
        responseHeaders,

        // timeout handle
        timeoutTimer,

        // Url cleanup var
        urlAnchor,

        // Request state (becomes false upon send and true upon completion)
        completed,

        // To know if global events are to be dispatched
        fireGlobals,

        // Loop variable
        i,

        // uncached part of the url
        uncached,

        // Create the final options object
        s = jQuery.ajaxSetup( {}, options ),

        // Callbacks context
        callbackContext = s.context || s,

        // Context for global events is callbackContext if it is a DOM node or jQuery collection
        globalEventContext = s.context &&
        ( callbackContext.nodeType || callbackContext.jquery ) ?
          jQuery( callbackContext ) :
          jQuery.event,

        // Deferreds
        deferred = jQuery.Deferred(),
        completeDeferred = jQuery.Callbacks( "once memory" ),

        // Status-dependent callbacks
        statusCode = s.statusCode || {},

        // Headers (they are sent all at once)
        requestHeaders = {},
        requestHeadersNames = {},

        // Default abort message
        strAbort = "canceled",

        // Fake xhr
        jqXHR = {
          readyState: 0,

          // Builds headers hashtable if needed
          getResponseHeader: function( key ) {
            var match;
            if ( completed ) {
              if ( !responseHeaders ) {
                responseHeaders = {};
                while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                  responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
                    ( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
                      .concat( match[ 2 ] );
                }
              }
              match = responseHeaders[ key.toLowerCase() + " " ];
            }
            return match == null ? null : match.join( ", " );
          },

          // Raw string
          getAllResponseHeaders: function() {
            return completed ? responseHeadersString : null;
          },

          // Caches the header
          setRequestHeader: function( name, value ) {
            if ( completed == null ) {
              name = requestHeadersNames[ name.toLowerCase() ] =
                requestHeadersNames[ name.toLowerCase() ] || name;
              requestHeaders[ name ] = value;
            }
            return this;
          },

          // Overrides response content-type header
          overrideMimeType: function( type ) {
            if ( completed == null ) {
              s.mimeType = type;
            }
            return this;
          },

          // Status-dependent callbacks
          statusCode: function( map ) {
            var code;
            if ( map ) {
              if ( completed ) {

                // Execute the appropriate callbacks
                jqXHR.always( map[ jqXHR.status ] );
              } else {

                // Lazy-add the new callbacks in a way that preserves old ones
                for ( code in map ) {
                  statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                }
              }
            }
            return this;
          },

          // Cancel the request
          abort: function( statusText ) {
            var finalText = statusText || strAbort;
            if ( transport ) {
              transport.abort( finalText );
            }
            done( 0, finalText );
            return this;
          }
        };

      // Attach deferreds
      deferred.promise( jqXHR );

      // Add protocol if not provided (prefilters might expect it)
      // Handle falsy url in the settings object (trac-10093: consistency with old signature)
      // We also use the url parameter if available
      s.url = ( ( url || s.url || location.href ) + "" )
        .replace( rprotocol, location.protocol + "//" );

      // Alias method option to type as per ticket trac-12004
      s.type = options.method || options.type || s.method || s.type;

      // Extract dataTypes list
      s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

      // A cross-domain request is in order when the origin doesn't match the current origin.
      if ( s.crossDomain == null ) {
        urlAnchor = document.createElement( "a" );

        // Support: IE <=8 - 11, Edge 12 - 15
        // IE throws exception on accessing the href property if url is malformed,
        // e.g. http://example.com:80x/
        try {
          urlAnchor.href = s.url;

          // Support: IE <=8 - 11 only
          // Anchor's host property isn't correctly set when s.url is relative
          urlAnchor.href = urlAnchor.href;
          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
            urlAnchor.protocol + "//" + urlAnchor.host;
        } catch ( e ) {

          // If there is an error parsing the URL, assume it is crossDomain,
          // it can be rejected by the transport if it is invalid
          s.crossDomain = true;
        }
      }

      // Convert data if not already a string
      if ( s.data && s.processData && typeof s.data !== "string" ) {
        s.data = jQuery.param( s.data, s.traditional );
      }

      // Apply prefilters
      inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

      // If request was aborted inside a prefilter, stop there
      if ( completed ) {
        return jqXHR;
      }

      // We can fire global events as of now if asked to
      // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
      fireGlobals = jQuery.event && s.global;

      // Watch for a new set of requests
      if ( fireGlobals && jQuery.active++ === 0 ) {
        jQuery.event.trigger( "ajaxStart" );
      }

      // Uppercase the type
      s.type = s.type.toUpperCase();

      // Determine if request has content
      s.hasContent = !rnoContent.test( s.type );

      // Save the URL in case we're toying with the If-Modified-Since
      // and/or If-None-Match header later on
      // Remove hash to simplify url manipulation
      cacheURL = s.url.replace( rhash, "" );

      // More options handling for requests with no content
      if ( !s.hasContent ) {

        // Remember the hash so we can put it back
        uncached = s.url.slice( cacheURL.length );

        // If data is available and should be processed, append data to url
        if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
          cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

          // trac-9682: remove data so that it's not used in an eventual retry
          delete s.data;
        }

        // Add or update anti-cache param if needed
        if ( s.cache === false ) {
          cacheURL = cacheURL.replace( rantiCache, "$1" );
          uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
            uncached;
        }

        // Put hash and anti-cache on the URL that will be requested (gh-1732)
        s.url = cacheURL + uncached;

        // Change '%20' to '+' if this is encoded form body content (gh-2658)
      } else if ( s.data && s.processData &&
        ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
        s.data = s.data.replace( r20, "+" );
      }

      // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
      if ( s.ifModified ) {
        if ( jQuery.lastModified[ cacheURL ] ) {
          jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
        }
        if ( jQuery.etag[ cacheURL ] ) {
          jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
        }
      }

      // Set the correct header, if data is being sent
      if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
        jqXHR.setRequestHeader( "Content-Type", s.contentType );
      }

      // Set the Accepts header for the server, depending on the dataType
      jqXHR.setRequestHeader(
        "Accept",
        s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
          s.accepts[ s.dataTypes[ 0 ] ] +
          ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
          s.accepts[ "*" ]
      );

      // Check for headers option
      for ( i in s.headers ) {
        jqXHR.setRequestHeader( i, s.headers[ i ] );
      }

      // Allow custom headers/mimetypes and early abort
      if ( s.beforeSend &&
        ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

        // Abort if not done already and return
        return jqXHR.abort();
      }

      // Aborting is no longer a cancellation
      strAbort = "abort";

      // Install callbacks on deferreds
      completeDeferred.add( s.complete );
      jqXHR.done( s.success );
      jqXHR.fail( s.error );

      // Get transport
      transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

      // If no transport, we auto-abort
      if ( !transport ) {
        done( -1, "No Transport" );
      } else {
        jqXHR.readyState = 1;

        // Send global event
        if ( fireGlobals ) {
          globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
        }

        // If request was aborted inside ajaxSend, stop there
        if ( completed ) {
          return jqXHR;
        }

        // Timeout
        if ( s.async && s.timeout > 0 ) {
          timeoutTimer = window.setTimeout( function() {
            jqXHR.abort( "timeout" );
          }, s.timeout );
        }

        try {
          completed = false;
          transport.send( requestHeaders, done );
        } catch ( e ) {

          // Rethrow post-completion exceptions
          if ( completed ) {
            throw e;
          }

          // Propagate others as results
          done( -1, e );
        }
      }

      // Callback for when everything is done
      function done( status, nativeStatusText, responses, headers ) {
        var isSuccess, success, error, response, modified,
          statusText = nativeStatusText;

        // Ignore repeat invocations
        if ( completed ) {
          return;
        }

        completed = true;

        // Clear timeout if it exists
        if ( timeoutTimer ) {
          window.clearTimeout( timeoutTimer );
        }

        // Dereference transport for early garbage collection
        // (no matter how long the jqXHR object will be used)
        transport = undefined;

        // Cache response headers
        responseHeadersString = headers || "";

        // Set readyState
        jqXHR.readyState = status > 0 ? 4 : 0;

        // Determine if successful
        isSuccess = status >= 200 && status < 300 || status === 304;

        // Get response data
        if ( responses ) {
          response = ajaxHandleResponses( s, jqXHR, responses );
        }

        // Use a noop converter for missing script but not if jsonp
        if ( !isSuccess &&
          jQuery.inArray( "script", s.dataTypes ) > -1 &&
          jQuery.inArray( "json", s.dataTypes ) < 0 ) {
          s.converters[ "text script" ] = function() {};
        }

        // Convert no matter what (that way responseXXX fields are always set)
        response = ajaxConvert( s, response, jqXHR, isSuccess );

        // If successful, handle type chaining
        if ( isSuccess ) {

          // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
          if ( s.ifModified ) {
            modified = jqXHR.getResponseHeader( "Last-Modified" );
            if ( modified ) {
              jQuery.lastModified[ cacheURL ] = modified;
            }
            modified = jqXHR.getResponseHeader( "etag" );
            if ( modified ) {
              jQuery.etag[ cacheURL ] = modified;
            }
          }

          // if no content
          if ( status === 204 || s.type === "HEAD" ) {
            statusText = "nocontent";

            // if not modified
          } else if ( status === 304 ) {
            statusText = "notmodified";

            // If we have data, let's convert it
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {

          // Extract error from statusText and normalize for non-aborts
          error = statusText;
          if ( status || !statusText ) {
            statusText = "error";
            if ( status < 0 ) {
              status = 0;
            }
          }
        }

        // Set data for the fake xhr object
        jqXHR.status = status;
        jqXHR.statusText = ( nativeStatusText || statusText ) + "";

        // Success/Error
        if ( isSuccess ) {
          deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
        } else {
          deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
        }

        // Status-dependent callbacks
        jqXHR.statusCode( statusCode );
        statusCode = undefined;

        if ( fireGlobals ) {
          globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
            [ jqXHR, s, isSuccess ? success : error ] );
        }

        // Complete
        completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

        if ( fireGlobals ) {
          globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

          // Handle the global AJAX counter
          if ( !( --jQuery.active ) ) {
            jQuery.event.trigger( "ajaxStop" );
          }
        }
      }

      return jqXHR;
    },

    getJSON: function( url, data, callback ) {
      return jQuery.get( url, data, callback, "json" );
    },

    getScript: function( url, callback ) {
      return jQuery.get( url, undefined, callback, "script" );
    }
  } );

  jQuery.each( [ "get", "post" ], function( _i, method ) {
    jQuery[ method ] = function( url, data, callback, type ) {

      // Shift arguments if data argument was omitted
      if ( isFunction( data ) ) {
        type = type || callback;
        callback = data;
        data = undefined;
      }

      // The url can be an options object (which then must have .url)
      return jQuery.ajax( jQuery.extend( {
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      }, jQuery.isPlainObject( url ) && url ) );
    };
  } );

  jQuery.ajaxPrefilter( function( s ) {
    var i;
    for ( i in s.headers ) {
      if ( i.toLowerCase() === "content-type" ) {
        s.contentType = s.headers[ i ] || "";
      }
    }
  } );


  jQuery._evalUrl = function( url, options, doc ) {
    return jQuery.ajax( {
      url: url,

      // Make this explicit, since user can override this through ajaxSetup (trac-11264)
      type: "GET",
      dataType: "script",
      cache: true,
      async: false,
      global: false,

      // Only evaluate the response if it is successful (gh-4126)
      // dataFilter is not invoked for failure responses, so using it instead
      // of the default converter is kludgy but it works.
      converters: {
        "text script": function() {}
      },
      dataFilter: function( response ) {
        jQuery.globalEval( response, options, doc );
      }
    } );
  };


  jQuery.fn.extend( {
    wrapAll: function( html ) {
      var wrap;

      if ( this[ 0 ] ) {
        if ( isFunction( html ) ) {
          html = html.call( this[ 0 ] );
        }

        // The elements to wrap the target around
        wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

        if ( this[ 0 ].parentNode ) {
          wrap.insertBefore( this[ 0 ] );
        }

        wrap.map( function() {
          var elem = this;

          while ( elem.firstElementChild ) {
            elem = elem.firstElementChild;
          }

          return elem;
        } ).append( this );
      }

      return this;
    },

    wrapInner: function( html ) {
      if ( isFunction( html ) ) {
        return this.each( function( i ) {
          jQuery( this ).wrapInner( html.call( this, i ) );
        } );
      }

      return this.each( function() {
        var self = jQuery( this ),
          contents = self.contents();

        if ( contents.length ) {
          contents.wrapAll( html );

        } else {
          self.append( html );
        }
      } );
    },

    wrap: function( html ) {
      var htmlIsFunction = isFunction( html );

      return this.each( function( i ) {
        jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
      } );
    },

    unwrap: function( selector ) {
      this.parent( selector ).not( "body" ).each( function() {
        jQuery( this ).replaceWith( this.childNodes );
      } );
      return this;
    }
  } );


  jQuery.expr.pseudos.hidden = function( elem ) {
    return !jQuery.expr.pseudos.visible( elem );
  };
  jQuery.expr.pseudos.visible = function( elem ) {
    return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
  };




  jQuery.ajaxSettings.xhr = function() {
    try {
      return new window.XMLHttpRequest();
    } catch ( e ) {}
  };

  var xhrSuccessStatus = {

      // File protocol always yields status code 0, assume 200
      0: 200,

      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    },
    xhrSupported = jQuery.ajaxSettings.xhr();

  support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
  support.ajax = xhrSupported = !!xhrSupported;

  jQuery.ajaxTransport( function( options ) {
    var callback, errorCallback;

    // Cross domain only allowed if supported through XMLHttpRequest
    if ( support.cors || xhrSupported && !options.crossDomain ) {
      return {
        send: function( headers, complete ) {
          var i,
            xhr = options.xhr();

          xhr.open(
            options.type,
            options.url,
            options.async,
            options.username,
            options.password
          );

          // Apply custom fields if provided
          if ( options.xhrFields ) {
            for ( i in options.xhrFields ) {
              xhr[ i ] = options.xhrFields[ i ];
            }
          }

          // Override mime type if needed
          if ( options.mimeType && xhr.overrideMimeType ) {
            xhr.overrideMimeType( options.mimeType );
          }

          // X-Requested-With header
          // For cross-domain requests, seeing as conditions for a preflight are
          // akin to a jigsaw puzzle, we simply never set it to be sure.
          // (it can always be set on a per-request basis or even using ajaxSetup)
          // For same-domain requests, won't change header if already provided.
          if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
            headers[ "X-Requested-With" ] = "XMLHttpRequest";
          }

          // Set headers
          for ( i in headers ) {
            xhr.setRequestHeader( i, headers[ i ] );
          }

          // Callback
          callback = function( type ) {
            return function() {
              if ( callback ) {
                callback = errorCallback = xhr.onload =
                  xhr.onerror = xhr.onabort = xhr.ontimeout =
                    xhr.onreadystatechange = null;

                if ( type === "abort" ) {
                  xhr.abort();
                } else if ( type === "error" ) {

                  // Support: IE <=9 only
                  // On a manual native abort, IE9 throws
                  // errors on any property access that is not readyState
                  if ( typeof xhr.status !== "number" ) {
                    complete( 0, "error" );
                  } else {
                    complete(

                      // File: protocol always yields status 0; see trac-8605, trac-14207
                      xhr.status,
                      xhr.statusText
                    );
                  }
                } else {
                  complete(
                    xhrSuccessStatus[ xhr.status ] || xhr.status,
                    xhr.statusText,

                    // Support: IE <=9 only
                    // IE9 has no XHR2 but throws on binary (trac-11426)
                    // For XHR2 non-text, let the caller handle it (gh-2498)
                    ( xhr.responseType || "text" ) !== "text"  ||
                    typeof xhr.responseText !== "string" ?
                      { binary: xhr.response } :
                      { text: xhr.responseText },
                    xhr.getAllResponseHeaders()
                  );
                }
              }
            };
          };

          // Listen to events
          xhr.onload = callback();
          errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

          // Support: IE 9 only
          // Use onreadystatechange to replace onabort
          // to handle uncaught aborts
          if ( xhr.onabort !== undefined ) {
            xhr.onabort = errorCallback;
          } else {
            xhr.onreadystatechange = function() {

              // Check readyState before timeout as it changes
              if ( xhr.readyState === 4 ) {

                // Allow onerror to be called first,
                // but that will not handle a native abort
                // Also, save errorCallback to a variable
                // as xhr.onerror cannot be accessed
                window.setTimeout( function() {
                  if ( callback ) {
                    errorCallback();
                  }
                } );
              }
            };
          }

          // Create the abort callback
          callback = callback( "abort" );

          try {

            // Do send the request (this may raise an exception)
            xhr.send( options.hasContent && options.data || null );
          } catch ( e ) {

            // trac-14683: Only rethrow if this hasn't been notified as an error yet
            if ( callback ) {
              throw e;
            }
          }
        },

        abort: function() {
          if ( callback ) {
            callback();
          }
        }
      };
    }
  } );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
  jQuery.ajaxPrefilter( function( s ) {
    if ( s.crossDomain ) {
      s.contents.script = false;
    }
  } );

// Install script dataType
  jQuery.ajaxSetup( {
    accepts: {
      script: "text/javascript, application/javascript, " +
        "application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function( text ) {
        jQuery.globalEval( text );
        return text;
      }
    }
  } );

// Handle cache's special case and crossDomain
  jQuery.ajaxPrefilter( "script", function( s ) {
    if ( s.cache === undefined ) {
      s.cache = false;
    }
    if ( s.crossDomain ) {
      s.type = "GET";
    }
  } );

// Bind script tag hack transport
  jQuery.ajaxTransport( "script", function( s ) {

    // This transport only deals with cross domain or forced-by-attrs requests
    if ( s.crossDomain || s.scriptAttrs ) {
      var script, callback;
      return {
        send: function( _, complete ) {
          script = jQuery( "<script>" )
            .attr( s.scriptAttrs || {} )
            .prop( { charset: s.scriptCharset, src: s.url } )
            .on( "load error", callback = function( evt ) {
              script.remove();
              callback = null;
              if ( evt ) {
                complete( evt.type === "error" ? 404 : 200, evt.type );
              }
            } );

          // Use native DOM manipulation to avoid our domManip AJAX trickery
          document.head.appendChild( script[ 0 ] );
        },
        abort: function() {
          if ( callback ) {
            callback();
          }
        }
      };
    }
  } );




  var oldCallbacks = [],
    rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
  jQuery.ajaxSetup( {
    jsonp: "callback",
    jsonpCallback: function() {
      var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
      this[ callback ] = true;
      return callback;
    }
  } );

// Detect, normalize options and install callbacks for jsonp requests
  jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

    var callbackName, overwritten, responseContainer,
      jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
          "url" :
          typeof s.data === "string" &&
          ( s.contentType || "" )
            .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
          rjsonp.test( s.data ) && "data"
      );

    // Handle iff the expected data type is "jsonp" or we have a parameter to set
    if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

      // Get callback name, remembering preexisting value associated with it
      callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
        s.jsonpCallback() :
        s.jsonpCallback;

      // Insert callback into url or form data
      if ( jsonProp ) {
        s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
      } else if ( s.jsonp !== false ) {
        s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
      }

      // Use data converter to retrieve json after script execution
      s.converters[ "script json" ] = function() {
        if ( !responseContainer ) {
          jQuery.error( callbackName + " was not called" );
        }
        return responseContainer[ 0 ];
      };

      // Force json dataType
      s.dataTypes[ 0 ] = "json";

      // Install callback
      overwritten = window[ callbackName ];
      window[ callbackName ] = function() {
        responseContainer = arguments;
      };

      // Clean-up function (fires after converters)
      jqXHR.always( function() {

        // If previous value didn't exist - remove it
        if ( overwritten === undefined ) {
          jQuery( window ).removeProp( callbackName );

          // Otherwise restore preexisting value
        } else {
          window[ callbackName ] = overwritten;
        }

        // Save back as free
        if ( s[ callbackName ] ) {

          // Make sure that re-using the options doesn't screw things around
          s.jsonpCallback = originalSettings.jsonpCallback;

          // Save the callback name for future use
          oldCallbacks.push( callbackName );
        }

        // Call if it was a function and we have a response
        if ( responseContainer && isFunction( overwritten ) ) {
          overwritten( responseContainer[ 0 ] );
        }

        responseContainer = overwritten = undefined;
      } );

      // Delegate to script
      return "script";
    }
  } );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
  support.createHTMLDocument = ( function() {
    var body = document.implementation.createHTMLDocument( "" ).body;
    body.innerHTML = "<form></form><form></form>";
    return body.childNodes.length === 2;
  } )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
  jQuery.parseHTML = function( data, context, keepScripts ) {
    if ( typeof data !== "string" ) {
      return [];
    }
    if ( typeof context === "boolean" ) {
      keepScripts = context;
      context = false;
    }

    var base, parsed, scripts;

    if ( !context ) {

      // Stop scripts or inline event handlers from being executed immediately
      // by using document.implementation
      if ( support.createHTMLDocument ) {
        context = document.implementation.createHTMLDocument( "" );

        // Set the base href for the created document
        // so any parsed elements with URLs
        // are based on the document's URL (gh-2965)
        base = context.createElement( "base" );
        base.href = document.location.href;
        context.head.appendChild( base );
      } else {
        context = document;
      }
    }

    parsed = rsingleTag.exec( data );
    scripts = !keepScripts && [];

    // Single tag
    if ( parsed ) {
      return [ context.createElement( parsed[ 1 ] ) ];
    }

    parsed = buildFragment( [ data ], context, scripts );

    if ( scripts && scripts.length ) {
      jQuery( scripts ).remove();
    }

    return jQuery.merge( [], parsed.childNodes );
  };


  /**
   * Load a url into a page
   */
  jQuery.fn.load = function( url, params, callback ) {
    var selector, type, response,
      self = this,
      off = url.indexOf( " " );

    if ( off > -1 ) {
      selector = stripAndCollapse( url.slice( off ) );
      url = url.slice( 0, off );
    }

    // If it's a function
    if ( isFunction( params ) ) {

      // We assume that it's the callback
      callback = params;
      params = undefined;

      // Otherwise, build a param string
    } else if ( params && typeof params === "object" ) {
      type = "POST";
    }

    // If we have elements to modify, make the request
    if ( self.length > 0 ) {
      jQuery.ajax( {
        url: url,

        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: type || "GET",
        dataType: "html",
        data: params
      } ).done( function( responseText ) {

        // Save response for use in complete callback
        response = arguments;

        self.html( selector ?

          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

          // Otherwise use the full result
          responseText );

        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
      } ).always( callback && function( jqXHR, status ) {
        self.each( function() {
          callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
        } );
      } );
    }

    return this;
  };




  jQuery.expr.pseudos.animated = function( elem ) {
    return jQuery.grep( jQuery.timers, function( fn ) {
      return elem === fn.elem;
    } ).length;
  };




  jQuery.offset = {
    setOffset: function( elem, options, i ) {
      var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
        position = jQuery.css( elem, "position" ),
        curElem = jQuery( elem ),
        props = {};

      // Set position first, in-case top/left are set even on static elem
      if ( position === "static" ) {
        elem.style.position = "relative";
      }

      curOffset = curElem.offset();
      curCSSTop = jQuery.css( elem, "top" );
      curCSSLeft = jQuery.css( elem, "left" );
      calculatePosition = ( position === "absolute" || position === "fixed" ) &&
        ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

      // Need to be able to calculate position if either
      // top or left is auto and position is either absolute or fixed
      if ( calculatePosition ) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;

      } else {
        curTop = parseFloat( curCSSTop ) || 0;
        curLeft = parseFloat( curCSSLeft ) || 0;
      }

      if ( isFunction( options ) ) {

        // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
        options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
      }

      if ( options.top != null ) {
        props.top = ( options.top - curOffset.top ) + curTop;
      }
      if ( options.left != null ) {
        props.left = ( options.left - curOffset.left ) + curLeft;
      }

      if ( "using" in options ) {
        options.using.call( elem, props );

      } else {
        curElem.css( props );
      }
    }
  };

  jQuery.fn.extend( {

    // offset() relates an element's border box to the document origin
    offset: function( options ) {

      // Preserve chaining for setter
      if ( arguments.length ) {
        return options === undefined ?
          this :
          this.each( function( i ) {
            jQuery.offset.setOffset( this, options, i );
          } );
      }

      var rect, win,
        elem = this[ 0 ];

      if ( !elem ) {
        return;
      }

      // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
      // Support: IE <=11 only
      // Running getBoundingClientRect on a
      // disconnected node in IE throws an error
      if ( !elem.getClientRects().length ) {
        return { top: 0, left: 0 };
      }

      // Get document-relative position by adding viewport scroll to viewport-relative gBCR
      rect = elem.getBoundingClientRect();
      win = elem.ownerDocument.defaultView;
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    },

    // position() relates an element's margin box to its offset parent's padding box
    // This corresponds to the behavior of CSS absolute positioning
    position: function() {
      if ( !this[ 0 ] ) {
        return;
      }

      var offsetParent, offset, doc,
        elem = this[ 0 ],
        parentOffset = { top: 0, left: 0 };

      // position:fixed elements are offset from the viewport, which itself always has zero offset
      if ( jQuery.css( elem, "position" ) === "fixed" ) {

        // Assume position:fixed implies availability of getBoundingClientRect
        offset = elem.getBoundingClientRect();

      } else {
        offset = this.offset();

        // Account for the *real* offset parent, which can be the document or its root element
        // when a statically positioned element is identified
        doc = elem.ownerDocument;
        offsetParent = elem.offsetParent || doc.documentElement;
        while ( offsetParent &&
        ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
        jQuery.css( offsetParent, "position" ) === "static" ) {

          offsetParent = offsetParent.parentNode;
        }
        if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

          // Incorporate borders into its offset, since they are outside its content origin
          parentOffset = jQuery( offsetParent ).offset();
          parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
          parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
        }
      }

      // Subtract parent offsets and element margins
      return {
        top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
        left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
      };
    },

    // This method will return documentElement in the following cases:
    // 1) For the element inside the iframe without offsetParent, this method will return
    //    documentElement of the parent window
    // 2) For the hidden or detached element
    // 3) For body or html element, i.e. in case of the html node - it will return itself
    //
    // but those exceptions were never presented as a real life use-cases
    // and might be considered as more preferable results.
    //
    // This logic, however, is not guaranteed and can change at any point in the future
    offsetParent: function() {
      return this.map( function() {
        var offsetParent = this.offsetParent;

        while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || documentElement;
      } );
    }
  } );

// Create scrollLeft and scrollTop methods
  jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
    var top = "pageYOffset" === prop;

    jQuery.fn[ method ] = function( val ) {
      return access( this, function( elem, method, val ) {

        // Coalesce documents and windows
        var win;
        if ( isWindow( elem ) ) {
          win = elem;
        } else if ( elem.nodeType === 9 ) {
          win = elem.defaultView;
        }

        if ( val === undefined ) {
          return win ? win[ prop ] : elem[ method ];
        }

        if ( win ) {
          win.scrollTo(
            !top ? val : win.pageXOffset,
            top ? val : win.pageYOffset
          );

        } else {
          elem[ method ] = val;
        }
      }, method, val, arguments.length );
    };
  } );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
  jQuery.each( [ "top", "left" ], function( _i, prop ) {
    jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
      function( elem, computed ) {
        if ( computed ) {
          computed = curCSS( elem, prop );

          // If curCSS returns percentage, fallback to offset
          return rnumnonpx.test( computed ) ?
            jQuery( elem ).position()[ prop ] + "px" :
            computed;
        }
      }
    );
  } );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
  jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
    jQuery.each( {
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function( defaultExtra, funcName ) {

      // Margin is only for outerHeight, outerWidth
      jQuery.fn[ funcName ] = function( margin, value ) {
        var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
          extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

        return access( this, function( elem, type, value ) {
          var doc;

          if ( isWindow( elem ) ) {

            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
            return funcName.indexOf( "outer" ) === 0 ?
              elem[ "inner" + name ] :
              elem.document.documentElement[ "client" + name ];
          }

          // Get document width or height
          if ( elem.nodeType === 9 ) {
            doc = elem.documentElement;

            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
            // whichever is greatest
            return Math.max(
              elem.body[ "scroll" + name ], doc[ "scroll" + name ],
              elem.body[ "offset" + name ], doc[ "offset" + name ],
              doc[ "client" + name ]
            );
          }

          return value === undefined ?

            // Get width or height on the element, requesting but not forcing parseFloat
            jQuery.css( elem, type, extra ) :

            // Set width or height on the element
            jQuery.style( elem, type, value, extra );
        }, type, chainable ? margin : undefined, chainable );
      };
    } );
  } );


  jQuery.each( [
    "ajaxStart",
    "ajaxStop",
    "ajaxComplete",
    "ajaxError",
    "ajaxSuccess",
    "ajaxSend"
  ], function( _i, type ) {
    jQuery.fn[ type ] = function( fn ) {
      return this.on( type, fn );
    };
  } );




  jQuery.fn.extend( {

    bind: function( types, data, fn ) {
      return this.on( types, null, data, fn );
    },
    unbind: function( types, fn ) {
      return this.off( types, null, fn );
    },

    delegate: function( selector, types, data, fn ) {
      return this.on( types, selector, data, fn );
    },
    undelegate: function( selector, types, fn ) {

      // ( namespace ) or ( selector, types [, fn] )
      return arguments.length === 1 ?
        this.off( selector, "**" ) :
        this.off( types, selector || "**", fn );
    },

    hover: function( fnOver, fnOut ) {
      return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
    }
  } );

  jQuery.each(
    ( "blur focus focusin focusout resize scroll click dblclick " +
      "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
      "change select submit keydown keypress keyup contextmenu" ).split( " " ),
    function( _i, name ) {

      // Handle event binding
      jQuery.fn[ name ] = function( data, fn ) {
        return arguments.length > 0 ?
          this.on( name, null, data, fn ) :
          this.trigger( name );
      };
    }
  );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
  var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
  jQuery.proxy = function( fn, context ) {
    var tmp, args, proxy;

    if ( typeof context === "string" ) {
      tmp = fn[ context ];
      context = fn;
      fn = tmp;
    }

    // Quick check to determine if target is callable, in the spec
    // this throws a TypeError, but we will just return undefined.
    if ( !isFunction( fn ) ) {
      return undefined;
    }

    // Simulated bind
    args = slice.call( arguments, 2 );
    proxy = function() {
      return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
    };

    // Set the guid of unique handler to the same of original handler, so it can be removed
    proxy.guid = fn.guid = fn.guid || jQuery.guid++;

    return proxy;
  };

  jQuery.holdReady = function( hold ) {
    if ( hold ) {
      jQuery.readyWait++;
    } else {
      jQuery.ready( true );
    }
  };
  jQuery.isArray = Array.isArray;
  jQuery.parseJSON = JSON.parse;
  jQuery.nodeName = nodeName;
  jQuery.isFunction = isFunction;
  jQuery.isWindow = isWindow;
  jQuery.camelCase = camelCase;
  jQuery.type = toType;

  jQuery.now = Date.now;

  jQuery.isNumeric = function( obj ) {

    // As of jQuery 3.0, isNumeric is limited to
    // strings and numbers (primitives or objects)
    // that can be coerced to finite numbers (gh-2662)
    var type = jQuery.type( obj );
    return ( type === "number" || type === "string" ) &&

      // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN( obj - parseFloat( obj ) );
  };

  jQuery.trim = function( text ) {
    return text == null ?
      "" :
      ( text + "" ).replace( rtrim, "$1" );
  };



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

  if ( typeof define === "function" && define.amd ) {
    define( "jquery", [], function() {
      return jQuery;
    } );
  }




  var

    // Map over jQuery in case of overwrite
    _jQuery = window.jQuery,

    // Map over the $ in case of overwrite
    _$ = window.$;

  jQuery.noConflict = function( deep ) {
    if ( window.$ === jQuery ) {
      window.$ = _$;
    }

    if ( deep && window.jQuery === jQuery ) {
      window.jQuery = _jQuery;
    }

    return jQuery;
  };

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
  if ( typeof noGlobal === "undefined" ) {
    window.jQuery = window.$ = jQuery;
  }




  return jQuery;
} );
/* jshint node: true */

/**
 * Unobtrusive scripting adapter for jQuery
 * https://github.com/rails/jquery-ujs
 *
 * Requires jQuery 1.8.0 or later.
 *
 * Released under the MIT license
 *
 */

(function() {
  'use strict';

  var jqueryUjsInit = function($, undefined) {

    // Cut down on the number of issues from people inadvertently including jquery_ujs twice
    // by detecting and raising an error when it happens.
    if ( $.rails !== undefined ) {
      $.error('jquery-ujs has already been loaded!');
    }

    // Shorthand to make it a little easier to call public rails functions from within rails.js
    var rails;
    var $document = $(document);

    $.rails = rails = {
      // Link elements bound by jquery-ujs
      linkClickSelector: 'a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]',

      // Button elements bound by jquery-ujs
      buttonClickSelector: 'button[data-remote]:not([form]):not(form button), button[data-confirm]:not([form]):not(form button)',

      // Select elements bound by jquery-ujs
      inputChangeSelector: 'select[data-remote], input[data-remote], textarea[data-remote]',

      // Form elements bound by jquery-ujs
      formSubmitSelector: 'form:not([data-turbo=true])',

      // Form input elements bound by jquery-ujs
      formInputClickSelector: 'form:not([data-turbo=true]) input[type=submit], form:not([data-turbo=true]) input[type=image], form:not([data-turbo=true]) button[type=submit], form:not([data-turbo=true]) button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])',

      // Form input elements disabled during form submission
      disableSelector: 'input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled',

      // Form input elements re-enabled after form submission
      enableSelector: 'input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled',

      // Form required input elements
      requiredInputSelector: 'input[name][required]:not([disabled]), textarea[name][required]:not([disabled])',

      // Form file input elements
      fileInputSelector: 'input[name][type=file]:not([disabled])',

      // Link onClick disable selector with possible reenable after remote submission
      linkDisableSelector: 'a[data-disable-with], a[data-disable]',

      // Button onClick disable selector with possible reenable after remote submission
      buttonDisableSelector: 'button[data-remote][data-disable-with], button[data-remote][data-disable]',

      // Up-to-date Cross-Site Request Forgery token
      csrfToken: function() {
        return $('meta[name=csrf-token]').attr('content');
      },

      // URL param that must contain the CSRF token
      csrfParam: function() {
        return $('meta[name=csrf-param]').attr('content');
      },

      // Make sure that every Ajax request sends the CSRF token
      CSRFProtection: function(xhr) {
        var token = rails.csrfToken();
        if (token) xhr.setRequestHeader('X-CSRF-Token', token);
      },

      // Make sure that all forms have actual up-to-date tokens (cached forms contain old ones)
      refreshCSRFTokens: function(){
        $('form input[name="' + rails.csrfParam() + '"]').val(rails.csrfToken());
      },

      // Triggers an event on an element and returns false if the event result is false
      fire: function(obj, name, data) {
        var event = $.Event(name);
        obj.trigger(event, data);
        return event.result !== false;
      },

      // Default confirm dialog, may be overridden with custom confirm dialog in $.rails.confirm
      confirm: function(message) {
        return confirm(message);
      },

      // Default ajax function, may be overridden with custom function in $.rails.ajax
      ajax: function(options) {
        return $.ajax(options);
      },

      // Default way to get an element's href. May be overridden at $.rails.href.
      href: function(element) {
        return element[0].href;
      },

      // Checks "data-remote" if true to handle the request through a XHR request.
      isRemote: function(element) {
        return element.data('remote') !== undefined && element.data('remote') !== false;
      },

      // Submits "remote" forms and links with ajax
      handleRemote: function(element) {
        var method, url, data, withCredentials, dataType, options;

        if (rails.fire(element, 'ajax:before')) {
          withCredentials = element.data('with-credentials') || null;
          dataType = element.data('type') || ($.ajaxSettings && $.ajaxSettings.dataType);

          if (element.is('form')) {
            method = element.data('ujs:submit-button-formmethod') || element.attr('method');
            url = element.data('ujs:submit-button-formaction') || element.attr('action');
            data = $(element[0]).serializeArray();
            // memoized value from clicked submit button
            var button = element.data('ujs:submit-button');
            if (button) {
              data.push(button);
              element.data('ujs:submit-button', null);
            }
            element.data('ujs:submit-button-formmethod', null);
            element.data('ujs:submit-button-formaction', null);
          } else if (element.is(rails.inputChangeSelector)) {
            method = element.data('method');
            url = element.data('url');
            data = element.serialize();
            if (element.data('params')) data = data + '&' + element.data('params');
          } else if (element.is(rails.buttonClickSelector)) {
            method = element.data('method') || 'get';
            url = element.data('url');
            data = element.serialize();
            if (element.data('params')) data = data + '&' + element.data('params');
          } else {
            method = element.data('method');
            url = rails.href(element);
            data = element.data('params') || null;
          }

          options = {
            type: method || 'GET', data: data, dataType: dataType,
            // stopping the "ajax:beforeSend" event will cancel the ajax request
            beforeSend: function(xhr, settings) {
              if (settings.dataType === undefined) {
                xhr.setRequestHeader('accept', '*/*;q=0.5, ' + settings.accepts.script);
              }
              if (rails.fire(element, 'ajax:beforeSend', [xhr, settings])) {
                element.trigger('ajax:send', xhr);
              } else {
                return false;
              }
            },
            success: function(data, status, xhr) {
              element.trigger('ajax:success', [data, status, xhr]);
            },
            complete: function(xhr, status) {
              element.trigger('ajax:complete', [xhr, status]);
            },
            error: function(xhr, status, error) {
              element.trigger('ajax:error', [xhr, status, error]);
            },
            crossDomain: rails.isCrossDomain(url)
          };

          // There is no withCredentials for IE6-8 when
          // "Enable native XMLHTTP support" is disabled
          if (withCredentials) {
            options.xhrFields = {
              withCredentials: withCredentials
            };
          }

          // Only pass url to `ajax` options if not blank
          if (url) { options.url = url; }

          return rails.ajax(options);
        } else {
          return false;
        }
      },

      // Determines if the request is a cross domain request.
      isCrossDomain: function(url) {
        var originAnchor = document.createElement('a');
        originAnchor.href = location.href;
        var urlAnchor = document.createElement('a');

        try {
          urlAnchor.href = url;
          // This is a workaround to a IE bug.
          urlAnchor.href = urlAnchor.href;

          // If URL protocol is false or is a string containing a single colon
          // *and* host are false, assume it is not a cross-domain request
          // (should only be the case for IE7 and IE compatibility mode).
          // Otherwise, evaluate protocol and host of the URL against the origin
          // protocol and host.
          return !(((!urlAnchor.protocol || urlAnchor.protocol === ':') && !urlAnchor.host) ||
            (originAnchor.protocol + '//' + originAnchor.host ===
              urlAnchor.protocol + '//' + urlAnchor.host));
        } catch (e) {
          // If there is an error parsing the URL, assume it is crossDomain.
          return true;
        }
      },

      // Handles "data-method" on links such as:
      // <a href="/users/5" data-method="delete" rel="nofollow" data-confirm="Are you sure?">Delete</a>
      handleMethod: function(link) {
        var href = rails.href(link),
          method = link.data('method'),
          target = link.attr('target'),
          csrfToken = rails.csrfToken(),
          csrfParam = rails.csrfParam(),
          form = $('<form method="post" action="' + href + '"></form>'),
          metadataInput = '<input name="_method" value="' + method + '" type="hidden" />';

        if (csrfParam !== undefined && csrfToken !== undefined && !rails.isCrossDomain(href)) {
          metadataInput += '<input name="' + csrfParam + '" value="' + csrfToken + '" type="hidden" />';
        }

        if (target) { form.attr('target', target); }

        form.hide().append(metadataInput).appendTo('body');
        form.submit();
      },

      // Helper function that returns form elements that match the specified CSS selector
      // If form is actually a "form" element this will return associated elements outside the from that have
      // the html form attribute set
      formElements: function(form, selector) {
        return form.is('form') ? $(form[0].elements).filter(selector) : form.find(selector);
      },

      /* Disables form elements:
        - Caches element value in 'ujs:enable-with' data store
        - Replaces element text with value of 'data-disable-with' attribute
        - Sets disabled property to true
      */
      disableFormElements: function(form) {
        rails.formElements(form, rails.disableSelector).each(function() {
          rails.disableFormElement($(this));
        });
      },

      disableFormElement: function(element) {
        var method, replacement;

        method = element.is('button') ? 'html' : 'val';
        replacement = element.data('disable-with');

        if (replacement !== undefined) {
          element.data('ujs:enable-with', element[method]());
          element[method](replacement);
        }

        element.prop('disabled', true);
        element.data('ujs:disabled', true);
      },

      /* Re-enables disabled form elements:
        - Replaces element text with cached value from 'ujs:enable-with' data store (created in `disableFormElements`)
        - Sets disabled property to false
      */
      enableFormElements: function(form) {
        rails.formElements(form, rails.enableSelector).each(function() {
          rails.enableFormElement($(this));
        });
      },

      enableFormElement: function(element) {
        var method = element.is('button') ? 'html' : 'val';
        if (element.data('ujs:enable-with') !== undefined) {
          element[method](element.data('ujs:enable-with'));
          element.removeData('ujs:enable-with'); // clean up cache
        }
        element.prop('disabled', false);
        element.removeData('ujs:disabled');
      },

      /* For 'data-confirm' attribute:
         - Fires `confirm` event
         - Shows the confirmation dialog
         - Fires the `confirm:complete` event

         Returns `true` if no function stops the chain and user chose yes; `false` otherwise.
         Attaching a handler to the element's `confirm` event that returns a `falsy` value cancels the confirmation dialog.
         Attaching a handler to the element's `confirm:complete` event that returns a `falsy` value makes this function
         return false. The `confirm:complete` event is fired whether or not the user answered true or false to the dialog.
      */
      allowAction: function(element) {
        var message = element.data('confirm'),
          answer = false, callback;
        if (!message) { return true; }

        if (rails.fire(element, 'confirm')) {
          try {
            answer = rails.confirm(message);
          } catch (e) {
            (console.error || console.log).call(console, e.stack || e);
          }
          callback = rails.fire(element, 'confirm:complete', [answer]);
        }
        return answer && callback;
      },

      // Helper function which checks for blank inputs in a form that match the specified CSS selector
      blankInputs: function(form, specifiedSelector, nonBlank) {
        var foundInputs = $(),
          input,
          valueToCheck,
          radiosForNameWithNoneSelected,
          radioName,
          selector = specifiedSelector || 'input,textarea',
          requiredInputs = form.find(selector),
          checkedRadioButtonNames = {};

        requiredInputs.each(function() {
          input = $(this);
          if (input.is('input[type=radio]')) {

            // Don't count unchecked required radio as blank if other radio with same name is checked,
            // regardless of whether same-name radio input has required attribute or not. The spec
            // states https://www.w3.org/TR/html5/forms.html#the-required-attribute
            radioName = input.attr('name');

            // Skip if we've already seen the radio with this name.
            if (!checkedRadioButtonNames[radioName]) {

              // If none checked
              if (form.find('input[type=radio]:checked[name="' + radioName + '"]').length === 0) {
                radiosForNameWithNoneSelected = form.find(
                  'input[type=radio][name="' + radioName + '"]');
                foundInputs = foundInputs.add(radiosForNameWithNoneSelected);
              }

              // We only need to check each name once.
              checkedRadioButtonNames[radioName] = radioName;
            }
          } else {
            valueToCheck = input.is('input[type=checkbox],input[type=radio]') ? input.is(':checked') : !!input.val();
            if (valueToCheck === nonBlank) {
              foundInputs = foundInputs.add(input);
            }
          }
        });
        return foundInputs.length ? foundInputs : false;
      },

      // Helper function which checks for non-blank inputs in a form that match the specified CSS selector
      nonBlankInputs: function(form, specifiedSelector) {
        return rails.blankInputs(form, specifiedSelector, true); // true specifies nonBlank
      },

      // Helper function, needed to provide consistent behavior in IE
      stopEverything: function(e) {
        $(e.target).trigger('ujs:everythingStopped');
        e.stopImmediatePropagation();
        return false;
      },

      //  Replace element's html with the 'data-disable-with' after storing original html
      //  and prevent clicking on it
      disableElement: function(element) {
        var replacement = element.data('disable-with');

        if (replacement !== undefined) {
          element.data('ujs:enable-with', element.html()); // store enabled state
          element.html(replacement);
        }

        element.on('click.railsDisable', function(e) { // prevent further clicking
          return rails.stopEverything(e);
        });
        element.data('ujs:disabled', true);
      },

      // Restore element to its original state which was disabled by 'disableElement' above
      enableElement: function(element) {
        if (element.data('ujs:enable-with') !== undefined) {
          element.html(element.data('ujs:enable-with')); // set to old enabled state
          element.removeData('ujs:enable-with'); // clean up cache
        }
        element.off('click.railsDisable'); // enable element
        element.removeData('ujs:disabled');
      }
    };

    if (rails.fire($document, 'rails:attachBindings')) {

      $.ajaxPrefilter(function(options, originalOptions, xhr){ if ( !options.crossDomain ) { rails.CSRFProtection(xhr); }});

      // This event works the same as the load event, except that it fires every
      // time the page is loaded.
      //
      // See https://github.com/rails/jquery-ujs/issues/357
      // See https://developer.mozilla.org/en-US/docs/Using_Firefox_1.5_caching
      $(window).on('pageshow.rails', function () {
        $($.rails.enableSelector).each(function () {
          var element = $(this);

          if (element.data('ujs:disabled')) {
            $.rails.enableFormElement(element);
          }
        });

        $($.rails.linkDisableSelector).each(function () {
          var element = $(this);

          if (element.data('ujs:disabled')) {
            $.rails.enableElement(element);
          }
        });
      });

      $document.on('ajax:complete', rails.linkDisableSelector, function() {
        rails.enableElement($(this));
      });

      $document.on('ajax:complete', rails.buttonDisableSelector, function() {
        rails.enableFormElement($(this));
      });

      $document.on('click.rails', rails.linkClickSelector, function(e) {
        var link = $(this), method = link.data('method'), data = link.data('params'), metaClick = e.metaKey || e.ctrlKey;
        if (!rails.allowAction(link)) return rails.stopEverything(e);

        if (!metaClick && link.is(rails.linkDisableSelector)) rails.disableElement(link);

        if (rails.isRemote(link)) {
          if (metaClick && (!method || method === 'GET') && !data) { return true; }

          var handleRemote = rails.handleRemote(link);
          // Response from rails.handleRemote() will either be false or a deferred object promise.
          if (handleRemote === false) {
            rails.enableElement(link);
          } else {
            handleRemote.fail( function() { rails.enableElement(link); } );
          }
          return false;

        } else if (method) {
          rails.handleMethod(link);
          return false;
        }
      });

      $document.on('click.rails', rails.buttonClickSelector, function(e) {
        var button = $(this);

        if (!rails.allowAction(button) || !rails.isRemote(button)) return rails.stopEverything(e);

        if (button.is(rails.buttonDisableSelector)) rails.disableFormElement(button);

        var handleRemote = rails.handleRemote(button);
        // Response from rails.handleRemote() will either be false or a deferred object promise.
        if (handleRemote === false) {
          rails.enableFormElement(button);
        } else {
          handleRemote.fail( function() { rails.enableFormElement(button); } );
        }
        return false;
      });

      $document.on('change.rails', rails.inputChangeSelector, function(e) {
        var link = $(this);
        if (!rails.allowAction(link) || !rails.isRemote(link)) return rails.stopEverything(e);

        rails.handleRemote(link);
        return false;
      });

      $document.on('submit.rails', rails.formSubmitSelector, function(e) {
        var form = $(this),
          remote = rails.isRemote(form),
          blankRequiredInputs,
          nonBlankFileInputs;

        if (!rails.allowAction(form)) return rails.stopEverything(e);

        // Skip other logic when required values are missing or file upload is present
        if (form.attr('novalidate') === undefined) {
          if (form.data('ujs:formnovalidate-button') === undefined) {
            blankRequiredInputs = rails.blankInputs(form, rails.requiredInputSelector, false);
            if (blankRequiredInputs && rails.fire(form, 'ajax:aborted:required', [blankRequiredInputs])) {
              return rails.stopEverything(e);
            }
          } else {
            // Clear the formnovalidate in case the next button click is not on a formnovalidate button
            // Not strictly necessary to do here, since it is also reset on each button click, but just to be certain
            form.data('ujs:formnovalidate-button', undefined);
          }
        }

        if (remote) {
          nonBlankFileInputs = rails.nonBlankInputs(form, rails.fileInputSelector);
          if (nonBlankFileInputs) {
            // Slight timeout so that the submit button gets properly serialized
            // (make it easy for event handler to serialize form without disabled values)
            setTimeout(function(){ rails.disableFormElements(form); }, 13);
            var aborted = rails.fire(form, 'ajax:aborted:file', [nonBlankFileInputs]);

            // Re-enable form elements if event bindings return false (canceling normal form submission)
            if (!aborted) { setTimeout(function(){ rails.enableFormElements(form); }, 13); }

            return aborted;
          }

          rails.handleRemote(form);
          return false;

        } else {
          // Slight timeout so that the submit button gets properly serialized
          setTimeout(function(){ rails.disableFormElements(form); }, 13);
        }
      });

      $document.on('click.rails', rails.formInputClickSelector, function(event) {
        var button = $(this);

        if (!rails.allowAction(button)) return rails.stopEverything(event);

        // Register the pressed submit button
        var name = button.attr('name'),
          data = name ? {name:name, value:button.val()} : null;

        var form = button.closest('form');
        if (form.length === 0) {
          form = $('#' + button.attr('form'));
        }
        form.data('ujs:submit-button', data);

        // Save attributes from button
        form.data('ujs:formnovalidate-button', button.attr('formnovalidate'));
        form.data('ujs:submit-button-formaction', button.attr('formaction'));
        form.data('ujs:submit-button-formmethod', button.attr('formmethod'));
      });

      $document.on('ajax:send.rails', rails.formSubmitSelector, function(event) {
        if (this === event.target) rails.disableFormElements($(this));
      });

      $document.on('ajax:complete.rails', rails.formSubmitSelector, function(event) {
        if (this === event.target) rails.enableFormElements($(this));
      });

      $(function(){
        rails.refreshCSRFTokens();
      });
    }

  };

  if (window.jQuery) {
    jqueryUjsInit(jQuery);
  } else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = jqueryUjsInit;
  }
})();
/*! jQuery UI - v1.13.2 - 2022-07-14
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-patch.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)}(function(V){"use strict";V.ui=V.ui||{};V.ui.version="1.13.2";var n,i=0,a=Array.prototype.hasOwnProperty,r=Array.prototype.slice;V.cleanData=(n=V.cleanData,function(t){for(var e,i,s=0;null!=(i=t[s]);s++)(e=V._data(i,"events"))&&e.remove&&V(i).triggerHandler("remove");n(t)}),V.widget=function(t,i,e){var s,n,o,a={},r=t.split(".")[0],l=r+"-"+(t=t.split(".")[1]);return e||(e=i,i=V.Widget),Array.isArray(e)&&(e=V.extend.apply(null,[{}].concat(e))),V.expr.pseudos[l.toLowerCase()]=function(t){return!!V.data(t,l)},V[r]=V[r]||{},s=V[r][t],n=V[r][t]=function(t,e){if(!this||!this._createWidget)return new n(t,e);arguments.length&&this._createWidget(t,e)},V.extend(n,s,{version:e.version,_proto:V.extend({},e),_childConstructors:[]}),(o=new i).options=V.widget.extend({},o.options),V.each(e,function(e,s){function n(){return i.prototype[e].apply(this,arguments)}function o(t){return i.prototype[e].apply(this,t)}a[e]="function"==typeof s?function(){var t,e=this._super,i=this._superApply;return this._super=n,this._superApply=o,t=s.apply(this,arguments),this._super=e,this._superApply=i,t}:s}),n.prototype=V.widget.extend(o,{widgetEventPrefix:s&&o.widgetEventPrefix||t},a,{constructor:n,namespace:r,widgetName:t,widgetFullName:l}),s?(V.each(s._childConstructors,function(t,e){var i=e.prototype;V.widget(i.namespace+"."+i.widgetName,n,e._proto)}),delete s._childConstructors):i._childConstructors.push(n),V.widget.bridge(t,n),n},V.widget.extend=function(t){for(var e,i,s=r.call(arguments,1),n=0,o=s.length;n<o;n++)for(e in s[n])i=s[n][e],a.call(s[n],e)&&void 0!==i&&(V.isPlainObject(i)?t[e]=V.isPlainObject(t[e])?V.widget.extend({},t[e],i):V.widget.extend({},i):t[e]=i);return t},V.widget.bridge=function(o,e){var a=e.prototype.widgetFullName||o;V.fn[o]=function(i){var t="string"==typeof i,s=r.call(arguments,1),n=this;return t?this.length||"instance"!==i?this.each(function(){var t,e=V.data(this,a);return"instance"===i?(n=e,!1):e?"function"!=typeof e[i]||"_"===i.charAt(0)?V.error("no such method '"+i+"' for "+o+" widget instance"):(t=e[i].apply(e,s))!==e&&void 0!==t?(n=t&&t.jquery?n.pushStack(t.get()):t,!1):void 0:V.error("cannot call methods on "+o+" prior to initialization; attempted to call method '"+i+"'")}):n=void 0:(s.length&&(i=V.widget.extend.apply(null,[i].concat(s))),this.each(function(){var t=V.data(this,a);t?(t.option(i||{}),t._init&&t._init()):V.data(this,a,new e(i,this))})),n}},V.Widget=function(){},V.Widget._childConstructors=[],V.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(t,e){e=V(e||this.defaultElement||this)[0],this.element=V(e),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=V(),this.hoverable=V(),this.focusable=V(),this.classesElementLookup={},e!==this&&(V.data(e,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===e&&this.destroy()}}),this.document=V(e.style?e.ownerDocument:e.document||e),this.window=V(this.document[0].defaultView||this.document[0].parentWindow)),this.options=V.widget.extend({},this.options,this._getCreateOptions(),t),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:V.noop,_create:V.noop,_init:V.noop,destroy:function(){var i=this;this._destroy(),V.each(this.classesElementLookup,function(t,e){i._removeClass(e,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:V.noop,widget:function(){return this.element},option:function(t,e){var i,s,n,o=t;if(0===arguments.length)return V.widget.extend({},this.options);if("string"==typeof t)if(o={},t=(i=t.split(".")).shift(),i.length){for(s=o[t]=V.widget.extend({},this.options[t]),n=0;n<i.length-1;n++)s[i[n]]=s[i[n]]||{},s=s[i[n]];if(t=i.pop(),1===arguments.length)return void 0===s[t]?null:s[t];s[t]=e}else{if(1===arguments.length)return void 0===this.options[t]?null:this.options[t];o[t]=e}return this._setOptions(o),this},_setOptions:function(t){for(var e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(t){var e,i,s;for(e in t)s=this.classesElementLookup[e],t[e]!==this.options.classes[e]&&s&&s.length&&(i=V(s.get()),this._removeClass(s,e),i.addClass(this._classes({element:i,keys:e,classes:t,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(n){var o=[],a=this;function t(t,e){for(var i,s=0;s<t.length;s++)i=a.classesElementLookup[t[s]]||V(),i=n.add?(function(){var i=[];n.element.each(function(t,e){V.map(a.classesElementLookup,function(t){return t}).some(function(t){return t.is(e)})||i.push(e)}),a._on(V(i),{remove:"_untrackClassesElement"})}(),V(V.uniqueSort(i.get().concat(n.element.get())))):V(i.not(n.element).get()),a.classesElementLookup[t[s]]=i,o.push(t[s]),e&&n.classes[t[s]]&&o.push(n.classes[t[s]])}return(n=V.extend({element:this.element,classes:this.options.classes||{}},n)).keys&&t(n.keys.match(/\S+/g)||[],!0),n.extra&&t(n.extra.match(/\S+/g)||[]),o.join(" ")},_untrackClassesElement:function(i){var s=this;V.each(s.classesElementLookup,function(t,e){-1!==V.inArray(i.target,e)&&(s.classesElementLookup[t]=V(e.not(i.target).get()))}),this._off(V(i.target))},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){var n="string"==typeof t||null===t,i={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s="boolean"==typeof s?s:i};return i.element.toggleClass(this._classes(i),s),this},_on:function(n,o,t){var a,r=this;"boolean"!=typeof n&&(t=o,o=n,n=!1),t?(o=a=V(o),this.bindings=this.bindings.add(o)):(t=o,o=this.element,a=this.widget()),V.each(t,function(t,e){function i(){if(n||!0!==r.options.disabled&&!V(this).hasClass("ui-state-disabled"))return("string"==typeof e?r[e]:e).apply(r,arguments)}"string"!=typeof e&&(i.guid=e.guid=e.guid||i.guid||V.guid++);var s=t.match(/^([\w:-]*)\s*(.*)$/),t=s[1]+r.eventNamespace,s=s[2];s?a.on(t,s,i):o.on(t,i)})},_off:function(t,e){e=(e||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,t.off(e),this.bindings=V(this.bindings.not(t).get()),this.focusable=V(this.focusable.not(t).get()),this.hoverable=V(this.hoverable.not(t).get())},_delay:function(t,e){var i=this;return setTimeout(function(){return("string"==typeof t?i[t]:t).apply(i,arguments)},e||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){this._addClass(V(t.currentTarget),null,"ui-state-hover")},mouseleave:function(t){this._removeClass(V(t.currentTarget),null,"ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){this._addClass(V(t.currentTarget),null,"ui-state-focus")},focusout:function(t){this._removeClass(V(t.currentTarget),null,"ui-state-focus")}})},_trigger:function(t,e,i){var s,n,o=this.options[t];if(i=i||{},(e=V.Event(e)).type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),e.target=this.element[0],n=e.originalEvent)for(s in n)s in e||(e[s]=n[s]);return this.element.trigger(e,i),!("function"==typeof o&&!1===o.apply(this.element[0],[e].concat(i))||e.isDefaultPrevented())}},V.each({show:"fadeIn",hide:"fadeOut"},function(o,a){V.Widget.prototype["_"+o]=function(e,t,i){var s,n=(t="string"==typeof t?{effect:t}:t)?!0!==t&&"number"!=typeof t&&t.effect||a:o;"number"==typeof(t=t||{})?t={duration:t}:!0===t&&(t={}),s=!V.isEmptyObject(t),t.complete=i,t.delay&&e.delay(t.delay),s&&V.effects&&V.effects.effect[n]?e[o](t):n!==o&&e[n]?e[n](t.duration,t.easing,i):e.queue(function(t){V(this)[o](),i&&i.call(e[0]),t()})}});var s,x,k,o,l,h,c,u,C;V.widget;function D(t,e,i){return[parseFloat(t[0])*(u.test(t[0])?e/100:1),parseFloat(t[1])*(u.test(t[1])?i/100:1)]}function I(t,e){return parseInt(V.css(t,e),10)||0}function T(t){return null!=t&&t===t.window}x=Math.max,k=Math.abs,o=/left|center|right/,l=/top|center|bottom/,h=/[\+\-]\d+(\.[\d]+)?%?/,c=/^\w+/,u=/%$/,C=V.fn.position,V.position={scrollbarWidth:function(){if(void 0!==s)return s;var t,e=V("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>"),i=e.children()[0];return V("body").append(e),t=i.offsetWidth,e.css("overflow","scroll"),t===(i=i.offsetWidth)&&(i=e[0].clientWidth),e.remove(),s=t-i},getScrollInfo:function(t){var e=t.isWindow||t.isDocument?"":t.element.css("overflow-x"),i=t.isWindow||t.isDocument?"":t.element.css("overflow-y"),e="scroll"===e||"auto"===e&&t.width<t.element[0].scrollWidth;return{width:"scroll"===i||"auto"===i&&t.height<t.element[0].scrollHeight?V.position.scrollbarWidth():0,height:e?V.position.scrollbarWidth():0}},getWithinInfo:function(t){var e=V(t||window),i=T(e[0]),s=!!e[0]&&9===e[0].nodeType;return{element:e,isWindow:i,isDocument:s,offset:!i&&!s?V(t).offset():{left:0,top:0},scrollLeft:e.scrollLeft(),scrollTop:e.scrollTop(),width:e.outerWidth(),height:e.outerHeight()}}},V.fn.position=function(u){if(!u||!u.of)return C.apply(this,arguments);var d,p,f,g,m,t,_="string"==typeof(u=V.extend({},u)).of?V(document).find(u.of):V(u.of),v=V.position.getWithinInfo(u.within),b=V.position.getScrollInfo(v),y=(u.collision||"flip").split(" "),w={},e=9===(t=(e=_)[0]).nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:T(t)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:t.preventDefault?{width:0,height:0,offset:{top:t.pageY,left:t.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()};return _[0].preventDefault&&(u.at="left top"),p=e.width,f=e.height,m=V.extend({},g=e.offset),V.each(["my","at"],function(){var t,e,i=(u[this]||"").split(" ");(i=1===i.length?o.test(i[0])?i.concat(["center"]):l.test(i[0])?["center"].concat(i):["center","center"]:i)[0]=o.test(i[0])?i[0]:"center",i[1]=l.test(i[1])?i[1]:"center",t=h.exec(i[0]),e=h.exec(i[1]),w[this]=[t?t[0]:0,e?e[0]:0],u[this]=[c.exec(i[0])[0],c.exec(i[1])[0]]}),1===y.length&&(y[1]=y[0]),"right"===u.at[0]?m.left+=p:"center"===u.at[0]&&(m.left+=p/2),"bottom"===u.at[1]?m.top+=f:"center"===u.at[1]&&(m.top+=f/2),d=D(w.at,p,f),m.left+=d[0],m.top+=d[1],this.each(function(){var i,t,a=V(this),r=a.outerWidth(),l=a.outerHeight(),e=I(this,"marginLeft"),s=I(this,"marginTop"),n=r+e+I(this,"marginRight")+b.width,o=l+s+I(this,"marginBottom")+b.height,h=V.extend({},m),c=D(w.my,a.outerWidth(),a.outerHeight());"right"===u.my[0]?h.left-=r:"center"===u.my[0]&&(h.left-=r/2),"bottom"===u.my[1]?h.top-=l:"center"===u.my[1]&&(h.top-=l/2),h.left+=c[0],h.top+=c[1],i={marginLeft:e,marginTop:s},V.each(["left","top"],function(t,e){V.ui.position[y[t]]&&V.ui.position[y[t]][e](h,{targetWidth:p,targetHeight:f,elemWidth:r,elemHeight:l,collisionPosition:i,collisionWidth:n,collisionHeight:o,offset:[d[0]+c[0],d[1]+c[1]],my:u.my,at:u.at,within:v,elem:a})}),u.using&&(t=function(t){var e=g.left-h.left,i=e+p-r,s=g.top-h.top,n=s+f-l,o={target:{element:_,left:g.left,top:g.top,width:p,height:f},element:{element:a,left:h.left,top:h.top,width:r,height:l},horizontal:i<0?"left":0<e?"right":"center",vertical:n<0?"top":0<s?"bottom":"middle"};p<r&&k(e+i)<p&&(o.horizontal="center"),f<l&&k(s+n)<f&&(o.vertical="middle"),x(k(e),k(i))>x(k(s),k(n))?o.important="horizontal":o.important="vertical",u.using.call(this,t,o)}),a.offset(V.extend(h,{using:t}))})},V.ui.position={fit:{left:function(t,e){var i=e.within,s=i.isWindow?i.scrollLeft:i.offset.left,n=i.width,o=t.left-e.collisionPosition.marginLeft,a=s-o,r=o+e.collisionWidth-n-s;e.collisionWidth>n?0<a&&r<=0?(i=t.left+a+e.collisionWidth-n-s,t.left+=a-i):t.left=!(0<r&&a<=0)&&r<a?s+n-e.collisionWidth:s:0<a?t.left+=a:0<r?t.left-=r:t.left=x(t.left-o,t.left)},top:function(t,e){var i=e.within,s=i.isWindow?i.scrollTop:i.offset.top,n=e.within.height,o=t.top-e.collisionPosition.marginTop,a=s-o,r=o+e.collisionHeight-n-s;e.collisionHeight>n?0<a&&r<=0?(i=t.top+a+e.collisionHeight-n-s,t.top+=a-i):t.top=!(0<r&&a<=0)&&r<a?s+n-e.collisionHeight:s:0<a?t.top+=a:0<r?t.top-=r:t.top=x(t.top-o,t.top)}},flip:{left:function(t,e){var i=e.within,s=i.offset.left+i.scrollLeft,n=i.width,o=i.isWindow?i.scrollLeft:i.offset.left,a=t.left-e.collisionPosition.marginLeft,r=a-o,l=a+e.collisionWidth-n-o,h="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,i="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,a=-2*e.offset[0];r<0?((s=t.left+h+i+a+e.collisionWidth-n-s)<0||s<k(r))&&(t.left+=h+i+a):0<l&&(0<(o=t.left-e.collisionPosition.marginLeft+h+i+a-o)||k(o)<l)&&(t.left+=h+i+a)},top:function(t,e){var i=e.within,s=i.offset.top+i.scrollTop,n=i.height,o=i.isWindow?i.scrollTop:i.offset.top,a=t.top-e.collisionPosition.marginTop,r=a-o,l=a+e.collisionHeight-n-o,h="top"===e.my[1]?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,i="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,a=-2*e.offset[1];r<0?((s=t.top+h+i+a+e.collisionHeight-n-s)<0||s<k(r))&&(t.top+=h+i+a):0<l&&(0<(o=t.top-e.collisionPosition.marginTop+h+i+a-o)||k(o)<l)&&(t.top+=h+i+a)}},flipfit:{left:function(){V.ui.position.flip.left.apply(this,arguments),V.ui.position.fit.left.apply(this,arguments)},top:function(){V.ui.position.flip.top.apply(this,arguments),V.ui.position.fit.top.apply(this,arguments)}}};V.ui.position,V.extend(V.expr.pseudos,{data:V.expr.createPseudo?V.expr.createPseudo(function(e){return function(t){return!!V.data(t,e)}}):function(t,e,i){return!!V.data(t,i[3])}}),V.fn.extend({disableSelection:(t="onselectstart"in document.createElement("div")?"selectstart":"mousedown",function(){return this.on(t+".ui-disableSelection",function(t){t.preventDefault()})}),enableSelection:function(){return this.off(".ui-disableSelection")}});var t,d=V,p={},e=p.toString,f=/^([\-+])=\s*(\d+\.?\d*)/,g=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16),t[4]?(parseInt(t[4],16)/255).toFixed(2):1]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16),t[4]?(parseInt(t[4]+t[4],16)/255).toFixed(2):1]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],m=d.Color=function(t,e,i,s){return new d.Color.fn.parse(t,e,i,s)},_={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},v={byte:{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},b=m.support={},y=d("<p>")[0],w=d.each;function P(t){return null==t?t+"":"object"==typeof t?p[e.call(t)]||"object":typeof t}function M(t,e,i){var s=v[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),isNaN(t)?e.def:s.mod?(t+s.mod)%s.mod:Math.min(s.max,Math.max(0,t)))}function S(s){var n=m(),o=n._rgba=[];return s=s.toLowerCase(),w(g,function(t,e){var i=e.re.exec(s),i=i&&e.parse(i),e=e.space||"rgba";if(i)return i=n[e](i),n[_[e].cache]=i[_[e].cache],o=n._rgba=i._rgba,!1}),o.length?("0,0,0,0"===o.join()&&d.extend(o,B.transparent),n):B[s]}function H(t,e,i){return 6*(i=(i+1)%1)<1?t+(e-t)*i*6:2*i<1?e:3*i<2?t+(e-t)*(2/3-i)*6:t}y.style.cssText="background-color:rgba(1,1,1,.5)",b.rgba=-1<y.style.backgroundColor.indexOf("rgba"),w(_,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),d.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(t,e){p["[object "+e+"]"]=e.toLowerCase()}),(m.fn=d.extend(m.prototype,{parse:function(n,t,e,i){if(void 0===n)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=d(n).css(t),t=void 0);var o=this,s=P(n),a=this._rgba=[];return void 0!==t&&(n=[n,t,e,i],s="array"),"string"===s?this.parse(S(n)||B._default):"array"===s?(w(_.rgba.props,function(t,e){a[e.idx]=M(n[e.idx],e)}),this):"object"===s?(w(_,n instanceof m?function(t,e){n[e.cache]&&(o[e.cache]=n[e.cache].slice())}:function(t,i){var s=i.cache;w(i.props,function(t,e){if(!o[s]&&i.to){if("alpha"===t||null==n[t])return;o[s]=i.to(o._rgba)}o[s][e.idx]=M(n[t],e,!0)}),o[s]&&d.inArray(null,o[s].slice(0,3))<0&&(null==o[s][3]&&(o[s][3]=1),i.from&&(o._rgba=i.from(o[s])))}),this):void 0},is:function(t){var n=m(t),o=!0,a=this;return w(_,function(t,e){var i,s=n[e.cache];return s&&(i=a[e.cache]||e.to&&e.to(a._rgba)||[],w(e.props,function(t,e){if(null!=s[e.idx])return o=s[e.idx]===i[e.idx]})),o}),o},_space:function(){var i=[],s=this;return w(_,function(t,e){s[e.cache]&&i.push(t)}),i.pop()},transition:function(t,a){var e=(h=m(t))._space(),i=_[e],t=0===this.alpha()?m("transparent"):this,r=t[i.cache]||i.to(t._rgba),l=r.slice(),h=h[i.cache];return w(i.props,function(t,e){var i=e.idx,s=r[i],n=h[i],o=v[e.type]||{};null!==n&&(null===s?l[i]=n:(o.mod&&(n-s>o.mod/2?s+=o.mod:s-n>o.mod/2&&(s-=o.mod)),l[i]=M((n-s)*a+s,e)))}),this[e](l)},blend:function(t){if(1===this._rgba[3])return this;var e=this._rgba.slice(),i=e.pop(),s=m(t)._rgba;return m(d.map(e,function(t,e){return(1-i)*s[e]+i*t}))},toRgbaString:function(){var t="rgba(",e=d.map(this._rgba,function(t,e){return null!=t?t:2<e?1:0});return 1===e[3]&&(e.pop(),t="rgb("),t+e.join()+")"},toHslaString:function(){var t="hsla(",e=d.map(this.hsla(),function(t,e){return null==t&&(t=2<e?1:0),t=e&&e<3?Math.round(100*t)+"%":t});return 1===e[3]&&(e.pop(),t="hsl("),t+e.join()+")"},toHexString:function(t){var e=this._rgba.slice(),i=e.pop();return t&&e.push(~~(255*i)),"#"+d.map(e,function(t){return 1===(t=(t||0).toString(16)).length?"0"+t:t}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}})).parse.prototype=m.fn,_.hsla.to=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/255,i=t[1]/255,s=t[2]/255,n=t[3],o=Math.max(e,i,s),a=Math.min(e,i,s),r=o-a,l=o+a,t=.5*l,i=a===o?0:e===o?60*(i-s)/r+360:i===o?60*(s-e)/r+120:60*(e-i)/r+240,l=0==r?0:t<=.5?r/l:r/(2-l);return[Math.round(i)%360,l,t,null==n?1:n]},_.hsla.from=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/360,i=t[1],s=t[2],t=t[3],i=s<=.5?s*(1+i):s+i-s*i,s=2*s-i;return[Math.round(255*H(s,i,e+1/3)),Math.round(255*H(s,i,e)),Math.round(255*H(s,i,e-1/3)),t]},w(_,function(l,t){var e=t.props,o=t.cache,a=t.to,r=t.from;m.fn[l]=function(t){if(a&&!this[o]&&(this[o]=a(this._rgba)),void 0===t)return this[o].slice();var i=P(t),s="array"===i||"object"===i?t:arguments,n=this[o].slice();return w(e,function(t,e){t=s["object"===i?t:e.idx];null==t&&(t=n[e.idx]),n[e.idx]=M(t,e)}),r?((t=m(r(n)))[o]=n,t):m(n)},w(e,function(a,r){m.fn[a]||(m.fn[a]=function(t){var e,i=P(t),s="alpha"===a?this._hsla?"hsla":"rgba":l,n=this[s](),o=n[r.idx];return"undefined"===i?o:("function"===i&&(i=P(t=t.call(this,o))),null==t&&r.empty?this:("string"===i&&(e=f.exec(t))&&(t=o+parseFloat(e[2])*("+"===e[1]?1:-1)),n[r.idx]=t,this[s](n)))})})}),(m.hook=function(t){t=t.split(" ");w(t,function(t,o){d.cssHooks[o]={set:function(t,e){var i,s,n="";if("transparent"!==e&&("string"!==P(e)||(i=S(e)))){if(e=m(i||e),!b.rgba&&1!==e._rgba[3]){for(s="backgroundColor"===o?t.parentNode:t;(""===n||"transparent"===n)&&s&&s.style;)try{n=d.css(s,"backgroundColor"),s=s.parentNode}catch(t){}e=e.blend(n&&"transparent"!==n?n:"_default")}e=e.toRgbaString()}try{t.style[o]=e}catch(t){}}},d.fx.step[o]=function(t){t.colorInit||(t.start=m(t.elem,o),t.end=m(t.end),t.colorInit=!0),d.cssHooks[o].set(t.elem,t.start.transition(t.end,t.pos))}})})("backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor"),d.cssHooks.borderColor={expand:function(i){var s={};return w(["Top","Right","Bottom","Left"],function(t,e){s["border"+e+"Color"]=i}),s}};var z,A,O,N,E,W,F,L,R,Y,B=d.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"},j="ui-effects-",q="ui-effects-style",K="ui-effects-animated";function U(t){var e,i,s=t.ownerDocument.defaultView?t.ownerDocument.defaultView.getComputedStyle(t,null):t.currentStyle,n={};if(s&&s.length&&s[0]&&s[s[0]])for(i=s.length;i--;)"string"==typeof s[e=s[i]]&&(n[e.replace(/-([\da-z])/gi,function(t,e){return e.toUpperCase()})]=s[e]);else for(e in s)"string"==typeof s[e]&&(n[e]=s[e]);return n}function X(t,e,i,s){return t={effect:t=V.isPlainObject(t)?(e=t).effect:t},"function"==typeof(e=null==e?{}:e)&&(s=e,i=null,e={}),"number"!=typeof e&&!V.fx.speeds[e]||(s=i,i=e,e={}),"function"==typeof i&&(s=i,i=null),e&&V.extend(t,e),i=i||e.duration,t.duration=V.fx.off?0:"number"==typeof i?i:i in V.fx.speeds?V.fx.speeds[i]:V.fx.speeds._default,t.complete=s||e.complete,t}function $(t){return!t||"number"==typeof t||V.fx.speeds[t]||("string"==typeof t&&!V.effects.effect[t]||("function"==typeof t||"object"==typeof t&&!t.effect))}function G(t,e){var i=e.outerWidth(),e=e.outerHeight(),t=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/.exec(t)||["",0,i,e,0];return{top:parseFloat(t[1])||0,right:"auto"===t[2]?i:parseFloat(t[2]),bottom:"auto"===t[3]?e:parseFloat(t[3]),left:parseFloat(t[4])||0}}V.effects={effect:{}},N=["add","remove","toggle"],E={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1},V.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(t,e){V.fx.step[e]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(d.style(t.elem,e,t.end),t.setAttr=!0)}}),V.fn.addBack||(V.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),V.effects.animateClass=function(n,t,e,i){var o=V.speed(t,e,i);return this.queue(function(){var i=V(this),t=i.attr("class")||"",e=(e=o.children?i.find("*").addBack():i).map(function(){return{el:V(this),start:U(this)}}),s=function(){V.each(N,function(t,e){n[e]&&i[e+"Class"](n[e])})};s(),e=e.map(function(){return this.end=U(this.el[0]),this.diff=function(t,e){var i,s,n={};for(i in e)s=e[i],t[i]!==s&&(E[i]||!V.fx.step[i]&&isNaN(parseFloat(s))||(n[i]=s));return n}(this.start,this.end),this}),i.attr("class",t),e=e.map(function(){var t=this,e=V.Deferred(),i=V.extend({},o,{queue:!1,complete:function(){e.resolve(t)}});return this.el.animate(this.diff,i),e.promise()}),V.when.apply(V,e.get()).done(function(){s(),V.each(arguments,function(){var e=this.el;V.each(this.diff,function(t){e.css(t,"")})}),o.complete.call(i[0])})})},V.fn.extend({addClass:(O=V.fn.addClass,function(t,e,i,s){return e?V.effects.animateClass.call(this,{add:t},e,i,s):O.apply(this,arguments)}),removeClass:(A=V.fn.removeClass,function(t,e,i,s){return 1<arguments.length?V.effects.animateClass.call(this,{remove:t},e,i,s):A.apply(this,arguments)}),toggleClass:(z=V.fn.toggleClass,function(t,e,i,s,n){return"boolean"==typeof e||void 0===e?i?V.effects.animateClass.call(this,e?{add:t}:{remove:t},i,s,n):z.apply(this,arguments):V.effects.animateClass.call(this,{toggle:t},e,i,s)}),switchClass:function(t,e,i,s,n){return V.effects.animateClass.call(this,{add:e,remove:t},i,s,n)}}),V.expr&&V.expr.pseudos&&V.expr.pseudos.animated&&(V.expr.pseudos.animated=(W=V.expr.pseudos.animated,function(t){return!!V(t).data(K)||W(t)})),!1!==V.uiBackCompat&&V.extend(V.effects,{save:function(t,e){for(var i=0,s=e.length;i<s;i++)null!==e[i]&&t.data(j+e[i],t[0].style[e[i]])},restore:function(t,e){for(var i,s=0,n=e.length;s<n;s++)null!==e[s]&&(i=t.data(j+e[s]),t.css(e[s],i))},setMode:function(t,e){return e="toggle"===e?t.is(":hidden")?"show":"hide":e},createWrapper:function(i){if(i.parent().is(".ui-effects-wrapper"))return i.parent();var s={width:i.outerWidth(!0),height:i.outerHeight(!0),float:i.css("float")},t=V("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),e={width:i.width(),height:i.height()},n=document.activeElement;try{n.id}catch(t){n=document.body}return i.wrap(t),i[0]!==n&&!V.contains(i[0],n)||V(n).trigger("focus"),t=i.parent(),"static"===i.css("position")?(t.css({position:"relative"}),i.css({position:"relative"})):(V.extend(s,{position:i.css("position"),zIndex:i.css("z-index")}),V.each(["top","left","bottom","right"],function(t,e){s[e]=i.css(e),isNaN(parseInt(s[e],10))&&(s[e]="auto")}),i.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),i.css(e),t.css(s).show()},removeWrapper:function(t){var e=document.activeElement;return t.parent().is(".ui-effects-wrapper")&&(t.parent().replaceWith(t),t[0]!==e&&!V.contains(t[0],e)||V(e).trigger("focus")),t}}),V.extend(V.effects,{version:"1.13.2",define:function(t,e,i){return i||(i=e,e="effect"),V.effects.effect[t]=i,V.effects.effect[t].mode=e,i},scaledDimensions:function(t,e,i){if(0===e)return{height:0,width:0,outerHeight:0,outerWidth:0};var s="horizontal"!==i?(e||100)/100:1,e="vertical"!==i?(e||100)/100:1;return{height:t.height()*e,width:t.width()*s,outerHeight:t.outerHeight()*e,outerWidth:t.outerWidth()*s}},clipToBox:function(t){return{width:t.clip.right-t.clip.left,height:t.clip.bottom-t.clip.top,left:t.clip.left,top:t.clip.top}},unshift:function(t,e,i){var s=t.queue();1<e&&s.splice.apply(s,[1,0].concat(s.splice(e,i))),t.dequeue()},saveStyle:function(t){t.data(q,t[0].style.cssText)},restoreStyle:function(t){t[0].style.cssText=t.data(q)||"",t.removeData(q)},mode:function(t,e){t=t.is(":hidden");return"toggle"===e&&(e=t?"show":"hide"),e=(t?"hide"===e:"show"===e)?"none":e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createPlaceholder:function(t){var e,i=t.css("position"),s=t.position();return t.css({marginTop:t.css("marginTop"),marginBottom:t.css("marginBottom"),marginLeft:t.css("marginLeft"),marginRight:t.css("marginRight")}).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()),/^(static|relative)/.test(i)&&(i="absolute",e=V("<"+t[0].nodeName+">").insertAfter(t).css({display:/^(inline|ruby)/.test(t.css("display"))?"inline-block":"block",visibility:"hidden",marginTop:t.css("marginTop"),marginBottom:t.css("marginBottom"),marginLeft:t.css("marginLeft"),marginRight:t.css("marginRight"),float:t.css("float")}).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).addClass("ui-effects-placeholder"),t.data(j+"placeholder",e)),t.css({position:i,left:s.left,top:s.top}),e},removePlaceholder:function(t){var e=j+"placeholder",i=t.data(e);i&&(i.remove(),t.removeData(e))},cleanUp:function(t){V.effects.restoreStyle(t),V.effects.removePlaceholder(t)},setTransition:function(s,t,n,o){return o=o||{},V.each(t,function(t,e){var i=s.cssUnit(e);0<i[0]&&(o[e]=i[0]*n+i[1])}),o}}),V.fn.extend({effect:function(){function t(t){var e=V(this),i=V.effects.mode(e,r)||o;e.data(K,!0),l.push(i),o&&("show"===i||i===o&&"hide"===i)&&e.show(),o&&"none"===i||V.effects.saveStyle(e),"function"==typeof t&&t()}var s=X.apply(this,arguments),n=V.effects.effect[s.effect],o=n.mode,e=s.queue,i=e||"fx",a=s.complete,r=s.mode,l=[];return V.fx.off||!n?r?this[r](s.duration,a):this.each(function(){a&&a.call(this)}):!1===e?this.each(t).each(h):this.queue(i,t).queue(i,h);function h(t){var e=V(this);function i(){"function"==typeof a&&a.call(e[0]),"function"==typeof t&&t()}s.mode=l.shift(),!1===V.uiBackCompat||o?"none"===s.mode?(e[r](),i()):n.call(e[0],s,function(){e.removeData(K),V.effects.cleanUp(e),"hide"===s.mode&&e.hide(),i()}):(e.is(":hidden")?"hide"===r:"show"===r)?(e[r](),i()):n.call(e[0],s,i)}},show:(R=V.fn.show,function(t){if($(t))return R.apply(this,arguments);t=X.apply(this,arguments);return t.mode="show",this.effect.call(this,t)}),hide:(L=V.fn.hide,function(t){if($(t))return L.apply(this,arguments);t=X.apply(this,arguments);return t.mode="hide",this.effect.call(this,t)}),toggle:(F=V.fn.toggle,function(t){if($(t)||"boolean"==typeof t)return F.apply(this,arguments);t=X.apply(this,arguments);return t.mode="toggle",this.effect.call(this,t)}),cssUnit:function(t){var i=this.css(t),s=[];return V.each(["em","px","%","pt"],function(t,e){0<i.indexOf(e)&&(s=[parseFloat(i),e])}),s},cssClip:function(t){return t?this.css("clip","rect("+t.top+"px "+t.right+"px "+t.bottom+"px "+t.left+"px)"):G(this.css("clip"),this)},transfer:function(t,e){var i=V(this),s=V(t.to),n="fixed"===s.css("position"),o=V("body"),a=n?o.scrollTop():0,r=n?o.scrollLeft():0,o=s.offset(),o={top:o.top-a,left:o.left-r,height:s.innerHeight(),width:s.innerWidth()},s=i.offset(),l=V("<div class='ui-effects-transfer'></div>");l.appendTo("body").addClass(t.className).css({top:s.top-a,left:s.left-r,height:i.innerHeight(),width:i.innerWidth(),position:n?"fixed":"absolute"}).animate(o,t.duration,t.easing,function(){l.remove(),"function"==typeof e&&e()})}}),V.fx.step.clip=function(t){t.clipInit||(t.start=V(t.elem).cssClip(),"string"==typeof t.end&&(t.end=G(t.end,t.elem)),t.clipInit=!0),V(t.elem).cssClip({top:t.pos*(t.end.top-t.start.top)+t.start.top,right:t.pos*(t.end.right-t.start.right)+t.start.right,bottom:t.pos*(t.end.bottom-t.start.bottom)+t.start.bottom,left:t.pos*(t.end.left-t.start.left)+t.start.left})},Y={},V.each(["Quad","Cubic","Quart","Quint","Expo"],function(e,t){Y[t]=function(t){return Math.pow(t,e+2)}}),V.extend(Y,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;t<((e=Math.pow(2,--i))-1)/11;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),V.each(Y,function(t,e){V.easing["easeIn"+t]=e,V.easing["easeOut"+t]=function(t){return 1-e(1-t)},V.easing["easeInOut"+t]=function(t){return t<.5?e(2*t)/2:1-e(-2*t+2)/2}});y=V.effects,V.effects.define("blind","hide",function(t,e){var i={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},s=V(this),n=t.direction||"up",o=s.cssClip(),a={clip:V.extend({},o)},r=V.effects.createPlaceholder(s);a.clip[i[n][0]]=a.clip[i[n][1]],"show"===t.mode&&(s.cssClip(a.clip),r&&r.css(V.effects.clipToBox(a)),a.clip=o),r&&r.animate(V.effects.clipToBox(a),t.duration,t.easing),s.animate(a,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("bounce",function(t,e){var i,s,n=V(this),o=t.mode,a="hide"===o,r="show"===o,l=t.direction||"up",h=t.distance,c=t.times||5,o=2*c+(r||a?1:0),u=t.duration/o,d=t.easing,p="up"===l||"down"===l?"top":"left",f="up"===l||"left"===l,g=0,t=n.queue().length;for(V.effects.createPlaceholder(n),l=n.css(p),h=h||n["top"==p?"outerHeight":"outerWidth"]()/3,r&&((s={opacity:1})[p]=l,n.css("opacity",0).css(p,f?2*-h:2*h).animate(s,u,d)),a&&(h/=Math.pow(2,c-1)),(s={})[p]=l;g<c;g++)(i={})[p]=(f?"-=":"+=")+h,n.animate(i,u,d).animate(s,u,d),h=a?2*h:h/2;a&&((i={opacity:0})[p]=(f?"-=":"+=")+h,n.animate(i,u,d)),n.queue(e),V.effects.unshift(n,t,1+o)}),V.effects.define("clip","hide",function(t,e){var i={},s=V(this),n=t.direction||"vertical",o="both"===n,a=o||"horizontal"===n,o=o||"vertical"===n,n=s.cssClip();i.clip={top:o?(n.bottom-n.top)/2:n.top,right:a?(n.right-n.left)/2:n.right,bottom:o?(n.bottom-n.top)/2:n.bottom,left:a?(n.right-n.left)/2:n.left},V.effects.createPlaceholder(s),"show"===t.mode&&(s.cssClip(i.clip),i.clip=n),s.animate(i,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("drop","hide",function(t,e){var i=V(this),s="show"===t.mode,n=t.direction||"left",o="up"===n||"down"===n?"top":"left",a="up"===n||"left"===n?"-=":"+=",r="+="==a?"-=":"+=",l={opacity:0};V.effects.createPlaceholder(i),n=t.distance||i["top"==o?"outerHeight":"outerWidth"](!0)/2,l[o]=a+n,s&&(i.css(l),l[o]=r+n,l.opacity=1),i.animate(l,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("explode","hide",function(t,e){var i,s,n,o,a,r,l=t.pieces?Math.round(Math.sqrt(t.pieces)):3,h=l,c=V(this),u="show"===t.mode,d=c.show().css("visibility","hidden").offset(),p=Math.ceil(c.outerWidth()/h),f=Math.ceil(c.outerHeight()/l),g=[];function m(){g.push(this),g.length===l*h&&(c.css({visibility:"visible"}),V(g).remove(),e())}for(i=0;i<l;i++)for(o=d.top+i*f,r=i-(l-1)/2,s=0;s<h;s++)n=d.left+s*p,a=s-(h-1)/2,c.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-s*p,top:-i*f}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:p,height:f,left:n+(u?a*p:0),top:o+(u?r*f:0),opacity:u?0:1}).animate({left:n+(u?0:a*p),top:o+(u?0:r*f),opacity:u?1:0},t.duration||500,t.easing,m)}),V.effects.define("fade","toggle",function(t,e){var i="show"===t.mode;V(this).css("opacity",i?0:1).animate({opacity:i?1:0},{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("fold","hide",function(e,t){var i=V(this),s=e.mode,n="show"===s,o="hide"===s,a=e.size||15,r=/([0-9]+)%/.exec(a),l=!!e.horizFirst?["right","bottom"]:["bottom","right"],h=e.duration/2,c=V.effects.createPlaceholder(i),u=i.cssClip(),d={clip:V.extend({},u)},p={clip:V.extend({},u)},f=[u[l[0]],u[l[1]]],s=i.queue().length;r&&(a=parseInt(r[1],10)/100*f[o?0:1]),d.clip[l[0]]=a,p.clip[l[0]]=a,p.clip[l[1]]=0,n&&(i.cssClip(p.clip),c&&c.css(V.effects.clipToBox(p)),p.clip=u),i.queue(function(t){c&&c.animate(V.effects.clipToBox(d),h,e.easing).animate(V.effects.clipToBox(p),h,e.easing),t()}).animate(d,h,e.easing).animate(p,h,e.easing).queue(t),V.effects.unshift(i,s,4)}),V.effects.define("highlight","show",function(t,e){var i=V(this),s={backgroundColor:i.css("backgroundColor")};"hide"===t.mode&&(s.opacity=0),V.effects.saveStyle(i),i.css({backgroundImage:"none",backgroundColor:t.color||"#ffff99"}).animate(s,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("size",function(s,e){var n,i=V(this),t=["fontSize"],o=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],a=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],r=s.mode,l="effect"!==r,h=s.scale||"both",c=s.origin||["middle","center"],u=i.css("position"),d=i.position(),p=V.effects.scaledDimensions(i),f=s.from||p,g=s.to||V.effects.scaledDimensions(i,0);V.effects.createPlaceholder(i),"show"===r&&(r=f,f=g,g=r),n={from:{y:f.height/p.height,x:f.width/p.width},to:{y:g.height/p.height,x:g.width/p.width}},"box"!==h&&"both"!==h||(n.from.y!==n.to.y&&(f=V.effects.setTransition(i,o,n.from.y,f),g=V.effects.setTransition(i,o,n.to.y,g)),n.from.x!==n.to.x&&(f=V.effects.setTransition(i,a,n.from.x,f),g=V.effects.setTransition(i,a,n.to.x,g))),"content"!==h&&"both"!==h||n.from.y!==n.to.y&&(f=V.effects.setTransition(i,t,n.from.y,f),g=V.effects.setTransition(i,t,n.to.y,g)),c&&(c=V.effects.getBaseline(c,p),f.top=(p.outerHeight-f.outerHeight)*c.y+d.top,f.left=(p.outerWidth-f.outerWidth)*c.x+d.left,g.top=(p.outerHeight-g.outerHeight)*c.y+d.top,g.left=(p.outerWidth-g.outerWidth)*c.x+d.left),delete f.outerHeight,delete f.outerWidth,i.css(f),"content"!==h&&"both"!==h||(o=o.concat(["marginTop","marginBottom"]).concat(t),a=a.concat(["marginLeft","marginRight"]),i.find("*[width]").each(function(){var t=V(this),e=V.effects.scaledDimensions(t),i={height:e.height*n.from.y,width:e.width*n.from.x,outerHeight:e.outerHeight*n.from.y,outerWidth:e.outerWidth*n.from.x},e={height:e.height*n.to.y,width:e.width*n.to.x,outerHeight:e.height*n.to.y,outerWidth:e.width*n.to.x};n.from.y!==n.to.y&&(i=V.effects.setTransition(t,o,n.from.y,i),e=V.effects.setTransition(t,o,n.to.y,e)),n.from.x!==n.to.x&&(i=V.effects.setTransition(t,a,n.from.x,i),e=V.effects.setTransition(t,a,n.to.x,e)),l&&V.effects.saveStyle(t),t.css(i),t.animate(e,s.duration,s.easing,function(){l&&V.effects.restoreStyle(t)})})),i.animate(g,{queue:!1,duration:s.duration,easing:s.easing,complete:function(){var t=i.offset();0===g.opacity&&i.css("opacity",f.opacity),l||(i.css("position","static"===u?"relative":u).offset(t),V.effects.saveStyle(i)),e()}})}),V.effects.define("scale",function(t,e){var i=V(this),s=t.mode,s=parseInt(t.percent,10)||(0===parseInt(t.percent,10)||"effect"!==s?0:100),s=V.extend(!0,{from:V.effects.scaledDimensions(i),to:V.effects.scaledDimensions(i,s,t.direction||"both"),origin:t.origin||["middle","center"]},t);t.fade&&(s.from.opacity=1,s.to.opacity=0),V.effects.effect.size.call(this,s,e)}),V.effects.define("puff","hide",function(t,e){t=V.extend(!0,{},t,{fade:!0,percent:parseInt(t.percent,10)||150});V.effects.effect.scale.call(this,t,e)}),V.effects.define("pulsate","show",function(t,e){var i=V(this),s=t.mode,n="show"===s,o=2*(t.times||5)+(n||"hide"===s?1:0),a=t.duration/o,r=0,l=1,s=i.queue().length;for(!n&&i.is(":visible")||(i.css("opacity",0).show(),r=1);l<o;l++)i.animate({opacity:r},a,t.easing),r=1-r;i.animate({opacity:r},a,t.easing),i.queue(e),V.effects.unshift(i,s,1+o)}),V.effects.define("shake",function(t,e){var i=1,s=V(this),n=t.direction||"left",o=t.distance||20,a=t.times||3,r=2*a+1,l=Math.round(t.duration/r),h="up"===n||"down"===n?"top":"left",c="up"===n||"left"===n,u={},d={},p={},n=s.queue().length;for(V.effects.createPlaceholder(s),u[h]=(c?"-=":"+=")+o,d[h]=(c?"+=":"-=")+2*o,p[h]=(c?"-=":"+=")+2*o,s.animate(u,l,t.easing);i<a;i++)s.animate(d,l,t.easing).animate(p,l,t.easing);s.animate(d,l,t.easing).animate(u,l/2,t.easing).queue(e),V.effects.unshift(s,n,1+r)}),V.effects.define("slide","show",function(t,e){var i,s,n=V(this),o={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},a=t.mode,r=t.direction||"left",l="up"===r||"down"===r?"top":"left",h="up"===r||"left"===r,c=t.distance||n["top"==l?"outerHeight":"outerWidth"](!0),u={};V.effects.createPlaceholder(n),i=n.cssClip(),s=n.position()[l],u[l]=(h?-1:1)*c+s,u.clip=n.cssClip(),u.clip[o[r][1]]=u.clip[o[r][0]],"show"===a&&(n.cssClip(u.clip),n.css(l,u[l]),u.clip=i,u[l]=s),n.animate(u,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),y=!1!==V.uiBackCompat?V.effects.define("transfer",function(t,e){V(this).transfer(t,e)}):y;V.ui.focusable=function(t,e){var i,s,n,o,a=t.nodeName.toLowerCase();return"area"===a?(s=(i=t.parentNode).name,!(!t.href||!s||"map"!==i.nodeName.toLowerCase())&&(0<(s=V("img[usemap='#"+s+"']")).length&&s.is(":visible"))):(/^(input|select|textarea|button|object)$/.test(a)?(n=!t.disabled)&&(o=V(t).closest("fieldset")[0])&&(n=!o.disabled):n="a"===a&&t.href||e,n&&V(t).is(":visible")&&function(t){var e=t.css("visibility");for(;"inherit"===e;)t=t.parent(),e=t.css("visibility");return"visible"===e}(V(t)))},V.extend(V.expr.pseudos,{focusable:function(t){return V.ui.focusable(t,null!=V.attr(t,"tabindex"))}});var Q,J;V.ui.focusable,V.fn._form=function(){return"string"==typeof this[0].form?this.closest("form"):V(this[0].form)},V.ui.formResetMixin={_formResetHandler:function(){var e=V(this);setTimeout(function(){var t=e.data("ui-form-reset-instances");V.each(t,function(){this.refresh()})})},_bindFormResetHandler:function(){var t;this.form=this.element._form(),this.form.length&&((t=this.form.data("ui-form-reset-instances")||[]).length||this.form.on("reset.ui-form-reset",this._formResetHandler),t.push(this),this.form.data("ui-form-reset-instances",t))},_unbindFormResetHandler:function(){var t;this.form.length&&((t=this.form.data("ui-form-reset-instances")).splice(V.inArray(this,t),1),t.length?this.form.data("ui-form-reset-instances",t):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset"))}};V.expr.pseudos||(V.expr.pseudos=V.expr[":"]),V.uniqueSort||(V.uniqueSort=V.unique),V.escapeSelector||(Q=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,J=function(t,e){return e?"\0"===t?"�":t.slice(0,-1)+"\\"+t.charCodeAt(t.length-1).toString(16)+" ":"\\"+t},V.escapeSelector=function(t){return(t+"").replace(Q,J)}),V.fn.even&&V.fn.odd||V.fn.extend({even:function(){return this.filter(function(t){return t%2==0})},odd:function(){return this.filter(function(t){return t%2==1})}});var Z;V.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},V.fn.labels=function(){var t,e,i;return this.length?this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(e=this.eq(0).parents("label"),(t=this.attr("id"))&&(i=(i=this.eq(0).parents().last()).add((i.length?i:this).siblings()),t="label[for='"+V.escapeSelector(t)+"']",e=e.add(i.find(t).addBack(t))),this.pushStack(e)):this.pushStack([])},V.fn.scrollParent=function(t){var e=this.css("position"),i="absolute"===e,s=t?/(auto|scroll|hidden)/:/(auto|scroll)/,t=this.parents().filter(function(){var t=V(this);return(!i||"static"!==t.css("position"))&&s.test(t.css("overflow")+t.css("overflow-y")+t.css("overflow-x"))}).eq(0);return"fixed"!==e&&t.length?t:V(this[0].ownerDocument||document)},V.extend(V.expr.pseudos,{tabbable:function(t){var e=V.attr(t,"tabindex"),i=null!=e;return(!i||0<=e)&&V.ui.focusable(t,i)}}),V.fn.extend({uniqueId:(Z=0,function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++Z)})}),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&V(this).removeAttr("id")})}}),V.widget("ui.accordion",{version:"1.13.2",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:function(t){return t.find("> li > :first-child").add(t.find("> :not(li)").even())},heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var t=this.options;this.prevShow=this.prevHide=V(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),t.collapsible||!1!==t.active&&null!=t.active||(t.active=0),this._processPanels(),t.active<0&&(t.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():V()}},_createIcons:function(){var t,e=this.options.icons;e&&(t=V("<span>"),this._addClass(t,"ui-accordion-header-icon","ui-icon "+e.header),t.prependTo(this.headers),t=this.active.children(".ui-accordion-header-icon"),this._removeClass(t,e.header)._addClass(t,null,e.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){"active"!==t?("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||!1!==this.options.active||this._activate(0),"icons"===t&&(this._destroyIcons(),e&&this._createIcons())):this._activate(e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t),this._toggleClass(this.headers.add(this.headers.next()),null,"ui-state-disabled",!!t)},_keydown:function(t){if(!t.altKey&&!t.ctrlKey){var e=V.ui.keyCode,i=this.headers.length,s=this.headers.index(t.target),n=!1;switch(t.keyCode){case e.RIGHT:case e.DOWN:n=this.headers[(s+1)%i];break;case e.LEFT:case e.UP:n=this.headers[(s-1+i)%i];break;case e.SPACE:case e.ENTER:this._eventHandler(t);break;case e.HOME:n=this.headers[0];break;case e.END:n=this.headers[i-1]}n&&(V(t.target).attr("tabIndex",-1),V(n).attr("tabIndex",0),V(n).trigger("focus"),t.preventDefault())}},_panelKeyDown:function(t){t.keyCode===V.ui.keyCode.UP&&t.ctrlKey&&V(t.currentTarget).prev().trigger("focus")},refresh:function(){var t=this.options;this._processPanels(),!1===t.active&&!0===t.collapsible||!this.headers.length?(t.active=!1,this.active=V()):!1===t.active?this._activate(0):this.active.length&&!V.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(t.active=!1,this.active=V()):this._activate(Math.max(0,t.active-1)):t.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var t=this.headers,e=this.panels;"function"==typeof this.options.header?this.headers=this.options.header(this.element):this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),e&&(this._off(t.not(this.headers)),this._off(e.not(this.panels)))},_refresh:function(){var i,t=this.options,e=t.heightStyle,s=this.element.parent();this.active=this._findActive(t.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var t=V(this),e=t.uniqueId().attr("id"),i=t.next(),s=i.uniqueId().attr("id");t.attr("aria-controls",s),i.attr("aria-labelledby",e)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(t.event),"fill"===e?(i=s.height(),this.element.siblings(":visible").each(function(){var t=V(this),e=t.css("position");"absolute"!==e&&"fixed"!==e&&(i-=t.outerHeight(!0))}),this.headers.each(function(){i-=V(this).outerHeight(!0)}),this.headers.next().each(function(){V(this).height(Math.max(0,i-V(this).innerHeight()+V(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.headers.next().each(function(){var t=V(this).is(":visible");t||V(this).show(),i=Math.max(i,V(this).css("height","").height()),t||V(this).hide()}).height(i))},_activate:function(t){t=this._findActive(t)[0];t!==this.active[0]&&(t=t||this.active[0],this._eventHandler({target:t,currentTarget:t,preventDefault:V.noop}))},_findActive:function(t){return"number"==typeof t?this.headers.eq(t):V()},_setupEvents:function(t){var i={keydown:"_keydown"};t&&V.each(t.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(t){var e=this.options,i=this.active,s=V(t.currentTarget),n=s[0]===i[0],o=n&&e.collapsible,a=o?V():s.next(),r=i.next(),a={oldHeader:i,oldPanel:r,newHeader:o?V():s,newPanel:a};t.preventDefault(),n&&!e.collapsible||!1===this._trigger("beforeActivate",t,a)||(e.active=!o&&this.headers.index(s),this.active=n?V():s,this._toggle(a),this._removeClass(i,"ui-accordion-header-active","ui-state-active"),e.icons&&(i=i.children(".ui-accordion-header-icon"),this._removeClass(i,null,e.icons.activeHeader)._addClass(i,null,e.icons.header)),n||(this._removeClass(s,"ui-accordion-header-collapsed")._addClass(s,"ui-accordion-header-active","ui-state-active"),e.icons&&(n=s.children(".ui-accordion-header-icon"),this._removeClass(n,null,e.icons.header)._addClass(n,null,e.icons.activeHeader)),this._addClass(s.next(),"ui-accordion-content-active")))},_toggle:function(t){var e=t.newPanel,i=this.prevShow.length?this.prevShow:t.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=e,this.prevHide=i,this.options.animate?this._animate(e,i,t):(i.hide(),e.show(),this._toggleComplete(t)),i.attr({"aria-hidden":"true"}),i.prev().attr({"aria-selected":"false","aria-expanded":"false"}),e.length&&i.length?i.prev().attr({tabIndex:-1,"aria-expanded":"false"}):e.length&&this.headers.filter(function(){return 0===parseInt(V(this).attr("tabIndex"),10)}).attr("tabIndex",-1),e.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(t,i,e){var s,n,o,a=this,r=0,l=t.css("box-sizing"),h=t.length&&(!i.length||t.index()<i.index()),c=this.options.animate||{},u=h&&c.down||c,h=function(){a._toggleComplete(e)};return n=(n="string"==typeof u?u:n)||u.easing||c.easing,o=(o="number"==typeof u?u:o)||u.duration||c.duration,i.length?t.length?(s=t.show().outerHeight(),i.animate(this.hideProps,{duration:o,easing:n,step:function(t,e){e.now=Math.round(t)}}),void t.hide().animate(this.showProps,{duration:o,easing:n,complete:h,step:function(t,e){e.now=Math.round(t),"height"!==e.prop?"content-box"===l&&(r+=e.now):"content"!==a.options.heightStyle&&(e.now=Math.round(s-i.outerHeight()-r),r=0)}})):i.animate(this.hideProps,o,n,h):t.animate(this.showProps,o,n,h)},_toggleComplete:function(t){var e=t.oldPanel,i=e.prev();this._removeClass(e,"ui-accordion-content-active"),this._removeClass(i,"ui-accordion-header-active")._addClass(i,"ui-accordion-header-collapsed"),e.length&&(e.parent()[0].className=e.parent()[0].className),this._trigger("activate",null,t)}}),V.ui.safeActiveElement=function(e){var i;try{i=e.activeElement}catch(t){i=e.body}return i=!(i=i||e.body).nodeName?e.body:i},V.widget("ui.menu",{version:"1.13.2",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.lastMousePosition={x:null,y:null},this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(t){t.preventDefault(),this._activateItem(t)},"click .ui-menu-item":function(t){var e=V(t.target),i=V(V.ui.safeActiveElement(this.document[0]));!this.mouseHandled&&e.not(".ui-state-disabled").length&&(this.select(t),t.isPropagationStopped()||(this.mouseHandled=!0),e.has(".ui-menu").length?this.expand(t):!this.element.is(":focus")&&i.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":"_activateItem","mousemove .ui-menu-item":"_activateItem",mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this._menuItems().first();e||this.focus(t,i)},blur:function(t){this._delay(function(){V.contains(this.element[0],V.ui.safeActiveElement(this.document[0]))||this.collapseAll(t)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){this._closeOnDocumentClick(t)&&this.collapseAll(t,!0),this.mouseHandled=!1}})},_activateItem:function(t){var e,i;this.previousFilter||t.clientX===this.lastMousePosition.x&&t.clientY===this.lastMousePosition.y||(this.lastMousePosition={x:t.clientX,y:t.clientY},e=V(t.target).closest(".ui-menu-item"),i=V(t.currentTarget),e[0]===i[0]&&(i.is(".ui-state-active")||(this._removeClass(i.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(t,i))))},_destroy:function(){var t=this.element.find(".ui-menu-item").removeAttr("role aria-disabled").children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),t.children().each(function(){var t=V(this);t.data("ui-menu-submenu-caret")&&t.remove()})},_keydown:function(t){var e,i,s,n=!0;switch(t.keyCode){case V.ui.keyCode.PAGE_UP:this.previousPage(t);break;case V.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case V.ui.keyCode.HOME:this._move("first","first",t);break;case V.ui.keyCode.END:this._move("last","last",t);break;case V.ui.keyCode.UP:this.previous(t);break;case V.ui.keyCode.DOWN:this.next(t);break;case V.ui.keyCode.LEFT:this.collapse(t);break;case V.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(t);break;case V.ui.keyCode.ENTER:case V.ui.keyCode.SPACE:this._activate(t);break;case V.ui.keyCode.ESCAPE:this.collapse(t);break;default:e=this.previousFilter||"",s=n=!1,i=96<=t.keyCode&&t.keyCode<=105?(t.keyCode-96).toString():String.fromCharCode(t.keyCode),clearTimeout(this.filterTimer),i===e?s=!0:i=e+i,e=this._filterMenuItems(i),(e=s&&-1!==e.index(this.active.next())?this.active.nextAll(".ui-menu-item"):e).length||(i=String.fromCharCode(t.keyCode),e=this._filterMenuItems(i)),e.length?(this.focus(t,e),this.previousFilter=i,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}n&&t.preventDefault()},_activate:function(t){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var t,e,s=this,n=this.options.icons.submenu,i=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),e=i.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var t=V(this),e=t.prev(),i=V("<span>").data("ui-menu-submenu-caret",!0);s._addClass(i,"ui-menu-icon","ui-icon "+n),e.attr("aria-haspopup","true").prepend(i),t.attr("aria-labelledby",e.attr("id"))}),this._addClass(e,"ui-menu","ui-widget ui-widget-content ui-front"),(t=i.add(this.element).find(this.options.items)).not(".ui-menu-item").each(function(){var t=V(this);s._isDivider(t)&&s._addClass(t,"ui-menu-divider","ui-widget-content")}),i=(e=t.not(".ui-menu-item, .ui-menu-divider")).children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(e,"ui-menu-item")._addClass(i,"ui-menu-item-wrapper"),t.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!V.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){var i;"icons"===t&&(i=this.element.find(".ui-menu-icon"),this._removeClass(i,null,this.options.icons.submenu)._addClass(i,null,e.submenu)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",String(t)),this._toggleClass(null,"ui-state-disabled",!!t)},focus:function(t,e){var i;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),i=this.active.children(".ui-menu-item-wrapper"),this._addClass(i,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",i.attr("id")),i=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(i,null,"ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),(i=e.children(".ui-menu")).length&&t&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(t){var e,i,s;this._hasScroll()&&(i=parseFloat(V.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(V.css(this.activeMenu[0],"paddingTop"))||0,e=t.offset().top-this.activeMenu.offset().top-i-s,i=this.activeMenu.scrollTop(),s=this.activeMenu.height(),t=t.outerHeight(),e<0?this.activeMenu.scrollTop(i+e):s<e+t&&this.activeMenu.scrollTop(i+e-s+t))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",t,{item:this.active}),this.active=null)},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(t){var e=V.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden","true"),t.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(e)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var t=i?this.element:V(e&&e.target).closest(this.element.find(".ui-menu"));t.length||(t=this.element),this._close(t),this.blur(e),this._removeClass(t.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=t},i?0:this.delay)},_close:function(t){(t=t||(this.active?this.active.parent():this.element)).find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(t){return!V(t.target).closest(".ui-menu").length},_isDivider:function(t){return!/[^\-\u2014\u2013\s]/.test(t.text())},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this._menuItems(this.active.children(".ui-menu")).first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_menuItems:function(t){return(t||this.element).find(this.options.items).filter(".ui-menu-item")},_move:function(t,e,i){var s;(s=this.active?"first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").last():this.active[t+"All"](".ui-menu-item").first():s)&&s.length&&this.active||(s=this._menuItems(this.activeMenu)[e]()),this.focus(i,s)},nextPage:function(t){var e,i,s;this.active?this.isLastItem()||(this._hasScroll()?(i=this.active.offset().top,s=this.element.innerHeight(),0===V.fn.jquery.indexOf("3.2.")&&(s+=this.element[0].offsetHeight-this.element.outerHeight()),this.active.nextAll(".ui-menu-item").each(function(){return(e=V(this)).offset().top-i-s<0}),this.focus(t,e)):this.focus(t,this._menuItems(this.activeMenu)[this.active?"last":"first"]())):this.next(t)},previousPage:function(t){var e,i,s;this.active?this.isFirstItem()||(this._hasScroll()?(i=this.active.offset().top,s=this.element.innerHeight(),0===V.fn.jquery.indexOf("3.2.")&&(s+=this.element[0].offsetHeight-this.element.outerHeight()),this.active.prevAll(".ui-menu-item").each(function(){return 0<(e=V(this)).offset().top-i+s}),this.focus(t,e)):this.focus(t,this._menuItems(this.activeMenu).first())):this.next(t)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(t){this.active=this.active||V(t.target).closest(".ui-menu-item");var e={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(t,!0),this._trigger("select",t,e)},_filterMenuItems:function(t){var t=t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),e=new RegExp("^"+t,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return e.test(String.prototype.trim.call(V(this).children(".ui-menu-item-wrapper").text()))})}});V.widget("ui.autocomplete",{version:"1.13.2",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,liveRegionTimer:null,_create:function(){var i,s,n,t=this.element[0].nodeName.toLowerCase(),e="textarea"===t,t="input"===t;this.isMultiLine=e||!t&&this._isContentEditable(this.element),this.valueMethod=this.element[e||t?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(t){if(this.element.prop("readOnly"))s=n=i=!0;else{s=n=i=!1;var e=V.ui.keyCode;switch(t.keyCode){case e.PAGE_UP:i=!0,this._move("previousPage",t);break;case e.PAGE_DOWN:i=!0,this._move("nextPage",t);break;case e.UP:i=!0,this._keyEvent("previous",t);break;case e.DOWN:i=!0,this._keyEvent("next",t);break;case e.ENTER:this.menu.active&&(i=!0,t.preventDefault(),this.menu.select(t));break;case e.TAB:this.menu.active&&this.menu.select(t);break;case e.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(t),t.preventDefault());break;default:s=!0,this._searchTimeout(t)}}},keypress:function(t){if(i)return i=!1,void(this.isMultiLine&&!this.menu.element.is(":visible")||t.preventDefault());if(!s){var e=V.ui.keyCode;switch(t.keyCode){case e.PAGE_UP:this._move("previousPage",t);break;case e.PAGE_DOWN:this._move("nextPage",t);break;case e.UP:this._keyEvent("previous",t);break;case e.DOWN:this._keyEvent("next",t)}}},input:function(t){if(n)return n=!1,void t.preventDefault();this._searchTimeout(t)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){clearTimeout(this.searching),this.close(t),this._change(t)}}),this._initSource(),this.menu=V("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().attr({unselectable:"on"}).menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault()},menufocus:function(t,e){var i,s;if(this.isNewMenu&&(this.isNewMenu=!1,t.originalEvent&&/^mouse/.test(t.originalEvent.type)))return this.menu.blur(),void this.document.one("mousemove",function(){V(t.target).trigger(t.originalEvent)});s=e.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",t,{item:s})&&t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(s.value),(i=e.item.attr("aria-label")||s.value)&&String.prototype.trim.call(i).length&&(clearTimeout(this.liveRegionTimer),this.liveRegionTimer=this._delay(function(){this.liveRegion.html(V("<div>").text(i))},100))},menuselect:function(t,e){var i=e.item.data("ui-autocomplete-item"),s=this.previous;this.element[0]!==V.ui.safeActiveElement(this.document[0])&&(this.element.trigger("focus"),this.previous=s,this._delay(function(){this.previous=s,this.selectedItem=i})),!1!==this._trigger("select",t,{item:i})&&this._value(i.value),this.term=this._value(),this.close(t),this.selectedItem=i}}),this.liveRegion=V("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(t){var e=this.menu.element[0];return t.target===this.element[0]||t.target===e||V.contains(e,t.target)},_closeOnClickOutside:function(t){this._isEventTargetInWidget(t)||this.close()},_appendTo:function(){var t=this.options.appendTo;return t=!(t=!(t=t&&(t.jquery||t.nodeType?V(t):this.document.find(t).eq(0)))||!t[0]?this.element.closest(".ui-front, dialog"):t).length?this.document[0].body:t},_initSource:function(){var i,s,n=this;Array.isArray(this.options.source)?(i=this.options.source,this.source=function(t,e){e(V.ui.autocomplete.filter(i,t.term))}):"string"==typeof this.options.source?(s=this.options.source,this.source=function(t,e){n.xhr&&n.xhr.abort(),n.xhr=V.ajax({url:s,data:t,dataType:"json",success:function(t){e(t)},error:function(){e([])}})}):this.source=this.options.source},_searchTimeout:function(s){clearTimeout(this.searching),this.searching=this._delay(function(){var t=this.term===this._value(),e=this.menu.element.is(":visible"),i=s.altKey||s.ctrlKey||s.metaKey||s.shiftKey;t&&(e||i)||(this.selectedItem=null,this.search(null,s))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):!1!==this._trigger("search",e)?this._search(t):void 0},_search:function(t){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var e=++this.requestIndex;return function(t){e===this.requestIndex&&this.__response(t),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")}.bind(this)},__response:function(t){t=t&&this._normalize(t),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:V.map(t,function(t){return"string"==typeof t?{label:t,value:t}:V.extend({},t,{label:t.label||t.value,value:t.value||t.label})})},_suggest:function(t){var e=this.menu.element.empty();this._renderMenu(e,t),this.isNewMenu=!0,this.menu.refresh(),e.show(),this._resizeMenu(),e.position(V.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(i,t){var s=this;V.each(t,function(t,e){s._renderItemData(i,e)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(t,e){return V("<li>").append(V("<div>").text(e.label)).appendTo(t)},_move:function(t,e){if(this.menu.element.is(":visible"))return this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this.isMultiLine||this._value(this.term),void this.menu.blur()):void this.menu[t](e);this.search(null,e)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){this.isMultiLine&&!this.menu.element.is(":visible")||(this._move(t,e),e.preventDefault())},_isContentEditable:function(t){if(!t.length)return!1;var e=t.prop("contentEditable");return"inherit"===e?this._isContentEditable(t.parent()):"true"===e}}),V.extend(V.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,e){var i=new RegExp(V.ui.autocomplete.escapeRegex(e),"i");return V.grep(t,function(t){return i.test(t.label||t.value||t)})}}),V.widget("ui.autocomplete",V.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(1<t?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(t){var e;this._superApply(arguments),this.options.disabled||this.cancelSearch||(e=t&&t.length?this.options.messages.results(t.length):this.options.messages.noResults,clearTimeout(this.liveRegionTimer),this.liveRegionTimer=this._delay(function(){this.liveRegion.html(V("<div>").text(e))},100))}});V.ui.autocomplete;var tt=/ui-corner-([a-z]){2,6}/g;V.widget("ui.controlgroup",{version:"1.13.2",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var o=this,a=[];V.each(this.options.items,function(s,t){var e,n={};if(t)return"controlgroupLabel"===s?((e=o.element.find(t)).each(function(){var t=V(this);t.children(".ui-controlgroup-label-contents").length||t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),o._addClass(e,null,"ui-widget ui-widget-content ui-state-default"),void(a=a.concat(e.get()))):void(V.fn[s]&&(n=o["_"+s+"Options"]?o["_"+s+"Options"]("middle"):{classes:{}},o.element.find(t).each(function(){var t=V(this),e=t[s]("instance"),i=V.widget.extend({},n);"button"===s&&t.parent(".ui-spinner").length||((e=e||t[s]()[s]("instance"))&&(i.classes=o._resolveClassesValues(i.classes,e)),t[s](i),i=t[s]("widget"),V.data(i[0],"ui-controlgroup-data",e||t[s]("instance")),a.push(i[0]))})))}),this.childWidgets=V(V.uniqueSort(a)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(e){this.childWidgets.each(function(){var t=V(this).data("ui-controlgroup-data");t&&t[e]&&t[e]()})},_updateCornerClass:function(t,e){e=this._buildSimpleOptions(e,"label").classes.label;this._removeClass(t,null,"ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all"),this._addClass(t,null,e)},_buildSimpleOptions:function(t,e){var i="vertical"===this.options.direction,s={classes:{}};return s.classes[e]={middle:"",first:"ui-corner-"+(i?"top":"left"),last:"ui-corner-"+(i?"bottom":"right"),only:"ui-corner-all"}[t],s},_spinnerOptions:function(t){t=this._buildSimpleOptions(t,"ui-spinner");return t.classes["ui-spinner-up"]="",t.classes["ui-spinner-down"]="",t},_buttonOptions:function(t){return this._buildSimpleOptions(t,"ui-button")},_checkboxradioOptions:function(t){return this._buildSimpleOptions(t,"ui-checkboxradio-label")},_selectmenuOptions:function(t){var e="vertical"===this.options.direction;return{width:e&&"auto",classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(e?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(e?"top":"left")},last:{"ui-selectmenu-button-open":e?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(e?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[t]}},_resolveClassesValues:function(i,s){var n={};return V.each(i,function(t){var e=s.options.classes[t]||"",e=String.prototype.trim.call(e.replace(tt,""));n[t]=(e+" "+i[t]).replace(/\s+/g," ")}),n},_setOption:function(t,e){"direction"===t&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(t,e),"disabled"!==t?this.refresh():this._callChildMethod(e?"disable":"enable")},refresh:function(){var n,o=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),n=this.childWidgets,(n=this.options.onlyVisible?n.filter(":visible"):n).length&&(V.each(["first","last"],function(t,e){var i,s=n[e]().data("ui-controlgroup-data");s&&o["_"+s.widgetName+"Options"]?((i=o["_"+s.widgetName+"Options"](1===n.length?"only":e)).classes=o._resolveClassesValues(i.classes,s),s.element[s.widgetName](i)):o._updateCornerClass(n[e](),e)}),this._callChildMethod("refresh"))}});V.widget("ui.checkboxradio",[V.ui.formResetMixin,{version:"1.13.2",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var t,e=this._super()||{};return this._readType(),t=this.element.labels(),this.label=V(t[t.length-1]),this.label.length||V.error("No label found for checkboxradio widget"),this.originalLabel="",(t=this.label.contents().not(this.element[0])).length&&(this.originalLabel+=t.clone().wrapAll("<div></div>").parent().html()),this.originalLabel&&(e.label=this.originalLabel),null!=(t=this.element[0].disabled)&&(e.disabled=t),e},_create:function(){var t=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),t&&this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var t=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===t&&/radio|checkbox/.test(this.type)||V.error("Can't create checkboxradio on element.nodeName="+t+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var t=this.element[0].name,e="input[name='"+V.escapeSelector(t)+"']";return t?(this.form.length?V(this.form[0].elements).filter(e):V(e).filter(function(){return 0===V(this)._form().length})).not(this.element):V([])},_toggleClasses:function(){var t=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",t)._toggleClass(this.icon,null,"ui-icon-blank",!t),"radio"===this.type&&this._getRadioGroup().each(function(){var t=V(this).checkboxradio("instance");t&&t._removeClass(t.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(t,e){if("label"!==t||e){if(this._super(t,e),"disabled"===t)return this._toggleClass(this.label,null,"ui-state-disabled",e),void(this.element[0].disabled=e);this.refresh()}},_updateIcon:function(t){var e="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=V("<span>"),this.iconSpace=V("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(e+=t?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,t?"ui-icon-blank":"ui-icon-check")):e+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",e),t||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){var t=this.label.contents().not(this.element[0]);this.icon&&(t=t.not(this.icon[0])),(t=this.iconSpace?t.not(this.iconSpace[0]):t).remove(),this.label.append(this.options.label)},refresh:function(){var t=this.element[0].checked,e=this.element[0].disabled;this._updateIcon(t),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),null!==this.options.label&&this._updateLabel(),e!==this.options.disabled&&this._setOptions({disabled:e})}}]);var et;V.ui.checkboxradio;V.widget("ui.button",{version:"1.13.2",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var t,e=this._super()||{};return this.isInput=this.element.is("input"),null!=(t=this.element[0].disabled)&&(e.disabled=t),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(e.label=this.originalLabel),e},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(t){t.keyCode===V.ui.keyCode.SPACE&&(t.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(t,e){var i="iconPosition"!==t,s=i?this.options.iconPosition:e,t="top"===s||"bottom"===s;this.icon?i&&this._removeClass(this.icon,null,this.options.icon):(this.icon=V("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),i&&this._addClass(this.icon,null,e),this._attachIcon(s),t?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=V("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(s))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")},_attachIconSpace:function(t){this.icon[/^(?:end|bottom)/.test(t)?"before":"after"](this.iconSpace)},_attachIcon:function(t){this.element[/^(?:end|bottom)/.test(t)?"append":"prepend"](this.icon)},_setOptions:function(t){var e=(void 0===t.showLabel?this.options:t).showLabel,i=(void 0===t.icon?this.options:t).icon;e||i||(t.showLabel=!0),this._super(t)},_setOption:function(t,e){"icon"===t&&(e?this._updateIcon(t,e):this.icon&&(this.icon.remove(),this.iconSpace&&this.iconSpace.remove())),"iconPosition"===t&&this._updateIcon(t,e),"showLabel"===t&&(this._toggleClass("ui-button-icon-only",null,!e),this._updateTooltip()),"label"===t&&(this.isInput?this.element.val(e):(this.element.html(e),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(t,e),"disabled"===t&&(this._toggleClass(null,"ui-state-disabled",e),(this.element[0].disabled=e)&&this.element.trigger("blur"))},refresh:function(){var t=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOptions({disabled:t}),this._updateTooltip()}}),!1!==V.uiBackCompat&&(V.widget("ui.button",V.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(t,e){"text"!==t?("showLabel"===t&&(this.options.text=e),"icon"===t&&(this.options.icons.primary=e),"icons"===t&&(e.primary?(this._super("icon",e.primary),this._super("iconPosition","beginning")):e.secondary&&(this._super("icon",e.secondary),this._super("iconPosition","end"))),this._superApply(arguments)):this._super("showLabel",e)}}),V.fn.button=(et=V.fn.button,function(i){var t="string"==typeof i,s=Array.prototype.slice.call(arguments,1),n=this;return t?this.length||"instance"!==i?this.each(function(){var t=V(this).attr("type"),e=V.data(this,"ui-"+("checkbox"!==t&&"radio"!==t?"button":"checkboxradio"));return"instance"===i?(n=e,!1):e?"function"!=typeof e[i]||"_"===i.charAt(0)?V.error("no such method '"+i+"' for button widget instance"):(t=e[i].apply(e,s))!==e&&void 0!==t?(n=t&&t.jquery?n.pushStack(t.get()):t,!1):void 0:V.error("cannot call methods on button prior to initialization; attempted to call method '"+i+"'")}):n=void 0:(s.length&&(i=V.widget.extend.apply(null,[i].concat(s))),this.each(function(){var t=V(this).attr("type"),e="checkbox"!==t&&"radio"!==t?"button":"checkboxradio",t=V.data(this,"ui-"+e);t?(t.option(i||{}),t._init&&t._init()):"button"!=e?V(this).checkboxradio(V.extend({icon:!1},i)):et.call(V(this),i)})),n}),V.fn.buttonset=function(){return V.ui.controlgroup||V.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))});var it;V.ui.button;function st(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:"",selectMonthLabel:"Select month",selectYearLabel:"Select year"},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,onUpdateDatepicker:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},V.extend(this._defaults,this.regional[""]),this.regional.en=V.extend(!0,{},this.regional[""]),this.regional["en-US"]=V.extend(!0,{},this.regional.en),this.dpDiv=nt(V("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function nt(t){var e="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.on("mouseout",e,function(){V(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&V(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&V(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",e,ot)}function ot(){V.datepicker._isDisabledDatepicker((it.inline?it.dpDiv.parent():it.input)[0])||(V(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),V(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&V(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&V(this).addClass("ui-datepicker-next-hover"))}function at(t,e){for(var i in V.extend(t,e),e)null==e[i]&&(t[i]=e[i]);return t}V.extend(V.ui,{datepicker:{version:"1.13.2"}}),V.extend(st.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return at(this._defaults,t||{}),this},_attachDatepicker:function(t,e){var i,s=t.nodeName.toLowerCase(),n="div"===s||"span"===s;t.id||(this.uuid+=1,t.id="dp"+this.uuid),(i=this._newInst(V(t),n)).settings=V.extend({},e||{}),"input"===s?this._connectDatepicker(t,i):n&&this._inlineDatepicker(t,i)},_newInst:function(t,e){return{id:t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1"),input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:e,dpDiv:e?nt(V("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,e){var i=V(t);e.append=V([]),e.trigger=V([]),i.hasClass(this.markerClassName)||(this._attachments(i,e),i.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(e),V.data(t,"datepicker",e),e.settings.disabled&&this._disableDatepicker(t))},_attachments:function(t,e){var i,s=this._get(e,"appendText"),n=this._get(e,"isRTL");e.append&&e.append.remove(),s&&(e.append=V("<span>").addClass(this._appendClass).text(s),t[n?"before":"after"](e.append)),t.off("focus",this._showDatepicker),e.trigger&&e.trigger.remove(),"focus"!==(i=this._get(e,"showOn"))&&"both"!==i||t.on("focus",this._showDatepicker),"button"!==i&&"both"!==i||(s=this._get(e,"buttonText"),i=this._get(e,"buttonImage"),this._get(e,"buttonImageOnly")?e.trigger=V("<img>").addClass(this._triggerClass).attr({src:i,alt:s,title:s}):(e.trigger=V("<button type='button'>").addClass(this._triggerClass),i?e.trigger.html(V("<img>").attr({src:i,alt:s,title:s})):e.trigger.text(s)),t[n?"before":"after"](e.trigger),e.trigger.on("click",function(){return V.datepicker._datepickerShowing&&V.datepicker._lastInput===t[0]?V.datepicker._hideDatepicker():(V.datepicker._datepickerShowing&&V.datepicker._lastInput!==t[0]&&V.datepicker._hideDatepicker(),V.datepicker._showDatepicker(t[0])),!1}))},_autoSize:function(t){var e,i,s,n,o,a;this._get(t,"autoSize")&&!t.inline&&(o=new Date(2009,11,20),(a=this._get(t,"dateFormat")).match(/[DM]/)&&(e=function(t){for(n=s=i=0;n<t.length;n++)t[n].length>i&&(i=t[n].length,s=n);return s},o.setMonth(e(this._get(t,a.match(/MM/)?"monthNames":"monthNamesShort"))),o.setDate(e(this._get(t,a.match(/DD/)?"dayNames":"dayNamesShort"))+20-o.getDay())),t.input.attr("size",this._formatDate(t,o).length))},_inlineDatepicker:function(t,e){var i=V(t);i.hasClass(this.markerClassName)||(i.addClass(this.markerClassName).append(e.dpDiv),V.data(t,"datepicker",e),this._setDate(e,this._getDefaultDate(e),!0),this._updateDatepicker(e),this._updateAlternate(e),e.settings.disabled&&this._disableDatepicker(t),e.dpDiv.css("display","block"))},_dialogDatepicker:function(t,e,i,s,n){var o,a=this._dialogInst;return a||(this.uuid+=1,o="dp"+this.uuid,this._dialogInput=V("<input type='text' id='"+o+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),V("body").append(this._dialogInput),(a=this._dialogInst=this._newInst(this._dialogInput,!1)).settings={},V.data(this._dialogInput[0],"datepicker",a)),at(a.settings,s||{}),e=e&&e.constructor===Date?this._formatDate(a,e):e,this._dialogInput.val(e),this._pos=n?n.length?n:[n.pageX,n.pageY]:null,this._pos||(o=document.documentElement.clientWidth,s=document.documentElement.clientHeight,e=document.documentElement.scrollLeft||document.body.scrollLeft,n=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[o/2-100+e,s/2-150+n]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),a.settings.onSelect=i,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),V.blockUI&&V.blockUI(this.dpDiv),V.data(this._dialogInput[0],"datepicker",a),this},_destroyDatepicker:function(t){var e,i=V(t),s=V.data(t,"datepicker");i.hasClass(this.markerClassName)&&(e=t.nodeName.toLowerCase(),V.removeData(t,"datepicker"),"input"===e?(s.append.remove(),s.trigger.remove(),i.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):"div"!==e&&"span"!==e||i.removeClass(this.markerClassName).empty(),it===s&&(it=null,this._curInst=null))},_enableDatepicker:function(e){var t,i=V(e),s=V.data(e,"datepicker");i.hasClass(this.markerClassName)&&("input"===(t=e.nodeName.toLowerCase())?(e.disabled=!1,s.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==t&&"span"!==t||((i=i.children("."+this._inlineClass)).children().removeClass("ui-state-disabled"),i.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=V.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var t,i=V(e),s=V.data(e,"datepicker");i.hasClass(this.markerClassName)&&("input"===(t=e.nodeName.toLowerCase())?(e.disabled=!0,s.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==t&&"span"!==t||((i=i.children("."+this._inlineClass)).children().addClass("ui-state-disabled"),i.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=V.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(!t)return!1;for(var e=0;e<this._disabledInputs.length;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(t){try{return V.data(t,"datepicker")}catch(t){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(t,e,i){var s,n,o=this._getInst(t);if(2===arguments.length&&"string"==typeof e)return"defaults"===e?V.extend({},V.datepicker._defaults):o?"all"===e?V.extend({},o.settings):this._get(o,e):null;s=e||{},"string"==typeof e&&((s={})[e]=i),o&&(this._curInst===o&&this._hideDatepicker(),n=this._getDateDatepicker(t,!0),e=this._getMinMaxDate(o,"min"),i=this._getMinMaxDate(o,"max"),at(o.settings,s),null!==e&&void 0!==s.dateFormat&&void 0===s.minDate&&(o.settings.minDate=this._formatDate(o,e)),null!==i&&void 0!==s.dateFormat&&void 0===s.maxDate&&(o.settings.maxDate=this._formatDate(o,i)),"disabled"in s&&(s.disabled?this._disableDatepicker(t):this._enableDatepicker(t)),this._attachments(V(t),o),this._autoSize(o),this._setDate(o,n),this._updateAlternate(o),this._updateDatepicker(o))},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){t=this._getInst(t);t&&this._updateDatepicker(t)},_setDateDatepicker:function(t,e){t=this._getInst(t);t&&(this._setDate(t,e),this._updateDatepicker(t),this._updateAlternate(t))},_getDateDatepicker:function(t,e){t=this._getInst(t);return t&&!t.inline&&this._setDateFromField(t,e),t?this._getDate(t):null},_doKeyDown:function(t){var e,i,s=V.datepicker._getInst(t.target),n=!0,o=s.dpDiv.is(".ui-datepicker-rtl");if(s._keyEvent=!0,V.datepicker._datepickerShowing)switch(t.keyCode){case 9:V.datepicker._hideDatepicker(),n=!1;break;case 13:return(i=V("td."+V.datepicker._dayOverClass+":not(."+V.datepicker._currentClass+")",s.dpDiv))[0]&&V.datepicker._selectDay(t.target,s.selectedMonth,s.selectedYear,i[0]),(e=V.datepicker._get(s,"onSelect"))?(i=V.datepicker._formatDate(s),e.apply(s.input?s.input[0]:null,[i,s])):V.datepicker._hideDatepicker(),!1;case 27:V.datepicker._hideDatepicker();break;case 33:V.datepicker._adjustDate(t.target,t.ctrlKey?-V.datepicker._get(s,"stepBigMonths"):-V.datepicker._get(s,"stepMonths"),"M");break;case 34:V.datepicker._adjustDate(t.target,t.ctrlKey?+V.datepicker._get(s,"stepBigMonths"):+V.datepicker._get(s,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&V.datepicker._clearDate(t.target),n=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&V.datepicker._gotoToday(t.target),n=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,o?1:-1,"D"),n=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&V.datepicker._adjustDate(t.target,t.ctrlKey?-V.datepicker._get(s,"stepBigMonths"):-V.datepicker._get(s,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,-7,"D"),n=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,o?-1:1,"D"),n=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&V.datepicker._adjustDate(t.target,t.ctrlKey?+V.datepicker._get(s,"stepBigMonths"):+V.datepicker._get(s,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,7,"D"),n=t.ctrlKey||t.metaKey;break;default:n=!1}else 36===t.keyCode&&t.ctrlKey?V.datepicker._showDatepicker(this):n=!1;n&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var e,i=V.datepicker._getInst(t.target);if(V.datepicker._get(i,"constrainInput"))return e=V.datepicker._possibleChars(V.datepicker._get(i,"dateFormat")),i=String.fromCharCode(null==t.charCode?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||i<" "||!e||-1<e.indexOf(i)},_doKeyUp:function(t){t=V.datepicker._getInst(t.target);if(t.input.val()!==t.lastVal)try{V.datepicker.parseDate(V.datepicker._get(t,"dateFormat"),t.input?t.input.val():null,V.datepicker._getFormatConfig(t))&&(V.datepicker._setDateFromField(t),V.datepicker._updateAlternate(t),V.datepicker._updateDatepicker(t))}catch(t){}return!0},_showDatepicker:function(t){var e,i,s,n;"input"!==(t=t.target||t).nodeName.toLowerCase()&&(t=V("input",t.parentNode)[0]),V.datepicker._isDisabledDatepicker(t)||V.datepicker._lastInput===t||(n=V.datepicker._getInst(t),V.datepicker._curInst&&V.datepicker._curInst!==n&&(V.datepicker._curInst.dpDiv.stop(!0,!0),n&&V.datepicker._datepickerShowing&&V.datepicker._hideDatepicker(V.datepicker._curInst.input[0])),!1!==(i=(s=V.datepicker._get(n,"beforeShow"))?s.apply(t,[t,n]):{})&&(at(n.settings,i),n.lastVal=null,V.datepicker._lastInput=t,V.datepicker._setDateFromField(n),V.datepicker._inDialog&&(t.value=""),V.datepicker._pos||(V.datepicker._pos=V.datepicker._findPos(t),V.datepicker._pos[1]+=t.offsetHeight),e=!1,V(t).parents().each(function(){return!(e|="fixed"===V(this).css("position"))}),s={left:V.datepicker._pos[0],top:V.datepicker._pos[1]},V.datepicker._pos=null,n.dpDiv.empty(),n.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),V.datepicker._updateDatepicker(n),s=V.datepicker._checkOffset(n,s,e),n.dpDiv.css({position:V.datepicker._inDialog&&V.blockUI?"static":e?"fixed":"absolute",display:"none",left:s.left+"px",top:s.top+"px"}),n.inline||(i=V.datepicker._get(n,"showAnim"),s=V.datepicker._get(n,"duration"),n.dpDiv.css("z-index",function(t){for(var e,i;t.length&&t[0]!==document;){if(("absolute"===(e=t.css("position"))||"relative"===e||"fixed"===e)&&(i=parseInt(t.css("zIndex"),10),!isNaN(i)&&0!==i))return i;t=t.parent()}return 0}(V(t))+1),V.datepicker._datepickerShowing=!0,V.effects&&V.effects.effect[i]?n.dpDiv.show(i,V.datepicker._get(n,"showOptions"),s):n.dpDiv[i||"show"](i?s:null),V.datepicker._shouldFocusInput(n)&&n.input.trigger("focus"),V.datepicker._curInst=n)))},_updateDatepicker:function(t){this.maxRows=4,(it=t).dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t);var e,i=this._getNumberOfMonths(t),s=i[1],n=t.dpDiv.find("."+this._dayOverClass+" a"),o=V.datepicker._get(t,"onUpdateDatepicker");0<n.length&&ot.apply(n.get(0)),t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),1<s&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",17*s+"em"),t.dpDiv[(1!==i[0]||1!==i[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===V.datepicker._curInst&&V.datepicker._datepickerShowing&&V.datepicker._shouldFocusInput(t)&&t.input.trigger("focus"),t.yearshtml&&(e=t.yearshtml,setTimeout(function(){e===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year").first().replaceWith(t.yearshtml),e=t.yearshtml=null},0)),o&&o.apply(t.input?t.input[0]:null,[t])},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&!t.input.is(":focus")},_checkOffset:function(t,e,i){var s=t.dpDiv.outerWidth(),n=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,a=t.input?t.input.outerHeight():0,r=document.documentElement.clientWidth+(i?0:V(document).scrollLeft()),l=document.documentElement.clientHeight+(i?0:V(document).scrollTop());return e.left-=this._get(t,"isRTL")?s-o:0,e.left-=i&&e.left===t.input.offset().left?V(document).scrollLeft():0,e.top-=i&&e.top===t.input.offset().top+a?V(document).scrollTop():0,e.left-=Math.min(e.left,e.left+s>r&&s<r?Math.abs(e.left+s-r):0),e.top-=Math.min(e.top,e.top+n>l&&n<l?Math.abs(n+a):0),e},_findPos:function(t){for(var e=this._getInst(t),i=this._get(e,"isRTL");t&&("hidden"===t.type||1!==t.nodeType||V.expr.pseudos.hidden(t));)t=t[i?"previousSibling":"nextSibling"];return[(e=V(t).offset()).left,e.top]},_hideDatepicker:function(t){var e,i,s=this._curInst;!s||t&&s!==V.data(t,"datepicker")||this._datepickerShowing&&(e=this._get(s,"showAnim"),i=this._get(s,"duration"),t=function(){V.datepicker._tidyDialog(s)},V.effects&&(V.effects.effect[e]||V.effects[e])?s.dpDiv.hide(e,V.datepicker._get(s,"showOptions"),i,t):s.dpDiv["slideDown"===e?"slideUp":"fadeIn"===e?"fadeOut":"hide"](e?i:null,t),e||t(),this._datepickerShowing=!1,(t=this._get(s,"onClose"))&&t.apply(s.input?s.input[0]:null,[s.input?s.input.val():"",s]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),V.blockUI&&(V.unblockUI(),V("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(t){var e;V.datepicker._curInst&&(e=V(t.target),t=V.datepicker._getInst(e[0]),(e[0].id===V.datepicker._mainDivId||0!==e.parents("#"+V.datepicker._mainDivId).length||e.hasClass(V.datepicker.markerClassName)||e.closest("."+V.datepicker._triggerClass).length||!V.datepicker._datepickerShowing||V.datepicker._inDialog&&V.blockUI)&&(!e.hasClass(V.datepicker.markerClassName)||V.datepicker._curInst===t)||V.datepicker._hideDatepicker())},_adjustDate:function(t,e,i){var s=V(t),t=this._getInst(s[0]);this._isDisabledDatepicker(s[0])||(this._adjustInstDate(t,e,i),this._updateDatepicker(t))},_gotoToday:function(t){var e=V(t),i=this._getInst(e[0]);this._get(i,"gotoCurrent")&&i.currentDay?(i.selectedDay=i.currentDay,i.drawMonth=i.selectedMonth=i.currentMonth,i.drawYear=i.selectedYear=i.currentYear):(t=new Date,i.selectedDay=t.getDate(),i.drawMonth=i.selectedMonth=t.getMonth(),i.drawYear=i.selectedYear=t.getFullYear()),this._notifyChange(i),this._adjustDate(e)},_selectMonthYear:function(t,e,i){var s=V(t),t=this._getInst(s[0]);t["selected"+("M"===i?"Month":"Year")]=t["draw"+("M"===i?"Month":"Year")]=parseInt(e.options[e.selectedIndex].value,10),this._notifyChange(t),this._adjustDate(s)},_selectDay:function(t,e,i,s){var n=V(t);V(s).hasClass(this._unselectableClass)||this._isDisabledDatepicker(n[0])||((n=this._getInst(n[0])).selectedDay=n.currentDay=parseInt(V("a",s).attr("data-date")),n.selectedMonth=n.currentMonth=e,n.selectedYear=n.currentYear=i,this._selectDate(t,this._formatDate(n,n.currentDay,n.currentMonth,n.currentYear)))},_clearDate:function(t){t=V(t);this._selectDate(t,"")},_selectDate:function(t,e){var i=V(t),t=this._getInst(i[0]);e=null!=e?e:this._formatDate(t),t.input&&t.input.val(e),this._updateAlternate(t),(i=this._get(t,"onSelect"))?i.apply(t.input?t.input[0]:null,[e,t]):t.input&&t.input.trigger("change"),t.inline?this._updateDatepicker(t):(this._hideDatepicker(),this._lastInput=t.input[0],"object"!=typeof t.input[0]&&t.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(t){var e,i,s=this._get(t,"altField");s&&(e=this._get(t,"altFormat")||this._get(t,"dateFormat"),i=this._getDate(t),t=this.formatDate(e,i,this._getFormatConfig(t)),V(document).find(s).val(t))},noWeekends:function(t){t=t.getDay();return[0<t&&t<6,""]},iso8601Week:function(t){var e=new Date(t.getTime());return e.setDate(e.getDate()+4-(e.getDay()||7)),t=e.getTime(),e.setMonth(0),e.setDate(1),Math.floor(Math.round((t-e)/864e5)/7)+1},parseDate:function(e,n,t){if(null==e||null==n)throw"Invalid arguments";if(""===(n="object"==typeof n?n.toString():n+""))return null;for(var i,s,o,a=0,r=(t?t.shortYearCutoff:null)||this._defaults.shortYearCutoff,r="string"!=typeof r?r:(new Date).getFullYear()%100+parseInt(r,10),l=(t?t.dayNamesShort:null)||this._defaults.dayNamesShort,h=(t?t.dayNames:null)||this._defaults.dayNames,c=(t?t.monthNamesShort:null)||this._defaults.monthNamesShort,u=(t?t.monthNames:null)||this._defaults.monthNames,d=-1,p=-1,f=-1,g=-1,m=!1,_=function(t){t=w+1<e.length&&e.charAt(w+1)===t;return t&&w++,t},v=function(t){var e=_(t),e="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,e=new RegExp("^\\d{"+("y"===t?e:1)+","+e+"}"),e=n.substring(a).match(e);if(!e)throw"Missing number at position "+a;return a+=e[0].length,parseInt(e[0],10)},b=function(t,e,i){var s=-1,e=V.map(_(t)?i:e,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(V.each(e,function(t,e){var i=e[1];if(n.substr(a,i.length).toLowerCase()===i.toLowerCase())return s=e[0],a+=i.length,!1}),-1!==s)return s+1;throw"Unknown name at position "+a},y=function(){if(n.charAt(a)!==e.charAt(w))throw"Unexpected literal at position "+a;a++},w=0;w<e.length;w++)if(m)"'"!==e.charAt(w)||_("'")?y():m=!1;else switch(e.charAt(w)){case"d":f=v("d");break;case"D":b("D",l,h);break;case"o":g=v("o");break;case"m":p=v("m");break;case"M":p=b("M",c,u);break;case"y":d=v("y");break;case"@":d=(o=new Date(v("@"))).getFullYear(),p=o.getMonth()+1,f=o.getDate();break;case"!":d=(o=new Date((v("!")-this._ticksTo1970)/1e4)).getFullYear(),p=o.getMonth()+1,f=o.getDate();break;case"'":_("'")?y():m=!0;break;default:y()}if(a<n.length&&(s=n.substr(a),!/^\s+/.test(s)))throw"Extra/unparsed characters found in date: "+s;if(-1===d?d=(new Date).getFullYear():d<100&&(d+=(new Date).getFullYear()-(new Date).getFullYear()%100+(d<=r?0:-100)),-1<g)for(p=1,f=g;;){if(f<=(i=this._getDaysInMonth(d,p-1)))break;p++,f-=i}if((o=this._daylightSavingAdjust(new Date(d,p-1,f))).getFullYear()!==d||o.getMonth()+1!==p||o.getDate()!==f)throw"Invalid date";return o},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(e,t,i){if(!t)return"";function s(t,e,i){var s=""+e;if(c(t))for(;s.length<i;)s="0"+s;return s}function n(t,e,i,s){return(c(t)?s:i)[e]}var o,a=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,r=(i?i.dayNames:null)||this._defaults.dayNames,l=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,h=(i?i.monthNames:null)||this._defaults.monthNames,c=function(t){t=o+1<e.length&&e.charAt(o+1)===t;return t&&o++,t},u="",d=!1;if(t)for(o=0;o<e.length;o++)if(d)"'"!==e.charAt(o)||c("'")?u+=e.charAt(o):d=!1;else switch(e.charAt(o)){case"d":u+=s("d",t.getDate(),2);break;case"D":u+=n("D",t.getDay(),a,r);break;case"o":u+=s("o",Math.round((new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()-new Date(t.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=s("m",t.getMonth()+1,2);break;case"M":u+=n("M",t.getMonth(),l,h);break;case"y":u+=c("y")?t.getFullYear():(t.getFullYear()%100<10?"0":"")+t.getFullYear()%100;break;case"@":u+=t.getTime();break;case"!":u+=1e4*t.getTime()+this._ticksTo1970;break;case"'":c("'")?u+="'":d=!0;break;default:u+=e.charAt(o)}return u},_possibleChars:function(e){for(var t="",i=!1,s=function(t){t=n+1<e.length&&e.charAt(n+1)===t;return t&&n++,t},n=0;n<e.length;n++)if(i)"'"!==e.charAt(n)||s("'")?t+=e.charAt(n):i=!1;else switch(e.charAt(n)){case"d":case"m":case"y":case"@":t+="0123456789";break;case"D":case"M":return null;case"'":s("'")?t+="'":i=!0;break;default:t+=e.charAt(n)}return t},_get:function(t,e){return(void 0!==t.settings[e]?t.settings:this._defaults)[e]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),o=n,a=this._getFormatConfig(t);try{o=this.parseDate(i,s,a)||n}catch(t){s=e?"":s}t.selectedDay=o.getDate(),t.drawMonth=t.selectedMonth=o.getMonth(),t.drawYear=t.selectedYear=o.getFullYear(),t.currentDay=s?o.getDate():0,t.currentMonth=s?o.getMonth():0,t.currentYear=s?o.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(r,t,e){var i,s,t=null==t||""===t?e:"string"==typeof t?function(t){try{return V.datepicker.parseDate(V.datepicker._get(r,"dateFormat"),t,V.datepicker._getFormatConfig(r))}catch(t){}for(var e=(t.toLowerCase().match(/^c/)?V.datepicker._getDate(r):null)||new Date,i=e.getFullYear(),s=e.getMonth(),n=e.getDate(),o=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,a=o.exec(t);a;){switch(a[2]||"d"){case"d":case"D":n+=parseInt(a[1],10);break;case"w":case"W":n+=7*parseInt(a[1],10);break;case"m":case"M":s+=parseInt(a[1],10),n=Math.min(n,V.datepicker._getDaysInMonth(i,s));break;case"y":case"Y":i+=parseInt(a[1],10),n=Math.min(n,V.datepicker._getDaysInMonth(i,s))}a=o.exec(t)}return new Date(i,s,n)}(t):"number"==typeof t?isNaN(t)?e:(i=t,(s=new Date).setDate(s.getDate()+i),s):new Date(t.getTime());return(t=t&&"Invalid Date"===t.toString()?e:t)&&(t.setHours(0),t.setMinutes(0),t.setSeconds(0),t.setMilliseconds(0)),this._daylightSavingAdjust(t)},_daylightSavingAdjust:function(t){return t?(t.setHours(12<t.getHours()?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,o=t.selectedYear,e=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=e.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=e.getMonth(),t.drawYear=t.selectedYear=t.currentYear=e.getFullYear(),n===t.selectedMonth&&o===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){return!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay))},_attachHandlers:function(t){var e=this._get(t,"stepMonths"),i="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){V.datepicker._adjustDate(i,-e,"M")},next:function(){V.datepicker._adjustDate(i,+e,"M")},hide:function(){V.datepicker._hideDatepicker()},today:function(){V.datepicker._gotoToday(i)},selectDay:function(){return V.datepicker._selectDay(i,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return V.datepicker._selectMonthYear(i,this,"M"),!1},selectYear:function(){return V.datepicker._selectMonthYear(i,this,"Y"),!1}};V(this).on(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,o,a,r,l,h,c,u,d,p,f,g,m,_,v,b,y,w,x,k,C,D,I,T,P,M,S,H,z,A=new Date,O=this._daylightSavingAdjust(new Date(A.getFullYear(),A.getMonth(),A.getDate())),N=this._get(t,"isRTL"),E=this._get(t,"showButtonPanel"),W=this._get(t,"hideIfNoPrevNext"),F=this._get(t,"navigationAsDateFormat"),L=this._getNumberOfMonths(t),R=this._get(t,"showCurrentAtPos"),A=this._get(t,"stepMonths"),Y=1!==L[0]||1!==L[1],B=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),j=this._getMinMaxDate(t,"min"),q=this._getMinMaxDate(t,"max"),K=t.drawMonth-R,U=t.drawYear;if(K<0&&(K+=12,U--),q)for(e=this._daylightSavingAdjust(new Date(q.getFullYear(),q.getMonth()-L[0]*L[1]+1,q.getDate())),e=j&&e<j?j:e;this._daylightSavingAdjust(new Date(U,K,1))>e;)--K<0&&(K=11,U--);for(t.drawMonth=K,t.drawYear=U,R=this._get(t,"prevText"),R=F?this.formatDate(R,this._daylightSavingAdjust(new Date(U,K-A,1)),this._getFormatConfig(t)):R,i=this._canAdjustMonth(t,-1,U,K)?V("<a>").attr({class:"ui-datepicker-prev ui-corner-all","data-handler":"prev","data-event":"click",title:R}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(N?"e":"w")).text(R))[0].outerHTML:W?"":V("<a>").attr({class:"ui-datepicker-prev ui-corner-all ui-state-disabled",title:R}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(N?"e":"w")).text(R))[0].outerHTML,R=this._get(t,"nextText"),R=F?this.formatDate(R,this._daylightSavingAdjust(new Date(U,K+A,1)),this._getFormatConfig(t)):R,s=this._canAdjustMonth(t,1,U,K)?V("<a>").attr({class:"ui-datepicker-next ui-corner-all","data-handler":"next","data-event":"click",title:R}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(N?"w":"e")).text(R))[0].outerHTML:W?"":V("<a>").attr({class:"ui-datepicker-next ui-corner-all ui-state-disabled",title:R}).append(V("<span>").attr("class","ui-icon ui-icon-circle-triangle-"+(N?"w":"e")).text(R))[0].outerHTML,A=this._get(t,"currentText"),W=this._get(t,"gotoCurrent")&&t.currentDay?B:O,A=F?this.formatDate(A,W,this._getFormatConfig(t)):A,R="",t.inline||(R=V("<button>").attr({type:"button",class:"ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all","data-handler":"hide","data-event":"click"}).text(this._get(t,"closeText"))[0].outerHTML),F="",E&&(F=V("<div class='ui-datepicker-buttonpane ui-widget-content'>").append(N?R:"").append(this._isInRange(t,W)?V("<button>").attr({type:"button",class:"ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all","data-handler":"today","data-event":"click"}).text(A):"").append(N?"":R)[0].outerHTML),n=parseInt(this._get(t,"firstDay"),10),n=isNaN(n)?0:n,o=this._get(t,"showWeek"),a=this._get(t,"dayNames"),r=this._get(t,"dayNamesMin"),l=this._get(t,"monthNames"),h=this._get(t,"monthNamesShort"),c=this._get(t,"beforeShowDay"),u=this._get(t,"showOtherMonths"),d=this._get(t,"selectOtherMonths"),p=this._getDefaultDate(t),f="",m=0;m<L[0];m++){for(_="",this.maxRows=4,v=0;v<L[1];v++){if(b=this._daylightSavingAdjust(new Date(U,K,t.selectedDay)),y=" ui-corner-all",w="",Y){if(w+="<div class='ui-datepicker-group",1<L[1])switch(v){case 0:w+=" ui-datepicker-group-first",y=" ui-corner-"+(N?"right":"left");break;case L[1]-1:w+=" ui-datepicker-group-last",y=" ui-corner-"+(N?"left":"right");break;default:w+=" ui-datepicker-group-middle",y=""}w+="'>"}for(w+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+y+"'>"+(/all|left/.test(y)&&0===m?N?s:i:"")+(/all|right/.test(y)&&0===m?N?i:s:"")+this._generateMonthYearHeader(t,K,U,j,q,0<m||0<v,l,h)+"</div><table class='ui-datepicker-calendar'><thead><tr>",x=o?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",g=0;g<7;g++)x+="<th scope='col'"+(5<=(g+n+6)%7?" class='ui-datepicker-week-end'":"")+"><span title='"+a[k=(g+n)%7]+"'>"+r[k]+"</span></th>";for(w+=x+"</tr></thead><tbody>",D=this._getDaysInMonth(U,K),U===t.selectedYear&&K===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,D)),C=(this._getFirstDayOfMonth(U,K)-n+7)%7,D=Math.ceil((C+D)/7),I=Y&&this.maxRows>D?this.maxRows:D,this.maxRows=I,T=this._daylightSavingAdjust(new Date(U,K,1-C)),P=0;P<I;P++){for(w+="<tr>",M=o?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(T)+"</td>":"",g=0;g<7;g++)S=c?c.apply(t.input?t.input[0]:null,[T]):[!0,""],z=(H=T.getMonth()!==K)&&!d||!S[0]||j&&T<j||q&&q<T,M+="<td class='"+(5<=(g+n+6)%7?" ui-datepicker-week-end":"")+(H?" ui-datepicker-other-month":"")+(T.getTime()===b.getTime()&&K===t.selectedMonth&&t._keyEvent||p.getTime()===T.getTime()&&p.getTime()===b.getTime()?" "+this._dayOverClass:"")+(z?" "+this._unselectableClass+" ui-state-disabled":"")+(H&&!u?"":" "+S[1]+(T.getTime()===B.getTime()?" "+this._currentClass:"")+(T.getTime()===O.getTime()?" ui-datepicker-today":""))+"'"+(H&&!u||!S[2]?"":" title='"+S[2].replace(/'/g,"&#39;")+"'")+(z?"":" data-handler='selectDay' data-event='click' data-month='"+T.getMonth()+"' data-year='"+T.getFullYear()+"'")+">"+(H&&!u?"&#xa0;":z?"<span class='ui-state-default'>"+T.getDate()+"</span>":"<a class='ui-state-default"+(T.getTime()===O.getTime()?" ui-state-highlight":"")+(T.getTime()===B.getTime()?" ui-state-active":"")+(H?" ui-priority-secondary":"")+"' href='#' aria-current='"+(T.getTime()===B.getTime()?"true":"false")+"' data-date='"+T.getDate()+"'>"+T.getDate()+"</a>")+"</td>",T.setDate(T.getDate()+1),T=this._daylightSavingAdjust(T);w+=M+"</tr>"}11<++K&&(K=0,U++),_+=w+="</tbody></table>"+(Y?"</div>"+(0<L[0]&&v===L[1]-1?"<div class='ui-datepicker-row-break'></div>":""):"")}f+=_}return f+=F,t._keyEvent=!1,f},_generateMonthYearHeader:function(t,e,i,s,n,o,a,r){var l,h,c,u,d,p,f=this._get(t,"changeMonth"),g=this._get(t,"changeYear"),m=this._get(t,"showMonthAfterYear"),_=this._get(t,"selectMonthLabel"),v=this._get(t,"selectYearLabel"),b="<div class='ui-datepicker-title'>",y="";if(o||!f)y+="<span class='ui-datepicker-month'>"+a[e]+"</span>";else{for(l=s&&s.getFullYear()===i,h=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' aria-label='"+_+"' data-handler='selectMonth' data-event='change'>",c=0;c<12;c++)(!l||c>=s.getMonth())&&(!h||c<=n.getMonth())&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+r[c]+"</option>");y+="</select>"}if(m||(b+=y+(!o&&f&&g?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",o||!g)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(a=this._get(t,"yearRange").split(":"),u=(new Date).getFullYear(),d=(_=function(t){t=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?u+parseInt(t,10):parseInt(t,10);return isNaN(t)?u:t})(a[0]),p=Math.max(d,_(a[1]||"")),d=s?Math.max(d,s.getFullYear()):d,p=n?Math.min(p,n.getFullYear()):p,t.yearshtml+="<select class='ui-datepicker-year' aria-label='"+v+"' data-handler='selectYear' data-event='change'>";d<=p;d++)t.yearshtml+="<option value='"+d+"'"+(d===i?" selected='selected'":"")+">"+d+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),m&&(b+=(!o&&f&&g?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.selectedYear+("Y"===i?e:0),n=t.selectedMonth+("M"===i?e:0),e=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),e=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,e)));t.selectedDay=e.getDate(),t.drawMonth=t.selectedMonth=e.getMonth(),t.drawYear=t.selectedYear=e.getFullYear(),"M"!==i&&"Y"!==i||this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),t=this._getMinMaxDate(t,"max"),e=i&&e<i?i:e;return t&&t<e?t:e},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){t=this._get(t,"numberOfMonths");return null==t?[1,1]:"number"==typeof t?[1,t]:t},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),n=this._daylightSavingAdjust(new Date(i,s+(e<0?e:n[0]*n[1]),1));return e<0&&n.setDate(this._getDaysInMonth(n.getFullYear(),n.getMonth())),this._isInRange(t,n)},_isInRange:function(t,e){var i=this._getMinMaxDate(t,"min"),s=this._getMinMaxDate(t,"max"),n=null,o=null,a=this._get(t,"yearRange");return a&&(t=a.split(":"),a=(new Date).getFullYear(),n=parseInt(t[0],10),o=parseInt(t[1],10),t[0].match(/[+\-].*/)&&(n+=a),t[1].match(/[+\-].*/)&&(o+=a)),(!i||e.getTime()>=i.getTime())&&(!s||e.getTime()<=s.getTime())&&(!n||e.getFullYear()>=n)&&(!o||e.getFullYear()<=o)},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return{shortYearCutoff:e="string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);e=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),e,this._getFormatConfig(t))}}),V.fn.datepicker=function(t){if(!this.length)return this;V.datepicker.initialized||(V(document).on("mousedown",V.datepicker._checkExternalClick),V.datepicker.initialized=!0),0===V("#"+V.datepicker._mainDivId).length&&V("body").append(V.datepicker.dpDiv);var e=Array.prototype.slice.call(arguments,1);return"string"==typeof t&&("isDisabled"===t||"getDate"===t||"widget"===t)||"option"===t&&2===arguments.length&&"string"==typeof arguments[1]?V.datepicker["_"+t+"Datepicker"].apply(V.datepicker,[this[0]].concat(e)):this.each(function(){"string"==typeof t?V.datepicker["_"+t+"Datepicker"].apply(V.datepicker,[this].concat(e)):V.datepicker._attachDatepicker(this,t)})},V.datepicker=new st,V.datepicker.initialized=!1,V.datepicker.uuid=(new Date).getTime(),V.datepicker.version="1.13.2";V.datepicker,V.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var rt=!1;V(document).on("mouseup",function(){rt=!1});V.widget("ui.mouse",{version:"1.13.2",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(t){if(!0===V.data(t.target,e.widgetName+".preventClickEvent"))return V.removeData(t.target,e.widgetName+".preventClickEvent"),t.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(t){if(!rt){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(t),this._mouseDownEvent=t;var e=this,i=1===t.which,s=!("string"!=typeof this.options.cancel||!t.target.nodeName)&&V(t.target).closest(this.options.cancel).length;return i&&!s&&this._mouseCapture(t)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){e.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=!1!==this._mouseStart(t),!this._mouseStarted)?(t.preventDefault(),!0):(!0===V.data(t.target,this.widgetName+".preventClickEvent")&&V.removeData(t.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return e._mouseMove(t)},this._mouseUpDelegate=function(t){return e._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),t.preventDefault(),rt=!0)):!0}},_mouseMove:function(t){if(this._mouseMoved){if(V.ui.ie&&(!document.documentMode||document.documentMode<9)&&!t.button)return this._mouseUp(t);if(!t.which)if(t.originalEvent.altKey||t.originalEvent.ctrlKey||t.originalEvent.metaKey||t.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(t)}return(t.which||t.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=!1!==this._mouseStart(this._mouseDownEvent,t),this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&V.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,rt=!1,t.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),V.ui.plugin={add:function(t,e,i){var s,n=V.ui[t].prototype;for(s in i)n.plugins[s]=n.plugins[s]||[],n.plugins[s].push([e,i[s]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;n<o.length;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}},V.ui.safeBlur=function(t){t&&"body"!==t.nodeName.toLowerCase()&&V(t).trigger("blur")};V.widget("ui.draggable",V.ui.mouse,{version:"1.13.2",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){(this.helper||this.element).is(".ui-draggable-dragging")?this.destroyOnClear=!0:(this._removeHandleClassName(),this._mouseDestroy())},_mouseCapture:function(t){var e=this.options;return!(this.helper||e.disabled||0<V(t.target).closest(".ui-resizable-handle").length)&&(this.handle=this._getHandle(t),!!this.handle&&(this._blurActiveElement(t),this._blockFrames(!0===e.iframeFix?"iframe":e.iframeFix),!0))},_blockFrames:function(t){this.iframeBlocks=this.document.find(t).map(function(){var t=V(this);return V("<div>").css("position","absolute").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(t){var e=V.ui.safeActiveElement(this.document[0]);V(t.target).closest(e).length||V.ui.safeBlur(e)},_mouseStart:function(t){var e=this.options;return this.helper=this._createHelper(t),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),V.ui.ddmanager&&(V.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=0<this.helper.parents().filter(function(){return"fixed"===V(this).css("position")}).length,this.positionAbs=this.element.offset(),this._refreshOffsets(t),this.originalPosition=this.position=this._generatePosition(t,!1),this.originalPageX=t.pageX,this.originalPageY=t.pageY,e.cursorAt&&this._adjustOffsetFromHelper(e.cursorAt),this._setContainment(),!1===this._trigger("start",t)?(this._clear(),!1):(this._cacheHelperProportions(),V.ui.ddmanager&&!e.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this._mouseDrag(t,!0),V.ui.ddmanager&&V.ui.ddmanager.dragStart(this,t),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(t,e){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(t,!0),this.positionAbs=this._convertPositionTo("absolute"),!e){e=this._uiHash();if(!1===this._trigger("drag",t,e))return this._mouseUp(new V.Event("mouseup",t)),!1;this.position=e.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",V.ui.ddmanager&&V.ui.ddmanager.drag(this,t),!1},_mouseStop:function(t){var e=this,i=!1;return V.ui.ddmanager&&!this.options.dropBehaviour&&(i=V.ui.ddmanager.drop(this,t)),this.dropped&&(i=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!i||"valid"===this.options.revert&&i||!0===this.options.revert||"function"==typeof this.options.revert&&this.options.revert.call(this.element,i)?V(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){!1!==e._trigger("stop",t)&&e._clear()}):!1!==this._trigger("stop",t)&&this._clear(),!1},_mouseUp:function(t){return this._unblockFrames(),V.ui.ddmanager&&V.ui.ddmanager.dragStop(this,t),this.handleElement.is(t.target)&&this.element.trigger("focus"),V.ui.mouse.prototype._mouseUp.call(this,t)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new V.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(t){return!this.options.handle||!!V(t.target).closest(this.element.find(this.options.handle)).length},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(t){var e=this.options,i="function"==typeof e.helper,t=i?V(e.helper.apply(this.element[0],[t])):"clone"===e.helper?this.element.clone().removeAttr("id"):this.element;return t.parents("body").length||t.appendTo("parent"===e.appendTo?this.element[0].parentNode:e.appendTo),i&&t[0]===this.element[0]&&this._setPositionRelative(),t[0]===this.element[0]||/(fixed|absolute)/.test(t.css("position"))||t.css("position","absolute"),t},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),"left"in(t=Array.isArray(t)?{left:+t[0],top:+t[1]||0}:t)&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var t=this.offsetParent.offset(),e=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==e&&V.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),{top:(t=this._isRootNode(this.offsetParent[0])?{top:0,left:0}:t).top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.element.position(),e=this._isRootNode(this.scrollParent[0]);return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,e,i,s=this.options,n=this.document[0];this.relativeContainer=null,s.containment?"window"!==s.containment?"document"!==s.containment?s.containment.constructor!==Array?("parent"===s.containment&&(s.containment=this.helper[0].parentNode),(i=(e=V(s.containment))[0])&&(t=/(scroll|auto)/.test(e.css("overflow")),this.containment=[(parseInt(e.css("borderLeftWidth"),10)||0)+(parseInt(e.css("paddingLeft"),10)||0),(parseInt(e.css("borderTopWidth"),10)||0)+(parseInt(e.css("paddingTop"),10)||0),(t?Math.max(i.scrollWidth,i.offsetWidth):i.offsetWidth)-(parseInt(e.css("borderRightWidth"),10)||0)-(parseInt(e.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(t?Math.max(i.scrollHeight,i.offsetHeight):i.offsetHeight)-(parseInt(e.css("borderBottomWidth"),10)||0)-(parseInt(e.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=e)):this.containment=s.containment:this.containment=[0,0,V(n).width()-this.helperProportions.width-this.margins.left,(V(n).height()||n.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]:this.containment=[V(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,V(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,V(window).scrollLeft()+V(window).width()-this.helperProportions.width-this.margins.left,V(window).scrollTop()+(V(window).height()||n.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]:this.containment=null},_convertPositionTo:function(t,e){e=e||this.position;var i="absolute"===t?1:-1,t=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.offset.scroll.top:t?0:this.offset.scroll.top)*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.offset.scroll.left:t?0:this.offset.scroll.left)*i}},_generatePosition:function(t,e){var i,s=this.options,n=this._isRootNode(this.scrollParent[0]),o=t.pageX,a=t.pageY;return n&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),e&&(this.containment&&(i=this.relativeContainer?(i=this.relativeContainer.offset(),[this.containment[0]+i.left,this.containment[1]+i.top,this.containment[2]+i.left,this.containment[3]+i.top]):this.containment,t.pageX-this.offset.click.left<i[0]&&(o=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(a=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(o=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(a=i[3]+this.offset.click.top)),s.grid&&(t=s.grid[1]?this.originalPageY+Math.round((a-this.originalPageY)/s.grid[1])*s.grid[1]:this.originalPageY,a=!i||t-this.offset.click.top>=i[1]||t-this.offset.click.top>i[3]?t:t-this.offset.click.top>=i[1]?t-s.grid[1]:t+s.grid[1],t=s.grid[0]?this.originalPageX+Math.round((o-this.originalPageX)/s.grid[0])*s.grid[0]:this.originalPageX,o=!i||t-this.offset.click.left>=i[0]||t-this.offset.click.left>i[2]?t:t-this.offset.click.left>=i[0]?t-s.grid[0]:t+s.grid[0]),"y"===s.axis&&(o=this.originalPageX),"x"===s.axis&&(a=this.originalPageY)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:n?0:this.offset.scroll.top),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:n?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(t,e,i){return i=i||this._uiHash(),V.ui.plugin.call(this,t,[e,i,this],!0),/^(drag|start|stop)/.test(t)&&(this.positionAbs=this._convertPositionTo("absolute"),i.offset=this.positionAbs),V.Widget.prototype._trigger.call(this,t,e,i)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),V.ui.plugin.add("draggable","connectToSortable",{start:function(e,t,i){var s=V.extend({},t,{item:i.element});i.sortables=[],V(i.options.connectToSortable).each(function(){var t=V(this).sortable("instance");t&&!t.options.disabled&&(i.sortables.push(t),t.refreshPositions(),t._trigger("activate",e,s))})},stop:function(e,t,i){var s=V.extend({},t,{item:i.element});i.cancelHelperRemoval=!1,V.each(i.sortables,function(){var t=this;t.isOver?(t.isOver=0,i.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,s))})},drag:function(i,s,n){V.each(n.sortables,function(){var t=!1,e=this;e.positionAbs=n.positionAbs,e.helperProportions=n.helperProportions,e.offset.click=n.offset.click,e._intersectsWith(e.containerCache)&&(t=!0,V.each(n.sortables,function(){return this.positionAbs=n.positionAbs,this.helperProportions=n.helperProportions,this.offset.click=n.offset.click,t=this!==e&&this._intersectsWith(this.containerCache)&&V.contains(e.element[0],this.element[0])?!1:t})),t?(e.isOver||(e.isOver=1,n._parent=s.helper.parent(),e.currentItem=s.helper.appendTo(e.element).data("ui-sortable-item",!0),e.options._helper=e.options.helper,e.options.helper=function(){return s.helper[0]},i.target=e.currentItem[0],e._mouseCapture(i,!0),e._mouseStart(i,!0,!0),e.offset.click.top=n.offset.click.top,e.offset.click.left=n.offset.click.left,e.offset.parent.left-=n.offset.parent.left-e.offset.parent.left,e.offset.parent.top-=n.offset.parent.top-e.offset.parent.top,n._trigger("toSortable",i),n.dropped=e.element,V.each(n.sortables,function(){this.refreshPositions()}),n.currentItem=n.element,e.fromOutside=n),e.currentItem&&(e._mouseDrag(i),s.position=e.position)):e.isOver&&(e.isOver=0,e.cancelHelperRemoval=!0,e.options._revert=e.options.revert,e.options.revert=!1,e._trigger("out",i,e._uiHash(e)),e._mouseStop(i,!0),e.options.revert=e.options._revert,e.options.helper=e.options._helper,e.placeholder&&e.placeholder.remove(),s.helper.appendTo(n._parent),n._refreshOffsets(i),s.position=n._generatePosition(i,!0),n._trigger("fromSortable",i),n.dropped=!1,V.each(n.sortables,function(){this.refreshPositions()}))})}}),V.ui.plugin.add("draggable","cursor",{start:function(t,e,i){var s=V("body"),i=i.options;s.css("cursor")&&(i._cursor=s.css("cursor")),s.css("cursor",i.cursor)},stop:function(t,e,i){i=i.options;i._cursor&&V("body").css("cursor",i._cursor)}}),V.ui.plugin.add("draggable","opacity",{start:function(t,e,i){e=V(e.helper),i=i.options;e.css("opacity")&&(i._opacity=e.css("opacity")),e.css("opacity",i.opacity)},stop:function(t,e,i){i=i.options;i._opacity&&V(e.helper).css("opacity",i._opacity)}}),V.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(t,e,i){var s=i.options,n=!1,o=i.scrollParentNotHidden[0],a=i.document[0];o!==a&&"HTML"!==o.tagName?(s.axis&&"x"===s.axis||(i.overflowOffset.top+o.offsetHeight-t.pageY<s.scrollSensitivity?o.scrollTop=n=o.scrollTop+s.scrollSpeed:t.pageY-i.overflowOffset.top<s.scrollSensitivity&&(o.scrollTop=n=o.scrollTop-s.scrollSpeed)),s.axis&&"y"===s.axis||(i.overflowOffset.left+o.offsetWidth-t.pageX<s.scrollSensitivity?o.scrollLeft=n=o.scrollLeft+s.scrollSpeed:t.pageX-i.overflowOffset.left<s.scrollSensitivity&&(o.scrollLeft=n=o.scrollLeft-s.scrollSpeed))):(s.axis&&"x"===s.axis||(t.pageY-V(a).scrollTop()<s.scrollSensitivity?n=V(a).scrollTop(V(a).scrollTop()-s.scrollSpeed):V(window).height()-(t.pageY-V(a).scrollTop())<s.scrollSensitivity&&(n=V(a).scrollTop(V(a).scrollTop()+s.scrollSpeed))),s.axis&&"y"===s.axis||(t.pageX-V(a).scrollLeft()<s.scrollSensitivity?n=V(a).scrollLeft(V(a).scrollLeft()-s.scrollSpeed):V(window).width()-(t.pageX-V(a).scrollLeft())<s.scrollSensitivity&&(n=V(a).scrollLeft(V(a).scrollLeft()+s.scrollSpeed)))),!1!==n&&V.ui.ddmanager&&!s.dropBehaviour&&V.ui.ddmanager.prepareOffsets(i,t)}}),V.ui.plugin.add("draggable","snap",{start:function(t,e,i){var s=i.options;i.snapElements=[],V(s.snap.constructor!==String?s.snap.items||":data(ui-draggable)":s.snap).each(function(){var t=V(this),e=t.offset();this!==i.element[0]&&i.snapElements.push({item:this,width:t.outerWidth(),height:t.outerHeight(),top:e.top,left:e.left})})},drag:function(t,e,i){for(var s,n,o,a,r,l,h,c,u,d=i.options,p=d.snapTolerance,f=e.offset.left,g=f+i.helperProportions.width,m=e.offset.top,_=m+i.helperProportions.height,v=i.snapElements.length-1;0<=v;v--)l=(r=i.snapElements[v].left-i.margins.left)+i.snapElements[v].width,c=(h=i.snapElements[v].top-i.margins.top)+i.snapElements[v].height,g<r-p||l+p<f||_<h-p||c+p<m||!V.contains(i.snapElements[v].item.ownerDocument,i.snapElements[v].item)?(i.snapElements[v].snapping&&i.options.snap.release&&i.options.snap.release.call(i.element,t,V.extend(i._uiHash(),{snapItem:i.snapElements[v].item})),i.snapElements[v].snapping=!1):("inner"!==d.snapMode&&(s=Math.abs(h-_)<=p,n=Math.abs(c-m)<=p,o=Math.abs(r-g)<=p,a=Math.abs(l-f)<=p,s&&(e.position.top=i._convertPositionTo("relative",{top:h-i.helperProportions.height,left:0}).top),n&&(e.position.top=i._convertPositionTo("relative",{top:c,left:0}).top),o&&(e.position.left=i._convertPositionTo("relative",{top:0,left:r-i.helperProportions.width}).left),a&&(e.position.left=i._convertPositionTo("relative",{top:0,left:l}).left)),u=s||n||o||a,"outer"!==d.snapMode&&(s=Math.abs(h-m)<=p,n=Math.abs(c-_)<=p,o=Math.abs(r-f)<=p,a=Math.abs(l-g)<=p,s&&(e.position.top=i._convertPositionTo("relative",{top:h,left:0}).top),n&&(e.position.top=i._convertPositionTo("relative",{top:c-i.helperProportions.height,left:0}).top),o&&(e.position.left=i._convertPositionTo("relative",{top:0,left:r}).left),a&&(e.position.left=i._convertPositionTo("relative",{top:0,left:l-i.helperProportions.width}).left)),!i.snapElements[v].snapping&&(s||n||o||a||u)&&i.options.snap.snap&&i.options.snap.snap.call(i.element,t,V.extend(i._uiHash(),{snapItem:i.snapElements[v].item})),i.snapElements[v].snapping=s||n||o||a||u)}}),V.ui.plugin.add("draggable","stack",{start:function(t,e,i){var s,i=i.options,i=V.makeArray(V(i.stack)).sort(function(t,e){return(parseInt(V(t).css("zIndex"),10)||0)-(parseInt(V(e).css("zIndex"),10)||0)});i.length&&(s=parseInt(V(i[0]).css("zIndex"),10)||0,V(i).each(function(t){V(this).css("zIndex",s+t)}),this.css("zIndex",s+i.length))}}),V.ui.plugin.add("draggable","zIndex",{start:function(t,e,i){e=V(e.helper),i=i.options;e.css("zIndex")&&(i._zIndex=e.css("zIndex")),e.css("zIndex",i.zIndex)},stop:function(t,e,i){i=i.options;i._zIndex&&V(e.helper).css("zIndex",i._zIndex)}});V.ui.draggable;V.widget("ui.resizable",V.ui.mouse,{version:"1.13.2",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(t){return parseFloat(t)||0},_isNumber:function(t){return!isNaN(parseFloat(t))},_hasScroll:function(t,e){if("hidden"===V(t).css("overflow"))return!1;var i=e&&"left"===e?"scrollLeft":"scrollTop",e=!1;if(0<t[i])return!0;try{t[i]=1,e=0<t[i],t[i]=0}catch(t){}return e},_create:function(){var t,e=this.options,i=this;this._addClass("ui-resizable"),V.extend(this,{_aspectRatio:!!e.aspectRatio,aspectRatio:e.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:e.helper||e.ghost||e.animate?e.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(V("<div class='ui-wrapper'></div>").css({overflow:"hidden",position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,t={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(t),this.originalElement.css("margin",0),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css(t),this._proportionallyResize()),this._setupHandles(),e.autoHide&&V(this.element).on("mouseenter",function(){e.disabled||(i._removeClass("ui-resizable-autohide"),i._handles.show())}).on("mouseleave",function(){e.disabled||i.resizing||(i._addClass("ui-resizable-autohide"),i._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy(),this._addedHandles.remove();function t(t){V(t).removeData("resizable").removeData("ui-resizable").off(".resizable")}var e;return this.elementIsWrapper&&(t(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),t(this.originalElement),this},_setOption:function(t,e){switch(this._super(t,e),t){case"handles":this._removeHandles(),this._setupHandles();break;case"aspectRatio":this._aspectRatio=!!e}},_setupHandles:function(){var t,e,i,s,n,o=this.options,a=this;if(this.handles=o.handles||(V(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=V(),this._addedHandles=V(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),i=this.handles.split(","),this.handles={},e=0;e<i.length;e++)s="ui-resizable-"+(t=String.prototype.trim.call(i[e])),n=V("<div>"),this._addClass(n,"ui-resizable-handle "+s),n.css({zIndex:o.zIndex}),this.handles[t]=".ui-resizable-"+t,this.element.children(this.handles[t]).length||(this.element.append(n),this._addedHandles=this._addedHandles.add(n));this._renderAxis=function(t){var e,i,s;for(e in t=t||this.element,this.handles)this.handles[e].constructor===String?this.handles[e]=this.element.children(this.handles[e]).first().show():(this.handles[e].jquery||this.handles[e].nodeType)&&(this.handles[e]=V(this.handles[e]),this._on(this.handles[e],{mousedown:a._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(i=V(this.handles[e],this.element),s=/sw|ne|nw|se|n|s/.test(e)?i.outerHeight():i.outerWidth(),i=["padding",/ne|nw|n/.test(e)?"Top":/se|sw|s/.test(e)?"Bottom":/^e$/.test(e)?"Right":"Left"].join(""),t.css(i,s),this._proportionallyResize()),this._handles=this._handles.add(this.handles[e])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){a.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),a.axis=n&&n[1]?n[1]:"se")}),o.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._addedHandles.remove()},_mouseCapture:function(t){var e,i,s=!1;for(e in this.handles)(i=V(this.handles[e])[0])!==t.target&&!V.contains(i,t.target)||(s=!0);return!this.options.disabled&&s},_mouseStart:function(t){var e,i,s=this.options,n=this.element;return this.resizing=!0,this._renderProxy(),e=this._num(this.helper.css("left")),i=this._num(this.helper.css("top")),s.containment&&(e+=V(s.containment).scrollLeft()||0,i+=V(s.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:e,top:i},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:n.width(),height:n.height()},this.originalSize=this._helper?{width:n.outerWidth(),height:n.outerHeight()}:{width:n.width(),height:n.height()},this.sizeDiff={width:n.outerWidth()-n.width(),height:n.outerHeight()-n.height()},this.originalPosition={left:e,top:i},this.originalMousePosition={left:t.pageX,top:t.pageY},this.aspectRatio="number"==typeof s.aspectRatio?s.aspectRatio:this.originalSize.width/this.originalSize.height||1,s=V(".ui-resizable-"+this.axis).css("cursor"),V("body").css("cursor","auto"===s?this.axis+"-resize":s),this._addClass("ui-resizable-resizing"),this._propagate("start",t),!0},_mouseDrag:function(t){var e=this.originalMousePosition,i=this.axis,s=t.pageX-e.left||0,e=t.pageY-e.top||0,i=this._change[i];return this._updatePrevProperties(),i&&(e=i.apply(this,[t,s,e]),this._updateVirtualBoundaries(t.shiftKey),(this._aspectRatio||t.shiftKey)&&(e=this._updateRatio(e,t)),e=this._respectSize(e,t),this._updateCache(e),this._propagate("resize",t),e=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),V.isEmptyObject(e)||(this._updatePrevProperties(),this._trigger("resize",t,this.ui()),this._applyChanges())),!1},_mouseStop:function(t){this.resizing=!1;var e,i,s,n=this.options,o=this;return this._helper&&(s=(e=(i=this._proportionallyResizeElements).length&&/textarea/i.test(i[0].nodeName))&&this._hasScroll(i[0],"left")?0:o.sizeDiff.height,i=e?0:o.sizeDiff.width,e={width:o.helper.width()-i,height:o.helper.height()-s},i=parseFloat(o.element.css("left"))+(o.position.left-o.originalPosition.left)||null,s=parseFloat(o.element.css("top"))+(o.position.top-o.originalPosition.top)||null,n.animate||this.element.css(V.extend(e,{top:s,left:i})),o.helper.height(o.size.height),o.helper.width(o.size.width),this._helper&&!n.animate&&this._proportionallyResize()),V("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",t),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var t={};return this.position.top!==this.prevPosition.top&&(t.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(t.left=this.position.left+"px"),this.size.width!==this.prevSize.width&&(t.width=this.size.width+"px"),this.size.height!==this.prevSize.height&&(t.height=this.size.height+"px"),this.helper.css(t),t},_updateVirtualBoundaries:function(t){var e,i,s=this.options,n={minWidth:this._isNumber(s.minWidth)?s.minWidth:0,maxWidth:this._isNumber(s.maxWidth)?s.maxWidth:1/0,minHeight:this._isNumber(s.minHeight)?s.minHeight:0,maxHeight:this._isNumber(s.maxHeight)?s.maxHeight:1/0};(this._aspectRatio||t)&&(e=n.minHeight*this.aspectRatio,i=n.minWidth/this.aspectRatio,s=n.maxHeight*this.aspectRatio,t=n.maxWidth/this.aspectRatio,e>n.minWidth&&(n.minWidth=e),i>n.minHeight&&(n.minHeight=i),s<n.maxWidth&&(n.maxWidth=s),t<n.maxHeight&&(n.maxHeight=t)),this._vBoundaries=n},_updateCache:function(t){this.offset=this.helper.offset(),this._isNumber(t.left)&&(this.position.left=t.left),this._isNumber(t.top)&&(this.position.top=t.top),this._isNumber(t.height)&&(this.size.height=t.height),this._isNumber(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,i=this.size,s=this.axis;return this._isNumber(t.height)?t.width=t.height*this.aspectRatio:this._isNumber(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===s&&(t.left=e.left+(i.width-t.width),t.top=null),"nw"===s&&(t.top=e.top+(i.height-t.height),t.left=e.left+(i.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,i=this.axis,s=this._isNumber(t.width)&&e.maxWidth&&e.maxWidth<t.width,n=this._isNumber(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=this._isNumber(t.width)&&e.minWidth&&e.minWidth>t.width,a=this._isNumber(t.height)&&e.minHeight&&e.minHeight>t.height,r=this.originalPosition.left+this.originalSize.width,l=this.originalPosition.top+this.originalSize.height,h=/sw|nw|w/.test(i),i=/nw|ne|n/.test(i);return o&&(t.width=e.minWidth),a&&(t.height=e.minHeight),s&&(t.width=e.maxWidth),n&&(t.height=e.maxHeight),o&&h&&(t.left=r-e.minWidth),s&&h&&(t.left=r-e.maxWidth),a&&i&&(t.top=l-e.minHeight),n&&i&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_getPaddingPlusBorderDimensions:function(t){for(var e=0,i=[],s=[t.css("borderTopWidth"),t.css("borderRightWidth"),t.css("borderBottomWidth"),t.css("borderLeftWidth")],n=[t.css("paddingTop"),t.css("paddingRight"),t.css("paddingBottom"),t.css("paddingLeft")];e<4;e++)i[e]=parseFloat(s[e])||0,i[e]+=parseFloat(n[e])||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var t,e=0,i=this.helper||this.element;e<this._proportionallyResizeElements.length;e++)t=this._proportionallyResizeElements[e],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(t)),t.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var t=this.element,e=this.options;this.elementOffset=t.offset(),this._helper?(this.helper=this.helper||V("<div></div>").css({overflow:"hidden"}),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++e.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize;return{left:this.originalPosition.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize;return{top:this.originalPosition.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(t,e,i){return V.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[t,e,i]))},sw:function(t,e,i){return V.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[t,e,i]))},ne:function(t,e,i){return V.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[t,e,i]))},nw:function(t,e,i){return V.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[t,e,i]))}},_propagate:function(t,e){V.ui.plugin.call(this,t,[e,this.ui()]),"resize"!==t&&this._trigger(t,e,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),V.ui.plugin.add("resizable","animate",{stop:function(e){var i=V(this).resizable("instance"),t=i.options,s=i._proportionallyResizeElements,n=s.length&&/textarea/i.test(s[0].nodeName),o=n&&i._hasScroll(s[0],"left")?0:i.sizeDiff.height,a=n?0:i.sizeDiff.width,n={width:i.size.width-a,height:i.size.height-o},a=parseFloat(i.element.css("left"))+(i.position.left-i.originalPosition.left)||null,o=parseFloat(i.element.css("top"))+(i.position.top-i.originalPosition.top)||null;i.element.animate(V.extend(n,o&&a?{top:o,left:a}:{}),{duration:t.animateDuration,easing:t.animateEasing,step:function(){var t={width:parseFloat(i.element.css("width")),height:parseFloat(i.element.css("height")),top:parseFloat(i.element.css("top")),left:parseFloat(i.element.css("left"))};s&&s.length&&V(s[0]).css({width:t.width,height:t.height}),i._updateCache(t),i._propagate("resize",e)}})}}),V.ui.plugin.add("resizable","containment",{start:function(){var i,s,n=V(this).resizable("instance"),t=n.options,e=n.element,o=t.containment,a=o instanceof V?o.get(0):/parent/.test(o)?e.parent().get(0):o;a&&(n.containerElement=V(a),/document/.test(o)||o===document?(n.containerOffset={left:0,top:0},n.containerPosition={left:0,top:0},n.parentData={element:V(document),left:0,top:0,width:V(document).width(),height:V(document).height()||document.body.parentNode.scrollHeight}):(i=V(a),s=[],V(["Top","Right","Left","Bottom"]).each(function(t,e){s[t]=n._num(i.css("padding"+e))}),n.containerOffset=i.offset(),n.containerPosition=i.position(),n.containerSize={height:i.innerHeight()-s[3],width:i.innerWidth()-s[1]},t=n.containerOffset,e=n.containerSize.height,o=n.containerSize.width,o=n._hasScroll(a,"left")?a.scrollWidth:o,e=n._hasScroll(a)?a.scrollHeight:e,n.parentData={element:a,left:t.left,top:t.top,width:o,height:e}))},resize:function(t){var e=V(this).resizable("instance"),i=e.options,s=e.containerOffset,n=e.position,o=e._aspectRatio||t.shiftKey,a={top:0,left:0},r=e.containerElement,t=!0;r[0]!==document&&/static/.test(r.css("position"))&&(a=s),n.left<(e._helper?s.left:0)&&(e.size.width=e.size.width+(e._helper?e.position.left-s.left:e.position.left-a.left),o&&(e.size.height=e.size.width/e.aspectRatio,t=!1),e.position.left=i.helper?s.left:0),n.top<(e._helper?s.top:0)&&(e.size.height=e.size.height+(e._helper?e.position.top-s.top:e.position.top),o&&(e.size.width=e.size.height*e.aspectRatio,t=!1),e.position.top=e._helper?s.top:0),i=e.containerElement.get(0)===e.element.parent().get(0),n=/relative|absolute/.test(e.containerElement.css("position")),i&&n?(e.offset.left=e.parentData.left+e.position.left,e.offset.top=e.parentData.top+e.position.top):(e.offset.left=e.element.offset().left,e.offset.top=e.element.offset().top),n=Math.abs(e.sizeDiff.width+(e._helper?e.offset.left-a.left:e.offset.left-s.left)),s=Math.abs(e.sizeDiff.height+(e._helper?e.offset.top-a.top:e.offset.top-s.top)),n+e.size.width>=e.parentData.width&&(e.size.width=e.parentData.width-n,o&&(e.size.height=e.size.width/e.aspectRatio,t=!1)),s+e.size.height>=e.parentData.height&&(e.size.height=e.parentData.height-s,o&&(e.size.width=e.size.height*e.aspectRatio,t=!1)),t||(e.position.left=e.prevPosition.left,e.position.top=e.prevPosition.top,e.size.width=e.prevSize.width,e.size.height=e.prevSize.height)},stop:function(){var t=V(this).resizable("instance"),e=t.options,i=t.containerOffset,s=t.containerPosition,n=t.containerElement,o=V(t.helper),a=o.offset(),r=o.outerWidth()-t.sizeDiff.width,o=o.outerHeight()-t.sizeDiff.height;t._helper&&!e.animate&&/relative/.test(n.css("position"))&&V(this).css({left:a.left-s.left-i.left,width:r,height:o}),t._helper&&!e.animate&&/static/.test(n.css("position"))&&V(this).css({left:a.left-s.left-i.left,width:r,height:o})}}),V.ui.plugin.add("resizable","alsoResize",{start:function(){var t=V(this).resizable("instance").options;V(t.alsoResize).each(function(){var t=V(this);t.data("ui-resizable-alsoresize",{width:parseFloat(t.width()),height:parseFloat(t.height()),left:parseFloat(t.css("left")),top:parseFloat(t.css("top"))})})},resize:function(t,i){var e=V(this).resizable("instance"),s=e.options,n=e.originalSize,o=e.originalPosition,a={height:e.size.height-n.height||0,width:e.size.width-n.width||0,top:e.position.top-o.top||0,left:e.position.left-o.left||0};V(s.alsoResize).each(function(){var t=V(this),s=V(this).data("ui-resizable-alsoresize"),n={},e=t.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];V.each(e,function(t,e){var i=(s[e]||0)+(a[e]||0);i&&0<=i&&(n[e]=i||null)}),t.css(n)})},stop:function(){V(this).removeData("ui-resizable-alsoresize")}}),V.ui.plugin.add("resizable","ghost",{start:function(){var t=V(this).resizable("instance"),e=t.size;t.ghost=t.originalElement.clone(),t.ghost.css({opacity:.25,display:"block",position:"relative",height:e.height,width:e.width,margin:0,left:0,top:0}),t._addClass(t.ghost,"ui-resizable-ghost"),!1!==V.uiBackCompat&&"string"==typeof t.options.ghost&&t.ghost.addClass(this.options.ghost),t.ghost.appendTo(t.helper)},resize:function(){var t=V(this).resizable("instance");t.ghost&&t.ghost.css({position:"relative",height:t.size.height,width:t.size.width})},stop:function(){var t=V(this).resizable("instance");t.ghost&&t.helper&&t.helper.get(0).removeChild(t.ghost.get(0))}}),V.ui.plugin.add("resizable","grid",{resize:function(){var t,e=V(this).resizable("instance"),i=e.options,s=e.size,n=e.originalSize,o=e.originalPosition,a=e.axis,r="number"==typeof i.grid?[i.grid,i.grid]:i.grid,l=r[0]||1,h=r[1]||1,c=Math.round((s.width-n.width)/l)*l,u=Math.round((s.height-n.height)/h)*h,d=n.width+c,p=n.height+u,f=i.maxWidth&&i.maxWidth<d,g=i.maxHeight&&i.maxHeight<p,m=i.minWidth&&i.minWidth>d,s=i.minHeight&&i.minHeight>p;i.grid=r,m&&(d+=l),s&&(p+=h),f&&(d-=l),g&&(p-=h),/^(se|s|e)$/.test(a)?(e.size.width=d,e.size.height=p):/^(ne)$/.test(a)?(e.size.width=d,e.size.height=p,e.position.top=o.top-u):/^(sw)$/.test(a)?(e.size.width=d,e.size.height=p,e.position.left=o.left-c):((p-h<=0||d-l<=0)&&(t=e._getPaddingPlusBorderDimensions(this)),0<p-h?(e.size.height=p,e.position.top=o.top-u):(p=h-t.height,e.size.height=p,e.position.top=o.top+n.height-p),0<d-l?(e.size.width=d,e.position.left=o.left-c):(d=l-t.width,e.size.width=d,e.position.left=o.left+n.width-d))}});V.ui.resizable;V.widget("ui.dialog",{version:"1.13.2",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(t){var e=V(this).css(t).offset().top;e<0&&V(this).css("top",t.top-e)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&V.fn.draggable&&this._makeDraggable(),this.options.resizable&&V.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var t=this.options.appendTo;return t&&(t.jquery||t.nodeType)?V(t):this.document.find(t||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),(t=e.parent.children().eq(e.index)).length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog},disable:V.noop,enable:V.noop,close:function(t){var e=this;this._isOpen&&!1!==this._trigger("beforeClose",t)&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||V.ui.safeBlur(V.ui.safeActiveElement(this.document[0])),this._hide(this.uiDialog,this.options.hide,function(){e._trigger("close",t)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(t,e){var i=!1,s=this.uiDialog.siblings(".ui-front:visible").map(function(){return+V(this).css("z-index")}).get(),s=Math.max.apply(null,s);return s>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",s+1),i=!0),i&&!e&&this._trigger("focus",t),i},open:function(){var t=this;this._isOpen?this._moveToTop()&&this._focusTabbable():(this._isOpen=!0,this.opener=V(V.ui.safeActiveElement(this.document[0])),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){t._focusTabbable(),t._trigger("focus")}),this._makeFocusTarget(),this._trigger("open"))},_focusTabbable:function(){var t=this._focusedElement;(t=!(t=!(t=!(t=!(t=t||this.element.find("[autofocus]")).length?this.element.find(":tabbable"):t).length?this.uiDialogButtonPane.find(":tabbable"):t).length?this.uiDialogTitlebarClose.filter(":tabbable"):t).length?this.uiDialog:t).eq(0).trigger("focus")},_restoreTabbableFocus:function(){var t=V.ui.safeActiveElement(this.document[0]);this.uiDialog[0]===t||V.contains(this.uiDialog[0],t)||this._focusTabbable()},_keepFocus:function(t){t.preventDefault(),this._restoreTabbableFocus(),this._delay(this._restoreTabbableFocus)},_createWrapper:function(){this.uiDialog=V("<div>").hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(t){if(this.options.closeOnEscape&&!t.isDefaultPrevented()&&t.keyCode&&t.keyCode===V.ui.keyCode.ESCAPE)return t.preventDefault(),void this.close(t);var e,i,s;t.keyCode!==V.ui.keyCode.TAB||t.isDefaultPrevented()||(e=this.uiDialog.find(":tabbable"),i=e.first(),s=e.last(),t.target!==s[0]&&t.target!==this.uiDialog[0]||t.shiftKey?t.target!==i[0]&&t.target!==this.uiDialog[0]||!t.shiftKey||(this._delay(function(){s.trigger("focus")}),t.preventDefault()):(this._delay(function(){i.trigger("focus")}),t.preventDefault()))},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var t;this.uiDialogTitlebar=V("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(t){V(t.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=V("<button type='button'></button>").button({label:V("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}}),t=V("<span>").uniqueId().prependTo(this.uiDialogTitlebar),this._addClass(t,"ui-dialog-title"),this._title(t),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":t.attr("id")})},_title:function(t){this.options.title?t.text(this.options.title):t.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=V("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=V("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var s=this,t=this.options.buttons;this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),V.isEmptyObject(t)||Array.isArray(t)&&!t.length?this._removeClass(this.uiDialog,"ui-dialog-buttons"):(V.each(t,function(t,e){var i;e=V.extend({type:"button"},e="function"==typeof e?{click:e,text:t}:e),i=e.click,t={icon:e.icon,iconPosition:e.iconPosition,showLabel:e.showLabel,icons:e.icons,text:e.text},delete e.click,delete e.icon,delete e.iconPosition,delete e.showLabel,delete e.icons,"boolean"==typeof e.text&&delete e.text,V("<button></button>",e).button(t).appendTo(s.uiButtonSet).on("click",function(){i.apply(s.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog))},_makeDraggable:function(){var n=this,o=this.options;function a(t){return{position:t.position,offset:t.offset}}this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(t,e){n._addClass(V(this),"ui-dialog-dragging"),n._blockFrames(),n._trigger("dragStart",t,a(e))},drag:function(t,e){n._trigger("drag",t,a(e))},stop:function(t,e){var i=e.offset.left-n.document.scrollLeft(),s=e.offset.top-n.document.scrollTop();o.position={my:"left top",at:"left"+(0<=i?"+":"")+i+" top"+(0<=s?"+":"")+s,of:n.window},n._removeClass(V(this),"ui-dialog-dragging"),n._unblockFrames(),n._trigger("dragStop",t,a(e))}})},_makeResizable:function(){var n=this,o=this.options,t=o.resizable,e=this.uiDialog.css("position"),t="string"==typeof t?t:"n,e,s,w,se,sw,ne,nw";function a(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}}this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:o.maxWidth,maxHeight:o.maxHeight,minWidth:o.minWidth,minHeight:this._minHeight(),handles:t,start:function(t,e){n._addClass(V(this),"ui-dialog-resizing"),n._blockFrames(),n._trigger("resizeStart",t,a(e))},resize:function(t,e){n._trigger("resize",t,a(e))},stop:function(t,e){var i=n.uiDialog.offset(),s=i.left-n.document.scrollLeft(),i=i.top-n.document.scrollTop();o.height=n.uiDialog.height(),o.width=n.uiDialog.width(),o.position={my:"left top",at:"left"+(0<=s?"+":"")+s+" top"+(0<=i?"+":"")+i,of:n.window},n._removeClass(V(this),"ui-dialog-resizing"),n._unblockFrames(),n._trigger("resizeStop",t,a(e))}}).css("position",e)},_trackFocus:function(){this._on(this.widget(),{focusin:function(t){this._makeFocusTarget(),this._focusedElement=V(t.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var t=this._trackingInstances(),e=V.inArray(this,t);-1!==e&&t.splice(e,1)},_trackingInstances:function(){var t=this.document.data("ui-dialog-instances");return t||this.document.data("ui-dialog-instances",t=[]),t},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(t){var i=this,s=!1,n={};V.each(t,function(t,e){i._setOption(t,e),t in i.sizeRelatedOptions&&(s=!0),t in i.resizableRelatedOptions&&(n[t]=e)}),s&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",n)},_setOption:function(t,e){var i,s=this.uiDialog;"disabled"!==t&&(this._super(t,e),"appendTo"===t&&this.uiDialog.appendTo(this._appendTo()),"buttons"===t&&this._createButtons(),"closeText"===t&&this.uiDialogTitlebarClose.button({label:V("<a>").text(""+this.options.closeText).html()}),"draggable"===t&&((i=s.is(":data(ui-draggable)"))&&!e&&s.draggable("destroy"),!i&&e&&this._makeDraggable()),"position"===t&&this._position(),"resizable"===t&&((i=s.is(":data(ui-resizable)"))&&!e&&s.resizable("destroy"),i&&"string"==typeof e&&s.resizable("option","handles",e),i||!1===e||this._makeResizable()),"title"===t&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var t=V(this);return V("<div>").css({position:"absolute",width:t.outerWidth(),height:t.outerHeight()}).appendTo(t.parent()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(t){return!!V(t.target).closest(".ui-dialog").length||!!V(t.target).closest(".ui-datepicker").length},_createOverlay:function(){var i,s;this.options.modal&&(i=V.fn.jquery.substring(0,4),s=!0,this._delay(function(){s=!1}),this.document.data("ui-dialog-overlays")||this.document.on("focusin.ui-dialog",function(t){var e;s||((e=this._trackingInstances()[0])._allowInteraction(t)||(t.preventDefault(),e._focusTabbable(),"3.4."!==i&&"3.5."!==i||e._delay(e._restoreTabbableFocus)))}.bind(this)),this.overlay=V("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1))},_destroyOverlay:function(){var t;this.options.modal&&this.overlay&&((t=this.document.data("ui-dialog-overlays")-1)?this.document.data("ui-dialog-overlays",t):(this.document.off("focusin.ui-dialog"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null)}}),!1!==V.uiBackCompat&&V.widget("ui.dialog",V.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(t,e){"dialogClass"===t&&this.uiDialog.removeClass(this.options.dialogClass).addClass(e),this._superApply(arguments)}});V.ui.dialog;function lt(t,e,i){return e<=t&&t<e+i}V.widget("ui.droppable",{version:"1.13.2",widgetEventPrefix:"drop",options:{accept:"*",addClasses:!0,greedy:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var t,e=this.options,i=e.accept;this.isover=!1,this.isout=!0,this.accept="function"==typeof i?i:function(t){return t.is(i)},this.proportions=function(){if(!arguments.length)return t=t||{width:this.element[0].offsetWidth,height:this.element[0].offsetHeight};t=arguments[0]},this._addToManager(e.scope),e.addClasses&&this._addClass("ui-droppable")},_addToManager:function(t){V.ui.ddmanager.droppables[t]=V.ui.ddmanager.droppables[t]||[],V.ui.ddmanager.droppables[t].push(this)},_splice:function(t){for(var e=0;e<t.length;e++)t[e]===this&&t.splice(e,1)},_destroy:function(){var t=V.ui.ddmanager.droppables[this.options.scope];this._splice(t)},_setOption:function(t,e){var i;"accept"===t?this.accept="function"==typeof e?e:function(t){return t.is(e)}:"scope"===t&&(i=V.ui.ddmanager.droppables[this.options.scope],this._splice(i),this._addToManager(e)),this._super(t,e)},_activate:function(t){var e=V.ui.ddmanager.current;this._addActiveClass(),e&&this._trigger("activate",t,this.ui(e))},_deactivate:function(t){var e=V.ui.ddmanager.current;this._removeActiveClass(),e&&this._trigger("deactivate",t,this.ui(e))},_over:function(t){var e=V.ui.ddmanager.current;e&&(e.currentItem||e.element)[0]!==this.element[0]&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this._addHoverClass(),this._trigger("over",t,this.ui(e)))},_out:function(t){var e=V.ui.ddmanager.current;e&&(e.currentItem||e.element)[0]!==this.element[0]&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this._removeHoverClass(),this._trigger("out",t,this.ui(e)))},_drop:function(e,t){var i=t||V.ui.ddmanager.current,s=!1;return!(!i||(i.currentItem||i.element)[0]===this.element[0])&&(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var t=V(this).droppable("instance");if(t.options.greedy&&!t.options.disabled&&t.options.scope===i.options.scope&&t.accept.call(t.element[0],i.currentItem||i.element)&&V.ui.intersect(i,V.extend(t,{offset:t.element.offset()}),t.options.tolerance,e))return!(s=!0)}),!s&&(!!this.accept.call(this.element[0],i.currentItem||i.element)&&(this._removeActiveClass(),this._removeHoverClass(),this._trigger("drop",e,this.ui(i)),this.element)))},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}},_addHoverClass:function(){this._addClass("ui-droppable-hover")},_removeHoverClass:function(){this._removeClass("ui-droppable-hover")},_addActiveClass:function(){this._addClass("ui-droppable-active")},_removeActiveClass:function(){this._removeClass("ui-droppable-active")}}),V.ui.intersect=function(t,e,i,s){if(!e.offset)return!1;var n=(t.positionAbs||t.position.absolute).left+t.margins.left,o=(t.positionAbs||t.position.absolute).top+t.margins.top,a=n+t.helperProportions.width,r=o+t.helperProportions.height,l=e.offset.left,h=e.offset.top,c=l+e.proportions().width,u=h+e.proportions().height;switch(i){case"fit":return l<=n&&a<=c&&h<=o&&r<=u;case"intersect":return l<n+t.helperProportions.width/2&&a-t.helperProportions.width/2<c&&h<o+t.helperProportions.height/2&&r-t.helperProportions.height/2<u;case"pointer":return lt(s.pageY,h,e.proportions().height)&&lt(s.pageX,l,e.proportions().width);case"touch":return(h<=o&&o<=u||h<=r&&r<=u||o<h&&u<r)&&(l<=n&&n<=c||l<=a&&a<=c||n<l&&c<a);default:return!1}},!(V.ui.ddmanager={current:null,droppables:{default:[]},prepareOffsets:function(t,e){var i,s,n=V.ui.ddmanager.droppables[t.options.scope]||[],o=e?e.type:null,a=(t.currentItem||t.element).find(":data(ui-droppable)").addBack();t:for(i=0;i<n.length;i++)if(!(n[i].options.disabled||t&&!n[i].accept.call(n[i].element[0],t.currentItem||t.element))){for(s=0;s<a.length;s++)if(a[s]===n[i].element[0]){n[i].proportions().height=0;continue t}n[i].visible="none"!==n[i].element.css("display"),n[i].visible&&("mousedown"===o&&n[i]._activate.call(n[i],e),n[i].offset=n[i].element.offset(),n[i].proportions({width:n[i].element[0].offsetWidth,height:n[i].element[0].offsetHeight}))}},drop:function(t,e){var i=!1;return V.each((V.ui.ddmanager.droppables[t.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&V.ui.intersect(t,this,this.options.tolerance,e)&&(i=this._drop.call(this,e)||i),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],t.currentItem||t.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,e)))}),i},dragStart:function(t,e){t.element.parentsUntil("body").on("scroll.droppable",function(){t.options.refreshPositions||V.ui.ddmanager.prepareOffsets(t,e)})},drag:function(n,o){n.options.refreshPositions&&V.ui.ddmanager.prepareOffsets(n,o),V.each(V.ui.ddmanager.droppables[n.options.scope]||[],function(){var t,e,i,s;this.options.disabled||this.greedyChild||!this.visible||(s=!(i=V.ui.intersect(n,this,this.options.tolerance,o))&&this.isover?"isout":i&&!this.isover?"isover":null)&&(this.options.greedy&&(e=this.options.scope,(i=this.element.parents(":data(ui-droppable)").filter(function(){return V(this).droppable("instance").options.scope===e})).length&&((t=V(i[0]).droppable("instance")).greedyChild="isover"===s)),t&&"isover"===s&&(t.isover=!1,t.isout=!0,t._out.call(t,o)),this[s]=!0,this["isout"===s?"isover":"isout"]=!1,this["isover"===s?"_over":"_out"].call(this,o),t&&"isout"===s&&(t.isout=!1,t.isover=!0,t._over.call(t,o)))})},dragStop:function(t,e){t.element.parentsUntil("body").off("scroll.droppable"),t.options.refreshPositions||V.ui.ddmanager.prepareOffsets(t,e)}})!==V.uiBackCompat&&V.widget("ui.droppable",V.ui.droppable,{options:{hoverClass:!1,activeClass:!1},_addActiveClass:function(){this._super(),this.options.activeClass&&this.element.addClass(this.options.activeClass)},_removeActiveClass:function(){this._super(),this.options.activeClass&&this.element.removeClass(this.options.activeClass)},_addHoverClass:function(){this._super(),this.options.hoverClass&&this.element.addClass(this.options.hoverClass)},_removeHoverClass:function(){this._super(),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass)}});V.ui.droppable,V.widget("ui.progressbar",{version:"1.13.2",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.attr({role:"progressbar","aria-valuemin":this.min}),this._addClass("ui-progressbar","ui-widget ui-widget-content"),this.valueDiv=V("<div>").appendTo(this.element),this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header"),this._refreshValue()},_destroy:function(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"),this.valueDiv.remove()},value:function(t){if(void 0===t)return this.options.value;this.options.value=this._constrainedValue(t),this._refreshValue()},_constrainedValue:function(t){return void 0===t&&(t=this.options.value),this.indeterminate=!1===t,"number"!=typeof t&&(t=0),!this.indeterminate&&Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var t=this.options.value,e=this._percentage();this.valueDiv.toggle(this.indeterminate||t>this.min).width(e.toFixed(0)+"%"),this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,t===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=V("<div>").appendTo(this.valueDiv),this._addClass(this.overlayDiv,"ui-progressbar-overlay"))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":t}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==t&&(this.oldValue=t,this._trigger("change")),t===this.options.max&&this._trigger("complete")}}),V.widget("ui.selectable",V.ui.mouse,{version:"1.13.2",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var i=this;this._addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){i.elementPos=V(i.element[0]).offset(),i.selectees=V(i.options.filter,i.element[0]),i._addClass(i.selectees,"ui-selectee"),i.selectees.each(function(){var t=V(this),e=t.offset(),e={left:e.left-i.elementPos.left,top:e.top-i.elementPos.top};V.data(this,"selectable-item",{element:this,$element:t,left:e.left,top:e.top,right:e.left+t.outerWidth(),bottom:e.top+t.outerHeight(),startselected:!1,selected:t.hasClass("ui-selected"),selecting:t.hasClass("ui-selecting"),unselecting:t.hasClass("ui-unselecting")})})},this.refresh(),this._mouseInit(),this.helper=V("<div>"),this._addClass(this.helper,"ui-selectable-helper")},_destroy:function(){this.selectees.removeData("selectable-item"),this._mouseDestroy()},_mouseStart:function(i){var s=this,t=this.options;this.opos=[i.pageX,i.pageY],this.elementPos=V(this.element[0]).offset(),this.options.disabled||(this.selectees=V(t.filter,this.element[0]),this._trigger("start",i),V(t.appendTo).append(this.helper),this.helper.css({left:i.pageX,top:i.pageY,width:0,height:0}),t.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var t=V.data(this,"selectable-item");t.startselected=!0,i.metaKey||i.ctrlKey||(s._removeClass(t.$element,"ui-selected"),t.selected=!1,s._addClass(t.$element,"ui-unselecting"),t.unselecting=!0,s._trigger("unselecting",i,{unselecting:t.element}))}),V(i.target).parents().addBack().each(function(){var t,e=V.data(this,"selectable-item");if(e)return t=!i.metaKey&&!i.ctrlKey||!e.$element.hasClass("ui-selected"),s._removeClass(e.$element,t?"ui-unselecting":"ui-selected")._addClass(e.$element,t?"ui-selecting":"ui-unselecting"),e.unselecting=!t,e.selecting=t,(e.selected=t)?s._trigger("selecting",i,{selecting:e.element}):s._trigger("unselecting",i,{unselecting:e.element}),!1}))},_mouseDrag:function(s){if(this.dragged=!0,!this.options.disabled){var t,n=this,o=this.options,a=this.opos[0],r=this.opos[1],l=s.pageX,h=s.pageY;return l<a&&(t=l,l=a,a=t),h<r&&(t=h,h=r,r=t),this.helper.css({left:a,top:r,width:l-a,height:h-r}),this.selectees.each(function(){var t=V.data(this,"selectable-item"),e=!1,i={};t&&t.element!==n.element[0]&&(i.left=t.left+n.elementPos.left,i.right=t.right+n.elementPos.left,i.top=t.top+n.elementPos.top,i.bottom=t.bottom+n.elementPos.top,"touch"===o.tolerance?e=!(i.left>l||i.right<a||i.top>h||i.bottom<r):"fit"===o.tolerance&&(e=i.left>a&&i.right<l&&i.top>r&&i.bottom<h),e?(t.selected&&(n._removeClass(t.$element,"ui-selected"),t.selected=!1),t.unselecting&&(n._removeClass(t.$element,"ui-unselecting"),t.unselecting=!1),t.selecting||(n._addClass(t.$element,"ui-selecting"),t.selecting=!0,n._trigger("selecting",s,{selecting:t.element}))):(t.selecting&&((s.metaKey||s.ctrlKey)&&t.startselected?(n._removeClass(t.$element,"ui-selecting"),t.selecting=!1,n._addClass(t.$element,"ui-selected"),t.selected=!0):(n._removeClass(t.$element,"ui-selecting"),t.selecting=!1,t.startselected&&(n._addClass(t.$element,"ui-unselecting"),t.unselecting=!0),n._trigger("unselecting",s,{unselecting:t.element}))),t.selected&&(s.metaKey||s.ctrlKey||t.startselected||(n._removeClass(t.$element,"ui-selected"),t.selected=!1,n._addClass(t.$element,"ui-unselecting"),t.unselecting=!0,n._trigger("unselecting",s,{unselecting:t.element})))))}),!1}},_mouseStop:function(e){var i=this;return this.dragged=!1,V(".ui-unselecting",this.element[0]).each(function(){var t=V.data(this,"selectable-item");i._removeClass(t.$element,"ui-unselecting"),t.unselecting=!1,t.startselected=!1,i._trigger("unselected",e,{unselected:t.element})}),V(".ui-selecting",this.element[0]).each(function(){var t=V.data(this,"selectable-item");i._removeClass(t.$element,"ui-selecting")._addClass(t.$element,"ui-selected"),t.selecting=!1,t.selected=!0,t.startselected=!0,i._trigger("selected",e,{selected:t.element})}),this._trigger("stop",e),this.helper.remove(),!1}}),V.widget("ui.selectmenu",[V.ui.formResetMixin,{version:"1.13.2",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:!1,change:null,close:null,focus:null,open:null,select:null},_create:function(){var t=this.element.uniqueId().attr("id");this.ids={element:t,button:t+"-button",menu:t+"-menu"},this._drawButton(),this._drawMenu(),this._bindFormResetHandler(),this._rendered=!1,this.menuItems=V()},_drawButton:function(){var t,e=this,i=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);this.labels=this.element.labels().attr("for",this.ids.button),this._on(this.labels,{click:function(t){this.button.trigger("focus"),t.preventDefault()}}),this.element.hide(),this.button=V("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element),this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget"),t=V("<span>").appendTo(this.button),this._addClass(t,"ui-selectmenu-icon","ui-icon "+this.options.icons.button),this.buttonItem=this._renderButtonItem(i).appendTo(this.button),!1!==this.options.width&&this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one("focusin",function(){e._rendered||e._refreshMenu()})},_drawMenu:function(){var i=this;this.menu=V("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu}),this.menuWrap=V("<div>").append(this.menu),this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front"),this.menuWrap.appendTo(this._appendTo()),this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function(t,e){t.preventDefault(),i._setSelection(),i._select(e.item.data("ui-selectmenu-item"),t)},focus:function(t,e){e=e.item.data("ui-selectmenu-item");null!=i.focusIndex&&e.index!==i.focusIndex&&(i._trigger("focus",t,{item:e}),i.isOpen||i._select(e,t)),i.focusIndex=e.index,i.button.attr("aria-activedescendant",i.menuItems.eq(e.index).attr("id"))}}).menu("instance"),this.menuInstance._off(this.menu,"mouseleave"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item")||{})),null===this.options.width&&this._resizeButton()},_refreshMenu:function(){var t=this.element.find("option");this.menu.empty(),this._parseOptions(t),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"),this._rendered=!0,t.length&&(t=this._getSelectedItem(),this.menuInstance.focus(null,t),this._setAria(t.data("ui-selectmenu-item")),this._setOption("disabled",this.element.prop("disabled")))},open:function(t){this.options.disabled||(this._rendered?(this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.menuItems.length&&(this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger("open",t)))},_position:function(){this.menuWrap.position(V.extend({of:this.button},this.options.position))},close:function(t){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger("close",t))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderButtonItem:function(t){var e=V("<span>");return this._setText(e,t.label),this._addClass(e,"ui-selectmenu-text"),e},_renderMenu:function(s,t){var n=this,o="";V.each(t,function(t,e){var i;e.optgroup!==o&&(i=V("<li>",{text:e.optgroup}),n._addClass(i,"ui-selectmenu-optgroup","ui-menu-divider"+(e.element.parent("optgroup").prop("disabled")?" ui-state-disabled":"")),i.appendTo(s),o=e.optgroup),n._renderItemData(s,e)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-selectmenu-item",e)},_renderItem:function(t,e){var i=V("<li>"),s=V("<div>",{title:e.element.attr("title")});return e.disabled&&this._addClass(i,null,"ui-state-disabled"),this._setText(s,e.label),i.append(s).appendTo(t)},_setText:function(t,e){e?t.text(e):t.html("&#160;")},_move:function(t,e){var i,s=".ui-menu-item";this.isOpen?i=this.menuItems.eq(this.focusIndex).parent("li"):(i=this.menuItems.eq(this.element[0].selectedIndex).parent("li"),s+=":not(.ui-state-disabled)"),(s="first"===t||"last"===t?i["first"===t?"prevAll":"nextAll"](s).eq(-1):i[t+"All"](s).eq(0)).length&&this.menuInstance.focus(e,s)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li")},_toggle:function(t){this[this.isOpen?"close":"open"](t)},_setSelection:function(){var t;this.range&&(window.getSelection?((t=window.getSelection()).removeAllRanges(),t.addRange(this.range)):this.range.select(),this.button.trigger("focus"))},_documentClick:{mousedown:function(t){this.isOpen&&(V(t.target).closest(".ui-selectmenu-menu, #"+V.escapeSelector(this.ids.button)).length||this.close(t))}},_buttonEvents:{mousedown:function(){var t;window.getSelection?(t=window.getSelection()).rangeCount&&(this.range=t.getRangeAt(0)):this.range=document.selection.createRange()},click:function(t){this._setSelection(),this._toggle(t)},keydown:function(t){var e=!0;switch(t.keyCode){case V.ui.keyCode.TAB:case V.ui.keyCode.ESCAPE:this.close(t),e=!1;break;case V.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(t);break;case V.ui.keyCode.UP:t.altKey?this._toggle(t):this._move("prev",t);break;case V.ui.keyCode.DOWN:t.altKey?this._toggle(t):this._move("next",t);break;case V.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(t):this._toggle(t);break;case V.ui.keyCode.LEFT:this._move("prev",t);break;case V.ui.keyCode.RIGHT:this._move("next",t);break;case V.ui.keyCode.HOME:case V.ui.keyCode.PAGE_UP:this._move("first",t);break;case V.ui.keyCode.END:case V.ui.keyCode.PAGE_DOWN:this._move("last",t);break;default:this.menu.trigger(t),e=!1}e&&t.preventDefault()}},_selectFocusedItem:function(t){var e=this.menuItems.eq(this.focusIndex).parent("li");e.hasClass("ui-state-disabled")||this._select(e.data("ui-selectmenu-item"),t)},_select:function(t,e){var i=this.element[0].selectedIndex;this.element[0].selectedIndex=t.index,this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(t)),this._setAria(t),this._trigger("select",e,{item:t}),t.index!==i&&this._trigger("change",e,{item:t}),this.close(e)},_setAria:function(t){t=this.menuItems.eq(t.index).attr("id");this.button.attr({"aria-labelledby":t,"aria-activedescendant":t}),this.menu.attr("aria-activedescendant",t)},_setOption:function(t,e){var i;"icons"===t&&(i=this.button.find("span.ui-icon"),this._removeClass(i,null,this.options.icons.button)._addClass(i,null,e.button)),this._super(t,e),"appendTo"===t&&this.menuWrap.appendTo(this._appendTo()),"width"===t&&this._resizeButton()},_setOptionDisabled:function(t){this._super(t),this.menuInstance.option("disabled",t),this.button.attr("aria-disabled",t),this._toggleClass(this.button,null,"ui-state-disabled",t),this.element.prop("disabled",t),t?(this.button.attr("tabindex",-1),this.close()):this.button.attr("tabindex",0)},_appendTo:function(){var t=this.options.appendTo;return t=!(t=!(t=t&&(t.jquery||t.nodeType?V(t):this.document.find(t).eq(0)))||!t[0]?this.element.closest(".ui-front, dialog"):t).length?this.document[0].body:t},_toggleAttr:function(){this.button.attr("aria-expanded",this.isOpen),this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen),this.menu.attr("aria-hidden",!this.isOpen)},_resizeButton:function(){var t=this.options.width;!1!==t?(null===t&&(t=this.element.show().outerWidth(),this.element.hide()),this.button.outerWidth(t)):this.button.css("width","")},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width("").outerWidth()+1))},_getCreateOptions:function(){var t=this._super();return t.disabled=this.element.prop("disabled"),t},_parseOptions:function(t){var i=this,s=[];t.each(function(t,e){e.hidden||s.push(i._parseOption(V(e),t))}),this.items=s},_parseOption:function(t,e){var i=t.parent("optgroup");return{element:t,index:e,value:t.val(),label:t.text(),optgroup:i.attr("label")||"",disabled:i.prop("disabled")||t.prop("disabled")}},_destroy:function(){this._unbindFormResetHandler(),this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.labels.attr("for",this.ids.element)}}]),V.widget("ui.slider",V.ui.mouse,{version:"1.13.2",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,e=this.options,i=this.element.find(".ui-slider-handle"),s=[],n=e.values&&e.values.length||1;for(i.length>n&&(i.slice(n).remove(),i=i.slice(0,n)),t=i.length;t<n;t++)s.push("<span tabindex='0'></span>");this.handles=i.add(V(s.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(t){V(this).data("ui-slider-handle-index",t).attr("tabIndex",0)})},_createRange:function(){var t=this.options;t.range?(!0===t.range&&(t.values?t.values.length&&2!==t.values.length?t.values=[t.values[0],t.values[0]]:Array.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=V("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),"min"!==t.range&&"max"!==t.range||this._addClass(this.range,"ui-slider-range-"+t.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(t){var i,s,n,o,e,a,r=this,l=this.options;return!l.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),a={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(a),s=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var e=Math.abs(i-r.values(t));(e<s||s===e&&(t===r._lastChangedValue||r.values(t)===l.min))&&(s=e,n=V(this),o=t)}),!1!==this._start(t,o)&&(this._mouseSliding=!0,this._handleIndex=o,this._addClass(n,null,"ui-state-active"),n.trigger("focus"),e=n.offset(),a=!V(t.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=a?{left:0,top:0}:{left:t.pageX-e.left-n.width()/2,top:t.pageY-e.top-n.height()/2-(parseInt(n.css("borderTopWidth"),10)||0)-(parseInt(n.css("borderBottomWidth"),10)||0)+(parseInt(n.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(t,o,i),this._animateOff=!0))},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},e=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,e),!1},_mouseStop:function(t){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,t="horizontal"===this.orientation?(e=this.elementSize.width,t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),t=t/e;return(t=1<t?1:t)<0&&(t=0),"vertical"===this.orientation&&(t=1-t),e=this._valueMax()-this._valueMin(),e=this._valueMin()+t*e,this._trimAlignValue(e)},_uiHash:function(t,e,i){var s={handle:this.handles[t],handleIndex:t,value:void 0!==e?e:this.value()};return this._hasMultipleValues()&&(s.value=void 0!==e?e:this.values(t),s.values=i||this.values()),s},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(t,e){return this._trigger("start",t,this._uiHash(e))},_slide:function(t,e,i){var s,n=this.value(),o=this.values();this._hasMultipleValues()&&(s=this.values(e?0:1),n=this.values(e),2===this.options.values.length&&!0===this.options.range&&(i=0===e?Math.min(s,i):Math.max(s,i)),o[e]=i),i!==n&&!1!==this._trigger("slide",t,this._uiHash(e,i,o))&&(this._hasMultipleValues()?this.values(e,i):this.value(i))},_stop:function(t,e){this._trigger("stop",t,this._uiHash(e))},_change:function(t,e){this._keySliding||this._mouseSliding||(this._lastChangedValue=e,this._trigger("change",t,this._uiHash(e)))},value:function(t){return arguments.length?(this.options.value=this._trimAlignValue(t),this._refreshValue(),void this._change(null,0)):this._value()},values:function(t,e){var i,s,n;if(1<arguments.length)return this.options.values[t]=this._trimAlignValue(e),this._refreshValue(),void this._change(null,t);if(!arguments.length)return this._values();if(!Array.isArray(t))return this._hasMultipleValues()?this._values(t):this.value();for(i=this.options.values,s=t,n=0;n<i.length;n+=1)i[n]=this._trimAlignValue(s[n]),this._change(null,n);this._refreshValue()},_setOption:function(t,e){var i,s=0;switch("range"===t&&!0===this.options.range&&("min"===e?(this.options.value=this._values(0),this.options.values=null):"max"===e&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),Array.isArray(this.options.values)&&(s=this.options.values.length),this._super(t,e),t){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(e),this.handles.css("horizontal"===e?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),i=s-1;0<=i;i--)this._change(null,i);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(t){this._super(t),this._toggleClass(null,"ui-state-disabled",!!t)},_value:function(){var t=this.options.value;return t=this._trimAlignValue(t)},_values:function(t){var e,i;if(arguments.length)return t=this.options.values[t],t=this._trimAlignValue(t);if(this._hasMultipleValues()){for(e=this.options.values.slice(),i=0;i<e.length;i+=1)e[i]=this._trimAlignValue(e[i]);return e}return[]},_trimAlignValue:function(t){if(t<=this._valueMin())return this._valueMin();if(t>=this._valueMax())return this._valueMax();var e=0<this.options.step?this.options.step:1,i=(t-this._valueMin())%e,t=t-i;return 2*Math.abs(i)>=e&&(t+=0<i?e:-e),parseFloat(t.toFixed(5))},_calculateNewMax:function(){var t=this.options.max,e=this._valueMin(),i=this.options.step;(t=Math.round((t-e)/i)*i+e)>this.options.max&&(t-=i),this.max=parseFloat(t.toFixed(this._precision()))},_precision:function(){var t=this._precisionOf(this.options.step);return t=null!==this.options.min?Math.max(t,this._precisionOf(this.options.min)):t},_precisionOf:function(t){var e=t.toString(),t=e.indexOf(".");return-1===t?0:e.length-t-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(t){"vertical"===t&&this.range.css({width:"",left:""}),"horizontal"===t&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var e,i,t,s,n,o=this.options.range,a=this.options,r=this,l=!this._animateOff&&a.animate,h={};this._hasMultipleValues()?this.handles.each(function(t){i=(r.values(t)-r._valueMin())/(r._valueMax()-r._valueMin())*100,h["horizontal"===r.orientation?"left":"bottom"]=i+"%",V(this).stop(1,1)[l?"animate":"css"](h,a.animate),!0===r.options.range&&("horizontal"===r.orientation?(0===t&&r.range.stop(1,1)[l?"animate":"css"]({left:i+"%"},a.animate),1===t&&r.range[l?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:a.animate})):(0===t&&r.range.stop(1,1)[l?"animate":"css"]({bottom:i+"%"},a.animate),1===t&&r.range[l?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:a.animate}))),e=i}):(t=this.value(),s=this._valueMin(),n=this._valueMax(),i=n!==s?(t-s)/(n-s)*100:0,h["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[l?"animate":"css"](h,a.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:i+"%"},a.animate),"max"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:100-i+"%"},a.animate),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:i+"%"},a.animate),"max"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:100-i+"%"},a.animate))},_handleEvents:{keydown:function(t){var e,i,s,n=V(t.target).data("ui-slider-handle-index");switch(t.keyCode){case V.ui.keyCode.HOME:case V.ui.keyCode.END:case V.ui.keyCode.PAGE_UP:case V.ui.keyCode.PAGE_DOWN:case V.ui.keyCode.UP:case V.ui.keyCode.RIGHT:case V.ui.keyCode.DOWN:case V.ui.keyCode.LEFT:if(t.preventDefault(),!this._keySliding&&(this._keySliding=!0,this._addClass(V(t.target),null,"ui-state-active"),!1===this._start(t,n)))return}switch(s=this.options.step,e=i=this._hasMultipleValues()?this.values(n):this.value(),t.keyCode){case V.ui.keyCode.HOME:i=this._valueMin();break;case V.ui.keyCode.END:i=this._valueMax();break;case V.ui.keyCode.PAGE_UP:i=this._trimAlignValue(e+(this._valueMax()-this._valueMin())/this.numPages);break;case V.ui.keyCode.PAGE_DOWN:i=this._trimAlignValue(e-(this._valueMax()-this._valueMin())/this.numPages);break;case V.ui.keyCode.UP:case V.ui.keyCode.RIGHT:if(e===this._valueMax())return;i=this._trimAlignValue(e+s);break;case V.ui.keyCode.DOWN:case V.ui.keyCode.LEFT:if(e===this._valueMin())return;i=this._trimAlignValue(e-s)}this._slide(t,n,i)},keyup:function(t){var e=V(t.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(t,e),this._change(t,e),this._removeClass(V(t.target),null,"ui-state-active"))}}}),V.widget("ui.sortable",V.ui.mouse,{version:"1.13.2",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return e<=t&&t<e+i},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){var t=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),V.each(this.items,function(){t._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var t=this.items.length-1;0<=t;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(t,e){var i=null,s=!1,n=this;return!this.reverting&&(!this.options.disabled&&"static"!==this.options.type&&(this._refreshItems(t),V(t.target).parents().each(function(){if(V.data(this,n.widgetName+"-item")===n)return i=V(this),!1}),!!(i=V.data(t.target,n.widgetName+"-item")===n?V(t.target):i)&&(!(this.options.handle&&!e&&(V(this.options.handle,i).find("*").addBack().each(function(){this===t.target&&(s=!0)}),!s))&&(this.currentItem=i,this._removeCurrentsFromItems(),!0))))},_mouseStart:function(t,e,i){var s,n,o=this.options;if((this.currentContainer=this).refreshPositions(),this.appendTo=V("parent"!==o.appendTo?o.appendTo:this.currentItem.parent()),this.helper=this._createHelper(t),this._cacheHelperProportions(),this._cacheMargins(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},V.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),this.scrollParent=this.placeholder.scrollParent(),V.extend(this.offset,{parent:this._getParentOffset()}),o.containment&&this._setContainment(),o.cursor&&"auto"!==o.cursor&&(n=this.document.find("body"),this.storedCursor=n.css("cursor"),n.css("cursor",o.cursor),this.storedStylesheet=V("<style>*{ cursor: "+o.cursor+" !important; }</style>").appendTo(n)),o.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",o.zIndex)),o.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",o.opacity)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",t,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!i)for(s=this.containers.length-1;0<=s;s--)this.containers[s]._trigger("activate",t,this._uiHash(this));return V.ui.ddmanager&&(V.ui.ddmanager.current=this),V.ui.ddmanager&&!o.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this.helper.parent().is(this.appendTo)||(this.helper.detach().appendTo(this.appendTo),this.offset.parent=this._getParentOffset()),this.position=this.originalPosition=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,this.lastPositionAbs=this.positionAbs=this._convertPositionTo("absolute"),this._mouseDrag(t),!0},_scroll:function(t){var e=this.options,i=!1;return this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-t.pageY<e.scrollSensitivity?this.scrollParent[0].scrollTop=i=this.scrollParent[0].scrollTop+e.scrollSpeed:t.pageY-this.overflowOffset.top<e.scrollSensitivity&&(this.scrollParent[0].scrollTop=i=this.scrollParent[0].scrollTop-e.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-t.pageX<e.scrollSensitivity?this.scrollParent[0].scrollLeft=i=this.scrollParent[0].scrollLeft+e.scrollSpeed:t.pageX-this.overflowOffset.left<e.scrollSensitivity&&(this.scrollParent[0].scrollLeft=i=this.scrollParent[0].scrollLeft-e.scrollSpeed)):(t.pageY-this.document.scrollTop()<e.scrollSensitivity?i=this.document.scrollTop(this.document.scrollTop()-e.scrollSpeed):this.window.height()-(t.pageY-this.document.scrollTop())<e.scrollSensitivity&&(i=this.document.scrollTop(this.document.scrollTop()+e.scrollSpeed)),t.pageX-this.document.scrollLeft()<e.scrollSensitivity?i=this.document.scrollLeft(this.document.scrollLeft()-e.scrollSpeed):this.window.width()-(t.pageX-this.document.scrollLeft())<e.scrollSensitivity&&(i=this.document.scrollLeft(this.document.scrollLeft()+e.scrollSpeed))),i},_mouseDrag:function(t){var e,i,s,n,o=this.options;for(this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),o.scroll&&!1!==this._scroll(t)&&(this._refreshItemPositions(!0),V.ui.ddmanager&&!o.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t)),this.dragDirection={vertical:this._getDragVerticalDirection(),horizontal:this._getDragHorizontalDirection()},e=this.items.length-1;0<=e;e--)if(s=(i=this.items[e]).item[0],(n=this._intersectsWithPointer(i))&&i.instance===this.currentContainer&&!(s===this.currentItem[0]||this.placeholder[1===n?"next":"prev"]()[0]===s||V.contains(this.placeholder[0],s)||"semi-dynamic"===this.options.type&&V.contains(this.element[0],s))){if(this.direction=1===n?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(i))break;this._rearrange(t,i),this._trigger("change",t,this._uiHash());break}return this._contactContainers(t),V.ui.ddmanager&&V.ui.ddmanager.drag(this,t),this._trigger("sort",t,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(t,e){var i,s,n,o;if(t)return V.ui.ddmanager&&!this.options.dropBehaviour&&V.ui.ddmanager.drop(this,t),this.options.revert?(s=(i=this).placeholder.offset(),o={},(n=this.options.axis)&&"x"!==n||(o.left=s.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),n&&"y"!==n||(o.top=s.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,V(this.helper).animate(o,parseInt(this.options.revert,10)||500,function(){i._clear(t)})):this._clear(t,e),!1},cancel:function(){if(this.dragging){this._mouseUp(new V.Event("mouseup",{target:null})),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var t=this.containers.length-1;0<=t;t--)this.containers[t]._trigger("deactivate",null,this._uiHash(this)),this.containers[t].containerCache.over&&(this.containers[t]._trigger("out",null,this._uiHash(this)),this.containers[t].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),V.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?V(this.domPosition.prev).after(this.currentItem):V(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var t=this._getItemsAsjQuery(e&&e.connected),i=[];return e=e||{},V(t).each(function(){var t=(V(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);t&&i.push((e.key||t[1]+"[]")+"="+(e.key&&e.expression?t[1]:t[2]))}),!i.length&&e.key&&i.push(e.key+"="),i.join("&")},toArray:function(t){var e=this._getItemsAsjQuery(t&&t.connected),i=[];return t=t||{},e.each(function(){i.push(V(t.item||this).attr(t.attribute||"id")||"")}),i},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,h="x"===this.options.axis||r<s+h&&s+h<l,c="y"===this.options.axis||o<e+c&&e+c<a;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?h&&c:o<e+this.helperProportions.width/2&&i-this.helperProportions.width/2<a&&r<s+this.helperProportions.height/2&&n-this.helperProportions.height/2<l},_intersectsWithPointer:function(t){var e="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),t="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width);return!(!e||!t)&&(e=this.dragDirection.vertical,t=this.dragDirection.horizontal,this.floating?"right"===t||"down"===e?2:1:e&&("down"===e?2:1))},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),i=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),s=this.dragDirection.vertical,t=this.dragDirection.horizontal;return this.floating&&t?"right"===t&&i||"left"===t&&!i:s&&("down"===s&&e||"up"===s&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!=t&&(0<t?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!=t&&(0<t?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(t){var e,i,s,n,o=[],a=[],r=this._connectWith();if(r&&t)for(e=r.length-1;0<=e;e--)for(i=(s=V(r[e],this.document[0])).length-1;0<=i;i--)(n=V.data(s[i],this.widgetFullName))&&n!==this&&!n.options.disabled&&a.push(["function"==typeof n.options.items?n.options.items.call(n.element):V(n.options.items,n.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),n]);function l(){o.push(this)}for(a.push(["function"==typeof this.options.items?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):V(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),e=a.length-1;0<=e;e--)a[e][0].each(l);return V(o)},_removeCurrentsFromItems:function(){var i=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=V.grep(this.items,function(t){for(var e=0;e<i.length;e++)if(i[e]===t.item[0])return!1;return!0})},_refreshItems:function(t){this.items=[],this.containers=[this];var e,i,s,n,o,a,r,l,h=this.items,c=[["function"==typeof this.options.items?this.options.items.call(this.element[0],t,{item:this.currentItem}):V(this.options.items,this.element),this]],u=this._connectWith();if(u&&this.ready)for(e=u.length-1;0<=e;e--)for(i=(s=V(u[e],this.document[0])).length-1;0<=i;i--)(n=V.data(s[i],this.widgetFullName))&&n!==this&&!n.options.disabled&&(c.push(["function"==typeof n.options.items?n.options.items.call(n.element[0],t,{item:this.currentItem}):V(n.options.items,n.element),n]),this.containers.push(n));for(e=c.length-1;0<=e;e--)for(o=c[e][1],l=(a=c[e][i=0]).length;i<l;i++)(r=V(a[i])).data(this.widgetName+"-item",o),h.push({item:r,instance:o,width:0,height:0,left:0,top:0})},_refreshItemPositions:function(t){for(var e,i,s=this.items.length-1;0<=s;s--)e=this.items[s],this.currentContainer&&e.instance!==this.currentContainer&&e.item[0]!==this.currentItem[0]||(i=this.options.toleranceElement?V(this.options.toleranceElement,e.item):e.item,t||(e.width=i.outerWidth(),e.height=i.outerHeight()),i=i.offset(),e.left=i.left,e.top=i.top)},refreshPositions:function(t){var e,i;if(this.floating=!!this.items.length&&("x"===this.options.axis||this._isFloating(this.items[0].item)),this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset()),this._refreshItemPositions(t),this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(e=this.containers.length-1;0<=e;e--)i=this.containers[e].element.offset(),this.containers[e].containerCache.left=i.left,this.containers[e].containerCache.top=i.top,this.containers[e].containerCache.width=this.containers[e].element.outerWidth(),this.containers[e].containerCache.height=this.containers[e].element.outerHeight();return this},_createPlaceholder:function(i){var s,n,o=(i=i||this).options;o.placeholder&&o.placeholder.constructor!==String||(s=o.placeholder,n=i.currentItem[0].nodeName.toLowerCase(),o.placeholder={element:function(){var t=V("<"+n+">",i.document[0]);return i._addClass(t,"ui-sortable-placeholder",s||i.currentItem[0].className)._removeClass(t,"ui-sortable-helper"),"tbody"===n?i._createTrPlaceholder(i.currentItem.find("tr").eq(0),V("<tr>",i.document[0]).appendTo(t)):"tr"===n?i._createTrPlaceholder(i.currentItem,t):"img"===n&&t.attr("src",i.currentItem.attr("src")),s||t.css("visibility","hidden"),t},update:function(t,e){s&&!o.forcePlaceholderSize||(e.height()&&(!o.forcePlaceholderSize||"tbody"!==n&&"tr"!==n)||e.height(i.currentItem.innerHeight()-parseInt(i.currentItem.css("paddingTop")||0,10)-parseInt(i.currentItem.css("paddingBottom")||0,10)),e.width()||e.width(i.currentItem.innerWidth()-parseInt(i.currentItem.css("paddingLeft")||0,10)-parseInt(i.currentItem.css("paddingRight")||0,10)))}}),i.placeholder=V(o.placeholder.element.call(i.element,i.currentItem)),i.currentItem.after(i.placeholder),o.placeholder.update(i,i.placeholder)},_createTrPlaceholder:function(t,e){var i=this;t.children().each(function(){V("<td>&#160;</td>",i.document[0]).attr("colspan",V(this).attr("colspan")||1).appendTo(e)})},_contactContainers:function(t){for(var e,i,s,n,o,a,r,l,h,c=null,u=null,d=this.containers.length-1;0<=d;d--)V.contains(this.currentItem[0],this.containers[d].element[0])||(this._intersectsWith(this.containers[d].containerCache)?c&&V.contains(this.containers[d].element[0],c.element[0])||(c=this.containers[d],u=d):this.containers[d].containerCache.over&&(this.containers[d]._trigger("out",t,this._uiHash(this)),this.containers[d].containerCache.over=0));if(c)if(1===this.containers.length)this.containers[u].containerCache.over||(this.containers[u]._trigger("over",t,this._uiHash(this)),this.containers[u].containerCache.over=1);else{for(i=1e4,s=null,n=(l=c.floating||this._isFloating(this.currentItem))?"left":"top",o=l?"width":"height",h=l?"pageX":"pageY",e=this.items.length-1;0<=e;e--)V.contains(this.containers[u].element[0],this.items[e].item[0])&&this.items[e].item[0]!==this.currentItem[0]&&(a=this.items[e].item.offset()[n],r=!1,t[h]-a>this.items[e][o]/2&&(r=!0),Math.abs(t[h]-a)<i&&(i=Math.abs(t[h]-a),s=this.items[e],this.direction=r?"up":"down"));(s||this.options.dropOnEmpty)&&(this.currentContainer!==this.containers[u]?(s?this._rearrange(t,s,null,!0):this._rearrange(t,null,this.containers[u].element,!0),this._trigger("change",t,this._uiHash()),this.containers[u]._trigger("change",t,this._uiHash(this)),this.currentContainer=this.containers[u],this.options.placeholder.update(this.currentContainer,this.placeholder),this.scrollParent=this.placeholder.scrollParent(),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this.containers[u]._trigger("over",t,this._uiHash(this)),this.containers[u].containerCache.over=1):this.currentContainer.containerCache.over||(this.containers[u]._trigger("over",t,this._uiHash()),this.currentContainer.containerCache.over=1))}},_createHelper:function(t){var e=this.options,t="function"==typeof e.helper?V(e.helper.apply(this.element[0],[t,this.currentItem])):"clone"===e.helper?this.currentItem.clone():this.currentItem;return t.parents("body").length||this.appendTo[0].appendChild(t[0]),t[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),t[0].style.width&&!e.forceHelperSize||t.width(this.currentItem.width()),t[0].style.height&&!e.forceHelperSize||t.height(this.currentItem.height()),t},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),"left"in(t=Array.isArray(t)?{left:+t[0],top:+t[1]||0}:t)&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var t=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),{top:(t=this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&V.ui.ie?{top:0,left:0}:t).top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,e,i=this.options;"parent"===i.containment&&(i.containment=this.helper[0].parentNode),"document"!==i.containment&&"window"!==i.containment||(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===i.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===i.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(i.containment)||(t=V(i.containment)[0],e=V(i.containment).offset(),i="hidden"!==V(t).css("overflow"),this.containment=[e.left+(parseInt(V(t).css("borderLeftWidth"),10)||0)+(parseInt(V(t).css("paddingLeft"),10)||0)-this.margins.left,e.top+(parseInt(V(t).css("borderTopWidth"),10)||0)+(parseInt(V(t).css("paddingTop"),10)||0)-this.margins.top,e.left+(i?Math.max(t.scrollWidth,t.offsetWidth):t.offsetWidth)-(parseInt(V(t).css("borderLeftWidth"),10)||0)-(parseInt(V(t).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,e.top+(i?Math.max(t.scrollHeight,t.offsetHeight):t.offsetHeight)-(parseInt(V(t).css("borderTopWidth"),10)||0)-(parseInt(V(t).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(t,e){e=e||this.position;var i="absolute"===t?1:-1,s="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,t=/(html|body)/i.test(s[0].tagName);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():t?0:s.scrollTop())*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():t?0:s.scrollLeft())*i}},_generatePosition:function(t){var e=this.options,i=t.pageX,s=t.pageY,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(t.pageX-this.offset.click.left<this.containment[0]&&(i=this.containment[0]+this.offset.click.left),t.pageY-this.offset.click.top<this.containment[1]&&(s=this.containment[1]+this.offset.click.top),t.pageX-this.offset.click.left>this.containment[2]&&(i=this.containment[2]+this.offset.click.left),t.pageY-this.offset.click.top>this.containment[3]&&(s=this.containment[3]+this.offset.click.top)),e.grid&&(t=this.originalPageY+Math.round((s-this.originalPageY)/e.grid[1])*e.grid[1],s=!this.containment||t-this.offset.click.top>=this.containment[1]&&t-this.offset.click.top<=this.containment[3]?t:t-this.offset.click.top>=this.containment[1]?t-e.grid[1]:t+e.grid[1],t=this.originalPageX+Math.round((i-this.originalPageX)/e.grid[0])*e.grid[0],i=!this.containment||t-this.offset.click.left>=this.containment[0]&&t-this.offset.click.left<=this.containment[2]?t:t-this.offset.click.left>=this.containment[0]?t-e.grid[0]:t+e.grid[0])),{top:s-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop()),left:i-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){this.reverting=!1;var i,s=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(i in this._storedCSS)"auto"!==this._storedCSS[i]&&"static"!==this._storedCSS[i]||(this._storedCSS[i]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();function n(e,i,s){return function(t){s._trigger(e,t,i._uiHash(i))}}for(this.fromOutside&&!e&&s.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||s.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(s.push(function(t){this._trigger("remove",t,this._uiHash())}),s.push(function(e){return function(t){e._trigger("receive",t,this._uiHash(this))}}.call(this,this.currentContainer)),s.push(function(e){return function(t){e._trigger("update",t,this._uiHash(this))}}.call(this,this.currentContainer)))),i=this.containers.length-1;0<=i;i--)e||s.push(n("deactivate",this,this.containers[i])),this.containers[i].containerCache.over&&(s.push(n("out",this,this.containers[i])),this.containers[i].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(i=0;i<s.length;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){!1===V.Widget.prototype._trigger.apply(this,arguments)&&this.cancel()},_uiHash:function(t){var e=t||this;return{helper:e.helper,placeholder:e.placeholder||V([]),position:e.position,originalPosition:e.originalPosition,offset:e.positionAbs,item:e.currentItem,sender:t?t.element:null}}});function ht(e){return function(){var t=this.element.val();e.apply(this,arguments),this._refresh(),t!==this.element.val()&&this._trigger("change")}}V.widget("ui.spinner",{version:"1.13.2",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var s=this._super(),n=this.element;return V.each(["min","max","step"],function(t,e){var i=n.attr(e);null!=i&&i.length&&(s[e]=i)}),s},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){this.cancelBlur?delete this.cancelBlur:(this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t))},mousewheel:function(t,e){var i=V.ui.safeActiveElement(this.document[0]);if(this.element[0]===i&&e){if(!this.spinning&&!this._start(t))return!1;this._spin((0<e?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(t){var e;function i(){this.element[0]===V.ui.safeActiveElement(this.document[0])||(this.element.trigger("focus"),this.previous=e,this._delay(function(){this.previous=e}))}e=this.element[0]===V.ui.safeActiveElement(this.document[0])?this.previous:this.element.val(),t.preventDefault(),i.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,i.call(this)}),!1!==this._start(t)&&this._repeat(null,V(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(t){if(V(t.currentTarget).hasClass("ui-state-active"))return!1!==this._start(t)&&void this._repeat(null,V(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseleave .ui-spinner-button":"_stop"},_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent().append("<a></a><a></a>")},_draw:function(){this._enhance(),this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content"),this._addClass("ui-spinner-input"),this.element.attr("role","spinbutton"),this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",!0).button({classes:{"ui-button":""}}),this._removeClass(this.buttons,"ui-corner-all"),this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up"),this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down"),this.buttons.first().button({icon:this.options.icons.up,showLabel:!1}),this.buttons.last().button({icon:this.options.icons.down,showLabel:!1}),this.buttons.height()>Math.ceil(.5*this.uiSpinner.height())&&0<this.uiSpinner.height()&&this.uiSpinner.height(this.uiSpinner.height())},_keydown:function(t){var e=this.options,i=V.ui.keyCode;switch(t.keyCode){case i.UP:return this._repeat(null,1,t),!0;case i.DOWN:return this._repeat(null,-1,t),!0;case i.PAGE_UP:return this._repeat(null,e.page,t),!0;case i.PAGE_DOWN:return this._repeat(null,-e.page,t),!0}return!1},_start:function(t){return!(!this.spinning&&!1===this._trigger("start",t))&&(this.counter||(this.counter=1),this.spinning=!0)},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&!1===this._trigger("spin",e,{value:i})||(this._value(i),this.counter++)},_increment:function(t){var e=this.options.incremental;return e?"function"==typeof e?e(t):Math.floor(t*t*t/5e4-t*t/500+17*t/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return t=null!==this.options.min?Math.max(t,this._precisionOf(this.options.min)):t},_precisionOf:function(t){var e=t.toString(),t=e.indexOf(".");return-1===t?0:e.length-t-1},_adjustValue:function(t){var e=this.options,i=null!==e.min?e.min:0,s=t-i;return t=i+Math.round(s/e.step)*e.step,t=parseFloat(t.toFixed(this._precision())),null!==e.max&&t>e.max?e.max:null!==e.min&&t<e.min?e.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){var i;if("culture"===t||"numberFormat"===t)return i=this._parse(this.element.val()),this.options[t]=e,void this.element.val(this._format(i));"max"!==t&&"min"!==t&&"step"!==t||"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(i=this.buttons.first().find(".ui-icon"),this._removeClass(i,null,this.options.icons.up),this._addClass(i,null,e.up),i=this.buttons.last().find(".ui-icon"),this._removeClass(i,null,this.options.icons.down),this._addClass(i,null,e.down)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!t),this.element.prop("disabled",!!t),this.buttons.button(t?"disable":"enable")},_setOptions:ht(function(t){this._super(t)}),_parse:function(t){return""===(t="string"==typeof t&&""!==t?window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t:t)||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},isValid:function(){var t=this.value();return null!==t&&t===this._adjustValue(t)},_value:function(t,e){var i;""!==t&&null!==(i=this._parse(t))&&(e||(i=this._adjustValue(i)),t=this._format(i)),this.element.val(t),this._refresh()},_destroy:function(){this.element.prop("disabled",!1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:ht(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:ht(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:ht(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:ht(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){if(!arguments.length)return this._parse(this.element.val());ht(this._value).call(this,t)},widget:function(){return this.uiSpinner}}),!1!==V.uiBackCompat&&V.widget("ui.spinner",V.ui.spinner,{_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())},_uiSpinnerHtml:function(){return"<span>"},_buttonHtml:function(){return"<a></a><a></a>"}});var ct;V.ui.spinner;V.widget("ui.tabs",{version:"1.13.2",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:(ct=/#.*$/,function(t){var e=t.href.replace(ct,""),i=location.href.replace(ct,"");try{e=decodeURIComponent(e)}catch(t){}try{i=decodeURIComponent(i)}catch(t){}return 1<t.hash.length&&e===i}),_create:function(){var e=this,t=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,t.collapsible),this._processTabs(),t.active=this._initialActive(),Array.isArray(t.disabled)&&(t.disabled=V.uniqueSort(t.disabled.concat(V.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),!1!==this.options.active&&this.anchors.length?this.active=this._findActive(t.active):this.active=V(),this._refresh(),this.active.length&&this.load(t.active)},_initialActive:function(){var i=this.options.active,t=this.options.collapsible,s=location.hash.substring(1);return null===i&&(s&&this.tabs.each(function(t,e){if(V(e).attr("aria-controls")===s)return i=t,!1}),null!==(i=null===i?this.tabs.index(this.tabs.filter(".ui-tabs-active")):i)&&-1!==i||(i=!!this.tabs.length&&0)),!1!==i&&-1===(i=this.tabs.index(this.tabs.eq(i)))&&(i=!t&&0),i=!t&&!1===i&&this.anchors.length?0:i},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):V()}},_tabKeydown:function(t){var e=V(V.ui.safeActiveElement(this.document[0])).closest("li"),i=this.tabs.index(e),s=!0;if(!this._handlePageNav(t)){switch(t.keyCode){case V.ui.keyCode.RIGHT:case V.ui.keyCode.DOWN:i++;break;case V.ui.keyCode.UP:case V.ui.keyCode.LEFT:s=!1,i--;break;case V.ui.keyCode.END:i=this.anchors.length-1;break;case V.ui.keyCode.HOME:i=0;break;case V.ui.keyCode.SPACE:return t.preventDefault(),clearTimeout(this.activating),void this._activate(i);case V.ui.keyCode.ENTER:return t.preventDefault(),clearTimeout(this.activating),void this._activate(i!==this.options.active&&i);default:return}t.preventDefault(),clearTimeout(this.activating),i=this._focusNextTab(i,s),t.ctrlKey||t.metaKey||(e.attr("aria-selected","false"),this.tabs.eq(i).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",i)},this.delay))}},_panelKeydown:function(t){this._handlePageNav(t)||t.ctrlKey&&t.keyCode===V.ui.keyCode.UP&&(t.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(t){return t.altKey&&t.keyCode===V.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):t.altKey&&t.keyCode===V.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(t,e){var i=this.tabs.length-1;for(;-1!==V.inArray(t=(t=i<t?0:t)<0?i:t,this.options.disabled);)t=e?t+1:t-1;return t},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).trigger("focus"),t},_setOption:function(t,e){"active"!==t?(this._super(t,e),"collapsible"===t&&(this._toggleClass("ui-tabs-collapsible",null,e),e||!1!==this.options.active||this._activate(0)),"event"===t&&this._setupEvents(e),"heightStyle"===t&&this._setupHeightStyle(e)):this._activate(e)},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var t=this.options,e=this.tablist.children(":has(a[href])");t.disabled=V.map(e.filter(".ui-state-disabled"),function(t){return e.index(t)}),this._processTabs(),!1!==t.active&&this.anchors.length?this.active.length&&!V.contains(this.tablist[0],this.active[0])?this.tabs.length===t.disabled.length?(t.active=!1,this.active=V()):this._activate(this._findNextTab(Math.max(0,t.active-1),!1)):t.active=this.tabs.index(this.active):(t.active=!1,this.active=V()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var l=this,t=this.tabs,e=this.anchors,i=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(t){V(this).is(".ui-state-disabled")&&t.preventDefault()}).on("focus"+this.eventNamespace,".ui-tabs-anchor",function(){V(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return V("a",this)[0]}).attr({tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=V(),this.anchors.each(function(t,e){var i,s,n,o=V(e).uniqueId().attr("id"),a=V(e).closest("li"),r=a.attr("aria-controls");l._isLocal(e)?(n=(i=e.hash).substring(1),s=l.element.find(l._sanitizeSelector(i))):(n=a.attr("aria-controls")||V({}).uniqueId()[0].id,(s=l.element.find(i="#"+n)).length||(s=l._createPanel(n)).insertAfter(l.panels[t-1]||l.tablist),s.attr("aria-live","polite")),s.length&&(l.panels=l.panels.add(s)),r&&a.data("ui-tabs-aria-controls",r),a.attr({"aria-controls":n,"aria-labelledby":o}),s.attr("aria-labelledby",o)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),t&&(this._off(t.not(this.tabs)),this._off(e.not(this.anchors)),this._off(i.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(t){return V("<div>").attr("id",t).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(t){var e,i;for(Array.isArray(t)&&(t.length?t.length===this.anchors.length&&(t=!0):t=!1),i=0;e=this.tabs[i];i++)e=V(e),!0===t||-1!==V.inArray(i,t)?(e.attr("aria-disabled","true"),this._addClass(e,null,"ui-state-disabled")):(e.removeAttr("aria-disabled"),this._removeClass(e,null,"ui-state-disabled"));this.options.disabled=t,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!0===t)},_setupEvents:function(t){var i={};t&&V.each(t.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(t){t.preventDefault()}}),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(t){var i,e=this.element.parent();"fill"===t?(i=e.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var t=V(this),e=t.css("position");"absolute"!==e&&"fixed"!==e&&(i-=t.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=V(this).outerHeight(!0)}),this.panels.each(function(){V(this).height(Math.max(0,i-V(this).innerHeight()+V(this).height()))}).css("overflow","auto")):"auto"===t&&(i=0,this.panels.each(function(){i=Math.max(i,V(this).height("").height())}).height(i))},_eventHandler:function(t){var e=this.options,i=this.active,s=V(t.currentTarget).closest("li"),n=s[0]===i[0],o=n&&e.collapsible,a=o?V():this._getPanelForTab(s),r=i.length?this._getPanelForTab(i):V(),i={oldTab:i,oldPanel:r,newTab:o?V():s,newPanel:a};t.preventDefault(),s.hasClass("ui-state-disabled")||s.hasClass("ui-tabs-loading")||this.running||n&&!e.collapsible||!1===this._trigger("beforeActivate",t,i)||(e.active=!o&&this.tabs.index(s),this.active=n?V():s,this.xhr&&this.xhr.abort(),r.length||a.length||V.error("jQuery UI Tabs: Mismatching fragment identifier."),a.length&&this.load(this.tabs.index(s),t),this._toggle(t,i))},_toggle:function(t,e){var i=this,s=e.newPanel,n=e.oldPanel;function o(){i.running=!1,i._trigger("activate",t,e)}function a(){i._addClass(e.newTab.closest("li"),"ui-tabs-active","ui-state-active"),s.length&&i.options.show?i._show(s,i.options.show,o):(s.show(),o())}this.running=!0,n.length&&this.options.hide?this._hide(n,this.options.hide,function(){i._removeClass(e.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),a()}):(this._removeClass(e.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),n.hide(),a()),n.attr("aria-hidden","true"),e.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),s.length&&n.length?e.oldTab.attr("tabIndex",-1):s.length&&this.tabs.filter(function(){return 0===V(this).attr("tabIndex")}).attr("tabIndex",-1),s.attr("aria-hidden","false"),e.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(t){var t=this._findActive(t);t[0]!==this.active[0]&&(t=(t=!t.length?this.active:t).find(".ui-tabs-anchor")[0],this._eventHandler({target:t,currentTarget:t,preventDefault:V.noop}))},_findActive:function(t){return!1===t?V():this.tabs.eq(t)},_getIndex:function(t){return t="string"==typeof t?this.anchors.index(this.anchors.filter("[href$='"+V.escapeSelector(t)+"']")):t},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){V.data(this,"ui-tabs-destroy")?V(this).remove():V(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var t=V(this),e=t.data("ui-tabs-aria-controls");e?t.attr("aria-controls",e).removeData("ui-tabs-aria-controls"):t.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var t=this.options.disabled;!1!==t&&(t=void 0!==i&&(i=this._getIndex(i),Array.isArray(t)?V.map(t,function(t){return t!==i?t:null}):V.map(this.tabs,function(t,e){return e!==i?e:null})),this._setOptionDisabled(t))},disable:function(t){var e=this.options.disabled;if(!0!==e){if(void 0===t)e=!0;else{if(t=this._getIndex(t),-1!==V.inArray(t,e))return;e=Array.isArray(e)?V.merge([t],e).sort():[t]}this._setOptionDisabled(e)}},load:function(t,s){t=this._getIndex(t);function n(t,e){"abort"===e&&o.panels.stop(!1,!0),o._removeClass(i,"ui-tabs-loading"),a.removeAttr("aria-busy"),t===o.xhr&&delete o.xhr}var o=this,i=this.tabs.eq(t),t=i.find(".ui-tabs-anchor"),a=this._getPanelForTab(i),r={tab:i,panel:a};this._isLocal(t[0])||(this.xhr=V.ajax(this._ajaxSettings(t,s,r)),this.xhr&&"canceled"!==this.xhr.statusText&&(this._addClass(i,"ui-tabs-loading"),a.attr("aria-busy","true"),this.xhr.done(function(t,e,i){setTimeout(function(){a.html(t),o._trigger("load",s,r),n(i,e)},1)}).fail(function(t,e){setTimeout(function(){n(t,e)},1)})))},_ajaxSettings:function(t,i,s){var n=this;return{url:t.attr("href").replace(/#.*$/,""),beforeSend:function(t,e){return n._trigger("beforeLoad",i,V.extend({jqXHR:t,ajaxSettings:e},s))}}},_getPanelForTab:function(t){t=V(t).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+t))}}),!1!==V.uiBackCompat&&V.widget("ui.tabs",V.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}});V.ui.tabs;V.widget("ui.tooltip",{version:"1.13.2",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function(){var t=V(this).attr("title");return V("<a>").text(t).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,track:!1,close:null,open:null},_addDescribedBy:function(t,e){var i=(t.attr("aria-describedby")||"").split(/\s+/);i.push(e),t.data("ui-tooltip-id",e).attr("aria-describedby",String.prototype.trim.call(i.join(" ")))},_removeDescribedBy:function(t){var e=t.data("ui-tooltip-id"),i=(t.attr("aria-describedby")||"").split(/\s+/),e=V.inArray(e,i);-1!==e&&i.splice(e,1),t.removeData("ui-tooltip-id"),(i=String.prototype.trim.call(i.join(" ")))?t.attr("aria-describedby",i):t.removeAttr("aria-describedby")},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.liveRegion=V("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this.disabledTitles=V([])},_setOption:function(t,e){var i=this;this._super(t,e),"content"===t&&V.each(this.tooltips,function(t,e){i._updateContent(e.element)})},_setOptionDisabled:function(t){this[t?"_disable":"_enable"]()},_disable:function(){var s=this;V.each(this.tooltips,function(t,e){var i=V.Event("blur");i.target=i.currentTarget=e.element[0],s.close(i,!0)}),this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var t=V(this);if(t.is("[title]"))return t.data("ui-tooltip-title",t.attr("title")).removeAttr("title")}))},_enable:function(){this.disabledTitles.each(function(){var t=V(this);t.data("ui-tooltip-title")&&t.attr("title",t.data("ui-tooltip-title"))}),this.disabledTitles=V([])},open:function(t){var i=this,e=V(t?t.target:this.element).closest(this.options.items);e.length&&!e.data("ui-tooltip-id")&&(e.attr("title")&&e.data("ui-tooltip-title",e.attr("title")),e.data("ui-tooltip-open",!0),t&&"mouseover"===t.type&&e.parents().each(function(){var t,e=V(this);e.data("ui-tooltip-open")&&((t=V.Event("blur")).target=t.currentTarget=this,i.close(t,!0)),e.attr("title")&&(e.uniqueId(),i.parents[this.id]={element:this,title:e.attr("title")},e.attr("title",""))}),this._registerCloseHandlers(t,e),this._updateContent(e,t))},_updateContent:function(e,i){var t=this.options.content,s=this,n=i?i.type:null;if("string"==typeof t||t.nodeType||t.jquery)return this._open(i,e,t);(t=t.call(e[0],function(t){s._delay(function(){e.data("ui-tooltip-open")&&(i&&(i.type=n),this._open(i,e,t))})}))&&this._open(i,e,t)},_open:function(t,e,i){var s,n,o,a=V.extend({},this.options.position);function r(t){a.of=t,n.is(":hidden")||n.position(a)}i&&((s=this._find(e))?s.tooltip.find(".ui-tooltip-content").html(i):(e.is("[title]")&&(t&&"mouseover"===t.type?e.attr("title",""):e.removeAttr("title")),s=this._tooltip(e),n=s.tooltip,this._addDescribedBy(e,n.attr("id")),n.find(".ui-tooltip-content").html(i),this.liveRegion.children().hide(),(i=V("<div>").html(n.find(".ui-tooltip-content").html())).removeAttr("name").find("[name]").removeAttr("name"),i.removeAttr("id").find("[id]").removeAttr("id"),i.appendTo(this.liveRegion),this.options.track&&t&&/^mouse/.test(t.type)?(this._on(this.document,{mousemove:r}),r(t)):n.position(V.extend({of:e},this.options.position)),n.hide(),this._show(n,this.options.show),this.options.track&&this.options.show&&this.options.show.delay&&(o=this.delayedShow=setInterval(function(){n.is(":visible")&&(r(a.of),clearInterval(o))},13)),this._trigger("open",t,{tooltip:n})))},_registerCloseHandlers:function(t,e){var i={keyup:function(t){t.keyCode===V.ui.keyCode.ESCAPE&&((t=V.Event(t)).currentTarget=e[0],this.close(t,!0))}};e[0]!==this.element[0]&&(i.remove=function(){var t=this._find(e);t&&this._removeTooltip(t.tooltip)}),t&&"mouseover"!==t.type||(i.mouseleave="close"),t&&"focusin"!==t.type||(i.focusout="close"),this._on(!0,e,i)},close:function(t){var e,i=this,s=V(t?t.currentTarget:this.element),n=this._find(s);n?(e=n.tooltip,n.closing||(clearInterval(this.delayedShow),s.data("ui-tooltip-title")&&!s.attr("title")&&s.attr("title",s.data("ui-tooltip-title")),this._removeDescribedBy(s),n.hiding=!0,e.stop(!0),this._hide(e,this.options.hide,function(){i._removeTooltip(V(this))}),s.removeData("ui-tooltip-open"),this._off(s,"mouseleave focusout keyup"),s[0]!==this.element[0]&&this._off(s,"remove"),this._off(this.document,"mousemove"),t&&"mouseleave"===t.type&&V.each(this.parents,function(t,e){V(e.element).attr("title",e.title),delete i.parents[t]}),n.closing=!0,this._trigger("close",t,{tooltip:e}),n.hiding||(n.closing=!1))):s.removeData("ui-tooltip-open")},_tooltip:function(t){var e=V("<div>").attr("role","tooltip"),i=V("<div>").appendTo(e),s=e.uniqueId().attr("id");return this._addClass(i,"ui-tooltip-content"),this._addClass(e,"ui-tooltip","ui-widget ui-widget-content"),e.appendTo(this._appendTo(t)),this.tooltips[s]={element:t,tooltip:e}},_find:function(t){t=t.data("ui-tooltip-id");return t?this.tooltips[t]:null},_removeTooltip:function(t){clearInterval(this.delayedShow),t.remove(),delete this.tooltips[t.attr("id")]},_appendTo:function(t){t=t.closest(".ui-front, dialog");return t=!t.length?this.document[0].body:t},_destroy:function(){var s=this;V.each(this.tooltips,function(t,e){var i=V.Event("blur"),e=e.element;i.target=i.currentTarget=e[0],s.close(i,!0),V("#"+t).remove(),e.data("ui-tooltip-title")&&(e.attr("title")||e.attr("title",e.data("ui-tooltip-title")),e.removeData("ui-tooltip-title"))}),this.liveRegion.remove()}}),!1!==V.uiBackCompat&&V.widget("ui.tooltip",V.ui.tooltip,{options:{tooltipClass:null},_tooltip:function(){var t=this._superApply(arguments);return this.options.tooltipClass&&t.tooltip.addClass(this.options.tooltipClass),t}});V.ui.tooltip});
/**
 * jQuery serializeObject
 * @copyright 2014, macek <paulmacek@gmail.com>
 * @link https://github.com/macek/jquery-serialize-object
 * @license BSD
 * @version 2.4.5
 */
(function(root, factory) {

  // AMD
  if (typeof define === "function" && define.amd) {
    define(["exports", "jquery"], function(exports, $) {
      return factory(exports, $);
    });
  }

  // CommonJS
  else if (typeof exports !== "undefined") {
    var $ = require("jquery");
    factory(exports, $);
  }

  // Browser
  else {
    factory(root, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(this, function(exports, $) {

  var patterns = {
    validate: /^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,
    key:      /[a-z0-9_]+|(?=\[\])/gi,
    push:     /^$/,
    fixed:    /^\d+$/,
    named:    /^[a-z0-9_]+$/i
  };

  function FormSerializer(helper, $form) {

    // private variables
    var data     = {},
        pushes   = {};

    // private API
    function build(base, key, value) {
      base[key] = value;
      return base;
    }

    function makeObject(root, value) {

      var keys = root.match(patterns.key), k;

      // nest, nest, ..., nest
      while ((k = keys.pop()) !== undefined) {
        // foo[]
        if (patterns.push.test(k)) {
          var idx = incrementPush(root.replace(/\[\]$/, ''));
          value = build([], idx, value);
        }

        // foo[n]
        else if (patterns.fixed.test(k)) {
          value = build([], k, value);
        }

        // foo; foo[bar]
        else if (patterns.named.test(k)) {
          value = build({}, k, value);
        }
      }

      return value;
    }

    function incrementPush(key) {
      if (pushes[key] === undefined) {
        pushes[key] = 0;
      }
      return pushes[key]++;
    }

    function encode(pair) {
      switch ($('[name="' + pair.name + '"]', $form).attr("type")) {
        case "checkbox":
          return pair.value === "on" ? true : pair.value;
        default:
          return pair.value;
      }
    }

    function addPair(pair) {
      if (!patterns.validate.test(pair.name)) return this;
      var obj = makeObject(pair.name, encode(pair));
      data = helper.extend(true, data, obj);
      return this;
    }

    function addPairs(pairs) {
      if (!helper.isArray(pairs)) {
        throw new Error("formSerializer.addPairs expects an Array");
      }
      for (var i=0, len=pairs.length; i<len; i++) {
        this.addPair(pairs[i]);
      }
      return this;
    }

    function serialize() {
      return data;
    }

    function serializeJSON() {
      return JSON.stringify(serialize());
    }

    // public API
    this.addPair = addPair;
    this.addPairs = addPairs;
    this.serialize = serialize;
    this.serializeJSON = serializeJSON;
  }

  FormSerializer.patterns = patterns;

  FormSerializer.serializeObject = function serializeObject() {
    if (this.length > 1) {
      return new Error("jquery-serialize-object can only serialize one form at a time");
    }
    return new FormSerializer($, this).
      addPairs(this.serializeArray()).
      serialize();
  };

  FormSerializer.serializeJSON = function serializeJSON() {
    if (this.length > 1) {
      return new Error("jquery-serialize-object can only serialize one form at a time");
    }
    return new FormSerializer($, this).
      addPairs(this.serializeArray()).
      serializeJSON();
  };

  if (typeof $.fn !== "undefined") {
    $.fn.serializeObject = FormSerializer.serializeObject;
    $.fn.serializeJSON   = FormSerializer.serializeJSON;
  }

  exports.FormSerializer = FormSerializer;

  return FormSerializer;
}));
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define('underscore', factory) :
      (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
        var current = global._;
        var exports = global._ = factory();
        exports.noConflict = function () { global._ = current; return exports; };
      }()));
}(this, (function () {
  //     Underscore.js 1.13.6
  //     https://underscorejs.org
  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.6';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
    (typeof global == 'object' && global.global === global && global) ||
    Function('return this')() ||
    {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
    supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create,
    nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
    _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || (type === 'object' && !!obj);
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
      supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
    ),
    isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
      isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key] === true; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
      var byteLength = getByteLength(a);
      if (byteLength !== getByteLength(b)) return false;
      if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
      areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
          isFunction$1(bCtor) && bCtor instanceof bCtor)
        && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
    hasName = 'has',
    commonInit = ['clear', 'delete'],
    mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
    weakMapMethods = commonInit.concat(mapTail),
    setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
      length = _keys.length,
      results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
      length = (_keys || obj).length,
      results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
      length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
      length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
      value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
      value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = toArray(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = (array && max(array, getLength).length) || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));
//# sourceMappingURL=underscore-umd.js.map;
/*
Copyright 2014 Igor Vaynberg

Version: 3.5.2 Timestamp: Sat Nov  1 14:43:36 EDT 2014

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

http://www.apache.org/licenses/LICENSE-2.0
http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the Apache License
or the GPL Licesnse is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
either express or implied. See the Apache License and the GPL License for the specific language governing
permissions and limitations under the Apache License and the GPL License.
*/
!function(a){"undefined"==typeof a.fn.each2&&a.extend(a.fn,{each2:function(b){for(var c=a([0]),d=-1,e=this.length;++d<e&&(c.context=c[0]=this[d])&&b.call(c[0],d,c)!==!1;);return this}})}(jQuery),function(a,b){"use strict";function n(b){var c=a(document.createTextNode(""));b.before(c),c.before(b),c.remove()}function o(a){function b(a){return m[a]||a}return a.replace(/[^\u0000-\u007E]/g,b)}function p(a,b){for(var c=0,d=b.length;d>c;c+=1)if(r(a,b[c]))return c;return-1}function q(){var b=a(l);b.appendTo(document.body);var c={width:b.width()-b[0].clientWidth,height:b.height()-b[0].clientHeight};return b.remove(),c}function r(a,c){return a===c?!0:a===b||c===b?!1:null===a||null===c?!1:a.constructor===String?a+""==c+"":c.constructor===String?c+""==a+"":!1}function s(a,b,c){var d,e,f;if(null===a||a.length<1)return[];for(d=a.split(b),e=0,f=d.length;f>e;e+=1)d[e]=c(d[e]);return d}function t(a){return a.outerWidth(!1)-a.width()}function u(c){var d="keyup-change-value";c.on("keydown",function(){a.data(c,d)===b&&a.data(c,d,c.val())}),c.on("keyup",function(){var e=a.data(c,d);e!==b&&c.val()!==e&&(a.removeData(c,d),c.trigger("keyup-change"))})}function v(c){c.on("mousemove",function(c){var d=h;(d===b||d.x!==c.pageX||d.y!==c.pageY)&&a(c.target).trigger("mousemove-filtered",c)})}function w(a,c,d){d=d||b;var e;return function(){var b=arguments;window.clearTimeout(e),e=window.setTimeout(function(){c.apply(d,b)},a)}}function x(a,b){var c=w(a,function(a){b.trigger("scroll-debounced",a)});b.on("scroll",function(a){p(a.target,b.get())>=0&&c(a)})}function y(a){a[0]!==document.activeElement&&window.setTimeout(function(){var d,b=a[0],c=a.val().length;a.focus();var e=b.offsetWidth>0||b.offsetHeight>0;e&&b===document.activeElement&&(b.setSelectionRange?b.setSelectionRange(c,c):b.createTextRange&&(d=b.createTextRange(),d.collapse(!1),d.select()))},0)}function z(b){b=a(b)[0];var c=0,d=0;if("selectionStart"in b)c=b.selectionStart,d=b.selectionEnd-c;else if("selection"in document){b.focus();var e=document.selection.createRange();d=document.selection.createRange().text.length,e.moveStart("character",-b.value.length),c=e.text.length-d}return{offset:c,length:d}}function A(a){a.preventDefault(),a.stopPropagation()}function B(a){a.preventDefault(),a.stopImmediatePropagation()}function C(b){if(!g){var c=b[0].currentStyle||window.getComputedStyle(b[0],null);g=a(document.createElement("div")).css({position:"absolute",left:"-10000px",top:"-10000px",display:"none",fontSize:c.fontSize,fontFamily:c.fontFamily,fontStyle:c.fontStyle,fontWeight:c.fontWeight,letterSpacing:c.letterSpacing,textTransform:c.textTransform,whiteSpace:"nowrap"}),g.attr("class","select2-sizer"),a(document.body).append(g)}return g.text(b.val()),g.width()}function D(b,c,d){var e,g,f=[];e=a.trim(b.attr("class")),e&&(e=""+e,a(e.split(/\s+/)).each2(function(){0===this.indexOf("select2-")&&f.push(this)})),e=a.trim(c.attr("class")),e&&(e=""+e,a(e.split(/\s+/)).each2(function(){0!==this.indexOf("select2-")&&(g=d(this),g&&f.push(g))})),b.attr("class",f.join(" "))}function E(a,b,c,d){var e=o(a.toUpperCase()).indexOf(o(b.toUpperCase())),f=b.length;return 0>e?(c.push(d(a)),void 0):(c.push(d(a.substring(0,e))),c.push("<span class='select2-match'>"),c.push(d(a.substring(e,e+f))),c.push("</span>"),c.push(d(a.substring(e+f,a.length))),void 0)}function F(a){var b={"\\":"&#92;","&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return String(a).replace(/[&<>"'\/\\]/g,function(a){return b[a]})}function G(c){var d,e=null,f=c.quietMillis||100,g=c.url,h=this;return function(i){window.clearTimeout(d),d=window.setTimeout(function(){var d=c.data,f=g,j=c.transport||a.fn.select2.ajaxDefaults.transport,k={type:c.type||"GET",cache:c.cache||!1,jsonpCallback:c.jsonpCallback||b,dataType:c.dataType||"json"},l=a.extend({},a.fn.select2.ajaxDefaults.params,k);d=d?d.call(h,i.term,i.page,i.context):null,f="function"==typeof f?f.call(h,i.term,i.page,i.context):f,e&&"function"==typeof e.abort&&e.abort(),c.params&&(a.isFunction(c.params)?a.extend(l,c.params.call(h)):a.extend(l,c.params)),a.extend(l,{url:f,dataType:c.dataType,data:d,success:function(a){var b=c.results(a,i.page,i);i.callback(b)},error:function(a,b,c){var d={hasError:!0,jqXHR:a,textStatus:b,errorThrown:c};i.callback(d)}}),e=j.call(h,l)},f)}}function H(b){var d,e,c=b,f=function(a){return""+a.text};a.isArray(c)&&(e=c,c={results:e}),a.isFunction(c)===!1&&(e=c,c=function(){return e});var g=c();return g.text&&(f=g.text,a.isFunction(f)||(d=g.text,f=function(a){return a[d]})),function(b){var g,d=b.term,e={results:[]};return""===d?(b.callback(c()),void 0):(g=function(c,e){var h,i;if(c=c[0],c.children){h={};for(i in c)c.hasOwnProperty(i)&&(h[i]=c[i]);h.children=[],a(c.children).each2(function(a,b){g(b,h.children)}),(h.children.length||b.matcher(d,f(h),c))&&e.push(h)}else b.matcher(d,f(c),c)&&e.push(c)},a(c().results).each2(function(a,b){g(b,e.results)}),b.callback(e),void 0)}}function I(c){var d=a.isFunction(c);return function(e){var f=e.term,g={results:[]},h=d?c(e):c;a.isArray(h)&&(a(h).each(function(){var a=this.text!==b,c=a?this.text:this;(""===f||e.matcher(f,c))&&g.results.push(a?this:{id:this,text:this})}),e.callback(g))}}function J(b,c){if(a.isFunction(b))return!0;if(!b)return!1;if("string"==typeof b)return!0;throw new Error(c+" must be a string, function, or falsy value")}function K(b,c){if(a.isFunction(b)){var d=Array.prototype.slice.call(arguments,2);return b.apply(c,d)}return b}function L(b){var c=0;return a.each(b,function(a,b){b.children?c+=L(b.children):c++}),c}function M(a,c,d,e){var h,i,j,k,l,f=a,g=!1;if(!e.createSearchChoice||!e.tokenSeparators||e.tokenSeparators.length<1)return b;for(;;){for(i=-1,j=0,k=e.tokenSeparators.length;k>j&&(l=e.tokenSeparators[j],i=a.indexOf(l),!(i>=0));j++);if(0>i)break;if(h=a.substring(0,i),a=a.substring(i+l.length),h.length>0&&(h=e.createSearchChoice.call(this,h,c),h!==b&&null!==h&&e.id(h)!==b&&null!==e.id(h))){for(g=!1,j=0,k=c.length;k>j;j++)if(r(e.id(h),e.id(c[j]))){g=!0;break}g||d(h)}}return f!==a?a:void 0}function N(){var b=this;a.each(arguments,function(a,c){b[c].remove(),b[c]=null})}function O(b,c){var d=function(){};return d.prototype=new b,d.prototype.constructor=d,d.prototype.parent=b.prototype,d.prototype=a.extend(d.prototype,c),d}if(window.Select2===b){var c,d,e,f,g,i,j,h={x:0,y:0},k={TAB:9,ENTER:13,ESC:27,SPACE:32,LEFT:37,UP:38,RIGHT:39,DOWN:40,SHIFT:16,CTRL:17,ALT:18,PAGE_UP:33,PAGE_DOWN:34,HOME:36,END:35,BACKSPACE:8,DELETE:46,isArrow:function(a){switch(a=a.which?a.which:a){case k.LEFT:case k.RIGHT:case k.UP:case k.DOWN:return!0}return!1},isControl:function(a){var b=a.which;switch(b){case k.SHIFT:case k.CTRL:case k.ALT:return!0}return a.metaKey?!0:!1},isFunctionKey:function(a){return a=a.which?a.which:a,a>=112&&123>=a}},l="<div class='select2-measure-scrollbar'></div>",m={"\u24b6":"A","\uff21":"A","\xc0":"A","\xc1":"A","\xc2":"A","\u1ea6":"A","\u1ea4":"A","\u1eaa":"A","\u1ea8":"A","\xc3":"A","\u0100":"A","\u0102":"A","\u1eb0":"A","\u1eae":"A","\u1eb4":"A","\u1eb2":"A","\u0226":"A","\u01e0":"A","\xc4":"A","\u01de":"A","\u1ea2":"A","\xc5":"A","\u01fa":"A","\u01cd":"A","\u0200":"A","\u0202":"A","\u1ea0":"A","\u1eac":"A","\u1eb6":"A","\u1e00":"A","\u0104":"A","\u023a":"A","\u2c6f":"A","\ua732":"AA","\xc6":"AE","\u01fc":"AE","\u01e2":"AE","\ua734":"AO","\ua736":"AU","\ua738":"AV","\ua73a":"AV","\ua73c":"AY","\u24b7":"B","\uff22":"B","\u1e02":"B","\u1e04":"B","\u1e06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24b8":"C","\uff23":"C","\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C","\xc7":"C","\u1e08":"C","\u0187":"C","\u023b":"C","\ua73e":"C","\u24b9":"D","\uff24":"D","\u1e0a":"D","\u010e":"D","\u1e0c":"D","\u1e10":"D","\u1e12":"D","\u1e0e":"D","\u0110":"D","\u018b":"D","\u018a":"D","\u0189":"D","\ua779":"D","\u01f1":"DZ","\u01c4":"DZ","\u01f2":"Dz","\u01c5":"Dz","\u24ba":"E","\uff25":"E","\xc8":"E","\xc9":"E","\xca":"E","\u1ec0":"E","\u1ebe":"E","\u1ec4":"E","\u1ec2":"E","\u1ebc":"E","\u0112":"E","\u1e14":"E","\u1e16":"E","\u0114":"E","\u0116":"E","\xcb":"E","\u1eba":"E","\u011a":"E","\u0204":"E","\u0206":"E","\u1eb8":"E","\u1ec6":"E","\u0228":"E","\u1e1c":"E","\u0118":"E","\u1e18":"E","\u1e1a":"E","\u0190":"E","\u018e":"E","\u24bb":"F","\uff26":"F","\u1e1e":"F","\u0191":"F","\ua77b":"F","\u24bc":"G","\uff27":"G","\u01f4":"G","\u011c":"G","\u1e20":"G","\u011e":"G","\u0120":"G","\u01e6":"G","\u0122":"G","\u01e4":"G","\u0193":"G","\ua7a0":"G","\ua77d":"G","\ua77e":"G","\u24bd":"H","\uff28":"H","\u0124":"H","\u1e22":"H","\u1e26":"H","\u021e":"H","\u1e24":"H","\u1e28":"H","\u1e2a":"H","\u0126":"H","\u2c67":"H","\u2c75":"H","\ua78d":"H","\u24be":"I","\uff29":"I","\xcc":"I","\xcd":"I","\xce":"I","\u0128":"I","\u012a":"I","\u012c":"I","\u0130":"I","\xcf":"I","\u1e2e":"I","\u1ec8":"I","\u01cf":"I","\u0208":"I","\u020a":"I","\u1eca":"I","\u012e":"I","\u1e2c":"I","\u0197":"I","\u24bf":"J","\uff2a":"J","\u0134":"J","\u0248":"J","\u24c0":"K","\uff2b":"K","\u1e30":"K","\u01e8":"K","\u1e32":"K","\u0136":"K","\u1e34":"K","\u0198":"K","\u2c69":"K","\ua740":"K","\ua742":"K","\ua744":"K","\ua7a2":"K","\u24c1":"L","\uff2c":"L","\u013f":"L","\u0139":"L","\u013d":"L","\u1e36":"L","\u1e38":"L","\u013b":"L","\u1e3c":"L","\u1e3a":"L","\u0141":"L","\u023d":"L","\u2c62":"L","\u2c60":"L","\ua748":"L","\ua746":"L","\ua780":"L","\u01c7":"LJ","\u01c8":"Lj","\u24c2":"M","\uff2d":"M","\u1e3e":"M","\u1e40":"M","\u1e42":"M","\u2c6e":"M","\u019c":"M","\u24c3":"N","\uff2e":"N","\u01f8":"N","\u0143":"N","\xd1":"N","\u1e44":"N","\u0147":"N","\u1e46":"N","\u0145":"N","\u1e4a":"N","\u1e48":"N","\u0220":"N","\u019d":"N","\ua790":"N","\ua7a4":"N","\u01ca":"NJ","\u01cb":"Nj","\u24c4":"O","\uff2f":"O","\xd2":"O","\xd3":"O","\xd4":"O","\u1ed2":"O","\u1ed0":"O","\u1ed6":"O","\u1ed4":"O","\xd5":"O","\u1e4c":"O","\u022c":"O","\u1e4e":"O","\u014c":"O","\u1e50":"O","\u1e52":"O","\u014e":"O","\u022e":"O","\u0230":"O","\xd6":"O","\u022a":"O","\u1ece":"O","\u0150":"O","\u01d1":"O","\u020c":"O","\u020e":"O","\u01a0":"O","\u1edc":"O","\u1eda":"O","\u1ee0":"O","\u1ede":"O","\u1ee2":"O","\u1ecc":"O","\u1ed8":"O","\u01ea":"O","\u01ec":"O","\xd8":"O","\u01fe":"O","\u0186":"O","\u019f":"O","\ua74a":"O","\ua74c":"O","\u01a2":"OI","\ua74e":"OO","\u0222":"OU","\u24c5":"P","\uff30":"P","\u1e54":"P","\u1e56":"P","\u01a4":"P","\u2c63":"P","\ua750":"P","\ua752":"P","\ua754":"P","\u24c6":"Q","\uff31":"Q","\ua756":"Q","\ua758":"Q","\u024a":"Q","\u24c7":"R","\uff32":"R","\u0154":"R","\u1e58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1e5a":"R","\u1e5c":"R","\u0156":"R","\u1e5e":"R","\u024c":"R","\u2c64":"R","\ua75a":"R","\ua7a6":"R","\ua782":"R","\u24c8":"S","\uff33":"S","\u1e9e":"S","\u015a":"S","\u1e64":"S","\u015c":"S","\u1e60":"S","\u0160":"S","\u1e66":"S","\u1e62":"S","\u1e68":"S","\u0218":"S","\u015e":"S","\u2c7e":"S","\ua7a8":"S","\ua784":"S","\u24c9":"T","\uff34":"T","\u1e6a":"T","\u0164":"T","\u1e6c":"T","\u021a":"T","\u0162":"T","\u1e70":"T","\u1e6e":"T","\u0166":"T","\u01ac":"T","\u01ae":"T","\u023e":"T","\ua786":"T","\ua728":"TZ","\u24ca":"U","\uff35":"U","\xd9":"U","\xda":"U","\xdb":"U","\u0168":"U","\u1e78":"U","\u016a":"U","\u1e7a":"U","\u016c":"U","\xdc":"U","\u01db":"U","\u01d7":"U","\u01d5":"U","\u01d9":"U","\u1ee6":"U","\u016e":"U","\u0170":"U","\u01d3":"U","\u0214":"U","\u0216":"U","\u01af":"U","\u1eea":"U","\u1ee8":"U","\u1eee":"U","\u1eec":"U","\u1ef0":"U","\u1ee4":"U","\u1e72":"U","\u0172":"U","\u1e76":"U","\u1e74":"U","\u0244":"U","\u24cb":"V","\uff36":"V","\u1e7c":"V","\u1e7e":"V","\u01b2":"V","\ua75e":"V","\u0245":"V","\ua760":"VY","\u24cc":"W","\uff37":"W","\u1e80":"W","\u1e82":"W","\u0174":"W","\u1e86":"W","\u1e84":"W","\u1e88":"W","\u2c72":"W","\u24cd":"X","\uff38":"X","\u1e8a":"X","\u1e8c":"X","\u24ce":"Y","\uff39":"Y","\u1ef2":"Y","\xdd":"Y","\u0176":"Y","\u1ef8":"Y","\u0232":"Y","\u1e8e":"Y","\u0178":"Y","\u1ef6":"Y","\u1ef4":"Y","\u01b3":"Y","\u024e":"Y","\u1efe":"Y","\u24cf":"Z","\uff3a":"Z","\u0179":"Z","\u1e90":"Z","\u017b":"Z","\u017d":"Z","\u1e92":"Z","\u1e94":"Z","\u01b5":"Z","\u0224":"Z","\u2c7f":"Z","\u2c6b":"Z","\ua762":"Z","\u24d0":"a","\uff41":"a","\u1e9a":"a","\xe0":"a","\xe1":"a","\xe2":"a","\u1ea7":"a","\u1ea5":"a","\u1eab":"a","\u1ea9":"a","\xe3":"a","\u0101":"a","\u0103":"a","\u1eb1":"a","\u1eaf":"a","\u1eb5":"a","\u1eb3":"a","\u0227":"a","\u01e1":"a","\xe4":"a","\u01df":"a","\u1ea3":"a","\xe5":"a","\u01fb":"a","\u01ce":"a","\u0201":"a","\u0203":"a","\u1ea1":"a","\u1ead":"a","\u1eb7":"a","\u1e01":"a","\u0105":"a","\u2c65":"a","\u0250":"a","\ua733":"aa","\xe6":"ae","\u01fd":"ae","\u01e3":"ae","\ua735":"ao","\ua737":"au","\ua739":"av","\ua73b":"av","\ua73d":"ay","\u24d1":"b","\uff42":"b","\u1e03":"b","\u1e05":"b","\u1e07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24d2":"c","\uff43":"c","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\xe7":"c","\u1e09":"c","\u0188":"c","\u023c":"c","\ua73f":"c","\u2184":"c","\u24d3":"d","\uff44":"d","\u1e0b":"d","\u010f":"d","\u1e0d":"d","\u1e11":"d","\u1e13":"d","\u1e0f":"d","\u0111":"d","\u018c":"d","\u0256":"d","\u0257":"d","\ua77a":"d","\u01f3":"dz","\u01c6":"dz","\u24d4":"e","\uff45":"e","\xe8":"e","\xe9":"e","\xea":"e","\u1ec1":"e","\u1ebf":"e","\u1ec5":"e","\u1ec3":"e","\u1ebd":"e","\u0113":"e","\u1e15":"e","\u1e17":"e","\u0115":"e","\u0117":"e","\xeb":"e","\u1ebb":"e","\u011b":"e","\u0205":"e","\u0207":"e","\u1eb9":"e","\u1ec7":"e","\u0229":"e","\u1e1d":"e","\u0119":"e","\u1e19":"e","\u1e1b":"e","\u0247":"e","\u025b":"e","\u01dd":"e","\u24d5":"f","\uff46":"f","\u1e1f":"f","\u0192":"f","\ua77c":"f","\u24d6":"g","\uff47":"g","\u01f5":"g","\u011d":"g","\u1e21":"g","\u011f":"g","\u0121":"g","\u01e7":"g","\u0123":"g","\u01e5":"g","\u0260":"g","\ua7a1":"g","\u1d79":"g","\ua77f":"g","\u24d7":"h","\uff48":"h","\u0125":"h","\u1e23":"h","\u1e27":"h","\u021f":"h","\u1e25":"h","\u1e29":"h","\u1e2b":"h","\u1e96":"h","\u0127":"h","\u2c68":"h","\u2c76":"h","\u0265":"h","\u0195":"hv","\u24d8":"i","\uff49":"i","\xec":"i","\xed":"i","\xee":"i","\u0129":"i","\u012b":"i","\u012d":"i","\xef":"i","\u1e2f":"i","\u1ec9":"i","\u01d0":"i","\u0209":"i","\u020b":"i","\u1ecb":"i","\u012f":"i","\u1e2d":"i","\u0268":"i","\u0131":"i","\u24d9":"j","\uff4a":"j","\u0135":"j","\u01f0":"j","\u0249":"j","\u24da":"k","\uff4b":"k","\u1e31":"k","\u01e9":"k","\u1e33":"k","\u0137":"k","\u1e35":"k","\u0199":"k","\u2c6a":"k","\ua741":"k","\ua743":"k","\ua745":"k","\ua7a3":"k","\u24db":"l","\uff4c":"l","\u0140":"l","\u013a":"l","\u013e":"l","\u1e37":"l","\u1e39":"l","\u013c":"l","\u1e3d":"l","\u1e3b":"l","\u017f":"l","\u0142":"l","\u019a":"l","\u026b":"l","\u2c61":"l","\ua749":"l","\ua781":"l","\ua747":"l","\u01c9":"lj","\u24dc":"m","\uff4d":"m","\u1e3f":"m","\u1e41":"m","\u1e43":"m","\u0271":"m","\u026f":"m","\u24dd":"n","\uff4e":"n","\u01f9":"n","\u0144":"n","\xf1":"n","\u1e45":"n","\u0148":"n","\u1e47":"n","\u0146":"n","\u1e4b":"n","\u1e49":"n","\u019e":"n","\u0272":"n","\u0149":"n","\ua791":"n","\ua7a5":"n","\u01cc":"nj","\u24de":"o","\uff4f":"o","\xf2":"o","\xf3":"o","\xf4":"o","\u1ed3":"o","\u1ed1":"o","\u1ed7":"o","\u1ed5":"o","\xf5":"o","\u1e4d":"o","\u022d":"o","\u1e4f":"o","\u014d":"o","\u1e51":"o","\u1e53":"o","\u014f":"o","\u022f":"o","\u0231":"o","\xf6":"o","\u022b":"o","\u1ecf":"o","\u0151":"o","\u01d2":"o","\u020d":"o","\u020f":"o","\u01a1":"o","\u1edd":"o","\u1edb":"o","\u1ee1":"o","\u1edf":"o","\u1ee3":"o","\u1ecd":"o","\u1ed9":"o","\u01eb":"o","\u01ed":"o","\xf8":"o","\u01ff":"o","\u0254":"o","\ua74b":"o","\ua74d":"o","\u0275":"o","\u01a3":"oi","\u0223":"ou","\ua74f":"oo","\u24df":"p","\uff50":"p","\u1e55":"p","\u1e57":"p","\u01a5":"p","\u1d7d":"p","\ua751":"p","\ua753":"p","\ua755":"p","\u24e0":"q","\uff51":"q","\u024b":"q","\ua757":"q","\ua759":"q","\u24e1":"r","\uff52":"r","\u0155":"r","\u1e59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1e5b":"r","\u1e5d":"r","\u0157":"r","\u1e5f":"r","\u024d":"r","\u027d":"r","\ua75b":"r","\ua7a7":"r","\ua783":"r","\u24e2":"s","\uff53":"s","\xdf":"s","\u015b":"s","\u1e65":"s","\u015d":"s","\u1e61":"s","\u0161":"s","\u1e67":"s","\u1e63":"s","\u1e69":"s","\u0219":"s","\u015f":"s","\u023f":"s","\ua7a9":"s","\ua785":"s","\u1e9b":"s","\u24e3":"t","\uff54":"t","\u1e6b":"t","\u1e97":"t","\u0165":"t","\u1e6d":"t","\u021b":"t","\u0163":"t","\u1e71":"t","\u1e6f":"t","\u0167":"t","\u01ad":"t","\u0288":"t","\u2c66":"t","\ua787":"t","\ua729":"tz","\u24e4":"u","\uff55":"u","\xf9":"u","\xfa":"u","\xfb":"u","\u0169":"u","\u1e79":"u","\u016b":"u","\u1e7b":"u","\u016d":"u","\xfc":"u","\u01dc":"u","\u01d8":"u","\u01d6":"u","\u01da":"u","\u1ee7":"u","\u016f":"u","\u0171":"u","\u01d4":"u","\u0215":"u","\u0217":"u","\u01b0":"u","\u1eeb":"u","\u1ee9":"u","\u1eef":"u","\u1eed":"u","\u1ef1":"u","\u1ee5":"u","\u1e73":"u","\u0173":"u","\u1e77":"u","\u1e75":"u","\u0289":"u","\u24e5":"v","\uff56":"v","\u1e7d":"v","\u1e7f":"v","\u028b":"v","\ua75f":"v","\u028c":"v","\ua761":"vy","\u24e6":"w","\uff57":"w","\u1e81":"w","\u1e83":"w","\u0175":"w","\u1e87":"w","\u1e85":"w","\u1e98":"w","\u1e89":"w","\u2c73":"w","\u24e7":"x","\uff58":"x","\u1e8b":"x","\u1e8d":"x","\u24e8":"y","\uff59":"y","\u1ef3":"y","\xfd":"y","\u0177":"y","\u1ef9":"y","\u0233":"y","\u1e8f":"y","\xff":"y","\u1ef7":"y","\u1e99":"y","\u1ef5":"y","\u01b4":"y","\u024f":"y","\u1eff":"y","\u24e9":"z","\uff5a":"z","\u017a":"z","\u1e91":"z","\u017c":"z","\u017e":"z","\u1e93":"z","\u1e95":"z","\u01b6":"z","\u0225":"z","\u0240":"z","\u2c6c":"z","\ua763":"z","\u0386":"\u0391","\u0388":"\u0395","\u0389":"\u0397","\u038a":"\u0399","\u03aa":"\u0399","\u038c":"\u039f","\u038e":"\u03a5","\u03ab":"\u03a5","\u038f":"\u03a9","\u03ac":"\u03b1","\u03ad":"\u03b5","\u03ae":"\u03b7","\u03af":"\u03b9","\u03ca":"\u03b9","\u0390":"\u03b9","\u03cc":"\u03bf","\u03cd":"\u03c5","\u03cb":"\u03c5","\u03b0":"\u03c5","\u03c9":"\u03c9","\u03c2":"\u03c3"};i=a(document),f=function(){var a=1;return function(){return a++}}(),c=O(Object,{bind:function(a){var b=this;return function(){a.apply(b,arguments)}},init:function(c){var d,e,g=".select2-results";this.opts=c=this.prepareOpts(c),this.id=c.id,c.element.data("select2")!==b&&null!==c.element.data("select2")&&c.element.data("select2").destroy(),this.container=this.createContainer(),this.liveRegion=a(".select2-hidden-accessible"),0==this.liveRegion.length&&(this.liveRegion=a("<span>",{role:"status","aria-live":"polite"}).addClass("select2-hidden-accessible").appendTo(document.body)),this.containerId="s2id_"+(c.element.attr("id")||"autogen"+f()),this.containerEventName=this.containerId.replace(/([.])/g,"_").replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g,"\\$1"),this.container.attr("id",this.containerId),this.container.attr("title",c.element.attr("title")),this.body=a(document.body),D(this.container,this.opts.element,this.opts.adaptContainerCssClass),this.container.attr("style",c.element.attr("style")),this.container.css(K(c.containerCss,this.opts.element)),this.container.addClass(K(c.containerCssClass,this.opts.element)),this.elementTabIndex=this.opts.element.attr("tabindex"),this.opts.element.data("select2",this).attr("tabindex","-1").before(this.container).on("click.select2",A),this.container.data("select2",this),this.dropdown=this.container.find(".select2-drop"),D(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass),this.dropdown.addClass(K(c.dropdownCssClass,this.opts.element)),this.dropdown.data("select2",this),this.dropdown.on("click",A),this.results=d=this.container.find(g),this.search=e=this.container.find("input.select2-input"),this.queryCount=0,this.resultsPage=0,this.context=null,this.initContainer(),this.container.on("click",A),v(this.results),this.dropdown.on("mousemove-filtered",g,this.bind(this.highlightUnderEvent)),this.dropdown.on("touchstart touchmove touchend",g,this.bind(function(a){this._touchEvent=!0,this.highlightUnderEvent(a)})),this.dropdown.on("touchmove",g,this.bind(this.touchMoved)),this.dropdown.on("touchstart touchend",g,this.bind(this.clearTouchMoved)),this.dropdown.on("click",this.bind(function(){this._touchEvent&&(this._touchEvent=!1,this.selectHighlighted())})),x(80,this.results),this.dropdown.on("scroll-debounced",g,this.bind(this.loadMoreIfNeeded)),a(this.container).on("change",".select2-input",function(a){a.stopPropagation()}),a(this.dropdown).on("change",".select2-input",function(a){a.stopPropagation()}),a.fn.mousewheel&&d.mousewheel(function(a,b,c,e){var f=d.scrollTop();e>0&&0>=f-e?(d.scrollTop(0),A(a)):0>e&&d.get(0).scrollHeight-d.scrollTop()+e<=d.height()&&(d.scrollTop(d.get(0).scrollHeight-d.height()),A(a))}),u(e),e.on("keyup-change input paste",this.bind(this.updateResults)),e.on("focus",function(){e.addClass("select2-focused")}),e.on("blur",function(){e.removeClass("select2-focused")}),this.dropdown.on("mouseup",g,this.bind(function(b){a(b.target).closest(".select2-result-selectable").length>0&&(this.highlightUnderEvent(b),this.selectHighlighted(b))})),this.dropdown.on("click mouseup mousedown touchstart touchend focusin",function(a){a.stopPropagation()}),this.nextSearchTerm=b,a.isFunction(this.opts.initSelection)&&(this.initSelection(),this.monitorSource()),null!==c.maximumInputLength&&this.search.attr("maxlength",c.maximumInputLength);var h=c.element.prop("disabled");h===b&&(h=!1),this.enable(!h);var i=c.element.prop("readonly");i===b&&(i=!1),this.readonly(i),j=j||q(),this.autofocus=c.element.prop("autofocus"),c.element.prop("autofocus",!1),this.autofocus&&this.focus(),this.search.attr("placeholder",c.searchInputPlaceholder)},destroy:function(){var a=this.opts.element,c=a.data("select2"),d=this;this.close(),a.length&&a[0].detachEvent&&d._sync&&a.each(function(){d._sync&&this.detachEvent("onpropertychange",d._sync)}),this.propertyObserver&&(this.propertyObserver.disconnect(),this.propertyObserver=null),this._sync=null,c!==b&&(c.container.remove(),c.liveRegion.remove(),c.dropdown.remove(),a.show().removeData("select2").off(".select2").prop("autofocus",this.autofocus||!1),this.elementTabIndex?a.attr({tabindex:this.elementTabIndex}):a.removeAttr("tabindex"),a.show()),N.call(this,"container","liveRegion","dropdown","results","search")},optionToData:function(a){return a.is("option")?{id:a.prop("value"),text:a.text(),element:a.get(),css:a.attr("class"),disabled:a.prop("disabled"),locked:r(a.attr("locked"),"locked")||r(a.data("locked"),!0)}:a.is("optgroup")?{text:a.attr("label"),children:[],element:a.get(),css:a.attr("class")}:void 0},prepareOpts:function(c){var d,e,g,h,i=this;if(d=c.element,"select"===d.get(0).tagName.toLowerCase()&&(this.select=e=c.element),e&&a.each(["id","multiple","ajax","query","createSearchChoice","initSelection","data","tags"],function(){if(this in c)throw new Error("Option '"+this+"' is not allowed for Select2 when attached to a <select> element.")}),c=a.extend({},{populateResults:function(d,e,g){var h,j=this.opts.id,k=this.liveRegion;h=function(d,e,l){var m,n,o,p,q,r,s,t,u,v;d=c.sortResults(d,e,g);var w=[];for(m=0,n=d.length;n>m;m+=1)o=d[m],q=o.disabled===!0,p=!q&&j(o)!==b,r=o.children&&o.children.length>0,s=a("<li></li>"),s.addClass("select2-results-dept-"+l),s.addClass("select2-result"),s.addClass(p?"select2-result-selectable":"select2-result-unselectable"),q&&s.addClass("select2-disabled"),r&&s.addClass("select2-result-with-children"),s.addClass(i.opts.formatResultCssClass(o)),s.attr("role","presentation"),t=a(document.createElement("div")),t.addClass("select2-result-label"),t.attr("id","select2-result-label-"+f()),t.attr("role","option"),v=c.formatResult(o,t,g,i.opts.escapeMarkup),v!==b&&(t.html(v),s.append(t)),r&&(u=a("<ul></ul>"),u.addClass("select2-result-sub"),h(o.children,u,l+1),s.append(u)),s.data("select2-data",o),w.push(s[0]);e.append(w),k.text(c.formatMatches(d.length))},h(e,d,0)}},a.fn.select2.defaults,c),"function"!=typeof c.id&&(g=c.id,c.id=function(a){return a[g]}),a.isArray(c.element.data("select2Tags"))){if("tags"in c)throw"tags specified as both an attribute 'data-select2-tags' and in options of Select2 "+c.element.attr("id");c.tags=c.element.data("select2Tags")}if(e?(c.query=this.bind(function(a){var f,g,h,c={results:[],more:!1},e=a.term;h=function(b,c){var d;b.is("option")?a.matcher(e,b.text(),b)&&c.push(i.optionToData(b)):b.is("optgroup")&&(d=i.optionToData(b),b.children().each2(function(a,b){h(b,d.children)}),d.children.length>0&&c.push(d))},f=d.children(),this.getPlaceholder()!==b&&f.length>0&&(g=this.getPlaceholderOption(),g&&(f=f.not(g))),f.each2(function(a,b){h(b,c.results)}),a.callback(c)}),c.id=function(a){return a.id}):"query"in c||("ajax"in c?(h=c.element.data("ajax-url"),h&&h.length>0&&(c.ajax.url=h),c.query=G.call(c.element,c.ajax)):"data"in c?c.query=H(c.data):"tags"in c&&(c.query=I(c.tags),c.createSearchChoice===b&&(c.createSearchChoice=function(b){return{id:a.trim(b),text:a.trim(b)}}),c.initSelection===b&&(c.initSelection=function(b,d){var e=[];a(s(b.val(),c.separator,c.transformVal)).each(function(){var b={id:this,text:this},d=c.tags;a.isFunction(d)&&(d=d()),a(d).each(function(){return r(this.id,b.id)?(b=this,!1):void 0}),e.push(b)}),d(e)}))),"function"!=typeof c.query)throw"query function not defined for Select2 "+c.element.attr("id");if("top"===c.createSearchChoicePosition)c.createSearchChoicePosition=function(a,b){a.unshift(b)};else if("bottom"===c.createSearchChoicePosition)c.createSearchChoicePosition=function(a,b){a.push(b)};else if("function"!=typeof c.createSearchChoicePosition)throw"invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";return c},monitorSource:function(){var d,c=this.opts.element,e=this;c.on("change.select2",this.bind(function(){this.opts.element.data("select2-change-triggered")!==!0&&this.initSelection()})),this._sync=this.bind(function(){var a=c.prop("disabled");a===b&&(a=!1),this.enable(!a);var d=c.prop("readonly");d===b&&(d=!1),this.readonly(d),this.container&&(D(this.container,this.opts.element,this.opts.adaptContainerCssClass),this.container.addClass(K(this.opts.containerCssClass,this.opts.element))),this.dropdown&&(D(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass),this.dropdown.addClass(K(this.opts.dropdownCssClass,this.opts.element)))}),c.length&&c[0].attachEvent&&c.each(function(){this.attachEvent("onpropertychange",e._sync)}),d=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,d!==b&&(this.propertyObserver&&(delete this.propertyObserver,this.propertyObserver=null),this.propertyObserver=new d(function(b){a.each(b,e._sync)}),this.propertyObserver.observe(c.get(0),{attributes:!0,subtree:!1}))},triggerSelect:function(b){var c=a.Event("select2-selecting",{val:this.id(b),object:b,choice:b});return this.opts.element.trigger(c),!c.isDefaultPrevented()},triggerChange:function(b){b=b||{},b=a.extend({},b,{type:"change",val:this.val()}),this.opts.element.data("select2-change-triggered",!0),this.opts.element.trigger(b),this.opts.element.data("select2-change-triggered",!1),this.opts.element.click(),this.opts.blurOnChange&&this.opts.element.blur()},isInterfaceEnabled:function(){return this.enabledInterface===!0},enableInterface:function(){var a=this._enabled&&!this._readonly,b=!a;return a===this.enabledInterface?!1:(this.container.toggleClass("select2-container-disabled",b),this.close(),this.enabledInterface=a,!0)},enable:function(a){a===b&&(a=!0),this._enabled!==a&&(this._enabled=a,this.opts.element.prop("disabled",!a),this.enableInterface())},disable:function(){this.enable(!1)},readonly:function(a){a===b&&(a=!1),this._readonly!==a&&(this._readonly=a,this.opts.element.prop("readonly",a),this.enableInterface())},opened:function(){return this.container?this.container.hasClass("select2-dropdown-open"):!1},positionDropdown:function(){var v,w,x,y,z,b=this.dropdown,c=this.container,d=c.offset(),e=c.outerHeight(!1),f=c.outerWidth(!1),g=b.outerHeight(!1),h=a(window),i=h.width(),k=h.height(),l=h.scrollLeft()+i,m=h.scrollTop()+k,n=d.top+e,o=d.left,p=m>=n+g,q=d.top-g>=h.scrollTop(),r=b.outerWidth(!1),s=function(){return l>=o+r},t=function(){return d.left+l+c.outerWidth(!1)>r},u=b.hasClass("select2-drop-above");u?(w=!0,!q&&p&&(x=!0,w=!1)):(w=!1,!p&&q&&(x=!0,w=!0)),x&&(b.hide(),d=this.container.offset(),e=this.container.outerHeight(!1),f=this.container.outerWidth(!1),g=b.outerHeight(!1),l=h.scrollLeft()+i,m=h.scrollTop()+k,n=d.top+e,o=d.left,r=b.outerWidth(!1),b.show(),this.focusSearch()),this.opts.dropdownAutoWidth?(z=a(".select2-results",b)[0],b.addClass("select2-drop-auto-width"),b.css("width",""),r=b.outerWidth(!1)+(z.scrollHeight===z.clientHeight?0:j.width),r>f?f=r:r=f,g=b.outerHeight(!1)):this.container.removeClass("select2-drop-auto-width"),"static"!==this.body.css("position")&&(v=this.body.offset(),n-=v.top,o-=v.left),!s()&&t()&&(o=d.left+this.container.outerWidth(!1)-r),y={left:o,width:f},w?(y.top=d.top-g,y.bottom="auto",this.container.addClass("select2-drop-above"),b.addClass("select2-drop-above")):(y.top=n,y.bottom="auto",this.container.removeClass("select2-drop-above"),b.removeClass("select2-drop-above")),y=a.extend(y,K(this.opts.dropdownCss,this.opts.element)),b.css(y)},shouldOpen:function(){var b;return this.opened()?!1:this._enabled===!1||this._readonly===!0?!1:(b=a.Event("select2-opening"),this.opts.element.trigger(b),!b.isDefaultPrevented())},clearDropdownAlignmentPreference:function(){this.container.removeClass("select2-drop-above"),this.dropdown.removeClass("select2-drop-above")},open:function(){return this.shouldOpen()?(this.opening(),i.on("mousemove.select2Event",function(a){h.x=a.pageX,h.y=a.pageY}),!0):!1},opening:function(){var f,b=this.containerEventName,c="scroll."+b,d="resize."+b,e="orientationchange."+b;this.container.addClass("select2-dropdown-open").addClass("select2-container-active"),this.clearDropdownAlignmentPreference(),this.dropdown[0]!==this.body.children().last()[0]&&this.dropdown.detach().appendTo(this.body),f=a("#select2-drop-mask"),0===f.length&&(f=a(document.createElement("div")),f.attr("id","select2-drop-mask").attr("class","select2-drop-mask"),f.hide(),f.appendTo(this.body),f.on("mousedown touchstart click",function(b){n(f);var d,c=a("#select2-drop");c.length>0&&(d=c.data("select2"),d.opts.selectOnBlur&&d.selectHighlighted({noFocus:!0}),d.close(),b.preventDefault(),b.stopPropagation())})),this.dropdown.prev()[0]!==f[0]&&this.dropdown.before(f),a("#select2-drop").removeAttr("id"),this.dropdown.attr("id","select2-drop"),f.show(),this.positionDropdown(),this.dropdown.show(),this.positionDropdown(),this.dropdown.addClass("select2-drop-active");var g=this;this.container.parents().add(window).each(function(){a(this).on(d+" "+c+" "+e,function(){g.opened()&&g.positionDropdown()})})},close:function(){if(this.opened()){var b=this.containerEventName,c="scroll."+b,d="resize."+b,e="orientationchange."+b;this.container.parents().add(window).each(function(){a(this).off(c).off(d).off(e)}),this.clearDropdownAlignmentPreference(),a("#select2-drop-mask").hide(),this.dropdown.removeAttr("id"),this.dropdown.hide(),this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active"),this.results.empty(),i.off("mousemove.select2Event"),this.clearSearch(),this.search.removeClass("select2-active"),this.opts.element.trigger(a.Event("select2-close"))}},externalSearch:function(a){this.open(),this.search.val(a),this.updateResults(!1)},clearSearch:function(){},getMaximumSelectionSize:function(){return K(this.opts.maximumSelectionSize,this.opts.element)},ensureHighlightVisible:function(){var c,d,e,f,g,h,i,j,b=this.results;if(d=this.highlight(),!(0>d)){if(0==d)return b.scrollTop(0),void 0;c=this.findHighlightableChoices().find(".select2-result-label"),e=a(c[d]),j=(e.offset()||{}).top||0,f=j+e.outerHeight(!0),d===c.length-1&&(i=b.find("li.select2-more-results"),i.length>0&&(f=i.offset().top+i.outerHeight(!0))),g=b.offset().top+b.outerHeight(!1),f>g&&b.scrollTop(b.scrollTop()+(f-g)),h=j-b.offset().top,0>h&&"none"!=e.css("display")&&b.scrollTop(b.scrollTop()+h)}},findHighlightableChoices:function(){return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)")},moveHighlight:function(b){for(var c=this.findHighlightableChoices(),d=this.highlight();d>-1&&d<c.length;){d+=b;
    var e=a(c[d]);if(e.hasClass("select2-result-selectable")&&!e.hasClass("select2-disabled")&&!e.hasClass("select2-selected")){this.highlight(d);break}}},highlight:function(b){var d,e,c=this.findHighlightableChoices();return 0===arguments.length?p(c.filter(".select2-highlighted")[0],c.get()):(b>=c.length&&(b=c.length-1),0>b&&(b=0),this.removeHighlight(),d=a(c[b]),d.addClass("select2-highlighted"),this.search.attr("aria-activedescendant",d.find(".select2-result-label").attr("id")),this.ensureHighlightVisible(),this.liveRegion.text(d.text()),e=d.data("select2-data"),e&&this.opts.element.trigger({type:"select2-highlight",val:this.id(e),choice:e}),void 0)},removeHighlight:function(){this.results.find(".select2-highlighted").removeClass("select2-highlighted")},touchMoved:function(){this._touchMoved=!0},clearTouchMoved:function(){this._touchMoved=!1},countSelectableResults:function(){return this.findHighlightableChoices().length},highlightUnderEvent:function(b){var c=a(b.target).closest(".select2-result-selectable");if(c.length>0&&!c.is(".select2-highlighted")){var d=this.findHighlightableChoices();this.highlight(d.index(c))}else 0==c.length&&this.removeHighlight()},loadMoreIfNeeded:function(){var c,a=this.results,b=a.find("li.select2-more-results"),d=this.resultsPage+1,e=this,f=this.search.val(),g=this.context;0!==b.length&&(c=b.offset().top-a.offset().top-a.height(),c<=this.opts.loadMorePadding&&(b.addClass("select2-active"),this.opts.query({element:this.opts.element,term:f,page:d,context:g,matcher:this.opts.matcher,callback:this.bind(function(c){e.opened()&&(e.opts.populateResults.call(this,a,c.results,{term:f,page:d,context:g}),e.postprocessResults(c,!1,!1),c.more===!0?(b.detach().appendTo(a).html(e.opts.escapeMarkup(K(e.opts.formatLoadMore,e.opts.element,d+1))),window.setTimeout(function(){e.loadMoreIfNeeded()},10)):b.remove(),e.positionDropdown(),e.resultsPage=d,e.context=c.context,this.opts.element.trigger({type:"select2-loaded",items:c}))})})))},tokenize:function(){},updateResults:function(c){function m(){d.removeClass("select2-active"),h.positionDropdown(),e.find(".select2-no-results,.select2-selection-limit,.select2-searching").length?h.liveRegion.text(e.text()):h.liveRegion.text(h.opts.formatMatches(e.find('.select2-result-selectable:not(".select2-selected")').length))}function n(a){e.html(a),m()}var g,i,l,d=this.search,e=this.results,f=this.opts,h=this,j=d.val(),k=a.data(this.container,"select2-last-term");if((c===!0||!k||!r(j,k))&&(a.data(this.container,"select2-last-term",j),c===!0||this.showSearchInput!==!1&&this.opened())){l=++this.queryCount;var o=this.getMaximumSelectionSize();if(o>=1&&(g=this.data(),a.isArray(g)&&g.length>=o&&J(f.formatSelectionTooBig,"formatSelectionTooBig")))return n("<li class='select2-selection-limit'>"+K(f.formatSelectionTooBig,f.element,o)+"</li>"),void 0;if(d.val().length<f.minimumInputLength)return J(f.formatInputTooShort,"formatInputTooShort")?n("<li class='select2-no-results'>"+K(f.formatInputTooShort,f.element,d.val(),f.minimumInputLength)+"</li>"):n(""),c&&this.showSearch&&this.showSearch(!0),void 0;if(f.maximumInputLength&&d.val().length>f.maximumInputLength)return J(f.formatInputTooLong,"formatInputTooLong")?n("<li class='select2-no-results'>"+K(f.formatInputTooLong,f.element,d.val(),f.maximumInputLength)+"</li>"):n(""),void 0;f.formatSearching&&0===this.findHighlightableChoices().length&&n("<li class='select2-searching'>"+K(f.formatSearching,f.element)+"</li>"),d.addClass("select2-active"),this.removeHighlight(),i=this.tokenize(),i!=b&&null!=i&&d.val(i),this.resultsPage=1,f.query({element:f.element,term:d.val(),page:this.resultsPage,context:null,matcher:f.matcher,callback:this.bind(function(g){var i;if(l==this.queryCount){if(!this.opened())return this.search.removeClass("select2-active"),void 0;if(g.hasError!==b&&J(f.formatAjaxError,"formatAjaxError"))return n("<li class='select2-ajax-error'>"+K(f.formatAjaxError,f.element,g.jqXHR,g.textStatus,g.errorThrown)+"</li>"),void 0;if(this.context=g.context===b?null:g.context,this.opts.createSearchChoice&&""!==d.val()&&(i=this.opts.createSearchChoice.call(h,d.val(),g.results),i!==b&&null!==i&&h.id(i)!==b&&null!==h.id(i)&&0===a(g.results).filter(function(){return r(h.id(this),h.id(i))}).length&&this.opts.createSearchChoicePosition(g.results,i)),0===g.results.length&&J(f.formatNoMatches,"formatNoMatches"))return n("<li class='select2-no-results'>"+K(f.formatNoMatches,f.element,d.val())+"</li>"),void 0;e.empty(),h.opts.populateResults.call(this,e,g.results,{term:d.val(),page:this.resultsPage,context:null}),g.more===!0&&J(f.formatLoadMore,"formatLoadMore")&&(e.append("<li class='select2-more-results'>"+f.escapeMarkup(K(f.formatLoadMore,f.element,this.resultsPage))+"</li>"),window.setTimeout(function(){h.loadMoreIfNeeded()},10)),this.postprocessResults(g,c),m(),this.opts.element.trigger({type:"select2-loaded",items:g})}})})}},cancel:function(){this.close()},blur:function(){this.opts.selectOnBlur&&this.selectHighlighted({noFocus:!0}),this.close(),this.container.removeClass("select2-container-active"),this.search[0]===document.activeElement&&this.search.blur(),this.clearSearch(),this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus")},focusSearch:function(){y(this.search)},selectHighlighted:function(a){if(this._touchMoved)return this.clearTouchMoved(),void 0;var b=this.highlight(),c=this.results.find(".select2-highlighted"),d=c.closest(".select2-result").data("select2-data");d?(this.highlight(b),this.onSelect(d,a)):a&&a.noFocus&&this.close()},getPlaceholder:function(){var a;return this.opts.element.attr("placeholder")||this.opts.element.attr("data-placeholder")||this.opts.element.data("placeholder")||this.opts.placeholder||((a=this.getPlaceholderOption())!==b?a.text():b)},getPlaceholderOption:function(){if(this.select){var c=this.select.children("option").first();if(this.opts.placeholderOption!==b)return"first"===this.opts.placeholderOption&&c||"function"==typeof this.opts.placeholderOption&&this.opts.placeholderOption(this.select);if(""===a.trim(c.text())&&""===c.val())return c}},initContainerWidth:function(){function c(){var c,d,e,f,g,h;if("off"===this.opts.width)return null;if("element"===this.opts.width)return 0===this.opts.element.outerWidth(!1)?"auto":this.opts.element.outerWidth(!1)+"px";if("copy"===this.opts.width||"resolve"===this.opts.width){if(c=this.opts.element.attr("style"),c!==b)for(d=c.split(";"),f=0,g=d.length;g>f;f+=1)if(h=d[f].replace(/\s/g,""),e=h.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i),null!==e&&e.length>=1)return e[1];return"resolve"===this.opts.width?(c=this.opts.element.css("width"),c.indexOf("%")>0?c:0===this.opts.element.outerWidth(!1)?"auto":this.opts.element.outerWidth(!1)+"px"):null}return a.isFunction(this.opts.width)?this.opts.width():this.opts.width}var d=c.call(this);null!==d&&this.container.css("width",d)}}),d=O(c,{createContainer:function(){var b=a(document.createElement("div")).attr({"class":"select2-container"}).html(["<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>","   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>","   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>","</a>","<label for='' class='select2-offscreen'></label>","<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />","<div class='select2-drop select2-display-none'>","   <div class='select2-search'>","       <label for='' class='select2-offscreen'></label>","       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'","       aria-autocomplete='list' />","   </div>","   <ul class='select2-results' role='listbox'>","   </ul>","</div>"].join(""));return b},enableInterface:function(){this.parent.enableInterface.apply(this,arguments)&&this.focusser.prop("disabled",!this.isInterfaceEnabled())},opening:function(){var c,d,e;this.opts.minimumResultsForSearch>=0&&this.showSearch(!0),this.parent.opening.apply(this,arguments),this.showSearchInput!==!1&&this.search.val(this.focusser.val()),this.opts.shouldFocusInput(this)&&(this.search.focus(),c=this.search.get(0),c.createTextRange?(d=c.createTextRange(),d.collapse(!1),d.select()):c.setSelectionRange&&(e=this.search.val().length,c.setSelectionRange(e,e))),""===this.search.val()&&this.nextSearchTerm!=b&&(this.search.val(this.nextSearchTerm),this.search.select()),this.focusser.prop("disabled",!0).val(""),this.updateResults(!0),this.opts.element.trigger(a.Event("select2-open"))},close:function(){this.opened()&&(this.parent.close.apply(this,arguments),this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus())},focus:function(){this.opened()?this.close():(this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus())},isFocused:function(){return this.container.hasClass("select2-container-active")},cancel:function(){this.parent.cancel.apply(this,arguments),this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus()},destroy:function(){a("label[for='"+this.focusser.attr("id")+"']").attr("for",this.opts.element.attr("id")),this.parent.destroy.apply(this,arguments),N.call(this,"selection","focusser")},initContainer:function(){var b,g,c=this.container,d=this.dropdown,e=f();this.opts.minimumResultsForSearch<0?this.showSearch(!1):this.showSearch(!0),this.selection=b=c.find(".select2-choice"),this.focusser=c.find(".select2-focusser"),b.find(".select2-chosen").attr("id","select2-chosen-"+e),this.focusser.attr("aria-labelledby","select2-chosen-"+e),this.results.attr("id","select2-results-"+e),this.search.attr("aria-owns","select2-results-"+e),this.focusser.attr("id","s2id_autogen"+e),g=a("label[for='"+this.opts.element.attr("id")+"']"),this.opts.element.focus(this.bind(function(){this.focus()})),this.focusser.prev().text(g.text()).attr("for",this.focusser.attr("id"));var h=this.opts.element.attr("title");this.opts.element.attr("title",h||g.text()),this.focusser.attr("tabindex",this.elementTabIndex),this.search.attr("id",this.focusser.attr("id")+"_search"),this.search.prev().text(a("label[for='"+this.focusser.attr("id")+"']").text()).attr("for",this.search.attr("id")),this.search.on("keydown",this.bind(function(a){if(this.isInterfaceEnabled()&&229!=a.keyCode){if(a.which===k.PAGE_UP||a.which===k.PAGE_DOWN)return A(a),void 0;switch(a.which){case k.UP:case k.DOWN:return this.moveHighlight(a.which===k.UP?-1:1),A(a),void 0;case k.ENTER:return this.selectHighlighted(),A(a),void 0;case k.TAB:return this.selectHighlighted({noFocus:!0}),void 0;case k.ESC:return this.cancel(a),A(a),void 0}}})),this.search.on("blur",this.bind(function(){document.activeElement===this.body.get(0)&&window.setTimeout(this.bind(function(){this.opened()&&this.search.focus()}),0)})),this.focusser.on("keydown",this.bind(function(a){if(this.isInterfaceEnabled()&&a.which!==k.TAB&&!k.isControl(a)&&!k.isFunctionKey(a)&&a.which!==k.ESC){if(this.opts.openOnEnter===!1&&a.which===k.ENTER)return A(a),void 0;if(a.which==k.DOWN||a.which==k.UP||a.which==k.ENTER&&this.opts.openOnEnter){if(a.altKey||a.ctrlKey||a.shiftKey||a.metaKey)return;return this.open(),A(a),void 0}return a.which==k.DELETE||a.which==k.BACKSPACE?(this.opts.allowClear&&this.clear(),A(a),void 0):void 0}})),u(this.focusser),this.focusser.on("keyup-change input",this.bind(function(a){if(this.opts.minimumResultsForSearch>=0){if(a.stopPropagation(),this.opened())return;this.open()}})),b.on("mousedown touchstart","abbr",this.bind(function(a){this.isInterfaceEnabled()&&(this.clear(),B(a),this.close(),this.selection&&this.selection.focus())})),b.on("mousedown touchstart",this.bind(function(c){n(b),this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.opened()?this.close():this.isInterfaceEnabled()&&this.open(),A(c)})),d.on("mousedown touchstart",this.bind(function(){this.opts.shouldFocusInput(this)&&this.search.focus()})),b.on("focus",this.bind(function(a){A(a)})),this.focusser.on("focus",this.bind(function(){this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.container.addClass("select2-container-active")})).on("blur",this.bind(function(){this.opened()||(this.container.removeClass("select2-container-active"),this.opts.element.trigger(a.Event("select2-blur")))})),this.search.on("focus",this.bind(function(){this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.container.addClass("select2-container-active")})),this.initContainerWidth(),this.opts.element.hide(),this.setPlaceholder()},clear:function(b){var c=this.selection.data("select2-data");if(c){var d=a.Event("select2-clearing");if(this.opts.element.trigger(d),d.isDefaultPrevented())return;var e=this.getPlaceholderOption();this.opts.element.val(e?e.val():""),this.selection.find(".select2-chosen").empty(),this.selection.removeData("select2-data"),this.setPlaceholder(),b!==!1&&(this.opts.element.trigger({type:"select2-removed",val:this.id(c),choice:c}),this.triggerChange({removed:c}))}},initSelection:function(){if(this.isPlaceholderOptionSelected())this.updateSelection(null),this.close(),this.setPlaceholder();else{var c=this;this.opts.initSelection.call(null,this.opts.element,function(a){a!==b&&null!==a&&(c.updateSelection(a),c.close(),c.setPlaceholder(),c.nextSearchTerm=c.opts.nextSearchTerm(a,c.search.val()))})}},isPlaceholderOptionSelected:function(){var a;return this.getPlaceholder()===b?!1:(a=this.getPlaceholderOption())!==b&&a.prop("selected")||""===this.opts.element.val()||this.opts.element.val()===b||null===this.opts.element.val()},prepareOpts:function(){var b=this.parent.prepareOpts.apply(this,arguments),c=this;return"select"===b.element.get(0).tagName.toLowerCase()?b.initSelection=function(a,b){var d=a.find("option").filter(function(){return this.selected&&!this.disabled});b(c.optionToData(d))}:"data"in b&&(b.initSelection=b.initSelection||function(c,d){var e=c.val(),f=null;b.query({matcher:function(a,c,d){var g=r(e,b.id(d));return g&&(f=d),g},callback:a.isFunction(d)?function(){d(f)}:a.noop})}),b},getPlaceholder:function(){return this.select&&this.getPlaceholderOption()===b?b:this.parent.getPlaceholder.apply(this,arguments)},setPlaceholder:function(){var a=this.getPlaceholder();if(this.isPlaceholderOptionSelected()&&a!==b){if(this.select&&this.getPlaceholderOption()===b)return;this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(a)),this.selection.addClass("select2-default"),this.container.removeClass("select2-allowclear")}},postprocessResults:function(a,b,c){var d=0,e=this;if(this.findHighlightableChoices().each2(function(a,b){return r(e.id(b.data("select2-data")),e.opts.element.val())?(d=a,!1):void 0}),c!==!1&&(b===!0&&d>=0?this.highlight(d):this.highlight(0)),b===!0){var g=this.opts.minimumResultsForSearch;g>=0&&this.showSearch(L(a.results)>=g)}},showSearch:function(b){this.showSearchInput!==b&&(this.showSearchInput=b,this.dropdown.find(".select2-search").toggleClass("select2-search-hidden",!b),this.dropdown.find(".select2-search").toggleClass("select2-offscreen",!b),a(this.dropdown,this.container).toggleClass("select2-with-searchbox",b))},onSelect:function(a,b){if(this.triggerSelect(a)){var c=this.opts.element.val(),d=this.data();this.opts.element.val(this.id(a)),this.updateSelection(a),this.opts.element.trigger({type:"select2-selected",val:this.id(a),choice:a}),this.nextSearchTerm=this.opts.nextSearchTerm(a,this.search.val()),this.close(),b&&b.noFocus||!this.opts.shouldFocusInput(this)||this.focusser.focus(),r(c,this.id(a))||this.triggerChange({added:a,removed:d})}},updateSelection:function(a){var d,e,c=this.selection.find(".select2-chosen");this.selection.data("select2-data",a),c.empty(),null!==a&&(d=this.opts.formatSelection(a,c,this.opts.escapeMarkup)),d!==b&&c.append(d),e=this.opts.formatSelectionCssClass(a,c),e!==b&&c.addClass(e),this.selection.removeClass("select2-default"),this.opts.allowClear&&this.getPlaceholder()!==b&&this.container.addClass("select2-allowclear")},val:function(){var a,c=!1,d=null,e=this,f=this.data();if(0===arguments.length)return this.opts.element.val();if(a=arguments[0],arguments.length>1&&(c=arguments[1]),this.select)this.select.val(a).find("option").filter(function(){return this.selected}).each2(function(a,b){return d=e.optionToData(b),!1}),this.updateSelection(d),this.setPlaceholder(),c&&this.triggerChange({added:d,removed:f});else{if(!a&&0!==a)return this.clear(c),void 0;if(this.opts.initSelection===b)throw new Error("cannot call val() if initSelection() is not defined");this.opts.element.val(a),this.opts.initSelection(this.opts.element,function(a){e.opts.element.val(a?e.id(a):""),e.updateSelection(a),e.setPlaceholder(),c&&e.triggerChange({added:a,removed:f})})}},clearSearch:function(){this.search.val(""),this.focusser.val("")},data:function(a){var c,d=!1;return 0===arguments.length?(c=this.selection.data("select2-data"),c==b&&(c=null),c):(arguments.length>1&&(d=arguments[1]),a?(c=this.data(),this.opts.element.val(a?this.id(a):""),this.updateSelection(a),d&&this.triggerChange({added:a,removed:c})):this.clear(d),void 0)}}),e=O(c,{createContainer:function(){var b=a(document.createElement("div")).attr({"class":"select2-container select2-container-multi"}).html(["<ul class='select2-choices'>","  <li class='select2-search-field'>","    <label for='' class='select2-offscreen'></label>","    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>","  </li>","</ul>","<div class='select2-drop select2-drop-multi select2-display-none'>","   <ul class='select2-results'>","   </ul>","</div>"].join(""));return b},prepareOpts:function(){var b=this.parent.prepareOpts.apply(this,arguments),c=this;return"select"===b.element.get(0).tagName.toLowerCase()?b.initSelection=function(a,b){var d=[];a.find("option").filter(function(){return this.selected&&!this.disabled}).each2(function(a,b){d.push(c.optionToData(b))}),b(d)}:"data"in b&&(b.initSelection=b.initSelection||function(c,d){var e=s(c.val(),b.separator,b.transformVal),f=[];b.query({matcher:function(c,d,g){var h=a.grep(e,function(a){return r(a,b.id(g))}).length;return h&&f.push(g),h},callback:a.isFunction(d)?function(){for(var a=[],c=0;c<e.length;c++)for(var g=e[c],h=0;h<f.length;h++){var i=f[h];if(r(g,b.id(i))){a.push(i),f.splice(h,1);break}}d(a)}:a.noop})}),b},selectChoice:function(a){var b=this.container.find(".select2-search-choice-focus");b.length&&a&&a[0]==b[0]||(b.length&&this.opts.element.trigger("choice-deselected",b),b.removeClass("select2-search-choice-focus"),a&&a.length&&(this.close(),a.addClass("select2-search-choice-focus"),this.opts.element.trigger("choice-selected",a)))},destroy:function(){a("label[for='"+this.search.attr("id")+"']").attr("for",this.opts.element.attr("id")),this.parent.destroy.apply(this,arguments),N.call(this,"searchContainer","selection")},initContainer:function(){var c,b=".select2-choices";this.searchContainer=this.container.find(".select2-search-field"),this.selection=c=this.container.find(b);var d=this;this.selection.on("click",".select2-container:not(.select2-container-disabled) .select2-search-choice:not(.select2-locked)",function(){d.search[0].focus(),d.selectChoice(a(this))}),this.search.attr("id","s2id_autogen"+f()),this.search.prev().text(a("label[for='"+this.opts.element.attr("id")+"']").text()).attr("for",this.search.attr("id")),this.opts.element.focus(this.bind(function(){this.focus()})),this.search.on("input paste",this.bind(function(){this.search.attr("placeholder")&&0==this.search.val().length||this.isInterfaceEnabled()&&(this.opened()||this.open())})),this.search.attr("tabindex",this.elementTabIndex),this.keydowns=0,this.search.on("keydown",this.bind(function(a){if(this.isInterfaceEnabled()){++this.keydowns;var b=c.find(".select2-search-choice-focus"),d=b.prev(".select2-search-choice:not(.select2-locked)"),e=b.next(".select2-search-choice:not(.select2-locked)"),f=z(this.search);if(b.length&&(a.which==k.LEFT||a.which==k.RIGHT||a.which==k.BACKSPACE||a.which==k.DELETE||a.which==k.ENTER)){var g=b;return a.which==k.LEFT&&d.length?g=d:a.which==k.RIGHT?g=e.length?e:null:a.which===k.BACKSPACE?this.unselect(b.first())&&(this.search.width(10),g=d.length?d:e):a.which==k.DELETE?this.unselect(b.first())&&(this.search.width(10),g=e.length?e:null):a.which==k.ENTER&&(g=null),this.selectChoice(g),A(a),g&&g.length||this.open(),void 0}if((a.which===k.BACKSPACE&&1==this.keydowns||a.which==k.LEFT)&&0==f.offset&&!f.length)return this.selectChoice(c.find(".select2-search-choice:not(.select2-locked)").last()),A(a),void 0;if(this.selectChoice(null),this.opened())switch(a.which){case k.UP:case k.DOWN:return this.moveHighlight(a.which===k.UP?-1:1),A(a),void 0;case k.ENTER:return this.selectHighlighted(),A(a),void 0;case k.TAB:return this.selectHighlighted({noFocus:!0}),this.close(),void 0;case k.ESC:return this.cancel(a),A(a),void 0}if(a.which!==k.TAB&&!k.isControl(a)&&!k.isFunctionKey(a)&&a.which!==k.BACKSPACE&&a.which!==k.ESC){if(a.which===k.ENTER){if(this.opts.openOnEnter===!1)return;if(a.altKey||a.ctrlKey||a.shiftKey||a.metaKey)return}this.open(),(a.which===k.PAGE_UP||a.which===k.PAGE_DOWN)&&A(a),a.which===k.ENTER&&A(a)}}})),this.search.on("keyup",this.bind(function(){this.keydowns=0,this.resizeSearch()})),this.search.on("blur",this.bind(function(b){this.container.removeClass("select2-container-active"),this.search.removeClass("select2-focused"),this.selectChoice(null),this.opened()||this.clearSearch(),b.stopImmediatePropagation(),this.opts.element.trigger(a.Event("select2-blur"))})),this.container.on("click",b,this.bind(function(b){this.isInterfaceEnabled()&&(a(b.target).closest(".select2-search-choice").length>0||(this.selectChoice(null),this.clearPlaceholder(),this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.open(),this.focusSearch(),b.preventDefault()))})),this.container.on("focus",b,this.bind(function(){this.isInterfaceEnabled()&&(this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.container.addClass("select2-container-active"),this.dropdown.addClass("select2-drop-active"),this.clearPlaceholder())})),this.initContainerWidth(),this.opts.element.hide(),this.clearSearch()},enableInterface:function(){this.parent.enableInterface.apply(this,arguments)&&this.search.prop("disabled",!this.isInterfaceEnabled())},initSelection:function(){if(""===this.opts.element.val()&&""===this.opts.element.text()&&(this.updateSelection([]),this.close(),this.clearSearch()),this.select||""!==this.opts.element.val()){var c=this;this.opts.initSelection.call(null,this.opts.element,function(a){a!==b&&null!==a&&(c.updateSelection(a),c.close(),c.clearSearch())})}},clearSearch:function(){var a=this.getPlaceholder(),c=this.getMaxSearchWidth();a!==b&&0===this.getVal().length&&this.search.hasClass("select2-focused")===!1?(this.search.val(a).addClass("select2-default"),this.search.width(c>0?c:this.container.css("width"))):this.search.val("").width(10)},clearPlaceholder:function(){this.search.hasClass("select2-default")&&this.search.val("").removeClass("select2-default")},opening:function(){this.clearPlaceholder(),this.resizeSearch(),this.parent.opening.apply(this,arguments),this.focusSearch(),""===this.search.val()&&this.nextSearchTerm!=b&&(this.search.val(this.nextSearchTerm),this.search.select()),this.updateResults(!0),this.opts.shouldFocusInput(this)&&this.search.focus(),this.opts.element.trigger(a.Event("select2-open"))},close:function(){this.opened()&&this.parent.close.apply(this,arguments)},focus:function(){this.close(),this.search.focus()},isFocused:function(){return this.search.hasClass("select2-focused")},updateSelection:function(b){var c=[],d=[],e=this;a(b).each(function(){p(e.id(this),c)<0&&(c.push(e.id(this)),d.push(this))}),b=d,this.selection.find(".select2-search-choice").remove(),a(b).each(function(){e.addSelectedChoice(this)}),e.postprocessResults()},tokenize:function(){var a=this.search.val();a=this.opts.tokenizer.call(this,a,this.data(),this.bind(this.onSelect),this.opts),null!=a&&a!=b&&(this.search.val(a),a.length>0&&this.open())},onSelect:function(a,c){this.triggerSelect(a)&&""!==a.text&&(this.addSelectedChoice(a),this.opts.element.trigger({type:"selected",val:this.id(a),choice:a}),this.nextSearchTerm=this.opts.nextSearchTerm(a,this.search.val()),this.clearSearch(),this.updateResults(),(this.select||!this.opts.closeOnSelect)&&this.postprocessResults(a,!1,this.opts.closeOnSelect===!0),this.opts.closeOnSelect?(this.close(),this.search.width(10)):this.countSelectableResults()>0?(this.search.width(10),this.resizeSearch(),this.getMaximumSelectionSize()>0&&this.val().length>=this.getMaximumSelectionSize()?this.updateResults(!0):this.nextSearchTerm!=b&&(this.search.val(this.nextSearchTerm),this.updateResults(),this.search.select()),this.positionDropdown()):(this.close(),this.search.width(10)),this.triggerChange({added:a}),c&&c.noFocus||this.focusSearch())},cancel:function(){this.close(),this.focusSearch()},addSelectedChoice:function(c){var j,k,d=!c.locked,e=a("<li class='select2-search-choice'>    <div></div>    <a href='#' class='select2-search-choice-close' tabindex='-1'></a></li>"),f=a("<li class='select2-search-choice select2-locked'><div></div></li>"),g=d?e:f,h=this.id(c),i=this.getVal();j=this.opts.formatSelection(c,g.find("div"),this.opts.escapeMarkup),j!=b&&g.find("div").replaceWith(a("<div></div>").html(j)),k=this.opts.formatSelectionCssClass(c,g.find("div")),k!=b&&g.addClass(k),d&&g.find(".select2-search-choice-close").on("mousedown",A).on("click dblclick",this.bind(function(b){this.isInterfaceEnabled()&&(this.unselect(a(b.target)),this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus"),A(b),this.close(),this.focusSearch())})).on("focus",this.bind(function(){this.isInterfaceEnabled()&&(this.container.addClass("select2-container-active"),this.dropdown.addClass("select2-drop-active"))})),g.data("select2-data",c),g.insertBefore(this.searchContainer),i.push(h),this.setVal(i)},unselect:function(b){var d,e,c=this.getVal();if(b=b.closest(".select2-search-choice"),0===b.length)throw"Invalid argument: "+b+". Must be .select2-search-choice";if(d=b.data("select2-data")){var f=a.Event("select2-removing");if(f.val=this.id(d),f.choice=d,this.opts.element.trigger(f),f.isDefaultPrevented())return!1;for(;(e=p(this.id(d),c))>=0;)c.splice(e,1),this.setVal(c),this.select&&this.postprocessResults();return b.remove(),this.opts.element.trigger({type:"select2-removed",val:this.id(d),choice:d}),this.triggerChange({removed:d}),!0}},postprocessResults:function(a,b,c){var d=this.getVal(),e=this.results.find(".select2-result"),f=this.results.find(".select2-result-with-children"),g=this;e.each2(function(a,b){var c=g.id(b.data("select2-data"));p(c,d)>=0&&(b.addClass("select2-selected"),b.find(".select2-result-selectable").addClass("select2-selected"))}),f.each2(function(a,b){b.is(".select2-result-selectable")||0!==b.find(".select2-result-selectable:not(.select2-selected)").length||b.addClass("select2-selected")}),-1==this.highlight()&&c!==!1&&this.opts.closeOnSelect===!0&&g.highlight(0),!this.opts.createSearchChoice&&!e.filter(".select2-result:not(.select2-selected)").length>0&&(!a||a&&!a.more&&0===this.results.find(".select2-no-results").length)&&J(g.opts.formatNoMatches,"formatNoMatches")&&this.results.append("<li class='select2-no-results'>"+K(g.opts.formatNoMatches,g.opts.element,g.search.val())+"</li>")},getMaxSearchWidth:function(){return this.selection.width()-t(this.search)},resizeSearch:function(){var a,b,c,d,e,f=t(this.search);a=C(this.search)+10,b=this.search.offset().left,c=this.selection.width(),d=this.selection.offset().left,e=c-(b-d)-f,a>e&&(e=c-f),40>e&&(e=c-f),0>=e&&(e=a),this.search.width(Math.floor(e))},getVal:function(){var a;return this.select?(a=this.select.val(),null===a?[]:a):(a=this.opts.element.val(),s(a,this.opts.separator,this.opts.transformVal))},setVal:function(b){var c;this.select?this.select.val(b):(c=[],a(b).each(function(){p(this,c)<0&&c.push(this)}),this.opts.element.val(0===c.length?"":c.join(this.opts.separator)))},buildChangeDetails:function(a,b){for(var b=b.slice(0),a=a.slice(0),c=0;c<b.length;c++)for(var d=0;d<a.length;d++)r(this.opts.id(b[c]),this.opts.id(a[d]))&&(b.splice(c,1),c>0&&c--,a.splice(d,1),d--);return{added:b,removed:a}},val:function(c,d){var e,f=this;if(0===arguments.length)return this.getVal();if(e=this.data(),e.length||(e=[]),!c&&0!==c)return this.opts.element.val(""),this.updateSelection([]),this.clearSearch(),d&&this.triggerChange({added:this.data(),removed:e}),void 0;if(this.setVal(c),this.select)this.opts.initSelection(this.select,this.bind(this.updateSelection)),d&&this.triggerChange(this.buildChangeDetails(e,this.data()));else{if(this.opts.initSelection===b)throw new Error("val() cannot be called if initSelection() is not defined");this.opts.initSelection(this.opts.element,function(b){var c=a.map(b,f.id);f.setVal(c),f.updateSelection(b),f.clearSearch(),d&&f.triggerChange(f.buildChangeDetails(e,f.data()))})}this.clearSearch()},onSortStart:function(){if(this.select)throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");this.search.width(0),this.searchContainer.hide()},onSortEnd:function(){var b=[],c=this;this.searchContainer.show(),this.searchContainer.appendTo(this.searchContainer.parent()),this.resizeSearch(),this.selection.find(".select2-search-choice").each(function(){b.push(c.opts.id(a(this).data("select2-data")))}),this.setVal(b),this.triggerChange()},data:function(b,c){var e,f,d=this;return 0===arguments.length?this.selection.children(".select2-search-choice").map(function(){return a(this).data("select2-data")}).get():(f=this.data(),b||(b=[]),e=a.map(b,function(a){return d.opts.id(a)}),this.setVal(e),this.updateSelection(b),this.clearSearch(),c&&this.triggerChange(this.buildChangeDetails(f,this.data())),void 0)}}),a.fn.select2=function(){var d,e,f,g,h,c=Array.prototype.slice.call(arguments,0),i=["val","destroy","opened","open","close","focus","isFocused","container","dropdown","onSortStart","onSortEnd","enable","disable","readonly","positionDropdown","data","search"],j=["opened","isFocused","container","dropdown"],k=["val","data"],l={search:"externalSearch"};return this.each(function(){if(0===c.length||"object"==typeof c[0])d=0===c.length?{}:a.extend({},c[0]),d.element=a(this),"select"===d.element.get(0).tagName.toLowerCase()?h=d.element.prop("multiple"):(h=d.multiple||!1,"tags"in d&&(d.multiple=h=!0)),e=h?new window.Select2["class"].multi:new window.Select2["class"].single,e.init(d);else{if("string"!=typeof c[0])throw"Invalid arguments to select2 plugin: "+c;if(p(c[0],i)<0)throw"Unknown method: "+c[0];if(g=b,e=a(this).data("select2"),e===b)return;if(f=c[0],"container"===f?g=e.container:"dropdown"===f?g=e.dropdown:(l[f]&&(f=l[f]),g=e[f].apply(e,c.slice(1))),p(c[0],j)>=0||p(c[0],k)>=0&&1==c.length)return!1}}),g===b?this:g},a.fn.select2.defaults={width:"copy",loadMorePadding:0,closeOnSelect:!0,openOnEnter:!0,containerCss:{},dropdownCss:{},containerCssClass:"",dropdownCssClass:"",formatResult:function(a,b,c,d){var e=[];return E(this.text(a),c.term,e,d),e.join("")},transformVal:function(b){return a.trim(b)},formatSelection:function(a,c,d){return a?d(this.text(a)):b},sortResults:function(a){return a},formatResultCssClass:function(a){return a.css},formatSelectionCssClass:function(){return b},minimumResultsForSearch:0,minimumInputLength:0,maximumInputLength:null,maximumSelectionSize:0,id:function(a){return a==b?null:a.id},text:function(b){return b&&this.data&&this.data.text?a.isFunction(this.data.text)?this.data.text(b):b[this.data.text]:b.text
  },matcher:function(a,b){return o(""+b).toUpperCase().indexOf(o(""+a).toUpperCase())>=0},separator:",",tokenSeparators:[],tokenizer:M,escapeMarkup:F,blurOnChange:!1,selectOnBlur:!1,adaptContainerCssClass:function(a){return a},adaptDropdownCssClass:function(){return null},nextSearchTerm:function(){return b},searchInputPlaceholder:"",createSearchChoicePosition:"top",shouldFocusInput:function(a){var b="ontouchstart"in window||navigator.msMaxTouchPoints>0;return b?a.opts.minimumResultsForSearch<0?!1:!0:!0}},a.fn.select2.locales=[],a.fn.select2.locales.en={formatMatches:function(a){return 1===a?"One result is available, press enter to select it.":a+" results are available, use up and down arrow keys to navigate."},formatNoMatches:function(){return"No matches found"},formatAjaxError:function(){return"Loading failed"},formatInputTooShort:function(a,b){var c=b-a.length;return"Please enter "+c+" or more character"+(1==c?"":"s")},formatInputTooLong:function(a,b){var c=a.length-b;return"Please delete "+c+" character"+(1==c?"":"s")},formatSelectionTooBig:function(a){return"You can only select "+a+" item"+(1==a?"":"s")},formatLoadMore:function(){return"Loading more results\u2026"},formatSearching:function(){return"Searching\u2026"}},a.extend(a.fn.select2.defaults,a.fn.select2.locales.en),a.fn.select2.ajaxDefaults={transport:a.ajax,params:{type:"GET",cache:!1,dataType:"json"}},window.Select2={query:{ajax:G,local:H,tags:I},util:{debounce:w,markMatch:E,escapeMarkup:F,stripDiacritics:o},"class":{"abstract":c,single:d,multi:e}}}}(jQuery);
var q = null;
window.PR_SHOULD_USE_CONTINUATION = !0;
(function () {
  function L(a) {
    function m(a) {
      var f = a.charCodeAt(0);
      if (f !== 92) {
        return f;
      }
      var b = a.charAt(1);
      return (f = r[b])
        ? f
        : '0' <= b && b <= '7'
        ? parseInt(a.substring(1), 8)
        : b === 'u' || b === 'x'
        ? parseInt(a.substring(2), 16)
        : a.charCodeAt(1);
    }
    function e(a) {
      if (a < 32) {
        return (a < 16 ? '\\x0' : '\\x') + a.toString(16);
      }
      a = String.fromCharCode(a);
      if (a === '\\' || a === '-' || a === '[' || a === ']') {
        a = '\\' + a;
      }
      return a;
    }
    function h(a) {
      for (
        var f = a
            .substring(1, a.length - 1)
            .match(
              /\\u[\dA-Fa-f]{4}|\\x[\dA-Fa-f]{2}|\\[0-3][0-7]{0,2}|\\[0-7]{1,2}|\\[\S\s]|[^\\]/g
            ),
          a = [],
          b = [],
          o = f[0] === '^',
          c = o ? 1 : 0,
          i = f.length;
        c < i;
        ++c
      ) {
        var j = f[c];
        if (/\\[bdsw]/i.test(j)) {
          a.push(j);
        } else {
          var j = m(j),
            d;
          c + 2 < i && '-' === f[c + 1]
            ? ((d = m(f[c + 2])), (c += 2))
            : (d = j);
          b.push([j, d]);
          d < 65 ||
            j > 122 ||
            (d < 65 ||
              j > 90 ||
              b.push([Math.max(65, j) | 32, Math.min(d, 90) | 32]),
            d < 97 ||
              j > 122 ||
              b.push([Math.max(97, j) & -33, Math.min(d, 122) & -33]));
        }
      }
      b.sort(function (a, f) {
        return a[0] - f[0] || f[1] - a[1];
      });
      f = [];
      j = [NaN, NaN];
      for (c = 0; c < b.length; ++c) {
        (i = b[c]),
          i[0] <= j[1] + 1 ? (j[1] = Math.max(j[1], i[1])) : f.push((j = i));
      }
      b = ['['];
      o && b.push('^');
      b.push.apply(b, a);
      for (c = 0; c < f.length; ++c) {
        (i = f[c]),
          b.push(e(i[0])),
          i[1] > i[0] && (i[1] + 1 > i[0] && b.push('-'), b.push(e(i[1])));
      }
      b.push(']');
      return b.join('');
    }
    function y(a) {
      for (
        var f = a.source.match(
            /\[(?:[^\\\]]|\\[\S\s])*]|\\u[\dA-Fa-f]{4}|\\x[\dA-Fa-f]{2}|\\\d+|\\[^\dux]|\(\?[!:=]|[()^]|[^()[\\^]+/g
          ),
          b = f.length,
          d = [],
          c = 0,
          i = 0;
        c < b;
        ++c
      ) {
        var j = f[c];
        j === '('
          ? ++i
          : '\\' === j.charAt(0) &&
            (j = +j.substring(1)) &&
            j <= i &&
            (d[j] = -1);
      }
      for (c = 1; c < d.length; ++c) {
        -1 === d[c] && (d[c] = ++t);
      }
      for (i = c = 0; c < b; ++c) {
        (j = f[c]),
          j === '('
            ? (++i, d[i] === void 0 && (f[c] = '(?:'))
            : '\\' === j.charAt(0) &&
              (j = +j.substring(1)) &&
              j <= i &&
              (f[c] = '\\' + d[i]);
      }
      for (i = c = 0; c < b; ++c) {
        '^' === f[c] && '^' !== f[c + 1] && (f[c] = '');
      }
      if (a.ignoreCase && s) {
        for (c = 0; c < b; ++c) {
          (j = f[c]),
            (a = j.charAt(0)),
            j.length >= 2 && a === '['
              ? (f[c] = h(j))
              : a !== '\\' &&
                (f[c] = j.replace(/[A-Za-z]/g, function (a) {
                  a = a.charCodeAt(0);
                  return '[' + String.fromCharCode(a & -33, a | 32) + ']';
                }));
        }
      }
      return f.join('');
    }
    for (var t = 0, s = !1, l = !1, p = 0, d = a.length; p < d; ++p) {
      var g = a[p];
      if (g.ignoreCase) {
        l = !0;
      } else if (
        /[a-z]/i.test(
          g.source.replace(/\\u[\da-f]{4}|\\x[\da-f]{2}|\\[^UXux]/gi, '')
        )
      ) {
        s = !0;
        l = !1;
        break;
      }
    }
    for (
      var r = { b: 8, t: 9, n: 10, v: 11, f: 12, r: 13 },
        n = [],
        p = 0,
        d = a.length;
      p < d;
      ++p
    ) {
      g = a[p];
      if (g.global || g.multiline) {
        throw Error('' + g);
      }
      n.push('(?:' + y(g) + ')');
    }
    return RegExp(n.join('|'), l ? 'gi' : 'g');
  }
  function M(a) {
    function m(a) {
      switch (a.nodeType) {
        case 1:
          if (e.test(a.className)) {
            break;
          }
          for (var g = a.firstChild; g; g = g.nextSibling) {
            m(g);
          }
          g = a.nodeName;
          if ('BR' === g || 'LI' === g) {
            (h[s] = '\n'), (t[s << 1] = y++), (t[(s++ << 1) | 1] = a);
          }
          break;
        case 3:
        case 4:
          (g = a.nodeValue),
            g.length &&
              ((g = p
                ? g.replace(/\r\n?/g, '\n')
                : g.replace(/[\t\n\r ]+/g, ' ')),
              (h[s] = g),
              (t[s << 1] = y),
              (y += g.length),
              (t[(s++ << 1) | 1] = a));
      }
    }
    var e = /(?:^|\s)nocode(?:\s|$)/,
      h = [],
      y = 0,
      t = [],
      s = 0,
      l;
    a.currentStyle
      ? (l = a.currentStyle.whiteSpace)
      : window.getComputedStyle &&
        (l = document.defaultView
          .getComputedStyle(a, q)
          .getPropertyValue('white-space'));
    var p = l && 'pre' === l.substring(0, 3);
    m(a);
    return { a: h.join('').replace(/\n$/, ''), c: t };
  }
  function B(a, m, e, h) {
    m && ((a = { a: m, d: a }), e(a), h.push.apply(h, a.e));
  }
  function x(a, m) {
    function e(a) {
      for (
        var l = a.d,
          p = [l, 'pln'],
          d = 0,
          g = a.a.match(y) || [],
          r = {},
          n = 0,
          z = g.length;
        n < z;
        ++n
      ) {
        var f = g[n],
          b = r[f],
          o = void 0,
          c;
        if (typeof b === 'string') {
          c = !1;
        } else {
          var i = h[f.charAt(0)];
          if (i) {
            (o = f.match(i[1])), (b = i[0]);
          } else {
            for (c = 0; c < t; ++c) {
              if (((i = m[c]), (o = f.match(i[1])))) {
                b = i[0];
                break;
              }
            }
            o || (b = 'pln');
          }
          if (
            (c = b.length >= 5 && 'lang-' === b.substring(0, 5)) &&
            !(o && typeof o[1] === 'string')
          ) {
            (c = !1), (b = 'src');
          }
          c || (r[f] = b);
        }
        i = d;
        d += f.length;
        if (c) {
          c = o[1];
          var j = f.indexOf(c),
            k = j + c.length;
          o[2] && ((k = f.length - o[2].length), (j = k - c.length));
          b = b.substring(5);
          B(l + i, f.substring(0, j), e, p);
          B(l + i + j, c, C(b, c), p);
          B(l + i + k, f.substring(k), e, p);
        } else {
          p.push(l + i, b);
        }
      }
      a.e = p;
    }
    var h = {},
      y;
    (function () {
      for (
        var e = a.concat(m), l = [], p = {}, d = 0, g = e.length;
        d < g;
        ++d
      ) {
        var r = e[d],
          n = r[3];
        if (n) {
          for (var k = n.length; --k >= 0; ) {
            h[n.charAt(k)] = r;
          }
        }
        r = r[1];
        n = '' + r;
        p.hasOwnProperty(n) || (l.push(r), (p[n] = q));
      }
      l.push(/[\S\s]/);
      y = L(l);
    })();
    var t = m.length;
    return e;
  }
  function u(a) {
    var m = [],
      e = [];
    a.tripleQuotedStrings
      ? m.push([
          'str',
          /^(?:'''(?:[^'\\]|\\[\S\s]|''?(?=[^']))*(?:'''|$)|"""(?:[^"\\]|\\[\S\s]|""?(?=[^"]))*(?:"""|$)|'(?:[^'\\]|\\[\S\s])*(?:'|$)|"(?:[^"\\]|\\[\S\s])*(?:"|$))/,
          q,
          '\'"',
        ])
      : a.multiLineStrings
      ? m.push([
          'str',
          /^(?:'(?:[^'\\]|\\[\S\s])*(?:'|$)|"(?:[^"\\]|\\[\S\s])*(?:"|$)|`(?:[^\\`]|\\[\S\s])*(?:`|$))/,
          q,
          '\'"`',
        ])
      : m.push([
          'str',
          /^(?:'(?:[^\n\r'\\]|\\.)*(?:'|$)|"(?:[^\n\r"\\]|\\.)*(?:"|$))/,
          q,
          '"\'',
        ]);
    a.verbatimStrings && e.push(['str', /^@"(?:[^"]|"")*(?:"|$)/, q]);
    var h = a.hashComments;
    h &&
      (a.cStyleComments
        ? (h > 1
            ? m.push(['com', /^#(?:##(?:[^#]|#(?!##))*(?:###|$)|.*)/, q, '#'])
            : m.push([
                'com',
                /^#(?:(?:define|elif|else|endif|error|ifdef|include|ifndef|line|pragma|undef|warning)\b|[^\n\r]*)/,
                q,
                '#',
              ]),
          e.push([
            'str',
            /^<(?:(?:(?:\.\.\/)*|\/?)(?:[\w-]+(?:\/[\w-]+)+)?[\w-]+\.h|[a-z]\w*)>/,
            q,
          ]))
        : m.push(['com', /^#[^\n\r]*/, q, '#']));
    a.cStyleComments &&
      (e.push(['com', /^\/\/[^\n\r]*/, q]),
      e.push(['com', /^\/\*[\S\s]*?(?:\*\/|$)/, q]));
    a.regexLiterals &&
      e.push([
        'lang-regex',
        /^(?:^^\.?|[!+-]|!=|!==|#|%|%=|&|&&|&&=|&=|\(|\*|\*=|\+=|,|-=|->|\/|\/=|:|::|;|<|<<|<<=|<=|=|==|===|>|>=|>>|>>=|>>>|>>>=|[?@[^]|\^=|\^\^|\^\^=|{|\||\|=|\|\||\|\|=|~|break|case|continue|delete|do|else|finally|instanceof|return|throw|try|typeof)\s*(\/(?=[^*/])(?:[^/[\\]|\\[\S\s]|\[(?:[^\\\]]|\\[\S\s])*(?:]|$))+\/)/,
      ]);
    (h = a.types) && e.push(['typ', h]);
    a = ('' + a.keywords).replace(/^ | $/g, '');
    a.length &&
      e.push(['kwd', RegExp('^(?:' + a.replace(/[\s,]+/g, '|') + ')\\b'), q]);
    m.push(['pln', /^\s+/, q, ' \r\n\t\xa0']);
    e.push(
      ['lit', /^@[$_a-z][\w$@]*/i, q],
      ['typ', /^(?:[@_]?[A-Z]+[a-z][\w$@]*|\w+_t\b)/, q],
      ['pln', /^[$_a-z][\w$@]*/i, q],
      [
        'lit',
        /^(?:0x[\da-f]+|(?:\d(?:_\d+)*\d*(?:\.\d*)?|\.\d\+)(?:e[+-]?\d+)?)[a-z]*/i,
        q,
        '0123456789',
      ],
      ['pln', /^\\[\S\s]?/, q],
      ['pun', /^.[^\s\w"-$'./@\\`]*/, q]
    );
    return x(m, e);
  }
  function D(a, m) {
    function e(a) {
      switch (a.nodeType) {
        case 1:
          if (k.test(a.className)) {
            break;
          }
          if ('BR' === a.nodeName) {
            h(a), a.parentNode && a.parentNode.removeChild(a);
          } else {
            for (a = a.firstChild; a; a = a.nextSibling) {
              e(a);
            }
          }
          break;
        case 3:
        case 4:
          if (p) {
            var b = a.nodeValue,
              d = b.match(t);
            if (d) {
              var c = b.substring(0, d.index);
              a.nodeValue = c;
              (b = b.substring(d.index + d[0].length)) &&
                a.parentNode.insertBefore(s.createTextNode(b), a.nextSibling);
              h(a);
              c || a.parentNode.removeChild(a);
            }
          }
      }
    }
    function h(a) {
      function b(a, d) {
        var e = d ? a.cloneNode(!1) : a,
          f = a.parentNode;
        if (f) {
          var f = b(f, 1),
            g = a.nextSibling;
          f.appendChild(e);
          for (var h = g; h; h = g) {
            (g = h.nextSibling), f.appendChild(h);
          }
        }
        return e;
      }
      for (; !a.nextSibling; ) {
        if (((a = a.parentNode), !a)) {
          return;
        }
      }
      for (
        var a = b(a.nextSibling, 0), e;
        (e = a.parentNode) && e.nodeType === 1;

      ) {
        a = e;
      }
      d.push(a);
    }
    var k = /(?:^|\s)nocode(?:\s|$)/,
      t = /\r\n?|\n/,
      s = a.ownerDocument,
      l;
    a.currentStyle
      ? (l = a.currentStyle.whiteSpace)
      : window.getComputedStyle &&
        (l = s.defaultView
          .getComputedStyle(a, q)
          .getPropertyValue('white-space'));
    var p = l && 'pre' === l.substring(0, 3);
    for (l = s.createElement('LI'); a.firstChild; ) {
      l.appendChild(a.firstChild);
    }
    for (var d = [l], g = 0; g < d.length; ++g) {
      e(d[g]);
    }
    m === (m | 0) && d[0].setAttribute('value', m);
    var r = s.createElement('OL');
    r.className = 'linenums';
    for (
      var n = Math.max(0, (m - 1) | 0) || 0, g = 0, z = d.length;
      g < z;
      ++g
    ) {
      (l = d[g]),
        (l.className = 'L' + ((g + n) % 10)),
        l.firstChild || l.appendChild(s.createTextNode('\xa0')),
        r.appendChild(l);
    }
    a.appendChild(r);
  }
  function k(a, m) {
    for (var e = m.length; --e >= 0; ) {
      var h = m[e];
      A.hasOwnProperty(h)
        ? window.console &&
          console.warn('cannot override language handler %s', h)
        : (A[h] = a);
    }
  }
  function C(a, m) {
    if (!a || !A.hasOwnProperty(a)) {
      a = /^\s*</.test(m) ? 'default-markup' : 'default-code';
    }
    return A[a];
  }
  function E(a) {
    var m = a.g;
    try {
      var e = M(a.h),
        h = e.a;
      a.a = h;
      a.c = e.c;
      a.d = 0;
      C(m, h)(a);
      var k = /\bMSIE\b/.test(navigator.userAgent),
        m = /\n/g,
        t = a.a,
        s = t.length,
        e = 0,
        l = a.c,
        p = l.length,
        h = 0,
        d = a.e,
        g = d.length,
        a = 0;
      d[g] = s;
      var r, n;
      for (n = r = 0; n < g; ) {
        d[n] !== d[n + 2] ? ((d[r++] = d[n++]), (d[r++] = d[n++])) : (n += 2);
      }
      g = r;
      for (n = r = 0; n < g; ) {
        for (
          var z = d[n], f = d[n + 1], b = n + 2;
          b + 2 <= g && d[b + 1] === f;

        ) {
          b += 2;
        }
        d[r++] = z;
        d[r++] = f;
        n = b;
      }
      for (d.length = r; h < p; ) {
        var o = l[h + 2] || s,
          c = d[a + 2] || s,
          b = Math.min(o, c),
          i = l[h + 1],
          j;
        if (i.nodeType !== 1 && (j = t.substring(e, b))) {
          k && (j = j.replace(m, '\r'));
          i.nodeValue = j;
          var u = i.ownerDocument,
            v = u.createElement('SPAN');
          v.className = d[a + 1];
          var x = i.parentNode;
          x.replaceChild(v, i);
          v.appendChild(i);
          e < o &&
            ((l[h + 1] = i = u.createTextNode(t.substring(b, o))),
            x.insertBefore(i, v.nextSibling));
        }
        e = b;
        e >= o && (h += 2);
        e >= c && (a += 2);
      }
    } catch (w) {
      'console' in window && console.log(w && w.stack ? w.stack : w);
    }
  }
  var v = ['break,continue,do,else,for,if,return,while'],
    w = [
      [
        v,
        'auto,case,char,const,default,double,enum,extern,float,goto,int,long,register,short,signed,sizeof,static,struct,switch,typedef,union,unsigned,void,volatile',
      ],
      'catch,class,delete,false,import,new,operator,private,protected,public,this,throw,true,try,typeof',
    ],
    F = [
      w,
      'alignof,align_union,asm,axiom,bool,concept,concept_map,const_cast,constexpr,decltype,dynamic_cast,explicit,export,friend,inline,late_check,mutable,namespace,nullptr,reinterpret_cast,static_assert,static_cast,template,typeid,typename,using,virtual,where',
    ],
    G = [
      w,
      'abstract,boolean,byte,extends,final,finally,implements,import,instanceof,null,native,package,strictfp,super,synchronized,throws,transient',
    ],
    H = [
      G,
      'as,base,by,checked,decimal,delegate,descending,dynamic,event,fixed,foreach,from,group,implicit,in,interface,internal,into,is,lock,object,out,override,orderby,params,partial,readonly,ref,sbyte,sealed,stackalloc,string,select,uint,ulong,unchecked,unsafe,ushort,var',
    ],
    w = [
      w,
      'debugger,eval,export,function,get,null,set,undefined,var,with,Infinity,NaN',
    ],
    I = [
      v,
      'and,as,assert,class,def,del,elif,except,exec,finally,from,global,import,in,is,lambda,nonlocal,not,or,pass,print,raise,try,with,yield,False,True,None',
    ],
    J = [
      v,
      'alias,and,begin,case,class,def,defined,elsif,end,ensure,false,in,module,next,nil,not,or,redo,rescue,retry,self,super,then,true,undef,unless,until,when,yield,BEGIN,END',
    ],
    v = [v, 'case,done,elif,esac,eval,fi,function,in,local,set,then,until'],
    K = /^(DIR|FILE|vector|(de|priority_)?queue|list|stack|(const_)?iterator|(multi)?(set|map)|bitset|u?(int|float)\d*)/,
    N = /\S/,
    O = u({
      keywords: [
        F,
        H,
        w,
        'caller,delete,die,do,dump,elsif,eval,exit,foreach,for,goto,if,import,last,local,my,next,no,our,print,package,redo,require,sub,undef,unless,until,use,wantarray,while,BEGIN,END' +
          I,
        J,
        v,
      ],
      hashComments: !0,
      cStyleComments: !0,
      multiLineStrings: !0,
      regexLiterals: !0,
    }),
    A = {};
  k(O, ['default-code']);
  k(
    x(
      [],
      [
        ['pln', /^[^<?]+/],
        ['dec', /^<!\w[^>]*(?:>|$)/],
        ['com', /^<\!--[\S\s]*?(?:--\>|$)/],
        ['lang-', /^<\?([\S\s]+?)(?:\?>|$)/],
        ['lang-', /^<%([\S\s]+?)(?:%>|$)/],
        ['pun', /^(?:<[%?]|[%?]>)/],
        ['lang-', /^<xmp\b[^>]*>([\S\s]+?)<\/xmp\b[^>]*>/i],
        ['lang-js', /^<script\b[^>]*>([\S\s]*?)(<\/script\b[^>]*>)/i],
        ['lang-css', /^<style\b[^>]*>([\S\s]*?)(<\/style\b[^>]*>)/i],
        ['lang-in.tag', /^(<\/?[a-z][^<>]*>)/i],
      ]
    ),
    ['default-markup', 'htm', 'html', 'mxml', 'xhtml', 'xml', 'xsl']
  );
  k(
    x(
      [
        ['pln', /^\s+/, q, ' \t\r\n'],
        ['atv', /^(?:"[^"]*"?|'[^']*'?)/, q, '"\''],
      ],
      [
        ['tag', /^^<\/?[a-z](?:[\w-.:]*\w)?|\/?>$/i],
        ['atn', /^(?!style[\s=]|on)[a-z](?:[\w:-]*\w)?/i],
        ['lang-uq.val', /^=\s*([^\s"'>]*(?:[^\s"'/>]|\/(?=\s)))/],
        ['pun', /^[/<->]+/],
        ['lang-js', /^on\w+\s*=\s*"([^"]+)"/i],
        ['lang-js', /^on\w+\s*=\s*'([^']+)'/i],
        ['lang-js', /^on\w+\s*=\s*([^\s"'>]+)/i],
        ['lang-css', /^style\s*=\s*"([^"]+)"/i],
        ['lang-css', /^style\s*=\s*'([^']+)'/i],
        ['lang-css', /^style\s*=\s*([^\s"'>]+)/i],
      ]
    ),
    ['in.tag']
  );
  k(x([], [['atv', /^[\S\s]+/]]), ['uq.val']);
  k(u({ keywords: F, hashComments: !0, cStyleComments: !0, types: K }), [
    'c',
    'cc',
    'cpp',
    'cxx',
    'cyc',
    'm',
  ]);
  k(u({ keywords: 'null,true,false' }), ['json']);
  k(
    u({
      keywords: H,
      hashComments: !0,
      cStyleComments: !0,
      verbatimStrings: !0,
      types: K,
    }),
    ['cs']
  );
  k(u({ keywords: G, cStyleComments: !0 }), ['java']);
  k(u({ keywords: v, hashComments: !0, multiLineStrings: !0 }), [
    'bsh',
    'csh',
    'sh',
  ]);
  k(
    u({
      keywords: I,
      hashComments: !0,
      multiLineStrings: !0,
      tripleQuotedStrings: !0,
    }),
    ['cv', 'py']
  );
  k(
    u({
      keywords:
        'caller,delete,die,do,dump,elsif,eval,exit,foreach,for,goto,if,import,last,local,my,next,no,our,print,package,redo,require,sub,undef,unless,until,use,wantarray,while,BEGIN,END',
      hashComments: !0,
      multiLineStrings: !0,
      regexLiterals: !0,
    }),
    ['perl', 'pl', 'pm']
  );
  k(
    u({
      keywords: J,
      hashComments: !0,
      multiLineStrings: !0,
      regexLiterals: !0,
    }),
    ['rb']
  );
  k(u({ keywords: w, cStyleComments: !0, regexLiterals: !0 }), ['js']);
  k(
    u({
      keywords:
        'all,and,by,catch,class,else,extends,false,finally,for,if,in,is,isnt,loop,new,no,not,null,of,off,on,or,return,super,then,true,try,unless,until,when,while,yes',
      hashComments: 3,
      cStyleComments: !0,
      multilineStrings: !0,
      tripleQuotedStrings: !0,
      regexLiterals: !0,
    }),
    ['coffee']
  );
  k(x([], [['str', /^[\S\s]+/]]), ['regex']);
  window.prettyPrintOne = function (a, m, e) {
    var h = document.createElement('PRE');
    h.innerHTML = a;
    e && D(h, e);
    E({ g: m, i: e, h: h });
    return h.innerHTML;
  };
  window.prettyPrint = function (a) {
    function m() {
      for (
        var e = window.PR_SHOULD_USE_CONTINUATION ? l.now() + 250 : Infinity;
        p < h.length && l.now() < e;
        p++
      ) {
        var n = h[p],
          k = n.className;
        if (k.indexOf('prettyprint') >= 0) {
          var k = k.match(g),
            f,
            b;
          if ((b = !k)) {
            b = n;
            for (var o = void 0, c = b.firstChild; c; c = c.nextSibling) {
              var i = c.nodeType,
                o =
                  i === 1
                    ? o
                      ? b
                      : c
                    : i === 3
                    ? N.test(c.nodeValue)
                      ? b
                      : o
                    : o;
            }
            b = (f = o === b ? void 0 : o) && 'CODE' === f.tagName;
          }
          b && (k = f.className.match(g));
          k && (k = k[1]);
          b = !1;
          for (o = n.parentNode; o; o = o.parentNode) {
            if (
              (o.tagName === 'pre' ||
                o.tagName === 'code' ||
                o.tagName === 'xmp') &&
              o.className &&
              o.className.indexOf('prettyprint') >= 0
            ) {
              b = !0;
              break;
            }
          }
          b ||
            ((b = (b = n.className.match(/\blinenums\b(?::(\d+))?/))
              ? b[1] && b[1].length
                ? +b[1]
                : !0
              : !1) && D(n, b),
            (d = { g: k, h: n, i: b }),
            E(d));
        }
      }
      p < h.length ? setTimeout(m, 250) : a && a();
    }
    for (
      var e = [
          document.getElementsByTagName('pre'),
          document.getElementsByTagName('code'),
          document.getElementsByTagName('xmp'),
        ],
        h = [],
        k = 0;
      k < e.length;
      ++k
    ) {
      for (var t = 0, s = e[k].length; t < s; ++t) {
        h.push(e[k][t]);
      }
    }
    var e = q,
      l = Date;
    l.now ||
      (l = {
        now: function () {
          return +new Date();
        },
      });
    var p = 0,
      d,
      g = /\blang(?:uage)?-([\w.]+)(?!\S)/;
    m();
  };
  window.PR = {
    createSimpleLexer: x,
    registerLangHandler: k,
    sourceDecorator: u,
    PR_ATTRIB_NAME: 'atn',
    PR_ATTRIB_VALUE: 'atv',
    PR_COMMENT: 'com',
    PR_DECLARATION: 'dec',
    PR_KEYWORD: 'kwd',
    PR_LITERAL: 'lit',
    PR_NOCODE: 'nocode',
    PR_PLAIN: 'pln',
    PR_PUNCTUATION: 'pun',
    PR_SOURCE: 'src',
    PR_STRING: 'str',
    PR_TAG: 'tag',
    PR_TYPE: 'typ',
  };
})();
PR.registerLangHandler(
  PR.createSimpleLexer(
    [['pln', /^[\t\n\f\r ]+/, null, ' \t\r\n']],
    [
      ['str', /^"(?:[^\n\f\r"\\]|\\(?:\r\n?|\n|\f)|\\[\S\s])*"/, null],
      ['str', /^'(?:[^\n\f\r'\\]|\\(?:\r\n?|\n|\f)|\\[\S\s])*'/, null],
      ['lang-css-str', /^url\(([^"')]*)\)/i],
      [
        'kwd',
        /^(?:url|rgb|!important|@import|@page|@media|@charset|inherit)(?=[^\w-]|$)/i,
        null,
      ],
      [
        'lang-css-kw',
        /^(-?(?:[_a-z]|\\[\da-f]+ ?)(?:[\w-]|\\\\[\da-f]+ ?)*)\s*:/i,
      ],
      ['com', /^\/\*[^*]*\*+(?:[^*/][^*]*\*+)*\//],
      ['com', /^(?:<\!--|--\>)/],
      ['lit', /^(?:\d+|\d*\.\d+)(?:%|[a-z]+)?/i],
      ['lit', /^#[\da-f]{3,6}/i],
      ['pln', /^-?(?:[_a-z]|\\[\da-f]+ ?)(?:[\w-]|\\\\[\da-f]+ ?)*/i],
      ['pun', /^[^\s\w"']+/],
    ]
  ),
  ['css']
);
PR.registerLangHandler(
  PR.createSimpleLexer(
    [],
    [['kwd', /^-?(?:[_a-z]|\\[\da-f]+ ?)(?:[\w-]|\\\\[\da-f]+ ?)*/i]]
  ),
  ['css-kw']
);
PR.registerLangHandler(PR.createSimpleLexer([], [['str', /^[^"')]+/]]), [
  'css-str',
]);
/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 2.7.3
 *
 * Copyright 2018 Chart.js Contributors
 * Released under the MIT license
 * https://github.com/chartjs/Chart.js/blob/master/LICENSE.md
 */
!(function (t) {
  if ('object' == typeof exports && 'undefined' != typeof module)
    module.exports = t();
  else if ('function' == typeof define && define.amd) define([], t);
  else {
    ('undefined' != typeof window
      ? window
      : 'undefined' != typeof global
      ? global
      : 'undefined' != typeof self
      ? self
      : this
    ).Chart = t();
  }
})(function () {
  return (function o(r, s, l) {
    function u(e, t) {
      if (!s[e]) {
        if (!r[e]) {
          var i = 'function' == typeof require && require;
          if (!t && i) return i(e, !0);
          if (d) return d(e, !0);
          var n = new Error("Cannot find module '" + e + "'");
          throw ((n.code = 'MODULE_NOT_FOUND'), n);
        }
        var a = (s[e] = { exports: {} });
        r[e][0].call(
          a.exports,
          function (t) {
            return u(r[e][1][t] || t);
          },
          a,
          a.exports,
          o,
          r,
          s,
          l
        );
      }
      return s[e].exports;
    }
    for (
      var d = 'function' == typeof require && require, t = 0;
      t < l.length;
      t++
    )
      u(l[t]);
    return u;
  })(
    {
      1: [function (t, e, i) {}, {}],
      2: [
        function (t, e, i) {
          var o = t(6);
          function n(t) {
            if (t) {
              var e = [0, 0, 0],
                i = 1,
                n = t.match(/^#([a-fA-F0-9]{3})$/i);
              if (n) {
                n = n[1];
                for (var a = 0; a < e.length; a++)
                  e[a] = parseInt(n[a] + n[a], 16);
              } else if ((n = t.match(/^#([a-fA-F0-9]{6})$/i))) {
                n = n[1];
                for (a = 0; a < e.length; a++)
                  e[a] = parseInt(n.slice(2 * a, 2 * a + 2), 16);
              } else if (
                (n = t.match(
                  /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i
                ))
              ) {
                for (a = 0; a < e.length; a++) e[a] = parseInt(n[a + 1]);
                i = parseFloat(n[4]);
              } else if (
                (n = t.match(
                  /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i
                ))
              ) {
                for (a = 0; a < e.length; a++)
                  e[a] = Math.round(2.55 * parseFloat(n[a + 1]));
                i = parseFloat(n[4]);
              } else if ((n = t.match(/(\w+)/))) {
                if ('transparent' == n[1]) return [0, 0, 0, 0];
                if (!(e = o[n[1]])) return;
              }
              for (a = 0; a < e.length; a++) e[a] = d(e[a], 0, 255);
              return (i = i || 0 == i ? d(i, 0, 1) : 1), (e[3] = i), e;
            }
          }
          function a(t) {
            if (t) {
              var e = t.match(
                /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/
              );
              if (e) {
                var i = parseFloat(e[4]);
                return [
                  d(parseInt(e[1]), 0, 360),
                  d(parseFloat(e[2]), 0, 100),
                  d(parseFloat(e[3]), 0, 100),
                  d(isNaN(i) ? 1 : i, 0, 1),
                ];
              }
            }
          }
          function r(t) {
            if (t) {
              var e = t.match(
                /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/
              );
              if (e) {
                var i = parseFloat(e[4]);
                return [
                  d(parseInt(e[1]), 0, 360),
                  d(parseFloat(e[2]), 0, 100),
                  d(parseFloat(e[3]), 0, 100),
                  d(isNaN(i) ? 1 : i, 0, 1),
                ];
              }
            }
          }
          function s(t, e) {
            return (
              void 0 === e && (e = void 0 !== t[3] ? t[3] : 1),
              'rgba(' + t[0] + ', ' + t[1] + ', ' + t[2] + ', ' + e + ')'
            );
          }
          function l(t, e) {
            return (
              'rgba(' +
              Math.round((t[0] / 255) * 100) +
              '%, ' +
              Math.round((t[1] / 255) * 100) +
              '%, ' +
              Math.round((t[2] / 255) * 100) +
              '%, ' +
              (e || t[3] || 1) +
              ')'
            );
          }
          function u(t, e) {
            return (
              void 0 === e && (e = void 0 !== t[3] ? t[3] : 1),
              'hsla(' + t[0] + ', ' + t[1] + '%, ' + t[2] + '%, ' + e + ')'
            );
          }
          function d(t, e, i) {
            return Math.min(Math.max(e, t), i);
          }
          function c(t) {
            var e = t.toString(16).toUpperCase();
            return e.length < 2 ? '0' + e : e;
          }
          e.exports = {
            getRgba: n,
            getHsla: a,
            getRgb: function (t) {
              var e = n(t);
              return e && e.slice(0, 3);
            },
            getHsl: function (t) {
              var e = a(t);
              return e && e.slice(0, 3);
            },
            getHwb: r,
            getAlpha: function (t) {
              var e = n(t);
              {
                if (e) return e[3];
                if ((e = a(t))) return e[3];
                if ((e = r(t))) return e[3];
              }
            },
            hexString: function (t) {
              return '#' + c(t[0]) + c(t[1]) + c(t[2]);
            },
            rgbString: function (t, e) {
              if (e < 1 || (t[3] && t[3] < 1)) return s(t, e);
              return 'rgb(' + t[0] + ', ' + t[1] + ', ' + t[2] + ')';
            },
            rgbaString: s,
            percentString: function (t, e) {
              if (e < 1 || (t[3] && t[3] < 1)) return l(t, e);
              var i = Math.round((t[0] / 255) * 100),
                n = Math.round((t[1] / 255) * 100),
                a = Math.round((t[2] / 255) * 100);
              return 'rgb(' + i + '%, ' + n + '%, ' + a + '%)';
            },
            percentaString: l,
            hslString: function (t, e) {
              if (e < 1 || (t[3] && t[3] < 1)) return u(t, e);
              return 'hsl(' + t[0] + ', ' + t[1] + '%, ' + t[2] + '%)';
            },
            hslaString: u,
            hwbString: function (t, e) {
              void 0 === e && (e = void 0 !== t[3] ? t[3] : 1);
              return (
                'hwb(' +
                t[0] +
                ', ' +
                t[1] +
                '%, ' +
                t[2] +
                '%' +
                (void 0 !== e && 1 !== e ? ', ' + e : '') +
                ')'
              );
            },
            keyword: function (t) {
              return h[t.slice(0, 3)];
            },
          };
          var h = {};
          for (var f in o) h[o[f]] = f;
        },
        { 6: 6 },
      ],
      3: [
        function (t, e, i) {
          var d = t(5),
            n = t(2),
            r = function (t) {
              return t instanceof r
                ? t
                : this instanceof r
                ? ((this.valid = !1),
                  (this.values = {
                    rgb: [0, 0, 0],
                    hsl: [0, 0, 0],
                    hsv: [0, 0, 0],
                    hwb: [0, 0, 0],
                    cmyk: [0, 0, 0, 0],
                    alpha: 1,
                  }),
                  void ('string' == typeof t
                    ? (e = n.getRgba(t))
                      ? this.setValues('rgb', e)
                      : (e = n.getHsla(t))
                      ? this.setValues('hsl', e)
                      : (e = n.getHwb(t)) && this.setValues('hwb', e)
                    : 'object' == typeof t &&
                      (void 0 !== (e = t).r || void 0 !== e.red
                        ? this.setValues('rgb', e)
                        : void 0 !== e.l || void 0 !== e.lightness
                        ? this.setValues('hsl', e)
                        : void 0 !== e.v || void 0 !== e.value
                        ? this.setValues('hsv', e)
                        : void 0 !== e.w || void 0 !== e.whiteness
                        ? this.setValues('hwb', e)
                        : (void 0 === e.c && void 0 === e.cyan) ||
                          this.setValues('cmyk', e))))
                : new r(t);
              var e;
            };
          (r.prototype = {
            isValid: function () {
              return this.valid;
            },
            rgb: function () {
              return this.setSpace('rgb', arguments);
            },
            hsl: function () {
              return this.setSpace('hsl', arguments);
            },
            hsv: function () {
              return this.setSpace('hsv', arguments);
            },
            hwb: function () {
              return this.setSpace('hwb', arguments);
            },
            cmyk: function () {
              return this.setSpace('cmyk', arguments);
            },
            rgbArray: function () {
              return this.values.rgb;
            },
            hslArray: function () {
              return this.values.hsl;
            },
            hsvArray: function () {
              return this.values.hsv;
            },
            hwbArray: function () {
              var t = this.values;
              return 1 !== t.alpha ? t.hwb.concat([t.alpha]) : t.hwb;
            },
            cmykArray: function () {
              return this.values.cmyk;
            },
            rgbaArray: function () {
              var t = this.values;
              return t.rgb.concat([t.alpha]);
            },
            hslaArray: function () {
              var t = this.values;
              return t.hsl.concat([t.alpha]);
            },
            alpha: function (t) {
              return void 0 === t
                ? this.values.alpha
                : (this.setValues('alpha', t), this);
            },
            red: function (t) {
              return this.setChannel('rgb', 0, t);
            },
            green: function (t) {
              return this.setChannel('rgb', 1, t);
            },
            blue: function (t) {
              return this.setChannel('rgb', 2, t);
            },
            hue: function (t) {
              return (
                t && (t = (t %= 360) < 0 ? 360 + t : t),
                this.setChannel('hsl', 0, t)
              );
            },
            saturation: function (t) {
              return this.setChannel('hsl', 1, t);
            },
            lightness: function (t) {
              return this.setChannel('hsl', 2, t);
            },
            saturationv: function (t) {
              return this.setChannel('hsv', 1, t);
            },
            whiteness: function (t) {
              return this.setChannel('hwb', 1, t);
            },
            blackness: function (t) {
              return this.setChannel('hwb', 2, t);
            },
            value: function (t) {
              return this.setChannel('hsv', 2, t);
            },
            cyan: function (t) {
              return this.setChannel('cmyk', 0, t);
            },
            magenta: function (t) {
              return this.setChannel('cmyk', 1, t);
            },
            yellow: function (t) {
              return this.setChannel('cmyk', 2, t);
            },
            black: function (t) {
              return this.setChannel('cmyk', 3, t);
            },
            hexString: function () {
              return n.hexString(this.values.rgb);
            },
            rgbString: function () {
              return n.rgbString(this.values.rgb, this.values.alpha);
            },
            rgbaString: function () {
              return n.rgbaString(this.values.rgb, this.values.alpha);
            },
            percentString: function () {
              return n.percentString(this.values.rgb, this.values.alpha);
            },
            hslString: function () {
              return n.hslString(this.values.hsl, this.values.alpha);
            },
            hslaString: function () {
              return n.hslaString(this.values.hsl, this.values.alpha);
            },
            hwbString: function () {
              return n.hwbString(this.values.hwb, this.values.alpha);
            },
            keyword: function () {
              return n.keyword(this.values.rgb, this.values.alpha);
            },
            rgbNumber: function () {
              var t = this.values.rgb;
              return (t[0] << 16) | (t[1] << 8) | t[2];
            },
            luminosity: function () {
              for (var t = this.values.rgb, e = [], i = 0; i < t.length; i++) {
                var n = t[i] / 255;
                e[i] =
                  n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
              }
              return 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
            },
            contrast: function (t) {
              var e = this.luminosity(),
                i = t.luminosity();
              return i < e ? (e + 0.05) / (i + 0.05) : (i + 0.05) / (e + 0.05);
            },
            level: function (t) {
              var e = this.contrast(t);
              return 7.1 <= e ? 'AAA' : 4.5 <= e ? 'AA' : '';
            },
            dark: function () {
              var t = this.values.rgb;
              return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128;
            },
            light: function () {
              return !this.dark();
            },
            negate: function () {
              for (var t = [], e = 0; e < 3; e++)
                t[e] = 255 - this.values.rgb[e];
              return this.setValues('rgb', t), this;
            },
            lighten: function (t) {
              var e = this.values.hsl;
              return (e[2] += e[2] * t), this.setValues('hsl', e), this;
            },
            darken: function (t) {
              var e = this.values.hsl;
              return (e[2] -= e[2] * t), this.setValues('hsl', e), this;
            },
            saturate: function (t) {
              var e = this.values.hsl;
              return (e[1] += e[1] * t), this.setValues('hsl', e), this;
            },
            desaturate: function (t) {
              var e = this.values.hsl;
              return (e[1] -= e[1] * t), this.setValues('hsl', e), this;
            },
            whiten: function (t) {
              var e = this.values.hwb;
              return (e[1] += e[1] * t), this.setValues('hwb', e), this;
            },
            blacken: function (t) {
              var e = this.values.hwb;
              return (e[2] += e[2] * t), this.setValues('hwb', e), this;
            },
            greyscale: function () {
              var t = this.values.rgb,
                e = 0.3 * t[0] + 0.59 * t[1] + 0.11 * t[2];
              return this.setValues('rgb', [e, e, e]), this;
            },
            clearer: function (t) {
              var e = this.values.alpha;
              return this.setValues('alpha', e - e * t), this;
            },
            opaquer: function (t) {
              var e = this.values.alpha;
              return this.setValues('alpha', e + e * t), this;
            },
            rotate: function (t) {
              var e = this.values.hsl,
                i = (e[0] + t) % 360;
              return (
                (e[0] = i < 0 ? 360 + i : i), this.setValues('hsl', e), this
              );
            },
            mix: function (t, e) {
              var i = this,
                n = t,
                a = void 0 === e ? 0.5 : e,
                o = 2 * a - 1,
                r = i.alpha() - n.alpha(),
                s = ((o * r == -1 ? o : (o + r) / (1 + o * r)) + 1) / 2,
                l = 1 - s;
              return this.rgb(
                s * i.red() + l * n.red(),
                s * i.green() + l * n.green(),
                s * i.blue() + l * n.blue()
              ).alpha(i.alpha() * a + n.alpha() * (1 - a));
            },
            toJSON: function () {
              return this.rgb();
            },
            clone: function () {
              var t,
                e,
                i = new r(),
                n = this.values,
                a = i.values;
              for (var o in n)
                n.hasOwnProperty(o) &&
                  ((t = n[o]),
                  '[object Array]' === (e = {}.toString.call(t))
                    ? (a[o] = t.slice(0))
                    : '[object Number]' === e
                    ? (a[o] = t)
                    : console.error('unexpected color value:', t));
              return i;
            },
          }),
            (r.prototype.spaces = {
              rgb: ['red', 'green', 'blue'],
              hsl: ['hue', 'saturation', 'lightness'],
              hsv: ['hue', 'saturation', 'value'],
              hwb: ['hue', 'whiteness', 'blackness'],
              cmyk: ['cyan', 'magenta', 'yellow', 'black'],
            }),
            (r.prototype.maxes = {
              rgb: [255, 255, 255],
              hsl: [360, 100, 100],
              hsv: [360, 100, 100],
              hwb: [360, 100, 100],
              cmyk: [100, 100, 100, 100],
            }),
            (r.prototype.getValues = function (t) {
              for (var e = this.values, i = {}, n = 0; n < t.length; n++)
                i[t.charAt(n)] = e[t][n];
              return 1 !== e.alpha && (i.a = e.alpha), i;
            }),
            (r.prototype.setValues = function (t, e) {
              var i,
                n,
                a = this.values,
                o = this.spaces,
                r = this.maxes,
                s = 1;
              if (((this.valid = !0), 'alpha' === t)) s = e;
              else if (e.length)
                (a[t] = e.slice(0, t.length)), (s = e[t.length]);
              else if (void 0 !== e[t.charAt(0)]) {
                for (i = 0; i < t.length; i++) a[t][i] = e[t.charAt(i)];
                s = e.a;
              } else if (void 0 !== e[o[t][0]]) {
                var l = o[t];
                for (i = 0; i < t.length; i++) a[t][i] = e[l[i]];
                s = e.alpha;
              }
              if (
                ((a.alpha = Math.max(
                  0,
                  Math.min(1, void 0 === s ? a.alpha : s)
                )),
                'alpha' === t)
              )
                return !1;
              for (i = 0; i < t.length; i++)
                (n = Math.max(0, Math.min(r[t][i], a[t][i]))),
                  (a[t][i] = Math.round(n));
              for (var u in o) u !== t && (a[u] = d[t][u](a[t]));
              return !0;
            }),
            (r.prototype.setSpace = function (t, e) {
              var i = e[0];
              return void 0 === i
                ? this.getValues(t)
                : ('number' == typeof i && (i = Array.prototype.slice.call(e)),
                  this.setValues(t, i),
                  this);
            }),
            (r.prototype.setChannel = function (t, e, i) {
              var n = this.values[t];
              return void 0 === i
                ? n[e]
                : (i === n[e] || ((n[e] = i), this.setValues(t, n)), this);
            }),
            'undefined' != typeof window && (window.Color = r),
            (e.exports = r);
        },
        { 2: 2, 5: 5 },
      ],
      4: [
        function (t, e, i) {
          function a(t) {
            var e,
              i,
              n = t[0] / 255,
              a = t[1] / 255,
              o = t[2] / 255,
              r = Math.min(n, a, o),
              s = Math.max(n, a, o),
              l = s - r;
            return (
              s == r
                ? (e = 0)
                : n == s
                ? (e = (a - o) / l)
                : a == s
                ? (e = 2 + (o - n) / l)
                : o == s && (e = 4 + (n - a) / l),
              (e = Math.min(60 * e, 360)) < 0 && (e += 360),
              (i = (r + s) / 2),
              [
                e,
                100 * (s == r ? 0 : i <= 0.5 ? l / (s + r) : l / (2 - s - r)),
                100 * i,
              ]
            );
          }
          function n(t) {
            var e,
              i,
              n = t[0],
              a = t[1],
              o = t[2],
              r = Math.min(n, a, o),
              s = Math.max(n, a, o),
              l = s - r;
            return (
              (i = 0 == s ? 0 : ((l / s) * 1e3) / 10),
              s == r
                ? (e = 0)
                : n == s
                ? (e = (a - o) / l)
                : a == s
                ? (e = 2 + (o - n) / l)
                : o == s && (e = 4 + (n - a) / l),
              (e = Math.min(60 * e, 360)) < 0 && (e += 360),
              [e, i, ((s / 255) * 1e3) / 10]
            );
          }
          function o(t) {
            var e = t[0],
              i = t[1],
              n = t[2];
            return [
              a(t)[0],
              100 * ((1 / 255) * Math.min(e, Math.min(i, n))),
              100 * (n = 1 - (1 / 255) * Math.max(e, Math.max(i, n))),
            ];
          }
          function s(t) {
            var e,
              i = t[0] / 255,
              n = t[1] / 255,
              a = t[2] / 255;
            return [
              100 *
                ((1 - i - (e = Math.min(1 - i, 1 - n, 1 - a))) / (1 - e) || 0),
              100 * ((1 - n - e) / (1 - e) || 0),
              100 * ((1 - a - e) / (1 - e) || 0),
              100 * e,
            ];
          }
          function l(t) {
            return S[JSON.stringify(t)];
          }
          function u(t) {
            var e = t[0] / 255,
              i = t[1] / 255,
              n = t[2] / 255;
            return [
              100 *
                (0.4124 *
                  (e =
                    0.04045 < e
                      ? Math.pow((e + 0.055) / 1.055, 2.4)
                      : e / 12.92) +
                  0.3576 *
                    (i =
                      0.04045 < i
                        ? Math.pow((i + 0.055) / 1.055, 2.4)
                        : i / 12.92) +
                  0.1805 *
                    (n =
                      0.04045 < n
                        ? Math.pow((n + 0.055) / 1.055, 2.4)
                        : n / 12.92)),
              100 * (0.2126 * e + 0.7152 * i + 0.0722 * n),
              100 * (0.0193 * e + 0.1192 * i + 0.9505 * n),
            ];
          }
          function d(t) {
            var e = u(t),
              i = e[0],
              n = e[1],
              a = e[2];
            return (
              (n /= 100),
              (a /= 108.883),
              (i =
                0.008856 < (i /= 95.047)
                  ? Math.pow(i, 1 / 3)
                  : 7.787 * i + 16 / 116),
              [
                116 *
                  (n =
                    0.008856 < n ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) -
                  16,
                500 * (i - n),
                200 *
                  (n -
                    (a =
                      0.008856 < a
                        ? Math.pow(a, 1 / 3)
                        : 7.787 * a + 16 / 116)),
              ]
            );
          }
          function c(t) {
            var e,
              i,
              n,
              a,
              o,
              r = t[0] / 360,
              s = t[1] / 100,
              l = t[2] / 100;
            if (0 == s) return [(o = 255 * l), o, o];
            (e = 2 * l - (i = l < 0.5 ? l * (1 + s) : l + s - l * s)),
              (a = [0, 0, 0]);
            for (var u = 0; u < 3; u++)
              (n = r + (1 / 3) * -(u - 1)) < 0 && n++,
                1 < n && n--,
                (o =
                  6 * n < 1
                    ? e + 6 * (i - e) * n
                    : 2 * n < 1
                    ? i
                    : 3 * n < 2
                    ? e + (i - e) * (2 / 3 - n) * 6
                    : e),
                (a[u] = 255 * o);
            return a;
          }
          function h(t) {
            var e = t[0] / 60,
              i = t[1] / 100,
              n = t[2] / 100,
              a = Math.floor(e) % 6,
              o = e - Math.floor(e),
              r = 255 * n * (1 - i),
              s = 255 * n * (1 - i * o),
              l = 255 * n * (1 - i * (1 - o));
            n *= 255;
            switch (a) {
              case 0:
                return [n, l, r];
              case 1:
                return [s, n, r];
              case 2:
                return [r, n, l];
              case 3:
                return [r, s, n];
              case 4:
                return [l, r, n];
              case 5:
                return [n, r, s];
            }
          }
          function f(t) {
            var e,
              i,
              n,
              a,
              o = t[0] / 360,
              s = t[1] / 100,
              l = t[2] / 100,
              u = s + l;
            switch (
              (1 < u && ((s /= u), (l /= u)),
              (n = 6 * o - (e = Math.floor(6 * o))),
              0 != (1 & e) && (n = 1 - n),
              (a = s + n * ((i = 1 - l) - s)),
              e)
            ) {
              default:
              case 6:
              case 0:
                (r = i), (g = a), (b = s);
                break;
              case 1:
                (r = a), (g = i), (b = s);
                break;
              case 2:
                (r = s), (g = i), (b = a);
                break;
              case 3:
                (r = s), (g = a), (b = i);
                break;
              case 4:
                (r = a), (g = s), (b = i);
                break;
              case 5:
                (r = i), (g = s), (b = a);
            }
            return [255 * r, 255 * g, 255 * b];
          }
          function p(t) {
            var e = t[0] / 100,
              i = t[1] / 100,
              n = t[2] / 100,
              a = t[3] / 100;
            return [
              255 * (1 - Math.min(1, e * (1 - a) + a)),
              255 * (1 - Math.min(1, i * (1 - a) + a)),
              255 * (1 - Math.min(1, n * (1 - a) + a)),
            ];
          }
          function m(t) {
            var e,
              i,
              n,
              a = t[0] / 100,
              o = t[1] / 100,
              r = t[2] / 100;
            return (
              (i = -0.9689 * a + 1.8758 * o + 0.0415 * r),
              (n = 0.0557 * a + -0.204 * o + 1.057 * r),
              (e =
                0.0031308 < (e = 3.2406 * a + -1.5372 * o + -0.4986 * r)
                  ? 1.055 * Math.pow(e, 1 / 2.4) - 0.055
                  : (e *= 12.92)),
              (i =
                0.0031308 < i
                  ? 1.055 * Math.pow(i, 1 / 2.4) - 0.055
                  : (i *= 12.92)),
              (n =
                0.0031308 < n
                  ? 1.055 * Math.pow(n, 1 / 2.4) - 0.055
                  : (n *= 12.92)),
              [
                255 * (e = Math.min(Math.max(0, e), 1)),
                255 * (i = Math.min(Math.max(0, i), 1)),
                255 * (n = Math.min(Math.max(0, n), 1)),
              ]
            );
          }
          function v(t) {
            var e = t[0],
              i = t[1],
              n = t[2];
            return (
              (i /= 100),
              (n /= 108.883),
              (e =
                0.008856 < (e /= 95.047)
                  ? Math.pow(e, 1 / 3)
                  : 7.787 * e + 16 / 116),
              [
                116 *
                  (i =
                    0.008856 < i ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) -
                  16,
                500 * (e - i),
                200 *
                  (i -
                    (n =
                      0.008856 < n
                        ? Math.pow(n, 1 / 3)
                        : 7.787 * n + 16 / 116)),
              ]
            );
          }
          function x(t) {
            var e,
              i,
              n,
              a,
              o = t[0],
              r = t[1],
              s = t[2];
            return (
              (a =
                o <= 8
                  ? ((i = (100 * o) / 903.3) / 100) * 7.787 + 16 / 116
                  : ((i = 100 * Math.pow((o + 16) / 116, 3)),
                    Math.pow(i / 100, 1 / 3))),
              [
                (e =
                  e / 95.047 <= 0.008856
                    ? (e = (95.047 * (r / 500 + a - 16 / 116)) / 7.787)
                    : 95.047 * Math.pow(r / 500 + a, 3)),
                i,
                (n =
                  n / 108.883 <= 0.008859
                    ? (n = (108.883 * (a - s / 200 - 16 / 116)) / 7.787)
                    : 108.883 * Math.pow(a - s / 200, 3)),
              ]
            );
          }
          function y(t) {
            var e,
              i = t[0],
              n = t[1],
              a = t[2];
            return (
              (e = (360 * Math.atan2(a, n)) / 2 / Math.PI) < 0 && (e += 360),
              [i, Math.sqrt(n * n + a * a), e]
            );
          }
          function k(t) {
            return m(x(t));
          }
          function M(t) {
            var e,
              i = t[0],
              n = t[1];
            return (
              (e = (t[2] / 360) * 2 * Math.PI),
              [i, n * Math.cos(e), n * Math.sin(e)]
            );
          }
          function w(t) {
            return C[t];
          }
          e.exports = {
            rgb2hsl: a,
            rgb2hsv: n,
            rgb2hwb: o,
            rgb2cmyk: s,
            rgb2keyword: l,
            rgb2xyz: u,
            rgb2lab: d,
            rgb2lch: function (t) {
              return y(d(t));
            },
            hsl2rgb: c,
            hsl2hsv: function (t) {
              var e = t[0],
                i = t[1] / 100,
                n = t[2] / 100;
              return 0 !== n
                ? [
                    e,
                    100 * ((2 * (i *= (n *= 2) <= 1 ? n : 2 - n)) / (n + i)),
                    100 * ((n + i) / 2),
                  ]
                : [0, 0, 0];
            },
            hsl2hwb: function (t) {
              return o(c(t));
            },
            hsl2cmyk: function (t) {
              return s(c(t));
            },
            hsl2keyword: function (t) {
              return l(c(t));
            },
            hsv2rgb: h,
            hsv2hsl: function (t) {
              var e,
                i,
                n = t[0],
                a = t[1] / 100,
                o = t[2] / 100;
              return (
                (e = a * o),
                [
                  n,
                  100 * (e = (e /= (i = (2 - a) * o) <= 1 ? i : 2 - i) || 0),
                  100 * (i /= 2),
                ]
              );
            },
            hsv2hwb: function (t) {
              return o(h(t));
            },
            hsv2cmyk: function (t) {
              return s(h(t));
            },
            hsv2keyword: function (t) {
              return l(h(t));
            },
            hwb2rgb: f,
            hwb2hsl: function (t) {
              return a(f(t));
            },
            hwb2hsv: function (t) {
              return n(f(t));
            },
            hwb2cmyk: function (t) {
              return s(f(t));
            },
            hwb2keyword: function (t) {
              return l(f(t));
            },
            cmyk2rgb: p,
            cmyk2hsl: function (t) {
              return a(p(t));
            },
            cmyk2hsv: function (t) {
              return n(p(t));
            },
            cmyk2hwb: function (t) {
              return o(p(t));
            },
            cmyk2keyword: function (t) {
              return l(p(t));
            },
            keyword2rgb: w,
            keyword2hsl: function (t) {
              return a(w(t));
            },
            keyword2hsv: function (t) {
              return n(w(t));
            },
            keyword2hwb: function (t) {
              return o(w(t));
            },
            keyword2cmyk: function (t) {
              return s(w(t));
            },
            keyword2lab: function (t) {
              return d(w(t));
            },
            keyword2xyz: function (t) {
              return u(w(t));
            },
            xyz2rgb: m,
            xyz2lab: v,
            xyz2lch: function (t) {
              return y(v(t));
            },
            lab2xyz: x,
            lab2rgb: k,
            lab2lch: y,
            lch2lab: M,
            lch2xyz: function (t) {
              return x(M(t));
            },
            lch2rgb: function (t) {
              return k(M(t));
            },
          };
          var C = {
              aliceblue: [240, 248, 255],
              antiquewhite: [250, 235, 215],
              aqua: [0, 255, 255],
              aquamarine: [127, 255, 212],
              azure: [240, 255, 255],
              beige: [245, 245, 220],
              bisque: [255, 228, 196],
              black: [0, 0, 0],
              blanchedalmond: [255, 235, 205],
              blue: [0, 0, 255],
              blueviolet: [138, 43, 226],
              brown: [165, 42, 42],
              burlywood: [222, 184, 135],
              cadetblue: [95, 158, 160],
              chartreuse: [127, 255, 0],
              chocolate: [210, 105, 30],
              coral: [255, 127, 80],
              cornflowerblue: [100, 149, 237],
              cornsilk: [255, 248, 220],
              crimson: [220, 20, 60],
              cyan: [0, 255, 255],
              darkblue: [0, 0, 139],
              darkcyan: [0, 139, 139],
              darkgoldenrod: [184, 134, 11],
              darkgray: [169, 169, 169],
              darkgreen: [0, 100, 0],
              darkgrey: [169, 169, 169],
              darkkhaki: [189, 183, 107],
              darkmagenta: [139, 0, 139],
              darkolivegreen: [85, 107, 47],
              darkorange: [255, 140, 0],
              darkorchid: [153, 50, 204],
              darkred: [139, 0, 0],
              darksalmon: [233, 150, 122],
              darkseagreen: [143, 188, 143],
              darkslateblue: [72, 61, 139],
              darkslategray: [47, 79, 79],
              darkslategrey: [47, 79, 79],
              darkturquoise: [0, 206, 209],
              darkviolet: [148, 0, 211],
              deeppink: [255, 20, 147],
              deepskyblue: [0, 191, 255],
              dimgray: [105, 105, 105],
              dimgrey: [105, 105, 105],
              dodgerblue: [30, 144, 255],
              firebrick: [178, 34, 34],
              floralwhite: [255, 250, 240],
              forestgreen: [34, 139, 34],
              fuchsia: [255, 0, 255],
              gainsboro: [220, 220, 220],
              ghostwhite: [248, 248, 255],
              gold: [255, 215, 0],
              goldenrod: [218, 165, 32],
              gray: [128, 128, 128],
              green: [0, 128, 0],
              greenyellow: [173, 255, 47],
              grey: [128, 128, 128],
              honeydew: [240, 255, 240],
              hotpink: [255, 105, 180],
              indianred: [205, 92, 92],
              indigo: [75, 0, 130],
              ivory: [255, 255, 240],
              khaki: [240, 230, 140],
              lavender: [230, 230, 250],
              lavenderblush: [255, 240, 245],
              lawngreen: [124, 252, 0],
              lemonchiffon: [255, 250, 205],
              lightblue: [173, 216, 230],
              lightcoral: [240, 128, 128],
              lightcyan: [224, 255, 255],
              lightgoldenrodyellow: [250, 250, 210],
              lightgray: [211, 211, 211],
              lightgreen: [144, 238, 144],
              lightgrey: [211, 211, 211],
              lightpink: [255, 182, 193],
              lightsalmon: [255, 160, 122],
              lightseagreen: [32, 178, 170],
              lightskyblue: [135, 206, 250],
              lightslategray: [119, 136, 153],
              lightslategrey: [119, 136, 153],
              lightsteelblue: [176, 196, 222],
              lightyellow: [255, 255, 224],
              lime: [0, 255, 0],
              limegreen: [50, 205, 50],
              linen: [250, 240, 230],
              magenta: [255, 0, 255],
              maroon: [128, 0, 0],
              mediumaquamarine: [102, 205, 170],
              mediumblue: [0, 0, 205],
              mediumorchid: [186, 85, 211],
              mediumpurple: [147, 112, 219],
              mediumseagreen: [60, 179, 113],
              mediumslateblue: [123, 104, 238],
              mediumspringgreen: [0, 250, 154],
              mediumturquoise: [72, 209, 204],
              mediumvioletred: [199, 21, 133],
              midnightblue: [25, 25, 112],
              mintcream: [245, 255, 250],
              mistyrose: [255, 228, 225],
              moccasin: [255, 228, 181],
              navajowhite: [255, 222, 173],
              navy: [0, 0, 128],
              oldlace: [253, 245, 230],
              olive: [128, 128, 0],
              olivedrab: [107, 142, 35],
              orange: [255, 165, 0],
              orangered: [255, 69, 0],
              orchid: [218, 112, 214],
              palegoldenrod: [238, 232, 170],
              palegreen: [152, 251, 152],
              paleturquoise: [175, 238, 238],
              palevioletred: [219, 112, 147],
              papayawhip: [255, 239, 213],
              peachpuff: [255, 218, 185],
              peru: [205, 133, 63],
              pink: [255, 192, 203],
              plum: [221, 160, 221],
              powderblue: [176, 224, 230],
              purple: [128, 0, 128],
              rebeccapurple: [102, 51, 153],
              red: [255, 0, 0],
              rosybrown: [188, 143, 143],
              royalblue: [65, 105, 225],
              saddlebrown: [139, 69, 19],
              salmon: [250, 128, 114],
              sandybrown: [244, 164, 96],
              seagreen: [46, 139, 87],
              seashell: [255, 245, 238],
              sienna: [160, 82, 45],
              silver: [192, 192, 192],
              skyblue: [135, 206, 235],
              slateblue: [106, 90, 205],
              slategray: [112, 128, 144],
              slategrey: [112, 128, 144],
              snow: [255, 250, 250],
              springgreen: [0, 255, 127],
              steelblue: [70, 130, 180],
              tan: [210, 180, 140],
              teal: [0, 128, 128],
              thistle: [216, 191, 216],
              tomato: [255, 99, 71],
              turquoise: [64, 224, 208],
              violet: [238, 130, 238],
              wheat: [245, 222, 179],
              white: [255, 255, 255],
              whitesmoke: [245, 245, 245],
              yellow: [255, 255, 0],
              yellowgreen: [154, 205, 50],
            },
            S = {};
          for (var _ in C) S[JSON.stringify(C[_])] = _;
        },
        {},
      ],
      5: [
        function (t, e, i) {
          var a = t(4),
            o = function () {
              return new u();
            };
          for (var n in a) {
            o[n + 'Raw'] = (function (e) {
              return function (t) {
                return (
                  'number' == typeof t &&
                    (t = Array.prototype.slice.call(arguments)),
                  a[e](t)
                );
              };
            })(n);
            var r = /(\w+)2(\w+)/.exec(n),
              s = r[1],
              l = r[2];
            (o[s] = o[s] || {})[l] = o[n] = (function (n) {
              return function (t) {
                'number' == typeof t &&
                  (t = Array.prototype.slice.call(arguments));
                var e = a[n](t);
                if ('string' == typeof e || void 0 === e) return e;
                for (var i = 0; i < e.length; i++) e[i] = Math.round(e[i]);
                return e;
              };
            })(n);
          }
          var u = function () {
            this.convs = {};
          };
          (u.prototype.routeSpace = function (t, e) {
            var i = e[0];
            return void 0 === i
              ? this.getValues(t)
              : ('number' == typeof i && (i = Array.prototype.slice.call(e)),
                this.setValues(t, i));
          }),
            (u.prototype.setValues = function (t, e) {
              return (
                (this.space = t), (this.convs = {}), (this.convs[t] = e), this
              );
            }),
            (u.prototype.getValues = function (t) {
              var e = this.convs[t];
              if (!e) {
                var i = this.space,
                  n = this.convs[i];
                (e = o[i][t](n)), (this.convs[t] = e);
              }
              return e;
            }),
            ['rgb', 'hsl', 'hsv', 'cmyk', 'keyword'].forEach(function (e) {
              u.prototype[e] = function (t) {
                return this.routeSpace(e, arguments);
              };
            }),
            (e.exports = o);
        },
        { 4: 4 },
      ],
      6: [
        function (t, e, i) {
          'use strict';
          e.exports = {
            aliceblue: [240, 248, 255],
            antiquewhite: [250, 235, 215],
            aqua: [0, 255, 255],
            aquamarine: [127, 255, 212],
            azure: [240, 255, 255],
            beige: [245, 245, 220],
            bisque: [255, 228, 196],
            black: [0, 0, 0],
            blanchedalmond: [255, 235, 205],
            blue: [0, 0, 255],
            blueviolet: [138, 43, 226],
            brown: [165, 42, 42],
            burlywood: [222, 184, 135],
            cadetblue: [95, 158, 160],
            chartreuse: [127, 255, 0],
            chocolate: [210, 105, 30],
            coral: [255, 127, 80],
            cornflowerblue: [100, 149, 237],
            cornsilk: [255, 248, 220],
            crimson: [220, 20, 60],
            cyan: [0, 255, 255],
            darkblue: [0, 0, 139],
            darkcyan: [0, 139, 139],
            darkgoldenrod: [184, 134, 11],
            darkgray: [169, 169, 169],
            darkgreen: [0, 100, 0],
            darkgrey: [169, 169, 169],
            darkkhaki: [189, 183, 107],
            darkmagenta: [139, 0, 139],
            darkolivegreen: [85, 107, 47],
            darkorange: [255, 140, 0],
            darkorchid: [153, 50, 204],
            darkred: [139, 0, 0],
            darksalmon: [233, 150, 122],
            darkseagreen: [143, 188, 143],
            darkslateblue: [72, 61, 139],
            darkslategray: [47, 79, 79],
            darkslategrey: [47, 79, 79],
            darkturquoise: [0, 206, 209],
            darkviolet: [148, 0, 211],
            deeppink: [255, 20, 147],
            deepskyblue: [0, 191, 255],
            dimgray: [105, 105, 105],
            dimgrey: [105, 105, 105],
            dodgerblue: [30, 144, 255],
            firebrick: [178, 34, 34],
            floralwhite: [255, 250, 240],
            forestgreen: [34, 139, 34],
            fuchsia: [255, 0, 255],
            gainsboro: [220, 220, 220],
            ghostwhite: [248, 248, 255],
            gold: [255, 215, 0],
            goldenrod: [218, 165, 32],
            gray: [128, 128, 128],
            green: [0, 128, 0],
            greenyellow: [173, 255, 47],
            grey: [128, 128, 128],
            honeydew: [240, 255, 240],
            hotpink: [255, 105, 180],
            indianred: [205, 92, 92],
            indigo: [75, 0, 130],
            ivory: [255, 255, 240],
            khaki: [240, 230, 140],
            lavender: [230, 230, 250],
            lavenderblush: [255, 240, 245],
            lawngreen: [124, 252, 0],
            lemonchiffon: [255, 250, 205],
            lightblue: [173, 216, 230],
            lightcoral: [240, 128, 128],
            lightcyan: [224, 255, 255],
            lightgoldenrodyellow: [250, 250, 210],
            lightgray: [211, 211, 211],
            lightgreen: [144, 238, 144],
            lightgrey: [211, 211, 211],
            lightpink: [255, 182, 193],
            lightsalmon: [255, 160, 122],
            lightseagreen: [32, 178, 170],
            lightskyblue: [135, 206, 250],
            lightslategray: [119, 136, 153],
            lightslategrey: [119, 136, 153],
            lightsteelblue: [176, 196, 222],
            lightyellow: [255, 255, 224],
            lime: [0, 255, 0],
            limegreen: [50, 205, 50],
            linen: [250, 240, 230],
            magenta: [255, 0, 255],
            maroon: [128, 0, 0],
            mediumaquamarine: [102, 205, 170],
            mediumblue: [0, 0, 205],
            mediumorchid: [186, 85, 211],
            mediumpurple: [147, 112, 219],
            mediumseagreen: [60, 179, 113],
            mediumslateblue: [123, 104, 238],
            mediumspringgreen: [0, 250, 154],
            mediumturquoise: [72, 209, 204],
            mediumvioletred: [199, 21, 133],
            midnightblue: [25, 25, 112],
            mintcream: [245, 255, 250],
            mistyrose: [255, 228, 225],
            moccasin: [255, 228, 181],
            navajowhite: [255, 222, 173],
            navy: [0, 0, 128],
            oldlace: [253, 245, 230],
            olive: [128, 128, 0],
            olivedrab: [107, 142, 35],
            orange: [255, 165, 0],
            orangered: [255, 69, 0],
            orchid: [218, 112, 214],
            palegoldenrod: [238, 232, 170],
            palegreen: [152, 251, 152],
            paleturquoise: [175, 238, 238],
            palevioletred: [219, 112, 147],
            papayawhip: [255, 239, 213],
            peachpuff: [255, 218, 185],
            peru: [205, 133, 63],
            pink: [255, 192, 203],
            plum: [221, 160, 221],
            powderblue: [176, 224, 230],
            purple: [128, 0, 128],
            rebeccapurple: [102, 51, 153],
            red: [255, 0, 0],
            rosybrown: [188, 143, 143],
            royalblue: [65, 105, 225],
            saddlebrown: [139, 69, 19],
            salmon: [250, 128, 114],
            sandybrown: [244, 164, 96],
            seagreen: [46, 139, 87],
            seashell: [255, 245, 238],
            sienna: [160, 82, 45],
            silver: [192, 192, 192],
            skyblue: [135, 206, 235],
            slateblue: [106, 90, 205],
            slategray: [112, 128, 144],
            slategrey: [112, 128, 144],
            snow: [255, 250, 250],
            springgreen: [0, 255, 127],
            steelblue: [70, 130, 180],
            tan: [210, 180, 140],
            teal: [0, 128, 128],
            thistle: [216, 191, 216],
            tomato: [255, 99, 71],
            turquoise: [64, 224, 208],
            violet: [238, 130, 238],
            wheat: [245, 222, 179],
            white: [255, 255, 255],
            whitesmoke: [245, 245, 245],
            yellow: [255, 255, 0],
            yellowgreen: [154, 205, 50],
          };
        },
        {},
      ],
      7: [
        function (t, e, i) {
          var n = t(30)();
          (n.helpers = t(46)),
            t(28)(n),
            (n.Animation = t(22)),
            (n.animationService = t(23)),
            (n.defaults = t(26)),
            (n.Element = t(27)),
            (n.elements = t(41)),
            (n.Interaction = t(29)),
            (n.layouts = t(31)),
            (n.platform = t(49)),
            (n.plugins = t(32)),
            (n.Scale = t(33)),
            (n.scaleService = t(34)),
            (n.Ticks = t(35)),
            (n.Tooltip = t(36)),
            t(24)(n),
            t(25)(n),
            t(56)(n),
            t(54)(n),
            t(55)(n),
            t(57)(n),
            t(58)(n),
            t(59)(n),
            t(15)(n),
            t(16)(n),
            t(17)(n),
            t(18)(n),
            t(19)(n),
            t(20)(n),
            t(21)(n),
            t(8)(n),
            t(9)(n),
            t(10)(n),
            t(11)(n),
            t(12)(n),
            t(13)(n),
            t(14)(n);
          var a = t(50);
          for (var o in a) a.hasOwnProperty(o) && n.plugins.register(a[o]);
          n.platform.initialize(),
            (e.exports = n),
            'undefined' != typeof window && (window.Chart = n),
            (n.Legend = a.legend._element),
            (n.Title = a.title._element),
            (n.pluginService = n.plugins),
            (n.PluginBase = n.Element.extend({})),
            (n.canvasHelpers = n.helpers.canvas),
            (n.layoutService = n.layouts);
        },
        {
          10: 10,
          11: 11,
          12: 12,
          13: 13,
          14: 14,
          15: 15,
          16: 16,
          17: 17,
          18: 18,
          19: 19,
          20: 20,
          21: 21,
          22: 22,
          23: 23,
          24: 24,
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          29: 29,
          30: 30,
          31: 31,
          32: 32,
          33: 33,
          34: 34,
          35: 35,
          36: 36,
          41: 41,
          46: 46,
          49: 49,
          50: 50,
          54: 54,
          55: 55,
          56: 56,
          57: 57,
          58: 58,
          59: 59,
          8: 8,
          9: 9,
        },
      ],
      8: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.Bar = function (t, e) {
              return (e.type = 'bar'), new i(t, e);
            };
          };
        },
        {},
      ],
      9: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.Bubble = function (t, e) {
              return (e.type = 'bubble'), new i(t, e);
            };
          };
        },
        {},
      ],
      10: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.Doughnut = function (t, e) {
              return (e.type = 'doughnut'), new i(t, e);
            };
          };
        },
        {},
      ],
      11: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.Line = function (t, e) {
              return (e.type = 'line'), new i(t, e);
            };
          };
        },
        {},
      ],
      12: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.PolarArea = function (t, e) {
              return (e.type = 'polarArea'), new i(t, e);
            };
          };
        },
        {},
      ],
      13: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.Radar = function (t, e) {
              return (e.type = 'radar'), new i(t, e);
            };
          };
        },
        {},
      ],
      14: [
        function (t, e, i) {
          'use strict';
          e.exports = function (i) {
            i.Scatter = function (t, e) {
              return (e.type = 'scatter'), new i(t, e);
            };
          };
        },
        {},
      ],
      15: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(41),
            S = t(46);
          n._set('bar', {
            hover: { mode: 'label' },
            scales: {
              xAxes: [
                {
                  type: 'category',
                  categoryPercentage: 0.8,
                  barPercentage: 0.9,
                  offset: !0,
                  gridLines: { offsetGridLines: !0 },
                },
              ],
              yAxes: [{ type: 'linear' }],
            },
          }),
            n._set('horizontalBar', {
              hover: { mode: 'index', axis: 'y' },
              scales: {
                xAxes: [{ type: 'linear', position: 'bottom' }],
                yAxes: [
                  {
                    position: 'left',
                    type: 'category',
                    categoryPercentage: 0.8,
                    barPercentage: 0.9,
                    offset: !0,
                    gridLines: { offsetGridLines: !0 },
                  },
                ],
              },
              elements: { rectangle: { borderSkipped: 'left' } },
              tooltips: {
                callbacks: {
                  title: function (t, e) {
                    var i = '';
                    return (
                      0 < t.length &&
                        (t[0].yLabel
                          ? (i = t[0].yLabel)
                          : 0 < e.labels.length &&
                            t[0].index < e.labels.length &&
                            (i = e.labels[t[0].index])),
                      i
                    );
                  },
                  label: function (t, e) {
                    return (
                      (e.datasets[t.datasetIndex].label || '') + ': ' + t.xLabel
                    );
                  },
                },
                mode: 'index',
                axis: 'y',
              },
            }),
            (e.exports = function (e) {
              (e.controllers.bar = e.DatasetController.extend({
                dataElementType: a.Rectangle,
                initialize: function () {
                  var t;
                  e.DatasetController.prototype.initialize.apply(
                    this,
                    arguments
                  ),
                    ((t = this.getMeta()).stack = this.getDataset().stack),
                    (t.bar = !0);
                },
                update: function (t) {
                  var e,
                    i,
                    n = this.getMeta().data;
                  for (
                    this._ruler = this.getRuler(), e = 0, i = n.length;
                    e < i;
                    ++e
                  )
                    this.updateElement(n[e], e, t);
                },
                updateElement: function (t, e, i) {
                  var n = this,
                    a = n.chart,
                    o = n.getMeta(),
                    r = n.getDataset(),
                    s = t.custom || {},
                    l = a.options.elements.rectangle;
                  (t._xScale = n.getScaleForId(o.xAxisID)),
                    (t._yScale = n.getScaleForId(o.yAxisID)),
                    (t._datasetIndex = n.index),
                    (t._index = e),
                    (t._model = {
                      datasetLabel: r.label,
                      label: a.data.labels[e],
                      borderSkipped: s.borderSkipped
                        ? s.borderSkipped
                        : l.borderSkipped,
                      backgroundColor: s.backgroundColor
                        ? s.backgroundColor
                        : S.valueAtIndexOrDefault(
                            r.backgroundColor,
                            e,
                            l.backgroundColor
                          ),
                      borderColor: s.borderColor
                        ? s.borderColor
                        : S.valueAtIndexOrDefault(
                            r.borderColor,
                            e,
                            l.borderColor
                          ),
                      borderWidth: s.borderWidth
                        ? s.borderWidth
                        : S.valueAtIndexOrDefault(
                            r.borderWidth,
                            e,
                            l.borderWidth
                          ),
                    }),
                    n.updateElementGeometry(t, e, i),
                    t.pivot();
                },
                updateElementGeometry: function (t, e, i) {
                  var n = this,
                    a = t._model,
                    o = n.getValueScale(),
                    r = o.getBasePixel(),
                    s = o.isHorizontal(),
                    l = n._ruler || n.getRuler(),
                    u = n.calculateBarValuePixels(n.index, e),
                    d = n.calculateBarIndexPixels(n.index, e, l);
                  (a.horizontal = s),
                    (a.base = i ? r : u.base),
                    (a.x = s ? (i ? r : u.head) : d.center),
                    (a.y = s ? d.center : i ? r : u.head),
                    (a.height = s ? d.size : void 0),
                    (a.width = s ? void 0 : d.size);
                },
                getValueScaleId: function () {
                  return this.getMeta().yAxisID;
                },
                getIndexScaleId: function () {
                  return this.getMeta().xAxisID;
                },
                getValueScale: function () {
                  return this.getScaleForId(this.getValueScaleId());
                },
                getIndexScale: function () {
                  return this.getScaleForId(this.getIndexScaleId());
                },
                _getStacks: function (t) {
                  var e,
                    i,
                    n = this.chart,
                    a = this.getIndexScale().options.stacked,
                    o = void 0 === t ? n.data.datasets.length : t + 1,
                    r = [];
                  for (e = 0; e < o; ++e)
                    (i = n.getDatasetMeta(e)).bar &&
                      n.isDatasetVisible(e) &&
                      (!1 === a ||
                        (!0 === a && -1 === r.indexOf(i.stack)) ||
                        (void 0 === a &&
                          (void 0 === i.stack || -1 === r.indexOf(i.stack)))) &&
                      r.push(i.stack);
                  return r;
                },
                getStackCount: function () {
                  return this._getStacks().length;
                },
                getStackIndex: function (t, e) {
                  var i = this._getStacks(t),
                    n = void 0 !== e ? i.indexOf(e) : -1;
                  return -1 === n ? i.length - 1 : n;
                },
                getRuler: function () {
                  var t,
                    e,
                    i = this.getIndexScale(),
                    n = this.getStackCount(),
                    a = this.index,
                    o = i.isHorizontal(),
                    r = o ? i.left : i.top,
                    s = r + (o ? i.width : i.height),
                    l = [];
                  for (t = 0, e = this.getMeta().data.length; t < e; ++t)
                    l.push(i.getPixelForValue(null, t, a));
                  return {
                    min: S.isNullOrUndef(i.options.barThickness)
                      ? (function (t, e) {
                          var i,
                            n,
                            a,
                            o,
                            r = t.isHorizontal() ? t.width : t.height,
                            s = t.getTicks();
                          for (a = 1, o = e.length; a < o; ++a)
                            r = Math.min(r, e[a] - e[a - 1]);
                          for (a = 0, o = s.length; a < o; ++a)
                            (n = t.getPixelForTick(a)),
                              (r = 0 < a ? Math.min(r, n - i) : r),
                              (i = n);
                          return r;
                        })(i, l)
                      : -1,
                    pixels: l,
                    start: r,
                    end: s,
                    stackCount: n,
                    scale: i,
                  };
                },
                calculateBarValuePixels: function (t, e) {
                  var i,
                    n,
                    a,
                    o,
                    r,
                    s,
                    l = this.chart,
                    u = this.getMeta(),
                    d = this.getValueScale(),
                    c = l.data.datasets,
                    h = d.getRightValue(c[t].data[e]),
                    f = d.options.stacked,
                    g = u.stack,
                    p = 0;
                  if (f || (void 0 === f && void 0 !== g))
                    for (i = 0; i < t; ++i)
                      (n = l.getDatasetMeta(i)).bar &&
                        n.stack === g &&
                        n.controller.getValueScaleId() === d.id &&
                        l.isDatasetVisible(i) &&
                        ((a = d.getRightValue(c[i].data[e])),
                        ((h < 0 && a < 0) || (0 <= h && 0 < a)) && (p += a));
                  return (
                    (o = d.getPixelForValue(p)),
                    {
                      size: (s = ((r = d.getPixelForValue(p + h)) - o) / 2),
                      base: o,
                      head: r,
                      center: r + s / 2,
                    }
                  );
                },
                calculateBarIndexPixels: function (t, e, i) {
                  var n,
                    a,
                    o,
                    r,
                    s,
                    l,
                    u,
                    d,
                    c,
                    h,
                    f,
                    g,
                    p,
                    m,
                    v,
                    b,
                    x,
                    y = i.scale.options,
                    k =
                      'flex' === y.barThickness
                        ? ((c = e),
                          (f = y),
                          (p = (h = i).pixels),
                          (m = p[c]),
                          (v = 0 < c ? p[c - 1] : null),
                          (b = c < p.length - 1 ? p[c + 1] : null),
                          (x = f.categoryPercentage),
                          null === v &&
                            (v = m - (null === b ? h.end - m : b - m)),
                          null === b && (b = m + m - v),
                          (g = m - ((m - v) / 2) * x),
                          {
                            chunk: (((b - v) / 2) * x) / h.stackCount,
                            ratio: f.barPercentage,
                            start: g,
                          })
                        : ((n = e),
                          (a = i),
                          (l = (o = y).barThickness),
                          (u = a.stackCount),
                          (d = a.pixels[n]),
                          (s = S.isNullOrUndef(l)
                            ? ((r = a.min * o.categoryPercentage),
                              o.barPercentage)
                            : ((r = l * u), 1)),
                          { chunk: r / u, ratio: s, start: d - r / 2 }),
                    M = this.getStackIndex(t, this.getMeta().stack),
                    w = k.start + k.chunk * M + k.chunk / 2,
                    C = Math.min(
                      S.valueOrDefault(y.maxBarThickness, 1 / 0),
                      k.chunk * k.ratio
                    );
                  return {
                    base: w - C / 2,
                    head: w + C / 2,
                    center: w,
                    size: C,
                  };
                },
                draw: function () {
                  var t = this.chart,
                    e = this.getValueScale(),
                    i = this.getMeta().data,
                    n = this.getDataset(),
                    a = i.length,
                    o = 0;
                  for (S.canvas.clipArea(t.ctx, t.chartArea); o < a; ++o)
                    isNaN(e.getRightValue(n.data[o])) || i[o].draw();
                  S.canvas.unclipArea(t.ctx);
                },
              })),
                (e.controllers.horizontalBar = e.controllers.bar.extend({
                  getValueScaleId: function () {
                    return this.getMeta().xAxisID;
                  },
                  getIndexScaleId: function () {
                    return this.getMeta().yAxisID;
                  },
                }));
            });
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      16: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(41),
            g = t(46);
          n._set('bubble', {
            hover: { mode: 'single' },
            scales: {
              xAxes: [{ type: 'linear', position: 'bottom', id: 'x-axis-0' }],
              yAxes: [{ type: 'linear', position: 'left', id: 'y-axis-0' }],
            },
            tooltips: {
              callbacks: {
                title: function () {
                  return '';
                },
                label: function (t, e) {
                  var i = e.datasets[t.datasetIndex].label || '',
                    n = e.datasets[t.datasetIndex].data[t.index];
                  return (
                    i + ': (' + t.xLabel + ', ' + t.yLabel + ', ' + n.r + ')'
                  );
                },
              },
            },
          }),
            (e.exports = function (t) {
              t.controllers.bubble = t.DatasetController.extend({
                dataElementType: a.Point,
                update: function (i) {
                  var n = this,
                    t = n.getMeta().data;
                  g.each(t, function (t, e) {
                    n.updateElement(t, e, i);
                  });
                },
                updateElement: function (t, e, i) {
                  var n = this,
                    a = n.getMeta(),
                    o = t.custom || {},
                    r = n.getScaleForId(a.xAxisID),
                    s = n.getScaleForId(a.yAxisID),
                    l = n._resolveElementOptions(t, e),
                    u = n.getDataset().data[e],
                    d = n.index,
                    c = i
                      ? r.getPixelForDecimal(0.5)
                      : r.getPixelForValue(
                          'object' == typeof u ? u : NaN,
                          e,
                          d
                        ),
                    h = i ? s.getBasePixel() : s.getPixelForValue(u, e, d);
                  (t._xScale = r),
                    (t._yScale = s),
                    (t._options = l),
                    (t._datasetIndex = d),
                    (t._index = e),
                    (t._model = {
                      backgroundColor: l.backgroundColor,
                      borderColor: l.borderColor,
                      borderWidth: l.borderWidth,
                      hitRadius: l.hitRadius,
                      pointStyle: l.pointStyle,
                      rotation: l.rotation,
                      radius: i ? 0 : l.radius,
                      skip: o.skip || isNaN(c) || isNaN(h),
                      x: c,
                      y: h,
                    }),
                    t.pivot();
                },
                setHoverStyle: function (t) {
                  var e = t._model,
                    i = t._options;
                  (t.$previousStyle = {
                    backgroundColor: e.backgroundColor,
                    borderColor: e.borderColor,
                    borderWidth: e.borderWidth,
                    radius: e.radius,
                  }),
                    (e.backgroundColor = g.valueOrDefault(
                      i.hoverBackgroundColor,
                      g.getHoverColor(i.backgroundColor)
                    )),
                    (e.borderColor = g.valueOrDefault(
                      i.hoverBorderColor,
                      g.getHoverColor(i.borderColor)
                    )),
                    (e.borderWidth = g.valueOrDefault(
                      i.hoverBorderWidth,
                      i.borderWidth
                    )),
                    (e.radius = i.radius + i.hoverRadius);
                },
                _resolveElementOptions: function (t, e) {
                  var i,
                    n,
                    a,
                    o = this.chart,
                    r = o.data.datasets[this.index],
                    s = t.custom || {},
                    l = o.options.elements.point,
                    u = g.options.resolve,
                    d = r.data[e],
                    c = {},
                    h = {
                      chart: o,
                      dataIndex: e,
                      dataset: r,
                      datasetIndex: this.index,
                    },
                    f = [
                      'backgroundColor',
                      'borderColor',
                      'borderWidth',
                      'hoverBackgroundColor',
                      'hoverBorderColor',
                      'hoverBorderWidth',
                      'hoverRadius',
                      'hitRadius',
                      'pointStyle',
                      'rotation',
                    ];
                  for (i = 0, n = f.length; i < n; ++i)
                    c[(a = f[i])] = u([s[a], r[a], l[a]], h, e);
                  return (
                    (c.radius = u(
                      [s.radius, d ? d.r : void 0, r.radius, l.radius],
                      h,
                      e
                    )),
                    c
                  );
                },
              });
            });
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      17: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(41),
            A = t(46);
          n._set('doughnut', {
            animation: { animateRotate: !0, animateScale: !1 },
            hover: { mode: 'single' },
            legendCallback: function (t) {
              var e = [];
              e.push('<ul class="' + t.id + '-legend">');
              var i = t.data,
                n = i.datasets,
                a = i.labels;
              if (n.length)
                for (var o = 0; o < n[0].data.length; ++o)
                  e.push(
                    '<li><span style="background-color:' +
                      n[0].backgroundColor[o] +
                      '"></span>'
                  ),
                    a[o] && e.push(a[o]),
                    e.push('</li>');
              return e.push('</ul>'), e.join('');
            },
            legend: {
              labels: {
                generateLabels: function (l) {
                  var u = l.data;
                  return u.labels.length && u.datasets.length
                    ? u.labels.map(function (t, e) {
                        var i = l.getDatasetMeta(0),
                          n = u.datasets[0],
                          a = i.data[e],
                          o = (a && a.custom) || {},
                          r = A.valueAtIndexOrDefault,
                          s = l.options.elements.arc;
                        return {
                          text: t,
                          fillStyle: o.backgroundColor
                            ? o.backgroundColor
                            : r(n.backgroundColor, e, s.backgroundColor),
                          strokeStyle: o.borderColor
                            ? o.borderColor
                            : r(n.borderColor, e, s.borderColor),
                          lineWidth: o.borderWidth
                            ? o.borderWidth
                            : r(n.borderWidth, e, s.borderWidth),
                          hidden: isNaN(n.data[e]) || i.data[e].hidden,
                          index: e,
                        };
                      })
                    : [];
                },
              },
              onClick: function (t, e) {
                var i,
                  n,
                  a,
                  o = e.index,
                  r = this.chart;
                for (i = 0, n = (r.data.datasets || []).length; i < n; ++i)
                  (a = r.getDatasetMeta(i)).data[o] &&
                    (a.data[o].hidden = !a.data[o].hidden);
                r.update();
              },
            },
            cutoutPercentage: 50,
            rotation: -0.5 * Math.PI,
            circumference: 2 * Math.PI,
            tooltips: {
              callbacks: {
                title: function () {
                  return '';
                },
                label: function (t, e) {
                  var i = e.labels[t.index],
                    n = ': ' + e.datasets[t.datasetIndex].data[t.index];
                  return A.isArray(i) ? ((i = i.slice())[0] += n) : (i += n), i;
                },
              },
            },
          }),
            n._set('pie', A.clone(n.doughnut)),
            n._set('pie', { cutoutPercentage: 0 }),
            (e.exports = function (t) {
              t.controllers.doughnut = t.controllers.pie = t.DatasetController.extend(
                {
                  dataElementType: a.Arc,
                  linkScales: A.noop,
                  getRingIndex: function (t) {
                    for (var e = 0, i = 0; i < t; ++i)
                      this.chart.isDatasetVisible(i) && ++e;
                    return e;
                  },
                  update: function (i) {
                    var n = this,
                      t = n.chart,
                      e = t.chartArea,
                      a = t.options,
                      o = a.elements.arc,
                      r = e.right - e.left - o.borderWidth,
                      s = e.bottom - e.top - o.borderWidth,
                      l = Math.min(r, s),
                      u = { x: 0, y: 0 },
                      d = n.getMeta(),
                      c = a.cutoutPercentage,
                      h = a.circumference;
                    if (h < 2 * Math.PI) {
                      var f = a.rotation % (2 * Math.PI),
                        g =
                          (f +=
                            2 *
                            Math.PI *
                            (f >= Math.PI ? -1 : f < -Math.PI ? 1 : 0)) + h,
                        p = Math.cos(f),
                        m = Math.sin(f),
                        v = Math.cos(g),
                        b = Math.sin(g),
                        x =
                          (f <= 0 && 0 <= g) ||
                          (f <= 2 * Math.PI && 2 * Math.PI <= g),
                        y =
                          (f <= 0.5 * Math.PI && 0.5 * Math.PI <= g) ||
                          (f <= 2.5 * Math.PI && 2.5 * Math.PI <= g),
                        k =
                          (f <= -Math.PI && -Math.PI <= g) ||
                          (f <= Math.PI && Math.PI <= g),
                        M =
                          (f <= 0.5 * -Math.PI && 0.5 * -Math.PI <= g) ||
                          (f <= 1.5 * Math.PI && 1.5 * Math.PI <= g),
                        w = c / 100,
                        C = k
                          ? -1
                          : Math.min(p * (p < 0 ? 1 : w), v * (v < 0 ? 1 : w)),
                        S = M
                          ? -1
                          : Math.min(m * (m < 0 ? 1 : w), b * (b < 0 ? 1 : w)),
                        _ = x
                          ? 1
                          : Math.max(p * (0 < p ? 1 : w), v * (0 < v ? 1 : w)),
                        D = y
                          ? 1
                          : Math.max(m * (0 < m ? 1 : w), b * (0 < b ? 1 : w)),
                        P = 0.5 * (_ - C),
                        I = 0.5 * (D - S);
                      (l = Math.min(r / P, s / I)),
                        (u = { x: -0.5 * (_ + C), y: -0.5 * (D + S) });
                    }
                    (t.borderWidth = n.getMaxBorderWidth(d.data)),
                      (t.outerRadius = Math.max((l - t.borderWidth) / 2, 0)),
                      (t.innerRadius = Math.max(
                        c ? (t.outerRadius / 100) * c : 0,
                        0
                      )),
                      (t.radiusLength =
                        (t.outerRadius - t.innerRadius) /
                        t.getVisibleDatasetCount()),
                      (t.offsetX = u.x * t.outerRadius),
                      (t.offsetY = u.y * t.outerRadius),
                      (d.total = n.calculateTotal()),
                      (n.outerRadius =
                        t.outerRadius -
                        t.radiusLength * n.getRingIndex(n.index)),
                      (n.innerRadius = Math.max(
                        n.outerRadius - t.radiusLength,
                        0
                      )),
                      A.each(d.data, function (t, e) {
                        n.updateElement(t, e, i);
                      });
                  },
                  updateElement: function (t, e, i) {
                    var n = this,
                      a = n.chart,
                      o = a.chartArea,
                      r = a.options,
                      s = r.animation,
                      l = (o.left + o.right) / 2,
                      u = (o.top + o.bottom) / 2,
                      d = r.rotation,
                      c = r.rotation,
                      h = n.getDataset(),
                      f =
                        i && s.animateRotate
                          ? 0
                          : t.hidden
                          ? 0
                          : n.calculateCircumference(h.data[e]) *
                            (r.circumference / (2 * Math.PI)),
                      g = i && s.animateScale ? 0 : n.innerRadius,
                      p = i && s.animateScale ? 0 : n.outerRadius,
                      m = A.valueAtIndexOrDefault;
                    A.extend(t, {
                      _datasetIndex: n.index,
                      _index: e,
                      _model: {
                        x: l + a.offsetX,
                        y: u + a.offsetY,
                        startAngle: d,
                        endAngle: c,
                        circumference: f,
                        outerRadius: p,
                        innerRadius: g,
                        label: m(h.label, e, a.data.labels[e]),
                      },
                    });
                    var v = t._model,
                      b = t.custom || {},
                      x = A.valueAtIndexOrDefault,
                      y = this.chart.options.elements.arc;
                    (v.backgroundColor = b.backgroundColor
                      ? b.backgroundColor
                      : x(h.backgroundColor, e, y.backgroundColor)),
                      (v.borderColor = b.borderColor
                        ? b.borderColor
                        : x(h.borderColor, e, y.borderColor)),
                      (v.borderWidth = b.borderWidth
                        ? b.borderWidth
                        : x(h.borderWidth, e, y.borderWidth)),
                      (i && s.animateRotate) ||
                        ((v.startAngle =
                          0 === e
                            ? r.rotation
                            : n.getMeta().data[e - 1]._model.endAngle),
                        (v.endAngle = v.startAngle + v.circumference)),
                      t.pivot();
                  },
                  calculateTotal: function () {
                    var i,
                      n = this.getDataset(),
                      t = this.getMeta(),
                      a = 0;
                    return (
                      A.each(t.data, function (t, e) {
                        (i = n.data[e]),
                          isNaN(i) || t.hidden || (a += Math.abs(i));
                      }),
                      a
                    );
                  },
                  calculateCircumference: function (t) {
                    var e = this.getMeta().total;
                    return 0 < e && !isNaN(t)
                      ? 2 * Math.PI * (Math.abs(t) / e)
                      : 0;
                  },
                  getMaxBorderWidth: function (t) {
                    for (
                      var e, i, n = 0, a = this.index, o = t.length, r = 0;
                      r < o;
                      r++
                    )
                      n =
                        (n =
                          n < (e = t[r]._model ? t[r]._model.borderWidth : 0)
                            ? e
                            : n) <
                        (i = t[r]._chart
                          ? t[r]._chart.config.data.datasets[a].hoverBorderWidth
                          : 0)
                          ? i
                          : n;
                    return n;
                  },
                }
              );
            });
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      18: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(41),
            g = t(46);
          n._set('line', {
            showLines: !0,
            spanGaps: !1,
            hover: { mode: 'label' },
            scales: {
              xAxes: [{ type: 'category', id: 'x-axis-0' }],
              yAxes: [{ type: 'linear', id: 'y-axis-0' }],
            },
          }),
            (e.exports = function (t) {
              function f(t, e) {
                return g.valueOrDefault(t.showLine, e.showLines);
              }
              t.controllers.line = t.DatasetController.extend({
                datasetElementType: a.Line,
                dataElementType: a.Point,
                update: function (t) {
                  var e,
                    i,
                    n,
                    a = this,
                    o = a.getMeta(),
                    r = o.dataset,
                    s = o.data || [],
                    l = a.chart.options,
                    u = l.elements.line,
                    d = a.getScaleForId(o.yAxisID),
                    c = a.getDataset(),
                    h = f(c, l);
                  for (
                    h &&
                      ((n = r.custom || {}),
                      void 0 !== c.tension &&
                        void 0 === c.lineTension &&
                        (c.lineTension = c.tension),
                      (r._scale = d),
                      (r._datasetIndex = a.index),
                      (r._children = s),
                      (r._model = {
                        spanGaps: c.spanGaps ? c.spanGaps : l.spanGaps,
                        tension: n.tension
                          ? n.tension
                          : g.valueOrDefault(c.lineTension, u.tension),
                        backgroundColor: n.backgroundColor
                          ? n.backgroundColor
                          : c.backgroundColor || u.backgroundColor,
                        borderWidth: n.borderWidth
                          ? n.borderWidth
                          : c.borderWidth || u.borderWidth,
                        borderColor: n.borderColor
                          ? n.borderColor
                          : c.borderColor || u.borderColor,
                        borderCapStyle: n.borderCapStyle
                          ? n.borderCapStyle
                          : c.borderCapStyle || u.borderCapStyle,
                        borderDash: n.borderDash
                          ? n.borderDash
                          : c.borderDash || u.borderDash,
                        borderDashOffset: n.borderDashOffset
                          ? n.borderDashOffset
                          : c.borderDashOffset || u.borderDashOffset,
                        borderJoinStyle: n.borderJoinStyle
                          ? n.borderJoinStyle
                          : c.borderJoinStyle || u.borderJoinStyle,
                        fill: n.fill
                          ? n.fill
                          : void 0 !== c.fill
                          ? c.fill
                          : u.fill,
                        steppedLine: n.steppedLine
                          ? n.steppedLine
                          : g.valueOrDefault(c.steppedLine, u.stepped),
                        cubicInterpolationMode: n.cubicInterpolationMode
                          ? n.cubicInterpolationMode
                          : g.valueOrDefault(
                              c.cubicInterpolationMode,
                              u.cubicInterpolationMode
                            ),
                      }),
                      r.pivot()),
                      e = 0,
                      i = s.length;
                    e < i;
                    ++e
                  )
                    a.updateElement(s[e], e, t);
                  for (
                    h &&
                      0 !== r._model.tension &&
                      a.updateBezierControlPoints(),
                      e = 0,
                      i = s.length;
                    e < i;
                    ++e
                  )
                    s[e].pivot();
                },
                getPointBackgroundColor: function (t, e) {
                  var i = this.chart.options.elements.point.backgroundColor,
                    n = this.getDataset(),
                    a = t.custom || {};
                  return (
                    a.backgroundColor
                      ? (i = a.backgroundColor)
                      : n.pointBackgroundColor
                      ? (i = g.valueAtIndexOrDefault(
                          n.pointBackgroundColor,
                          e,
                          i
                        ))
                      : n.backgroundColor && (i = n.backgroundColor),
                    i
                  );
                },
                getPointBorderColor: function (t, e) {
                  var i = this.chart.options.elements.point.borderColor,
                    n = this.getDataset(),
                    a = t.custom || {};
                  return (
                    a.borderColor
                      ? (i = a.borderColor)
                      : n.pointBorderColor
                      ? (i = g.valueAtIndexOrDefault(n.pointBorderColor, e, i))
                      : n.borderColor && (i = n.borderColor),
                    i
                  );
                },
                getPointBorderWidth: function (t, e) {
                  var i = this.chart.options.elements.point.borderWidth,
                    n = this.getDataset(),
                    a = t.custom || {};
                  return (
                    isNaN(a.borderWidth)
                      ? !isNaN(n.pointBorderWidth) ||
                        g.isArray(n.pointBorderWidth)
                        ? (i = g.valueAtIndexOrDefault(
                            n.pointBorderWidth,
                            e,
                            i
                          ))
                        : isNaN(n.borderWidth) || (i = n.borderWidth)
                      : (i = a.borderWidth),
                    i
                  );
                },
                getPointRotation: function (t, e) {
                  var i = this.chart.options.elements.point.rotation,
                    n = this.getDataset(),
                    a = t.custom || {};
                  return (
                    isNaN(a.rotation)
                      ? (isNaN(n.pointRotation) &&
                          !g.isArray(n.pointRotation)) ||
                        (i = g.valueAtIndexOrDefault(n.pointRotation, e, i))
                      : (i = a.rotation),
                    i
                  );
                },
                updateElement: function (t, e, i) {
                  var n,
                    a,
                    o = this,
                    r = o.getMeta(),
                    s = t.custom || {},
                    l = o.getDataset(),
                    u = o.index,
                    d = l.data[e],
                    c = o.getScaleForId(r.yAxisID),
                    h = o.getScaleForId(r.xAxisID),
                    f = o.chart.options.elements.point;
                  void 0 !== l.radius &&
                    void 0 === l.pointRadius &&
                    (l.pointRadius = l.radius),
                    void 0 !== l.hitRadius &&
                      void 0 === l.pointHitRadius &&
                      (l.pointHitRadius = l.hitRadius),
                    (n = h.getPixelForValue(
                      'object' == typeof d ? d : NaN,
                      e,
                      u
                    )),
                    (a = i ? c.getBasePixel() : o.calculatePointY(d, e, u)),
                    (t._xScale = h),
                    (t._yScale = c),
                    (t._datasetIndex = u),
                    (t._index = e),
                    (t._model = {
                      x: n,
                      y: a,
                      skip: s.skip || isNaN(n) || isNaN(a),
                      radius:
                        s.radius ||
                        g.valueAtIndexOrDefault(l.pointRadius, e, f.radius),
                      pointStyle:
                        s.pointStyle ||
                        g.valueAtIndexOrDefault(l.pointStyle, e, f.pointStyle),
                      rotation: o.getPointRotation(t, e),
                      backgroundColor: o.getPointBackgroundColor(t, e),
                      borderColor: o.getPointBorderColor(t, e),
                      borderWidth: o.getPointBorderWidth(t, e),
                      tension: r.dataset._model ? r.dataset._model.tension : 0,
                      steppedLine:
                        !!r.dataset._model && r.dataset._model.steppedLine,
                      hitRadius:
                        s.hitRadius ||
                        g.valueAtIndexOrDefault(
                          l.pointHitRadius,
                          e,
                          f.hitRadius
                        ),
                    });
                },
                calculatePointY: function (t, e, i) {
                  var n,
                    a,
                    o,
                    r = this.chart,
                    s = this.getMeta(),
                    l = this.getScaleForId(s.yAxisID),
                    u = 0,
                    d = 0;
                  if (l.options.stacked) {
                    for (n = 0; n < i; n++)
                      if (
                        ((a = r.data.datasets[n]),
                        'line' === (o = r.getDatasetMeta(n)).type &&
                          o.yAxisID === l.id &&
                          r.isDatasetVisible(n))
                      ) {
                        var c = Number(l.getRightValue(a.data[e]));
                        c < 0 ? (d += c || 0) : (u += c || 0);
                      }
                    var h = Number(l.getRightValue(t));
                    return h < 0
                      ? l.getPixelForValue(d + h)
                      : l.getPixelForValue(u + h);
                  }
                  return l.getPixelForValue(t);
                },
                updateBezierControlPoints: function () {
                  var t,
                    e,
                    i,
                    n,
                    a = this.getMeta(),
                    o = this.chart.chartArea,
                    r = a.data || [];
                  function s(t, e, i) {
                    return Math.max(Math.min(t, i), e);
                  }
                  if (
                    (a.dataset._model.spanGaps &&
                      (r = r.filter(function (t) {
                        return !t._model.skip;
                      })),
                    'monotone' === a.dataset._model.cubicInterpolationMode)
                  )
                    g.splineCurveMonotone(r);
                  else
                    for (t = 0, e = r.length; t < e; ++t)
                      (i = r[t]._model),
                        (n = g.splineCurve(
                          g.previousItem(r, t)._model,
                          i,
                          g.nextItem(r, t)._model,
                          a.dataset._model.tension
                        )),
                        (i.controlPointPreviousX = n.previous.x),
                        (i.controlPointPreviousY = n.previous.y),
                        (i.controlPointNextX = n.next.x),
                        (i.controlPointNextY = n.next.y);
                  if (this.chart.options.elements.line.capBezierPoints)
                    for (t = 0, e = r.length; t < e; ++t)
                      ((i = r[t]._model).controlPointPreviousX = s(
                        i.controlPointPreviousX,
                        o.left,
                        o.right
                      )),
                        (i.controlPointPreviousY = s(
                          i.controlPointPreviousY,
                          o.top,
                          o.bottom
                        )),
                        (i.controlPointNextX = s(
                          i.controlPointNextX,
                          o.left,
                          o.right
                        )),
                        (i.controlPointNextY = s(
                          i.controlPointNextY,
                          o.top,
                          o.bottom
                        ));
                },
                draw: function () {
                  var t,
                    e = this.chart,
                    i = this.getMeta(),
                    n = i.data || [],
                    a = e.chartArea,
                    o = n.length,
                    r = 0;
                  for (
                    f(this.getDataset(), e.options) &&
                    ((t = (i.dataset._model.borderWidth || 0) / 2),
                    g.canvas.clipArea(e.ctx, {
                      left: a.left,
                      right: a.right,
                      top: a.top - t,
                      bottom: a.bottom + t,
                    }),
                    i.dataset.draw(),
                    g.canvas.unclipArea(e.ctx));
                    r < o;
                    ++r
                  )
                    n[r].draw(a);
                },
                setHoverStyle: function (t) {
                  var e = this.chart.data.datasets[t._datasetIndex],
                    i = t._index,
                    n = t.custom || {},
                    a = t._model;
                  (t.$previousStyle = {
                    backgroundColor: a.backgroundColor,
                    borderColor: a.borderColor,
                    borderWidth: a.borderWidth,
                    radius: a.radius,
                  }),
                    (a.backgroundColor =
                      n.hoverBackgroundColor ||
                      g.valueAtIndexOrDefault(
                        e.pointHoverBackgroundColor,
                        i,
                        g.getHoverColor(a.backgroundColor)
                      )),
                    (a.borderColor =
                      n.hoverBorderColor ||
                      g.valueAtIndexOrDefault(
                        e.pointHoverBorderColor,
                        i,
                        g.getHoverColor(a.borderColor)
                      )),
                    (a.borderWidth =
                      n.hoverBorderWidth ||
                      g.valueAtIndexOrDefault(
                        e.pointHoverBorderWidth,
                        i,
                        a.borderWidth
                      )),
                    (a.radius =
                      n.hoverRadius ||
                      g.valueAtIndexOrDefault(
                        e.pointHoverRadius,
                        i,
                        this.chart.options.elements.point.hoverRadius
                      ));
                },
              });
            });
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      19: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(41),
            k = t(46);
          n._set('polarArea', {
            scale: {
              type: 'radialLinear',
              angleLines: { display: !1 },
              gridLines: { circular: !0 },
              pointLabels: { display: !1 },
              ticks: { beginAtZero: !0 },
            },
            animation: { animateRotate: !0, animateScale: !0 },
            startAngle: -0.5 * Math.PI,
            legendCallback: function (t) {
              var e = [];
              e.push('<ul class="' + t.id + '-legend">');
              var i = t.data,
                n = i.datasets,
                a = i.labels;
              if (n.length)
                for (var o = 0; o < n[0].data.length; ++o)
                  e.push(
                    '<li><span style="background-color:' +
                      n[0].backgroundColor[o] +
                      '"></span>'
                  ),
                    a[o] && e.push(a[o]),
                    e.push('</li>');
              return e.push('</ul>'), e.join('');
            },
            legend: {
              labels: {
                generateLabels: function (s) {
                  var l = s.data;
                  return l.labels.length && l.datasets.length
                    ? l.labels.map(function (t, e) {
                        var i = s.getDatasetMeta(0),
                          n = l.datasets[0],
                          a = i.data[e].custom || {},
                          o = k.valueAtIndexOrDefault,
                          r = s.options.elements.arc;
                        return {
                          text: t,
                          fillStyle: a.backgroundColor
                            ? a.backgroundColor
                            : o(n.backgroundColor, e, r.backgroundColor),
                          strokeStyle: a.borderColor
                            ? a.borderColor
                            : o(n.borderColor, e, r.borderColor),
                          lineWidth: a.borderWidth
                            ? a.borderWidth
                            : o(n.borderWidth, e, r.borderWidth),
                          hidden: isNaN(n.data[e]) || i.data[e].hidden,
                          index: e,
                        };
                      })
                    : [];
                },
              },
              onClick: function (t, e) {
                var i,
                  n,
                  a,
                  o = e.index,
                  r = this.chart;
                for (i = 0, n = (r.data.datasets || []).length; i < n; ++i)
                  (a = r.getDatasetMeta(i)).data[o].hidden = !a.data[o].hidden;
                r.update();
              },
            },
            tooltips: {
              callbacks: {
                title: function () {
                  return '';
                },
                label: function (t, e) {
                  return e.labels[t.index] + ': ' + t.yLabel;
                },
              },
            },
          }),
            (e.exports = function (t) {
              t.controllers.polarArea = t.DatasetController.extend({
                dataElementType: a.Arc,
                linkScales: k.noop,
                update: function (i) {
                  var t,
                    e,
                    n,
                    a = this,
                    o = a.getDataset(),
                    r = a.getMeta(),
                    s = a.chart.options.startAngle || 0,
                    l = (a._starts = []),
                    u = (a._angles = []);
                  for (
                    a._updateRadius(),
                      r.count = a.countVisibleElements(),
                      t = 0,
                      e = o.data.length;
                    t < e;
                    t++
                  )
                    (l[t] = s), (n = a._computeAngle(t)), (s += u[t] = n);
                  k.each(r.data, function (t, e) {
                    a.updateElement(t, e, i);
                  });
                },
                _updateRadius: function () {
                  var t = this,
                    e = t.chart,
                    i = e.chartArea,
                    n = e.options,
                    a = n.elements.arc,
                    o = Math.min(i.right - i.left, i.bottom - i.top);
                  (e.outerRadius = Math.max((o - a.borderWidth / 2) / 2, 0)),
                    (e.innerRadius = Math.max(
                      n.cutoutPercentage
                        ? (e.outerRadius / 100) * n.cutoutPercentage
                        : 1,
                      0
                    )),
                    (e.radiusLength =
                      (e.outerRadius - e.innerRadius) /
                      e.getVisibleDatasetCount()),
                    (t.outerRadius = e.outerRadius - e.radiusLength * t.index),
                    (t.innerRadius = t.outerRadius - e.radiusLength);
                },
                updateElement: function (t, e, i) {
                  var n = this,
                    a = n.chart,
                    o = n.getDataset(),
                    r = a.options,
                    s = r.animation,
                    l = a.scale,
                    u = a.data.labels,
                    d = l.xCenter,
                    c = l.yCenter,
                    h = r.startAngle,
                    f = t.hidden
                      ? 0
                      : l.getDistanceFromCenterForValue(o.data[e]),
                    g = n._starts[e],
                    p = g + (t.hidden ? 0 : n._angles[e]),
                    m = s.animateScale
                      ? 0
                      : l.getDistanceFromCenterForValue(o.data[e]);
                  k.extend(t, {
                    _datasetIndex: n.index,
                    _index: e,
                    _scale: l,
                    _model: {
                      x: d,
                      y: c,
                      innerRadius: 0,
                      outerRadius: i ? m : f,
                      startAngle: i && s.animateRotate ? h : g,
                      endAngle: i && s.animateRotate ? h : p,
                      label: k.valueAtIndexOrDefault(u, e, u[e]),
                    },
                  });
                  var v = this.chart.options.elements.arc,
                    b = t.custom || {},
                    x = k.valueAtIndexOrDefault,
                    y = t._model;
                  (y.backgroundColor = b.backgroundColor
                    ? b.backgroundColor
                    : x(o.backgroundColor, e, v.backgroundColor)),
                    (y.borderColor = b.borderColor
                      ? b.borderColor
                      : x(o.borderColor, e, v.borderColor)),
                    (y.borderWidth = b.borderWidth
                      ? b.borderWidth
                      : x(o.borderWidth, e, v.borderWidth)),
                    t.pivot();
                },
                countVisibleElements: function () {
                  var i = this.getDataset(),
                    t = this.getMeta(),
                    n = 0;
                  return (
                    k.each(t.data, function (t, e) {
                      isNaN(i.data[e]) || t.hidden || n++;
                    }),
                    n
                  );
                },
                _computeAngle: function (t) {
                  var e = this,
                    i = this.getMeta().count,
                    n = e.getDataset(),
                    a = e.getMeta();
                  if (isNaN(n.data[t]) || a.data[t].hidden) return 0;
                  var o = {
                    chart: e.chart,
                    dataIndex: t,
                    dataset: n,
                    datasetIndex: e.index,
                  };
                  return k.options.resolve(
                    [e.chart.options.elements.arc.angle, (2 * Math.PI) / i],
                    o,
                    t
                  );
                },
              });
            });
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      20: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(41),
            u = t(46);
          n._set('radar', {
            scale: { type: 'radialLinear' },
            elements: { line: { tension: 0 } },
          }),
            (e.exports = function (t) {
              t.controllers.radar = t.DatasetController.extend({
                datasetElementType: a.Line,
                dataElementType: a.Point,
                linkScales: u.noop,
                update: function (i) {
                  var n = this,
                    t = n.getMeta(),
                    e = t.dataset,
                    a = t.data,
                    o = e.custom || {},
                    r = n.getDataset(),
                    s = n.chart.options.elements.line,
                    l = n.chart.scale;
                  void 0 !== r.tension &&
                    void 0 === r.lineTension &&
                    (r.lineTension = r.tension),
                    u.extend(t.dataset, {
                      _datasetIndex: n.index,
                      _scale: l,
                      _children: a,
                      _loop: !0,
                      _model: {
                        tension: o.tension
                          ? o.tension
                          : u.valueOrDefault(r.lineTension, s.tension),
                        backgroundColor: o.backgroundColor
                          ? o.backgroundColor
                          : r.backgroundColor || s.backgroundColor,
                        borderWidth: o.borderWidth
                          ? o.borderWidth
                          : r.borderWidth || s.borderWidth,
                        borderColor: o.borderColor
                          ? o.borderColor
                          : r.borderColor || s.borderColor,
                        fill: o.fill
                          ? o.fill
                          : void 0 !== r.fill
                          ? r.fill
                          : s.fill,
                        borderCapStyle: o.borderCapStyle
                          ? o.borderCapStyle
                          : r.borderCapStyle || s.borderCapStyle,
                        borderDash: o.borderDash
                          ? o.borderDash
                          : r.borderDash || s.borderDash,
                        borderDashOffset: o.borderDashOffset
                          ? o.borderDashOffset
                          : r.borderDashOffset || s.borderDashOffset,
                        borderJoinStyle: o.borderJoinStyle
                          ? o.borderJoinStyle
                          : r.borderJoinStyle || s.borderJoinStyle,
                      },
                    }),
                    t.dataset.pivot(),
                    u.each(
                      a,
                      function (t, e) {
                        n.updateElement(t, e, i);
                      },
                      n
                    ),
                    n.updateBezierControlPoints();
                },
                updateElement: function (t, e, i) {
                  var n = this,
                    a = t.custom || {},
                    o = n.getDataset(),
                    r = n.chart.scale,
                    s = n.chart.options.elements.point,
                    l = r.getPointPositionForValue(e, o.data[e]);
                  void 0 !== o.radius &&
                    void 0 === o.pointRadius &&
                    (o.pointRadius = o.radius),
                    void 0 !== o.hitRadius &&
                      void 0 === o.pointHitRadius &&
                      (o.pointHitRadius = o.hitRadius),
                    u.extend(t, {
                      _datasetIndex: n.index,
                      _index: e,
                      _scale: r,
                      _model: {
                        x: i ? r.xCenter : l.x,
                        y: i ? r.yCenter : l.y,
                        tension: a.tension
                          ? a.tension
                          : u.valueOrDefault(
                              o.lineTension,
                              n.chart.options.elements.line.tension
                            ),
                        radius: a.radius
                          ? a.radius
                          : u.valueAtIndexOrDefault(o.pointRadius, e, s.radius),
                        backgroundColor: a.backgroundColor
                          ? a.backgroundColor
                          : u.valueAtIndexOrDefault(
                              o.pointBackgroundColor,
                              e,
                              s.backgroundColor
                            ),
                        borderColor: a.borderColor
                          ? a.borderColor
                          : u.valueAtIndexOrDefault(
                              o.pointBorderColor,
                              e,
                              s.borderColor
                            ),
                        borderWidth: a.borderWidth
                          ? a.borderWidth
                          : u.valueAtIndexOrDefault(
                              o.pointBorderWidth,
                              e,
                              s.borderWidth
                            ),
                        pointStyle: a.pointStyle
                          ? a.pointStyle
                          : u.valueAtIndexOrDefault(
                              o.pointStyle,
                              e,
                              s.pointStyle
                            ),
                        rotation: a.rotation
                          ? a.rotation
                          : u.valueAtIndexOrDefault(
                              o.pointRotation,
                              e,
                              s.rotation
                            ),
                        hitRadius: a.hitRadius
                          ? a.hitRadius
                          : u.valueAtIndexOrDefault(
                              o.pointHitRadius,
                              e,
                              s.hitRadius
                            ),
                      },
                    }),
                    (t._model.skip = a.skip
                      ? a.skip
                      : isNaN(t._model.x) || isNaN(t._model.y));
                },
                updateBezierControlPoints: function () {
                  var a = this.chart.chartArea,
                    o = this.getMeta();
                  u.each(o.data, function (t, e) {
                    var i = t._model,
                      n = u.splineCurve(
                        u.previousItem(o.data, e, !0)._model,
                        i,
                        u.nextItem(o.data, e, !0)._model,
                        i.tension
                      );
                    (i.controlPointPreviousX = Math.max(
                      Math.min(n.previous.x, a.right),
                      a.left
                    )),
                      (i.controlPointPreviousY = Math.max(
                        Math.min(n.previous.y, a.bottom),
                        a.top
                      )),
                      (i.controlPointNextX = Math.max(
                        Math.min(n.next.x, a.right),
                        a.left
                      )),
                      (i.controlPointNextY = Math.max(
                        Math.min(n.next.y, a.bottom),
                        a.top
                      )),
                      t.pivot();
                  });
                },
                setHoverStyle: function (t) {
                  var e = this.chart.data.datasets[t._datasetIndex],
                    i = t.custom || {},
                    n = t._index,
                    a = t._model;
                  (t.$previousStyle = {
                    backgroundColor: a.backgroundColor,
                    borderColor: a.borderColor,
                    borderWidth: a.borderWidth,
                    radius: a.radius,
                  }),
                    (a.radius = i.hoverRadius
                      ? i.hoverRadius
                      : u.valueAtIndexOrDefault(
                          e.pointHoverRadius,
                          n,
                          this.chart.options.elements.point.hoverRadius
                        )),
                    (a.backgroundColor = i.hoverBackgroundColor
                      ? i.hoverBackgroundColor
                      : u.valueAtIndexOrDefault(
                          e.pointHoverBackgroundColor,
                          n,
                          u.getHoverColor(a.backgroundColor)
                        )),
                    (a.borderColor = i.hoverBorderColor
                      ? i.hoverBorderColor
                      : u.valueAtIndexOrDefault(
                          e.pointHoverBorderColor,
                          n,
                          u.getHoverColor(a.borderColor)
                        )),
                    (a.borderWidth = i.hoverBorderWidth
                      ? i.hoverBorderWidth
                      : u.valueAtIndexOrDefault(
                          e.pointHoverBorderWidth,
                          n,
                          a.borderWidth
                        ));
                },
              });
            });
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      21: [
        function (t, e, i) {
          'use strict';
          t(26)._set('scatter', {
            hover: { mode: 'single' },
            scales: {
              xAxes: [{ id: 'x-axis-1', type: 'linear', position: 'bottom' }],
              yAxes: [{ id: 'y-axis-1', type: 'linear', position: 'left' }],
            },
            showLines: !1,
            tooltips: {
              callbacks: {
                title: function () {
                  return '';
                },
                label: function (t) {
                  return '(' + t.xLabel + ', ' + t.yLabel + ')';
                },
              },
            },
          }),
            (e.exports = function (t) {
              t.controllers.scatter = t.controllers.line;
            });
        },
        { 26: 26 },
      ],
      22: [
        function (t, e, i) {
          'use strict';
          var n = t(27);
          i = e.exports = n.extend({
            chart: null,
            currentStep: 0,
            numSteps: 60,
            easing: '',
            render: null,
            onAnimationProgress: null,
            onAnimationComplete: null,
          });
          Object.defineProperty(i.prototype, 'animationObject', {
            get: function () {
              return this;
            },
          }),
            Object.defineProperty(i.prototype, 'chartInstance', {
              get: function () {
                return this.chart;
              },
              set: function (t) {
                this.chart = t;
              },
            });
        },
        { 27: 27 },
      ],
      23: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            o = t(46);
          n._set('global', {
            animation: {
              duration: 1e3,
              easing: 'easeOutQuart',
              onProgress: o.noop,
              onComplete: o.noop,
            },
          }),
            (e.exports = {
              frameDuration: 17,
              animations: [],
              dropFrames: 0,
              request: null,
              addAnimation: function (t, e, i, n) {
                var a,
                  o,
                  r = this.animations;
                for (
                  e.chart = t, n || (t.animating = !0), a = 0, o = r.length;
                  a < o;
                  ++a
                )
                  if (r[a].chart === t) return void (r[a] = e);
                r.push(e), 1 === r.length && this.requestAnimationFrame();
              },
              cancelAnimation: function (e) {
                var t = o.findIndex(this.animations, function (t) {
                  return t.chart === e;
                });
                -1 !== t && (this.animations.splice(t, 1), (e.animating = !1));
              },
              requestAnimationFrame: function () {
                var t = this;
                null === t.request &&
                  (t.request = o.requestAnimFrame.call(window, function () {
                    (t.request = null), t.startDigest();
                  }));
              },
              startDigest: function () {
                var t = this,
                  e = Date.now(),
                  i = 0;
                1 < t.dropFrames &&
                  ((i = Math.floor(t.dropFrames)),
                  (t.dropFrames = t.dropFrames % 1)),
                  t.advance(1 + i);
                var n = Date.now();
                (t.dropFrames += (n - e) / t.frameDuration),
                  0 < t.animations.length && t.requestAnimationFrame();
              },
              advance: function (t) {
                for (var e, i, n = this.animations, a = 0; a < n.length; )
                  (i = (e = n[a]).chart),
                    (e.currentStep = (e.currentStep || 0) + t),
                    (e.currentStep = Math.min(e.currentStep, e.numSteps)),
                    o.callback(e.render, [i, e], i),
                    o.callback(e.onAnimationProgress, [e], i),
                    e.currentStep >= e.numSteps
                      ? (o.callback(e.onAnimationComplete, [e], i),
                        (i.animating = !1),
                        n.splice(a, 1))
                      : ++a;
              },
            });
        },
        { 26: 26, 46: 46 },
      ],
      24: [
        function (t, e, i) {
          'use strict';
          var s = t(22),
            l = t(23),
            c = t(26),
            h = t(46),
            a = t(29),
            o = t(31),
            f = t(49),
            g = t(32),
            p = t(34),
            n = t(36);
          e.exports = function (u) {
            function d(t) {
              return 'top' === t || 'bottom' === t;
            }
            (u.types = {}),
              (u.instances = {}),
              (u.controllers = {}),
              h.extend(u.prototype, {
                construct: function (t, e) {
                  var i,
                    n,
                    a = this;
                  ((n = (i = (i = e) || {}).data = i.data || {}).datasets =
                    n.datasets || []),
                    (n.labels = n.labels || []),
                    (i.options = h.configMerge(
                      c.global,
                      c[i.type],
                      i.options || {}
                    )),
                    (e = i);
                  var o = f.acquireContext(t, e),
                    r = o && o.canvas,
                    s = r && r.height,
                    l = r && r.width;
                  (a.id = h.uid()),
                    (a.ctx = o),
                    (a.canvas = r),
                    (a.config = e),
                    (a.width = l),
                    (a.height = s),
                    (a.aspectRatio = s ? l / s : null),
                    (a.options = e.options),
                    (a._bufferedRender = !1),
                    ((a.chart = a).controller = a),
                    (u.instances[a.id] = a),
                    Object.defineProperty(a, 'data', {
                      get: function () {
                        return a.config.data;
                      },
                      set: function (t) {
                        a.config.data = t;
                      },
                    }),
                    o && r
                      ? (a.initialize(), a.update())
                      : console.error(
                          "Failed to create chart: can't acquire context from the given item"
                        );
                },
                initialize: function () {
                  var t = this;
                  return (
                    g.notify(t, 'beforeInit'),
                    h.retinaScale(t, t.options.devicePixelRatio),
                    t.bindEvents(),
                    t.options.responsive && t.resize(!0),
                    t.ensureScalesHaveIDs(),
                    t.buildOrUpdateScales(),
                    t.initToolTip(),
                    g.notify(t, 'afterInit'),
                    t
                  );
                },
                clear: function () {
                  return h.canvas.clear(this), this;
                },
                stop: function () {
                  return l.cancelAnimation(this), this;
                },
                resize: function (t) {
                  var e = this,
                    i = e.options,
                    n = e.canvas,
                    a = (i.maintainAspectRatio && e.aspectRatio) || null,
                    o = Math.max(0, Math.floor(h.getMaximumWidth(n))),
                    r = Math.max(
                      0,
                      Math.floor(a ? o / a : h.getMaximumHeight(n))
                    );
                  if (
                    (e.width !== o || e.height !== r) &&
                    ((n.width = e.width = o),
                    (n.height = e.height = r),
                    (n.style.width = o + 'px'),
                    (n.style.height = r + 'px'),
                    h.retinaScale(e, i.devicePixelRatio),
                    !t)
                  ) {
                    var s = { width: o, height: r };
                    g.notify(e, 'resize', [s]),
                      e.options.onResize && e.options.onResize(e, s),
                      e.stop(),
                      e.update({
                        duration: e.options.responsiveAnimationDuration,
                      });
                  }
                },
                ensureScalesHaveIDs: function () {
                  var t = this.options,
                    e = t.scales || {},
                    i = t.scale;
                  h.each(e.xAxes, function (t, e) {
                    t.id = t.id || 'x-axis-' + e;
                  }),
                    h.each(e.yAxes, function (t, e) {
                      t.id = t.id || 'y-axis-' + e;
                    }),
                    i && (i.id = i.id || 'scale');
                },
                buildOrUpdateScales: function () {
                  var r = this,
                    t = r.options,
                    s = r.scales || {},
                    e = [],
                    l = Object.keys(s).reduce(function (t, e) {
                      return (t[e] = !1), t;
                    }, {});
                  t.scales &&
                    (e = e.concat(
                      (t.scales.xAxes || []).map(function (t) {
                        return {
                          options: t,
                          dtype: 'category',
                          dposition: 'bottom',
                        };
                      }),
                      (t.scales.yAxes || []).map(function (t) {
                        return {
                          options: t,
                          dtype: 'linear',
                          dposition: 'left',
                        };
                      })
                    )),
                    t.scale &&
                      e.push({
                        options: t.scale,
                        dtype: 'radialLinear',
                        isDefault: !0,
                        dposition: 'chartArea',
                      }),
                    h.each(e, function (t) {
                      var e = t.options,
                        i = e.id,
                        n = h.valueOrDefault(e.type, t.dtype);
                      d(e.position) !== d(t.dposition) &&
                        (e.position = t.dposition),
                        (l[i] = !0);
                      var a = null;
                      if (i in s && s[i].type === n)
                        ((a = s[i]).options = e),
                          (a.ctx = r.ctx),
                          (a.chart = r);
                      else {
                        var o = p.getScaleConstructor(n);
                        if (!o) return;
                        (a = new o({
                          id: i,
                          type: n,
                          options: e,
                          ctx: r.ctx,
                          chart: r,
                        })),
                          (s[a.id] = a);
                      }
                      a.mergeTicksOptions(), t.isDefault && (r.scale = a);
                    }),
                    h.each(l, function (t, e) {
                      t || delete s[e];
                    }),
                    (r.scales = s),
                    p.addScalesToLayout(this);
                },
                buildOrUpdateControllers: function () {
                  var o = this,
                    r = [],
                    s = [];
                  return (
                    h.each(
                      o.data.datasets,
                      function (t, e) {
                        var i = o.getDatasetMeta(e),
                          n = t.type || o.config.type;
                        if (
                          (i.type &&
                            i.type !== n &&
                            (o.destroyDatasetMeta(e),
                            (i = o.getDatasetMeta(e))),
                          (i.type = n),
                          r.push(i.type),
                          i.controller)
                        )
                          i.controller.updateIndex(e),
                            i.controller.linkScales();
                        else {
                          var a = u.controllers[i.type];
                          if (void 0 === a)
                            throw new Error(
                              '"' + i.type + '" is not a chart type.'
                            );
                          (i.controller = new a(o, e)), s.push(i.controller);
                        }
                      },
                      o
                    ),
                    s
                  );
                },
                resetElements: function () {
                  var i = this;
                  h.each(
                    i.data.datasets,
                    function (t, e) {
                      i.getDatasetMeta(e).controller.reset();
                    },
                    i
                  );
                },
                reset: function () {
                  this.resetElements(), this.tooltip.initialize();
                },
                update: function (t) {
                  var e,
                    i,
                    n = this;
                  if (
                    ((t && 'object' == typeof t) ||
                      (t = { duration: t, lazy: arguments[1] }),
                    (i = (e = n).options),
                    h.each(e.scales, function (t) {
                      o.removeBox(e, t);
                    }),
                    (i = h.configMerge(
                      u.defaults.global,
                      u.defaults[e.config.type],
                      i
                    )),
                    (e.options = e.config.options = i),
                    e.ensureScalesHaveIDs(),
                    e.buildOrUpdateScales(),
                    (e.tooltip._options = i.tooltips),
                    e.tooltip.initialize(),
                    g._invalidate(n),
                    !1 !== g.notify(n, 'beforeUpdate'))
                  ) {
                    n.tooltip._data = n.data;
                    var a = n.buildOrUpdateControllers();
                    h.each(
                      n.data.datasets,
                      function (t, e) {
                        n.getDatasetMeta(e).controller.buildOrUpdateElements();
                      },
                      n
                    ),
                      n.updateLayout(),
                      n.options.animation &&
                        n.options.animation.duration &&
                        h.each(a, function (t) {
                          t.reset();
                        }),
                      n.updateDatasets(),
                      n.tooltip.initialize(),
                      (n.lastActive = []),
                      g.notify(n, 'afterUpdate'),
                      n._bufferedRender
                        ? (n._bufferedRequest = {
                            duration: t.duration,
                            easing: t.easing,
                            lazy: t.lazy,
                          })
                        : n.render(t);
                  }
                },
                updateLayout: function () {
                  !1 !== g.notify(this, 'beforeLayout') &&
                    (o.update(this, this.width, this.height),
                    g.notify(this, 'afterScaleUpdate'),
                    g.notify(this, 'afterLayout'));
                },
                updateDatasets: function () {
                  if (!1 !== g.notify(this, 'beforeDatasetsUpdate')) {
                    for (var t = 0, e = this.data.datasets.length; t < e; ++t)
                      this.updateDataset(t);
                    g.notify(this, 'afterDatasetsUpdate');
                  }
                },
                updateDataset: function (t) {
                  var e = this.getDatasetMeta(t),
                    i = { meta: e, index: t };
                  !1 !== g.notify(this, 'beforeDatasetUpdate', [i]) &&
                    (e.controller.update(),
                    g.notify(this, 'afterDatasetUpdate', [i]));
                },
                render: function (t) {
                  var e = this;
                  (t && 'object' == typeof t) ||
                    (t = { duration: t, lazy: arguments[1] });
                  var i = t.duration,
                    n = t.lazy;
                  if (!1 !== g.notify(e, 'beforeRender')) {
                    var a = e.options.animation,
                      o = function (t) {
                        g.notify(e, 'afterRender'),
                          h.callback(a && a.onComplete, [t], e);
                      };
                    if (
                      a &&
                      ((void 0 !== i && 0 !== i) ||
                        (void 0 === i && 0 !== a.duration))
                    ) {
                      var r = new s({
                        numSteps: (i || a.duration) / 16.66,
                        easing: t.easing || a.easing,
                        render: function (t, e) {
                          var i = h.easing.effects[e.easing],
                            n = e.currentStep,
                            a = n / e.numSteps;
                          t.draw(i(a), a, n);
                        },
                        onAnimationProgress: a.onProgress,
                        onAnimationComplete: o,
                      });
                      l.addAnimation(e, r, i, n);
                    } else e.draw(), o(new s({ numSteps: 0, chart: e }));
                    return e;
                  }
                },
                draw: function (t) {
                  var e = this;
                  e.clear(),
                    h.isNullOrUndef(t) && (t = 1),
                    e.transition(t),
                    e.width <= 0 ||
                      e.height <= 0 ||
                      (!1 !== g.notify(e, 'beforeDraw', [t]) &&
                        (h.each(
                          e.boxes,
                          function (t) {
                            t.draw(e.chartArea);
                          },
                          e
                        ),
                        e.scale && e.scale.draw(),
                        e.drawDatasets(t),
                        e._drawTooltip(t),
                        g.notify(e, 'afterDraw', [t])));
                },
                transition: function (t) {
                  for (
                    var e = 0, i = (this.data.datasets || []).length;
                    e < i;
                    ++e
                  )
                    this.isDatasetVisible(e) &&
                      this.getDatasetMeta(e).controller.transition(t);
                  this.tooltip.transition(t);
                },
                drawDatasets: function (t) {
                  var e = this;
                  if (!1 !== g.notify(e, 'beforeDatasetsDraw', [t])) {
                    for (
                      var i = (e.data.datasets || []).length - 1;
                      0 <= i;
                      --i
                    )
                      e.isDatasetVisible(i) && e.drawDataset(i, t);
                    g.notify(e, 'afterDatasetsDraw', [t]);
                  }
                },
                drawDataset: function (t, e) {
                  var i = this.getDatasetMeta(t),
                    n = { meta: i, index: t, easingValue: e };
                  !1 !== g.notify(this, 'beforeDatasetDraw', [n]) &&
                    (i.controller.draw(e),
                    g.notify(this, 'afterDatasetDraw', [n]));
                },
                _drawTooltip: function (t) {
                  var e = this.tooltip,
                    i = { tooltip: e, easingValue: t };
                  !1 !== g.notify(this, 'beforeTooltipDraw', [i]) &&
                    (e.draw(), g.notify(this, 'afterTooltipDraw', [i]));
                },
                getElementAtEvent: function (t) {
                  return a.modes.single(this, t);
                },
                getElementsAtEvent: function (t) {
                  return a.modes.label(this, t, { intersect: !0 });
                },
                getElementsAtXAxis: function (t) {
                  return a.modes['x-axis'](this, t, { intersect: !0 });
                },
                getElementsAtEventForMode: function (t, e, i) {
                  var n = a.modes[e];
                  return 'function' == typeof n ? n(this, t, i) : [];
                },
                getDatasetAtEvent: function (t) {
                  return a.modes.dataset(this, t, { intersect: !0 });
                },
                getDatasetMeta: function (t) {
                  var e = this.data.datasets[t];
                  e._meta || (e._meta = {});
                  var i = e._meta[this.id];
                  return (
                    i ||
                      (i = e._meta[this.id] = {
                        type: null,
                        data: [],
                        dataset: null,
                        controller: null,
                        hidden: null,
                        xAxisID: null,
                        yAxisID: null,
                      }),
                    i
                  );
                },
                getVisibleDatasetCount: function () {
                  for (
                    var t = 0, e = 0, i = this.data.datasets.length;
                    e < i;
                    ++e
                  )
                    this.isDatasetVisible(e) && t++;
                  return t;
                },
                isDatasetVisible: function (t) {
                  var e = this.getDatasetMeta(t);
                  return 'boolean' == typeof e.hidden
                    ? !e.hidden
                    : !this.data.datasets[t].hidden;
                },
                generateLegend: function () {
                  return this.options.legendCallback(this);
                },
                destroyDatasetMeta: function (t) {
                  var e = this.id,
                    i = this.data.datasets[t],
                    n = i._meta && i._meta[e];
                  n && (n.controller.destroy(), delete i._meta[e]);
                },
                destroy: function () {
                  var t,
                    e,
                    i = this,
                    n = i.canvas;
                  for (i.stop(), t = 0, e = i.data.datasets.length; t < e; ++t)
                    i.destroyDatasetMeta(t);
                  n &&
                    (i.unbindEvents(),
                    h.canvas.clear(i),
                    f.releaseContext(i.ctx),
                    (i.canvas = null),
                    (i.ctx = null)),
                    g.notify(i, 'destroy'),
                    delete u.instances[i.id];
                },
                toBase64Image: function () {
                  return this.canvas.toDataURL.apply(this.canvas, arguments);
                },
                initToolTip: function () {
                  var t = this;
                  t.tooltip = new n(
                    {
                      _chart: t,
                      _chartInstance: t,
                      _data: t.data,
                      _options: t.options.tooltips,
                    },
                    t
                  );
                },
                bindEvents: function () {
                  var e = this,
                    i = (e._listeners = {}),
                    n = function () {
                      e.eventHandler.apply(e, arguments);
                    };
                  h.each(e.options.events, function (t) {
                    f.addEventListener(e, t, n), (i[t] = n);
                  }),
                    e.options.responsive &&
                      ((n = function () {
                        e.resize();
                      }),
                      f.addEventListener(e, 'resize', n),
                      (i.resize = n));
                },
                unbindEvents: function () {
                  var i = this,
                    t = i._listeners;
                  t &&
                    (delete i._listeners,
                    h.each(t, function (t, e) {
                      f.removeEventListener(i, e, t);
                    }));
                },
                updateHoverStyle: function (t, e, i) {
                  var n,
                    a,
                    o,
                    r = i ? 'setHoverStyle' : 'removeHoverStyle';
                  for (a = 0, o = t.length; a < o; ++a)
                    (n = t[a]) &&
                      this.getDatasetMeta(n._datasetIndex).controller[r](n);
                },
                eventHandler: function (t) {
                  var e = this,
                    i = e.tooltip;
                  if (!1 !== g.notify(e, 'beforeEvent', [t])) {
                    (e._bufferedRender = !0), (e._bufferedRequest = null);
                    var n = e.handleEvent(t);
                    i &&
                      (n = i._start ? i.handleEvent(t) : n | i.handleEvent(t)),
                      g.notify(e, 'afterEvent', [t]);
                    var a = e._bufferedRequest;
                    return (
                      a
                        ? e.render(a)
                        : n &&
                          !e.animating &&
                          (e.stop(),
                          e.render({
                            duration: e.options.hover.animationDuration,
                            lazy: !0,
                          })),
                      (e._bufferedRender = !1),
                      (e._bufferedRequest = null),
                      e
                    );
                  }
                },
                handleEvent: function (t) {
                  var e,
                    i = this,
                    n = i.options || {},
                    a = n.hover;
                  return (
                    (i.lastActive = i.lastActive || []),
                    'mouseout' === t.type
                      ? (i.active = [])
                      : (i.active = i.getElementsAtEventForMode(t, a.mode, a)),
                    h.callback(
                      n.onHover || n.hover.onHover,
                      [t.native, i.active],
                      i
                    ),
                    ('mouseup' !== t.type && 'click' !== t.type) ||
                      (n.onClick && n.onClick.call(i, t.native, i.active)),
                    i.lastActive.length &&
                      i.updateHoverStyle(i.lastActive, a.mode, !1),
                    i.active.length &&
                      a.mode &&
                      i.updateHoverStyle(i.active, a.mode, !0),
                    (e = !h.arrayEquals(i.active, i.lastActive)),
                    (i.lastActive = i.active),
                    e
                  );
                },
              }),
              (u.Controller = u);
          };
        },
        {
          22: 22,
          23: 23,
          26: 26,
          29: 29,
          31: 31,
          32: 32,
          34: 34,
          36: 36,
          46: 46,
          49: 49,
        },
      ],
      25: [
        function (t, e, i) {
          'use strict';
          var s = t(46);
          e.exports = function (t) {
            var o = ['push', 'pop', 'shift', 'splice', 'unshift'];
            function r(e, t) {
              var i = e._chartjs;
              if (i) {
                var n = i.listeners,
                  a = n.indexOf(t);
                -1 !== a && n.splice(a, 1),
                  0 < n.length ||
                    (o.forEach(function (t) {
                      delete e[t];
                    }),
                    delete e._chartjs);
              }
            }
            (t.DatasetController = function (t, e) {
              this.initialize(t, e);
            }),
              s.extend(t.DatasetController.prototype, {
                datasetElementType: null,
                dataElementType: null,
                initialize: function (t, e) {
                  (this.chart = t),
                    (this.index = e),
                    this.linkScales(),
                    this.addElements();
                },
                updateIndex: function (t) {
                  this.index = t;
                },
                linkScales: function () {
                  var t = this,
                    e = t.getMeta(),
                    i = t.getDataset();
                  (null !== e.xAxisID && e.xAxisID in t.chart.scales) ||
                    (e.xAxisID =
                      i.xAxisID || t.chart.options.scales.xAxes[0].id),
                    (null !== e.yAxisID && e.yAxisID in t.chart.scales) ||
                      (e.yAxisID =
                        i.yAxisID || t.chart.options.scales.yAxes[0].id);
                },
                getDataset: function () {
                  return this.chart.data.datasets[this.index];
                },
                getMeta: function () {
                  return this.chart.getDatasetMeta(this.index);
                },
                getScaleForId: function (t) {
                  return this.chart.scales[t];
                },
                reset: function () {
                  this.update(!0);
                },
                destroy: function () {
                  this._data && r(this._data, this);
                },
                createMetaDataset: function () {
                  var t = this.datasetElementType;
                  return (
                    t &&
                    new t({ _chart: this.chart, _datasetIndex: this.index })
                  );
                },
                createMetaData: function (t) {
                  var e = this.dataElementType;
                  return (
                    e &&
                    new e({
                      _chart: this.chart,
                      _datasetIndex: this.index,
                      _index: t,
                    })
                  );
                },
                addElements: function () {
                  var t,
                    e,
                    i = this.getMeta(),
                    n = this.getDataset().data || [],
                    a = i.data;
                  for (t = 0, e = n.length; t < e; ++t)
                    a[t] = a[t] || this.createMetaData(t);
                  i.dataset = i.dataset || this.createMetaDataset();
                },
                addElementAndReset: function (t) {
                  var e = this.createMetaData(t);
                  this.getMeta().data.splice(t, 0, e),
                    this.updateElement(e, t, !0);
                },
                buildOrUpdateElements: function () {
                  var a,
                    t,
                    e = this,
                    i = e.getDataset(),
                    n = i.data || (i.data = []);
                  e._data !== n &&
                    (e._data && r(e._data, e),
                    (t = e),
                    (a = n)._chartjs
                      ? a._chartjs.listeners.push(t)
                      : (Object.defineProperty(a, '_chartjs', {
                          configurable: !0,
                          enumerable: !1,
                          value: { listeners: [t] },
                        }),
                        o.forEach(function (t) {
                          var i =
                              'onData' + t.charAt(0).toUpperCase() + t.slice(1),
                            n = a[t];
                          Object.defineProperty(a, t, {
                            configurable: !0,
                            enumerable: !1,
                            value: function () {
                              var e = Array.prototype.slice.call(arguments),
                                t = n.apply(this, e);
                              return (
                                s.each(a._chartjs.listeners, function (t) {
                                  'function' == typeof t[i] && t[i].apply(t, e);
                                }),
                                t
                              );
                            },
                          });
                        })),
                    (e._data = n)),
                    e.resyncElements();
                },
                update: s.noop,
                transition: function (t) {
                  for (
                    var e = this.getMeta(),
                      i = e.data || [],
                      n = i.length,
                      a = 0;
                    a < n;
                    ++a
                  )
                    i[a].transition(t);
                  e.dataset && e.dataset.transition(t);
                },
                draw: function () {
                  var t = this.getMeta(),
                    e = t.data || [],
                    i = e.length,
                    n = 0;
                  for (t.dataset && t.dataset.draw(); n < i; ++n) e[n].draw();
                },
                removeHoverStyle: function (t) {
                  s.merge(t._model, t.$previousStyle || {}),
                    delete t.$previousStyle;
                },
                setHoverStyle: function (t) {
                  var e = this.chart.data.datasets[t._datasetIndex],
                    i = t._index,
                    n = t.custom || {},
                    a = s.valueAtIndexOrDefault,
                    o = s.getHoverColor,
                    r = t._model;
                  (t.$previousStyle = {
                    backgroundColor: r.backgroundColor,
                    borderColor: r.borderColor,
                    borderWidth: r.borderWidth,
                  }),
                    (r.backgroundColor = n.hoverBackgroundColor
                      ? n.hoverBackgroundColor
                      : a(e.hoverBackgroundColor, i, o(r.backgroundColor))),
                    (r.borderColor = n.hoverBorderColor
                      ? n.hoverBorderColor
                      : a(e.hoverBorderColor, i, o(r.borderColor))),
                    (r.borderWidth = n.hoverBorderWidth
                      ? n.hoverBorderWidth
                      : a(e.hoverBorderWidth, i, r.borderWidth));
                },
                resyncElements: function () {
                  var t = this.getMeta(),
                    e = this.getDataset().data,
                    i = t.data.length,
                    n = e.length;
                  n < i
                    ? t.data.splice(n, i - n)
                    : i < n && this.insertElements(i, n - i);
                },
                insertElements: function (t, e) {
                  for (var i = 0; i < e; ++i) this.addElementAndReset(t + i);
                },
                onDataPush: function () {
                  this.insertElements(
                    this.getDataset().data.length - 1,
                    arguments.length
                  );
                },
                onDataPop: function () {
                  this.getMeta().data.pop();
                },
                onDataShift: function () {
                  this.getMeta().data.shift();
                },
                onDataSplice: function (t, e) {
                  this.getMeta().data.splice(t, e),
                    this.insertElements(t, arguments.length - 2);
                },
                onDataUnshift: function () {
                  this.insertElements(0, arguments.length);
                },
              }),
              (t.DatasetController.extend = s.inherits);
          };
        },
        { 46: 46 },
      ],
      26: [
        function (t, e, i) {
          'use strict';
          var n = t(46);
          e.exports = {
            _set: function (t, e) {
              return n.merge(this[t] || (this[t] = {}), e);
            },
          };
        },
        { 46: 46 },
      ],
      27: [
        function (t, e, i) {
          'use strict';
          var g = t(3),
            n = t(46);
          var a = function (t) {
            n.extend(this, t), this.initialize.apply(this, arguments);
          };
          n.extend(a.prototype, {
            initialize: function () {
              this.hidden = !1;
            },
            pivot: function () {
              var t = this;
              return (
                t._view || (t._view = n.clone(t._model)), (t._start = {}), t
              );
            },
            transition: function (t) {
              var e = this,
                i = e._model,
                n = e._start,
                a = e._view;
              return (
                i && 1 !== t
                  ? (a || (a = e._view = {}),
                    n || (n = e._start = {}),
                    (function (t, e, i, n) {
                      var a,
                        o,
                        r,
                        s,
                        l,
                        u,
                        d,
                        c,
                        h,
                        f = Object.keys(i);
                      for (a = 0, o = f.length; a < o; ++a)
                        if (
                          ((u = i[(r = f[a])]),
                          e.hasOwnProperty(r) || (e[r] = u),
                          (s = e[r]) !== u && '_' !== r[0])
                        ) {
                          if (
                            (t.hasOwnProperty(r) || (t[r] = s),
                            (d = typeof u) == typeof (l = t[r]))
                          )
                            if ('string' === d) {
                              if ((c = g(l)).valid && (h = g(u)).valid) {
                                e[r] = h.mix(c, n).rgbString();
                                continue;
                              }
                            } else if (
                              'number' === d &&
                              isFinite(l) &&
                              isFinite(u)
                            ) {
                              e[r] = l + (u - l) * n;
                              continue;
                            }
                          e[r] = u;
                        }
                    })(n, a, i, t))
                  : ((e._view = i), (e._start = null)),
                e
              );
            },
            tooltipPosition: function () {
              return { x: this._model.x, y: this._model.y };
            },
            hasValue: function () {
              return n.isNumber(this._model.x) && n.isNumber(this._model.y);
            },
          }),
            (a.extend = n.inherits),
            (e.exports = a);
        },
        { 3: 3, 46: 46 },
      ],
      28: [
        function (t, e, i) {
          'use strict';
          var n = t(3),
            a = t(26),
            g = t(46),
            l = t(34);
          e.exports = function () {
            function d(t, e, i) {
              var n;
              return (
                'string' == typeof t
                  ? ((n = parseInt(t, 10)),
                    -1 !== t.indexOf('%') && (n = (n / 100) * e.parentNode[i]))
                  : (n = t),
                n
              );
            }
            function c(t) {
              return null != t && 'none' !== t;
            }
            function e(t, e, i) {
              var n = document.defaultView,
                a = g._getParentNode(t),
                o = n.getComputedStyle(t)[e],
                r = n.getComputedStyle(a)[e],
                s = c(o),
                l = c(r),
                u = Number.POSITIVE_INFINITY;
              return s || l
                ? Math.min(s ? d(o, t, i) : u, l ? d(r, a, i) : u)
                : 'none';
            }
            (g.configMerge = function () {
              return g.merge(
                g.clone(arguments[0]),
                [].slice.call(arguments, 1),
                {
                  merger: function (t, e, i, n) {
                    var a = e[t] || {},
                      o = i[t];
                    'scales' === t
                      ? (e[t] = g.scaleMerge(a, o))
                      : 'scale' === t
                      ? (e[t] = g.merge(a, [l.getScaleDefaults(o.type), o]))
                      : g._merger(t, e, i, n);
                  },
                }
              );
            }),
              (g.scaleMerge = function () {
                return g.merge(
                  g.clone(arguments[0]),
                  [].slice.call(arguments, 1),
                  {
                    merger: function (t, e, i, n) {
                      if ('xAxes' === t || 'yAxes' === t) {
                        var a,
                          o,
                          r,
                          s = i[t].length;
                        for (e[t] || (e[t] = []), a = 0; a < s; ++a)
                          (r = i[t][a]),
                            (o = g.valueOrDefault(
                              r.type,
                              'xAxes' === t ? 'category' : 'linear'
                            )),
                            a >= e[t].length && e[t].push({}),
                            !e[t][a].type || (r.type && r.type !== e[t][a].type)
                              ? g.merge(e[t][a], [l.getScaleDefaults(o), r])
                              : g.merge(e[t][a], r);
                      } else g._merger(t, e, i, n);
                    },
                  }
                );
              }),
              (g.where = function (t, e) {
                if (g.isArray(t) && Array.prototype.filter) return t.filter(e);
                var i = [];
                return (
                  g.each(t, function (t) {
                    e(t) && i.push(t);
                  }),
                  i
                );
              }),
              (g.findIndex = Array.prototype.findIndex
                ? function (t, e, i) {
                    return t.findIndex(e, i);
                  }
                : function (t, e, i) {
                    i = void 0 === i ? t : i;
                    for (var n = 0, a = t.length; n < a; ++n)
                      if (e.call(i, t[n], n, t)) return n;
                    return -1;
                  }),
              (g.findNextWhere = function (t, e, i) {
                g.isNullOrUndef(i) && (i = -1);
                for (var n = i + 1; n < t.length; n++) {
                  var a = t[n];
                  if (e(a)) return a;
                }
              }),
              (g.findPreviousWhere = function (t, e, i) {
                g.isNullOrUndef(i) && (i = t.length);
                for (var n = i - 1; 0 <= n; n--) {
                  var a = t[n];
                  if (e(a)) return a;
                }
              }),
              (g.isNumber = function (t) {
                return !isNaN(parseFloat(t)) && isFinite(t);
              }),
              (g.almostEquals = function (t, e, i) {
                return Math.abs(t - e) < i;
              }),
              (g.almostWhole = function (t, e) {
                var i = Math.round(t);
                return i - e < t && t < i + e;
              }),
              (g.max = function (t) {
                return t.reduce(function (t, e) {
                  return isNaN(e) ? t : Math.max(t, e);
                }, Number.NEGATIVE_INFINITY);
              }),
              (g.min = function (t) {
                return t.reduce(function (t, e) {
                  return isNaN(e) ? t : Math.min(t, e);
                }, Number.POSITIVE_INFINITY);
              }),
              (g.sign = Math.sign
                ? function (t) {
                    return Math.sign(t);
                  }
                : function (t) {
                    return 0 === (t = +t) || isNaN(t) ? t : 0 < t ? 1 : -1;
                  }),
              (g.log10 = Math.log10
                ? function (t) {
                    return Math.log10(t);
                  }
                : function (t) {
                    var e = Math.log(t) * Math.LOG10E,
                      i = Math.round(e);
                    return t === Math.pow(10, i) ? i : e;
                  }),
              (g.toRadians = function (t) {
                return t * (Math.PI / 180);
              }),
              (g.toDegrees = function (t) {
                return t * (180 / Math.PI);
              }),
              (g.getAngleFromPoint = function (t, e) {
                var i = e.x - t.x,
                  n = e.y - t.y,
                  a = Math.sqrt(i * i + n * n),
                  o = Math.atan2(n, i);
                return (
                  o < -0.5 * Math.PI && (o += 2 * Math.PI),
                  { angle: o, distance: a }
                );
              }),
              (g.distanceBetweenPoints = function (t, e) {
                return Math.sqrt(
                  Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)
                );
              }),
              (g.aliasPixel = function (t) {
                return t % 2 == 0 ? 0 : 0.5;
              }),
              (g.splineCurve = function (t, e, i, n) {
                var a = t.skip ? e : t,
                  o = e,
                  r = i.skip ? e : i,
                  s = Math.sqrt(
                    Math.pow(o.x - a.x, 2) + Math.pow(o.y - a.y, 2)
                  ),
                  l = Math.sqrt(
                    Math.pow(r.x - o.x, 2) + Math.pow(r.y - o.y, 2)
                  ),
                  u = s / (s + l),
                  d = l / (s + l),
                  c = n * (u = isNaN(u) ? 0 : u),
                  h = n * (d = isNaN(d) ? 0 : d);
                return {
                  previous: {
                    x: o.x - c * (r.x - a.x),
                    y: o.y - c * (r.y - a.y),
                  },
                  next: { x: o.x + h * (r.x - a.x), y: o.y + h * (r.y - a.y) },
                };
              }),
              (g.EPSILON = Number.EPSILON || 1e-14),
              (g.splineCurveMonotone = function (t) {
                var e,
                  i,
                  n,
                  a,
                  o,
                  r,
                  s,
                  l,
                  u,
                  d = (t || []).map(function (t) {
                    return { model: t._model, deltaK: 0, mK: 0 };
                  }),
                  c = d.length;
                for (e = 0; e < c; ++e)
                  if (!(n = d[e]).model.skip) {
                    if (
                      ((i = 0 < e ? d[e - 1] : null),
                      (a = e < c - 1 ? d[e + 1] : null) && !a.model.skip)
                    ) {
                      var h = a.model.x - n.model.x;
                      n.deltaK = 0 !== h ? (a.model.y - n.model.y) / h : 0;
                    }
                    !i || i.model.skip
                      ? (n.mK = n.deltaK)
                      : !a || a.model.skip
                      ? (n.mK = i.deltaK)
                      : this.sign(i.deltaK) !== this.sign(n.deltaK)
                      ? (n.mK = 0)
                      : (n.mK = (i.deltaK + n.deltaK) / 2);
                  }
                for (e = 0; e < c - 1; ++e)
                  (n = d[e]),
                    (a = d[e + 1]),
                    n.model.skip ||
                      a.model.skip ||
                      (g.almostEquals(n.deltaK, 0, this.EPSILON)
                        ? (n.mK = a.mK = 0)
                        : ((o = n.mK / n.deltaK),
                          (r = a.mK / n.deltaK),
                          (l = Math.pow(o, 2) + Math.pow(r, 2)) <= 9 ||
                            ((s = 3 / Math.sqrt(l)),
                            (n.mK = o * s * n.deltaK),
                            (a.mK = r * s * n.deltaK))));
                for (e = 0; e < c; ++e)
                  (n = d[e]).model.skip ||
                    ((i = 0 < e ? d[e - 1] : null),
                    (a = e < c - 1 ? d[e + 1] : null),
                    i &&
                      !i.model.skip &&
                      ((u = (n.model.x - i.model.x) / 3),
                      (n.model.controlPointPreviousX = n.model.x - u),
                      (n.model.controlPointPreviousY = n.model.y - u * n.mK)),
                    a &&
                      !a.model.skip &&
                      ((u = (a.model.x - n.model.x) / 3),
                      (n.model.controlPointNextX = n.model.x + u),
                      (n.model.controlPointNextY = n.model.y + u * n.mK)));
              }),
              (g.nextItem = function (t, e, i) {
                return i
                  ? e >= t.length - 1
                    ? t[0]
                    : t[e + 1]
                  : e >= t.length - 1
                  ? t[t.length - 1]
                  : t[e + 1];
              }),
              (g.previousItem = function (t, e, i) {
                return i
                  ? e <= 0
                    ? t[t.length - 1]
                    : t[e - 1]
                  : e <= 0
                  ? t[0]
                  : t[e - 1];
              }),
              (g.niceNum = function (t, e) {
                var i = Math.floor(g.log10(t)),
                  n = t / Math.pow(10, i);
                return (
                  (e
                    ? n < 1.5
                      ? 1
                      : n < 3
                      ? 2
                      : n < 7
                      ? 5
                      : 10
                    : n <= 1
                    ? 1
                    : n <= 2
                    ? 2
                    : n <= 5
                    ? 5
                    : 10) * Math.pow(10, i)
                );
              }),
              (g.requestAnimFrame =
                'undefined' == typeof window
                  ? function (t) {
                      t();
                    }
                  : window.requestAnimationFrame ||
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    window.oRequestAnimationFrame ||
                    window.msRequestAnimationFrame ||
                    function (t) {
                      return window.setTimeout(t, 1e3 / 60);
                    }),
              (g.getRelativePosition = function (t, e) {
                var i,
                  n,
                  a = t.originalEvent || t,
                  o = t.target || t.srcElement,
                  r = o.getBoundingClientRect(),
                  s = a.touches;
                n =
                  s && 0 < s.length
                    ? ((i = s[0].clientX), s[0].clientY)
                    : ((i = a.clientX), a.clientY);
                var l = parseFloat(g.getStyle(o, 'padding-left')),
                  u = parseFloat(g.getStyle(o, 'padding-top')),
                  d = parseFloat(g.getStyle(o, 'padding-right')),
                  c = parseFloat(g.getStyle(o, 'padding-bottom')),
                  h = r.right - r.left - l - d,
                  f = r.bottom - r.top - u - c;
                return {
                  x: (i = Math.round(
                    (((i - r.left - l) / h) * o.width) /
                      e.currentDevicePixelRatio
                  )),
                  y: (n = Math.round(
                    (((n - r.top - u) / f) * o.height) /
                      e.currentDevicePixelRatio
                  )),
                };
              }),
              (g.getConstraintWidth = function (t) {
                return e(t, 'max-width', 'clientWidth');
              }),
              (g.getConstraintHeight = function (t) {
                return e(t, 'max-height', 'clientHeight');
              }),
              (g._calculatePadding = function (t, e, i) {
                return -1 < (e = g.getStyle(t, e)).indexOf('%')
                  ? i / parseInt(e, 10)
                  : parseInt(e, 10);
              }),
              (g._getParentNode = function (t) {
                var e = t.parentNode;
                return e && e.host && (e = e.host), e;
              }),
              (g.getMaximumWidth = function (t) {
                var e = g._getParentNode(t);
                if (!e) return t.clientWidth;
                var i = e.clientWidth,
                  n =
                    i -
                    g._calculatePadding(e, 'padding-left', i) -
                    g._calculatePadding(e, 'padding-right', i),
                  a = g.getConstraintWidth(t);
                return isNaN(a) ? n : Math.min(n, a);
              }),
              (g.getMaximumHeight = function (t) {
                var e = g._getParentNode(t);
                if (!e) return t.clientHeight;
                var i = e.clientHeight,
                  n =
                    i -
                    g._calculatePadding(e, 'padding-top', i) -
                    g._calculatePadding(e, 'padding-bottom', i),
                  a = g.getConstraintHeight(t);
                return isNaN(a) ? n : Math.min(n, a);
              }),
              (g.getStyle = function (t, e) {
                return t.currentStyle
                  ? t.currentStyle[e]
                  : document.defaultView
                      .getComputedStyle(t, null)
                      .getPropertyValue(e);
              }),
              (g.retinaScale = function (t, e) {
                var i = (t.currentDevicePixelRatio =
                  e ||
                  ('undefined' != typeof window && window.devicePixelRatio) ||
                  1);
                if (1 !== i) {
                  var n = t.canvas,
                    a = t.height,
                    o = t.width;
                  (n.height = a * i),
                    (n.width = o * i),
                    t.ctx.scale(i, i),
                    n.style.height ||
                      n.style.width ||
                      ((n.style.height = a + 'px'), (n.style.width = o + 'px'));
                }
              }),
              (g.fontString = function (t, e, i) {
                return e + ' ' + t + 'px ' + i;
              }),
              (g.longestText = function (e, t, i, n) {
                var a = ((n = n || {}).data = n.data || {}),
                  o = (n.garbageCollect = n.garbageCollect || []);
                n.font !== t &&
                  ((a = n.data = {}),
                  (o = n.garbageCollect = []),
                  (n.font = t)),
                  (e.font = t);
                var r = 0;
                g.each(i, function (t) {
                  null != t && !0 !== g.isArray(t)
                    ? (r = g.measureText(e, a, o, r, t))
                    : g.isArray(t) &&
                      g.each(t, function (t) {
                        null == t ||
                          g.isArray(t) ||
                          (r = g.measureText(e, a, o, r, t));
                      });
                });
                var s = o.length / 2;
                if (s > i.length) {
                  for (var l = 0; l < s; l++) delete a[o[l]];
                  o.splice(0, s);
                }
                return r;
              }),
              (g.measureText = function (t, e, i, n, a) {
                var o = e[a];
                return (
                  o || ((o = e[a] = t.measureText(a).width), i.push(a)),
                  n < o && (n = o),
                  n
                );
              }),
              (g.numberOfLabelLines = function (t) {
                var e = 1;
                return (
                  g.each(t, function (t) {
                    g.isArray(t) && t.length > e && (e = t.length);
                  }),
                  e
                );
              }),
              (g.color = n
                ? function (t) {
                    return (
                      t instanceof CanvasGradient &&
                        (t = a.global.defaultColor),
                      n(t)
                    );
                  }
                : function (t) {
                    return console.error('Color.js not found!'), t;
                  }),
              (g.getHoverColor = function (t) {
                return t instanceof CanvasPattern
                  ? t
                  : g.color(t).saturate(0.5).darken(0.1).rgbString();
              });
          };
        },
        { 26: 26, 3: 3, 34: 34, 46: 46 },
      ],
      29: [
        function (t, e, i) {
          'use strict';
          var n = t(46);
          function s(t, e) {
            return t.native ? { x: t.x, y: t.y } : n.getRelativePosition(t, e);
          }
          function l(t, e) {
            var i, n, a, o, r;
            for (n = 0, o = t.data.datasets.length; n < o; ++n)
              if (t.isDatasetVisible(n))
                for (
                  a = 0, r = (i = t.getDatasetMeta(n)).data.length;
                  a < r;
                  ++a
                ) {
                  var s = i.data[a];
                  s._view.skip || e(s);
                }
          }
          function u(t, e) {
            var i = [];
            return (
              l(t, function (t) {
                t.inRange(e.x, e.y) && i.push(t);
              }),
              i
            );
          }
          function d(t, n, a, o) {
            var r = Number.POSITIVE_INFINITY,
              s = [];
            return (
              l(t, function (t) {
                if (!a || t.inRange(n.x, n.y)) {
                  var e = t.getCenterPoint(),
                    i = o(n, e);
                  i < r ? ((s = [t]), (r = i)) : i === r && s.push(t);
                }
              }),
              s
            );
          }
          function c(t) {
            var a = -1 !== t.indexOf('x'),
              o = -1 !== t.indexOf('y');
            return function (t, e) {
              var i = a ? Math.abs(t.x - e.x) : 0,
                n = o ? Math.abs(t.y - e.y) : 0;
              return Math.sqrt(Math.pow(i, 2) + Math.pow(n, 2));
            };
          }
          function a(n, t, e) {
            var i = s(t, n);
            e.axis = e.axis || 'x';
            var a = c(e.axis),
              o = e.intersect ? u(n, i) : d(n, i, !1, a),
              r = [];
            return o.length
              ? (n.data.datasets.forEach(function (t, e) {
                  if (n.isDatasetVisible(e)) {
                    var i = n.getDatasetMeta(e).data[o[0]._index];
                    i && !i._view.skip && r.push(i);
                  }
                }),
                r)
              : [];
          }
          e.exports = {
            modes: {
              single: function (t, e) {
                var i = s(e, t),
                  n = [];
                return (
                  l(t, function (t) {
                    if (t.inRange(i.x, i.y)) return n.push(t), n;
                  }),
                  n.slice(0, 1)
                );
              },
              label: a,
              index: a,
              dataset: function (t, e, i) {
                var n = s(e, t);
                i.axis = i.axis || 'xy';
                var a = c(i.axis),
                  o = i.intersect ? u(t, n) : d(t, n, !1, a);
                return (
                  0 < o.length &&
                    (o = t.getDatasetMeta(o[0]._datasetIndex).data),
                  o
                );
              },
              'x-axis': function (t, e) {
                return a(t, e, { intersect: !1 });
              },
              point: function (t, e) {
                return u(t, s(e, t));
              },
              nearest: function (t, e, i) {
                var n = s(e, t);
                i.axis = i.axis || 'xy';
                var a = c(i.axis),
                  o = d(t, n, i.intersect, a);
                return (
                  1 < o.length &&
                    o.sort(function (t, e) {
                      var i = t.getArea() - e.getArea();
                      return (
                        0 === i && (i = t._datasetIndex - e._datasetIndex), i
                      );
                    }),
                  o.slice(0, 1)
                );
              },
              x: function (t, e, i) {
                var n = s(e, t),
                  a = [],
                  o = !1;
                return (
                  l(t, function (t) {
                    t.inXRange(n.x) && a.push(t),
                      t.inRange(n.x, n.y) && (o = !0);
                  }),
                  i.intersect && !o && (a = []),
                  a
                );
              },
              y: function (t, e, i) {
                var n = s(e, t),
                  a = [],
                  o = !1;
                return (
                  l(t, function (t) {
                    t.inYRange(n.y) && a.push(t),
                      t.inRange(n.x, n.y) && (o = !0);
                  }),
                  i.intersect && !o && (a = []),
                  a
                );
              },
            },
          };
        },
        { 46: 46 },
      ],
      30: [
        function (t, e, i) {
          'use strict';
          t(26)._set('global', {
            responsive: !0,
            responsiveAnimationDuration: 0,
            maintainAspectRatio: !0,
            events: [
              'mousemove',
              'mouseout',
              'click',
              'touchstart',
              'touchmove',
            ],
            hover: {
              onHover: null,
              mode: 'nearest',
              intersect: !0,
              animationDuration: 400,
            },
            onClick: null,
            defaultColor: 'rgba(0,0,0,0.1)',
            defaultFontColor: '#666',
            defaultFontFamily:
              "'Helvetica', 'Arial', sans-serif",
            defaultFontSize: 12,
            defaultFontStyle: 'normal',
            showLines: !0,
            elements: {},
            layout: { padding: { top: 0, right: 0, bottom: 0, left: 0 } },
          }),
            (e.exports = function () {
              var t = function (t, e) {
                return this.construct(t, e), this;
              };
              return (t.Chart = t);
            });
        },
        { 26: 26 },
      ],
      31: [
        function (t, e, i) {
          'use strict';
          var B = t(46);
          function W(t, e) {
            return B.where(t, function (t) {
              return t.position === e;
            });
          }
          function V(t, a) {
            t.forEach(function (t, e) {
              return (t._tmpIndex_ = e), t;
            }),
              t.sort(function (t, e) {
                var i = a ? e : t,
                  n = a ? t : e;
                return i.weight === n.weight
                  ? i._tmpIndex_ - n._tmpIndex_
                  : i.weight - n.weight;
              }),
              t.forEach(function (t) {
                delete t._tmpIndex_;
              });
          }
          e.exports = {
            defaults: {},
            addBox: function (t, e) {
              t.boxes || (t.boxes = []),
                (e.fullWidth = e.fullWidth || !1),
                (e.position = e.position || 'top'),
                (e.weight = e.weight || 0),
                t.boxes.push(e);
            },
            removeBox: function (t, e) {
              var i = t.boxes ? t.boxes.indexOf(e) : -1;
              -1 !== i && t.boxes.splice(i, 1);
            },
            configure: function (t, e, i) {
              for (
                var n,
                  a = ['fullWidth', 'position', 'weight'],
                  o = a.length,
                  r = 0;
                r < o;
                ++r
              )
                (n = a[r]), i.hasOwnProperty(n) && (e[n] = i[n]);
            },
            update: function (e, i, t) {
              if (e) {
                var n = e.options.layout || {},
                  a = B.options.toPadding(n.padding),
                  o = a.left,
                  r = a.right,
                  s = a.top,
                  l = a.bottom,
                  u = W(e.boxes, 'left'),
                  d = W(e.boxes, 'right'),
                  c = W(e.boxes, 'top'),
                  h = W(e.boxes, 'bottom'),
                  f = W(e.boxes, 'chartArea');
                V(u, !0), V(d, !1), V(c, !0), V(h, !1);
                var g = i - o - r,
                  p = t - s - l,
                  m = p / 2,
                  v = (i - g / 2) / (u.length + d.length),
                  b = (t - m) / (c.length + h.length),
                  x = g,
                  y = p,
                  k = [];
                B.each(u.concat(d, c, h), function (t) {
                  var e,
                    i = t.isHorizontal();
                  i
                    ? ((e = t.update(t.fullWidth ? g : x, b)), (y -= e.height))
                    : ((e = t.update(v, y)), (x -= e.width)),
                    k.push({ horizontal: i, minSize: e, box: t });
                });
                var M = 0,
                  w = 0,
                  C = 0,
                  S = 0;
                B.each(c.concat(h), function (t) {
                  if (t.getPadding) {
                    var e = t.getPadding();
                    (M = Math.max(M, e.left)), (w = Math.max(w, e.right));
                  }
                }),
                  B.each(u.concat(d), function (t) {
                    if (t.getPadding) {
                      var e = t.getPadding();
                      (C = Math.max(C, e.top)), (S = Math.max(S, e.bottom));
                    }
                  });
                var _ = o,
                  D = r,
                  P = s,
                  I = l;
                B.each(u.concat(d), z),
                  B.each(u, function (t) {
                    _ += t.width;
                  }),
                  B.each(d, function (t) {
                    D += t.width;
                  }),
                  B.each(c.concat(h), z),
                  B.each(c, function (t) {
                    P += t.height;
                  }),
                  B.each(h, function (t) {
                    I += t.height;
                  }),
                  B.each(u.concat(d), function (e) {
                    var t = B.findNextWhere(k, function (t) {
                        return t.box === e;
                      }),
                      i = { left: 0, right: 0, top: P, bottom: I };
                    t && e.update(t.minSize.width, y, i);
                  }),
                  (_ = o),
                  (D = r),
                  (P = s),
                  (I = l),
                  B.each(u, function (t) {
                    _ += t.width;
                  }),
                  B.each(d, function (t) {
                    D += t.width;
                  }),
                  B.each(c, function (t) {
                    P += t.height;
                  }),
                  B.each(h, function (t) {
                    I += t.height;
                  });
                var A = Math.max(M - _, 0);
                (_ += A), (D += Math.max(w - D, 0));
                var T = Math.max(C - P, 0);
                (P += T), (I += Math.max(S - I, 0));
                var F = t - P - I,
                  O = i - _ - D;
                (O === x && F === y) ||
                  (B.each(u, function (t) {
                    t.height = F;
                  }),
                  B.each(d, function (t) {
                    t.height = F;
                  }),
                  B.each(c, function (t) {
                    t.fullWidth || (t.width = O);
                  }),
                  B.each(h, function (t) {
                    t.fullWidth || (t.width = O);
                  }),
                  (y = F),
                  (x = O));
                var R = o + A,
                  L = s + T;
                B.each(u.concat(c), N),
                  (R += x),
                  (L += y),
                  B.each(d, N),
                  B.each(h, N),
                  (e.chartArea = {
                    left: _,
                    top: P,
                    right: _ + x,
                    bottom: P + y,
                  }),
                  B.each(f, function (t) {
                    (t.left = e.chartArea.left),
                      (t.top = e.chartArea.top),
                      (t.right = e.chartArea.right),
                      (t.bottom = e.chartArea.bottom),
                      t.update(x, y);
                  });
              }
              function z(e) {
                var t = B.findNextWhere(k, function (t) {
                  return t.box === e;
                });
                if (t)
                  if (e.isHorizontal()) {
                    var i = {
                      left: Math.max(_, M),
                      right: Math.max(D, w),
                      top: 0,
                      bottom: 0,
                    };
                    e.update(e.fullWidth ? g : x, p / 2, i);
                  } else e.update(t.minSize.width, y);
              }
              function N(t) {
                t.isHorizontal()
                  ? ((t.left = t.fullWidth ? o : _),
                    (t.right = t.fullWidth ? i - r : _ + x),
                    (t.top = L),
                    (t.bottom = L + t.height),
                    (L = t.bottom))
                  : ((t.left = R),
                    (t.right = R + t.width),
                    (t.top = P),
                    (t.bottom = P + y),
                    (R = t.right));
              }
            },
          };
        },
        { 46: 46 },
      ],
      32: [
        function (t, e, i) {
          'use strict';
          var r = t(26),
            s = t(46);
          r._set('global', { plugins: {} }),
            (e.exports = {
              _plugins: [],
              _cacheId: 0,
              register: function (t) {
                var e = this._plugins;
                [].concat(t).forEach(function (t) {
                  -1 === e.indexOf(t) && e.push(t);
                }),
                  this._cacheId++;
              },
              unregister: function (t) {
                var i = this._plugins;
                [].concat(t).forEach(function (t) {
                  var e = i.indexOf(t);
                  -1 !== e && i.splice(e, 1);
                }),
                  this._cacheId++;
              },
              clear: function () {
                (this._plugins = []), this._cacheId++;
              },
              count: function () {
                return this._plugins.length;
              },
              getAll: function () {
                return this._plugins;
              },
              notify: function (t, e, i) {
                var n,
                  a,
                  o,
                  r,
                  s,
                  l = this.descriptors(t),
                  u = l.length;
                for (n = 0; n < u; ++n)
                  if (
                    'function' == typeof (s = (o = (a = l[n]).plugin)[e]) &&
                    ((r = [t].concat(i || [])).push(a.options),
                    !1 === s.apply(o, r))
                  )
                    return !1;
                return !0;
              },
              descriptors: function (t) {
                var e = t.$plugins || (t.$plugins = {});
                if (e.id === this._cacheId) return e.descriptors;
                var n = [],
                  a = [],
                  i = (t && t.config) || {},
                  o = (i.options && i.options.plugins) || {};
                return (
                  this._plugins.concat(i.plugins || []).forEach(function (t) {
                    if (-1 === n.indexOf(t)) {
                      var e = t.id,
                        i = o[e];
                      !1 !== i &&
                        (!0 === i && (i = s.clone(r.global.plugins[e])),
                        n.push(t),
                        a.push({ plugin: t, options: i || {} }));
                    }
                  }),
                  (e.descriptors = a),
                  (e.id = this._cacheId),
                  a
                );
              },
              _invalidate: function (t) {
                delete t.$plugins;
              },
            });
        },
        { 26: 26, 46: 46 },
      ],
      33: [
        function (t, e, i) {
          'use strict';
          var y = t(26),
            n = t(27),
            H = t(46),
            a = t(35);
          function k(t) {
            var e,
              i,
              n = [];
            for (e = 0, i = t.length; e < i; ++e) n.push(t[e].label);
            return n;
          }
          function j(t, e, i) {
            var n = t.getPixelForTick(e);
            return (
              i &&
                (n -=
                  0 === e
                    ? (t.getPixelForTick(1) - n) / 2
                    : (n - t.getPixelForTick(e - 1)) / 2),
              n
            );
          }
          function M(t, e, i) {
            return H.isArray(e)
              ? H.longestText(t, i, e)
              : t.measureText(e).width;
          }
          function w(t) {
            var e = H.valueOrDefault,
              i = y.global,
              n = e(t.fontSize, i.defaultFontSize),
              a = e(t.fontStyle, i.defaultFontStyle),
              o = e(t.fontFamily, i.defaultFontFamily);
            return {
              size: n,
              style: a,
              family: o,
              font: H.fontString(n, a, o),
            };
          }
          function C(t) {
            return H.options.toLineHeight(
              H.valueOrDefault(t.lineHeight, 1.2),
              H.valueOrDefault(t.fontSize, y.global.defaultFontSize)
            );
          }
          y._set('scale', {
            display: !0,
            position: 'left',
            offset: !1,
            gridLines: {
              display: !0,
              color: 'rgba(0, 0, 0, 0.1)',
              lineWidth: 1,
              drawBorder: !0,
              drawOnChartArea: !0,
              drawTicks: !0,
              tickMarkLength: 10,
              zeroLineWidth: 1,
              zeroLineColor: 'rgba(0,0,0,0.25)',
              zeroLineBorderDash: [],
              zeroLineBorderDashOffset: 0,
              offsetGridLines: !1,
              borderDash: [],
              borderDashOffset: 0,
            },
            scaleLabel: {
              display: !1,
              labelString: '',
              lineHeight: 1.2,
              padding: { top: 4, bottom: 4 },
            },
            ticks: {
              beginAtZero: !1,
              minRotation: 0,
              maxRotation: 50,
              mirror: !1,
              padding: 0,
              reverse: !1,
              display: !0,
              autoSkip: !0,
              autoSkipPadding: 0,
              labelOffset: 0,
              callback: a.formatters.values,
              minor: {},
              major: {},
            },
          }),
            (e.exports = n.extend({
              getPadding: function () {
                return {
                  left: this.paddingLeft || 0,
                  top: this.paddingTop || 0,
                  right: this.paddingRight || 0,
                  bottom: this.paddingBottom || 0,
                };
              },
              getTicks: function () {
                return this._ticks;
              },
              mergeTicksOptions: function () {
                var t = this.options.ticks;
                for (var e in (!1 === t.minor && (t.minor = { display: !1 }),
                !1 === t.major && (t.major = { display: !1 }),
                t))
                  'major' !== e &&
                    'minor' !== e &&
                    (void 0 === t.minor[e] && (t.minor[e] = t[e]),
                    void 0 === t.major[e] && (t.major[e] = t[e]));
              },
              beforeUpdate: function () {
                H.callback(this.options.beforeUpdate, [this]);
              },
              update: function (t, e, i) {
                var n,
                  a,
                  o,
                  r,
                  s,
                  l,
                  u = this;
                for (
                  u.beforeUpdate(),
                    u.maxWidth = t,
                    u.maxHeight = e,
                    u.margins = H.extend(
                      { left: 0, right: 0, top: 0, bottom: 0 },
                      i
                    ),
                    u.longestTextCache = u.longestTextCache || {},
                    u.beforeSetDimensions(),
                    u.setDimensions(),
                    u.afterSetDimensions(),
                    u.beforeDataLimits(),
                    u.determineDataLimits(),
                    u.afterDataLimits(),
                    u.beforeBuildTicks(),
                    s = u.buildTicks() || [],
                    u.afterBuildTicks(),
                    u.beforeTickToLabelConversion(),
                    o = u.convertTicksToLabels(s) || u.ticks,
                    u.afterTickToLabelConversion(),
                    n = 0,
                    a = (u.ticks = o).length;
                  n < a;
                  ++n
                )
                  (r = o[n]),
                    (l = s[n])
                      ? (l.label = r)
                      : s.push((l = { label: r, major: !1 }));
                return (
                  (u._ticks = s),
                  u.beforeCalculateTickRotation(),
                  u.calculateTickRotation(),
                  u.afterCalculateTickRotation(),
                  u.beforeFit(),
                  u.fit(),
                  u.afterFit(),
                  u.afterUpdate(),
                  u.minSize
                );
              },
              afterUpdate: function () {
                H.callback(this.options.afterUpdate, [this]);
              },
              beforeSetDimensions: function () {
                H.callback(this.options.beforeSetDimensions, [this]);
              },
              setDimensions: function () {
                var t = this;
                t.isHorizontal()
                  ? ((t.width = t.maxWidth), (t.left = 0), (t.right = t.width))
                  : ((t.height = t.maxHeight),
                    (t.top = 0),
                    (t.bottom = t.height)),
                  (t.paddingLeft = 0),
                  (t.paddingTop = 0),
                  (t.paddingRight = 0),
                  (t.paddingBottom = 0);
              },
              afterSetDimensions: function () {
                H.callback(this.options.afterSetDimensions, [this]);
              },
              beforeDataLimits: function () {
                H.callback(this.options.beforeDataLimits, [this]);
              },
              determineDataLimits: H.noop,
              afterDataLimits: function () {
                H.callback(this.options.afterDataLimits, [this]);
              },
              beforeBuildTicks: function () {
                H.callback(this.options.beforeBuildTicks, [this]);
              },
              buildTicks: H.noop,
              afterBuildTicks: function () {
                H.callback(this.options.afterBuildTicks, [this]);
              },
              beforeTickToLabelConversion: function () {
                H.callback(this.options.beforeTickToLabelConversion, [this]);
              },
              convertTicksToLabels: function () {
                var t = this.options.ticks;
                this.ticks = this.ticks.map(t.userCallback || t.callback, this);
              },
              afterTickToLabelConversion: function () {
                H.callback(this.options.afterTickToLabelConversion, [this]);
              },
              beforeCalculateTickRotation: function () {
                H.callback(this.options.beforeCalculateTickRotation, [this]);
              },
              calculateTickRotation: function () {
                var t = this,
                  e = t.ctx,
                  i = t.options.ticks,
                  n = k(t._ticks),
                  a = w(i);
                e.font = a.font;
                var o = i.minRotation || 0;
                if (n.length && t.options.display && t.isHorizontal())
                  for (
                    var r,
                      s = H.longestText(e, a.font, n, t.longestTextCache),
                      l = s,
                      u = t.getPixelForTick(1) - t.getPixelForTick(0) - 6;
                    u < l && o < i.maxRotation;

                  ) {
                    var d = H.toRadians(o);
                    if (((r = Math.cos(d)), Math.sin(d) * s > t.maxHeight)) {
                      o--;
                      break;
                    }
                    o++, (l = r * s);
                  }
                t.labelRotation = o;
              },
              afterCalculateTickRotation: function () {
                H.callback(this.options.afterCalculateTickRotation, [this]);
              },
              beforeFit: function () {
                H.callback(this.options.beforeFit, [this]);
              },
              fit: function () {
                var t = this,
                  e = (t.minSize = { width: 0, height: 0 }),
                  i = k(t._ticks),
                  n = t.options,
                  a = n.ticks,
                  o = n.scaleLabel,
                  r = n.gridLines,
                  s = n.display,
                  l = t.isHorizontal(),
                  u = w(a),
                  d = n.gridLines.tickMarkLength;
                if (
                  ((e.width = l
                    ? t.isFullWidth()
                      ? t.maxWidth - t.margins.left - t.margins.right
                      : t.maxWidth
                    : s && r.drawTicks
                    ? d
                    : 0),
                  (e.height = l ? (s && r.drawTicks ? d : 0) : t.maxHeight),
                  o.display && s)
                ) {
                  var c = C(o) + H.options.toPadding(o.padding).height;
                  l ? (e.height += c) : (e.width += c);
                }
                if (a.display && s) {
                  var h = H.longestText(t.ctx, u.font, i, t.longestTextCache),
                    f = H.numberOfLabelLines(i),
                    g = 0.5 * u.size,
                    p = t.options.ticks.padding;
                  if (l) {
                    t.longestLabelWidth = h;
                    var m = H.toRadians(t.labelRotation),
                      v = Math.cos(m),
                      b = Math.sin(m) * h + u.size * f + g * (f - 1) + g;
                    (e.height = Math.min(t.maxHeight, e.height + b + p)),
                      (t.ctx.font = u.font);
                    var x = M(t.ctx, i[0], u.font),
                      y = M(t.ctx, i[i.length - 1], u.font);
                    0 !== t.labelRotation
                      ? ((t.paddingLeft =
                          'bottom' === n.position ? v * x + 3 : v * g + 3),
                        (t.paddingRight =
                          'bottom' === n.position ? v * g + 3 : v * y + 3))
                      : ((t.paddingLeft = x / 2 + 3),
                        (t.paddingRight = y / 2 + 3));
                  } else
                    a.mirror ? (h = 0) : (h += p + g),
                      (e.width = Math.min(t.maxWidth, e.width + h)),
                      (t.paddingTop = u.size / 2),
                      (t.paddingBottom = u.size / 2);
                }
                t.handleMargins(), (t.width = e.width), (t.height = e.height);
              },
              handleMargins: function () {
                var t = this;
                t.margins &&
                  ((t.paddingLeft = Math.max(
                    t.paddingLeft - t.margins.left,
                    0
                  )),
                  (t.paddingTop = Math.max(t.paddingTop - t.margins.top, 0)),
                  (t.paddingRight = Math.max(
                    t.paddingRight - t.margins.right,
                    0
                  )),
                  (t.paddingBottom = Math.max(
                    t.paddingBottom - t.margins.bottom,
                    0
                  )));
              },
              afterFit: function () {
                H.callback(this.options.afterFit, [this]);
              },
              isHorizontal: function () {
                return (
                  'top' === this.options.position ||
                  'bottom' === this.options.position
                );
              },
              isFullWidth: function () {
                return this.options.fullWidth;
              },
              getRightValue: function (t) {
                if (H.isNullOrUndef(t)) return NaN;
                if ('number' == typeof t && !isFinite(t)) return NaN;
                if (t)
                  if (this.isHorizontal()) {
                    if (void 0 !== t.x) return this.getRightValue(t.x);
                  } else if (void 0 !== t.y) return this.getRightValue(t.y);
                return t;
              },
              getLabelForIndex: H.noop,
              getPixelForValue: H.noop,
              getValueForPixel: H.noop,
              getPixelForTick: function (t) {
                var e = this,
                  i = e.options.offset;
                if (e.isHorizontal()) {
                  var n =
                      (e.width - (e.paddingLeft + e.paddingRight)) /
                      Math.max(e._ticks.length - (i ? 0 : 1), 1),
                    a = n * t + e.paddingLeft;
                  i && (a += n / 2);
                  var o = e.left + Math.round(a);
                  return (o += e.isFullWidth() ? e.margins.left : 0);
                }
                var r = e.height - (e.paddingTop + e.paddingBottom);
                return e.top + t * (r / (e._ticks.length - 1));
              },
              getPixelForDecimal: function (t) {
                var e = this;
                if (e.isHorizontal()) {
                  var i =
                      (e.width - (e.paddingLeft + e.paddingRight)) * t +
                      e.paddingLeft,
                    n = e.left + Math.round(i);
                  return (n += e.isFullWidth() ? e.margins.left : 0);
                }
                return e.top + t * e.height;
              },
              getBasePixel: function () {
                return this.getPixelForValue(this.getBaseValue());
              },
              getBaseValue: function () {
                var t = this.min,
                  e = this.max;
                return this.beginAtZero
                  ? 0
                  : t < 0 && e < 0
                  ? e
                  : 0 < t && 0 < e
                  ? t
                  : 0;
              },
              _autoSkip: function (t) {
                var e,
                  i,
                  n,
                  a,
                  o = this,
                  r = o.isHorizontal(),
                  s = o.options.ticks.minor,
                  l = t.length,
                  u = H.toRadians(o.labelRotation),
                  d = Math.cos(u),
                  c = o.longestLabelWidth * d,
                  h = [];
                for (
                  s.maxTicksLimit && (a = s.maxTicksLimit),
                    r &&
                      ((e = !1),
                      (c + s.autoSkipPadding) * l >
                        o.width - (o.paddingLeft + o.paddingRight) &&
                        (e =
                          1 +
                          Math.floor(
                            ((c + s.autoSkipPadding) * l) /
                              (o.width - (o.paddingLeft + o.paddingRight))
                          )),
                      a && a < l && (e = Math.max(e, Math.floor(l / a)))),
                    i = 0;
                  i < l;
                  i++
                )
                  (n = t[i]),
                    ((1 < e && 0 < i % e) || (i % e == 0 && l <= i + e)) &&
                      i !== l - 1 &&
                      delete n.label,
                    h.push(n);
                return h;
              },
              draw: function (S) {
                var _ = this,
                  D = _.options;
                if (D.display) {
                  var r = _.ctx,
                    P = y.global,
                    I = D.ticks.minor,
                    t = D.ticks.major || I,
                    A = D.gridLines,
                    e = D.scaleLabel,
                    T = 0 !== _.labelRotation,
                    F = _.isHorizontal(),
                    O = I.autoSkip ? _._autoSkip(_.getTicks()) : _.getTicks(),
                    s = H.valueOrDefault(I.fontColor, P.defaultFontColor),
                    l = w(I),
                    u = H.valueOrDefault(t.fontColor, P.defaultFontColor),
                    d = w(t),
                    R = A.drawTicks ? A.tickMarkLength : 0,
                    i = H.valueOrDefault(e.fontColor, P.defaultFontColor),
                    n = w(e),
                    a = H.options.toPadding(e.padding),
                    L = H.toRadians(_.labelRotation),
                    z = [],
                    N = _.options.gridLines.lineWidth,
                    B = 'right' === D.position ? _.left : _.right - N - R,
                    W = 'right' === D.position ? _.left + R : _.right,
                    V = 'bottom' === D.position ? _.top + N : _.bottom - R - N,
                    E = 'bottom' === D.position ? _.top + N + R : _.bottom + N;
                  if (
                    (H.each(O, function (t, e) {
                      if (!H.isNullOrUndef(t.label)) {
                        var i,
                          n,
                          a,
                          o,
                          r,
                          s,
                          l,
                          u,
                          d,
                          c,
                          h,
                          f,
                          g,
                          p,
                          m = t.label;
                        o =
                          e === _.zeroLineIndex &&
                          D.offset === A.offsetGridLines
                            ? ((i = A.zeroLineWidth),
                              (n = A.zeroLineColor),
                              (a = A.zeroLineBorderDash),
                              A.zeroLineBorderDashOffset)
                            : ((i = H.valueAtIndexOrDefault(A.lineWidth, e)),
                              (n = H.valueAtIndexOrDefault(A.color, e)),
                              (a = H.valueOrDefault(
                                A.borderDash,
                                P.borderDash
                              )),
                              H.valueOrDefault(
                                A.borderDashOffset,
                                P.borderDashOffset
                              ));
                        var v = 'middle',
                          b = 'middle',
                          x = I.padding;
                        if (F) {
                          var y = R + x;
                          p =
                            'bottom' === D.position
                              ? ((b = T ? 'middle' : 'top'),
                                (v = T ? 'right' : 'center'),
                                _.top + y)
                              : ((b = T ? 'middle' : 'bottom'),
                                (v = T ? 'left' : 'center'),
                                _.bottom - y);
                          var k = j(_, e, A.offsetGridLines && 1 < O.length);
                          k < _.left && (n = 'rgba(0,0,0,0)'),
                            (k += H.aliasPixel(i)),
                            (g = _.getPixelForTick(e) + I.labelOffset),
                            (r = l = d = h = k),
                            (s = V),
                            (u = E),
                            (c = S.top),
                            (f = S.bottom + N);
                        } else {
                          var M,
                            w = 'left' === D.position;
                          (M = I.mirror
                            ? ((v = w ? 'left' : 'right'), x)
                            : ((v = w ? 'right' : 'left'), R + x)),
                            (g = w ? _.right - M : _.left + M);
                          var C = j(_, e, A.offsetGridLines && 1 < O.length);
                          C < _.top && (n = 'rgba(0,0,0,0)'),
                            (C += H.aliasPixel(i)),
                            (p = _.getPixelForTick(e) + I.labelOffset),
                            (r = B),
                            (l = W),
                            (d = S.left),
                            (h = S.right + N),
                            (s = u = c = f = C);
                        }
                        z.push({
                          tx1: r,
                          ty1: s,
                          tx2: l,
                          ty2: u,
                          x1: d,
                          y1: c,
                          x2: h,
                          y2: f,
                          labelX: g,
                          labelY: p,
                          glWidth: i,
                          glColor: n,
                          glBorderDash: a,
                          glBorderDashOffset: o,
                          rotation: -1 * L,
                          label: m,
                          major: t.major,
                          textBaseline: b,
                          textAlign: v,
                        });
                      }
                    }),
                    H.each(z, function (t) {
                      if (
                        (A.display &&
                          (r.save(),
                          (r.lineWidth = t.glWidth),
                          (r.strokeStyle = t.glColor),
                          r.setLineDash &&
                            (r.setLineDash(t.glBorderDash),
                            (r.lineDashOffset = t.glBorderDashOffset)),
                          r.beginPath(),
                          A.drawTicks &&
                            (r.moveTo(t.tx1, t.ty1), r.lineTo(t.tx2, t.ty2)),
                          A.drawOnChartArea &&
                            (r.moveTo(t.x1, t.y1), r.lineTo(t.x2, t.y2)),
                          r.stroke(),
                          r.restore()),
                        I.display)
                      ) {
                        r.save(),
                          r.translate(t.labelX, t.labelY),
                          r.rotate(t.rotation),
                          (r.font = t.major ? d.font : l.font),
                          (r.fillStyle = t.major ? u : s),
                          (r.textBaseline = t.textBaseline),
                          (r.textAlign = t.textAlign);
                        var e = t.label;
                        if (H.isArray(e))
                          for (
                            var i = e.length,
                              n = 1.5 * l.size,
                              a = _.isHorizontal() ? 0 : (-n * (i - 1)) / 2,
                              o = 0;
                            o < i;
                            ++o
                          )
                            r.fillText('' + e[o], 0, a), (a += n);
                        else r.fillText(e, 0, 0);
                        r.restore();
                      }
                    }),
                    e.display)
                  ) {
                    var o,
                      c,
                      h = 0,
                      f = C(e) / 2;
                    if (F)
                      (o = _.left + (_.right - _.left) / 2),
                        (c =
                          'bottom' === D.position
                            ? _.bottom - f - a.bottom
                            : _.top + f + a.top);
                    else {
                      var g = 'left' === D.position;
                      (o = g ? _.left + f + a.top : _.right - f - a.top),
                        (c = _.top + (_.bottom - _.top) / 2),
                        (h = g ? -0.5 * Math.PI : 0.5 * Math.PI);
                    }
                    r.save(),
                      r.translate(o, c),
                      r.rotate(h),
                      (r.textAlign = 'center'),
                      (r.textBaseline = 'middle'),
                      (r.fillStyle = i),
                      (r.font = n.font),
                      r.fillText(e.labelString, 0, 0),
                      r.restore();
                  }
                  if (A.drawBorder) {
                    (r.lineWidth = H.valueAtIndexOrDefault(A.lineWidth, 0)),
                      (r.strokeStyle = H.valueAtIndexOrDefault(A.color, 0));
                    var p = _.left,
                      m = _.right + N,
                      v = _.top,
                      b = _.bottom + N,
                      x = H.aliasPixel(r.lineWidth);
                    F
                      ? ((v = b = 'top' === D.position ? _.bottom : _.top),
                        (v += x),
                        (b += x))
                      : ((p = m = 'left' === D.position ? _.right : _.left),
                        (p += x),
                        (m += x)),
                      r.beginPath(),
                      r.moveTo(p, v),
                      r.lineTo(m, b),
                      r.stroke();
                  }
                }
              },
            }));
        },
        { 26: 26, 27: 27, 35: 35, 46: 46 },
      ],
      34: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(46),
            o = t(31);
          e.exports = {
            constructors: {},
            defaults: {},
            registerScaleType: function (t, e, i) {
              (this.constructors[t] = e), (this.defaults[t] = a.clone(i));
            },
            getScaleConstructor: function (t) {
              return this.constructors.hasOwnProperty(t)
                ? this.constructors[t]
                : void 0;
            },
            getScaleDefaults: function (t) {
              return this.defaults.hasOwnProperty(t)
                ? a.merge({}, [n.scale, this.defaults[t]])
                : {};
            },
            updateScaleDefaults: function (t, e) {
              this.defaults.hasOwnProperty(t) &&
                (this.defaults[t] = a.extend(this.defaults[t], e));
            },
            addScalesToLayout: function (e) {
              a.each(e.scales, function (t) {
                (t.fullWidth = t.options.fullWidth),
                  (t.position = t.options.position),
                  (t.weight = t.options.weight),
                  o.addBox(e, t);
              });
            },
          };
        },
        { 26: 26, 31: 31, 46: 46 },
      ],
      35: [
        function (t, e, i) {
          'use strict';
          var l = t(46);
          e.exports = {
            formatters: {
              values: function (t) {
                return l.isArray(t) ? t : '' + t;
              },
              linear: function (t, e, i) {
                var n = 3 < i.length ? i[2] - i[1] : i[1] - i[0];
                1 < Math.abs(n) &&
                  t !== Math.floor(t) &&
                  (n = t - Math.floor(t));
                var a = l.log10(Math.abs(n)),
                  o = '';
                if (0 !== t)
                  if (
                    Math.max(Math.abs(i[0]), Math.abs(i[i.length - 1])) < 1e-4
                  ) {
                    var r = l.log10(Math.abs(t));
                    o = t.toExponential(Math.floor(r) - Math.floor(a));
                  } else {
                    var s = -1 * Math.floor(a);
                    (s = Math.max(Math.min(s, 20), 0)), (o = t.toFixed(s));
                  }
                else o = '0';
                return o;
              },
              logarithmic: function (t, e, i) {
                var n = t / Math.pow(10, Math.floor(l.log10(t)));
                return 0 === t
                  ? '0'
                  : 1 === n ||
                    2 === n ||
                    5 === n ||
                    0 === e ||
                    e === i.length - 1
                  ? t.toExponential()
                  : '';
              },
            },
          };
        },
        { 46: 46 },
      ],
      36: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(27),
            R = t(46);
          n._set('global', {
            tooltips: {
              enabled: !0,
              custom: null,
              mode: 'nearest',
              position: 'average',
              intersect: !0,
              backgroundColor: 'rgba(0,0,0,0.8)',
              titleFontStyle: 'bold',
              titleSpacing: 2,
              titleMarginBottom: 6,
              titleFontColor: '#fff',
              titleAlign: 'left',
              bodySpacing: 2,
              bodyFontColor: '#fff',
              bodyAlign: 'left',
              footerFontStyle: 'bold',
              footerSpacing: 2,
              footerMarginTop: 6,
              footerFontColor: '#fff',
              footerAlign: 'left',
              yPadding: 6,
              xPadding: 6,
              caretPadding: 2,
              caretSize: 5,
              cornerRadius: 6,
              multiKeyBackground: '#fff',
              displayColors: !0,
              borderColor: 'rgba(0,0,0,0)',
              borderWidth: 0,
              callbacks: {
                beforeTitle: R.noop,
                title: function (t, e) {
                  var i = '',
                    n = e.labels,
                    a = n ? n.length : 0;
                  if (0 < t.length) {
                    var o = t[0];
                    o.xLabel
                      ? (i = o.xLabel)
                      : 0 < a && o.index < a && (i = n[o.index]);
                  }
                  return i;
                },
                afterTitle: R.noop,
                beforeBody: R.noop,
                beforeLabel: R.noop,
                label: function (t, e) {
                  var i = e.datasets[t.datasetIndex].label || '';
                  return i && (i += ': '), (i += t.yLabel);
                },
                labelColor: function (t, e) {
                  var i = e.getDatasetMeta(t.datasetIndex).data[t.index]._view;
                  return {
                    borderColor: i.borderColor,
                    backgroundColor: i.backgroundColor,
                  };
                },
                labelTextColor: function () {
                  return this._options.bodyFontColor;
                },
                afterLabel: R.noop,
                afterBody: R.noop,
                beforeFooter: R.noop,
                footer: R.noop,
                afterFooter: R.noop,
              },
            },
          });
          var L = {
            average: function (t) {
              if (!t.length) return !1;
              var e,
                i,
                n = 0,
                a = 0,
                o = 0;
              for (e = 0, i = t.length; e < i; ++e) {
                var r = t[e];
                if (r && r.hasValue()) {
                  var s = r.tooltipPosition();
                  (n += s.x), (a += s.y), ++o;
                }
              }
              return { x: Math.round(n / o), y: Math.round(a / o) };
            },
            nearest: function (t, e) {
              var i,
                n,
                a,
                o = e.x,
                r = e.y,
                s = Number.POSITIVE_INFINITY;
              for (i = 0, n = t.length; i < n; ++i) {
                var l = t[i];
                if (l && l.hasValue()) {
                  var u = l.getCenterPoint(),
                    d = R.distanceBetweenPoints(e, u);
                  d < s && ((s = d), (a = l));
                }
              }
              if (a) {
                var c = a.tooltipPosition();
                (o = c.x), (r = c.y);
              }
              return { x: o, y: r };
            },
          };
          function h(t, e) {
            var i = R.color(t);
            return i.alpha(e * i.alpha()).rgbaString();
          }
          function r(t, e) {
            return (
              e &&
                (R.isArray(e) ? Array.prototype.push.apply(t, e) : t.push(e)),
              t
            );
          }
          function s(t) {
            return ('string' == typeof t || t instanceof String) &&
              -1 < t.indexOf('\n')
              ? t.split('\n')
              : t;
          }
          function z(t) {
            var e = n.global,
              i = R.valueOrDefault;
            return {
              xPadding: t.xPadding,
              yPadding: t.yPadding,
              xAlign: t.xAlign,
              yAlign: t.yAlign,
              bodyFontColor: t.bodyFontColor,
              _bodyFontFamily: i(t.bodyFontFamily, e.defaultFontFamily),
              _bodyFontStyle: i(t.bodyFontStyle, e.defaultFontStyle),
              _bodyAlign: t.bodyAlign,
              bodyFontSize: i(t.bodyFontSize, e.defaultFontSize),
              bodySpacing: t.bodySpacing,
              titleFontColor: t.titleFontColor,
              _titleFontFamily: i(t.titleFontFamily, e.defaultFontFamily),
              _titleFontStyle: i(t.titleFontStyle, e.defaultFontStyle),
              titleFontSize: i(t.titleFontSize, e.defaultFontSize),
              _titleAlign: t.titleAlign,
              titleSpacing: t.titleSpacing,
              titleMarginBottom: t.titleMarginBottom,
              footerFontColor: t.footerFontColor,
              _footerFontFamily: i(t.footerFontFamily, e.defaultFontFamily),
              _footerFontStyle: i(t.footerFontStyle, e.defaultFontStyle),
              footerFontSize: i(t.footerFontSize, e.defaultFontSize),
              _footerAlign: t.footerAlign,
              footerSpacing: t.footerSpacing,
              footerMarginTop: t.footerMarginTop,
              caretSize: t.caretSize,
              cornerRadius: t.cornerRadius,
              backgroundColor: t.backgroundColor,
              opacity: 0,
              legendColorBackground: t.multiKeyBackground,
              displayColors: t.displayColors,
              borderColor: t.borderColor,
              borderWidth: t.borderWidth,
            };
          }
          function o(t) {
            return r([], s(t));
          }
          (e.exports = a.extend({
            initialize: function () {
              (this._model = z(this._options)), (this._lastActive = []);
            },
            getTitle: function () {
              var t = this._options.callbacks,
                e = t.beforeTitle.apply(this, arguments),
                i = t.title.apply(this, arguments),
                n = t.afterTitle.apply(this, arguments),
                a = [];
              return (a = r((a = r((a = r(a, s(e))), s(i))), s(n)));
            },
            getBeforeBody: function () {
              return o(
                this._options.callbacks.beforeBody.apply(this, arguments)
              );
            },
            getBody: function (t, i) {
              var n = this,
                a = n._options.callbacks,
                o = [];
              return (
                R.each(t, function (t) {
                  var e = { before: [], lines: [], after: [] };
                  r(e.before, s(a.beforeLabel.call(n, t, i))),
                    r(e.lines, a.label.call(n, t, i)),
                    r(e.after, s(a.afterLabel.call(n, t, i))),
                    o.push(e);
                }),
                o
              );
            },
            getAfterBody: function () {
              return o(
                this._options.callbacks.afterBody.apply(this, arguments)
              );
            },
            getFooter: function () {
              var t = this._options.callbacks,
                e = t.beforeFooter.apply(this, arguments),
                i = t.footer.apply(this, arguments),
                n = t.afterFooter.apply(this, arguments),
                a = [];
              return (a = r((a = r((a = r(a, s(e))), s(i))), s(n)));
            },
            update: function (t) {
              var e,
                i,
                n,
                a,
                o,
                r,
                s,
                l,
                u,
                d,
                c,
                h,
                f,
                g,
                p,
                m,
                v,
                b,
                x,
                y,
                k = this,
                M = k._options,
                w = k._model,
                C = (k._model = z(M)),
                S = k._active,
                _ = k._data,
                D = { xAlign: w.xAlign, yAlign: w.yAlign },
                P = { x: w.x, y: w.y },
                I = { width: w.width, height: w.height },
                A = { x: w.caretX, y: w.caretY };
              if (S.length) {
                C.opacity = 1;
                var T = [],
                  F = [];
                A = L[M.position].call(k, S, k._eventPosition);
                var O = [];
                for (e = 0, i = S.length; e < i; ++e)
                  O.push(
                    ((m = S[e]),
                    (b = v = void 0),
                    (v = m._xScale),
                    (b = m._yScale || m._scale),
                    (x = m._index),
                    (y = m._datasetIndex),
                    {
                      xLabel: v ? v.getLabelForIndex(x, y) : '',
                      yLabel: b ? b.getLabelForIndex(x, y) : '',
                      index: x,
                      datasetIndex: y,
                      x: m._model.x,
                      y: m._model.y,
                    })
                  );
                M.filter &&
                  (O = O.filter(function (t) {
                    return M.filter(t, _);
                  })),
                  M.itemSort &&
                    (O = O.sort(function (t, e) {
                      return M.itemSort(t, e, _);
                    })),
                  R.each(O, function (t) {
                    T.push(M.callbacks.labelColor.call(k, t, k._chart)),
                      F.push(M.callbacks.labelTextColor.call(k, t, k._chart));
                  }),
                  (C.title = k.getTitle(O, _)),
                  (C.beforeBody = k.getBeforeBody(O, _)),
                  (C.body = k.getBody(O, _)),
                  (C.afterBody = k.getAfterBody(O, _)),
                  (C.footer = k.getFooter(O, _)),
                  (C.x = Math.round(A.x)),
                  (C.y = Math.round(A.y)),
                  (C.caretPadding = M.caretPadding),
                  (C.labelColors = T),
                  (C.labelTextColors = F),
                  (C.dataPoints = O),
                  (D = (function (t, e) {
                    var i,
                      n,
                      a,
                      o,
                      r,
                      s = t._model,
                      l = t._chart,
                      u = t._chart.chartArea,
                      d = 'center',
                      c = 'center';
                    s.y < e.height
                      ? (c = 'top')
                      : s.y > l.height - e.height && (c = 'bottom');
                    var h = (u.left + u.right) / 2,
                      f = (u.top + u.bottom) / 2;
                    (n =
                      'center' === c
                        ? ((i = function (t) {
                            return t <= h;
                          }),
                          function (t) {
                            return h < t;
                          })
                        : ((i = function (t) {
                            return t <= e.width / 2;
                          }),
                          function (t) {
                            return t >= l.width - e.width / 2;
                          })),
                      (a = function (t) {
                        return (
                          t + e.width + s.caretSize + s.caretPadding > l.width
                        );
                      }),
                      (o = function (t) {
                        return t - e.width - s.caretSize - s.caretPadding < 0;
                      }),
                      (r = function (t) {
                        return t <= f ? 'top' : 'bottom';
                      }),
                      i(s.x)
                        ? ((d = 'left'),
                          a(s.x) && ((d = 'center'), (c = r(s.y))))
                        : n(s.x) &&
                          ((d = 'right'),
                          o(s.x) && ((d = 'center'), (c = r(s.y))));
                    var g = t._options;
                    return {
                      xAlign: g.xAlign ? g.xAlign : d,
                      yAlign: g.yAlign ? g.yAlign : c,
                    };
                  })(
                    this,
                    (I = (function (t, e) {
                      var i = t._chart.ctx,
                        n = 2 * e.yPadding,
                        a = 0,
                        o = e.body,
                        r = o.reduce(function (t, e) {
                          return (
                            t +
                            e.before.length +
                            e.lines.length +
                            e.after.length
                          );
                        }, 0);
                      r += e.beforeBody.length + e.afterBody.length;
                      var s = e.title.length,
                        l = e.footer.length,
                        u = e.titleFontSize,
                        d = e.bodyFontSize,
                        c = e.footerFontSize;
                      (n += s * u),
                        (n += s ? (s - 1) * e.titleSpacing : 0),
                        (n += s ? e.titleMarginBottom : 0),
                        (n += r * d),
                        (n += r ? (r - 1) * e.bodySpacing : 0),
                        (n += l ? e.footerMarginTop : 0),
                        (n += l * c),
                        (n += l ? (l - 1) * e.footerSpacing : 0);
                      var h = 0,
                        f = function (t) {
                          a = Math.max(a, i.measureText(t).width + h);
                        };
                      return (
                        (i.font = R.fontString(
                          u,
                          e._titleFontStyle,
                          e._titleFontFamily
                        )),
                        R.each(e.title, f),
                        (i.font = R.fontString(
                          d,
                          e._bodyFontStyle,
                          e._bodyFontFamily
                        )),
                        R.each(e.beforeBody.concat(e.afterBody), f),
                        (h = e.displayColors ? d + 2 : 0),
                        R.each(o, function (t) {
                          R.each(t.before, f),
                            R.each(t.lines, f),
                            R.each(t.after, f);
                        }),
                        (h = 0),
                        (i.font = R.fontString(
                          c,
                          e._footerFontStyle,
                          e._footerFontFamily
                        )),
                        R.each(e.footer, f),
                        { width: (a += 2 * e.xPadding), height: n }
                      );
                    })(this, C))
                  )),
                  (n = C),
                  (a = I),
                  (o = D),
                  (r = k._chart),
                  (s = n.x),
                  (l = n.y),
                  (u = n.caretSize),
                  (d = n.caretPadding),
                  (c = n.cornerRadius),
                  (h = o.xAlign),
                  (f = o.yAlign),
                  (g = u + d),
                  (p = c + d),
                  'right' === h
                    ? (s -= a.width)
                    : 'center' === h &&
                      ((s -= a.width / 2) + a.width > r.width &&
                        (s = r.width - a.width),
                      s < 0 && (s = 0)),
                  'top' === f
                    ? (l += g)
                    : (l -= 'bottom' === f ? a.height + g : a.height / 2),
                  'center' === f
                    ? 'left' === h
                      ? (s += g)
                      : 'right' === h && (s -= g)
                    : 'left' === h
                    ? (s -= p)
                    : 'right' === h && (s += p),
                  (P = { x: s, y: l });
              } else C.opacity = 0;
              return (
                (C.xAlign = D.xAlign),
                (C.yAlign = D.yAlign),
                (C.x = P.x),
                (C.y = P.y),
                (C.width = I.width),
                (C.height = I.height),
                (C.caretX = A.x),
                (C.caretY = A.y),
                (k._model = C),
                t && M.custom && M.custom.call(k, C),
                k
              );
            },
            drawCaret: function (t, e) {
              var i = this._chart.ctx,
                n = this._view,
                a = this.getCaretPosition(t, e, n);
              i.lineTo(a.x1, a.y1), i.lineTo(a.x2, a.y2), i.lineTo(a.x3, a.y3);
            },
            getCaretPosition: function (t, e, i) {
              var n,
                a,
                o,
                r,
                s,
                l,
                u = i.caretSize,
                d = i.cornerRadius,
                c = i.xAlign,
                h = i.yAlign,
                f = t.x,
                g = t.y,
                p = e.width,
                m = e.height;
              if ('center' === h)
                (s = g + m / 2),
                  (l =
                    'left' === c
                      ? ((a = (n = f) - u), (o = n), (r = s + u), s - u)
                      : ((a = (n = f + p) + u), (o = n), (r = s - u), s + u));
              else if (
                ((o =
                  ((n =
                    'left' === c
                      ? (a = f + d + u) - u
                      : 'right' === c
                      ? (a = f + p - d - u) - u
                      : (a = i.caretX) - u),
                  a + u)),
                'top' === h)
              )
                (s = (r = g) - u), (l = r);
              else {
                (s = (r = g + m) + u), (l = r);
                var v = o;
                (o = n), (n = v);
              }
              return { x1: n, x2: a, x3: o, y1: r, y2: s, y3: l };
            },
            drawTitle: function (t, e, i, n) {
              var a = e.title;
              if (a.length) {
                (i.textAlign = e._titleAlign), (i.textBaseline = 'top');
                var o,
                  r,
                  s = e.titleFontSize,
                  l = e.titleSpacing;
                for (
                  i.fillStyle = h(e.titleFontColor, n),
                    i.font = R.fontString(
                      s,
                      e._titleFontStyle,
                      e._titleFontFamily
                    ),
                    o = 0,
                    r = a.length;
                  o < r;
                  ++o
                )
                  i.fillText(a[o], t.x, t.y),
                    (t.y += s + l),
                    o + 1 === a.length && (t.y += e.titleMarginBottom - l);
              }
            },
            drawBody: function (n, a, o, r) {
              var s = a.bodyFontSize,
                e = a.bodySpacing,
                t = a.body;
              (o.textAlign = a._bodyAlign),
                (o.textBaseline = 'top'),
                (o.font = R.fontString(s, a._bodyFontStyle, a._bodyFontFamily));
              var i = 0,
                l = function (t) {
                  o.fillText(t, n.x + i, n.y), (n.y += s + e);
                };
              (o.fillStyle = h(a.bodyFontColor, r)), R.each(a.beforeBody, l);
              var u = a.displayColors;
              (i = u ? s + 2 : 0),
                R.each(t, function (t, e) {
                  var i = h(a.labelTextColors[e], r);
                  (o.fillStyle = i),
                    R.each(t.before, l),
                    R.each(t.lines, function (t) {
                      u &&
                        ((o.fillStyle = h(a.legendColorBackground, r)),
                        o.fillRect(n.x, n.y, s, s),
                        (o.lineWidth = 1),
                        (o.strokeStyle = h(a.labelColors[e].borderColor, r)),
                        o.strokeRect(n.x, n.y, s, s),
                        (o.fillStyle = h(a.labelColors[e].backgroundColor, r)),
                        o.fillRect(n.x + 1, n.y + 1, s - 2, s - 2),
                        (o.fillStyle = i)),
                        l(t);
                    }),
                    R.each(t.after, l);
                }),
                (i = 0),
                R.each(a.afterBody, l),
                (n.y -= e);
            },
            drawFooter: function (e, i, n, t) {
              var a = i.footer;
              a.length &&
                ((e.y += i.footerMarginTop),
                (n.textAlign = i._footerAlign),
                (n.textBaseline = 'top'),
                (n.fillStyle = h(i.footerFontColor, t)),
                (n.font = R.fontString(
                  i.footerFontSize,
                  i._footerFontStyle,
                  i._footerFontFamily
                )),
                R.each(a, function (t) {
                  n.fillText(t, e.x, e.y),
                    (e.y += i.footerFontSize + i.footerSpacing);
                }));
            },
            drawBackground: function (t, e, i, n, a) {
              (i.fillStyle = h(e.backgroundColor, a)),
                (i.strokeStyle = h(e.borderColor, a)),
                (i.lineWidth = e.borderWidth);
              var o = e.xAlign,
                r = e.yAlign,
                s = t.x,
                l = t.y,
                u = n.width,
                d = n.height,
                c = e.cornerRadius;
              i.beginPath(),
                i.moveTo(s + c, l),
                'top' === r && this.drawCaret(t, n),
                i.lineTo(s + u - c, l),
                i.quadraticCurveTo(s + u, l, s + u, l + c),
                'center' === r && 'right' === o && this.drawCaret(t, n),
                i.lineTo(s + u, l + d - c),
                i.quadraticCurveTo(s + u, l + d, s + u - c, l + d),
                'bottom' === r && this.drawCaret(t, n),
                i.lineTo(s + c, l + d),
                i.quadraticCurveTo(s, l + d, s, l + d - c),
                'center' === r && 'left' === o && this.drawCaret(t, n),
                i.lineTo(s, l + c),
                i.quadraticCurveTo(s, l, s + c, l),
                i.closePath(),
                i.fill(),
                0 < e.borderWidth && i.stroke();
            },
            draw: function () {
              var t = this._chart.ctx,
                e = this._view;
              if (0 !== e.opacity) {
                var i = { width: e.width, height: e.height },
                  n = { x: e.x, y: e.y },
                  a = Math.abs(e.opacity < 0.001) ? 0 : e.opacity,
                  o =
                    e.title.length ||
                    e.beforeBody.length ||
                    e.body.length ||
                    e.afterBody.length ||
                    e.footer.length;
                this._options.enabled &&
                  o &&
                  (this.drawBackground(n, e, t, i, a),
                  (n.x += e.xPadding),
                  (n.y += e.yPadding),
                  this.drawTitle(n, e, t, a),
                  this.drawBody(n, e, t, a),
                  this.drawFooter(n, e, t, a));
              }
            },
            handleEvent: function (t) {
              var e,
                i = this,
                n = i._options;
              return (
                (i._lastActive = i._lastActive || []),
                'mouseout' === t.type
                  ? (i._active = [])
                  : (i._active = i._chart.getElementsAtEventForMode(
                      t,
                      n.mode,
                      n
                    )),
                (e = !R.arrayEquals(i._active, i._lastActive)) &&
                  ((i._lastActive = i._active),
                  (n.enabled || n.custom) &&
                    ((i._eventPosition = { x: t.x, y: t.y }),
                    i.update(!0),
                    i.pivot())),
                e
              );
            },
          })).positioners = L;
        },
        { 26: 26, 27: 27, 46: 46 },
      ],
      37: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(27),
            d = t(46);
          n._set('global', {
            elements: {
              arc: {
                backgroundColor: n.global.defaultColor,
                borderColor: '#fff',
                borderWidth: 2,
              },
            },
          }),
            (e.exports = a.extend({
              inLabelRange: function (t) {
                var e = this._view;
                return (
                  !!e &&
                  Math.pow(t - e.x, 2) < Math.pow(e.radius + e.hoverRadius, 2)
                );
              },
              inRange: function (t, e) {
                var i = this._view;
                if (i) {
                  for (
                    var n = d.getAngleFromPoint(i, { x: t, y: e }),
                      a = n.angle,
                      o = n.distance,
                      r = i.startAngle,
                      s = i.endAngle;
                    s < r;

                  )
                    s += 2 * Math.PI;
                  for (; s < a; ) a -= 2 * Math.PI;
                  for (; a < r; ) a += 2 * Math.PI;
                  var l = r <= a && a <= s,
                    u = o >= i.innerRadius && o <= i.outerRadius;
                  return l && u;
                }
                return !1;
              },
              getCenterPoint: function () {
                var t = this._view,
                  e = (t.startAngle + t.endAngle) / 2,
                  i = (t.innerRadius + t.outerRadius) / 2;
                return { x: t.x + Math.cos(e) * i, y: t.y + Math.sin(e) * i };
              },
              getArea: function () {
                var t = this._view;
                return (
                  Math.PI *
                  ((t.endAngle - t.startAngle) / (2 * Math.PI)) *
                  (Math.pow(t.outerRadius, 2) - Math.pow(t.innerRadius, 2))
                );
              },
              tooltipPosition: function () {
                var t = this._view,
                  e = t.startAngle + (t.endAngle - t.startAngle) / 2,
                  i = (t.outerRadius - t.innerRadius) / 2 + t.innerRadius;
                return { x: t.x + Math.cos(e) * i, y: t.y + Math.sin(e) * i };
              },
              draw: function () {
                var t = this._chart.ctx,
                  e = this._view,
                  i = e.startAngle,
                  n = e.endAngle;
                t.beginPath(),
                  t.arc(e.x, e.y, e.outerRadius, i, n),
                  t.arc(e.x, e.y, e.innerRadius, n, i, !0),
                  t.closePath(),
                  (t.strokeStyle = e.borderColor),
                  (t.lineWidth = e.borderWidth),
                  (t.fillStyle = e.backgroundColor),
                  t.fill(),
                  (t.lineJoin = 'bevel'),
                  e.borderWidth && t.stroke();
              },
            }));
        },
        { 26: 26, 27: 27, 46: 46 },
      ],
      38: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(27),
            d = t(46),
            c = n.global;
          n._set('global', {
            elements: {
              line: {
                tension: 0.4,
                backgroundColor: c.defaultColor,
                borderWidth: 3,
                borderColor: c.defaultColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: 'miter',
                capBezierPoints: !0,
                fill: !0,
              },
            },
          }),
            (e.exports = a.extend({
              draw: function () {
                var t,
                  e,
                  i,
                  n,
                  a = this._view,
                  o = this._chart.ctx,
                  r = a.spanGaps,
                  s = this._children.slice(),
                  l = c.elements.line,
                  u = -1;
                for (
                  this._loop && s.length && s.push(s[0]),
                    o.save(),
                    o.lineCap = a.borderCapStyle || l.borderCapStyle,
                    o.setLineDash &&
                      o.setLineDash(a.borderDash || l.borderDash),
                    o.lineDashOffset = a.borderDashOffset || l.borderDashOffset,
                    o.lineJoin = a.borderJoinStyle || l.borderJoinStyle,
                    o.lineWidth = a.borderWidth || l.borderWidth,
                    o.strokeStyle = a.borderColor || c.defaultColor,
                    o.beginPath(),
                    u = -1,
                    t = 0;
                  t < s.length;
                  ++t
                )
                  (e = s[t]),
                    (i = d.previousItem(s, t)),
                    (n = e._view),
                    0 === t
                      ? n.skip || (o.moveTo(n.x, n.y), (u = t))
                      : ((i = -1 === u ? i : s[u]),
                        n.skip ||
                          ((u !== t - 1 && !r) || -1 === u
                            ? o.moveTo(n.x, n.y)
                            : d.canvas.lineTo(o, i._view, e._view),
                          (u = t)));
                o.stroke(), o.restore();
              },
            }));
        },
        { 26: 26, 27: 27, 46: 46 },
      ],
      39: [
        function (t, e, i) {
          'use strict';
          var u = t(26),
            n = t(27),
            d = t(46),
            c = u.global.defaultColor;
          function a(t) {
            var e = this._view;
            return !!e && Math.abs(t - e.x) < e.radius + e.hitRadius;
          }
          u._set('global', {
            elements: {
              point: {
                radius: 3,
                pointStyle: 'circle',
                backgroundColor: c,
                borderColor: c,
                borderWidth: 1,
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1,
              },
            },
          }),
            (e.exports = n.extend({
              inRange: function (t, e) {
                var i = this._view;
                return (
                  !!i &&
                  Math.pow(t - i.x, 2) + Math.pow(e - i.y, 2) <
                    Math.pow(i.hitRadius + i.radius, 2)
                );
              },
              inLabelRange: a,
              inXRange: a,
              inYRange: function (t) {
                var e = this._view;
                return !!e && Math.abs(t - e.y) < e.radius + e.hitRadius;
              },
              getCenterPoint: function () {
                var t = this._view;
                return { x: t.x, y: t.y };
              },
              getArea: function () {
                return Math.PI * Math.pow(this._view.radius, 2);
              },
              tooltipPosition: function () {
                var t = this._view;
                return { x: t.x, y: t.y, padding: t.radius + t.borderWidth };
              },
              draw: function (t) {
                var e = this._view,
                  i = this._model,
                  n = this._chart.ctx,
                  a = e.pointStyle,
                  o = e.rotation,
                  r = e.radius,
                  s = e.x,
                  l = e.y;
                e.skip ||
                  ((void 0 === t ||
                    (i.x >= t.left &&
                      1.01 * t.right >= i.x &&
                      i.y >= t.top &&
                      1.01 * t.bottom >= i.y)) &&
                    ((n.strokeStyle = e.borderColor || c),
                    (n.lineWidth = d.valueOrDefault(
                      e.borderWidth,
                      u.global.elements.point.borderWidth
                    )),
                    (n.fillStyle = e.backgroundColor || c),
                    d.canvas.drawPoint(n, a, r, s, l, o)));
              },
            }));
        },
        { 26: 26, 27: 27, 46: 46 },
      ],
      40: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            a = t(27);
          function l(t) {
            return void 0 !== t._view.width;
          }
          function o(t) {
            var e,
              i,
              n,
              a,
              o = t._view;
            if (l(t)) {
              var r = o.width / 2;
              (e = o.x - r),
                (i = o.x + r),
                (n = Math.min(o.y, o.base)),
                (a = Math.max(o.y, o.base));
            } else {
              var s = o.height / 2;
              (e = Math.min(o.x, o.base)),
                (i = Math.max(o.x, o.base)),
                (n = o.y - s),
                (a = o.y + s);
            }
            return { left: e, top: n, right: i, bottom: a };
          }
          n._set('global', {
            elements: {
              rectangle: {
                backgroundColor: n.global.defaultColor,
                borderColor: n.global.defaultColor,
                borderSkipped: 'bottom',
                borderWidth: 0,
              },
            },
          }),
            (e.exports = a.extend({
              draw: function () {
                var t,
                  e,
                  i,
                  n,
                  a,
                  o,
                  r,
                  s = this._chart.ctx,
                  l = this._view,
                  u = l.borderWidth;
                if (
                  ((r = l.horizontal
                    ? ((t = l.base),
                      (e = l.x),
                      (i = l.y - l.height / 2),
                      (n = l.y + l.height / 2),
                      (a = t < e ? 1 : -1),
                      (o = 1),
                      l.borderSkipped || 'left')
                    : ((t = l.x - l.width / 2),
                      (e = l.x + l.width / 2),
                      (a = 1),
                      (o = (i = l.y) < (n = l.base) ? 1 : -1),
                      l.borderSkipped || 'bottom')),
                  u)
                ) {
                  var d = Math.min(Math.abs(t - e), Math.abs(i - n)),
                    c = (u = d < u ? d : u) / 2,
                    h = t + ('left' !== r ? c * a : 0),
                    f = e + ('right' !== r ? -c * a : 0),
                    g = i + ('top' !== r ? c * o : 0),
                    p = n + ('bottom' !== r ? -c * o : 0);
                  h !== f && ((i = g), (n = p)), g !== p && ((t = h), (e = f));
                }
                s.beginPath(),
                  (s.fillStyle = l.backgroundColor),
                  (s.strokeStyle = l.borderColor),
                  (s.lineWidth = u);
                var m = [
                    [t, n],
                    [t, i],
                    [e, i],
                    [e, n],
                  ],
                  v = ['bottom', 'left', 'top', 'right'].indexOf(r, 0);
                function b(t) {
                  return m[(v + t) % 4];
                }
                -1 === v && (v = 0);
                var x = b(0);
                s.moveTo(x[0], x[1]);
                for (var y = 1; y < 4; y++) (x = b(y)), s.lineTo(x[0], x[1]);
                s.fill(), u && s.stroke();
              },
              height: function () {
                var t = this._view;
                return t.base - t.y;
              },
              inRange: function (t, e) {
                var i = !1;
                if (this._view) {
                  var n = o(this);
                  i =
                    t >= n.left && t <= n.right && e >= n.top && e <= n.bottom;
                }
                return i;
              },
              inLabelRange: function (t, e) {
                if (!this._view) return !1;
                var i = o(this);
                return l(this)
                  ? t >= i.left && t <= i.right
                  : e >= i.top && e <= i.bottom;
              },
              inXRange: function (t) {
                var e = o(this);
                return t >= e.left && t <= e.right;
              },
              inYRange: function (t) {
                var e = o(this);
                return t >= e.top && t <= e.bottom;
              },
              getCenterPoint: function () {
                var t,
                  e,
                  i = this._view;
                return (
                  (e = l(this)
                    ? ((t = i.x), (i.y + i.base) / 2)
                    : ((t = (i.x + i.base) / 2), i.y)),
                  { x: t, y: e }
                );
              },
              getArea: function () {
                var t = this._view;
                return t.width * Math.abs(t.y - t.base);
              },
              tooltipPosition: function () {
                var t = this._view;
                return { x: t.x, y: t.y };
              },
            }));
        },
        { 26: 26, 27: 27 },
      ],
      41: [
        function (t, e, i) {
          'use strict';
          (e.exports = {}),
            (e.exports.Arc = t(37)),
            (e.exports.Line = t(38)),
            (e.exports.Point = t(39)),
            (e.exports.Rectangle = t(40));
        },
        { 37: 37, 38: 38, 39: 39, 40: 40 },
      ],
      42: [
        function (t, e, i) {
          'use strict';
          var n = t(43);
          i = e.exports = {
            clear: function (t) {
              t.ctx.clearRect(0, 0, t.width, t.height);
            },
            roundedRect: function (t, e, i, n, a, o) {
              if (o) {
                var r = Math.min(o, a / 2 - 1e-7, n / 2 - 1e-7);
                t.moveTo(e + r, i),
                  t.lineTo(e + n - r, i),
                  t.arcTo(e + n, i, e + n, i + r, r),
                  t.lineTo(e + n, i + a - r),
                  t.arcTo(e + n, i + a, e + n - r, i + a, r),
                  t.lineTo(e + r, i + a),
                  t.arcTo(e, i + a, e, i + a - r, r),
                  t.lineTo(e, i + r),
                  t.arcTo(e, i, e + r, i, r),
                  t.closePath(),
                  t.moveTo(e, i);
              } else t.rect(e, i, n, a);
            },
            drawPoint: function (t, e, i, n, a, o) {
              var r, s, l, u, d, c;
              if (
                ((o = o || 0),
                !e ||
                  'object' != typeof e ||
                  ('[object HTMLImageElement]' !== (r = e.toString()) &&
                    '[object HTMLCanvasElement]' !== r))
              ) {
                if (!(isNaN(i) || i <= 0)) {
                  switch (
                    (t.save(),
                    t.translate(n, a),
                    t.rotate((o * Math.PI) / 180),
                    t.beginPath(),
                    e)
                  ) {
                    default:
                      t.arc(0, 0, i, 0, 2 * Math.PI), t.closePath();
                      break;
                    case 'triangle':
                      (d = ((s = (3 * i) / Math.sqrt(3)) * Math.sqrt(3)) / 2),
                        t.moveTo(-s / 2, d / 3),
                        t.lineTo(s / 2, d / 3),
                        t.lineTo(0, (-2 * d) / 3),
                        t.closePath();
                      break;
                    case 'rect':
                      (c = (1 / Math.SQRT2) * i), t.rect(-c, -c, 2 * c, 2 * c);
                      break;
                    case 'rectRounded':
                      var h = i / Math.SQRT2,
                        f = -h,
                        g = -h,
                        p = Math.SQRT2 * i;
                      this.roundedRect(t, f, g, p, p, 0.425 * i);
                      break;
                    case 'rectRot':
                      (c = (1 / Math.SQRT2) * i),
                        t.moveTo(-c, 0),
                        t.lineTo(0, c),
                        t.lineTo(c, 0),
                        t.lineTo(0, -c),
                        t.closePath();
                      break;
                    case 'cross':
                      t.moveTo(0, i),
                        t.lineTo(0, -i),
                        t.moveTo(-i, 0),
                        t.lineTo(i, 0);
                      break;
                    case 'crossRot':
                      (l = Math.cos(Math.PI / 4) * i),
                        (u = Math.sin(Math.PI / 4) * i),
                        t.moveTo(-l, -u),
                        t.lineTo(l, u),
                        t.moveTo(-l, u),
                        t.lineTo(l, -u);
                      break;
                    case 'star':
                      t.moveTo(0, i),
                        t.lineTo(0, -i),
                        t.moveTo(-i, 0),
                        t.lineTo(i, 0),
                        (l = Math.cos(Math.PI / 4) * i),
                        (u = Math.sin(Math.PI / 4) * i),
                        t.moveTo(-l, -u),
                        t.lineTo(l, u),
                        t.moveTo(-l, u),
                        t.lineTo(l, -u);
                      break;
                    case 'line':
                      t.moveTo(-i, 0), t.lineTo(i, 0);
                      break;
                    case 'dash':
                      t.moveTo(0, 0), t.lineTo(i, 0);
                  }
                  t.fill(), t.stroke(), t.restore();
                }
              } else
                t.drawImage(
                  e,
                  n - e.width / 2,
                  a - e.height / 2,
                  e.width,
                  e.height
                );
            },
            clipArea: function (t, e) {
              t.save(),
                t.beginPath(),
                t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top),
                t.clip();
            },
            unclipArea: function (t) {
              t.restore();
            },
            lineTo: function (t, e, i, n) {
              if (i.steppedLine)
                return (
                  ('after' === i.steppedLine && !n) ||
                  ('after' !== i.steppedLine && n)
                    ? t.lineTo(e.x, i.y)
                    : t.lineTo(i.x, e.y),
                  void t.lineTo(i.x, i.y)
                );
              i.tension
                ? t.bezierCurveTo(
                    n ? e.controlPointPreviousX : e.controlPointNextX,
                    n ? e.controlPointPreviousY : e.controlPointNextY,
                    n ? i.controlPointNextX : i.controlPointPreviousX,
                    n ? i.controlPointNextY : i.controlPointPreviousY,
                    i.x,
                    i.y
                  )
                : t.lineTo(i.x, i.y);
            },
          };
          (n.clear = i.clear),
            (n.drawRoundedRectangle = function (t) {
              t.beginPath(), i.roundedRect.apply(i, arguments);
            });
        },
        { 43: 43 },
      ],
      43: [
        function (t, e, i) {
          'use strict';
          var n,
            d = {
              noop: function () {},
              uid:
                ((n = 0),
                function () {
                  return n++;
                }),
              isNullOrUndef: function (t) {
                return null == t;
              },
              isArray: Array.isArray
                ? Array.isArray
                : function (t) {
                    return (
                      '[object Array]' === Object.prototype.toString.call(t)
                    );
                  },
              isObject: function (t) {
                return (
                  null !== t &&
                  '[object Object]' === Object.prototype.toString.call(t)
                );
              },
              valueOrDefault: function (t, e) {
                return void 0 === t ? e : t;
              },
              valueAtIndexOrDefault: function (t, e, i) {
                return d.valueOrDefault(d.isArray(t) ? t[e] : t, i);
              },
              callback: function (t, e, i) {
                if (t && 'function' == typeof t.call) return t.apply(i, e);
              },
              each: function (t, e, i, n) {
                var a, o, r;
                if (d.isArray(t))
                  if (((o = t.length), n))
                    for (a = o - 1; 0 <= a; a--) e.call(i, t[a], a);
                  else for (a = 0; a < o; a++) e.call(i, t[a], a);
                else if (d.isObject(t))
                  for (o = (r = Object.keys(t)).length, a = 0; a < o; a++)
                    e.call(i, t[r[a]], r[a]);
              },
              arrayEquals: function (t, e) {
                var i, n, a, o;
                if (!t || !e || t.length !== e.length) return !1;
                for (i = 0, n = t.length; i < n; ++i)
                  if (
                    ((a = t[i]),
                    (o = e[i]),
                    a instanceof Array && o instanceof Array)
                  ) {
                    if (!d.arrayEquals(a, o)) return !1;
                  } else if (a !== o) return !1;
                return !0;
              },
              clone: function (t) {
                if (d.isArray(t)) return t.map(d.clone);
                if (d.isObject(t)) {
                  for (
                    var e = {}, i = Object.keys(t), n = i.length, a = 0;
                    a < n;
                    ++a
                  )
                    e[i[a]] = d.clone(t[i[a]]);
                  return e;
                }
                return t;
              },
              _merger: function (t, e, i, n) {
                var a = e[t],
                  o = i[t];
                d.isObject(a) && d.isObject(o)
                  ? d.merge(a, o, n)
                  : (e[t] = d.clone(o));
              },
              _mergerIf: function (t, e, i) {
                var n = e[t],
                  a = i[t];
                d.isObject(n) && d.isObject(a)
                  ? d.mergeIf(n, a)
                  : e.hasOwnProperty(t) || (e[t] = d.clone(a));
              },
              merge: function (t, e, i) {
                var n,
                  a,
                  o,
                  r,
                  s,
                  l = d.isArray(e) ? e : [e],
                  u = l.length;
                if (!d.isObject(t)) return t;
                for (n = (i = i || {}).merger || d._merger, a = 0; a < u; ++a)
                  if (((e = l[a]), d.isObject(e)))
                    for (s = 0, r = (o = Object.keys(e)).length; s < r; ++s)
                      n(o[s], t, e, i);
                return t;
              },
              mergeIf: function (t, e) {
                return d.merge(t, e, { merger: d._mergerIf });
              },
              extend: function (i) {
                for (
                  var t = function (t, e) {
                      i[e] = t;
                    },
                    e = 1,
                    n = arguments.length;
                  e < n;
                  ++e
                )
                  d.each(arguments[e], t);
                return i;
              },
              inherits: function (t) {
                var e = this,
                  i =
                    t && t.hasOwnProperty('constructor')
                      ? t.constructor
                      : function () {
                          return e.apply(this, arguments);
                        },
                  n = function () {
                    this.constructor = i;
                  };
                return (
                  (n.prototype = e.prototype),
                  (i.prototype = new n()),
                  (i.extend = d.inherits),
                  t && d.extend(i.prototype, t),
                  (i.__super__ = e.prototype),
                  i
                );
              },
            };
          ((e.exports = d).callCallback = d.callback),
            (d.indexOf = function (t, e, i) {
              return Array.prototype.indexOf.call(t, e, i);
            }),
            (d.getValueOrDefault = d.valueOrDefault),
            (d.getValueAtIndexOrDefault = d.valueAtIndexOrDefault);
        },
        {},
      ],
      44: [
        function (t, e, i) {
          'use strict';
          var n = t(43),
            a = {
              linear: function (t) {
                return t;
              },
              easeInQuad: function (t) {
                return t * t;
              },
              easeOutQuad: function (t) {
                return -t * (t - 2);
              },
              easeInOutQuad: function (t) {
                return (t /= 0.5) < 1
                  ? 0.5 * t * t
                  : -0.5 * (--t * (t - 2) - 1);
              },
              easeInCubic: function (t) {
                return t * t * t;
              },
              easeOutCubic: function (t) {
                return (t -= 1) * t * t + 1;
              },
              easeInOutCubic: function (t) {
                return (t /= 0.5) < 1
                  ? 0.5 * t * t * t
                  : 0.5 * ((t -= 2) * t * t + 2);
              },
              easeInQuart: function (t) {
                return t * t * t * t;
              },
              easeOutQuart: function (t) {
                return -((t -= 1) * t * t * t - 1);
              },
              easeInOutQuart: function (t) {
                return (t /= 0.5) < 1
                  ? 0.5 * t * t * t * t
                  : -0.5 * ((t -= 2) * t * t * t - 2);
              },
              easeInQuint: function (t) {
                return t * t * t * t * t;
              },
              easeOutQuint: function (t) {
                return (t -= 1) * t * t * t * t + 1;
              },
              easeInOutQuint: function (t) {
                return (t /= 0.5) < 1
                  ? 0.5 * t * t * t * t * t
                  : 0.5 * ((t -= 2) * t * t * t * t + 2);
              },
              easeInSine: function (t) {
                return 1 - Math.cos(t * (Math.PI / 2));
              },
              easeOutSine: function (t) {
                return Math.sin(t * (Math.PI / 2));
              },
              easeInOutSine: function (t) {
                return -0.5 * (Math.cos(Math.PI * t) - 1);
              },
              easeInExpo: function (t) {
                return 0 === t ? 0 : Math.pow(2, 10 * (t - 1));
              },
              easeOutExpo: function (t) {
                return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
              },
              easeInOutExpo: function (t) {
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : (t /= 0.5) < 1
                  ? 0.5 * Math.pow(2, 10 * (t - 1))
                  : 0.5 * (2 - Math.pow(2, -10 * --t));
              },
              easeInCirc: function (t) {
                return 1 <= t ? t : -(Math.sqrt(1 - t * t) - 1);
              },
              easeOutCirc: function (t) {
                return Math.sqrt(1 - (t -= 1) * t);
              },
              easeInOutCirc: function (t) {
                return (t /= 0.5) < 1
                  ? -0.5 * (Math.sqrt(1 - t * t) - 1)
                  : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
              },
              easeInElastic: function (t) {
                var e = 1.70158,
                  i = 0,
                  n = 1;
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : (i || (i = 0.3),
                    (e =
                      n < 1
                        ? ((n = 1), i / 4)
                        : (i / (2 * Math.PI)) * Math.asin(1 / n)),
                    -n *
                      Math.pow(2, 10 * (t -= 1)) *
                      Math.sin(((t - e) * (2 * Math.PI)) / i));
              },
              easeOutElastic: function (t) {
                var e = 1.70158,
                  i = 0,
                  n = 1;
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : (i || (i = 0.3),
                    (e =
                      n < 1
                        ? ((n = 1), i / 4)
                        : (i / (2 * Math.PI)) * Math.asin(1 / n)),
                    n *
                      Math.pow(2, -10 * t) *
                      Math.sin(((t - e) * (2 * Math.PI)) / i) +
                      1);
              },
              easeInOutElastic: function (t) {
                var e = 1.70158,
                  i = 0,
                  n = 1;
                return 0 === t
                  ? 0
                  : 2 == (t /= 0.5)
                  ? 1
                  : (i || (i = 0.45),
                    (e =
                      n < 1
                        ? ((n = 1), i / 4)
                        : (i / (2 * Math.PI)) * Math.asin(1 / n)),
                    t < 1
                      ? n *
                        Math.pow(2, 10 * (t -= 1)) *
                        Math.sin(((t - e) * (2 * Math.PI)) / i) *
                        -0.5
                      : n *
                          Math.pow(2, -10 * (t -= 1)) *
                          Math.sin(((t - e) * (2 * Math.PI)) / i) *
                          0.5 +
                        1);
              },
              easeInBack: function (t) {
                return t * t * (2.70158 * t - 1.70158);
              },
              easeOutBack: function (t) {
                return (t -= 1) * t * (2.70158 * t + 1.70158) + 1;
              },
              easeInOutBack: function (t) {
                var e = 1.70158;
                return (t /= 0.5) < 1
                  ? t * t * ((1 + (e *= 1.525)) * t - e) * 0.5
                  : 0.5 * ((t -= 2) * t * ((1 + (e *= 1.525)) * t + e) + 2);
              },
              easeInBounce: function (t) {
                return 1 - a.easeOutBounce(1 - t);
              },
              easeOutBounce: function (t) {
                return t < 1 / 2.75
                  ? 7.5625 * t * t
                  : t < 2 / 2.75
                  ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75
                  : t < 2.5 / 2.75
                  ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375
                  : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
              },
              easeInOutBounce: function (t) {
                return t < 0.5
                  ? 0.5 * a.easeInBounce(2 * t)
                  : 0.5 * a.easeOutBounce(2 * t - 1) + 0.5;
              },
            };
          (e.exports = { effects: a }), (n.easingEffects = a);
        },
        { 43: 43 },
      ],
      45: [
        function (t, e, i) {
          'use strict';
          var r = t(43);
          e.exports = {
            toLineHeight: function (t, e) {
              var i = ('' + t).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
              if (!i || 'normal' === i[1]) return 1.2 * e;
              switch (((t = +i[2]), i[3])) {
                case 'px':
                  return t;
                case '%':
                  t /= 100;
              }
              return e * t;
            },
            toPadding: function (t) {
              var e, i, n, a;
              return (
                r.isObject(t)
                  ? ((e = +t.top || 0),
                    (i = +t.right || 0),
                    (n = +t.bottom || 0),
                    (a = +t.left || 0))
                  : (e = i = n = a = +t || 0),
                {
                  top: e,
                  right: i,
                  bottom: n,
                  left: a,
                  height: e + n,
                  width: a + i,
                }
              );
            },
            resolve: function (t, e, i) {
              var n, a, o;
              for (n = 0, a = t.length; n < a; ++n)
                if (
                  void 0 !== (o = t[n]) &&
                  (void 0 !== e && 'function' == typeof o && (o = o(e)),
                  void 0 !== i && r.isArray(o) && (o = o[i]),
                  void 0 !== o)
                )
                  return o;
            },
          };
        },
        { 43: 43 },
      ],
      46: [
        function (t, e, i) {
          'use strict';
          (e.exports = t(43)),
            (e.exports.easing = t(44)),
            (e.exports.canvas = t(42)),
            (e.exports.options = t(45));
        },
        { 42: 42, 43: 43, 44: 44, 45: 45 },
      ],
      47: [
        function (t, e, i) {
          e.exports = {
            acquireContext: function (t) {
              return (
                t && t.canvas && (t = t.canvas),
                (t && t.getContext('2d')) || null
              );
            },
          };
        },
        {},
      ],
      48: [
        function (t, e, i) {
          'use strict';
          var f = t(46),
            g = '$chartjs',
            p = 'chartjs-',
            m = p + 'render-monitor',
            v = p + 'render-animation',
            b = ['animationstart', 'webkitAnimationStart'],
            s = {
              touchstart: 'mousedown',
              touchmove: 'mousemove',
              touchend: 'mouseup',
              pointerenter: 'mouseenter',
              pointerdown: 'mousedown',
              pointermove: 'mousemove',
              pointerup: 'mouseup',
              pointerleave: 'mouseout',
              pointerout: 'mouseout',
            };
          function l(t, e) {
            var i = f.getStyle(t, e),
              n = i && i.match(/^(\d+)(\.\d+)?px$/);
            return n ? Number(n[1]) : void 0;
          }
          var n = !!(function () {
            var t = !1;
            try {
              var e = Object.defineProperty({}, 'passive', {
                get: function () {
                  t = !0;
                },
              });
              window.addEventListener('e', null, e);
            } catch (t) {}
            return t;
          })() && { passive: !0 };
          function x(t, e, i) {
            t.addEventListener(e, i, n);
          }
          function r(t, e, i) {
            t.removeEventListener(e, i, n);
          }
          function y(t, e, i, n, a) {
            return {
              type: t,
              chart: e,
              native: a || null,
              x: void 0 !== i ? i : null,
              y: void 0 !== n ? n : null,
            };
          }
          function a(e, t, i) {
            var n,
              a,
              o,
              r,
              s,
              l,
              u,
              d,
              c = e[g] || (e[g] = {}),
              h = (c.resizer = (function (t) {
                var e = document.createElement('div'),
                  i = p + 'size-monitor',
                  n =
                    'position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;';
                (e.style.cssText = n),
                  (e.className = i),
                  (e.innerHTML =
                    '<div class="' +
                    i +
                    '-expand" style="' +
                    n +
                    '"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="' +
                    i +
                    '-shrink" style="' +
                    n +
                    '"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div>');
                var a = e.childNodes[0],
                  o = e.childNodes[1];
                e._reset = function () {
                  (a.scrollLeft = 1e6),
                    (a.scrollTop = 1e6),
                    (o.scrollLeft = 1e6),
                    (o.scrollTop = 1e6);
                };
                var r = function () {
                  e._reset(), t();
                };
                return (
                  x(a, 'scroll', r.bind(a, 'expand')),
                  x(o, 'scroll', r.bind(o, 'shrink')),
                  e
                );
              })(
                ((o = !(n = function () {
                  if (c.resizer) return t(y('resize', i));
                })),
                (r = []),
                function () {
                  (r = Array.prototype.slice.call(arguments)),
                    (a = a || this),
                    o ||
                      ((o = !0),
                      f.requestAnimFrame.call(window, function () {
                        (o = !1), n.apply(a, r);
                      }));
                })
              ));
            (l = function () {
              if (c.resizer) {
                var t = e.parentNode;
                t && t !== h.parentNode && t.insertBefore(h, t.firstChild),
                  h._reset();
              }
            }),
              (u = (s = e)[g] || (s[g] = {})),
              (d = u.renderProxy = function (t) {
                t.animationName === v && l();
              }),
              f.each(b, function (t) {
                x(s, t, d);
              }),
              (u.reflow = !!s.offsetParent),
              s.classList.add(m);
          }
          function o(t) {
            var e,
              i,
              n,
              a = t[g] || {},
              o = a.resizer;
            delete a.resizer,
              (i = (e = t)[g] || {}),
              (n = i.renderProxy) &&
                (f.each(b, function (t) {
                  r(e, t, n);
                }),
                delete i.renderProxy),
              e.classList.remove(m),
              o && o.parentNode && o.parentNode.removeChild(o);
          }
          (e.exports = {
            _enabled:
              'undefined' != typeof window && 'undefined' != typeof document,
            initialize: function () {
              var t,
                e,
                i,
                n = 'from{opacity:0.99}to{opacity:1}';
              (e =
                '@-webkit-keyframes ' +
                v +
                '{' +
                n +
                '}@keyframes ' +
                v +
                '{' +
                n +
                '}.' +
                m +
                '{-webkit-animation:' +
                v +
                ' 0.001s;animation:' +
                v +
                ' 0.001s;}'),
                (i = (t = this)._style || document.createElement('style')),
                t._style ||
                  ((e = '/* Chart.js */\n' + e),
                  (t._style = i).setAttribute('type', 'text/css'),
                  document.getElementsByTagName('head')[0].appendChild(i)),
                i.appendChild(document.createTextNode(e));
            },
            acquireContext: function (t, e) {
              'string' == typeof t
                ? (t = document.getElementById(t))
                : t.length && (t = t[0]),
                t && t.canvas && (t = t.canvas);
              var i = t && t.getContext && t.getContext('2d');
              return i && i.canvas === t
                ? ((function (t, e) {
                    var i = t.style,
                      n = t.getAttribute('height'),
                      a = t.getAttribute('width');
                    if (
                      ((t[g] = {
                        initial: {
                          height: n,
                          width: a,
                          style: {
                            display: i.display,
                            height: i.height,
                            width: i.width,
                          },
                        },
                      }),
                      (i.display = i.display || 'block'),
                      null === a || '' === a)
                    ) {
                      var o = l(t, 'width');
                      void 0 !== o && (t.width = o);
                    }
                    if (null === n || '' === n)
                      if ('' === t.style.height)
                        t.height = t.width / (e.options.aspectRatio || 2);
                      else {
                        var r = l(t, 'height');
                        void 0 !== o && (t.height = r);
                      }
                  })(t, e),
                  i)
                : null;
            },
            releaseContext: function (t) {
              var i = t.canvas;
              if (i[g]) {
                var n = i[g].initial;
                ['height', 'width'].forEach(function (t) {
                  var e = n[t];
                  f.isNullOrUndef(e)
                    ? i.removeAttribute(t)
                    : i.setAttribute(t, e);
                }),
                  f.each(n.style || {}, function (t, e) {
                    i.style[e] = t;
                  }),
                  (i.width = i.width),
                  delete i[g];
              }
            },
            addEventListener: function (o, t, r) {
              var e = o.canvas;
              if ('resize' !== t) {
                var i = r[g] || (r[g] = {});
                x(
                  e,
                  t,
                  ((i.proxies || (i.proxies = {}))[o.id + '_' + t] = function (
                    t
                  ) {
                    var e, i, n, a;
                    r(
                      ((i = o),
                      (n = s[(e = t).type] || e.type),
                      (a = f.getRelativePosition(e, i)),
                      y(n, i, a.x, a.y, e))
                    );
                  })
                );
              } else a(e, r, o);
            },
            removeEventListener: function (t, e, i) {
              var n = t.canvas;
              if ('resize' !== e) {
                var a = ((i[g] || {}).proxies || {})[t.id + '_' + e];
                a && r(n, e, a);
              } else o(n);
            },
          }),
            (f.addEvent = x),
            (f.removeEvent = r);
        },
        { 46: 46 },
      ],
      49: [
        function (t, e, i) {
          'use strict';
          var n = t(46),
            a = t(47),
            o = t(48),
            r = o._enabled ? o : a;
          e.exports = n.extend(
            {
              initialize: function () {},
              acquireContext: function () {},
              releaseContext: function () {},
              addEventListener: function () {},
              removeEventListener: function () {},
            },
            r
          );
        },
        { 46: 46, 47: 47, 48: 48 },
      ],
      50: [
        function (t, e, i) {
          'use strict';
          (e.exports = {}),
            (e.exports.filler = t(51)),
            (e.exports.legend = t(52)),
            (e.exports.title = t(53));
        },
        { 51: 51, 52: 52, 53: 53 },
      ],
      51: [
        function (t, e, i) {
          'use strict';
          var u = t(26),
            h = t(41),
            d = t(46);
          u._set('global', { plugins: { filler: { propagate: !0 } } });
          var f = {
            dataset: function (t) {
              var e = t.fill,
                i = t.chart,
                n = i.getDatasetMeta(e),
                a = (n && i.isDatasetVisible(e) && n.dataset._children) || [],
                o = a.length || 0;
              return o
                ? function (t, e) {
                    return (e < o && a[e]._view) || null;
                  }
                : null;
            },
            boundary: function (t) {
              var e = t.boundary,
                i = e ? e.x : null,
                n = e ? e.y : null;
              return function (t) {
                return { x: null === i ? t.x : i, y: null === n ? t.y : n };
              };
            },
          };
          function g(t, e, i) {
            var n,
              a = t._model || {},
              o = a.fill;
            if (
              (void 0 === o && (o = !!a.backgroundColor),
              !1 === o || null === o)
            )
              return !1;
            if (!0 === o) return 'origin';
            if (((n = parseFloat(o, 10)), isFinite(n) && Math.floor(n) === n))
              return (
                ('-' !== o[0] && '+' !== o[0]) || (n = e + n),
                !(n === e || n < 0 || i <= n) && n
              );
            switch (o) {
              case 'bottom':
                return 'start';
              case 'top':
                return 'end';
              case 'zero':
                return 'origin';
              case 'origin':
              case 'start':
              case 'end':
                return o;
              default:
                return !1;
            }
          }
          function p(t) {
            var e,
              i = t.el._model || {},
              n = t.el._scale || {},
              a = t.fill,
              o = null;
            if (isFinite(a)) return null;
            if (
              ('start' === a
                ? (o = void 0 === i.scaleBottom ? n.bottom : i.scaleBottom)
                : 'end' === a
                ? (o = void 0 === i.scaleTop ? n.top : i.scaleTop)
                : void 0 !== i.scaleZero
                ? (o = i.scaleZero)
                : n.getBasePosition
                ? (o = n.getBasePosition())
                : n.getBasePixel && (o = n.getBasePixel()),
              null != o)
            ) {
              if (void 0 !== o.x && void 0 !== o.y) return o;
              if ('number' == typeof o && isFinite(o))
                return {
                  x: (e = n.isHorizontal()) ? o : null,
                  y: e ? null : o,
                };
            }
            return null;
          }
          function m(t, e, i) {
            var n,
              a = t[e].fill,
              o = [e];
            if (!i) return a;
            for (; !1 !== a && -1 === o.indexOf(a); ) {
              if (!isFinite(a)) return a;
              if (!(n = t[a])) return !1;
              if (n.visible) return a;
              o.push(a), (a = n.fill);
            }
            return !1;
          }
          function x(t) {
            return t && !t.skip;
          }
          function y(t, e, i, n, a) {
            var o;
            if (n && a) {
              for (t.moveTo(e[0].x, e[0].y), o = 1; o < n; ++o)
                d.canvas.lineTo(t, e[o - 1], e[o]);
              for (t.lineTo(i[a - 1].x, i[a - 1].y), o = a - 1; 0 < o; --o)
                d.canvas.lineTo(t, i[o], i[o - 1], !0);
            }
          }
          e.exports = {
            id: 'filler',
            afterDatasetsUpdate: function (t, e) {
              var i,
                n,
                a,
                o,
                r,
                s,
                l,
                u = (t.data.datasets || []).length,
                d = e.propagate,
                c = [];
              for (n = 0; n < u; ++n)
                (o = null),
                  (a = (i = t.getDatasetMeta(n)).dataset) &&
                    a._model &&
                    a instanceof h.Line &&
                    (o = {
                      visible: t.isDatasetVisible(n),
                      fill: g(a, n, u),
                      chart: t,
                      el: a,
                    }),
                  (i.$filler = o),
                  c.push(o);
              for (n = 0; n < u; ++n)
                (o = c[n]) &&
                  ((o.fill = m(c, n, d)),
                  (o.boundary = p(o)),
                  (o.mapper =
                    ((l = void 0),
                    (s = (r = o).fill),
                    !(l = 'dataset') === s
                      ? null
                      : (isFinite(s) || (l = 'boundary'), f[l](r)))));
            },
            beforeDatasetDraw: function (t, e) {
              var i = e.meta.$filler;
              if (i) {
                var n = t.ctx,
                  a = i.el,
                  o = a._view,
                  r = a._children || [],
                  s = i.mapper,
                  l = o.backgroundColor || u.global.defaultColor;
                s &&
                  l &&
                  r.length &&
                  (d.canvas.clipArea(n, t.chartArea),
                  (function (t, e, i, n, a, o) {
                    var r,
                      s,
                      l,
                      u,
                      d,
                      c,
                      h,
                      f = e.length,
                      g = n.spanGaps,
                      p = [],
                      m = [],
                      v = 0,
                      b = 0;
                    for (t.beginPath(), r = 0, s = f + !!o; r < s; ++r)
                      (d = i((u = e[(l = r % f)]._view), l, n)),
                        (c = x(u)),
                        (h = x(d)),
                        c && h
                          ? ((v = p.push(u)), (b = m.push(d)))
                          : v &&
                            b &&
                            (g
                              ? (c && p.push(u), h && m.push(d))
                              : (y(t, p, m, v, b),
                                (v = b = 0),
                                (p = []),
                                (m = [])));
                    y(t, p, m, v, b),
                      t.closePath(),
                      (t.fillStyle = a),
                      t.fill();
                  })(n, r, s, o, l, a._loop),
                  d.canvas.unclipArea(n));
              }
            },
          };
        },
        { 26: 26, 41: 41, 46: 46 },
      ],
      52: [
        function (t, e, i) {
          'use strict';
          var _ = t(26),
            n = t(27),
            D = t(46),
            a = t(31),
            o = D.noop;
          function P(t, e) {
            return t.usePointStyle ? e * Math.SQRT2 : t.boxWidth;
          }
          _._set('global', {
            legend: {
              display: !0,
              position: 'top',
              fullWidth: !0,
              reverse: !1,
              weight: 1e3,
              onClick: function (t, e) {
                var i = e.datasetIndex,
                  n = this.chart,
                  a = n.getDatasetMeta(i);
                (a.hidden =
                  null === a.hidden ? !n.data.datasets[i].hidden : null),
                  n.update();
              },
              onHover: null,
              labels: {
                boxWidth: 40,
                padding: 10,
                generateLabels: function (i) {
                  var t = i.data;
                  return D.isArray(t.datasets)
                    ? t.datasets.map(function (t, e) {
                        return {
                          text: t.label,
                          fillStyle: D.isArray(t.backgroundColor)
                            ? t.backgroundColor[0]
                            : t.backgroundColor,
                          hidden: !i.isDatasetVisible(e),
                          lineCap: t.borderCapStyle,
                          lineDash: t.borderDash,
                          lineDashOffset: t.borderDashOffset,
                          lineJoin: t.borderJoinStyle,
                          lineWidth: t.borderWidth,
                          strokeStyle: t.borderColor,
                          pointStyle: t.pointStyle,
                          datasetIndex: e,
                        };
                      }, this)
                    : [];
                },
              },
            },
            legendCallback: function (t) {
              var e = [];
              e.push('<ul class="' + t.id + '-legend">');
              for (var i = 0; i < t.data.datasets.length; i++)
                e.push(
                  '<li><span style="background-color:' +
                    t.data.datasets[i].backgroundColor +
                    '"></span>'
                ),
                  t.data.datasets[i].label && e.push(t.data.datasets[i].label),
                  e.push('</li>');
              return e.push('</ul>'), e.join('');
            },
          });
          var r = n.extend({
            initialize: function (t) {
              D.extend(this, t),
                (this.legendHitBoxes = []),
                (this.doughnutMode = !1);
            },
            beforeUpdate: o,
            update: function (t, e, i) {
              var n = this;
              return (
                n.beforeUpdate(),
                (n.maxWidth = t),
                (n.maxHeight = e),
                (n.margins = i),
                n.beforeSetDimensions(),
                n.setDimensions(),
                n.afterSetDimensions(),
                n.beforeBuildLabels(),
                n.buildLabels(),
                n.afterBuildLabels(),
                n.beforeFit(),
                n.fit(),
                n.afterFit(),
                n.afterUpdate(),
                n.minSize
              );
            },
            afterUpdate: o,
            beforeSetDimensions: o,
            setDimensions: function () {
              var t = this;
              t.isHorizontal()
                ? ((t.width = t.maxWidth), (t.left = 0), (t.right = t.width))
                : ((t.height = t.maxHeight),
                  (t.top = 0),
                  (t.bottom = t.height)),
                (t.paddingLeft = 0),
                (t.paddingTop = 0),
                (t.paddingRight = 0),
                (t.paddingBottom = 0),
                (t.minSize = { width: 0, height: 0 });
            },
            afterSetDimensions: o,
            beforeBuildLabels: o,
            buildLabels: function () {
              var e = this,
                i = e.options.labels || {},
                t = D.callback(i.generateLabels, [e.chart], e) || [];
              i.filter &&
                (t = t.filter(function (t) {
                  return i.filter(t, e.chart.data);
                })),
                e.options.reverse && t.reverse(),
                (e.legendItems = t);
            },
            afterBuildLabels: o,
            beforeFit: o,
            fit: function () {
              var n = this,
                t = n.options,
                a = t.labels,
                e = t.display,
                o = n.ctx,
                i = _.global,
                r = D.valueOrDefault,
                s = r(a.fontSize, i.defaultFontSize),
                l = r(a.fontStyle, i.defaultFontStyle),
                u = r(a.fontFamily, i.defaultFontFamily),
                d = D.fontString(s, l, u),
                c = (n.legendHitBoxes = []),
                h = n.minSize,
                f = n.isHorizontal();
              if (
                ((h.height = f
                  ? ((h.width = n.maxWidth), e ? 10 : 0)
                  : ((h.width = e ? 10 : 0), n.maxHeight)),
                e)
              )
                if (((o.font = d), f)) {
                  var g = (n.lineWidths = [0]),
                    p = n.legendItems.length ? s + a.padding : 0;
                  (o.textAlign = 'left'),
                    (o.textBaseline = 'top'),
                    D.each(n.legendItems, function (t, e) {
                      var i = P(a, s) + s / 2 + o.measureText(t.text).width;
                      g[g.length - 1] + i + a.padding >= n.width &&
                        ((p += s + a.padding), (g[g.length] = n.left)),
                        (c[e] = { left: 0, top: 0, width: i, height: s }),
                        (g[g.length - 1] += i + a.padding);
                    }),
                    (h.height += p);
                } else {
                  var m = a.padding,
                    v = (n.columnWidths = []),
                    b = a.padding,
                    x = 0,
                    y = 0,
                    k = s + m;
                  D.each(n.legendItems, function (t, e) {
                    var i = P(a, s) + s / 2 + o.measureText(t.text).width;
                    y + k > h.height &&
                      ((b += x + a.padding), v.push(x), (y = x = 0)),
                      (x = Math.max(x, i)),
                      (y += k),
                      (c[e] = { left: 0, top: 0, width: i, height: s });
                  }),
                    (b += x),
                    v.push(x),
                    (h.width += b);
                }
              (n.width = h.width), (n.height = h.height);
            },
            afterFit: o,
            isHorizontal: function () {
              return (
                'top' === this.options.position ||
                'bottom' === this.options.position
              );
            },
            draw: function () {
              var c = this,
                h = c.options,
                f = h.labels,
                g = _.global,
                p = g.elements.line,
                m = c.width,
                v = c.lineWidths;
              if (h.display) {
                var b,
                  x = c.ctx,
                  y = D.valueOrDefault,
                  t = y(f.fontColor, g.defaultFontColor),
                  k = y(f.fontSize, g.defaultFontSize),
                  e = y(f.fontStyle, g.defaultFontStyle),
                  i = y(f.fontFamily, g.defaultFontFamily),
                  n = D.fontString(k, e, i);
                (x.textAlign = 'left'),
                  (x.textBaseline = 'middle'),
                  (x.lineWidth = 0.5),
                  (x.strokeStyle = t),
                  (x.fillStyle = t),
                  (x.font = n);
                var M = P(f, k),
                  w = c.legendHitBoxes,
                  C = c.isHorizontal();
                b = C
                  ? {
                      x: c.left + (m - v[0]) / 2,
                      y: c.top + f.padding,
                      line: 0,
                    }
                  : { x: c.left + f.padding, y: c.top + f.padding, line: 0 };
                var S = k + f.padding;
                D.each(c.legendItems, function (t, e) {
                  var i,
                    n,
                    a,
                    o,
                    r,
                    s = x.measureText(t.text).width,
                    l = M + k / 2 + s,
                    u = b.x,
                    d = b.y;
                  C
                    ? m <= u + l &&
                      ((d = b.y += S),
                      b.line++,
                      (u = b.x = c.left + (m - v[b.line]) / 2))
                    : d + S > c.bottom &&
                      ((u = b.x = u + c.columnWidths[b.line] + f.padding),
                      (d = b.y = c.top + f.padding),
                      b.line++),
                    (function (t, e, i) {
                      if (!(isNaN(M) || M <= 0)) {
                        x.save(),
                          (x.fillStyle = y(i.fillStyle, g.defaultColor)),
                          (x.lineCap = y(i.lineCap, p.borderCapStyle)),
                          (x.lineDashOffset = y(
                            i.lineDashOffset,
                            p.borderDashOffset
                          )),
                          (x.lineJoin = y(i.lineJoin, p.borderJoinStyle)),
                          (x.lineWidth = y(i.lineWidth, p.borderWidth)),
                          (x.strokeStyle = y(i.strokeStyle, g.defaultColor));
                        var n = 0 === y(i.lineWidth, p.borderWidth);
                        if (
                          (x.setLineDash &&
                            x.setLineDash(y(i.lineDash, p.borderDash)),
                          h.labels && h.labels.usePointStyle)
                        ) {
                          var a = (k * Math.SQRT2) / 2,
                            o = a / Math.SQRT2,
                            r = t + o,
                            s = e + o;
                          D.canvas.drawPoint(x, i.pointStyle, a, r, s);
                        } else
                          n || x.strokeRect(t, e, M, k), x.fillRect(t, e, M, k);
                        x.restore();
                      }
                    })(u, d, t),
                    (w[e].left = u),
                    (w[e].top = d),
                    (i = t),
                    (n = s),
                    (o = M + (a = k / 2) + u),
                    (r = d + a),
                    x.fillText(i.text, o, r),
                    i.hidden &&
                      (x.beginPath(),
                      (x.lineWidth = 2),
                      x.moveTo(o, r),
                      x.lineTo(o + n, r),
                      x.stroke()),
                    C ? (b.x += l + f.padding) : (b.y += S);
                });
              }
            },
            handleEvent: function (t) {
              var e = this,
                i = e.options,
                n = 'mouseup' === t.type ? 'click' : t.type,
                a = !1;
              if ('mousemove' === n) {
                if (!i.onHover) return;
              } else {
                if ('click' !== n) return;
                if (!i.onClick) return;
              }
              var o = t.x,
                r = t.y;
              if (o >= e.left && o <= e.right && r >= e.top && r <= e.bottom)
                for (var s = e.legendHitBoxes, l = 0; l < s.length; ++l) {
                  var u = s[l];
                  if (
                    o >= u.left &&
                    o <= u.left + u.width &&
                    r >= u.top &&
                    r <= u.top + u.height
                  ) {
                    if ('click' === n) {
                      i.onClick.call(e, t.native, e.legendItems[l]), (a = !0);
                      break;
                    }
                    if ('mousemove' === n) {
                      i.onHover.call(e, t.native, e.legendItems[l]), (a = !0);
                      break;
                    }
                  }
                }
              return a;
            },
          });
          function s(t, e) {
            var i = new r({ ctx: t.ctx, options: e, chart: t });
            a.configure(t, i, e), a.addBox(t, i), (t.legend = i);
          }
          e.exports = {
            id: 'legend',
            _element: r,
            beforeInit: function (t) {
              var e = t.options.legend;
              e && s(t, e);
            },
            beforeUpdate: function (t) {
              var e = t.options.legend,
                i = t.legend;
              e
                ? (D.mergeIf(e, _.global.legend),
                  i ? (a.configure(t, i, e), (i.options = e)) : s(t, e))
                : i && (a.removeBox(t, i), delete t.legend);
            },
            afterEvent: function (t, e) {
              var i = t.legend;
              i && i.handleEvent(e);
            },
          };
        },
        { 26: 26, 27: 27, 31: 31, 46: 46 },
      ],
      53: [
        function (t, e, i) {
          'use strict';
          var M = t(26),
            n = t(27),
            w = t(46),
            a = t(31),
            o = w.noop;
          M._set('global', {
            title: {
              display: !1,
              fontStyle: 'bold',
              fullWidth: !0,
              lineHeight: 1.2,
              padding: 10,
              position: 'top',
              text: '',
              weight: 2e3,
            },
          });
          var r = n.extend({
            initialize: function (t) {
              w.extend(this, t), (this.legendHitBoxes = []);
            },
            beforeUpdate: o,
            update: function (t, e, i) {
              var n = this;
              return (
                n.beforeUpdate(),
                (n.maxWidth = t),
                (n.maxHeight = e),
                (n.margins = i),
                n.beforeSetDimensions(),
                n.setDimensions(),
                n.afterSetDimensions(),
                n.beforeBuildLabels(),
                n.buildLabels(),
                n.afterBuildLabels(),
                n.beforeFit(),
                n.fit(),
                n.afterFit(),
                n.afterUpdate(),
                n.minSize
              );
            },
            afterUpdate: o,
            beforeSetDimensions: o,
            setDimensions: function () {
              var t = this;
              t.isHorizontal()
                ? ((t.width = t.maxWidth), (t.left = 0), (t.right = t.width))
                : ((t.height = t.maxHeight),
                  (t.top = 0),
                  (t.bottom = t.height)),
                (t.paddingLeft = 0),
                (t.paddingTop = 0),
                (t.paddingRight = 0),
                (t.paddingBottom = 0),
                (t.minSize = { width: 0, height: 0 });
            },
            afterSetDimensions: o,
            beforeBuildLabels: o,
            buildLabels: o,
            afterBuildLabels: o,
            beforeFit: o,
            fit: function () {
              var t = this,
                e = w.valueOrDefault,
                i = t.options,
                n = i.display,
                a = e(i.fontSize, M.global.defaultFontSize),
                o = t.minSize,
                r = w.isArray(i.text) ? i.text.length : 1,
                s = w.options.toLineHeight(i.lineHeight, a),
                l = n ? r * s + 2 * i.padding : 0;
              t.isHorizontal()
                ? ((o.width = t.maxWidth), (o.height = l))
                : ((o.width = l), (o.height = t.maxHeight)),
                (t.width = o.width),
                (t.height = o.height);
            },
            afterFit: o,
            isHorizontal: function () {
              var t = this.options.position;
              return 'top' === t || 'bottom' === t;
            },
            draw: function () {
              var t = this,
                e = t.ctx,
                i = w.valueOrDefault,
                n = t.options,
                a = M.global;
              if (n.display) {
                var o,
                  r,
                  s,
                  l = i(n.fontSize, a.defaultFontSize),
                  u = i(n.fontStyle, a.defaultFontStyle),
                  d = i(n.fontFamily, a.defaultFontFamily),
                  c = w.fontString(l, u, d),
                  h = w.options.toLineHeight(n.lineHeight, l),
                  f = h / 2 + n.padding,
                  g = 0,
                  p = t.top,
                  m = t.left,
                  v = t.bottom,
                  b = t.right;
                (e.fillStyle = i(n.fontColor, a.defaultFontColor)),
                  (e.font = c),
                  t.isHorizontal()
                    ? ((r = m + (b - m) / 2), (s = p + f), (o = b - m))
                    : ((r = 'left' === n.position ? m + f : b - f),
                      (s = p + (v - p) / 2),
                      (o = v - p),
                      (g = Math.PI * ('left' === n.position ? -0.5 : 0.5))),
                  e.save(),
                  e.translate(r, s),
                  e.rotate(g),
                  (e.textAlign = 'center'),
                  (e.textBaseline = 'middle');
                var x = n.text;
                if (w.isArray(x))
                  for (var y = 0, k = 0; k < x.length; ++k)
                    e.fillText(x[k], 0, y, o), (y += h);
                else e.fillText(x, 0, 0, o);
                e.restore();
              }
            },
          });
          function s(t, e) {
            var i = new r({ ctx: t.ctx, options: e, chart: t });
            a.configure(t, i, e), a.addBox(t, i), (t.titleBlock = i);
          }
          e.exports = {
            id: 'title',
            _element: r,
            beforeInit: function (t) {
              var e = t.options.title;
              e && s(t, e);
            },
            beforeUpdate: function (t) {
              var e = t.options.title,
                i = t.titleBlock;
              e
                ? (w.mergeIf(e, M.global.title),
                  i ? (a.configure(t, i, e), (i.options = e)) : s(t, e))
                : i && (a.removeBox(t, i), delete t.titleBlock);
            },
          };
        },
        { 26: 26, 27: 27, 31: 31, 46: 46 },
      ],
      54: [
        function (t, e, i) {
          'use strict';
          var n = t(33),
            a = t(34);
          e.exports = function () {
            var t = n.extend({
              getLabels: function () {
                var t = this.chart.data;
                return (
                  this.options.labels ||
                  (this.isHorizontal() ? t.xLabels : t.yLabels) ||
                  t.labels
                );
              },
              determineDataLimits: function () {
                var t,
                  e = this,
                  i = e.getLabels();
                (e.minIndex = 0),
                  (e.maxIndex = i.length - 1),
                  void 0 !== e.options.ticks.min &&
                    ((t = i.indexOf(e.options.ticks.min)),
                    (e.minIndex = -1 !== t ? t : e.minIndex)),
                  void 0 !== e.options.ticks.max &&
                    ((t = i.indexOf(e.options.ticks.max)),
                    (e.maxIndex = -1 !== t ? t : e.maxIndex)),
                  (e.min = i[e.minIndex]),
                  (e.max = i[e.maxIndex]);
              },
              buildTicks: function () {
                var t = this,
                  e = t.getLabels();
                t.ticks =
                  0 === t.minIndex && t.maxIndex === e.length - 1
                    ? e
                    : e.slice(t.minIndex, t.maxIndex + 1);
              },
              getLabelForIndex: function (t, e) {
                var i = this,
                  n = i.chart.data,
                  a = i.isHorizontal();
                return n.yLabels && !a
                  ? i.getRightValue(n.datasets[e].data[t])
                  : i.ticks[t - i.minIndex];
              },
              getPixelForValue: function (t, e) {
                var i,
                  n = this,
                  a = n.options.offset,
                  o = Math.max(n.maxIndex + 1 - n.minIndex - (a ? 0 : 1), 1);
                if (
                  (null != t && (i = n.isHorizontal() ? t.x : t.y),
                  void 0 !== i || (void 0 !== t && isNaN(e)))
                ) {
                  t = i || t;
                  var r = n.getLabels().indexOf(t);
                  e = -1 !== r ? r : e;
                }
                if (n.isHorizontal()) {
                  var s = n.width / o,
                    l = s * (e - n.minIndex);
                  return a && (l += s / 2), n.left + Math.round(l);
                }
                var u = n.height / o,
                  d = u * (e - n.minIndex);
                return a && (d += u / 2), n.top + Math.round(d);
              },
              getPixelForTick: function (t) {
                return this.getPixelForValue(
                  this.ticks[t],
                  t + this.minIndex,
                  null
                );
              },
              getValueForPixel: function (t) {
                var e = this,
                  i = e.options.offset,
                  n = Math.max(e._ticks.length - (i ? 0 : 1), 1),
                  a = e.isHorizontal(),
                  o = (a ? e.width : e.height) / n;
                return (
                  (t -= a ? e.left : e.top),
                  i && (t -= o / 2),
                  (t <= 0 ? 0 : Math.round(t / o)) + e.minIndex
                );
              },
              getBasePixel: function () {
                return this.bottom;
              },
            });
            a.registerScaleType('category', t, { position: 'bottom' });
          };
        },
        { 33: 33, 34: 34 },
      ],
      55: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            c = t(46),
            a = t(34),
            o = t(35);
          e.exports = function (t) {
            var e = {
                position: 'left',
                ticks: { callback: o.formatters.linear },
              },
              i = t.LinearScaleBase.extend({
                determineDataLimits: function () {
                  var r = this,
                    s = r.options,
                    l = r.chart,
                    t = l.data.datasets,
                    e = r.isHorizontal();
                  function u(t) {
                    return e ? t.xAxisID === r.id : t.yAxisID === r.id;
                  }
                  (r.min = null), (r.max = null);
                  var n = s.stacked;
                  if (
                    (void 0 === n &&
                      c.each(t, function (t, e) {
                        if (!n) {
                          var i = l.getDatasetMeta(e);
                          l.isDatasetVisible(e) &&
                            u(i) &&
                            void 0 !== i.stack &&
                            (n = !0);
                        }
                      }),
                    s.stacked || n)
                  ) {
                    var d = {};
                    c.each(t, function (t, e) {
                      var n = l.getDatasetMeta(e),
                        i = [
                          n.type,
                          void 0 === s.stacked && void 0 === n.stack ? e : '',
                          n.stack,
                        ].join('.');
                      void 0 === d[i] &&
                        (d[i] = { positiveValues: [], negativeValues: [] });
                      var a = d[i].positiveValues,
                        o = d[i].negativeValues;
                      l.isDatasetVisible(e) &&
                        u(n) &&
                        c.each(t.data, function (t, e) {
                          var i = +r.getRightValue(t);
                          isNaN(i) ||
                            n.data[e].hidden ||
                            ((a[e] = a[e] || 0),
                            (o[e] = o[e] || 0),
                            s.relativePoints
                              ? (a[e] = 100)
                              : i < 0
                              ? (o[e] += i)
                              : (a[e] += i));
                        });
                    }),
                      c.each(d, function (t) {
                        var e = t.positiveValues.concat(t.negativeValues),
                          i = c.min(e),
                          n = c.max(e);
                        (r.min = null === r.min ? i : Math.min(r.min, i)),
                          (r.max = null === r.max ? n : Math.max(r.max, n));
                      });
                  } else
                    c.each(t, function (t, e) {
                      var n = l.getDatasetMeta(e);
                      l.isDatasetVisible(e) &&
                        u(n) &&
                        c.each(t.data, function (t, e) {
                          var i = +r.getRightValue(t);
                          isNaN(i) ||
                            n.data[e].hidden ||
                            (null === r.min
                              ? (r.min = i)
                              : i < r.min && (r.min = i),
                            null === r.max
                              ? (r.max = i)
                              : i > r.max && (r.max = i));
                        });
                    });
                  (r.min = isFinite(r.min) && !isNaN(r.min) ? r.min : 0),
                    (r.max = isFinite(r.max) && !isNaN(r.max) ? r.max : 1),
                    this.handleTickRangeOptions();
                },
                getTickLimit: function () {
                  var t,
                    e = this.options.ticks;
                  if (this.isHorizontal())
                    t = Math.min(
                      e.maxTicksLimit ? e.maxTicksLimit : 11,
                      Math.ceil(this.width / 50)
                    );
                  else {
                    var i = c.valueOrDefault(
                      e.fontSize,
                      n.global.defaultFontSize
                    );
                    t = Math.min(
                      e.maxTicksLimit ? e.maxTicksLimit : 11,
                      Math.ceil(this.height / (2 * i))
                    );
                  }
                  return t;
                },
                handleDirectionalChanges: function () {
                  this.isHorizontal() || this.ticks.reverse();
                },
                getLabelForIndex: function (t, e) {
                  return +this.getRightValue(
                    this.chart.data.datasets[e].data[t]
                  );
                },
                getPixelForValue: function (t) {
                  var e = this,
                    i = e.start,
                    n = +e.getRightValue(t),
                    a = e.end - i;
                  return e.isHorizontal()
                    ? e.left + (e.width / a) * (n - i)
                    : e.bottom - (e.height / a) * (n - i);
                },
                getValueForPixel: function (t) {
                  var e = this,
                    i = e.isHorizontal(),
                    n = i ? e.width : e.height,
                    a = (i ? t - e.left : e.bottom - t) / n;
                  return e.start + (e.end - e.start) * a;
                },
                getPixelForTick: function (t) {
                  return this.getPixelForValue(this.ticksAsNumbers[t]);
                },
              });
            a.registerScaleType('linear', i, e);
          };
        },
        { 26: 26, 34: 34, 35: 35, 46: 46 },
      ],
      56: [
        function (t, e, i) {
          'use strict';
          var c = t(46),
            n = t(33);
          e.exports = function (t) {
            var e = c.noop;
            t.LinearScaleBase = n.extend({
              getRightValue: function (t) {
                return 'string' == typeof t
                  ? +t
                  : n.prototype.getRightValue.call(this, t);
              },
              handleTickRangeOptions: function () {
                var t = this,
                  e = t.options.ticks;
                if (e.beginAtZero) {
                  var i = c.sign(t.min),
                    n = c.sign(t.max);
                  i < 0 && n < 0 ? (t.max = 0) : 0 < i && 0 < n && (t.min = 0);
                }
                var a = void 0 !== e.min || void 0 !== e.suggestedMin,
                  o = void 0 !== e.max || void 0 !== e.suggestedMax;
                void 0 !== e.min
                  ? (t.min = e.min)
                  : void 0 !== e.suggestedMin &&
                    (null === t.min
                      ? (t.min = e.suggestedMin)
                      : (t.min = Math.min(t.min, e.suggestedMin))),
                  void 0 !== e.max
                    ? (t.max = e.max)
                    : void 0 !== e.suggestedMax &&
                      (null === t.max
                        ? (t.max = e.suggestedMax)
                        : (t.max = Math.max(t.max, e.suggestedMax))),
                  a !== o &&
                    t.min >= t.max &&
                    (a ? (t.max = t.min + 1) : (t.min = t.max - 1)),
                  t.min === t.max && (t.max++, e.beginAtZero || t.min--);
              },
              getTickLimit: e,
              handleDirectionalChanges: e,
              buildTicks: function () {
                var t = this,
                  e = t.options.ticks,
                  i = t.getTickLimit(),
                  n = {
                    maxTicks: (i = Math.max(2, i)),
                    min: e.min,
                    max: e.max,
                    precision: e.precision,
                    stepSize: c.valueOrDefault(e.fixedStepSize, e.stepSize),
                  },
                  a = (t.ticks = (function (t, e) {
                    var i,
                      n,
                      a,
                      o = [];
                    if (t.stepSize && 0 < t.stepSize) a = t.stepSize;
                    else {
                      var r = c.niceNum(e.max - e.min, !1);
                      (a = c.niceNum(r / (t.maxTicks - 1), !0)),
                        void 0 !== (n = t.precision) &&
                          ((i = Math.pow(10, n)), (a = Math.ceil(a * i) / i));
                    }
                    var s = Math.floor(e.min / a) * a,
                      l = Math.ceil(e.max / a) * a;
                    c.isNullOrUndef(t.min) ||
                      c.isNullOrUndef(t.max) ||
                      !t.stepSize ||
                      (c.almostWhole((t.max - t.min) / t.stepSize, a / 1e3) &&
                        ((s = t.min), (l = t.max)));
                    var u = (l - s) / a;
                    (u = c.almostEquals(u, Math.round(u), a / 1e3)
                      ? Math.round(u)
                      : Math.ceil(u)),
                      a < (n = 1) &&
                        ((n = Math.pow(10, 1 - Math.floor(c.log10(a)))),
                        (s = Math.round(s * n) / n),
                        (l = Math.round(l * n) / n)),
                      o.push(void 0 !== t.min ? t.min : s);
                    for (var d = 1; d < u; ++d)
                      o.push(Math.round((s + d * a) * n) / n);
                    return o.push(void 0 !== t.max ? t.max : l), o;
                  })(n, t));
                t.handleDirectionalChanges(),
                  (t.max = c.max(a)),
                  (t.min = c.min(a)),
                  e.reverse
                    ? (a.reverse(), (t.start = t.max), (t.end = t.min))
                    : ((t.start = t.min), (t.end = t.max));
              },
              convertTicksToLabels: function () {
                var t = this;
                (t.ticksAsNumbers = t.ticks.slice()),
                  (t.zeroLineIndex = t.ticks.indexOf(0)),
                  n.prototype.convertTicksToLabels.call(t);
              },
            });
          };
        },
        { 33: 33, 46: 46 },
      ],
      57: [
        function (t, e, i) {
          'use strict';
          var h = t(46),
            n = t(33),
            a = t(34),
            o = t(35);
          e.exports = function (c) {
            var t = {
                position: 'left',
                ticks: { callback: o.formatters.logarithmic },
              },
              e = n.extend({
                determineDataLimits: function () {
                  var r = this,
                    i = r.options,
                    s = r.chart,
                    t = s.data.datasets,
                    e = r.isHorizontal();
                  function l(t) {
                    return e ? t.xAxisID === r.id : t.yAxisID === r.id;
                  }
                  (r.min = null), (r.max = null), (r.minNotZero = null);
                  var n = i.stacked;
                  if (
                    (void 0 === n &&
                      h.each(t, function (t, e) {
                        if (!n) {
                          var i = s.getDatasetMeta(e);
                          s.isDatasetVisible(e) &&
                            l(i) &&
                            void 0 !== i.stack &&
                            (n = !0);
                        }
                      }),
                    i.stacked || n)
                  ) {
                    var u = {};
                    h.each(t, function (t, e) {
                      var a = s.getDatasetMeta(e),
                        o = [
                          a.type,
                          void 0 === i.stacked && void 0 === a.stack ? e : '',
                          a.stack,
                        ].join('.');
                      s.isDatasetVisible(e) &&
                        l(a) &&
                        (void 0 === u[o] && (u[o] = []),
                        h.each(t.data, function (t, e) {
                          var i = u[o],
                            n = +r.getRightValue(t);
                          isNaN(n) ||
                            a.data[e].hidden ||
                            n < 0 ||
                            ((i[e] = i[e] || 0), (i[e] += n));
                        }));
                    }),
                      h.each(u, function (t) {
                        if (0 < t.length) {
                          var e = h.min(t),
                            i = h.max(t);
                          (r.min = null === r.min ? e : Math.min(r.min, e)),
                            (r.max = null === r.max ? i : Math.max(r.max, i));
                        }
                      });
                  } else
                    h.each(t, function (t, e) {
                      var n = s.getDatasetMeta(e);
                      s.isDatasetVisible(e) &&
                        l(n) &&
                        h.each(t.data, function (t, e) {
                          var i = +r.getRightValue(t);
                          isNaN(i) ||
                            n.data[e].hidden ||
                            i < 0 ||
                            (null === r.min
                              ? (r.min = i)
                              : i < r.min && (r.min = i),
                            null === r.max
                              ? (r.max = i)
                              : i > r.max && (r.max = i),
                            0 !== i &&
                              (null === r.minNotZero || i < r.minNotZero) &&
                              (r.minNotZero = i));
                        });
                    });
                  this.handleTickRangeOptions();
                },
                handleTickRangeOptions: function () {
                  var t = this,
                    e = t.options.ticks,
                    i = h.valueOrDefault;
                  (t.min = i(e.min, t.min)),
                    (t.max = i(e.max, t.max)),
                    t.min === t.max &&
                      (0 !== t.min && null !== t.min
                        ? ((t.min = Math.pow(
                            10,
                            Math.floor(h.log10(t.min)) - 1
                          )),
                          (t.max = Math.pow(
                            10,
                            Math.floor(h.log10(t.max)) + 1
                          )))
                        : ((t.min = 1), (t.max = 10))),
                    null === t.min &&
                      (t.min = Math.pow(10, Math.floor(h.log10(t.max)) - 1)),
                    null === t.max &&
                      (t.max =
                        0 !== t.min
                          ? Math.pow(10, Math.floor(h.log10(t.min)) + 1)
                          : 10),
                    null === t.minNotZero &&
                      (0 < t.min
                        ? (t.minNotZero = t.min)
                        : t.max < 1
                        ? (t.minNotZero = Math.pow(
                            10,
                            Math.floor(h.log10(t.max))
                          ))
                        : (t.minNotZero = 1));
                },
                buildTicks: function () {
                  var t = this,
                    e = t.options.ticks,
                    i = !t.isHorizontal(),
                    n = { min: e.min, max: e.max },
                    a = (t.ticks = (function (t, e) {
                      var i,
                        n,
                        a = [],
                        o = h.valueOrDefault,
                        r = o(t.min, Math.pow(10, Math.floor(h.log10(e.min)))),
                        s = Math.floor(h.log10(e.max)),
                        l = Math.ceil(e.max / Math.pow(10, s));
                      0 === r
                        ? ((i = Math.floor(h.log10(e.minNotZero))),
                          (n = Math.floor(e.minNotZero / Math.pow(10, i))),
                          a.push(r),
                          (r = n * Math.pow(10, i)))
                        : ((i = Math.floor(h.log10(r))),
                          (n = Math.floor(r / Math.pow(10, i))));
                      for (
                        var u = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
                        a.push(r),
                          10 == ++n && ((n = 1), (u = 0 <= ++i ? 1 : u)),
                          (r = Math.round(n * Math.pow(10, i) * u) / u),
                          i < s || (i === s && n < l);

                      );
                      var d = o(t.max, r);
                      return a.push(d), a;
                    })(n, t));
                  (t.max = h.max(a)),
                    (t.min = h.min(a)),
                    e.reverse
                      ? ((i = !i), (t.start = t.max), (t.end = t.min))
                      : ((t.start = t.min), (t.end = t.max)),
                    i && a.reverse();
                },
                convertTicksToLabels: function () {
                  (this.tickValues = this.ticks.slice()),
                    n.prototype.convertTicksToLabels.call(this);
                },
                getLabelForIndex: function (t, e) {
                  return +this.getRightValue(
                    this.chart.data.datasets[e].data[t]
                  );
                },
                getPixelForTick: function (t) {
                  return this.getPixelForValue(this.tickValues[t]);
                },
                _getFirstTickValue: function (t) {
                  var e = Math.floor(h.log10(t));
                  return Math.floor(t / Math.pow(10, e)) * Math.pow(10, e);
                },
                getPixelForValue: function (t) {
                  var e,
                    i,
                    n,
                    a,
                    o,
                    r = this,
                    s = r.options.ticks.reverse,
                    l = h.log10,
                    u = r._getFirstTickValue(r.minNotZero),
                    d = 0;
                  return (
                    (t = +r.getRightValue(t)),
                    (o = s
                      ? ((n = r.end), (a = r.start), -1)
                      : ((n = r.start), (a = r.end), 1)),
                    (i = r.isHorizontal()
                      ? ((e = r.width), s ? r.right : r.left)
                      : ((e = r.height), (o *= -1), s ? r.top : r.bottom)),
                    t !== n &&
                      (0 === n &&
                        ((e -= d = h.getValueOrDefault(
                          r.options.ticks.fontSize,
                          c.defaults.global.defaultFontSize
                        )),
                        (n = u)),
                      0 !== t && (d += (e / (l(a) - l(n))) * (l(t) - l(n))),
                      (i += o * d)),
                    i
                  );
                },
                getValueForPixel: function (t) {
                  var e,
                    i,
                    n,
                    a,
                    o = this,
                    r = o.options.ticks.reverse,
                    s = h.log10,
                    l = o._getFirstTickValue(o.minNotZero);
                  if (
                    ((n = r ? ((i = o.end), o.start) : ((i = o.start), o.end)),
                    (a = o.isHorizontal()
                      ? ((e = o.width), r ? o.right - t : t - o.left)
                      : ((e = o.height), r ? t - o.top : o.bottom - t)) !== i)
                  ) {
                    if (0 === i) {
                      var u = h.getValueOrDefault(
                        o.options.ticks.fontSize,
                        c.defaults.global.defaultFontSize
                      );
                      (a -= u), (e -= u), (i = l);
                    }
                    (a *= s(n) - s(i)), (a /= e), (a = Math.pow(10, s(i) + a));
                  }
                  return a;
                },
              });
            a.registerScaleType('logarithmic', e, t);
          };
        },
        { 33: 33, 34: 34, 35: 35, 46: 46 },
      ],
      58: [
        function (t, e, i) {
          'use strict';
          var n = t(26),
            k = t(46),
            a = t(34),
            o = t(35);
          e.exports = function (e) {
            var v = n.global,
              t = {
                display: !0,
                animate: !0,
                position: 'chartArea',
                angleLines: {
                  display: !0,
                  color: 'rgba(0, 0, 0, 0.1)',
                  lineWidth: 1,
                },
                gridLines: { circular: !1 },
                ticks: {
                  showLabelBackdrop: !0,
                  backdropColor: 'rgba(255,255,255,0.75)',
                  backdropPaddingY: 2,
                  backdropPaddingX: 2,
                  callback: o.formatters.linear,
                },
                pointLabels: {
                  display: !0,
                  fontSize: 10,
                  callback: function (t) {
                    return t;
                  },
                },
              };
            function b(t) {
              var e = t.options;
              return e.angleLines.display || e.pointLabels.display
                ? t.chart.data.labels.length
                : 0;
            }
            function x(t) {
              var e = t.options.pointLabels,
                i = k.valueOrDefault(e.fontSize, v.defaultFontSize),
                n = k.valueOrDefault(e.fontStyle, v.defaultFontStyle),
                a = k.valueOrDefault(e.fontFamily, v.defaultFontFamily);
              return {
                size: i,
                style: n,
                family: a,
                font: k.fontString(i, n, a),
              };
            }
            function m(t, e, i, n, a) {
              return t === n || t === a
                ? { start: e - i / 2, end: e + i / 2 }
                : t < n || a < t
                ? { start: e - i - 5, end: e }
                : { start: e, end: e + i + 5 };
            }
            function y(t, e, i, n) {
              if (k.isArray(e))
                for (var a = i.y, o = 1.5 * n, r = 0; r < e.length; ++r)
                  t.fillText(e[r], i.x, a), (a += o);
              else t.fillText(e, i.x, i.y);
            }
            function s(t) {
              return k.isNumber(t) ? t : 0;
            }
            var i = e.LinearScaleBase.extend({
              setDimensions: function () {
                var t = this,
                  e = t.options,
                  i = e.ticks;
                (t.width = t.maxWidth),
                  (t.height = t.maxHeight),
                  (t.xCenter = Math.round(t.width / 2)),
                  (t.yCenter = Math.round(t.height / 2));
                var n = k.min([t.height, t.width]),
                  a = k.valueOrDefault(i.fontSize, v.defaultFontSize);
                t.drawingArea = e.display
                  ? n / 2 - (a / 2 + i.backdropPaddingY)
                  : n / 2;
              },
              determineDataLimits: function () {
                var a = this,
                  i = a.chart,
                  o = Number.POSITIVE_INFINITY,
                  r = Number.NEGATIVE_INFINITY;
                k.each(i.data.datasets, function (t, e) {
                  if (i.isDatasetVisible(e)) {
                    var n = i.getDatasetMeta(e);
                    k.each(t.data, function (t, e) {
                      var i = +a.getRightValue(t);
                      isNaN(i) ||
                        n.data[e].hidden ||
                        ((o = Math.min(i, o)), (r = Math.max(i, r)));
                    });
                  }
                }),
                  (a.min = o === Number.POSITIVE_INFINITY ? 0 : o),
                  (a.max = r === Number.NEGATIVE_INFINITY ? 0 : r),
                  a.handleTickRangeOptions();
              },
              getTickLimit: function () {
                var t = this.options.ticks,
                  e = k.valueOrDefault(t.fontSize, v.defaultFontSize);
                return Math.min(
                  t.maxTicksLimit ? t.maxTicksLimit : 11,
                  Math.ceil(this.drawingArea / (1.5 * e))
                );
              },
              convertTicksToLabels: function () {
                var t = this;
                e.LinearScaleBase.prototype.convertTicksToLabels.call(t),
                  (t.pointLabels = t.chart.data.labels.map(
                    t.options.pointLabels.callback,
                    t
                  ));
              },
              getLabelForIndex: function (t, e) {
                return +this.getRightValue(this.chart.data.datasets[e].data[t]);
              },
              fit: function () {
                var t, e;
                this.options.pointLabels.display
                  ? (function (t) {
                      var e,
                        i,
                        n,
                        a = x(t),
                        o = Math.min(t.height / 2, t.width / 2),
                        r = { r: t.width, l: 0, t: t.height, b: 0 },
                        s = {};
                      (t.ctx.font = a.font), (t._pointLabelSizes = []);
                      var l,
                        u,
                        d,
                        c = b(t);
                      for (e = 0; e < c; e++) {
                        (n = t.getPointPosition(e, o)),
                          (l = t.ctx),
                          (u = a.size),
                          (d = t.pointLabels[e] || ''),
                          (i = k.isArray(d)
                            ? {
                                w: k.longestText(l, l.font, d),
                                h: d.length * u + 1.5 * (d.length - 1) * u,
                              }
                            : { w: l.measureText(d).width, h: u }),
                          (t._pointLabelSizes[e] = i);
                        var h = t.getIndexAngle(e),
                          f = k.toDegrees(h) % 360,
                          g = m(f, n.x, i.w, 0, 180),
                          p = m(f, n.y, i.h, 90, 270);
                        g.start < r.l && ((r.l = g.start), (s.l = h)),
                          g.end > r.r && ((r.r = g.end), (s.r = h)),
                          p.start < r.t && ((r.t = p.start), (s.t = h)),
                          p.end > r.b && ((r.b = p.end), (s.b = h));
                      }
                      t.setReductions(o, r, s);
                    })(this)
                  : ((t = this),
                    (e = Math.min(t.height / 2, t.width / 2)),
                    (t.drawingArea = Math.round(e)),
                    t.setCenterPoint(0, 0, 0, 0));
              },
              setReductions: function (t, e, i) {
                var n = e.l / Math.sin(i.l),
                  a = Math.max(e.r - this.width, 0) / Math.sin(i.r),
                  o = -e.t / Math.cos(i.t),
                  r = -Math.max(e.b - this.height, 0) / Math.cos(i.b);
                (n = s(n)),
                  (a = s(a)),
                  (o = s(o)),
                  (r = s(r)),
                  (this.drawingArea = Math.min(
                    Math.round(t - (n + a) / 2),
                    Math.round(t - (o + r) / 2)
                  )),
                  this.setCenterPoint(n, a, o, r);
              },
              setCenterPoint: function (t, e, i, n) {
                var a = this,
                  o = a.width - e - a.drawingArea,
                  r = t + a.drawingArea,
                  s = i + a.drawingArea,
                  l = a.height - n - a.drawingArea;
                (a.xCenter = Math.round((r + o) / 2 + a.left)),
                  (a.yCenter = Math.round((s + l) / 2 + a.top));
              },
              getIndexAngle: function (t) {
                return (
                  t * ((2 * Math.PI) / b(this)) +
                  ((this.chart.options && this.chart.options.startAngle
                    ? this.chart.options.startAngle
                    : 0) *
                    Math.PI *
                    2) /
                    360
                );
              },
              getDistanceFromCenterForValue: function (t) {
                var e = this;
                if (null === t) return 0;
                var i = e.drawingArea / (e.max - e.min);
                return e.options.ticks.reverse
                  ? (e.max - t) * i
                  : (t - e.min) * i;
              },
              getPointPosition: function (t, e) {
                var i = this.getIndexAngle(t) - Math.PI / 2;
                return {
                  x: Math.round(Math.cos(i) * e) + this.xCenter,
                  y: Math.round(Math.sin(i) * e) + this.yCenter,
                };
              },
              getPointPositionForValue: function (t, e) {
                return this.getPointPosition(
                  t,
                  this.getDistanceFromCenterForValue(e)
                );
              },
              getBasePosition: function () {
                var t = this.min,
                  e = this.max;
                return this.getPointPositionForValue(
                  0,
                  this.beginAtZero
                    ? 0
                    : t < 0 && e < 0
                    ? e
                    : 0 < t && 0 < e
                    ? t
                    : 0
                );
              },
              draw: function () {
                var o = this,
                  t = o.options,
                  r = t.gridLines,
                  s = t.ticks,
                  l = k.valueOrDefault;
                if (t.display) {
                  var u = o.ctx,
                    d = this.getIndexAngle(0),
                    c = l(s.fontSize, v.defaultFontSize),
                    e = l(s.fontStyle, v.defaultFontStyle),
                    i = l(s.fontFamily, v.defaultFontFamily),
                    h = k.fontString(c, e, i);
                  k.each(o.ticks, function (t, e) {
                    if (0 < e || s.reverse) {
                      var i = o.getDistanceFromCenterForValue(
                        o.ticksAsNumbers[e]
                      );
                      if (
                        (r.display &&
                          0 !== e &&
                          (function (t, e, i, n) {
                            var a = t.ctx;
                            if (
                              ((a.strokeStyle = k.valueAtIndexOrDefault(
                                e.color,
                                n - 1
                              )),
                              (a.lineWidth = k.valueAtIndexOrDefault(
                                e.lineWidth,
                                n - 1
                              )),
                              t.options.gridLines.circular)
                            )
                              a.beginPath(),
                                a.arc(t.xCenter, t.yCenter, i, 0, 2 * Math.PI),
                                a.closePath(),
                                a.stroke();
                            else {
                              var o = b(t);
                              if (0 === o) return;
                              a.beginPath();
                              var r = t.getPointPosition(0, i);
                              a.moveTo(r.x, r.y);
                              for (var s = 1; s < o; s++)
                                (r = t.getPointPosition(s, i)),
                                  a.lineTo(r.x, r.y);
                              a.closePath(), a.stroke();
                            }
                          })(o, r, i, e),
                        s.display)
                      ) {
                        var n = l(s.fontColor, v.defaultFontColor);
                        if (
                          ((u.font = h),
                          u.save(),
                          u.translate(o.xCenter, o.yCenter),
                          u.rotate(d),
                          s.showLabelBackdrop)
                        ) {
                          var a = u.measureText(t).width;
                          (u.fillStyle = s.backdropColor),
                            u.fillRect(
                              -a / 2 - s.backdropPaddingX,
                              -i - c / 2 - s.backdropPaddingY,
                              a + 2 * s.backdropPaddingX,
                              c + 2 * s.backdropPaddingY
                            );
                        }
                        (u.textAlign = 'center'),
                          (u.textBaseline = 'middle'),
                          (u.fillStyle = n),
                          u.fillText(t, 0, -i),
                          u.restore();
                      }
                    }
                  }),
                    (t.angleLines.display || t.pointLabels.display) &&
                      (function (t) {
                        var e = t.ctx,
                          i = t.options,
                          n = i.angleLines,
                          a = i.pointLabels;
                        (e.lineWidth = n.lineWidth), (e.strokeStyle = n.color);
                        var o,
                          r,
                          s,
                          l,
                          u = t.getDistanceFromCenterForValue(
                            i.ticks.reverse ? t.min : t.max
                          ),
                          d = x(t);
                        e.textBaseline = 'top';
                        for (var c = b(t) - 1; 0 <= c; c--) {
                          if (n.display) {
                            var h = t.getPointPosition(c, u);
                            e.beginPath(),
                              e.moveTo(t.xCenter, t.yCenter),
                              e.lineTo(h.x, h.y),
                              e.stroke(),
                              e.closePath();
                          }
                          if (a.display) {
                            var f = t.getPointPosition(c, u + 5),
                              g = k.valueAtIndexOrDefault(
                                a.fontColor,
                                c,
                                v.defaultFontColor
                              );
                            (e.font = d.font), (e.fillStyle = g);
                            var p = t.getIndexAngle(c),
                              m = k.toDegrees(p);
                            (e.textAlign =
                              0 === (l = m) || 180 === l
                                ? 'center'
                                : l < 180
                                ? 'left'
                                : 'right'),
                              (o = m),
                              (r = t._pointLabelSizes[c]),
                              (s = f),
                              90 === o || 270 === o
                                ? (s.y -= r.h / 2)
                                : (270 < o || o < 90) && (s.y -= r.h),
                              y(e, t.pointLabels[c] || '', f, d.size);
                          }
                        }
                      })(o);
                }
              },
            });
            a.registerScaleType('radialLinear', i, t);
          };
        },
        { 26: 26, 34: 34, 35: 35, 46: 46 },
      ],
      59: [
        function (t, e, i) {
          'use strict';
          var x = t(1);
          x = 'function' == typeof x ? x : window.moment;
          var r = t(26),
            m = t(46),
            n = t(33),
            a = t(34),
            p = Number.MIN_SAFE_INTEGER || -9007199254740991,
            v = Number.MAX_SAFE_INTEGER || 9007199254740991,
            y = {
              millisecond: {
                common: !0,
                size: 1,
                steps: [1, 2, 5, 10, 20, 50, 100, 250, 500],
              },
              second: { common: !0, size: 1e3, steps: [1, 2, 5, 10, 15, 30] },
              minute: { common: !0, size: 6e4, steps: [1, 2, 5, 10, 15, 30] },
              hour: { common: !0, size: 36e5, steps: [1, 2, 3, 6, 12] },
              day: { common: !0, size: 864e5, steps: [1, 2, 5] },
              week: { common: !1, size: 6048e5, steps: [1, 2, 3, 4] },
              month: { common: !0, size: 2628e6, steps: [1, 2, 3] },
              quarter: { common: !1, size: 7884e6, steps: [1, 2, 3, 4] },
              year: { common: !0, size: 3154e7 },
            },
            k = Object.keys(y);
          function b(t, e) {
            return t - e;
          }
          function M(t) {
            var e,
              i,
              n,
              a = {},
              o = [];
            for (e = 0, i = t.length; e < i; ++e)
              a[(n = t[e])] || ((a[n] = !0), o.push(n));
            return o;
          }
          function w(t, e, i, n) {
            var a = (function (t, e, i) {
                for (var n, a, o, r = 0, s = t.length - 1; 0 <= r && r <= s; ) {
                  if (((a = t[(n = (r + s) >> 1) - 1] || null), (o = t[n]), !a))
                    return { lo: null, hi: o };
                  if (o[e] < i) r = n + 1;
                  else {
                    if (!(a[e] > i)) return { lo: a, hi: o };
                    s = n - 1;
                  }
                }
                return { lo: o, hi: null };
              })(t, e, i),
              o = a.lo ? (a.hi ? a.lo : t[t.length - 2]) : t[0],
              r = a.lo ? (a.hi ? a.hi : t[t.length - 1]) : t[1],
              s = r[e] - o[e],
              l = s ? (i - o[e]) / s : 0,
              u = (r[n] - o[n]) * l;
            return o[n] + u;
          }
          function C(t, e) {
            var i = e.parser,
              n = e.parser || e.format;
            return 'function' == typeof i
              ? i(t)
              : 'string' == typeof t && 'string' == typeof n
              ? x(t, n)
              : (t instanceof x || (t = x(t)),
                t.isValid() ? t : 'function' == typeof n ? n(t) : t);
          }
          function S(t, e) {
            if (m.isNullOrUndef(t)) return null;
            var i = e.options.time,
              n = C(e.getRightValue(t), i);
            return n.isValid()
              ? (i.round && n.startOf(i.round), n.valueOf())
              : null;
          }
          function _(t) {
            for (var e = k.indexOf(t) + 1, i = k.length; e < i; ++e)
              if (y[k[e]].common) return k[e];
          }
          function D(t, e, i, n) {
            var a,
              o = n.time,
              r =
                o.unit ||
                (function (t, e, i, n) {
                  var a,
                    o,
                    r,
                    s = k.length;
                  for (a = k.indexOf(t); a < s - 1; ++a)
                    if (
                      ((r = (o = y[k[a]]).steps
                        ? o.steps[o.steps.length - 1]
                        : v),
                      o.common && Math.ceil((i - e) / (r * o.size)) <= n)
                    )
                      return k[a];
                  return k[s - 1];
                })(o.minUnit, t, e, i),
              s = _(r),
              l = m.valueOrDefault(o.stepSize, o.unitStepSize),
              u = 'week' === r && o.isoWeekday,
              d = n.ticks.major.enabled,
              c = y[r],
              h = x(t),
              f = x(e),
              g = [];
            for (
              l ||
                (l = (function (t, e, i, n) {
                  var a,
                    o,
                    r,
                    s = e - t,
                    l = y[i],
                    u = l.size,
                    d = l.steps;
                  if (!d) return Math.ceil(s / (n * u));
                  for (
                    a = 0, o = d.length;
                    a < o && ((r = d[a]), !(Math.ceil(s / (u * r)) <= n));
                    ++a
                  );
                  return r;
                })(t, e, r, i)),
                u && ((h = h.isoWeekday(u)), (f = f.isoWeekday(u))),
                h = h.startOf(u ? 'day' : r),
                (f = f.startOf(u ? 'day' : r)) < e && f.add(1, r),
                a = x(h),
                d &&
                  s &&
                  !u &&
                  !o.round &&
                  (a.startOf(s), a.add(~~((h - a) / (c.size * l)) * l, r));
              a < f;
              a.add(l, r)
            )
              g.push(+a);
            return g.push(+a), g;
          }
          e.exports = function () {
            var t = n.extend({
              initialize: function () {
                if (!x)
                  throw new Error(
                    'Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com'
                  );
                this.mergeTicksOptions(), n.prototype.initialize.call(this);
              },
              update: function () {
                var t = this.options;
                return (
                  t.time &&
                    t.time.format &&
                    console.warn(
                      'options.time.format is deprecated and replaced by options.time.parser.'
                    ),
                  n.prototype.update.apply(this, arguments)
                );
              },
              getRightValue: function (t) {
                return (
                  t && void 0 !== t.t && (t = t.t),
                  n.prototype.getRightValue.call(this, t)
                );
              },
              determineDataLimits: function () {
                var t,
                  e,
                  i,
                  n,
                  a,
                  o,
                  r = this,
                  s = r.chart,
                  l = r.options.time,
                  u = l.unit || 'day',
                  d = v,
                  c = p,
                  h = [],
                  f = [],
                  g = [];
                for (t = 0, i = s.data.labels.length; t < i; ++t)
                  g.push(S(s.data.labels[t], r));
                for (t = 0, i = (s.data.datasets || []).length; t < i; ++t)
                  if (s.isDatasetVisible(t))
                    if (((a = s.data.datasets[t].data), m.isObject(a[0])))
                      for (f[t] = [], e = 0, n = a.length; e < n; ++e)
                        (o = S(a[e], r)), h.push(o), (f[t][e] = o);
                    else h.push.apply(h, g), (f[t] = g.slice(0));
                  else f[t] = [];
                g.length &&
                  ((g = M(g).sort(b)),
                  (d = Math.min(d, g[0])),
                  (c = Math.max(c, g[g.length - 1]))),
                  h.length &&
                    ((h = M(h).sort(b)),
                    (d = Math.min(d, h[0])),
                    (c = Math.max(c, h[h.length - 1]))),
                  (d = S(l.min, r) || d),
                  (c = S(l.max, r) || c),
                  (d = d === v ? +x().startOf(u) : d),
                  (c = c === p ? +x().endOf(u) + 1 : c),
                  (r.min = Math.min(d, c)),
                  (r.max = Math.max(d + 1, c)),
                  (r._horizontal = r.isHorizontal()),
                  (r._table = []),
                  (r._timestamps = { data: h, datasets: f, labels: g });
              },
              buildTicks: function () {
                var t,
                  e,
                  i,
                  n,
                  a,
                  o,
                  r,
                  s,
                  l,
                  u,
                  d,
                  c,
                  h = this,
                  f = h.min,
                  g = h.max,
                  p = h.options,
                  m = p.time,
                  v = [],
                  b = [];
                switch (p.ticks.source) {
                  case 'data':
                    v = h._timestamps.data;
                    break;
                  case 'labels':
                    v = h._timestamps.labels;
                    break;
                  case 'auto':
                  default:
                    v = D(f, g, h.getLabelCapacity(f), p);
                }
                for (
                  'ticks' === p.bounds &&
                    v.length &&
                    ((f = v[0]), (g = v[v.length - 1])),
                    f = S(m.min, h) || f,
                    g = S(m.max, h) || g,
                    t = 0,
                    e = v.length;
                  t < e;
                  ++t
                )
                  f <= (i = v[t]) && i <= g && b.push(i);
                return (
                  (h.min = f),
                  (h.max = g),
                  (h._unit =
                    m.unit ||
                    (function (t, e, i, n) {
                      var a,
                        o,
                        r = x.duration(x(n).diff(x(i)));
                      for (a = k.length - 1; a >= k.indexOf(e); a--)
                        if (((o = k[a]), y[o].common && r.as(o) >= t.length))
                          return o;
                      return k[e ? k.indexOf(e) : 0];
                    })(b, m.minUnit, h.min, h.max)),
                  (h._majorUnit = _(h._unit)),
                  (h._table = (function (t, e, i, n) {
                    if ('linear' === n || !t.length)
                      return [
                        { time: e, pos: 0 },
                        { time: i, pos: 1 },
                      ];
                    var a,
                      o,
                      r,
                      s,
                      l,
                      u = [],
                      d = [e];
                    for (a = 0, o = t.length; a < o; ++a)
                      e < (s = t[a]) && s < i && d.push(s);
                    for (d.push(i), a = 0, o = d.length; a < o; ++a)
                      (l = d[a + 1]),
                        (r = d[a - 1]),
                        (s = d[a]),
                        (void 0 !== r &&
                          void 0 !== l &&
                          Math.round((l + r) / 2) === s) ||
                          u.push({ time: s, pos: a / (o - 1) });
                    return u;
                  })(h._timestamps.data, f, g, p.distribution)),
                  (h._offsets =
                    ((n = h._table),
                    (a = b),
                    (o = f),
                    (r = g),
                    (c = d = 0),
                    (s = p).offset &&
                      a.length &&
                      (s.time.min ||
                        ((l = 1 < a.length ? a[1] : r),
                        (u = a[0]),
                        (d =
                          (w(n, 'time', l, 'pos') - w(n, 'time', u, 'pos')) /
                          2)),
                      s.time.max ||
                        ((l = a[a.length - 1]),
                        (u = 1 < a.length ? a[a.length - 2] : o),
                        (c =
                          (w(n, 'time', l, 'pos') - w(n, 'time', u, 'pos')) /
                          2))),
                    { left: d, right: c })),
                  (h._labelFormat = (function (t, e) {
                    var i,
                      n,
                      a,
                      o = t.length;
                    for (i = 0; i < o; i++) {
                      if (0 !== (n = C(t[i], e)).millisecond())
                        return 'MMM D, YYYY h:mm:ss.SSS a';
                      (0 === n.second() &&
                        0 === n.minute() &&
                        0 === n.hour()) ||
                        (a = !0);
                    }
                    return a ? 'MMM D, YYYY h:mm:ss a' : 'MMM D, YYYY';
                  })(h._timestamps.data, m)),
                  (function (t, e) {
                    var i,
                      n,
                      a,
                      o,
                      r = [];
                    for (i = 0, n = t.length; i < n; ++i)
                      (a = t[i]),
                        (o = !!e && a === +x(a).startOf(e)),
                        r.push({ value: a, major: o });
                    return r;
                  })(b, h._majorUnit)
                );
              },
              getLabelForIndex: function (t, e) {
                var i = this.chart.data,
                  n = this.options.time,
                  a = i.labels && t < i.labels.length ? i.labels[t] : '',
                  o = i.datasets[e].data[t];
                return (
                  m.isObject(o) && (a = this.getRightValue(o)),
                  n.tooltipFormat
                    ? C(a, n).format(n.tooltipFormat)
                    : 'string' == typeof a
                    ? a
                    : C(a, n).format(this._labelFormat)
                );
              },
              tickFormatFunction: function (t, e, i, n) {
                var a = this.options,
                  o = t.valueOf(),
                  r = a.time.displayFormats,
                  s = r[this._unit],
                  l = this._majorUnit,
                  u = r[l],
                  d = t.clone().startOf(l).valueOf(),
                  c = a.ticks.major,
                  h = c.enabled && l && u && o === d,
                  f = t.format(n || (h ? u : s)),
                  g = h ? c : a.ticks.minor,
                  p = m.valueOrDefault(g.callback, g.userCallback);
                return p ? p(f, e, i) : f;
              },
              convertTicksToLabels: function (t) {
                var e,
                  i,
                  n = [];
                for (e = 0, i = t.length; e < i; ++e)
                  n.push(this.tickFormatFunction(x(t[e].value), e, t));
                return n;
              },
              getPixelForOffset: function (t) {
                var e = this,
                  i = e._horizontal ? e.width : e.height,
                  n = e._horizontal ? e.left : e.top,
                  a = w(e._table, 'time', t, 'pos');
                return (
                  n +
                  (i * (e._offsets.left + a)) /
                    (e._offsets.left + 1 + e._offsets.right)
                );
              },
              getPixelForValue: function (t, e, i) {
                var n = null;
                if (
                  (void 0 !== e &&
                    void 0 !== i &&
                    (n = this._timestamps.datasets[i][e]),
                  null === n && (n = S(t, this)),
                  null !== n)
                )
                  return this.getPixelForOffset(n);
              },
              getPixelForTick: function (t) {
                var e = this.getTicks();
                return 0 <= t && t < e.length
                  ? this.getPixelForOffset(e[t].value)
                  : null;
              },
              getValueForPixel: function (t) {
                var e = this,
                  i = e._horizontal ? e.width : e.height,
                  n = e._horizontal ? e.left : e.top,
                  a =
                    (i ? (t - n) / i : 0) *
                      (e._offsets.left + 1 + e._offsets.left) -
                    e._offsets.right,
                  o = w(e._table, 'pos', a, 'time');
                return x(o);
              },
              getLabelWidth: function (t) {
                var e = this.options.ticks,
                  i = this.ctx.measureText(t).width,
                  n = m.toRadians(e.maxRotation),
                  a = Math.cos(n),
                  o = Math.sin(n);
                return (
                  i * a +
                  m.valueOrDefault(e.fontSize, r.global.defaultFontSize) * o
                );
              },
              getLabelCapacity: function (t) {
                var e = this.options.time.displayFormats.millisecond,
                  i = this.tickFormatFunction(x(t), 0, [], e),
                  n = this.getLabelWidth(i),
                  a = this.isHorizontal() ? this.width : this.height,
                  o = Math.floor(a / n);
                return 0 < o ? o : 1;
              },
            });
            a.registerScaleType('time', t, {
              position: 'bottom',
              distribution: 'linear',
              bounds: 'data',
              time: {
                parser: !1,
                format: !1,
                unit: !1,
                round: !1,
                displayFormat: !1,
                isoWeekday: !1,
                minUnit: 'millisecond',
                displayFormats: {
                  millisecond: 'h:mm:ss.SSS a',
                  second: 'h:mm:ss a',
                  minute: 'h:mm a',
                  hour: 'hA',
                  day: 'MMM D',
                  week: 'll',
                  month: 'MMM YYYY',
                  quarter: '[Q]Q - YYYY',
                  year: 'YYYY',
                },
              },
              ticks: { autoSkip: !1, source: 'auto', major: { enabled: !1 } },
            });
          };
        },
        { 1: 1, 26: 26, 33: 33, 34: 34, 46: 46 },
      ],
    },
    {},
    [7]
  )(7);
});
// Chosen, a Select Box Enhancer for jQuery and Protoype
// by Patrick Filler for Harvest, http://getharvest.com
//
// Version 0.9.10
// Full source at https://github.com/harvesthq/chosen
// Copyright (c) 2011 Harvest http://getharvest.com

// MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
// This file is generated by `cake build`, do not edit it by hand.

/*global Greenhouse*/

(function () {
  var SelectParser;

  SelectParser = (function () {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function (child) {
      if (child.nodeName.toUpperCase() === 'OPTGROUP') {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function (group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: group.label,
        children: 0,
        disabled: group.disabled,
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function (
      option,
      group_position,
      group_disabled
    ) {
      if (option.nodeName.toUpperCase() === 'OPTION') {
        if (option.text !== '') {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            selected: option.selected,
            disabled:
              group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            classes: option.className,
            style: option.style.cssText,
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true,
          });
        }
        return (this.options_index += 1);
      }
    };

    return SelectParser;
  })();

  SelectParser.select_to_array = function (select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  this.SelectParser = SelectParser;
}.call(this));

/*
Chosen source: generate output using 'cake build'
Copyright (c) 2011 by Harvest
*/

(function () {
  var AbstractChosen, root;

  root = this;

  AbstractChosen = (function () {
    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.finish_setup();
    }

    AbstractChosen.prototype.set_default_values = function () {
      var _this = this;
      this.click_test_action = function (evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function (evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.result_single_selected = null;
      this.allow_single_deselect =
        this.options.allow_single_deselect != null &&
        this.form_field.options[0] != null &&
        this.form_field.options[0].text === ''
          ? this.options.allow_single_deselect
          : false;
      this.disable_search_threshold =
        this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.search_split_words = !(
        this.options.disable_search_split_words || false
      );
      this.search_contains = this.options.search_contains || false;
      this.choices = 0;
      this.single_backstroke_delete =
        this.options.single_backstroke_delete || false;
      return (this.max_selected_options =
        this.options.max_selected_options || Infinity);
    };

    AbstractChosen.prototype.set_default_text = function () {
      if (this.form_field.getAttribute('data-placeholder')) {
        this.default_text = this.form_field.getAttribute('data-placeholder');
      } else if (this.is_multiple) {
        this.default_text =
          this.options.placeholder_text_multiple ||
          this.options.placeholder_text ||
          'Select Some Options';
      } else {
        this.default_text =
          this.options.placeholder_text_single ||
          this.options.placeholder_text ||
          Greenhouse.Translation.t('shared.tree.select_an_option');
      }
      return (this.results_none_found =
        this.form_field.getAttribute('data-no_results_text') ||
        this.options.no_results_text ||
        'No results match');
    };

    AbstractChosen.prototype.mouse_enter = function () {
      return (this.mouse_on_container = true);
    };

    AbstractChosen.prototype.mouse_leave = function () {
      return (this.mouse_on_container = false);
    };

    AbstractChosen.prototype.input_focus = function (evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout(function () {
            return _this.container_mousedown();
          }, 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function (evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout(function () {
          return _this.blur_test();
        }, 100);
      }
    };

    AbstractChosen.prototype.result_add_option = function (option) {
      var classes, style;
      if (!option.disabled) {
        option.dom_id = this.container_id + '_o_' + option.array_index;
        classes = option.selected && this.is_multiple ? [] : ['active-result'];
        if (option.selected) {
          classes.push('result-selected');
        }
        if (option.group_array_index != null) {
          classes.push('group-option');
        }
        if (option.classes !== '') {
          classes.push(option.classes);
        }
        style =
          option.style.cssText !== '' ? ' style="' + option.style + '"' : '';
        return (
          '<li id="' +
          option.dom_id +
          '" class="' +
          classes.join(' ') +
          '"' +
          style +
          '>' +
          option.html +
          '</li>'
        );
      } else {
        return '';
      }
    };

    AbstractChosen.prototype.results_update_field = function () {
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.result_single_selected = null;
      return this.results_build();
    };

    AbstractChosen.prototype.results_toggle = function () {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function (evt) {
      var results;

      if (this.results_showing) {
        results = this.winnow_results();
      } else {
        results = this.results_show();
      }

      // GREENHOUSE: triggers an event to the listener that no results were found
      $('.modify-tags').trigger('greenhouse.noResultsUpdated');
      // END

      return results;
    };

    AbstractChosen.prototype.keyup_checker = function (evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (
            this.is_multiple &&
            this.backstroke_length < 1 &&
            this.choices > 0
          ) {
            return this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            return this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            return this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          return true;
        case 9:
        case 38:
        case 40:
        case 16:
        case 91:
        case 17:
          break;
        default:
          return this.results_search();
      }
    };

    AbstractChosen.prototype.generate_field_id = function () {
      var new_id;
      new_id = this.generate_random_id();
      this.form_field.id = new_id;
      return new_id;
    };

    AbstractChosen.prototype.generate_random_char = function () {
      var chars, newchar, rand;
      chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      rand = Math.floor(Math.random() * chars.length);
      return (newchar = chars.substring(rand, rand + 1));
    };

    AbstractChosen.browser_is_supported = function () {
      if (window.navigator.appName === 'Microsoft Internet Explorer') {
        return document.documentMode >= 9;
      }
      if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
        return false;
      }
      if (/Android/i.test(window.navigator.userAgent)) {
        if (/Mobile/i.test(window.navigator.userAgent)) {
          return false;
        }
      }
      return true;
    };

    return AbstractChosen;
  })();

  root.AbstractChosen = AbstractChosen;
}.call(this));

/*
Chosen source: generate output using 'cake build'
Copyright (c) 2011 by Harvest
*/

(function () {
  var $,
    Chosen,
    get_side_border_padding,
    root,
    __hasProp = {}.hasOwnProperty,
    __extends = function (child, parent) {
      for (var key in parent) {
        if (__hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    };

  root = this;

  $ = jQuery;

  $.fn.extend({
    chosen: function (options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }
      return this.each(function (input_field) {
        var $this;
        $this = $(this);
        if (!$this.hasClass('chzn-done')) {
          return $this.data('chosen', new Chosen(this, options));
        }
      });
    },
  });

  Chosen = (function (_super) {
    __extends(Chosen, _super);

    function Chosen() {
      return Chosen.__super__.constructor.apply(this, arguments);
    }

    Chosen.prototype.setup = function () {
      this.form_field_jq = $(this.form_field);
      this.current_value = this.form_field_jq.val();
      return (this.is_rtl = this.form_field_jq.hasClass('chzn-rtl'));
    };

    Chosen.prototype.finish_setup = function () {
      return this.form_field_jq.addClass('chzn-done');
    };

    Chosen.prototype.set_up_html = function () {
      var container_div, container_props, dd_top, dd_width, sf_width;
      this.container_id = this.form_field.id.length
        ? this.form_field.id.replace(/[^\w]/g, '_')
        : this.generate_field_id();
      this.container_id += '_chzn';
      this.f_width = this.form_field_jq.outerWidth();
      container_props = {
        id: this.container_id,
        class: 'chzn-container' + (this.is_rtl ? ' chzn-rtl' : ''),
        style: 'width: ' + this.f_width + 'px;',
        title: this.form_field.title,
      };
      container_div = $('<div />', container_props);
      if (this.is_multiple) {
        container_div.html(
          '<ul class="chzn-choices"><li class="search-field"><input type="text" value="' +
            this.default_text +
            '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop" style="left:-9000px;"><ul class="chzn-results"></ul></div>'
        );
      } else {
        container_div.html(
          '<a href="#" class="chzn-single chzn-default" tabindex="-1"><span>' +
            this.default_text +
            '</span><div><b></b></div></a><div class="chzn-drop" style="left:-9000px;"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>'
        );
      }
      this.form_field_jq.hide().after(container_div);
      this.container = $('#' + this.container_id);
      this.container.addClass(
        'chzn-container-' + (this.is_multiple ? 'multi' : 'single')
      );
      this.dropdown = this.container.find('div.chzn-drop').first();
      dd_top = this.container.height();
      dd_width = this.f_width - get_side_border_padding(this.dropdown);
      this.dropdown.css({
        width: dd_width + 'px',
        top: dd_top + 'px',
      });
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chzn-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chzn-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chzn-search').first();
        this.selected_item = this.container.find('.chzn-single').first();
        sf_width =
          dd_width -
          get_side_border_padding(this.search_container) -
          get_side_border_padding(this.search_field);
        this.search_field.css({
          width: sf_width + 'px',
        });
      }
      this.results_build();
      this.set_tab_index();
      return this.form_field_jq.trigger('liszt:ready', {
        chosen: this,
      });
    };

    Chosen.prototype.register_observers = function () {
      var _this = this;
      this.container.mousedown(function (evt) {
        return _this.container_mousedown(evt);
      });
      this.container.mouseup(function (evt) {
        return _this.container_mouseup(evt);
      });
      this.container.mouseenter(function (evt) {
        return _this.mouse_enter(evt);
      });
      this.container.mouseleave(function (evt) {
        return _this.mouse_leave(evt);
      });
      this.search_results.mouseup(function (evt) {
        return _this.search_results_mouseup(evt);
      });
      this.search_results.mouseover(function (evt) {
        return _this.search_results_mouseover(evt);
      });
      this.search_results.mouseout(function (evt) {
        return _this.search_results_mouseout(evt);
      });
      this.form_field_jq.bind('liszt:updated', function (evt) {
        return _this.results_update_field(evt);
      });
      this.form_field_jq.bind('liszt:activate', function (evt) {
        return _this.activate_field(evt);
      });
      this.form_field_jq.bind('liszt:open', function (evt) {
        return _this.container_mousedown(evt);
      });
      this.search_field.blur(function (evt) {
        return _this.input_blur(evt);
      });
      this.search_field.keyup(function (evt) {
        // GREENHOUSE
        // orig: return _this.keyup_checker(evt);
        var ret = _this.keyup_checker(evt);
        if (
          typeof _this.options.for_tagging !== 'undefined' &&
          this.is_multiple
        ) {
          var searchText = $('<div/>')
            .text($.trim(_this.search_field.val()))
            .html();
          if (
            $('.tag_field_chzn .no-results').length === 0 &&
            searchText.length > 0
          ) {
            _this.no_results(searchText);
          }

          if ($('.tag_field_chzn .no-results').length > 0) {
            $('.modify-tags').trigger('greenhouse.noResultsUpdated');
          }
        }
        return ret;
        // END
      });
      this.search_field.keydown(function (evt) {
        return _this.keydown_checker(evt);
      });
      this.search_field.focus(function (evt) {
        return _this.input_focus(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.click(function (evt) {
          return _this.choices_click(evt);
        });
      } else {
        return this.container.click(function (evt) {
          return evt.preventDefault();
        });
      }
    };

    Chosen.prototype.search_field_disabled = function () {
      this.is_disabled = this.form_field_jq[0].disabled;
      if (this.is_disabled) {
        this.container.addClass('chzn-disabled');
        this.search_field[0].disabled = true;
        if (!this.is_multiple) {
          this.selected_item.unbind('focus', this.activate_action);
        }
        return this.close_field();
      } else {
        this.container.removeClass('chzn-disabled');
        this.search_field[0].disabled = false;
        if (!this.is_multiple) {
          return this.selected_item.bind('focus', this.activate_action);
        }
      }
    };

    Chosen.prototype.container_mousedown = function (evt) {
      var target_closelink;
      if (!this.is_disabled) {
        target_closelink =
          evt != null ? $(evt.target).hasClass('search-choice-close') : false;
        if (evt && evt.type === 'mousedown' && !this.results_showing) {
          evt.preventDefault();
        }
        if (!this.pending_destroy_click && !target_closelink) {
          if (!this.active_field) {
            if (this.is_multiple) {
              this.search_field.val('');
            }
            $(document).click(this.click_test_action);
            this.results_show();
          } else if (
            !this.is_multiple &&
            evt &&
            ($(evt.target)[0] === this.selected_item[0] ||
              $(evt.target).parents('a.chzn-single').length)
          ) {
            evt.preventDefault();
            this.results_toggle();
          }
          return this.activate_field();
        } else {
          return (this.pending_destroy_click = false);
        }
      }
    };

    Chosen.prototype.container_mouseup = function (evt) {
      if (evt.target.nodeName === 'ABBR' && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.blur_test = function (evt) {
      if (
        !this.active_field &&
        this.container.hasClass('chzn-container-active')
      ) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function () {
      $(document).unbind('click', this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass('chzn-container-active');
      this.winnow_results_clear();
      this.clear_backstroke();
      this.show_search_field_default();
      return this.search_field_scale();
    };

    Chosen.prototype.activate_field = function () {
      this.container.addClass('chzn-container-active');
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function (evt) {
      if ($(evt.target).parents('#' + this.container_id).length) {
        return (this.active_field = true);
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function () {
      var content, data, _i, _len, _ref;
      this.parsing = true;
      this.results_data = root.SelectParser.select_to_array(this.form_field);
      if (this.is_multiple && this.choices > 0) {
        this.search_choices.find('li.search-choice').remove();
        this.choices = 0;
      } else if (!this.is_multiple) {
        this.selected_item
          .addClass('chzn-default')
          .find('span')
          .text(this.default_text);
        if (
          this.disable_search ||
          this.form_field.options.length <= this.disable_search_threshold
        ) {
          this.container.addClass('chzn-container-single-nosearch');
        } else {
          this.container.removeClass('chzn-container-single-nosearch');
        }
      }
      content = '';
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        if (data.group) {
          content += this.result_add_group(data);
        } else if (!data.empty) {
          content += this.result_add_option(data);
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.selected_item
              .removeClass('chzn-default')
              .find('span')
              .text(data.text);
            if (this.allow_single_deselect) {
              this.single_deselect_control_build();
            }
          }
        }
      }
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      this.search_results.html(content);
      return (this.parsing = false);
    };

    Chosen.prototype.result_add_group = function (group) {
      if (!group.disabled) {
        group.dom_id = this.container_id + '_g_' + group.array_index;
        return (
          '<li id="' +
          group.dom_id +
          '" class="group-result">' +
          $('<div />').text(group.label).html() +
          '</li>'
        );
      } else {
        return '';
      }
    };

    Chosen.prototype.result_do_highlight = function (el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass('highlighted');
        maxHeight = parseInt(this.search_results.css('maxHeight'), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top =
          this.result_highlight.position().top +
          this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop(
            high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0
          );
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function () {
      if (this.result_highlight) {
        this.result_highlight.removeClass('highlighted');
      }
      return (this.result_highlight = null);
    };

    Chosen.prototype.results_show = function () {
      var dd_top;
      if (!this.is_multiple) {
        this.selected_item.addClass('chzn-single-with-drop');
        if (this.result_single_selected) {
          this.result_do_highlight(this.result_single_selected);
        }
      } else if (this.max_selected_options <= this.choices) {
        this.form_field_jq.trigger('liszt:maxselected', {
          chosen: this,
        });
        return false;
      }
      dd_top = this.is_multiple
        ? this.container.height()
        : this.container.height() - 1;
      this.form_field_jq.trigger('liszt:showing_dropdown', {
        chosen: this,
      });
      this.dropdown.css({
        top: dd_top + 'px',
        left: 0,
      });
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.search_field.val());
      return this.winnow_results();
    };

    Chosen.prototype.results_hide = function () {
      if (!this.is_multiple) {
        this.selected_item.removeClass('chzn-single-with-drop');
      }
      this.result_clear_highlight();
      this.form_field_jq.trigger('liszt:hiding_dropdown', {
        chosen: this,
      });
      this.dropdown.css({
        left: '-9000px',
      });
      return (this.results_showing = false);
    };

    Chosen.prototype.set_tab_index = function (el) {
      var ti;
      if (this.form_field_jq.attr('tabindex')) {
        ti = this.form_field_jq.attr('tabindex');
        this.form_field_jq.attr('tabindex', -1);
        return this.search_field.attr('tabindex', ti);
      }
    };

    Chosen.prototype.show_search_field_default = function () {
      if (this.is_multiple && this.choices < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass('default');
      } else {
        this.search_field.val('');
        return this.search_field.removeClass('default');
      }
    };

    Chosen.prototype.search_results_mouseup = function (evt) {
      var target;
      target = $(evt.target).hasClass('active-result')
        ? $(evt.target)
        : $(evt.target).parents('.active-result').first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function (evt) {
      var target;
      target = $(evt.target).hasClass('active-result')
        ? $(evt.target)
        : $(evt.target).parents('.active-result').first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function (evt) {
      if (
        $(evt.target).hasClass(
          'active-result' || $(evt.target).parents('.active-result').first()
        )
      ) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choices_click = function (evt) {
      evt.preventDefault();
      if (
        this.active_field &&
        !$(evt.target).hasClass(
          'search-choice' || $(evt.target).parents('.search-choice').first
        ) &&
        !this.results_showing
      ) {
        return this.results_show();
      }
    };

    Chosen.prototype.choice_build = function (item) {
      var choice_id,
        html,
        link,
        _this = this;
      if (this.is_multiple && this.max_selected_options <= this.choices) {
        this.form_field_jq.trigger('liszt:maxselected', {
          chosen: this,
        });
        return false;
      }
      choice_id = this.container_id + '_c_' + item.array_index;
      this.choices += 1;
      if (item.disabled) {
        html =
          '<li class="search-choice search-choice-disabled" id="' +
          choice_id +
          '"><span>' +
          item.html +
          '</span></li>';
      } else {
        html =
          '<li class="search-choice" id="' +
          choice_id +
          '"><span>' +
          item.html +
          '</span><a href="#" class="search-choice-close" rel="' +
          item.array_index +
          '"></a></li>';
      }
      this.search_container.before(html);
      link = $('#' + choice_id)
        .find('a')
        .first();
      return link.click(function (evt) {
        return _this.choice_destroy_link_click(evt);
      });
    };

    Chosen.prototype.choice_destroy_link_click = function (evt) {
      evt.preventDefault();
      if (!this.is_disabled) {
        this.pending_destroy_click = true;
        return this.choice_destroy($(evt.target));
      } else {
        return evt.stopPropagation;
      }
    };

    Chosen.prototype.choice_destroy = function (link) {
      if (this.result_deselect(link.attr('rel'))) {
        this.choices -= 1;
        this.show_search_field_default();
        if (
          this.is_multiple &&
          this.choices > 0 &&
          this.search_field.val().length < 1
        ) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function () {
      this.form_field.options[0].selected = true;
      this.selected_item.find('span').text(this.default_text);
      if (!this.is_multiple) {
        this.selected_item.addClass('chzn-default');
      }
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.form_field_jq.trigger('change');
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function () {
      this.current_value = this.form_field_jq.val();
      return this.selected_item.find('abbr').remove();
    };

    Chosen.prototype.result_select = function (evt) {
      var high, high_id, item, position;
      if (this.result_highlight) {
        high = this.result_highlight;
        high_id = high.attr('id');
        this.result_clear_highlight();
        if (this.is_multiple) {
          this.result_deactivate(high);
        } else {
          this.search_results
            .find('.result-selected')
            .removeClass('result-selected');
          this.result_single_selected = high;
          this.selected_item.removeClass('chzn-default');
        }
        high.addClass('result-selected');
        position = high_id.substr(high_id.lastIndexOf('_') + 1);
        item = this.results_data[position];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.selected_item.find('span').first().text(item.text);
          if (this.allow_single_deselect) {
            this.single_deselect_control_build();
          }
        }
        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
          this.results_hide();
        }
        this.search_field.val('');
        if (
          this.is_multiple ||
          this.form_field_jq.val() !== this.current_value
        ) {
          this.form_field_jq.trigger('change', {
            selected: this.form_field.options[item.options_index].value,
          });
        }
        this.current_value = this.form_field_jq.val();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.result_activate = function (el) {
      return el.addClass('active-result');
    };

    Chosen.prototype.result_deactivate = function (el) {
      return el.removeClass('active-result');
    };

    Chosen.prototype.result_deselect = function (pos) {
      var result, result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        result = $('#' + this.container_id + '_o_' + pos);
        result.removeClass('result-selected').addClass('active-result').show();
        this.result_clear_highlight();
        this.winnow_results();
        this.form_field_jq.trigger('change', {
          deselected: this.form_field.options[result_data.options_index].value,
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function () {
      if (
        this.allow_single_deselect &&
        this.selected_item.find('abbr').length < 1
      ) {
        return this.selected_item
          .find('span')
          .first()
          .after('<abbr class="search-choice-close"></abbr>');
      }
    };

    Chosen.prototype.winnow_results = function () {
      // exact_match is added to see if searched term found an exact match in the dropdown
      var exact_match,
        found,
        option,
        part,
        parts,
        regex,
        regexAnchor,
        result,
        result_id,
        results,
        searchText,
        startpos,
        text,
        zregex,
        _i,
        _j,
        _len,
        _len1,
        _ref;
      this.no_results_clear();
      results = 0;
      searchText =
        this.search_field.val() === this.default_text
          ? ''
          : $('<div/>').text($.trim(this.search_field.val())).html();
      regexAnchor = this.search_contains ? '' : '^';
      regex = new RegExp(
        regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'),
        'i'
      );
      zregex = new RegExp(
        searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'),
        'i'
      );
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (!option.disabled && !option.empty) {
          if (option.group) {
            $('#' + option.dom_id).css('display', 'none');
          } else if (!(this.is_multiple && option.selected)) {
            found = false;
            result_id = option.dom_id;
            result = $('#' + result_id);
            if (regex.test(option.html)) {
              found = true;
              results += 1;
            } else if (
              this.search_split_words &&
              (option.html.indexOf(' ') >= 0 || option.html.indexOf('[') === 0)
            ) {
              parts = option.html.replace(/\[|\]/g, '').split(' ');
              if (parts.length) {
                for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                  part = parts[_j];
                  if (regex.test(part)) {
                    found = true;
                    results += 1;
                  }
                }
              }
            }
            if (found) {
              if (searchText.length) {
                if (option.html === searchText) {
                  exact_match = true;
                }
                startpos = option.html.search(zregex);
                text =
                  option.html.substr(0, startpos + searchText.length) +
                  '</em>' +
                  option.html.substr(startpos + searchText.length);
                text =
                  text.substr(0, startpos) + '<em>' + text.substr(startpos);
              } else {
                text = option.html;
              }
              result.html(text);
              this.result_activate(result);
              if (option.group_array_index != null) {
                $('#' + this.results_data[option.group_array_index].dom_id).css(
                  'display',
                  'list-item'
                );
              }
            } else {
              if (
                this.result_highlight &&
                result_id === this.result_highlight.attr('id')
              ) {
                this.result_clear_highlight();
              }
              this.result_deactivate(result);
            }
          }
        }
      }

      if (searchText.length) {
        if ($(this.form_field).is('.tag-field') && !exact_match) {
          this.no_results(searchText);
        } else if (results < 1) {
          return this.no_results(searchText);
        }
      }

      return this.winnow_results_set_highlight();
    };

    Chosen.prototype.winnow_results_clear = function () {
      var li, lis, _i, _len, _results;
      this.search_field.val('');
      lis = this.search_results.find('li');
      _results = [];
      for (_i = 0, _len = lis.length; _i < _len; _i++) {
        li = lis[_i];
        li = $(li);
        if (li.hasClass('group-result')) {
          _results.push(li.css('display', 'auto'));
        } else if (!this.is_multiple || !li.hasClass('result-selected')) {
          _results.push(this.result_activate(li));
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Chosen.prototype.winnow_results_set_highlight = function () {
      var do_high, selected_results;
      if (!this.result_highlight) {
        selected_results = !this.is_multiple
          ? this.search_results.find('.result-selected.active-result')
          : [];
        do_high = selected_results.length
          ? selected_results.first()
          : this.search_results.find('.active-result').first();
        if (do_high != null) {
          return this.result_do_highlight(do_high);
        }
      }
    };

    Chosen.prototype.no_results = function (terms) {
      var no_results_html;
      no_results_html = $(
        '<li class="no-results">' +
          this.results_none_found +
          ' "<span></span>"</li>'
      );
      no_results_html.find('span').first().html(terms);
      return this.search_results.append(no_results_html);
    };

    Chosen.prototype.no_results_clear = function () {
      return this.search_results.find('.no-results').remove();
    };

    Chosen.prototype.keydown_arrow = function () {
      var first_active, next_sib;
      if (!this.result_highlight) {
        first_active = this.search_results.find('li.active-result').first();
        if (first_active) {
          this.result_do_highlight($(first_active));
        }
      } else if (this.results_showing) {
        next_sib = this.result_highlight.nextAll('li.active-result').first();
        if (next_sib) {
          this.result_do_highlight(next_sib);
        }
      }
      if (!this.results_showing) {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function () {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll('li.active-result');
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function () {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find('a').first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container
          .siblings('li.search-choice')
          .last();
        if (
          next_available_destroy.length &&
          !next_available_destroy.hasClass('search-choice-disabled')
        ) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass('search-choice-focus');
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function () {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass('search-choice-focus');
      }
      return (this.pending_backstroke = null);
    };

    Chosen.prototype.keydown_checker = function (evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.search_field.val().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          evt.preventDefault();
          // GREENHOUSE
          var $chznResults = $('.add-tags-select-container .chzn-results');
          if (
            $chznResults.find('.no-results').length > 0 &&
            $chznResults.find('.highlighted').length === 0
          ) {
            $('.tag-field').trigger('greenhouse.addtag');
          }
          // END
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          this.keydown_arrow();
          break;
      }
    };

    Chosen.prototype.search_field_scale = function () {
      var dd_top, div, h, style, style_block, styles, w, _i, _len;
      if (this.is_multiple) {
        h = 0;
        w = 0;
        style_block =
          'position:absolute; left: -1000px; top: -1000px; display:none;';
        styles = [
          'font-size',
          'font-style',
          'font-weight',
          'font-family',
          'line-height',
          'text-transform',
          'letter-spacing',
        ];
        for (_i = 0, _len = styles.length; _i < _len; _i++) {
          style = styles[_i];
          style_block += style + ':' + this.search_field.css(style) + ';';
        }
        div = $('<div />', {
          style: style_block,
        });
        div.text(this.search_field.val());
        $('body').append(div);
        w = div.width() + 25;
        div.remove();
        if (w > this.f_width - 10) {
          w = this.f_width - 10;
        }
        this.search_field.css({
          width: w + 'px',
        });
        dd_top = this.container.height();
        return this.dropdown.css({
          top: dd_top + 'px',
        });
      }
    };

    Chosen.prototype.generate_random_id = function () {
      var string;
      string =
        'sel' +
        this.generate_random_char() +
        this.generate_random_char() +
        this.generate_random_char();
      while ($('#' + string).length > 0) {
        string += this.generate_random_char();
      }
      return string;
    };

    return Chosen;
  })(AbstractChosen);

  root.Chosen = Chosen;

  get_side_border_padding = function (elmt) {
    var side_border_padding;
    return (side_border_padding = elmt.outerWidth() - elmt.width());
  };

  root.get_side_border_padding = get_side_border_padding;
}.call(this));
/**!

 @license
 handlebars v4.7.7

Copyright (C) 2011-2019 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
!function(a,b){"object"==typeof exports&&"object"==typeof module?module.exports=b():"function"==typeof define&&define.amd?define([],b):"object"==typeof exports?exports.Handlebars=b():a.Handlebars=b()}(this,function(){return function(a){function b(d){if(c[d])return c[d].exports;var e=c[d]={exports:{},id:d,loaded:!1};return a[d].call(e.exports,e,e.exports,b),e.loaded=!0,e.exports}var c={};return b.m=a,b.c=c,b.p="",b(0)}([function(a,b,c){"use strict";function d(){var a=r();return a.compile=function(b,c){return k.compile(b,c,a)},a.precompile=function(b,c){return k.precompile(b,c,a)},a.AST=i["default"],a.Compiler=k.Compiler,a.JavaScriptCompiler=m["default"],a.Parser=j.parser,a.parse=j.parse,a.parseWithoutProcessing=j.parseWithoutProcessing,a}var e=c(1)["default"];b.__esModule=!0;var f=c(2),g=e(f),h=c(45),i=e(h),j=c(46),k=c(51),l=c(52),m=e(l),n=c(49),o=e(n),p=c(44),q=e(p),r=g["default"].create,s=d();s.create=d,q["default"](s),s.Visitor=o["default"],s["default"]=s,b["default"]=s,a.exports=b["default"]},function(a,b){"use strict";b["default"]=function(a){return a&&a.__esModule?a:{"default":a}},b.__esModule=!0},function(a,b,c){"use strict";function d(){var a=new h.HandlebarsEnvironment;return n.extend(a,h),a.SafeString=j["default"],a.Exception=l["default"],a.Utils=n,a.escapeExpression=n.escapeExpression,a.VM=p,a.template=function(b){return p.template(b,a)},a}var e=c(3)["default"],f=c(1)["default"];b.__esModule=!0;var g=c(4),h=e(g),i=c(37),j=f(i),k=c(6),l=f(k),m=c(5),n=e(m),o=c(38),p=e(o),q=c(44),r=f(q),s=d();s.create=d,r["default"](s),s["default"]=s,b["default"]=s,a.exports=b["default"]},function(a,b){"use strict";b["default"]=function(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b["default"]=a,b},b.__esModule=!0},function(a,b,c){"use strict";function d(a,b,c){this.helpers=a||{},this.partials=b||{},this.decorators=c||{},i.registerDefaultHelpers(this),j.registerDefaultDecorators(this)}var e=c(1)["default"];b.__esModule=!0,b.HandlebarsEnvironment=d;var f=c(5),g=c(6),h=e(g),i=c(10),j=c(30),k=c(32),l=e(k),m=c(33),n="4.7.7";b.VERSION=n;var o=8;b.COMPILER_REVISION=o;var p=7;b.LAST_COMPATIBLE_COMPILER_REVISION=p;var q={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0 <4.3.0",8:">= 4.3.0"};b.REVISION_CHANGES=q;var r="[object Object]";d.prototype={constructor:d,logger:l["default"],log:l["default"].log,registerHelper:function(a,b){if(f.toString.call(a)===r){if(b)throw new h["default"]("Arg not supported with multiple helpers");f.extend(this.helpers,a)}else this.helpers[a]=b},unregisterHelper:function(a){delete this.helpers[a]},registerPartial:function(a,b){if(f.toString.call(a)===r)f.extend(this.partials,a);else{if("undefined"==typeof b)throw new h["default"]('Attempting to register a partial called "'+a+'" as undefined');this.partials[a]=b}},unregisterPartial:function(a){delete this.partials[a]},registerDecorator:function(a,b){if(f.toString.call(a)===r){if(b)throw new h["default"]("Arg not supported with multiple decorators");f.extend(this.decorators,a)}else this.decorators[a]=b},unregisterDecorator:function(a){delete this.decorators[a]},resetLoggedPropertyAccesses:function(){m.resetLoggedProperties()}};var s=l["default"].log;b.log=s,b.createFrame=f.createFrame,b.logger=l["default"]},function(a,b){"use strict";function c(a){return k[a]}function d(a){for(var b=1;b<arguments.length;b++)for(var c in arguments[b])Object.prototype.hasOwnProperty.call(arguments[b],c)&&(a[c]=arguments[b][c]);return a}function e(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1}function f(a){if("string"!=typeof a){if(a&&a.toHTML)return a.toHTML();if(null==a)return"";if(!a)return a+"";a=""+a}return m.test(a)?a.replace(l,c):a}function g(a){return!a&&0!==a||!(!p(a)||0!==a.length)}function h(a){var b=d({},a);return b._parent=a,b}function i(a,b){return a.path=b,a}function j(a,b){return(a?a+".":"")+b}b.__esModule=!0,b.extend=d,b.indexOf=e,b.escapeExpression=f,b.isEmpty=g,b.createFrame=h,b.blockParams=i,b.appendContextPath=j;var k={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},l=/[&<>"'`=]/g,m=/[&<>"'`=]/,n=Object.prototype.toString;b.toString=n;var o=function(a){return"function"==typeof a};o(/x/)&&(b.isFunction=o=function(a){return"function"==typeof a&&"[object Function]"===n.call(a)}),b.isFunction=o;var p=Array.isArray||function(a){return!(!a||"object"!=typeof a)&&"[object Array]"===n.call(a)};b.isArray=p},function(a,b,c){"use strict";function d(a,b){var c=b&&b.loc,g=void 0,h=void 0,i=void 0,j=void 0;c&&(g=c.start.line,h=c.end.line,i=c.start.column,j=c.end.column,a+=" - "+g+":"+i);for(var k=Error.prototype.constructor.call(this,a),l=0;l<f.length;l++)this[f[l]]=k[f[l]];Error.captureStackTrace&&Error.captureStackTrace(this,d);try{c&&(this.lineNumber=g,this.endLineNumber=h,e?(Object.defineProperty(this,"column",{value:i,enumerable:!0}),Object.defineProperty(this,"endColumn",{value:j,enumerable:!0})):(this.column=i,this.endColumn=j))}catch(m){}}var e=c(7)["default"];b.__esModule=!0;var f=["description","fileName","lineNumber","endLineNumber","message","name","number","stack"];d.prototype=new Error,b["default"]=d,a.exports=b["default"]},function(a,b,c){a.exports={"default":c(8),__esModule:!0}},function(a,b,c){var d=c(9);a.exports=function(a,b,c){return d.setDesc(a,b,c)}},function(a,b){var c=Object;a.exports={create:c.create,getProto:c.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:c.getOwnPropertyDescriptor,setDesc:c.defineProperty,setDescs:c.defineProperties,getKeys:c.keys,getNames:c.getOwnPropertyNames,getSymbols:c.getOwnPropertySymbols,each:[].forEach}},function(a,b,c){"use strict";function d(a){h["default"](a),j["default"](a),l["default"](a),n["default"](a),p["default"](a),r["default"](a),t["default"](a)}function e(a,b,c){a.helpers[b]&&(a.hooks[b]=a.helpers[b],c||delete a.helpers[b])}var f=c(1)["default"];b.__esModule=!0,b.registerDefaultHelpers=d,b.moveHelperToHooks=e;var g=c(11),h=f(g),i=c(12),j=f(i),k=c(25),l=f(k),m=c(26),n=f(m),o=c(27),p=f(o),q=c(28),r=f(q),s=c(29),t=f(s)},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5);b["default"]=function(a){a.registerHelper("blockHelperMissing",function(b,c){var e=c.inverse,f=c.fn;if(b===!0)return f(this);if(b===!1||null==b)return e(this);if(d.isArray(b))return b.length>0?(c.ids&&(c.ids=[c.name]),a.helpers.each(b,c)):e(this);if(c.data&&c.ids){var g=d.createFrame(c.data);g.contextPath=d.appendContextPath(c.data.contextPath,c.name),c={data:g}}return f(b,c)})},a.exports=b["default"]},function(a,b,c){(function(d){"use strict";var e=c(13)["default"],f=c(1)["default"];b.__esModule=!0;var g=c(5),h=c(6),i=f(h);b["default"]=function(a){a.registerHelper("each",function(a,b){function c(b,c,d){l&&(l.key=b,l.index=c,l.first=0===c,l.last=!!d,m&&(l.contextPath=m+b)),k+=f(a[b],{data:l,blockParams:g.blockParams([a[b],b],[m+b,null])})}if(!b)throw new i["default"]("Must pass iterator to #each");var f=b.fn,h=b.inverse,j=0,k="",l=void 0,m=void 0;if(b.data&&b.ids&&(m=g.appendContextPath(b.data.contextPath,b.ids[0])+"."),g.isFunction(a)&&(a=a.call(this)),b.data&&(l=g.createFrame(b.data)),a&&"object"==typeof a)if(g.isArray(a))for(var n=a.length;j<n;j++)j in a&&c(j,j,j===a.length-1);else if(d.Symbol&&a[d.Symbol.iterator]){for(var o=[],p=a[d.Symbol.iterator](),q=p.next();!q.done;q=p.next())o.push(q.value);a=o;for(var n=a.length;j<n;j++)c(j,j,j===a.length-1)}else!function(){var b=void 0;e(a).forEach(function(a){void 0!==b&&c(b,j-1),b=a,j++}),void 0!==b&&c(b,j-1,!0)}();return 0===j&&(k=h(this)),k})},a.exports=b["default"]}).call(b,function(){return this}())},function(a,b,c){a.exports={"default":c(14),__esModule:!0}},function(a,b,c){c(15),a.exports=c(21).Object.keys},function(a,b,c){var d=c(16);c(18)("keys",function(a){return function(b){return a(d(b))}})},function(a,b,c){var d=c(17);a.exports=function(a){return Object(d(a))}},function(a,b){a.exports=function(a){if(void 0==a)throw TypeError("Can't call method on  "+a);return a}},function(a,b,c){var d=c(19),e=c(21),f=c(24);a.exports=function(a,b){var c=(e.Object||{})[a]||Object[a],g={};g[a]=b(c),d(d.S+d.F*f(function(){c(1)}),"Object",g)}},function(a,b,c){var d=c(20),e=c(21),f=c(22),g="prototype",h=function(a,b,c){var i,j,k,l=a&h.F,m=a&h.G,n=a&h.S,o=a&h.P,p=a&h.B,q=a&h.W,r=m?e:e[b]||(e[b]={}),s=m?d:n?d[b]:(d[b]||{})[g];m&&(c=b);for(i in c)j=!l&&s&&i in s,j&&i in r||(k=j?s[i]:c[i],r[i]=m&&"function"!=typeof s[i]?c[i]:p&&j?f(k,d):q&&s[i]==k?function(a){var b=function(b){return this instanceof a?new a(b):a(b)};return b[g]=a[g],b}(k):o&&"function"==typeof k?f(Function.call,k):k,o&&((r[g]||(r[g]={}))[i]=k))};h.F=1,h.G=2,h.S=4,h.P=8,h.B=16,h.W=32,a.exports=h},function(a,b){var c=a.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=c)},function(a,b){var c=a.exports={version:"1.2.6"};"number"==typeof __e&&(__e=c)},function(a,b,c){var d=c(23);a.exports=function(a,b,c){if(d(a),void 0===b)return a;switch(c){case 1:return function(c){return a.call(b,c)};case 2:return function(c,d){return a.call(b,c,d)};case 3:return function(c,d,e){return a.call(b,c,d,e)}}return function(){return a.apply(b,arguments)}}},function(a,b){a.exports=function(a){if("function"!=typeof a)throw TypeError(a+" is not a function!");return a}},function(a,b){a.exports=function(a){try{return!!a()}catch(b){return!0}}},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(6),f=d(e);b["default"]=function(a){a.registerHelper("helperMissing",function(){if(1!==arguments.length)throw new f["default"]('Missing helper: "'+arguments[arguments.length-1].name+'"')})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(5),f=c(6),g=d(f);b["default"]=function(a){a.registerHelper("if",function(a,b){if(2!=arguments.length)throw new g["default"]("#if requires exactly one argument");return e.isFunction(a)&&(a=a.call(this)),!b.hash.includeZero&&!a||e.isEmpty(a)?b.inverse(this):b.fn(this)}),a.registerHelper("unless",function(b,c){if(2!=arguments.length)throw new g["default"]("#unless requires exactly one argument");return a.helpers["if"].call(this,b,{fn:c.inverse,inverse:c.fn,hash:c.hash})})},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){a.registerHelper("log",function(){for(var b=[void 0],c=arguments[arguments.length-1],d=0;d<arguments.length-1;d++)b.push(arguments[d]);var e=1;null!=c.hash.level?e=c.hash.level:c.data&&null!=c.data.level&&(e=c.data.level),b[0]=e,a.log.apply(a,b)})},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){a.registerHelper("lookup",function(a,b,c){return a?c.lookupProperty(a,b):a})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(5),f=c(6),g=d(f);b["default"]=function(a){a.registerHelper("with",function(a,b){if(2!=arguments.length)throw new g["default"]("#with requires exactly one argument");e.isFunction(a)&&(a=a.call(this));var c=b.fn;if(e.isEmpty(a))return b.inverse(this);var d=b.data;return b.data&&b.ids&&(d=e.createFrame(b.data),d.contextPath=e.appendContextPath(b.data.contextPath,b.ids[0])),c(a,{data:d,blockParams:e.blockParams([a],[d&&d.contextPath])})})},a.exports=b["default"]},function(a,b,c){"use strict";function d(a){g["default"](a)}var e=c(1)["default"];b.__esModule=!0,b.registerDefaultDecorators=d;var f=c(31),g=e(f)},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5);b["default"]=function(a){a.registerDecorator("inline",function(a,b,c,e){var f=a;return b.partials||(b.partials={},f=function(e,f){var g=c.partials;c.partials=d.extend({},g,b.partials);var h=a(e,f);return c.partials=g,h}),b.partials[e.args[0]]=e.fn,f})},a.exports=b["default"]},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5),e={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(a){if("string"==typeof a){var b=d.indexOf(e.methodMap,a.toLowerCase());a=b>=0?b:parseInt(a,10)}return a},log:function(a){if(a=e.lookupLevel(a),"undefined"!=typeof console&&e.lookupLevel(e.level)<=a){var b=e.methodMap[a];console[b]||(b="log");for(var c=arguments.length,d=Array(c>1?c-1:0),f=1;f<c;f++)d[f-1]=arguments[f];console[b].apply(console,d)}}};b["default"]=e,a.exports=b["default"]},function(a,b,c){"use strict";function d(a){var b=i(null);b.constructor=!1,b.__defineGetter__=!1,b.__defineSetter__=!1,b.__lookupGetter__=!1;var c=i(null);return c.__proto__=!1,{properties:{whitelist:l.createNewLookupObject(c,a.allowedProtoProperties),defaultValue:a.allowProtoPropertiesByDefault},methods:{whitelist:l.createNewLookupObject(b,a.allowedProtoMethods),defaultValue:a.allowProtoMethodsByDefault}}}function e(a,b,c){return"function"==typeof a?f(b.methods,c):f(b.properties,c)}function f(a,b){return void 0!==a.whitelist[b]?a.whitelist[b]===!0:void 0!==a.defaultValue?a.defaultValue:(g(b),!1)}function g(a){o[a]!==!0&&(o[a]=!0,n.log("error",'Handlebars: Access has been denied to resolve the property "'+a+'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'))}function h(){j(o).forEach(function(a){delete o[a]})}var i=c(34)["default"],j=c(13)["default"],k=c(3)["default"];b.__esModule=!0,b.createProtoAccessControl=d,b.resultIsAllowed=e,b.resetLoggedProperties=h;var l=c(36),m=c(32),n=k(m),o=i(null)},function(a,b,c){a.exports={"default":c(35),__esModule:!0}},function(a,b,c){var d=c(9);a.exports=function(a,b){return d.create(a,b)}},function(a,b,c){"use strict";function d(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];return f.extend.apply(void 0,[e(null)].concat(b))}var e=c(34)["default"];b.__esModule=!0,b.createNewLookupObject=d;var f=c(5)},function(a,b){"use strict";function c(a){this.string=a}b.__esModule=!0,c.prototype.toString=c.prototype.toHTML=function(){return""+this.string},b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(a){var b=a&&a[0]||1,c=v.COMPILER_REVISION;if(!(b>=v.LAST_COMPATIBLE_COMPILER_REVISION&&b<=v.COMPILER_REVISION)){if(b<v.LAST_COMPATIBLE_COMPILER_REVISION){var d=v.REVISION_CHANGES[c],e=v.REVISION_CHANGES[b];throw new u["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+d+") or downgrade your runtime to an older version ("+e+").")}throw new u["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+a[1]+").")}}function e(a,b){function c(c,d,e){e.hash&&(d=s.extend({},d,e.hash),e.ids&&(e.ids[0]=!0)),c=b.VM.resolvePartial.call(this,c,d,e);var f=s.extend({},e,{hooks:this.hooks,protoAccessControl:this.protoAccessControl}),g=b.VM.invokePartial.call(this,c,d,f);if(null==g&&b.compile&&(e.partials[e.name]=b.compile(c,a.compilerOptions,b),g=e.partials[e.name](d,f)),null!=g){if(e.indent){for(var h=g.split("\n"),i=0,j=h.length;i<j&&(h[i]||i+1!==j);i++)h[i]=e.indent+h[i];g=h.join("\n")}return g}throw new u["default"]("The partial "+e.name+" could not be compiled when running in runtime-only mode")}function d(b){function c(b){return""+a.main(g,b,g.helpers,g.partials,f,i,h)}var e=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],f=e.data;d._setup(e),!e.partial&&a.useData&&(f=j(b,f));var h=void 0,i=a.useBlockParams?[]:void 0;return a.useDepths&&(h=e.depths?b!=e.depths[0]?[b].concat(e.depths):e.depths:[b]),(c=k(a.main,c,g,e.depths||[],f,i))(b,e)}if(!b)throw new u["default"]("No environment passed to template");if(!a||!a.main)throw new u["default"]("Unknown template object: "+typeof a);a.main.decorator=a.main_d,b.VM.checkRevision(a.compiler);var e=a.compiler&&7===a.compiler[0],g={strict:function(a,b,c){if(!(a&&b in a))throw new u["default"]('"'+b+'" not defined in '+a,{loc:c});return g.lookupProperty(a,b)},lookupProperty:function(a,b){var c=a[b];return null==c?c:Object.prototype.hasOwnProperty.call(a,b)?c:y.resultIsAllowed(c,g.protoAccessControl,b)?c:void 0},lookup:function(a,b){for(var c=a.length,d=0;d<c;d++){var e=a[d]&&g.lookupProperty(a[d],b);if(null!=e)return a[d][b]}},lambda:function(a,b){return"function"==typeof a?a.call(b):a},escapeExpression:s.escapeExpression,invokePartial:c,fn:function(b){var c=a[b];return c.decorator=a[b+"_d"],c},programs:[],program:function(a,b,c,d,e){var g=this.programs[a],h=this.fn(a);return b||e||d||c?g=f(this,a,h,b,c,d,e):g||(g=this.programs[a]=f(this,a,h)),g},data:function(a,b){for(;a&&b--;)a=a._parent;return a},mergeIfNeeded:function(a,b){var c=a||b;return a&&b&&a!==b&&(c=s.extend({},b,a)),c},nullContext:n({}),noop:b.VM.noop,compilerInfo:a.compiler};return d.isTop=!0,d._setup=function(c){if(c.partial)g.protoAccessControl=c.protoAccessControl,g.helpers=c.helpers,g.partials=c.partials,g.decorators=c.decorators,g.hooks=c.hooks;else{var d=s.extend({},b.helpers,c.helpers);l(d,g),g.helpers=d,a.usePartial&&(g.partials=g.mergeIfNeeded(c.partials,b.partials)),(a.usePartial||a.useDecorators)&&(g.decorators=s.extend({},b.decorators,c.decorators)),g.hooks={},g.protoAccessControl=y.createProtoAccessControl(c);var f=c.allowCallsToHelperMissing||e;w.moveHelperToHooks(g,"helperMissing",f),w.moveHelperToHooks(g,"blockHelperMissing",f)}},d._child=function(b,c,d,e){if(a.useBlockParams&&!d)throw new u["default"]("must pass block params");if(a.useDepths&&!e)throw new u["default"]("must pass parent depths");return f(g,b,a[b],c,0,d,e)},d}function f(a,b,c,d,e,f,g){function h(b){var e=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],h=g;return!g||b==g[0]||b===a.nullContext&&null===g[0]||(h=[b].concat(g)),c(a,b,a.helpers,a.partials,e.data||d,f&&[e.blockParams].concat(f),h)}return h=k(c,h,a,g,d,f),h.program=b,h.depth=g?g.length:0,h.blockParams=e||0,h}function g(a,b,c){return a?a.call||c.name||(c.name=a,a=c.partials[a]):a="@partial-block"===c.name?c.data["partial-block"]:c.partials[c.name],a}function h(a,b,c){var d=c.data&&c.data["partial-block"];c.partial=!0,c.ids&&(c.data.contextPath=c.ids[0]||c.data.contextPath);var e=void 0;if(c.fn&&c.fn!==i&&!function(){c.data=v.createFrame(c.data);var a=c.fn;e=c.data["partial-block"]=function(b){var c=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];return c.data=v.createFrame(c.data),c.data["partial-block"]=d,a(b,c)},a.partials&&(c.partials=s.extend({},c.partials,a.partials))}(),void 0===a&&e&&(a=e),void 0===a)throw new u["default"]("The partial "+c.name+" could not be found");if(a instanceof Function)return a(b,c)}function i(){return""}function j(a,b){return b&&"root"in b||(b=b?v.createFrame(b):{},b.root=a),b}function k(a,b,c,d,e,f){if(a.decorator){var g={};b=a.decorator(b,g,c,d&&d[0],e,f,d),s.extend(b,g)}return b}function l(a,b){o(a).forEach(function(c){var d=a[c];a[c]=m(d,b)})}function m(a,b){var c=b.lookupProperty;return x.wrapHelper(a,function(a){return s.extend({lookupProperty:c},a)})}var n=c(39)["default"],o=c(13)["default"],p=c(3)["default"],q=c(1)["default"];b.__esModule=!0,b.checkRevision=d,b.template=e,b.wrapProgram=f,b.resolvePartial=g,b.invokePartial=h,b.noop=i;var r=c(5),s=p(r),t=c(6),u=q(t),v=c(4),w=c(10),x=c(43),y=c(33)},function(a,b,c){a.exports={"default":c(40),__esModule:!0}},function(a,b,c){c(41),a.exports=c(21).Object.seal},function(a,b,c){var d=c(42);c(18)("seal",function(a){return function(b){return a&&d(b)?a(b):b}})},function(a,b){a.exports=function(a){return"object"==typeof a?null!==a:"function"==typeof a}},function(a,b){"use strict";function c(a,b){if("function"!=typeof a)return a;var c=function(){var c=arguments[arguments.length-1];return arguments[arguments.length-1]=b(c),a.apply(this,arguments)};return c}b.__esModule=!0,b.wrapHelper=c},function(a,b){(function(c){"use strict";b.__esModule=!0,b["default"]=function(a){var b="undefined"!=typeof c?c:window,d=b.Handlebars;a.noConflict=function(){return b.Handlebars===a&&(b.Handlebars=d),a}},a.exports=b["default"]}).call(b,function(){return this}())},function(a,b){"use strict";b.__esModule=!0;var c={helpers:{helperExpression:function(a){return"SubExpression"===a.type||("MustacheStatement"===a.type||"BlockStatement"===a.type)&&!!(a.params&&a.params.length||a.hash)},scopedId:function(a){return/^\.|this\b/.test(a.original)},simpleId:function(a){return 1===a.parts.length&&!c.helpers.scopedId(a)&&!a.depth}}};b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b){if("Program"===a.type)return a;i["default"].yy=o,o.locInfo=function(a){return new o.SourceLocation(b&&b.srcName,a)};var c=i["default"].parse(a);return c}function e(a,b){var c=d(a,b),e=new k["default"](b);return e.accept(c)}var f=c(1)["default"],g=c(3)["default"];b.__esModule=!0,b.parseWithoutProcessing=d,b.parse=e;var h=c(47),i=f(h),j=c(48),k=f(j),l=c(50),m=g(l),n=c(5);b.parser=i["default"];var o={};n.extend(o,m)},function(a,b){"use strict";b.__esModule=!0;var c=function(){function a(){this.yy={}}var b={trace:function(){},yy:{},symbols_:{error:2,root:3,program:4,EOF:5,program_repetition0:6,statement:7,mustache:8,block:9,rawBlock:10,partial:11,partialBlock:12,content:13,COMMENT:14,CONTENT:15,openRawBlock:16,rawBlock_repetition0:17,END_RAW_BLOCK:18,OPEN_RAW_BLOCK:19,helperName:20,openRawBlock_repetition0:21,openRawBlock_option0:22,CLOSE_RAW_BLOCK:23,openBlock:24,block_option0:25,closeBlock:26,openInverse:27,block_option1:28,OPEN_BLOCK:29,openBlock_repetition0:30,openBlock_option0:31,openBlock_option1:32,CLOSE:33,OPEN_INVERSE:34,openInverse_repetition0:35,openInverse_option0:36,openInverse_option1:37,openInverseChain:38,OPEN_INVERSE_CHAIN:39,openInverseChain_repetition0:40,openInverseChain_option0:41,openInverseChain_option1:42,inverseAndProgram:43,INVERSE:44,inverseChain:45,inverseChain_option0:46,OPEN_ENDBLOCK:47,OPEN:48,mustache_repetition0:49,mustache_option0:50,OPEN_UNESCAPED:51,mustache_repetition1:52,mustache_option1:53,CLOSE_UNESCAPED:54,OPEN_PARTIAL:55,partialName:56,partial_repetition0:57,partial_option0:58,openPartialBlock:59,OPEN_PARTIAL_BLOCK:60,openPartialBlock_repetition0:61,openPartialBlock_option0:62,param:63,sexpr:64,OPEN_SEXPR:65,sexpr_repetition0:66,sexpr_option0:67,CLOSE_SEXPR:68,hash:69,hash_repetition_plus0:70,hashSegment:71,ID:72,EQUALS:73,blockParams:74,OPEN_BLOCK_PARAMS:75,blockParams_repetition_plus0:76,CLOSE_BLOCK_PARAMS:77,path:78,dataName:79,STRING:80,NUMBER:81,BOOLEAN:82,UNDEFINED:83,NULL:84,DATA:85,pathSegments:86,SEP:87,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"COMMENT",15:"CONTENT",18:"END_RAW_BLOCK",19:"OPEN_RAW_BLOCK",23:"CLOSE_RAW_BLOCK",29:"OPEN_BLOCK",33:"CLOSE",34:"OPEN_INVERSE",39:"OPEN_INVERSE_CHAIN",44:"INVERSE",47:"OPEN_ENDBLOCK",48:"OPEN",51:"OPEN_UNESCAPED",54:"CLOSE_UNESCAPED",55:"OPEN_PARTIAL",60:"OPEN_PARTIAL_BLOCK",65:"OPEN_SEXPR",68:"CLOSE_SEXPR",72:"ID",73:"EQUALS",75:"OPEN_BLOCK_PARAMS",77:"CLOSE_BLOCK_PARAMS",80:"STRING",81:"NUMBER",82:"BOOLEAN",83:"UNDEFINED",84:"NULL",85:"DATA",87:"SEP"},productions_:[0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[13,1],[10,3],[16,5],[9,4],[9,4],[24,6],[27,6],[38,6],[43,2],[45,3],[45,1],[26,3],[8,5],[8,5],[11,5],[12,3],[59,5],[63,1],[63,1],[64,5],[69,1],[71,3],[74,3],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[56,1],[56,1],[79,2],[78,1],[86,3],[86,1],[6,0],[6,2],[17,0],[17,2],[21,0],[21,2],[22,0],[22,1],[25,0],[25,1],[28,0],[28,1],[30,0],[30,2],[31,0],[31,1],[32,0],[32,1],[35,0],[35,2],[36,0],[36,1],[37,0],[37,1],[40,0],[40,2],[41,0],[41,1],[42,0],[42,1],[46,0],[46,1],[49,0],[49,2],[50,0],[50,1],[52,0],[52,2],[53,0],[53,1],[57,0],[57,2],[58,0],[58,1],[61,0],[61,2],[62,0],[62,1],[66,0],[66,2],[67,0],[67,1],[70,1],[70,2],[76,1],[76,2]],performAction:function(a,b,c,d,e,f,g){var h=f.length-1;switch(e){case 1:return f[h-1];case 2:this.$=d.prepareProgram(f[h]);break;case 3:this.$=f[h];break;case 4:this.$=f[h];break;case 5:this.$=f[h];break;case 6:this.$=f[h];break;case 7:this.$=f[h];break;case 8:this.$=f[h];break;case 9:this.$={type:"CommentStatement",value:d.stripComment(f[h]),strip:d.stripFlags(f[h],f[h]),loc:d.locInfo(this._$)};break;case 10:this.$={type:"ContentStatement",original:f[h],value:f[h],loc:d.locInfo(this._$)};break;case 11:this.$=d.prepareRawBlock(f[h-2],f[h-1],f[h],this._$);break;case 12:this.$={path:f[h-3],params:f[h-2],hash:f[h-1]};break;case 13:this.$=d.prepareBlock(f[h-3],f[h-2],f[h-1],f[h],!1,this._$);break;case 14:this.$=d.prepareBlock(f[h-3],f[h-2],f[h-1],f[h],!0,this._$);break;case 15:this.$={open:f[h-5],path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 16:this.$={path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 17:this.$={path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 18:this.$={strip:d.stripFlags(f[h-1],f[h-1]),program:f[h]};break;case 19:var i=d.prepareBlock(f[h-2],f[h-1],f[h],f[h],!1,this._$),j=d.prepareProgram([i],f[h-1].loc);j.chained=!0,this.$={strip:f[h-2].strip,program:j,chain:!0};break;case 20:this.$=f[h];break;case 21:this.$={path:f[h-1],strip:d.stripFlags(f[h-2],f[h])};break;case 22:this.$=d.prepareMustache(f[h-3],f[h-2],f[h-1],f[h-4],d.stripFlags(f[h-4],f[h]),this._$);break;case 23:this.$=d.prepareMustache(f[h-3],f[h-2],f[h-1],f[h-4],d.stripFlags(f[h-4],f[h]),this._$);break;case 24:this.$={type:"PartialStatement",name:f[h-3],params:f[h-2],hash:f[h-1],indent:"",strip:d.stripFlags(f[h-4],f[h]),loc:d.locInfo(this._$)};break;case 25:this.$=d.preparePartialBlock(f[h-2],f[h-1],f[h],this._$);break;case 26:this.$={path:f[h-3],params:f[h-2],hash:f[h-1],strip:d.stripFlags(f[h-4],f[h])};break;case 27:this.$=f[h];break;case 28:this.$=f[h];break;case 29:this.$={type:"SubExpression",path:f[h-3],params:f[h-2],hash:f[h-1],loc:d.locInfo(this._$)};break;case 30:this.$={type:"Hash",pairs:f[h],loc:d.locInfo(this._$)};break;case 31:this.$={type:"HashPair",key:d.id(f[h-2]),value:f[h],loc:d.locInfo(this._$)};break;case 32:this.$=d.id(f[h-1]);break;case 33:this.$=f[h];break;case 34:this.$=f[h];break;case 35:this.$={type:"StringLiteral",value:f[h],original:f[h],loc:d.locInfo(this._$)};break;case 36:this.$={type:"NumberLiteral",value:Number(f[h]),original:Number(f[h]),loc:d.locInfo(this._$)};break;case 37:this.$={type:"BooleanLiteral",value:"true"===f[h],original:"true"===f[h],loc:d.locInfo(this._$)};break;case 38:this.$={type:"UndefinedLiteral",original:void 0,value:void 0,loc:d.locInfo(this._$)};break;case 39:this.$={type:"NullLiteral",original:null,value:null,loc:d.locInfo(this._$)};break;case 40:this.$=f[h];break;case 41:this.$=f[h];break;case 42:this.$=d.preparePath(!0,f[h],this._$);break;case 43:this.$=d.preparePath(!1,f[h],this._$);break;case 44:f[h-2].push({part:d.id(f[h]),original:f[h],separator:f[h-1]}),this.$=f[h-2];break;case 45:this.$=[{part:d.id(f[h]),original:f[h]}];break;case 46:this.$=[];break;case 47:f[h-1].push(f[h]);break;case 48:this.$=[];break;case 49:f[h-1].push(f[h]);break;case 50:this.$=[];break;case 51:f[h-1].push(f[h]);break;case 58:this.$=[];break;case 59:f[h-1].push(f[h]);break;case 64:this.$=[];break;case 65:f[h-1].push(f[h]);break;case 70:this.$=[];break;case 71:f[h-1].push(f[h]);break;case 78:this.$=[];break;case 79:f[h-1].push(f[h]);break;case 82:this.$=[];break;case 83:f[h-1].push(f[h]);break;case 86:this.$=[];break;case 87:f[h-1].push(f[h]);break;case 90:this.$=[];break;case 91:f[h-1].push(f[h]);break;case 94:this.$=[];break;case 95:f[h-1].push(f[h]);break;case 98:this.$=[f[h]];break;case 99:f[h-1].push(f[h]);break;case 100:this.$=[f[h]];break;case 101:f[h-1].push(f[h])}},table:[{3:1,4:2,5:[2,46],6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:10,13:11,14:[1,12],15:[1,20],16:17,19:[1,23],24:15,27:16,29:[1,21],34:[1,22],39:[2,2],44:[2,2],47:[2,2],48:[1,13],51:[1,14],55:[1,18],59:19,60:[1,24]},{1:[2,1]},{5:[2,47],14:[2,47],15:[2,47],19:[2,47],29:[2,47],34:[2,47],39:[2,47],44:[2,47],47:[2,47],48:[2,47],51:[2,47],55:[2,47],60:[2,47]},{5:[2,3],14:[2,3],15:[2,3],19:[2,3],29:[2,3],34:[2,3],39:[2,3],44:[2,3],47:[2,3],48:[2,3],51:[2,3],55:[2,3],60:[2,3]},{5:[2,4],14:[2,4],15:[2,4],19:[2,4],29:[2,4],34:[2,4],39:[2,4],44:[2,4],47:[2,4],48:[2,4],51:[2,4],55:[2,4],60:[2,4]},{5:[2,5],14:[2,5],15:[2,5],19:[2,5],29:[2,5],34:[2,5],39:[2,5],44:[2,5],47:[2,5],48:[2,5],51:[2,5],55:[2,5],60:[2,5]},{5:[2,6],14:[2,6],15:[2,6],19:[2,6],29:[2,6],34:[2,6],39:[2,6],44:[2,6],47:[2,6],48:[2,6],51:[2,6],55:[2,6],60:[2,6]},{5:[2,7],14:[2,7],15:[2,7],19:[2,7],29:[2,7],34:[2,7],39:[2,7],44:[2,7],47:[2,7],48:[2,7],51:[2,7],55:[2,7],60:[2,7]},{5:[2,8],14:[2,8],15:[2,8],19:[2,8],29:[2,8],34:[2,8],39:[2,8],44:[2,8],47:[2,8],48:[2,8],51:[2,8],55:[2,8],60:[2,8]},{5:[2,9],14:[2,9],15:[2,9],19:[2,9],29:[2,9],34:[2,9],39:[2,9],44:[2,9],47:[2,9],48:[2,9],51:[2,9],55:[2,9],60:[2,9]},{20:25,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:36,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:37,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{4:38,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{15:[2,48],17:39,18:[2,48]},{20:41,56:40,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:44,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{5:[2,10],14:[2,10],15:[2,10],18:[2,10],19:[2,10],29:[2,10],34:[2,10],39:[2,10],44:[2,10],47:[2,10],48:[2,10],51:[2,10],55:[2,10],60:[2,10]},{20:45,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:46,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:47,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:41,56:48,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[2,78],49:49,65:[2,78],72:[2,78],80:[2,78],81:[2,78],82:[2,78],83:[2,78],84:[2,78],85:[2,78]},{23:[2,33],33:[2,33],54:[2,33],65:[2,33],68:[2,33],72:[2,33],75:[2,33],80:[2,33],81:[2,33],82:[2,33],83:[2,33],84:[2,33],85:[2,33]},{23:[2,34],33:[2,34],54:[2,34],65:[2,34],68:[2,34],72:[2,34],75:[2,34],80:[2,34],81:[2,34],82:[2,34],83:[2,34],84:[2,34],85:[2,34]},{23:[2,35],33:[2,35],54:[2,35],65:[2,35],68:[2,35],72:[2,35],75:[2,35],80:[2,35],81:[2,35],82:[2,35],83:[2,35],84:[2,35],85:[2,35]},{23:[2,36],33:[2,36],54:[2,36],65:[2,36],68:[2,36],72:[2,36],75:[2,36],80:[2,36],81:[2,36],82:[2,36],83:[2,36],84:[2,36],85:[2,36]},{23:[2,37],33:[2,37],54:[2,37],65:[2,37],68:[2,37],72:[2,37],75:[2,37],80:[2,37],81:[2,37],82:[2,37],83:[2,37],84:[2,37],85:[2,37]},{23:[2,38],33:[2,38],54:[2,38],65:[2,38],68:[2,38],72:[2,38],75:[2,38],80:[2,38],81:[2,38],82:[2,38],83:[2,38],84:[2,38],85:[2,38]},{23:[2,39],33:[2,39],54:[2,39],65:[2,39],68:[2,39],72:[2,39],75:[2,39],80:[2,39],81:[2,39],82:[2,39],83:[2,39],84:[2,39],85:[2,39]},{23:[2,43],33:[2,43],54:[2,43],65:[2,43],68:[2,43],72:[2,43],75:[2,43],80:[2,43],81:[2,43],82:[2,43],83:[2,43],84:[2,43],85:[2,43],87:[1,50]},{72:[1,35],86:51},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{52:52,54:[2,82],65:[2,82],72:[2,82],80:[2,82],81:[2,82],82:[2,82],83:[2,82],84:[2,82],85:[2,82]},{25:53,38:55,39:[1,57],43:56,44:[1,58],45:54,47:[2,54]},{28:59,43:60,44:[1,58],47:[2,56]},{13:62,15:[1,20],18:[1,61]},{33:[2,86],57:63,65:[2,86],72:[2,86],80:[2,86],81:[2,86],82:[2,86],83:[2,86],84:[2,86],85:[2,86]},{33:[2,40],65:[2,40],72:[2,40],80:[2,40],81:[2,40],82:[2,40],83:[2,40],84:[2,40],85:[2,40]},{
33:[2,41],65:[2,41],72:[2,41],80:[2,41],81:[2,41],82:[2,41],83:[2,41],84:[2,41],85:[2,41]},{20:64,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:65,47:[1,66]},{30:67,33:[2,58],65:[2,58],72:[2,58],75:[2,58],80:[2,58],81:[2,58],82:[2,58],83:[2,58],84:[2,58],85:[2,58]},{33:[2,64],35:68,65:[2,64],72:[2,64],75:[2,64],80:[2,64],81:[2,64],82:[2,64],83:[2,64],84:[2,64],85:[2,64]},{21:69,23:[2,50],65:[2,50],72:[2,50],80:[2,50],81:[2,50],82:[2,50],83:[2,50],84:[2,50],85:[2,50]},{33:[2,90],61:70,65:[2,90],72:[2,90],80:[2,90],81:[2,90],82:[2,90],83:[2,90],84:[2,90],85:[2,90]},{20:74,33:[2,80],50:71,63:72,64:75,65:[1,43],69:73,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{72:[1,79]},{23:[2,42],33:[2,42],54:[2,42],65:[2,42],68:[2,42],72:[2,42],75:[2,42],80:[2,42],81:[2,42],82:[2,42],83:[2,42],84:[2,42],85:[2,42],87:[1,50]},{20:74,53:80,54:[2,84],63:81,64:75,65:[1,43],69:82,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:83,47:[1,66]},{47:[2,55]},{4:84,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{47:[2,20]},{20:85,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:86,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{26:87,47:[1,66]},{47:[2,57]},{5:[2,11],14:[2,11],15:[2,11],19:[2,11],29:[2,11],34:[2,11],39:[2,11],44:[2,11],47:[2,11],48:[2,11],51:[2,11],55:[2,11],60:[2,11]},{15:[2,49],18:[2,49]},{20:74,33:[2,88],58:88,63:89,64:75,65:[1,43],69:90,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{65:[2,94],66:91,68:[2,94],72:[2,94],80:[2,94],81:[2,94],82:[2,94],83:[2,94],84:[2,94],85:[2,94]},{5:[2,25],14:[2,25],15:[2,25],19:[2,25],29:[2,25],34:[2,25],39:[2,25],44:[2,25],47:[2,25],48:[2,25],51:[2,25],55:[2,25],60:[2,25]},{20:92,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,31:93,33:[2,60],63:94,64:75,65:[1,43],69:95,70:76,71:77,72:[1,78],75:[2,60],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,66],36:96,63:97,64:75,65:[1,43],69:98,70:76,71:77,72:[1,78],75:[2,66],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,22:99,23:[2,52],63:100,64:75,65:[1,43],69:101,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,92],62:102,63:103,64:75,65:[1,43],69:104,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,105]},{33:[2,79],65:[2,79],72:[2,79],80:[2,79],81:[2,79],82:[2,79],83:[2,79],84:[2,79],85:[2,79]},{33:[2,81]},{23:[2,27],33:[2,27],54:[2,27],65:[2,27],68:[2,27],72:[2,27],75:[2,27],80:[2,27],81:[2,27],82:[2,27],83:[2,27],84:[2,27],85:[2,27]},{23:[2,28],33:[2,28],54:[2,28],65:[2,28],68:[2,28],72:[2,28],75:[2,28],80:[2,28],81:[2,28],82:[2,28],83:[2,28],84:[2,28],85:[2,28]},{23:[2,30],33:[2,30],54:[2,30],68:[2,30],71:106,72:[1,107],75:[2,30]},{23:[2,98],33:[2,98],54:[2,98],68:[2,98],72:[2,98],75:[2,98]},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],73:[1,108],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{23:[2,44],33:[2,44],54:[2,44],65:[2,44],68:[2,44],72:[2,44],75:[2,44],80:[2,44],81:[2,44],82:[2,44],83:[2,44],84:[2,44],85:[2,44],87:[2,44]},{54:[1,109]},{54:[2,83],65:[2,83],72:[2,83],80:[2,83],81:[2,83],82:[2,83],83:[2,83],84:[2,83],85:[2,83]},{54:[2,85]},{5:[2,13],14:[2,13],15:[2,13],19:[2,13],29:[2,13],34:[2,13],39:[2,13],44:[2,13],47:[2,13],48:[2,13],51:[2,13],55:[2,13],60:[2,13]},{38:55,39:[1,57],43:56,44:[1,58],45:111,46:110,47:[2,76]},{33:[2,70],40:112,65:[2,70],72:[2,70],75:[2,70],80:[2,70],81:[2,70],82:[2,70],83:[2,70],84:[2,70],85:[2,70]},{47:[2,18]},{5:[2,14],14:[2,14],15:[2,14],19:[2,14],29:[2,14],34:[2,14],39:[2,14],44:[2,14],47:[2,14],48:[2,14],51:[2,14],55:[2,14],60:[2,14]},{33:[1,113]},{33:[2,87],65:[2,87],72:[2,87],80:[2,87],81:[2,87],82:[2,87],83:[2,87],84:[2,87],85:[2,87]},{33:[2,89]},{20:74,63:115,64:75,65:[1,43],67:114,68:[2,96],69:116,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,117]},{32:118,33:[2,62],74:119,75:[1,120]},{33:[2,59],65:[2,59],72:[2,59],75:[2,59],80:[2,59],81:[2,59],82:[2,59],83:[2,59],84:[2,59],85:[2,59]},{33:[2,61],75:[2,61]},{33:[2,68],37:121,74:122,75:[1,120]},{33:[2,65],65:[2,65],72:[2,65],75:[2,65],80:[2,65],81:[2,65],82:[2,65],83:[2,65],84:[2,65],85:[2,65]},{33:[2,67],75:[2,67]},{23:[1,123]},{23:[2,51],65:[2,51],72:[2,51],80:[2,51],81:[2,51],82:[2,51],83:[2,51],84:[2,51],85:[2,51]},{23:[2,53]},{33:[1,124]},{33:[2,91],65:[2,91],72:[2,91],80:[2,91],81:[2,91],82:[2,91],83:[2,91],84:[2,91],85:[2,91]},{33:[2,93]},{5:[2,22],14:[2,22],15:[2,22],19:[2,22],29:[2,22],34:[2,22],39:[2,22],44:[2,22],47:[2,22],48:[2,22],51:[2,22],55:[2,22],60:[2,22]},{23:[2,99],33:[2,99],54:[2,99],68:[2,99],72:[2,99],75:[2,99]},{73:[1,108]},{20:74,63:125,64:75,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,23],14:[2,23],15:[2,23],19:[2,23],29:[2,23],34:[2,23],39:[2,23],44:[2,23],47:[2,23],48:[2,23],51:[2,23],55:[2,23],60:[2,23]},{47:[2,19]},{47:[2,77]},{20:74,33:[2,72],41:126,63:127,64:75,65:[1,43],69:128,70:76,71:77,72:[1,78],75:[2,72],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,24],14:[2,24],15:[2,24],19:[2,24],29:[2,24],34:[2,24],39:[2,24],44:[2,24],47:[2,24],48:[2,24],51:[2,24],55:[2,24],60:[2,24]},{68:[1,129]},{65:[2,95],68:[2,95],72:[2,95],80:[2,95],81:[2,95],82:[2,95],83:[2,95],84:[2,95],85:[2,95]},{68:[2,97]},{5:[2,21],14:[2,21],15:[2,21],19:[2,21],29:[2,21],34:[2,21],39:[2,21],44:[2,21],47:[2,21],48:[2,21],51:[2,21],55:[2,21],60:[2,21]},{33:[1,130]},{33:[2,63]},{72:[1,132],76:131},{33:[1,133]},{33:[2,69]},{15:[2,12],18:[2,12]},{14:[2,26],15:[2,26],19:[2,26],29:[2,26],34:[2,26],47:[2,26],48:[2,26],51:[2,26],55:[2,26],60:[2,26]},{23:[2,31],33:[2,31],54:[2,31],68:[2,31],72:[2,31],75:[2,31]},{33:[2,74],42:134,74:135,75:[1,120]},{33:[2,71],65:[2,71],72:[2,71],75:[2,71],80:[2,71],81:[2,71],82:[2,71],83:[2,71],84:[2,71],85:[2,71]},{33:[2,73],75:[2,73]},{23:[2,29],33:[2,29],54:[2,29],65:[2,29],68:[2,29],72:[2,29],75:[2,29],80:[2,29],81:[2,29],82:[2,29],83:[2,29],84:[2,29],85:[2,29]},{14:[2,15],15:[2,15],19:[2,15],29:[2,15],34:[2,15],39:[2,15],44:[2,15],47:[2,15],48:[2,15],51:[2,15],55:[2,15],60:[2,15]},{72:[1,137],77:[1,136]},{72:[2,100],77:[2,100]},{14:[2,16],15:[2,16],19:[2,16],29:[2,16],34:[2,16],44:[2,16],47:[2,16],48:[2,16],51:[2,16],55:[2,16],60:[2,16]},{33:[1,138]},{33:[2,75]},{33:[2,32]},{72:[2,101],77:[2,101]},{14:[2,17],15:[2,17],19:[2,17],29:[2,17],34:[2,17],39:[2,17],44:[2,17],47:[2,17],48:[2,17],51:[2,17],55:[2,17],60:[2,17]}],defaultActions:{4:[2,1],54:[2,55],56:[2,20],60:[2,57],73:[2,81],82:[2,85],86:[2,18],90:[2,89],101:[2,53],104:[2,93],110:[2,19],111:[2,77],116:[2,97],119:[2,63],122:[2,69],135:[2,75],136:[2,32]},parseError:function(a,b){throw new Error(a)},parse:function(a){function b(){var a;return a=c.lexer.lex()||1,"number"!=typeof a&&(a=c.symbols_[a]||a),a}var c=this,d=[0],e=[null],f=[],g=this.table,h="",i=0,j=0,k=0;this.lexer.setInput(a),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,this.yy.parser=this,"undefined"==typeof this.lexer.yylloc&&(this.lexer.yylloc={});var l=this.lexer.yylloc;f.push(l);var m=this.lexer.options&&this.lexer.options.ranges;"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var n,o,p,q,r,s,t,u,v,w={};;){if(p=d[d.length-1],this.defaultActions[p]?q=this.defaultActions[p]:(null!==n&&"undefined"!=typeof n||(n=b()),q=g[p]&&g[p][n]),"undefined"==typeof q||!q.length||!q[0]){var x="";if(!k){v=[];for(s in g[p])this.terminals_[s]&&s>2&&v.push("'"+this.terminals_[s]+"'");x=this.lexer.showPosition?"Parse error on line "+(i+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+v.join(", ")+", got '"+(this.terminals_[n]||n)+"'":"Parse error on line "+(i+1)+": Unexpected "+(1==n?"end of input":"'"+(this.terminals_[n]||n)+"'"),this.parseError(x,{text:this.lexer.match,token:this.terminals_[n]||n,line:this.lexer.yylineno,loc:l,expected:v})}}if(q[0]instanceof Array&&q.length>1)throw new Error("Parse Error: multiple actions possible at state: "+p+", token: "+n);switch(q[0]){case 1:d.push(n),e.push(this.lexer.yytext),f.push(this.lexer.yylloc),d.push(q[1]),n=null,o?(n=o,o=null):(j=this.lexer.yyleng,h=this.lexer.yytext,i=this.lexer.yylineno,l=this.lexer.yylloc,k>0&&k--);break;case 2:if(t=this.productions_[q[1]][1],w.$=e[e.length-t],w._$={first_line:f[f.length-(t||1)].first_line,last_line:f[f.length-1].last_line,first_column:f[f.length-(t||1)].first_column,last_column:f[f.length-1].last_column},m&&(w._$.range=[f[f.length-(t||1)].range[0],f[f.length-1].range[1]]),r=this.performAction.call(w,h,j,i,this.yy,q[1],e,f),"undefined"!=typeof r)return r;t&&(d=d.slice(0,-1*t*2),e=e.slice(0,-1*t),f=f.slice(0,-1*t)),d.push(this.productions_[q[1]][0]),e.push(w.$),f.push(w._$),u=g[d[d.length-2]][d[d.length-1]],d.push(u);break;case 3:return!0}}return!0}},c=function(){var a={EOF:1,parseError:function(a,b){if(!this.yy.parser)throw new Error(a);this.yy.parser.parseError(a,b)},setInput:function(a){return this._input=a,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var a=this._input[0];this.yytext+=a,this.yyleng++,this.offset++,this.match+=a,this.matched+=a;var b=a.match(/(?:\r\n?|\n).*/g);return b?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),a},unput:function(a){var b=a.length,c=a.split(/(?:\r\n?|\n)/g);this._input=a+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-b-1),this.offset-=b;var d=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),c.length-1&&(this.yylineno-=c.length-1);var e=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:c?(c.length===d.length?this.yylloc.first_column:0)+d[d.length-c.length].length-c[0].length:this.yylloc.first_column-b},this.options.ranges&&(this.yylloc.range=[e[0],e[0]+this.yyleng-b]),this},more:function(){return this._more=!0,this},less:function(a){this.unput(this.match.slice(a))},pastInput:function(){var a=this.matched.substr(0,this.matched.length-this.match.length);return(a.length>20?"...":"")+a.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var a=this.match;return a.length<20&&(a+=this._input.substr(0,20-a.length)),(a.substr(0,20)+(a.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var a=this.pastInput(),b=new Array(a.length+1).join("-");return a+this.upcomingInput()+"\n"+b+"^"},next:function(){if(this.done)return this.EOF;this._input||(this.done=!0);var a,b,c,d,e;this._more||(this.yytext="",this.match="");for(var f=this._currentRules(),g=0;g<f.length&&(c=this._input.match(this.rules[f[g]]),!c||b&&!(c[0].length>b[0].length)||(b=c,d=g,this.options.flex));g++);return b?(e=b[0].match(/(?:\r\n?|\n).*/g),e&&(this.yylineno+=e.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:e?e[e.length-1].length-e[e.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+b[0].length},this.yytext+=b[0],this.match+=b[0],this.matches=b,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._input=this._input.slice(b[0].length),this.matched+=b[0],a=this.performAction.call(this,this.yy,this,f[d],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),a?a:void 0):""===this._input?this.EOF:this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var a=this.next();return"undefined"!=typeof a?a:this.lex()},begin:function(a){this.conditionStack.push(a)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(a){this.begin(a)}};return a.options={},a.performAction=function(a,b,c,d){function e(a,c){return b.yytext=b.yytext.substring(a,b.yyleng-c+a)}switch(c){case 0:if("\\\\"===b.yytext.slice(-2)?(e(0,1),this.begin("mu")):"\\"===b.yytext.slice(-1)?(e(0,1),this.begin("emu")):this.begin("mu"),b.yytext)return 15;break;case 1:return 15;case 2:return this.popState(),15;case 3:return this.begin("raw"),15;case 4:return this.popState(),"raw"===this.conditionStack[this.conditionStack.length-1]?15:(e(5,9),"END_RAW_BLOCK");case 5:return 15;case 6:return this.popState(),14;case 7:return 65;case 8:return 68;case 9:return 19;case 10:return this.popState(),this.begin("raw"),23;case 11:return 55;case 12:return 60;case 13:return 29;case 14:return 47;case 15:return this.popState(),44;case 16:return this.popState(),44;case 17:return 34;case 18:return 39;case 19:return 51;case 20:return 48;case 21:this.unput(b.yytext),this.popState(),this.begin("com");break;case 22:return this.popState(),14;case 23:return 48;case 24:return 73;case 25:return 72;case 26:return 72;case 27:return 87;case 28:break;case 29:return this.popState(),54;case 30:return this.popState(),33;case 31:return b.yytext=e(1,2).replace(/\\"/g,'"'),80;case 32:return b.yytext=e(1,2).replace(/\\'/g,"'"),80;case 33:return 85;case 34:return 82;case 35:return 82;case 36:return 83;case 37:return 84;case 38:return 81;case 39:return 75;case 40:return 77;case 41:return 72;case 42:return b.yytext=b.yytext.replace(/\\([\\\]])/g,"$1"),72;case 43:return"INVALID";case 44:return 5}},a.rules=[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{(?=[^\/]))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]+?(?=(\{\{\{\{)))/,/^(?:[\s\S]*?--(~)?\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#>)/,/^(?:\{\{(~)?#\*?)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{(~)?!--)/,/^(?:\{\{(~)?![\s\S]*?\}\})/,/^(?:\{\{(~)?\*?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)|])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:undefined(?=([~}\s)])))/,/^(?:null(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:as\s+\|)/,/^(?:\|)/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,/^(?:\[(\\\]|[^\]])*\])/,/^(?:.)/,/^(?:$)/],a.conditions={mu:{rules:[7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44],inclusive:!1},emu:{rules:[2],inclusive:!1},com:{rules:[6],inclusive:!1},raw:{rules:[3,4,5],inclusive:!1},INITIAL:{rules:[0,1,44],inclusive:!0}},a}();return b.lexer=c,a.prototype=b,b.Parser=a,new a}();b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(){var a=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.options=a}function e(a,b,c){void 0===b&&(b=a.length);var d=a[b-1],e=a[b-2];return d?"ContentStatement"===d.type?(e||!c?/\r?\n\s*?$/:/(^|\r?\n)\s*?$/).test(d.original):void 0:c}function f(a,b,c){void 0===b&&(b=-1);var d=a[b+1],e=a[b+2];return d?"ContentStatement"===d.type?(e||!c?/^\s*?\r?\n/:/^\s*?(\r?\n|$)/).test(d.original):void 0:c}function g(a,b,c){var d=a[null==b?0:b+1];if(d&&"ContentStatement"===d.type&&(c||!d.rightStripped)){var e=d.value;d.value=d.value.replace(c?/^\s+/:/^[ \t]*\r?\n?/,""),d.rightStripped=d.value!==e}}function h(a,b,c){var d=a[null==b?a.length-1:b-1];if(d&&"ContentStatement"===d.type&&(c||!d.leftStripped)){var e=d.value;return d.value=d.value.replace(c?/\s+$/:/[ \t]+$/,""),d.leftStripped=d.value!==e,d.leftStripped}}var i=c(1)["default"];b.__esModule=!0;var j=c(49),k=i(j);d.prototype=new k["default"],d.prototype.Program=function(a){var b=!this.options.ignoreStandalone,c=!this.isRootSeen;this.isRootSeen=!0;for(var d=a.body,i=0,j=d.length;i<j;i++){var k=d[i],l=this.accept(k);if(l){var m=e(d,i,c),n=f(d,i,c),o=l.openStandalone&&m,p=l.closeStandalone&&n,q=l.inlineStandalone&&m&&n;l.close&&g(d,i,!0),l.open&&h(d,i,!0),b&&q&&(g(d,i),h(d,i)&&"PartialStatement"===k.type&&(k.indent=/([ \t]+$)/.exec(d[i-1].original)[1])),b&&o&&(g((k.program||k.inverse).body),h(d,i)),b&&p&&(g(d,i),h((k.inverse||k.program).body))}}return a},d.prototype.BlockStatement=d.prototype.DecoratorBlock=d.prototype.PartialBlockStatement=function(a){this.accept(a.program),this.accept(a.inverse);var b=a.program||a.inverse,c=a.program&&a.inverse,d=c,i=c;if(c&&c.chained)for(d=c.body[0].program;i.chained;)i=i.body[i.body.length-1].program;var j={open:a.openStrip.open,close:a.closeStrip.close,openStandalone:f(b.body),closeStandalone:e((d||b).body)};if(a.openStrip.close&&g(b.body,null,!0),c){var k=a.inverseStrip;k.open&&h(b.body,null,!0),k.close&&g(d.body,null,!0),a.closeStrip.open&&h(i.body,null,!0),!this.options.ignoreStandalone&&e(b.body)&&f(d.body)&&(h(b.body),g(d.body))}else a.closeStrip.open&&h(b.body,null,!0);return j},d.prototype.Decorator=d.prototype.MustacheStatement=function(a){return a.strip},d.prototype.PartialStatement=d.prototype.CommentStatement=function(a){var b=a.strip||{};return{inlineStandalone:!0,open:b.open,close:b.close}},b["default"]=d,a.exports=b["default"]},function(a,b,c){"use strict";function d(){this.parents=[]}function e(a){this.acceptRequired(a,"path"),this.acceptArray(a.params),this.acceptKey(a,"hash")}function f(a){e.call(this,a),this.acceptKey(a,"program"),this.acceptKey(a,"inverse")}function g(a){this.acceptRequired(a,"name"),this.acceptArray(a.params),this.acceptKey(a,"hash")}var h=c(1)["default"];b.__esModule=!0;var i=c(6),j=h(i);d.prototype={constructor:d,mutating:!1,acceptKey:function(a,b){var c=this.accept(a[b]);if(this.mutating){if(c&&!d.prototype[c.type])throw new j["default"]('Unexpected node type "'+c.type+'" found when accepting '+b+" on "+a.type);a[b]=c}},acceptRequired:function(a,b){if(this.acceptKey(a,b),!a[b])throw new j["default"](a.type+" requires "+b)},acceptArray:function(a){for(var b=0,c=a.length;b<c;b++)this.acceptKey(a,b),a[b]||(a.splice(b,1),b--,c--)},accept:function(a){if(a){if(!this[a.type])throw new j["default"]("Unknown type: "+a.type,a);this.current&&this.parents.unshift(this.current),this.current=a;var b=this[a.type](a);return this.current=this.parents.shift(),!this.mutating||b?b:b!==!1?a:void 0}},Program:function(a){this.acceptArray(a.body)},MustacheStatement:e,Decorator:e,BlockStatement:f,DecoratorBlock:f,PartialStatement:g,PartialBlockStatement:function(a){g.call(this,a),this.acceptKey(a,"program")},ContentStatement:function(){},CommentStatement:function(){},SubExpression:e,PathExpression:function(){},StringLiteral:function(){},NumberLiteral:function(){},BooleanLiteral:function(){},UndefinedLiteral:function(){},NullLiteral:function(){},Hash:function(a){this.acceptArray(a.pairs)},HashPair:function(a){this.acceptRequired(a,"value")}},b["default"]=d,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b){if(b=b.path?b.path.original:b,a.path.original!==b){var c={loc:a.path.loc};throw new q["default"](a.path.original+" doesn't match "+b,c)}}function e(a,b){this.source=a,this.start={line:b.first_line,column:b.first_column},this.end={line:b.last_line,column:b.last_column}}function f(a){return/^\[.*\]$/.test(a)?a.substring(1,a.length-1):a}function g(a,b){return{open:"~"===a.charAt(2),close:"~"===b.charAt(b.length-3)}}function h(a){return a.replace(/^\{\{~?!-?-?/,"").replace(/-?-?~?\}\}$/,"")}function i(a,b,c){c=this.locInfo(c);for(var d=a?"@":"",e=[],f=0,g=0,h=b.length;g<h;g++){var i=b[g].part,j=b[g].original!==i;if(d+=(b[g].separator||"")+i,j||".."!==i&&"."!==i&&"this"!==i)e.push(i);else{if(e.length>0)throw new q["default"]("Invalid path: "+d,{loc:c});".."===i&&f++}}return{type:"PathExpression",data:a,depth:f,parts:e,original:d,loc:c}}function j(a,b,c,d,e,f){var g=d.charAt(3)||d.charAt(2),h="{"!==g&&"&"!==g,i=/\*/.test(d);return{type:i?"Decorator":"MustacheStatement",path:a,params:b,hash:c,escaped:h,strip:e,loc:this.locInfo(f)}}function k(a,b,c,e){d(a,c),e=this.locInfo(e);var f={type:"Program",body:b,strip:{},loc:e};return{type:"BlockStatement",path:a.path,params:a.params,hash:a.hash,program:f,openStrip:{},inverseStrip:{},closeStrip:{},loc:e}}function l(a,b,c,e,f,g){e&&e.path&&d(a,e);var h=/\*/.test(a.open);b.blockParams=a.blockParams;var i=void 0,j=void 0;if(c){if(h)throw new q["default"]("Unexpected inverse block on decorator",c);c.chain&&(c.program.body[0].closeStrip=e.strip),j=c.strip,i=c.program}return f&&(f=i,i=b,b=f),{type:h?"DecoratorBlock":"BlockStatement",path:a.path,params:a.params,hash:a.hash,program:b,inverse:i,openStrip:a.strip,inverseStrip:j,closeStrip:e&&e.strip,loc:this.locInfo(g)}}function m(a,b){if(!b&&a.length){var c=a[0].loc,d=a[a.length-1].loc;c&&d&&(b={source:c.source,start:{line:c.start.line,column:c.start.column},end:{line:d.end.line,column:d.end.column}})}return{type:"Program",body:a,strip:{},loc:b}}function n(a,b,c,e){return d(a,c),{type:"PartialBlockStatement",name:a.path,params:a.params,hash:a.hash,program:b,openStrip:a.strip,closeStrip:c&&c.strip,loc:this.locInfo(e)}}var o=c(1)["default"];b.__esModule=!0,b.SourceLocation=e,b.id=f,b.stripFlags=g,b.stripComment=h,b.preparePath=i,b.prepareMustache=j,b.prepareRawBlock=k,b.prepareBlock=l,b.prepareProgram=m,b.preparePartialBlock=n;var p=c(6),q=o(p)},function(a,b,c){"use strict";function d(){}function e(a,b,c){if(null==a||"string"!=typeof a&&"Program"!==a.type)throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+a);b=b||{},"data"in b||(b.data=!0),b.compat&&(b.useDepths=!0);var d=c.parse(a,b),e=(new c.Compiler).compile(d,b);return(new c.JavaScriptCompiler).compile(e,b)}function f(a,b,c){function d(){var d=c.parse(a,b),e=(new c.Compiler).compile(d,b),f=(new c.JavaScriptCompiler).compile(e,b,void 0,!0);return c.template(f)}function e(a,b){return f||(f=d()),f.call(this,a,b)}if(void 0===b&&(b={}),null==a||"string"!=typeof a&&"Program"!==a.type)throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+a);b=m.extend({},b),"data"in b||(b.data=!0),b.compat&&(b.useDepths=!0);var f=void 0;return e._setup=function(a){return f||(f=d()),f._setup(a)},e._child=function(a,b,c,e){return f||(f=d()),f._child(a,b,c,e)},e}function g(a,b){if(a===b)return!0;if(m.isArray(a)&&m.isArray(b)&&a.length===b.length){for(var c=0;c<a.length;c++)if(!g(a[c],b[c]))return!1;return!0}}function h(a){if(!a.path.parts){var b=a.path;a.path={type:"PathExpression",data:!1,depth:0,parts:[b.original+""],original:b.original+"",loc:b.loc}}}var i=c(34)["default"],j=c(1)["default"];b.__esModule=!0,b.Compiler=d,b.precompile=e,b.compile=f;var k=c(6),l=j(k),m=c(5),n=c(45),o=j(n),p=[].slice;d.prototype={compiler:d,equals:function(a){var b=this.opcodes.length;if(a.opcodes.length!==b)return!1;for(var c=0;c<b;c++){var d=this.opcodes[c],e=a.opcodes[c];if(d.opcode!==e.opcode||!g(d.args,e.args))return!1}b=this.children.length;for(var c=0;c<b;c++)if(!this.children[c].equals(a.children[c]))return!1;return!0},guid:0,compile:function(a,b){return this.sourceNode=[],this.opcodes=[],this.children=[],this.options=b,this.stringParams=b.stringParams,this.trackIds=b.trackIds,b.blockParams=b.blockParams||[],b.knownHelpers=m.extend(i(null),{helperMissing:!0,blockHelperMissing:!0,each:!0,"if":!0,unless:!0,"with":!0,log:!0,lookup:!0},b.knownHelpers),this.accept(a)},compileProgram:function(a){var b=new this.compiler,c=b.compile(a,this.options),d=this.guid++;return this.usePartial=this.usePartial||c.usePartial,this.children[d]=c,this.useDepths=this.useDepths||c.useDepths,d},accept:function(a){if(!this[a.type])throw new l["default"]("Unknown type: "+a.type,a);this.sourceNode.unshift(a);var b=this[a.type](a);return this.sourceNode.shift(),b},Program:function(a){this.options.blockParams.unshift(a.blockParams);for(var b=a.body,c=b.length,d=0;d<c;d++)this.accept(b[d]);return this.options.blockParams.shift(),this.isSimple=1===c,this.blockParams=a.blockParams?a.blockParams.length:0,this},BlockStatement:function(a){h(a);var b=a.program,c=a.inverse;b=b&&this.compileProgram(b),c=c&&this.compileProgram(c);var d=this.classifySexpr(a);"helper"===d?this.helperSexpr(a,b,c):"simple"===d?(this.simpleSexpr(a),this.opcode("pushProgram",b),this.opcode("pushProgram",c),this.opcode("emptyHash"),this.opcode("blockValue",a.path.original)):(this.ambiguousSexpr(a,b,c),this.opcode("pushProgram",b),this.opcode("pushProgram",c),this.opcode("emptyHash"),this.opcode("ambiguousBlockValue")),this.opcode("append")},DecoratorBlock:function(a){var b=a.program&&this.compileProgram(a.program),c=this.setupFullMustacheParams(a,b,void 0),d=a.path;this.useDecorators=!0,this.opcode("registerDecorator",c.length,d.original)},PartialStatement:function(a){this.usePartial=!0;var b=a.program;b&&(b=this.compileProgram(a.program));var c=a.params;if(c.length>1)throw new l["default"]("Unsupported number of partial arguments: "+c.length,a);c.length||(this.options.explicitPartialContext?this.opcode("pushLiteral","undefined"):c.push({type:"PathExpression",parts:[],depth:0}));var d=a.name.original,e="SubExpression"===a.name.type;e&&this.accept(a.name),this.setupFullMustacheParams(a,b,void 0,!0);var f=a.indent||"";this.options.preventIndent&&f&&(this.opcode("appendContent",f),f=""),this.opcode("invokePartial",e,d,f),this.opcode("append")},PartialBlockStatement:function(a){this.PartialStatement(a)},MustacheStatement:function(a){this.SubExpression(a),a.escaped&&!this.options.noEscape?this.opcode("appendEscaped"):this.opcode("append")},Decorator:function(a){this.DecoratorBlock(a)},ContentStatement:function(a){a.value&&this.opcode("appendContent",a.value)},CommentStatement:function(){},SubExpression:function(a){h(a);var b=this.classifySexpr(a);"simple"===b?this.simpleSexpr(a):"helper"===b?this.helperSexpr(a):this.ambiguousSexpr(a)},ambiguousSexpr:function(a,b,c){var d=a.path,e=d.parts[0],f=null!=b||null!=c;this.opcode("getContext",d.depth),this.opcode("pushProgram",b),this.opcode("pushProgram",c),d.strict=!0,this.accept(d),this.opcode("invokeAmbiguous",e,f)},simpleSexpr:function(a){var b=a.path;b.strict=!0,this.accept(b),this.opcode("resolvePossibleLambda")},helperSexpr:function(a,b,c){var d=this.setupFullMustacheParams(a,b,c),e=a.path,f=e.parts[0];if(this.options.knownHelpers[f])this.opcode("invokeKnownHelper",d.length,f);else{if(this.options.knownHelpersOnly)throw new l["default"]("You specified knownHelpersOnly, but used the unknown helper "+f,a);e.strict=!0,e.falsy=!0,this.accept(e),this.opcode("invokeHelper",d.length,e.original,o["default"].helpers.simpleId(e))}},PathExpression:function(a){this.addDepth(a.depth),this.opcode("getContext",a.depth);var b=a.parts[0],c=o["default"].helpers.scopedId(a),d=!a.depth&&!c&&this.blockParamIndex(b);d?this.opcode("lookupBlockParam",d,a.parts):b?a.data?(this.options.data=!0,this.opcode("lookupData",a.depth,a.parts,a.strict)):this.opcode("lookupOnContext",a.parts,a.falsy,a.strict,c):this.opcode("pushContext")},StringLiteral:function(a){this.opcode("pushString",a.value)},NumberLiteral:function(a){this.opcode("pushLiteral",a.value)},BooleanLiteral:function(a){this.opcode("pushLiteral",a.value)},UndefinedLiteral:function(){this.opcode("pushLiteral","undefined")},NullLiteral:function(){this.opcode("pushLiteral","null")},Hash:function(a){var b=a.pairs,c=0,d=b.length;for(this.opcode("pushHash");c<d;c++)this.pushParam(b[c].value);for(;c--;)this.opcode("assignToHash",b[c].key);this.opcode("popHash")},opcode:function(a){this.opcodes.push({opcode:a,args:p.call(arguments,1),loc:this.sourceNode[0].loc})},addDepth:function(a){a&&(this.useDepths=!0)},classifySexpr:function(a){var b=o["default"].helpers.simpleId(a.path),c=b&&!!this.blockParamIndex(a.path.parts[0]),d=!c&&o["default"].helpers.helperExpression(a),e=!c&&(d||b);if(e&&!d){var f=a.path.parts[0],g=this.options;g.knownHelpers[f]?d=!0:g.knownHelpersOnly&&(e=!1)}return d?"helper":e?"ambiguous":"simple"},pushParams:function(a){for(var b=0,c=a.length;b<c;b++)this.pushParam(a[b])},pushParam:function(a){var b=null!=a.value?a.value:a.original||"";if(this.stringParams)b.replace&&(b=b.replace(/^(\.?\.\/)*/g,"").replace(/\//g,".")),a.depth&&this.addDepth(a.depth),this.opcode("getContext",a.depth||0),this.opcode("pushStringParam",b,a.type),"SubExpression"===a.type&&this.accept(a);else{if(this.trackIds){var c=void 0;if(!a.parts||o["default"].helpers.scopedId(a)||a.depth||(c=this.blockParamIndex(a.parts[0])),c){var d=a.parts.slice(1).join(".");this.opcode("pushId","BlockParam",c,d)}else b=a.original||b,b.replace&&(b=b.replace(/^this(?:\.|$)/,"").replace(/^\.\//,"").replace(/^\.$/,"")),this.opcode("pushId",a.type,b)}this.accept(a)}},setupFullMustacheParams:function(a,b,c,d){var e=a.params;return this.pushParams(e),this.opcode("pushProgram",b),this.opcode("pushProgram",c),a.hash?this.accept(a.hash):this.opcode("emptyHash",d),e},blockParamIndex:function(a){for(var b=0,c=this.options.blockParams.length;b<c;b++){var d=this.options.blockParams[b],e=d&&m.indexOf(d,a);if(d&&e>=0)return[b,e]}}}},function(a,b,c){"use strict";function d(a){this.value=a}function e(){}function f(a,b,c,d){var e=b.popStack(),f=0,g=c.length;for(a&&g--;f<g;f++)e=b.nameLookup(e,c[f],d);return a?[b.aliasable("container.strict"),"(",e,", ",b.quotedString(c[f]),", ",JSON.stringify(b.source.currentLocation)," )"]:e}var g=c(13)["default"],h=c(1)["default"];b.__esModule=!0;var i=c(4),j=c(6),k=h(j),l=c(5),m=c(53),n=h(m);e.prototype={nameLookup:function(a,b){return this.internalNameLookup(a,b)},depthedLookup:function(a){return[this.aliasable("container.lookup"),"(depths, ",JSON.stringify(a),")"]},compilerInfo:function(){var a=i.COMPILER_REVISION,b=i.REVISION_CHANGES[a];return[a,b]},appendToBuffer:function(a,b,c){return l.isArray(a)||(a=[a]),a=this.source.wrap(a,b),this.environment.isSimple?["return ",a,";"]:c?["buffer += ",a,";"]:(a.appendToBuffer=!0,a)},initializeBuffer:function(){return this.quotedString("")},internalNameLookup:function(a,b){return this.lookupPropertyFunctionIsUsed=!0,["lookupProperty(",a,",",JSON.stringify(b),")"]},lookupPropertyFunctionIsUsed:!1,compile:function(a,b,c,d){this.environment=a,this.options=b,this.stringParams=this.options.stringParams,this.trackIds=this.options.trackIds,this.precompile=!d,this.name=this.environment.name,this.isChild=!!c,this.context=c||{decorators:[],programs:[],environments:[]},this.preamble(),this.stackSlot=0,this.stackVars=[],this.aliases={},this.registers={list:[]},this.hashes=[],this.compileStack=[],this.inlineStack=[],this.blockParams=[],this.compileChildren(a,b),this.useDepths=this.useDepths||a.useDepths||a.useDecorators||this.options.compat,this.useBlockParams=this.useBlockParams||a.useBlockParams;var e=a.opcodes,f=void 0,g=void 0,h=void 0,i=void 0;for(h=0,i=e.length;h<i;h++)f=e[h],this.source.currentLocation=f.loc,g=g||f.loc,this[f.opcode].apply(this,f.args);if(this.source.currentLocation=g,this.pushSource(""),this.stackSlot||this.inlineStack.length||this.compileStack.length)throw new k["default"]("Compile completed with content left on stack");this.decorators.isEmpty()?this.decorators=void 0:(this.useDecorators=!0,this.decorators.prepend(["var decorators = container.decorators, ",this.lookupPropertyFunctionVarDeclaration(),";\n"]),
this.decorators.push("return fn;"),d?this.decorators=Function.apply(this,["fn","props","container","depth0","data","blockParams","depths",this.decorators.merge()]):(this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"),this.decorators.push("}\n"),this.decorators=this.decorators.merge()));var j=this.createFunctionContext(d);if(this.isChild)return j;var l={compiler:this.compilerInfo(),main:j};this.decorators&&(l.main_d=this.decorators,l.useDecorators=!0);var m=this.context,n=m.programs,o=m.decorators;for(h=0,i=n.length;h<i;h++)n[h]&&(l[h]=n[h],o[h]&&(l[h+"_d"]=o[h],l.useDecorators=!0));return this.environment.usePartial&&(l.usePartial=!0),this.options.data&&(l.useData=!0),this.useDepths&&(l.useDepths=!0),this.useBlockParams&&(l.useBlockParams=!0),this.options.compat&&(l.compat=!0),d?l.compilerOptions=this.options:(l.compiler=JSON.stringify(l.compiler),this.source.currentLocation={start:{line:1,column:0}},l=this.objectLiteral(l),b.srcName?(l=l.toStringWithSourceMap({file:b.destName}),l.map=l.map&&l.map.toString()):l=l.toString()),l},preamble:function(){this.lastContext=0,this.source=new n["default"](this.options.srcName),this.decorators=new n["default"](this.options.srcName)},createFunctionContext:function(a){var b=this,c="",d=this.stackVars.concat(this.registers.list);d.length>0&&(c+=", "+d.join(", "));var e=0;g(this.aliases).forEach(function(a){var d=b.aliases[a];d.children&&d.referenceCount>1&&(c+=", alias"+ ++e+"="+a,d.children[0]="alias"+e)}),this.lookupPropertyFunctionIsUsed&&(c+=", "+this.lookupPropertyFunctionVarDeclaration());var f=["container","depth0","helpers","partials","data"];(this.useBlockParams||this.useDepths)&&f.push("blockParams"),this.useDepths&&f.push("depths");var h=this.mergeSource(c);return a?(f.push(h),Function.apply(this,f)):this.source.wrap(["function(",f.join(","),") {\n  ",h,"}"])},mergeSource:function(a){var b=this.environment.isSimple,c=!this.forceBuffer,d=void 0,e=void 0,f=void 0,g=void 0;return this.source.each(function(a){a.appendToBuffer?(f?a.prepend("  + "):f=a,g=a):(f&&(e?f.prepend("buffer += "):d=!0,g.add(";"),f=g=void 0),e=!0,b||(c=!1))}),c?f?(f.prepend("return "),g.add(";")):e||this.source.push('return "";'):(a+=", buffer = "+(d?"":this.initializeBuffer()),f?(f.prepend("return buffer + "),g.add(";")):this.source.push("return buffer;")),a&&this.source.prepend("var "+a.substring(2)+(d?"":";\n")),this.source.merge()},lookupPropertyFunctionVarDeclaration:function(){return"\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim()},blockValue:function(a){var b=this.aliasable("container.hooks.blockHelperMissing"),c=[this.contextName(0)];this.setupHelperArgs(a,0,c);var d=this.popStack();c.splice(1,0,d),this.push(this.source.functionCall(b,"call",c))},ambiguousBlockValue:function(){var a=this.aliasable("container.hooks.blockHelperMissing"),b=[this.contextName(0)];this.setupHelperArgs("",0,b,!0),this.flushInline();var c=this.topStack();b.splice(1,0,c),this.pushSource(["if (!",this.lastHelper,") { ",c," = ",this.source.functionCall(a,"call",b),"}"])},appendContent:function(a){this.pendingContent?a=this.pendingContent+a:this.pendingLocation=this.source.currentLocation,this.pendingContent=a},append:function(){if(this.isInline())this.replaceStack(function(a){return[" != null ? ",a,' : ""']}),this.pushSource(this.appendToBuffer(this.popStack()));else{var a=this.popStack();this.pushSource(["if (",a," != null) { ",this.appendToBuffer(a,void 0,!0)," }"]),this.environment.isSimple&&this.pushSource(["else { ",this.appendToBuffer("''",void 0,!0)," }"])}},appendEscaped:function(){this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"),"(",this.popStack(),")"]))},getContext:function(a){this.lastContext=a},pushContext:function(){this.pushStackLiteral(this.contextName(this.lastContext))},lookupOnContext:function(a,b,c,d){var e=0;d||!this.options.compat||this.lastContext?this.pushContext():this.push(this.depthedLookup(a[e++])),this.resolvePath("context",a,e,b,c)},lookupBlockParam:function(a,b){this.useBlockParams=!0,this.push(["blockParams[",a[0],"][",a[1],"]"]),this.resolvePath("context",b,1)},lookupData:function(a,b,c){a?this.pushStackLiteral("container.data(data, "+a+")"):this.pushStackLiteral("data"),this.resolvePath("data",b,0,!0,c)},resolvePath:function(a,b,c,d,e){var g=this;if(this.options.strict||this.options.assumeObjects)return void this.push(f(this.options.strict&&e,this,b,a));for(var h=b.length;c<h;c++)this.replaceStack(function(e){var f=g.nameLookup(e,b[c],a);return d?[" && ",f]:[" != null ? ",f," : ",e]})},resolvePossibleLambda:function(){this.push([this.aliasable("container.lambda"),"(",this.popStack(),", ",this.contextName(0),")"])},pushStringParam:function(a,b){this.pushContext(),this.pushString(b),"SubExpression"!==b&&("string"==typeof a?this.pushString(a):this.pushStackLiteral(a))},emptyHash:function(a){this.trackIds&&this.push("{}"),this.stringParams&&(this.push("{}"),this.push("{}")),this.pushStackLiteral(a?"undefined":"{}")},pushHash:function(){this.hash&&this.hashes.push(this.hash),this.hash={values:{},types:[],contexts:[],ids:[]}},popHash:function(){var a=this.hash;this.hash=this.hashes.pop(),this.trackIds&&this.push(this.objectLiteral(a.ids)),this.stringParams&&(this.push(this.objectLiteral(a.contexts)),this.push(this.objectLiteral(a.types))),this.push(this.objectLiteral(a.values))},pushString:function(a){this.pushStackLiteral(this.quotedString(a))},pushLiteral:function(a){this.pushStackLiteral(a)},pushProgram:function(a){null!=a?this.pushStackLiteral(this.programExpression(a)):this.pushStackLiteral(null)},registerDecorator:function(a,b){var c=this.nameLookup("decorators",b,"decorator"),d=this.setupHelperArgs(b,a);this.decorators.push(["fn = ",this.decorators.functionCall(c,"",["fn","props","container",d])," || fn;"])},invokeHelper:function(a,b,c){var d=this.popStack(),e=this.setupHelper(a,b),f=[];c&&f.push(e.name),f.push(d),this.options.strict||f.push(this.aliasable("container.hooks.helperMissing"));var g=["(",this.itemsSeparatedBy(f,"||"),")"],h=this.source.functionCall(g,"call",e.callParams);this.push(h)},itemsSeparatedBy:function(a,b){var c=[];c.push(a[0]);for(var d=1;d<a.length;d++)c.push(b,a[d]);return c},invokeKnownHelper:function(a,b){var c=this.setupHelper(a,b);this.push(this.source.functionCall(c.name,"call",c.callParams))},invokeAmbiguous:function(a,b){this.useRegister("helper");var c=this.popStack();this.emptyHash();var d=this.setupHelper(0,a,b),e=this.lastHelper=this.nameLookup("helpers",a,"helper"),f=["(","(helper = ",e," || ",c,")"];this.options.strict||(f[0]="(helper = ",f.push(" != null ? helper : ",this.aliasable("container.hooks.helperMissing"))),this.push(["(",f,d.paramsInit?["),(",d.paramsInit]:[],"),","(typeof helper === ",this.aliasable('"function"')," ? ",this.source.functionCall("helper","call",d.callParams)," : helper))"])},invokePartial:function(a,b,c){var d=[],e=this.setupParams(b,1,d);a&&(b=this.popStack(),delete e.name),c&&(e.indent=JSON.stringify(c)),e.helpers="helpers",e.partials="partials",e.decorators="container.decorators",a?d.unshift(b):d.unshift(this.nameLookup("partials",b,"partial")),this.options.compat&&(e.depths="depths"),e=this.objectLiteral(e),d.push(e),this.push(this.source.functionCall("container.invokePartial","",d))},assignToHash:function(a){var b=this.popStack(),c=void 0,d=void 0,e=void 0;this.trackIds&&(e=this.popStack()),this.stringParams&&(d=this.popStack(),c=this.popStack());var f=this.hash;c&&(f.contexts[a]=c),d&&(f.types[a]=d),e&&(f.ids[a]=e),f.values[a]=b},pushId:function(a,b,c){"BlockParam"===a?this.pushStackLiteral("blockParams["+b[0]+"].path["+b[1]+"]"+(c?" + "+JSON.stringify("."+c):"")):"PathExpression"===a?this.pushString(b):"SubExpression"===a?this.pushStackLiteral("true"):this.pushStackLiteral("null")},compiler:e,compileChildren:function(a,b){for(var c=a.children,d=void 0,e=void 0,f=0,g=c.length;f<g;f++){d=c[f],e=new this.compiler;var h=this.matchExistingProgram(d);if(null==h){this.context.programs.push("");var i=this.context.programs.length;d.index=i,d.name="program"+i,this.context.programs[i]=e.compile(d,b,this.context,!this.precompile),this.context.decorators[i]=e.decorators,this.context.environments[i]=d,this.useDepths=this.useDepths||e.useDepths,this.useBlockParams=this.useBlockParams||e.useBlockParams,d.useDepths=this.useDepths,d.useBlockParams=this.useBlockParams}else d.index=h.index,d.name="program"+h.index,this.useDepths=this.useDepths||h.useDepths,this.useBlockParams=this.useBlockParams||h.useBlockParams}},matchExistingProgram:function(a){for(var b=0,c=this.context.environments.length;b<c;b++){var d=this.context.environments[b];if(d&&d.equals(a))return d}},programExpression:function(a){var b=this.environment.children[a],c=[b.index,"data",b.blockParams];return(this.useBlockParams||this.useDepths)&&c.push("blockParams"),this.useDepths&&c.push("depths"),"container.program("+c.join(", ")+")"},useRegister:function(a){this.registers[a]||(this.registers[a]=!0,this.registers.list.push(a))},push:function(a){return a instanceof d||(a=this.source.wrap(a)),this.inlineStack.push(a),a},pushStackLiteral:function(a){this.push(new d(a))},pushSource:function(a){this.pendingContent&&(this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent),this.pendingLocation)),this.pendingContent=void 0),a&&this.source.push(a)},replaceStack:function(a){var b=["("],c=void 0,e=void 0,f=void 0;if(!this.isInline())throw new k["default"]("replaceStack on non-inline");var g=this.popStack(!0);if(g instanceof d)c=[g.value],b=["(",c],f=!0;else{e=!0;var h=this.incrStack();b=["((",this.push(h)," = ",g,")"],c=this.topStack()}var i=a.call(this,c);f||this.popStack(),e&&this.stackSlot--,this.push(b.concat(i,")"))},incrStack:function(){return this.stackSlot++,this.stackSlot>this.stackVars.length&&this.stackVars.push("stack"+this.stackSlot),this.topStackName()},topStackName:function(){return"stack"+this.stackSlot},flushInline:function(){var a=this.inlineStack;this.inlineStack=[];for(var b=0,c=a.length;b<c;b++){var e=a[b];if(e instanceof d)this.compileStack.push(e);else{var f=this.incrStack();this.pushSource([f," = ",e,";"]),this.compileStack.push(f)}}},isInline:function(){return this.inlineStack.length},popStack:function(a){var b=this.isInline(),c=(b?this.inlineStack:this.compileStack).pop();if(!a&&c instanceof d)return c.value;if(!b){if(!this.stackSlot)throw new k["default"]("Invalid stack pop");this.stackSlot--}return c},topStack:function(){var a=this.isInline()?this.inlineStack:this.compileStack,b=a[a.length-1];return b instanceof d?b.value:b},contextName:function(a){return this.useDepths&&a?"depths["+a+"]":"depth"+a},quotedString:function(a){return this.source.quotedString(a)},objectLiteral:function(a){return this.source.objectLiteral(a)},aliasable:function(a){var b=this.aliases[a];return b?(b.referenceCount++,b):(b=this.aliases[a]=this.source.wrap(a),b.aliasable=!0,b.referenceCount=1,b)},setupHelper:function(a,b,c){var d=[],e=this.setupHelperArgs(b,a,d,c),f=this.nameLookup("helpers",b,"helper"),g=this.aliasable(this.contextName(0)+" != null ? "+this.contextName(0)+" : (container.nullContext || {})");return{params:d,paramsInit:e,name:f,callParams:[g].concat(d)}},setupParams:function(a,b,c){var d={},e=[],f=[],g=[],h=!c,i=void 0;h&&(c=[]),d.name=this.quotedString(a),d.hash=this.popStack(),this.trackIds&&(d.hashIds=this.popStack()),this.stringParams&&(d.hashTypes=this.popStack(),d.hashContexts=this.popStack());var j=this.popStack(),k=this.popStack();(k||j)&&(d.fn=k||"container.noop",d.inverse=j||"container.noop");for(var l=b;l--;)i=this.popStack(),c[l]=i,this.trackIds&&(g[l]=this.popStack()),this.stringParams&&(f[l]=this.popStack(),e[l]=this.popStack());return h&&(d.args=this.source.generateArray(c)),this.trackIds&&(d.ids=this.source.generateArray(g)),this.stringParams&&(d.types=this.source.generateArray(f),d.contexts=this.source.generateArray(e)),this.options.data&&(d.data="data"),this.useBlockParams&&(d.blockParams="blockParams"),d},setupHelperArgs:function(a,b,c,d){var e=this.setupParams(a,b,c);return e.loc=JSON.stringify(this.source.currentLocation),e=this.objectLiteral(e),d?(this.useRegister("options"),c.push("options"),["options=",e]):c?(c.push(e),""):e}},function(){for(var a="break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "),b=e.RESERVED_WORDS={},c=0,d=a.length;c<d;c++)b[a[c]]=!0}(),e.isValidJavaScriptVariableName=function(a){return!e.RESERVED_WORDS[a]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a)},b["default"]=e,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b,c){if(g.isArray(a)){for(var d=[],e=0,f=a.length;e<f;e++)d.push(b.wrap(a[e],c));return d}return"boolean"==typeof a||"number"==typeof a?a+"":a}function e(a){this.srcFile=a,this.source=[]}var f=c(13)["default"];b.__esModule=!0;var g=c(5),h=void 0;try{}catch(i){}h||(h=function(a,b,c,d){this.src="",d&&this.add(d)},h.prototype={add:function(a){g.isArray(a)&&(a=a.join("")),this.src+=a},prepend:function(a){g.isArray(a)&&(a=a.join("")),this.src=a+this.src},toStringWithSourceMap:function(){return{code:this.toString()}},toString:function(){return this.src}}),e.prototype={isEmpty:function(){return!this.source.length},prepend:function(a,b){this.source.unshift(this.wrap(a,b))},push:function(a,b){this.source.push(this.wrap(a,b))},merge:function(){var a=this.empty();return this.each(function(b){a.add(["  ",b,"\n"])}),a},each:function(a){for(var b=0,c=this.source.length;b<c;b++)a(this.source[b])},empty:function(){var a=this.currentLocation||{start:{}};return new h(a.start.line,a.start.column,this.srcFile)},wrap:function(a){var b=arguments.length<=1||void 0===arguments[1]?this.currentLocation||{start:{}}:arguments[1];return a instanceof h?a:(a=d(a,this,b),new h(b.start.line,b.start.column,this.srcFile,a))},functionCall:function(a,b,c){return c=this.generateList(c),this.wrap([a,b?"."+b+"(":"(",c,")"])},quotedString:function(a){return'"'+(a+"").replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},objectLiteral:function(a){var b=this,c=[];f(a).forEach(function(e){var f=d(a[e],b);"undefined"!==f&&c.push([b.quotedString(e),":",f])});var e=this.generateList(c);return e.prepend("{"),e.add("}"),e},generateList:function(a){for(var b=this.empty(),c=0,e=a.length;c<e;c++)c&&b.add(","),b.add(d(a[c],this));return b},generateArray:function(a){var b=this.generateList(a);return b.prepend("["),b.add("]"),b}},b["default"]=e,a.exports=b["default"]}])});

Handlebars.registerHelper(
  'compare',
  function (lvalue, operator, rvalue, options) {
    var operators, result;

    if (arguments.length < 3) {
      throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    }

    if (options === undefined) {
      options = rvalue;
      rvalue = operator;
      operator = '===';
    }

    operators = {
      '==': function (l, r) {
        return l == r;
      },
      '===': function (l, r) {
        return l === r;
      },
      '!=': function (l, r) {
        return l != r;
      },
      '!==': function (l, r) {
        return l !== r;
      },
      '<': function (l, r) {
        return l < r;
      },
      '>': function (l, r) {
        return l > r;
      },
      '<=': function (l, r) {
        return l <= r;
      },
      '>=': function (l, r) {
        return l >= r;
      },
      typeof: function (l, r) {
        return typeof l == r;
      },
    };

    if (!operators[operator]) {
      throw new Error(
        "Handlerbars Helper 'compare' doesn't know the operator " + operator
      );
    }

    result = operators[operator](lvalue, rvalue);

    if (result) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  }
);
(function (root, factory) {
  if (typeof exports === 'object') {
    module.exports = factory(require('handlebars'));
  } else if (typeof define === 'function' && define.amd) {
    define(['handlebars'], factory);
  } else {
    root.HandlebarsHelpersRegistry = factory(root.Handlebars);
  }
})(this, function (Handlebars) {
  var isArray = function (value) {
    return Object.prototype.toString.call(value) === '[object Array]';
  };

  var ExpressionRegistry = function () {
    this.expressions = [];
  };

  ExpressionRegistry.prototype.add = function (operator, method) {
    this.expressions[operator] = method;
  };

  ExpressionRegistry.prototype.call = function (operator, left, right) {
    if (!this.expressions.hasOwnProperty(operator)) {
      throw new Error('Unknown operator "' + operator + '"');
    }

    return this.expressions[operator](left, right);
  };

  var eR = new ExpressionRegistry();
  eR.add('not', function (left, right) {
    return left != right;
  });
  eR.add('>', function (left, right) {
    return left > right;
  });
  eR.add('<', function (left, right) {
    return left < right;
  });
  eR.add('>=', function (left, right) {
    return left >= right;
  });
  eR.add('<=', function (left, right) {
    return left <= right;
  });
  eR.add('===', function (left, right) {
    return left === right;
  });
  eR.add('!==', function (left, right) {
    return left !== right;
  });
  eR.add('in', function (left, right) {
    if (!isArray(right)) {
      right = right.split(',');
    }
    return right.indexOf(left) !== -1;
  });

  var isHelper = function () {
    var args = arguments,
      left = args[0],
      operator = args[1],
      right = args[2],
      options = args[3];
    if (args.length == 2) {
      options = args[1];
      if (left) return options.fn(this);
      return options.inverse(this);
    }

    if (args.length == 3) {
      right = args[1];
      options = args[2];
      if (left == right) return options.fn(this);
      return options.inverse(this);
    }

    if (eR.call(operator, left, right)) {
      return options.fn(this);
    }
    return options.inverse(this);
  };

  Handlebars.registerHelper('is', isHelper);

  Handlebars.registerHelper('nl2br', function (text) {
    var nl2br = (text + '').replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      '$1' + '<br>' + '$2'
    );
    return new Handlebars.SafeString(nl2br);
  });

  Handlebars.registerHelper('log', function () {
    console.log(
      ['Values:'].concat(Array.prototype.slice.call(arguments, 0, -1))
    );
  });

  Handlebars.registerHelper('debug', function () {
    console.log('Context:', this);
    console.log(
      ['Values:'].concat(Array.prototype.slice.call(arguments, 0, -1))
    );
  });

  return eR;
});
/*
 * Text'N'Tags (textntags)
 * Version 0.1.2
 * Written by: Daniel Zahariev
 *
 * Dependencies: jQuery, underscore.js
 *
 * License: MIT License - http://www.opensource.org/licenses/mit-license.php
 */
(function ($, _, undefined) {
  // Keys "enum"
  var KEY = {
    V: 86,
    Z: 90,
    BACKSPACE: 8,
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    COMMA: 188,
    SPACE: 32,
    HOME: 36,
    END: 35,
    DELETE: 46,
  };
  var defaultSettings = {
    onDataRequest: $.noop,
    realValOnSubmit: true,
    triggers: { '@': {} },
    templates: {
      wrapper: _.template('<div class="textntags-wrapper"></div>'),
      beautifier: _.template(
        '<div class="textntags-beautifier"><div></div></div>'
      ),
      tagHighlight: _.template(
        '<strong class="<%= class_name %>"><span>$<%= idx %></span></strong>'
      ),
      tagList: _.template('<div class="textntags-tag-list"></div>'),
      tagsListItem: _.template('<li><%= title %></li>'),
      tagsListItemImage: _.template('<img src="<%= img %>" />'),
      tagsListItemIcon: _.template(
        '<div class="icon <%= no_img_class %>"></div>'
      ),
    },
  };
  var trigger_defaults = {
    minChars: 2,
    uniqueTags: true,
    showImageOrIcon: true,
    keys_map: {
      id: 'id',
      title: 'name',
      description: '',
      img: 'avatar',
      no_img_class: 'icon',
      type: 'type',
    },
    syntax: _.template('@[[<%= id %>:<%= type %>:<%= title %>]]'),
    parser: /(@)\[\[(\d+):([\w\s\.\-]+):([\w\s@\.,-\/#!$%\^&\*;:{}=\-_`~()]+)\]\]/gi,
    parserGroups: { id: 2, type: 3, title: 4 },
    classes: {
      tagsDropDown: '',
      tagActiveDropDown: 'active',
      tagHighlight: '',
    },
  };

  function transformObjectPropertiesFn(keys_map) {
    return function (obj, localToPublic) {
      var new_obj = {};
      if (localToPublic) {
        _.each(keys_map, function (v, k) {
          new_obj[v] = obj[k];
        });
      } else {
        _.each(keys_map, function (v, k) {
          new_obj[k] = obj[v];
        });
      }
      return new_obj;
    };
  }
  var transformObjectProperties = _.memoize(transformObjectPropertiesFn);

  var utils = {
    htmlEncode: function (str) {
      return _.escape(str);
    },
    highlightTerm: function (value, term) {
      if (!term && !term.length) {
        return value;
      }
      return value.replace(
        new RegExp(
          '(?![^&;]+;)(?!<[^<>]*)(' + term + ')(?![^<>]*>)(?![^&;]+;)',
          'gi'
        ),
        '<b>$1</b>'
      );
    },
    setCaratPosition: function (domNode, caretPos) {
      if (domNode.createTextRange) {
        var range = domNode.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else {
        if (domNode.selectionStart) {
          domNode.focus();
          domNode.setSelectionRange(caretPos, caretPos);
        } else {
          domNode.focus();
        }
      }
    },
  };

  var TextNTags = function (editor) {
    var settings = null,
      templates;
    var elContainer, elEditor, elBeautifier, elTagList, elTagListItemActive;
    var tagsCollection;
    var currentTriggerChar, currentDataQuery;
    var editorSelectionLength = 0,
      editorTextLength = 0,
      editorKeyCode = 0,
      editorAddingTag = false;
    var editorInPasteMode = false,
      editorPasteStartPosition = 0,
      editorPasteCutCharacters = 0;
    var REGEX_ESCAPE_CHARS = [
      '[',
      '^',
      '$',
      '.',
      '|',
      '?',
      '*',
      '+',
      '(',
      ')',
      '\\',
    ];

    function setSettings(options) {
      if (settings != null) {
        return false;
      }

      settings = $.extend(true, {}, defaultSettings, options);
      delete settings.triggers[''];
      _.each(settings.triggers, function (val, key) {
        settings.triggers[key] = $.extend(true, {}, trigger_defaults, val);
        if (
          _.find(REGEX_ESCAPE_CHARS, function (character) {
            return character === key;
          })
        ) {
          var regex_key = '\\' + key;
        } else {
          var regex_key = key;
        }
        //settings.triggers[key].finder = new RegExp(regex_key + '\\w+(\\s+\\w+)?\\s?$', 'gi');
        // Greenhouse edit: added ()? around regex to allow for minChars = 0 to work
        // Greenhouse edit: added single quote to stop it killing the tag list when the user typed one
        settings.triggers[key].finder = new RegExp(
          regex_key + "([\\w']+(\\s+[\\w']+)?\\s?)?$",
          'gi'
        );
      });

      templates = settings.templates;

      return true;
    }

    function initTextarea() {
      elEditor = $(editor).bind({
        click: onEditorClick,
        keydown: onEditorKeyDown,
        keypress: onEditorKeyPress,
        keyup: onEditorKeyUp,
        input: onEditorInput,
        blur: onEditorBlur,
      });

      elContainer = elEditor.wrapAll($(templates.wrapper())).parent();

      if (settings.realValOnSubmit) {
        elEditor.closest('form').bind('submit.textntags', function (event) {
          elContainer.css('visibility', 'hidden');
          elEditor.val(getTaggedText());
        });
      }
    }

    function initTagList() {
      elTagList = $(templates.tagList());
      elTagList.appendTo(elContainer);
      elTagList.delegate('li', 'click', onTagListItemClick);
    }

    function initBeautifier() {
      elBeautifier = $(templates.beautifier());
      elBeautifier.prependTo(elContainer);
    }

    function initState() {
      var text_with_tags = getEditorValue(),
        initialState = parseTaggedText(text_with_tags);
      tagsCollection = initialState.tagsCollection;
      elEditor.val(initialState.plain_text);
      updateBeautifier();

      if (tagsCollection.length > 0) {
        var addedTags = _.uniq(
          _.map(tagsCollection, function (tagPos) {
            return tagPos[3];
          })
        );
        elEditor.trigger('tagsAdded.textntags', [addedTags]);
      }
    }

    function getEditorValue() {
      return elEditor.val();
    }

    function getBeautifiedText(tagged_text) {
      var beautified_text = tagged_text || getTaggedText();
      beautified_text = beautified_text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      _.each(settings.triggers, function (trigger) {
        var markup = templates.tagHighlight({
          idx: trigger.parserGroups.title,
          class_name: trigger.classes.tagHighlight,
        });
        beautified_text = beautified_text.replace(trigger.parser, markup);
      });

      beautified_text = beautified_text.replace(/\n/g, '<br />&shy;');
      beautified_text = beautified_text.replace(/ {2}/g, ' &nbsp;') + '&shy;';
      return beautified_text;
    }

    function getTaggedText() {
      var plain_text = getEditorValue(),
        position = 0,
        tagged_text,
        triggers = settings.triggers;

      tagged_text = _.map(tagsCollection, function (tagPos) {
        var diff_pos = tagPos[0] - position,
          diff_text = diff_pos > 0 ? plain_text.substr(position, diff_pos) : '',
          objPropTransformer = transformObjectProperties(
            triggers[tagPos[2]].keys_map
          ),
          tagText = triggers[tagPos[2]].syntax(
            objPropTransformer(tagPos[3], false)
          );

        position = tagPos[0] + tagPos[1];
        return diff_text + tagText;
      });

      return tagged_text.join('') + plain_text.substr(position);
    }

    // it's ready for export
    function parseTaggedText(tagged_text) {
      if (_.isString(tagged_text) == false) {
        return null;
      }
      var plain_text = '' + tagged_text,
        tagsColl = [],
        triggers = settings.triggers;

      _.each(triggers, function (opts, tchar) {
        var parts = tagged_text.split(opts.parser),
          idx = 0,
          pos = 0,
          len = parts.length,
          found_tag,
          found_len,
          part_len,
          max_group = _.max(opts.parserGroups);

        while (idx < len) {
          if (parts[idx] == tchar) {
            found_tag = {};
            _.each(opts.parserGroups, function (v, k) {
              found_tag[opts.keys_map[k]] = parts[idx + v - 1];
              if (k == 'title') {
                found_len = parts[idx + v - 1].length;
              }
            });
            tagsColl.push([pos, found_len, tchar, found_tag]);
            part_len = found_len;
            idx += max_group;
          } else {
            part_len = parts[idx].length;
            idx += 1;
          }
          pos += part_len;
        }
      });

      tagsColl = _.sortBy(tagsColl, function (tagPos) {
        return tagPos[0];
      });

      _.each(triggers, function (opts, tchar) {
        plain_text = plain_text.replace(
          opts.parser,
          '$' + opts.parserGroups.title
        );
      });

      return {
        plain_text: plain_text,
        tagged_text: tagged_text,
        tagsCollection: tagsColl,
      };
    }

    function updateBeautifier() {
      elBeautifier.find('div').html(getBeautifiedText());
      elEditor.css('height', elBeautifier.outerHeight() + 'px');
    }

    function checkForTrigger(look_ahead) {
      look_ahead = look_ahead || 0;

      var selectionStartFix = /AppleWebKit/.test(window.navigator.userAgent)
          ? 0
          : -1,
        sStart = elEditor[0].selectionStart + selectionStartFix,
        left_text = elEditor.val().substr(0, sStart + look_ahead),
        found_trigger,
        found_trigger_char = null,
        query;

      if (!left_text || !left_text.length) {
        return;
      }

      found_trigger = _.find(settings.triggers, function (trigger, tchar) {
        var matches = left_text.match(trigger.finder);
        if (matches) {
          found_trigger_char = tchar;
          query = matches[0].substr(tchar.length);
          return true;
        }
        return false;
      });

      if (
        !found_trigger_char ||
        (found_trigger && query.length < found_trigger.minChars)
      ) {
        hideTagList();
      } else {
        currentDataQuery = query;
        currentTriggerChar = found_trigger_char;
        _.defer(_.bind(searchTags, this, currentDataQuery, found_trigger_char));
      }
    }

    function onEditorClick(e) {
      checkForTrigger(0);
    }

    function onEditorKeyDown(e) {
      var keys = KEY, // store in local var for faster lookup
        sStart = elEditor[0].selectionStart,
        sEnd = elEditor[0].selectionEnd,
        plain_text = elEditor.val();

      editorSelectionLength = sEnd - sStart;
      editorTextLength = plain_text.length;
      editorKeyCode = e.keyCode;

      switch (e.keyCode) {
        case keys.UP:
        case keys.DOWN:
          if (!elTagList.is(':visible')) {
            return true;
          }

          var elCurrentTagListItem = null;
          if (e.keyCode == keys.DOWN) {
            if (elTagListItemActive && elTagListItemActive.length) {
              elCurrentTagListItem = elTagListItemActive.next();
            } else {
              elCurrentTagListItem = elTagList.find('li').first();
            }
          } else {
            if (elTagListItemActive && elTagListItemActive.length) {
              elCurrentTagListItem = elTagListItemActive.prev();
            } else {
              elCurrentTagListItem = elTagList.find('li').last();
            }
          }

          selectTagListItem(
            elCurrentTagListItem,
            settings.triggers[currentTriggerChar].classes.tagActiveDropDown
          );
          return false;

        case keys.RETURN:
        case keys.TAB:
          if (elTagListItemActive && elTagListItemActive.length) {
            editorAddingTag = true;
            elTagListItemActive.click();
            return false;
          }
          return true;

        case keys.BACKSPACE:
        case keys['DELETE']:
          if (e.keyCode == keys.BACKSPACE && sStart == sEnd && sStart > 0) {
            sStart -= 1;
          }
          if (sEnd > sStart) {
            removeTagsInRange(sStart, sEnd);
            shiftTagsPosition(sStart, sStart - sEnd);
          }
          return true;

        case keys.LEFT:
        case keys.RIGHT:
        case keys.HOME:
        case keys.END:
          _.defer(function () {
            checkForTrigger.call(this, 0);
          });
          break;
        case keys.V:
          // checking for paste
          if (e.ctrlKey) {
            editorInPasteMode = true;
            editorPasteStartPosition = sStart;
            editorPasteCutCharacters = sEnd - sStart;
            removeTagsInRange(sStart, sEnd);
          }
          break;
        case keys.Z:
          if (e.ctrlKey) {
            // forbid undo
            return false;
          }
          break;
      }

      return true;
    }

    function onEditorKeyPress(e) {
      if (e.keyCode == KEY.RETURN) {
        updateBeautifier(elEditor.val());
      }
      if (editorAddingTag) {
        if (e.keyCode == KEY.RETURN || e.keyCode == KEY.TAB) {
          e.preventDefault();
        }
        editorAddingTag = false;
      }
    }

    function onEditorKeyUp(e) {
      if (editorInPasteMode) {
        editorInPasteMode = false;

        if (editorSelectionLength > 0) {
          return;
        }

        var sStart = elEditor[0].selectionStart,
          sEnd = elEditor[0].selectionEnd;

        shiftTagsPosition(
          editorPasteStartPosition,
          sEnd - editorPasteStartPosition - editorPasteCutCharacters
        );
        updateBeautifier();
      }
    }

    function onEditorInput(e) {
      var selectionStartFix = /AppleWebKit/.test(window.navigator.userAgent)
        ? 0
        : -1;
      if (editorKeyCode != KEY.BACKSPACE && editorKeyCode != KEY['DELETE']) {
        if (editorSelectionLength > 0) {
          // delete of selection occured
          var sStart = elEditor[0].selectionStart + selectionStartFix,
            selectionLength = editorSelectionLength,
            sEnd = sStart + selectionLength,
            tags_shift_positions = elEditor.val().length - editorTextLength;
          removeTagsInRange(sStart, sEnd);
          shiftTagsPosition(sEnd, tags_shift_positions);
        } else if (!editorInPasteMode) {
          // char input - shift with 1
          var sStart = elEditor[0].selectionStart + selectionStartFix,
            sEnd = elEditor[0].selectionEnd + selectionStartFix,
            selectionLength = sEnd - sStart;

          if (editorKeyCode == KEY.RETURN) {
            shiftTagsPosition(sStart - 1, 1);
            removeTagsInRange(sStart, sStart);
          } else {
            shiftTagsPosition(sStart, 1);
            removeTagsInRange(sStart, sStart + 1);
          }
        }
      }

      updateBeautifier();

      // Greenhouse edit: changed lookahead argument from 1 to 0, which caused putting @mentions
      // above other text to not work, as the 1-char lookahead included a newline and the trigger
      // regex wasn't matching
      checkForTrigger(0);
    }

    function onEditorBlur(e) {
      _.delay(hideTagList, 100);
    }

    function hideTagList() {
      elTagListItemActive = null;
      elTagList.hide().empty();
    }

    function onTagListItemClick(e) {
      addTag($(this).data('tag'));
      return false;
    }

    function removeTagsInRange(start, end) {
      var removedTags = [];
      tagsCollection = _.filter(tagsCollection, function (tagPos) {
        var s = tagPos[0],
          e = s + tagPos[1],
          inRange =
            (s >= start && s < end) ||
            (e > start && e <= end) ||
            (s < start && e > end);
        if (inRange) {
          removedTags.push(tagPos[3]);
        }
        return !inRange;
      });

      if (removedTags.length > 0) {
        elEditor.trigger('tagsRemoved.textntags', [removedTags]);
      }
    }

    function shiftTagsPosition(afterPosition, position_shift) {
      tagsCollection = _.map(tagsCollection, function (tagPos) {
        if (tagPos[0] >= afterPosition) {
          tagPos[0] += position_shift;
        }
        return tagPos;
      });
    }

    function addTag(tag) {
      var trigger = settings.triggers[currentTriggerChar],
        objPropTransformer = transformObjectProperties(trigger.keys_map),
        localTag = objPropTransformer(tag, false),
        plain_text = getEditorValue(),
        sStart = elEditor[0].selectionStart,
        tagStart = sStart - currentTriggerChar.length - currentDataQuery.length,
        newCaretPosition = tagStart + localTag.title.length,
        left_text = plain_text.substr(0, tagStart),
        right_text = plain_text.substr(sStart),
        new_text = left_text + localTag.title + right_text;

      // shift the tags after the current new one
      shiftTagsPosition(sStart, newCaretPosition - sStart);

      // explicitly convert to string for comparisons later
      tag[trigger.keys_map.id] = '' + tag[trigger.keys_map.id];

      tagsCollection.push([
        tagStart,
        localTag.title.length,
        currentTriggerChar,
        tag,
      ]);
      tagsCollection = _.sortBy(tagsCollection, function (t) {
        return t[0];
      });

      currentTriggerChar = '';
      currentDataQuery = '';
      hideTagList();

      elEditor.val(new_text);
      updateBeautifier();

      elEditor.focus();
      utils.setCaratPosition(elEditor[0], newCaretPosition);

      elEditor.trigger('tagsAdded.textntags', [[tag]]);
    }

    function selectTagListItem(tagItem, class_name) {
      if (tagItem && tagItem.length) {
        tagItem.addClass(class_name);
        tagItem.siblings().removeClass(class_name);
        elTagListItemActive = tagItem;
      } else {
        elTagListItemActive.removeClass(class_name);
        elTagListItemActive = null;
      }
    }

    function populateTagList(query, triggerChar, results) {
      var trigger = settings.triggers[triggerChar];

      if (trigger.uniqueTags) {
        // Filter items that has already been mentioned
        var id_key = trigger.keys_map.id,
          tagIds = _.map(tagsCollection, function (tagPos) {
            return tagPos[3][id_key];
          });
        results = _.reject(results, function (item) {
          // converting to string ids
          return _.include(tagIds, '' + item[id_key]);
        });
      }

      if (!results.length) {
        return;
      }

      var tagsDropDown = $('<ul />')
          .addClass(trigger.classes.tagsDropDown)
          .appendTo(elTagList),
        imgOrIconTpl = trigger.showImageOrIcon
          ? templates.tagsListItemImage
          : templates.tagsListItemIcon,
        objPropTransformer = transformObjectProperties(trigger.keys_map);

      _.each(results, function (tag, index) {
        var tagItem,
          localTag = objPropTransformer(tag, false);
        localTag.title = utils.highlightTerm(
          utils.htmlEncode(localTag.title),
          query
        );
        tagItem = $(templates.tagsListItem(localTag)).data('tag', tag);
        if (localTag.img) {
          tagItem = tagItem.prepend(imgOrIconTpl(localTag));
        }
        tagItem.appendTo(tagsDropDown);

        if (index === 0) {
          selectTagListItem(tagItem, trigger.classes.tagActiveDropDown);
        }
      });

      elTagList.show();
    }

    function searchTags(query, triggerChar) {
      hideTagList();
      settings.onDataRequest.call(
        this,
        'search',
        query,
        triggerChar,
        function (responseData) {
          populateTagList(query, triggerChar, responseData);
        }
      );
    }

    // Public methods
    return {
      init: function (options) {
        if (setSettings(options)) {
          initTextarea();
          initTagList();
          initBeautifier();
          initState();
        }
      },
      val: function (callback) {
        if (_.isString(callback)) {
          var removedTags = _.uniq(
            _.map(tagsCollection, function (tagPos) {
              return tagPos[3];
            })
          );
          elEditor.trigger('tagsRemoved.textntags', [removedTags]);
          elEditor.val(callback);
          initState();
          return;
        } else if (!_.isFunction(callback)) {
          return;
        }

        var value = tagsCollection.length ? getTaggedText() : getEditorValue();
        callback.call(this, value);
      },
      reset: function () {
        var removedTags = _.uniq(
          _.map(tagsCollection, function (tagPos) {
            return tagPos[3];
          })
        );
        elEditor.trigger('tagsRemoved.textntags', [removedTags]);
        elEditor.val('');
        tagsCollection = [];
        updateBeautifier();
      },
      getTags: function (callback) {
        if (!_.isFunction(callback)) {
          return;
        }
        var tags = _.map(tagsCollection, function (tagPos) {
          return tagPos[3];
        });

        callback.call(this, _.uniq(tags));
      },
      getTagsMap: function (callback) {
        if (!_.isFunction(callback)) {
          return;
        }

        callback.call(this, tagsCollection);
      },
      getTagsMapFacebook: function (callback) {
        if (!_.isFunction(callback)) {
          return;
        }
        var fbTagsCollection = {},
          triggers = settings.triggers;

        _.each(tagsCollection, function (tagPos) {
          var objPropTransformer = transformObjectProperties(
              triggers[tagPos[2]].keys_map
            ),
            localTag = objPropTransformer(tagPos[3], false);
          fbTagsCollection[tagPos[0]] = [
            {
              id: localTag.id,
              name: localTag.title,
              type: localTag.type,
              offset: tagPos[0],
              length: tagPos[1],
            },
          ];
        });

        callback.call(this, fbTagsCollection);
      },
      parseTaggedText: function (tagged_text, callback) {
        if (!_.isFunction(callback)) {
          return;
        }

        callback.call(this, parseTaggedText(tagged_text));
      },
    };
  };

  $.fn.textntags = function (methodOrSettings) {
    var outerArguments = arguments;

    return this.each(function () {
      var ms = methodOrSettings,
        instance =
          $.data(this, 'textntags') ||
          $.data(this, 'textntags', new TextNTags(this));

      if (_.isFunction(instance[ms])) {
        return instance[ms].apply(
          this,
          Array.prototype.slice.call(outerArguments, 1)
        );
      } else if (typeof ms === 'object' || !ms) {
        return instance.init.call(this, ms);
      } else {
        $.error('Method ' + ms + ' does not exist');
      }
    });
  };
})(jQuery, _);
/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch (e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = ($.cookie = function (key, value, options) {
    // Write

    if (value !== undefined && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires,
          t = (options.expires = new Date());
        t.setTime(+t + days * 864e5);
      }

      return (document.cookie = [
        encode(key),
        '=',
        stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path ? '; path=' + options.path : '',
        options.domain ? '; domain=' + options.domain : '',
        options.secure ? '; secure' : '',
      ].join(''));
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling $.cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i++) {
      var parts = cookies[i].split('=');
      var name = decode(parts.shift());
      var cookie = parts.join('=');

      if (key && key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  });

  config.defaults = {};

  $.removeCookie = function (key, options) {
    if ($.cookie(key) === undefined) {
      return false;
    }

    // Must not alter options, thus extending a fresh object...
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };
});
/*!
 * jQuery Form Plugin
 * version: 3.49.0-2014.02.05
 * Requires jQuery v1.5 or later
 * Copyright (c) 2013 M. Alsup
 * Examples and documentation at: http://malsup.com/jquery/form/
 * Project repository: https://github.com/malsup/form
 * Dual licensed under the MIT and GPL licenses.
 * https://github.com/malsup/form#copyright-and-license
 */
/*global ActiveXObject */

// AMD support
(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // using AMD; register as anon module
    define(['jquery'], factory);
  } else {
    // no AMD; invoke directly
    factory(typeof jQuery != 'undefined' ? jQuery : window.Zepto);
  }
})(function ($) {
  'use strict';

  /*
   Usage Note:
   -----------
   Do not use both ajaxSubmit and ajaxForm on the same form.  These
   functions are mutually exclusive.  Use ajaxSubmit if you want
   to bind your own submit handler to the form.  For example,

   $(document).ready(function() {
   $('#myForm').on('submit', function(e) {
   e.preventDefault(); // <-- important
   $(this).ajaxSubmit({
   target: '#output'
   });
   });
   });

   Use ajaxForm when you want the plugin to manage all the event binding
   for you.  For example,

   $(document).ready(function() {
   $('#myForm').ajaxForm({
   target: '#output'
   });
   });

   You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
   form does not have to exist when you invoke ajaxForm:

   $('#myForm').ajaxForm({
   delegation: true,
   target: '#output'
   });

   When using ajaxForm, the ajaxSubmit function will be invoked for you
   at the appropriate time.
   */

  /**
   * Feature detection
   */
  var feature = {};
  feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
  feature.formdata = window.FormData !== undefined;

  var hasProp = !!$.fn.prop;

  // attr2 uses prop when it can but checks the return type for
  // an expected string.  this accounts for the case where a form
  // contains inputs with names like "action" or "method"; in those
  // cases "prop" returns the element
  $.fn.attr2 = function () {
    if (!hasProp) {
      return this.attr.apply(this, arguments);
    }
    var val = this.prop.apply(this, arguments);
    if ((val && val.jquery) || typeof val === 'string') {
      return val;
    }
    return this.attr.apply(this, arguments);
  };

  /**
   * ajaxSubmit() provides a mechanism for immediately submitting
   * an HTML form using AJAX.
   */
  $.fn.ajaxSubmit = function (options) {
    /*jshint scripturl:true */

    // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
    if (!this.length) {
      log('ajaxSubmit: skipping submit process - no element selected');
      return this;
    }

    var method,
      action,
      url,
      $form = this;

    if (typeof options == 'function') {
      options = { success: options };
    } else if (options === undefined) {
      options = {};
    }

    method = options.type || this.attr2('method');
    action = options.url || this.attr2('action');

    url = typeof action === 'string' ? $.trim(action) : '';
    url = url || window.location.href || '';
    if (url) {
      // clean url (don't include hash vaue)
      url = (url.match(/^([^#]+)/) || [])[1];
    }

    options = $.extend(
      true,
      {
        url: url,
        success: $.ajaxSettings.success,
        type: method || $.ajaxSettings.type,
        iframeSrc: /^https/i.test(window.location.href || '')
          ? 'javascript:false'
          : 'about:blank',
      },
      options
    );

    // hook for manipulating the form data before it is extracted;
    // convenient for use with rich editors like tinyMCE or FCKEditor
    var veto = {};
    this.trigger('form-pre-serialize', [this, options, veto]);
    if (veto.veto) {
      log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
      return this;
    }

    // provide opportunity to alter form data before it is serialized
    if (
      options.beforeSerialize &&
      options.beforeSerialize(this, options) === false
    ) {
      log('ajaxSubmit: submit aborted via beforeSerialize callback');
      return this;
    }

    var traditional = options.traditional;
    if (traditional === undefined) {
      traditional = $.ajaxSettings.traditional;
    }

    var elements = [];
    var qx,
      a = this.formToArray(options.semantic, elements);
    if (options.data) {
      options.extraData = options.data;
      qx = $.param(options.data, traditional);
    }

    // give pre-submit callback an opportunity to abort the submit
    if (
      options.beforeSubmit &&
      options.beforeSubmit(a, this, options) === false
    ) {
      log('ajaxSubmit: submit aborted via beforeSubmit callback');
      return this;
    }

    // fire vetoable 'validate' event
    this.trigger('form-submit-validate', [a, this, options, veto]);
    if (veto.veto) {
      log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
      return this;
    }

    var q = $.param(a, traditional);
    if (qx) {
      q = q ? q + '&' + qx : qx;
    }
    if (options.type.toUpperCase() == 'GET') {
      options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
      options.data = null; // data is null for 'get'
    } else {
      options.data = q; // data is the query string for 'post'
    }

    var callbacks = [];
    if (options.resetForm) {
      callbacks.push(function () {
        $form.resetForm();
      });
    }
    if (options.clearForm) {
      callbacks.push(function () {
        $form.clearForm(options.includeHidden);
      });
    }

    // perform a load on the target only if dataType is not provided
    if (!options.dataType && options.target) {
      var oldSuccess = options.success || function () {};
      callbacks.push(function (data) {
        var fn = options.replaceTarget ? 'replaceWith' : 'html';
        $(options.target)[fn](data).each(oldSuccess, arguments);
      });
    } else if (options.success) {
      callbacks.push(options.success);
    }

    options.success = function (data, status, xhr) {
      // jQuery 1.4+ passes xhr as 3rd arg
      var context = options.context || this; // jQuery 1.4+ supports scope context
      for (var i = 0, max = callbacks.length; i < max; i++) {
        callbacks[i].apply(context, [data, status, xhr || $form, $form]);
      }
    };

    if (options.error) {
      var oldError = options.error;
      options.error = function (xhr, status, error) {
        var context = options.context || this;
        oldError.apply(context, [xhr, status, error, $form]);
      };
    }

    if (options.complete) {
      var oldComplete = options.complete;
      options.complete = function (xhr, status) {
        var context = options.context || this;
        oldComplete.apply(context, [xhr, status, $form]);
      };
    }

    // are there files to upload?

    // [value] (issue #113), also see comment:
    // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
    var fileInputs = $('input[type=file]:enabled', this).filter(function () {
      return $(this).val() !== '';
    });

    var hasFileInputs = fileInputs.length > 0;
    var mp = 'multipart/form-data';
    var multipart = $form.attr('enctype') == mp || $form.attr('encoding') == mp;

    var fileAPI = feature.fileapi && feature.formdata;
    log('fileAPI :' + fileAPI);
    var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;

    var jqxhr;

    // options.iframe allows user to force iframe mode
    // 06-NOV-09: now defaulting to iframe mode if file input is detected
    if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
      // hack to fix Safari hang (thanks to Tim Molendijk for this)
      // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
      if (options.closeKeepAlive) {
        $.get(options.closeKeepAlive, function () {
          jqxhr = fileUploadIframe(a);
        });
      } else {
        jqxhr = fileUploadIframe(a);
      }
    } else if ((hasFileInputs || multipart) && fileAPI) {
      jqxhr = fileUploadXhr(a);
    } else {
      jqxhr = $.ajax(options);
    }

    $form.removeData('jqxhr').data('jqxhr', jqxhr);

    // clear element array
    for (var k = 0; k < elements.length; k++) {
      elements[k] = null;
    }

    // fire 'notify' event
    this.trigger('form-submit-notify', [this, options]);
    return this;

    // utility fn for deep serialization
    function deepSerialize(extraData) {
      var serialized = $.param(extraData, options.traditional).split('&');
      var len = serialized.length;
      var result = [];
      var i, part;
      for (i = 0; i < len; i++) {
        // #252; undo param space replacement
        serialized[i] = serialized[i].replace(/\+/g, ' ');
        part = serialized[i].split('=');
        // #278; use array instead of object storage, favoring array serializations
        result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
      }
      return result;
    }

    // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
    function fileUploadXhr(a) {
      var formdata = new FormData();

      for (var i = 0; i < a.length; i++) {
        formdata.append(a[i].name, a[i].value);
      }

      if (options.extraData) {
        var serializedData = deepSerialize(options.extraData);
        for (i = 0; i < serializedData.length; i++) {
          if (serializedData[i]) {
            formdata.append(serializedData[i][0], serializedData[i][1]);
          }
        }
      }

      options.data = null;

      var s = $.extend(true, {}, $.ajaxSettings, options, {
        contentType: false,
        processData: false,
        cache: false,
        type: method || 'POST',
      });

      if (options.uploadProgress) {
        // workaround because jqXHR does not expose upload property
        s.xhr = function () {
          var xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener(
              'progress',
              function (event) {
                var percent = 0;
                var position =
                  event.loaded ||
                  event.position; /*event.position is deprecated*/
                var total = event.total;
                if (event.lengthComputable) {
                  percent = Math.ceil((position / total) * 100);
                }
                options.uploadProgress(event, position, total, percent);
              },
              false
            );
          }
          return xhr;
        };
      }

      s.data = null;
      var beforeSend = s.beforeSend;
      s.beforeSend = function (xhr, o) {
        //Send FormData() provided by user
        if (options.formData) {
          o.data = options.formData;
        } else {
          o.data = formdata;
        }
        if (beforeSend) {
          beforeSend.call(this, xhr, o);
        }
      };
      return $.ajax(s);
    }

    // private function for handling file uploads (hat tip to YAHOO!)
    function fileUploadIframe(a) {
      var form = $form[0],
        el,
        i,
        s,
        g,
        id,
        $io,
        io,
        xhr,
        sub,
        n,
        timedOut,
        timeoutHandle;
      var deferred = $.Deferred();

      // #341
      deferred.abort = function (status) {
        xhr.abort(status);
      };

      if (a) {
        // ensure that every serialized input is still enabled
        for (i = 0; i < elements.length; i++) {
          el = $(elements[i]);
          if (hasProp) {
            el.prop('disabled', false);
          } else {
            el.removeAttr('disabled');
          }
        }
      }

      s = $.extend(true, {}, $.ajaxSettings, options);
      s.context = s.context || s;
      id = 'jqFormIO' + new Date().getTime();
      if (s.iframeTarget) {
        $io = $(s.iframeTarget);
        n = $io.attr2('name');
        if (!n) {
          $io.attr2('name', id);
        } else {
          id = n;
        }
      } else {
        $io = $('<iframe name="' + id + '" src="' + s.iframeSrc + '" />');
        $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
      }
      io = $io[0];

      xhr = {
        // mock object
        aborted: 0,
        responseText: null,
        responseXML: null,
        status: 0,
        statusText: 'n/a',
        getAllResponseHeaders: function () {},
        getResponseHeader: function () {},
        setRequestHeader: function () {},
        abort: function (status) {
          var e = status === 'timeout' ? 'timeout' : 'aborted';
          log('aborting upload... ' + e);
          this.aborted = 1;

          try {
            // #214, #257
            if (io.contentWindow.document.execCommand) {
              io.contentWindow.document.execCommand('Stop');
            }
          } catch (ignore) {}

          $io.attr('src', s.iframeSrc); // abort op in progress
          xhr.error = e;
          if (s.error) {
            s.error.call(s.context, xhr, e, status);
          }
          if (g) {
            $.event.trigger('ajaxError', [xhr, s, e]);
          }
          if (s.complete) {
            s.complete.call(s.context, xhr, e);
          }
        },
      };

      g = s.global;
      // trigger ajax global events so that activity/block indicators work like normal
      if (g && 0 === $.active++) {
        $.event.trigger('ajaxStart');
      }
      if (g) {
        $.event.trigger('ajaxSend', [xhr, s]);
      }

      if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
        if (s.global) {
          $.active--;
        }
        deferred.reject();
        return deferred;
      }
      if (xhr.aborted) {
        deferred.reject();
        return deferred;
      }

      // add submitting element to data if we know it
      sub = form.clk;
      if (sub) {
        n = sub.name;
        if (n && !sub.disabled) {
          s.extraData = s.extraData || {};
          s.extraData[n] = sub.value;
          if (sub.type == 'image') {
            s.extraData[n + '.x'] = form.clk_x;
            s.extraData[n + '.y'] = form.clk_y;
          }
        }
      }

      var CLIENT_TIMEOUT_ABORT = 1;
      var SERVER_ABORT = 2;

      function getDoc(frame) {
        /* it looks like contentWindow or contentDocument do not
         * carry the protocol property in ie8, when running under ssl
         * frame.document is the only valid response document, since
         * the protocol is know but not on the other two objects. strange?
         * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
         */

        var doc = null;

        // IE8 cascading access check
        try {
          if (frame.contentWindow) {
            doc = frame.contentWindow.document;
          }
        } catch (err) {
          // IE8 access denied under ssl & missing protocol
          log('cannot get iframe.contentWindow document: ' + err);
        }

        if (doc) {
          // successful getting content
          return doc;
        }

        try {
          // simply checking may throw in ie8 under ssl or mismatched protocol
          doc = frame.contentDocument ? frame.contentDocument : frame.document;
        } catch (err) {
          // last attempt
          log('cannot get iframe.contentDocument: ' + err);
          doc = frame.document;
        }
        return doc;
      }

      // Rails CSRF hack (thanks to Yvan Barthelemy)
      var csrf_token = $('meta[name=csrf-token]').attr('content');
      var csrf_param = $('meta[name=csrf-param]').attr('content');
      if (csrf_param && csrf_token) {
        s.extraData = s.extraData || {};
        s.extraData[csrf_param] = csrf_token;
      }

      // take a breath so that pending repaints get some cpu time before the upload starts
      function doSubmit() {
        // make sure form attrs are set
        var t = $form.attr2('target'),
          a = $form.attr2('action'),
          mp = 'multipart/form-data',
          et = $form.attr('enctype') || $form.attr('encoding') || mp;

        // update form attrs in IE friendly way
        form.setAttribute('target', id);
        if (!method || /post/i.test(method)) {
          form.setAttribute('method', 'POST');
        }
        if (a != s.url) {
          form.setAttribute('action', s.url);
        }

        // ie borks in some cases when setting encoding
        if (!s.skipEncodingOverride && (!method || /post/i.test(method))) {
          $form.attr({
            encoding: 'multipart/form-data',
            enctype: 'multipart/form-data',
          });
        }

        // support timout
        if (s.timeout) {
          timeoutHandle = setTimeout(function () {
            timedOut = true;
            cb(CLIENT_TIMEOUT_ABORT);
          }, s.timeout);
        }

        // look for server aborts
        function checkState() {
          try {
            var state = getDoc(io).readyState;
            log('state = ' + state);
            if (state && state.toLowerCase() == 'uninitialized') {
              setTimeout(checkState, 50);
            }
          } catch (e) {
            log('Server abort: ', e, ' (', e.name, ')');
            cb(SERVER_ABORT);
            if (timeoutHandle) {
              clearTimeout(timeoutHandle);
            }
            timeoutHandle = undefined;
          }
        }

        // add "extra" data to form if provided in options
        var extraInputs = [];
        try {
          if (s.extraData) {
            for (var n in s.extraData) {
              if (s.extraData.hasOwnProperty(n)) {
                // if using the $.param format that allows for multiple values with the same name
                if (
                  $.isPlainObject(s.extraData[n]) &&
                  s.extraData[n].hasOwnProperty('name') &&
                  s.extraData[n].hasOwnProperty('value')
                ) {
                  extraInputs.push(
                    $(
                      '<input type="hidden" name="' + s.extraData[n].name + '">'
                    )
                      .val(s.extraData[n].value)
                      .appendTo(form)[0]
                  );
                } else {
                  extraInputs.push(
                    $('<input type="hidden" name="' + n + '">')
                      .val(s.extraData[n])
                      .appendTo(form)[0]
                  );
                }
              }
            }
          }

          if (!s.iframeTarget) {
            // add iframe to doc and submit the form
            $io.appendTo('body');
          }
          if (io.attachEvent) {
            io.attachEvent('onload', cb);
          } else {
            io.addEventListener('load', cb, false);
          }
          setTimeout(checkState, 15);

          try {
            form.submit();
          } catch (err) {
            // just in case form has element with name/id of 'submit'
            var submitFn = document.createElement('form').submit;
            submitFn.apply(form);
          }
        } finally {
          // reset attrs and remove "extra" input elements
          form.setAttribute('action', a);
          form.setAttribute('enctype', et); // #380
          if (t) {
            form.setAttribute('target', t);
          } else {
            $form.removeAttr('target');
          }
          $(extraInputs).remove();
        }
      }

      if (s.forceSync) {
        doSubmit();
      } else {
        setTimeout(doSubmit, 10); // this lets dom updates render
      }

      var data,
        doc,
        domCheckCount = 50,
        callbackProcessed;

      function cb(e) {
        if (xhr.aborted || callbackProcessed) {
          return;
        }

        doc = getDoc(io);
        if (!doc) {
          log('cannot access response document');
          e = SERVER_ABORT;
        }
        if (e === CLIENT_TIMEOUT_ABORT && xhr) {
          xhr.abort('timeout');
          deferred.reject(xhr, 'timeout');
          return;
        } else if (e == SERVER_ABORT && xhr) {
          xhr.abort('server abort');
          deferred.reject(xhr, 'error', 'server abort');
          return;
        }

        if (!doc || doc.location.href == s.iframeSrc) {
          // response not received yet
          if (!timedOut) {
            return;
          }
        }
        if (io.detachEvent) {
          io.detachEvent('onload', cb);
        } else {
          io.removeEventListener('load', cb, false);
        }

        var status = 'success',
          errMsg;
        try {
          if (timedOut) {
            throw 'timeout';
          }

          var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
          log('isXml=' + isXml);
          if (
            !isXml &&
            window.opera &&
            (doc.body === null || !doc.body.innerHTML)
          ) {
            if (--domCheckCount) {
              // in some browsers (Opera) the iframe DOM is not always traversable when
              // the onload callback fires, so we loop a bit to accommodate
              log('requeing onLoad callback, DOM not available');
              setTimeout(cb, 250);
              return;
            }
            // let this fall through because server response could be an empty document
            //log('Could not access iframe DOM after mutiple tries.');
            //throw 'DOMException: not available';
          }

          //log('response detected');
          var docRoot = doc.body ? doc.body : doc.documentElement;
          xhr.responseText = docRoot ? docRoot.innerHTML : null;
          xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
          if (isXml) {
            s.dataType = 'xml';
          }
          xhr.getResponseHeader = function (header) {
            var headers = { 'content-type': s.dataType };
            return headers[header.toLowerCase()];
          };
          // support for XHR 'status' & 'statusText' emulation :
          if (docRoot) {
            xhr.status = Number(docRoot.getAttribute('status')) || xhr.status;
            xhr.statusText =
              docRoot.getAttribute('statusText') || xhr.statusText;
          }

          var dt = (s.dataType || '').toLowerCase();
          var scr = /(json|script|text)/.test(dt);
          if (scr || s.textarea) {
            // see if user embedded response in textarea
            var ta = doc.getElementsByTagName('textarea')[0];
            if (ta) {
              xhr.responseText = ta.value;
              // support for XHR 'status' & 'statusText' emulation :
              xhr.status = Number(ta.getAttribute('status')) || xhr.status;
              xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
            } else if (scr) {
              // account for browsers injecting pre around json response
              var pre = doc.getElementsByTagName('pre')[0];
              var b = doc.getElementsByTagName('body')[0];
              if (pre) {
                xhr.responseText = pre.textContent
                  ? pre.textContent
                  : pre.innerText;
              } else if (b) {
                xhr.responseText = b.textContent ? b.textContent : b.innerText;
              }
            }
          } else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
            xhr.responseXML = toXml(xhr.responseText);
          }

          try {
            data = httpData(xhr, dt, s);
          } catch (err) {
            status = 'parsererror';
            xhr.error = errMsg = err || status;
          }
        } catch (err) {
          log('error caught: ', err);
          status = 'error';
          xhr.error = errMsg = err || status;
        }

        if (xhr.aborted) {
          log('upload aborted');
          status = null;
        }

        if (xhr.status) {
          // we've set xhr.status
          status =
            (xhr.status >= 200 && xhr.status < 300) || xhr.status === 304
              ? 'success'
              : 'error';
        }

        // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
        if (status === 'success') {
          if (s.success) {
            s.success.call(s.context, data, 'success', xhr);
          }
          deferred.resolve(xhr.responseText, 'success', xhr);
          if (g) {
            $.event.trigger('ajaxSuccess', [xhr, s]);
          }
        } else if (status) {
          if (errMsg === undefined) {
            errMsg = xhr.statusText;
          }
          if (s.error) {
            s.error.call(s.context, xhr, status, errMsg);
          }
          deferred.reject(xhr, 'error', errMsg);
          if (g) {
            $.event.trigger('ajaxError', [xhr, s, errMsg]);
          }
        }

        if (g) {
          $.event.trigger('ajaxComplete', [xhr, s]);
        }

        if (g && !--$.active) {
          $.event.trigger('ajaxStop');
        }

        if (s.complete) {
          s.complete.call(s.context, xhr, status);
        }

        callbackProcessed = true;
        if (s.timeout) {
          clearTimeout(timeoutHandle);
        }

        // clean up
        setTimeout(function () {
          if (!s.iframeTarget) {
            $io.remove();
          } else {
            //adding else to clean up existing iframe response.
            $io.attr('src', s.iframeSrc);
          }
          xhr.responseXML = null;
        }, 100);
      }

      var toXml =
        $.parseXML ||
        function (s, doc) {
          // use parseXML if available (jQuery 1.5+)
          if (window.ActiveXObject) {
            doc = new ActiveXObject('Microsoft.XMLDOM');
            doc.async = 'false';
            doc.loadXML(s);
          } else {
            doc = new DOMParser().parseFromString(s, 'text/xml');
          }
          return doc &&
            doc.documentElement &&
            doc.documentElement.nodeName != 'parsererror'
            ? doc
            : null;
        };
      var parseJSON =
        $.parseJSON ||
        function (s) {
          /*jslint evil:true */
          return window['eval']('(' + s + ')');
        };

      var httpData = function (xhr, type, s) {
        // mostly lifted from jq1.4.4

        var ct = xhr.getResponseHeader('content-type') || '',
          xml = type === 'xml' || (!type && ct.indexOf('xml') >= 0),
          data = xml ? xhr.responseXML : xhr.responseText;

        if (xml && data.documentElement.nodeName === 'parsererror') {
          if ($.error) {
            $.error('parsererror');
          }
        }
        if (s && s.dataFilter) {
          data = s.dataFilter(data, type);
        }
        if (typeof data === 'string') {
          if (type === 'json' || (!type && ct.indexOf('json') >= 0)) {
            data = parseJSON(data);
          } else if (
            type === 'script' ||
            (!type && ct.indexOf('javascript') >= 0)
          ) {
            $.globalEval(data);
          }
        }
        return data;
      };

      return deferred;
    }
  };

  /**
   * ajaxForm() provides a mechanism for fully automating form submission.
   *
   * The advantages of using this method instead of ajaxSubmit() are:
   *
   * 1: This method will include coordinates for <input type="image" /> elements (if the element
   *    is used to submit the form).
   * 2. This method will include the submit element's name/value data (for the element that was
   *    used to submit the form).
   * 3. This method binds the submit() method to the form for you.
   *
   * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
   * passes the options argument along after properly binding events for submit elements and
   * the form itself.
   */
  $.fn.ajaxForm = function (options) {
    options = options || {};
    options.delegation = options.delegation && $.isFunction($.fn.on);

    // in jQuery 1.3+ we can fix mistakes with the ready state
    if (!options.delegation && this.length === 0) {
      var o = { s: this.selector, c: this.context };
      if (!$.isReady && o.s) {
        log('DOM not ready, queuing ajaxForm');
        $(function () {
          $(o.s, o.c).ajaxForm(options);
        });
        return this;
      }
      // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
      log(
        'terminating; zero elements found by selector' +
          ($.isReady ? '' : ' (DOM not ready)')
      );
      return this;
    }

    if (options.delegation) {
      $(document)
        .off('submit.form-plugin', this.selector, doAjaxSubmit)
        .off('click.form-plugin', this.selector, captureSubmittingElement)
        .on('submit.form-plugin', this.selector, options, doAjaxSubmit)
        .on(
          'click.form-plugin',
          this.selector,
          options,
          captureSubmittingElement
        );
      return this;
    }

    return this.ajaxFormUnbind()
      .bind('submit.form-plugin', options, doAjaxSubmit)
      .bind('click.form-plugin', options, captureSubmittingElement);
  };

  // private event handlers
  function doAjaxSubmit(e) {
    /*jshint validthis:true */
    var options = e.data;
    if (!e.isDefaultPrevented()) {
      // if event has been canceled, don't proceed
      e.preventDefault();
      $(e.target).ajaxSubmit(options); // #365
    }
  }

  function captureSubmittingElement(e) {
    /*jshint validthis:true */
    var target = e.target;
    var $el = $(target);
    if (!$el.is('[type=submit],[type=image]')) {
      // is this a child element of the submit el?  (ex: a span within a button)
      var t = $el.closest('[type=submit]');
      if (t.length === 0) {
        return;
      }
      target = t[0];
    }
    var form = this;
    form.clk = target;
    if (target.type == 'image') {
      if (e.offsetX !== undefined) {
        form.clk_x = e.offsetX;
        form.clk_y = e.offsetY;
      } else if (typeof $.fn.offset == 'function') {
        var offset = $el.offset();
        form.clk_x = e.pageX - offset.left;
        form.clk_y = e.pageY - offset.top;
      } else {
        form.clk_x = e.pageX - target.offsetLeft;
        form.clk_y = e.pageY - target.offsetTop;
      }
    }
    // clear form vars
    setTimeout(function () {
      form.clk = form.clk_x = form.clk_y = null;
    }, 100);
  }

  // ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
  $.fn.ajaxFormUnbind = function () {
    return this.unbind('submit.form-plugin click.form-plugin');
  };

  /**
   * formToArray() gathers form element data into an array of objects that can
   * be passed to any of the following ajax functions: $.get, $.post, or load.
   * Each object in the array has both a 'name' and 'value' property.  An example of
   * an array for a simple login form might be:
   *
   * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
   *
   * It is this array that is passed to pre-submit callback functions provided to the
   * ajaxSubmit() and ajaxForm() methods.
   */
  $.fn.formToArray = function (semantic, elements) {
    var a = [];
    if (this.length === 0) {
      return a;
    }

    var form = this[0];
    var formId = this.attr('id');
    var els = semantic ? form.getElementsByTagName('*') : form.elements;
    var els2;

    if (els && !/MSIE 8/.test(navigator.userAgent)) {
      // #390
      els = $(els).get(); // convert to standard array
    }

    // #386; account for inputs outside the form which use the 'form' attribute
    if (formId) {
      els2 = $(':input[form=' + formId + ']').get();
      if (els2.length) {
        els = (els || []).concat(els2);
      }
    }

    if (!els || !els.length) {
      return a;
    }

    var i, j, n, v, el, max, jmax;
    for (i = 0, max = els.length; i < max; i++) {
      el = els[i];
      n = el.name;
      if (!n || el.disabled) {
        continue;
      }

      if (semantic && form.clk && el.type == 'image') {
        // handle image inputs on the fly when semantic == true
        if (form.clk == el) {
          a.push({ name: n, value: $(el).val(), type: el.type });
          a.push(
            { name: n + '.x', value: form.clk_x },
            { name: n + '.y', value: form.clk_y }
          );
        }
        continue;
      }

      v = $.fieldValue(el, true);
      if (v && v.constructor == Array) {
        if (elements) {
          elements.push(el);
        }
        for (j = 0, jmax = v.length; j < jmax; j++) {
          a.push({ name: n, value: v[j] });
        }
      } else if (feature.fileapi && el.type == 'file') {
        if (elements) {
          elements.push(el);
        }
        var files = el.files;
        if (files.length) {
          for (j = 0; j < files.length; j++) {
            a.push({ name: n, value: files[j], type: el.type });
          }
        } else {
          // #180
          a.push({ name: n, value: '', type: el.type });
        }
      } else if (v !== null && typeof v != 'undefined') {
        if (elements) {
          elements.push(el);
        }
        a.push({ name: n, value: v, type: el.type, required: el.required });
      }
    }

    if (!semantic && form.clk) {
      // input type=='image' are not found in elements array! handle it here
      var $input = $(form.clk),
        input = $input[0];
      n = input.name;
      if (n && !input.disabled && input.type == 'image') {
        a.push({ name: n, value: $input.val() });
        a.push(
          { name: n + '.x', value: form.clk_x },
          { name: n + '.y', value: form.clk_y }
        );
      }
    }
    return a;
  };

  /**
   * Serializes form data into a 'submittable' string. This method will return a string
   * in the format: name1=value1&amp;name2=value2
   */
  $.fn.formSerialize = function (semantic) {
    //hand off to jQuery.param for proper encoding
    return $.param(this.formToArray(semantic));
  };

  /**
   * Serializes all field elements in the jQuery object into a query string.
   * This method will return a string in the format: name1=value1&amp;name2=value2
   */
  $.fn.fieldSerialize = function (successful) {
    var a = [];
    this.each(function () {
      var n = this.name;
      if (!n) {
        return;
      }
      var v = $.fieldValue(this, successful);
      if (v && v.constructor == Array) {
        for (var i = 0, max = v.length; i < max; i++) {
          a.push({ name: n, value: v[i] });
        }
      } else if (v !== null && typeof v != 'undefined') {
        a.push({ name: this.name, value: v });
      }
    });
    //hand off to jQuery.param for proper encoding
    return $.param(a);
  };

  /**
   * Returns the value(s) of the element in the matched set.  For example, consider the following form:
   *
   *  <form><fieldset>
   *      <input name="A" type="text" />
   *      <input name="A" type="text" />
   *      <input name="B" type="checkbox" value="B1" />
   *      <input name="B" type="checkbox" value="B2"/>
   *      <input name="C" type="radio" value="C1" />
   *      <input name="C" type="radio" value="C2" />
   *  </fieldset></form>
   *
   *  var v = $('input[type=text]').fieldValue();
   *  // if no values are entered into the text inputs
   *  v == ['','']
   *  // if values entered into the text inputs are 'foo' and 'bar'
   *  v == ['foo','bar']
   *
   *  var v = $('input[type=checkbox]').fieldValue();
   *  // if neither checkbox is checked
   *  v === undefined
   *  // if both checkboxes are checked
   *  v == ['B1', 'B2']
   *
   *  var v = $('input[type=radio]').fieldValue();
   *  // if neither radio is checked
   *  v === undefined
   *  // if first radio is checked
   *  v == ['C1']
   *
   * The successful argument controls whether or not the field element must be 'successful'
   * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
   * The default value of the successful argument is true.  If this value is false the value(s)
   * for each element is returned.
   *
   * Note: This method *always* returns an array.  If no valid value can be determined the
   *    array will be empty, otherwise it will contain one or more values.
   */
  $.fn.fieldValue = function (successful) {
    for (var val = [], i = 0, max = this.length; i < max; i++) {
      var el = this[i];
      var v = $.fieldValue(el, successful);
      if (
        v === null ||
        typeof v == 'undefined' ||
        (v.constructor == Array && !v.length)
      ) {
        continue;
      }
      if (v.constructor == Array) {
        $.merge(val, v);
      } else {
        val.push(v);
      }
    }
    return val;
  };

  /**
   * Returns the value of the field element.
   */
  $.fieldValue = function (el, successful) {
    var n = el.name,
      t = el.type,
      tag = el.tagName.toLowerCase();
    if (successful === undefined) {
      successful = true;
    }

    if (
      successful &&
      (!n ||
        el.disabled ||
        t == 'reset' ||
        t == 'button' ||
        ((t == 'checkbox' || t == 'radio') && !el.checked) ||
        ((t == 'submit' || t == 'image') && el.form && el.form.clk != el) ||
        (tag == 'select' && el.selectedIndex == -1))
    ) {
      return null;
    }

    if (tag == 'select') {
      var index = el.selectedIndex;
      if (index < 0) {
        return null;
      }
      var a = [],
        ops = el.options;
      var one = t == 'select-one';
      var max = one ? index + 1 : ops.length;
      for (var i = one ? index : 0; i < max; i++) {
        var op = ops[i];
        if (op.selected) {
          var v = op.value;
          if (!v) {
            // extra pain for IE...
            v =
              op.attributes &&
              op.attributes.value &&
              !op.attributes.value.specified
                ? op.text
                : op.value;
          }
          if (one) {
            return v;
          }
          a.push(v);
        }
      }
      return a;
    }
    return $(el).val();
  };

  /**
   * Clears the form data.  Takes the following actions on the form's input fields:
   *  - input text fields will have their 'value' property set to the empty string
   *  - select elements will have their 'selectedIndex' property set to -1
   *  - checkbox and radio inputs will have their 'checked' property set to false
   *  - inputs of type submit, button, reset, and hidden will *not* be effected
   *  - button elements will *not* be effected
   */
  $.fn.clearForm = function (includeHidden) {
    return this.each(function () {
      $('input,select,textarea', this).clearFields(includeHidden);
    });
  };

  /**
   * Clears the selected form elements.
   */
  $.fn.clearFields = $.fn.clearInputs = function (includeHidden) {
    var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
    return this.each(function () {
      var t = this.type,
        tag = this.tagName.toLowerCase();
      if (re.test(t) || tag == 'textarea') {
        this.value = '';
      } else if (t == 'checkbox' || t == 'radio') {
        this.checked = false;
      } else if (tag == 'select') {
        this.selectedIndex = -1;
      } else if (t == 'file') {
        if (/MSIE/.test(navigator.userAgent)) {
          $(this).replaceWith($(this).clone(true));
        } else {
          $(this).val('');
        }
      } else if (includeHidden) {
        // includeHidden can be the value true, or it can be a selector string
        // indicating a special test; for example:
        //  $('#myForm').clearForm('.special:hidden')
        // the above would clean hidden inputs that have the class of 'special'
        if (
          (includeHidden === true && /hidden/.test(t)) ||
          (typeof includeHidden == 'string' && $(this).is(includeHidden))
        ) {
          this.value = '';
        }
      }
    });
  };

  /**
   * Resets the form data.  Causes all form elements to be reset to their original value.
   */
  $.fn.resetForm = function () {
    return this.each(function () {
      // guard against an input with the name of 'reset'
      // note that IE reports the reset function as an 'object'
      if (
        typeof this.reset == 'function' ||
        (typeof this.reset == 'object' && !this.reset.nodeType)
      ) {
        this.reset();
      }
    });
  };

  /**
   * Enables or disables any matching elements.
   */
  $.fn.enable = function (b) {
    if (b === undefined) {
      b = true;
    }
    return this.each(function () {
      this.disabled = !b;
    });
  };

  /**
   * Checks/unchecks any matching checkboxes or radio buttons and
   * selects/deselects and matching option elements.
   */
  $.fn.selected = function (select) {
    if (select === undefined) {
      select = true;
    }
    return this.each(function () {
      var t = this.type;
      if (t == 'checkbox' || t == 'radio') {
        this.checked = select;
      } else if (this.tagName.toLowerCase() == 'option') {
        var $sel = $(this).parent('select');
        if (select && $sel[0] && $sel[0].type == 'select-one') {
          // deselect all other options
          $sel.find('option').selected(false);
        }
        this.selected = select;
      }
    });
  };

  // expose debug var
  $.fn.ajaxSubmit.debug = false;

  // helper fn for console logging
  function log() {
    if (!$.fn.ajaxSubmit.debug) {
      return;
    }
    var msg = '[jquery.form] ' + Array.prototype.join.call(arguments, '');
    if (window.console && window.console.log) {
      window.console.log(msg);
    } else if (window.opera && window.opera.postError) {
      window.opera.postError(msg);
    }
  }
});
/*
 *
 * Copyright (c) 2006-2014 Sam Collett (http://www.texotela.co.uk)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version 1.4.1
 * Demo: http://www.texotela.co.uk/code/jquery/numeric/
 *
 */
(function ($) {
  /*
   * Allows only valid characters to be entered into input boxes.
   * Note: fixes value when pasting via Ctrl+V, but not when using the mouse to paste
   *      side-effect: Ctrl+A does not work, though you can still use the mouse to select (or double-click to select all)
   *
   * @name     numeric
   * @param    config      { decimal : "." , negative : true }
   * @param    callback     A function that runs if the number is not valid (fires onblur)
   * @author   Sam Collett (http://www.texotela.co.uk)
   * @example  $(".numeric").numeric();
   * @example  $(".numeric").numeric(","); // use , as separator
   * @example  $(".numeric").numeric({ decimal : "," }); // use , as separator
   * @example  $(".numeric").numeric({ negative : false }); // do not allow negative values
   * @example  $(".numeric").numeric({ decimalPlaces : 2 }); // only allow 2 decimal places
   * @example  $(".numeric").numeric(null, callback); // use default values, pass on the 'callback' function
   *
   */
  $.fn.numeric = function (config, callback) {
    if (typeof config === 'boolean') {
      config = { decimal: config, negative: true, decimalPlaces: -1 };
    }
    config = config || {};
    // if config.negative undefined, set to true (default is to allow negative numbers)
    if (typeof config.negative == 'undefined') {
      config.negative = true;
    }
    // set decimal point
    var decimal = config.decimal === false ? '' : config.decimal || '.';
    // allow negatives
    var negative = config.negative === true ? true : false;
    // set decimal places
    var decimalPlaces =
      typeof config.decimalPlaces == 'undefined' ? -1 : config.decimalPlaces;
    // callback function
    callback = typeof callback == 'function' ? callback : function () {};
    // set data and methods
    return this.data('numeric.decimal', decimal)
      .data('numeric.negative', negative)
      .data('numeric.callback', callback)
      .data('numeric.decimalPlaces', decimalPlaces)
      .keypress($.fn.numeric.keypress)
      .keyup($.fn.numeric.keyup)
      .blur($.fn.numeric.blur);
  };

  $.fn.numeric.keypress = function (e) {
    // get decimal character and determine if negatives are allowed
    var decimal = $.data(this, 'numeric.decimal');
    var negative = $.data(this, 'numeric.negative');
    var decimalPlaces = $.data(this, 'numeric.decimalPlaces');
    // get the key that was pressed
    var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
    // allow enter/return key (only when in an input box)
    if (key == 13 && this.nodeName.toLowerCase() == 'input') {
      return true;
    } else if (key == 13) {
      return false;
    }
    var allow = false;
    // allow Ctrl+A
    if (
      (e.ctrlKey && key == 97) /* firefox */ ||
      (e.ctrlKey && key == 65) /* opera */
    ) {
      return true;
    }
    // allow Ctrl+X (cut)
    if (
      (e.ctrlKey && key == 120) /* firefox */ ||
      (e.ctrlKey && key == 88) /* opera */
    ) {
      return true;
    }
    // allow Ctrl+C (copy)
    if (
      (e.ctrlKey && key == 99) /* firefox */ ||
      (e.ctrlKey && key == 67) /* opera */
    ) {
      return true;
    }
    // allow Ctrl+Z (undo)
    if (
      (e.ctrlKey && key == 122) /* firefox */ ||
      (e.ctrlKey && key == 90) /* opera */
    ) {
      return true;
    }
    // allow or deny Ctrl+V (paste), Shift+Ins
    if (
      (e.ctrlKey && key == 118) /* firefox */ ||
      (e.ctrlKey && key == 86) /* opera */ ||
      (e.shiftKey && key == 45)
    ) {
      return true;
    }
    // if a number was not pressed
    if (key < 48 || key > 57) {
      var value = $(this).val();
      /* '-' only allowed at start and if negative numbers allowed */
      if (
        $.inArray('-', value.split('')) !== 0 &&
        negative &&
        key == 45 &&
        (value.length === 0 || parseInt($.fn.getSelectionStart(this), 10) === 0)
      ) {
        return true;
      }
      /* only one decimal separator allowed */
      if (
        decimal &&
        key == decimal.charCodeAt(0) &&
        $.inArray(decimal, value.split('')) != -1
      ) {
        allow = false;
      }
      // check for other keys that have special purposes
      if (
        key != 8 /* backspace */ &&
        key != 9 /* tab */ &&
        key != 13 /* enter */ &&
        key != 35 /* end */ &&
        key != 36 /* home */ &&
        key != 37 /* left */ &&
        key != 39 /* right */ &&
        key != 46 /* del */
      ) {
        allow = false;
      } else {
        // for detecting special keys (listed above)
        // IE does not support 'charCode' and ignores them in keypress anyway
        if (typeof e.charCode != 'undefined') {
          // special keys have 'keyCode' and 'which' the same (e.g. backspace)
          if (e.keyCode == e.which && e.which !== 0) {
            allow = true;
            // . and delete share the same code, don't allow . (will be set to true later if it is the decimal point)
            if (e.which == 46) {
              allow = false;
            }
          }
          // or keyCode != 0 and 'charCode'/'which' = 0
          else if (e.keyCode !== 0 && e.charCode === 0 && e.which === 0) {
            allow = true;
          }
        }
      }
      // if key pressed is the decimal and it is not already in the field
      if (decimal && key == decimal.charCodeAt(0)) {
        if ($.inArray(decimal, value.split('')) == -1) {
          allow = true;
        } else {
          allow = false;
        }
      }
    } else {
      allow = true;
      // remove extra decimal places
      if (decimal && decimalPlaces > 0) {
        var dot = $.inArray(decimal, $(this).val().split(''));
        if (dot >= 0 && $(this).val().length > dot + decimalPlaces) {
          allow = false;
        }
      }
    }
    return allow;
  };

  $.fn.numeric.keyup = function (e) {
    var val = $(this).val();
    if (val && val.length > 0) {
      // get carat (cursor) position
      var carat = $.fn.getSelectionStart(this);
      var selectionEnd = $.fn.getSelectionEnd(this);
      // get decimal character and determine if negatives are allowed
      var decimal = $.data(this, 'numeric.decimal');
      var negative = $.data(this, 'numeric.negative');
      var decimalPlaces = $.data(this, 'numeric.decimalPlaces');

      // prepend a 0 if necessary
      if (decimal !== '' && decimal !== null) {
        // find decimal point
        var dot = $.inArray(decimal, val.split(''));
        // if dot at start, add 0 before
        if (dot === 0) {
          this.value = '0' + val;
          carat++;
          selectionEnd++;
        }
        // if dot at position 1, check if there is a - symbol before it
        if (dot == 1 && val.charAt(0) == '-') {
          this.value = '-0' + val.substring(1);
          carat++;
          selectionEnd++;
        }
        val = this.value;
      }

      // if pasted in, only allow the following characters
      var validChars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '-', decimal];
      // get length of the value (to loop through)
      var length = val.length;
      // loop backwards (to prevent going out of bounds)
      for (var i = length - 1; i >= 0; i--) {
        var ch = val.charAt(i);
        // remove '-' if it is in the wrong place
        if (i !== 0 && ch == '-') {
          val = val.substring(0, i) + val.substring(i + 1);
        }
        // remove character if it is at the start, a '-' and negatives aren't allowed
        else if (i === 0 && !negative && ch == '-') {
          val = val.substring(1);
        }
        var validChar = false;
        // loop through validChars
        for (var j = 0; j < validChars.length; j++) {
          // if it is valid, break out the loop
          if (ch == validChars[j]) {
            validChar = true;
            break;
          }
        }
        // if not a valid character, or a space, remove
        if (!validChar || ch == ' ') {
          val = val.substring(0, i) + val.substring(i + 1);
        }
      }
      // remove extra decimal characters
      var firstDecimal = $.inArray(decimal, val.split(''));
      if (firstDecimal > 0) {
        for (var k = length - 1; k > firstDecimal; k--) {
          var chch = val.charAt(k);
          // remove decimal character
          if (chch == decimal) {
            val = val.substring(0, k) + val.substring(k + 1);
          }
        }
      }

      // remove extra decimal places
      if (decimal && decimalPlaces > 0) {
        var dot = $.inArray(decimal, val.split(''));
        if (dot >= 0) {
          val = val.substring(0, dot + decimalPlaces + 1);
          selectionEnd = Math.min(val.length, selectionEnd);
        }
      }
      // set the value and prevent the cursor moving to the end
      this.value = val;
      $.fn.setSelection(this, [carat, selectionEnd]);
    }
  };

  $.fn.numeric.blur = function () {
    var decimal = $.data(this, 'numeric.decimal');
    var callback = $.data(this, 'numeric.callback');
    var negative = $.data(this, 'numeric.negative');
    var val = this.value;
    if (val !== '') {
      var re = new RegExp(
        negative ? '-?' : '' + '^\\d+$|^\\d*' + decimal + '\\d+$'
      );
      if (!re.exec(val)) {
        callback.apply(this);
      }
    }
  };

  $.fn.removeNumeric = function () {
    return this.data('numeric.decimal', null)
      .data('numeric.negative', null)
      .data('numeric.callback', null)
      .data('numeric.decimalPlaces', null)
      .unbind('keypress', $.fn.numeric.keypress)
      .unbind('keyup', $.fn.numeric.keyup)
      .unbind('blur', $.fn.numeric.blur);
  };

  // Based on code from http://javascript.nwbox.com/cursor_position/ (Diego Perini <dperini@nwbox.com>)
  $.fn.getSelectionStart = function (o) {
    if (o.type === 'number') {
      return undefined;
    } else if (o.createTextRange && document.selection) {
      var r = document.selection.createRange().duplicate();
      r.moveEnd('character', o.value.length);
      if (r.text == '') return o.value.length;

      return Math.max(0, o.value.lastIndexOf(r.text));
    } else {
      try {
        return o.selectionStart;
      } catch (e) {
        return 0;
      }
    }
  };

  // Based on code from http://javascript.nwbox.com/cursor_position/ (Diego Perini <dperini@nwbox.com>)
  $.fn.getSelectionEnd = function (o) {
    if (o.type === 'number') {
      return undefined;
    } else if (o.createTextRange && document.selection) {
      var r = document.selection.createRange().duplicate();
      r.moveStart('character', -o.value.length);
      return r.text.length;
    } else return o.selectionEnd;
  };

  // set the selection, o is the object (input), p is the position ([start, end] or just start)
  $.fn.setSelection = function (o, p) {
    // if p is number, start and end are the same
    if (typeof p == 'number') {
      p = [p, p];
    }
    // only set if p is an array of length 2
    if (p && p.constructor == Array && p.length == 2) {
      if (o.type === 'number') {
        o.focus();
      } else if (o.createTextRange) {
        var r = o.createTextRange();
        r.collapse(true);
        r.moveStart('character', p[0]);
        r.moveEnd('character', p[1] - p[0]);
        r.select();
      } else {
        o.focus();
        try {
          if (o.setSelectionRange) {
            o.setSelectionRange(p[0], p[1]);
          }
        } catch (e) {}
      }
    }
  };
})(jQuery);
/*! http://mths.be/placeholder v2.0.7 by @mathias */
(function (window, document, $) {
  var isInputSupported = 'placeholder' in document.createElement('input'),
    isTextareaSupported = 'placeholder' in document.createElement('textarea'),
    prototype = $.fn,
    valHooks = $.valHooks,
    hooks,
    placeholder;

  if (isInputSupported && isTextareaSupported) {
    placeholder = prototype.placeholder = function () {
      return this;
    };

    placeholder.input = placeholder.textarea = true;
  } else {
    placeholder = prototype.placeholder = function () {
      var $this = this;
      $this
        .filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]')
        .not('.placeholder')
        .bind({
          'focus.placeholder': clearPlaceholder,
          'blur.placeholder': setPlaceholder,
        })
        .data('placeholder-enabled', true)
        .trigger('blur.placeholder');
      return $this;
    };

    placeholder.input = isInputSupported;
    placeholder.textarea = isTextareaSupported;

    hooks = {
      get: function (element) {
        var $element = $(element);
        return $element.data('placeholder-enabled') &&
          $element.hasClass('placeholder')
          ? ''
          : element.value;
      },
      set: function (element, value) {
        var $element = $(element);
        if (!$element.data('placeholder-enabled')) {
          return (element.value = value);
        }
        if (value == '') {
          element.value = value;
          // Issue #56: Setting the placeholder causes problems if the element continues to have focus.
          if (element != document.activeElement) {
            // We can't use `triggerHandler` here because of dummy text/password inputs :(
            setPlaceholder.call(element);
          }
        } else if ($element.hasClass('placeholder')) {
          clearPlaceholder.call(element, true, value) ||
            (element.value = value);
        } else {
          element.value = value;
        }
        // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
        return $element;
      },
    };

    isInputSupported || (valHooks.input = hooks);
    isTextareaSupported || (valHooks.textarea = hooks);

    $(function () {
      // Look for forms
      $(document).delegate('form', 'submit.placeholder', function () {
        // Clear the placeholder values so they don't get submitted
        var $inputs = $('.placeholder', this).each(clearPlaceholder);
        setTimeout(function () {
          $inputs.each(setPlaceholder);
        }, 10);
      });
    });

    // Clear placeholder values upon page reload
    $(window).bind('beforeunload.placeholder', function () {
      $('.placeholder').each(function () {
        this.value = '';
      });
    });
  }

  function args(elem) {
    // Return an object of element attributes
    var newAttrs = {},
      rinlinejQuery = /^jQuery\d+$/;
    $.each(elem.attributes, function (i, attr) {
      if (attr.specified && !rinlinejQuery.test(attr.name)) {
        newAttrs[attr.name] = attr.value;
      }
    });
    return newAttrs;
  }

  function clearPlaceholder(event, value) {
    var input = this,
      $input = $(input);
    if (
      input.value == $input.attr('placeholder') &&
      $input.hasClass('placeholder')
    ) {
      if ($input.data('placeholder-password')) {
        $input = $input
          .hide()
          .next()
          .show()
          .attr('id', $input.removeAttr('id').data('placeholder-id'));
        // If `clearPlaceholder` was called from `$.valHooks.input.set`
        if (event === true) {
          return ($input[0].value = value);
        }
        $input.focus();
      } else {
        input.value = '';
        $input.removeClass('placeholder');
        input == document.activeElement && input.select();
      }
    }
  }

  function setPlaceholder() {
    var $replacement,
      input = this,
      $input = $(input),
      $origInput = $input,
      id = this.id;
    if (input.value == '') {
      if (input.type == 'password') {
        if (!$input.data('placeholder-textinput')) {
          try {
            $replacement = $input.clone().attr({ type: 'text' });
          } catch (e) {
            $replacement = $('<input>').attr(
              $.extend(args(this), { type: 'text' })
            );
          }
          $replacement
            .removeAttr('name')
            .data({
              'placeholder-password': true,
              'placeholder-id': id,
            })
            .bind('focus.placeholder', clearPlaceholder);
          $input
            .data({
              'placeholder-textinput': $replacement,
              'placeholder-id': id,
            })
            .before($replacement);
        }
        $input = $input.removeAttr('id').hide().prev().attr('id', id).show();
        // Note: `$input[0] != input` now!
      }
      $input.addClass('placeholder');
      $input[0].value = $input.attr('placeholder');
    } else {
      $input.removeClass('placeholder');
    }
  }
})(this, document, jQuery);
/*! TinySort 1.5.3
 * Copyright (c) 2008-2013 Ron Valstar http://tinysort.sjeiti.com/
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */ /*
 * Description:
 *   A jQuery plugin to sort child nodes by (sub) contents or attributes.
 *
 * Contributors:
 *	brian.gibson@gmail.com
 *	michael.thornberry@gmail.com
 *
 * Usage:
 *   $("ul#people>li").tsort();
 *   $("ul#people>li").tsort("span.surname");
 *   $("ul#people>li").tsort("span.surname",{order:"desc"});
 *   $("ul#people>li").tsort({place:"end"});
 *   $("ul#people>li").tsort("span.surname",{order:"desc"},span.name");
 *
 * Change default like so:
 *   $.tinysort.defaults.order = "desc";
 *
 */
(function ($, undefined) {
  // private vars
  var fls = !1, // minify placeholder
    nll = null, // minify placeholder
    prsflt = parseFloat, // minify	 placeholder
    mathmn = Math.min, // minify placeholder
    rxLastNr = /(-?\d+\.?\d*)$/g, // regex for testing strings ending on numbers
    rxLastNrNoDash = /(\d+\.?\d*)$/g, // regex for testing strings ending on numbers ignoring dashes
    aPluginPrepare = [],
    aPluginSort = [],
    isString = function (o) {
      return typeof o == 'string';
    },
    // Array.prototype.indexOf for IE (issue #26) (local variable to prevent unwanted prototype pollution)
    fnIndexOf =
      Array.prototype.indexOf ||
      function (elm) {
        var len = this.length,
          from = Number(arguments[1]) || 0;
        from = from < 0 ? Math.ceil(from) : Math.floor(from);
        if (from < 0) from += len;
        for (; from < len; from++) {
          if (from in this && this[from] === elm) return from;
        }
        return -1;
      };
  //
  // init plugin
  $.tinysort = {
    id: 'TinySort',
    version: '1.5.2',
    copyright: 'Copyright (c) 2008-2013 Ron Valstar',
    uri: 'http://tinysort.sjeiti.com/',
    licensed: {
      MIT: 'http://www.opensource.org/licenses/mit-license.php',
      GPL: 'http://www.gnu.org/licenses/gpl.html',
    },
    plugin: (function () {
      var fn = function (prepare, sort) {
        aPluginPrepare.push(prepare); // function(settings){doStuff();}
        aPluginSort.push(sort); // function(valuesAreNumeric,sA,sB,iReturn){doStuff();return iReturn;}
      };
      // expose stuff to plugins
      fn.indexOf = fnIndexOf;
      return fn;
    })(),
    defaults: {
      // default settings

      order: 'asc', // order: asc, desc or rand

      attr: nll, // order by attribute value
      data: nll, // use the data attribute for sorting
      useVal: fls, // use element value instead of text

      place: 'start', // place ordered elements at position: start, end, org (original position), first
      returns: fls, // return all elements or only the sorted ones (true/false)

      cases: fls, // a case sensitive sort orders [aB,aa,ab,bb]
      forceStrings: fls, // if false the string '2' will sort with the value 2, not the string '2'

      ignoreDashes: fls, // ignores dashes when looking for numerals

      sortFunction: nll, // override the default sort function
    },
  };
  $.fn.extend({
    tinysort: function () {
      var i,
        l,
        oThis = this,
        aNewOrder = [],
        // sortable- and non-sortable list per parent
        aElements = [],
        aElementsParent = [], // index reference for parent to aElements
        // multiple sort criteria (sort===0?iCriteria++:iCriteria=0)
        aCriteria = [],
        iCriteria = 0,
        iCriteriaMax,
        //
        aFind = [],
        aSettings = [],
        //
        fnPluginPrepare = function (_settings) {
          $.each(aPluginPrepare, function (i, fn) {
            fn.call(fn, _settings);
          });
        },
        //
        fnSort = function (a, b) {
          var iReturn = 0;
          if (iCriteria !== 0) iCriteria = 0;
          while (iReturn === 0 && iCriteria < iCriteriaMax) {
            var oPoint = aCriteria[iCriteria],
              oSett = oPoint.oSettings,
              rxLast = oSett.ignoreDashes ? rxLastNrNoDash : rxLastNr;
            //
            fnPluginPrepare(oSett);
            //
            if (oSett.sortFunction) {
              // custom sort
              iReturn = oSett.sortFunction(a, b);
            } else if (oSett.order == 'rand') {
              // random sort
              iReturn = Math.random() < 0.5 ? 1 : -1;
            } else {
              // regular sort
              var bNumeric = fls,
                // maybe toLower
                sA = !oSett.cases
                  ? toLowerCase(a.s[iCriteria])
                  : a.s[iCriteria],
                sB = !oSett.cases
                  ? toLowerCase(b.s[iCriteria])
                  : b.s[iCriteria];
              // maybe force Strings
              if (!oSettings.forceStrings) {
                // maybe mixed
                var aAnum = isString(sA) ? sA && sA.match(rxLast) : fls,
                  aBnum = isString(sB) ? sB && sB.match(rxLast) : fls;
                if (aAnum && aBnum) {
                  var sAprv = sA.substr(0, sA.length - aAnum[0].length),
                    sBprv = sB.substr(0, sB.length - aBnum[0].length);
                  if (sAprv == sBprv) {
                    bNumeric = !fls;
                    sA = prsflt(aAnum[0]);
                    sB = prsflt(aBnum[0]);
                  }
                }
              }
              iReturn = oPoint.iAsc * (sA < sB ? -1 : sA > sB ? 1 : 0);
            }

            $.each(aPluginSort, function (i, fn) {
              iReturn = fn.call(fn, bNumeric, sA, sB, iReturn);
            });

            if (iReturn === 0) iCriteria++;
          }

          return iReturn;
        };
      // fill aFind and aSettings but keep length pairing up
      for (i = 0, l = arguments.length; i < l; i++) {
        var o = arguments[i];
        if (isString(o)) {
          if (aFind.push(o) - 1 > aSettings.length)
            aSettings.length = aFind.length - 1;
        } else {
          if (aSettings.push(o) > aFind.length) aFind.length = aSettings.length;
        }
      }
      if (aFind.length > aSettings.length) aSettings.length = aFind.length; // todo: and other way around?

      // fill aFind and aSettings for arguments.length===0
      iCriteriaMax = aFind.length;
      if (iCriteriaMax === 0) {
        iCriteriaMax = aFind.length = 1;
        aSettings.push({});
      }

      for (i = 0, l = iCriteriaMax; i < l; i++) {
        var sFind = aFind[i],
          oSettings = $.extend({}, $.tinysort.defaults, aSettings[i]),
          // has find, attr or data
          bFind = !(!sFind || sFind == ''),
          // since jQuery's filter within each works on array index and not actual index we have to create the filter in advance
          bFilter = bFind && sFind[0] == ':';
        aCriteria.push({
          // todo: only used locally, find a way to minify properties
          sFind: sFind,
          oSettings: oSettings,
          // has find, attr or data
          bFind: bFind,
          bAttr: !(oSettings.attr === nll || oSettings.attr == ''),
          bData: oSettings.data !== nll,
          // filter
          bFilter: bFilter,
          $Filter: bFilter ? oThis.filter(sFind) : oThis,
          fnSort: oSettings.sortFunction,
          iAsc: oSettings.order == 'asc' ? 1 : -1,
        });
      }
      //
      // prepare oElements for sorting
      oThis.each(function (i, el) {
        var $Elm = $(el),
          mParent = $Elm.parent().get(0),
          mFirstElmOrSub, // we still need to distinguish between sortable and non-sortable elements (might have unexpected results for multiple criteria)
          aSort = [];
        for (j = 0; j < iCriteriaMax; j++) {
          var oPoint = aCriteria[j],
            // element or sub selection
            mElmOrSub = oPoint.bFind
              ? oPoint.bFilter
                ? oPoint.$Filter.filter(el)
                : $Elm.find(oPoint.sFind)
              : $Elm;
          // text or attribute value
          aSort.push(
            oPoint.bData
              ? mElmOrSub.data(oPoint.oSettings.data)
              : oPoint.bAttr
              ? mElmOrSub.attr(oPoint.oSettings.attr)
              : oPoint.oSettings.useVal
              ? mElmOrSub.val()
              : mElmOrSub.text()
          );
          if (mFirstElmOrSub === undefined) mFirstElmOrSub = mElmOrSub;
        }
        // to sort or not to sort
        var iElmIndex = fnIndexOf.call(aElementsParent, mParent);
        if (iElmIndex < 0) {
          iElmIndex = aElementsParent.push(mParent) - 1;
          aElements[iElmIndex] = { s: [], n: [] }; // s: sort, n: not sort
        }
        if (mFirstElmOrSub.length > 0)
          aElements[iElmIndex].s.push({ s: aSort, e: $Elm, n: i });
        // s:string/pointer, e:element, n:number
        else aElements[iElmIndex].n.push({ e: $Elm, n: i });
      });
      //
      // sort
      $.each(aElements, function (j, oParent) {
        oParent.s.sort(fnSort);
      });
      //
      // order elements and fill new order
      $.each(aElements, function (j, oParent) {
        //				var oParent = aElements[j]
        var iNumElm = oParent.s.length,
          aOrg = [], // list for original position
          iLow = iNumElm,
          aCnt = [0, 0]; // count how much we've sorted for retreival from either the sort list or the non-sort list (oParent.s/oParent.n)
        switch (oSettings.place) {
          case 'first':
            $.each(oParent.s, function (i, obj) {
              iLow = mathmn(iLow, obj.n);
            });
            break;
          case 'org':
            $.each(oParent.s, function (i, obj) {
              aOrg.push(obj.n);
            });
            break;
          case 'end':
            iLow = oParent.n.length;
            break;
          default:
            iLow = 0;
        }
        for (i = 0; i < iNumElm; i++) {
          var bSList = contains(aOrg, i)
              ? !fls
              : i >= iLow && i < iLow + oParent.s.length,
            mEl = (bSList ? oParent.s : oParent.n)[aCnt[bSList ? 0 : 1]].e;
          mEl.parent().append(mEl);
          if (bSList || !oSettings.returns) aNewOrder.push(mEl.get(0));
          aCnt[bSList ? 0 : 1]++;
        }
      });
      oThis.length = 0;
      Array.prototype.push.apply(oThis, aNewOrder);
      return oThis;
    },
  });
  // toLowerCase
  function toLowerCase(s) {
    return s && s.toLowerCase ? s.toLowerCase() : s;
  }
  // array contains
  function contains(a, n) {
    for (var i = 0, l = a.length; i < l; i++) if (a[i] == n) return !fls;
    return fls;
  }
  // set functions
  $.fn.TinySort = $.fn.Tinysort = $.fn.tsort = $.fn.tinysort;
})(jQuery);
/*
 *	TypeWatch 2.1
 *
 *	Examples/Docs: github.com/dennyferra/TypeWatch
 *
 *  Copyright(c) 2013
 *	Denny Ferrassoli - dennyferra.com
 *   Charles Christolini
 *
 *  Dual licensed under the MIT and GPL licenses:
 *  http://www.opensource.org/licenses/mit-license.php
 *  http://www.gnu.org/licenses/gpl.html
 */

(function (jQuery) {
  jQuery.fn.typeWatch = function (o) {
    // The default input types that are supported
    var _supportedInputTypes = [
      'TEXT',
      'TEXTAREA',
      'PASSWORD',
      'TEL',
      'SEARCH',
      'URL',
      'EMAIL',
      'DATETIME',
      'DATE',
      'MONTH',
      'WEEK',
      'TIME',
      'DATETIME-LOCAL',
      'NUMBER',
      'RANGE',
    ];

    // Options
    var options = jQuery.extend(
      {
        wait: 750,
        callback: function () {},
        highlight: true,
        captureLength: 2,
        inputTypes: _supportedInputTypes,
      },
      o
    );

    function checkElement(timer, override) {
      var value = jQuery(timer.el).val();

      // Fire if text >= options.captureLength AND text != saved text OR if override AND text >= options.captureLength
      if (
        (value.length >= options.captureLength &&
          value.toUpperCase() != timer.text) ||
        (override && value.length >= options.captureLength)
      ) {
        timer.text = value.toUpperCase();
        timer.cb.call(timer.el, value);
      }
    }

    function watchElement(elem) {
      var elementType = elem.type.toUpperCase();
      if (jQuery.inArray(elementType, options.inputTypes) >= 0) {
        // Allocate timer element
        var timer = {
          timer: null,
          text: jQuery(elem).val().toUpperCase(),
          cb: options.callback,
          el: elem,
          wait: options.wait,
        };

        // Set focus action (highlight)
        if (options.highlight) {
          jQuery(elem).focus(function () {
            this.select();
          });
        }

        // Key watcher / clear and reset the timer
        var startWatch = function (evt) {
          var timerWait = timer.wait;
          var overrideBool = false;
          var evtElementType = this.type.toUpperCase();

          // If enter key is pressed and not a TEXTAREA and matched inputTypes
          if (
            evt.keyCode == 13 &&
            evtElementType != 'TEXTAREA' &&
            jQuery.inArray(evtElementType, options.inputTypes) >= 0
          ) {
            timerWait = 1;
            overrideBool = true;
          }

          var timerCallbackFx = function () {
            checkElement(timer, overrideBool);
          };

          // Clear timer
          clearTimeout(timer.timer);
          timer.timer = setTimeout(timerCallbackFx, timerWait);
        };

        jQuery(elem).keydown(startWatch);
      }
    }

    // Watch Each Element
    return this.each(function () {
      watchElement(this);
    });
  };
})(jQuery);
/* jstz.min.js Version: 2.1.0 (https://github.com/iansinnott/jstz) Build date: 2018-11-04 */

/* THIS HAS BEEN MODIFIED FROM ITS ORIGINAL VERSION TO FIX A YEAR DEPENDENT BUG
 * BASELINE_YEAR was originally `2014` but has now been set to `(new Date()).getFullYear()` */
!(function (e) {
  var a = (function () {
    'use strict';
    var e = 's',
      s = {
        DAY: 864e5,
        HOUR: 36e5,
        MINUTE: 6e4,
        SECOND: 1e3,
        BASELINE_YEAR: new Date().getFullYear(),
        MAX_SCORE: 864e6,
        AMBIGUITIES: {
          'America/Denver': ['America/Mazatlan'],
          'Europe/London': ['Africa/Casablanca'],
          'America/Chicago': ['America/Mexico_City'],
          'America/Asuncion': ['America/Campo_Grande', 'America/Santiago'],
          'America/Montevideo': ['America/Sao_Paulo', 'America/Santiago'],
          'Asia/Beirut': [
            'Asia/Amman',
            'Asia/Jerusalem',
            'Europe/Helsinki',
            'Asia/Damascus',
            'Africa/Cairo',
            'Asia/Gaza',
            'Europe/Minsk',
          ],
          'Pacific/Auckland': ['Pacific/Fiji'],
          'America/Los_Angeles': ['America/Santa_Isabel'],
          'America/New_York': ['America/Havana'],
          'America/Halifax': ['America/Goose_Bay'],
          'America/Godthab': ['America/Miquelon'],
          'Asia/Dubai': ['Asia/Yerevan'],
          'Asia/Jakarta': ['Asia/Krasnoyarsk'],
          'Asia/Shanghai': ['Asia/Irkutsk', 'Australia/Perth'],
          'Australia/Sydney': ['Australia/Lord_Howe'],
          'Asia/Tokyo': ['Asia/Yakutsk'],
          'Asia/Dhaka': ['Asia/Omsk'],
          'Asia/Baku': ['Asia/Yerevan'],
          'Australia/Brisbane': ['Asia/Vladivostok'],
          'Pacific/Noumea': ['Asia/Vladivostok'],
          'Pacific/Majuro': ['Asia/Kamchatka', 'Pacific/Fiji'],
          'Pacific/Tongatapu': ['Pacific/Apia'],
          'Asia/Baghdad': ['Europe/Minsk', 'Europe/Moscow'],
          'Asia/Karachi': ['Asia/Yekaterinburg'],
          'Africa/Johannesburg': ['Asia/Gaza', 'Africa/Cairo'],
        },
      },
      i = function (e) {
        var a = -e.getTimezoneOffset();
        return null !== a ? a : 0;
      },
      r = function () {
        var a = i(new Date(s.BASELINE_YEAR, 0, 2)),
          r = i(new Date(s.BASELINE_YEAR, 5, 2)),
          n = a - r;
        return n < 0 ? a + ',1' : n > 0 ? r + ',1,' + e : a + ',0';
      },
      n = function () {
        var e, a;
        if (
          'undefined' != typeof Intl &&
          'undefined' != typeof Intl.DateTimeFormat &&
          ((e = Intl.DateTimeFormat()),
          'undefined' != typeof e && 'undefined' != typeof e.resolvedOptions)
        )
          return (
            (a = e.resolvedOptions().timeZone),
            a && (a.indexOf('/') > -1 || 'UTC' === a) && 0 != a.indexOf('Etc')
              ? a
              : void 0
          );
      },
      o = function (e) {
        for (
          var a = new Date(e, 0, 1, 0, 0, 1, 0).getTime(),
            s = new Date(e, 12, 31, 23, 59, 59).getTime(),
            i = a,
            r = new Date(i).getTimezoneOffset(),
            n = null,
            o = null;
          i < s - 864e5;

        ) {
          var u = new Date(i),
            A = u.getTimezoneOffset();
          A !== r && (A < r && (n = u), A > r && (o = u), (r = A)),
            (i += 864e5);
        }
        return !(!n || !o) && { s: t(n).getTime(), e: t(o).getTime() };
      },
      t = function l(e, a, i) {
        'undefined' == typeof a && ((a = s.DAY), (i = s.HOUR));
        for (
          var r = new Date(e.getTime() - a).getTime(),
            n = e.getTime() + a,
            o = new Date(r).getTimezoneOffset(),
            t = r,
            u = null;
          t < n - i;

        ) {
          var A = new Date(t),
            c = A.getTimezoneOffset();
          if (c !== o) {
            u = A;
            break;
          }
          t += i;
        }
        return a === s.DAY
          ? l(u, s.HOUR, s.MINUTE)
          : a === s.HOUR
          ? l(u, s.MINUTE, s.SECOND)
          : u;
      },
      u = function (e, a, s, i) {
        if ('N/A' !== s) return s;
        if ('Asia/Beirut' === a) {
          if (
            'Africa/Cairo' === i.name &&
            13983768e5 === e[6].s &&
            14116788e5 === e[6].e
          )
            return 0;
          if (
            'Asia/Jerusalem' === i.name &&
            13959648e5 === e[6].s &&
            14118588e5 === e[6].e
          )
            return 0;
        } else if ('America/Santiago' === a) {
          if (
            'America/Asuncion' === i.name &&
            14124816e5 === e[6].s &&
            1397358e6 === e[6].e
          )
            return 0;
          if (
            'America/Campo_Grande' === i.name &&
            14136912e5 === e[6].s &&
            13925196e5 === e[6].e
          )
            return 0;
        } else if ('America/Montevideo' === a) {
          if (
            'America/Sao_Paulo' === i.name &&
            14136876e5 === e[6].s &&
            1392516e6 === e[6].e
          )
            return 0;
        } else if (
          'Pacific/Auckland' === a &&
          'Pacific/Fiji' === i.name &&
          14142456e5 === e[6].s &&
          13961016e5 === e[6].e
        )
          return 0;
        return s;
      },
      A = function (e, i) {
        for (
          var r = function (a) {
              for (var r = 0, n = 0; n < e.length; n++)
                if (a.rules[n] && e[n]) {
                  if (!(e[n].s >= a.rules[n].s && e[n].e <= a.rules[n].e)) {
                    r = 'N/A';
                    break;
                  }
                  if (
                    ((r = 0),
                    (r += Math.abs(e[n].s - a.rules[n].s)),
                    (r += Math.abs(a.rules[n].e - e[n].e)),
                    r > s.MAX_SCORE)
                  ) {
                    r = 'N/A';
                    break;
                  }
                }
              return (r = u(e, i, r, a));
            },
            n = {},
            o = a.olson.dst_rules.zones,
            t = o.length,
            A = s.AMBIGUITIES[i],
            c = 0;
          c < t;
          c++
        ) {
          var m = o[c],
            l = r(o[c]);
          'N/A' !== l && (n[m.name] = l);
        }
        for (var f in n)
          if (n.hasOwnProperty(f))
            for (var d = 0; d < A.length; d++) if (A[d] === f) return f;
        return i;
      },
      c = function (e) {
        var s = function () {
            for (var e = [], s = 0; s < a.olson.dst_rules.years.length; s++) {
              var i = o(a.olson.dst_rules.years[s]);
              e.push(i);
            }
            return e;
          },
          i = function (e) {
            for (var a = 0; a < e.length; a++) if (e[a] !== !1) return !0;
            return !1;
          },
          r = s(),
          n = i(r);
        return n ? A(r, e) : e;
      },
      m = function () {
        var e = n();
        return (
          e ||
            ((e = a.olson.timezones[r()]),
            'undefined' != typeof s.AMBIGUITIES[e] && (e = c(e))),
          {
            name: function () {
              return e;
            },
            stdTimezoneOffset: function () {
              return -r().split(',')[0];
            },
            timezoneOffset: function () {
              return -i(new Date());
            },
          }
        );
      };
    return { determine: m };
  })();
  (a.olson = a.olson || {}),
    (a.olson.timezones = {
      '-720,0': 'Etc/GMT+12',
      '-660,0': 'Pacific/Pago_Pago',
      '-660,1,s': 'Pacific/Apia',
      '-600,1': 'America/Adak',
      '-600,0': 'Pacific/Honolulu',
      '-570,0': 'Pacific/Marquesas',
      '-540,0': 'Pacific/Gambier',
      '-540,1': 'America/Anchorage',
      '-480,1': 'America/Los_Angeles',
      '-480,0': 'Pacific/Pitcairn',
      '-420,0': 'America/Phoenix',
      '-420,1': 'America/Denver',
      '-360,0': 'America/Guatemala',
      '-360,1': 'America/Chicago',
      '-360,1,s': 'Pacific/Easter',
      '-300,0': 'America/Bogota',
      '-300,1': 'America/New_York',
      '-270,0': 'America/Caracas',
      '-240,1': 'America/Halifax',
      '-240,0': 'America/Santo_Domingo',
      '-240,1,s': 'America/Asuncion',
      '-210,1': 'America/St_Johns',
      '-180,1': 'America/Godthab',
      '-180,0': 'America/Argentina/Buenos_Aires',
      '-180,1,s': 'America/Montevideo',
      '-120,0': 'America/Noronha',
      '-120,1': 'America/Noronha',
      '-60,1': 'Atlantic/Azores',
      '-60,0': 'Atlantic/Cape_Verde',
      '0,0': 'UTC',
      '0,1': 'Europe/London',
      '60,1': 'Europe/Berlin',
      '60,0': 'Africa/Lagos',
      '60,1,s': 'Africa/Windhoek',
      '120,1': 'Asia/Beirut',
      '120,0': 'Africa/Johannesburg',
      '180,0': 'Asia/Baghdad',
      '180,1': 'Europe/Moscow',
      '210,1': 'Asia/Tehran',
      '240,0': 'Asia/Dubai',
      '240,1': 'Asia/Baku',
      '270,0': 'Asia/Kabul',
      '300,1': 'Asia/Yekaterinburg',
      '300,0': 'Asia/Karachi',
      '330,0': 'Asia/Kolkata',
      '345,0': 'Asia/Kathmandu',
      '360,0': 'Asia/Dhaka',
      '360,1': 'Asia/Omsk',
      '390,0': 'Asia/Rangoon',
      '420,1': 'Asia/Krasnoyarsk',
      '420,0': 'Asia/Jakarta',
      '480,0': 'Asia/Shanghai',
      '480,1': 'Asia/Irkutsk',
      '525,0': 'Australia/Eucla',
      '525,1,s': 'Australia/Eucla',
      '540,1': 'Asia/Yakutsk',
      '540,0': 'Asia/Tokyo',
      '570,0': 'Australia/Darwin',
      '570,1,s': 'Australia/Adelaide',
      '600,0': 'Australia/Brisbane',
      '600,1': 'Asia/Vladivostok',
      '600,1,s': 'Australia/Sydney',
      '630,1,s': 'Australia/Lord_Howe',
      '660,1': 'Asia/Kamchatka',
      '660,0': 'Pacific/Noumea',
      '690,0': 'Pacific/Norfolk',
      '720,1,s': 'Pacific/Auckland',
      '720,0': 'Pacific/Majuro',
      '765,1,s': 'Pacific/Chatham',
      '780,0': 'Pacific/Tongatapu',
      '780,1,s': 'Pacific/Apia',
      '840,0': 'Pacific/Kiritimati',
    }),
    (a.olson.dst_rules = {
      years: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
      zones: [
        {
          name: 'Africa/Cairo',
          rules: [
            { e: 12199572e5, s: 12090744e5 },
            { e: 1250802e6, s: 1240524e6 },
            { e: 12858804e5, s: 12840696e5 },
            !1,
            !1,
            !1,
            { e: 14116788e5, s: 1406844e6 },
          ],
        },
        {
          name: 'Africa/Casablanca',
          rules: [
            { e: 12202236e5, s: 12122784e5 },
            { e: 12508092e5, s: 12438144e5 },
            { e: 1281222e6, s: 12727584e5 },
            { e: 13120668e5, s: 13017888e5 },
            { e: 13489704e5, s: 1345428e6 },
            { e: 13828392e5, s: 13761e8 },
            { e: 14142888e5, s: 14069448e5 },
          ],
        },
        {
          name: 'America/Asuncion',
          rules: [
            { e: 12050316e5, s: 12243888e5 },
            { e: 12364812e5, s: 12558384e5 },
            { e: 12709548e5, s: 12860784e5 },
            { e: 13024044e5, s: 1317528e6 },
            { e: 1333854e6, s: 13495824e5 },
            { e: 1364094e6, s: 1381032e6 },
            { e: 13955436e5, s: 14124816e5 },
          ],
        },
        {
          name: 'America/Campo_Grande',
          rules: [
            { e: 12032172e5, s: 12243888e5 },
            { e: 12346668e5, s: 12558384e5 },
            { e: 12667212e5, s: 1287288e6 },
            { e: 12981708e5, s: 13187376e5 },
            { e: 13302252e5, s: 1350792e6 },
            { e: 136107e7, s: 13822416e5 },
            { e: 13925196e5, s: 14136912e5 },
          ],
        },
        {
          name: 'America/Goose_Bay',
          rules: [
            { e: 122559486e4, s: 120503526e4 },
            { e: 125704446e4, s: 123648486e4 },
            { e: 128909886e4, s: 126853926e4 },
            { e: 13205556e5, s: 129998886e4 },
            { e: 13520052e5, s: 13314456e5 },
            { e: 13834548e5, s: 13628952e5 },
            { e: 14149044e5, s: 13943448e5 },
          ],
        },
        {
          name: 'America/Havana',
          rules: [
            { e: 12249972e5, s: 12056436e5 },
            { e: 12564468e5, s: 12364884e5 },
            { e: 12885012e5, s: 12685428e5 },
            { e: 13211604e5, s: 13005972e5 },
            { e: 13520052e5, s: 13332564e5 },
            { e: 13834548e5, s: 13628916e5 },
            { e: 14149044e5, s: 13943412e5 },
          ],
        },
        {
          name: 'America/Mazatlan',
          rules: [
            { e: 1225008e6, s: 12074724e5 },
            { e: 12564576e5, s: 1238922e6 },
            { e: 1288512e6, s: 12703716e5 },
            { e: 13199616e5, s: 13018212e5 },
            { e: 13514112e5, s: 13332708e5 },
            { e: 13828608e5, s: 13653252e5 },
            { e: 14143104e5, s: 13967748e5 },
          ],
        },
        {
          name: 'America/Mexico_City',
          rules: [
            { e: 12250044e5, s: 12074688e5 },
            { e: 1256454e6, s: 12389184e5 },
            { e: 12885084e5, s: 1270368e6 },
            { e: 1319958e6, s: 13018176e5 },
            { e: 13514076e5, s: 13332672e5 },
            { e: 13828572e5, s: 13653216e5 },
            { e: 14143068e5, s: 13967712e5 },
          ],
        },
        {
          name: 'America/Miquelon',
          rules: [
            { e: 12255984e5, s: 12050388e5 },
            { e: 1257048e6, s: 12364884e5 },
            { e: 12891024e5, s: 12685428e5 },
            { e: 1320552e6, s: 12999924e5 },
            { e: 13520016e5, s: 1331442e6 },
            { e: 13834512e5, s: 13628916e5 },
            { e: 14149008e5, s: 13943412e5 },
          ],
        },
        {
          name: 'America/Santa_Isabel',
          rules: [
            { e: 12250116e5, s: 1207476e6 },
            { e: 12564612e5, s: 12389256e5 },
            { e: 12885156e5, s: 12703752e5 },
            { e: 13199652e5, s: 13018248e5 },
            { e: 13514148e5, s: 13332744e5 },
            { e: 13828644e5, s: 13653288e5 },
            { e: 1414314e6, s: 13967784e5 },
          ],
        },
        {
          name: 'America/Santiago',
          rules: [
            { e: 1206846e6, s: 1223784e6 },
            { e: 1237086e6, s: 12552336e5 },
            { e: 127035e7, s: 12866832e5 },
            { e: 13048236e5, s: 13138992e5 },
            { e: 13356684e5, s: 13465584e5 },
            { e: 1367118e6, s: 13786128e5 },
            { e: 13985676e5, s: 14100624e5 },
          ],
        },
        {
          name: 'America/Sao_Paulo',
          rules: [
            { e: 12032136e5, s: 12243852e5 },
            { e: 12346632e5, s: 12558348e5 },
            { e: 12667176e5, s: 12872844e5 },
            { e: 12981672e5, s: 1318734e6 },
            { e: 13302216e5, s: 13507884e5 },
            { e: 13610664e5, s: 1382238e6 },
            { e: 1392516e6, s: 14136876e5 },
          ],
        },
        {
          name: 'Asia/Amman',
          rules: [
            { e: 1225404e6, s: 12066552e5 },
            { e: 12568536e5, s: 12381048e5 },
            { e: 12883032e5, s: 12695544e5 },
            { e: 13197528e5, s: 13016088e5 },
            !1,
            !1,
            { e: 14147064e5, s: 13959576e5 },
          ],
        },
        {
          name: 'Asia/Damascus',
          rules: [
            { e: 12254868e5, s: 120726e7 },
            { e: 125685e7, s: 12381048e5 },
            { e: 12882996e5, s: 12701592e5 },
            { e: 13197492e5, s: 13016088e5 },
            { e: 13511988e5, s: 13330584e5 },
            { e: 13826484e5, s: 1364508e6 },
            { e: 14147028e5, s: 13959576e5 },
          ],
        },
        { name: 'Asia/Dubai', rules: [!1, !1, !1, !1, !1, !1, !1] },
        {
          name: 'Asia/Gaza',
          rules: [
            { e: 12199572e5, s: 12066552e5 },
            { e: 12520152e5, s: 12381048e5 },
            { e: 1281474e6, s: 126964086e4 },
            { e: 1312146e6, s: 130160886e4 },
            { e: 13481784e5, s: 13330584e5 },
            { e: 13802292e5, s: 1364508e6 },
            { e: 1414098e6, s: 13959576e5 },
          ],
        },
        {
          name: 'Asia/Irkutsk',
          rules: [
            { e: 12249576e5, s: 12068136e5 },
            { e: 12564072e5, s: 12382632e5 },
            { e: 12884616e5, s: 12697128e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Jerusalem',
          rules: [
            { e: 12231612e5, s: 12066624e5 },
            { e: 1254006e6, s: 1238112e6 },
            { e: 1284246e6, s: 12695616e5 },
            { e: 131751e7, s: 1301616e6 },
            { e: 13483548e5, s: 13330656e5 },
            { e: 13828284e5, s: 13645152e5 },
            { e: 1414278e6, s: 13959648e5 },
          ],
        },
        {
          name: 'Asia/Kamchatka',
          rules: [
            { e: 12249432e5, s: 12067992e5 },
            { e: 12563928e5, s: 12382488e5 },
            { e: 12884508e5, s: 12696984e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Krasnoyarsk',
          rules: [
            { e: 12249612e5, s: 12068172e5 },
            { e: 12564108e5, s: 12382668e5 },
            { e: 12884652e5, s: 12697164e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Omsk',
          rules: [
            { e: 12249648e5, s: 12068208e5 },
            { e: 12564144e5, s: 12382704e5 },
            { e: 12884688e5, s: 126972e7 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Vladivostok',
          rules: [
            { e: 12249504e5, s: 12068064e5 },
            { e: 12564e8, s: 1238256e6 },
            { e: 12884544e5, s: 12697056e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Yakutsk',
          rules: [
            { e: 1224954e6, s: 120681e7 },
            { e: 12564036e5, s: 12382596e5 },
            { e: 1288458e6, s: 12697092e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Yekaterinburg',
          rules: [
            { e: 12249684e5, s: 12068244e5 },
            { e: 1256418e6, s: 1238274e6 },
            { e: 12884724e5, s: 12697236e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Asia/Yerevan',
          rules: [
            { e: 1224972e6, s: 1206828e6 },
            { e: 12564216e5, s: 12382776e5 },
            { e: 1288476e6, s: 12697272e5 },
            { e: 13199256e5, s: 13011768e5 },
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Australia/Lord_Howe',
          rules: [
            { e: 12074076e5, s: 12231342e5 },
            { e: 12388572e5, s: 12545838e5 },
            { e: 12703068e5, s: 12860334e5 },
            { e: 13017564e5, s: 1317483e6 },
            { e: 1333206e6, s: 13495374e5 },
            { e: 13652604e5, s: 1380987e6 },
            { e: 139671e7, s: 14124366e5 },
          ],
        },
        {
          name: 'Australia/Perth',
          rules: [{ e: 12068136e5, s: 12249576e5 }, !1, !1, !1, !1, !1, !1],
        },
        {
          name: 'Europe/Helsinki',
          rules: [
            { e: 12249828e5, s: 12068388e5 },
            { e: 12564324e5, s: 12382884e5 },
            { e: 12884868e5, s: 1269738e6 },
            { e: 13199364e5, s: 13011876e5 },
            { e: 1351386e6, s: 13326372e5 },
            { e: 13828356e5, s: 13646916e5 },
            { e: 14142852e5, s: 13961412e5 },
          ],
        },
        {
          name: 'Europe/Minsk',
          rules: [
            { e: 12249792e5, s: 12068352e5 },
            { e: 12564288e5, s: 12382848e5 },
            { e: 12884832e5, s: 12697344e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Europe/Moscow',
          rules: [
            { e: 12249756e5, s: 12068316e5 },
            { e: 12564252e5, s: 12382812e5 },
            { e: 12884796e5, s: 12697308e5 },
            !1,
            !1,
            !1,
            !1,
          ],
        },
        {
          name: 'Pacific/Apia',
          rules: [
            !1,
            !1,
            !1,
            { e: 13017528e5, s: 13168728e5 },
            { e: 13332024e5, s: 13489272e5 },
            { e: 13652568e5, s: 13803768e5 },
            { e: 13967064e5, s: 14118264e5 },
          ],
        },
        {
          name: 'Pacific/Fiji',
          rules: [
            !1,
            !1,
            { e: 12696984e5, s: 12878424e5 },
            { e: 13271544e5, s: 1319292e6 },
            { e: 1358604e6, s: 13507416e5 },
            { e: 139005e7, s: 1382796e6 },
            { e: 14215032e5, s: 14148504e5 },
          ],
        },
        {
          name: 'Europe/London',
          rules: [
            { e: 12249828e5, s: 12068388e5 },
            { e: 12564324e5, s: 12382884e5 },
            { e: 12884868e5, s: 1269738e6 },
            { e: 13199364e5, s: 13011876e5 },
            { e: 1351386e6, s: 13326372e5 },
            { e: 13828356e5, s: 13646916e5 },
            { e: 14142852e5, s: 13961412e5 },
          ],
        },
      ],
    }),
    'undefined' != typeof module && 'undefined' != typeof module.exports
      ? (module.exports = a)
      : 'undefined' != typeof define && null !== define && null != define.amd
      ? define([], function () {
          return a;
        })
      : 'undefined' == typeof e
      ? (window.jstz = a)
      : (e.jstz = a);
})();
/*!
 * Tiny Carousel 1.9
 * http://www.baijs.nl/tinycarousel
 *
 * Copyright 2010, Maarten Baijs
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.opensource.org/licenses/gpl-2.0.php
 *
 * Date: 01 / 06 / 2011
 * Depends on library: jQuery
 */

(function ($) {
  $.tiny = $.tiny || {};

  $.tiny.carousel = {
    options: {
      start: 1, // where should the carousel start?
      display: 4, // how many blocks do you want to move at 1 time?
      axis: 'x', // vertical or horizontal scroller? ( x || y ).
      controls: true, // show left and right navigation buttons.
      pager: false, // is there a page number navigation present?
      interval: false, // move to another block on intervals.
      intervaltime: 3000, // interval time in milliseconds.
      rewind: false, // If interval is true and rewind is true it will play in reverse if the last slide is reached.
      animation: true, // false is instant, true is animate.
      duration: 350, // how fast must the animation move in ms?
      callback: null, // function that executes after every move.
    },
  };

  $.fn.tinycarousel = function (options) {
    var options = $.extend({}, $.tiny.carousel.options, options);
    this.each(function () {
      $(this).data('tcl', new Carousel($(this), options));
    });
    return this;
  };
  $.fn.tinycarousel_start = function () {
    $(this).data('tcl').start();
  };
  $.fn.tinycarousel_stop = function () {
    $(this).data('tcl').stop();
  };
  $.fn.tinycarousel_move = function (iNum) {
    $(this)
      .data('tcl')
      .move(iNum - 1, true);
  };

  function Carousel(root, options) {
    var oSelf = this;
    var oViewport = $('.viewport:first', root);
    var oContent = $('.overview:first', root);
    var oPages = oContent.children();
    var oBtnNext = $('.next:first', root);
    var oBtnPrev = $('.prev:first', root);
    var oPager = $('.pager:first', root);
    var iPageSize,
      iSteps,
      iCurrent,
      oTimer,
      bPause,
      bForward = true,
      bAxis = options.axis == 'x';

    function initialize() {
      iPageSize = bAxis
        ? $(oPages[0]).outerWidth(true)
        : $(oPages[0]).outerHeight(true);
      var iLeftover = Math.ceil(
        (bAxis ? oViewport.outerWidth() : oViewport.outerHeight()) /
          (iPageSize * options.display) -
          1
      );
      iSteps = Math.max(
        1,
        Math.ceil(oPages.length / options.display) - iLeftover
      );
      iCurrent = Math.min(iSteps, Math.max(1, options.start)) - 2;
      oContent.css(bAxis ? 'width' : 'height', iPageSize * oPages.length);
      oSelf.move(1);
      setEvents();
      return oSelf;
    }
    function setEvents() {
      if (options.controls && oBtnPrev.length > 0 && oBtnNext.length > 0) {
        oBtnPrev.click(function () {
          oSelf.move(-1);
          return false;
        });
        oBtnNext.click(function () {
          oSelf.move(1);
          return false;
        });
      }
      if (options.interval) {
        root.hover(oSelf.stop, oSelf.start);
      }
      if (options.pager && oPager.length > 0) {
        $('a', oPager).click(setPager);
      }
    }
    function setButtons() {
      if (options.controls) {
        oBtnPrev.toggleClass('disable', !(iCurrent > 0));
        oBtnNext.toggleClass('disable', !(iCurrent + 1 < iSteps));

        if (!(iCurrent > 0)) {
          oBtnPrev.find('img[class*=left-inactive]').show();
          oBtnPrev.find('img[class*=left-active]').hide();
        } else {
          oBtnPrev.find('img[class*=left-inactive]').hide();
          oBtnPrev.find('img[class*=left-active]').show();
        }

        if (!(iCurrent + 1 < iSteps)) {
          oBtnNext.find('img[class*=right-inactive]').show();
          oBtnNext.find('img[class*=right-active]').hide();
        } else {
          oBtnNext.find('img[class*=right-inactive]').hide();
          oBtnNext.find('img[class*=right-active]').show();
        }
      }
      if (options.pager) {
        var oNumbers = $('.pagenum', oPager);
        oNumbers.removeClass('active');
        $(oNumbers[iCurrent]).addClass('active');
      }
    }
    function setPager(oEvent) {
      if ($(this).hasClass('pagenum')) {
        oSelf.move(parseInt(this.rel), true);
      }
      return false;
    }
    function setTimer() {
      if (options.interval && !bPause) {
        clearTimeout(oTimer);
        oTimer = setTimeout(function () {
          iCurrent = iCurrent + 1 == iSteps ? -1 : iCurrent;
          bForward =
            iCurrent + 1 == iSteps ? false : iCurrent == 0 ? true : bForward;
          oSelf.move(bForward ? 1 : -1);
        }, options.intervaltime);
      }
    }
    this.stop = function () {
      clearTimeout(oTimer);
      bPause = true;
    };
    this.start = function () {
      bPause = false;
      setTimer();
    };
    this.move = function (iDirection, bPublic) {
      iCurrent = bPublic ? iDirection : (iCurrent += iDirection);
      if (iCurrent > -1 && iCurrent < iSteps) {
        var oPosition = {};
        oPosition[bAxis ? 'left' : 'top'] = -(
          iCurrent *
          (iPageSize * options.display)
        );
        oContent.animate(oPosition, {
          queue: false,
          duration: options.animation ? options.duration : 0,
          complete: function () {
            if (typeof options.callback == 'function')
              options.callback.call(this, oPages[iCurrent], iCurrent);
          },
        });
        setButtons();
        setTimer();
      }
    };
    return initialize();
  }
})(jQuery);
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
(function() {
  'use strict'

  var keyCounter = 0
  var allWaypoints = {}

  /* http://imakewebthings.com/waypoints/api/waypoint */
  function Waypoint(options) {
    if (!options) {
      throw new Error('No options passed to Waypoint constructor')
    }
    if (!options.element) {
      throw new Error('No element option passed to Waypoint constructor')
    }
    if (!options.handler) {
      throw new Error('No handler option passed to Waypoint constructor')
    }

    this.key = 'waypoint-' + keyCounter
    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options)
    this.element = this.options.element
    this.adapter = new Waypoint.Adapter(this.element)
    this.callback = options.handler
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
    this.enabled = this.options.enabled
    this.triggerPoint = null
    this.group = Waypoint.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    })
    this.context = Waypoint.Context.findOrCreateByElement(this.options.context)

    if (Waypoint.offsetAliases[this.options.offset]) {
      this.options.offset = Waypoint.offsetAliases[this.options.offset]
    }
    this.group.add(this)
    this.context.add(this)
    allWaypoints[this.key] = this
    keyCounter += 1
  }

  /* Private */
  Waypoint.prototype.queueTrigger = function(direction) {
    this.group.queueTrigger(this, direction)
  }

  /* Private */
  Waypoint.prototype.trigger = function(args) {
    if (!this.enabled) {
      return
    }
    if (this.callback) {
      this.callback.apply(this, args)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy */
  Waypoint.prototype.destroy = function() {
    this.context.remove(this)
    this.group.remove(this)
    delete allWaypoints[this.key]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable */
  Waypoint.prototype.disable = function() {
    this.enabled = false
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable */
  Waypoint.prototype.enable = function() {
    this.context.refresh()
    this.enabled = true
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/next */
  Waypoint.prototype.next = function() {
    return this.group.next(this)
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/previous */
  Waypoint.prototype.previous = function() {
    return this.group.previous(this)
  }

  /* Private */
  Waypoint.invokeAll = function(method) {
    var allWaypointsArray = []
    for (var waypointKey in allWaypoints) {
      allWaypointsArray.push(allWaypoints[waypointKey])
    }
    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
      allWaypointsArray[i][method]()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy-all */
  Waypoint.destroyAll = function() {
    Waypoint.invokeAll('destroy')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable-all */
  Waypoint.disableAll = function() {
    Waypoint.invokeAll('disable')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable-all */
  Waypoint.enableAll = function() {
    Waypoint.Context.refreshAll()
    for (var waypointKey in allWaypoints) {
      allWaypoints[waypointKey].enabled = true
    }
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/refresh-all */
  Waypoint.refreshAll = function() {
    Waypoint.Context.refreshAll()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-height */
  Waypoint.viewportHeight = function() {
    return window.innerHeight || document.documentElement.clientHeight
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-width */
  Waypoint.viewportWidth = function() {
    return document.documentElement.clientWidth
  }

  Waypoint.adapters = []

  Waypoint.defaults = {
    context: window,
    continuous: true,
    enabled: true,
    group: 'default',
    horizontal: false,
    offset: 0
  }

  Waypoint.offsetAliases = {
    'bottom-in-view': function() {
      return this.context.innerHeight() - this.adapter.outerHeight()
    },
    'right-in-view': function() {
      return this.context.innerWidth() - this.adapter.outerWidth()
    }
  }

  window.Waypoint = Waypoint
}())
;(function() {
  'use strict'

  function requestAnimationFrameShim(callback) {
    window.setTimeout(callback, 1000 / 60)
  }

  var keyCounter = 0
  var contexts = {}
  var Waypoint = window.Waypoint
  var oldWindowLoad = window.onload

  /* http://imakewebthings.com/waypoints/api/context */
  function Context(element) {
    this.element = element
    this.Adapter = Waypoint.Adapter
    this.adapter = new this.Adapter(element)
    this.key = 'waypoint-context-' + keyCounter
    this.didScroll = false
    this.didResize = false
    this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    }
    this.waypoints = {
      vertical: {},
      horizontal: {}
    }

    element.waypointContextKey = this.key
    contexts[element.waypointContextKey] = this
    keyCounter += 1
    if (!Waypoint.windowContext) {
      Waypoint.windowContext = true
      Waypoint.windowContext = new Context(window)
    }

    this.createThrottledScrollHandler()
    this.createThrottledResizeHandler()
  }

  /* Private */
  Context.prototype.add = function(waypoint) {
    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical'
    this.waypoints[axis][waypoint.key] = waypoint
    this.refresh()
  }

  /* Private */
  Context.prototype.checkEmpty = function() {
    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal)
    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical)
    var isWindow = this.element == this.element.window
    if (horizontalEmpty && verticalEmpty && !isWindow) {
      this.adapter.off('.waypoints')
      delete contexts[this.key]
    }
  }

  /* Private */
  Context.prototype.createThrottledResizeHandler = function() {
    var self = this

    function resizeHandler() {
      self.handleResize()
      self.didResize = false
    }

    this.adapter.on('resize.waypoints', function() {
      if (!self.didResize) {
        self.didResize = true
        Waypoint.requestAnimationFrame(resizeHandler)
      }
    })
  }

  /* Private */
  Context.prototype.createThrottledScrollHandler = function() {
    var self = this
    function scrollHandler() {
      self.handleScroll()
      self.didScroll = false
    }

    this.adapter.on('scroll.waypoints', function() {
      if (!self.didScroll || Waypoint.isTouch) {
        self.didScroll = true
        Waypoint.requestAnimationFrame(scrollHandler)
      }
    })
  }

  /* Private */
  Context.prototype.handleResize = function() {
    Waypoint.Context.refreshAll()
  }

  /* Private */
  Context.prototype.handleScroll = function() {
    var triggeredGroups = {}
    var axes = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left'
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      var isForward = axis.newScroll > axis.oldScroll
      var direction = isForward ? axis.forward : axis.backward

      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        if (waypoint.triggerPoint === null) {
          continue
        }
        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint
        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint
        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint
        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint
        if (crossedForward || crossedBackward) {
          waypoint.queueTrigger(direction)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    for (var groupKey in triggeredGroups) {
      triggeredGroups[groupKey].flushTriggers()
    }

    this.oldScroll = {
      x: axes.horizontal.newScroll,
      y: axes.vertical.newScroll
    }
  }

  /* Private */
  Context.prototype.innerHeight = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportHeight()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerHeight()
  }

  /* Private */
  Context.prototype.remove = function(waypoint) {
    delete this.waypoints[waypoint.axis][waypoint.key]
    this.checkEmpty()
  }

  /* Private */
  Context.prototype.innerWidth = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportWidth()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerWidth()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-destroy */
  Context.prototype.destroy = function() {
    var allWaypoints = []
    for (var axis in this.waypoints) {
      for (var waypointKey in this.waypoints[axis]) {
        allWaypoints.push(this.waypoints[axis][waypointKey])
      }
    }
    for (var i = 0, end = allWaypoints.length; i < end; i++) {
      allWaypoints[i].destroy()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-refresh */
  Context.prototype.refresh = function() {
    /*eslint-disable eqeqeq */
    var isWindow = this.element == this.element.window
    /*eslint-enable eqeqeq */
    var contextOffset = isWindow ? undefined : this.adapter.offset()
    var triggeredGroups = {}
    var axes

    this.handleScroll()
    axes = {
      horizontal: {
        contextOffset: isWindow ? 0 : contextOffset.left,
        contextScroll: isWindow ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left',
        offsetProp: 'left'
      },
      vertical: {
        contextOffset: isWindow ? 0 : contextOffset.top,
        contextScroll: isWindow ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up',
        offsetProp: 'top'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        var adjustment = waypoint.options.offset
        var oldTriggerPoint = waypoint.triggerPoint
        var elementOffset = 0
        var freshWaypoint = oldTriggerPoint == null
        var contextModifier, wasBeforeScroll, nowAfterScroll
        var triggeredBackward, triggeredForward

        if (waypoint.element !== waypoint.element.window) {
          elementOffset = waypoint.adapter.offset()[axis.offsetProp]
        }

        if (typeof adjustment === 'function') {
          adjustment = adjustment.apply(waypoint)
        }
        else if (typeof adjustment === 'string') {
          adjustment = parseFloat(adjustment)
          if (waypoint.options.offset.indexOf('%') > - 1) {
            adjustment = Math.ceil(axis.contextDimension * adjustment / 100)
          }
        }

        contextModifier = axis.contextScroll - axis.contextOffset
        waypoint.triggerPoint = Math.floor(elementOffset + contextModifier - adjustment)
        wasBeforeScroll = oldTriggerPoint < axis.oldScroll
        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll
        triggeredBackward = wasBeforeScroll && nowAfterScroll
        triggeredForward = !wasBeforeScroll && !nowAfterScroll

        if (!freshWaypoint && triggeredBackward) {
          waypoint.queueTrigger(axis.backward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (!freshWaypoint && triggeredForward) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    Waypoint.requestAnimationFrame(function() {
      for (var groupKey in triggeredGroups) {
        triggeredGroups[groupKey].flushTriggers()
      }
    })

    return this
  }

  /* Private */
  Context.findOrCreateByElement = function(element) {
    return Context.findByElement(element) || new Context(element)
  }

  /* Private */
  Context.refreshAll = function() {
    for (var contextId in contexts) {
      contexts[contextId].refresh()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
  Context.findByElement = function(element) {
    return contexts[element.waypointContextKey]
  }

  window.onload = function() {
    if (oldWindowLoad) {
      oldWindowLoad()
    }
    Context.refreshAll()
  }


  Waypoint.requestAnimationFrame = function(callback) {
    var requestFn = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      requestAnimationFrameShim
    requestFn.call(window, callback)
  }
  Waypoint.Context = Context
}())
;(function() {
  'use strict'

  function byTriggerPoint(a, b) {
    return a.triggerPoint - b.triggerPoint
  }

  function byReverseTriggerPoint(a, b) {
    return b.triggerPoint - a.triggerPoint
  }

  var groups = {
    vertical: {},
    horizontal: {}
  }
  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/api/group */
  function Group(options) {
    this.name = options.name
    this.axis = options.axis
    this.id = this.name + '-' + this.axis
    this.waypoints = []
    this.clearTriggerQueues()
    groups[this.axis][this.name] = this
  }

  /* Private */
  Group.prototype.add = function(waypoint) {
    this.waypoints.push(waypoint)
  }

  /* Private */
  Group.prototype.clearTriggerQueues = function() {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    }
  }

  /* Private */
  Group.prototype.flushTriggers = function() {
    for (var direction in this.triggerQueues) {
      var waypoints = this.triggerQueues[direction]
      var reverse = direction === 'up' || direction === 'left'
      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint)
      for (var i = 0, end = waypoints.length; i < end; i += 1) {
        var waypoint = waypoints[i]
        if (waypoint.options.continuous || i === waypoints.length - 1) {
          waypoint.trigger([direction])
        }
      }
    }
    this.clearTriggerQueues()
  }

  /* Private */
  Group.prototype.next = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    var isLast = index === this.waypoints.length - 1
    return isLast ? null : this.waypoints[index + 1]
  }

  /* Private */
  Group.prototype.previous = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    return index ? this.waypoints[index - 1] : null
  }

  /* Private */
  Group.prototype.queueTrigger = function(waypoint, direction) {
    this.triggerQueues[direction].push(waypoint)
  }

  /* Private */
  Group.prototype.remove = function(waypoint) {
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    if (index > -1) {
      this.waypoints.splice(index, 1)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/first */
  Group.prototype.first = function() {
    return this.waypoints[0]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/last */
  Group.prototype.last = function() {
    return this.waypoints[this.waypoints.length - 1]
  }

  /* Private */
  Group.findOrCreate = function(options) {
    return groups[options.axis][options.name] || new Group(options)
  }

  Waypoint.Group = Group
}())
;(function() {
  'use strict'

  var $ = window.jQuery
  var Waypoint = window.Waypoint

  function JQueryAdapter(element) {
    this.$element = $(element)
  }

  $.each([
    'innerHeight',
    'innerWidth',
    'off',
    'offset',
    'on',
    'outerHeight',
    'outerWidth',
    'scrollLeft',
    'scrollTop'
  ], function(i, method) {
    JQueryAdapter.prototype[method] = function() {
      var args = Array.prototype.slice.call(arguments)
      return this.$element[method].apply(this.$element, args)
    }
  })

  $.each([
    'extend',
    'inArray',
    'isEmptyObject'
  ], function(i, method) {
    JQueryAdapter[method] = $[method]
  })

  Waypoint.adapters.push({
    name: 'jquery',
    Adapter: JQueryAdapter
  })
  Waypoint.Adapter = JQueryAdapter
}())
;(function() {
  'use strict'

  var Waypoint = window.Waypoint

  function createExtension(framework) {
    return function() {
      var waypoints = []
      var overrides = arguments[0]

      // https://github.com/imakewebthings/waypoints/pull/622/files
      if (typeof arguments[0] === "function"){
        overrides = framework.extend({}, arguments[1])
        overrides.handler = arguments[0]
      }

      this.each(function() {
        var options = framework.extend({}, overrides, {
          element: this
        })
        if (typeof options.context === 'string') {
          options.context = framework(this).closest(options.context)[0]
        }
        waypoints.push(new Waypoint(options))
      })

      return waypoints
    }
  }

  if (window.jQuery) {
    window.jQuery.fn.waypoint = createExtension(window.jQuery)
  }
  if (window.Zepto) {
    window.Zepto.fn.waypoint = createExtension(window.Zepto)
  }
}())
;
var Config = Config || {};

Config.Chosen = {
  Default: {
    search_contains: true,
    disable_search_threshold: 10
  },
  DisableSearch: {
    search_contains: true,
    disable_search_threshold: 1000
  },
  AllowDeselect: {
    search_contains: true,
    disable_search_threshold: 10,
    allow_single_deselect: true
  }
},

Config.Select2 = {
  Default: {
    minimumResultsForSearch: 10,
    width: 'resolve'
  }
};

Config.Modal = {
  Standard: {
    draggable: true,
    resizable: false,
    modal: true,
    minHeight: 0,
    dialogClass: 'modal-dialog',
    open: function(event, ui) {
      $('body').css({ overflow: 'hidden' });
      $('.ui-widget-overlay').bind('click', closeModal);

      function closeModal() {
        $(this).siblings('.ui-dialog').find('.ui-dialog-titlebar-close').click();
      }
    },
    beforeClose: function(event, ui) {
      $('body').css({ overflow: 'inherit' })
    }
  },
  custom: function(overrides) {
    return $.extend({}, Config.Modal.Standard, overrides);
  }
};

Config.Recurly = Config.Recurly || {};

Config.Sortable = {
  Standard: {
    items: "li:not(.not-sortable)",
    placeholder: 'sortable-placeholder',
    start: function(e, ui) {
      // subtract 6 to account for dashed border on placeholder
      ui.placeholder.height(ui.item.height() - 6);
    },
    tolerance: 'pointer',
    revert: 200
  }
};

Config.FullCalendar = {
  Default: {
    height: 550,
    header: {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay'
    },
    timezone: 'local',
    scrollTime: '09:00:00',
    defaultView: 'agendaWeek',
    editable: true,
    selectable: true,
    selectHelper: true
  }
};

Config.TimeZone = {
  timeFormat: function(format) {
    function timeFormatMap(clock12Hour, clock24Hour) {
      if (typeof TimeFormat === "undefined") {
        return clock12Hour;
      } else {
        switch(TimeFormat) {
          case('clock_24_hr'): // TODO: change to customer facing value, app/presenters/time_format_presenter.rb
            return clock24Hour;
          default:
            return clock12Hour;
        }
      }
    }

    switch(format) {
      case('time'):
        return timeFormatMap('h:mma', 'H:mm');
      case('time_double_digits'):
        return timeFormatMap('hh:mma', 'HH:mm');
      case('time_hide_minutes_when_0'):
        return timeFormatMap('h(:mm)a', 'H:mm');
      case('timezone'):
        return timeFormatMap('Z', 'Z');
    }
  },
  dateFormat: function(format) {
    function dateFormatMap(monthDayYear, dayMonthYear, yearMonthDay) {
      if (typeof DateFormat === "undefined") {
        return monthDayYear;
      } else {
        switch(DateFormat) {
          case('DD/MM/YYYY'):
            return dayMonthYear;
          case('YYYY/MM/DD'):
            return yearMonthDay;
          default:
            return monthDayYear;
        }
      }
    }

    switch(format) {
      case('date'):
        return dateFormatMap('MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD');
      case('date_pretty'):
        return dateFormatMap('MMM D, YYYY', 'D MMM YYYY', 'YYYY MMM D');
      case('date_pretty_long_month'):
        return dateFormatMap('MMMM D, YYYY', 'D MMMM YYYY', 'YYYY MMMM D');
      case('date_pretty_without_year'):
        return dateFormatMap('MMM D', 'D MMM', 'MMM D');
      case('datepicker'):
        return dateFormatMap('mm/dd/yy', 'dd/mm/yy', 'yy/mm/dd');
      case('trend_chart'):
        return dateFormatMap('%m/%d', '%d/%m', '%m/%d');
      case('date_without_year_with_day_of_week'):
        return dateFormatMap('ddd M/D', 'ddd D/M', 'ddd M/D');
      case('date_without_year_with_day_of_week_2'):
        return dateFormatMap('ddd MMM Do', 'ddd D MMM', 'ddd D MMM')
    }
  }
};
/* eslint max-len: "off", quotes: "off", no-unused-vars: "off" */
var uploaders = ['Dropbox', 'Google Drive'];

var Message = {
  Tooltip: {
    InterviewPlanCandidateGoal:
      'If you set a goal, Greenhouse will show your progress against this goal on your weekly reports.',
    InterviewPlanDwellTime:
      'Greenhouse can alert you when candidates are in a stage for too long, ensuring that no one falls through the cracks.',
    JobDetailsNumberOfOpenings:
      'If you would like to purchase more openings, you can do so under Subscription.',
    GreenhouseJobApplicationGuidance: "What are you looking for?<br/><br/>What is the most appealing part of the job?<br/><br/>What is the work environment like?<br/><br/>What are the required skills and experience?",
    HRRole: 'Admin + EEOC/Private Candidates',
    Responsive:  "This checkbox will make your job board and application form responsive. If you have a pre-existing job board with custom CSS, ticking this box could cause styling issues, so please make sure that you have a developer handy to make any changes which might be necessary.",
    Accessible:  "Turning this on could cause styling issues for job boards with custom CSS. Please make sure you have a developer available to make any necessary changes.",
    NoAutoScroll:  "Depending on how you have implemented your job board, you may not want candidates to start at the top of the website once the iFrame has loaded",
    AutoLoad:  "If your site is a Single-Page App, or you would otherwise like to prevent the board from being loaded on window.onload, uncheck this box",
    JobBoardBaseUrl: "This URL should point to your site's careers page.  If you are using the JSONP API, you will likely need to include a separate URL for your job application page below.",
    JobAppBaseUrl: "The URL should point to your job application page. It is only necessary to configure this field if your application form resides on a separate page from your job board.",
    YourURLToken: "The token you will use in requests to the Greenhouse Job Board API.  This is not an API key; it is public and may be shared.",
    CustomCssUrl: "Optionally enter a URL to a file containing CSS overrides. View our CSS Guide to see what can be styled.",
    BambooHrApiKey:
      'To find your API key in Bamboo, log in and click the link to "Hi, Your Name". The submenu will include a link to "API Keys". Click through and "Add a New Key".',
    BambooHrCompanySubdomain:
      'To find your company subdomain, log in to Bamboo and look at the URL in your browser. The subdomain is the part before ".bamboohr.com". For example, if the URL is "mycompany.bamboohr.com", then the company subdomain is "mycompany."',
    ResendInvite:
      'Click to re-send the email inviting this user to join your Greenhouse account.',
    DisableDataProtectionOfficer:
      'This user is currently set as the Data Protection Officer on the Account Settings > Contacts page. Please set another user before disabling this user.',
    AddAProspect:
      'If you don’t have a specific job for a prospect in mind, you can choose a department (and optionally office/level) and they’ll show up as a prospect on all corresponding jobs at once. <br/><br/>' +
      'If you know exactly which position(s) they’d be good for, you can choose one or more specific jobs individually.',
    ApprovalOpenJob: "Approvals needed before a draft job can be opened and posted on your careers page so you can start recruiting and interviewing candidates.",
    ApprovalOfferJob: "Approvals needed to confirm that your company has decided to go ahead and fill the position.  It allows designated Admins to create offers, but not to extend them to candidates.",
    ApprovalOfferCandidate: "Approvals needed for the details of individual offers (salary, benefits, etc.). The details must be approved before the offer can be extended to each candidate.",
    ApprovalTwoStage: "Toggling this will allow your organization to have separate approval flows. The first controlling opening a job and the second controlling creating offers for candidates.",
    ApprovalOneStage: "Toggling this will allow your organization to have a single approval flow for opening a job and allowing it to be filled.",
    ReportingQuality:
      "Quality % is the average distance candidates travel through the pipeline. All candidates hired would be 100%. All candidates rejected in the first stage would be 0%.",
    MilestoneReportingQuality:
      "Quality % is the average distance candidates travel through the pipeline. All candidates hired would be 100%. All candidates rejected in the first milestone would be 0%.",
    ReportingTotalHours:
      "This is the # of interviewer hours scheduled for this job",
    ReportingExcludeAppReview:
      "If checked, we'll exclude Application Review (and Hiring Manager Application Review).",
    ReportingActivityDate:
      'This will filter each column uniquely by the date the event occurred.',
    TakeHomeTestSendLink:
      "By default, Greenhouse automatically includes a link to a page where candidates can directly upload their completed tests.  If you'd like them to submit their test another way (e.g. survey monkey, email address) simply check the box and the link won't be included in the email.<br/><br/>NOTE: If you do check the box, be sure to include instructions for how to submit their test in the body of the email.",
    TakeHomeTestGrading:
      "You can edit graders for each candidate when you send the test.",
    EmailTokens:
      "Use tokens to customize your email. Be sure to include double braces e.g. {{TOKEN}} so we can identify them.",
    JobAdminOrgRoleConfig:
      'Want to specify what Job Admins have access to without giving them full Site Admin permissions? Manage your own Job Admin levels here.',
    DefaultJobAdminPermissions:
      "<ul id='default-job-admin-permissions'><li>Can see dashboard, pipeline, and reports</li><li>Can see all candidates</li><li>Can add and edit candidates and referrals</li><li>Can be assigned hiring team roles</li></ul>",
    JobPostPrivateQuestion:
      'Marking this question Private will allow only Job Admins and Site Admins with the "Private Data" permission to see candidate answers.' +
      '<br><br>Marking this question API Only will hide it from Greenhouse completely and allow only users accessing the Harvest API to see candidate answers. Marking questions API Only cannot be undone.',
    AgencyPrivateNotes:
      'Use this for confidential information to be seen by HR only (e.g. current/desired salary)',
    FollowJob:
      'Jobs you follow will show up under the "Jobs I\'m following" filter on your homepage',
    BulkAddToAnotherJob: 'Filter by "Candidates Only" to do this action.',
    BulkApplicationReview:
      'Filter for "Candidates Only" on a single job to do this action. Any candidates not in an application review stage will be skipped.',
    BulkCreateOffer: 'Filter by "Candidates Only" to perform this action.',
    BulkCreateOfferWithOpeningsOnOffers:
      'Cannot perform bulk offer creation due to "Openings on Offers" feature being enabled for your account.',
    BulkDeleteCandidatesPersonalData:
      'Filter by GDPR status "Data due to be deleted" (under Profile Details) to do this action',
    BulkRequestCandidatesConsent:
      'Filter by GDPR status "Consent not requested" (under Profile Details) to enable this action',
    BulkScheduleWithCalendly:
      'Filter by Job, Stage, and "To Be Scheduled" to do this action. All candidates must be in an interview stage with exactly 1 schedulable interview.',
    BulkGenerateOfferDocuments: 'Filter by "Offer Created" to do this action.',
    BulkPrintResumes:
      'Select a maximum of 30 applications. Applications without resumes will be skipped.',
    BulkProspectActions: 'Filter by "Prospect Only" to do this action.',
    BulkSendJobPosts:
      'Filter by Job and Job Post "To Be Sent" to do this action.',
    BulkSendForm:
      'Filter for "Candidates Only" on a single job to do this action. Any candidates without an email address will be skipped.',
    BulkSendTakeHomeTest:
      'Filter by Job, Stage and Test Status "To Be Sent" to do this action.',
    BulkTransferToDifferentJob:
      'Filter by "Candidates Only" on the same job to do this action.',
    BulkSendOffer:
      'Filter by "Candidates Only" and Offer "To Be Sent" to do this action.',
    JobBoardIndeedApply: "Note: This integration is not available for jobs that have the following:<br/><br/>• Required education fields<br/>• Required employment fields<br/>• Required location field<br/>• Equal Employment Opportunity (EEO) questions<br/>• Custom demographic questions<br/>• Custom questions with attachments<br/>• Custom questions seeking personally identifiable information (PII)",
    JobBoardSeekApply: "Entering your company's SEEK ID will allow you to add an 'Apply with SEEK' button to jobs on this board.<br/><br/> Candidates can use this button to quickly pre-fill basic information from their SEEK profiles onto your job applications.<br/><br/>  After saving, edit each individual job post to toggle the integration on or off.<br/><br/>Please discuss this solution with your SEEK Account Manager before activating.",
    WebHookBasicAuth: "These options exist in case the environment receiving web hook notifications require basic authorization to allow access.  This username and password will be converted to a HTTP Authorization header.  This is not generally required and is usually only needed in special circumstances.",
    WebHookOauth: "Some customers choose to receive web hooks at an endpoint protected with an access token generated using OAuth. Greenhouse will authenticate with the OAuth provider using your credentials and then send web hooks with the token it receives.",
    WebHookAdditionalHeaders: "These are HTTP Headers that will be included with each web hook export. This should be formatted as regular HTTP Headers, one per line, and will be included exactly as written.  If you don't know how these work, it's likely you don't need to fill this out.",
    WebHookMaxAttempts: "This option exists to set a maximum number of times you'd like the web hook to attempt processing before giving up. If you're unsure, leave this value at its default.",
    ConfidentialJob:
      "Confidential jobs will only be visible to you. You must add additional users to the job manually on the job's hiring team page.",
    TeamAndResponsibilities:
      "<ul><li> What will this person's role and responsibilities be? </li> <li> How will their success be evaluated? </li> <li> Who will they be working with? </li> <li> Who will they report to? </li><ul>",
    HowToSellThisJob:
      '<ul><li> How should employees sell this job to candidates? </li> <li> What are the challenges of this position? </li> <li> How is taking this job a good career move? </li> <li> What will the candidate learn in this role? </li> </ul>',
    ConnectToGoogleCalendar:
      'Click here to give Greenhouse permission to schedule events in your Google Calendar.',
    ConnectToOutlook365Calendar:
      'Click here to give Greenhouse permission to schedule events in your Outlook 365 Calendar',
    ImmutableFieldKeyNote:
      'This key is generated on creation of a custom field and will never change. It enables downstream systems, such as HRIS systems, to detect the presence of Greenhouse custom fields in exported data.',
    BulkEmailWarning: "NOTE: Candidates without an email address and candidates marked as 'Do Not Email' will not receive this email.  <br/><br/>Uncheck the 'Do Not Email' box on a candidate's profile to send them emails through Greenhouse.",
    RejectBulkEmailWarning: "NOTE: Candidates who are already rejected, active candidates without an email address, and candidates marked as 'Do Not Email' will not receive this email.  <br/><br/>Uncheck the 'Do Not Email' box on a candidate's profile to send them emails through Greenhouse.",
    JobBoardLogoHref: "Users clicking your logo will be brought to this address.",
    CandidatesEntered:
      "This column shows how many candidates were moved into a particular stage/milestone in a given period. It could contain duplicates if you moved one candidate into a stage/milestone on two different jobs.",
    CandidatesExited:
      "This column shows how many candidates were moved out of a particular stage in a given period, including rejections. It could contain duplicates if you moved one candidates out of a stage on two different jobs.",
    CandidatesRejected:
      "This column shows how many applications were rejected from a particular stage/milestone in a given period. It could contain duplicates if you rejected one candidate from two different jobs.",
    InterviewsCreated:
      "The number of interviews that were created and sent to interviewers in a particular period. Meant to show how much scheduling is being done, this column ignores the date the interview takes place and only looks at when it was initially set up. ",
    NumberOfInterviews:
      "The number of interviews that happened or are set to take place in a given period. Meant to show how many interviews actually took place, this column ignores the interview creation date and only looks at when it was scheduled to occur.",
    CandidatesInterviewing:
      "The number of candidates with any interviews scheduled for a given period. One candidate could have four interviews as part of a face-to-face stage, but this column will only count one distinct person for all of those interviews. It could contain duplicates if you scheduled one candidate on two different jobs.",
    ScorecardsSubmitted:
      "The number of candidates with any scorecards submitted for them in a given period. One candidate could have four scorecards as part of a group interview stage, but this column will only count one distinct person for all of those scorecards. It could contain duplicates if you submitted scorecards for one candidate on two different jobs.",
    CandidatesRated:
      "The number of candidates with any scorecards submitted for them in a given period. One candidate could have four scorecards as part of a group interview stage, but this column will only count one distinct person for all of those scorecards. It could contain duplicates if you submitted scorecards for one candidate on two different jobs.",
    TakeHomeTestsSent:
      "The total number of unique take home tests sent to candidates. Re-sending a test does not impact this number.",
    TakeHomeTestsSubmitted:
      "The number of completed take home tests received. A test sent in a previous time period may be completed in a later period.",
    LinkedInLimitedListings: "Your jobs will be distributed to LinkedIn as limited listings and appear in their search results.<br><br>Adding your company ID will help LinkedIn match your job posts to your company page on LinkedIn.",
    LinkedInCompanyUrl: "Your jobs will be distributed to LinkedIn and appear in their search results.<br><br>Adding your LinkedIn company url will help LinkedIn match your job posts to your company page on LinkedIn. <br><br><a href=\"https://www.linkedin.com/help/linkedin/answer/a541944\" target=\"_blank\">How do I find my LinkedIn company URL?</a>",
    GravatarSetting:
      'Candidates can create their Gravatars whenever they sign up with sites that use wordpress.com. <br> Gravatars are helpful as they give you a visual cue to remember candidates.',
    IDashAppReview:
      "Review applications for jobs you're a hiring manager or recruiter on. These roles can be assigned on a job's Hiring Team page.",
    OfficeSpecificField:
      'This field will only be applied to the appropriate candidates.',
    LinkedinVerifyEmail:
      'Signing in with LinkedIn connects the post to your LinkedIn profile, allowing you to manage the post once published in LinkedIn and track all candidate views and apply clicks.',
    OfferApprovalFlowForExistingJobs: "This will update the offer approval flow for all jobs in this department and office. It won't affect offers in process.",
    CustomFieldOption:
      'Input custom field options, each on a new line. For example: <br> Option one <br> Option' +
      ' two <br> Option three',
    TalentwiseOrderedBy:
      'Contact the user who ordered this Talentwise background check for access to the report.',
    AddThisJob:
      "You can only add a candidate to a job on which you have equal or lesser permissions.",
    MoveThisJob:
      "You can only move a candidate to a job on which you have equal or lesser permissions.",
    ScorecardQuestionOption:
      'Enter question options, each on a new line. For example: <br> Option one <br> Option' +
      ' two <br> Option three',
    LinkedAttributes:
      "Tagged attributes will display directly next to the question on the scorecard",
    CannotManageProspectPool:
      "You can only edit this pool if you're a pool admin",
    ProspectPool: "Use prospect pools to organize people you’ve found online, met through events or have been through your interview process before who you think might be a good fit for a job now or in the future.",
    ProspectStages: "Use prospect stages to keep track of prospect’s status, experience level or however you see fit.  A different set of stages can be created for each prospect pool.",
    HideProspectPool:
      'Hide pools if you no longer want them to appear in prospect pool and stage dropdown.',
    OfferSectionToken: "Use this token in your offer templates for one of the below offer sections to appear. The offer section text will vary based on the custom field option selected when creating a candidate offer.",
    OfferSectionAvailableTokens: "Use other tokens within your offer sections to further customize offer templates. Be sure to use double braces i.e. {{TOKEN}} around any tokens so we can identify them.",
    PipelinePerJobNow: "Active candidates in the stage right now",
    PipelinePerJobEver: "Candidates who ever reached that stage or beyond",
    DemographicPipelinePassRate:
      'Pass rate is the percentage of candidates who advanced to the following milestone.',
    DemographicPipelineMilestonePassRate:
      'Milestone pass rate is the overall percentage of candidates for the selected job(s) who advance to the following milestone.',
    MilestonePipelinePerJobNow: "Active candidates in the milestone right now",
    MilestonePipelinePerJobEver:
      "Candidates who ever reached that milestone or beyond",
    OfferExtended:
      "Offers your organization sent through Greenhouse during this time period",
    OfferOutstanding:
      "Offers that were sent, but unresolved, during this time period",
    OfferAcceptanceRate:
      "Calculated by dividing Offers Accepted by the sum of Offers Accepted plus Offers Rejected",
    Adherence: 'The percent of focus attributes completed by the interviewer',
    AdobeSignTokens:
      'For multiple signers, use the same Adobe Acrobat Sign Tokens, but change the number in the token to match the associated signer. For example, to add a second signer, use {{SIG_ES_:SIGNER2:SIGNATURE}}.',
    DocusignDateTokens:
      'Older versions of the Docusign integration relied on a single {{SIGNATURE_DATE}} token. For the best results, we recommend using both {{CANDIDATE_SIGNATURE_DATE}} and {{COMPANY_SIGNATURE_DATE}} in your templates.',
    InterviewerTags:
      "When scheduling an interview, you'll be able to filter users by tag to help decide who should conduct each interview.",
    LinkUserToCandidate:
      'Link users to candidates to prevent users from seeing their own candidate profile.',
    ArchivedProspectPool: "Prospects can't be added to Archived Pools.",
    QuestionPrivacy: "Marking this question <b>Private</b> will allow only Job Admins and Site Admins with &ldquo;Private&rdquo; permissions to see candidate answers. <br><br>Marking this question <b>API Only</b> will hide it from Greenhouse completely and allow only users accessing the Harvest API to see candidate answers. Marking questions API Only cannot be undone. <br><br>Answers linked to a custom field on candidate profiles will inherit those privacy settings.",
    FormsQuestionPrivacy: "Marking this question <b>Private</b> will allow only Job Admins and Site Admins with &ldquo;Private&rdquo; permissions to see candidate answers. <br><br>Answers linked to a custom field on candidate profiles will inherit those privacy settings.",
    BulkEditJobPostDate:
      'Month can be required when year is required on all posts. Month can be optional when year is either optional or required on all posts.',
    UltiproServiceUsername:
      'This is the username used to access the API endpoints to fetch the list of onboarding owners and active jobs.',
    UltiproServicePassword:
      'This is the password used to access the API endpoints to fetch the list of onboarding owners and active jobs. This is used with the service username for HTTP Basic Auth',
    UltiproServiceKey:
      'This is an API key used in conjunction with the username and password to access onboarding owners and active jobs. All 3 are required to access these endpoints.',
    UltiProTenantAlias:
      "This is your company's unique tenant to access the Onboarding API.",
    UltiproServiceHostname:
      'This is the hostname your company uses to access the Service API. It should look like service.ultipro.com',
    UltiproOnboardingHost:
      'This is the hostname used to access the Onboarding API. This should look like onb.ultipro.com',
    UltiproRoleId:
      'This is the role id unique to your Ultipro instance that indicates Onboarding Owners. This allows Greenhouse to get only users with the Onboarding Owner Role.',
    PhantomLoginNoGrant:
      'The user has not granted temporary access to their account',
    ShorterDkimKey: "By default, email domains will be generated with a 2048-bit DKIM length. If your DKIM records have a character limit and need to be shorter, check this box.",
    MissingApplicationRuleQuestions:
      "Rules can only be set for yes/no, single select, and multi select questions.",
  },
  Billing: {
    Subscription: {
      Updating: 'Updating your subscription',
    },
  },
  Account: {
    OrgName: {
      Success: 'Organization name successfully updated',
      Failure: 'Failed to save organization name, please try again',
      Blank: "Organization name can't be blank",
    },
    OrgSize: {
      Success: 'Organization size successfully updated',
      Failure: 'Failed to save organization size, please try again',
    },
    RequisitionCounter: {
      Success: 'Requisition ID counter successfully updated',
      Failure: 'Failed to save Requisition ID counter, please try again',
      Invalid: 'Must be a number greater than 0',
    },
    DefaultDateFormat: {
      Success: 'Default Date Format successfully updated',
      Failure: 'Failed to save Default Date Format, please try again',
    },
    DefaultTimeFormat: {
      Success: 'Default Time Format successfully updated',
      Failure: 'Failed to save Default Time Format, please try again',
    },
    CloseJob: {
      Success: 'Job successfully closed',
      Failure: 'Failed to close job, please try again.',
    },
    ReopenJob: {
      Success: 'Job successfully re-opened',
      Failure: 'Failed to re-open job, please try again.',
    },
    OpenDraftJob: {
      Success: 'Job successfully opened',
    },
    NewUser: {
      EmailRequired: 'You must add at least one email address to continue',
    },
  },
  Person: {
    Show: {
      HeadlineDefault: 'Write a headline about this person ...',
      AddToJob: {
        Success: 'Added to job',
        Failure: 'Failed to add person to job',
      },
      UpdateSource: {
        Success: 'Source updated',
        Failure: 'Failed to update source',
      },
      UploadPhotoPending: 'Uploading photo...',
      DeletePhotoPending: 'Deleting photo...',
      Application: {
        LoadCustomFieldsFailed:
          'Failed to load custom fields. Please try refreshing the page.',
      },
    },
    Offer: {
      OfferDateRequired: 'Offer date is required',
    },
  },
  Home: {
    MustSelectJobType: 'Please make a selection',
  },
  RampUp: {
    Validation: {
      RoleRequired: 'A role must be selected',
      JobNameRequired: 'An internal job name is required',
      PublicJobNameRequired: 'An external job name is required',
    },
  },
  JobBoard: {
    ApplicationConfirmationRequired: 'Application confirmation required',
    CompanyNameRequired: 'Company name is required',
    UrlTokenRequired: 'URL is required',
    UrlTokenUnavailable: 'Sorry, that URL is already taken',
    CompanyNameUnavailable: 'Sorry, that company name is already taken',
    UrlTokenAlphanumeric: 'You can only use letters and numbers',
    LinkedinCompanyIdRequired: 'LinkedIn Company ID is required',
    LinkedinCompanyUrlRequired: 'LinkedIn Company URL is required',
    LinkedinCompanyId11Numeric:
      'LinkedIn Company IDs must be 11 numbers or less',
    LinkedinApplyRequired: 'A Linkedin Easy Apply selection is required',
    ImageFormat: 'You may only upload a .jpg, .png, or .gif file.',
    LogoHrefInvalid:
      'Logo link must be a valid URL (be sure to include http:// or https://)',
    CreatedAd: {
      Validation: {
        AdTitleRequired: 'Name is required',
        UniqueAdTitleRequired:
          'This name is already in use. Please use another.',
        PostTitleRequired: 'Title is required',
        DescriptionRequired: 'Content is required',
      },
    },
    Index: {
      ScheduledForDeletion:
        'Your job board ad is scheduled for removal. Please allow up to 24 hours for the removal to take effect.',
      Error: {
        DeletionFailed:
          'Sorry, we ran into a problem removing your ad. Please try again.',
      },
    },
    Confirm: {
      Error: 'An error occurred posting your ad. Please try again.',
    },
    Public: {
      InvalidUrl: 'Invalid URL',
    },
    Embed: {
      UrlUpdated: 'Your URL has been updated successfully',
      ApplicationConfirmationUpdated:
        'Your application confirmation has been updated successfully',
      LinkToSaved: 'Your links have been updated successfully.',
      HideViewAllSetting:
        "Your hide 'View All Jobs' setting has been updated successfully.",
      Responsive:
        "The 'responsive' setting on your job board has been updated successfully.",
      NoAutoScroll:
        "The 'No Auto Scroll' setting on your job board has been updated successfully.",
      Accessible:
        "The 'Accessible' setting on your job board has been updated successfully.",
      AutoLoad:
        "The 'auto-load' setting on your job board has been updated successfully.",
      Validation: {
        UrlRequired: 'URL required to generate embed code',
        UrlMustBeSet: 'The URL for your job board must be set.',
      },
    },
  },
  JobApplication: {
    TitleRequired: 'Title is required',
    LocationRequired: 'Location is required',
    ContentRequired: 'Content is required',
    UnsavedChanges:
      'This page is asking you to confirm that you want to leave - data you have entered may not be' +
      ' saved.',
  },
  General: {
    LeavingPageWithUnsavedChanges:
      "You haven't saved your changes! Your changes will be lost if you leave this page without saving.",
  },
  InterviewPlan: {
    NoUnassignedAttributes:
      'This interview plan includes all Skills, Personality, Qualifications and Details of your Target Candidate.',
    Validation: {
      NameIsRequired: 'Name is required',
      DescriptionIsRequired: 'Description is required',
      TimeCandidateMustBeANumber: 'Time / Candidate must be a number.',
      InvalidNumber: 'Invalid number',
    },
    Confirm: {
      DeleteStep: 'Are you sure you want to delete this step?',
    },
    Error: {
      SavingPlan:
        'Sorry, there was an error saving your plan! Please try again.',
    },
  },
  InterviewKit: {
    Error: {
      Generic:
        "Error updating your interview kit. Please try again; if that fails, <a href='https://support.greenhouse.io/direct'>contact our support team</a>.",
    },
  },
  MyInfo: {
    AllowlistUpdated: 'Your email allowlist has been updated.',
    Validation: {
      CurrentPasswordRequired: 'You must enter your current password.',
    },
  },
  EditUser: {
    PasswordResetPending: 'Sending instructions...',
    PasswordResetSent: 'Password reset instructions were emailed.',
    InvitationPending: 'Resending invite...',
    InvitationSent: 'Invitation was emailed.',
  },
  Dashboard: {
    ReopenPending: 'Re-opening job...',
  },
  Login: {
    EmailRequired: 'Enter your email.',
    PasswordRequired: 'Enter your password.',
    AlreadyInvited:
      'You need to complete your registration by clicking the link in your invitation email before you can log in.',
    UserLocked:
      'Your account has been temporarily locked due to too many invalid login attempts. Please reset your password to unlock.',
    InvalidCredentials: 'Invalid email or password. Please try again.',
    TooManyRequests:
      'You have attempted to log in too many times in a row.  Please try again later.',
    Error: 'There was an error trying to log you in.',
  },
  ResetPassword: {
    ErrorChangingPassword: 'There was an error trying to change your password.',
    ErrorSendingEmail:
      'There was an error trying to send your password reset instructions.',
  },
  Interviews: {
    CalendarTypeRequired: 'Calendar type is required',
    EndTimeInvalid: 'End time must be after start time',
    iCal: {
      DateRequired: 'Date is required',
      StartTimeRequired: 'Start time is required',
    },
  },
  Sourcing: {
    TypeRequired: 'You must select a type',
    NameRequired: 'You must provide a name',
  },
  Common: {
    Validation: {
      RequiredField: 'Required field',
      Duplicate: 'This name is already in use',
      FieldEmpty: 'A value must be provided',
      FirstNameRequired: 'First name is required.',
      LastNameRequired: 'Last name is required.',
      AgencyNameRequired: 'Agency name is required',
      SubjectRequired: "Subject is required",
      BodyRequired: "Body is required",
      InvalidEmailAddress: 'Invalid email address',
      InvalidCandidateEmailAddress:
        "This doesn't seem to be a valid email address. Please edit this candidate's profile and fix the email address.",
      InvalidEmailUpdateProfile:
        "Invalid email address. Please fix this person's email address on their profile and try again.",
      InvalidCC: 'One or more invalid e-mail addresses',
      NewPasswordEmpty: 'Your must type a new password.',
      IncorrectPasswordConfirmation: "Passwords don't match.",
      OpeningsRequired: 'Number of openings is required.',
      JobNameRequired: 'Job name is a required field',
      OfficeRequired: 'Office is a required field',
      ReqIdRequired: 'Requisition ID is a required field',
      OpeningIdRequired: 'Opening ID is a required field',
      JobLevelRequired: 'Job Level is a required field',
      DepartmentRequired: 'Department is a required field',
      OrganizationRequired: 'Company/Organization is required',
      DescriptionRequired: 'Description is required',
      PhoneRequired: 'Phone is required',
      ResumeRequired: 'A resume is required',
      CoverLetterRequired: 'A cover letter is required',
      AttachmentRequired: 'An attachment is required',
      LocationRequired: 'Location is required',
      InvalidLocation: 'We could not find that location',
      DateInvalid: 'Enter a valid date of the format ',
    },
    General: {
      ConnectionError:
        "It looks like we're having trouble connecting to the server, please try again later.",
    },
  },
  CustomOptions: {
    Edit: {
      EnterFieldName: 'Enter a field name',
      SelectFieldType: 'Select a field type',
      SelectJobRangeField: 'Select a job range field',
      SelectCustomField: 'Select a custom field',
      ValidateToken: 'Token may only contain letters, numbers, and underscores',
      EnterOption: 'Enter an option',
      RejectionFieldConfiguration: 'At least 1 option must be selected',
      Required: 'This field is required',
    },
    DeleteSourceConfirm: 'Are you sure you want to delete this custom source?',
    DeleteTagConfirm: 'Are you sure you want to delete this custom tag?',
    DeleteReferrerConfirm:
      'Are you sure you want to delete this custom referrer?',
    DeleteRejectionReasonConfirm:
      'Are you sure you want to delete this custom rejection reason?',
    CandidateAttrUpdateSuccessful:
      'Your custom candidate attribute was updated successfully',
  },
  StackOverflow: {
    InvalidCompanyName: 'A company name is required',
    InvalidCompanyURL: 'A valid company URL is required',
    TechnologyMissing: 'You must specify at least 1 technology',
    MaxTechnologies: 'You can only specify 5 technologies',
    InvalidCity: 'A city is required',
    InvalidState: 'A state is required',
  },
  ZipRecruiter: {
    BlankCategory: 'You need to select a category to post this job to',
    BlankPostalCode: 'Postal Code is required',
  },
  Dice: {
    SkillsRequired: 'Skills are required',
    PayRateRequired: 'Pay rate is required',
    CityRequired: 'City is required',
    StateRequired: 'State is required',
    PostalCodeNumeric: 'Postal code must be numeric',
    AreaCodeNumeric: 'Area code must be numeric',
    TaxTermRequired: 'At least 1 tax term is required',
  },
  Organization: {
    NameRequired: 'Name is required',
    NameAlreadyInUse: 'This name is already in use',
    NewLocationRequired: 'You must choose where to move the existing jobs',
  },
  ApiCredential: {
    TypeRequired: 'A Type is required',
    CredentiableRequired: 'A Client Application is required',
  },
  Form: {
    InvalidFormat: 'Invalid file format selected. Please try again.',
    ResumeAttached:
      'The resume you chose has been attached. Please make any changes and submit.',
    ResumeParsedAndAttached: 'Resume successfully parsed',
  },
  WorkdaySyncServiceCalls: {
    IdXpathTokenRequired:
      'The @type must be provided for the Workday service call.',
  },
  Uploaders: uploaderMessages(uploaders),
  Virus: {
    FileScanningWarning:
      'This attachment is still being scanned, do you wish to still download?',
    VirusDetectedWarning:
      'We have detected a potentially malicious or dangerous attachment, do you still wish to download?',
    VirusErrorWarning:
      'The virus scan of this document failed. It could contain harmful content. Would you still like to download?',
    FileSkippedWarning:
      'Sorry, we are unable to scan this file for viruses. The file exceeds the maximum size that we scan. Download anyway?',
  },
  Error: {
    Generic: 'Sorry, but an error has occurred',
    TabContent:
      "Sorry, we ran into an error trying to load this information. Try refreshing the page, or <a href='https://support.greenhouse.io/direct'>contact our support team</a> for further support.",
    NoPermission: 'You do not have permission to perform that action',
  },
  ClipBoard: {
    CopyLink: 'Copy this link to your clipboard',
  },
  Otp: {
    BlankCode: 'Enter your code',
    InvalidCode: 'You entered an invalid or expired code. Please try again.',
    CodeSent: 'A new code was sent to your phone',
    Throttled: 'Please wait a few minutes before requesting another code.',
    GenericError: 'Something went wrong. Please try again.',
  },
  ScorecardLabels: {
    LabelLength: 'Candidate attribute rating label cannot exceed 30 characters',
    LabelPresent: 'Candidate attribute rating label must be present',
  },
  SupplementalInfo: {
    JobPostRequired: 'Job post required.',
    SubmissionLinkRequired: 'Submission link is required.',
  },
};

function uploaderMessages(uploaders) {
  var hash = {};
  for (var index in uploaders) {
    var name = uploaders[index];
    key = name.replace(/\s/g, ''); // remove empty space in the uploader name as hash key
    hash[key] = {
      LoadingAttachment: 'Loading attachment from ' + name + '...',
      WithoutBrowserSupport:
        'The browser does not support ' + name + ' upload.',
      TryAgain:
        'Unable to load ' +
        name +
        '. It has either timed out or you can try again later.',
    };
  }
  return hash;
};
var Routes = Routes || {};
Routes.Config = Routes.Config || {};
Routes.Person = Routes.Person || {};
Routes.Openings = Routes.Openings || {};
Routes.Approvals = Routes.Approvals || {};
Routes.Automation = Routes.Automation || { SourcingStrategies: {}, Stages: {} };

_.extend(Routes, {
  application_stage_tasks_path: Handlebars.compile(
    Routes.application_stage_tasks_path_template
  ),
  change_application_state_path: Handlebars.compile(
    Routes.change_application_state_path_template
  ),
  create_task_path: Handlebars.compile(Routes.create_task_path_template),
  destroy_task_path: Handlebars.compile(Routes.destroy_task_path_template),
  remove_department_modal_path: Handlebars.compile(
    Routes.remove_department_modal_path_template
  ),
  remove_office_modal_path: Handlebars.compile(
    Routes.remove_office_modal_path_template
  ),
  single_search_result_path: Handlebars.compile(
    Routes.single_search_result_path_template
  ),
  update_task_path: Handlebars.compile(Routes.update_task_path_template),
  update_task_status_path: Handlebars.compile(
    Routes.update_task_status_path_template
  ),
  hiring_plan_job_admins_path: Handlebars.compile(
    Routes.hiring_plan_job_admins_path_template
  ),
  update_hiring_plan_path: Handlebars.compile(
    Routes.update_hiring_plan_path_template
  ),
  people_gdpr_compliant_candidate_path: Handlebars.compile(
    Routes.people_gdpr_compliant_candidate_path
  ),
  hiring_plan_stages_json_path: Handlebars.compile(
    Routes.hiring_plan_stages_json_path_template
  ),
  office_hiring_plans_path: Handlebars.compile(
    Routes.office_hiring_plans_path_template
  ),
  job_status_report_path: Handlebars.compile(
    Routes.job_status_report_path_template
  ),
  job_approval_edit_path: Handlebars.compile(
    Routes.job_approval_edit_path_template
  ),
  credential_permissions_edit_path: Handlebars.compile(
    Routes.credential_edit_permissions_path_template
  ),
  categorized_api_endpoints_for_partner_path: Handlebars.compile(
    Routes.categorized_api_endpoints_for_partner_path_template
  ),
  credential_edit_path: Handlebars.compile(
    Routes.credential_edit_path_template
  ),
  credential_enable_path: Handlebars.compile(
    Routes.credential_enable_path_template
  ),
  credential_disable_path: Handlebars.compile(
    Routes.credential_disable_path_template
  ),
  credential_creation_path: Handlebars.compile(Routes.credential_creation_path),
  create_adobe_agreements_path: Handlebars.compile(
    Routes.create_adobe_agreements_path
  ),
  get_adobe_templates_path: Handlebars.compile(Routes.get_adobe_templates_path),
});

_.extend(Routes.Config, {
  custom_options_sources_configuration_path:
    Routes.Config.custom_options_sources_configuration_path,
});

_.extend(Routes.Person, {
  person_attachment_path: Handlebars.compile(
    Routes.Person.person_attachment_path_template
  ),
  attachment_preview_path: Handlebars.compile(
    Routes.Person.attachment_preview_path_template
  ),
});

_.extend(Routes.Openings, {
  openings_path: Handlebars.compile(Routes.Openings.openings_path_template),
  create_or_update_openings_path: Handlebars.compile(
    Routes.Openings.create_or_update_openings_path_template
  ),
  save_openings_details_path: Handlebars.compile(
    Routes.Openings.save_openings_details_path_template
  ),
  update_openings_path: Handlebars.compile(
    Routes.Openings.update_openings_path_template
  ),
  update_attributes_opening_path: Handlebars.compile(
    Routes.Openings.update_attributes_opening_path_template
  ),
});
_.extend(Routes.Approvals, {
  approvals_path: Handlebars.compile(Routes.Approvals.approvals_path_template),
  approvals_update_path: Handlebars.compile(
    Routes.Approvals.approvals_update_path_template
  ),
});
_.extend(Routes.CustomFields, {
  custom_field_path: Handlebars.compile(
    Routes.CustomFields.custom_field_path_template
  ),
  custom_field_options_path: Handlebars.compile(
    Routes.CustomFields.custom_field_options_path_template
  ),
  edit_custom_field_path: Handlebars.compile(
    Routes.CustomFields.edit_custom_field_path_template
  ),
  destroy_modal_path: Handlebars.compile(
    Routes.CustomFields.destroy_modal_path_template
  ),
});
_.extend(Routes.CustomFieldDependencies, {
  update_custom_field_dependency_path: Handlebars.compile(
    Routes.CustomFieldDependencies.update_dependency_path_template
  ),
  custom_field_dependency_parent_field_options_path: Handlebars.compile(
    Routes.CustomFieldDependencies
      .custom_field_dependency_parent_field_options_template
  ),
});

_.extend(Routes.Automation, {
  SourcingStrategies: {
    create_sourcing_strategy_rule_path:
      Routes.Automation.SourcingStrategies.create_sourcing_strategy_rule_path,
    update_sourcing_strategy_rule_path: Handlebars.compile(
      Routes.Automation.SourcingStrategies
        .update_sourcing_strategy_rule_path_template
    ),
    delete_sourcing_strategy_rule_path: Handlebars.compile(
      Routes.Automation.SourcingStrategies
        .destroy_sourcing_strategy_rule_path_template
    ),
  },
  Stages: {
    destroy_stage_rule_path: Handlebars.compile(
      Routes.Automation.Stages.destroy_stage_rule_path_template
    ),
    edit_stage_rule_path: Handlebars.compile(
      Routes.Automation.Stages.edit_stage_rule_path_template
    ),
  },
});

_.extend(Routes.Zendesk, {
  Sync: {
    user_path: Routes.Zendesk.Sync.user_path,
  },
});
/* global Greenhouse, ButtonUtil, Flash, Rollbar */

/**
 * Utility methods which encapsulate the standard behavior for AJAX requests. This includes:
 *
 *   1) prohibiting duplicate concurrent requests with a lock on the form/url being submitted
 *   2) showing a pending message
 *   2) handling errors with a flash message
 *   3) handling redirects on success if the response indicates to do so
 *
 * There are three flavors you can invoke, each which accepts a hash of options (a few of which are required):
 *
 * Ajax.get:     Call this method when you want to do a GET request.
 *
 *               Ajax.get({
 *                 url: '/path'
 *               });
 *
 * Ajax.post:    Call this method when you want to post to a url with arbitrary data you have in an object.
 *
 *               Ajax.post({
 *                 url: '/path'      // required
 *                 data: { x: 'y' }  // optional; an object to post
 *                 json: true        // optional; defaults to false, meaning the data object will be posted
 *                                   //           as standard form params. If true, the object will be posted
 *                                   //           as JSON instead. The main reason to do this is if you need
 *                                   //           nulls and empty arrays to be serialized.
 *               });
 *
 * Ajax.submit:  Call this method when you want a form on the page to be submitted as-is but via AJAX.
 *
 *               Ajax.submit({
 *                 formSelector: '#myform'  // required
 *               });
 *
 * For all 3 calls, you may also pass these optional parameters:
 *   buttonSelector          selector of the button which should be visually disabled during the request
 *   validator               a function that returns an array of validations (booleans)
 *   scrollAfterValidation   defaults to true
 *
 *   pendingMessage          defaults to 'Saving'; pass a different message or null to disable
 *   successMessage          defaults to no message, unless a message was returned by the server to show
 *   errorMessage            defaults to 'Sorry, we encountered an error. Please try again.', unless a
 *                           message was returned by the server to show
 *   disableFlash            defaults to false; if true, disables the default pending/error messages
 *   disableLock             defaults to false; if true, ignore our AJAX locks and just do it
 *
 *   dataType                the type of response you expect; defaults to json, or you may specify html
 *
 *   success                 callback on success
 *   error                   callback on error
 *   always                  callback which happens after success or error
 *   <foobar>                callback; if the AJAX response object has `status: foobar`, this will be called
 */
var Ajax = (function () {
  var locks = {};

  function get(options) {
    doMethod(options, 'GET');
  }

  function post(options) {
    doMethod(options, 'POST');
  }

  function del(options) {
    doMethod(options, 'DELETE');
  }

  function put(options) {
    doMethod(options, 'PUT');
  }

  function doMethod(options, method) {
    validateOption('url', options);
    options.lockId = options.url;

    execute(options, function () {
      var params = createAjaxParams(options);
      params.type = method;
      params.url = options.url;

      if (options.async === false) {
        params.async = false;
      }

      if (options.json === true) {
        params.contentType = 'application/json';
        params.data = JSON.stringify(options.data);
      } else {
        params.data = options.data;
      }

      $.ajax(params);
    });
  }

  /**
   * @param {Object} options see comments at top of file
   * @param {Object} ajaxParams params to pass to ajaxSubmit
   */
  function submit(options, ajaxParams) {
    validateOption('formSelector', options);
    options.lockId = options.formSelector;

    execute(options, function () {
      var params = createAjaxParams(options);
      params.url = options.url;
      _.extend(params, ajaxParams);
      $(options.formSelector).ajaxSubmit(params);
    });
  }

  function validateOption(name, options) {
    var option = options[name];
    if (typeof option === 'undefined') {
      throw "Missing option '" + name + "'";
    } else if (typeof option === 'string' && option.trim().length === 0) {
      throw "Option is an empty string '" + name + "'";
    }
  }

  function createAjaxParams(options) {
    return {
      dataType: options.dataType || 'json',
      success: function (response) {
        if (options.dataType === 'html' || response.status === 'success') {
          handleSuccess(options, response);
        } else if (response.status === 'error') {
          safeRollbarWarning(
            'Ajax helper received successful http status code but response body has status of error',
            {url: options.url}
          )
          handleError(options, response);
        } else {
          safeRollbarWarning(
            'Ajax helper received successful http status code but response body has status of ' + response.status,
            {url: options.url}
          )
          handleCustomStatus(options, response);
        }
        cleanup(options, response);
      },
      error: function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.status !== 'error' && options[xhr.responseJSON.status]) {
          handleCustomStatus(options, xhr.responseJSON)
        } else {
          handleError(options, xhr.responseJSON, xhr);
        }
        cleanup(options, xhr.responseJSON);
      },
    };
  }

  function execute(options, callback) {
    var lockId = options.lockId;

    if (options.disableLock === true || acquireLock(lockId)) {
      disableButton(options);

      var validator = options.validator;
      if (typeof validator === 'function') {
        if (!validator.call().isValid()) {
          if (options.scrollAfterValidation !== false) {
            Validate.scrollToFirstError();
          }
          cleanup(options);
          return;
        }
      }

      showPendingMessage(options);

      callback();
    }
  }

  function disableButton(options) {
    if (options.buttonSelector) {
      ButtonUtil.disable(options.buttonSelector);
    }
  }

  function enableButton(options) {
    if (options.buttonSelector) {
      ButtonUtil.enable(options.buttonSelector);
    }
  }

  function showPendingMessage(options) {
    if (typeof options.pendingMessage === 'string') {
      Flash.setPending(options.pendingMessage);
    } else if (
      options.pendingMessage !== null &&
      options.disableFlash !== true &&
      options.disablePending !== true
    ) {
      Flash.setPending(Greenhouse.Translation.t('flash.saving'));
    }
  }

  function handleSuccess(options, response) {
    if (typeof options.success === 'function') {
      options.success(response);
    }

    if (response.goto && options.redirect !== false) {
      window.location.href = response.goto;
    } else {
      if (options.successMessage) {
        Flash.setNotice(options.successMessage);
      } else if (response && response.message) {
        Flash.setNotice(response.message);
      } else {
        Flash.remove('.flash-pending');
      }
    }
  }

  function handleError(options, response, xhr) {
    if (typeof options.error === 'function') {
      options.error(response, xhr);
    }

    if (!options.disableFlash) {
      if (response && response.message) {
        Flash.setError(response.message);
      } else if (options.errorMessage) {
        Flash.setError(options.errorMessage);
      } else if (!options.hasOwnProperty('errorMessage')) {
        Flash.setError(Greenhouse.Translation.t('flash.error'));
      } else {
        Flash.remove();
      }
    }
  }

  function handleCustomStatus(options, response) {
    Flash.remove();

    var handler = options[response.status];
    if (typeof handler === 'function') {
      handler(response);
    } else {
      console.error('Missing handler for ' + response.status);
      safeRollbarWarning('Ajax helper missing custom status handler for ' + response.status, {url: options.url})
    }
  }

  function safeRollbarWarning(message, options) {
    if (typeof Rollbar !== 'undefined') {
      Rollbar.warning(message, options);
    }
  }

  function cleanup(options, response) {
    if (typeof options.always === 'function') {
      options.always(response);
    }

    enableButton(options);
    releaseLock(options.lockId);
  }

  function acquireLock(lockId) {
    if (locks[lockId]) {
      return false;
    }

    locks[lockId] = true;
    return true;
  }

  function releaseLock(lockId) {
    locks[lockId] = false;
  }

  return {
    get: get,
    post: post,
    del: del,
    put: put,
    submit: submit,
  };
})();
/**
 * Inline javascript tags open us up to XSS vulnerabilities.
 * To avoid that, we instead create html tags marked up with js data (generated by content_security_policy_helper.rb).
 * This script retrieves and parses the data and assigns it to variables,
 * preserving the original scope and values.
 *
 * =====================
 * Usage Types
 * =====================
 *
 * 1. There are several types that are handled:
 *    a. strings
 *    b. objects (also handles all levels of nesting)
 *    c. handlebars
 *
 * 2. To see how to generate html markup that is utilized for this script
 *    see comments in content_security_policy_helper.rb
 *
 * side note: This file is not using any jQuery in order to be able to extract
 * inline javascripts (i.e. rollbar) to a separate file which is loaded before
 * jQuery is available.
 */

var Greenhouse = Greenhouse || {};

Greenhouse.ContentSecurityPolicyHelper = function (selector) {
  var key = selector.getAttribute('data-key'),
    value = selector.getAttribute('data-value'),
    type = selector.getAttribute('data-type'),
    handlebars = selector.getAttribute('data-handlebars');

  this.setObject = function () {
    // Objects are built by iterating through a string that is split by '.'
    // (ex: "Config.EmailTypes.nameTokenMap")
    // This also works for strings that aren't separated by dots (i.e. "current_user_id")
    var keys = key.split('.'),
      lastKey = keys.pop(),
      parentObject = buildObject(keys);

    setValue(lastKey, parentObject);
  };

  function buildObject(keys) {
    var parentObject = window,
      key;

    for (var i = 0; i < keys.length; i++) {
      key = keys[i];

      parentObject[key] = parentObject[key] || {};
      parentObject = parentObject[key];
    }

    return parentObject;
  }

  function setValue(key, object) {
    object = object || window;

    if (handlebars) {
      value = Handlebars.compile(value);
      object[key] = value;
    } else {
      switch (type) {
        case 'json':
          object[key] = JSON.parse(value);
          break;
        case 'string':
          if (value === 'null') {
            object[key] = null;
          } else {
            object[key] = value.toString();
          }
          break;
        case 'boolean':
          object[key] = JSON.parse(value);
          break;
        case 'number':
          object[key] = parseFloat(value);
          break;
        case 'null':
          object[key] = null;
          break;
        default:
          object[key] = value;
      }
    }
  }
};

// Only iterating through selectors without a class of processed because
// of cases where loading multiple partials in templates where the data has already been processed.
Greenhouse.findAndConvertMetadata = function () {
  // Fix for IE8 browsers that don't support querySelectorAll. If querySelectorAll is
  // not supported we use jQuery instead. We don't use jQuery for all cases in the first
  // place because this script is needed at certain points before jQuery is even loaded
  // in the app. One such case is for rollbar.
  if (typeof document.querySelectorAll === 'function') {
    var jsContainer = document.querySelectorAll('.js-metadata:not(.processed)');

    forEachElement(jsContainer, function (el, i) {
      var contentSecurityPolicyHelper = new Greenhouse.ContentSecurityPolicyHelper(
        el
      );

      contentSecurityPolicyHelper.setObject();

      addClass(el, 'processed');
    });
  } else if (typeof jQuery === 'function') {
    var $jsContainer = $('.js-metadata:not(.processed)');

    $jsContainer.each(function (i, el) {
      var contentSecurityPolicyHelper = new Greenhouse.ContentSecurityPolicyHelper(
        el
      );
      contentSecurityPolicyHelper.setObject();
      $(el).addClass('processed');
    });
  }

  function forEachElement(elements, fn) {
    for (var i = 0; i < elements.length; i++) {
      fn(elements[i], i);
    }
  }

  function addClass(el, className) {
    if (el.classList) {
      el.classList.add(className);
    } else {
      el.className += ' ' + className;
    }
  }
};

Greenhouse.findAndConvertMetadata();


/**
 * A control for loading a modal's content via ajax, with loading and error states.
 *
 * =====================
 * Basic Usage
 * =====================
 *
 * 1. Create a button or link that will trigger loading the modal.
 *    It must have a "modal_path" attribute containing a path to load
 *    into the modal when clicked.
 *
 *    <%= link_to 'Click to load modal', '#', :modal_path => example_modal_content_path, :id => 'my_link' %>
 *
 * 2. On document ready, initialize the modal:
 *
 *    var modal = new AjaxModal('my_modal', {
 *      title: 'My Modal',
 *      openWith: '#my_link',
 *    });
 *
 *    The modal has the following API:
 *
 *    modal.close();
 *
 *    modal.registerEvents();
 *      Re-registers events on all buttons which should open the modal. You'll need to call
 *      this if the modal has already been initialized and you've later added new buttons to
 *      the page dynamically.
 *
 *    modal.getTitle();
 *    modal.setTitle(value);
 *
 * =====================
 * Configuration
 * =====================
 *
 * The following options are also accepted, but not required:
 *
 *      config: { width: 300 }
 *        Custom modal configuration overrides.
 *
 *      openWithFilter: undefined
 *        A child selector to filter open events by. Useful when wanting to
 *        bind the event listener higher than the dom element that the event
 *        fires from.
 *
 *      onContentLoad: function(contentWrapper, ajaxModal) { }
 *        A function which is invoked after the modal content is loaded. It receives two
 *        arguments: first is a JQ object of the wrapper surrounding the newly
 *        placed html content, the second is the AjaxModal itself. The value of 'this' is
 *        the button which opened the modal.
 *
 *      validateWith: function() { }
 *        A function to perform validation with on the modal's form when submitted. The
 *        value of 'this' is the form.
 *
 *      onSubmit: function() { }
 *        A function to invoke when the modal's form is submitted and passes validation.
 *        The value of 'this' is the form.
 *
 *      preload: true
 *        *** WARNING: This feature broke with the Jquery upgrade, yet to be debugged/fixed ***
 *        Preloads the modal; defaults to false. If there is more than one button
 *        specified, only the first will be preloaded.
 *
 *      refreshEachOpen: true
 *        Forces a refresh of the modal content each time it is opened, even if the same
 *        button is used (normally the response is cached for the second time).
 *
 *      centerOnLoad: true
 *        Centers the modal after loading the ajax content; defaults to false. Useful
 *        for larger modals which would otherwise end up too low on the page.
 *
 *      openEvent: 'change'
 *        Defaults to click. This is the event that gets bound to 'openWith' to open
 *        the modal.
 *
 *      classes: []
 *        An array of extra classes to add to the modal's container element.
 *
 * =====================
 * Features
 * =====================
 *
 * Auto-focus/select
 *
 *   Add class 'autofocus' to the text field in your modal which should be focused.
 *   You can also add class 'autoselect' if the text itself should be selected.
 *
 * Scrolling
 *
 *   The modal height will be automatically adjusted to account for the window height,
 *   so long as there is a div with class 'scrollable' in the modal content.
 *
 * Chosen
 *
 *   Chosen fields are initialized using Config.Chosen.Default. If a select also has
 *   class 'chzn-allow-deselect', it will use Config.Chosen.AllowDeselect instead.
 *
 * Select2
 *
 *   Non-select inputs marked with class 'select2' and with an attribute 'json' or 'data-url' will be
 *   initialized using the value of the attribute.
 */

var AjaxModal = (function () {
  var template =
    '<div id="{{id}}" class="modal">' +
    '<div class="modal-body">' +
    '<div class="spinner-container"></div>' +
    '<div class="loading-error">' +
    'Sorry, we encountered an error. Please <a href="https://support.greenhouse.io/direct">contact our support team</a> if the problem persists.' +
    '</div>' +
    '<div class="modal-content-wrapper"></div>' +
    '</div>' +
    '</div>';

  function AjaxModal(id, options) {
    this.id = id;
    this.modal = $('#' + id);
    this.options = options || {};
    this.options.openEvent = this.options.openEvent || 'click';
    this.options.useRedesign = this.options.useRedesign || false;
    this.options.classes = this.options.classes || [];
    this.options.config = options.config || {};
    this.options.bufferSpace = this.options.bufferSpace || 0;

    if (this.options.useRedesign) {
      this.options.config.width = 980;
    }

    if (this.modal.length === 0) {
      this.modal = $(
        Handlebars.compile(template)({
          id: id,
          title: this.options.title,
          subtitle: this.options.subtitle,
        })
      );

      if (this.options.classes) {
        this.modal.addClass(this.options.classes.join(' '));
      }

      $(document.body).append(this.modal);
    }

    this.contentWrapper = this.modal.find('.modal-content-wrapper');
    this.spinner = this.modal.find('.spinner-container');
    this.loadingError = this.modal.find('.loading-error');
    this.currentUrl = null;

    this.registerEvents();

    if (this.options.preload) {
      var button = $(this.options.openWith)[0];
      this.loadContent(button);
    }
  }

  AjaxModal.prototype.registerEvents = function () {
    this.modal
      .find('.x')
      .unbind('click')
      .click($.proxy(this.close, this))
      .on('click', contentSecurityPolicy.hrefPreventDefault);

    var $openWith = $(this.options.openWith);

    if ($openWith.length > 0) {
      // use a namespaced event to prevent unbinding the same event from another control
      var event = this.options.openEvent + '.' + this.id;
      $openWith
        .unbind(event)
        .on(event, this.options.openWithFilter, openHandler);
    }

    if ($openWith.attr('href') === '#') {
      $openWith.on('click', contentSecurityPolicy.hrefPreventDefault);
    }

    var options = this.options,
      that = this;

    if (typeof options.onClose === 'function') {
      this.modal.on('dialogclose', options.onClose);
    }

    this.modal.on('greenhouse.heightChanged', function () {
      that.adjustHeight();
    });

    $(window).on(
      'resize',
      function () {
        this.adjustHeight();
      }.bind(this)
    );

    function openHandler() {
      if (!$(this).hasClass('disabled-button')) {
        that.open(this);
      }
      return false;
    }
  };

  AjaxModal.prototype.open = function (button) {
    this.modal.dialog(Config.Modal.custom(this.options.config));
    this.header = this.modal.siblings('.ui-dialog-titlebar');

    // The widget markup is only created once and shared by all modals.
    // Any changes should be reverted.
    //  Add subtitle element
    this.header.find('.subheader').remove();
    this.header.find('.ui-dialog-title').before('<span class="subheader">');

    // Add redesign class to outermost wrapper
    if (this.options.useRedesign) {
      this.modal.parents('.ui-dialog').addClass('modal-redesign');

      if (!this.options.subtitle) {
        this.modal.parents('.ui-dialog').find('a.x').css('padding', '20px');
      }
    }

    // Add x class to preserve any events bound to it
    $('.ui-dialog-titlebar-close').addClass('x').attr('href', '#');
    this.header
      .find('.x')
      .unbind('click')
      .click($.proxy(this.close, this))
      .on('click', contentSecurityPolicy.hrefPreventDefault);

    this.modal.find('.x').blur();

    this.adjustHeight();

    this.loadContent(button);
  };

  AjaxModal.prototype.close = function () {
    // Remove redesign class from shared modal wrapper
    this.modal.parents('.ui-dialog').removeClass('modal-redesign');

    // var options = this.options,
    //   contentWrapper = this.contentWrapper,
    //   that = this;
    //
    // if (typeof options.onClose === 'function') {
    //   options.onClose = [options.onClose];
    // }
    //
    // if ($.isArray(options.onClose)) {
    //   _.each(options.onClose, function (func) {
    //     func.call(that.openedBy, contentWrapper, that);
    //   });
    // }

    if (this.options.refreshEachOpen && this.options.destroyOnClose) {
      this.modal.dialog('close').remove();
    } else if (this.modal.hasClass('ui-dialog-content')) {
      this.modal.dialog('close');
    }
  };

  /**
   * Adjusts the height of the modal to account for the window height by enabling
   * scrolling on whichever div has class 'scrollable'.
   */
  AjaxModal.prototype.adjustHeight = function () {
    var scrollableContent = this.modal.find('.scrollable');

    if (scrollableContent.length === 1) {
      this.modal.css('maxHeight', 'none');
      scrollableContent.css('height', 'auto');
      var borderThickness = 1;
      var height = this.modal.height() + borderThickness,
        // headerHeight actually varies, but 50 is the max to be safe
        headerHeight = 50,
        maxHeight =
          $(window).height() - 60 - headerHeight - this.options.bufferSpace;

      if (height > maxHeight) {
        this.modal.css('maxHeight', maxHeight);
        scrollableContent.css({
          height: maxHeight - (height - scrollableContent.height()),
          overflow: 'auto',
        });
      }
    }

    if (this.options.centerOnLoad) {
      this.center();
    }
  };

  AjaxModal.prototype.loadContent = function (button) {
    var $button = $(button);
    var modalPath =
      $button.attr('modal_path') ||
      $button.data('modal_path') ||
      $button.data('modal-path') ||
      this.options.path;
    var newUrl = modalPath || $button.val(),
      title =
        $button.attr('modal_title') ||
        $button.data('modal-title') ||
        this.options.title,
      subtitle = $button.attr('modal_subtitle'),
      spinner = this.spinner,
      loadingError = this.loadingError,
      contentWrapper = this.contentWrapper,
      modal = this.modal,
      options = this.options,
      that = this,
      data;

    if (typeof this.options.data === 'function') {
      data = this.options.data();
    } else {
      data = this.options.data || {};
    }

    if (
      Validate.notBlank(newUrl) &&
      (options.refreshEachOpen || newUrl !== this.currentUrl)
    ) {
      this.currentUrl = newUrl;
      this.openedBy = button;

      if (title) {
        this.setTitle(title);
      }

      if (subtitle) {
        this.setSubtitle(subtitle);
      }

      contentWrapper.hide();
      loadingError.hide();
      spinner.show();

      Ajax.get({
        url: this.currentUrl,
        data: data,
        dataType: 'html',
        pendingMessage: null,
        disableFlash: true,
        success: afterLoad,
        error: onLoadError,
      });
    }

    function afterLoad(response) {
      // Necessary because TinyMCE would not load properly for FF after previously closing rejection modal
      if (typeof tinyMCE === 'object') {
        tinyMCE.triggerSave();
      }

      spinner.hide();
      contentWrapper.html(response);
      Greenhouse.findAndConvertMetadata();
      contentWrapper
        .find('.chzn-select:not(.chzn-allow-deselect)')
        .chosen(Config.Chosen.Default);
      contentWrapper
        .find('.chzn-select.chzn-allow-deselect')
        .chosen(Config.Chosen.AllowDeselect);
      contentWrapper.find('.cancel').click($.proxy(that.close, that));
      contentWrapper
        .find('.select2[json]:not(select)')
        .each(function (i, input) {
          var json = $(input).attr('json');
          $(input).select2({ tags: $.parseJSON(json) });
        });
      contentWrapper
        .find('.select2[data-url]:not(select)')
        .each(function (i, input) {
          new Ajax.SelectBox({
            selectBox: $(input),
          });
        });

      if (
        typeof options.validateWith === 'function' &&
        typeof options.onSubmit === 'function'
      ) {
        modal
          .find('form')
          .validateOn('submit', options.validateWith, options.onSubmit);
      } else if (typeof options.onSubmit === 'function') {
        modal.find('form').on('submit', options.onSubmit);
      }

      if (typeof options.onContentLoad === 'function') {
        options.onContentLoad = [options.onContentLoad];
      }

      if ($.isArray(options.onContentLoad)) {
        _.each(options.onContentLoad, function (func) {
          func.call(that.openedBy, contentWrapper, that);
        });
      }

      window.setTimeout(autofocus, 0);

      contentWrapper.show();

      contentWrapper
        .find('link[rel="stylesheet"]')
        .on('load', that.adjustHeight.bind(that));
      that.adjustHeight();

      function autofocus() {
        modal.find('.autofocus').first().focus();
        modal.find('.autoselect').first().select();
      }
    }

    function onLoadError(response) {
      if (typeof response === 'undefined') {
        loadingError.text(that.options.errorMessage);
      } else if (response.status === 404) {
        loadingError.text(response.responseText);
      }

      spinner.hide();
      loadingError.show();

      that.currentUrl = null;
      that.openedBy = null;
    }
  };

  AjaxModal.prototype.setTitle = function (title) {
    this.modal.dialog('option', 'title', title);
  };

  AjaxModal.prototype.getTitle = function () {
    return this.modal.dialog('option', 'title');
  };

  AjaxModal.prototype.setSubtitle = function (subtitle) {
    this.header.find('.subheader').text(subtitle);
  };

  AjaxModal.prototype.getSubtitle = function () {
    return this.header.find('.subheader').text();
  };

  AjaxModal.prototype.center = function () {
    if (this.modal.hasClass('ui-dialog-content')) {
      this.modal.dialog('option', 'position', {
        my: 'center',
        at: 'center',
        of: window,
      });
    }
  };

  return AjaxModal;
})();
/**
 * SelectBox - Use ajax to load the contents of a select2 widget.
 *
 * Arguments:
 * - selectBox (jQuery element)        - jQuery element to which to attach the select2 widget.
 * - url (String, optional)            - JSON Data source endpoint. Can instead be specified as a data attribute
 *                                       It should return a payload
 *                                       like: {
 *                                         "results": [
 *                                           { id: ID1, text: TEXT1 },
 *                                           { id: ID2, text: TEXT2 },
 *                                           ....
 *                                         ],
 *                                         "more": true/false
 *                                       }
 * - callback (function, optional)     - When an item is selected, run the callback. It will
 *                                       receive an event object as its first argument.
 * - defaultOption (hash, optional)    - When the select2 widget is initialized, load it with
 *                                       this item. It can also accept options from data attribute
 *                                       default-option
 *                                       e.g.
 *                                           <input
                                               type="hidden"
                                               id="user_id"
                                               name="user_id"
                                               data-default-option="{ 'id' : 1, 'text' : 'Foo' }"
                                               data-ajax-url="/reports/recruiting_update/users" />

 * - debounceDelay (integer, optional) - (In Millis). How long to wait before issuing request
 *                                       for results.
 * - config                            - Any additional configuration to pass to select2()
 * - multiple (boolean, optional)      - Multiple options can be selected. Default to false.
 *                                        Can also be specified as a data attribute
 * - allowFreeText (boolean, optional) - User can enter a free text value. Default to false.
 *                                        Can also be specified as a data attribute
 * - pagination (boolean, optional)    - Set this to false if the server endpoint does not support pagination.
 *                                        This will assume everything is loaded on the first ajax call.
 *                                        After that, the search term will only check what's already loaded and
 *                                        not make another ajax request. Defaults to true.
 *
 * You can instantiate this class like:
 *
 *   new Ajax.SelectBox({
 *     url: '/path/to/results',
 *     selectBox: $('#find_me'),
 *     callback: function(e) { doSomethingCoolWithThis(); },
 *     defaultOption: { id: 'myId', text: 'Hello, Ajaxy World!' },
 *     config: { width: '100%' }
 *     multiple: true,
 *     allowFreeText: true
 *   });
 *
 * for an HTML element defined like:
 *
 *   <input type="hidden" id="find_me" data-url="/some/data/source/endpoint" data-multiple="true" />
 *
 */
Ajax.SelectBox = function (opts) {
  var callback = opts.callback,
    ajaxError = opts.error,
    debounceDelay = opts.debounceDelay || 500,
    $selectBox = opts.selectBox,
    url = opts.url || opts.selectBox.data('url'),
    config = opts.config || opts.selectBox.data('config') || {},
    multiple = opts.multiple || opts.selectBox.data('multiple'),
    allowFreeText =
      opts.allowFreeText || opts.selectBox.data('allow-free-text'),
    searchText = opts.searchText || opts.selectBox.data('search-text') || Greenhouse.Translation.t('select.searchText'),
    noResultsText = opts.noResultsText || opts.selectBox.data('no-results-text') || Greenhouse.Translation.t('select.noResultsText'),
    pagination = opts.pagination !== false,
    cacheDataSource = {},
    timeout;

  function queryAndCache(params) {
    var page = params.page,
      term = params.term,
      key = pagination ? [term, page] : 'results',
      data = pagination ? { term: term, page: page } : null;

    $.ajax({
      url: url,
      data: data,
      success: function (response) {
        cacheDataSource[key] = response;
        params.callback(response);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        ajaxError(xhr, ajaxOptions, thrownError);
      },
    });
  }

  function query(params) {
    var key = pagination ? [params.term, params.page] : 'results',
      cachedData = cacheDataSource[key];

    if (cachedData) {
      if (!pagination) {
        // So updating the children by searching doesn't change the cached data
        var clonedResult = JSON.parse(JSON.stringify(cachedData.results));

        cachedData = Object.assign(
          {},
          { results: filterLocal(clonedResult, params.term.toLowerCase()) }
        );
      }

      params.callback(cachedData);
    } else {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        queryAndCache(params);
      }, debounceDelay);
    }
  }

  function setupSelectBox() {
    $selectBox.select2(
      Object.assign(
        {
          query: query,
          multiple: multiple,
          createSearchChoice: createSearchChoice,
          formatSearching: searchText,
          formatNoMatches: noResultsText,
        },
        config
      )
    );
  }

  function createSearchChoice(term, data) {
    if (allowFreeText) {
      var termNotFound =
        $(data).filter(function () {
          return this.text.localeCompare(term) === 0;
        }).length === 0;

      if (termNotFound) {
        return { id: term, text: term };
      }
    }
  }

  function filterLocal(data, term) {
    return data.filter(function (object) {
      var matchedText = object.text.toLowerCase().indexOf(term) >= 0;

      if (object.children) {
        object.children = filterLocal(object.children, term);
      }

      return matchedText || (object.children && object.children.length > 0);
    });
  }

  function addEventHandler() {
    if (typeof callback === 'function') {
      $selectBox.on('change', callback);
    }
  }

  function addDefaultData() {
    $selectBox.each(function () {
      $(this).select2(
        'data',
        opts.defaultOption || $(this).data('default-option')
      );
    });
  }

  function setup() {
    setupSelectBox();
    addEventHandler();
    addDefaultData();
  }

  setup();
};
var Effects = {
  Slide: {
    remove: function (element, complete) {
      element.animate({ opacity: '0' }, 100);
      element.slideUp(200, function () {
        $(this).remove();
        if (complete) {
          complete();
        }
      });
    },

    append: function (element, container, complete) {
      element.hide().css('opacity', '0');
      $(container).append(element);
      element.slideDown(200);
      element.animate({ opacity: '100' }, 100, complete);
    },

    addBefore: function (element, elementToAddBefore, complete) {
      element.hide().css('opacity', '0');
      elementToAddBefore.before(element);
      element.slideDown(200);
      element.animate({ opacity: '100' }, 100, complete);
    },

    addAfter: function (element, elementToAddAfter, complete) {
      element.hide().css('opacity', '0');
      elementToAddAfter.after(element);
      element.slideDown(200);
      element.animate({ opacity: '100' }, 100, complete);
    },
  },

  flash: function (element) {
    var oldBackgroundColor = $(element).css('background-color');
    $(element)
      .animate({ backgroundColor: '#e2f1fa' }, 1500, 'easeOutBack')
      .animate({ backgroundColor: oldBackgroundColor }, 1500, function () {
        $(this).css({ backgroundColor: '' });
      });
  },
};
/* global documentReady */

documentReady(function () {
  var $announcementDiv = $('div#announcement'),
    path = $announcementDiv.data('path'),
    announcementUpdatedAt = $announcementDiv.data('updatedAt');

  $announcementDiv.find('span.hide a').on('click', function () {
    Ajax.post({
      url: path,
      data: { announcement_updated_at: announcementUpdatedAt },
      disableFlash: true,
    });
    $announcementDiv.slideUp();
  });
});
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (searchElement, fromIndex) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return (
          x === y ||
          (typeof x === 'number' &&
            typeof y === 'number' &&
            isNaN(x) &&
            isNaN(y))
        );
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    },
  });
};
/**
 * Functions is a case-insensitive version of the jQuery "contains" selector.  Usage is the same
 * as the contains selector
 * <code>
 *   li:containsInsensitive('abcd')
 * </code>
 * will return true for ABCD or AbCd.
 *
 * Reference: https://css-tricks.com/snippets/jquery/make-jquery-contains-case-insensitive/
 * @param a
 * @param i
 * @param m
 * @returns {boolean}
 */

jQuery.expr[':'].containsInsensitive = function (a, i, m) {
  return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};
/* global $, AsyncOrganizationalStructureControl, Ajax, Greenhouse, _*/

var AsyncOrganizationalStructureControl = (function () {
  var AsyncOrganizationalStructureControl = function (id, options) {
    this.id = id;
    this.$select = $(id);
    this.type = this.kind();
    this.orgStructureOptions = options || {};
    this.options = this.mapToAjaxOptions();
    new Ajax.SelectBox(this.options);
  };

  AsyncOrganizationalStructureControl.prototype.prop = function (
    prop,
    defaultValue
  ) {
    return this.orgStructureOptions.hasOwnProperty(prop)
      ? this.orgStructureOptions[prop]
      : defaultValue;
  };

  AsyncOrganizationalStructureControl.prototype.kind = function () {
    return this.$select.data('type');
  };

  AsyncOrganizationalStructureControl.prototype.mapToAjaxOptions = function () {
    var orgStructureOptions = {
      selectBox: this.$select,
      pagination: true,
      url: this.url(),
      callback: this.orgStructureOptions.onChangeCallback,
      defaultOption: this.prop('defaultOption', undefined),
      config: {
        width: this.prop('width', '300px'),
        placeholder: this.placeholder(),
        initSelection: this.prop('initSelection', this.initSelection),
        allowClear: this.prop('allowClear', true),
        containerCss: this.prop('containerCss', undefined),
        formatSearching: this.searchText(),
      },
    };

    return orgStructureOptions;
  };

  AsyncOrganizationalStructureControl.prototype.selectedText = function () {
    var data = this.$select.select2('data');

    if (!data) {
      return 'None';
    } else if (Array.isArray(data)) {
      return _.map(data, function (obj) {
        return obj.text;
      });
    } else if (data.hasOwnProperty('text')) {
      return data.text;
    } else {
      return '';
    }
  };

  AsyncOrganizationalStructureControl.prototype.placeholder = function () {
    if (this.orgStructureOptions.placeHolder) {
      return this.orgStructureOptions.placeHolder;
    } else {
      return this.allowClear() ? 'No ' + this.type : 'Select one';
    }
  };

  AsyncOrganizationalStructureControl.prototype.searchText = function () {
    return this.$select.attr('searchText') || Greenhouse.Translation.t('select.searchText');
  }

  AsyncOrganizationalStructureControl.prototype.allowClear = function () {
    return this.prop('allowClear', true);
  };

  AsyncOrganizationalStructureControl.prototype.url = function () {
    var path = this.$select.data('url');
    return (
      path +
      '?' +
      [this.hiringPlanIdParam(), this.includeSelf(), this.disableIds()].join(
        '&'
      )
    );
  };

  AsyncOrganizationalStructureControl.prototype.hiringPlanIdParam = function () {
    var id = this.$select.data('hiringPlanId'),
      isNew = this.$select.data('new');

    if (id) {
      return 'hp_id=' + id;
    } else if (isNew) {
      return 'new=true';
    } else {
      return '';
    }
  };

  AsyncOrganizationalStructureControl.prototype.disableIds = function () {
    var ids = this.$select.data('disableIds');

    if (ids) {
      return ids
        .map(function (id) {
          return 'disabled_ids[]=' + id;
        })
        .join('&');
    } else {
      return '';
    }
  };

  AsyncOrganizationalStructureControl.prototype.includeSelf = function () {
    var includeSelf = this.$select.data('includeSelf');

    // default to true
    if (includeSelf || includeSelf === undefined) {
      return 'include_self=true';
    } else {
      return '';
    }
  };

  AsyncOrganizationalStructureControl.prototype.initSelection = function (
    el,
    callback
  ) {
    var $element = $(el);

    var value = $element.attr('value');
    var valueText = $element.attr('value_text') || $element.data('value-text');

    var defaultValues = $element.attr('default_values');

    if (value && valueText) {
      callback({ id: value, text: valueText });
    } else if (defaultValues) {
      callback(JSON.parse(defaultValues));
    }
  };

  AsyncOrganizationalStructureControl.linkToAllCheckbox = function (
    checkboxSelector,
    orgStructureControl
  ) {
    var $checkbox = $(checkboxSelector);
    var $multiSelectInput = orgStructureControl.$select;

    // When checkbox for all offices or all departments is checked,
    // disable multi select input field.
    $checkbox.on('change', function () {
      if ($checkbox.is(':checked')) {
        $multiSelectInput.val([]);
        $multiSelectInput.select2('enable', false);
        $multiSelectInput.trigger('change');
      } else {
        $multiSelectInput.select2('enable', true);
      }
    });

    // When a multi select option is selected,
    // uncheck the all offices or all departments $checkbox.
    $multiSelectInput.on('change', function () {
      if ($checkbox.is(':checked') && $multiSelectInput.val().length > 0) {
        $checkbox.prop('checked', false);
      }
    });
  };

  AsyncOrganizationalStructureControl.prototype.selectedIdsAndChildrenIdsArray = function () {
    return _.uniq(
      _.flatten(
        this.$select.select2('data').map(function (e) {
          return [e.id, e.id_path];
        })
      )
    );
  };
  return AsyncOrganizationalStructureControl;
})();
(function (window) {
  window.DropboxChooser = function (args) {
    var options, $trigger;

    function init(args) {
      options = args || {};
      $trigger = options.$trigger;
      options.uploadComplete = options.uploadComplete || function () {};

      $trigger.on('click', call);
    }

    function uploadSuccess(files) {
      var file = files[0];
      options.$messages.hide();
      options.uploadComplete({
        filename: file.name,
        url: file.link,
      });
    }

    function call() {
      if (!window.Dropbox) {
        options.$messages.text(Message.Uploaders.Dropbox.TryAgain).show();
        return;
      }

      if (!Dropbox.isBrowserSupported()) {
        options.$messages
          .text(Message.Uploaders.Dropbox.WithoutBrowserSupport)
          .show();
        $trigger.remove();
        return;
      }

      Dropbox.choose({
        success: uploadSuccess,
        cancel: options.uploadCancelled,
        linkType: 'direct',
        extensions: ['documents', 'text'],
      });
      options.uploadStarted();
      options.$messages
        .text(Message.Uploaders.Dropbox.LoadingAttachment)
        .show();
      options.$messages.show();
    }

    init(args);
  };
})(window);
/**
 *  Creates an editable field control
 *
 *  opts: {
 *    defaultText: 'something',
 *    collapseWithQuotes: true,
 *    allowBlank: false,        // true is the default value
 *    blankMessage: 'whatever', // required if allowBlank is false
 *    validateWith: myfunc,     // a custom validation function that returns a Validator or array of validators. *This will override allowBlank if both are specified*
 *    displayValue: myfunc,     // an optional function to determine the collapsed text after saving. Useful when
 *                              // your editable field is more complex than a simple text input.
 *    initializeFieldValue: true // defaults to true; specify false if the input field value should NOT be initialized
 *                                  from the collapsed text. In this case you need to set it yourself in ERB.
 *    initializeDisplayValue: true // defaults to false; specify true if the display label should be initialized
 *                                    immediately using the provided displayValue function
 *    autoCollapse: false          // defaults to true; set to false if you want to collapse the field yourself by
 *                                    triggering the greenhouse.collapse event
 *    noPencilIcon: false          // defaults to false; set to true if you want to remove the pencil icon for editing the field,
 *                                    and instead you can enter into edit mode by clicking the text field.
 *  };
 *
 */
var editableFieldControl = function (selector, opts) {
  opts = opts || {};

  opts = $.extend(
    {
      autoCollapse: true,
    },
    opts
  );

  var inEditMode = false;

  var container = $(selector);
  var editableField = container.find('.editable-field');
  if (opts.noPencilIcon === true) {
    var editButton = container.find('.collapsed-field-text');
  } else {
    var editButton = container.find('.inline-edit-icon');
    editButton.attr('data-loaded', true);
  }
  var saveButton = container.find('.save-field');
  var collapsedField = container.find('.collapsed-field');
  var collapsedText = container.find('.collapsed-field-text');

  // select2 adds a class in mutliple places.
  // We always want a field that is a form element and not a div.
  var field = container.find('.field:not(div)');

  container.on('greenhouse.collapse', collapse);

  editButton.on('click', enterEditMode);

  saveButton.unbind('click').on('click', function () {
    if (validate(opts)) {
      afterSave();
    }
  });

  if (opts.initializeDisplayValue && opts.displayValue) {
    collapsedText.text(opts.displayValue());
  }

  function afterSave() {
    var fieldText;

    if (opts.autoCollapse) {
      fieldText = collapse();
    }

    triggerUpdate(fieldText);
  }

  function collapse() {
    var field = update();

    enterReadOnlyMode();

    return field;
  }

  function enterEditMode(e) {
    inEditMode = true;

    var existingField = $.trim(collapsedText.text());

    field.data('oldval', field.val());
    // Quotation marks indicate non-default text, so we check to make sure
    // they are editing user-generated content and not the default text
    if (
      existingField !== null &&
      existingField !== opts.defaultText &&
      opts.initializeFieldValue !== false
    ) {
      field.val(existingField.replace(/\"/g, ''));
    }

    if (opts.datepicker) {
      UI.Datepicker.init(field);

      if (opts.minDate) {
        field.datepicker('option', 'minDate', opts.minDate);
      }

      if (opts.maxDate) {
        field.datepicker('option', 'maxDate', opts.maxDate);
      }
    }

    collapsedField.hide();
    editableField.show();

    if (!field.is(':file')) {
      field.trigger('focus');
    }

    if (!field.is('textarea')) {
      field.select();

      field.unbind('keydown').on('keydown', function (e) {
        if (e.which === ENTER_KEY_CODE && validate(opts)) {
          afterSave();

          // prevent form submit if the field is within a form
          return false;
        }
      });
    }

    e.stopPropagation();
  }

  function enterReadOnlyMode() {
    editableField.hide();
    collapsedField.show();
    inEditMode = false;
  }

  function update() {
    var fieldText = '',
      display;

    if (typeof opts.displayValue === 'function') {
      if (opts.isHtml) {
        fieldText = $('<div/>').html(opts.displayValue()).text();
        collapsedText.html(opts.displayValue());
      } else {
        fieldText = opts.displayValue();
        collapsedText.text(opts.displayValue());
      }
    } else {
      trimFields();

      if (fieldsEmpty()) {
        clear();
      } else {
        if (typeof tinyMCE !== 'undefined') {
          tinyMCE.triggerSave();
        }

        display = fieldText =
          opts && opts.collapseWithQuotes
            ? '"' + field.val() + '"'
            : field.val();

        if (field.is('select')) {
          var options = field.find('option:selected'),
            names = $.map(options, function (option, i) {
              return $(option).text();
            });
          display = names.join(', ');
        }
        collapsedText.text(display);
      }
    }

    if (typeof tinyMCE !== 'undefined') {
      tinyMCE.triggerSave();
    }

    return fieldText;
  }

  function triggerUpdate(fieldText) {
    container.trigger('editableFieldUpdated', [fieldText]);
  }

  function trimFields() {
    field.each(function () {
      if ($.trim($(this).val()).length === 0) {
        $(this).val('');
      }
    });
  }

  function fieldsEmpty() {
    var empty = true;

    field.each(function () {
      if ($(this).val().length > 0) {
        empty = false;
      }
    });

    return empty;
  }

  function clear() {
    // Default text is optional, if not provided, an empty collapsed state will appear
    if (opts && typeof opts.defaultText !== 'undefined') {
      collapsedText.text(opts.defaultText);
    } else {
      collapsedText.text('');
    }
  }

  function validate(opts) {
    if (typeof tinyMCE !== 'undefined') {
      tinyMCE.triggerSave();
    }

    Validate.clearError(field);

    if (opts && typeof opts.validateWith === 'function') {
      var result = opts.validateWith.call(field);
      return typeof result.isValid === 'function'
        ? result.isValid()
        : Validate.isValid(result);
    } else if (
      opts &&
      opts.allowBlank === false &&
      !Validate.notBlank(field.val())
    ) {
      Validate.setError(field, opts.blankMessage);
      return false;
    }

    return true;
  }
};
(function (window) {
  var tokenClient,
    gapiInitialized = false,
    gisInitialized = false;

  window.GoogleDrivePicker = function (args) {
    var $trigger,
      options,
      pickerShown = false;

    function init(args) {
      options = args || {};
      $trigger = options.$trigger;

      options.uploadToS3 = options.uploadToS3 || function () {};
      options.uploadCancelled = options.uploadCancelled || function () {};

      $trigger.on('click', call);
    }

    function call() {
      if (!window.gapi || !gapiInitialized || !gisInitialized) {
        options.$messages.text(Message.Uploaders.GoogleDrive.TryAgain).show();
        return;
      }

      tokenClient.callback = handleAuthResult;

      if (GoogleDrivePicker.oauthToken === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({prompt: 'consent'});
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({prompt: ''});
      }
    }

    function handleAuthResult(authResult) {
      if (authResult && !authResult.error) {
        GoogleDrivePicker.oauthToken = authResult.access_token;
        createPicker();
      }
    }

    function createPicker() {
      if (!pickerShown && GoogleDrivePicker.oauthToken) {
        var picker = new google.picker.PickerBuilder()
          .addView(google.picker.ViewId.DOCUMENTS)
          .addView(google.picker.ViewId.PDFS)
          .setOAuthToken(GoogleDrivePicker.oauthToken)
          .setAppId(googlePickerAppId)
          .setDeveloperKey(googlePickerDeveloperKey)
          .setCallback(pickerCallback)
          .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
          .build();

        picker.setVisible(true);
        options.$messages
          .text(Message.Uploaders.GoogleDrive.LoadingAttachment)
          .show();
        options.$messages.show();

        pickerShown = true;
      }
    }

    function pickerCallback(data) {
      switch (data[google.picker.Response.ACTION]) {
        case google.picker.Action.PICKED:
          pickedFile(data);
          pickerShown = false;
          options.uploadFinished();
          break;
        case google.picker.Action.CANCEL:
          pickerShown = false;
          options.uploadCancelled();
          break;
      }
    }

    function pickedFile(data) {
      var doc = data[google.picker.Response.DOCUMENTS][0];

      downloadFile({
        id: doc[google.picker.Document.ID],
        mimeType: doc[google.picker.Document.MIME_TYPE],
        name: doc[google.picker.Document.NAME],
        type: doc[google.picker.Document.TYPE]
      });
    }

    function dataToArrayBuffer(data) {
      if (!data) {
        return new Uint8Array(0);
      }

      var arrayBuffer = new Uint8Array(data.length);

      for (var i = 0; i < data.length; i++) {
        arrayBuffer[i] = data.charCodeAt(i);
      }

      return arrayBuffer;
    }

    function downloadFile(metadata) {
      var request;
      var mimeType = metadata.mimeType;
      var filename = metadata.name;

      if (metadata.type === 'document') {
        request = gapi.client.drive.files.export({
          fileId: metadata.id,
          mimeType: 'application/pdf'
        });

        mimeType = 'application/pdf';
        filename = filename + '.pdf';
      } else {
        request = gapi.client.drive.files.get({
          fileId: metadata.id,
          supportsAllDrives: true,
          alt: 'media'
        });
      }

      request.then(function(response) {
        var arrayBuffer = dataToArrayBuffer(response.body);

        var file = new Blob([arrayBuffer], {type: mimeType});
        file.name = filename;

        options.uploadToS3(file);
      });
    }

    init(args);
  };

  window.gapiLoaded = function () {
    gapi.load('client:picker', initializeGapiClient);
  };

  window.gisLoaded = function () {
    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: googlePickerClientId,
      scope: 'https://www.googleapis.com/auth/drive.file',
      callback: '',
    });

    gisInitialized = true;
  };

  function initializeGapiClient() {
    gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest')
      .then(function () {
        gapiInitialized = true;
      });
  }
})(window);
/* global $, Greenhouse, Validate */

(function (window) {
  window.S3DirectUploader = function (args) {
    var $cancelLink,
      $dropZone,
      $form,
      options,
      $progressBar,
      skipValidationsFor = {},
      $trigger;

    function init(args) {
      options = args || {};
      $dropZone = options.$dropZone;
      $form = options.$form;
      $progressBar = options.$progressBar;
      ($cancelLink = options.$cancelLink || $progressBar.find('.cancel')),
        ($trigger = options.$trigger);

      setupForm();
      setupBindings();
    }

    function setupForm() {
      $form.fileupload({
        dataType: 'xml',
        dropZone: $dropZone,
        add: addFile,
        progress: uploadProgress,
        done: uploadSuccess,
        fail: uploadFailed,
        always: uploadFinished,
      });
    }

    function formData(file) {
      var formData = $form.serializeArray();
      formData.push({ name: 'Content-Type', value: file.type });
      return formData;
    }

    function setupBindings() {
      $trigger.on('click', call);
    }

    function uploadFile(file) {
      skipValidationsFor[file.name] = true;
      $form.fileupload('add', { files: [file] });
    }

    function uploadProgress(e, data) {
      var progress = (data.loaded / data.total) * 100.0;
      $progressBar.find('.bar').css('width', progress + '%');
    }

    function uploadSuccess(e, data) {
      var file = data.files[0],
        url = $(
          data.result.documentElement.getElementsByTagName('Location')
        ).text();

      options.uploadComplete({
        filename: file.name,
        url: url,
      });
    }

    function uploadFailed(e, data) {
      if (data.textStatus === 'abort') {
        options.uploadCancelled();
        return;
      }

      options.uploadFailed(e, data.result);
    }

    function addFile(e, data) {
      var file = data.files[0],
        xhr;

      // Optionally set a reference to the uploaded file on the caller.
      (options.uploadedFileSetter || function () {})(file);

      setValues();
      options.uploadStarted();

      if (!validateFileIfNecessary(file)) {
        xhr = data.submit();
        xhr.abort();
        return;
      }

      data.formData = formData(file);
      xhr = data.submit();
      bindCancel(xhr);

      $dropZone.removeClass('highlight');
      $dropZone.hide();
      $progressBar.show();
    }

    function setValues() {
      confirmAuthenticityTokenIsSet();
    }

    // This is necessary for tests.
    function confirmAuthenticityTokenIsSet() {
      var $token = $form.find('input[name="authenticity_token"]');

      if ($token.length > 0) {
        return;
      }

      $form.append(
        $('<input/>')
          .attr('name', 'authenticity_token')
          .attr('value', uniqueId())
      );
    }

    function timestamp() {
      return new Date().getTime();
    }

    function uniqueId() {
      return Math.random().toString(36).substr(2, 16);
    }

    function bindCancel(xhr) {
      $cancelLink.unbind('click');
      $cancelLink.click(function () {
        xhr.abort();
      });
    }

    function validateFileIfNecessary(file) {
      /* If the user pastes an image into the Paste textbox, S3DirectUpload gets called anyway */
      if (!file.name) {
        return false;
      }

      if (options.$fileTypes.length === 0 || skipValidationsFor[file.name]) {
        return true;
      }

      if (!Validate.specificFileFormat(options.$fileTypes)(file.name)) {
        var message = Greenhouse.Translation.t(
          'add_person.flash_messages.invalid_format',
          {
            allowed_formats: options.$fileTypes.join(', '),
          }
        );

        alert(message);
        return false;
      }

      return true;
    }

    function uploadFinished(e, data) {
      $progressBar.hide();
    }

    function call(e) {
      e.preventDefault();
      $form.find(':file').click();
    }

    init(args);

    return { uploadFile: uploadFile };
  };
})(window);
/* global Greenhouse */





var FormControl = {
  initFileChooser: function (fileType) {
    $('#' + fileType + '_button').click(function () {
      FormControl.attachFileButton(fileType);
    });
  },

  initFilenameDisplayWithValidation: function (
    fileType,
    validateFunc,
    validateMessage,
    afterSuccess,
    afterError
  ) {
    $('#' + fileType + '_chooser').change(function () {
      FormControl.validateAndSetFilename(
        fileType,
        validateFunc,
        validateMessage,
        afterSuccess,
        afterError
      );
    });
  },

  /**
   * Cross-browser support for file upload
   */
  attachFileButton: function (file_type) {
    if (is_safari || is_explorer) {
      this.initFileChooserForSafari(file_type);
    } else {
      $('#' + file_type + '_chooser').trigger('click');
    }

    // clear and hide the paste textarea
    $('#' + file_type).val('');
    $('#' + file_type + '_paste').hide();
  },

  initFileChooserForSafari: function (file_type) {
    var chooser = $('#' + file_type + '_chooser');

    // For "security reasons" safari does not allow for the input file HTML control
    // to be triggered programatically.  We replace the button with a standard
    // HTML file control if the user is on safari.
    var standardFileEl = Handlebars.compile(
      '<div class="{{alt_css_class}}"></div>'
    );
    var alt_css_class = 'alt-upload-' + file_type.replace(/_/g, '-');
    var actions = $('#' + file_type + '_actions');

    actions.after(standardFileEl({ alt_css_class: alt_css_class }));
    $('.' + alt_css_class).append(chooser.detach());
    chooser.show();
    actions.hide();
  },

  validateAndSetFilename: function (
    fileType,
    validateFunc,
    validateMessage,
    afterSuccess,
    afterError
  ) {
    var chooser = $('#' + fileType + '_chooser');
    var filename = FileUtil.getFilenameFromPath(chooser.val());

    if (
      Validate.field('#' + fileType + '_chooser', validateFunc, validateMessage)
    ) {
      $('#' + fileType + '_filename').html(filename);

      if (!is_safari && !is_explorer) {
        $('#' + fileType + '_filename_container').show();
      }

      if (typeof afterSuccess === 'function') {
        afterSuccess();
      }
    } else {
      FormControl.clearFileChooserAndFilename(fileType);
      if (typeof afterError === 'function') {
        afterError();
      }
    }
  },

  clearFileChooserAndFilename: function (fileType) {
    FormControl.clearFileChooser('#' + fileType + '_chooser');
    $('#' + fileType + '_filename').html('');
    $('#' + fileType + '_filename_container').hide();
    $('#' + fileType + '_url').val('');
  },

  clearFileChooser: function (selector) {
    var input = $(selector);
    input.val(''); // this takes care of non-IE browsers
    var clone = input.clone(true);
    input.replaceWith(clone); // this takes care of IE
    return clone;
  },

  /**
   *
   * Registers events for a control with "attach file or paste text"
   * functionality.
   */
  attachOrPaste: function (selector, options) {
    options = options || {};

    var fnUploadStarted = options.uploadStarted || function () {},
      fnUploadFinished = options.uploadFinished || function () {},
      fnAttachmentRemoved = options.attachmentRemoved || function () {},
      resumeParser = options.resumeParser;

    $(selector).each(function () {
      var $container = $(this),
        $googlePickerTrigger = $container.find('[data-source="google-drive"]'),
        $linkContainer = $container.find('.link-container'),
        $messages = $container.find('[data-messages="uploaders"]'),
        field = $container.data('field'),
        model = $container.data('model'),
        s3DirectUploader;

      function setup() {
        $container
          .find('[data-source="paste"]')
          .on('click', togglePasteArea)
          .on('click', contentSecurityPolicy.hrefPreventDefault);
        if (allowAdvancedControls($container)) {
          setupDirectUploader();
          setupGoogleDrivePicker();
        } else {
          $googlePickerTrigger.remove();
        }
        setupDropbox();
      }

      function setupGoogleDrivePicker() {
        new GoogleDrivePicker({
          $trigger: $googlePickerTrigger,
          $messages: $messages,
          uploadCancelled: uploadCancelled,
          uploadComplete: uploadComplete,
          uploadFinished: uploadFinished,
          uploadStarted: uploadStarted,
          uploadToS3: uploadToS3,
        });
      }

      function setupDirectUploader() {
        s3DirectUploader = new S3DirectUploader({
          $form: $(jQueryEscape('#s3_upload_for_' + field)),
          $trigger: $container.find('[data-source="attach"]'),
          $dropZone: $container.find('.drop-zone'),
          $progressBar: $container.find('.progress-bar'),
          $fileTypes: $container.data('file-types'),
          uploadCancelled: uploadCancelled,
          uploadComplete: uploadComplete,
          uploadFailed: uploadFailed,
          uploadStarted: uploadStarted,
        });
      }

      function setupDropbox() {
        new DropboxChooser({
          $trigger: $container.find('[data-source="dropbox"]'),
          $messages: $messages,
          uploadComplete: uploadComplete,
          uploadCancelled: uploadCancelled,
          uploadStarted: uploadStarted,
        });
      }

      function uploadToS3(file) {
        s3DirectUploader.uploadFile(file);
      }

      function togglePasteArea() {
        $(this).toggleClass('active');
        $container.find('textarea.paste').toggle();
        $(document).trigger('greenhouse.jobApplication.heightChanged');
      }

      function uploadStarted() {
        $container.find('textarea.paste').hide();
        $linkContainer.hide();
        fnUploadStarted();
      }

      function uploadFinished() {
        $messages.hide();
        fnUploadFinished(field);
      }

      function uploadComplete(content) {
        if (resumeParser) {
          var data = {
            resume: {
              filename: content.filename,
              resume_url: content.url,
              from_s3: true,
            },
          };

          new Person.ResumeParser(resumeParser.fromResume).post(data);
        } else {
          FormControl.attachFromUrl(
            $container.closest('form'),
            model,
            field,
            content.filename,
            content.url,
            fnAttachmentRemoved
          );
          uploadFinished();
        }
      }

      function uploadCancelled() {
        $messages.hide();
        FormControl.clearFileChooserAndFilename(model);
        $linkContainer.show();
        fnUploadFinished(field);
      }

      function uploadFailed(event, errorJson) {
        var message = Greenhouse.Translation.t(
          'add_person.flash_messages.expired',
          {}
        );
        $linkContainer.addClass('error').text(message);
        uploadCancelled();
      }

      /*  Some browsers, like IE9, disallow javascript actions on file choosers for security reasons.  In these cases,
          We need to display a file chooser in our form that the user clicks on explicitly.  This won't work for S3
          Direct Upload because the s3_direct_upload requires its own form so it can POST to Amazon AWS.

          In these cases, we just fall back to the old file chooser method where the file data is sent to Greenhouse
          with the rest of the candidate data.
       */
      function allowAdvancedControls($container) {
        if (allowS3($container)) {
          return true;
        } else {
          var $attachLink = $container.find('[data-source="attach"]');
          $attachLink
            .on('click', injectFileChooser)
            .on('click', contentSecurityPolicy.hrefPreventDefault);
          return false;
        }
      }

      function injectFileChooser() {
        $linkContainer.empty();

        var $fileChooser = $("<input type='file' />")
            .attr('id', field + '_file')
            .attr('name', model + '[' + field + ']')
            .appendTo($linkContainer),
          fileTypes = $fileChooser
            .closest('.attach-or-paste')
            .data('file-types');

        $fileChooser.on('change', function () {
          if (
            $fileChooser.val() &&
            !Validate.specificFileFormat(fileTypes)($fileChooser.val())
          ) {
            var message = Greenhouse.Translation.t(
              'add_person.flash_messages.invalid_format',
              {
                allowed_formats: fileTypes.join(', '),
              }
            );

            alert(message);
            $fileChooser.replaceWith(($fileChooser = $fileChooser.clone(true)));
          }

          uploadFinished();
        });
      }

      /* Escapes square brackets to allow finding by IDs that have brackets in them */
      function jQueryEscape(selector) {
        return selector.replace(/\[/, '\\[').replace(/\]/, '\\]');
      }

      function allowS3(container) {
        return container.data('allowS3');
      }

      setup();
    });
  },

  registerFileChooser: function (attachmentWrapper) {
    var fileInput = $(attachmentWrapper).next('input[type=file]'),
      clearInput = fileInput.next('input[type=hidden].clear-attachment'),
      removeFileButton = $(attachmentWrapper).find('.x');

    removeFileButton.on('click', clear);

    function clear() {
      var attachmentId = $(this).parent().attr('data-id');

      clearInput.val(_.compact([clearInput.val(), attachmentId]).join(','));
      fileInput.show();
      $(this).parent().remove();
    }
  },

  attachFromUrl: function (
    $form,
    model,
    fileType,
    filename,
    url,
    fnAttachmentRemoved
  ) {
    var urlName = fileType + '_url',
      $hiddenUrl = $('#' + urlName),
      $hiddenUrlFilename = $('#' + urlName + '_filename'),
      $container = $('#' + fileType + '_chosen'),
      $linkContainer = $container.parent().find('.link-container'),
      $removeLink = $container.find('a.remove'),
      fileTypes = $linkContainer.closest('.attach-or-paste').data('file-types');

    if (fileTypes) {
      if (!Validate.specificFileFormat(fileTypes)(filename)) {
        var message = Greenhouse.Translation.t(
          'add_person.flash_messages.invalid_format',
          {
            allowed_formats: fileTypes.join(', '),
          }
        );

        alert(message);
        removeAttachment();
        return false;
      }
    }

    if ($hiddenUrl.length === 0) {
      $hiddenUrl = $("<input type='hidden' />")
        .attr('id', urlName)
        .attr('name', model + '[' + urlName + ']')
        .appendTo($form);

      $hiddenUrlFilename = $("<input type='hidden' />")
        .attr('id', urlName + '_filename')
        .attr('name', model + '[' + urlName + '_filename]')
        .appendTo($form);
    }

    $container.on('click', 'a.remove', removeAttachment);
    $removeLink.css('display', 'inline-block');

    FormControl.clearFileChooserAndFilename(fileType);
    $hiddenUrl.val(url);
    $hiddenUrlFilename.val(filename);

    $form.find("div[data-field='" + fileType + "'] .link-container").hide();
    $container.show();
    $removeLink.css('display', 'inline-block');

    $('#' + fileType + '_text').hide();
    $('#' + fileType + '_filename').text(filename);

    function removeAttachment() {
      FormControl.clearFileChooserAndFilename(fileType);
      $container.hide();
      $removeLink.hide();
      $linkContainer.show();
      $hiddenUrl.remove();
      $hiddenUrlFilename.remove();

      fnAttachmentRemoved();
    }
  },

  useUploadResumeChooser: function (filename, url) {
    var $container = $("div[data-field='resume']");

    $container.find("[name='person[resume]']").remove();

    $container.find('.link-container').hide();
    $('#resume_filename').text(filename);
    $('#resume_chosen').show();
    $('#resume_text').hide();

    FormControl.attachFromUrl(
      $container.closest('form'),
      'person',
      'resume',
      filename,
      url,
      function () {}
    );
  },
};
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));
//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));
//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));
//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));





/* global documentReady */

documentReady(function () {
  moment.locale(window.Greenhouse.Translation.locale);
});
/*!
 * <%= meta.title %> v<%= meta.version %>
 * Docs & License: <%= meta.homepage %>
 * (c) <%= meta.copyright %>
 */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery', 'moment'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    module.exports = factory(require('jquery'), require('moment'));
  } else {
    factory(jQuery, moment);
  }
})(function ($, moment) {
  var FC = ($.fullCalendar = {
    version: '<%= meta.version %>',
    internalApiVersion: 5,
  });
  var fcViews = (FC.views = {});

  $.fn.fullCalendar = function (options) {
    var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
    var res = this; // what this function will return (this jQuery object by default)

    this.each(function (i, _element) {
      // loop each DOM element involved
      var element = $(_element);
      var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
      var singleRes; // the returned value of this single method call

      // a method call
      if (typeof options === 'string') {
        if (calendar && $.isFunction(calendar[options])) {
          singleRes = calendar[options].apply(calendar, args);
          if (!i) {
            res = singleRes; // record the first method call result
          }
          if (options === 'destroy') {
            // for the destroy method, must remove Calendar object data
            element.removeData('fullCalendar');
          }
        }
      }
      // a new calendar initialization
      else if (!calendar) {
        // don't initialize twice
        calendar = new Calendar(element, options);
        element.data('fullCalendar', calendar);
        calendar.render();
      }
    });

    return res;
  };

  var complexOptions = [
    // names of options that are objects whose properties should be combined
    'header',
    'buttonText',
    'buttonIcons',
    'themeButtonIcons',
  ];

  // Merges an array of option objects into a single object
  function mergeOptions(optionObjs) {
    return mergeProps(optionObjs, complexOptions);
  }

  // Given options specified for the calendar's constructor, massages any legacy options into a non-legacy form.
  // Converts View-Option-Hashes into the View-Specific-Options format.
  function massageOverrides(input) {
    var overrides = { views: input.views || {} }; // the output. ensure a `views` hash
    var subObj;

    // iterate through all option override properties (except `views`)
    $.each(input, function (name, val) {
      if (name != 'views') {
        // could the value be a legacy View-Option-Hash?
        if (
          $.isPlainObject(val) &&
          !/(time|duration|interval)$/i.test(name) && // exclude duration options. might be given as objects
          $.inArray(name, complexOptions) == -1 // complex options aren't allowed to be View-Option-Hashes
        ) {
          subObj = null;

          // iterate through the properties of this possible View-Option-Hash value
          $.each(val, function (subName, subVal) {
            // is the property targeting a view?
            if (
              /^(month|week|day|default|basic(Week|Day)?|agenda(Week|Day)?)$/.test(
                subName
              )
            ) {
              if (!overrides.views[subName]) {
                // ensure the view-target entry exists
                overrides.views[subName] = {};
              }
              overrides.views[subName][name] = subVal; // record the value in the `views` object
            } else {
              // a non-View-Option-Hash property
              if (!subObj) {
                subObj = {};
              }
              subObj[subName] = subVal; // accumulate these unrelated values for later
            }
          });

          if (subObj) {
            // non-View-Option-Hash properties? transfer them as-is
            overrides[name] = subObj;
          }
        } else {
          overrides[name] = val; // transfer normal options as-is
        }
      }
    });

    return overrides;
  }

  // exports
  FC.intersectRanges = intersectRanges;
  FC.applyAll = applyAll;
  FC.debounce = debounce;
  FC.isInt = isInt;
  FC.htmlEscape = htmlEscape;
  FC.cssToStr = cssToStr;
  FC.proxy = proxy;
  FC.capitaliseFirstLetter = capitaliseFirstLetter;

  /* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/

  // Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
  // and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
  function compensateScroll(rowEls, scrollbarWidths) {
    if (scrollbarWidths.left) {
      rowEls.css({
        'border-left-width': 1,
        'margin-left': scrollbarWidths.left - 1,
      });
    }
    if (scrollbarWidths.right) {
      rowEls.css({
        'border-right-width': 1,
        'margin-right': scrollbarWidths.right - 1,
      });
    }
  }

  // Undoes compensateScroll and restores all borders/margins
  function uncompensateScroll(rowEls) {
    rowEls.css({
      'margin-left': '',
      'margin-right': '',
      'border-left-width': '',
      'border-right-width': '',
    });
  }

  // Make the mouse cursor express that an event is not allowed in the current area
  function disableCursor() {
    $('body').addClass('fc-not-allowed');
  }

  // Returns the mouse cursor to its original look
  function enableCursor() {
    $('body').removeClass('fc-not-allowed');
  }

  // Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
  // By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
  // any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
  // reduces the available height.
  function distributeHeight(els, availableHeight, shouldRedistribute) {
    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.

    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
    var minOffset2 = Math.floor(
      availableHeight - minOffset1 * (els.length - 1)
    ); // for last element *FLOORING NOTE*
    var flexEls = []; // elements that are allowed to expand. array of DOM nodes
    var flexOffsets = []; // amount of vertical space it takes up
    var flexHeights = []; // actual css height
    var usedHeight = 0;

    undistributeHeight(els); // give all elements their natural height

    // find elements that are below the recommended height (expandable).
    // important to query for heights in a single first pass (to avoid reflow oscillation).
    els.each(function (i, el) {
      var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
      var naturalOffset = $(el).outerHeight(true);

      if (naturalOffset < minOffset) {
        flexEls.push(el);
        flexOffsets.push(naturalOffset);
        flexHeights.push($(el).height());
      } else {
        // this element stretches past recommended height (non-expandable). mark the space as occupied.
        usedHeight += naturalOffset;
      }
    });

    // readjust the recommended height to only consider the height available to non-maxed-out rows.
    if (shouldRedistribute) {
      availableHeight -= usedHeight;
      minOffset1 = Math.floor(availableHeight / flexEls.length);
      minOffset2 = Math.floor(
        availableHeight - minOffset1 * (flexEls.length - 1)
      ); // *FLOORING NOTE*
    }

    // assign heights to all expandable elements
    $(flexEls).each(function (i, el) {
      var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
      var naturalOffset = flexOffsets[i];
      var naturalHeight = flexHeights[i];
      var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding

      if (naturalOffset < minOffset) {
        // we check this again because redistribution might have changed things
        $(el).height(newHeight);
      }
    });
  }

  // Undoes distrubuteHeight, restoring all els to their natural height
  function undistributeHeight(els) {
    els.height('');
  }

  // Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
  // cells to be that width.
  // PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
  function matchCellWidths(els) {
    var maxInnerWidth = 0;

    els.find('> span').each(function (i, innerEl) {
      var innerWidth = $(innerEl).outerWidth();
      if (innerWidth > maxInnerWidth) {
        maxInnerWidth = innerWidth;
      }
    });

    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance

    els.width(maxInnerWidth);

    return maxInnerWidth;
  }

  // Given one element that resides inside another,
  // Subtracts the height of the inner element from the outer element.
  function subtractInnerElHeight(outerEl, innerEl) {
    var both = outerEl.add(innerEl);
    var diff;

    // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
    both.css({
      position: 'relative', // cause a reflow, which will force fresh dimension recalculation
      left: -1, // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
    });
    diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
    both.css({ position: '', left: '' }); // undo hack

    return diff;
  }

  /* Element Geom Utilities
----------------------------------------------------------------------------------------------------------------------*/

  FC.getOuterRect = getOuterRect;
  FC.getClientRect = getClientRect;
  FC.getContentRect = getContentRect;
  FC.getScrollbarWidths = getScrollbarWidths;

  // borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
  function getScrollParent(el) {
    var position = el.css('position'),
      scrollParent = el
        .parents()
        .filter(function () {
          var parent = $(this);
          return /(auto|scroll)/.test(
            parent.css('overflow') +
              parent.css('overflow-y') +
              parent.css('overflow-x')
          );
        })
        .eq(0);

    return position === 'fixed' || !scrollParent.length
      ? $(el[0].ownerDocument || document)
      : scrollParent;
  }

  // Queries the outer bounding area of a jQuery element.
  // Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
  // Origin is optional.
  function getOuterRect(el, origin) {
    var offset = el.offset();
    var left = offset.left - (origin ? origin.left : 0);
    var top = offset.top - (origin ? origin.top : 0);

    return {
      left: left,
      right: left + el.outerWidth(),
      top: top,
      bottom: top + el.outerHeight(),
    };
  }

  // Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
  // Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
  // Origin is optional.
  // NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
  function getClientRect(el, origin) {
    var offset = el.offset();
    var scrollbarWidths = getScrollbarWidths(el);
    var left =
      offset.left +
      getCssFloat(el, 'border-left-width') +
      scrollbarWidths.left -
      (origin ? origin.left : 0);
    var top =
      offset.top +
      getCssFloat(el, 'border-top-width') +
      scrollbarWidths.top -
      (origin ? origin.top : 0);

    return {
      left: left,
      right: left + el[0].clientWidth, // clientWidth includes padding but NOT scrollbars
      top: top,
      bottom: top + el[0].clientHeight, // clientHeight includes padding but NOT scrollbars
    };
  }

  // Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
  // Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
  // Origin is optional.
  function getContentRect(el, origin) {
    var offset = el.offset(); // just outside of border, margin not included
    var left =
      offset.left +
      getCssFloat(el, 'border-left-width') +
      getCssFloat(el, 'padding-left') -
      (origin ? origin.left : 0);
    var top =
      offset.top +
      getCssFloat(el, 'border-top-width') +
      getCssFloat(el, 'padding-top') -
      (origin ? origin.top : 0);

    return {
      left: left,
      right: left + el.width(),
      top: top,
      bottom: top + el.height(),
    };
  }

  // Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
  // NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
  function getScrollbarWidths(el) {
    var leftRightWidth = el.innerWidth() - el[0].clientWidth; // the paddings cancel out, leaving the scrollbars
    var widths = {
      left: 0,
      right: 0,
      top: 0,
      bottom: el.innerHeight() - el[0].clientHeight, // the paddings cancel out, leaving the bottom scrollbar
    };

    if (getIsLeftRtlScrollbars() && el.css('direction') == 'rtl') {
      // is the scrollbar on the left side?
      widths.left = leftRightWidth;
    } else {
      widths.right = leftRightWidth;
    }

    return widths;
  }

  // Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side

  var _isLeftRtlScrollbars = null;

  function getIsLeftRtlScrollbars() {
    // responsible for caching the computation
    if (_isLeftRtlScrollbars === null) {
      _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
    }
    return _isLeftRtlScrollbars;
  }

  function computeIsLeftRtlScrollbars() {
    // creates an offscreen test element, then removes it
    var el = $('<div><div></div></div>')
      .css({
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl',
      })
      .appendTo('body');
    var innerEl = el.children();
    var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
    el.remove();
    return res;
  }

  // Retrieves a jQuery element's computed CSS value as a floating-point number.
  // If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
  function getCssFloat(el, prop) {
    return parseFloat(el.css(prop)) || 0;
  }

  /* Mouse / Touch Utilities
----------------------------------------------------------------------------------------------------------------------*/

  FC.preventDefault = preventDefault;

  // Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
  function isPrimaryMouseButton(ev) {
    return ev.which == 1 && !ev.ctrlKey;
  }

  function getEvX(ev) {
    if (ev.pageX !== undefined) {
      return ev.pageX;
    }
    var touches = ev.originalEvent.touches;
    if (touches) {
      return touches[0].pageX;
    }
  }

  function getEvY(ev) {
    if (ev.pageY !== undefined) {
      return ev.pageY;
    }
    var touches = ev.originalEvent.touches;
    if (touches) {
      return touches[0].pageY;
    }
  }

  function getEvIsTouch(ev) {
    return /^touch/.test(ev.type);
  }

  function preventSelection(el) {
    el.addClass('fc-unselectable').on('selectstart', preventDefault);
  }

  // Stops a mouse/touch event from doing it's native browser action
  function preventDefault(ev) {
    ev.preventDefault();
  }

  // attach a handler to get called when ANY scroll action happens on the page.
  // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
  // http://stackoverflow.com/a/32954565/96342
  // returns `true` on success.
  function bindAnyScroll(handler) {
    if (window.addEventListener) {
      window.addEventListener('scroll', handler, true); // useCapture=true
      return true;
    }
    return false;
  }

  // undoes bindAnyScroll. must pass in the original function.
  // returns `true` on success.
  function unbindAnyScroll(handler) {
    if (window.removeEventListener) {
      window.removeEventListener('scroll', handler, true); // useCapture=true
      return true;
    }
    return false;
  }

  /* General Geometry Utils
----------------------------------------------------------------------------------------------------------------------*/

  FC.intersectRects = intersectRects;

  // Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
  function intersectRects(rect1, rect2) {
    var res = {
      left: Math.max(rect1.left, rect2.left),
      right: Math.min(rect1.right, rect2.right),
      top: Math.max(rect1.top, rect2.top),
      bottom: Math.min(rect1.bottom, rect2.bottom),
    };

    if (res.left < res.right && res.top < res.bottom) {
      return res;
    }
    return false;
  }

  // Returns a new point that will have been moved to reside within the given rectangle
  function constrainPoint(point, rect) {
    return {
      left: Math.min(Math.max(point.left, rect.left), rect.right),
      top: Math.min(Math.max(point.top, rect.top), rect.bottom),
    };
  }

  // Returns a point that is the center of the given rectangle
  function getRectCenter(rect) {
    return {
      left: (rect.left + rect.right) / 2,
      top: (rect.top + rect.bottom) / 2,
    };
  }

  // Subtracts point2's coordinates from point1's coordinates, returning a delta
  function diffPoints(point1, point2) {
    return {
      left: point1.left - point2.left,
      top: point1.top - point2.top,
    };
  }

  /* Object Ordering by Field
----------------------------------------------------------------------------------------------------------------------*/

  FC.parseFieldSpecs = parseFieldSpecs;
  FC.compareByFieldSpecs = compareByFieldSpecs;
  FC.compareByFieldSpec = compareByFieldSpec;
  FC.flexibleCompare = flexibleCompare;

  function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i, token;

    if (typeof input === 'string') {
      tokens = input.split(/\s*,\s*/);
    } else if (typeof input === 'function') {
      tokens = [input];
    } else if ($.isArray(input)) {
      tokens = input;
    }

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];

      if (typeof token === 'string') {
        specs.push(
          token.charAt(0) == '-'
            ? { field: token.substring(1), order: -1 }
            : { field: token, order: 1 }
        );
      } else if (typeof token === 'function') {
        specs.push({ func: token });
      }
    }

    return specs;
  }

  function compareByFieldSpecs(obj1, obj2, fieldSpecs) {
    var i;
    var cmp;

    for (i = 0; i < fieldSpecs.length; i++) {
      cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i]);
      if (cmp) {
        return cmp;
      }
    }

    return 0;
  }

  function compareByFieldSpec(obj1, obj2, fieldSpec) {
    if (fieldSpec.func) {
      return fieldSpec.func(obj1, obj2);
    }
    return (
      flexibleCompare(obj1[fieldSpec.field], obj2[fieldSpec.field]) *
      (fieldSpec.order || 1)
    );
  }

  function flexibleCompare(a, b) {
    if (!a && !b) {
      return 0;
    }
    if (b == null) {
      return -1;
    }
    if (a == null) {
      return 1;
    }
    if ($.type(a) === 'string' || $.type(b) === 'string') {
      return String(a).localeCompare(String(b));
    }
    return a - b;
  }

  /* FullCalendar-specific Misc Utilities
----------------------------------------------------------------------------------------------------------------------*/

  // Computes the intersection of the two ranges. Returns undefined if no intersection.
  // Expects all dates to be normalized to the same timezone beforehand.
  // TODO: move to date section?
  function intersectRanges(subjectRange, constraintRange) {
    var subjectStart = subjectRange.start;
    var subjectEnd = subjectRange.end;
    var constraintStart = constraintRange.start;
    var constraintEnd = constraintRange.end;
    var segStart, segEnd;
    var isStart, isEnd;

    if (subjectEnd > constraintStart && subjectStart < constraintEnd) {
      // in bounds at all?

      if (subjectStart >= constraintStart) {
        segStart = subjectStart.clone();
        isStart = true;
      } else {
        segStart = constraintStart.clone();
        isStart = false;
      }

      if (subjectEnd <= constraintEnd) {
        segEnd = subjectEnd.clone();
        isEnd = true;
      } else {
        segEnd = constraintEnd.clone();
        isEnd = false;
      }

      return {
        start: segStart,
        end: segEnd,
        isStart: isStart,
        isEnd: isEnd,
      };
    }
  }

  /* Date Utilities
----------------------------------------------------------------------------------------------------------------------*/

  FC.computeIntervalUnit = computeIntervalUnit;
  FC.divideRangeByDuration = divideRangeByDuration;
  FC.divideDurationByDuration = divideDurationByDuration;
  FC.multiplyDuration = multiplyDuration;
  FC.durationHasTime = durationHasTime;

  var dayIDs = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var intervalUnits = [
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond',
  ];

  // Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
  // Moments will have their timezones normalized.
  function diffDayTime(a, b) {
    return moment.duration({
      days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
      ms: a.time() - b.time(), // time-of-day from day start. disregards timezone
    });
  }

  // Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
  function diffDay(a, b) {
    return moment.duration({
      days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
    });
  }

  // Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
  function diffByUnit(a, b, unit) {
    return moment.duration(
      Math.round(a.diff(b, unit, true)), // returnFloat=true
      unit
    );
  }

  // Computes the unit name of the largest whole-unit period of time.
  // For example, 48 hours will be "days" whereas 49 hours will be "hours".
  // Accepts start/end, a range object, or an original duration object.
  function computeIntervalUnit(start, end) {
    var i, unit;
    var val;

    for (i = 0; i < intervalUnits.length; i++) {
      unit = intervalUnits[i];
      val = computeRangeAs(unit, start, end);

      if (val >= 1 && isInt(val)) {
        break;
      }
    }

    return unit; // will be "milliseconds" if nothing else matches
  }

  // Computes the number of units (like "hours") in the given range.
  // Range can be a {start,end} object, separate start/end args, or a Duration.
  // Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
  // of month-diffing logic (which tends to vary from version to version).
  function computeRangeAs(unit, start, end) {
    if (end != null) {
      // given start, end
      return end.diff(start, unit, true);
    } else if (moment.isDuration(start)) {
      // given duration
      return start.as(unit);
    } else {
      // given { start, end } range object
      return start.end.diff(start.start, unit, true);
    }
  }

  // Intelligently divides a range (specified by a start/end params) by a duration
  function divideRangeByDuration(start, end, dur) {
    var months;

    if (durationHasTime(dur)) {
      return (end - start) / dur;
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && isInt(months)) {
      return end.diff(start, 'months', true) / months;
    }
    return end.diff(start, 'days', true) / dur.asDays();
  }

  // Intelligently divides one duration by another
  function divideDurationByDuration(dur1, dur2) {
    var months1, months2;

    if (durationHasTime(dur1) || durationHasTime(dur2)) {
      return dur1 / dur2;
    }
    months1 = dur1.asMonths();
    months2 = dur2.asMonths();
    if (
      Math.abs(months1) >= 1 &&
      isInt(months1) &&
      Math.abs(months2) >= 1 &&
      isInt(months2)
    ) {
      return months1 / months2;
    }
    return dur1.asDays() / dur2.asDays();
  }

  // Intelligently multiplies a duration by a number
  function multiplyDuration(dur, n) {
    var months;

    if (durationHasTime(dur)) {
      return moment.duration(dur * n);
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && isInt(months)) {
      return moment.duration({ months: months * n });
    }
    return moment.duration({ days: dur.asDays() * n });
  }

  // Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
  function durationHasTime(dur) {
    return Boolean(
      dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds()
    );
  }

  function isNativeDate(input) {
    return (
      Object.prototype.toString.call(input) === '[object Date]' ||
      input instanceof Date
    );
  }

  // Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
  function isTimeString(str) {
    return /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
  }

  /* Logging and Debug
----------------------------------------------------------------------------------------------------------------------*/

  FC.log = function () {
    var console = window.console;

    if (console && console.log) {
      return console.log.apply(console, arguments);
    }
  };

  FC.warn = function () {
    var console = window.console;

    if (console && console.warn) {
      return console.warn.apply(console, arguments);
    } else {
      return FC.log.apply(FC, arguments);
    }
  };

  /* General Utilities
----------------------------------------------------------------------------------------------------------------------*/

  var hasOwnPropMethod = {}.hasOwnProperty;

  // Merges an array of objects into a single object.
  // The second argument allows for an array of property names who's object values will be merged together.
  function mergeProps(propObjs, complexProps) {
    var dest = {};
    var i, name;
    var complexObjs;
    var j, val;
    var props;

    if (complexProps) {
      for (i = 0; i < complexProps.length; i++) {
        name = complexProps[i];
        complexObjs = [];

        // collect the trailing object values, stopping when a non-object is discovered
        for (j = propObjs.length - 1; j >= 0; j--) {
          val = propObjs[j][name];

          if (typeof val === 'object') {
            complexObjs.unshift(val);
          } else if (val !== undefined) {
            dest[name] = val; // if there were no objects, this value will be used
            break;
          }
        }

        // if the trailing values were objects, use the merged value
        if (complexObjs.length) {
          dest[name] = mergeProps(complexObjs);
        }
      }
    }

    // copy values into the destination, going from last to first
    for (i = propObjs.length - 1; i >= 0; i--) {
      props = propObjs[i];

      for (name in props) {
        if (!(name in dest)) {
          // if already assigned by previous props or complex props, don't reassign
          dest[name] = props[name];
        }
      }
    }

    return dest;
  }

  // Create an object that has the given prototype. Just like Object.create
  function createObject(proto) {
    var f = function () {};
    f.prototype = proto;
    return new f();
  }

  function copyOwnProps(src, dest) {
    for (var name in src) {
      if (hasOwnProp(src, name)) {
        dest[name] = src[name];
      }
    }
  }

  // Copies over certain methods with the same names as Object.prototype methods. Overcomes an IE<=8 bug:
  // https://developer.mozilla.org/en-US/docs/ECMAScript_DontEnum_attribute#JScript_DontEnum_Bug
  function copyNativeMethods(src, dest) {
    var names = ['constructor', 'toString', 'valueOf'];
    var i, name;

    for (i = 0; i < names.length; i++) {
      name = names[i];

      if (src[name] !== Object.prototype[name]) {
        dest[name] = src[name];
      }
    }
  }

  function hasOwnProp(obj, name) {
    return hasOwnPropMethod.call(obj, name);
  }

  // Is the given value a non-object non-function value?
  function isAtomic(val) {
    return /undefined|null|boolean|number|string/.test($.type(val));
  }

  function applyAll(functions, thisObj, args) {
    if ($.isFunction(functions)) {
      functions = [functions];
    }
    if (functions) {
      var i;
      var ret;
      for (i = 0; i < functions.length; i++) {
        ret = functions[i].apply(thisObj, args) || ret;
      }
      return ret;
    }
  }

  function firstDefined() {
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] !== undefined) {
        return arguments[i];
      }
    }
  }

  function htmlEscape(s) {
    return (s + '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/'/g, '&#039;')
      .replace(/"/g, '&quot;')
      .replace(/\n/g, '<br />');
  }

  function stripHtmlEntities(text) {
    return text.replace(/&.*?;/g, '');
  }

  // Given a hash of CSS properties, returns a string of CSS.
  // Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
  function cssToStr(cssProps) {
    var statements = [];

    $.each(cssProps, function (name, val) {
      if (val != null) {
        statements.push(name + ':' + val);
      }
    });

    return statements.join(';');
  }

  function capitaliseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function compareNumbers(a, b) {
    // for .sort()
    return a - b;
  }

  function isInt(n) {
    return n % 1 === 0;
  }

  // Returns a method bound to the given object context.
  // Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
  // different contexts as identical when binding/unbinding events.
  function proxy(obj, methodName) {
    var method = obj[methodName];

    return function () {
      return method.apply(obj, arguments);
    };
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  // https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
  function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function () {
      var last = +new Date() - timestamp;
      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    };

    return function () {
      context = this;
      args = arguments;
      timestamp = +new Date();
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }
      return result;
    };
  }

  // HACK around jQuery's now A+ promises: execute callback synchronously if already resolved.
  // thenFunc shouldn't accept args.
  // similar to whenResources in Scheduler plugin.
  function syncThen(promise, thenFunc) {
    // not a promise, or an already-resolved promise?
    if (!promise || !promise.then || promise.state() === 'resolved') {
      return $.when(thenFunc()); // resolve immediately
    } else if (thenFunc) {
      return promise.then(thenFunc);
    }
  }

  var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
  var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
  var newMomentProto = moment.fn; // where we will attach our new methods
  var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
  var allowValueOptimization;
  var setUTCValues; // function defined below
  var setLocalValues; // function defined below

  // Creating
  // -------------------------------------------------------------------------------------------------

  // Creates a new moment, similar to the vanilla moment(...) constructor, but with
  // extra features (ambiguous time, enhanced formatting). When given an existing moment,
  // it will function as a clone (and retain the zone of the moment). Anything else will
  // result in a moment in the local zone.
  FC.moment = function () {
    return makeMoment(arguments);
  };

  // Sames as FC.moment, but forces the resulting moment to be in the UTC timezone.
  FC.moment.utc = function () {
    var mom = makeMoment(arguments, true);

    // Force it into UTC because makeMoment doesn't guarantee it
    // (if given a pre-existing moment for example)
    if (mom.hasTime()) {
      // don't give ambiguously-timed moments a UTC zone
      mom.utc();
    }

    return mom;
  };

  // Same as FC.moment, but when given an ISO8601 string, the timezone offset is preserved.
  // ISO8601 strings with no timezone offset will become ambiguously zoned.
  FC.moment.parseZone = function () {
    return makeMoment(arguments, true, true);
  };

  // Builds an enhanced moment from args. When given an existing moment, it clones. When given a
  // native Date, or called with no arguments (the current time), the resulting moment will be local.
  // Anything else needs to be "parsed" (a string or an array), and will be affected by:
  //    parseAsUTC - if there is no zone information, should we parse the input in UTC?
  //    parseZone - if there is zone information, should we force the zone of the moment?
  function makeMoment(args, parseAsUTC, parseZone) {
    var input = args[0];
    var isSingleString = args.length == 1 && typeof input === 'string';
    var isAmbigTime;
    var isAmbigZone;
    var ambigMatch;
    var mom;

    if (moment.isMoment(input)) {
      mom = moment.apply(null, args); // clone it
      transferAmbigs(input, mom); // the ambig flags weren't transfered with the clone
    } else if (isNativeDate(input) || input === undefined) {
      mom = moment.apply(null, args); // will be local
    } else {
      // "parsing" is required
      isAmbigTime = false;
      isAmbigZone = false;

      if (isSingleString) {
        if (ambigDateOfMonthRegex.test(input)) {
          // accept strings like '2014-05', but convert to the first of the month
          input += '-01';
          args = [input]; // for when we pass it on to moment's constructor
          isAmbigTime = true;
          isAmbigZone = true;
        } else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
          isAmbigTime = !ambigMatch[5]; // no time part?
          isAmbigZone = true;
        }
      } else if ($.isArray(input)) {
        // arrays have no timezone information, so assume ambiguous zone
        isAmbigZone = true;
      }
      // otherwise, probably a string with a format

      if (parseAsUTC || isAmbigTime) {
        mom = moment.utc.apply(moment, args);
      } else {
        mom = moment.apply(null, args);
      }

      if (isAmbigTime) {
        mom._ambigTime = true;
        mom._ambigZone = true; // ambiguous time always means ambiguous zone
      } else if (parseZone) {
        // let's record the inputted zone somehow
        if (isAmbigZone) {
          mom._ambigZone = true;
        } else if (isSingleString) {
          if (mom.utcOffset) {
            mom.utcOffset(input); // if not a valid zone, will assign UTC
          } else {
            mom.zone(input); // for moment-pre-2.9
          }
        }
      }
    }

    mom._fullCalendar = true; // flag for extended functionality

    return mom;
  }

  // A clone method that works with the flags related to our enhanced functionality.
  // In the future, use moment.momentProperties
  newMomentProto.clone = function () {
    var mom = oldMomentProto.clone.apply(this, arguments);

    // these flags weren't transfered with the clone
    transferAmbigs(this, mom);
    if (this._fullCalendar) {
      mom._fullCalendar = true;
    }

    return mom;
  };

  // Week Number
  // -------------------------------------------------------------------------------------------------

  // Returns the week number, considering the locale's custom week number calcuation
  // `weeks` is an alias for `week`
  newMomentProto.week = newMomentProto.weeks = function (input) {
    var weekCalc = (this._locale || this._lang)._fullCalendar_weekCalc; // works pre-moment-2.8

    if (input == null && typeof weekCalc === 'function') {
      // custom function only works for getter
      return weekCalc(this);
    } else if (weekCalc === 'ISO') {
      return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
    }

    return oldMomentProto.week.apply(this, arguments); // local getter/setter
  };

  // Time-of-day
  // -------------------------------------------------------------------------------------------------

  // GETTER
  // Returns a Duration with the hours/minutes/seconds/ms values of the moment.
  // If the moment has an ambiguous time, a duration of 00:00 will be returned.
  //
  // SETTER
  // You can supply a Duration, a Moment, or a Duration-like argument.
  // When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
  newMomentProto.time = function (time) {
    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
    if (!this._fullCalendar) {
      return oldMomentProto.time.apply(this, arguments);
    }

    if (time == null) {
      // getter
      return moment.duration({
        hours: this.hours(),
        minutes: this.minutes(),
        seconds: this.seconds(),
        milliseconds: this.milliseconds(),
      });
    } else {
      // setter

      this._ambigTime = false; // mark that the moment now has a time

      if (!moment.isDuration(time) && !moment.isMoment(time)) {
        time = moment.duration(time);
      }

      // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
      // Only for Duration times, not Moment times.
      var dayHours = 0;
      if (moment.isDuration(time)) {
        dayHours = Math.floor(time.asDays()) * 24;
      }

      // We need to set the individual fields.
      // Can't use startOf('day') then add duration. In case of DST at start of day.
      return this.hours(dayHours + time.hours())
        .minutes(time.minutes())
        .seconds(time.seconds())
        .milliseconds(time.milliseconds());
    }
  };

  // Converts the moment to UTC, stripping out its time-of-day and timezone offset,
  // but preserving its YMD. A moment with a stripped time will display no time
  // nor timezone offset when .format() is called.
  newMomentProto.stripTime = function () {
    var a;

    if (!this._ambigTime) {
      // get the values before any conversion happens
      a = this.toArray(); // array of y/m/d/h/m/s/ms

      // TODO: use keepLocalTime in the future
      this.utc(); // set the internal UTC flag (will clear the ambig flags)
      setUTCValues(this, a.slice(0, 3)); // set the year/month/date. time will be zero

      // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
      // which clears all ambig flags. Same with setUTCValues with moment-timezone.
      this._ambigTime = true;
      this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
    }

    return this; // for chaining
  };

  // Returns if the moment has a non-ambiguous time (boolean)
  newMomentProto.hasTime = function () {
    return !this._ambigTime;
  };

  // Timezone
  // -------------------------------------------------------------------------------------------------

  // Converts the moment to UTC, stripping out its timezone offset, but preserving its
  // YMD and time-of-day. A moment with a stripped timezone offset will display no
  // timezone offset when .format() is called.
  // TODO: look into Moment's keepLocalTime functionality
  newMomentProto.stripZone = function () {
    var a, wasAmbigTime;

    if (!this._ambigZone) {
      // get the values before any conversion happens
      a = this.toArray(); // array of y/m/d/h/m/s/ms
      wasAmbigTime = this._ambigTime;

      this.utc(); // set the internal UTC flag (might clear the ambig flags, depending on Moment internals)
      setUTCValues(this, a); // will set the year/month/date/hours/minutes/seconds/ms

      // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
      this._ambigTime = wasAmbigTime || false;

      // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
      // which clears the ambig flags. Same with setUTCValues with moment-timezone.
      this._ambigZone = true;
    }

    return this; // for chaining
  };

  // Returns of the moment has a non-ambiguous timezone offset (boolean)
  newMomentProto.hasZone = function () {
    return !this._ambigZone;
  };

  // this method implicitly marks a zone
  newMomentProto.local = function () {
    var a = this.toArray(); // year,month,date,hours,minutes,seconds,ms as an array
    var wasAmbigZone = this._ambigZone;

    oldMomentProto.local.apply(this, arguments);

    // ensure non-ambiguous
    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;

    if (wasAmbigZone) {
      // If the moment was ambiguously zoned, the date fields were stored as UTC.
      // We want to preserve these, but in local time.
      // TODO: look into Moment's keepLocalTime functionality
      setLocalValues(this, a);
    }

    return this; // for chaining
  };

  // implicitly marks a zone
  newMomentProto.utc = function () {
    oldMomentProto.utc.apply(this, arguments);

    // ensure non-ambiguous
    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;

    return this;
  };

  // methods for arbitrarily manipulating timezone offset.
  // should clear time/zone ambiguity when called.
  $.each(
    [
      'zone', // only in moment-pre-2.9. deprecated afterwards
      'utcOffset',
    ],
    function (i, name) {
      if (oldMomentProto[name]) {
        // original method exists?

        // this method implicitly marks a zone (will probably get called upon .utc() and .local())
        newMomentProto[name] = function (tzo) {
          if (tzo != null) {
            // setter
            // these assignments needs to happen before the original zone method is called.
            // I forget why, something to do with a browser crash.
            this._ambigTime = false;
            this._ambigZone = false;
          }

          return oldMomentProto[name].apply(this, arguments);
        };
      }
    }
  );

  // Formatting
  // -------------------------------------------------------------------------------------------------

  newMomentProto.format = function () {
    if (this._fullCalendar && arguments[0]) {
      // an enhanced moment? and a format string provided?
      return formatDate(this, arguments[0]); // our extended formatting
    }
    if (this._ambigTime) {
      return oldMomentFormat(this, 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
      return oldMomentFormat(this, 'YYYY-MM-DD[T]HH:mm:ss');
    }
    return oldMomentProto.format.apply(this, arguments);
  };

  newMomentProto.toISOString = function () {
    if (this._ambigTime) {
      return oldMomentFormat(this, 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
      return oldMomentFormat(this, 'YYYY-MM-DD[T]HH:mm:ss');
    }
    return oldMomentProto.toISOString.apply(this, arguments);
  };

  // Querying
  // -------------------------------------------------------------------------------------------------

  // Is the moment within the specified range? `end` is exclusive.
  // FYI, this method is not a standard Moment method, so always do our enhanced logic.
  newMomentProto.isWithin = function (start, end) {
    var a = commonlyAmbiguate([this, start, end]);
    return a[0] >= a[1] && a[0] < a[2];
  };

  // When isSame is called with units, timezone ambiguity is normalized before the comparison happens.
  // If no units specified, the two moments must be identically the same, with matching ambig flags.
  newMomentProto.isSame = function (input, units) {
    var a;

    // only do custom logic if this is an enhanced moment
    if (!this._fullCalendar) {
      return oldMomentProto.isSame.apply(this, arguments);
    }

    if (units) {
      a = commonlyAmbiguate([this, input], true); // normalize timezones but don't erase times
      return oldMomentProto.isSame.call(a[0], a[1], units);
    } else {
      input = FC.moment.parseZone(input); // normalize input
      return (
        oldMomentProto.isSame.call(this, input) &&
        Boolean(this._ambigTime) === Boolean(input._ambigTime) &&
        Boolean(this._ambigZone) === Boolean(input._ambigZone)
      );
    }
  };

  // Make these query methods work with ambiguous moments
  $.each(['isBefore', 'isAfter'], function (i, methodName) {
    newMomentProto[methodName] = function (input, units) {
      var a;

      // only do custom logic if this is an enhanced moment
      if (!this._fullCalendar) {
        return oldMomentProto[methodName].apply(this, arguments);
      }

      a = commonlyAmbiguate([this, input]);
      return oldMomentProto[methodName].call(a[0], a[1], units);
    };
  });

  // Misc Internals
  // -------------------------------------------------------------------------------------------------

  // given an array of moment-like inputs, return a parallel array w/ moments similarly ambiguated.
  // for example, of one moment has ambig time, but not others, all moments will have their time stripped.
  // set `preserveTime` to `true` to keep times, but only normalize zone ambiguity.
  // returns the original moments if no modifications are necessary.
  function commonlyAmbiguate(inputs, preserveTime) {
    var anyAmbigTime = false;
    var anyAmbigZone = false;
    var len = inputs.length;
    var moms = [];
    var i, mom;

    // parse inputs into real moments and query their ambig flags
    for (i = 0; i < len; i++) {
      mom = inputs[i];
      if (!moment.isMoment(mom)) {
        mom = FC.moment.parseZone(mom);
      }
      anyAmbigTime = anyAmbigTime || mom._ambigTime;
      anyAmbigZone = anyAmbigZone || mom._ambigZone;
      moms.push(mom);
    }

    // strip each moment down to lowest common ambiguity
    // use clones to avoid modifying the original moments
    for (i = 0; i < len; i++) {
      mom = moms[i];
      if (!preserveTime && anyAmbigTime && !mom._ambigTime) {
        moms[i] = mom.clone().stripTime();
      } else if (anyAmbigZone && !mom._ambigZone) {
        moms[i] = mom.clone().stripZone();
      }
    }

    return moms;
  }

  // Transfers all the flags related to ambiguous time/zone from the `src` moment to the `dest` moment
  // TODO: look into moment.momentProperties for this.
  function transferAmbigs(src, dest) {
    if (src._ambigTime) {
      dest._ambigTime = true;
    } else if (dest._ambigTime) {
      dest._ambigTime = false;
    }

    if (src._ambigZone) {
      dest._ambigZone = true;
    } else if (dest._ambigZone) {
      dest._ambigZone = false;
    }
  }

  // Sets the year/month/date/etc values of the moment from the given array.
  // Inefficient because it calls each individual setter.
  function setMomentValues(mom, a) {
    mom
      .year(a[0] || 0)
      .month(a[1] || 0)
      .date(a[2] || 0)
      .hours(a[3] || 0)
      .minutes(a[4] || 0)
      .seconds(a[5] || 0)
      .milliseconds(a[6] || 0);
  }

  // Can we set the moment's internal date directly?
  allowValueOptimization = '_d' in moment() && 'updateOffset' in moment;

  // Utility function. Accepts a moment and an array of the UTC year/month/date/etc values to set.
  // Assumes the given moment is already in UTC mode.
  setUTCValues = allowValueOptimization
    ? function (mom, a) {
        // simlate what moment's accessors do
        mom._d.setTime(Date.UTC.apply(Date, a));
        moment.updateOffset(mom, false); // keepTime=false
      }
    : setMomentValues;

  // Utility function. Accepts a moment and an array of the local year/month/date/etc values to set.
  // Assumes the given moment is already in local mode.
  setLocalValues = allowValueOptimization
    ? function (mom, a) {
        // simlate what moment's accessors do
        mom._d.setTime(
          +new Date( // FYI, there is now way to apply an array of args to a constructor
            a[0] || 0,
            a[1] || 0,
            a[2] || 0,
            a[3] || 0,
            a[4] || 0,
            a[5] || 0,
            a[6] || 0
          )
        );
        moment.updateOffset(mom, false); // keepTime=false
      }
    : setMomentValues;

  // Single Date Formatting
  // -------------------------------------------------------------------------------------------------

  // call this if you want Moment's original format method to be used
  function oldMomentFormat(mom, formatStr) {
    return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
  }

  // Formats `date` with a Moment formatting string, but allow our non-zero areas and
  // additional token.
  function formatDate(date, formatStr) {
    return formatDateWithChunks(date, getFormatStringChunks(formatStr));
  }

  function formatDateWithChunks(date, chunks) {
    var s = '';
    var i;

    for (i = 0; i < chunks.length; i++) {
      s += formatDateWithChunk(date, chunks[i]);
    }

    return s;
  }

  // addition formatting tokens we want recognized
  var tokenOverrides = {
    t: function (date) {
      // "a" or "p"
      return oldMomentFormat(date, 'a').charAt(0);
    },
    T: function (date) {
      // "A" or "P"
      return oldMomentFormat(date, 'A').charAt(0);
    },
  };

  function formatDateWithChunk(date, chunk) {
    var token;
    var maybeStr;

    if (typeof chunk === 'string') {
      // a literal string
      return chunk;
    } else if ((token = chunk.token)) {
      // a token, like "YYYY"
      if (tokenOverrides[token]) {
        return tokenOverrides[token](date); // use our custom token
      }
      return oldMomentFormat(date, token);
    } else if (chunk.maybe) {
      // a grouping of other chunks that must be non-zero
      maybeStr = formatDateWithChunks(date, chunk.maybe);
      if (maybeStr.match(/[1-9]/)) {
        return maybeStr;
      }
    }

    return '';
  }

  // Date Range Formatting
  // -------------------------------------------------------------------------------------------------
  // TODO: make it work with timezone offset

  // Using a formatting string meant for a single date, generate a range string, like
  // "Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
  // If the dates are the same as far as the format string is concerned, just return a single
  // rendering of one date, without any separator.
  function formatRange(date1, date2, formatStr, separator, isRTL) {
    var localeData;

    date1 = FC.moment.parseZone(date1);
    date2 = FC.moment.parseZone(date2);

    localeData = (date1.localeData || date1.lang).call(date1); // works with moment-pre-2.8

    // Expand localized format strings, like "LL" -> "MMMM D YYYY"
    formatStr = localeData.longDateFormat(formatStr) || formatStr;
    // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
    // or non-zero areas in Moment's localized format strings.

    separator = separator || ' - ';

    return formatRangeWithChunks(
      date1,
      date2,
      getFormatStringChunks(formatStr),
      separator,
      isRTL
    );
  }
  FC.formatRange = formatRange; // expose

  function formatRangeWithChunks(date1, date2, chunks, separator, isRTL) {
    var unzonedDate1 = date1.clone().stripZone(); // for formatSimilarChunk
    var unzonedDate2 = date2.clone().stripZone(); // "
    var chunkStr; // the rendering of the chunk
    var leftI;
    var leftStr = '';
    var rightI;
    var rightStr = '';
    var middleI;
    var middleStr1 = '';
    var middleStr2 = '';
    var middleStr = '';

    // Start at the leftmost side of the formatting string and continue until you hit a token
    // that is not the same between dates.
    for (leftI = 0; leftI < chunks.length; leftI++) {
      chunkStr = formatSimilarChunk(
        date1,
        date2,
        unzonedDate1,
        unzonedDate2,
        chunks[leftI]
      );
      if (chunkStr === false) {
        break;
      }
      leftStr += chunkStr;
    }

    // Similarly, start at the rightmost side of the formatting string and move left
    for (rightI = chunks.length - 1; rightI > leftI; rightI--) {
      chunkStr = formatSimilarChunk(
        date1,
        date2,
        unzonedDate1,
        unzonedDate2,
        chunks[rightI]
      );
      if (chunkStr === false) {
        break;
      }
      rightStr = chunkStr + rightStr;
    }

    // The area in the middle is different for both of the dates.
    // Collect them distinctly so we can jam them together later.
    for (middleI = leftI; middleI <= rightI; middleI++) {
      middleStr1 += formatDateWithChunk(date1, chunks[middleI]);
      middleStr2 += formatDateWithChunk(date2, chunks[middleI]);
    }

    if (middleStr1 || middleStr2) {
      if (isRTL) {
        middleStr = middleStr2 + separator + middleStr1;
      } else {
        middleStr = middleStr1 + separator + middleStr2;
      }
    }

    return leftStr + middleStr + rightStr;
  }

  var similarUnitMap = {
    Y: 'year',
    M: 'month',
    D: 'day', // day of month
    d: 'day', // day of week
    // prevents a separator between anything time-related...
    A: 'second', // AM/PM
    a: 'second', // am/pm
    T: 'second', // A/P
    t: 'second', // a/p
    H: 'second', // hour (24)
    h: 'second', // hour (12)
    m: 'second', // minute
    s: 'second', // second
  };
  // TODO: week maybe?

  // Given a formatting chunk, and given that both dates are similar in the regard the
  // formatting chunk is concerned, format date1 against `chunk`. Otherwise, return `false`.
  function formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2, chunk) {
    var token;
    var unit;

    if (typeof chunk === 'string') {
      // a literal string
      return chunk;
    } else if ((token = chunk.token)) {
      unit = similarUnitMap[token.charAt(0)];

      // are the dates the same for this unit of measurement?
      // use the unzoned dates for this calculation because unreliable when near DST (bug #2396)
      if (unit && unzonedDate1.isSame(unzonedDate2, unit)) {
        return oldMomentFormat(date1, token); // would be the same if we used `date2`
        // BTW, don't support custom tokens
      }
    }

    return false; // the chunk is NOT the same for the two dates
    // BTW, don't support splitting on non-zero areas
  }

  // Chunking Utils
  // -------------------------------------------------------------------------------------------------

  var formatStringChunkCache = {};

  function getFormatStringChunks(formatStr) {
    if (formatStr in formatStringChunkCache) {
      return formatStringChunkCache[formatStr];
    }
    return (formatStringChunkCache[formatStr] = chunkFormatString(formatStr));
  }

  // Break the formatting string into an array of chunks
  function chunkFormatString(formatStr) {
    var chunks = [];
    var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g; // TODO: more descrimination
    var match;

    while ((match = chunker.exec(formatStr))) {
      if (match[1]) {
        // a literal string inside [ ... ]
        chunks.push(match[1]);
      } else if (match[2]) {
        // non-zero formatting inside ( ... )
        chunks.push({ maybe: chunkFormatString(match[2]) });
      } else if (match[3]) {
        // a formatting token
        chunks.push({ token: match[3] });
      } else if (match[5]) {
        // an unenclosed literal string
        chunks.push(match[5]);
      }
    }

    return chunks;
  }

  FC.Class = Class; // export

  // Class that all other classes will inherit from
  function Class() {}

  // Called on a class to create a subclass.
  // Last argument contains instance methods. Any argument before the last are considered mixins.
  Class.extend = function () {
    var len = arguments.length;
    var i;
    var members;

    for (i = 0; i < len; i++) {
      members = arguments[i];
      if (i < len - 1) {
        // not the last argument?
        mixIntoClass(this, members);
      }
    }

    return extendClass(this, members || {}); // members will be undefined if no arguments
  };

  // Adds new member variables/methods to the class's prototype.
  // Can be called with another class, or a plain object hash containing new members.
  Class.mixin = function (members) {
    mixIntoClass(this, members);
  };

  function extendClass(superClass, members) {
    var subClass;

    // ensure a constructor for the subclass, forwarding all arguments to the super-constructor if it doesn't exist
    if (hasOwnProp(members, 'constructor')) {
      subClass = members.constructor;
    }
    if (typeof subClass !== 'function') {
      subClass = members.constructor = function () {
        superClass.apply(this, arguments);
      };
    }

    // build the base prototype for the subclass, which is an new object chained to the superclass's prototype
    subClass.prototype = createObject(superClass.prototype);

    // copy each member variable/method onto the the subclass's prototype
    copyOwnProps(members, subClass.prototype);
    copyNativeMethods(members, subClass.prototype); // hack for IE8

    // copy over all class variables/methods to the subclass, such as `extend` and `mixin`
    copyOwnProps(superClass, subClass);

    return subClass;
  }

  function mixIntoClass(theClass, members) {
    copyOwnProps(members, theClass.prototype); // TODO: copyNativeMethods?
  }
  var EmitterMixin = (FC.EmitterMixin = {
    // jQuery-ification via $(this) allows a non-DOM object to have
    // the same event handling capabilities (including namespaces).

    on: function (types, handler) {
      // handlers are always called with an "event" object as their first param.
      // sneak the `this` context and arguments into the extra parameter object
      // and forward them on to the original handler.
      var intercept = function (ev, extra) {
        return handler.apply(extra.context || this, extra.args || []);
      };

      // mimick jQuery's internal "proxy" system (risky, I know)
      // causing all functions with the same .guid to appear to be the same.
      // https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
      // this is needed for calling .off with the original non-intercept handler.
      if (!handler.guid) {
        handler.guid = $.guid++;
      }
      intercept.guid = handler.guid;

      $(this).on(types, intercept);

      return this; // for chaining
    },

    off: function (types, handler) {
      $(this).off(types, handler);

      return this; // for chaining
    },

    trigger: function (types) {
      var args = Array.prototype.slice.call(arguments, 1); // arguments after the first

      // pass in "extra" info to the intercept
      $(this).triggerHandler(types, { args: args });

      return this; // for chaining
    },

    triggerWith: function (types, context, args) {
      // `triggerHandler` is less reliant on the DOM compared to `trigger`.
      // pass in "extra" info to the intercept.
      $(this).triggerHandler(types, { context: context, args: args });

      return this; // for chaining
    },
  });

  /*
Utility methods for easily listening to events on another object,
and more importantly, easily unlistening from them.
*/
  var ListenerMixin = (FC.ListenerMixin = (function () {
    var guid = 0;
    var ListenerMixin = {
      listenerId: null,

      /*
		Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
		The `callback` will be called with the `this` context of the object that .listenTo is being called on.
		Can be called:
			.listenTo(other, eventName, callback)
		OR
			.listenTo(other, {
				eventName1: callback1,
				eventName2: callback2
			})
		*/
      listenTo: function (other, arg, callback) {
        if (typeof arg === 'object') {
          // given dictionary of callbacks
          for (var eventName in arg) {
            if (arg.hasOwnProperty(eventName)) {
              this.listenTo(other, eventName, arg[eventName]);
            }
          }
        } else if (typeof arg === 'string') {
          other.on(
            arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
            $.proxy(callback, this) // always use `this` context
            // the usually-undesired jQuery guid behavior doesn't matter,
            // because we always unbind via namespace
          );
        }
      },

      /*
		Causes the current object to stop listening to events on the `other` object.
		`eventName` is optional. If omitted, will stop listening to ALL events on `other`.
		*/
      stopListeningTo: function (other, eventName) {
        other.off((eventName || '') + '.' + this.getListenerNamespace());
      },

      /*
		Returns a string, unique to this object, to be used for event namespacing
		*/
      getListenerNamespace: function () {
        if (this.listenerId == null) {
          this.listenerId = guid++;
        }
        return '_listener' + this.listenerId;
      },
    };
    return ListenerMixin;
  })());
  // simple class for toggle a `isIgnoringMouse` flag on delay
  // initMouseIgnoring must first be called, with a millisecond delay setting.
  var MouseIgnorerMixin = {
    isIgnoringMouse: false, // bool
    delayUnignoreMouse: null, // method

    initMouseIgnoring: function (delay) {
      this.delayUnignoreMouse = debounce(
        proxy(this, 'unignoreMouse'),
        delay || 1000
      );
    },

    // temporarily ignore mouse actions on segments
    tempIgnoreMouse: function () {
      this.isIgnoringMouse = true;
      this.delayUnignoreMouse();
    },

    // delayUnignoreMouse eventually calls this
    unignoreMouse: function () {
      this.isIgnoringMouse = false;
    },
  };

  /* A rectangular panel that is absolutely positioned over other content
------------------------------------------------------------------------------------------------------------------------
Options:
	- className (string)
	- content (HTML string or jQuery element set)
	- parentEl
	- top
	- left
	- right (the x coord of where the right edge should be. not a "CSS" right)
	- autoHide (boolean)
	- show (callback)
	- hide (callback)
*/

  var Popover = Class.extend(ListenerMixin, {
    isHidden: true,
    options: null,
    el: null, // the container element for the popover. generated by this object
    margin: 10, // the space required between the popover and the edges of the scroll container

    constructor: function (options) {
      this.options = options || {};
    },

    // Shows the popover on the specified position. Renders it if not already
    show: function () {
      if (this.isHidden) {
        if (!this.el) {
          this.render();
        }
        this.el.show();
        this.position();
        this.isHidden = false;
        this.trigger('show');
      }
    },

    // Hides the popover, through CSS, but does not remove it from the DOM
    hide: function () {
      if (!this.isHidden) {
        this.el.hide();
        this.isHidden = true;
        this.trigger('hide');
      }
    },

    // Creates `this.el` and renders content inside of it
    render: function () {
      var _this = this;
      var options = this.options;

      this.el = $('<div class="fc-popover"></div>')
        .addClass(options.className || '')
        .css({
          // position initially to the top left to avoid creating scrollbars
          top: 0,
          left: 0,
        })
        .append(options.content)
        .appendTo(options.parentEl);

      // when a click happens on anything inside with a 'fc-close' className, hide the popover
      this.el.on('click', '.fc-close', function () {
        _this.hide();
      });

      if (options.autoHide) {
        this.listenTo($(document), 'mousedown', this.documentMousedown);
      }
    },

    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
    documentMousedown: function (ev) {
      // only hide the popover if the click happened outside the popover
      if (this.el && !$(ev.target).closest(this.el).length) {
        this.hide();
      }
    },

    // Hides and unregisters any handlers
    removeElement: function () {
      this.hide();

      if (this.el) {
        this.el.remove();
        this.el = null;
      }

      this.stopListeningTo($(document), 'mousedown');
    },

    // Positions the popover optimally, using the top/left/right options
    position: function () {
      var options = this.options;
      var origin = this.el.offsetParent().offset();
      var width = this.el.outerWidth();
      var height = this.el.outerHeight();
      var windowEl = $(window);
      var viewportEl = getScrollParent(this.el);
      var viewportTop;
      var viewportLeft;
      var viewportOffset;
      var top; // the "position" (not "offset") values for the popover
      var left; //

      // compute top and left
      top = options.top || 0;
      if (options.left !== undefined) {
        left = options.left;
      } else if (options.right !== undefined) {
        left = options.right - width; // derive the left value from the right value
      } else {
        left = 0;
      }

      if (viewportEl.is(window) || viewportEl.is(document)) {
        // normalize getScrollParent's result
        viewportEl = windowEl;
        viewportTop = 0; // the window is always at the top left
        viewportLeft = 0; // (and .offset() won't work if called here)
      } else {
        viewportOffset = viewportEl.offset();
        viewportTop = viewportOffset.top;
        viewportLeft = viewportOffset.left;
      }

      // if the window is scrolled, it causes the visible area to be further down
      viewportTop += windowEl.scrollTop();
      viewportLeft += windowEl.scrollLeft();

      // constrain to the view port. if constrained by two edges, give precedence to top/left
      if (options.viewportConstrain !== false) {
        top = Math.min(
          top,
          viewportTop + viewportEl.outerHeight() - height - this.margin
        );
        top = Math.max(top, viewportTop + this.margin);
        left = Math.min(
          left,
          viewportLeft + viewportEl.outerWidth() - width - this.margin
        );
        left = Math.max(left, viewportLeft + this.margin);
      }

      this.el.css({
        top: top - origin.top,
        left: left - origin.left,
      });
    },

    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    // TODO: better code reuse for this. Repeat code
    trigger: function (name) {
      if (this.options[name]) {
        this.options[name].apply(
          this,
          Array.prototype.slice.call(arguments, 1)
        );
      }
    },
  });

  /*
A cache for the left/right/top/bottom/width/height values for one or more elements.
Works with both offset (from topleft document) and position (from offsetParent).

options:
- els
- isHorizontal
- isVertical
*/
  var CoordCache = (FC.CoordCache = Class.extend({
    els: null, // jQuery set (assumed to be siblings)
    forcedOffsetParentEl: null, // options can override the natural offsetParent
    origin: null, // {left,top} position of offsetParent of els
    boundingRect: null, // constrain cordinates to this rectangle. {left,right,top,bottom} or null
    isHorizontal: false, // whether to query for left/right/width
    isVertical: false, // whether to query for top/bottom/height

    // arrays of coordinates (offsets from topleft of document)
    lefts: null,
    rights: null,
    tops: null,
    bottoms: null,

    constructor: function (options) {
      this.els = $(options.els);
      this.isHorizontal = options.isHorizontal;
      this.isVertical = options.isVertical;
      this.forcedOffsetParentEl = options.offsetParent
        ? $(options.offsetParent)
        : null;
    },

    // Queries the els for coordinates and stores them.
    // Call this method before using and of the get* methods below.
    build: function () {
      var offsetParentEl =
        this.forcedOffsetParentEl || this.els.eq(0).offsetParent();

      this.origin = offsetParentEl.offset();
      this.boundingRect = this.queryBoundingRect();

      if (this.isHorizontal) {
        this.buildElHorizontals();
      }
      if (this.isVertical) {
        this.buildElVerticals();
      }
    },

    // Destroys all internal data about coordinates, freeing memory
    clear: function () {
      this.origin = null;
      this.boundingRect = null;
      this.lefts = null;
      this.rights = null;
      this.tops = null;
      this.bottoms = null;
    },

    // When called, if coord caches aren't built, builds them
    ensureBuilt: function () {
      if (!this.origin) {
        this.build();
      }
    },

    // Populates the left/right internal coordinate arrays
    buildElHorizontals: function () {
      var lefts = [];
      var rights = [];

      this.els.each(function (i, node) {
        var el = $(node);
        var left = el.offset().left;
        var width = el.outerWidth();

        lefts.push(left);
        rights.push(left + width);
      });

      this.lefts = lefts;
      this.rights = rights;
    },

    // Populates the top/bottom internal coordinate arrays
    buildElVerticals: function () {
      var tops = [];
      var bottoms = [];

      this.els.each(function (i, node) {
        var el = $(node);
        var top = el.offset().top;
        var height = el.outerHeight();

        tops.push(top);
        bottoms.push(top + height);
      });

      this.tops = tops;
      this.bottoms = bottoms;
    },

    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    getHorizontalIndex: function (leftOffset) {
      this.ensureBuilt();

      var lefts = this.lefts;
      var rights = this.rights;
      var len = lefts.length;
      var i;

      for (i = 0; i < len; i++) {
        if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
          return i;
        }
      }
    },

    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    getVerticalIndex: function (topOffset) {
      this.ensureBuilt();

      var tops = this.tops;
      var bottoms = this.bottoms;
      var len = tops.length;
      var i;

      for (i = 0; i < len; i++) {
        if (topOffset >= tops[i] && topOffset < bottoms[i]) {
          return i;
        }
      }
    },

    // Gets the left offset (from document left) of the element at the given index
    getLeftOffset: function (leftIndex) {
      this.ensureBuilt();
      return this.lefts[leftIndex];
    },

    // Gets the left position (from offsetParent left) of the element at the given index
    getLeftPosition: function (leftIndex) {
      this.ensureBuilt();
      return this.lefts[leftIndex] - this.origin.left;
    },

    // Gets the right offset (from document left) of the element at the given index.
    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
    getRightOffset: function (leftIndex) {
      this.ensureBuilt();
      return this.rights[leftIndex];
    },

    // Gets the right position (from offsetParent left) of the element at the given index.
    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
    getRightPosition: function (leftIndex) {
      this.ensureBuilt();
      return this.rights[leftIndex] - this.origin.left;
    },

    // Gets the width of the element at the given index
    getWidth: function (leftIndex) {
      this.ensureBuilt();
      return this.rights[leftIndex] - this.lefts[leftIndex];
    },

    // Gets the top offset (from document top) of the element at the given index
    getTopOffset: function (topIndex) {
      this.ensureBuilt();
      return this.tops[topIndex];
    },

    // Gets the top position (from offsetParent top) of the element at the given position
    getTopPosition: function (topIndex) {
      this.ensureBuilt();
      return this.tops[topIndex] - this.origin.top;
    },

    // Gets the bottom offset (from the document top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    getBottomOffset: function (topIndex) {
      this.ensureBuilt();
      return this.bottoms[topIndex];
    },

    // Gets the bottom position (from the offsetParent top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    getBottomPosition: function (topIndex) {
      this.ensureBuilt();
      return this.bottoms[topIndex] - this.origin.top;
    },

    // Gets the height of the element at the given index
    getHeight: function (topIndex) {
      this.ensureBuilt();
      return this.bottoms[topIndex] - this.tops[topIndex];
    },

    // Bounding Rect
    // TODO: decouple this from CoordCache

    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
    queryBoundingRect: function () {
      var scrollParentEl = getScrollParent(this.els.eq(0));

      if (!scrollParentEl.is(document)) {
        return getClientRect(scrollParentEl);
      }
    },

    isPointInBounds: function (leftOffset, topOffset) {
      return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
    },

    isLeftInBounds: function (leftOffset) {
      return (
        !this.boundingRect ||
        (leftOffset >= this.boundingRect.left &&
          leftOffset < this.boundingRect.right)
      );
    },

    isTopInBounds: function (topOffset) {
      return (
        !this.boundingRect ||
        (topOffset >= this.boundingRect.top &&
          topOffset < this.boundingRect.bottom)
      );
    },
  }));

  /* Tracks a drag's mouse movement, firing various handlers
----------------------------------------------------------------------------------------------------------------------*/
  // TODO: use Emitter

  var DragListener = (FC.DragListener = Class.extend(
    ListenerMixin,
    MouseIgnorerMixin,
    {
      options: null,

      // for IE8 bug-fighting behavior
      subjectEl: null,
      subjectHref: null,

      // coordinates of the initial mousedown
      originX: null,
      originY: null,

      // the wrapping element that scrolls, or MIGHT scroll if there's overflow.
      // TODO: do this for wrappers that have overflow:hidden as well.
      scrollEl: null,

      isInteracting: false,
      isDistanceSurpassed: false,
      isDelayEnded: false,
      isDragging: false,
      isTouch: false,

      delay: null,
      delayTimeoutId: null,
      minDistance: null,

      handleTouchScrollProxy: null, // calls handleTouchScroll, always bound to `this`

      constructor: function (options) {
        this.options = options || {};
        this.handleTouchScrollProxy = proxy(this, 'handleTouchScroll');
        this.initMouseIgnoring(500);
      },

      // Interaction (high-level)
      // -----------------------------------------------------------------------------------------------------------------

      startInteraction: function (ev, extraOptions) {
        var isTouch = getEvIsTouch(ev);

        if (ev.type === 'mousedown') {
          if (this.isIgnoringMouse) {
            return;
          } else if (!isPrimaryMouseButton(ev)) {
            return;
          } else {
            ev.preventDefault(); // prevents native selection in most browsers
          }
        }

        if (!this.isInteracting) {
          // process options
          extraOptions = extraOptions || {};
          this.delay = firstDefined(extraOptions.delay, this.options.delay, 0);
          this.minDistance = firstDefined(
            extraOptions.distance,
            this.options.distance,
            0
          );
          this.subjectEl = this.options.subjectEl;

          this.isInteracting = true;
          this.isTouch = isTouch;
          this.isDelayEnded = false;
          this.isDistanceSurpassed = false;

          this.originX = getEvX(ev);
          this.originY = getEvY(ev);
          this.scrollEl = getScrollParent($(ev.target));

          this.bindHandlers();
          this.initAutoScroll();
          this.handleInteractionStart(ev);
          this.startDelay(ev);

          if (!this.minDistance) {
            this.handleDistanceSurpassed(ev);
          }
        }
      },

      handleInteractionStart: function (ev) {
        this.trigger('interactionStart', ev);
      },

      endInteraction: function (ev, isCancelled) {
        if (this.isInteracting) {
          this.endDrag(ev);

          if (this.delayTimeoutId) {
            clearTimeout(this.delayTimeoutId);
            this.delayTimeoutId = null;
          }

          this.destroyAutoScroll();
          this.unbindHandlers();

          this.isInteracting = false;
          this.handleInteractionEnd(ev, isCancelled);

          // a touchstart+touchend on the same element will result in the following addition simulated events:
          // mouseover + mouseout + click
          // let's ignore these bogus events
          if (this.isTouch) {
            this.tempIgnoreMouse();
          }
        }
      },

      handleInteractionEnd: function (ev, isCancelled) {
        this.trigger('interactionEnd', ev, isCancelled || false);
      },

      // Binding To DOM
      // -----------------------------------------------------------------------------------------------------------------

      bindHandlers: function () {
        var _this = this;
        var touchStartIgnores = 1;

        if (this.isTouch) {
          this.listenTo($(document), {
            touchmove: this.handleTouchMove,
            touchend: this.endInteraction,
            touchcancel: this.endInteraction,

            // Sometimes touchend doesn't fire
            // (can't figure out why. touchcancel doesn't fire either. has to do with scrolling?)
            // If another touchstart happens, we know it's bogus, so cancel the drag.
            // touchend will continue to be broken until user does a shorttap/scroll, but this is best we can do.
            touchstart: function (ev) {
              if (touchStartIgnores) {
                // bindHandlers is called from within a touchstart,
                touchStartIgnores--; // and we don't want this to fire immediately, so ignore.
              } else {
                _this.endInteraction(ev, true); // isCancelled=true
              }
            },
          });

          // listen to ALL scroll actions on the page
          if (
            !bindAnyScroll(this.handleTouchScrollProxy) && // hopefully this works and short-circuits the rest
            this.scrollEl // otherwise, attach a single handler to this
          ) {
            this.listenTo(this.scrollEl, 'scroll', this.handleTouchScroll);
          }
        } else {
          this.listenTo($(document), {
            mousemove: this.handleMouseMove,
            mouseup: this.endInteraction,
          });
        }

        this.listenTo($(document), {
          selectstart: preventDefault, // don't allow selection while dragging
          contextmenu: preventDefault, // long taps would open menu on Chrome dev tools
        });
      },

      unbindHandlers: function () {
        this.stopListeningTo($(document));

        // unbind scroll listening
        unbindAnyScroll(this.handleTouchScrollProxy);
        if (this.scrollEl) {
          this.stopListeningTo(this.scrollEl, 'scroll');
        }
      },

      // Drag (high-level)
      // -----------------------------------------------------------------------------------------------------------------

      // extraOptions ignored if drag already started
      startDrag: function (ev, extraOptions) {
        this.startInteraction(ev, extraOptions); // ensure interaction began

        if (!this.isDragging) {
          this.isDragging = true;
          this.handleDragStart(ev);
        }
      },

      handleDragStart: function (ev) {
        this.trigger('dragStart', ev);
        this.initHrefHack();
      },

      handleMove: function (ev) {
        var dx = getEvX(ev) - this.originX;
        var dy = getEvY(ev) - this.originY;
        var minDistance = this.minDistance;
        var distanceSq; // current distance from the origin, squared

        if (!this.isDistanceSurpassed) {
          distanceSq = dx * dx + dy * dy;
          if (distanceSq >= minDistance * minDistance) {
            // use pythagorean theorem
            this.handleDistanceSurpassed(ev);
          }
        }

        if (this.isDragging) {
          this.handleDrag(dx, dy, ev);
        }
      },

      // Called while the mouse is being moved and when we know a legitimate drag is taking place
      handleDrag: function (dx, dy, ev) {
        this.trigger('drag', dx, dy, ev);
        this.updateAutoScroll(ev); // will possibly cause scrolling
      },

      endDrag: function (ev) {
        if (this.isDragging) {
          this.isDragging = false;
          this.handleDragEnd(ev);
        }
      },

      handleDragEnd: function (ev) {
        this.trigger('dragEnd', ev);
        this.destroyHrefHack();
      },

      // Delay
      // -----------------------------------------------------------------------------------------------------------------

      startDelay: function (initialEv) {
        var _this = this;

        if (this.delay) {
          this.delayTimeoutId = setTimeout(function () {
            _this.handleDelayEnd(initialEv);
          }, this.delay);
        } else {
          this.handleDelayEnd(initialEv);
        }
      },

      handleDelayEnd: function (initialEv) {
        this.isDelayEnded = true;

        if (this.isDistanceSurpassed) {
          this.startDrag(initialEv);
        }
      },

      // Distance
      // -----------------------------------------------------------------------------------------------------------------

      handleDistanceSurpassed: function (ev) {
        this.isDistanceSurpassed = true;

        if (this.isDelayEnded) {
          this.startDrag(ev);
        }
      },

      // Mouse / Touch
      // -----------------------------------------------------------------------------------------------------------------

      handleTouchMove: function (ev) {
        // prevent inertia and touchmove-scrolling while dragging
        if (this.isDragging) {
          ev.preventDefault();
        }

        this.handleMove(ev);
      },

      handleMouseMove: function (ev) {
        this.handleMove(ev);
      },

      // Scrolling (unrelated to auto-scroll)
      // -----------------------------------------------------------------------------------------------------------------

      handleTouchScroll: function (ev) {
        // if the drag is being initiated by touch, but a scroll happens before
        // the drag-initiating delay is over, cancel the drag
        if (!this.isDragging) {
          this.endInteraction(ev, true); // isCancelled=true
        }
      },

      // <A> HREF Hack
      // -----------------------------------------------------------------------------------------------------------------

      initHrefHack: function () {
        var subjectEl = this.subjectEl;

        // remove a mousedown'd <a>'s href so it is not visited (IE8 bug)
        if ((this.subjectHref = subjectEl ? subjectEl.attr('href') : null)) {
          subjectEl.removeAttr('href');
        }
      },

      destroyHrefHack: function () {
        var subjectEl = this.subjectEl;
        var subjectHref = this.subjectHref;

        // restore a mousedown'd <a>'s href (for IE8 bug)
        setTimeout(function () {
          // must be outside of the click's execution
          if (subjectHref) {
            subjectEl.attr('href', subjectHref);
          }
        }, 0);
      },

      // Utils
      // -----------------------------------------------------------------------------------------------------------------

      // Triggers a callback. Calls a function in the option hash of the same name.
      // Arguments beyond the first `name` are forwarded on.
      trigger: function (name) {
        if (this.options[name]) {
          this.options[name].apply(
            this,
            Array.prototype.slice.call(arguments, 1)
          );
        }
        // makes _methods callable by event name. TODO: kill this
        if (this['_' + name]) {
          this['_' + name].apply(
            this,
            Array.prototype.slice.call(arguments, 1)
          );
        }
      },
    }
  ));

  /*
this.scrollEl is set in DragListener
*/
  DragListener.mixin({
    isAutoScroll: false,

    scrollBounds: null, // { top, bottom, left, right }
    scrollTopVel: null, // pixels per second
    scrollLeftVel: null, // pixels per second
    scrollIntervalId: null, // ID of setTimeout for scrolling animation loop

    // defaults
    scrollSensitivity: 30, // pixels from edge for scrolling to start
    scrollSpeed: 200, // pixels per second, at maximum speed
    scrollIntervalMs: 50, // millisecond wait between scroll increment

    initAutoScroll: function () {
      var scrollEl = this.scrollEl;

      this.isAutoScroll =
        this.options.scroll &&
        scrollEl &&
        !scrollEl.is(window) &&
        !scrollEl.is(document);

      if (this.isAutoScroll) {
        // debounce makes sure rapid calls don't happen
        this.listenTo(
          scrollEl,
          'scroll',
          debounce(this.handleDebouncedScroll, 100)
        );
      }
    },

    destroyAutoScroll: function () {
      this.endAutoScroll(); // kill any animation loop

      // remove the scroll handler if there is a scrollEl
      if (this.isAutoScroll) {
        this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
      }
    },

    // Computes and stores the bounding rectangle of scrollEl
    computeScrollBounds: function () {
      if (this.isAutoScroll) {
        this.scrollBounds = getOuterRect(this.scrollEl);
        // TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
      }
    },

    // Called when the dragging is in progress and scrolling should be updated
    updateAutoScroll: function (ev) {
      var sensitivity = this.scrollSensitivity;
      var bounds = this.scrollBounds;
      var topCloseness, bottomCloseness;
      var leftCloseness, rightCloseness;
      var topVel = 0;
      var leftVel = 0;

      if (bounds) {
        // only scroll if scrollEl exists

        // compute closeness to edges. valid range is from 0.0 - 1.0
        topCloseness = (sensitivity - (getEvY(ev) - bounds.top)) / sensitivity;
        bottomCloseness =
          (sensitivity - (bounds.bottom - getEvY(ev))) / sensitivity;
        leftCloseness =
          (sensitivity - (getEvX(ev) - bounds.left)) / sensitivity;
        rightCloseness =
          (sensitivity - (bounds.right - getEvX(ev))) / sensitivity;

        // translate vertical closeness into velocity.
        // mouse must be completely in bounds for velocity to happen.
        if (topCloseness >= 0 && topCloseness <= 1) {
          topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
        } else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
          topVel = bottomCloseness * this.scrollSpeed;
        }

        // translate horizontal closeness into velocity
        if (leftCloseness >= 0 && leftCloseness <= 1) {
          leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
        } else if (rightCloseness >= 0 && rightCloseness <= 1) {
          leftVel = rightCloseness * this.scrollSpeed;
        }
      }

      this.setScrollVel(topVel, leftVel);
    },

    // Sets the speed-of-scrolling for the scrollEl
    setScrollVel: function (topVel, leftVel) {
      this.scrollTopVel = topVel;
      this.scrollLeftVel = leftVel;

      this.constrainScrollVel(); // massages into realistic values

      // if there is non-zero velocity, and an animation loop hasn't already started, then START
      if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
        this.scrollIntervalId = setInterval(
          proxy(this, 'scrollIntervalFunc'), // scope to `this`
          this.scrollIntervalMs
        );
      }
    },

    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
    constrainScrollVel: function () {
      var el = this.scrollEl;

      if (this.scrollTopVel < 0) {
        // scrolling up?
        if (el.scrollTop() <= 0) {
          // already scrolled all the way up?
          this.scrollTopVel = 0;
        }
      } else if (this.scrollTopVel > 0) {
        // scrolling down?
        if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) {
          // already scrolled all the way down?
          this.scrollTopVel = 0;
        }
      }

      if (this.scrollLeftVel < 0) {
        // scrolling left?
        if (el.scrollLeft() <= 0) {
          // already scrolled all the left?
          this.scrollLeftVel = 0;
        }
      } else if (this.scrollLeftVel > 0) {
        // scrolling right?
        if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) {
          // already scrolled all the way right?
          this.scrollLeftVel = 0;
        }
      }
    },

    // This function gets called during every iteration of the scrolling animation loop
    scrollIntervalFunc: function () {
      var el = this.scrollEl;
      var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by

      // change the value of scrollEl's scroll
      if (this.scrollTopVel) {
        el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
      }
      if (this.scrollLeftVel) {
        el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
      }

      this.constrainScrollVel(); // since the scroll values changed, recompute the velocities

      // if scrolled all the way, which causes the vels to be zero, stop the animation loop
      if (!this.scrollTopVel && !this.scrollLeftVel) {
        this.endAutoScroll();
      }
    },

    // Kills any existing scrolling animation loop
    endAutoScroll: function () {
      if (this.scrollIntervalId) {
        clearInterval(this.scrollIntervalId);
        this.scrollIntervalId = null;

        this.handleScrollEnd();
      }
    },

    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
    handleDebouncedScroll: function () {
      // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
      if (!this.scrollIntervalId) {
        this.handleScrollEnd();
      }
    },

    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    handleScrollEnd: function () {},
  });
  /* Tracks mouse movements over a component and raises events about which hit the mouse is over.
------------------------------------------------------------------------------------------------------------------------
options:
- subjectEl
- subjectCenter
*/

  var HitDragListener = DragListener.extend({
    component: null, // converts coordinates to hits
    // methods: prepareHits, releaseHits, queryHit

    origHit: null, // the hit the mouse was over when listening started
    hit: null, // the hit the mouse is over
    coordAdjust: null, // delta that will be added to the mouse coordinates when computing collisions

    constructor: function (component, options) {
      DragListener.call(this, options); // call the super-constructor

      this.component = component;
    },

    // Called when drag listening starts (but a real drag has not necessarily began).
    // ev might be undefined if dragging was started manually.
    handleInteractionStart: function (ev) {
      var subjectEl = this.subjectEl;
      var subjectRect;
      var origPoint;
      var point;

      this.computeCoords();

      if (ev) {
        origPoint = { left: getEvX(ev), top: getEvY(ev) };
        point = origPoint;

        // constrain the point to bounds of the element being dragged
        if (subjectEl) {
          subjectRect = getOuterRect(subjectEl); // used for centering as well
          point = constrainPoint(point, subjectRect);
        }

        this.origHit = this.queryHit(point.left, point.top);

        // treat the center of the subject as the collision point?
        if (subjectEl && this.options.subjectCenter) {
          // only consider the area the subject overlaps the hit. best for large subjects.
          // TODO: skip this if hit didn't supply left/right/top/bottom
          if (this.origHit) {
            subjectRect =
              intersectRects(this.origHit, subjectRect) || subjectRect; // in case there is no intersection
          }

          point = getRectCenter(subjectRect);
        }

        this.coordAdjust = diffPoints(point, origPoint); // point - origPoint
      } else {
        this.origHit = null;
        this.coordAdjust = null;
      }

      // call the super-method. do it after origHit has been computed
      DragListener.prototype.handleInteractionStart.apply(this, arguments);
    },

    // Recomputes the drag-critical positions of elements
    computeCoords: function () {
      this.component.prepareHits();
      this.computeScrollBounds(); // why is this here??????
    },

    // Called when the actual drag has started
    handleDragStart: function (ev) {
      var hit;

      DragListener.prototype.handleDragStart.apply(this, arguments); // call the super-method

      // might be different from this.origHit if the min-distance is large
      hit = this.queryHit(getEvX(ev), getEvY(ev));

      // report the initial hit the mouse is over
      // especially important if no min-distance and drag starts immediately
      if (hit) {
        this.handleHitOver(hit);
      }
    },

    // Called when the drag moves
    handleDrag: function (dx, dy, ev) {
      var hit;

      DragListener.prototype.handleDrag.apply(this, arguments); // call the super-method

      hit = this.queryHit(getEvX(ev), getEvY(ev));

      if (!isHitsEqual(hit, this.hit)) {
        // a different hit than before?
        if (this.hit) {
          this.handleHitOut();
        }
        if (hit) {
          this.handleHitOver(hit);
        }
      }
    },

    // Called when dragging has been stopped
    handleDragEnd: function () {
      this.handleHitDone();
      DragListener.prototype.handleDragEnd.apply(this, arguments); // call the super-method
    },

    // Called when a the mouse has just moved over a new hit
    handleHitOver: function (hit) {
      var isOrig = isHitsEqual(hit, this.origHit);

      this.hit = hit;

      this.trigger('hitOver', this.hit, isOrig, this.origHit);
    },

    // Called when the mouse has just moved out of a hit
    handleHitOut: function () {
      if (this.hit) {
        this.trigger('hitOut', this.hit);
        this.handleHitDone();
        this.hit = null;
      }
    },

    // Called after a hitOut. Also called before a dragStop
    handleHitDone: function () {
      if (this.hit) {
        this.trigger('hitDone', this.hit);
      }
    },

    // Called when the interaction ends, whether there was a real drag or not
    handleInteractionEnd: function () {
      DragListener.prototype.handleInteractionEnd.apply(this, arguments); // call the super-method

      this.origHit = null;
      this.hit = null;

      this.component.releaseHits();
    },

    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    handleScrollEnd: function () {
      DragListener.prototype.handleScrollEnd.apply(this, arguments); // call the super-method

      this.computeCoords(); // hits' absolute positions will be in new places. recompute
    },

    // Gets the hit underneath the coordinates for the given mouse event
    queryHit: function (left, top) {
      if (this.coordAdjust) {
        left += this.coordAdjust.left;
        top += this.coordAdjust.top;
      }

      return this.component.queryHit(left, top);
    },
  });

  // Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
  // Two null values will be considered equal, as two "out of the component" states are the same.
  function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
      return true;
    }

    if (hit0 && hit1) {
      return (
        hit0.component === hit1.component &&
        isHitPropsWithin(hit0, hit1) &&
        isHitPropsWithin(hit1, hit0)
      ); // ensures all props are identical
    }

    return false;
  }

  // Returns true if all of subHit's non-standard properties are within superHit
  function isHitPropsWithin(subHit, superHit) {
    for (var propName in subHit) {
      if (!/^(component|left|right|top|bottom)$/.test(propName)) {
        if (subHit[propName] !== superHit[propName]) {
          return false;
        }
      }
    }
    return true;
  }

  /* Creates a clone of an element and lets it track the mouse as it moves
----------------------------------------------------------------------------------------------------------------------*/

  var MouseFollower = Class.extend(ListenerMixin, {
    options: null,

    sourceEl: null, // the element that will be cloned and made to look like it is dragging
    el: null, // the clone of `sourceEl` that will track the mouse
    parentEl: null, // the element that `el` (the clone) will be attached to

    // the initial position of el, relative to the offset parent. made to match the initial offset of sourceEl
    top0: null,
    left0: null,

    // the absolute coordinates of the initiating touch/mouse action
    y0: null,
    x0: null,

    // the number of pixels the mouse has moved from its initial position
    topDelta: null,
    leftDelta: null,

    isFollowing: false,
    isHidden: false,
    isAnimating: false, // doing the revert animation?

    constructor: function (sourceEl, options) {
      this.options = options = options || {};
      this.sourceEl = sourceEl;
      this.parentEl = options.parentEl
        ? $(options.parentEl)
        : sourceEl.parent(); // default to sourceEl's parent
    },

    // Causes the element to start following the mouse
    start: function (ev) {
      if (!this.isFollowing) {
        this.isFollowing = true;

        this.y0 = getEvY(ev);
        this.x0 = getEvX(ev);
        this.topDelta = 0;
        this.leftDelta = 0;

        if (!this.isHidden) {
          this.updatePosition();
        }

        if (getEvIsTouch(ev)) {
          this.listenTo($(document), 'touchmove', this.handleMove);
        } else {
          this.listenTo($(document), 'mousemove', this.handleMove);
        }
      }
    },

    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
    stop: function (shouldRevert, callback) {
      var _this = this;
      var revertDuration = this.options.revertDuration;

      function complete() {
        // might be called by .animate(), which might change `this` context
        _this.isAnimating = false;
        _this.removeElement();

        _this.top0 = _this.left0 = null; // reset state for future updatePosition calls

        if (callback) {
          callback();
        }
      }

      if (this.isFollowing && !this.isAnimating) {
        // disallow more than one stop animation at a time
        this.isFollowing = false;

        this.stopListeningTo($(document));

        if (shouldRevert && revertDuration && !this.isHidden) {
          // do a revert animation?
          this.isAnimating = true;
          this.el.animate(
            {
              top: this.top0,
              left: this.left0,
            },
            {
              duration: revertDuration,
              complete: complete,
            }
          );
        } else {
          complete();
        }
      }
    },

    // Gets the tracking element. Create it if necessary
    getEl: function () {
      var el = this.el;

      if (!el) {
        this.sourceEl.width(); // hack to force IE8 to compute correct bounding box
        el = this.el = this.sourceEl
          .clone()
          .addClass(this.options.additionalClass || '')
          .css({
            position: 'absolute',
            visibility: '', // in case original element was hidden (commonly through hideEvents())
            display: this.isHidden ? 'none' : '', // for when initially hidden
            margin: 0,
            right: 'auto', // erase and set width instead
            bottom: 'auto', // erase and set height instead
            width: this.sourceEl.width(), // explicit height in case there was a 'right' value
            height: this.sourceEl.height(), // explicit width in case there was a 'bottom' value
            opacity: this.options.opacity || '',
            zIndex: this.options.zIndex,
          });

        // we don't want long taps or any mouse interaction causing selection/menus.
        // would use preventSelection(), but that prevents selectstart, causing problems.
        el.addClass('fc-unselectable');

        el.appendTo(this.parentEl);
      }

      return el;
    },

    // Removes the tracking element if it has already been created
    removeElement: function () {
      if (this.el) {
        this.el.remove();
        this.el = null;
      }
    },

    // Update the CSS position of the tracking element
    updatePosition: function () {
      var sourceOffset;
      var origin;

      this.getEl(); // ensure this.el

      // make sure origin info was computed
      if (this.top0 === null) {
        this.sourceEl.width(); // hack to force IE8 to compute correct bounding box
        sourceOffset = this.sourceEl.offset();
        origin = this.el.offsetParent().offset();
        this.top0 = sourceOffset.top - origin.top;
        this.left0 = sourceOffset.left - origin.left;
      }

      this.el.css({
        top: this.top0 + this.topDelta,
        left: this.left0 + this.leftDelta,
      });
    },

    // Gets called when the user moves the mouse
    handleMove: function (ev) {
      this.topDelta = getEvY(ev) - this.y0;
      this.leftDelta = getEvX(ev) - this.x0;

      if (!this.isHidden) {
        this.updatePosition();
      }
    },

    // Temporarily makes the tracking element invisible. Can be called before following starts
    hide: function () {
      if (!this.isHidden) {
        this.isHidden = true;
        if (this.el) {
          this.el.hide();
        }
      }
    },

    // Show the tracking element after it has been temporarily hidden
    show: function () {
      if (this.isHidden) {
        this.isHidden = false;
        this.updatePosition();
        this.getEl().show();
      }
    },
  });

  /* An abstract class comprised of a "grid" of areas that each represent a specific datetime
----------------------------------------------------------------------------------------------------------------------*/

  var Grid = (FC.Grid = Class.extend(ListenerMixin, MouseIgnorerMixin, {
    view: null, // a View object
    isRTL: null, // shortcut to the view's isRTL option

    start: null,
    end: null,

    el: null, // the containing element
    elsByFill: null, // a hash of jQuery element sets used for rendering each fill. Keyed by fill name.

    // derived from options
    eventTimeFormat: null,
    displayEventTime: null,
    displayEventEnd: null,

    minResizeDuration: null, // TODO: hack. set by subclasses. minumum event resize duration

    // if defined, holds the unit identified (ex: "year" or "month") that determines the level of granularity
    // of the date areas. if not defined, assumes to be day and time granularity.
    // TODO: port isTimeScale into same system?
    largeUnit: null,

    dayDragListener: null,
    segDragListener: null,
    segResizeListener: null,
    externalDragListener: null,

    constructor: function (view) {
      this.view = view;
      this.isRTL = view.opt('isRTL');
      this.elsByFill = {};

      this.dayDragListener = this.buildDayDragListener();
      this.initMouseIgnoring();
    },

    /* Options
	------------------------------------------------------------------------------------------------------------------*/

    // Generates the format string used for event time text, if not explicitly defined by 'timeFormat'
    computeEventTimeFormat: function () {
      return this.view.opt('smallTimeFormat');
    },

    // Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventTime'.
    // Only applies to non-all-day events.
    computeDisplayEventTime: function () {
      return true;
    },

    // Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventEnd'
    computeDisplayEventEnd: function () {
      return true;
    },

    /* Dates
	------------------------------------------------------------------------------------------------------------------*/

    // Tells the grid about what period of time to display.
    // Any date-related internal data should be generated.
    setRange: function (range) {
      this.start = range.start.clone();
      this.end = range.end.clone();

      this.rangeUpdated();
      this.processRangeOptions();
    },

    // Called when internal variables that rely on the range should be updated
    rangeUpdated: function () {},

    // Updates values that rely on options and also relate to range
    processRangeOptions: function () {
      var view = this.view;
      var displayEventTime;
      var displayEventEnd;

      this.eventTimeFormat =
        view.opt('eventTimeFormat') ||
        view.opt('timeFormat') || // deprecated
        this.computeEventTimeFormat();

      displayEventTime = view.opt('displayEventTime');
      if (displayEventTime == null) {
        displayEventTime = this.computeDisplayEventTime(); // might be based off of range
      }

      displayEventEnd = view.opt('displayEventEnd');
      if (displayEventEnd == null) {
        displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
      }

      this.displayEventTime = displayEventTime;
      this.displayEventEnd = displayEventEnd;
    },

    // Converts a span (has unzoned start/end and any other grid-specific location information)
    // into an array of segments (pieces of events whose format is decided by the grid).
    spanToSegs: function (span) {
      // subclasses must implement
    },

    // Diffs the two dates, returning a duration, based on granularity of the grid
    // TODO: port isTimeScale into this system?
    diffDates: function (a, b) {
      if (this.largeUnit) {
        return diffByUnit(a, b, this.largeUnit);
      } else {
        return diffDayTime(a, b);
      }
    },

    /* Hit Area
	------------------------------------------------------------------------------------------------------------------*/

    // Called before one or more queryHit calls might happen. Should prepare any cached coordinates for queryHit
    prepareHits: function () {},

    // Called when queryHit calls have subsided. Good place to clear any coordinate caches.
    releaseHits: function () {},

    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
    // The returned object will be processed by getHitSpan and getHitEl.
    queryHit: function (leftOffset, topOffset) {},

    // Given position-level information about a date-related area within the grid,
    // should return an object with at least a start/end date. Can provide other information as well.
    getHitSpan: function (hit) {},

    // Given position-level information about a date-related area within the grid,
    // should return a jQuery element that best represents it. passed to dayClick callback.
    getHitEl: function (hit) {},

    /* Rendering
	------------------------------------------------------------------------------------------------------------------*/

    // Sets the container element that the grid should render inside of.
    // Does other DOM-related initializations.
    setElement: function (el) {
      this.el = el;
      preventSelection(el);

      this.bindDayHandler('touchstart', this.dayTouchStart);
      this.bindDayHandler('mousedown', this.dayMousedown);

      // attach event-element-related handlers. in Grid.events
      // same garbage collection note as above.
      this.bindSegHandlers();

      this.bindGlobalHandlers();
    },

    bindDayHandler: function (name, handler) {
      var _this = this;

      // attach a handler to the grid's root element.
      // jQuery will take care of unregistering them when removeElement gets called.
      this.el.on(name, function (ev) {
        if (
          !$(ev.target).is('.fc-event-container *, .fc-more') // not an an event element, or "more.." link
        ) {
          return handler.call(_this, ev);
        }
      });
    },

    // Removes the grid's container element from the DOM. Undoes any other DOM-related attachments.
    // DOES NOT remove any content beforehand (doesn't clear events or call unrenderDates), unlike View
    removeElement: function () {
      this.unbindGlobalHandlers();
      this.clearDragListeners();

      this.el.remove();

      // NOTE: we don't null-out this.el for the same reasons we don't do it within View::removeElement
    },

    // Renders the basic structure of grid view before any content is rendered
    renderSkeleton: function () {
      // subclasses should implement
    },

    // Renders the grid's date-related content (like areas that represent days/times).
    // Assumes setRange has already been called and the skeleton has already been rendered.
    renderDates: function () {
      // subclasses should implement
    },

    // Unrenders the grid's date-related content
    unrenderDates: function () {
      // subclasses should implement
    },

    /* Handlers
	------------------------------------------------------------------------------------------------------------------*/

    // Binds DOM handlers to elements that reside outside the grid, such as the document
    bindGlobalHandlers: function () {
      this.listenTo($(document), {
        dragstart: this.externalDragStart, // jqui
        sortstart: this.externalDragStart, // jqui
      });
    },

    // Unbinds DOM handlers from elements that reside outside the grid
    unbindGlobalHandlers: function () {
      this.stopListeningTo($(document));
    },

    // Process a mousedown on an element that represents a day. For day clicking and selecting.
    dayMousedown: function (ev) {
      if (!this.isIgnoringMouse) {
        this.dayDragListener.startInteraction(ev, {
          //distance: 5, // needs more work if we want dayClick to fire correctly
        });
      }
    },

    dayTouchStart: function (ev) {
      var view = this.view;

      // HACK to prevent a user's clickaway for unselecting a range or an event
      // from causing a dayClick.
      if (view.isSelected || view.selectedEvent) {
        this.tempIgnoreMouse();
      }

      this.dayDragListener.startInteraction(ev, {
        delay: this.view.opt('longPressDelay'),
      });
    },

    // Creates a listener that tracks the user's drag across day elements.
    // For day clicking and selecting.
    buildDayDragListener: function () {
      var _this = this;
      var view = this.view;
      var isSelectable = view.opt('selectable');
      var dayClickHit; // null if invalid dayClick
      var selectionSpan; // null if invalid selection

      // this listener tracks a mousedown on a day element, and a subsequent drag.
      // if the drag ends on the same day, it is a 'dayClick'.
      // if 'selectable' is enabled, this listener also detects selections.
      var dragListener = new HitDragListener(this, {
        scroll: view.opt('dragScroll'),
        interactionStart: function () {
          dayClickHit = dragListener.origHit; // for dayClick, where no dragging happens
          selectionSpan = null;
        },
        dragStart: function () {
          view.unselect(); // since we could be rendering a new selection, we want to clear any old one
        },
        hitOver: function (hit, isOrig, origHit) {
          if (origHit) {
            // click needs to have started on a hit

            // if user dragged to another cell at any point, it can no longer be a dayClick
            if (!isOrig) {
              dayClickHit = null;
            }

            if (isSelectable) {
              selectionSpan = _this.computeSelection(
                _this.getHitSpan(origHit),
                _this.getHitSpan(hit)
              );
              if (selectionSpan) {
                _this.renderSelection(selectionSpan);
              } else if (selectionSpan === false) {
                disableCursor();
              }
            }
          }
        },
        hitOut: function () {
          // called before mouse moves to a different hit OR moved out of all hits
          dayClickHit = null;
          selectionSpan = null;
          _this.unrenderSelection();
        },
        hitDone: function () {
          // called after a hitOut OR before a dragEnd
          enableCursor();
        },
        interactionEnd: function (ev, isCancelled) {
          if (!isCancelled) {
            if (
              dayClickHit &&
              !_this.isIgnoringMouse // see hack in dayTouchStart
            ) {
              view.triggerDayClick(
                _this.getHitSpan(dayClickHit),
                _this.getHitEl(dayClickHit),
                ev
              );
            }
            if (selectionSpan) {
              // the selection will already have been rendered. just report it
              view.reportSelection(selectionSpan, ev);
            }
          }
        },
      });

      return dragListener;
    },

    // Kills all in-progress dragging.
    // Useful for when public API methods that result in re-rendering are invoked during a drag.
    // Also useful for when touch devices misbehave and don't fire their touchend.
    clearDragListeners: function () {
      this.dayDragListener.endInteraction();

      if (this.segDragListener) {
        this.segDragListener.endInteraction(); // will clear this.segDragListener
      }
      if (this.segResizeListener) {
        this.segResizeListener.endInteraction(); // will clear this.segResizeListener
      }
      if (this.externalDragListener) {
        this.externalDragListener.endInteraction(); // will clear this.externalDragListener
      }
    },

    /* Event Helper
	------------------------------------------------------------------------------------------------------------------*/
    // TODO: should probably move this to Grid.events, like we did event dragging / resizing

    // Renders a mock event at the given event location, which contains zoned start/end properties.
    // Returns all mock event elements.
    renderEventLocationHelper: function (eventLocation, sourceSeg) {
      var fakeEvent = this.fabricateHelperEvent(eventLocation, sourceSeg);

      return this.renderHelper(fakeEvent, sourceSeg); // do the actual rendering
    },

    // Builds a fake event given zoned event date properties and a segment is should be inspired from.
    // The range's end can be null, in which case the mock event that is rendered will have a null end time.
    // `sourceSeg` is the internal segment object involved in the drag. If null, something external is dragging.
    fabricateHelperEvent: function (eventLocation, sourceSeg) {
      var fakeEvent = sourceSeg ? createObject(sourceSeg.event) : {}; // mask the original event object if possible

      fakeEvent.start = eventLocation.start.clone();
      fakeEvent.end = eventLocation.end ? eventLocation.end.clone() : null;
      fakeEvent.allDay = null; // force it to be freshly computed by normalizeEventDates
      this.view.calendar.normalizeEventDates(fakeEvent);

      // this extra className will be useful for differentiating real events from mock events in CSS
      fakeEvent.className = (fakeEvent.className || []).concat('fc-helper');

      // if something external is being dragged in, don't render a resizer
      if (!sourceSeg) {
        fakeEvent.editable = false;
      }

      return fakeEvent;
    },

    // Renders a mock event. Given zoned event date properties.
    // Must return all mock event elements.
    renderHelper: function (eventLocation, sourceSeg) {
      // subclasses must implement
    },

    // Unrenders a mock event
    unrenderHelper: function () {
      // subclasses must implement
    },

    /* Selection
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of a selection. Will highlight by default but can be overridden by subclasses.
    // Given a span (unzoned start/end and other misc data)
    renderSelection: function (span) {
      this.renderHighlight(span);
    },

    // Unrenders any visual indications of a selection. Will unrender a highlight by default.
    unrenderSelection: function () {
      this.unrenderHighlight();
    },

    // Given the first and last date-spans of a selection, returns another date-span object.
    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelection().
    // Will return false if the selection is invalid and this should be indicated to the user.
    // Will return null/undefined if a selection invalid but no error should be reported.
    computeSelection: function (span0, span1) {
      var span = this.computeSelectionSpan(span0, span1);

      if (span && !this.view.calendar.isSelectionSpanAllowed(span)) {
        return false;
      }

      return span;
    },

    // Given two spans, must return the combination of the two.
    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
    computeSelectionSpan: function (span0, span1) {
      var dates = [span0.start, span0.end, span1.start, span1.end];

      dates.sort(compareNumbers); // sorts chronologically. works with Moments

      return { start: dates[0].clone(), end: dates[3].clone() };
    },

    /* Highlight
	------------------------------------------------------------------------------------------------------------------*/

    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
    renderHighlight: function (span) {
      this.renderFill('highlight', this.spanToSegs(span));
    },

    // Unrenders the emphasis on a date range
    unrenderHighlight: function () {
      this.unrenderFill('highlight');
    },

    // Generates an array of classNames for rendering the highlight. Used by the fill system.
    highlightSegClasses: function () {
      return ['fc-highlight'];
    },

    /* Business Hours
	------------------------------------------------------------------------------------------------------------------*/

    renderBusinessHours: function () {},

    unrenderBusinessHours: function () {},

    /* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/

    getNowIndicatorUnit: function () {},

    renderNowIndicator: function (date) {},

    unrenderNowIndicator: function () {},

    /* Fill System (highlight, background events, business hours)
	--------------------------------------------------------------------------------------------------------------------
	TODO: remove this system. like we did in TimeGrid
	*/

    // Renders a set of rectangles over the given segments of time.
    // MUST RETURN a subset of segs, the segs that were actually rendered.
    // Responsible for populating this.elsByFill. TODO: better API for expressing this requirement
    renderFill: function (type, segs) {
      // subclasses must implement
    },

    // Unrenders a specific type of fill that is currently rendered on the grid
    unrenderFill: function (type) {
      var el = this.elsByFill[type];

      if (el) {
        el.remove();
        delete this.elsByFill[type];
      }
    },

    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
    // Only returns segments that successfully rendered.
    // To be harnessed by renderFill (implemented by subclasses).
    // Analagous to renderFgSegEls.
    renderFillSegEls: function (type, segs) {
      var _this = this;
      var segElMethod = this[type + 'SegEl'];
      var html = '';
      var renderedSegs = [];
      var i;

      if (segs.length) {
        // build a large concatenation of segment HTML
        for (i = 0; i < segs.length; i++) {
          html += this.fillSegHtml(type, segs[i]);
        }

        // Grab individual elements from the combined HTML string. Use each as the default rendering.
        // Then, compute the 'el' for each segment.
        $(html).each(function (i, node) {
          var seg = segs[i];
          var el = $(node);

          // allow custom filter methods per-type
          if (segElMethod) {
            el = segElMethod.call(_this, seg, el);
          }

          if (el) {
            // custom filters did not cancel the render
            el = $(el); // allow custom filter to return raw DOM node

            // correct element type? (would be bad if a non-TD were inserted into a table for example)
            if (el.is(_this.fillSegTag)) {
              seg.el = el;
              renderedSegs.push(seg);
            }
          }
        });
      }

      return renderedSegs;
    },

    fillSegTag: 'div', // subclasses can override

    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
    fillSegHtml: function (type, seg) {
      // custom hooks per-type
      var classesMethod = this[type + 'SegClasses'];
      var cssMethod = this[type + 'SegCss'];

      var classes = classesMethod ? classesMethod.call(this, seg) : [];
      var css = cssToStr(cssMethod ? cssMethod.call(this, seg) : {});

      return (
        '<' +
        this.fillSegTag +
        (classes.length ? ' class="' + classes.join(' ') + '"' : '') +
        (css ? ' style="' + css + '"' : '') +
        ' ></' + this.fillSegTag + '>'
      );
    },

    /* Generic rendering utilities for subclasses
	------------------------------------------------------------------------------------------------------------------*/

    // Computes HTML classNames for a single-day element
    getDayClasses: function (date) {
      var view = this.view;
      var today = view.calendar.getNow();
      var classes = ['fc-' + dayIDs[date.day()]];

      if (
        view.intervalDuration.as('months') == 1 &&
        date.month() != view.intervalStart.month()
      ) {
        classes.push('fc-other-month');
      }

      if (date.isSame(today, 'day')) {
        classes.push('fc-today', view.highlightStateClass);
      } else if (date < today) {
        classes.push('fc-past');
      } else {
        classes.push('fc-future');
      }

      return classes;
    },
  }));

  /* Event-rendering and event-interaction methods for the abstract Grid class
----------------------------------------------------------------------------------------------------------------------*/

  Grid.mixin({
    mousedOverSeg: null, // the segment object the user's mouse is over. null if over nothing
    isDraggingSeg: false, // is a segment being dragged? boolean
    isResizingSeg: false, // is a segment being resized? boolean
    isDraggingExternal: false, // jqui-dragging an external element? boolean
    segs: null, // the *event* segments currently rendered in the grid. TODO: rename to `eventSegs`

    // Renders the given events onto the grid
    renderEvents: function (events) {
      var bgEvents = [];
      var fgEvents = [];
      var i;

      for (i = 0; i < events.length; i++) {
        (isBgEvent(events[i]) ? bgEvents : fgEvents).push(events[i]);
      }

      this.segs = [].concat(
        // record all segs
        this.renderBgEvents(bgEvents),
        this.renderFgEvents(fgEvents)
      );
    },

    renderBgEvents: function (events) {
      var segs = this.eventsToSegs(events);

      // renderBgSegs might return a subset of segs, segs that were actually rendered
      return this.renderBgSegs(segs) || segs;
    },

    renderFgEvents: function (events) {
      var segs = this.eventsToSegs(events);

      // renderFgSegs might return a subset of segs, segs that were actually rendered
      return this.renderFgSegs(segs) || segs;
    },

    // Unrenders all events currently rendered on the grid
    unrenderEvents: function () {
      this.handleSegMouseout(); // trigger an eventMouseout if user's mouse is over an event
      this.clearDragListeners();

      this.unrenderFgSegs();
      this.unrenderBgSegs();

      this.segs = null;
    },

    // Retrieves all rendered segment objects currently rendered on the grid
    getEventSegs: function () {
      return this.segs || [];
    },

    /* Foreground Segment Rendering
	------------------------------------------------------------------------------------------------------------------*/

    // Renders foreground event segments onto the grid. May return a subset of segs that were rendered.
    renderFgSegs: function (segs) {
      // subclasses must implement
    },

    // Unrenders all currently rendered foreground segments
    unrenderFgSegs: function () {
      // subclasses must implement
    },

    // Renders and assigns an `el` property for each foreground event segment.
    // Only returns segments that successfully rendered.
    // A utility that subclasses may use.
    renderFgSegEls: function (segs, disableResizing) {
      var view = this.view;
      var html = '';
      var renderedSegs = [];
      var i;

      if (segs.length) {
        // don't build an empty html string

        // build a large concatenation of event segment HTML
        for (i = 0; i < segs.length; i++) {
          html += this.fgSegHtml(segs[i], disableResizing);
        }

        // Grab individual elements from the combined HTML string. Use each as the default rendering.
        // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
        $(html).each(function (i, node) {
          var seg = segs[i];
          var el = view.resolveEventEl(seg.event, $(node));

          if (el) {
            el.data('fc-seg', seg); // used by handlers
            seg.el = el;
            renderedSegs.push(seg);
          }
        });
      }

      return renderedSegs;
    },

    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
    fgSegHtml: function (seg, disableResizing) {
      // subclasses should implement
    },

    /* Background Segment Rendering
	------------------------------------------------------------------------------------------------------------------*/

    // Renders the given background event segments onto the grid.
    // Returns a subset of the segs that were actually rendered.
    renderBgSegs: function (segs) {
      return this.renderFill('bgEvent', segs);
    },

    // Unrenders all the currently rendered background event segments
    unrenderBgSegs: function () {
      this.unrenderFill('bgEvent');
    },

    // Renders a background event element, given the default rendering. Called by the fill system.
    bgEventSegEl: function (seg, el) {
      return this.view.resolveEventEl(seg.event, el); // will filter through eventRender
    },

    // Generates an array of classNames to be used for the default rendering of a background event.
    // Called by fillSegHtml.
    bgEventSegClasses: function (seg) {
      var event = seg.event;
      var source = event.source || {};

      return ['fc-bgevent'].concat(event.className, source.className || []);
    },

    // Generates a semicolon-separated CSS string to be used for the default rendering of a background event.
    // Called by fillSegHtml.
    bgEventSegCss: function (seg) {
      return {
        'background-color': this.getSegSkinCss(seg)['background-color'],
      };
    },

    // Generates an array of classNames to be used for the rendering business hours overlay. Called by the fill system.
    // Called by fillSegHtml.
    businessHoursSegClasses: function (seg) {
      return ['fc-nonbusiness', 'fc-bgevent'];
    },

    /* Business Hours
	------------------------------------------------------------------------------------------------------------------*/

    // Compute business hour segs for the grid's current date range.
    // Caller must ask if whole-day business hours are needed.
    buildBusinessHourSegs: function (wholeDay) {
      var events = this.view.calendar.getCurrentBusinessHourEvents(wholeDay);

      // HACK. Eventually refactor business hours "events" system.
      // If no events are given, but businessHours is activated, this means the entire visible range should be
      // marked as *not* business-hours, via inverse-background rendering.
      if (
        !events.length &&
        this.view.calendar.options.businessHours // don't access view option. doesn't update with dynamic options
      ) {
        events = [
          $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, {
            start: this.view.end, // guaranteed out-of-range
            end: this.view.end, // "
            dow: null,
          }),
        ];
      }

      return this.eventsToSegs(events);
    },

    /* Handlers
	------------------------------------------------------------------------------------------------------------------*/

    // Attaches event-element-related handlers for *all* rendered event segments of the view.
    bindSegHandlers: function () {
      this.bindSegHandlersToEl(this.el);
    },

    // Attaches event-element-related handlers to an arbitrary container element. leverages bubbling.
    bindSegHandlersToEl: function (el) {
      this.bindSegHandlerToEl(el, 'touchstart', this.handleSegTouchStart);
      this.bindSegHandlerToEl(el, 'touchend', this.handleSegTouchEnd);
      this.bindSegHandlerToEl(el, 'mouseenter', this.handleSegMouseover);
      this.bindSegHandlerToEl(el, 'mouseleave', this.handleSegMouseout);
      this.bindSegHandlerToEl(el, 'mousedown', this.handleSegMousedown);
      this.bindSegHandlerToEl(el, 'click', this.handleSegClick);
    },

    // Executes a handler for any a user-interaction on a segment.
    // Handler gets called with (seg, ev), and with the `this` context of the Grid
    bindSegHandlerToEl: function (el, name, handler) {
      var _this = this;

      el.on(name, '.fc-event-container > *', function (ev) {
        var seg = $(this).data('fc-seg'); // grab segment data. put there by View::renderEvents

        // only call the handlers if there is not a drag/resize in progress
        if (seg && !_this.isDraggingSeg && !_this.isResizingSeg) {
          return handler.call(_this, seg, ev); // context will be the Grid
        }
      });
    },

    handleSegClick: function (seg, ev) {
      return this.view.trigger('eventClick', seg.el[0], seg.event, ev); // can return `false` to cancel
    },

    // Updates internal state and triggers handlers for when an event element is moused over
    handleSegMouseover: function (seg, ev) {
      if (!this.isIgnoringMouse && !this.mousedOverSeg) {
        this.mousedOverSeg = seg;
        seg.el.addClass('fc-allow-mouse-resize');
        this.view.trigger('eventMouseover', seg.el[0], seg.event, ev);
      }
    },

    // Updates internal state and triggers handlers for when an event element is moused out.
    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
    handleSegMouseout: function (seg, ev) {
      ev = ev || {}; // if given no args, make a mock mouse event

      if (this.mousedOverSeg) {
        seg = seg || this.mousedOverSeg; // if given no args, use the currently moused-over segment
        this.mousedOverSeg = null;
        seg.el.removeClass('fc-allow-mouse-resize');
        this.view.trigger('eventMouseout', seg.el[0], seg.event, ev);
      }
    },

    handleSegMousedown: function (seg, ev) {
      var isResizing = this.startSegResize(seg, ev, { distance: 5 });

      if (!isResizing && this.view.isEventDraggable(seg.event)) {
        this.buildSegDragListener(seg).startInteraction(ev, {
          distance: 5,
        });
      }
    },

    handleSegTouchStart: function (seg, ev) {
      var view = this.view;
      var event = seg.event;
      var isSelected = view.isEventSelected(event);
      var isDraggable = view.isEventDraggable(event);
      var isResizable = view.isEventResizable(event);
      var isResizing = false;
      var dragListener;

      if (isSelected && isResizable) {
        // only allow resizing of the event is selected
        isResizing = this.startSegResize(seg, ev);
      }

      if (!isResizing && (isDraggable || isResizable)) {
        // allowed to be selected?

        dragListener = isDraggable
          ? this.buildSegDragListener(seg)
          : this.buildSegSelectListener(seg); // seg isn't draggable, but still needs to be selected

        dragListener.startInteraction(ev, {
          // won't start if already started
          delay: isSelected ? 0 : this.view.opt('longPressDelay'), // do delay if not already selected
        });
      }

      // a long tap simulates a mouseover. ignore this bogus mouseover.
      this.tempIgnoreMouse();
    },

    handleSegTouchEnd: function (seg, ev) {
      // touchstart+touchend = click, which simulates a mouseover.
      // ignore this bogus mouseover.
      this.tempIgnoreMouse();
    },

    // returns boolean whether resizing actually started or not.
    // assumes the seg allows resizing.
    // `dragOptions` are optional.
    startSegResize: function (seg, ev, dragOptions) {
      if ($(ev.target).is('.fc-resizer')) {
        this.buildSegResizeListener(
          seg,
          $(ev.target).is('.fc-start-resizer')
        ).startInteraction(ev, dragOptions);
        return true;
      }
      return false;
    },

    /* Event Dragging
	------------------------------------------------------------------------------------------------------------------*/

    // Builds a listener that will track user-dragging on an event segment.
    // Generic enough to work with any type of Grid.
    // Has side effect of setting/unsetting `segDragListener`
    buildSegDragListener: function (seg) {
      var _this = this;
      var view = this.view;
      var calendar = view.calendar;
      var el = seg.el;
      var event = seg.event;
      var isDragging;
      var mouseFollower; // A clone of the original element that will move with the mouse
      var dropLocation; // zoned event date properties

      if (this.segDragListener) {
        return this.segDragListener;
      }

      // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
      // of the view.
      var dragListener = (this.segDragListener = new HitDragListener(view, {
        scroll: view.opt('dragScroll'),
        subjectEl: el,
        subjectCenter: true,
        interactionStart: function (ev) {
          seg.component = _this; // for renderDrag
          isDragging = false;
          mouseFollower = new MouseFollower(seg.el, {
            additionalClass: 'fc-dragging',
            parentEl: view.el,
            opacity: dragListener.isTouch ? null : view.opt('dragOpacity'),
            revertDuration: view.opt('dragRevertDuration'),
            zIndex: 2, // one above the .fc-view
          });
          mouseFollower.hide(); // don't show until we know this is a real drag
          mouseFollower.start(ev);
        },
        dragStart: function (ev) {
          if (dragListener.isTouch && !view.isEventSelected(event)) {
            // if not previously selected, will fire after a delay. then, select the event
            view.selectEvent(event);
          }
          isDragging = true;
          _this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
          _this.segDragStart(seg, ev);
          view.hideEvent(event); // hide all event segments. our mouseFollower will take over
        },
        hitOver: function (hit, isOrig, origHit) {
          var dragHelperEls;

          // starting hit could be forced (DayGrid.limit)
          if (seg.hit) {
            origHit = seg.hit;
          }

          // since we are querying the parent view, might not belong to this grid
          dropLocation = _this.computeEventDrop(
            origHit.component.getHitSpan(origHit),
            hit.component.getHitSpan(hit),
            event
          );

          if (
            dropLocation &&
            !calendar.isEventSpanAllowed(_this.eventToSpan(dropLocation), event)
          ) {
            disableCursor();
            dropLocation = null;
          }

          // if a valid drop location, have the subclass render a visual indication
          if (
            dropLocation &&
            (dragHelperEls = view.renderDrag(dropLocation, seg))
          ) {
            dragHelperEls.addClass('fc-dragging');
            if (!dragListener.isTouch) {
              _this.applyDragOpacity(dragHelperEls);
            }

            mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
          } else {
            mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
          }

          if (isOrig) {
            dropLocation = null; // needs to have moved hits to be a valid drop
          }
        },
        hitOut: function () {
          // called before mouse moves to a different hit OR moved out of all hits
          view.unrenderDrag(); // unrender whatever was done in renderDrag
          mouseFollower.show(); // show in case we are moving out of all hits
          dropLocation = null;
        },
        hitDone: function () {
          // Called after a hitOut OR before a dragEnd
          enableCursor();
        },
        interactionEnd: function (ev) {
          delete seg.component; // prevent side effects

          // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
          mouseFollower.stop(!dropLocation, function () {
            if (isDragging) {
              view.unrenderDrag();
              view.showEvent(event);
              _this.segDragStop(seg, ev);
            }
            if (dropLocation) {
              view.reportEventDrop(event, dropLocation, this.largeUnit, el, ev);
            }
          });
          _this.segDragListener = null;
        },
      }));

      return dragListener;
    },

    // seg isn't draggable, but let's use a generic DragListener
    // simply for the delay, so it can be selected.
    // Has side effect of setting/unsetting `segDragListener`
    buildSegSelectListener: function (seg) {
      var _this = this;
      var view = this.view;
      var event = seg.event;

      if (this.segDragListener) {
        return this.segDragListener;
      }

      var dragListener = (this.segDragListener = new DragListener({
        dragStart: function (ev) {
          if (dragListener.isTouch && !view.isEventSelected(event)) {
            // if not previously selected, will fire after a delay. then, select the event
            view.selectEvent(event);
          }
        },
        interactionEnd: function (ev) {
          _this.segDragListener = null;
        },
      }));

      return dragListener;
    },

    // Called before event segment dragging starts
    segDragStart: function (seg, ev) {
      this.isDraggingSeg = true;
      this.view.trigger('eventDragStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
    },

    // Called after event segment dragging stops
    segDragStop: function (seg, ev) {
      this.isDraggingSeg = false;
      this.view.trigger('eventDragStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
    },

    // Given the spans an event drag began, and the span event was dropped, calculates the new zoned start/end/allDay
    // values for the event. Subclasses may override and set additional properties to be used by renderDrag.
    // A falsy returned value indicates an invalid drop.
    // DOES NOT consider overlap/constraint.
    computeEventDrop: function (startSpan, endSpan, event) {
      var calendar = this.view.calendar;
      var dragStart = startSpan.start;
      var dragEnd = endSpan.start;
      var delta;
      var dropLocation; // zoned event date properties

      if (dragStart.hasTime() === dragEnd.hasTime()) {
        delta = this.diffDates(dragEnd, dragStart);

        // if an all-day event was in a timed area and it was dragged to a different time,
        // guarantee an end and adjust start/end to have times
        if (event.allDay && durationHasTime(delta)) {
          dropLocation = {
            start: event.start.clone(),
            end: calendar.getEventEnd(event), // will be an ambig day
            allDay: false, // for normalizeEventTimes
          };
          calendar.normalizeEventTimes(dropLocation);
        }
        // othewise, work off existing values
        else {
          dropLocation = {
            start: event.start.clone(),
            end: event.end ? event.end.clone() : null,
            allDay: event.allDay, // keep it the same
          };
        }

        dropLocation.start.add(delta);
        if (dropLocation.end) {
          dropLocation.end.add(delta);
        }
      } else {
        // if switching from day <-> timed, start should be reset to the dropped date, and the end cleared
        dropLocation = {
          start: dragEnd.clone(),
          end: null, // end should be cleared
          allDay: !dragEnd.hasTime(),
        };
      }

      return dropLocation;
    },

    // Utility for apply dragOpacity to a jQuery set
    applyDragOpacity: function (els) {
      var opacity = this.view.opt('dragOpacity');

      if (opacity != null) {
        els.each(function (i, node) {
          // Don't use jQuery (will set an IE filter), do it the old fashioned way.
          // In IE8, a helper element will disappears if there's a filter.
          node.style.opacity = opacity;
        });
      }
    },

    /* External Element Dragging
	------------------------------------------------------------------------------------------------------------------*/

    // Called when a jQuery UI drag is initiated anywhere in the DOM
    externalDragStart: function (ev, ui) {
      var view = this.view;
      var el;
      var accept;

      if (view.opt('droppable')) {
        // only listen if this setting is on
        el = $((ui ? ui.item : null) || ev.target);

        // Test that the dragged element passes the dropAccept selector or filter function.
        // FYI, the default is "*" (matches all)
        accept = view.opt('dropAccept');
        if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
          if (!this.isDraggingExternal) {
            // prevent double-listening if fired twice
            this.listenToExternalDrag(el, ev, ui);
          }
        }
      }
    },

    // Called when a jQuery UI drag starts and it needs to be monitored for dropping
    listenToExternalDrag: function (el, ev, ui) {
      var _this = this;
      var calendar = this.view.calendar;
      var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
      var dropLocation; // a null value signals an unsuccessful drag

      // listener that tracks mouse movement over date-associated pixel regions
      var dragListener = (_this.externalDragListener = new HitDragListener(
        this,
        {
          interactionStart: function () {
            _this.isDraggingExternal = true;
          },
          hitOver: function (hit) {
            dropLocation = _this.computeExternalDrop(
              hit.component.getHitSpan(hit), // since we are querying the parent view, might not belong to this grid
              meta
            );

            if (
              // invalid hit?
              dropLocation &&
              !calendar.isExternalSpanAllowed(
                _this.eventToSpan(dropLocation),
                dropLocation,
                meta.eventProps
              )
            ) {
              disableCursor();
              dropLocation = null;
            }

            if (dropLocation) {
              _this.renderDrag(dropLocation); // called without a seg parameter
            }
          },
          hitOut: function () {
            dropLocation = null; // signal unsuccessful
          },
          hitDone: function () {
            // Called after a hitOut OR before a dragEnd
            enableCursor();
            _this.unrenderDrag();
          },
          interactionEnd: function (ev) {
            if (dropLocation) {
              // element was dropped on a valid hit
              _this.view.reportExternalDrop(meta, dropLocation, el, ev, ui);
            }
            _this.isDraggingExternal = false;
            _this.externalDragListener = null;
          },
        }
      ));

      dragListener.startDrag(ev); // start listening immediately
    },

    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
    // Returning a null value signals an invalid drop hit.
    // DOES NOT consider overlap/constraint.
    computeExternalDrop: function (span, meta) {
      var calendar = this.view.calendar;
      var dropLocation = {
        start: calendar.applyTimezone(span.start), // simulate a zoned event start date
        end: null,
      };

      // if dropped on an all-day span, and element's metadata specified a time, set it
      if (meta.startTime && !dropLocation.start.hasTime()) {
        dropLocation.start.time(meta.startTime);
      }

      if (meta.duration) {
        dropLocation.end = dropLocation.start.clone().add(meta.duration);
      }

      return dropLocation;
    },

    /* Drag Rendering (for both events and an external elements)
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of an event or external element being dragged.
    // `dropLocation` contains hypothetical start/end/allDay values the event would have if dropped. end can be null.
    // `seg` is the internal segment object that is being dragged. If dragging an external element, `seg` is null.
    // A truthy returned value indicates this method has rendered a helper element.
    // Must return elements used for any mock events.
    renderDrag: function (dropLocation, seg) {
      // subclasses must implement
    },

    // Unrenders a visual indication of an event or external element being dragged
    unrenderDrag: function () {
      // subclasses must implement
    },

    /* Resizing
	------------------------------------------------------------------------------------------------------------------*/

    // Creates a listener that tracks the user as they resize an event segment.
    // Generic enough to work with any type of Grid.
    buildSegResizeListener: function (seg, isStart) {
      var _this = this;
      var view = this.view;
      var calendar = view.calendar;
      var el = seg.el;
      var event = seg.event;
      var eventEnd = calendar.getEventEnd(event);
      var isDragging;
      var resizeLocation; // zoned event date properties. falsy if invalid resize

      // Tracks mouse movement over the *grid's* coordinate map
      var dragListener = (this.segResizeListener = new HitDragListener(this, {
        scroll: view.opt('dragScroll'),
        subjectEl: el,
        interactionStart: function () {
          isDragging = false;
        },
        dragStart: function (ev) {
          isDragging = true;
          _this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
          _this.segResizeStart(seg, ev);
        },
        hitOver: function (hit, isOrig, origHit) {
          var origHitSpan = _this.getHitSpan(origHit);
          var hitSpan = _this.getHitSpan(hit);

          resizeLocation = isStart
            ? _this.computeEventStartResize(origHitSpan, hitSpan, event)
            : _this.computeEventEndResize(origHitSpan, hitSpan, event);

          if (resizeLocation) {
            if (
              !calendar.isEventSpanAllowed(
                _this.eventToSpan(resizeLocation),
                event
              )
            ) {
              disableCursor();
              resizeLocation = null;
            }
            // no change? (TODO: how does this work with timezones?)
            else if (
              resizeLocation.start.isSame(event.start) &&
              resizeLocation.end.isSame(eventEnd)
            ) {
              resizeLocation = null;
            }
          }

          if (resizeLocation) {
            view.hideEvent(event);
            _this.renderEventResize(resizeLocation, seg);
          }
        },
        hitOut: function () {
          // called before mouse moves to a different hit OR moved out of all hits
          resizeLocation = null;
        },
        hitDone: function () {
          // resets the rendering to show the original event
          _this.unrenderEventResize();
          view.showEvent(event);
          enableCursor();
        },
        interactionEnd: function (ev) {
          if (isDragging) {
            _this.segResizeStop(seg, ev);
          }
          if (resizeLocation) {
            // valid date to resize to?
            view.reportEventResize(
              event,
              resizeLocation,
              this.largeUnit,
              el,
              ev
            );
          }
          _this.segResizeListener = null;
        },
      }));

      return dragListener;
    },

    // Called before event segment resizing starts
    segResizeStart: function (seg, ev) {
      this.isResizingSeg = true;
      this.view.trigger('eventResizeStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
    },

    // Called after event segment resizing stops
    segResizeStop: function (seg, ev) {
      this.isResizingSeg = false;
      this.view.trigger('eventResizeStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
    },

    // Returns new date-information for an event segment being resized from its start
    computeEventStartResize: function (startSpan, endSpan, event) {
      return this.computeEventResize('start', startSpan, endSpan, event);
    },

    // Returns new date-information for an event segment being resized from its end
    computeEventEndResize: function (startSpan, endSpan, event) {
      return this.computeEventResize('end', startSpan, endSpan, event);
    },

    // Returns new zoned date information for an event segment being resized from its start OR end
    // `type` is either 'start' or 'end'.
    // DOES NOT consider overlap/constraint.
    computeEventResize: function (type, startSpan, endSpan, event) {
      var calendar = this.view.calendar;
      var delta = this.diffDates(endSpan[type], startSpan[type]);
      var resizeLocation; // zoned event date properties
      var defaultDuration;

      // build original values to work from, guaranteeing a start and end
      resizeLocation = {
        start: event.start.clone(),
        end: calendar.getEventEnd(event),
        allDay: event.allDay,
      };

      // if an all-day event was in a timed area and was resized to a time, adjust start/end to have times
      if (resizeLocation.allDay && durationHasTime(delta)) {
        resizeLocation.allDay = false;
        calendar.normalizeEventTimes(resizeLocation);
      }

      resizeLocation[type].add(delta); // apply delta to start or end

      // if the event was compressed too small, find a new reasonable duration for it
      if (!resizeLocation.start.isBefore(resizeLocation.end)) {
        defaultDuration =
          this.minResizeDuration || // TODO: hack
          (event.allDay
            ? calendar.defaultAllDayEventDuration
            : calendar.defaultTimedEventDuration);

        if (type == 'start') {
          // resizing the start?
          resizeLocation.start = resizeLocation.end
            .clone()
            .subtract(defaultDuration);
        } else {
          // resizing the end?
          resizeLocation.end = resizeLocation.start
            .clone()
            .add(defaultDuration);
        }
      }

      return resizeLocation;
    },

    // Renders a visual indication of an event being resized.
    // `range` has the updated dates of the event. `seg` is the original segment object involved in the drag.
    // Must return elements used for any mock events.
    renderEventResize: function (range, seg) {
      // subclasses must implement
    },

    // Unrenders a visual indication of an event being resized.
    unrenderEventResize: function () {
      // subclasses must implement
    },

    /* Rendering Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Compute the text that should be displayed on an event's element.
    // `range` can be the Event object itself, or something range-like, with at least a `start`.
    // If event times are disabled, or the event has no time, will return a blank string.
    // If not specified, formatStr will default to the eventTimeFormat setting,
    // and displayEnd will default to the displayEventEnd setting.
    getEventTimeText: function (range, formatStr, displayEnd) {
      if (formatStr == null) {
        formatStr = this.eventTimeFormat;
      }

      if (displayEnd == null) {
        displayEnd = this.displayEventEnd;
      }

      if (this.displayEventTime && range.start.hasTime()) {
        if (displayEnd && range.end) {
          return this.view.formatRange(range, formatStr);
        } else {
          return range.start.format(formatStr);
        }
      }

      return '';
    },

    // Generic utility for generating the HTML classNames for an event segment's element
    getSegClasses: function (seg, isDraggable, isResizable) {
      var view = this.view;
      var event = seg.event;
      var classes = [
        'fc-event',
        seg.isStart ? 'fc-start' : 'fc-not-start',
        seg.isEnd ? 'fc-end' : 'fc-not-end',
      ].concat(event.className, event.source ? event.source.className : []);

      if (isDraggable) {
        classes.push('fc-draggable');
      }
      if (isResizable) {
        classes.push('fc-resizable');
      }

      // event is currently selected? attach a className.
      if (view.isEventSelected(event)) {
        classes.push('fc-selected');
      }

      return classes;
    },

    // Utility for generating event skin-related CSS properties
    getSegSkinCss: function (seg) {
      var event = seg.event;
      var view = this.view;
      var source = event.source || {};
      var eventColor = event.color;
      var sourceColor = source.color;
      var optionColor = view.opt('eventColor');

      return {
        'background-color':
          event.backgroundColor ||
          eventColor ||
          source.backgroundColor ||
          sourceColor ||
          view.opt('eventBackgroundColor') ||
          optionColor,
        'border-color':
          event.borderColor ||
          eventColor ||
          source.borderColor ||
          sourceColor ||
          view.opt('eventBorderColor') ||
          optionColor,
        color:
          event.textColor || source.textColor || view.opt('eventTextColor'),
      };
    },

    /* Converting events -> eventRange -> eventSpan -> eventSegs
	------------------------------------------------------------------------------------------------------------------*/

    // Generates an array of segments for the given single event
    // Can accept an event "location" as well (which only has start/end and no allDay)
    eventToSegs: function (event) {
      return this.eventsToSegs([event]);
    },

    eventToSpan: function (event) {
      return this.eventToSpans(event)[0];
    },

    // Generates spans (always unzoned) for the given event.
    // Does not do any inverting for inverse-background events.
    // Can accept an event "location" as well (which only has start/end and no allDay)
    eventToSpans: function (event) {
      var range = this.eventToRange(event);
      return this.eventRangeToSpans(range, event);
    },

    // Converts an array of event objects into an array of event segment objects.
    // A custom `segSliceFunc` may be given for arbitrarily slicing up events.
    // Doesn't guarantee an order for the resulting array.
    eventsToSegs: function (allEvents, segSliceFunc) {
      var _this = this;
      var eventsById = groupEventsById(allEvents);
      var segs = [];

      $.each(eventsById, function (id, events) {
        var ranges = [];
        var i;

        for (i = 0; i < events.length; i++) {
          ranges.push(_this.eventToRange(events[i]));
        }

        // inverse-background events (utilize only the first event in calculations)
        if (isInverseBgEvent(events[0])) {
          ranges = _this.invertRanges(ranges);

          for (i = 0; i < ranges.length; i++) {
            segs.push.apply(
              segs, // append to
              _this.eventRangeToSegs(ranges[i], events[0], segSliceFunc)
            );
          }
        }
        // normal event ranges
        else {
          for (i = 0; i < ranges.length; i++) {
            segs.push.apply(
              segs, // append to
              _this.eventRangeToSegs(ranges[i], events[i], segSliceFunc)
            );
          }
        }
      });

      return segs;
    },

    // Generates the unzoned start/end dates an event appears to occupy
    // Can accept an event "location" as well (which only has start/end and no allDay)
    eventToRange: function (event) {
      return {
        start: event.start.clone().stripZone(),
        end: (event.end
          ? event.end.clone()
          : // derive the end from the start and allDay. compute allDay if necessary
            this.view.calendar.getDefaultEventEnd(
              event.allDay != null ? event.allDay : !event.start.hasTime(),
              event.start
            )
        ).stripZone(),
      };
    },

    // Given an event's range (unzoned start/end), and the event itself,
    // slice into segments (using the segSliceFunc function if specified)
    eventRangeToSegs: function (range, event, segSliceFunc) {
      var spans = this.eventRangeToSpans(range, event);
      var segs = [];
      var i;

      for (i = 0; i < spans.length; i++) {
        segs.push.apply(
          segs, // append to
          this.eventSpanToSegs(spans[i], event, segSliceFunc)
        );
      }

      return segs;
    },

    // Given an event's unzoned date range, return an array of "span" objects.
    // Subclasses can override.
    eventRangeToSpans: function (range, event) {
      return [$.extend({}, range)]; // copy into a single-item array
    },

    // Given an event's span (unzoned start/end and other misc data), and the event itself,
    // slices into segments and attaches event-derived properties to them.
    eventSpanToSegs: function (span, event, segSliceFunc) {
      var segs = segSliceFunc ? segSliceFunc(span) : this.spanToSegs(span);
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        seg.event = event;
        seg.eventStartMS = +span.start; // TODO: not the best name after making spans unzoned
        seg.eventDurationMS = span.end - span.start;
      }

      return segs;
    },

    // Produces a new array of range objects that will cover all the time NOT covered by the given ranges.
    // SIDE EFFECT: will mutate the given array and will use its date references.
    invertRanges: function (ranges) {
      var view = this.view;
      var viewStart = view.start.clone(); // need a copy
      var viewEnd = view.end.clone(); // need a copy
      var inverseRanges = [];
      var start = viewStart; // the end of the previous range. the start of the new range
      var i, range;

      // ranges need to be in order. required for our date-walking algorithm
      ranges.sort(compareRanges);

      for (i = 0; i < ranges.length; i++) {
        range = ranges[i];

        // add the span of time before the event (if there is any)
        if (range.start > start) {
          // compare millisecond time (skip any ambig logic)
          inverseRanges.push({
            start: start,
            end: range.start,
          });
        }

        start = range.end;
      }

      // add the span of time after the last event (if there is any)
      if (start < viewEnd) {
        // compare millisecond time (skip any ambig logic)
        inverseRanges.push({
          start: start,
          end: viewEnd,
        });
      }

      return inverseRanges;
    },

    sortEventSegs: function (segs) {
      segs.sort(proxy(this, 'compareEventSegs'));
    },

    // A cmp function for determining which segments should take visual priority
    compareEventSegs: function (seg1, seg2) {
      return (
        seg1.eventStartMS - seg2.eventStartMS || // earlier events go first
        seg2.eventDurationMS - seg1.eventDurationMS || // tie? longer events go first
        seg2.event.allDay - seg1.event.allDay || // tie? put all-day events first (booleans cast to 0/1)
        compareByFieldSpecs(seg1.event, seg2.event, this.view.eventOrderSpecs)
      );
    },
  });

  /* Utilities
----------------------------------------------------------------------------------------------------------------------*/

  function isBgEvent(event) {
    // returns true if background OR inverse-background
    var rendering = getEventRendering(event);
    return rendering === 'background' || rendering === 'inverse-background';
  }
  FC.isBgEvent = isBgEvent; // export

  function isInverseBgEvent(event) {
    return getEventRendering(event) === 'inverse-background';
  }

  function getEventRendering(event) {
    return firstDefined((event.source || {}).rendering, event.rendering);
  }

  function groupEventsById(events) {
    var eventsById = {};
    var i, event;

    for (i = 0; i < events.length; i++) {
      event = events[i];
      (eventsById[event._id] || (eventsById[event._id] = [])).push(event);
    }

    return eventsById;
  }

  // A cmp function for determining which non-inverted "ranges" (see above) happen earlier
  function compareRanges(range1, range2) {
    return range1.start - range2.start; // earlier ranges go first
  }

  /* External-Dragging-Element Data
----------------------------------------------------------------------------------------------------------------------*/

  // Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
  // A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
  FC.dataAttrPrefix = '';

  // Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
  // to be used for Event Object creation.
  // A defined `.eventProps`, even when empty, indicates that an event should be created.
  function getDraggedElMeta(el) {
    var prefix = FC.dataAttrPrefix;
    var eventProps; // properties for creating the event, not related to date/time
    var startTime; // a Duration
    var duration;
    var stick;

    if (prefix) {
      prefix += '-';
    }
    eventProps = el.data(prefix + 'event') || null;

    if (eventProps) {
      if (typeof eventProps === 'object') {
        eventProps = $.extend({}, eventProps); // make a copy
      } else {
        // something like 1 or true. still signal event creation
        eventProps = {};
      }

      // pluck special-cased date/time properties
      startTime = eventProps.start;
      if (startTime == null) {
        startTime = eventProps.time;
      } // accept 'time' as well
      duration = eventProps.duration;
      stick = eventProps.stick;
      delete eventProps.start;
      delete eventProps.time;
      delete eventProps.duration;
      delete eventProps.stick;
    }

    // fallback to standalone attribute values for each of the date/time properties
    if (startTime == null) {
      startTime = el.data(prefix + 'start');
    }
    if (startTime == null) {
      startTime = el.data(prefix + 'time');
    } // accept 'time' as well
    if (duration == null) {
      duration = el.data(prefix + 'duration');
    }
    if (stick == null) {
      stick = el.data(prefix + 'stick');
    }

    // massage into correct data types
    startTime = startTime != null ? moment.duration(startTime) : null;
    duration = duration != null ? moment.duration(duration) : null;
    stick = Boolean(stick);

    return {
      eventProps: eventProps,
      startTime: startTime,
      duration: duration,
      stick: stick,
    };
  }

  /*
A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
Prerequisite: the object being mixed into needs to be a *Grid*
*/
  var DayTableMixin = (FC.DayTableMixin = {
    breakOnWeeks: false, // should create a new row for each week?
    dayDates: null, // whole-day dates for each column. left to right
    dayIndices: null, // for each day from start, the offset
    daysPerRow: null,
    rowCnt: null,
    colCnt: null,
    colHeadFormat: null,

    // Populates internal variables used for date calculation and rendering
    updateDayTable: function () {
      var view = this.view;
      var date = this.start.clone();
      var dayIndex = -1;
      var dayIndices = [];
      var dayDates = [];
      var daysPerRow;
      var firstDay;
      var rowCnt;

      while (date.isBefore(this.end)) {
        // loop each day from start to end
        if (view.isHiddenDay(date)) {
          dayIndices.push(dayIndex + 0.5); // mark that it's between indices
        } else {
          dayIndex++;
          dayIndices.push(dayIndex);
          dayDates.push(date.clone());
        }
        date.add(1, 'days');
      }

      if (this.breakOnWeeks) {
        // count columns until the day-of-week repeats
        firstDay = dayDates[0].day();
        for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
          if (dayDates[daysPerRow].day() == firstDay) {
            break;
          }
        }
        rowCnt = Math.ceil(dayDates.length / daysPerRow);
      } else {
        rowCnt = 1;
        daysPerRow = dayDates.length;
      }

      this.dayDates = dayDates;
      this.dayIndices = dayIndices;
      this.daysPerRow = daysPerRow;
      this.rowCnt = rowCnt;

      this.updateDayTableCols();
    },

    // Computes and assigned the colCnt property and updates any options that may be computed from it
    updateDayTableCols: function () {
      this.colCnt = this.computeColCnt();
      this.colHeadFormat =
        this.view.opt('columnFormat') || this.computeColHeadFormat();
    },

    // Determines how many columns there should be in the table
    computeColCnt: function () {
      return this.daysPerRow;
    },

    // Computes the ambiguously-timed moment for the given cell
    getCellDate: function (row, col) {
      return this.dayDates[this.getCellDayIndex(row, col)].clone();
    },

    // Computes the ambiguously-timed date range for the given cell
    getCellRange: function (row, col) {
      var start = this.getCellDate(row, col);
      var end = start.clone().add(1, 'days');

      return { start: start, end: end };
    },

    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
    getCellDayIndex: function (row, col) {
      return row * this.daysPerRow + this.getColDayIndex(col);
    },

    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
    getColDayIndex: function (col) {
      if (this.isRTL) {
        return this.colCnt - 1 - col;
      } else {
        return col;
      }
    },

    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex: function (date) {
      var dayIndices = this.dayIndices;
      var dayOffset = date.diff(this.start, 'days');

      if (dayOffset < 0) {
        return dayIndices[0] - 1;
      } else if (dayOffset >= dayIndices.length) {
        return dayIndices[dayIndices.length - 1] + 1;
      } else {
        return dayIndices[dayOffset];
      }
    },

    /* Options
	------------------------------------------------------------------------------------------------------------------*/

    // Computes a default column header formatting string if `colFormat` is not explicitly defined
    computeColHeadFormat: function () {
      // if more than one week row, or if there are a lot of columns with not much space,
      // put just the day numbers will be in each cell
      if (this.rowCnt > 1 || this.colCnt > 10) {
        return 'ddd'; // "Sat"
      }
      // multiple days, so full single date string WON'T be in title text
      else if (this.colCnt > 1) {
        return this.view.opt('dayOfMonthFormat'); // "Sat 12/10"
      }
      // single day, so full single date string will probably be in title text
      else {
        return 'dddd'; // "Saturday"
      }
    },

    /* Slicing
	------------------------------------------------------------------------------------------------------------------*/

    // Slices up a date range into a segment for every week-row it intersects with
    sliceRangeByRow: function (range) {
      var daysPerRow = this.daysPerRow;
      var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
      var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
      var rangeLast = this.getDateDayIndex(
        normalRange.end.clone().subtract(1, 'days')
      ); // inclusive last index
      var segs = [];
      var row;
      var rowFirst, rowLast; // inclusive day-index range for current row
      var segFirst, segLast; // inclusive day-index range for segment

      for (row = 0; row < this.rowCnt; row++) {
        rowFirst = row * daysPerRow;
        rowLast = rowFirst + daysPerRow - 1;

        // intersect segment's offset range with the row's
        segFirst = Math.max(rangeFirst, rowFirst);
        segLast = Math.min(rangeLast, rowLast);

        // deal with in-between indices
        segFirst = Math.ceil(segFirst); // in-between starts round to next cell
        segLast = Math.floor(segLast); // in-between ends round to prev cell

        if (segFirst <= segLast) {
          // was there any intersection with the current row?
          segs.push({
            row: row,

            // normalize to start of row
            firstRowDayIndex: segFirst - rowFirst,
            lastRowDayIndex: segLast - rowFirst,

            // must be matching integers to be the segment's start/end
            isStart: segFirst === rangeFirst,
            isEnd: segLast === rangeLast,
          });
        }
      }

      return segs;
    },

    // Slices up a date range into a segment for every day-cell it intersects with.
    // TODO: make more DRY with sliceRangeByRow somehow.
    sliceRangeByDay: function (range) {
      var daysPerRow = this.daysPerRow;
      var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
      var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
      var rangeLast = this.getDateDayIndex(
        normalRange.end.clone().subtract(1, 'days')
      ); // inclusive last index
      var segs = [];
      var row;
      var rowFirst, rowLast; // inclusive day-index range for current row
      var i;
      var segFirst, segLast; // inclusive day-index range for segment

      for (row = 0; row < this.rowCnt; row++) {
        rowFirst = row * daysPerRow;
        rowLast = rowFirst + daysPerRow - 1;

        for (i = rowFirst; i <= rowLast; i++) {
          // intersect segment's offset range with the row's
          segFirst = Math.max(rangeFirst, i);
          segLast = Math.min(rangeLast, i);

          // deal with in-between indices
          segFirst = Math.ceil(segFirst); // in-between starts round to next cell
          segLast = Math.floor(segLast); // in-between ends round to prev cell

          if (segFirst <= segLast) {
            // was there any intersection with the current row?
            segs.push({
              row: row,

              // normalize to start of row
              firstRowDayIndex: segFirst - rowFirst,
              lastRowDayIndex: segLast - rowFirst,

              // must be matching integers to be the segment's start/end
              isStart: segFirst === rangeFirst,
              isEnd: segLast === rangeLast,
            });
          }
        }
      }

      return segs;
    },

    /* Header Rendering
	------------------------------------------------------------------------------------------------------------------*/

    renderHeadHtml: function () {
      var view = this.view;

      return (
        '' +
        '<div class="fc-row ' +
        view.widgetHeaderClass +
        '">' +
        '<table>' +
        '<thead>' +
        this.renderHeadTrHtml() +
        '</thead>' +
        '</table>' +
        '</div>'
      );
    },

    renderHeadIntroHtml: function () {
      return this.renderIntroHtml(); // fall back to generic
    },

    renderHeadTrHtml: function () {
      return (
        '' +
        '<tr>' +
        (this.isRTL ? '' : this.renderHeadIntroHtml()) +
        this.renderHeadDateCellsHtml() +
        (this.isRTL ? this.renderHeadIntroHtml() : '') +
        '</tr>'
      );
    },

    renderHeadDateCellsHtml: function () {
      var htmls = [];
      var col, date;

      for (col = 0; col < this.colCnt; col++) {
        date = this.getCellDate(0, col);
        htmls.push(this.renderHeadDateCellHtml(date));
      }

      return htmls.join('');
    },

    // TODO: when internalApiVersion, accept an object for HTML attributes
    // (colspan should be no different)
    renderHeadDateCellHtml: function (date, colspan, otherAttrs) {
      var view = this.view;

      return (
        '' +
        '<th class="fc-day-header ' +
        view.widgetHeaderClass +
        ' fc-' +
        dayIDs[date.day()] +
        '"' +
        (this.rowCnt == 1
          ? ' data-date="' + date.format('YYYY-MM-DD') + '"'
          : '') +
        (colspan > 1 ? ' colspan="' + colspan + '"' : '') +
        (otherAttrs ? ' ' + otherAttrs : '') +
        '>' +
        htmlEscape(date.format(this.colHeadFormat)) +
        '</th>'
      );
    },

    /* Background Rendering
	------------------------------------------------------------------------------------------------------------------*/

    renderBgTrHtml: function (row) {
      return (
        '' +
        '<tr>' +
        (this.isRTL ? '' : this.renderBgIntroHtml(row)) +
        this.renderBgCellsHtml(row) +
        (this.isRTL ? this.renderBgIntroHtml(row) : '') +
        '</tr>'
      );
    },

    renderBgIntroHtml: function (row) {
      return this.renderIntroHtml(); // fall back to generic
    },

    renderBgCellsHtml: function (row) {
      var htmls = [];
      var col, date;

      for (col = 0; col < this.colCnt; col++) {
        date = this.getCellDate(row, col);
        htmls.push(this.renderBgCellHtml(date));
      }

      return htmls.join('');
    },

    renderBgCellHtml: function (date, otherAttrs) {
      var view = this.view;
      var classes = this.getDayClasses(date);

      classes.unshift('fc-day', view.widgetContentClass);

      return (
        '<td class="' +
        classes.join(' ') +
        '"' +
        ' data-date="' +
        date.format('YYYY-MM-DD') +
        '"' + // if date has a time, won't format it
        (otherAttrs ? ' ' + otherAttrs : '') +
        '></td>'
      );
    },

    /* Generic
	------------------------------------------------------------------------------------------------------------------*/

    // Generates the default HTML intro for any row. User classes should override
    renderIntroHtml: function () {},

    // TODO: a generic method for dealing with <tr>, RTL, intro
    // when increment internalApiVersion
    // wrapTr (scheduler)

    /* Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Applies the generic "intro" and "outro" HTML to the given cells.
    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
    bookendCells: function (trEl) {
      var introHtml = this.renderIntroHtml();

      if (introHtml) {
        if (this.isRTL) {
          trEl.append(introHtml);
        } else {
          trEl.prepend(introHtml);
        }
      }
    },
  });

  /* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
----------------------------------------------------------------------------------------------------------------------*/

  var DayGrid = (FC.DayGrid = Grid.extend(DayTableMixin, {
    numbersVisible: false, // should render a row for day/week numbers? set by outside view. TODO: make internal
    bottomCoordPadding: 0, // hack for extending the hit area for the last row of the coordinate grid

    rowEls: null, // set of fake row elements
    cellEls: null, // set of whole-day elements comprising the row's background
    helperEls: null, // set of cell skeleton elements for rendering the mock event "helper"

    rowCoordCache: null,
    colCoordCache: null,

    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
    // isRigid determins whether the individual rows should ignore the contents and be a constant height.
    // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
    renderDates: function (isRigid) {
      var view = this.view;
      var rowCnt = this.rowCnt;
      var colCnt = this.colCnt;
      var html = '';
      var row;
      var col;

      for (row = 0; row < rowCnt; row++) {
        html += this.renderDayRowHtml(row, isRigid);
      }
      this.el.html(html);

      this.rowEls = this.el.find('.fc-row');
      this.cellEls = this.el.find('.fc-day');

      this.rowCoordCache = new CoordCache({
        els: this.rowEls,
        isVertical: true,
      });
      this.colCoordCache = new CoordCache({
        els: this.cellEls.slice(0, this.colCnt), // only the first row
        isHorizontal: true,
      });

      // trigger dayRender with each cell's element
      for (row = 0; row < rowCnt; row++) {
        for (col = 0; col < colCnt; col++) {
          view.trigger(
            'dayRender',
            null,
            this.getCellDate(row, col),
            this.getCellEl(row, col)
          );
        }
      }
    },

    unrenderDates: function () {
      this.removeSegPopover();
    },

    renderBusinessHours: function () {
      var segs = this.buildBusinessHourSegs(true); // wholeDay=true
      this.renderFill('businessHours', segs, 'bgevent');
    },

    unrenderBusinessHours: function () {
      this.unrenderFill('businessHours');
    },

    // Generates the HTML for a single row, which is a div that wraps a table.
    // `row` is the row number.
    renderDayRowHtml: function (row, isRigid) {
      var view = this.view;
      var classes = ['fc-row', 'fc-week', view.widgetContentClass];

      if (isRigid) {
        classes.push('fc-rigid');
      }

      return (
        '' +
        '<div class="' +
        classes.join(' ') +
        '">' +
        '<div class="fc-bg">' +
        '<table>' +
        this.renderBgTrHtml(row) +
        '</table>' +
        '</div>' +
        '<div class="fc-content-skeleton">' +
        '<table>' +
        (this.numbersVisible
          ? '<thead>' + this.renderNumberTrHtml(row) + '</thead>'
          : '') +
        '</table>' +
        '</div>' +
        '</div>'
      );
    },

    /* Grid Number Rendering
	------------------------------------------------------------------------------------------------------------------*/

    renderNumberTrHtml: function (row) {
      return (
        '' +
        '<tr>' +
        (this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
        this.renderNumberCellsHtml(row) +
        (this.isRTL ? this.renderNumberIntroHtml(row) : '') +
        '</tr>'
      );
    },

    renderNumberIntroHtml: function (row) {
      return this.renderIntroHtml();
    },

    renderNumberCellsHtml: function (row) {
      var htmls = [];
      var col, date;

      for (col = 0; col < this.colCnt; col++) {
        date = this.getCellDate(row, col);
        htmls.push(this.renderNumberCellHtml(date));
      }

      return htmls.join('');
    },

    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
    // The number row will only exist if either day numbers or week numbers are turned on.
    renderNumberCellHtml: function (date) {
      var classes;

      if (!this.view.dayNumbersVisible) {
        // if there are week numbers but not day numbers
        return '<td></td>'; //  will create an empty space above events :(
      }

      classes = this.getDayClasses(date);
      classes.unshift('fc-day-number');

      return (
        '' +
        '<td class="' +
        classes.join(' ') +
        '" data-date="' +
        date.format() +
        '">' +
        date.date() +
        '</td>'
      );
    },

    /* Options
	------------------------------------------------------------------------------------------------------------------*/

    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    computeEventTimeFormat: function () {
      return this.view.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
    },

    // Computes a default `displayEventEnd` value if one is not expliclty defined
    computeDisplayEventEnd: function () {
      return this.colCnt == 1; // we'll likely have space if there's only one day
    },

    /* Dates
	------------------------------------------------------------------------------------------------------------------*/

    rangeUpdated: function () {
      this.updateDayTable();
    },

    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    spanToSegs: function (span) {
      var segs = this.sliceRangeByRow(span);
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        if (this.isRTL) {
          seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
          seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
        } else {
          seg.leftCol = seg.firstRowDayIndex;
          seg.rightCol = seg.lastRowDayIndex;
        }
      }

      return segs;
    },

    /* Hit System
	------------------------------------------------------------------------------------------------------------------*/

    prepareHits: function () {
      this.colCoordCache.build();
      this.rowCoordCache.build();
      this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
    },

    releaseHits: function () {
      this.colCoordCache.clear();
      this.rowCoordCache.clear();
    },

    queryHit: function (leftOffset, topOffset) {
      if (
        this.colCoordCache.isLeftInBounds(leftOffset) &&
        this.rowCoordCache.isTopInBounds(topOffset)
      ) {
        var col = this.colCoordCache.getHorizontalIndex(leftOffset);
        var row = this.rowCoordCache.getVerticalIndex(topOffset);

        if (row != null && col != null) {
          return this.getCellHit(row, col);
        }
      }
    },

    getHitSpan: function (hit) {
      return this.getCellRange(hit.row, hit.col);
    },

    getHitEl: function (hit) {
      return this.getCellEl(hit.row, hit.col);
    },

    /* Cell System
	------------------------------------------------------------------------------------------------------------------*/
    // FYI: the first column is the leftmost column, regardless of date

    getCellHit: function (row, col) {
      return {
        row: row,
        col: col,
        component: this, // needed unfortunately :(
        left: this.colCoordCache.getLeftOffset(col),
        right: this.colCoordCache.getRightOffset(col),
        top: this.rowCoordCache.getTopOffset(row),
        bottom: this.rowCoordCache.getBottomOffset(row),
      };
    },

    getCellEl: function (row, col) {
      return this.cellEls.eq(row * this.colCnt + col);
    },

    /* Event Drag Visualization
	------------------------------------------------------------------------------------------------------------------*/
    // TODO: move to DayGrid.event, similar to what we did with Grid's drag methods

    // Renders a visual indication of an event or external element being dragged.
    // `eventLocation` has zoned start and end (optional)
    renderDrag: function (eventLocation, seg) {
      // always render a highlight underneath
      this.renderHighlight(this.eventToSpan(eventLocation));

      // if a segment from the same calendar but another component is being dragged, render a helper event
      if (seg && seg.component !== this) {
        return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
      }
    },

    // Unrenders any visual indication of a hovering event
    unrenderDrag: function () {
      this.unrenderHighlight();
      this.unrenderHelper();
    },

    /* Event Resize Visualization
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of an event being resized
    renderEventResize: function (eventLocation, seg) {
      this.renderHighlight(this.eventToSpan(eventLocation));
      return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
    },

    // Unrenders a visual indication of an event being resized
    unrenderEventResize: function () {
      this.unrenderHighlight();
      this.unrenderHelper();
    },

    /* Event Helper
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
    renderHelper: function (event, sourceSeg) {
      var helperNodes = [];
      var segs = this.eventToSegs(event);
      var rowStructs;

      segs = this.renderFgSegEls(segs); // assigns each seg's el and returns a subset of segs that were rendered
      rowStructs = this.renderSegRows(segs);

      // inject each new event skeleton into each associated row
      this.rowEls.each(function (row, rowNode) {
        var rowEl = $(rowNode); // the .fc-row
        var skeletonEl = $('<div class="fc-helper-skeleton"><table></table></div>'); // will be absolutely positioned
        var skeletonTop;

        // If there is an original segment, match the top position. Otherwise, put it at the row's top level
        if (sourceSeg && sourceSeg.row === row) {
          skeletonTop = sourceSeg.el.position().top;
        } else {
          skeletonTop = rowEl.find('.fc-content-skeleton tbody').position().top;
        }

        skeletonEl
          .css('top', skeletonTop)
          .find('table')
          .append(rowStructs[row].tbodyEl);

        rowEl.append(skeletonEl);
        helperNodes.push(skeletonEl[0]);
      });

      return (
        // must return the elements rendered
        (this.helperEls = $(helperNodes)) // array -> jQuery set
      );
    },

    // Unrenders any visual indication of a mock helper event
    unrenderHelper: function () {
      if (this.helperEls) {
        this.helperEls.remove();
        this.helperEls = null;
      }
    },

    /* Fill System (highlight, background events, business hours)
	------------------------------------------------------------------------------------------------------------------*/

    fillSegTag: 'td', // override the default tag name

    // Renders a set of rectangles over the given segments of days.
    // Only returns segments that successfully rendered.
    renderFill: function (type, segs, className) {
      var nodes = [];
      var i, seg;
      var skeletonEl;

      segs = this.renderFillSegEls(type, segs); // assignes `.el` to each seg. returns successfully rendered segs

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        skeletonEl = this.renderFillRow(type, seg, className);
        this.rowEls.eq(seg.row).append(skeletonEl);
        nodes.push(skeletonEl[0]);
      }

      this.elsByFill[type] = $(nodes);

      return segs;
    },

    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
    renderFillRow: function (type, seg, className) {
      var colCnt = this.colCnt;
      var startCol = seg.leftCol;
      var endCol = seg.rightCol + 1;
      var skeletonEl;
      var trEl;

      className = className || type.toLowerCase();

      skeletonEl = $(
        '<div class="fc-' +
          className +
          '-skeleton">' +
          '<table><tr></tr></table>' +
          '</div>'
      );
      trEl = skeletonEl.find('tr');

      if (startCol > 0) {
        trEl.append('<td colspan="' + startCol + '"></td>');
      }

      trEl.append(seg.el.attr('colspan', endCol - startCol));

      if (endCol < colCnt) {
        trEl.append('<td colspan="' + (colCnt - endCol) + '"></td>');
      }

      this.bookendCells(trEl);

      return skeletonEl;
    },
  }));

  /* Event-rendering methods for the DayGrid class
----------------------------------------------------------------------------------------------------------------------*/

  DayGrid.mixin({
    rowStructs: null, // an array of objects, each holding information about a row's foreground event-rendering

    // Unrenders all events currently rendered on the grid
    unrenderEvents: function () {
      this.removeSegPopover(); // removes the "more.." events popover
      Grid.prototype.unrenderEvents.apply(this, arguments); // calls the super-method
    },

    // Retrieves all rendered segment objects currently rendered on the grid
    getEventSegs: function () {
      return Grid.prototype.getEventSegs
        .call(this) // get the segments from the super-method
        .concat(this.popoverSegs || []); // append the segments from the "more..." popover
    },

    // Renders the given background event segments onto the grid
    renderBgSegs: function (segs) {
      // don't render timed background events
      var allDaySegs = $.grep(segs, function (seg) {
        return seg.event.allDay;
      });

      return Grid.prototype.renderBgSegs.call(this, allDaySegs); // call the super-method
    },

    // Renders the given foreground event segments onto the grid
    renderFgSegs: function (segs) {
      var rowStructs;

      // render an `.el` on each seg
      // returns a subset of the segs. segs that were actually rendered
      segs = this.renderFgSegEls(segs);

      rowStructs = this.rowStructs = this.renderSegRows(segs);

      // append to each row's content skeleton
      this.rowEls.each(function (i, rowNode) {
        $(rowNode)
          .find('.fc-content-skeleton > table')
          .append(rowStructs[i].tbodyEl);
      });

      return segs; // return only the segs that were actually rendered
    },

    // Unrenders all currently rendered foreground event segments
    unrenderFgSegs: function () {
      var rowStructs = this.rowStructs || [];
      var rowStruct;

      while ((rowStruct = rowStructs.pop())) {
        rowStruct.tbodyEl.remove();
      }

      this.rowStructs = null;
    },

    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
    renderSegRows: function (segs) {
      var rowStructs = [];
      var segRows;
      var row;

      segRows = this.groupSegRows(segs); // group into nested arrays

      // iterate each row of segment groupings
      for (row = 0; row < segRows.length; row++) {
        rowStructs.push(this.renderSegRow(row, segRows[row]));
      }

      return rowStructs;
    },

    // Builds the HTML to be used for the default element for an individual segment
    fgSegHtml: function (seg, disableResizing) {
      var view = this.view;
      var event = seg.event;
      var isDraggable = view.isEventDraggable(event);
      var isResizableFromStart =
        !disableResizing &&
        event.allDay &&
        seg.isStart &&
        view.isEventResizableFromStart(event);
      var isResizableFromEnd =
        !disableResizing &&
        event.allDay &&
        seg.isEnd &&
        view.isEventResizableFromEnd(event);
      var classes = this.getSegClasses(
        seg,
        isDraggable,
        isResizableFromStart || isResizableFromEnd
      );
      var skinCss = cssToStr(this.getSegSkinCss(seg));
      var timeHtml = '';
      var timeText;
      var titleHtml;

      classes.unshift('fc-day-grid-event', 'fc-h-event');

      // Only display a timed events time if it is the starting segment
      if (seg.isStart) {
        timeText = this.getEventTimeText(event);
        if (timeText) {
          timeHtml =
            '<span class="fc-time">' + htmlEscape(timeText) + '</span>';
        }
      }

      titleHtml =
        '<span class="fc-title">' +
        (htmlEscape(event.title || '') || '&nbsp;') + // we always want one line of height
        '</span>';

      return (
        '<a class="' +
        classes.join(' ') +
        '"' +
        (event.url ? ' href="' + htmlEscape(event.url) + '"' : '') +
        (skinCss ? ' style="' + skinCss + '"' : '') +
        '>' +
        '<div class="fc-content">' +
        (this.isRTL
          ? titleHtml + ' ' + timeHtml // put a natural space in between
          : timeHtml + ' ' + titleHtml) + //
        '</div>' +
        (isResizableFromStart
          ? '<div class="fc-resizer fc-start-resizer" ></div>'
          : '') +
        (isResizableFromEnd
          ? '<div class="fc-resizer fc-end-resizer" ></div>'
          : '') +
        '</a>'
      );
    },

    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
    // the segments. Returns object with a bunch of internal data about how the render was calculated.
    // NOTE: modifies rowSegs
    renderSegRow: function (row, rowSegs) {
      var colCnt = this.colCnt;
      var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
      var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
      var tbody = $('<tbody></tbody>');
      var segMatrix = []; // lookup for which segments are rendered into which level+col cells
      var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
      var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
      var i, levelSegs;
      var col;
      var tr;
      var j, seg;
      var td;

      // populates empty cells from the current column (`col`) to `endCol`
      function emptyCellsUntil(endCol) {
        while (col < endCol) {
          // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
          td = (loneCellMatrix[i - 1] || [])[col];
          if (td) {
            td.attr('rowspan', parseInt(td.attr('rowspan') || 1, 10) + 1);
          } else {
            td = $('<td></td>');
            tr.append(td);
          }
          cellMatrix[i][col] = td;
          loneCellMatrix[i][col] = td;
          col++;
        }
      }

      for (i = 0; i < levelCnt; i++) {
        // iterate through all levels
        levelSegs = segLevels[i];
        col = 0;
        tr = $('<tr></tr>');

        segMatrix.push([]);
        cellMatrix.push([]);
        loneCellMatrix.push([]);

        // levelCnt might be 1 even though there are no actual levels. protect against this.
        // this single empty row is useful for styling.
        if (levelSegs) {
          for (j = 0; j < levelSegs.length; j++) {
            // iterate through segments in level
            seg = levelSegs[j];

            emptyCellsUntil(seg.leftCol);

            // create a container that occupies or more columns. append the event element.
            td = $('<td class="fc-event-container"></td>').append(seg.el);
            if (seg.leftCol != seg.rightCol) {
              td.attr('colspan', seg.rightCol - seg.leftCol + 1);
            } else {
              // a single-column segment
              loneCellMatrix[i][col] = td;
            }

            while (col <= seg.rightCol) {
              cellMatrix[i][col] = td;
              segMatrix[i][col] = seg;
              col++;
            }

            tr.append(td);
          }
        }

        emptyCellsUntil(colCnt); // finish off the row
        this.bookendCells(tr);
        tbody.append(tr);
      }

      return {
        // a "rowStruct"
        row: row, // the row number
        tbodyEl: tbody,
        cellMatrix: cellMatrix,
        segMatrix: segMatrix,
        segLevels: segLevels,
        segs: rowSegs,
      };
    },

    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
    // NOTE: modifies segs
    buildSegLevels: function (segs) {
      var levels = [];
      var i, seg;
      var j;

      // Give preference to elements with certain criteria, so they have
      // a chance to be closer to the top.
      this.sortEventSegs(segs);

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];

        // loop through levels, starting with the topmost, until the segment doesn't collide with other segments
        for (j = 0; j < levels.length; j++) {
          if (!isDaySegCollision(seg, levels[j])) {
            break;
          }
        }
        // `j` now holds the desired subrow index
        seg.level = j;

        // create new level array if needed and append segment
        (levels[j] || (levels[j] = [])).push(seg);
      }

      // order segments left-to-right. very important if calendar is RTL
      for (j = 0; j < levels.length; j++) {
        levels[j].sort(compareDaySegCols);
      }

      return levels;
    },

    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
    groupSegRows: function (segs) {
      var segRows = [];
      var i;

      for (i = 0; i < this.rowCnt; i++) {
        segRows.push([]);
      }

      for (i = 0; i < segs.length; i++) {
        segRows[segs[i].row].push(segs[i]);
      }

      return segRows;
    },
  });

  // Computes whether two segments' columns collide. They are assumed to be in the same row.
  function isDaySegCollision(seg, otherSegs) {
    var i, otherSeg;

    for (i = 0; i < otherSegs.length; i++) {
      otherSeg = otherSegs[i];

      if (
        otherSeg.leftCol <= seg.rightCol &&
        otherSeg.rightCol >= seg.leftCol
      ) {
        return true;
      }
    }

    return false;
  }

  // A cmp function for determining the leftmost event
  function compareDaySegCols(a, b) {
    return a.leftCol - b.leftCol;
  }

  /* Methods relate to limiting the number events for a given day on a DayGrid
----------------------------------------------------------------------------------------------------------------------*/
  // NOTE: all the segs being passed around in here are foreground segs

  DayGrid.mixin({
    segPopover: null, // the Popover that holds events that can't fit in a cell. null when not visible
    popoverSegs: null, // an array of segment objects that the segPopover holds. null when not visible

    removeSegPopover: function () {
      if (this.segPopover) {
        this.segPopover.hide(); // in handler, will call segPopover's removeElement
      }
    },

    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
    limitRows: function (levelLimit) {
      var rowStructs = this.rowStructs || [];
      var row; // row #
      var rowLevelLimit;

      for (row = 0; row < rowStructs.length; row++) {
        this.unlimitRow(row);

        if (!levelLimit) {
          rowLevelLimit = false;
        } else if (typeof levelLimit === 'number') {
          rowLevelLimit = levelLimit;
        } else {
          rowLevelLimit = this.computeRowLevelLimit(row);
        }

        if (rowLevelLimit !== false) {
          this.limitRow(row, rowLevelLimit);
        }
      }
    },

    // Computes the number of levels a row will accomodate without going outside its bounds.
    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
    // `row` is the row number.
    computeRowLevelLimit: function (row) {
      var rowEl = this.rowEls.eq(row); // the containing "fake" row div
      var rowHeight = rowEl.height(); // TODO: cache somehow?
      var trEls = this.rowStructs[row].tbodyEl.children();
      var i, trEl;
      var trHeight;

      function iterInnerHeights(i, childNode) {
        trHeight = Math.max(trHeight, $(childNode).outerHeight());
      }

      // Reveal one level <tr> at a time and stop when we find one out of bounds
      for (i = 0; i < trEls.length; i++) {
        trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)

        // with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
        // so instead, find the tallest inner content element.
        trHeight = 0;
        trEl.find('> td > :first-child').each(iterInnerHeights);

        if (trEl.position().top + trHeight > rowHeight) {
          return i;
        }
      }

      return false; // should not limit at all
    },

    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
    // `row` is the row number.
    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
    limitRow: function (row, levelLimit) {
      var _this = this;
      var rowStruct = this.rowStructs[row];
      var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
      var col = 0; // col #, left-to-right (not chronologically)
      var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
      var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
      var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
      var i, seg;
      var segsBelow; // array of segment objects below `seg` in the current `col`
      var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
      var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
      var td, rowspan;
      var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
      var j;
      var moreTd, moreWrap, moreLink;

      // Iterates through empty level cells and places "more" links inside if need be
      function emptyCellsUntil(endCol) {
        // goes from current `col` to `endCol`
        while (col < endCol) {
          segsBelow = _this.getCellSegs(row, col, levelLimit);
          if (segsBelow.length) {
            td = cellMatrix[levelLimit - 1][col];
            moreLink = _this.renderMoreLink(row, col, segsBelow);
            moreWrap = $('<div></div>').append(moreLink);
            td.append(moreWrap);
            moreNodes.push(moreWrap[0]);
          }
          col++;
        }
      }

      if (levelLimit && levelLimit < rowStruct.segLevels.length) {
        // is it actually over the limit?
        levelSegs = rowStruct.segLevels[levelLimit - 1];
        cellMatrix = rowStruct.cellMatrix;

        limitedNodes = rowStruct.tbodyEl
          .children()
          .slice(levelLimit) // get level <tr> elements past the limit
          .addClass('fc-limited')
          .get(); // hide elements and get a simple DOM-nodes array

        // iterate though segments in the last allowable level
        for (i = 0; i < levelSegs.length; i++) {
          seg = levelSegs[i];
          emptyCellsUntil(seg.leftCol); // process empty cells before the segment

          // determine *all* segments below `seg` that occupy the same columns
          colSegsBelow = [];
          totalSegsBelow = 0;
          while (col <= seg.rightCol) {
            segsBelow = this.getCellSegs(row, col, levelLimit);
            colSegsBelow.push(segsBelow);
            totalSegsBelow += segsBelow.length;
            col++;
          }

          if (totalSegsBelow) {
            // do we need to replace this segment with one or many "more" links?
            td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
            rowspan = td.attr('rowspan') || 1;
            segMoreNodes = [];

            // make a replacement <td> for each column the segment occupies. will be one for each colspan
            for (j = 0; j < colSegsBelow.length; j++) {
              moreTd = $('<td class="fc-more-cell"></td>').attr('rowspan', rowspan);
              segsBelow = colSegsBelow[j];
              moreLink = this.renderMoreLink(
                row,
                seg.leftCol + j,
                [seg].concat(segsBelow) // count seg as hidden too
              );
              moreWrap = $('<div></div>').append(moreLink);
              moreTd.append(moreWrap);
              segMoreNodes.push(moreTd[0]);
              moreNodes.push(moreTd[0]);
            }

            td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
            limitedNodes.push(td[0]);
          }
        }

        emptyCellsUntil(this.colCnt); // finish off the level
        rowStruct.moreEls = $(moreNodes); // for easy undoing later
        rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
      }
    },

    // Reveals all levels and removes all "more"-related elements for a grid's row.
    // `row` is a row number.
    unlimitRow: function (row) {
      var rowStruct = this.rowStructs[row];

      if (rowStruct.moreEls) {
        rowStruct.moreEls.remove();
        rowStruct.moreEls = null;
      }

      if (rowStruct.limitedEls) {
        rowStruct.limitedEls.removeClass('fc-limited');
        rowStruct.limitedEls = null;
      }
    },

    // Renders an <a> element that represents hidden event element for a cell.
    // Responsible for attaching click handler as well.
    renderMoreLink: function (row, col, hiddenSegs) {
      var _this = this;
      var view = this.view;

      return $('<a class="fc-more"></a>')
        .text(this.getMoreLinkText(hiddenSegs.length))
        .on('click', function (ev) {
          var clickOption = view.opt('eventLimitClick');
          var date = _this.getCellDate(row, col);
          var moreEl = $(this);
          var dayEl = _this.getCellEl(row, col);
          var allSegs = _this.getCellSegs(row, col);

          // rescope the segments to be within the cell's date
          var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
          var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);

          if (typeof clickOption === 'function') {
            // the returned value can be an atomic option
            clickOption = view.trigger(
              'eventLimitClick',
              null,
              {
                date: date,
                dayEl: dayEl,
                moreEl: moreEl,
                segs: reslicedAllSegs,
                hiddenSegs: reslicedHiddenSegs,
              },
              ev
            );
          }

          if (clickOption === 'popover') {
            _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
          } else if (typeof clickOption === 'string') {
            // a view name
            view.calendar.zoomTo(date, clickOption);
          }
        });
    },

    // Reveals the popover that displays all events within a cell
    showSegPopover: function (row, col, moreLink, segs) {
      var _this = this;
      var view = this.view;
      var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
      var topEl; // the element we want to match the top coordinate of
      var options;

      if (this.rowCnt == 1) {
        topEl = view.el; // will cause the popover to cover any sort of header
      } else {
        topEl = this.rowEls.eq(row); // will align with top of row
      }

      options = {
        className: 'fc-more-popover',
        content: this.renderSegPopoverContent(row, col, segs),
        parentEl: this.view.el, // attach to root of view. guarantees outside of scrollbars.
        top: topEl.offset().top,
        autoHide: true, // when the user clicks elsewhere, hide the popover
        viewportConstrain: view.opt('popoverViewportConstrain'),
        hide: function () {
          // kill everything when the popover is hidden
          _this.segPopover.removeElement();
          _this.segPopover = null;
          _this.popoverSegs = null;
        },
      };

      // Determine horizontal coordinate.
      // We use the moreWrap instead of the <td> to avoid border confusion.
      if (this.isRTL) {
        options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
      } else {
        options.left = moreWrap.offset().left - 1; // -1 to be over cell border
      }

      this.segPopover = new Popover(options);
      this.segPopover.show();

      // the popover doesn't live within the grid's container element, and thus won't get the event
      // delegated-handlers for free. attach event-related handlers to the popover.
      this.bindSegHandlersToEl(this.segPopover.el);
    },

    // Builds the inner DOM contents of the segment popover
    renderSegPopoverContent: function (row, col, segs) {
      var view = this.view;
      var isTheme = view.opt('theme');
      var title = this.getCellDate(row, col).format(
        view.opt('dayPopoverFormat')
      );
      var content = $(
        '<div class="fc-header ' +
          view.widgetHeaderClass +
          '">' +
          '<span class="fc-close ' +
          (isTheme ? 'ui-icon ui-icon-closethick' : 'fc-icon fc-icon-x') +
          '"></span>' +
          '<span class="fc-title">' +
          htmlEscape(title) +
          '</span>' +
          '<div class="fc-clear"></div>' +
          '</div>' +
          '<div class="fc-body ' +
          view.widgetContentClass +
          '">' +
          '<div class="fc-event-container"></div>' +
          '</div>'
      );
      var segContainer = content.find('.fc-event-container');
      var i;

      // render each seg's `el` and only return the visible segs
      segs = this.renderFgSegEls(segs, true); // disableResizing=true
      this.popoverSegs = segs;

      for (i = 0; i < segs.length; i++) {
        // because segments in the popover are not part of a grid coordinate system, provide a hint to any
        // grids that want to do drag-n-drop about which cell it came from
        this.prepareHits();
        segs[i].hit = this.getCellHit(row, col);
        this.releaseHits();

        segContainer.append(segs[i].el);
      }

      return content;
    },

    // Given the events within an array of segment objects, reslice them to be in a single day
    resliceDaySegs: function (segs, dayDate) {
      // build an array of the original events
      var events = $.map(segs, function (seg) {
        return seg.event;
      });

      var dayStart = dayDate.clone();
      var dayEnd = dayStart.clone().add(1, 'days');
      var dayRange = { start: dayStart, end: dayEnd };

      // slice the events with a custom slicing function
      segs = this.eventsToSegs(events, function (range) {
        var seg = intersectRanges(range, dayRange); // undefind if no intersection
        return seg ? [seg] : []; // must return an array of segments
      });

      // force an order because eventsToSegs doesn't guarantee one
      this.sortEventSegs(segs);

      return segs;
    },

    // Generates the text that should be inside a "more" link, given the number of events it represents
    getMoreLinkText: function (num) {
      var opt = this.view.opt('eventLimitText');

      if (typeof opt === 'function') {
        return opt(num);
      } else {
        return '+' + num + ' ' + opt;
      }
    },

    // Returns segments within a given cell.
    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
    getCellSegs: function (row, col, startLevel) {
      var segMatrix = this.rowStructs[row].segMatrix;
      var level = startLevel || 0;
      var segs = [];
      var seg;

      while (level < segMatrix.length) {
        seg = segMatrix[level][col];
        if (seg) {
          segs.push(seg);
        }
        level++;
      }

      return segs;
    },
  });

  /* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
  // We mixin DayTable, even though there is only a single row of days

  var TimeGrid = (FC.TimeGrid = Grid.extend(DayTableMixin, {
    slotDuration: null, // duration of a "slot", a distinct time segment on given day, visualized by lines
    snapDuration: null, // granularity of time for dragging and selecting
    snapsPerSlot: null,
    minTime: null, // Duration object that denotes the first visible time of any given day
    maxTime: null, // Duration object that denotes the exclusive visible end time of any given day
    labelFormat: null, // formatting string for times running along vertical axis
    labelInterval: null, // duration of how often a label should be displayed for a slot

    colEls: null, // cells elements in the day-row background
    slatContainerEl: null, // div that wraps all the slat rows
    slatEls: null, // elements running horizontally across all columns
    nowIndicatorEls: null,

    colCoordCache: null,
    slatCoordCache: null,

    constructor: function () {
      Grid.apply(this, arguments); // call the super-constructor

      this.processOptions();
    },

    // Renders the time grid into `this.el`, which should already be assigned.
    // Relies on the view's colCnt. In the future, this component should probably be self-sufficient.
    renderDates: function () {
      this.el.html(this.renderHtml());
      this.colEls = this.el.find('.fc-day');
      this.slatContainerEl = this.el.find('.fc-slats');
      this.slatEls = this.slatContainerEl.find('tr');

      this.colCoordCache = new CoordCache({
        els: this.colEls,
        isHorizontal: true,
      });
      this.slatCoordCache = new CoordCache({
        els: this.slatEls,
        isVertical: true,
      });

      this.renderContentSkeleton();
    },

    // Renders the basic HTML skeleton for the grid
    renderHtml: function () {
      return (
        '' +
        '<div class="fc-bg">' +
        '<table>' +
        this.renderBgTrHtml(0) + // row=0
        '</table>' +
        '</div>' +
        '<div class="fc-slats">' +
        '<table>' +
        this.renderSlatRowHtml() +
        '</table>' +
        '</div>'
      );
    },

    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
    renderSlatRowHtml: function () {
      var view = this.view;
      var isRTL = this.isRTL;
      var html = '';
      var slotTime = moment.duration(+this.minTime); // wish there was .clone() for durations
      var slotDate; // will be on the view's first day, but we only care about its time
      var isLabeled;
      var axisHtml;

      // Calculate the time for each slot
      while (slotTime < this.maxTime) {
        slotDate = this.start.clone().time(slotTime);
        isLabeled = isInt(
          divideDurationByDuration(slotTime, this.labelInterval)
        );

        axisHtml =
          '<td class="fc-axis fc-time ' +
          view.widgetContentClass +
          '" ' +
          view.axisStyleAttr() +
          '>' +
          (isLabeled
            ? '<span>' + // for matchCellWidths
              htmlEscape(slotDate.format(this.labelFormat)) +
              '</span>'
            : '') +
          '</td>';

        html +=
          '<tr data-time="' +
          slotDate.format('HH:mm:ss') +
          '"' +
          (isLabeled ? '' : ' class="fc-minor"') +
          '>' +
          (!isRTL ? axisHtml : '') +
          '<td class="' +
          view.widgetContentClass +
          '"></td>' +
          (isRTL ? axisHtml : '') +
          '</tr>';

        slotTime.add(this.slotDuration);
      }

      return html;
    },

    /* Options
	------------------------------------------------------------------------------------------------------------------*/

    // Parses various options into properties of this object
    processOptions: function () {
      var view = this.view;
      var slotDuration = view.opt('slotDuration');
      var snapDuration = view.opt('snapDuration');
      var input;

      slotDuration = moment.duration(slotDuration);
      snapDuration = snapDuration
        ? moment.duration(snapDuration)
        : slotDuration;

      this.slotDuration = slotDuration;
      this.snapDuration = snapDuration;
      this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?

      this.minResizeDuration = snapDuration; // hack

      this.minTime = moment.duration(view.opt('minTime'));
      this.maxTime = moment.duration(view.opt('maxTime'));

      // might be an array value (for TimelineView).
      // if so, getting the most granular entry (the last one probably).
      input = view.opt('slotLabelFormat');
      if ($.isArray(input)) {
        input = input[input.length - 1];
      }

      this.labelFormat =
        input ||
        view.opt('axisFormat') || // deprecated
        view.opt('smallTimeFormat'); // the computed default

      input = view.opt('slotLabelInterval');
      this.labelInterval = input
        ? moment.duration(input)
        : this.computeLabelInterval(slotDuration);
    },

    // Computes an automatic value for slotLabelInterval
    computeLabelInterval: function (slotDuration) {
      var i;
      var labelInterval;
      var slotsPerLabel;

      // find the smallest stock label interval that results in more than one slots-per-label
      for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
        labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = divideDurationByDuration(labelInterval, slotDuration);
        if (isInt(slotsPerLabel) && slotsPerLabel > 1) {
          return labelInterval;
        }
      }

      return moment.duration(slotDuration); // fall back. clone
    },

    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    computeEventTimeFormat: function () {
      return this.view.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
    },

    // Computes a default `displayEventEnd` value if one is not expliclty defined
    computeDisplayEventEnd: function () {
      return true;
    },

    /* Hit System
	------------------------------------------------------------------------------------------------------------------*/

    prepareHits: function () {
      this.colCoordCache.build();
      this.slatCoordCache.build();
    },

    releaseHits: function () {
      this.colCoordCache.clear();
      // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
    },

    queryHit: function (leftOffset, topOffset) {
      var snapsPerSlot = this.snapsPerSlot;
      var colCoordCache = this.colCoordCache;
      var slatCoordCache = this.slatCoordCache;

      if (
        colCoordCache.isLeftInBounds(leftOffset) &&
        slatCoordCache.isTopInBounds(topOffset)
      ) {
        var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
        var slatIndex = slatCoordCache.getVerticalIndex(topOffset);

        if (colIndex != null && slatIndex != null) {
          var slatTop = slatCoordCache.getTopOffset(slatIndex);
          var slatHeight = slatCoordCache.getHeight(slatIndex);
          var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
          var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
          var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
          var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
          var snapBottom =
            slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;

          return {
            col: colIndex,
            snap: snapIndex,
            component: this, // needed unfortunately :(
            left: colCoordCache.getLeftOffset(colIndex),
            right: colCoordCache.getRightOffset(colIndex),
            top: snapTop,
            bottom: snapBottom,
          };
        }
      }
    },

    getHitSpan: function (hit) {
      var start = this.getCellDate(0, hit.col); // row=0
      var time = this.computeSnapTime(hit.snap); // pass in the snap-index
      var end;

      start.time(time);
      end = start.clone().add(this.snapDuration);

      return { start: start, end: end };
    },

    getHitEl: function (hit) {
      return this.colEls.eq(hit.col);
    },

    /* Dates
	------------------------------------------------------------------------------------------------------------------*/

    rangeUpdated: function () {
      this.updateDayTable();
    },

    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
    computeSnapTime: function (snapIndex) {
      return moment.duration(this.minTime + this.snapDuration * snapIndex);
    },

    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    spanToSegs: function (span) {
      var segs = this.sliceRangeByTimes(span);
      var i;

      for (i = 0; i < segs.length; i++) {
        if (this.isRTL) {
          segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
        } else {
          segs[i].col = segs[i].dayIndex;
        }
      }

      return segs;
    },

    sliceRangeByTimes: function (range) {
      var segs = [];
      var seg;
      var dayIndex;
      var dayDate;
      var dayRange;

      for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
        dayDate = this.dayDates[dayIndex].clone(); // TODO: better API for this?
        dayRange = {
          start: dayDate.clone().time(this.minTime),
          end: dayDate.clone().time(this.maxTime),
        };
        seg = intersectRanges(range, dayRange); // both will be ambig timezone
        if (seg) {
          seg.dayIndex = dayIndex;
          segs.push(seg);
        }
      }

      return segs;
    },

    /* Coordinates
	------------------------------------------------------------------------------------------------------------------*/

    updateSize: function (isResize) {
      // NOT a standard Grid method
      this.slatCoordCache.build();

      if (isResize) {
        this.updateSegVerticals(
          [].concat(
            this.fgSegs || [],
            this.bgSegs || [],
            this.businessSegs || []
          )
        );
      }
    },

    getTotalSlatHeight: function () {
      return this.slatContainerEl.outerHeight();
    },

    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    computeDateTop: function (date, startOfDayDate) {
      return this.computeTimeTop(
        moment.duration(date - startOfDayDate.clone().stripTime())
      );
    },

    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    computeTimeTop: function (time) {
      var len = this.slatEls.length;
      var slatCoverage = (time - this.minTime) / this.slotDuration; // floating-point value of # of slots covered
      var slatIndex;
      var slatRemainder;

      // compute a floating-point number for how many slats should be progressed through.
      // from 0 to number of slats (inclusive)
      // constrained because minTime/maxTime might be customized.
      slatCoverage = Math.max(0, slatCoverage);
      slatCoverage = Math.min(len, slatCoverage);

      // an integer index of the furthest whole slat
      // from 0 to number slats (*exclusive*, so len-1)
      slatIndex = Math.floor(slatCoverage);
      slatIndex = Math.min(slatIndex, len - 1);

      // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
      // could be 1.0 if slatCoverage is covering *all* the slots
      slatRemainder = slatCoverage - slatIndex;

      return (
        this.slatCoordCache.getTopPosition(slatIndex) +
        this.slatCoordCache.getHeight(slatIndex) * slatRemainder
      );
    },

    /* Event Drag Visualization
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of an event being dragged over the specified date(s).
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    renderDrag: function (eventLocation, seg) {
      if (seg) {
        // if there is event information for this drag, render a helper event

        // returns mock event elements
        // signal that a helper has been rendered
        return this.renderEventLocationHelper(eventLocation, seg);
      } else {
        // otherwise, just render a highlight
        this.renderHighlight(this.eventToSpan(eventLocation));
      }
    },

    // Unrenders any visual indication of an event being dragged
    unrenderDrag: function () {
      this.unrenderHelper();
      this.unrenderHighlight();
    },

    /* Event Resize Visualization
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of an event being resized
    renderEventResize: function (eventLocation, seg) {
      return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
    },

    // Unrenders any visual indication of an event being resized
    unrenderEventResize: function () {
      this.unrenderHelper();
    },

    /* Event Helper
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a mock "helper" event. `sourceSeg` is the original segment object and might be null (an external drag)
    renderHelper: function (event, sourceSeg) {
      return this.renderHelperSegs(this.eventToSegs(event), sourceSeg); // returns mock event elements
    },

    // Unrenders any mock helper event
    unrenderHelper: function () {
      this.unrenderHelperSegs();
    },

    /* Business Hours
	------------------------------------------------------------------------------------------------------------------*/

    renderBusinessHours: function () {
      this.renderBusinessSegs(this.buildBusinessHourSegs());
    },

    unrenderBusinessHours: function () {
      this.unrenderBusinessSegs();
    },

    /* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/

    getNowIndicatorUnit: function () {
      return 'minute'; // will refresh on the minute
    },

    renderNowIndicator: function (date) {
      // seg system might be overkill, but it handles scenario where line needs to be rendered
      //  more than once because of columns with the same date (resources columns for example)
      var segs = this.spanToSegs({ start: date, end: date });
      var top = this.computeDateTop(date, date);
      var nodes = [];
      var i;

      // render lines within the columns
      for (i = 0; i < segs.length; i++) {
        nodes.push(
          $('<div class="fc-now-indicator fc-now-indicator-line"></div>')
            .css('top', top)
            .appendTo(this.colContainerEls.eq(segs[i].col))[0]
        );
      }

      // render an arrow over the axis
      if (segs.length > 0) {
        // is the current time in view?
        nodes.push(
          $('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
            .css('top', top)
            .appendTo(this.el.find('.fc-content-skeleton'))[0]
        );
      }

      this.nowIndicatorEls = $(nodes);
    },

    unrenderNowIndicator: function () {
      if (this.nowIndicatorEls) {
        this.nowIndicatorEls.remove();
        this.nowIndicatorEls = null;
      }
    },

    /* Selection
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
    renderSelection: function (span) {
      if (this.view.opt('selectHelper')) {
        // this setting signals that a mock helper event should be rendered

        // normally acceps an eventLocation, span has a start/end, which is good enough
        this.renderEventLocationHelper(span);
      } else {
        this.renderHighlight(span);
      }
    },

    // Unrenders any visual indication of a selection
    unrenderSelection: function () {
      this.unrenderHelper();
      this.unrenderHighlight();
    },

    /* Highlight
	------------------------------------------------------------------------------------------------------------------*/

    renderHighlight: function (span) {
      this.renderHighlightSegs(this.spanToSegs(span));
    },

    unrenderHighlight: function () {
      this.unrenderHighlightSegs();
    },
  }));

  /* Methods for rendering SEGMENTS, pieces of content that live on the view
 ( this file is no longer just for events )
----------------------------------------------------------------------------------------------------------------------*/

  TimeGrid.mixin({
    colContainerEls: null, // containers for each column

    // inner-containers for each column where different types of segs live
    fgContainerEls: null,
    bgContainerEls: null,
    helperContainerEls: null,
    highlightContainerEls: null,
    businessContainerEls: null,

    // arrays of different types of displayed segments
    fgSegs: null,
    bgSegs: null,
    helperSegs: null,
    highlightSegs: null,
    businessSegs: null,

    // Renders the DOM that the view's content will live in
    renderContentSkeleton: function () {
      var cellHtml = '';
      var i;
      var skeletonEl;

      for (i = 0; i < this.colCnt; i++) {
        cellHtml +=
          '<td>' +
          '<div class="fc-content-col">' +
          '<div class="fc-event-container fc-helper-container"></div>' +
          '<div class="fc-event-container"></div>' +
          '<div class="fc-highlight-container"></div>' +
          '<div class="fc-bgevent-container"></div>' +
          '<div class="fc-business-container"></div>' +
          '</div>' +
          '</td>';
      }

      skeletonEl = $(
        '<div class="fc-content-skeleton">' +
          '<table>' +
          '<tr>' +
          cellHtml +
          '</tr>' +
          '</table>' +
          '</div>'
      );

      this.colContainerEls = skeletonEl.find('.fc-content-col');
      this.helperContainerEls = skeletonEl.find('.fc-helper-container');
      this.fgContainerEls = skeletonEl.find(
        '.fc-event-container:not(.fc-helper-container)'
      );
      this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
      this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
      this.businessContainerEls = skeletonEl.find('.fc-business-container');

      this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
      this.el.append(skeletonEl);
    },

    /* Foreground Events
	------------------------------------------------------------------------------------------------------------------*/

    renderFgSegs: function (segs) {
      segs = this.renderFgSegsIntoContainers(segs, this.fgContainerEls);
      this.fgSegs = segs;
      return segs; // needed for Grid::renderEvents
    },

    unrenderFgSegs: function () {
      this.unrenderNamedSegs('fgSegs');
    },

    /* Foreground Helper Events
	------------------------------------------------------------------------------------------------------------------*/

    renderHelperSegs: function (segs, sourceSeg) {
      var helperEls = [];
      var i, seg;
      var sourceEl;

      segs = this.renderFgSegsIntoContainers(segs, this.helperContainerEls);

      // Try to make the segment that is in the same row as sourceSeg look the same
      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        if (sourceSeg && sourceSeg.col === seg.col) {
          sourceEl = sourceSeg.el;
          seg.el.css({
            left: sourceEl.css('left'),
            right: sourceEl.css('right'),
            'margin-left': sourceEl.css('margin-left'),
            'margin-right': sourceEl.css('margin-right'),
          });
        }
        helperEls.push(seg.el[0]);
      }

      this.helperSegs = segs;

      return $(helperEls); // must return rendered helpers
    },

    unrenderHelperSegs: function () {
      this.unrenderNamedSegs('helperSegs');
    },

    /* Background Events
	------------------------------------------------------------------------------------------------------------------*/

    renderBgSegs: function (segs) {
      segs = this.renderFillSegEls('bgEvent', segs); // TODO: old fill system
      this.updateSegVerticals(segs);
      this.attachSegsByCol(this.groupSegsByCol(segs), this.bgContainerEls);
      this.bgSegs = segs;
      return segs; // needed for Grid::renderEvents
    },

    unrenderBgSegs: function () {
      this.unrenderNamedSegs('bgSegs');
    },

    /* Highlight
	------------------------------------------------------------------------------------------------------------------*/

    renderHighlightSegs: function (segs) {
      segs = this.renderFillSegEls('highlight', segs); // TODO: old fill system
      this.updateSegVerticals(segs);
      this.attachSegsByCol(
        this.groupSegsByCol(segs),
        this.highlightContainerEls
      );
      this.highlightSegs = segs;
    },

    unrenderHighlightSegs: function () {
      this.unrenderNamedSegs('highlightSegs');
    },

    /* Business Hours
	------------------------------------------------------------------------------------------------------------------*/

    renderBusinessSegs: function (segs) {
      segs = this.renderFillSegEls('businessHours', segs); // TODO: old fill system
      this.updateSegVerticals(segs);
      this.attachSegsByCol(
        this.groupSegsByCol(segs),
        this.businessContainerEls
      );
      this.businessSegs = segs;
    },

    unrenderBusinessSegs: function () {
      this.unrenderNamedSegs('businessSegs');
    },

    /* Seg Rendering Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
    groupSegsByCol: function (segs) {
      var segsByCol = [];
      var i;

      for (i = 0; i < this.colCnt; i++) {
        segsByCol.push([]);
      }

      for (i = 0; i < segs.length; i++) {
        segsByCol[segs[i].col].push(segs[i]);
      }

      return segsByCol;
    },

    // Given segments grouped by column, insert the segments' elements into a parallel array of container
    // elements, each living within a column.
    attachSegsByCol: function (segsByCol, containerEls) {
      var col;
      var segs;
      var i;

      for (col = 0; col < this.colCnt; col++) {
        // iterate each column grouping
        segs = segsByCol[col];

        for (i = 0; i < segs.length; i++) {
          containerEls.eq(col).append(segs[i].el);
        }
      }
    },

    // Given the name of a property of `this` object, assumed to be an array of segments,
    // loops through each segment and removes from DOM. Will null-out the property afterwards.
    unrenderNamedSegs: function (propName) {
      var segs = this[propName];
      var i;

      if (segs) {
        for (i = 0; i < segs.length; i++) {
          segs[i].el.remove();
        }
        this[propName] = null;
      }
    },

    /* Foreground Event Rendering Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Given an array of foreground segments, render a DOM element for each, computes position,
    // and attaches to the column inner-container elements.
    renderFgSegsIntoContainers: function (segs, containerEls) {
      var segsByCol;
      var col;

      segs = this.renderFgSegEls(segs); // will call fgSegHtml
      segsByCol = this.groupSegsByCol(segs);

      for (col = 0; col < this.colCnt; col++) {
        this.updateFgSegCoords(segsByCol[col]);
      }

      this.attachSegsByCol(segsByCol, containerEls);

      return segs;
    },

    // Renders the HTML for a single event segment's default rendering
    fgSegHtml: function (seg, disableResizing) {
      var view = this.view;
      var event = seg.event;
      var isDraggable = view.isEventDraggable(event);
      var isResizableFromStart =
        !disableResizing &&
        seg.isStart &&
        view.isEventResizableFromStart(event);
      var isResizableFromEnd =
        !disableResizing && seg.isEnd && view.isEventResizableFromEnd(event);
      var classes = this.getSegClasses(
        seg,
        isDraggable,
        isResizableFromStart || isResizableFromEnd
      );
      var skinCss = cssToStr(this.getSegSkinCss(seg));
      var timeText;
      var fullTimeText; // more verbose time text. for the print stylesheet
      var startTimeText; // just the start time text

      classes.unshift('fc-time-grid-event', 'fc-v-event');

      if (view.isMultiDayEvent(event)) {
        // if the event appears to span more than one day...
        // Don't display time text on segments that run entirely through a day.
        // That would appear as midnight-midnight and would look dumb.
        // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
        if (seg.isStart || seg.isEnd) {
          timeText = this.getEventTimeText(seg);
          fullTimeText = this.getEventTimeText(seg, 'LT');
          startTimeText = this.getEventTimeText(seg, null, false); // displayEnd=false
        }
      } else {
        // Display the normal time text for the *event's* times
        timeText = this.getEventTimeText(event);
        fullTimeText = this.getEventTimeText(event, 'LT');
        startTimeText = this.getEventTimeText(event, null, false); // displayEnd=false
      }

      return (
        '<a class="' +
        classes.join(' ') +
        '"' +
        (event.url ? ' href="' + htmlEscape(event.url) + '"' : '') +
        (skinCss ? ' style="' + skinCss + '"' : '') +
        '>' +
        '<div class="fc-content">' +
        (timeText
          ? '<div class="fc-time"' +
            ' data-start="' +
            htmlEscape(startTimeText) +
            '"' +
            ' data-full="' +
            htmlEscape(fullTimeText) +
            '"' +
            '>' +
            '<span>' +
            htmlEscape(timeText) +
            '</span>' +
            '</div>'
          : '') +
        (event.title
          ? '<div class="fc-title">' + htmlEscape(event.title) + '</div>'
          : '') +
        '</div>' +
        '<div class="fc-bg"></div>' +
        /* TODO: write CSS for this
				(isResizableFromStart ?
					'<div class="fc-resizer fc-start-resizer"></div>' :
					''
					) +
				*/
        (isResizableFromEnd
          ? '<div class="fc-resizer fc-end-resizer"></div>'
          : '') +
        '</a>'
      );
    },

    /* Seg Position Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Refreshes the CSS top/bottom coordinates for each segment element.
    // Works when called after initial render, after a window resize/zoom for example.
    updateSegVerticals: function (segs) {
      this.computeSegVerticals(segs);
      this.assignSegVerticals(segs);
    },

    // For each segment in an array, computes and assigns its top and bottom properties
    computeSegVerticals: function (segs) {
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        seg.top = this.computeDateTop(seg.start, seg.start);
        seg.bottom = this.computeDateTop(seg.end, seg.start);
      }
    },

    // Given segments that already have their top/bottom properties computed, applies those values to
    // the segments' elements.
    assignSegVerticals: function (segs) {
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        seg.el.css(this.generateSegVerticalCss(seg));
      }
    },

    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
    generateSegVerticalCss: function (seg) {
      return {
        top: seg.top,
        bottom: -seg.bottom, // flipped because needs to be space beyond bottom edge of event container
      };
    },

    /* Foreground Event Positioning Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Given segments that are assumed to all live in the *same column*,
    // compute their verical/horizontal coordinates and assign to their elements.
    updateFgSegCoords: function (segs) {
      this.computeSegVerticals(segs); // horizontals relies on this
      this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
      this.assignSegVerticals(segs);
      this.assignFgSegHorizontals(segs);
    },

    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
    // NOTE: Also reorders the given array by date!
    computeFgSegHorizontals: function (segs) {
      var levels;
      var level0;
      var i;

      this.sortEventSegs(segs); // order by certain criteria
      levels = buildSlotSegLevels(segs);
      computeForwardSlotSegs(levels);

      if ((level0 = levels[0])) {
        for (i = 0; i < level0.length; i++) {
          computeSlotSegPressures(level0[i]);
        }

        for (i = 0; i < level0.length; i++) {
          this.computeFgSegForwardBack(level0[i], 0, 0);
        }
      }
    },

    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
    //
    // The segment might be part of a "series", which means consecutive segments with the same pressure
    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
    // coordinate of the first segment in the series.
    computeFgSegForwardBack: function (
      seg,
      seriesBackwardPressure,
      seriesBackwardCoord
    ) {
      var forwardSegs = seg.forwardSegs;
      var i;

      if (seg.forwardCoord === undefined) {
        // not already computed

        if (!forwardSegs.length) {
          // if there are no forward segments, this segment should butt up against the edge
          seg.forwardCoord = 1;
        } else {
          // sort highest pressure first
          this.sortForwardSegs(forwardSegs);

          // this segment's forwardCoord will be calculated from the backwardCoord of the
          // highest-pressure forward segment.
          this.computeFgSegForwardBack(
            forwardSegs[0],
            seriesBackwardPressure + 1,
            seriesBackwardCoord
          );
          seg.forwardCoord = forwardSegs[0].backwardCoord;
        }

        // calculate the backwardCoord from the forwardCoord. consider the series
        seg.backwardCoord =
          seg.forwardCoord -
          (seg.forwardCoord - seriesBackwardCoord) / // available width for series
            (seriesBackwardPressure + 1); // # of segments in the series

        // use this segment's coordinates to computed the coordinates of the less-pressurized
        // forward segments
        for (i = 0; i < forwardSegs.length; i++) {
          this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
        }
      }
    },

    sortForwardSegs: function (forwardSegs) {
      forwardSegs.sort(proxy(this, 'compareForwardSegs'));
    },

    // A cmp function for determining which forward segment to rely on more when computing coordinates.
    compareForwardSegs: function (seg1, seg2) {
      // put higher-pressure first
      return (
        seg2.forwardPressure - seg1.forwardPressure ||
        // put segments that are closer to initial edge first (and favor ones with no coords yet)
        (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
        // do normal sorting...
        this.compareEventSegs(seg1, seg2)
      );
    },

    // Given foreground event segments that have already had their position coordinates computed,
    // assigns position-related CSS values to their elements.
    assignFgSegHorizontals: function (segs) {
      var i, seg;

      for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        seg.el.css(this.generateFgSegHorizontalCss(seg));

        // if the height is short, add a className for alternate styling
        if (seg.bottom - seg.top < 30) {
          seg.el.addClass('fc-short');
        }
      }
    },

    // Generates an object with CSS properties/values that should be applied to an event segment element.
    // Contains important positioning-related properties that should be applied to any event element, customized or not.
    generateFgSegHorizontalCss: function (seg) {
      var shouldOverlap = this.view.opt('slotEventOverlap');
      var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
      var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
      var props = this.generateSegVerticalCss(seg); // get top/bottom first
      var left; // amount of space from left edge, a fraction of the total width
      var right; // amount of space from right edge, a fraction of the total width

      if (shouldOverlap) {
        // double the width, but don't go beyond the maximum forward coordinate (1.0)
        forwardCoord = Math.min(
          1,
          backwardCoord + (forwardCoord - backwardCoord) * 2
        );
      }

      if (this.isRTL) {
        left = 1 - forwardCoord;
        right = backwardCoord;
      } else {
        left = backwardCoord;
        right = 1 - forwardCoord;
      }

      props.zIndex = seg.level + 1; // convert from 0-base to 1-based
      props.left = left * 100 + '%';
      props.right = right * 100 + '%';

      if (shouldOverlap && seg.forwardPressure) {
        // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[this.isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
      }

      return props;
    },
  });

  // Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
  // left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
  function buildSlotSegLevels(segs) {
    var levels = [];
    var i, seg;
    var j;

    for (i = 0; i < segs.length; i++) {
      seg = segs[i];

      // go through all the levels and stop on the first level where there are no collisions
      for (j = 0; j < levels.length; j++) {
        if (!computeSlotSegCollisions(seg, levels[j]).length) {
          break;
        }
      }

      seg.level = j;

      (levels[j] || (levels[j] = [])).push(seg);
    }

    return levels;
  }

  // For every segment, figure out the other segments that are in subsequent
  // levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
  function computeForwardSlotSegs(levels) {
    var i, level;
    var j, seg;
    var k;

    for (i = 0; i < levels.length; i++) {
      level = levels[i];

      for (j = 0; j < level.length; j++) {
        seg = level[j];

        seg.forwardSegs = [];
        for (k = i + 1; k < levels.length; k++) {
          computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
        }
      }
    }
  }

  // Figure out which path forward (via seg.forwardSegs) results in the longest path until
  // the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
  function computeSlotSegPressures(seg) {
    var forwardSegs = seg.forwardSegs;
    var forwardPressure = 0;
    var i, forwardSeg;

    if (seg.forwardPressure === undefined) {
      // not already computed

      for (i = 0; i < forwardSegs.length; i++) {
        forwardSeg = forwardSegs[i];

        // figure out the child's maximum forward path
        computeSlotSegPressures(forwardSeg);

        // either use the existing maximum, or use the child's forward pressure
        // plus one (for the forwardSeg itself)
        forwardPressure = Math.max(
          forwardPressure,
          1 + forwardSeg.forwardPressure
        );
      }

      seg.forwardPressure = forwardPressure;
    }
  }

  // Find all the segments in `otherSegs` that vertically collide with `seg`.
  // Append into an optionally-supplied `results` array and return.
  function computeSlotSegCollisions(seg, otherSegs, results) {
    results = results || [];

    for (var i = 0; i < otherSegs.length; i++) {
      if (isSlotSegCollision(seg, otherSegs[i])) {
        results.push(otherSegs[i]);
      }
    }

    return results;
  }

  // Do these segments occupy the same vertical space?
  function isSlotSegCollision(seg1, seg2) {
    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
  }

  /* An abstract class from which other views inherit from
----------------------------------------------------------------------------------------------------------------------*/

  var View = (FC.View = Class.extend(EmitterMixin, ListenerMixin, {
    type: null, // subclass' view name (string)
    name: null, // deprecated. use `type` instead
    title: null, // the text that will be displayed in the header's title

    calendar: null, // owner Calendar object
    options: null, // hash containing all options. already merged with view-specific-options
    el: null, // the view's containing element. set by Calendar

    displaying: null, // a promise representing the state of rendering. null if no render requested
    isSkeletonRendered: false,
    isEventsRendered: false,

    // range the view is actually displaying (moments)
    start: null,
    end: null, // exclusive

    // range the view is formally responsible for (moments)
    // may be different from start/end. for example, a month view might have 1st-31st, excluding padded dates
    intervalStart: null,
    intervalEnd: null, // exclusive
    intervalDuration: null,
    intervalUnit: null, // name of largest unit being displayed, like "month" or "week"

    isRTL: false,
    isSelected: false, // boolean whether a range of time is user-selected or not
    selectedEvent: null,

    eventOrderSpecs: null, // criteria for ordering events when they have same date/time

    // classNames styled by jqui themes
    widgetHeaderClass: null,
    widgetContentClass: null,
    highlightStateClass: null,

    // for date utils, computed from options
    nextDayThreshold: null,
    isHiddenDayHash: null,

    // now indicator
    isNowIndicatorRendered: null,
    initialNowDate: null, // result first getNow call
    initialNowQueriedMs: null, // ms time the getNow was called
    nowIndicatorTimeoutID: null, // for refresh timing of now indicator
    nowIndicatorIntervalID: null, // "

    constructor: function (calendar, type, options, intervalDuration) {
      this.calendar = calendar;
      this.type = this.name = type; // .name is deprecated
      this.options = options;
      this.intervalDuration = intervalDuration || moment.duration(1, 'day');

      this.nextDayThreshold = moment.duration(this.opt('nextDayThreshold'));
      this.initThemingProps();
      this.initHiddenDays();
      this.isRTL = this.opt('isRTL');

      this.eventOrderSpecs = parseFieldSpecs(this.opt('eventOrder'));

      this.initialize();
    },

    // A good place for subclasses to initialize member variables
    initialize: function () {
      // subclasses can implement
    },

    // Retrieves an option with the given name
    opt: function (name) {
      return this.options[name];
    },

    // Triggers handlers that are view-related. Modifies args before passing to calendar.
    trigger: function (name, thisObj) {
      // arguments beyond thisObj are passed along
      var calendar = this.calendar;

      return calendar.trigger.apply(
        calendar,
        [name, thisObj || this].concat(
          Array.prototype.slice.call(arguments, 2), // arguments beyond thisObj
          [this] // always make the last argument a reference to the view. TODO: deprecate
        )
      );
    },

    /* Dates
	------------------------------------------------------------------------------------------------------------------*/

    // Updates all internal dates to center around the given current unzoned date.
    setDate: function (date) {
      this.setRange(this.computeRange(date));
    },

    // Updates all internal dates for displaying the given unzoned range.
    setRange: function (range) {
      $.extend(this, range); // assigns every property to this object's member variables
      this.updateTitle();
    },

    // Given a single current unzoned date, produce information about what range to display.
    // Subclasses can override. Must return all properties.
    computeRange: function (date) {
      var intervalUnit = computeIntervalUnit(this.intervalDuration);
      var intervalStart = date.clone().startOf(intervalUnit);
      var intervalEnd = intervalStart.clone().add(this.intervalDuration);
      var start, end;

      // normalize the range's time-ambiguity
      if (/year|month|week|day/.test(intervalUnit)) {
        // whole-days?
        intervalStart.stripTime();
        intervalEnd.stripTime();
      } else {
        // needs to have a time?
        if (!intervalStart.hasTime()) {
          intervalStart = this.calendar.time(0); // give 00:00 time
        }
        if (!intervalEnd.hasTime()) {
          intervalEnd = this.calendar.time(0); // give 00:00 time
        }
      }

      start = intervalStart.clone();
      start = this.skipHiddenDays(start);
      end = intervalEnd.clone();
      end = this.skipHiddenDays(end, -1, true); // exclusively move backwards

      return {
        intervalUnit: intervalUnit,
        intervalStart: intervalStart,
        intervalEnd: intervalEnd,
        start: start,
        end: end,
      };
    },

    // Computes the new date when the user hits the prev button, given the current date
    computePrevDate: function (date) {
      return this.massageCurrentDate(
        date.clone().startOf(this.intervalUnit).subtract(this.intervalDuration),
        -1
      );
    },

    // Computes the new date when the user hits the next button, given the current date
    computeNextDate: function (date) {
      return this.massageCurrentDate(
        date.clone().startOf(this.intervalUnit).add(this.intervalDuration)
      );
    },

    // Given an arbitrarily calculated current date of the calendar, returns a date that is ensured to be completely
    // visible. `direction` is optional and indicates which direction the current date was being
    // incremented or decremented (1 or -1).
    massageCurrentDate: function (date, direction) {
      if (this.intervalDuration.as('days') <= 1) {
        // if the view displays a single day or smaller
        if (this.isHiddenDay(date)) {
          date = this.skipHiddenDays(date, direction);
          date.startOf('day');
        }
      }

      return date;
    },

    /* Title and Date Formatting
	------------------------------------------------------------------------------------------------------------------*/

    // Sets the view's title property to the most updated computed value
    updateTitle: function () {
      this.title = this.computeTitle();
    },

    // Computes what the title at the top of the calendar should be for this view
    computeTitle: function () {
      return this.formatRange(
        {
          // in case intervalStart/End has a time, make sure timezone is correct
          start: this.calendar.applyTimezone(this.intervalStart),
          end: this.calendar.applyTimezone(this.intervalEnd),
        },
        this.opt('titleFormat') || this.computeTitleFormat(),
        this.opt('titleRangeSeparator')
      );
    },

    // Generates the format string that should be used to generate the title for the current date range.
    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
    computeTitleFormat: function () {
      if (this.intervalUnit == 'year') {
        return 'YYYY';
      } else if (this.intervalUnit == 'month') {
        return this.opt('monthYearFormat'); // like "September 2014"
      } else if (this.intervalDuration.as('days') > 1) {
        return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
      } else {
        return 'LL'; // one day. longer, like "September 9 2014"
      }
    },

    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
    // The timezones of the dates within `range` will be respected.
    formatRange: function (range, formatStr, separator) {
      var end = range.end;

      if (!end.hasTime()) {
        // all-day?
        end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
      }

      return formatRange(
        range.start,
        end,
        formatStr,
        separator,
        this.opt('isRTL')
      );
    },

    /* Rendering
	------------------------------------------------------------------------------------------------------------------*/

    // Sets the container element that the view should render inside of.
    // Does other DOM-related initializations.
    setElement: function (el) {
      this.el = el;
      this.bindGlobalHandlers();
    },

    // Removes the view's container element from the DOM, clearing any content beforehand.
    // Undoes any other DOM-related attachments.
    removeElement: function () {
      this.clear(); // clears all content

      // clean up the skeleton
      if (this.isSkeletonRendered) {
        this.unrenderSkeleton();
        this.isSkeletonRendered = false;
      }

      this.unbindGlobalHandlers();

      this.el.remove();

      // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
      // We don't null-out the View's other jQuery element references upon destroy,
      //  so we shouldn't kill this.el either.
    },

    // Does everything necessary to display the view centered around the given unzoned date.
    // Does every type of rendering EXCEPT rendering events.
    // Is asychronous and returns a promise.
    display: function (date, explicitScrollState) {
      var _this = this;
      var prevScrollState = null;

      if (explicitScrollState != null && this.displaying) {
        // don't need prevScrollState if explicitScrollState
        prevScrollState = this.queryScroll();
      }

      this.calendar.freezeContentHeight();

      return syncThen(this.clear(), function () {
        // clear the content first
        return (_this.displaying = syncThen(
          _this.displayView(date),
          function () {
            // displayView might return a promise

            // caller of display() wants a specific scroll state?
            if (explicitScrollState != null) {
              // we make an assumption that this is NOT the initial render,
              // and thus don't need forceScroll (is inconveniently asynchronous)
              _this.setScroll(explicitScrollState);
            } else {
              _this.forceScroll(_this.computeInitialScroll(prevScrollState));
            }

            _this.calendar.unfreezeContentHeight();
            _this.triggerRender();
          }
        ));
      });
    },

    // Does everything necessary to clear the content of the view.
    // Clears dates and events. Does not clear the skeleton.
    // Is asychronous and returns a promise.
    clear: function () {
      var _this = this;
      var displaying = this.displaying;

      if (displaying) {
        // previously displayed, or in the process of being displayed?
        return syncThen(displaying, function () {
          // wait for the display to finish
          _this.displaying = null;
          _this.clearEvents();
          return _this.clearView(); // might return a promise. chain it
        });
      } else {
        return $.when(); // an immediately-resolved promise
      }
    },

    // Displays the view's non-event content, such as date-related content or anything required by events.
    // Renders the view's non-content skeleton if necessary.
    // Can be asynchronous and return a promise.
    displayView: function (date) {
      if (!this.isSkeletonRendered) {
        this.renderSkeleton();
        this.isSkeletonRendered = true;
      }
      if (date) {
        this.setDate(date);
      }
      if (this.render) {
        this.render(); // TODO: deprecate
      }
      this.renderDates();
      this.updateSize();
      this.renderBusinessHours(); // might need coordinates, so should go after updateSize()
      this.startNowIndicator();
    },

    // Unrenders the view content that was rendered in displayView.
    // Can be asynchronous and return a promise.
    clearView: function () {
      this.unselect();
      this.stopNowIndicator();
      this.triggerUnrender();
      this.unrenderBusinessHours();
      this.unrenderDates();
      if (this.destroy) {
        this.destroy(); // TODO: deprecate
      }
    },

    // Renders the basic structure of the view before any content is rendered
    renderSkeleton: function () {
      // subclasses should implement
    },

    // Unrenders the basic structure of the view
    unrenderSkeleton: function () {
      // subclasses should implement
    },

    // Renders the view's date-related content.
    // Assumes setRange has already been called and the skeleton has already been rendered.
    renderDates: function () {
      // subclasses should implement
    },

    // Unrenders the view's date-related content
    unrenderDates: function () {
      // subclasses should override
    },

    // Signals that the view's content has been rendered
    triggerRender: function () {
      this.trigger('viewRender', this, this, this.el);
    },

    // Signals that the view's content is about to be unrendered
    triggerUnrender: function () {
      this.trigger('viewDestroy', this, this, this.el);
    },

    // Binds DOM handlers to elements that reside outside the view container, such as the document
    bindGlobalHandlers: function () {
      this.listenTo($(document), 'mousedown', this.handleDocumentMousedown);
      this.listenTo($(document), 'touchstart', this.processUnselect);
    },

    // Unbinds DOM handlers from elements that reside outside the view container
    unbindGlobalHandlers: function () {
      this.stopListeningTo($(document));
    },

    // Initializes internal variables related to theming
    initThemingProps: function () {
      var tm = this.opt('theme') ? 'ui' : 'fc';

      this.widgetHeaderClass = tm + '-widget-header';
      this.widgetContentClass = tm + '-widget-content';
      this.highlightStateClass = tm + '-state-highlight';
    },

    /* Business Hours
	------------------------------------------------------------------------------------------------------------------*/

    // Renders business-hours onto the view. Assumes updateSize has already been called.
    renderBusinessHours: function () {
      // subclasses should implement
    },

    // Unrenders previously-rendered business-hours
    unrenderBusinessHours: function () {
      // subclasses should implement
    },

    /* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/

    // Immediately render the current time indicator and begins re-rendering it at an interval,
    // which is defined by this.getNowIndicatorUnit().
    // TODO: somehow do this for the current whole day's background too
    startNowIndicator: function () {
      var _this = this;
      var unit;
      var update;
      var delay; // ms wait value

      if (this.opt('nowIndicator')) {
        unit = this.getNowIndicatorUnit();
        if (unit) {
          update = proxy(this, 'updateNowIndicator'); // bind to `this`

          this.initialNowDate = this.calendar.getNow();
          this.initialNowQueriedMs = +new Date();
          this.renderNowIndicator(this.initialNowDate);
          this.isNowIndicatorRendered = true;

          // wait until the beginning of the next interval
          delay =
            this.initialNowDate.clone().startOf(unit).add(1, unit) -
            this.initialNowDate;
          this.nowIndicatorTimeoutID = setTimeout(function () {
            _this.nowIndicatorTimeoutID = null;
            update();
            delay = +moment.duration(1, unit);
            delay = Math.max(100, delay); // prevent too frequent
            _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
          }, delay);
        }
      }
    },

    // rerenders the now indicator, computing the new current time from the amount of time that has passed
    // since the initial getNow call.
    updateNowIndicator: function () {
      if (this.isNowIndicatorRendered) {
        this.unrenderNowIndicator();
        this.renderNowIndicator(
          this.initialNowDate.clone().add(new Date() - this.initialNowQueriedMs) // add ms
        );
      }
    },

    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
    // Won't cause side effects if indicator isn't rendered.
    stopNowIndicator: function () {
      if (this.isNowIndicatorRendered) {
        if (this.nowIndicatorTimeoutID) {
          clearTimeout(this.nowIndicatorTimeoutID);
          this.nowIndicatorTimeoutID = null;
        }
        if (this.nowIndicatorIntervalID) {
          clearTimeout(this.nowIndicatorIntervalID);
          this.nowIndicatorIntervalID = null;
        }

        this.unrenderNowIndicator();
        this.isNowIndicatorRendered = false;
      }
    },

    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
    getNowIndicatorUnit: function () {
      // subclasses should implement
    },

    // Renders a current time indicator at the given datetime
    renderNowIndicator: function (date) {
      // subclasses should implement
    },

    // Undoes the rendering actions from renderNowIndicator
    unrenderNowIndicator: function () {
      // subclasses should implement
    },

    /* Dimensions
	------------------------------------------------------------------------------------------------------------------*/

    // Refreshes anything dependant upon sizing of the container element of the grid
    updateSize: function (isResize) {
      var scrollState;

      if (isResize) {
        scrollState = this.queryScroll();
      }

      this.updateHeight(isResize);
      this.updateWidth(isResize);
      this.updateNowIndicator();

      if (isResize) {
        this.setScroll(scrollState);
      }
    },

    // Refreshes the horizontal dimensions of the calendar
    updateWidth: function (isResize) {
      // subclasses should implement
    },

    // Refreshes the vertical dimensions of the calendar
    updateHeight: function (isResize) {
      var calendar = this.calendar; // we poll the calendar for height information

      this.setHeight(
        calendar.getSuggestedViewHeight(),
        calendar.isHeightAuto()
      );
    },

    // Updates the vertical dimensions of the calendar to the specified height.
    // if `isAuto` is set to true, height becomes merely a suggestion and the view should use its "natural" height.
    setHeight: function (height, isAuto) {
      // subclasses should implement
    },

    /* Scroller
	------------------------------------------------------------------------------------------------------------------*/

    // Computes the initial pre-configured scroll state prior to allowing the user to change it.
    // Given the scroll state from the previous rendering. If first time rendering, given null.
    computeInitialScroll: function (previousScrollState) {
      return 0;
    },

    // Retrieves the view's current natural scroll state. Can return an arbitrary format.
    queryScroll: function () {
      // subclasses must implement
    },

    // Sets the view's scroll state. Will accept the same format computeInitialScroll and queryScroll produce.
    setScroll: function (scrollState) {
      // subclasses must implement
    },

    // Sets the scroll state, making sure to overcome any predefined scroll value the browser has in mind
    forceScroll: function (scrollState) {
      var _this = this;

      this.setScroll(scrollState);
      setTimeout(function () {
        _this.setScroll(scrollState);
      }, 0);
    },

    /* Event Elements / Segments
	------------------------------------------------------------------------------------------------------------------*/

    // Does everything necessary to display the given events onto the current view
    displayEvents: function (events) {
      var scrollState = this.queryScroll();

      this.clearEvents();
      this.renderEvents(events);
      this.isEventsRendered = true;
      this.setScroll(scrollState);
      this.triggerEventRender();
    },

    // Does everything necessary to clear the view's currently-rendered events
    clearEvents: function () {
      var scrollState;

      if (this.isEventsRendered) {
        // TODO: optimize: if we know this is part of a displayEvents call, don't queryScroll/setScroll
        scrollState = this.queryScroll();

        this.triggerEventUnrender();
        if (this.destroyEvents) {
          this.destroyEvents(); // TODO: deprecate
        }
        this.unrenderEvents();
        this.setScroll(scrollState);
        this.isEventsRendered = false;
      }
    },

    // Renders the events onto the view.
    renderEvents: function (events) {
      // subclasses should implement
    },

    // Removes event elements from the view.
    unrenderEvents: function () {
      // subclasses should implement
    },

    // Signals that all events have been rendered
    triggerEventRender: function () {
      this.renderedEventSegEach(function (seg) {
        this.trigger('eventAfterRender', seg.event, seg.event, seg.el);
      });
      this.trigger('eventAfterAllRender');
    },

    // Signals that all event elements are about to be removed
    triggerEventUnrender: function () {
      this.renderedEventSegEach(function (seg) {
        this.trigger('eventDestroy', seg.event, seg.event, seg.el);
      });
    },

    // Given an event and the default element used for rendering, returns the element that should actually be used.
    // Basically runs events and elements through the eventRender hook.
    resolveEventEl: function (event, el) {
      var custom = this.trigger('eventRender', event, event, el);

      if (custom === false) {
        // means don't render at all
        el = null;
      } else if (custom && custom !== true) {
        el = $(custom);
      }

      return el;
    },

    // Hides all rendered event segments linked to the given event
    showEvent: function (event) {
      this.renderedEventSegEach(function (seg) {
        seg.el.css('visibility', '');
      }, event);
    },

    // Shows all rendered event segments linked to the given event
    hideEvent: function (event) {
      this.renderedEventSegEach(function (seg) {
        seg.el.css('visibility', 'hidden');
      }, event);
    },

    // Iterates through event segments that have been rendered (have an el). Goes through all by default.
    // If the optional `event` argument is specified, only iterates through segments linked to that event.
    // The `this` value of the callback function will be the view.
    renderedEventSegEach: function (func, event) {
      var segs = this.getEventSegs();
      var i;

      for (i = 0; i < segs.length; i++) {
        if (!event || segs[i].event._id === event._id) {
          if (segs[i].el) {
            func.call(this, segs[i]);
          }
        }
      }
    },

    // Retrieves all the rendered segment objects for the view
    getEventSegs: function () {
      // subclasses must implement
      return [];
    },

    /* Event Drag-n-Drop
	------------------------------------------------------------------------------------------------------------------*/

    // Computes if the given event is allowed to be dragged by the user
    isEventDraggable: function (event) {
      var source = event.source || {};

      return firstDefined(
        event.startEditable,
        source.startEditable,
        this.opt('eventStartEditable'),
        event.editable,
        source.editable,
        this.opt('editable')
      );
    },

    // Must be called when an event in the view is dropped onto new location.
    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
    reportEventDrop: function (event, dropLocation, largeUnit, el, ev) {
      var calendar = this.calendar;
      var mutateResult = calendar.mutateEvent(event, dropLocation, largeUnit);
      var undoFunc = function () {
        mutateResult.undo();
        calendar.reportEventChange();
      };

      this.triggerEventDrop(event, mutateResult.dateDelta, undoFunc, el, ev);
      calendar.reportEventChange(); // will rerender events
    },

    // Triggers event-drop handlers that have subscribed via the API
    triggerEventDrop: function (event, dateDelta, undoFunc, el, ev) {
      this.trigger('eventDrop', el[0], event, dateDelta, undoFunc, ev, {}); // {} = jqui dummy
    },

    /* External Element Drag-n-Drop
	------------------------------------------------------------------------------------------------------------------*/

    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
    // `meta` is the parsed data that has been embedded into the dragging event.
    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
    reportExternalDrop: function (meta, dropLocation, el, ev, ui) {
      var eventProps = meta.eventProps;
      var eventInput;
      var event;

      // Try to build an event object and render it. TODO: decouple the two
      if (eventProps) {
        eventInput = $.extend({}, eventProps, dropLocation);
        event = this.calendar.renderEvent(eventInput, meta.stick)[0]; // renderEvent returns an array
      }

      this.triggerExternalDrop(event, dropLocation, el, ev, ui);
    },

    // Triggers external-drop handlers that have subscribed via the API
    triggerExternalDrop: function (event, dropLocation, el, ev, ui) {
      // trigger 'drop' regardless of whether element represents an event
      this.trigger('drop', el[0], dropLocation.start, ev, ui);

      if (event) {
        this.trigger('eventReceive', null, event); // signal an external event landed
      }
    },

    /* Drag-n-Drop Rendering (for both events and external elements)
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of a event or external-element drag over the given drop zone.
    // If an external-element, seg will be `null`.
    // Must return elements used for any mock events.
    renderDrag: function (dropLocation, seg) {
      // subclasses must implement
    },

    // Unrenders a visual indication of an event or external-element being dragged.
    unrenderDrag: function () {
      // subclasses must implement
    },

    /* Event Resizing
	------------------------------------------------------------------------------------------------------------------*/

    // Computes if the given event is allowed to be resized from its starting edge
    isEventResizableFromStart: function (event) {
      return (
        this.opt('eventResizableFromStart') && this.isEventResizable(event)
      );
    },

    // Computes if the given event is allowed to be resized from its ending edge
    isEventResizableFromEnd: function (event) {
      return this.isEventResizable(event);
    },

    // Computes if the given event is allowed to be resized by the user at all
    isEventResizable: function (event) {
      var source = event.source || {};

      return firstDefined(
        event.durationEditable,
        source.durationEditable,
        this.opt('eventDurationEditable'),
        event.editable,
        source.editable,
        this.opt('editable')
      );
    },

    // Must be called when an event in the view has been resized to a new length
    reportEventResize: function (event, resizeLocation, largeUnit, el, ev) {
      var calendar = this.calendar;
      var mutateResult = calendar.mutateEvent(event, resizeLocation, largeUnit);
      var undoFunc = function () {
        mutateResult.undo();
        calendar.reportEventChange();
      };

      this.triggerEventResize(
        event,
        mutateResult.durationDelta,
        undoFunc,
        el,
        ev
      );
      calendar.reportEventChange(); // will rerender events
    },

    // Triggers event-resize handlers that have subscribed via the API
    triggerEventResize: function (event, durationDelta, undoFunc, el, ev) {
      this.trigger(
        'eventResize',
        el[0],
        event,
        durationDelta,
        undoFunc,
        ev,
        {}
      ); // {} = jqui dummy
    },

    /* Selection (time range)
	------------------------------------------------------------------------------------------------------------------*/

    // Selects a date span on the view. `start` and `end` are both Moments.
    // `ev` is the native mouse event that begin the interaction.
    select: function (span, ev) {
      this.unselect(ev);
      this.renderSelection(span);
      this.reportSelection(span, ev);
    },

    // Renders a visual indication of the selection
    renderSelection: function (span) {
      // subclasses should implement
    },

    // Called when a new selection is made. Updates internal state and triggers handlers.
    reportSelection: function (span, ev) {
      this.isSelected = true;
      this.triggerSelect(span, ev);
    },

    // Triggers handlers to 'select'
    triggerSelect: function (span, ev) {
      this.trigger(
        'select',
        null,
        this.calendar.applyTimezone(span.start), // convert to calendar's tz for external API
        this.calendar.applyTimezone(span.end), // "
        ev
      );
    },

    // Undoes a selection. updates in the internal state and triggers handlers.
    // `ev` is the native mouse event that began the interaction.
    unselect: function (ev) {
      if (this.isSelected) {
        this.isSelected = false;
        if (this.destroySelection) {
          this.destroySelection(); // TODO: deprecate
        }
        this.unrenderSelection();
        this.trigger('unselect', null, ev);
      }
    },

    // Unrenders a visual indication of selection
    unrenderSelection: function () {
      // subclasses should implement
    },

    /* Event Selection
	------------------------------------------------------------------------------------------------------------------*/

    selectEvent: function (event) {
      if (!this.selectedEvent || this.selectedEvent !== event) {
        this.unselectEvent();
        this.renderedEventSegEach(function (seg) {
          seg.el.addClass('fc-selected');
        }, event);
        this.selectedEvent = event;
      }
    },

    unselectEvent: function () {
      if (this.selectedEvent) {
        this.renderedEventSegEach(function (seg) {
          seg.el.removeClass('fc-selected');
        }, this.selectedEvent);
        this.selectedEvent = null;
      }
    },

    isEventSelected: function (event) {
      // event references might change on refetchEvents(), while selectedEvent doesn't,
      // so compare IDs
      return this.selectedEvent && this.selectedEvent._id === event._id;
    },

    /* Mouse / Touch Unselecting (time range & event unselection)
	------------------------------------------------------------------------------------------------------------------*/
    // TODO: move consistently to down/start or up/end?
    // TODO: don't kill previous selection if touch scrolling

    handleDocumentMousedown: function (ev) {
      if (isPrimaryMouseButton(ev)) {
        this.processUnselect(ev);
      }
    },

    processUnselect: function (ev) {
      this.processRangeUnselect(ev);
      this.processEventUnselect(ev);
    },

    processRangeUnselect: function (ev) {
      var ignore;

      // is there a time-range selection?
      if (this.isSelected && this.opt('unselectAuto')) {
        // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
        ignore = this.opt('unselectCancel');
        if (!ignore || !$(ev.target).closest(ignore).length) {
          this.unselect(ev);
        }
      }
    },

    processEventUnselect: function (ev) {
      if (this.selectedEvent) {
        if (!$(ev.target).closest('.fc-selected').length) {
          this.unselectEvent();
        }
      }
    },

    /* Day Click
	------------------------------------------------------------------------------------------------------------------*/

    // Triggers handlers to 'dayClick'
    // Span has start/end of the clicked area. Only the start is useful.
    triggerDayClick: function (span, dayEl, ev) {
      this.trigger(
        'dayClick',
        dayEl,
        this.calendar.applyTimezone(span.start), // convert to calendar's timezone for external API
        ev
      );
    },

    /* Date Utils
	------------------------------------------------------------------------------------------------------------------*/

    // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays: function () {
      var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
      var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
      var dayCnt = 0;
      var i;

      if (this.opt('weekends') === false) {
        hiddenDays.push(0, 6); // 0=sunday, 6=saturday
      }

      for (i = 0; i < 7; i++) {
        if (!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)) {
          dayCnt++;
        }
      }

      if (!dayCnt) {
        throw 'invalid hiddenDays'; // all days were hidden? bad.
      }

      this.isHiddenDayHash = isHiddenDayHash;
    },

    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Moment
    isHiddenDay: function (day) {
      if (moment.isMoment(day)) {
        day = day.day();
      }
      return this.isHiddenDayHash[day];
    },

    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays: function (date, inc, isExclusive) {
      var out = date.clone();
      inc = inc || 1;
      while (
        this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]
      ) {
        out.add(inc, 'days');
      }
      return out;
    },

    // Returns the date range of the full days the given range visually appears to occupy.
    // Returns a new range object.
    computeDayRange: function (range) {
      var startDay = range.start.clone().stripTime(); // the beginning of the day the range starts
      var end = range.end;
      var endDay = null;
      var endTimeMS;

      if (end) {
        endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
        endTimeMS = +end.time(); // # of milliseconds into `endDay`

        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
          endDay.add(1, 'days');
        }
      }

      // If no end was specified, or if it is within `startDay` but not past nextDayThreshold,
      // assign the default duration of one day.
      if (!end || endDay <= startDay) {
        endDay = startDay.clone().add(1, 'days');
      }

      return { start: startDay, end: endDay };
    },

    // Does the given event visually appear to occupy more than one day?
    isMultiDayEvent: function (event) {
      var range = this.computeDayRange(event); // event is range-ish

      return range.end.diff(range.start, 'days') > 1;
    },
  }));

  /*
Embodies a div that has potential scrollbars
*/
  var Scroller = (FC.Scroller = Class.extend({
    el: null, // the guaranteed outer element
    scrollEl: null, // the element with the scrollbars
    overflowX: null,
    overflowY: null,

    constructor: function (options) {
      options = options || {};
      this.overflowX = options.overflowX || options.overflow || 'auto';
      this.overflowY = options.overflowY || options.overflow || 'auto';
    },

    render: function () {
      this.el = this.renderEl();
      this.applyOverflow();
    },

    renderEl: function () {
      return (this.scrollEl = $('<div class="fc-scroller"></div>'));
    },

    // sets to natural height, unlocks overflow
    clear: function () {
      this.setHeight('auto');
      this.applyOverflow();
    },

    destroy: function () {
      this.el.remove();
    },

    // Overflow
    // -----------------------------------------------------------------------------------------------------------------

    applyOverflow: function () {
      this.scrollEl.css({
        'overflow-x': this.overflowX,
        'overflow-y': this.overflowY,
      });
    },

    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
    // Useful for preserving scrollbar widths regardless of future resizes.
    // Can pass in scrollbarWidths for optimization.
    lockOverflow: function (scrollbarWidths) {
      var overflowX = this.overflowX;
      var overflowY = this.overflowY;

      scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();

      if (overflowX === 'auto') {
        overflowX =
          scrollbarWidths.top ||
          scrollbarWidths.bottom || // horizontal scrollbars?
          // OR scrolling pane with massless scrollbars?
          this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth
            ? // subtract 1 because of IE off-by-one issue
              'scroll'
            : 'hidden';
      }

      if (overflowY === 'auto') {
        overflowY =
          scrollbarWidths.left ||
          scrollbarWidths.right || // vertical scrollbars?
          // OR scrolling pane with massless scrollbars?
          this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight
            ? // subtract 1 because of IE off-by-one issue
              'scroll'
            : 'hidden';
      }

      this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
    },

    // Getters / Setters
    // -----------------------------------------------------------------------------------------------------------------

    setHeight: function (height) {
      this.scrollEl.height(height);
    },

    getScrollTop: function () {
      return this.scrollEl.scrollTop();
    },

    setScrollTop: function (top) {
      this.scrollEl.scrollTop(top);
    },

    getClientWidth: function () {
      return this.scrollEl[0].clientWidth;
    },

    getClientHeight: function () {
      return this.scrollEl[0].clientHeight;
    },

    getScrollbarWidths: function () {
      return getScrollbarWidths(this.scrollEl);
    },
  }));

  var Calendar = (FC.Calendar = Class.extend({
    dirDefaults: null, // option defaults related to LTR or RTL
    langDefaults: null, // option defaults related to current locale
    overrides: null, // option overrides given to the fullCalendar constructor
    dynamicOverrides: null, // options set with dynamic setter method. higher precedence than view overrides.
    options: null, // all defaults combined with overrides
    viewSpecCache: null, // cache of view definitions
    view: null, // current View object
    header: null,
    loadingLevel: 0, // number of simultaneous loading tasks

    // a lot of this class' OOP logic is scoped within this constructor function,
    // but in the future, write individual methods on the prototype.
    constructor: Calendar_constructor,

    // Subclasses can override this for initialization logic after the constructor has been called
    initialize: function () {},

    // Computes the flattened options hash for the calendar and assigns to `this.options`.
    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
    populateOptionsHash: function () {
      var lang, langDefaults;
      var isRTL, dirDefaults;

      lang = firstDefined(
        // explicit lang option given?
        this.dynamicOverrides.lang,
        this.overrides.lang
      );
      langDefaults = langOptionHash[lang];
      if (!langDefaults) {
        // explicit lang option not given or invalid?
        lang = Calendar.defaults.lang;
        langDefaults = langOptionHash[lang] || {};
      }

      isRTL = firstDefined(
        // based on options computed so far, is direction RTL?
        this.dynamicOverrides.isRTL,
        this.overrides.isRTL,
        langDefaults.isRTL,
        Calendar.defaults.isRTL
      );
      dirDefaults = isRTL ? Calendar.rtlDefaults : {};

      this.dirDefaults = dirDefaults;
      this.langDefaults = langDefaults;
      this.options = mergeOptions([
        // merge defaults and overrides. lowest to highest precedence
        Calendar.defaults, // global defaults
        dirDefaults,
        langDefaults,
        this.overrides,
        this.dynamicOverrides,
      ]);
      populateInstanceComputableOptions(this.options); // fill in gaps with computed options
    },

    // Gets information about how to create a view. Will use a cache.
    getViewSpec: function (viewType) {
      var cache = this.viewSpecCache;

      return (
        cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType))
      );
    },

    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec: function (unit) {
      var viewTypes;
      var i;
      var spec;

      if ($.inArray(unit, intervalUnits) != -1) {
        // put views that have buttons first. there will be duplicates, but oh well
        viewTypes = this.header.getViewsWithButtons();
        $.each(FC.views, function (viewType) {
          // all views
          viewTypes.push(viewType);
        });

        for (i = 0; i < viewTypes.length; i++) {
          spec = this.getViewSpec(viewTypes[i]);
          if (spec) {
            if (spec.singleUnit == unit) {
              return spec;
            }
          }
        }
      }
    },

    // Builds an object with information on how to create a given view
    buildViewSpec: function (requestedViewType) {
      var viewOverrides = this.overrides.views || {};
      var specChain = []; // for the view. lowest to highest priority
      var defaultsChain = []; // for the view. lowest to highest priority
      var overridesChain = []; // for the view. lowest to highest priority
      var viewType = requestedViewType;
      var spec; // for the view
      var overrides; // for the view
      var duration;
      var unit;

      // iterate from the specific view definition to a more general one until we hit an actual View class
      while (viewType) {
        spec = fcViews[viewType];
        overrides = viewOverrides[viewType];
        viewType = null; // clear. might repopulate for another iteration

        if (typeof spec === 'function') {
          // TODO: deprecate
          spec = { class: spec };
        }

        if (spec) {
          specChain.unshift(spec);
          defaultsChain.unshift(spec.defaults || {});
          duration = duration || spec.duration;
          viewType = viewType || spec.type;
        }

        if (overrides) {
          overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
          duration = duration || overrides.duration;
          viewType = viewType || overrides.type;
        }
      }

      spec = mergeProps(specChain);
      spec.type = requestedViewType;
      if (!spec['class']) {
        return false;
      }

      if (duration) {
        duration = moment.duration(duration);
        if (duration.valueOf()) {
          // valid?
          spec.duration = duration;
          unit = computeIntervalUnit(duration);

          // view is a single-unit duration, like "week" or "day"
          // incorporate options for this. lowest priority
          if (duration.as(unit) === 1) {
            spec.singleUnit = unit;
            overridesChain.unshift(viewOverrides[unit] || {});
          }
        }
      }

      spec.defaults = mergeOptions(defaultsChain);
      spec.overrides = mergeOptions(overridesChain);

      this.buildViewSpecOptions(spec);
      this.buildViewSpecButtonText(spec, requestedViewType);

      return spec;
    },

    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
    buildViewSpecOptions: function (spec) {
      spec.options = mergeOptions([
        // lowest to highest priority
        Calendar.defaults, // global defaults
        spec.defaults, // view's defaults (from ViewSubclass.defaults)
        this.dirDefaults,
        this.langDefaults, // locale and dir take precedence over view's defaults!
        this.overrides, // calendar's overrides (options given to constructor)
        spec.overrides, // view's overrides (view-specific options)
        this.dynamicOverrides, // dynamically set via setter. highest precedence
      ]);
      populateInstanceComputableOptions(spec.options);
    },

    // Computes and assigns a view spec's buttonText-related options
    buildViewSpecButtonText: function (spec, requestedViewType) {
      // given an options object with a possible `buttonText` hash, lookup the buttonText for the
      // requested view, falling back to a generic unit entry like "week" or "day"
      function queryButtonText(options) {
        var buttonText = options.buttonText || {};
        return (
          buttonText[requestedViewType] ||
          (spec.singleUnit ? buttonText[spec.singleUnit] : null)
        );
      }

      // highest to lowest priority
      spec.buttonTextOverride =
        queryButtonText(this.dynamicOverrides) ||
        queryButtonText(this.overrides) || // constructor-specified buttonText lookup hash takes precedence
        spec.overrides.buttonText; // `buttonText` for view-specific options is a string

      // highest to lowest priority. mirrors buildViewSpecOptions
      spec.buttonTextDefault =
        queryButtonText(this.langDefaults) ||
        queryButtonText(this.dirDefaults) ||
        spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
        queryButtonText(Calendar.defaults) ||
        (spec.duration ? this.humanizeDuration(spec.duration) : null) || // like "3 days"
        requestedViewType; // fall back to given view name
    },

    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
    instantiateView: function (viewType) {
      var spec = this.getViewSpec(viewType);

      return new spec['class'](this, viewType, spec.options, spec.duration);
    },

    // Returns a boolean about whether the view is okay to instantiate at some point
    isValidViewType: function (viewType) {
      return Boolean(this.getViewSpec(viewType));
    },

    // Should be called when any type of async data fetching begins
    pushLoading: function () {
      if (!this.loadingLevel++) {
        this.trigger('loading', null, true, this.view);
      }
    },

    // Should be called when any type of async data fetching completes
    popLoading: function () {
      if (!--this.loadingLevel) {
        this.trigger('loading', null, false, this.view);
      }
    },

    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
    buildSelectSpan: function (zonedStartInput, zonedEndInput) {
      var start = this.moment(zonedStartInput).stripZone();
      var end;

      if (zonedEndInput) {
        end = this.moment(zonedEndInput).stripZone();
      } else if (start.hasTime()) {
        end = start.clone().add(this.defaultTimedEventDuration);
      } else {
        end = start.clone().add(this.defaultAllDayEventDuration);
      }

      return { start: start, end: end };
    },
  }));

  Calendar.mixin(EmitterMixin);

  function Calendar_constructor(element, overrides) {
    var t = this;

    // Exports
    // -----------------------------------------------------------------------------------

    t.render = render;
    t.destroy = destroy;
    t.refetchEvents = refetchEvents;
    t.refetchEventSources = refetchEventSources;
    t.reportEvents = reportEvents;
    t.reportEventChange = reportEventChange;
    t.rerenderEvents = renderEvents; // `renderEvents` serves as a rerender. an API method
    t.changeView = renderView; // `renderView` will switch to another view
    t.select = select;
    t.unselect = unselect;
    t.prev = prev;
    t.next = next;
    t.prevYear = prevYear;
    t.nextYear = nextYear;
    t.today = today;
    t.gotoDate = gotoDate;
    t.incrementDate = incrementDate;
    t.zoomTo = zoomTo;
    t.getDate = getDate;
    t.getCalendar = getCalendar;
    t.getView = getView;
    t.option = option; // getter/setter method
    t.trigger = trigger;

    // Options
    // -----------------------------------------------------------------------------------

    t.dynamicOverrides = {};
    t.viewSpecCache = {};
    t.optionHandlers = {}; // for Calendar.options.js

    // convert legacy options into non-legacy ones.
    // in the future, when this is removed, don't use `overrides` reference. make a copy.
    t.overrides = massageOverrides(overrides || {});

    t.populateOptionsHash(); // sets this.options

    // Language-data Internals
    // -----------------------------------------------------------------------------------
    // Apply overrides to the current language's data

    var localeData;

    // Called immediately, and when any of the options change.
    // Happens before any internal objects rebuild or rerender, because this is very core.
    t.bindOptions(
      [
        'lang',
        'monthNames',
        'monthNamesShort',
        'dayNames',
        'dayNamesShort',
        'firstDay',
        'weekNumberCalculation',
      ],
      function (
        lang,
        monthNames,
        monthNamesShort,
        dayNames,
        dayNamesShort,
        firstDay,
        weekNumberCalculation
      ) {
        localeData = createObject(
          // make a cheap copy
          getMomentLocaleData(lang) // will fall back to en
        );

        if (monthNames) {
          localeData._months = monthNames;
        }
        if (monthNamesShort) {
          localeData._monthsShort = monthNamesShort;
        }
        if (dayNames) {
          localeData._weekdays = dayNames;
        }
        if (dayNamesShort) {
          localeData._weekdaysShort = dayNamesShort;
        }
        if (firstDay != null) {
          var _week = createObject(localeData._week); // _week: { dow: # }
          _week.dow = firstDay;
          localeData._week = _week;
        }

        if (weekNumberCalculation === 'iso') {
          weekNumberCalculation = 'ISO'; // normalize
        }
        if (
          // whitelist certain kinds of input
          weekNumberCalculation === 'ISO' ||
          weekNumberCalculation === 'local' ||
          typeof weekNumberCalculation === 'function'
        ) {
          localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
        }

        // If the internal current date object already exists, move to new locale.
        // We do NOT need to do this technique for event dates, because this happens when converting to "segments".
        if (date) {
          localizeMoment(date); // sets to localeData
        }
      }
    );

    // Calendar-specific Date Utilities
    // -----------------------------------------------------------------------------------

    t.defaultAllDayEventDuration = moment.duration(
      t.options.defaultAllDayEventDuration
    );
    t.defaultTimedEventDuration = moment.duration(
      t.options.defaultTimedEventDuration
    );

    // Builds a moment using the settings of the current calendar: timezone and language.
    // Accepts anything the vanilla moment() constructor accepts.
    t.moment = function () {
      var mom;

      if (t.options.timezone === 'local') {
        mom = FC.moment.apply(null, arguments);

        // Force the moment to be local, because FC.moment doesn't guarantee it.
        if (mom.hasTime()) {
          // don't give ambiguously-timed moments a local zone
          mom.local();
        }
      } else if (t.options.timezone === 'UTC') {
        mom = FC.moment.utc.apply(null, arguments); // process as UTC
      } else {
        mom = FC.moment.parseZone.apply(null, arguments); // let the input decide the zone
      }

      localizeMoment(mom);

      return mom;
    };

    // Updates the given moment's locale settings to the current calendar locale settings.
    function localizeMoment(mom) {
      if ('_locale' in mom) {
        // moment 2.8 and above
        mom._locale = localeData;
      } else {
        // pre-moment-2.8
        mom._lang = localeData;
      }
    }

    // Returns a boolean about whether or not the calendar knows how to calculate
    // the timezone offset of arbitrary dates in the current timezone.
    t.getIsAmbigTimezone = function () {
      return t.options.timezone !== 'local' && t.options.timezone !== 'UTC';
    };

    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
    t.applyTimezone = function (date) {
      if (!date.hasTime()) {
        return date.clone();
      }

      var zonedDate = t.moment(date.toArray());
      var timeAdjust = date.time() - zonedDate.time();
      var adjustedZonedDate;

      // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
      if (timeAdjust) {
        // is the time result different than expected?
        adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
        if (date.time() - adjustedZonedDate.time() === 0) {
          // does it match perfectly now?
          zonedDate = adjustedZonedDate;
        }
      }

      return zonedDate;
    };

    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
    // Will return an moment with an ambiguous timezone.
    t.getNow = function () {
      var now = t.options.now;
      if (typeof now === 'function') {
        now = now();
      }
      return t.moment(now).stripZone();
    };

    // Get an event's normalized end date. If not present, calculate it from the defaults.
    t.getEventEnd = function (event) {
      if (event.end) {
        return event.end.clone();
      } else {
        return t.getDefaultEventEnd(event.allDay, event.start);
      }
    };

    // Given an event's allDay status and start date, return what its fallback end date should be.
    // TODO: rename to computeDefaultEventEnd
    t.getDefaultEventEnd = function (allDay, zonedStart) {
      var end = zonedStart.clone();

      if (allDay) {
        end.stripTime().add(t.defaultAllDayEventDuration);
      } else {
        end.add(t.defaultTimedEventDuration);
      }

      if (t.getIsAmbigTimezone()) {
        end.stripZone(); // we don't know what the tzo should be
      }

      return end;
    };

    // Produces a human-readable string for the given duration.
    // Side-effect: changes the locale of the given duration.
    t.humanizeDuration = function (duration) {
      return (duration.locale || duration.lang)
        .call(duration, t.options.lang) // works moment-pre-2.8
        .humanize();
    };

    // Imports
    // -----------------------------------------------------------------------------------

    EventManager.call(t);
    var isFetchNeeded = t.isFetchNeeded;
    var fetchEvents = t.fetchEvents;
    var fetchEventSources = t.fetchEventSources;

    // Locals
    // -----------------------------------------------------------------------------------

    var _element = element[0];
    var header;
    var content;
    var tm; // for making theme classes
    var currentView; // NOTE: keep this in sync with this.view
    var viewsByType = {}; // holds all instantiated view instances, current or not
    var suggestedViewHeight;
    var windowResizeProxy; // wraps the windowResize function
    var ignoreWindowResize = 0;
    var events = [];
    var date; // unzoned

    // Main Rendering
    // -----------------------------------------------------------------------------------

    // compute the initial ambig-timezone date
    if (t.options.defaultDate != null) {
      date = t.moment(t.options.defaultDate).stripZone();
    } else {
      date = t.getNow(); // getNow already returns unzoned
    }

    function render() {
      if (!content) {
        initialRender();
      } else if (elementVisible()) {
        // mainly for the public API
        calcSize();
        renderView();
      }
    }

    function initialRender() {
      element.addClass('fc');

      // called immediately, and upon option change
      t.bindOption('theme', function (theme) {
        tm = theme ? 'ui' : 'fc'; // affects a larger scope
        element.toggleClass('ui-widget', theme);
        element.toggleClass('fc-unthemed', !theme);
      });

      // called immediately, and upon option change.
      // HACK: lang often affects isRTL, so we explicitly listen to that too.
      t.bindOptions(['isRTL', 'lang'], function (isRTL) {
        element.toggleClass('fc-ltr', !isRTL);
        element.toggleClass('fc-rtl', isRTL);
      });

      content = $("<div class='fc-view-container'></div>").prependTo(element);

      header = t.header = new Header(t);
      renderHeader();

      renderView(t.options.defaultView);

      if (t.options.handleWindowResize) {
        windowResizeProxy = debounce(windowResize, t.options.windowResizeDelay); // prevents rapid calls
        $(window).resize(windowResizeProxy);
      }
    }

    // can be called repeatedly and Header will rerender
    function renderHeader() {
      header.render();
      if (header.el) {
        element.prepend(header.el);
      }
    }

    function destroy() {
      if (currentView) {
        currentView.removeElement();

        // NOTE: don't null-out currentView/t.view in case API methods are called after destroy.
        // It is still the "current" view, just not rendered.
      }

      header.removeElement();
      content.remove();
      element.removeClass('fc fc-ltr fc-rtl fc-unthemed ui-widget');

      if (windowResizeProxy) {
        $(window).unbind('resize', windowResizeProxy);
      }
    }

    function elementVisible() {
      return element.is(':visible');
    }

    // View Rendering
    // -----------------------------------------------------------------------------------

    // Renders a view because of a date change, view-type change, or for the first time.
    // If not given a viewType, keep the current view but render different dates.
    // Accepts an optional scroll state to restore to.
    function renderView(viewType, explicitScrollState) {
      ignoreWindowResize++;

      // if viewType is changing, remove the old view's rendering
      if (currentView && viewType && currentView.type !== viewType) {
        freezeContentHeight(); // prevent a scroll jump when view element is removed
        clearView();
      }

      // if viewType changed, or the view was never created, create a fresh view
      if (!currentView && viewType) {
        currentView = t.view =
          viewsByType[viewType] ||
          (viewsByType[viewType] = t.instantiateView(viewType));

        currentView.setElement(
          $("<div class='fc-view fc-" + viewType + "-view'></div>").appendTo(
            content
          )
        );
        header.activateButton(viewType);
      }

      if (currentView) {
        // in case the view should render a period of time that is completely hidden
        date = currentView.massageCurrentDate(date);

        // render or rerender the view
        if (
          !currentView.displaying ||
          !date.isWithin(currentView.intervalStart, currentView.intervalEnd) // implicit date window change
        ) {
          if (elementVisible()) {
            currentView.display(date, explicitScrollState); // will call freezeContentHeight
            unfreezeContentHeight(); // immediately unfreeze regardless of whether display is async

            // need to do this after View::render, so dates are calculated
            updateHeaderTitle();
            updateTodayButton();

            getAndRenderEvents();
          }
        }
      }

      unfreezeContentHeight(); // undo any lone freezeContentHeight calls
      ignoreWindowResize--;
    }

    // Unrenders the current view and reflects this change in the Header.
    // Unregsiters the `currentView`, but does not remove from viewByType hash.
    function clearView() {
      header.deactivateButton(currentView.type);
      currentView.removeElement();
      currentView = t.view = null;
    }

    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
    // Maintains the same scroll state.
    // TODO: maintain any other user-manipulated state.
    function reinitView() {
      ignoreWindowResize++;
      freezeContentHeight();

      var viewType = currentView.type;
      var scrollState = currentView.queryScroll();
      clearView();
      renderView(viewType, scrollState);

      unfreezeContentHeight();
      ignoreWindowResize--;
    }

    // Resizing
    // -----------------------------------------------------------------------------------

    t.getSuggestedViewHeight = function () {
      if (suggestedViewHeight === undefined) {
        calcSize();
      }
      return suggestedViewHeight;
    };

    t.isHeightAuto = function () {
      return t.options.contentHeight === 'auto' || t.options.height === 'auto';
    };

    function updateSize(shouldRecalc) {
      if (elementVisible()) {
        if (shouldRecalc) {
          _calcSize();
        }

        ignoreWindowResize++;
        currentView.updateSize(true); // isResize=true. will poll getSuggestedViewHeight() and isHeightAuto()
        ignoreWindowResize--;

        return true; // signal success
      }
    }

    function calcSize() {
      if (elementVisible()) {
        _calcSize();
      }
    }

    function _calcSize() {
      // assumes elementVisible
      var contentHeightInput = t.options.contentHeight;
      var heightInput = t.options.height;

      if (typeof contentHeightInput === 'number') {
        // exists and not 'auto'
        suggestedViewHeight = contentHeightInput;
      } else if (typeof contentHeightInput === 'function') {
        // exists and is a function
        suggestedViewHeight = contentHeightInput();
      } else if (typeof heightInput === 'number') {
        // exists and not 'auto'
        suggestedViewHeight = heightInput - queryHeaderHeight();
      } else if (typeof heightInput === 'function') {
        // exists and is a function
        suggestedViewHeight = heightInput() - queryHeaderHeight();
      } else if (heightInput === 'parent') {
        // set to height of parent element
        suggestedViewHeight = element.parent().height() - queryHeaderHeight();
      } else {
        suggestedViewHeight = Math.round(
          content.width() / Math.max(t.options.aspectRatio, 0.5)
        );
      }
    }

    function queryHeaderHeight() {
      return header.el ? header.el.outerHeight(true) : 0; // includes margin
    }

    function windowResize(ev) {
      if (
        !ignoreWindowResize &&
        ev.target === window && // so we don't process jqui "resize" events that have bubbled up
        currentView.start // view has already been rendered
      ) {
        if (updateSize(true)) {
          currentView.trigger('windowResize', _element);
        }
      }
    }

    /* Event Fetching/Rendering
	-----------------------------------------------------------------------------*/
    // TODO: going forward, most of this stuff should be directly handled by the view

    function refetchEvents() {
      // can be called as an API method
      fetchAndRenderEvents();
    }

    // TODO: move this into EventManager?
    function refetchEventSources(matchInputs) {
      fetchEventSources(t.getEventSourcesByMatchArray(matchInputs));
    }

    function renderEvents() {
      // destroys old events if previously rendered
      if (elementVisible()) {
        freezeContentHeight();
        currentView.displayEvents(events);
        unfreezeContentHeight();
      }
    }

    function getAndRenderEvents() {
      if (
        !t.options.lazyFetching ||
        isFetchNeeded(currentView.start, currentView.end)
      ) {
        fetchAndRenderEvents();
      } else {
        renderEvents();
      }
    }

    function fetchAndRenderEvents() {
      fetchEvents(currentView.start, currentView.end);
      // ... will call reportEvents
      // ... which will call renderEvents
    }

    // called when event data arrives
    function reportEvents(_events) {
      events = _events;
      renderEvents();
    }

    // called when a single event's data has been changed
    function reportEventChange() {
      renderEvents();
    }

    /* Header Updating
	-----------------------------------------------------------------------------*/

    function updateHeaderTitle() {
      header.updateTitle(currentView.title);
    }

    function updateTodayButton() {
      var now = t.getNow();
      if (now.isWithin(currentView.intervalStart, currentView.intervalEnd)) {
        header.disableButton('today');
      } else {
        header.enableButton('today');
      }
    }

    /* Selection
	-----------------------------------------------------------------------------*/

    // this public method receives start/end dates in any format, with any timezone
    function select(zonedStartInput, zonedEndInput) {
      currentView.select(t.buildSelectSpan.apply(t, arguments));
    }

    function unselect() {
      // safe to be called before renderView
      if (currentView) {
        currentView.unselect();
      }
    }

    /* Date
	-----------------------------------------------------------------------------*/

    function prev() {
      date = currentView.computePrevDate(date);
      renderView();
    }

    function next() {
      date = currentView.computeNextDate(date);
      renderView();
    }

    function prevYear() {
      date.add(-1, 'years');
      renderView();
    }

    function nextYear() {
      date.add(1, 'years');
      renderView();
    }

    function today() {
      date = t.getNow();
      renderView();
    }

    function gotoDate(zonedDateInput) {
      date = t.moment(zonedDateInput).stripZone();
      renderView();
    }

    function incrementDate(delta) {
      date.add(moment.duration(delta));
      renderView();
    }

    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    function zoomTo(newDate, viewType) {
      var spec;

      viewType = viewType || 'day'; // day is default zoom
      spec = t.getViewSpec(viewType) || t.getUnitViewSpec(viewType);

      date = newDate.clone();
      renderView(spec ? spec.type : null);
    }

    // for external API
    function getDate() {
      return t.applyTimezone(date); // infuse the calendar's timezone
    }

    /* Height "Freezing"
	-----------------------------------------------------------------------------*/
    // TODO: move this into the view

    t.freezeContentHeight = freezeContentHeight;
    t.unfreezeContentHeight = unfreezeContentHeight;

    function freezeContentHeight() {
      content.css({
        width: '100%',
        height: content.height(),
        overflow: 'hidden',
      });
    }

    function unfreezeContentHeight() {
      content.css({
        width: '',
        height: '',
        overflow: '',
      });
    }

    /* Misc
	-----------------------------------------------------------------------------*/

    function getCalendar() {
      return t;
    }

    function getView() {
      return currentView;
    }

    function option(name, value) {
      var newOptionHash;

      if (typeof name === 'string') {
        if (value === undefined) {
          // getter
          return t.options[name];
        } else {
          // setter for individual option
          newOptionHash = {};
          newOptionHash[name] = value;
          setOptions(newOptionHash);
        }
      } else if (typeof name === 'object') {
        // compound setter with object input
        setOptions(name);
      }
    }

    function setOptions(newOptionHash) {
      var optionCnt = 0;
      var optionName;

      for (optionName in newOptionHash) {
        t.dynamicOverrides[optionName] = newOptionHash[optionName];
      }

      t.viewSpecCache = {}; // the dynamic override invalidates the options in this cache, so just clear it
      t.populateOptionsHash(); // this.options needs to be recomputed after the dynamic override

      // trigger handlers after this.options has been updated
      for (optionName in newOptionHash) {
        t.triggerOptionHandlers(optionName); // recall bindOption/bindOptions
        optionCnt++;
      }

      // special-case handling of single option change.
      // if only one option change, `optionName` will be its name.
      if (optionCnt === 1) {
        if (
          optionName === 'height' ||
          optionName === 'contentHeight' ||
          optionName === 'aspectRatio'
        ) {
          updateSize(true); // true = allow recalculation of height
          return;
        } else if (optionName === 'defaultDate') {
          return; // can't change date this way. use gotoDate instead
        } else if (optionName === 'businessHours') {
          if (currentView) {
            currentView.unrenderBusinessHours();
            currentView.renderBusinessHours();
          }
          return;
        } else if (optionName === 'timezone') {
          t.rezoneArrayEventSources();
          refetchEvents();
          return;
        }
      }

      // catch-all. rerender the header and rebuild/rerender the current view
      renderHeader();
      viewsByType = {}; // even non-current views will be affected by this option change. do before rerender
      reinitView();
    }

    function trigger(name, thisObj) {
      // overrides the Emitter's trigger method :(
      var args = Array.prototype.slice.call(arguments, 2);

      thisObj = thisObj || _element;
      this.triggerWith(name, thisObj, args); // Emitter's method

      if (t.options[name]) {
        return t.options[name].apply(thisObj, args);
      }
    }

    t.initialize();
  }

  /*
Options binding/triggering system.
*/
  Calendar.mixin({
    // A map of option names to arrays of handler objects. Initialized to {} in Calendar.
    // Format for a handler object:
    // {
    //   func // callback function to be called upon change
    //   names // option names whose values should be given to func
    // }
    optionHandlers: null,

    // Calls handlerFunc immediately, and when the given option has changed.
    // handlerFunc will be given the option value.
    bindOption: function (optionName, handlerFunc) {
      this.bindOptions([optionName], handlerFunc);
    },

    // Calls handlerFunc immediately, and when any of the given options change.
    // handlerFunc will be given each option value as ordered function arguments.
    bindOptions: function (optionNames, handlerFunc) {
      var handlerObj = { func: handlerFunc, names: optionNames };
      var i;

      for (i = 0; i < optionNames.length; i++) {
        this.registerOptionHandlerObj(optionNames[i], handlerObj);
      }

      this.triggerOptionHandlerObj(handlerObj);
    },

    // Puts the given handler object into the internal hash
    registerOptionHandlerObj: function (optionName, handlerObj) {
      (
        this.optionHandlers[optionName] ||
        (this.optionHandlers[optionName] = [])
      ).push(handlerObj);
    },

    // Reports that the given option has changed, and calls all appropriate handlers.
    triggerOptionHandlers: function (optionName) {
      var handlerObjs = this.optionHandlers[optionName] || [];
      var i;

      for (i = 0; i < handlerObjs.length; i++) {
        this.triggerOptionHandlerObj(handlerObjs[i]);
      }
    },

    // Calls the callback for a specific handler object, passing in the appropriate arguments.
    triggerOptionHandlerObj: function (handlerObj) {
      var optionNames = handlerObj.names;
      var optionValues = [];
      var i;

      for (i = 0; i < optionNames.length; i++) {
        optionValues.push(this.options[optionNames[i]]);
      }

      handlerObj.func.apply(this, optionValues); // maintain the Calendar's `this` context
    },
  });

  Calendar.defaults = {
    titleRangeSeparator: ' \u2013 ', // en dash
    monthYearFormat: 'MMMM YYYY', // required for en. other languages rely on datepicker computable option

    defaultTimedEventDuration: '02:00:00',
    defaultAllDayEventDuration: { days: 1 },
    forceEventDuration: false,
    nextDayThreshold: '09:00:00', // 9am

    // display
    defaultView: 'month',
    aspectRatio: 1.35,
    header: {
      left: 'title',
      center: '',
      right: 'today prev,next',
    },
    weekends: true,
    weekNumbers: false,

    weekNumberTitle: 'W',
    weekNumberCalculation: 'local',

    //editable: false,

    //nowIndicator: false,

    scrollTime: '06:00:00',

    // event ajax
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timezoneParam: 'timezone',

    timezone: false,

    //allDayDefault: undefined,

    // locale
    isRTL: false,
    buttonText: {
      prev: 'prev',
      next: 'next',
      prevYear: 'prev year',
      nextYear: 'next year',
      year: 'year', // TODO: locale files need to specify this
      today: 'today',
      month: 'month',
      week: 'week',
      day: 'day',
    },

    buttonIcons: {
      prev: 'left-single-arrow',
      next: 'right-single-arrow',
      prevYear: 'left-double-arrow',
      nextYear: 'right-double-arrow',
    },

    // jquery-ui theming
    theme: false,
    themeButtonIcons: {
      prev: 'circle-triangle-w',
      next: 'circle-triangle-e',
      prevYear: 'seek-prev',
      nextYear: 'seek-next',
    },

    //eventResizableFromStart: false,
    dragOpacity: 0.75,
    dragRevertDuration: 500,
    dragScroll: true,

    //selectable: false,
    unselectAuto: true,

    dropAccept: '*',

    eventOrder: 'title',

    eventLimit: false,
    eventLimitText: 'more',
    eventLimitClick: 'popover',
    dayPopoverFormat: 'LL',

    handleWindowResize: true,
    windowResizeDelay: 100, // milliseconds before an updateSize happens

    longPressDelay: 1000,
  };

  Calendar.englishDefaults = {
    // used by lang.js
    dayPopoverFormat: 'dddd, MMMM D',
  };

  Calendar.rtlDefaults = {
    // right-to-left defaults
    header: {
      // TODO: smarter solution (first/center/last ?)
      left: 'next,prev today',
      center: '',
      right: 'title',
    },
    buttonIcons: {
      prev: 'right-single-arrow',
      next: 'left-single-arrow',
      prevYear: 'right-double-arrow',
      nextYear: 'left-double-arrow',
    },
    themeButtonIcons: {
      prev: 'circle-triangle-e',
      next: 'circle-triangle-w',
      nextYear: 'seek-prev',
      prevYear: 'seek-next',
    },
  };

  var langOptionHash = (FC.langs = {}); // initialize and expose

  // TODO: document the structure and ordering of a FullCalendar lang file
  // TODO: rename everything "lang" to "locale", like what the moment project did

  // Initialize jQuery UI datepicker translations while using some of the translations
  // Will set this as the default language for datepicker.
  FC.datepickerLang = function (langCode, dpLangCode, dpOptions) {
    // get the FullCalendar internal option hash for this language. create if necessary
    var fcOptions = langOptionHash[langCode] || (langOptionHash[langCode] = {});

    // transfer some simple options from datepicker to fc
    fcOptions.isRTL = dpOptions.isRTL;
    fcOptions.weekNumberTitle = dpOptions.weekHeader;

    // compute some more complex options from datepicker
    $.each(dpComputableOptions, function (name, func) {
      fcOptions[name] = func(dpOptions);
    });

    // is jQuery UI Datepicker is on the page?
    if ($.datepicker) {
      // Register the language data.
      // FullCalendar and MomentJS use language codes like "pt-br" but Datepicker
      // does it like "pt-BR" or if it doesn't have the language, maybe just "pt".
      // Make an alias so the language can be referenced either way.
      $.datepicker.regional[dpLangCode] = $.datepicker.regional[
        langCode
      ] = dpOptions; // alias

      // Alias 'en' to the default language data. Do this every time.
      $.datepicker.regional.en = $.datepicker.regional[''];

      // Set as Datepicker's global defaults.
      $.datepicker.setDefaults(dpOptions);
    }
  };

  // Sets FullCalendar-specific translations. Will set the language as the global default.
  FC.lang = function (langCode, newFcOptions) {
    var fcOptions;
    var momOptions;

    // get the FullCalendar internal option hash for this language. create if necessary
    fcOptions = langOptionHash[langCode] || (langOptionHash[langCode] = {});

    // provided new options for this language? merge them in
    if (newFcOptions) {
      fcOptions = langOptionHash[langCode] = mergeOptions([
        fcOptions,
        newFcOptions,
      ]);
    }

    // compute language options that weren't defined.
    // always do this. newFcOptions can be undefined when initializing from i18n file,
    // so no way to tell if this is an initialization or a default-setting.
    momOptions = getMomentLocaleData(langCode); // will fall back to en
    $.each(momComputableOptions, function (name, func) {
      if (fcOptions[name] == null) {
        fcOptions[name] = func(momOptions, fcOptions);
      }
    });

    // set it as the default language for FullCalendar
    Calendar.defaults.lang = langCode;
  };

  // NOTE: can't guarantee any of these computations will run because not every language has datepicker
  // configs, so make sure there are English fallbacks for these in the defaults file.
  var dpComputableOptions = {
    buttonText: function (dpOptions) {
      return {
        // the translations sometimes wrongly contain HTML entities
        prev: stripHtmlEntities(dpOptions.prevText),
        next: stripHtmlEntities(dpOptions.nextText),
        today: stripHtmlEntities(dpOptions.currentText),
      };
    },

    // Produces format strings like "MMMM YYYY" -> "September 2014"
    monthYearFormat: function (dpOptions) {
      return dpOptions.showMonthAfterYear
        ? 'YYYY[' + dpOptions.yearSuffix + '] MMMM'
        : 'MMMM YYYY[' + dpOptions.yearSuffix + ']';
    },
  };

  var momComputableOptions = {
    // Produces format strings like "ddd M/D" -> "Fri 9/15"
    dayOfMonthFormat: function (momOptions, fcOptions) {
      var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"

      // strip the year off the edge, as well as other misc non-whitespace chars
      format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');

      if (fcOptions.isRTL) {
        format += ' ddd'; // for RTL, add day-of-week to end
      } else {
        format = 'ddd ' + format; // for LTR, add day-of-week to beginning
      }
      return format;
    },

    // Produces format strings like "h:mma" -> "6:00pm"
    mediumTimeFormat: function (momOptions) {
      // can't be called `timeFormat` because collides with option
      return momOptions.longDateFormat('LT').replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },

    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
    smallTimeFormat: function (momOptions) {
      return momOptions
        .longDateFormat('LT')
        .replace(':mm', '(:mm)')
        .replace(/(\Wmm)$/, '($1)') // like above, but for foreign langs
        .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },

    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
    extraSmallTimeFormat: function (momOptions) {
      return momOptions
        .longDateFormat('LT')
        .replace(':mm', '(:mm)')
        .replace(/(\Wmm)$/, '($1)') // like above, but for foreign langs
        .replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
    },

    // Produces format strings like "ha" / "H" -> "6pm" / "18"
    hourFormat: function (momOptions) {
      return momOptions
        .longDateFormat('LT')
        .replace(':mm', '')
        .replace(/(\Wmm)$/, '') // like above, but for foreign langs
        .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },

    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
    noMeridiemTimeFormat: function (momOptions) {
      return momOptions.longDateFormat('LT').replace(/\s*a$/i, ''); // remove trailing AM/PM
    },
  };

  // options that should be computed off live calendar options (considers override options)
  // TODO: best place for this? related to lang?
  // TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
  var instanceComputableOptions = {
    // Produces format strings for results like "Mo 16"
    smallDayDateFormat: function (options) {
      return options.isRTL ? 'D dd' : 'dd D';
    },

    // Produces format strings for results like "Wk 5"
    weekFormat: function (options) {
      return options.isRTL
        ? 'w[ ' + options.weekNumberTitle + ']'
        : '[' + options.weekNumberTitle + ' ]w';
    },

    // Produces format strings for results like "Wk5"
    smallWeekFormat: function (options) {
      return options.isRTL
        ? 'w[' + options.weekNumberTitle + ']'
        : '[' + options.weekNumberTitle + ']w';
    },
  };

  function populateInstanceComputableOptions(options) {
    $.each(instanceComputableOptions, function (name, func) {
      if (options[name] == null) {
        options[name] = func(options);
      }
    });
  }

  // Returns moment's internal locale data. If doesn't exist, returns English.
  // Works with moment-pre-2.8
  function getMomentLocaleData(langCode) {
    var func = moment.localeData || moment.langData;
    return func.call(moment, langCode) || func.call(moment, 'en'); // the newer localData could return null, so fall back to en
  }

  // Initialize English by forcing computation of moment-derived options.
  // Also, sets it as the default.
  FC.lang('en', Calendar.englishDefaults);

  /* Top toolbar area with buttons and title
----------------------------------------------------------------------------------------------------------------------*/
  // TODO: rename all header-related things to "toolbar"

  function Header(calendar) {
    var t = this;

    // exports
    t.render = render;
    t.removeElement = removeElement;
    t.updateTitle = updateTitle;
    t.activateButton = activateButton;
    t.deactivateButton = deactivateButton;
    t.disableButton = disableButton;
    t.enableButton = enableButton;
    t.getViewsWithButtons = getViewsWithButtons;
    t.el = null; // mirrors local `el`

    // locals
    var el;
    var viewsWithButtons = [];
    var tm;

    // can be called repeatedly and will rerender
    function render() {
      var options = calendar.options;
      var sections = options.header;

      tm = options.theme ? 'ui' : 'fc';

      if (sections) {
        if (!el) {
          el = this.el = $("<div class='fc-toolbar'></div>");
        } else {
          el.empty();
        }
        el.append(renderSection('left'))
          .append(renderSection('right'))
          .append(renderSection('center'))
          .append('<div class="fc-clear"></div>');
      } else {
        removeElement();
      }
    }

    function removeElement() {
      if (el) {
        el.remove();
        el = t.el = null;
      }
    }

    function renderSection(position) {
      var sectionEl = $('<div class="fc-' + position + '"></div>');
      var options = calendar.options;
      var buttonStr = options.header[position];

      if (buttonStr) {
        $.each(buttonStr.split(' '), function (i) {
          var groupChildren = $();
          var isOnlyButtons = true;
          var groupEl;

          $.each(this.split(','), function (j, buttonName) {
            var customButtonProps;
            var viewSpec;
            var buttonClick;
            var overrideText; // text explicitly set by calendar's constructor options. overcomes icons
            var defaultText;
            var themeIcon;
            var normalIcon;
            var innerHtml;
            var classes;
            var button; // the element

            if (buttonName == 'title') {
              groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
              isOnlyButtons = false;
            } else {
              if (
                (customButtonProps = (options.customButtons || {})[buttonName])
              ) {
                buttonClick = function (ev) {
                  if (customButtonProps.click) {
                    customButtonProps.click.call(button[0], ev);
                  }
                };
                overrideText = ''; // icons will override text
                defaultText = customButtonProps.text;
              } else if ((viewSpec = calendar.getViewSpec(buttonName))) {
                buttonClick = function () {
                  calendar.changeView(buttonName);
                };
                viewsWithButtons.push(buttonName);
                overrideText = viewSpec.buttonTextOverride;
                defaultText = viewSpec.buttonTextDefault;
              } else if (calendar[buttonName]) {
                // a calendar method
                buttonClick = function () {
                  calendar[buttonName]();
                };
                overrideText = (calendar.overrides.buttonText || {})[
                  buttonName
                ];
                defaultText = options.buttonText[buttonName]; // everything else is considered default
              }

              if (buttonClick) {
                themeIcon = customButtonProps
                  ? customButtonProps.themeIcon
                  : options.themeButtonIcons[buttonName];

                normalIcon = customButtonProps
                  ? customButtonProps.icon
                  : options.buttonIcons[buttonName];

                if (overrideText) {
                  innerHtml = htmlEscape(overrideText);
                } else if (themeIcon && options.theme) {
                  innerHtml =
                    "<span class='ui-icon ui-icon-" + themeIcon + "'></span>";
                } else if (normalIcon && !options.theme) {
                  innerHtml =
                    "<span class='fc-icon fc-icon-" + normalIcon + "'></span>";
                } else {
                  innerHtml = htmlEscape(defaultText);
                }

                classes = [
                  'fc-' + buttonName + '-button',
                  tm + '-button',
                  tm + '-state-default',
                ];

                button = $(
                  // type="button" so that it doesn't submit a form
                  '<button type="button" class="' +
                    classes.join(' ') +
                    '">' +
                    innerHtml +
                    '</button>'
                )
                  .click(function (ev) {
                    // don't process clicks for disabled buttons
                    if (!button.hasClass(tm + '-state-disabled')) {
                      buttonClick(ev);

                      // after the click action, if the button becomes the "active" tab, or disabled,
                      // it should never have a hover class, so remove it now.
                      if (
                        button.hasClass(tm + '-state-active') ||
                        button.hasClass(tm + '-state-disabled')
                      ) {
                        button.removeClass(tm + '-state-hover');
                      }
                    }
                  })
                  .mousedown(function () {
                    // the *down* effect (mouse pressed in).
                    // only on buttons that are not the "active" tab, or disabled
                    button
                      .not('.' + tm + '-state-active')
                      .not('.' + tm + '-state-disabled')
                      .addClass(tm + '-state-down');
                  })
                  .mouseup(function () {
                    // undo the *down* effect
                    button.removeClass(tm + '-state-down');
                  })
                  .hover(
                    function () {
                      // the *hover* effect.
                      // only on buttons that are not the "active" tab, or disabled
                      button
                        .not('.' + tm + '-state-active')
                        .not('.' + tm + '-state-disabled')
                        .addClass(tm + '-state-hover');
                    },
                    function () {
                      // undo the *hover* effect
                      button
                        .removeClass(tm + '-state-hover')
                        .removeClass(tm + '-state-down'); // if mouseleave happens before mouseup
                    }
                  );

                groupChildren = groupChildren.add(button);
              }
            }
          });

          if (isOnlyButtons) {
            groupChildren
              .first()
              .addClass(tm + '-corner-left')
              .end()
              .last()
              .addClass(tm + '-corner-right')
              .end();
          }

          if (groupChildren.length > 1) {
            groupEl = $('<div></div>');
            if (isOnlyButtons) {
              groupEl.addClass('fc-button-group');
            }
            groupEl.append(groupChildren);
            sectionEl.append(groupEl);
          } else {
            sectionEl.append(groupChildren); // 1 or 0 children
          }
        });
      }

      return sectionEl;
    }

    function updateTitle(text) {
      if (el) {
        el.find('h2').text(text);
      }
    }

    function activateButton(buttonName) {
      if (el) {
        el.find('.fc-' + buttonName + '-button').addClass(tm + '-state-active');
      }
    }

    function deactivateButton(buttonName) {
      if (el) {
        el.find('.fc-' + buttonName + '-button').removeClass(
          tm + '-state-active'
        );
      }
    }

    function disableButton(buttonName) {
      if (el) {
        el.find('.fc-' + buttonName + '-button')
          .prop('disabled', true)
          .addClass(tm + '-state-disabled');
      }
    }

    function enableButton(buttonName) {
      if (el) {
        el.find('.fc-' + buttonName + '-button')
          .prop('disabled', false)
          .removeClass(tm + '-state-disabled');
      }
    }

    function getViewsWithButtons() {
      return viewsWithButtons;
    }
  }

  FC.sourceNormalizers = [];
  FC.sourceFetchers = [];

  var ajaxDefaults = {
    dataType: 'json',
    cache: false,
  };

  var eventGUID = 1;

  function EventManager() {
    // assumed to be a calendar
    var t = this;

    // exports
    t.isFetchNeeded = isFetchNeeded;
    t.fetchEvents = fetchEvents;
    t.fetchEventSources = fetchEventSources;
    t.getEventSources = getEventSources;
    t.getEventSourceById = getEventSourceById;
    t.getEventSourcesByMatchArray = getEventSourcesByMatchArray;
    t.getEventSourcesByMatch = getEventSourcesByMatch;
    t.addEventSource = addEventSource;
    t.removeEventSource = removeEventSource;
    t.removeEventSources = removeEventSources;
    t.updateEvent = updateEvent;
    t.renderEvent = renderEvent;
    t.removeEvents = removeEvents;
    t.clientEvents = clientEvents;
    t.mutateEvent = mutateEvent;
    t.normalizeEventDates = normalizeEventDates;
    t.normalizeEventTimes = normalizeEventTimes;

    // imports
    var reportEvents = t.reportEvents;

    // locals
    var stickySource = { events: [] };
    var sources = [stickySource];
    var rangeStart, rangeEnd;
    var pendingSourceCnt = 0; // outstanding fetch requests, max one per source
    var cache = []; // holds events that have already been expanded

    $.each(
      (t.options.events ? [t.options.events] : []).concat(
        t.options.eventSources || []
      ),
      function (i, sourceInput) {
        var source = buildEventSource(sourceInput);
        if (source) {
          sources.push(source);
        }
      }
    );

    /* Fetching
	-----------------------------------------------------------------------------*/

    // start and end are assumed to be unzoned
    function isFetchNeeded(start, end) {
      return (
        !rangeStart || // nothing has been fetched yet?
        start < rangeStart ||
        end > rangeEnd
      ); // is part of the new range outside of the old range?
    }

    function fetchEvents(start, end) {
      rangeStart = start;
      rangeEnd = end;
      fetchEventSources(sources, 'reset');
    }

    // expects an array of event source objects (the originals, not copies)
    // `specialFetchType` is an optimization parameter that affects purging of the event cache.
    function fetchEventSources(specificSources, specialFetchType) {
      var i, source;

      if (specialFetchType === 'reset') {
        cache = [];
      } else if (specialFetchType !== 'add') {
        cache = excludeEventsBySources(cache, specificSources);
      }

      for (i = 0; i < specificSources.length; i++) {
        source = specificSources[i];

        // already-pending sources have already been accounted for in pendingSourceCnt
        if (source._status !== 'pending') {
          pendingSourceCnt++;
        }

        source._fetchId = (source._fetchId || 0) + 1;
        source._status = 'pending';
      }

      for (i = 0; i < specificSources.length; i++) {
        source = specificSources[i];

        tryFetchEventSource(source, source._fetchId);
      }
    }

    // fetches an event source and processes its result ONLY if it is still the current fetch.
    // caller is responsible for incrementing pendingSourceCnt first.
    function tryFetchEventSource(source, fetchId) {
      _fetchEventSource(source, function (eventInputs) {
        var isArraySource = $.isArray(source.events);
        var i, eventInput;
        var abstractEvent;

        if (
          // is this the source's most recent fetch?
          // if not, rely on an upcoming fetch of this source to decrement pendingSourceCnt
          fetchId === source._fetchId &&
          // event source no longer valid?
          source._status !== 'rejected'
        ) {
          source._status = 'resolved';

          if (eventInputs) {
            for (i = 0; i < eventInputs.length; i++) {
              eventInput = eventInputs[i];

              if (isArraySource) {
                // array sources have already been convert to Event Objects
                abstractEvent = eventInput;
              } else {
                abstractEvent = buildEventFromInput(eventInput, source);
              }

              if (abstractEvent) {
                // not false (an invalid event)
                cache.push.apply(
                  cache,
                  expandEvent(abstractEvent) // add individual expanded events to the cache
                );
              }
            }
          }

          decrementPendingSourceCnt();
        }
      });
    }

    function rejectEventSource(source) {
      var wasPending = source._status === 'pending';

      source._status = 'rejected';

      if (wasPending) {
        decrementPendingSourceCnt();
      }
    }

    function decrementPendingSourceCnt() {
      pendingSourceCnt--;
      if (!pendingSourceCnt) {
        reportEvents(cache);
      }
    }

    function _fetchEventSource(source, callback) {
      var i;
      var fetchers = FC.sourceFetchers;
      var res;

      for (i = 0; i < fetchers.length; i++) {
        res = fetchers[i].call(
          t, // this, the Calendar object
          source,
          rangeStart.clone(),
          rangeEnd.clone(),
          t.options.timezone,
          callback
        );

        if (res === true) {
          // the fetcher is in charge. made its own async request
          return;
        } else if (typeof res == 'object') {
          // the fetcher returned a new source. process it
          _fetchEventSource(res, callback);
          return;
        }
      }

      var events = source.events;
      if (events) {
        if ($.isFunction(events)) {
          t.pushLoading();
          events.call(
            t, // this, the Calendar object
            rangeStart.clone(),
            rangeEnd.clone(),
            t.options.timezone,
            function (events) {
              callback(events);
              t.popLoading();
            }
          );
        } else if ($.isArray(events)) {
          callback(events);
        } else {
          callback();
        }
      } else {
        var url = source.url;
        if (url) {
          var success = source.success;
          var error = source.error;
          var complete = source.complete;

          // retrieve any outbound GET/POST $.ajax data from the options
          var customData;
          if ($.isFunction(source.data)) {
            // supplied as a function that returns a key/value object
            customData = source.data();
          } else {
            // supplied as a straight key/value object
            customData = source.data;
          }

          // use a copy of the custom data so we can modify the parameters
          // and not affect the passed-in object.
          var data = $.extend({}, customData || {});

          var startParam = firstDefined(
            source.startParam,
            t.options.startParam
          );
          var endParam = firstDefined(source.endParam, t.options.endParam);
          var timezoneParam = firstDefined(
            source.timezoneParam,
            t.options.timezoneParam
          );

          if (startParam) {
            data[startParam] = rangeStart.format();
          }
          if (endParam) {
            data[endParam] = rangeEnd.format();
          }
          if (t.options.timezone && t.options.timezone != 'local') {
            data[timezoneParam] = t.options.timezone;
          }

          t.pushLoading();
          $.ajax(
            $.extend({}, ajaxDefaults, source, {
              data: data,
              success: function (events) {
                events = events || [];
                var res = applyAll(success, this, arguments);
                if ($.isArray(res)) {
                  events = res;
                }
                callback(events);
              },
              error: function () {
                applyAll(error, this, arguments);
                callback();
              },
              complete: function () {
                applyAll(complete, this, arguments);
                t.popLoading();
              },
            })
          );
        } else {
          callback();
        }
      }
    }

    /* Sources
	-----------------------------------------------------------------------------*/

    function addEventSource(sourceInput) {
      var source = buildEventSource(sourceInput);
      if (source) {
        sources.push(source);
        fetchEventSources([source], 'add'); // will eventually call reportEvents
      }
    }

    function buildEventSource(sourceInput) {
      // will return undefined if invalid source
      var normalizers = FC.sourceNormalizers;
      var source;
      var i;

      if ($.isFunction(sourceInput) || $.isArray(sourceInput)) {
        source = { events: sourceInput };
      } else if (typeof sourceInput === 'string') {
        source = { url: sourceInput };
      } else if (typeof sourceInput === 'object') {
        source = $.extend({}, sourceInput); // shallow copy
      }

      if (source) {
        // TODO: repeat code, same code for event classNames
        if (source.className) {
          if (typeof source.className === 'string') {
            source.className = source.className.split(/\s+/);
          }
          // otherwise, assumed to be an array
        } else {
          source.className = [];
        }

        // for array sources, we convert to standard Event Objects up front
        if ($.isArray(source.events)) {
          source.origArray = source.events; // for removeEventSource
          source.events = $.map(source.events, function (eventInput) {
            return buildEventFromInput(eventInput, source);
          });
        }

        for (i = 0; i < normalizers.length; i++) {
          normalizers[i].call(t, source);
        }

        return source;
      }
    }

    function removeEventSource(matchInput) {
      removeSpecificEventSources(getEventSourcesByMatch(matchInput));
    }

    // if called with no arguments, removes all.
    function removeEventSources(matchInputs) {
      if (matchInputs == null) {
        removeSpecificEventSources(sources, true); // isAll=true
      } else {
        removeSpecificEventSources(getEventSourcesByMatchArray(matchInputs));
      }
    }

    function removeSpecificEventSources(targetSources, isAll) {
      var i;

      // cancel pending requests
      for (i = 0; i < targetSources.length; i++) {
        rejectEventSource(targetSources[i]);
      }

      if (isAll) {
        // an optimization
        sources = [];
        cache = [];
      } else {
        // remove from persisted source list
        sources = $.grep(sources, function (source) {
          for (i = 0; i < targetSources.length; i++) {
            if (source === targetSources[i]) {
              return false; // exclude
            }
          }
          return true; // include
        });

        cache = excludeEventsBySources(cache, targetSources);
      }

      reportEvents(cache);
    }

    function getEventSources() {
      return sources.slice(1); // returns a shallow copy of sources with stickySource removed
    }

    function getEventSourceById(id) {
      return $.grep(sources, function (source) {
        return source.id && source.id === id;
      })[0];
    }

    // like getEventSourcesByMatch, but accepts multple match criteria (like multiple IDs)
    function getEventSourcesByMatchArray(matchInputs) {
      // coerce into an array
      if (!matchInputs) {
        matchInputs = [];
      } else if (!$.isArray(matchInputs)) {
        matchInputs = [matchInputs];
      }

      var matchingSources = [];
      var i;

      // resolve raw inputs to real event source objects
      for (i = 0; i < matchInputs.length; i++) {
        matchingSources.push.apply(
          // append
          matchingSources,
          getEventSourcesByMatch(matchInputs[i])
        );
      }

      return matchingSources;
    }

    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
    // returns an array of matching source objects.
    function getEventSourcesByMatch(matchInput) {
      var i, source;

      // given an proper event source object
      for (i = 0; i < sources.length; i++) {
        source = sources[i];
        if (source === matchInput) {
          return [source];
        }
      }

      // an ID match
      source = getEventSourceById(matchInput);
      if (source) {
        return [source];
      }

      return $.grep(sources, function (source) {
        return isSourcesEquivalent(matchInput, source);
      });
    }

    function isSourcesEquivalent(source1, source2) {
      return (
        source1 &&
        source2 &&
        getSourcePrimitive(source1) == getSourcePrimitive(source2)
      );
    }

    function getSourcePrimitive(source) {
      return (
        (typeof source === 'object' // a normalized event source?
          ? source.origArray ||
            source.googleCalendarId ||
            source.url ||
            source.events // get the primitive
          : null) || source
      ); // the given argument *is* the primitive
    }

    // util
    // returns a filtered array without events that are part of any of the given sources
    function excludeEventsBySources(specificEvents, specificSources) {
      return $.grep(specificEvents, function (event) {
        for (var i = 0; i < specificSources.length; i++) {
          if (event.source === specificSources[i]) {
            return false; // exclude
          }
        }
        return true; // keep
      });
    }

    /* Manipulation
	-----------------------------------------------------------------------------*/

    // Only ever called from the externally-facing API
    function updateEvent(event) {
      // massage start/end values, even if date string values
      event.start = t.moment(event.start);
      if (event.end) {
        event.end = t.moment(event.end);
      } else {
        event.end = null;
      }

      mutateEvent(event, getMiscEventProps(event)); // will handle start/end/allDay normalization
      reportEvents(cache); // reports event modifications (so we can redraw)
    }

    // Returns a hash of misc event properties that should be copied over to related events.
    function getMiscEventProps(event) {
      var props = {};

      $.each(event, function (name, val) {
        if (isMiscEventPropName(name)) {
          if (val !== undefined && isAtomic(val)) {
            // a defined non-object
            props[name] = val;
          }
        }
      });

      return props;
    }

    // non-date-related, non-id-related, non-secret
    function isMiscEventPropName(name) {
      return !/^_|^(id|allDay|start|end)$/.test(name);
    }

    // returns the expanded events that were created
    function renderEvent(eventInput, stick) {
      var abstractEvent = buildEventFromInput(eventInput);
      var events;
      var i, event;

      if (abstractEvent) {
        // not false (a valid input)
        events = expandEvent(abstractEvent);

        for (i = 0; i < events.length; i++) {
          event = events[i];

          if (!event.source) {
            if (stick) {
              stickySource.events.push(event);
              event.source = stickySource;
            }
            cache.push(event);
          }
        }

        reportEvents(cache);

        return events;
      }

      return [];
    }

    function removeEvents(filter) {
      var eventID;
      var i;

      if (filter == null) {
        // null or undefined. remove all events
        filter = function () {
          return true;
        }; // will always match
      } else if (!$.isFunction(filter)) {
        // an event ID
        eventID = filter + '';
        filter = function (event) {
          return event._id == eventID;
        };
      }

      // Purge event(s) from our local cache
      cache = $.grep(cache, filter, true); // inverse=true

      // Remove events from array sources.
      // This works because they have been converted to official Event Objects up front.
      // (and as a result, event._id has been calculated).
      for (i = 0; i < sources.length; i++) {
        if ($.isArray(sources[i].events)) {
          sources[i].events = $.grep(sources[i].events, filter, true);
        }
      }

      reportEvents(cache);
    }

    function clientEvents(filter) {
      if ($.isFunction(filter)) {
        return $.grep(cache, filter);
      } else if (filter != null) {
        // not null, not undefined. an event ID
        filter += '';
        return $.grep(cache, function (e) {
          return e._id == filter;
        });
      }
      return cache; // else, return all
    }

    // Makes sure all array event sources have their internal event objects
    // converted over to the Calendar's current timezone.
    t.rezoneArrayEventSources = function () {
      var i;
      var events;
      var j;

      for (i = 0; i < sources.length; i++) {
        events = sources[i].events;
        if ($.isArray(events)) {
          for (j = 0; j < events.length; j++) {
            rezoneEventDates(events[j]);
          }
        }
      }
    };

    function rezoneEventDates(event) {
      event.start = t.moment(event.start);
      if (event.end) {
        event.end = t.moment(event.end);
      }
      backupEventDates(event);
    }

    /* Event Normalization
	-----------------------------------------------------------------------------*/

    // Given a raw object with key/value properties, returns an "abstract" Event object.
    // An "abstract" event is an event that, if recurring, will not have been expanded yet.
    // Will return `false` when input is invalid.
    // `source` is optional
    function buildEventFromInput(input, source) {
      var out = {};
      var start, end;
      var allDay;

      if (t.options.eventDataTransform) {
        input = t.options.eventDataTransform(input);
      }
      if (source && source.eventDataTransform) {
        input = source.eventDataTransform(input);
      }

      // Copy all properties over to the resulting object.
      // The special-case properties will be copied over afterwards.
      $.extend(out, input);

      if (source) {
        out.source = source;
      }

      out._id =
        input._id ||
        (input.id === undefined ? '_fc' + eventGUID++ : input.id + '');

      if (input.className) {
        if (typeof input.className == 'string') {
          out.className = input.className.split(/\s+/);
        } else {
          // assumed to be an array
          out.className = input.className;
        }
      } else {
        out.className = [];
      }

      start = input.start || input.date; // "date" is an alias for "start"
      end = input.end;

      // parse as a time (Duration) if applicable
      if (isTimeString(start)) {
        start = moment.duration(start);
      }
      if (isTimeString(end)) {
        end = moment.duration(end);
      }

      if (input.dow || moment.isDuration(start) || moment.isDuration(end)) {
        // the event is "abstract" (recurring) so don't calculate exact start/end dates just yet
        out.start = start ? moment.duration(start) : null; // will be a Duration or null
        out.end = end ? moment.duration(end) : null; // will be a Duration or null
        out._recurring = true; // our internal marker
      } else {
        if (start) {
          start = t.moment(start);
          if (!start.isValid()) {
            return false;
          }
        }

        if (end) {
          end = t.moment(end);
          if (!end.isValid()) {
            end = null; // let defaults take over
          }
        }

        allDay = input.allDay;
        if (allDay === undefined) {
          // still undefined? fallback to default
          allDay = firstDefined(
            source ? source.allDayDefault : undefined,
            t.options.allDayDefault
          );
          // still undefined? normalizeEventDates will calculate it
        }

        assignDatesToEvent(start, end, allDay, out);
      }

      t.normalizeEvent(out); // hook for external use. a prototype method

      return out;
    }
    t.buildEventFromInput = buildEventFromInput;

    // Normalizes and assigns the given dates to the given partially-formed event object.
    // NOTE: mutates the given start/end moments. does not make a copy.
    function assignDatesToEvent(start, end, allDay, event) {
      event.start = start;
      event.end = end;
      event.allDay = allDay;
      normalizeEventDates(event);
      backupEventDates(event);
    }

    // Ensures proper values for allDay/start/end. Accepts an Event object, or a plain object with event-ish properties.
    // NOTE: Will modify the given object.
    function normalizeEventDates(eventProps) {
      normalizeEventTimes(eventProps);

      if (eventProps.end && !eventProps.end.isAfter(eventProps.start)) {
        eventProps.end = null;
      }

      if (!eventProps.end) {
        if (t.options.forceEventDuration) {
          eventProps.end = t.getDefaultEventEnd(
            eventProps.allDay,
            eventProps.start
          );
        } else {
          eventProps.end = null;
        }
      }
    }

    // Ensures the allDay property exists and the timeliness of the start/end dates are consistent
    function normalizeEventTimes(eventProps) {
      if (eventProps.allDay == null) {
        eventProps.allDay = !(
          eventProps.start.hasTime() ||
          (eventProps.end && eventProps.end.hasTime())
        );
      }

      if (eventProps.allDay) {
        eventProps.start.stripTime();
        if (eventProps.end) {
          // TODO: consider nextDayThreshold here? If so, will require a lot of testing and adjustment
          eventProps.end.stripTime();
        }
      } else {
        if (!eventProps.start.hasTime()) {
          eventProps.start = t.applyTimezone(eventProps.start.time(0)); // will assign a 00:00 time
        }
        if (eventProps.end && !eventProps.end.hasTime()) {
          eventProps.end = t.applyTimezone(eventProps.end.time(0)); // will assign a 00:00 time
        }
      }
    }

    // If the given event is a recurring event, break it down into an array of individual instances.
    // If not a recurring event, return an array with the single original event.
    // If given a falsy input (probably because of a failed buildEventFromInput call), returns an empty array.
    // HACK: can override the recurring window by providing custom rangeStart/rangeEnd (for businessHours).
    function expandEvent(abstractEvent, _rangeStart, _rangeEnd) {
      var events = [];
      var dowHash;
      var dow;
      var i;
      var date;
      var startTime, endTime;
      var start, end;
      var event;

      _rangeStart = _rangeStart || rangeStart;
      _rangeEnd = _rangeEnd || rangeEnd;

      if (abstractEvent) {
        if (abstractEvent._recurring) {
          // make a boolean hash as to whether the event occurs on each day-of-week
          if ((dow = abstractEvent.dow)) {
            dowHash = {};
            for (i = 0; i < dow.length; i++) {
              dowHash[dow[i]] = true;
            }
          }

          // iterate through every day in the current range
          date = _rangeStart.clone().stripTime(); // holds the date of the current day
          while (date.isBefore(_rangeEnd)) {
            if (!dowHash || dowHash[date.day()]) {
              // if everyday, or this particular day-of-week

              startTime = abstractEvent.start; // the stored start and end properties are times (Durations)
              endTime = abstractEvent.end; // "
              start = date.clone();
              end = null;

              if (startTime) {
                start = start.time(startTime);
              }
              if (endTime) {
                end = date.clone().time(endTime);
              }

              event = $.extend({}, abstractEvent); // make a copy of the original
              assignDatesToEvent(
                start,
                end,
                !startTime && !endTime, // allDay?
                event
              );
              events.push(event);
            }

            date.add(1, 'days');
          }
        } else {
          events.push(abstractEvent); // return the original event. will be a one-item array
        }
      }

      return events;
    }
    t.expandEvent = expandEvent;

    /* Event Modification Math
	-----------------------------------------------------------------------------------------*/

    // Modifies an event and all related events by applying the given properties.
    // Special date-diffing logic is used for manipulation of dates.
    // If `props` does not contain start/end dates, the updated values are assumed to be the event's current start/end.
    // All date comparisons are done against the event's pristine _start and _end dates.
    // Returns an object with delta information and a function to undo all operations.
    // For making computations in a granularity greater than day/time, specify largeUnit.
    // NOTE: The given `newProps` might be mutated for normalization purposes.
    function mutateEvent(event, newProps, largeUnit) {
      var miscProps = {};
      var oldProps;
      var clearEnd;
      var startDelta;
      var endDelta;
      var durationDelta;
      var undoFunc;

      // diffs the dates in the appropriate way, returning a duration
      function diffDates(date1, date0) {
        // date1 - date0
        if (largeUnit) {
          return diffByUnit(date1, date0, largeUnit);
        } else if (newProps.allDay) {
          return diffDay(date1, date0);
        } else {
          return diffDayTime(date1, date0);
        }
      }

      newProps = newProps || {};

      // normalize new date-related properties
      if (!newProps.start) {
        newProps.start = event.start.clone();
      }
      if (newProps.end === undefined) {
        newProps.end = event.end ? event.end.clone() : null;
      }
      if (newProps.allDay == null) {
        // is null or undefined?
        newProps.allDay = event.allDay;
      }
      normalizeEventDates(newProps);

      // create normalized versions of the original props to compare against
      // need a real end value, for diffing
      oldProps = {
        start: event._start.clone(),
        end: event._end
          ? event._end.clone()
          : t.getDefaultEventEnd(event._allDay, event._start),
        allDay: newProps.allDay, // normalize the dates in the same regard as the new properties
      };
      normalizeEventDates(oldProps);

      // need to clear the end date if explicitly changed to null
      clearEnd = event._end !== null && newProps.end === null;

      // compute the delta for moving the start date
      startDelta = diffDates(newProps.start, oldProps.start);

      // compute the delta for moving the end date
      if (newProps.end) {
        endDelta = diffDates(newProps.end, oldProps.end);
        durationDelta = endDelta.subtract(startDelta);
      } else {
        durationDelta = null;
      }

      // gather all non-date-related properties
      $.each(newProps, function (name, val) {
        if (isMiscEventPropName(name)) {
          if (val !== undefined) {
            miscProps[name] = val;
          }
        }
      });

      // apply the operations to the event and all related events
      undoFunc = mutateEvents(
        clientEvents(event._id), // get events with this ID
        clearEnd,
        newProps.allDay,
        startDelta,
        durationDelta,
        miscProps
      );

      return {
        dateDelta: startDelta,
        durationDelta: durationDelta,
        undo: undoFunc,
      };
    }

    // Modifies an array of events in the following ways (operations are in order):
    // - clear the event's `end`
    // - convert the event to allDay
    // - add `dateDelta` to the start and end
    // - add `durationDelta` to the event's duration
    // - assign `miscProps` to the event
    //
    // Returns a function that can be called to undo all the operations.
    //
    // TODO: don't use so many closures. possible memory issues when lots of events with same ID.
    //
    function mutateEvents(
      events,
      clearEnd,
      allDay,
      dateDelta,
      durationDelta,
      miscProps
    ) {
      var isAmbigTimezone = t.getIsAmbigTimezone();
      var undoFunctions = [];

      // normalize zero-length deltas to be null
      if (dateDelta && !dateDelta.valueOf()) {
        dateDelta = null;
      }
      if (durationDelta && !durationDelta.valueOf()) {
        durationDelta = null;
      }

      $.each(events, function (i, event) {
        var oldProps;
        var newProps;

        // build an object holding all the old values, both date-related and misc.
        // for the undo function.
        oldProps = {
          start: event.start.clone(),
          end: event.end ? event.end.clone() : null,
          allDay: event.allDay,
        };
        $.each(miscProps, function (name) {
          oldProps[name] = event[name];
        });

        // new date-related properties. work off the original date snapshot.
        // ok to use references because they will be thrown away when backupEventDates is called.
        newProps = {
          start: event._start,
          end: event._end,
          allDay: allDay, // normalize the dates in the same regard as the new properties
        };
        normalizeEventDates(newProps); // massages start/end/allDay

        // strip or ensure the end date
        if (clearEnd) {
          newProps.end = null;
        } else if (durationDelta && !newProps.end) {
          // the duration translation requires an end date
          newProps.end = t.getDefaultEventEnd(newProps.allDay, newProps.start);
        }

        if (dateDelta) {
          newProps.start.add(dateDelta);
          if (newProps.end) {
            newProps.end.add(dateDelta);
          }
        }

        if (durationDelta) {
          newProps.end.add(durationDelta); // end already ensured above
        }

        // if the dates have changed, and we know it is impossible to recompute the
        // timezone offsets, strip the zone.
        if (
          isAmbigTimezone &&
          !newProps.allDay &&
          (dateDelta || durationDelta)
        ) {
          newProps.start.stripZone();
          if (newProps.end) {
            newProps.end.stripZone();
          }
        }

        $.extend(event, miscProps, newProps); // copy over misc props, then date-related props
        backupEventDates(event); // regenerate internal _start/_end/_allDay

        undoFunctions.push(function () {
          $.extend(event, oldProps);
          backupEventDates(event); // regenerate internal _start/_end/_allDay
        });
      });

      return function () {
        for (var i = 0; i < undoFunctions.length; i++) {
          undoFunctions[i]();
        }
      };
    }

    /* Overlapping / Constraining
	-----------------------------------------------------------------------------------------*/

    t.isEventSpanAllowed = isEventSpanAllowed;
    t.isExternalSpanAllowed = isExternalSpanAllowed;
    t.isSelectionSpanAllowed = isSelectionSpanAllowed;

    // Determines if the given event can be relocated to the given span (unzoned start/end with other misc data)
    function isEventSpanAllowed(span, event) {
      var source = event.source || {};
      var constraint = firstDefined(
        event.constraint,
        source.constraint,
        t.options.eventConstraint
      );
      var overlap = firstDefined(
        event.overlap,
        source.overlap,
        t.options.eventOverlap
      );
      return isSpanAllowed(span, constraint, overlap, event);
    }

    // Determines if an external event can be relocated to the given span (unzoned start/end with other misc data)
    function isExternalSpanAllowed(eventSpan, eventLocation, eventProps) {
      var eventInput;
      var event;

      // note: very similar logic is in View's reportExternalDrop
      if (eventProps) {
        eventInput = $.extend({}, eventProps, eventLocation);
        event = expandEvent(buildEventFromInput(eventInput))[0];
      }

      if (event) {
        return isEventSpanAllowed(eventSpan, event);
      } else {
        // treat it as a selection

        return isSelectionSpanAllowed(eventSpan);
      }
    }

    // Determines the given span (unzoned start/end with other misc data) can be selected.
    function isSelectionSpanAllowed(span) {
      return isSpanAllowed(
        span,
        t.options.selectConstraint,
        t.options.selectOverlap
      );
    }

    // Returns true if the given span (caused by an event drop/resize or a selection) is allowed to exist
    // according to the constraint/overlap settings.
    // `event` is not required if checking a selection.
    function isSpanAllowed(span, constraint, overlap, event) {
      var constraintEvents;
      var anyContainment;
      var peerEvents;
      var i, peerEvent;
      var peerOverlap;

      // the range must be fully contained by at least one of produced constraint events
      if (constraint != null) {
        // not treated as an event! intermediate data structure
        // TODO: use ranges in the future
        constraintEvents = constraintToEvents(constraint);

        anyContainment = false;
        for (i = 0; i < constraintEvents.length; i++) {
          if (t.spanContainsSpan(constraintEvents[i], span)) {
            anyContainment = true;
            break;
          }
        }

        if (!anyContainment) {
          return false;
        }
      }

      peerEvents = t.getPeerEvents(span, event);

      for (i = 0; i < peerEvents.length; i++) {
        peerEvent = peerEvents[i];

        // there needs to be an actual intersection before disallowing anything
        if (eventIntersectsRange(peerEvent, span)) {
          // evaluate overlap for the given range and short-circuit if necessary
          if (overlap === false) {
            return false;
          }
          // if the event's overlap is a test function, pass the peer event in question as the first param
          else if (
            typeof overlap === 'function' &&
            !overlap(peerEvent, event)
          ) {
            return false;
          }

          // if we are computing if the given range is allowable for an event, consider the other event's
          // EventObject-specific or Source-specific `overlap` property
          if (event) {
            peerOverlap = firstDefined(
              peerEvent.overlap,
              (peerEvent.source || {}).overlap
              // we already considered the global `eventOverlap`
            );
            if (peerOverlap === false) {
              return false;
            }
            // if the peer event's overlap is a test function, pass the subject event as the first param
            if (
              typeof peerOverlap === 'function' &&
              !peerOverlap(event, peerEvent)
            ) {
              return false;
            }
          }
        }
      }

      return true;
    }

    // Given an event input from the API, produces an array of event objects. Possible event inputs:
    // 'businessHours'
    // An event ID (number or string)
    // An object with specific start/end dates or a recurring event (like what businessHours accepts)
    function constraintToEvents(constraintInput) {
      if (constraintInput === 'businessHours') {
        return t.getCurrentBusinessHourEvents();
      }

      if (typeof constraintInput === 'object') {
        return expandEvent(buildEventFromInput(constraintInput));
      }

      return clientEvents(constraintInput); // probably an ID
    }

    // Does the event's date range intersect with the given range?
    // start/end already assumed to have stripped zones :(
    function eventIntersectsRange(event, range) {
      var eventStart = event.start.clone().stripZone();
      var eventEnd = t.getEventEnd(event).stripZone();

      return range.start < eventEnd && range.end > eventStart;
    }

    t.getEventCache = function () {
      return cache;
    };
  }

  // hook for external libs to manipulate event properties upon creation.
  // should manipulate the event in-place.
  Calendar.prototype.normalizeEvent = function (event) {};

  // Does the given span (start, end, and other location information)
  // fully contain the other?
  Calendar.prototype.spanContainsSpan = function (outerSpan, innerSpan) {
    var eventStart = outerSpan.start.clone().stripZone();
    var eventEnd = this.getEventEnd(outerSpan).stripZone();

    return innerSpan.start >= eventStart && innerSpan.end <= eventEnd;
  };

  // Returns a list of events that the given event should be compared against when being considered for a move to
  // the specified span. Attached to the Calendar's prototype because EventManager is a mixin for a Calendar.
  Calendar.prototype.getPeerEvents = function (span, event) {
    var cache = this.getEventCache();
    var peerEvents = [];
    var i, otherEvent;

    for (i = 0; i < cache.length; i++) {
      otherEvent = cache[i];
      if (
        !event ||
        event._id !== otherEvent._id // don't compare the event to itself or other related [repeating] events
      ) {
        peerEvents.push(otherEvent);
      }
    }

    return peerEvents;
  };

  // updates the "backup" properties, which are preserved in order to compute diffs later on.
  function backupEventDates(event) {
    event._allDay = event.allDay;
    event._start = event.start.clone();
    event._end = event.end ? event.end.clone() : null;
  }

  /* Business Hours
-----------------------------------------------------------------------------------------*/

  var BUSINESS_HOUR_EVENT_DEFAULTS = {
    id: '_fcBusinessHours', // will relate events from different calls to expandEvent
    start: '09:00',
    end: '17:00',
    dow: [1, 2, 3, 4, 5], // monday - friday
    rendering: 'inverse-background',
    // classNames are defined in businessHoursSegClasses
  };

  // Return events objects for business hours within the current view.
  // Abuse of our event system :(
  Calendar.prototype.getCurrentBusinessHourEvents = function (wholeDay) {
    return this.computeBusinessHourEvents(wholeDay, this.options.businessHours);
  };

  // Given a raw input value from options, return events objects for business hours within the current view.
  Calendar.prototype.computeBusinessHourEvents = function (wholeDay, input) {
    if (input === true) {
      return this.expandBusinessHourEvents(wholeDay, [{}]);
    } else if ($.isPlainObject(input)) {
      return this.expandBusinessHourEvents(wholeDay, [input]);
    } else if ($.isArray(input)) {
      return this.expandBusinessHourEvents(wholeDay, input, true);
    } else {
      return [];
    }
  };

  // inputs expected to be an array of objects.
  // if ignoreNoDow is true, will ignore entries that don't specify a day-of-week (dow) key.
  Calendar.prototype.expandBusinessHourEvents = function (
    wholeDay,
    inputs,
    ignoreNoDow
  ) {
    var view = this.getView();
    var events = [];
    var i, input;

    for (i = 0; i < inputs.length; i++) {
      input = inputs[i];

      if (ignoreNoDow && !input.dow) {
        continue;
      }

      // give defaults. will make a copy
      input = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, input);

      // if a whole-day series is requested, clear the start/end times
      if (wholeDay) {
        input.start = null;
        input.end = null;
      }

      events.push.apply(
        events, // append
        this.expandEvent(this.buildEventFromInput(input), view.start, view.end)
      );
    }

    return events;
  };

  /* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
  // It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
  // It is responsible for managing width/height.

  var BasicView = (FC.BasicView = View.extend({
    scroller: null,

    dayGridClass: DayGrid, // class the dayGrid will be instantiated from (overridable by subclasses)
    dayGrid: null, // the main subcomponent that does most of the heavy lifting

    dayNumbersVisible: false, // display day numbers on each day cell?
    weekNumbersVisible: false, // display week numbers along the side?

    weekNumberWidth: null, // width of all the week-number cells running down the side

    headContainerEl: null, // div that hold's the dayGrid's rendered date header
    headRowEl: null, // the fake row element of the day-of-week header

    initialize: function () {
      this.dayGrid = this.instantiateDayGrid();

      this.scroller = new Scroller({
        overflowX: 'hidden',
        overflowY: 'auto',
      });
    },

    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
    instantiateDayGrid: function () {
      // generate a subclass on the fly with BasicView-specific behavior
      // TODO: cache this subclass
      var subclass = this.dayGridClass.extend(basicDayGridMethods);

      return new subclass(this);
    },

    // Sets the display range and computes all necessary dates
    setRange: function (range) {
      View.prototype.setRange.call(this, range); // call the super-method

      this.dayGrid.breakOnWeeks = /year|month|week/.test(this.intervalUnit); // do before setRange
      this.dayGrid.setRange(range);
    },

    // Compute the value to feed into setRange. Overrides superclass.
    computeRange: function (date) {
      var range = View.prototype.computeRange.call(this, date); // get value from the super-method

      // year and month views should be aligned with weeks. this is already done for week
      if (/year|month/.test(range.intervalUnit)) {
        range.start.startOf('week');
        range.start = this.skipHiddenDays(range.start);

        // make end-of-week if not already
        if (range.end.weekday()) {
          range.end.add(1, 'week').startOf('week');
          range.end = this.skipHiddenDays(range.end, -1, true); // exclusively move backwards
        }
      }

      return range;
    },

    // Renders the view into `this.el`, which should already be assigned
    renderDates: function () {
      this.dayNumbersVisible = this.dayGrid.rowCnt > 1; // TODO: make grid responsible
      this.weekNumbersVisible = this.opt('weekNumbers');
      this.dayGrid.numbersVisible =
        this.dayNumbersVisible || this.weekNumbersVisible;

      this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
      this.renderHead();

      this.scroller.render();
      var dayGridContainerEl = this.scroller.el.addClass(
        'fc-day-grid-container'
      );
      var dayGridEl = $('<div class="fc-day-grid"></div>').appendTo(
        dayGridContainerEl
      );
      this.el.find('.fc-body > tr > td').append(dayGridContainerEl);

      this.dayGrid.setElement(dayGridEl);
      this.dayGrid.renderDates(this.hasRigidRows());
    },

    // render the day-of-week headers
    renderHead: function () {
      this.headContainerEl = this.el
        .find('.fc-head-container')
        .html(this.dayGrid.renderHeadHtml());
      this.headRowEl = this.headContainerEl.find('.fc-row');
    },

    // Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
    // always completely kill the dayGrid's rendering.
    unrenderDates: function () {
      this.dayGrid.unrenderDates();
      this.dayGrid.removeElement();
      this.scroller.destroy();
    },

    renderBusinessHours: function () {
      this.dayGrid.renderBusinessHours();
    },

    unrenderBusinessHours: function () {
      this.dayGrid.unrenderBusinessHours();
    },

    // Builds the HTML skeleton for the view.
    // The day-grid component will render inside of a container defined by this HTML.
    renderSkeletonHtml: function () {
      return (
        '' +
        '<table>' +
        '<thead class="fc-head">' +
        '<tr>' +
        '<td class="fc-head-container ' +
        this.widgetHeaderClass +
        '"></td>' +
        '</tr>' +
        '</thead>' +
        '<tbody class="fc-body">' +
        '<tr>' +
        '<td class="' +
        this.widgetContentClass +
        '"></td>' +
        '</tr>' +
        '</tbody>' +
        '</table>'
      );
    },

    // Generates an HTML attribute string for setting the width of the week number column, if it is known
    weekNumberStyleAttr: function () {
      if (this.weekNumberWidth !== null) {
        return 'style="width:' + this.weekNumberWidth + 'px"';
      }
      return '';
    },

    // Determines whether each row should have a constant height
    hasRigidRows: function () {
      var eventLimit = this.opt('eventLimit');
      return eventLimit && typeof eventLimit !== 'number';
    },

    /* Dimensions
	------------------------------------------------------------------------------------------------------------------*/

    // Refreshes the horizontal dimensions of the view
    updateWidth: function () {
      if (this.weekNumbersVisible) {
        // Make sure all week number cells running down the side have the same width.
        // Record the width for cells created later.
        this.weekNumberWidth = matchCellWidths(this.el.find('.fc-week-number'));
      }
    },

    // Adjusts the vertical dimensions of the view to the specified values
    setHeight: function (totalHeight, isAuto) {
      var eventLimit = this.opt('eventLimit');
      var scrollerHeight;
      var scrollbarWidths;

      // reset all heights to be natural
      this.scroller.clear();
      uncompensateScroll(this.headRowEl);

      this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed

      // is the event limit a constant level number?
      if (eventLimit && typeof eventLimit === 'number') {
        this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
      }

      // distribute the height to the rows
      // (totalHeight is a "recommended" value if isAuto)
      scrollerHeight = this.computeScrollerHeight(totalHeight);
      this.setGridHeight(scrollerHeight, isAuto);

      // is the event limit dynamically calculated?
      if (eventLimit && typeof eventLimit !== 'number') {
        this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
      }

      if (!isAuto) {
        // should we force dimensions of the scroll container?

        this.scroller.setHeight(scrollerHeight);
        scrollbarWidths = this.scroller.getScrollbarWidths();

        if (scrollbarWidths.left || scrollbarWidths.right) {
          // using scrollbars?

          compensateScroll(this.headRowEl, scrollbarWidths);

          // doing the scrollbar compensation might have created text overflow which created more height. redo
          scrollerHeight = this.computeScrollerHeight(totalHeight);
          this.scroller.setHeight(scrollerHeight);
        }

        // guarantees the same scrollbar widths
        this.scroller.lockOverflow(scrollbarWidths);
      }
    },

    // given a desired total height of the view, returns what the height of the scroller should be
    computeScrollerHeight: function (totalHeight) {
      return totalHeight - subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    },

    // Sets the height of just the DayGrid component in this view
    setGridHeight: function (height, isAuto) {
      if (isAuto) {
        undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
      } else {
        distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
      }
    },

    /* Scroll
	------------------------------------------------------------------------------------------------------------------*/

    queryScroll: function () {
      return this.scroller.getScrollTop();
    },

    setScroll: function (top) {
      this.scroller.setScrollTop(top);
    },

    /* Hit Areas
	------------------------------------------------------------------------------------------------------------------*/
    // forward all hit-related method calls to dayGrid

    prepareHits: function () {
      this.dayGrid.prepareHits();
    },

    releaseHits: function () {
      this.dayGrid.releaseHits();
    },

    queryHit: function (left, top) {
      return this.dayGrid.queryHit(left, top);
    },

    getHitSpan: function (hit) {
      return this.dayGrid.getHitSpan(hit);
    },

    getHitEl: function (hit) {
      return this.dayGrid.getHitEl(hit);
    },

    /* Events
	------------------------------------------------------------------------------------------------------------------*/

    // Renders the given events onto the view and populates the segments array
    renderEvents: function (events) {
      this.dayGrid.renderEvents(events);

      this.updateHeight(); // must compensate for events that overflow the row
    },

    // Retrieves all segment objects that are rendered in the view
    getEventSegs: function () {
      return this.dayGrid.getEventSegs();
    },

    // Unrenders all event elements and clears internal segment data
    unrenderEvents: function () {
      this.dayGrid.unrenderEvents();

      // we DON'T need to call updateHeight() because:
      // A) a renderEvents() call always happens after this, which will eventually call updateHeight()
      // B) in IE8, this causes a flash whenever events are rerendered
    },

    /* Dragging (for both events and external elements)
	------------------------------------------------------------------------------------------------------------------*/

    // A returned value of `true` signals that a mock "helper" event has been rendered.
    renderDrag: function (dropLocation, seg) {
      return this.dayGrid.renderDrag(dropLocation, seg);
    },

    unrenderDrag: function () {
      this.dayGrid.unrenderDrag();
    },

    /* Selection
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of a selection
    renderSelection: function (span) {
      this.dayGrid.renderSelection(span);
    },

    // Unrenders a visual indications of a selection
    unrenderSelection: function () {
      this.dayGrid.unrenderSelection();
    },
  }));

  // Methods that will customize the rendering behavior of the BasicView's dayGrid
  var basicDayGridMethods = {
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function () {
      var view = this.view;

      if (view.weekNumbersVisible) {
        return (
          '' +
          '<th class="fc-week-number ' +
          view.widgetHeaderClass +
          '" ' +
          view.weekNumberStyleAttr() +
          '>' +
          '<span>' + // needed for matchCellWidths
          htmlEscape(view.opt('weekNumberTitle')) +
          '</span>' +
          '</th>'
        );
      }

      return '';
    },

    // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
    renderNumberIntroHtml: function (row) {
      var view = this.view;

      if (view.weekNumbersVisible) {
        return (
          '' +
          '<td class="fc-week-number" ' +
          view.weekNumberStyleAttr() +
          '>' +
          '<span>' + // needed for matchCellWidths
          this.getCellDate(row, 0).format('w') +
          '</span>' +
          '</td>'
        );
      }

      return '';
    },

    // Generates the HTML that goes before the day bg cells for each day-row
    renderBgIntroHtml: function () {
      var view = this.view;

      if (view.weekNumbersVisible) {
        return (
          '<td class="fc-week-number ' +
          view.widgetContentClass +
          '" ' +
          view.weekNumberStyleAttr() +
          '></td>'
        );
      }

      return '';
    },

    // Generates the HTML that goes before every other type of row generated by DayGrid.
    // Affects helper-skeleton and highlight-skeleton rows.
    renderIntroHtml: function () {
      var view = this.view;

      if (view.weekNumbersVisible) {
        return (
          '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>'
        );
      }

      return '';
    },
  };

  /* A month view with day cells running in rows (one-per-week) and columns
----------------------------------------------------------------------------------------------------------------------*/

  var MonthView = (FC.MonthView = BasicView.extend({
    // Produces information about what range to display
    computeRange: function (date) {
      var range = BasicView.prototype.computeRange.call(this, date); // get value from super-method
      var rowCnt;

      // ensure 6 weeks
      if (this.isFixedWeeks()) {
        rowCnt = Math.ceil(range.end.diff(range.start, 'weeks', true)); // could be partial weeks due to hiddenDays
        range.end.add(6 - rowCnt, 'weeks');
      }

      return range;
    },

    // Overrides the default BasicView behavior to have special multi-week auto-height logic
    setGridHeight: function (height, isAuto) {
      isAuto = isAuto || this.opt('weekMode') === 'variable'; // LEGACY: weekMode is deprecated

      // if auto, make the height of each row the height that it would be if there were 6 weeks
      if (isAuto) {
        height *= this.rowCnt / 6;
      }

      distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
    },

    isFixedWeeks: function () {
      var weekMode = this.opt('weekMode'); // LEGACY: weekMode is deprecated
      if (weekMode) {
        return weekMode === 'fixed'; // if any other type of weekMode, assume NOT fixed
      }

      return this.opt('fixedWeekCount');
    },
  }));

  fcViews.basic = {
    class: BasicView,
  };

  fcViews.basicDay = {
    type: 'basic',
    duration: { days: 1 },
  };

  fcViews.basicWeek = {
    type: 'basic',
    duration: { weeks: 1 },
  };

  fcViews.month = {
    class: MonthView,
    duration: { months: 1 }, // important for prev/next
    defaults: {
      fixedWeekCount: true,
    },
  };
  /* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
----------------------------------------------------------------------------------------------------------------------*/
  // Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
  // Responsible for managing width/height.

  var AgendaView = (FC.AgendaView = View.extend({
    scroller: null,

    timeGridClass: TimeGrid, // class used to instantiate the timeGrid. subclasses can override
    timeGrid: null, // the main time-grid subcomponent of this view

    dayGridClass: DayGrid, // class used to instantiate the dayGrid. subclasses can override
    dayGrid: null, // the "all-day" subcomponent. if all-day is turned off, this will be null

    axisWidth: null, // the width of the time axis running down the side

    headContainerEl: null, // div that hold's the timeGrid's rendered date header
    noScrollRowEls: null, // set of fake row elements that must compensate when scroller has scrollbars

    // when the time-grid isn't tall enough to occupy the given height, we render an <hr> underneath
    bottomRuleEl: null,

    initialize: function () {
      this.timeGrid = this.instantiateTimeGrid();

      if (this.opt('allDaySlot')) {
        // should we display the "all-day" area?
        this.dayGrid = this.instantiateDayGrid(); // the all-day subcomponent of this view
      }

      this.scroller = new Scroller({
        overflowX: 'hidden',
        overflowY: 'auto',
      });
    },

    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
    instantiateTimeGrid: function () {
      var subclass = this.timeGridClass.extend(agendaTimeGridMethods);

      return new subclass(this);
    },

    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
    instantiateDayGrid: function () {
      var subclass = this.dayGridClass.extend(agendaDayGridMethods);

      return new subclass(this);
    },

    /* Rendering
	------------------------------------------------------------------------------------------------------------------*/

    // Sets the display range and computes all necessary dates
    setRange: function (range) {
      View.prototype.setRange.call(this, range); // call the super-method

      this.timeGrid.setRange(range);
      if (this.dayGrid) {
        this.dayGrid.setRange(range);
      }
    },

    // Renders the view into `this.el`, which has already been assigned
    renderDates: function () {
      this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
      this.renderHead();

      this.scroller.render();
      var timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
      var timeGridEl = $('<div class="fc-time-grid"></div>').appendTo(
        timeGridWrapEl
      );
      this.el.find('.fc-body > tr > td').append(timeGridWrapEl);

      this.timeGrid.setElement(timeGridEl);
      this.timeGrid.renderDates();

      // the <hr> that sometimes displays under the time-grid
      this.bottomRuleEl = $(
        '<hr class="fc-divider ' + this.widgetHeaderClass + '"/>'
      ).appendTo(this.timeGrid.el); // inject it into the time-grid

      if (this.dayGrid) {
        this.dayGrid.setElement(this.el.find('.fc-day-grid'));
        this.dayGrid.renderDates();

        // have the day-grid extend it's coordinate area over the <hr> dividing the two grids
        this.dayGrid.bottomCoordPadding = this.dayGrid.el
          .next('hr')
          .outerHeight();
      }

      this.noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)'); // fake rows not within the scroller
    },

    // render the day-of-week headers
    renderHead: function () {
      this.headContainerEl = this.el
        .find('.fc-head-container')
        .html(this.timeGrid.renderHeadHtml());
    },

    // Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
    // always completely kill each grid's rendering.
    unrenderDates: function () {
      this.timeGrid.unrenderDates();
      this.timeGrid.removeElement();

      if (this.dayGrid) {
        this.dayGrid.unrenderDates();
        this.dayGrid.removeElement();
      }

      this.scroller.destroy();
    },

    // Builds the HTML skeleton for the view.
    // The day-grid and time-grid components will render inside containers defined by this HTML.
    renderSkeletonHtml: function () {
      return (
        '' +
        '<table>' +
        '<thead class="fc-head">' +
        '<tr>' +
        '<td class="fc-head-container ' +
        this.widgetHeaderClass +
        '"></td>' +
        '</tr>' +
        '</thead>' +
        '<tbody class="fc-body">' +
        '<tr>' +
        '<td class="' +
        this.widgetContentClass +
        '">' +
        (this.dayGrid
          ? '<div class="fc-day-grid"></div>' +
            '<hr class="fc-divider ' +
            this.widgetHeaderClass +
            '"/>'
          : '') +
        '</td>' +
        '</tr>' +
        '</tbody>' +
        '</table>'
      );
    },

    // Generates an HTML attribute string for setting the width of the axis, if it is known
    axisStyleAttr: function () {
      if (this.axisWidth !== null) {
        return 'style="width:' + this.axisWidth + 'px"';
      }
      return '';
    },

    /* Business Hours
	------------------------------------------------------------------------------------------------------------------*/

    renderBusinessHours: function () {
      this.timeGrid.renderBusinessHours();

      if (this.dayGrid) {
        this.dayGrid.renderBusinessHours();
      }
    },

    unrenderBusinessHours: function () {
      this.timeGrid.unrenderBusinessHours();

      if (this.dayGrid) {
        this.dayGrid.unrenderBusinessHours();
      }
    },

    /* Now Indicator
	------------------------------------------------------------------------------------------------------------------*/

    getNowIndicatorUnit: function () {
      return this.timeGrid.getNowIndicatorUnit();
    },

    renderNowIndicator: function (date) {
      this.timeGrid.renderNowIndicator(date);
    },

    unrenderNowIndicator: function () {
      this.timeGrid.unrenderNowIndicator();
    },

    /* Dimensions
	------------------------------------------------------------------------------------------------------------------*/

    updateSize: function (isResize) {
      this.timeGrid.updateSize(isResize);

      View.prototype.updateSize.call(this, isResize); // call the super-method
    },

    // Refreshes the horizontal dimensions of the view
    updateWidth: function () {
      // make all axis cells line up, and record the width so newly created axis cells will have it
      this.axisWidth = matchCellWidths(this.el.find('.fc-axis'));
    },

    // Adjusts the vertical dimensions of the view to the specified values
    setHeight: function (totalHeight, isAuto) {
      var eventLimit;
      var scrollerHeight;
      var scrollbarWidths;

      // reset all dimensions back to the original state
      this.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
      this.scroller.clear(); // sets height to 'auto' and clears overflow
      uncompensateScroll(this.noScrollRowEls);

      // limit number of events in the all-day area
      if (this.dayGrid) {
        this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed

        eventLimit = this.opt('eventLimit');
        if (eventLimit && typeof eventLimit !== 'number') {
          eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
        }
        if (eventLimit) {
          this.dayGrid.limitRows(eventLimit);
        }
      }

      if (!isAuto) {
        // should we force dimensions of the scroll container?

        scrollerHeight = this.computeScrollerHeight(totalHeight);
        this.scroller.setHeight(scrollerHeight);
        scrollbarWidths = this.scroller.getScrollbarWidths();

        if (scrollbarWidths.left || scrollbarWidths.right) {
          // using scrollbars?

          // make the all-day and header rows lines up
          compensateScroll(this.noScrollRowEls, scrollbarWidths);

          // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
          // and reapply the desired height to the scroller.
          scrollerHeight = this.computeScrollerHeight(totalHeight);
          this.scroller.setHeight(scrollerHeight);
        }

        // guarantees the same scrollbar widths
        this.scroller.lockOverflow(scrollbarWidths);

        // if there's any space below the slats, show the horizontal rule.
        // this won't cause any new overflow, because lockOverflow already called.
        if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
          this.bottomRuleEl.show();
        }
      }
    },

    // given a desired total height of the view, returns what the height of the scroller should be
    computeScrollerHeight: function (totalHeight) {
      return totalHeight - subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    },

    /* Scroll
	------------------------------------------------------------------------------------------------------------------*/

    // Computes the initial pre-configured scroll state prior to allowing the user to change it
    computeInitialScroll: function () {
      var scrollTime = moment.duration(this.opt('scrollTime'));
      var top = this.timeGrid.computeTimeTop(scrollTime);

      // zoom can give weird floating-point values. rather scroll a little bit further
      top = Math.ceil(top);

      if (top) {
        top++; // to overcome top border that slots beyond the first have. looks better
      }

      return top;
    },

    queryScroll: function () {
      return this.scroller.getScrollTop();
    },

    setScroll: function (top) {
      this.scroller.setScrollTop(top);
    },

    /* Hit Areas
	------------------------------------------------------------------------------------------------------------------*/
    // forward all hit-related method calls to the grids (dayGrid might not be defined)

    prepareHits: function () {
      this.timeGrid.prepareHits();
      if (this.dayGrid) {
        this.dayGrid.prepareHits();
      }
    },

    releaseHits: function () {
      this.timeGrid.releaseHits();
      if (this.dayGrid) {
        this.dayGrid.releaseHits();
      }
    },

    queryHit: function (left, top) {
      var hit = this.timeGrid.queryHit(left, top);

      if (!hit && this.dayGrid) {
        hit = this.dayGrid.queryHit(left, top);
      }

      return hit;
    },

    getHitSpan: function (hit) {
      // TODO: hit.component is set as a hack to identify where the hit came from
      return hit.component.getHitSpan(hit);
    },

    getHitEl: function (hit) {
      // TODO: hit.component is set as a hack to identify where the hit came from
      return hit.component.getHitEl(hit);
    },

    /* Events
	------------------------------------------------------------------------------------------------------------------*/

    // Renders events onto the view and populates the View's segment array
    renderEvents: function (events) {
      var dayEvents = [];
      var timedEvents = [];
      var daySegs = [];
      var timedSegs;
      var i;

      // separate the events into all-day and timed
      for (i = 0; i < events.length; i++) {
        if (events[i].allDay) {
          dayEvents.push(events[i]);
        } else {
          timedEvents.push(events[i]);
        }
      }

      // render the events in the subcomponents
      timedSegs = this.timeGrid.renderEvents(timedEvents);
      if (this.dayGrid) {
        daySegs = this.dayGrid.renderEvents(dayEvents);
      }

      // the all-day area is flexible and might have a lot of events, so shift the height
      this.updateHeight();
    },

    // Retrieves all segment objects that are rendered in the view
    getEventSegs: function () {
      return this.timeGrid
        .getEventSegs()
        .concat(this.dayGrid ? this.dayGrid.getEventSegs() : []);
    },

    // Unrenders all event elements and clears internal segment data
    unrenderEvents: function () {
      // unrender the events in the subcomponents
      this.timeGrid.unrenderEvents();
      if (this.dayGrid) {
        this.dayGrid.unrenderEvents();
      }

      // we DON'T need to call updateHeight() because:
      // A) a renderEvents() call always happens after this, which will eventually call updateHeight()
      // B) in IE8, this causes a flash whenever events are rerendered
    },

    /* Dragging (for events and external elements)
	------------------------------------------------------------------------------------------------------------------*/

    // A returned value of `true` signals that a mock "helper" event has been rendered.
    renderDrag: function (dropLocation, seg) {
      if (dropLocation.start.hasTime()) {
        return this.timeGrid.renderDrag(dropLocation, seg);
      } else if (this.dayGrid) {
        return this.dayGrid.renderDrag(dropLocation, seg);
      }
    },

    unrenderDrag: function () {
      this.timeGrid.unrenderDrag();
      if (this.dayGrid) {
        this.dayGrid.unrenderDrag();
      }
    },

    /* Selection
	------------------------------------------------------------------------------------------------------------------*/

    // Renders a visual indication of a selection
    renderSelection: function (span) {
      if (span.start.hasTime() || span.end.hasTime()) {
        this.timeGrid.renderSelection(span);
      } else if (this.dayGrid) {
        this.dayGrid.renderSelection(span);
      }
    },

    // Unrenders a visual indications of a selection
    unrenderSelection: function () {
      this.timeGrid.unrenderSelection();
      if (this.dayGrid) {
        this.dayGrid.unrenderSelection();
      }
    },
  }));

  // Methods that will customize the rendering behavior of the AgendaView's timeGrid
  // TODO: move into TimeGrid
  var agendaTimeGridMethods = {
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function () {
      var view = this.view;
      var weekText;

      if (view.opt('weekNumbers')) {
        weekText = this.start.format(view.opt('smallWeekFormat'));

        return (
          '' +
          '<th class="fc-axis fc-week-number ' +
          view.widgetHeaderClass +
          '" ' +
          view.axisStyleAttr() +
          '>' +
          '<span>' + // needed for matchCellWidths
          htmlEscape(weekText) +
          '</span>' +
          '</th>'
        );
      } else {
        return (
          '<th class="fc-axis ' +
          view.widgetHeaderClass +
          '" ' +
          view.axisStyleAttr() +
          '></th>'
        );
      }
    },

    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
    renderBgIntroHtml: function () {
      var view = this.view;

      return (
        '<td class="fc-axis ' +
        view.widgetContentClass +
        '" ' +
        view.axisStyleAttr() +
        '></td>'
      );
    },

    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
      var view = this.view;

      return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    },
  };

  // Methods that will customize the rendering behavior of the AgendaView's dayGrid
  var agendaDayGridMethods = {
    // Generates the HTML that goes before the all-day cells
    renderBgIntroHtml: function () {
      var view = this.view;

      return (
        '' +
        '<td class="fc-axis ' +
        view.widgetContentClass +
        '" ' +
        view.axisStyleAttr() +
        '>' +
        '<span>' + // needed for matchCellWidths
        (view.opt('allDayHtml') || htmlEscape(view.opt('allDayText'))) +
        '</span>' +
        '</td>'
      );
    },

    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
      var view = this.view;

      return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    },
  };

  var AGENDA_ALL_DAY_EVENT_LIMIT = 5;

  // potential nice values for the slot-duration and interval-duration
  // from largest to smallest
  var AGENDA_STOCK_SUB_DURATIONS = [
    { hours: 1 },
    { minutes: 30 },
    { minutes: 15 },
    { seconds: 30 },
    { seconds: 15 },
  ];

  fcViews.agenda = {
    class: AgendaView,
    defaults: {
      allDaySlot: true,
      allDayText: 'all-day',
      slotDuration: '00:30:00',
      minTime: '00:00:00',
      maxTime: '24:00:00',
      slotEventOverlap: true, // a bad name. confused with overlap/constraint system
    },
  };

  fcViews.agendaDay = {
    type: 'agenda',
    duration: { days: 1 },
  };

  fcViews.agendaWeek = {
    type: 'agenda',
    duration: { weeks: 1 },
  };
  return FC; // export for Node/CommonJS
});



(function (window) {
  window.FullCalendar = {};

  FullCalendar.eventToInputs = function (event, namePrefix) {
    return _.map(['start', 'end'], function (key) {
      return $('<input/>', {
        type: 'hidden',
        name: namePrefix + '[][' + key + ']',
        value: event[key].format(),
      });
    });
  };

  FullCalendar.eventsToInputs = function (events, namePrefix) {
    return _.chain(events)
      .map(_.partial(window.FullCalendar.eventToInputs, _, namePrefix))
      .flatten()
      .value();
  };

  FullCalendar.addRemoveButton = function (event, eventElement, onClick) {
    var container = $('<div></div>')
      .css('position', 'absolute')
      .css('top', '0px')
      .css('right', '2px')
      .css('z-index', 10);

    var button = $('<span>X</span>').on('click', function () {
      onClick(event);
    });

    container.prepend(button);
    $(eventElement).find('.fc-content').prepend(container);
  };
})(window);
/**
 * Options:
 *   beforeOpen - single function or array of functions that are ran BEFORE the modal is opened
 *   afterOpen  - single function or array of functions that are ran AFTER the modal is opened
 */
var Modal = (function () {
  function Modal(selector, options) {
    this.selector = selector;
    this.modal = $(selector);
    this.options = options || {};
    this.openWithContext = null;

    // wrap 'beforeOpen' and 'afterOpen' in an array, if it isn't already
    if (this.options.beforeOpen && !$.isArray(this.options.beforeOpen)) {
      this.options.beforeOpen = [this.options.beforeOpen];
    }

    if (this.options.afterOpen && !$.isArray(this.options.afterOpen)) {
      this.options.afterOpen = [this.options.afterOpen];
    }

    this.registerEvents();
  }

  Modal.prototype.container = function () {
    return this.modal;
  };

  Modal.prototype.registerEvents = function () {
    var that = this;

    this.modal.on('greenhouse.heightChanged', function () {
      that.adjustHeight();
    });

    this.modal.on(
      'keydown',
      function (e) {
        if (this.options.closeOnEscape && e.keyCode === $.ui.keyCode.ESCAPE) {
          this.close();
          e.stopPropagation();
        }
      }.bind(this)
    );

    // Register jquery ui titlebar event
    this.modal
      .siblings('.ui-dialog-titlebar')
      .find('.x')
      .unbind('click')
      .click($.proxy(this.close, this));
    this.modal
      .find('.x, .cancel')
      .unbind('click')
      .click($.proxy(this.close, this))
      .on('click', contentSecurityPolicy.hrefPreventDefault);
    this.modal.find('.chzn-select').chosen(Config.Chosen.Default);

    this.registerOpen();

    if (
      typeof this.options.validateWith === 'function' &&
      typeof this.options.onSubmit === 'function'
    ) {
      this.modal
        .find('form')
        .validateOn(
          'submit',
          this.options.validateWith,
          this.options.onSubmit,
          { scroll: false }
        );
    } else if (typeof this.options.onSubmit === 'function') {
      this.modal.find('form').on('submit', this.options.onSubmit);
    } else if (
      this.options.confirmWith &&
      typeof this.options.onConfirm === 'function'
    ) {
      $(this.options.confirmWith).on('click', this.options.onConfirm);
    }
  };

  Modal.prototype.registerOpen = function () {
    var modal = this,
      $openWith = $(this.options.openWith),
      $openWithFilter = $(this.options.openWithFilter),
      openWithEvent = this.options.openWithEvent;

    if ($openWith.length > 0) {
      // use a namespaced event to prevent unbinding click events from other controls
      var event = 'click.' + this.selector;

      $openWith
        .unbind(event)
        .on(event, this.options.openWithFilter, function (e) {
          modal.openWithContext = this;

          if (
            modal.options.openIfTrue === undefined ||
            modal.options.openIfTrue(this)
          ) {
            openHandler.call(this);
          }

          e.stopPropagation();
        });

      if ($openWithFilter.attr('href') === '#') {
        $openWithFilter.on('click', contentSecurityPolicy.hrefPreventDefault);
      } else if ($openWith.attr('href') === '#') {
        $openWith.on('click', contentSecurityPolicy.hrefPreventDefault);
      }

      // Open modal without a selector
      if (openWithEvent) {
        $(window.document)
          .unbind(openWithEvent)
          .on(openWithEvent, function () {
            openHandler.call(this);
          });
      }
    }

    function openHandler() {
      var runCallbacks = function (callbackArray) {
        if (callbackArray) {
          for (var i = 0; i < callbackArray.length; i++) {
            var callback = callbackArray[i];
            if (typeof callback === 'function') {
              callback.call(this, modal);
            }
          }
        }
      }.bind(this);

      runCallbacks(modal.options.beforeOpen);
      modal.open();
      runCallbacks(modal.options.afterOpen);

      modal.adjustHeight();
    }
  };

  Modal.prototype.open = function () {
    this.modal.dialog(Config.Modal.custom(this.options.config));
    this.header = this.modal.siblings('.ui-dialog-titlebar');
    this.title = this.title || this.modal.data('modal-title');
    this.setTitle(this.title);

    if (!this.options.preventCloseOnOutsideClick) {
      $('.ui-widget-overlay').on('click', this.close.bind(this));
    }

    // After widget is initialized, replace jquery ui button and register event
    $('.ui-dialog-titlebar-close').addClass('x').attr('href', '#');
    this.modal
      .siblings('.ui-dialog-titlebar')
      .find('.x')
      .unbind('click')
      .click($.proxy(this.close, this))
      .on('click', contentSecurityPolicy.hrefPreventDefault);
    this.modal.find('.x').blur();
    this.modal.find('.autofocus').focus();
    this.modal.find('.autoselect').select();

    this.adjustHeight();
  };

  Modal.prototype.close = function () {
    if (typeof this.options.beforeClose === 'function') {
      if (this.options.beforeClose.call(this) === false) {
        return false;
      }
    }

    if (this.modal.hasClass('ui-dialog-content')) {
      this.modal.dialog('close');
    }
  };

  Modal.prototype.destroy = function () {
    if (this.modal.dialog('instance')) {
      this.modal.dialog('destroy').remove();
    }
  };

  Modal.prototype.clearForm = function () {
    this.modal.find('form')[0].reset();
    this.modal.find('.chzn-select').trigger('liszt:updated');
    Validate.clearError(this.modal.find('input, select, textarea'));
  };

  Modal.prototype.setTitle = function (title) {
    this.title = title;
    if (this.header) {
      this.header.find('.ui-dialog-title').text(title);
    }
  };

  Modal.prototype.getTitle = function () {
    return this.title;
  };

  Modal.prototype.center = function () {
    if (this.modal.hasClass('ui-dialog-content')) {
      this.modal.dialog('option', 'position', {
        my: 'center',
        at: 'center',
        of: window,
      });
    }
  };

  Modal.prototype.top = function () {
    if (this.modal.hasClass('ui-dialog-content')) {
      this.modal.dialog('option', 'position', {
        my: 'top',
        at: 'top',
        of: window,
      });
    }
  };

  Modal.prototype.setWidth = function (width) {
    this.modal.dialog('option', 'width', width);
  };

  /**
   * Adjusts the modal's height based on the window height if there is an element
   * with class "scrollable" in the modal body.
   */
  Modal.prototype.adjustHeight = function () {
    if (this.options.config && this.options.config.doNotAdjustHeight) {
      return;
    }

    var scrollableContent = this.modal.find('.scrollable:visible');

    if (scrollableContent.length === 1) {
      this.modal.css('maxHeight', 'none');
      scrollableContent.css('height', 'auto');

      var height = this.modal.height(),
        maxHeight = $(window).height() - 200;

      if (height > maxHeight) {
        this.modal.css('maxHeight', maxHeight);

        scrollableContent.css({
          height: maxHeight - (height - scrollableContent.height()),
          overflow: 'auto',
        });
      }
    }

    this.center();
  };

  Modal.clearForm = function (modal) {
    modal.clearForm();
  };

  return Modal;
})();

var SelectionModal = (function () {
  function SelectionModal(id, options) {
    Modal.call(this, id, options);

    if (typeof this.singleSelect !== 'boolean') {
      this.options.singleSelect = true;
    }
    this.list = this.modal.find('.modal-selection-list');
    this.registerListEvents();
  }

  SelectionModal.prototype = Object.create(Modal.prototype);

  SelectionModal.prototype.registerListEvents = function () {
    if (this.options.singleSelect) {
      this.list.find('li').unbind('click').click(updateSingleSelection);
    } else {
      this.list.find('li').unbind('click').click(updateMultiSelection);
    }

    if (
      this.options.completeButton &&
      typeof this.options.onComplete === 'function'
    ) {
      $(this.options.completeButton).unbind('click').click(onComplete);
    }

    var that = this;

    function updateSingleSelection() {
      $(this).siblings('li').removeClass('selected');
      updateMultiSelection.call(this);
    }

    function updateMultiSelection() {
      $(this).toggleClass('selected');

      if (that.options.requireSelection && that.options.completeButton) {
        if ($(this).hasClass('selected')) {
          ButtonUtil.enable(that.options.completeButton);
        } else {
          ButtonUtil.disable(that.options.completeButton);
        }
      }
    }

    function onComplete() {
      if (
        that.options.completeButton &&
        ButtonUtil.isDisabled(that.options.completeButton)
      ) {
        return false;
      }

      var selections = $.map(that.list.find('li.selected'), function (li) {
        return $(li).attr('data-id');
      });

      if (selections.length > 0 || !that.options.requireSelection) {
        if (that.options.singleSelect) {
          that.options.onComplete(selections.length > 0 ? selections[0] : null);
        } else {
          that.options.onComplete(selections);
        }
      }

      return false;
    }
  };

  SelectionModal.prototype.open = function () {
    this.reset();
    Modal.prototype.open.call(this);
  };

  SelectionModal.prototype.reset = function () {
    this.list.find('li').removeClass('selected');
    this.list[0].scrollTop = 0;

    if (this.options.requireSelection && this.options.completeButton) {
      ButtonUtil.disable(this.options.completeButton);
    }
  };

  return SelectionModal;
})();
/**
 * Dropdown control for loading office/departments through ajax and displaying it with tiering
 *
 * =====================
 * Basic Usage
 * =====================
 *
 * 1. Use the greenhouse helper tag to create the dropdown. It will be an input field that takes in the id,
 *    type (:office/:department), starting selected model, and the configurations (more info below)
 *
 *    <%= organizational_structure_select_tag :office_id, :office, selected_office, configurations %>
 *
 * 2. On document ready, initialize the dropdown:
 *
 *    var control = OrganizationalStructureControl.register('#office_id', { width: '300px', allowClear: false });
 *
 *    The control has the following API:
 *
 *    control.selectedText(); // Returns the text of the selected option
 *
 *    var control = OrganizationalStructureControl.find('#office_id'); // Returns the control of an already registered id
 *
 * =====================
 * Configuration
 * =====================
 *
 * The following configurations are set as data attributes on the organizational_structure_select_tag:
 *
 *      disable_ids: []
 *        Disable (gray out) all options with these ids. Useful for not allowing selecting nodes
 *        in the same branch.
 *
 *      display_only_ids_with_parents: []
 *        Hide all options that do not have these ids, but show parents who may not
 *        be in the array of IDs. Useful for permissions.
 *
 *      display_only_ids_without_parents: []
 *        Hide all options that do not have these IDs. This is stricter than display_only_ids_without_parents,
 *        so parents that don't have the IDs will not be shown, e.g. for restricting offices/depts for job creation
 *
 *      include_unattached_prospect_option: false
 *        Useful with the displayHiringPlans option. This will decide whether to display the
 *        'Prospects on no job' option
 *
 *      json: []
 *        An array of the organizational structure. If you pass this in, it will not do the ajax call and use this
 *
 *
 * The following configurations are set as attributes on the organizational_structure_select_tag:
 *
 *      value: Integer/String
 *        The id of the starting selected office/department
 *
 *      value_text: String
 *        Starting name of the starting selected office/department
 *
 *
 * =====================
 * Options
 * =====================
 *
 * The following options are set on the Javascript when you register. These are accepted, but not required:
 *
 *      lazyLoad: true
 *        Set to false if options should be fetched immediately on initialized
 *
 *      width: 300
 *        Set width of the dropdown
 *
 *      dropdownAutoWidth: true
 *        Adjust the width of the dropdown based on the content. You might want to set this to false
 *        if you are limited with space like in the prospecting plugin.
 *
 *      allowClear: true
 *        Allow dropdown to be cleared with the X button on the right
 *
 *      placeHolder: String
 *        Text place holder when nothing is selected
 *
 *      onChangeCallback: function() { }
 *        On change, this function will be called
 *
 *      clearCacheOnChange: false
 *        The dropdown options is cached so it does not make a ajax call on every open.
 *        If this is turned on, it will clear the cache every time the selected value is changed.
 *        This is useful with onChangeCallback when you need to update your dropdown.
 *
 *      displayHiringPlans: false
 *        This will display hiring plans that belongs to the organization structure.
 *        If the global filter is on, it will apply the changes to the dropdown to only show the jobs
 *        under that office/department
 *
 *      prependOptions: []
 *        Given an array of json with the key id and hash, options will be created with that data and prepended
 *        to the top of the dropdown
 *
 * =====================
 * Features
 * =====================
 *
 * Caching
 *
 *   The options are cached by type and if it includes hiring plan. The cacheKey is what the options
 *   are cached by. The response also goes through filterResponse to filter/manipulate the data
 *   from all the configurations and then cached so that is not done every time the dropdown is opened.
 *
 * Search
 *
 *   The search will filter the options with filterOptionsWithSearch. It will recursively look
 *   through all the children to find if it should display the parent.
 *
 * Auto-hide empty parent
 *
 *   If there is nothing selectable under a parent node, we will automatically hide the parents
 *   to only show selectable options.
 *
 */

/*global Greenhouse */

var organizationalStructureControls = [],
  organizationalStructureCache = {},
  organizationalStructureCacheWithParents = {};

var OrganizationalStructureControl = (function () {
  function OrganizationalStructureControl(id, options) {
    this.id = id;
    this.dropdown = $(id);
    this.options = options || {};
    this.type = this.dropdown.attr('type');
  }

  OrganizationalStructureControl.prototype.loadOptions = function () {
    var that = this,
      options = this.options,
      containerCss = options.containerCss,
      allowClear = options.hasOwnProperty('allowClear')
        ? options.allowClear
        : true,
      lazyLoad = options.hasOwnProperty('lazyLoad') ? options.lazyLoad : true,
      cacheKey = this.type + options.displayHiringPlans,
      noResultsText = options.hasOwnProperty('noResultsText')
        ? options.noResultsText
        : Greenhouse.Translation.t('select.noResultsText'),
      searchText = options.hasOwnProperty('searchText')
        ? options.searchText
        : Greenhouse.Translation.t('select.searchText'),
      dropdownAutoWidth = options.hasOwnProperty('dropdownAutoWidth')
        ? options.dropdownAutoWidth
        : true;

    this.dropdown.select2({
      placeholder: placeHolderText(),
      dropdownAutoWidth: dropdownAutoWidth,
      allowClear: allowClear,
      minimumResultsForSearch: 3,
      containerCss: containerCss,
      width: options.width || '100%',
      multiple: options.multiple || false,
      formatSearching: searchText,
      formatNoMatches: noResultsText,
      initSelection: function (element, callback) {
        var $element = $(element);

        var value = $element.attr('value');
        var valueText =
          $element.attr('value_text') || $element.data('value-text');

        var defaultValues = $element.attr('default_values');

        if (value && valueText) {
          callback({ id: value, text: valueText });
        } else if (defaultValues) {
          callback(JSON.parse(defaultValues));
        }
      },
      query: function (query) {
        var cache = organizationalStructureCache[cacheKey];

        if (cache && !that.dropdown.data('json')) {
          populateDropdown(query, cache);
        } else {
          loadData(function (data) {
            populateDropdown(query, data);
          });
        }
      },
    });

    if (options.onChangeCallback) {
      this.dropdown.on('change', options.onChangeCallback);
    }

    if (!lazyLoad) {
      var dropdown = this.dropdown;

      loadData(function () {
        dropdown.trigger('change');
      });
    }

    if (options.clearCacheOnChange) {
      delete organizationalStructureCache[cacheKey];
    }

    function loadData(callback) {
      if (that.dropdown.data('json')) {
        loadDataThroughJSON(callback);
      } else {
        loadDataThroughAjax(callback);
      }
    }

    function loadDataThroughJSON(callback) {
      callback(cacheResponse(JSON.parse(that.dropdown.attr('data-json'))));
    }

    function loadDataThroughAjax(callback) {
      var data = {};

      if (options.displayHiringPlans) {
        data.display_hiring_plans = true;
      }

      $.ajax({
        url: eval('Routes.' + that.type + 's_path'),
        data: data,
        dataType: 'json',
        success: function (response) {
          callback(cacheResponse(response));
        },
      });
    }

    function cacheResponse(data) {
      if (!that.dropdown.data('json')) {
        organizationalStructureCache[cacheKey] = data;
      }

      if (
        options.includeParents &&
        organizationalStructureCacheWithParents[cacheKey] === undefined
      ) {
        cloneCacheAndAddParentReference();
      }

      return data;
    }

    function cloneCacheAndAddParentReference() {
      // We need to clone the cache object because of the deepClone function which calls JSON.stringify.
      // Since we are creating an object below with a circular reference,
      // (recursively passing the parent object as a reference to each child object) JSON.stringify will error.
      organizationalStructureCacheWithParents[cacheKey] = jQuery.extend(
        true,
        {},
        organizationalStructureCache[cacheKey]
      );

      traverseAndAddParentReference(
        organizationalStructureCacheWithParents[cacheKey]
      );
    }

    function traverseAndAddParentReference(data) {
      data.init = function () {
        for (var i in this) {
          if (typeof this[i] === 'object') {
            this[i].init = this.init;
            this[i].init();
            this[i].parent = this;
          }
        }
        return this;
      };

      data.init();
    }

    function placeHolderText() {
      if (options.placeHolder) {
        return options.placeHolder;
      } else {
        var type = options.displayHiringPlans
          ? 'Hiring Plan'
          : StringUtil.capitalize(that.type);

        return allowClear ? 'No ' + type : 'Select one';
      }
    }

    function populateDropdown(query, data) {
      query.callback({ results: filterData(data) });

      function filterData(data) {
        var searchTerm = query.term,
          defaultValues = that.selectedText(),
          disableOption = that.dropdown.data('disable-ids'),
          displayOnlyIdsWithParents = that.dropdown.data(
            'display-only-ids-with-parents'
          ),
          displayOnlyIdsWithoutParents = that.dropdown.data(
            'display-only-ids-without-parents'
          ),
          includeUnattachedProspectOption = that.dropdown.data(
            'include-unattached-prospect-option'
          ),
          clonedData = deepClone(data);

        if (searchTerm !== '') {
          clonedData = filterOptionsWithSearch(clonedData);
        }

        if (options.multiple && defaultValues.length > 0) {
          clonedData = filterChildrenOfSelected(clonedData);
        }

        if (displayOnlyIdsWithoutParents) {
          clonedData = filterDisplayOnlyWithoutParents(clonedData);
        }

        if (displayOnlyIdsWithParents) {
          clonedData = filterDisplayOnlyWithParents(clonedData);
        }

        if (disableOption) {
          clonedData = disableOptions(clonedData);
        }

        if (options.prependOptions) {
          options.prependOptions.forEach(function (hash) {
            clonedData.unshift({ id: hash.id, text: hash.text });
          });
        }

        clonedData = filterEmptyParent(clonedData);

        if (includeUnattachedProspectOption) {
          clonedData.unshift({ id: '-1', text: 'Prospects on no job' });
        }

        return clonedData;

        function disableOptions(dataArray) {
          return _.map(dataArray, function (object) {
            object.disabled = object.id == disableOption;

            if (object.children) {
              object.children = disableOptions(object.children);
            }

            return object;
          });
        }

        function filterEmptyParent(dataArray) {
          return dataArray.filter(function (object) {
            if (object.children) {
              var filteredData = filterEmptyParent(object.children);
              object.children = filteredData;

              return filteredData.length > 0;
            } else {
              return !!object.id;
            }
          });
        }

        // for Job Creation tasks like Ramp Up Create and Job Info edit, we don't want to display parents
        // unless their IDs are specified
        function filterDisplayOnlyWithoutParents(dataArray) {
          var returnedArray = [];

          dataArray.forEach(function (object) {
            findObjectToDisplay(object);
          });

          return returnedArray;

          function findObjectToDisplay(object) {
            if (displayOnlyIdsWithoutParents.indexOf(object.id) >= 0) {
              returnedArray.push(object);
            } else if (object.children) {
              object.children.forEach(function (child) {
                findObjectToDisplay(child);
              });
            }
          }
        }

        function filterDisplayOnlyWithParents(dataArray) {
          return dataArray.filter(function (object) {
            if (object.children) {
              var filteredData = filterDisplayOnlyWithParents(object.children);
              object.children = filteredData;

              return (
                displayOnlyIdsWithParents.indexOf(object.id) >= 0 ||
                filteredData.length > 0
              );
            } else {
              return displayOnlyIdsWithParents.indexOf(object.id) >= 0;
            }
          });
        }

        function filterOptionsWithSearch(dataArray) {
          if (typeof dataArray === 'undefined') {
            return false;
          }

          return dataArray.filter(function (value) {
            var childrenMatch = filterOptionsWithSearch(value.children);

            if (childrenMatch.length > 0) {
              value.children = filterOptionsWithSearch(childrenMatch);
            }

            return (
              value.text.toLowerCase().match(searchTerm.toLowerCase()) ||
              childrenMatch.length > 0
            );
          });
        }

        function filterChildrenOfSelected(dataArray) {
          return dataArray.filter(function (value) {
            var children = value.children || [],
              valueNotSelected = defaultValues.indexOf(value.text) === -1;

            if (children.length > 0) {
              value.children = filterChildrenOfSelected(children);
            }

            return valueNotSelected;
          });
        }
      }
    }

    function deepClone(object) {
      return JSON.parse(JSON.stringify(object));
    }
  };

  function traverseAndAddParentIdsToArray(data, id, parentIds) {
    for (var i in data) {
      if (i === 'id' && data[i] === id) {
        traverseAndFindParentIds(data, parentIds);
      }

      if (data[i] !== null && typeof data[i] === 'object' && i !== 'parent') {
        traverseAndAddParentIdsToArray(data[i], id, parentIds);
      }
    }
  }

  function traverseAndFindParentIds(data, idArray) {
    for (var i in data) {
      if (i === 'id' && data.hasOwnProperty('parent')) {
        // We are calling .parent twice because the first .parent gives you the children array,
        // and the second .parent gives you the actual object with the id property.
        if (data.parent.parent !== undefined) {
          idArray.push(data.parent.parent.id);
          traverseAndFindParentIds(data.parent.parent, idArray);
        }
      }
    }
  }

  function findSelectedIds(data) {
    if (!data) {
      return [];
    } else if (data.hasOwnProperty('id')) {
      return [data.id];
    } else if (Array.isArray(data)) {
      return _.map(data, function (obj) {
        return obj.id;
      });
    } else {
      return [];
    }
  }

  OrganizationalStructureControl.prototype.selectedText = function () {
    var data = this.dropdown.select2('data');

    if (!data) {
      return 'None';
    } else if (Array.isArray(data)) {
      return _.map(data, function (obj) {
        return obj.text;
      });
    } else if (data.hasOwnProperty('text')) {
      return data.text;
    } else {
      return '';
    }
  };

  OrganizationalStructureControl.prototype.setSelectedIdsAndChildrenIds = function () {
    var parentIds = [],
      selectedData = this.dropdown.select2('data');

    var selectedIds = findSelectedIds(selectedData);

    if (this.options.includeParents) {
      selectedIds.forEach(function (id) {
        traverseAndAddParentIdsToArray(
          organizationalStructureCacheWithParents,
          id,
          parentIds
        );
      });
    }

    this.selectedIdsAndChildrenIdsArray = _.union(parentIds, selectedIds);
  };

  OrganizationalStructureControl.hasAccessToOfficeDept = function (
    customFieldDeptIds,
    customFieldOfficeIds,
    hiringPlanDeptIds,
    hiringPlanOfficeIds
  ) {
    if (
      _.intersection(customFieldOfficeIds, hiringPlanOfficeIds).length > 0 &&
      customFieldDeptIds.length === 0
    ) {
      return true;
    } else if (
      _.intersection(customFieldDeptIds, hiringPlanDeptIds).length > 0 &&
      customFieldOfficeIds.length === 0
    ) {
      return true;
    } else if (
      _.intersection(customFieldOfficeIds, hiringPlanOfficeIds).length > 0 &&
      _.intersection(customFieldDeptIds, hiringPlanDeptIds).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  OrganizationalStructureControl.register = function (id, options) {
    var control = new this(id, options);

    if (control.dropdown.length > 0 && control.dropdown.is('input')) {
      control.loadOptions();
      organizationalStructureControls.push(control);
    }

    return control;
  };

  OrganizationalStructureControl.find = function (id) {
    return _.find(organizationalStructureControls, function (object) {
      return object.id == id;
    });
  };

  OrganizationalStructureControl.registerEventsForMultiSelect = function (
    checkboxSelector,
    multiSelectInputSelector
  ) {
    var checkbox = $(checkboxSelector),
      multiSelectInput = $(multiSelectInputSelector);

    // When checkbox for all offices or all departments is checked,
    // disable multi select input field.
    checkbox.on('change', function () {
      if ($(this).is(':checked')) {
        multiSelectInput.val(null).trigger('change');
        multiSelectInput.prop('disabled', true);
      } else {
        multiSelectInput.prop('disabled', false);
      }
    });

    // When a multi select option is selected,
    // uncheck the all offices or all departments checkbox.
    multiSelectInput.on('change', function () {
      if (checkbox.is(':checked') && multiSelectInput.val().length > 0) {
        checkbox.prop('checked', false);
      }
    });
  };

  return OrganizationalStructureControl;
})();
var Person = Person || {};

Person.AttachmentClient = {
  createAttachment: function (formSelector, onSuccess, onError) {
    Ajax.submit({
      formSelector: formSelector,
      success: onSuccess,
      error: onError,
    });
  },

  changeVisibility: function (
    attachmentId,
    visibility,
    applicationId,
    onSuccess
  ) {
    Ajax.put({
      url: change_attachment_visibility_path({
        id: applicationId,
        attachment_id: attachmentId,
      }),
      data: { visibility: visibility },
      success: onSuccess,
    });
  },

  deleteAttachment: function (attachmentId, applicationId, onSuccess) {
    Ajax.del({
      url: delete_attached_file_path({
        id: applicationId,
        attachment_id: attachmentId,
      }),
      pendingMessage: 'Deleting file',
      success: onSuccess,
    });
  },

  changeType: function (attachmentId, newType, applicationId, onSuccess) {
    Ajax.put({
      url: change_attachment_type_path({
        id: applicationId,
        attachment_id: attachmentId,
      }),
      data: { type: newType },
      success: onSuccess,
    });
  },

  fetchAttachment: function (attachmentId, applicationId, onSuccess, onError) {
    Ajax.get({
      url:
        Routes.Person.person_attachment_path({
          id: applicationId,
          attachment_id: attachmentId,
        }) +
        '?timestamp=' +
        Date.now(),
      disableFlash: true,
      success: onSuccess,
      error: onError,
    });
  },

  fetchPreview: function (
    attachmentId,
    attachmentType,
    width,
    onSuccess,
    onError
  ) {
    return $.ajax({
      url: Routes.Person.attachment_preview_path({
        id: attachmentId,
        width: width,
        type: attachmentType,
      }),
      success: onSuccess,
      error: onError,
    });
  },
};

window.PdfJSViewer = (function () {
  var LOADING_CLASS = 'fetching-preview';

  function injectViewer(selector, attachment, width) {
    var $container = $(selector).empty();

    hideErrorMessage();

    load($container, attachment, width);
  }

  function setFrame($container, source) {
    $container.removeClass(LOADING_CLASS);

    if ($container.find('iframe').length > 0) {
      // The user may have started previewing a different document before a long-running request finished
      // In this case we don't want the success callback from the other document to replace this iframe
      return;
    }

    var iframe = $(
      '<iframe sandbox="allow-scripts allow-same-origin allow-popups" src="' +
        source +
        '" class="box-view-viewer"></iframe>'
    );
    $container.html(iframe);
  }

  function load($container, attachment, width) {
    function requestError() {
      showErrorMessage('An error occured while trying to fetch the document');
      $container.removeClass(LOADING_CLASS);
    }

    function notPreviewable() {
      showErrorMessage('This document can not be previewed');
      $container.removeClass(LOADING_CLASS);
    }

    function success(response) {
      if (response.previewable) {
        setFrame($container, response.source);
      } else {
        notPreviewable();
      }
    }

    function fetch() {
      $container.addClass(LOADING_CLASS);
      Person.AttachmentClient.fetchPreview(
        attachment.id,
        attachment.type,
        width,
        success,
        requestError
      );
    }

    fetch();
  }

  function showErrorMessage(text) {
    $('.document-error-status').text(text).show();
  }

  function hideErrorMessage() {
    $('.document-error-status').hide();
  }

  return {
    injectViewer: injectViewer,
  };
})();
/**
 * See taggable.rb for detailed end-to-end instructions on adding tagging to your model.
 *
 * init()
 *   Initializes all textareas that have the class 'taggable' to support tagging. You must have a
 *   data-with-tags attribute if you wish to initialize the textarea with already-marked-up text.
 *   Note that this method returns false if tagging is unsupported (older versions of IE).
 *
 *   Also initializes the @mentions modal if present on the page.
 *
 * prepareSubmit()
 *   You must call this right before your form is submitted, to add (or update) hidden fields
 *   containing marked-up copies of the text.
 */
var Taggable = lib(
  (function () {
    var SELECTOR = 'textarea.taggable',
      modal = null,
      cachedUsers = null;

    function normalizeName(name) {
      return name.toLowerCase().replace(/\W/g, '');
    }

    function normalizeUsers(users) {
      _.each(users, function (user) {
        user.normalizedName = normalizeName(user.name);
      });
    }

    function init() {
      if (!modal) {
        modal = new Modal('#mentions_modal', {
          openWith: '#mentions',
          config: { width: 600 },
        });
      }

      var textareas = $(SELECTOR),
        ajaxRequest = null;

      textareas.textntags({
        triggers: {
          '@': {
            minChars: 0,
            // this is overridden to add single quote to the characters allowed in a tag name
            parser: /(@)\[\[(\d+):([\w\s\.\-]+):([\w\s@\.,-\/#!$%\^&\*;:{}=\-_`~()']+)\]\]/gi,
          },
        },

        realValOnSubmit: false,

        onDataRequest: function (mode, query, triggerChar, callback) {
          if (ajaxRequest) {
            ajaxRequest.abort();
          }

          if (cachedUsers) {
            callback.call(this, filter(cachedUsers, query));
          } else {
            ajaxRequest = $.getJSON(Routes.tags_path, function (response) {
              normalizeUsers(response);
              cachedUsers = response;
              callback.call(this, filter(cachedUsers, query));
              ajaxRequest = null;
            });
          }
        },
      });

      textareas.each(function () {
        var textarea = $(this),
          taggedValue = textarea.data('with-tags'),
          minHeight = textarea.css('min-height');

        if (minHeight) {
          textarea
            .siblings('.textntags-beautifier')
            .css('min-height', minHeight);
        }

        textarea.textntags('val', taggedValue || textarea.val());
      });

      return true;
    }

    function prepareSubmit() {
      $(SELECTOR).each(function () {
        var textarea = $(this);

        var hiddenField = textarea.next('input[type=hidden]');

        if (hiddenField.length === 0) {
          hiddenField = createHiddenFieldFor(textarea);
        }

        hiddenField.val(markupFor(textarea));
      });
    }

    function createHiddenFieldFor(textarea) {
      var name = textarea.attr('name'),
        qualified = name.match(/\]$/),
        field = qualified ? name.match(/\[(.+?)\]$/)[1] : name,
        newField = field + '_with_tags',
        newName = qualified
          ? name.replace('[' + field + ']', '[' + newField + ']')
          : newField,
        hiddenField = $('<input/>')
          .attr('type', 'hidden')
          .attr('name', newName);

      if (textarea.attr('id')) {
        hiddenField.attr('id', textarea.attr('id') + '_with_tags');
      }

      hiddenField.insertAfter(textarea);
      return hiddenField;
    }

    // Clears a taggable textarea.
    function clear(selector) {
      var textarea = $(selector);

      textarea.textntags('val', '');
    }

    function latestFields() {
      var fields = {};

      $(SELECTOR).each(function () {
        var textarea = $(this),
          name = textarea.attr('name');

        fields[name] = {
          plaintext: textarea.val(),
          markup: markupFor(textarea),
          textarea: textarea,
        };
      });

      return fields;
    }

    function markupFor(textarea) {
      var result = '';

      textarea.textntags('val', function (markup) {
        // optimization: don't store marked-up text if there is no markup in it
        result = markup === textarea.val() ? '' : markup;
      });

      return result;
    }

    function escapeRegex(str) {
      return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function createFilterRegex(query) {
      query = query.replace(/\s+/, ' ').trim();
      var parts = query.split(' ');
      parts = _.map(parts, function (part) {
        var result = normalizeName(part);
        return escapeRegex(result);
      });
      return parts.join('.*');
    }

    function filter(users, query) {
      query = createFilterRegex(query);

      var matches = _(users).filter(function (user) {
        return user.normalizedName.search(query) > -1;
      });

      return _(matches).first(10);
    }

    return {
      init: init,
      prepareSubmit: prepareSubmit,
      clear: clear,
      latestFields: latestFields,
    };
  })()
);
/*global Greenhouse */

var Tree = (function () {
  function Tree(selector, html, options) {
    this.container = $(selector);
    this.options = options || {};

    if (html) {
      this.container.html(html);
    }

    this.registerEvents();
    this.initializeSelectAll();
    this.checkBranchIfAllLeafSelected();

    if (this.options.expand_all_branches) {
      this.expandAllBranches();
    } else {
      this.expandIncompleteBranches();
    }
  }

  Tree.prototype.registerEvents = function () {
    var tree = this,
      container = this.container,
      options = this.options;

    container.find('.toggle').on('click', function () {
      $(this).closest('.branch').toggleClass('branch-open');
    });

    container.find('input[type=checkbox]').on('change', function () {
      var li = $(this).closest('li'),
        checked = $(this).is(':checked');

      if (li.hasClass('branch')) {
        li.find('input[type=checkbox]').prop('checked', checked);
      }

      $(this)
        .parents('.branch')
        .each(function () {
          checkIfAllLeafSelected(this);
        });

      tree.initializeSelectAll();

      if (options.onChange) {
        options.onChange.call(container[0]);
      }
    });

    container.find('.select-all').on('click', function () {
      if (tree.allSelected()) {
        tree.deselectAll();
      } else {
        tree.selectAll();
      }

      tree.initializeSelectAll();

      if (tree.options.onChange) {
        tree.options.onChange.call(tree.container[0]);
      }
    });
  };

  Tree.prototype.selectAll = function () {
    this.container.find('input[type=checkbox]').prop('checked', true);
  };

  Tree.prototype.deselectAll = function () {
    this.container.find('input[type=checkbox]').prop('checked', false);
  };

  Tree.prototype.selectedLeafCount = function () {
    return this.container.find('.leaf').find('> input:checked').length;
  };

  // Expands branches which have some children checked, but not all.
  Tree.prototype.expandIncompleteBranches = function () {
    this.container.find('.branch').each(function () {
      expandIfIncomplete($(this));
    });
  };

  Tree.prototype.expandAllBranches = function () {
    this.container.find('.branch').addClass('branch-open');
  };

  Tree.prototype.checkBranchIfAllLeafSelected = function () {
    this.container.find('li.branch').each(function () {
      checkIfAllLeafSelected($(this));
    });
  };

  Tree.prototype.initializeSelectAll = function () {
    var link = this.container.find('.select-all').find('a');

    if (this.allSelected()) {
      link.text(Greenhouse.Translation.t('shared.tree.deselect_all'));
    } else {
      link.text(Greenhouse.Translation.t('shared.tree.select_all'));
    }
  };

  Tree.prototype.allSelected = function () {
    var checkboxes = this.container.find('> .tree > li > input[type=checkbox]');
    return checkboxes.length == checkboxes.filter(':checked').length;
  };

  // Returns the outermost selected branch IDs (i.e. omits branch IDs which are implied
  // by its parent already being selected).
  Tree.prototype.getSelectedBranchIds = function () {
    return branchNodeIds(this.container);
  };

  // Returns the IDs of selected leaf nodes that don't have a parent that is selected
  // (i.e. omits leaf IDs which are implied by its parent branch being selected).
  Tree.prototype.getSelectedLeafIds = function () {
    var checkedNodes = this.container.find('li.leaf').filter(function () {
      var checked = $(this).find('> input[type=checkbox]').is(':checked'),
        parent = $(this).closest('li.branch'),
        parentChecked = parent.find('> input[type=checkbox]').is(':checked');

      return checked && !parentChecked;
    });

    return _(checkedNodes).map(function (node) {
      return $(node).data('node-id');
    });
  };

  Tree.prototype.getAllSelectedLeafIds = function () {
    var checkedNodes = this.container.find('li.leaf').filter(function () {
      return $(this).find('> input[type=checkbox]').is(':checked');
    });

    return _(checkedNodes).map(function (node) {
      return $(node).data('node-id');
    });
  };

  function branchNodeIds(node) {
    if (node.find('> input[type=checkbox]').is(':checked')) {
      return [node.data('node-id')];
    }

    var ids = [];

    node.find('> .tree > li.branch').each(function (i, child) {
      ids = ids.concat(branchNodeIds($(child)));
    });

    return ids;
  }

  // NOTE: this doesn't handle multiple levels of nesting
  function expandIfIncomplete(node) {
    var checked = node.find('> input[type=checkbox]').is(':checked');

    if (!checked) {
      var anyChildrenChecked =
        node.find('input[type=checkbox]:checked').length > 0;

      if (anyChildrenChecked) {
        node.addClass('branch-open');
      }
    }
  }

  function checkIfAllLeafSelected(node) {
    var branch = $(node),
      checkbox = branch.find('> input[type=checkbox]'),
      childCheckboxes = branch.find('.leaf > input[type=checkbox]');

    checkbox.prop(
      'checked',
      childCheckboxes.filter(':checked').length === childCheckboxes.length
    );
  }

  return Tree;
})();
var CustomFields = lib(
  (function () {
    function register(container, customFieldTypeEvents) {
      container = container || document;

      $(container)
        .find('.custom-field-control')
        .each(function () {
          var $control = $(this);

          window.editableFieldControl($control, {
            initializeFieldValue: false,
            autoCollapse: false,
          });

          var afterValidateCallback = getAfterValidateCallback(
            $control,
            customFieldTypeEvents
          );
          $control.validateOn(
            'editableFieldUpdated',
            validatorFor($control),
            afterValidateCallback
          );
        });

      $(container)
        .find('.custom-field-input')
        .each(function () {
          var field = $(this);

          switch (field.data('type')) {
            case 'date':
              initializeDateField(field);
              break;
            case 'user':
              initializeUserField(field);
              break;
          }
        });
    }

    function getAfterValidateCallback($control, opts) {
      if (!opts) {
        return save;
      }

      var fieldType = $control.data('type');
      if (opts.hasOwnProperty(fieldType)) {
        return function customCallback() {
          triggerEvent(opts[fieldType], $control);
        };
      }

      return save;
    }

    function triggerEvent(eventName, $control) {
      $(document).trigger(eventName, $control);
    }

    function initializeDateField(field) {
      UI.Datepicker.init(field);
    }

    function initializeUserField(field) {
      new Ajax.SelectBox({
        selectBox: field,
      });
    }

    function save() {
      var control = $(this),
        form = control.find('form'),
        label = control.find('.collapsed-field-text');

      Ajax.submit({
        formSelector: form,
        success: function (response) {
          control.trigger('greenhouse.collapse');
          label.html(response.display_html || '--');
        },
      });
    }

    function validate(container) {
      var validator = new Validator(),
        inputFinder = [
          'input.custom-field-input:visible',
          'textarea.custom-field-input:visible',
          'select.custom-field-input',
          'input.custom-field-input.select2',
        ],
        customFieldInputs = $(container).find(inputFinder.join(', '));

      customFieldInputs.each(function () {
        var input = $(this),
          type = input.data('type'),
          required = input.data('required');

        validator.validate(input);

        if (!required || customFieldSelectIsNotVisible(input)) {
          validator.allowEmpty();
        }

        if (
          [
            'short_text',
            'long_text',
            'yes_no',
            'single_select',
            'multi_select',
            'attachment',
            'user',
          ].indexOf(type) >= 0
        ) {
          validator.withMessage('This field is required').notBlank();
        } else if (type === 'url') {
          validator.withMessage('Enter a valid URL').url();
        } else if (
          type === 'currency' ||
          type === 'number' ||
          type === 'currency_range' ||
          type === 'number_range'
        ) {
          // Due a limitation with the data warehouse, custom field numeric values
          // shouldn't exceed 28 digits. See GREEN-34787 for more context.
          validator
            .withMessage('Enter a valid number')
            .decimalWithMaxPrecision(28);
        } else if (type === 'date') {
          validator
            .withMessage(
              'Enter a valid date of the format ' +
                Config.TimeZone.dateFormat('date')
            )
            .dateFormat();
        } else {
          window.Flash.setError(
            "We're sorry, but there was an error processing this form."
          );
          console.error("Unknown field type: '%s'", type);
          validator.fail();
        }
      });

      $(container)
        .find('.custom-field-unit[data-required=true]')
        .each(function () {
          var input = $(this),
            value = input.val(),
            blank = $.trim(value).length === 0;

          // Since the unit shares the same parent element as the text input, the validation will replace each other
          // So it will only replace when it is blank. Else remove the error on the unit drop down only
          if (blank && !customFieldSelectIsNotVisible(input)) {
            validator
              .validate(input)
              .withMessage('This field is required')
              .notBlank();
          } else {
            input.removeClass('field-error');
          }
        });

      validate_range(container);

      return validator;
    }

    function customFieldSelectIsNotVisible(el) {
      return el.is('select') && !chznDropdownIsVisible(el);
    }

    function chznDropdownIsVisible(input) {
      return (
        input.siblings('.chzn-container').length > 0 &&
        input.siblings('.chzn-container').is(':visible')
      );
    }

    function validate_range(container) {
      $(container)
        .find('tr')
        .each(function () {
          var row = $(this);

          if (
            row.find('.custom-field-input[data-type=currency_range]').length >
              0 ||
            row.find('.custom-field-input[data-type=number_range]').length > 0
          ) {
            var minValue = row.find('.custom-field-input').eq(0).val();
            var maxValue = row.find('.custom-field-input').eq(1).val();

            if (
              minValue &&
              maxValue &&
              parseInt(minValue, 10) > parseInt(maxValue, 10)
            ) {
              row.find('.custom-field-input').eq(0).val(maxValue);
              row.find('.custom-field-input').eq(1).val(minValue);
            }
          }
        });
    }

    function validatorFor(container) {
      return validate.bind(null, container);
    }

    /**
     * Serializes the custom field forms in a way that's compatible with the Rails attr_accessible mechanism.  Produces
     * a hash that looks like:
     *
     * <namePrefix>: {
     *   'custom_field_values_attributes' => {
     *     '0' => {
     *       'custom_field_id' => 1,
     *       'value' => 123,
     *       'unit' => 'USD'
     *     }
     *   }
     * }
     * //referral_details"=>{"custom_field_values_attributes"=>{"0"=>{"id"=>"", "custom_field_id"=>"16", "value"=>""},
     *
     * @param namePrefix Probably what you passed into `custom_field_tag` on the Rails side
     */
    function serializeForRails(selector, namePrefix) {
      var customFieldData = {
        custom_field_values_attributes: {},
      };

      _(
        $(selector)
          .find("[name^='" + namePrefix + "[']")
          .serializeArray()
      ).each(function (field) {
        if (!field.value || field.value.trim().length === 0) {
          return;
        }

        var regex = new RegExp(
            namePrefix +
              '\\[custom_field_values_attributes\\]\\[(\\d+)\\]\\[([^\\]]+)\\](?:\\[\\])?'
          ),
          match = field.name.match(regex);

        if (!match) {
          throw 'Encountered invalid custom field element' + field;
        }

        var index = match[1],
          attribute = match[2],
          fieldData = customFieldData.custom_field_values_attributes[index];

        if (!fieldData) {
          fieldData = {};
          customFieldData.custom_field_values_attributes[index] = fieldData;
        }

        var existingValue = fieldData[attribute];
        if (existingValue) {
          fieldData[attribute] = [].concat(fieldData[attribute], field.value);
        } else {
          fieldData[attribute] = field.value;
        }
      });

      return customFieldData;
    }

    return {
      register: register,
      validate: validate,
      validatorFor: validatorFor,
      save: save,
      serializeForRails: serializeForRails,
    };
  })()
);
/* global documentReady */

// Custom event so that we can unbind just the
// outside click event from document, and not
// ALL click events from document
var OUTSIDE_CLICK = 'greenhouse.outsideclick';

var OutsideClickLock = {
  locked: false,
  // Stores the selector
  selector: null,
  callback: null,

  // Acquires the lock for the given container and
  // registers an outside click event.  Callback optional.
  acquire: function (containerSelector, callback) {
    var docLock = this;

    if (docLock.locked) {
      docLock.release();
    }

    docLock.locked = true;
    docLock.selector = containerSelector;
    docLock.callback = callback;

    // This event prevents inside clicks from propagating
    // up through the document.
    $(docLock.selector).on('click', function (e) {
      e.stopPropagation();
    });

    $(document).on(OUTSIDE_CLICK, function (e) {
      // Looks up through the DOM for the selector to make sure
      // the click was not 'inside' the container
      if ($(e.target).closest(docLock.selector).length === 0) {
        docLock.release();
      }
    });
  },

  // Unbinds events registered by acquire and releases the lock
  release: function () {
    // Standard callback hook (optional)
    if (typeof this.callback === 'function') {
      this.callback.call($(this.selector));
    }

    $(this.selector).unbind('click');
    $(document).unbind(OUTSIDE_CLICK);

    this.locked = false;
  },
};

documentReady(function () {
  // Delegates any click event to trigger a greenhouse.outsideClick
  // this is so we can later unbind just the greenhouse.outsideClick
  // event listeners without unbinding all click listeners from document
  $(document).on('click', function () {
    $(document).trigger(OUTSIDE_CLICK);
  });
});
var activityFeed = {
  templates: {
    moreLink: Handlebars.compile(
      '<div id="view_more" style="text-align:right;"><a href="#" id="view_more_link">Show More &darr;</a></div>'
    ),
    newsItem: Handlebars.compile(
      '<div class="news-item" created="{{created}}">{{{message}}} <span class="timestamp">{{date}}</span></div>'
    ),
    hpNewsItem: Handlebars.compile(
      '<div class="news-item" created="{{created}}">{{{message}}}<div class="hiring-plan">{{hiring_plan}}</div><div class="timestamp">{{date}}</div><div style="clear:both;"></div></div>'
    ),
    emptyState: Handlebars.compile(
      '<div><em>No activity to display</em></div>'
    ),
  },

  viewMoreSingleton: function () {
    var viewMore = $('#view_more');
    // If view_more not found, create a new one, otherwise return existing
    return viewMore.length === 0
      ? this.templates.moreLink()
      : viewMore.detach();
  },

  populate: function (opts) {
    var feed = this,
      BLOCK_SIZE = opts && opts.alertsOnly ? 20 : 5,
      feedContainer = $('#activity_feed'),
      lastItem = $('.news-item:last'),
      params = { requestSize: BLOCK_SIZE };

    if (feedContainer.length === 0) {
      return;
    }

    if (lastItem) {
      params.before = lastItem.attr('created');
    }

    if (opts) {
      $.extend(params, opts);
    }

    $.get(activity_feed_path, params, function (data) {
      $.each(data.items, function (i, item) {
        if (i >= BLOCK_SIZE) {
          return false; //break
        }

        // If we have a last item, then this is not the first
        // request, so we want to append.
        addItem(item, lastItem);
      });

      if ($('.news-item').length === 0) {
        feedContainer.append(feed.templates.emptyState());
      } else {
        if (typeof opts === 'undefined' || opts.displayMore) {
          if (
            typeof newsItems !== 'undefined' &&
            newsItems.length < BLOCK_SIZE
          ) {
            feed.viewMoreSingleton(); //detaches the view more link
          } else {
            feedContainer.append(feed.viewMoreSingleton());
          }

          $('#view_more_link').unbind('click');
          $('#view_more_link').click(function () {
            feed.populate(opts);
          });
        }
      }
    });

    function addItem(item, append) {
      var templatedItem;
      var baseItem = {
        message: item.content,
        created: item.created_at,
        date: moment(item.created_at).fromNow(),
      };

      if (opts && opts.showHiringPlanName) {
        templatedItem = feed.templates.hpNewsItem(
          $.extend(baseItem, { hiring_plan: item.hiring_plan.name })
        );
      } else {
        templatedItem = feed.templates.newsItem(baseItem);
      }

      if (append) {
        feedContainer.append(templatedItem);
      } else {
        feedContainer.prepend(templatedItem);
      }
    }
  },
};
var FeatureAnnouncement = {
  registerEvents: function (options) {
    // The following options are required:
    // selector - The id of the announcement container.
    // key - This is the unique name for the feature that we store in localStorage as the key.

    var KEY = 'feature_announcements/' + options.key;
    var $announcement = $(options.selector);

    if (!warningSeen()) {
      $announcement.find('.x, .ok').on('click', hide);
      $announcement.show();
    }

    function warningSeen() {
      return !localStorage || localStorage.getItem(KEY) === 'true';
    }

    function hide() {
      localStorage.setItem(KEY, 'true');

      $announcement.slideUp();
    }
  },
};
var moreInfoFlyoutTemplate = Handlebars.compile(
  '<div class="more-info-flyout"><span class="arrow"></span><div>{{{desc}}}</div></div>'
);

var MoreInfo = {
  // selector is an optional parent element to limit the initialization to
  init: function (selector) {
    var links =
      typeof selector === 'undefined'
        ? $('.more-info-link')
        : $(selector).find('.more-info-link');

    links.unbind('hover').hover(showFlyout, hideFlyout);

    function showFlyout() {
      var desc = $(this).data('desc');

      if (desc) {
        var flyout = $(moreInfoFlyoutTemplate({ desc: desc })),
          link = $(this);

        $('body').append(flyout);

        flyout.css({
          top: link.offset().top - flyout.outerHeight() - 10,
          left:
            link.offset().left +
            link.outerWidth() / 2 -
            flyout.outerWidth() / 2,
        });

        setTimeout(function () {
          flyout.show();
        }, 100);
      }
    }

    function hideFlyout() {
      $('.more-info-flyout').remove();
    }
  },
};
/* global Greenhouse, Tooltip */

var Tooltip = {
  flyoutHtml:
    '<div id="_gh_tooltip" class="tooltip-flyout">' +
    '<span class="arrow"></span>' +
    '<div id="_gh_tooltip_text"></div>' +
    '</div>',

  flyout: function () {
    return $('#_gh_tooltip');
  },

  setText: function (text) {
    // We are using html() instead of text() because some tooltips use HTML.
    // In theory this is safe because we never pass in user input.
    $('#_gh_tooltip_text').html(text);
  },

  registerClass: function (class_selector) {
    Tooltip.registerParent($(class_selector), null);
  },

  registerParent: function ($parent, childSelector) {
    if (Tooltip.flyout().length === 0) {
      var flyout = $(Tooltip.flyoutHtml);
      $('body').append(flyout);
    }

    if ($.type($parent) === 'string') {
      $parent = $($parent);
    }

    var tooltip = Tooltip.flyout();
    tooltip.on('mouseleave', Tooltip.hideTooltip);
    $parent.on(
      'mouseenter',
      childSelector,
      _.debounce(Tooltip.showTooltip, 100)
    );
    $parent.on(
      'mouseleave',
      childSelector,
      _.debounce(function () {
        if (!tooltip.is(':hover')) {
          Tooltip.hideTooltip();
        }
      }, 100)
    );
  },

  // initialize all tooltips on the page
  init: function () {
    Tooltip.registerClass('.tooltip-icon');
  },

  showTooltip: function () {
    var subject = $(this);
    var key = subject.attr('key') || subject.data('key');
    var description = subject.data('description');
    var imageSrc = subject.data('image-src');
    var message = description || Message.Tooltip[key];

    if (imageSrc) {
      Tooltip.flyout().addClass('image-tooltip');
      message = $('<img/>').attr({
        src: imageSrc,
        width: subject.data('image-width'),
        height: subject.data('image-height'),
      });
    }

    Tooltip.setText(message);

    var tooltip = Tooltip.flyout();
    var tooltipIconOffset = subject.offset();

    tooltip.removeClass('right-side left-side bottom');
    if (
      subject.attr('tooltip-side') === 'right' ||
      subject.data('tooltip-side') === 'right'
    ) {
      // put the tooltip on the right
      tooltip.addClass('right-side');
      tooltip.css({
        top:
          tooltipIconOffset.top -
          tooltip.outerHeight() / 2 +
          subject.outerHeight() / 2,
        left: tooltipIconOffset.left + subject.outerWidth() + 8,
      });
    } else if (
      subject.attr('tooltip-side') === 'left' ||
      subject.data('tooltip-side') === 'left'
    ) {
      // put the tooltip on the right
      tooltip.addClass('left-side');
      tooltip.css({
        top: tooltipIconOffset.top - tooltip.outerHeight() / 2 + 8,
        left: tooltipIconOffset.left - tooltip.outerWidth() - 9,
      });
    } else if (
      subject.attr('tooltip-side') === 'bottom' ||
      subject.data('tooltip-side') === 'bottom'
    ) {
      tooltip.addClass('bottom');
      tooltip.css({
        top: tooltipIconOffset.top + tooltip.outerHeight() + 10,
        left:
          tooltipIconOffset.left -
          tooltip.outerWidth() / 2 +
          subject.outerWidth() / 2,
      });
    } else {
      // by default put the tooltip on top
      tooltip.css({
        top: tooltipIconOffset.top - tooltip.outerHeight() - 17,
        left:
          tooltipIconOffset.left -
          tooltip.outerWidth() / 2 +
          subject.outerWidth() / 2,
      });
    }

    if (subject.data('tooltip-color') === 'grey') {
      tooltip.addClass('grey');
    }

    tooltip.show();
  },

  hideTooltip: function () {
    Tooltip.flyout().hide();
    Tooltip.flyout().prop('class', 'tooltip-flyout');
  },
};
var ENTER_KEY_CODE = 13;

var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
var is_safari = navigator.userAgent.indexOf('Safari') > -1 && !is_chrome;
// Helper to render a feedback rating icon w/text
Handlebars.registerHelper('feedback_rating', function (rating) {
  var klass = [
      'two-thumbs-down',
      'thumbs-down',
      'thumbs-up',
      'two-thumbs-up',
      'mixed-rating',
      'no-decision',
    ],
    desc = [
      'Definitely Not',
      'No',
      'Yes',
      'Strong Yes',
      'Mixed',
      'No Decision',
    ];

  rating = rating || 6;

  var result =
    '<span class="' +
    klass[rating - 1] +
    ' rating-icon rating-with-name selected" \
                include_name="true" rating="' +
    rating +
    '">' +
    desc[rating - 1] +
    '</span>';

  return new Handlebars.SafeString(result);
});

Handlebars.registerHelper('ifCond', function (v1, v2, options) {
  if (v1 == v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('unlessCond', function (v1, v2, options) {
  if (v1 != v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper(
  'unlessCondAnd',
  function (val1, testVal1, val2, testVal2, options) {
    if (val1 != testVal1 || val2 != testVal2) {
      return options.fn(this);
    }
    return options.inverse(this);
  }
);

Handlebars.registerHelper('render_privacy', function (questionPrivacy) {
  var textMapping = {
    standard_question: 'Standard',
    private_question: 'Private',
    api_only_question: 'API Only',
  };

  return textMapping[questionPrivacy];
});
// Array Remove - By John Resig (MIT Licensed)
Array.prototype.remove = function (from, to) {
  var rest = this.slice((to || from) + 1 || this.length);
  this.length = from < 0 ? this.length + from : from;
  return this.push.apply(this, rest);
};

Array.prototype.removeValue = function (value) {
  var index = this.indexOf(value);
  if (index > -1) {
    this.splice(index, 1);
  }
};

// Extends the Date prototype to include functions to get names of days/months
(function () {
  var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  var days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  Date.prototype.getMonthOfYear = function () {
    return months[this.getMonth()];
  };
  Date.prototype.getDayOfWeek = function () {
    return days[this.getDay()];
  };

  Date.prototype.isAfter = function (mm_dd_yyyy, delim) {
    var date_parts = mm_dd_yyyy.split(delim);
    // @jsauthors not year nor day, but month is 0-indexed?!?! #inconsistentlanguagedesign
    var other_date = new Date(date_parts[2], date_parts[0] - 1, date_parts[1]);
    return this > other_date;
  };
})();
// JQuery Extensions
$.fn.validateOn = function (
  eventType,
  validateFunc,
  afterSuccessfulValidation,
  options
) {
  $(this).on(eventType, function (event) {
    // NOTE: by calling the validation function this way, we're ensuring "this" inside the function
    // is the same as "this" outside the function, i.e. it references the form being validated.
    var results = validateFunc.call(this, event);

    // supports a return value of either a Validator, or an array of validations
    var valid =
      typeof results.isValid === 'function'
        ? results.isValid()
        : Validate.isValid(results);

    if (!valid) {
      if (options === undefined || options.scroll !== false) {
        Validate.scrollToFirstError();
      }
      return false;
    }

    // if defined, call the afterValidation callback
    if (afterSuccessfulValidation) {
      return afterSuccessfulValidation.call(this, event);
    }
  });
};

(function () {
  'use strict';

  /**
   * hack hack hack hack hack
   *
   * workaround for jquery bug http://bugs.jquery.com/ticket/8362
   */
  var origOffset = $.fn.offset;

  $.fn.offset = function () {
    if ($.fn.hasClass.call(this, 'gh-jquery-override-offset')) {
      return { top: this[0].offsetTop, left: this[0].offsetLeft };
    }

    return origOffset.apply(this, arguments);
  };
})();

$.fn.hasAncestor = function (selector) {
  return this.closest(selector).length > 0;
};

$.clickOutside = function (selector, callback) {
  $(document).click(function (e) {
    if (!$(e.target).hasAncestor(selector)) {
      return callback(e);
    }
  });
};

$.isSameClick = function (event1, event2) {
  return (
    event1 &&
    event2 &&
    event1.pageX === event2.pageX &&
    event1.pageY === event2.pageY
  );
};

$.fn.offOn = function (event, listener) {
  this.off(event).on(event, listener);
};

/**
 * @return {jQuery object} Copy of elem with "id" attributes removed
 */
$.cloneSansIds = function (elem) {
  var copy = $(elem).clone(true);
  copy.find('[id]').removeAttr('id');
  copy.removeAttr('id');
  return copy;
};

// jQuery has a `wrap` method, but this interface is more obvious
$.wrapWithTag = function (elem, wrapperTagName) {
  var wrapper = $(document.createElement(wrapperTagName));
  elem.before(wrapper);
  $(elem).detach();
  wrapper.append(elem);
  return wrapper;
};

(function () {
  var usageCount = 0;

  // The callback will be executed at most once.
  // If the element is already visible in the window, the callback will be executed immediately.
  $.fn.whenScrolledTo = function (callback) {
    var $element = $(this),
      callbackExecuted = false,
      scrollEvent = 'scroll.ghWhenScrolledTo_' + usageCount;

    usageCount += 1;

    executeIfOnScreen();

    if (!callbackExecuted) {
      $(window).on(scrollEvent, _.throttle(executeIfOnScreen, 200));
    }

    function executeIfOnScreen() {
      if (callbackExecuted) {
        return;
      }

      var elementTop = $element.offset().top,
        windowHeight = $(window).height(),
        windowScroll = $(this).scrollTop();

      if (windowScroll > elementTop - windowHeight) {
        callback();

        callbackExecuted = true;
        $(window).off(scrollEvent);
      }
    }
  };
})();
/* global documentReady */

/*
 *  Library function which ensures init methods are called after
 *  documentReady when using the module pattern.
 */
function lib(module) {
  documentReady(function () {
    if (module.init) {
      module.init();
    }
  });

  return module;
};
/* global Greenhouse */

// Methods for adding flash notices and errors to the page. All add methods accept either
// a string or an array of strings.
var Flash = {
  remove: function (selector) {
    var el = 'div';

    if (selector) {
      el += selector;
    }

    $('#flash_wrapper').find(el).remove();
  },

  fadeOut: function () {
    $('#flash_wrapper')
      .find('div')
      .fadeOut(250, function () {
        $(this).remove();
      });
  },

  fadeOutAfterDelay: function () {
    $('#flash_wrapper')
      .find('div')
      .each(function (i, div) {
        $(div)
          .delay(8000)
          .fadeOut(250, function () {
            $(this).remove();
          });
      });
  },

  fadeIn: function () {
    $('#flash_wrapper').find('div').fadeIn(500);
  },

  setNotice: function (object) {
    Flash.set(object, 'notice', true);
  },

  setError: function (object) {
    Flash.set(object, 'error', true);
  },

  setDefaultError: function () {
    Flash.set(Greenhouse.Translation.t('flash.error'), 'error', true);
  },

  setPending: function (object, fade) {
    Flash.set(object, 'pending', !!fade);
  },

  setDefaultPending: function () {
    Flash.set(Greenhouse.Translation.t('flash.saving'), 'pending');
  },

  set: function (object, type, fadeOut) {
    Flash.remove();
    if (object instanceof Array) {
      $.each(object, function (i, message) {
        addSingleFlash(message);
      });
    } else {
      addSingleFlash(object);
    }

    if (fadeOut) {
      Flash.fadeOutAfterDelay();
    }

    function addSingleFlash(message) {
      var flash = $('<div/>');
      flash.addClass('flash-' + type);
      flash.text(message);
      flash.hide();

      $('#flash_wrapper').append(flash);
      flash.fadeIn(250);
    }
  },
};
var Tables = Tables || {};

Tables.HoverColumn = (function () {
  /**
   * @return {jQuery} td elements in the column above and including the target of the event
   */
  function hoveredColumn(mouseEvent) {
    var td = $(mouseEvent.target).closest('td'),
      column = Tables.tdColumn(td);

    return column.slice(0, column.index(td));
  }

  function highlightOnHover(selector) {
    $(selector)
      .mouseover(function (e) {
        hoveredColumn(e).addClass('hovered-column');
      })
      .mouseleave(function (e) {
        hoveredColumn(e).removeClass('hovered-column');
      });
  }

  return {
    hoveredColumn: hoveredColumn,
    highlightOnHover: highlightOnHover,
  };
})();
var Tables = Tables || {};

/**
 * @return {jQuery object} All td elements in the same column as the given one
 */
Tables.tdColumn = function (tdElem) {
  var td = $(tdElem),
    column = td.index() + 1;

  return td.closest('table').find('td:nth-child(' + column + ')');
};

/**
 * @return {jQuery object} The next cell in the row, or the first cell in the next row.
 *                         No distinction is made between <td> and <th>
 */
Tables.nextCell = function ($td) {
  if (!$td.length) {
    return;
  }

  var tagName = $td.get(0).tagName,
    $next = $td.next(tagName);

  if (!$next.length) {
    $next = $td
      .parent()
      .next('tr')
      .find(tagName + ':first-child');
  }

  return $next.length ? $next : false;
};

var TimeZones = TimeZones || {};

// jstz uses the browser's international api if it's available - but that API returns
// names our server doesn't know about, such as "America/Toronto".
TimeZones.detect = function () {
  function withoutInternationalAPI(callback) {
    var oldInternationalApi = window.Intl;
    window.Intl = undefined;

    var value = callback();

    window.Intl = oldInternationalApi;

    return value;
  }

  return withoutInternationalAPI(function () {
    return jstz.determine().name();
  });
};
var UI = UI || {};

UI.Datepicker = {
  init: function (selector, options) {
    var datepicker = $(selector);
    datepicker.datepicker(
      $.extend(options, {
        dateFormat: Config.TimeZone.dateFormat('datepicker'),
      })
    );
    datepicker.datepicker('setDate', datepicker.val());
    $('#ui-datepicker-div').addClass('datepicker');
  },
};
var UI = UI || {};

(function () {
  /**
   * Manages tab-based navigation for a given page.  To use it, the page needs:
   *
   *   * A place on the page that holds the tab handles, used for navigation. This must be structured like:
   *
   *     <div class='gh-tabs'>
   *       <div class='tabs-nav'>
   *         <ul>
   *           <li>
   *             <a href='#tab1' data-tab-path='/path/to/tab1/contents'>Tab 1</a>
   *           </li>
   *           <li>
   *             <a href='#tab2' data-tab-path='/path/to/tab2/contents'>Tab 2</a>
   *           </li>
   *         </ul>
   *       </div>
   *     </div>
   *
   *   * A place on the page where the actual tab content will be shown.  Note that each tab has its own
   *     separate div!  The div's ID corresponds to the anchor for each tag.  Example:
   *
   *   <div id="tab1_tab"></div>
   *   <div id="tab2_tab"></div>
   *
   *   * To initialize:
   *
   *      var tabs = new UI.Tabs('.gh-tabs');
   *      tabs.init();
   */
  UI.Tabs = function (selector) {
    var $tabNavigation,
      tabs = {};

    function init() {
      $tabNavigation = $(selector);
      $tabNavigation.find('.tabs-nav li').each(function (i, li) {
        var $link = $(li).find('a'),
          tabId = $link.attr('href').split('#')[1];

        tabs[tabId] = new Tab(tabId, $link);
      });

      var defaultTab = tabFromAnchor() || currentlySelectedTab();
      showTab(defaultTab);

      $(window).bind('hashchange', function () {
        showTab(tabFromAnchor());
      });
    }

    function deselectAllTabs() {
      _(tabs).each(function (tab) {
        tab.hide();
      });
    }

    function showTab(tab) {
      if (tab) {
        deselectAllTabs();
        tab.show();
        return true;
      }
    }

    function tabFromAnchor() {
      var tabId = window.location.hash.slice(1);

      if (tabId.length > 1) {
        // Remove the leading forward slash added to the anchor by angular JS
        tabId = tabId.replace('/', '');

        return tabs[tabId];
      }

      return null;
    }

    // Returns the tab that is currently selected in the GUI nav, i.e. has the
    // "selected" class. The tab contents aren't necessarily visible, though.
    function currentlySelectedTab() {
      return _(tabs).find(function (tab) {
        return tab.isSelected();
      });
    }

    return {
      init: init,
    };
  };

  /**
   * Represents a single tab on the page.  A tab has UI components:
   *  * The 'handle', or the little tab itself that the user clicks on to select the tab
   *  * The 'content pane', which displays the data for this tab.
   *
   * Only a single tab can be active at any given time.  Selecting a new tab implicitly deselects all of
   * the other tabs
   *
   * @param tabId Corresponds to the 'anchor' used to display this tab (e.g. 'candidate_details', 'private')
   * @param $link The link the user clicks on to select the tab
   * @constructor
   */
  function Tab(tabId, $link) {
    var $contentPane = $('#' + tabId + '_tab'),
      loaded = $link.data('loaded') || false,
      url = $link.data('tab-path');

    init();

    function init() {
      $contentPane.on('greenhouse.refresh', refresh);
    }

    function id() {
      return tabId;
    }

    function refresh() {
      loaded = false;
      if (isSelected()) {
        show();
      }
    }

    function show() {
      if (url && !loaded) {
        loadContent();
        loaded = true;
      }

      $link.parents('li').addClass('selected');
      $contentPane.show();
      $contentPane.trigger('greenhouse.tabSelected');
    }

    function hide() {
      $link.parents('li').removeClass('selected');
      $contentPane.hide();
    }

    function loadContent() {
      Ajax.get({
        url: url,
        dataType: 'html',
        disableFlash: true,
        success: onLoad,
        error: showError,
      });

      function onLoad(response) {
        $contentPane.html(response);
        $contentPane.trigger('greenhouse.loaded');
      }

      function showError() {
        $contentPane.html(Message.Error.TabContent);
      }
    }

    function isSelected() {
      return $link.parents('li').hasClass('selected');
    }

    return {
      id: id,
      show: show,
      hide: hide,
      isSelected: isSelected,
    };
  }
})();
/**
 * Button utility functions
 */
var ButtonUtil = {
  enable: function (selector) {
    $(selector).removeClass('disabled-button');
  },

  disable: function (selector) {
    $(selector).addClass('disabled-button');
  },

  isEnabled: function (selector) {
    return !ButtonUtil.isDisabled(selector);
  },

  isDisabled: function (selector) {
    return $(selector).hasClass('disabled-button');
  },

  toggle: function (selector) {
    if (ButtonUtil.isEnabled(selector)) {
      ButtonUtil.disable(selector);
    } else {
      ButtonUtil.enable(selector);
    }
  },
};
var FileUtil = {
  getFilenameFromPath: function (path) {
    return path.substr(path.lastIndexOf('\\') + 1);
  },
};
// For cases where we have href="#", we want to preventDefault so that the
// page does not scroll to the top of the page.
// This method is used in cases where we are unbinding the click event
// and we want to re-bind the behavior to preventDefault on click events.
// This is currently primarily used in the modal.js and ajax_modal.js
// This method was a necessary addition as part of the project to remove all
// references to href="javascript;" because of our Content Security Policy implementation.

var contentSecurityPolicy = {
  hrefPreventDefault: function (e) {
    e.preventDefault();
  },
};

$(document).on(
  'click',
  'a[href="#"]',
  contentSecurityPolicy.hrefPreventDefault
);
var Select2Tag = lib(
  (function () {
    function tags(selector) {
      $(selector).each(function () {
        $(this).select2({
          tags: $(this).data('tags'),
        });
      });
    }

    return {
      tags: tags,
    };
  })()
);
var StringUtil = {
  URL_REGEX: /\b((https?:\/\/|www\.)([A-Za-z0-9\-_=%&@\?\.\/#;=]+)|([a-zA-Z0-9.]+\.[a-zA-Z]{2,3}))\b/gi,

  capitalize: function (str) {
    if (typeof str === 'undefined' || str.length === 0) {
      throw new Error(
        'Invalid string ' + str + ' provided to StringUtil.capitalize'
      );
    }

    return str[0].toUpperCase() + str.slice(1, str.length);
  },

  capitalizeEachWord: function (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },

  stripLinks: function (str) {
    return str.replace(/<a\s+[^>]*>/g, '').replace(/<\/a>/g, '');
  },

  stripHtmlTags: function (str) {
    return str.replace(/(<([^>]+)>)/gi, '');
  },

  strike: function (str) {
    return '<del>' + str + '</del>';
  },

  truncate: function (str, maxlen) {
    if (str && str.length > maxlen) {
      return str.substr(0, maxlen - 3) + '...';
    }

    return str;
  },

  linkify: function (string) {
    if (string === null || string === undefined) {
      return;
    }

    return string.replace(StringUtil.URL_REGEX, function (match) {
      if (match.indexOf('http') === 0) {
        return match.replace(
          StringUtil.URL_REGEX,
          '<a href="$1" target="_blank">$1</a>'
        );
      } else {
        return match.replace(
          StringUtil.URL_REGEX,
          '<a href="http://$1" target="_blank">$1</a>'
        );
      }
    });
  },

  escapeAndLinkify: function (string) {
    if (string === null || string === undefined) {
      return;
    }

    var escapedString = _.escape(string);
    return StringUtil.linkify(escapedString);
  },

  htmlEscape: function (string) {
    return string
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/&lt;p&gt;/g, '<p>')
      .replace(/&lt;\/p&gt;/g, '</p>');
  },

  toSentence: function (array) {
    if (array.length == 0) {
      return '';
    } else if (array.length == 1) {
      return array[0];
    } else {
      var sentence = array.slice(0, array.length - 1).join(', ');
      if (array.length > 2) {
        sentence += ',';
      }
      sentence += ' and ' + array.slice(-1);
      return sentence;
    }
  },

  pluralize: function (x, unit) {
    return typeof x === 'number' ? x + ' ' + unit + (x === 1 ? '' : 's') : '';
  },

  regexEscape: function (string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  },

  toCamelCase: function (string) {
    return string.replace(/_([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
  },
};
var Url = {
  params: function () {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, ' '));
      },
      queryString = window.location.search.substring(1),
      params = {};

    while ((match = search.exec(queryString))) {
      var name = decode(match[1]),
        value = decode(match[2]);

      params[name] = value;
    }

    return params;
  },

  updateQueryStringParameter: function (uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i'),
      separator = uri.indexOf('?') !== -1 ? '&' : '?',
      hashIndex = uri.indexOf('#'),
      encodedVal = encodeURIComponent(value);

    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + encodedVal + '$2');
    } else {
      // this is to ensure if there is a hash at the end of the uri, we add it before.
      // i.e
      // We want this: http://google.com?q=hello#foo
      // NOT:          http://google.com#foo?q=hello
      if (hashIndex >= 0) {
        var beforeHashStr = uri.substring(0, hashIndex);
        var afterHashStr = uri.substring(hashIndex);

        return (
          beforeHashStr + separator + key + '=' + encodedVal + afterHashStr
        );
      }
      return uri + separator + key + '=' + encodedVal;
    }
  },
};
/**
 * Form validation functions
 */
/* global Greenhouse, Flash, Email, SocialMedia */

function someChecked($elements) {
  for (var i = 0; i < $elements.length; i++) {
    if ($($elements[i]).is(':checked')) {
      return true;
    }
  }

  return false;
}

function uniq(items) {
  return items.reduce(function (collection, item) {
    if (collection.indexOf(item) === -1) {
      return collection.concat([item]);
    }

    return collection;
  }, []);
}

var Validate = {
  ERROR_TEMPLATE: Handlebars.compile(
    '<div class="field-error-msg">{{msg}}</div>'
  ),

  alphanumeric: function (val) {
    return /^[a-zA-Z0-9]+$/.test(val);
  },

  wordCharacter: function (val) {
    return /^\w+$/.test(val);
  },

  checked: function (val) {
    return $(this.selector).is(':checked');
  },

  numeric: function (val) {
    return /^[0-9]+$/.test(val);
  },

  decimal: function (val) {
    return /^-?(([0-9]+)|(\.[0-9]+)|([0-9]+\.[0-9]+))$/.test(val);
  },

  decimalWithMaxPrecision: function (numDigits) {
    return function (val) {
      return (
        Validate.decimal(val) &&
        val.toString().replace(/[-.]/g, '').length <= numDigits
      );
    };
  },

  notEmpty: function (val) {
    return val !== null && $.trim(val).length > 0;
  },

  notBlank: function (val) {
    return $.trim(val).length > 0;
  },

  blank: function (val) {
    return $.trim(val).length === 0 || val === 'None';
  },

  // Allows either a raw email address, or one with a display name, such as: "Bob Johnson" <bob@johnson.com>
  email: function (val) {
    var emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})+$/i;

    if (emailRegex.test(val)) {
      return true;
    } else {
      var displayRegex = /^.+<(.+)>$/,
        match = displayRegex.exec(val);

      return !!(match && emailRegex.test(match[1]));
    }
  },

  multipleEmails: function (val) {
    var emails = val.split(/\s*,\s*/);
    return emails.every(Validate.email);
  },

  emailOrMyEmailAddressToken: function (val) {
    return Validate.email(val) || val === '{{MY_EMAIL_ADDRESS}}';
  },

  emailDomain: function (val) {
    return (
      val.indexOf('.') > 0 &&
      val.indexOf(' ') < 0 &&
      Validate.notEmailAddress(val)
    );
  },

  notEmailAddress: function (val) {
    return val.indexOf('@') < 0;
  },

  twitterHandle: function (val) {
    return /@([A-Za-z0-9_]+)/.test(val);
  },

  fileFormat: function (val) {
    // this needs to match the ACCEPTED_FORMATS in https://github.com/grnhse/greenhouse/blob/main/app/concepts/sourcing/bulk_imports/resume_attacher.rb
    return /\.(pdf|doc|docx|txt|rtf)$/i.test(val);
  },

  specificFileFormat: function (extension, val) {
    return function (val) {
      var extensions = extension instanceof Array ? extension : [extension];
      return new RegExp('.(' + extensions.join('|') + ')', 'i').test(val);
    };
  },

  blocklistedExtension: function (val) {
    var blocklisted = Email.blocklistedExtensions;
    return new RegExp('.(' + blocklisted.join('|') + ')$', 'i').test(val);
  },

  imageFormat: function (val) {
    return /\.(png|jpg|jpeg|gif)$/i.test(val);
  },

  url: function (val) {
    return /^(http:\/\/|https:\/\/)?[0-9a-z\-]+\.[0-9a-z\.\-]+(\/.*)?$/i.test(
      val
    );
  },

  urlWithProtocol: function (val) {
    return /https?:\/\/[0-9a-z\-]+\.[0-9a-z\.\-]+(\/.*)?$/i.test(val);
  },

  httpsUrl: function (val) {
    return /^https:\/\/[0-9a-z\-]+\.[0-9a-z\.\-]+(\/.*)?$/i.test(val);
  },

  httpsUrlPortAllowed: function (val) {
    return /^https:\/\/[0-9a-z\-]+\.[0-9a-z\.\-]+(:[0-9]+)?(\/.*)?$/i.test(val);
  },

  urlOrTwitterHandle: function (val) {
    return Validate.url(val) || Validate.twitterHandle(val);
  },

  minLength: function (minLength) {
    return function (val) {
      return typeof val === 'string' && val.length >= minLength;
    };
  },

  maxLength: function (maxLength) {
    return function (val) {
      return typeof val === 'string' && val.length <= maxLength;
    };
  },

  maxLengthUrlEncoded: function (maxLength) {
    return function (val) {
      return (
        typeof val === 'string' && encodeURIComponent(val).length <= maxLength
      );
    };
  },

  maxLengthTwitterMessage: function (maxLength) {
    return function (val) {
      return (
        typeof val === 'string' &&
        // TODO: currentTwitterMessageLength comes from app/webpack/javascripts/dashboard/social_media_url_shim.js
        window.currentTwitterMessageLength(val) <= maxLength
      );
    };
  },

  arrayMinLength: function (minLength) {
    return function (val) {
      return val !== null && val.length >= minLength;
    };
  },

  arrayMaxLength: function (maxLength) {
    return function (val) {
      return val === null || val.length <= maxLength;
    };
  },

  maxNumberOfOptions: function (maxOptions) {
    return function (val) {
      var optionsValArray = val.split(/\r|\n/);
      var arrayWithoutEmptyValues = uniq(optionsValArray).filter(Boolean);

      return arrayWithoutEmptyValues.length <= maxOptions;
    };
  },

  maxOptionCharLength: function (maxCharLength) {
    return function (val) {
      var optionsValArray = val.split(/\r|\n/);
      var maxCharLengthExceeded = optionsValArray.some(function (el) {
        return el.length > maxCharLength;
      });

      return !maxCharLengthExceeded;
    };
  },

  matches: function (match) {
    return function (val) {
      return val === match;
    };
  },

  matchesCaseInsensitive: function (match) {
    return function (val) {
      return val.toLowerCase() === match.toLowerCase();
    };
  },

  matchesRegex: function (regex) {
    return function (val) {
      return val.match(regex) !== null;
    };
  },

  doesNotMatchRegex: function (regex) {
    return function (val) {
      return val.match(regex) === null;
    };
  },

  greaterThan: function (other) {
    return function (val) {
      return parseInt(val, 10) > parseInt(other, 10);
    };
  },

  lessThan: function (other) {
    return function (val) {
      return parseInt(val, 10) < parseInt(other, 10);
    };
  },

  inRange: function (left, right) {
    return function (val) {
      return (
        parseInt(val, 10) >= parseInt(left, 10) &&
        parseInt(val, 10) <= parseInt(right, 10)
      );
    };
  },

  notPresentIn: function (array, caseInsensitive) {
    return function (val) {
      if (caseInsensitive) {
        if (array) {
          array = $.map(array, function (item, i) {
            return item.toLowerCase();
          });
        }

        if (val) {
          val = val.toLowerCase();
        }
      }

      return $.inArray(val, array) == -1;
    };
  },

  atLeastOneChecked: function (setId) {
    return someChecked($('input[required][set=' + setId + ']'));
  },

  atLeastOneCheckboxChecked: function () {
    return someChecked($(this.selector).find('input[type="checkbox"]'));
  },

  maxCheckboxesChecked: function (max, parentFilter) {
    return function () {
      var $selection = $(this.selector)
        .find(parentFilter + ' input[type="checkbox"]')
        .filter(':checked');

      return $selection.length <= max;
    };
  },

  matchAllAndReturnFirstGroup: function (regex, stringToMatch) {
    var matchingTokens = [];

    var match;
    while ((match = regex.exec(stringToMatch)) !== null) {
      matchingTokens.push(match[1]);
    }

    return matchingTokens;
  },

  // Finds all possible tokens within the given body string.
  // These tokens are not guaranteed to be valid; valid tokens must start with two open braces,
  // contain one or more word chars, and end with two close braces - e.g. "{{TOKEN}}", "{{TOKEN_VAL}}".
  // But all token candidates will either start with an open brace - "{" - AND end with a close brace - "}" -
  // with some combination of word characters or braces in between - e.g. "{{{TOKEN}", "{TOKEN}", "{{{TOKEN}}}"
  findTokenCandidates: function (body) {
    // Regex matches the optional start of the line or a non-open brace char
    var optionalPreviousCharRegex = /(?:^|[^{])?/.source;
    // Regex matches the optional end of the line or a non-close brace char
    var optionalNextCharRegex = /(?:$|[^}])?/.source;
    // Regex matches a token starting with at least one open brace, at least one close brace,
    // and some combo of word chars and braces in between - e.g. "{TOKEN}", "{{TOKEN_CHAR}}}", "{}{}{}{}"
    var openedAndClosedTokenRegex = /({[{}\w]+})/.source;

    // Regex matches a token starting and ending with braces,
    // with optional previous and next surrounding non-brace chars - e.g. "{{TOKEN}}" or " {TOKEN}," or "\{{{TOKEN}} "
    // The previous and next chars are in non-captured groups and the token is in the only captured group
    var tokenAndSurroundingCharsRegex = new RegExp(
      optionalPreviousCharRegex +
        openedAndClosedTokenRegex +
        optionalNextCharRegex,
      'g'
    );

    // Return matching tokens within the capture group, and strip surrounding chars
    return Validate.matchAllAndReturnFirstGroup(
      tokenAndSurroundingCharsRegex,
      body
    );
  },

  emailTemplateWithTokens: function (validTokens, requiredTokens) {
    return function (body) {
      // Find any correctly-formatted or malformed tokens in the email text
      var malformedTokens = [],
        invalidTokens = [],
        usedTokens = [],
        valid = true;

      var tokenCandidates = Validate.findTokenCandidates(body);
      $.each(tokenCandidates, function (i, token) {
        // Identify tokens that are malformed,
        // i.e. starting and ending with more than two curly braces
        if (!token.match(/^{{\w+}}$/)) {
          malformedTokens.push(token);
        }

        // Identify tokens that are not allowed for the given template
        if (
          !Validate.emailTemplateToken(token, validTokens)
        ) {
          invalidTokens.push(token);
        }

        if (
          requiredTokens &&
          Validate.emailTemplateToken(token, requiredTokens)
        ) {
          usedTokens.push(token);
        }
      });

      if (malformedTokens.length !== 0) {
        this.message = Greenhouse.Translation.t(
          'messages.validation.malformed_placeholders',
          { tokens: malformedTokens.join(', ') }
        );
        valid = false;
      } else if (invalidTokens.length !== 0) {
        this.message = Greenhouse.Translation.t(
          'messages.validation.invalid_placeholders',
          { tokens: invalidTokens.join(', ') }
        );
        valid = false;
      } else if (
        requiredTokens &&
        uniq(usedTokens).length !== requiredTokens.length
      ) {
        var unusedRequiredTokens = requiredTokens.filter(function (token) {
          return usedTokens.indexOf(token) === -1;
        });

        this.message = Greenhouse.Translation.t(
          'messages.validation.required_placeholders',
          { tokens: unusedRequiredTokens.join(', ') }
        );
        valid = false;
      }

      return valid;
    };
  },

  emailTemplateToken: function (val, validTokens) {
    return validTokens.indexOf(val) > -1;
  },

  passes: function (result) {
    return function () {
      return result;
    };
  },

  dateFormat: function (value) {
    if (/[0-9]{1,4}\/[0-9]{1,4}\/[0-9]{1,4}/.test(value)) {
      if (
        typeof moment === 'function' &&
        !moment(value, Config.TimeZone.dateFormat('date'), true).isValid()
      ) {
        return false;
      }

      return true;
    } else {
      return false;
    }
  },

  field: function (
    selector,
    validateFunction,
    message,
    allowEmpty,
    trim,
    setErrorToOtherSelector
  ) {
    this.selector = selector;
    this.clearError(selector);
    if (setErrorToOtherSelector) {
      this.clearError(setErrorToOtherSelector);
    }

    if (trim) {
      var trimmedValue = $.trim($(selector).val());
      $(selector).val(trimmedValue);
    }

    var value = $(selector).val();
    var condition =
      (allowEmpty === true && value === '') ||
      validateFunction.call(this, value);

    if (!condition) {
      this.setError(setErrorToOtherSelector || selector, message);
    }

    return condition;
  },

  fieldWithTrim: function (selector, validateFunction, message, allowEmpty) {
    return Validate.field(
      selector,
      validateFunction,
      message,
      allowEmpty,
      true
    );
  },

  setError: function (selector, message) {
    $(selector).addClass('field-error');

    if ($(selector).hasClass('select2')) {
      $($(selector).select2('container')).addClass('field-error');
    }

    if (message) {
      $(selector)
        .parent()
        .append(this.ERROR_TEMPLATE({ msg: message }));
    }
  },

  clearError: function (selector) {
    $(selector).removeClass('field-error');
    $(selector).siblings('.field-error-msg').remove();

    if ($(selector).hasClass('select2')) {
      $($(selector).select2('container')).removeClass('field-error');
    }
  },

  isValid: function (validations) {
    if (Array.isArray(validations)) {
      return validations.every(Boolean);
    } else {
      return !!validations;
    }
  },

  fail: function () {
    return false;
  },

  scrollToFirstError: function () {
    var $visibleModals = $('.modal-body:visible'),
      $error,
      scrollPosition;

    if ($visibleModals.length > 0) {
      $error = $visibleModals.find('.field-error:first');
    } else {
      $error = $('.field-error:first');
    }
    // When Chosen and Select2 fields are present, errors are added to hidden fields (display: none)
    // which are not rendered and do not have an offset or position
    // Act on the visible element instead
    if ($error.is('.chzn-select, .select2-offscreen, .select2-tags')) {
      $error = $error.siblings('.chzn-container, .select2-container');
    } else if ($error.is('.editor')) {
      $error = $error.siblings('.tox-tinymce');
    }

    if ($error.length === 0) {
      return;
    }

    if ($visibleModals.length > 0) {
      if ($visibleModals.hasClass('scrollable')) {
        scrollPosition =
          $error.offset().top -
          $visibleModals.offset().top +
          $visibleModals.scrollTop() -
          90;
        $visibleModals.animate({ scrollTop: scrollPosition }, 'fast');
      }
    } else {
      scrollPosition = $error.offset().top - 100;
      $('html, body').animate({ scrollTop: scrollPosition }, 'fast');
    }
  },
};

/**
 * Provides a fluid interface for describing form validation.
 */
var Validator = (function () {
  function Construct() {
    this.validations = [];
    this.resetFlags();
  }

  Construct.prototype.resetFlags = function () {
    this.allowMissingElement = false;
    this.ignoreDisabled = false;
    this.allowEmptyVal = false;
  };

  /** Set the jQuery-esque 'selector' used to discover the element to be validated */
  Construct.prototype.validate = function (selector) {
    this.selector = selector;
    return this;
  };

  /** Validation will pass if the element's value is the empty string */
  Construct.prototype.allowEmpty = function () {
    this.allowEmptyVal = true;
    return this;
  };

  /** Validation will pass if no element is found on the page that matches the selector */
  Construct.prototype.whenPresent = function () {
    this.allowMissingElement = true;
    return this;
  };

  /** Validation will pass if this element is not enabled */
  Construct.prototype.whenEnabled = function () {
    this.ignoreDisabled = true;
    return this;
  };

  /** Set the message that will be displayed if form validation fails */
  Construct.prototype.withMessage = function (message) {
    this.message = message;
    return this;
  };

  Construct.prototype.doValidate = function (validateFunction, args) {
    Validate.clearError(this.selector);

    var $elements = $(this.selector),
      value = $elements.val(),
      actualValidateFunction =
        args.length === 0
          ? validateFunction
          : validateFunction.apply(null, args),
      condition = true;

    if ($elements.length === 0) {
      if (!this.allowMissingElement) {
        Flash.setError(
          Greenhouse.Translation.t('messages.validation.form_error')
        );
        console.error(
          "No elements discovered for selector: '%s'",
          this.selector
        );
        condition = false;
      } else {
        condition = true;
      }
    } else {
      if (this.ignoreDisabled && $elements.attr('disabled') === 'disabled') {
        condition = true;
      } else {
        condition =
          (this.allowEmptyVal && $.trim(value).length === 0) ||
          actualValidateFunction.call(this, value);
      }

      if (!condition) {
        Validate.setError(this.selector, this.message);
      }
    }

    this.validations.push(condition);

    this.message = null;
    this.resetFlags();

    return condition;
  };

  var blocklist = [
    'ERROR_TEMPLATE',
    'field',
    'setError',
    'clearError',
    'isValid',
    'scrollToFirstError',
  ];

  for (var name in Validate) {
    var func = Validate[name];

    if (typeof func === 'function' && $.inArray(name, blocklist) === -1) {
      (function (name, func) {
        Construct.prototype[name] = function () {
          return this.doValidate(func, arguments);
        };
      })(name, func);
    }
  }

  Construct.prototype.isValid = function () {
    if (Array.isArray(this.validations)) {
      return this.validations.every(Boolean);
    } else {
      return !!this.validations;
    }
  };

  return Construct;
})();
var Links = lib(
  (function () {
    var maxLen = 26;

    var types = [
      {
        name: 'YouTube',
        class: 'youtube',
        matcher: /youtube/,
        sortOrder: 4,
        display: removeProtocol,
      },
      {
        name: 'LinkedIn',
        class: 'linkedin',
        matcher: /linkedin/,
        sortOrder: 1,
        display: removeProtocol,
      },
      {
        name: 'Facebook',
        class: 'facebook',
        matcher: /facebook/,
        sortOrder: 3,
        display: removeProtocol,
      },
      {
        name: 'Twitter',
        class: 'twitter',
        matcher: /twitter/,
        sortOrder: 2,
        display: removeProtocol,
      },
      {
        name: 'Twitter',
        class: 'twitter',
        matcher: /^@/,
        sortOrder: 2,
        linkNormalizer: function (url) {
          return url.replace(/@/, 'https://twitter.com/');
        },
        display: function (url) {
          return url;
        },
      },
      {
        name: 'Entelo',
        class: 'entelo',
        matcher: /entelo/,
        sortOrder: 5,
        display: removeProtocol,
      },
      {
        name: 'Website',
        class: 'website',
        matcher: /./,
        sortOrder: 6,
        display: removeProtocol,
      },
    ];

    var websiteType = _(types).find(function (type) {
        return type.name === 'Website';
      }),
      enteloType = _(types).find(function (type) {
        return type.name === 'Entelo';
      });

    function defaultTemplate() {
      return Handlebars.compile(
        Util.convertLtGtSymsToChar($('#links_default_template').html())
      );
    }

    function addWebsiteLinks(urlsWithType, customTemplate) {
      var template = customTemplate || defaultTemplate();

      $.each(urlsWithType, function (i, urlWithType) {
        var url = urlsWithType[i].url;
        var type = urlsWithType[i].type;

        var link = expandUrl(url, type);
        $('#social_links').append(template(link));
      });

      function expandUrl(url, type) {
        var display,
          iconType = websiteType;
        if (type === 'Other') {
          display = url;

          // Don't display slashes
          var slashPos = url.indexOf('//');
          if (slashPos !== -1) {
            display = display.substr(slashPos + 2);
          }
        } else {
          display = type;
        }

        if (url.indexOf('entelo.com') >= 0) {
          iconType = enteloType;
        }

        return {
          icon: iconType.icon,
          class: iconType.class,
          link: normalize(url),
          display_text: Util.truncate(display, maxLen),
          sortOrder: type.sortOrder,
        };
      }
    }

    function createSocialLinks(urls, customTemplate) {
      var template = customTemplate || defaultTemplate(),
        links = $.map(urls, expandUrl),
        templatedLinks = [];

      $.each(_.sortBy(links, comparator), function (i, link) {
        templatedLinks.push(template(link));
      });

      return templatedLinks;

      function comparator(link) {
        return link.sortOrder;
      }

      function expandUrl(url) {
        var type = _(types).find(function (type) {
          return type.matcher.test(url);
        });

        return {
          icon: type.icon,
          class: type.class,
          link: type.linkNormalizer ? type.linkNormalizer(url) : normalize(url),
          display_text: Util.truncate(type.display(url), maxLen),
          sortOrder: type.sortOrder,
        };
      }
    }

    function addSocialLinks(urls, customTemplate) {
      var templatedLinks = createSocialLinks(urls, customTemplate);

      $.each(templatedLinks, function (i, link) {
        $('#social_links').append(link);
      });
    }

    function normalize(link) {
      return link.indexOf('http') != -1 ? link : 'http://' + link;
    }

    function removeProtocol(url) {
      return url.replace(/^https?:\/\//, '');
    }

    return {
      addWebsiteLinks: addWebsiteLinks,
      addSocialLinks: addSocialLinks,
      normalize: normalize,
    };
  })()
);
/*! jQuery UI - v1.13.2 - 2022-09-16
* http://jqueryui.com
* Includes: widget.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

( function( factory ) {
  "use strict";

  if ( typeof define === "function" && define.amd ) {

    // AMD. Register as an anonymous module.
    define( [ "jquery" ], factory );
  } else {

    // Browser globals
    factory( jQuery );
  }
} )( function( $ ) {
  "use strict";

  $.ui = $.ui || {};

  var version = $.ui.version = "1.13.2";


  /*!
   * jQuery UI Widget 1.13.2
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/


  var widgetUuid = 0;
  var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
  var widgetSlice = Array.prototype.slice;

  $.cleanData = ( function( orig ) {
    return function( elems ) {
      var events, elem, i;
      for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {

        // Only trigger remove when necessary to save time
        events = $._data( elem, "events" );
        if ( events && events.remove ) {
          $( elem ).triggerHandler( "remove" );
        }
      }
      orig( elems );
    };
  } )( $.cleanData );

  $.widget = function( name, base, prototype ) {
    var existingConstructor, constructor, basePrototype;

    // ProxiedPrototype allows the provided prototype to remain unmodified
    // so that it can be used as a mixin for multiple widgets (#8876)
    var proxiedPrototype = {};

    var namespace = name.split( "." )[ 0 ];
    name = name.split( "." )[ 1 ];
    var fullName = namespace + "-" + name;

    if ( !prototype ) {
      prototype = base;
      base = $.Widget;
    }

    if ( Array.isArray( prototype ) ) {
      prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
    }

    // Create selector for plugin
    $.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
      return !!$.data( elem, fullName );
    };

    $[ namespace ] = $[ namespace ] || {};
    existingConstructor = $[ namespace ][ name ];
    constructor = $[ namespace ][ name ] = function( options, element ) {

      // Allow instantiation without "new" keyword
      if ( !this || !this._createWidget ) {
        return new constructor( options, element );
      }

      // Allow instantiation without initializing for simple inheritance
      // must use "new" keyword (the code above always passes args)
      if ( arguments.length ) {
        this._createWidget( options, element );
      }
    };

    // Extend with the existing constructor to carry over any static properties
    $.extend( constructor, existingConstructor, {
      version: prototype.version,

      // Copy the object used to create the prototype in case we need to
      // redefine the widget later
      _proto: $.extend( {}, prototype ),

      // Track widgets that inherit from this widget in case this widget is
      // redefined after a widget inherits from it
      _childConstructors: []
    } );

    basePrototype = new base();

    // We need to make the options hash a property directly on the new instance
    // otherwise we'll modify the options hash on the prototype that we're
    // inheriting from
    basePrototype.options = $.widget.extend( {}, basePrototype.options );
    $.each( prototype, function( prop, value ) {
      if ( typeof value !== "function" ) {
        proxiedPrototype[ prop ] = value;
        return;
      }
      proxiedPrototype[ prop ] = ( function() {
        function _super() {
          return base.prototype[ prop ].apply( this, arguments );
        }

        function _superApply( args ) {
          return base.prototype[ prop ].apply( this, args );
        }

        return function() {
          var __super = this._super;
          var __superApply = this._superApply;
          var returnValue;

          this._super = _super;
          this._superApply = _superApply;

          returnValue = value.apply( this, arguments );

          this._super = __super;
          this._superApply = __superApply;

          return returnValue;
        };
      } )();
    } );
    constructor.prototype = $.widget.extend( basePrototype, {

      // TODO: remove support for widgetEventPrefix
      // always use the name + a colon as the prefix, e.g., draggable:start
      // don't prefix for widgets that aren't DOM-based
      widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
    }, proxiedPrototype, {
      constructor: constructor,
      namespace: namespace,
      widgetName: name,
      widgetFullName: fullName
    } );

    // If this widget is being redefined then we need to find all widgets that
    // are inheriting from it and redefine all of them so that they inherit from
    // the new version of this widget. We're essentially trying to replace one
    // level in the prototype chain.
    if ( existingConstructor ) {
      $.each( existingConstructor._childConstructors, function( i, child ) {
        var childPrototype = child.prototype;

        // Redefine the child widget using the same prototype that was
        // originally used, but inherit from the new version of the base
        $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
          child._proto );
      } );

      // Remove the list of existing child constructors from the old constructor
      // so the old child constructors can be garbage collected
      delete existingConstructor._childConstructors;
    } else {
      base._childConstructors.push( constructor );
    }

    $.widget.bridge( name, constructor );

    return constructor;
  };

  $.widget.extend = function( target ) {
    var input = widgetSlice.call( arguments, 1 );
    var inputIndex = 0;
    var inputLength = input.length;
    var key;
    var value;

    for ( ; inputIndex < inputLength; inputIndex++ ) {
      for ( key in input[ inputIndex ] ) {
        value = input[ inputIndex ][ key ];
        if ( widgetHasOwnProperty.call( input[ inputIndex ], key ) && value !== undefined ) {

          // Clone objects
          if ( $.isPlainObject( value ) ) {
            target[ key ] = $.isPlainObject( target[ key ] ) ?
              $.widget.extend( {}, target[ key ], value ) :

              // Don't extend strings, arrays, etc. with objects
              $.widget.extend( {}, value );

            // Copy everything else by reference
          } else {
            target[ key ] = value;
          }
        }
      }
    }
    return target;
  };

  $.widget.bridge = function( name, object ) {
    var fullName = object.prototype.widgetFullName || name;
    $.fn[ name ] = function( options ) {
      var isMethodCall = typeof options === "string";
      var args = widgetSlice.call( arguments, 1 );
      var returnValue = this;

      if ( isMethodCall ) {

        // If this is an empty collection, we need to have the instance method
        // return undefined instead of the jQuery instance
        if ( !this.length && options === "instance" ) {
          returnValue = undefined;
        } else {
          this.each( function() {
            var methodValue;
            var instance = $.data( this, fullName );

            if ( options === "instance" ) {
              returnValue = instance;
              return false;
            }

            if ( !instance ) {
              return $.error( "cannot call methods on " + name +
                " prior to initialization; " +
                "attempted to call method '" + options + "'" );
            }

            if ( typeof instance[ options ] !== "function" ||
              options.charAt( 0 ) === "_" ) {
              return $.error( "no such method '" + options + "' for " + name +
                " widget instance" );
            }

            methodValue = instance[ options ].apply( instance, args );

            if ( methodValue !== instance && methodValue !== undefined ) {
              returnValue = methodValue && methodValue.jquery ?
                returnValue.pushStack( methodValue.get() ) :
                methodValue;
              return false;
            }
          } );
        }
      } else {

        // Allow multiple hashes to be passed on init
        if ( args.length ) {
          options = $.widget.extend.apply( null, [ options ].concat( args ) );
        }

        this.each( function() {
          var instance = $.data( this, fullName );
          if ( instance ) {
            instance.option( options || {} );
            if ( instance._init ) {
              instance._init();
            }
          } else {
            $.data( this, fullName, new object( options, this ) );
          }
        } );
      }

      return returnValue;
    };
  };

  $.Widget = function( /* options, element */ ) {};
  $.Widget._childConstructors = [];

  $.Widget.prototype = {
    widgetName: "widget",
    widgetEventPrefix: "",
    defaultElement: "<div>",

    options: {
      classes: {},
      disabled: false,

      // Callbacks
      create: null
    },

    _createWidget: function( options, element ) {
      element = $( element || this.defaultElement || this )[ 0 ];
      this.element = $( element );
      this.uuid = widgetUuid++;
      this.eventNamespace = "." + this.widgetName + this.uuid;

      this.bindings = $();
      this.hoverable = $();
      this.focusable = $();
      this.classesElementLookup = {};

      if ( element !== this ) {
        $.data( element, this.widgetFullName, this );
        this._on( true, this.element, {
          remove: function( event ) {
            if ( event.target === element ) {
              this.destroy();
            }
          }
        } );
        this.document = $( element.style ?

          // Element within the document
          element.ownerDocument :

          // Element is window or document
          element.document || element );
        this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
      }

      this.options = $.widget.extend( {},
        this.options,
        this._getCreateOptions(),
        options );

      this._create();

      if ( this.options.disabled ) {
        this._setOptionDisabled( this.options.disabled );
      }

      this._trigger( "create", null, this._getCreateEventData() );
      this._init();
    },

    _getCreateOptions: function() {
      return {};
    },

    _getCreateEventData: $.noop,

    _create: $.noop,

    _init: $.noop,

    destroy: function() {
      var that = this;

      this._destroy();
      $.each( this.classesElementLookup, function( key, value ) {
        that._removeClass( value, key );
      } );

      // We can probably remove the unbind calls in 2.0
      // all event bindings should go through this._on()
      this.element
        .off( this.eventNamespace )
        .removeData( this.widgetFullName );
      this.widget()
        .off( this.eventNamespace )
        .removeAttr( "aria-disabled" );

      // Clean up events and states
      this.bindings.off( this.eventNamespace );
    },

    _destroy: $.noop,

    widget: function() {
      return this.element;
    },

    option: function( key, value ) {
      var options = key;
      var parts;
      var curOption;
      var i;

      if ( arguments.length === 0 ) {

        // Don't return a reference to the internal hash
        return $.widget.extend( {}, this.options );
      }

      if ( typeof key === "string" ) {

        // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
        options = {};
        parts = key.split( "." );
        key = parts.shift();
        if ( parts.length ) {
          curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
          for ( i = 0; i < parts.length - 1; i++ ) {
            curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
            curOption = curOption[ parts[ i ] ];
          }
          key = parts.pop();
          if ( arguments.length === 1 ) {
            return curOption[ key ] === undefined ? null : curOption[ key ];
          }
          curOption[ key ] = value;
        } else {
          if ( arguments.length === 1 ) {
            return this.options[ key ] === undefined ? null : this.options[ key ];
          }
          options[ key ] = value;
        }
      }

      this._setOptions( options );

      return this;
    },

    _setOptions: function( options ) {
      var key;

      for ( key in options ) {
        this._setOption( key, options[ key ] );
      }

      return this;
    },

    _setOption: function( key, value ) {
      if ( key === "classes" ) {
        this._setOptionClasses( value );
      }

      this.options[ key ] = value;

      if ( key === "disabled" ) {
        this._setOptionDisabled( value );
      }

      return this;
    },

    _setOptionClasses: function( value ) {
      var classKey, elements, currentElements;

      for ( classKey in value ) {
        currentElements = this.classesElementLookup[ classKey ];
        if ( value[ classKey ] === this.options.classes[ classKey ] ||
          !currentElements ||
          !currentElements.length ) {
          continue;
        }

        // We are doing this to create a new jQuery object because the _removeClass() call
        // on the next line is going to destroy the reference to the current elements being
        // tracked. We need to save a copy of this collection so that we can add the new classes
        // below.
        elements = $( currentElements.get() );
        this._removeClass( currentElements, classKey );

        // We don't use _addClass() here, because that uses this.options.classes
        // for generating the string of classes. We want to use the value passed in from
        // _setOption(), this is the new value of the classes option which was passed to
        // _setOption(). We pass this value directly to _classes().
        elements.addClass( this._classes( {
          element: elements,
          keys: classKey,
          classes: value,
          add: true
        } ) );
      }
    },

    _setOptionDisabled: function( value ) {
      this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

      // If the widget is becoming disabled, then nothing is interactive
      if ( value ) {
        this._removeClass( this.hoverable, null, "ui-state-hover" );
        this._removeClass( this.focusable, null, "ui-state-focus" );
      }
    },

    enable: function() {
      return this._setOptions( { disabled: false } );
    },

    disable: function() {
      return this._setOptions( { disabled: true } );
    },

    _classes: function( options ) {
      var full = [];
      var that = this;

      options = $.extend( {
        element: this.element,
        classes: this.options.classes || {}
      }, options );

      function bindRemoveEvent() {
        var nodesToBind = [];

        options.element.each( function( _, element ) {
          var isTracked = $.map( that.classesElementLookup, function( elements ) {
            return elements;
          } )
            .some( function( elements ) {
              return elements.is( element );
            } );

          if ( !isTracked ) {
            nodesToBind.push( element );
          }
        } );

        that._on( $( nodesToBind ), {
          remove: "_untrackClassesElement"
        } );
      }

      function processClassString( classes, checkOption ) {
        var current, i;
        for ( i = 0; i < classes.length; i++ ) {
          current = that.classesElementLookup[ classes[ i ] ] || $();
          if ( options.add ) {
            bindRemoveEvent();
            current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
          } else {
            current = $( current.not( options.element ).get() );
          }
          that.classesElementLookup[ classes[ i ] ] = current;
          full.push( classes[ i ] );
          if ( checkOption && options.classes[ classes[ i ] ] ) {
            full.push( options.classes[ classes[ i ] ] );
          }
        }
      }

      if ( options.keys ) {
        processClassString( options.keys.match( /\S+/g ) || [], true );
      }
      if ( options.extra ) {
        processClassString( options.extra.match( /\S+/g ) || [] );
      }

      return full.join( " " );
    },

    _untrackClassesElement: function( event ) {
      var that = this;
      $.each( that.classesElementLookup, function( key, value ) {
        if ( $.inArray( event.target, value ) !== -1 ) {
          that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
        }
      } );

      this._off( $( event.target ) );
    },

    _removeClass: function( element, keys, extra ) {
      return this._toggleClass( element, keys, extra, false );
    },

    _addClass: function( element, keys, extra ) {
      return this._toggleClass( element, keys, extra, true );
    },

    _toggleClass: function( element, keys, extra, add ) {
      add = ( typeof add === "boolean" ) ? add : extra;
      var shift = ( typeof element === "string" || element === null ),
        options = {
          extra: shift ? keys : extra,
          keys: shift ? element : keys,
          element: shift ? this.element : element,
          add: add
        };
      options.element.toggleClass( this._classes( options ), add );
      return this;
    },

    _on: function( suppressDisabledCheck, element, handlers ) {
      var delegateElement;
      var instance = this;

      // No suppressDisabledCheck flag, shuffle arguments
      if ( typeof suppressDisabledCheck !== "boolean" ) {
        handlers = element;
        element = suppressDisabledCheck;
        suppressDisabledCheck = false;
      }

      // No element argument, shuffle and use this.element
      if ( !handlers ) {
        handlers = element;
        element = this.element;
        delegateElement = this.widget();
      } else {
        element = delegateElement = $( element );
        this.bindings = this.bindings.add( element );
      }

      $.each( handlers, function( event, handler ) {
        function handlerProxy() {

          // Allow widgets to customize the disabled handling
          // - disabled as an array instead of boolean
          // - disabled class as method for disabling individual parts
          if ( !suppressDisabledCheck &&
            ( instance.options.disabled === true ||
              $( this ).hasClass( "ui-state-disabled" ) ) ) {
            return;
          }
          return ( typeof handler === "string" ? instance[ handler ] : handler )
            .apply( instance, arguments );
        }

        // Copy the guid so direct unbinding works
        if ( typeof handler !== "string" ) {
          handlerProxy.guid = handler.guid =
            handler.guid || handlerProxy.guid || $.guid++;
        }

        var match = event.match( /^([\w:-]*)\s*(.*)$/ );
        var eventName = match[ 1 ] + instance.eventNamespace;
        var selector = match[ 2 ];

        if ( selector ) {
          delegateElement.on( eventName, selector, handlerProxy );
        } else {
          element.on( eventName, handlerProxy );
        }
      } );
    },

    _off: function( element, eventName ) {
      eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
        this.eventNamespace;
      element.off( eventName );

      // Clear the stack to avoid memory leaks (#10056)
      this.bindings = $( this.bindings.not( element ).get() );
      this.focusable = $( this.focusable.not( element ).get() );
      this.hoverable = $( this.hoverable.not( element ).get() );
    },

    _delay: function( handler, delay ) {
      function handlerProxy() {
        return ( typeof handler === "string" ? instance[ handler ] : handler )
          .apply( instance, arguments );
      }
      var instance = this;
      return setTimeout( handlerProxy, delay || 0 );
    },

    _hoverable: function( element ) {
      this.hoverable = this.hoverable.add( element );
      this._on( element, {
        mouseenter: function( event ) {
          this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
        },
        mouseleave: function( event ) {
          this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
        }
      } );
    },

    _focusable: function( element ) {
      this.focusable = this.focusable.add( element );
      this._on( element, {
        focusin: function( event ) {
          this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
        },
        focusout: function( event ) {
          this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
        }
      } );
    },

    _trigger: function( type, event, data ) {
      var prop, orig;
      var callback = this.options[ type ];

      data = data || {};
      event = $.Event( event );
      event.type = ( type === this.widgetEventPrefix ?
        type :
        this.widgetEventPrefix + type ).toLowerCase();

      // The original event may come from any element
      // so we need to reset the target on the new event
      event.target = this.element[ 0 ];

      // Copy original event properties over to the new event
      orig = event.originalEvent;
      if ( orig ) {
        for ( prop in orig ) {
          if ( !( prop in event ) ) {
            event[ prop ] = orig[ prop ];
          }
        }
      }

      this.element.trigger( event, data );
      return !( typeof callback === "function" &&
        callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
        event.isDefaultPrevented() );
    }
  };

  $.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
    $.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
      if ( typeof options === "string" ) {
        options = { effect: options };
      }

      var hasOptions;
      var effectName = !options ?
        method :
        options === true || typeof options === "number" ?
          defaultEffect :
          options.effect || defaultEffect;

      options = options || {};
      if ( typeof options === "number" ) {
        options = { duration: options };
      } else if ( options === true ) {
        options = {};
      }

      hasOptions = !$.isEmptyObject( options );
      options.complete = callback;

      if ( options.delay ) {
        element.delay( options.delay );
      }

      if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
        element[ method ]( options );
      } else if ( effectName !== method && element[ effectName ] ) {
        element[ effectName ]( options.duration, options.easing, callback );
      } else {
        element.queue( function( next ) {
          $( this )[ method ]();
          if ( callback ) {
            callback.call( element[ 0 ] );
          }
          next();
        } );
      }
    };
  } );
});
/*
 * jQuery postMessage Transport Plugin 1.1.1
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

/* global define, window, document */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['jquery'], factory);
  } else {
    // Browser globals:
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';

  var counter = 0,
    names = [
      'accepts',
      'cache',
      'contents',
      'contentType',
      'crossDomain',
      'data',
      'dataType',
      'headers',
      'ifModified',
      'mimeType',
      'password',
      'processData',
      'timeout',
      'traditional',
      'type',
      'url',
      'username',
    ],
    convert = function (p) {
      return p;
    };

  $.ajaxSetup({
    converters: {
      'postmessage text': convert,
      'postmessage json': convert,
      'postmessage html': convert,
    },
  });

  $.ajaxTransport('postmessage', function (options) {
    if (options.postMessage && window.postMessage) {
      var iframe,
        loc = $('<a>').prop('href', options.postMessage)[0],
        target = loc.protocol + '//' + loc.host,
        xhrUpload = options.xhr().upload;
      return {
        send: function (_, completeCallback) {
          counter += 1;
          var message = {
              id: 'postmessage-transport-' + counter,
            },
            eventName = 'message.' + message.id;
          iframe = $(
            '<iframe style="display:none;" src="' +
              options.postMessage +
              '" name="' +
              message.id +
              '"></iframe>'
          )
            .bind('load', function () {
              $.each(names, function (i, name) {
                message[name] = options[name];
              });
              message.dataType = message.dataType.replace('postmessage ', '');
              $(window).bind(eventName, function (e) {
                e = e.originalEvent;
                var data = e.data,
                  ev;
                if (e.origin === target && data.id === message.id) {
                  if (data.type === 'progress') {
                    ev = document.createEvent('Event');
                    ev.initEvent(data.type, false, true);
                    $.extend(ev, data);
                    xhrUpload.dispatchEvent(ev);
                  } else {
                    completeCallback(
                      data.status,
                      data.statusText,
                      { postmessage: data.result },
                      data.headers
                    );
                    iframe.remove();
                    $(window).unbind(eventName);
                  }
                }
              });
              iframe[0].contentWindow.postMessage(message, target);
            })
            .appendTo(document.body);
        },
        abort: function () {
          if (iframe) {
            iframe.remove();
          }
        },
      };
    }
  });
});
/*
 * jQuery XDomainRequest Transport Plugin 1.1.3
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 *
 * Based on Julian Aubourg's ajaxHooks xdr.js:
 * https://github.com/jaubourg/ajaxHooks/
 */

/* global define, window, XDomainRequest */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['jquery'], factory);
  } else {
    // Browser globals:
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';
  if (window.XDomainRequest && !$.support.cors) {
    $.ajaxTransport(function (s) {
      if (s.crossDomain && s.async) {
        if (s.timeout) {
          s.xdrTimeout = s.timeout;
          delete s.timeout;
        }
        var xdr;
        return {
          send: function (headers, completeCallback) {
            var addParamChar = /\?/.test(s.url) ? '&' : '?';
            function callback(status, statusText, responses, responseHeaders) {
              xdr.onload = xdr.onerror = xdr.ontimeout = $.noop;
              xdr = null;
              completeCallback(status, statusText, responses, responseHeaders);
            }
            xdr = new XDomainRequest();
            // XDomainRequest only supports GET and POST:
            if (s.type === 'DELETE') {
              s.url = s.url + addParamChar + '_method=DELETE';
              s.type = 'POST';
            } else if (s.type === 'PUT') {
              s.url = s.url + addParamChar + '_method=PUT';
              s.type = 'POST';
            } else if (s.type === 'PATCH') {
              s.url = s.url + addParamChar + '_method=PATCH';
              s.type = 'POST';
            }
            xdr.open(s.type, s.url);
            xdr.onload = function () {
              callback(
                200,
                'OK',
                { text: xdr.responseText },
                'Content-Type: ' + xdr.contentType
              );
            };
            xdr.onerror = function () {
              callback(404, 'Not Found');
            };
            if (s.xdrTimeout) {
              xdr.ontimeout = function () {
                callback(0, 'timeout');
              };
              xdr.timeout = s.xdrTimeout;
            }
            xdr.send((s.hasContent && s.data) || null);
          },
          abort: function () {
            if (xdr) {
              xdr.onerror = $.noop();
              xdr.abort();
            }
          },
        };
      }
    });
  }
});
/*
 * jQuery Iframe Transport Plugin
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, require */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS:
    factory(require('jquery'));
  } else {
    // Browser globals:
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';

  // Helper variable to create unique names for the transport iframes:
  var counter = 0,
    jsonAPI = $,
    jsonParse = 'parseJSON';

  if ('JSON' in window && 'parse' in JSON) {
    jsonAPI = JSON;
    jsonParse = 'parse';
  }

  // The iframe transport accepts four additional options:
  // options.fileInput: a jQuery collection of file input fields
  // options.paramName: the parameter name for the file form data,
  //  overrides the name property of the file input field(s),
  //  can be a string or an array of strings.
  // options.formData: an array of objects with name and value properties,
  //  equivalent to the return data of .serializeArray(), e.g.:
  //  [{name: 'a', value: 1}, {name: 'b', value: 2}]
  // options.initialIframeSrc: the URL of the initial iframe src,
  //  by default set to "javascript:false;"
  $.ajaxTransport('iframe', function (options) {
    if (options.async) {
      // javascript:false as initial iframe src
      // prevents warning popups on HTTPS in IE6:
      // eslint-disable-next-line no-script-url
      var initialIframeSrc = options.initialIframeSrc || 'javascript:false;',
        form,
        iframe,
        addParamChar;
      return {
        send: function (_, completeCallback) {
          form = $('<form style="display:none;"></form>');
          form.attr('accept-charset', options.formAcceptCharset);
          addParamChar = /\?/.test(options.url) ? '&' : '?';
          // XDomainRequest only supports GET and POST:
          if (options.type === 'DELETE') {
            options.url = options.url + addParamChar + '_method=DELETE';
            options.type = 'POST';
          } else if (options.type === 'PUT') {
            options.url = options.url + addParamChar + '_method=PUT';
            options.type = 'POST';
          } else if (options.type === 'PATCH') {
            options.url = options.url + addParamChar + '_method=PATCH';
            options.type = 'POST';
          }
          // IE versions below IE8 cannot set the name property of
          // elements that have already been added to the DOM,
          // so we set the name along with the iframe HTML markup:
          counter += 1;
          iframe = $(
            '<iframe src="' +
              initialIframeSrc +
              '" name="iframe-transport-' +
              counter +
              '"></iframe>'
          ).on('load', function () {
            var fileInputClones,
              paramNames = $.isArray(options.paramName)
                ? options.paramName
                : [options.paramName];
            iframe.off('load').on('load', function () {
              var response;
              // Wrap in a try/catch block to catch exceptions thrown
              // when trying to access cross-domain iframe contents:
              try {
                response = iframe.contents();
                // Google Chrome and Firefox do not throw an
                // exception when calling iframe.contents() on
                // cross-domain requests, so we unify the response:
                if (!response.length || !response[0].firstChild) {
                  throw new Error();
                }
              } catch (e) {
                response = undefined;
              }
              // The complete callback returns the
              // iframe content document as response object:
              completeCallback(200, 'success', { iframe: response });
              // Fix for IE endless progress bar activity bug
              // (happens on form submits to iframe targets):
              $('<iframe src="' + initialIframeSrc + '"></iframe>').appendTo(
                form
              );
              window.setTimeout(function () {
                // Removing the form in a setTimeout call
                // allows Chrome's developer tools to display
                // the response result
                form.remove();
              }, 0);
            });
            form
              .prop('target', iframe.prop('name'))
              .prop('action', options.url)
              .prop('method', options.type);
            if (options.formData) {
              $.each(options.formData, function (index, field) {
                $('<input type="hidden"/>')
                  .prop('name', field.name)
                  .val(field.value)
                  .appendTo(form);
              });
            }
            if (
              options.fileInput &&
              options.fileInput.length &&
              options.type === 'POST'
            ) {
              fileInputClones = options.fileInput.clone();
              // Insert a clone for each file input field:
              options.fileInput.after(function (index) {
                return fileInputClones[index];
              });
              if (options.paramName) {
                options.fileInput.each(function (index) {
                  $(this).prop('name', paramNames[index] || options.paramName);
                });
              }
              // Appending the file input fields to the hidden form
              // removes them from their original location:
              form
                .append(options.fileInput)
                .prop('enctype', 'multipart/form-data')
                // enctype must be set as encoding for IE:
                .prop('encoding', 'multipart/form-data');
              // Remove the HTML5 form attribute from the input(s):
              options.fileInput.removeAttr('form');
            }
            window.setTimeout(function () {
              // Submitting the form in a setTimeout call fixes an issue with
              // Safari 13 not triggering the iframe load event after resetting
              // the load event handler, see also:
              // https://github.com/blueimp/jQuery-File-Upload/issues/3633
              form.submit();
              // Insert the file input fields at their original location
              // by replacing the clones with the originals:
              if (fileInputClones && fileInputClones.length) {
                options.fileInput.each(function (index, input) {
                  var clone = $(fileInputClones[index]);
                  // Restore the original name and form properties:
                  $(input)
                    .prop('name', clone.prop('name'))
                    .attr('form', clone.attr('form'));
                  clone.replaceWith(input);
                });
              }
            }, 0);
          });
          form.append(iframe).appendTo(document.body);
        },
        abort: function () {
          if (iframe) {
            // javascript:false as iframe src aborts the request
            // and prevents warning popups on HTTPS in IE6.
            iframe.off('load').prop('src', initialIframeSrc);
          }
          if (form) {
            form.remove();
          }
        }
      };
    }
  });

  // The iframe transport returns the iframe content document as response.
  // The following adds converters from iframe to text, json, html, xml
  // and script.
  // Please note that the Content-Type for JSON responses has to be text/plain
  // or text/html, if the browser doesn't include application/json in the
  // Accept header, else IE will show a download dialog.
  // The Content-Type for XML responses on the other hand has to be always
  // application/xml or text/xml, so IE properly parses the XML response.
  // See also
  // https://github.com/blueimp/jQuery-File-Upload/wiki/Setup#content-type-negotiation
  $.ajaxSetup({
    converters: {
      'iframe text': function (iframe) {
        return iframe && $(iframe[0].body).text();
      },
      'iframe json': function (iframe) {
        return iframe && jsonAPI[jsonParse]($(iframe[0].body).text());
      },
      'iframe html': function (iframe) {
        return iframe && $(iframe[0].body).html();
      },
      'iframe xml': function (iframe) {
        var xmlDoc = iframe && iframe[0];
        return xmlDoc && $.isXMLDoc(xmlDoc)
          ? xmlDoc
          : $.parseXML(
              (xmlDoc.XMLDocument && xmlDoc.XMLDocument.xml) ||
                $(xmlDoc.body).html()
            );
      },
      'iframe script': function (iframe) {
        return iframe && $.globalEval($(iframe[0].body).text());
      }
    }
  });
});
/*
 * jQuery File Upload Plugin
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2010, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, require */
/* eslint-disable new-cap */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['jquery', 'jquery-ui/ui/widget'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS:
    factory(require('jquery'), require('./vendor/jquery.ui.widget'));
  } else {
    // Browser globals:
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';

  // Detect file input support, based on
  // https://viljamis.com/2012/file-upload-support-on-mobile/
  $.support.fileInput = !(
    new RegExp(
      // Handle devices which give false positives for the feature detection:
      '(Android (1\\.[0156]|2\\.[01]))' +
        '|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)' +
        '|(w(eb)?OSBrowser)|(webOS)' +
        '|(Kindle/(1\\.0|2\\.[05]|3\\.0))'
    ).test(window.navigator.userAgent) ||
    // Feature detection for all other devices:
    $('<input type="file"/>').prop('disabled')
  );

  // The FileReader API is not actually used, but works as feature detection,
  // as some Safari versions (5?) support XHR file uploads via the FormData API,
  // but not non-multipart XHR file uploads.
  // window.XMLHttpRequestUpload is not available on IE10, so we check for
  // window.ProgressEvent instead to detect XHR2 file upload capability:
  $.support.xhrFileUpload = !!(window.ProgressEvent && window.FileReader);
  $.support.xhrFormDataFileUpload = !!window.FormData;

  // Detect support for Blob slicing (required for chunked uploads):
  $.support.blobSlice =
    window.Blob &&
    (Blob.prototype.slice ||
      Blob.prototype.webkitSlice ||
      Blob.prototype.mozSlice);

  /**
   * Helper function to create drag handlers for dragover/dragenter/dragleave
   *
   * @param {string} type Event type
   * @returns {Function} Drag handler
   */
  function getDragHandler(type) {
    var isDragOver = type === 'dragover';
    return function (e) {
      e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
      var dataTransfer = e.dataTransfer;
      if (
        dataTransfer &&
        $.inArray('Files', dataTransfer.types) !== -1 &&
        this._trigger(type, $.Event(type, { delegatedEvent: e })) !== false
      ) {
        e.preventDefault();
        if (isDragOver) {
          dataTransfer.dropEffect = 'copy';
        }
      }
    };
  }

  // The fileupload widget listens for change events on file input fields defined
  // via fileInput setting and paste or drop events of the given dropZone.
  // In addition to the default jQuery Widget methods, the fileupload widget
  // exposes the "add" and "send" methods, to add or directly send files using
  // the fileupload API.
  // By default, files added via file input selection, paste, drag & drop or
  // "add" method are uploaded immediately, but it is possible to override
  // the "add" callback option to queue file uploads.
  $.widget('blueimp.fileupload', {
    options: {
      // The drop target element(s), by the default the complete document.
      // Set to null to disable drag & drop support:
      dropZone: $(document),
      // The paste target element(s), by the default undefined.
      // Set to a DOM node or jQuery object to enable file pasting:
      pasteZone: undefined,
      // The file input field(s), that are listened to for change events.
      // If undefined, it is set to the file input fields inside
      // of the widget element on plugin initialization.
      // Set to null to disable the change listener.
      fileInput: undefined,
      // By default, the file input field is replaced with a clone after
      // each input field change event. This is required for iframe transport
      // queues and allows change events to be fired for the same file
      // selection, but can be disabled by setting the following option to false:
      replaceFileInput: true,
      // The parameter name for the file form data (the request argument name).
      // If undefined or empty, the name property of the file input field is
      // used, or "files[]" if the file input name property is also empty,
      // can be a string or an array of strings:
      paramName: undefined,
      // By default, each file of a selection is uploaded using an individual
      // request for XHR type uploads. Set to false to upload file
      // selections in one request each:
      singleFileUploads: true,
      // To limit the number of files uploaded with one XHR request,
      // set the following option to an integer greater than 0:
      limitMultiFileUploads: undefined,
      // The following option limits the number of files uploaded with one
      // XHR request to keep the request size under or equal to the defined
      // limit in bytes:
      limitMultiFileUploadSize: undefined,
      // Multipart file uploads add a number of bytes to each uploaded file,
      // therefore the following option adds an overhead for each file used
      // in the limitMultiFileUploadSize configuration:
      limitMultiFileUploadSizeOverhead: 512,
      // Set the following option to true to issue all file upload requests
      // in a sequential order:
      sequentialUploads: false,
      // To limit the number of concurrent uploads,
      // set the following option to an integer greater than 0:
      limitConcurrentUploads: undefined,
      // Set the following option to true to force iframe transport uploads:
      forceIframeTransport: false,
      // Set the following option to the location of a redirect url on the
      // origin server, for cross-domain iframe transport uploads:
      redirect: undefined,
      // The parameter name for the redirect url, sent as part of the form
      // data and set to 'redirect' if this option is empty:
      redirectParamName: undefined,
      // Set the following option to the location of a postMessage window,
      // to enable postMessage transport uploads:
      postMessage: undefined,
      // By default, XHR file uploads are sent as multipart/form-data.
      // The iframe transport is always using multipart/form-data.
      // Set to false to enable non-multipart XHR uploads:
      multipart: true,
      // To upload large files in smaller chunks, set the following option
      // to a preferred maximum chunk size. If set to 0, null or undefined,
      // or the browser does not support the required Blob API, files will
      // be uploaded as a whole.
      maxChunkSize: undefined,
      // When a non-multipart upload or a chunked multipart upload has been
      // aborted, this option can be used to resume the upload by setting
      // it to the size of the already uploaded bytes. This option is most
      // useful when modifying the options object inside of the "add" or
      // "send" callbacks, as the options are cloned for each file upload.
      uploadedBytes: undefined,
      // By default, failed (abort or error) file uploads are removed from the
      // global progress calculation. Set the following option to false to
      // prevent recalculating the global progress data:
      recalculateProgress: true,
      // Interval in milliseconds to calculate and trigger progress events:
      progressInterval: 100,
      // Interval in milliseconds to calculate progress bitrate:
      bitrateInterval: 500,
      // By default, uploads are started automatically when adding files:
      autoUpload: true,
      // By default, duplicate file names are expected to be handled on
      // the server-side. If this is not possible (e.g. when uploading
      // files directly to Amazon S3), the following option can be set to
      // an empty object or an object mapping existing filenames, e.g.:
      // { "image.jpg": true, "image (1).jpg": true }
      // If it is set, all files will be uploaded with unique filenames,
      // adding increasing number suffixes if necessary, e.g.:
      // "image (2).jpg"
      uniqueFilenames: undefined,

      // Error and info messages:
      messages: {
        uploadedBytes: 'Uploaded bytes exceed file size'
      },

      // Translation function, gets the message key to be translated
      // and an object with context specific data as arguments:
      i18n: function (message, context) {
        // eslint-disable-next-line no-param-reassign
        message = this.messages[message] || message.toString();
        if (context) {
          $.each(context, function (key, value) {
            // eslint-disable-next-line no-param-reassign
            message = message.replace('{' + key + '}', value);
          });
        }
        return message;
      },

      // Additional form data to be sent along with the file uploads can be set
      // using this option, which accepts an array of objects with name and
      // value properties, a function returning such an array, a FormData
      // object (for XHR file uploads), or a simple object.
      // The form of the first fileInput is given as parameter to the function:
      formData: function (form) {
        return form.serializeArray();
      },

      // The add callback is invoked as soon as files are added to the fileupload
      // widget (via file input selection, drag & drop, paste or add API call).
      // If the singleFileUploads option is enabled, this callback will be
      // called once for each file in the selection for XHR file uploads, else
      // once for each file selection.
      //
      // The upload starts when the submit method is invoked on the data parameter.
      // The data object contains a files property holding the added files
      // and allows you to override plugin options as well as define ajax settings.
      //
      // Listeners for this callback can also be bound the following way:
      // .on('fileuploadadd', func);
      //
      // data.submit() returns a Promise object and allows to attach additional
      // handlers using jQuery's Deferred callbacks:
      // data.submit().done(func).fail(func).always(func);
      add: function (e, data) {
        if (e.isDefaultPrevented()) {
          return false;
        }
        if (
          data.autoUpload ||
          (data.autoUpload !== false &&
            $(this).fileupload('option', 'autoUpload'))
        ) {
          data.process().done(function () {
            data.submit();
          });
        }
      },

      // Other callbacks:

      // Callback for the submit event of each file upload:
      // submit: function (e, data) {}, // .on('fileuploadsubmit', func);

      // Callback for the start of each file upload request:
      // send: function (e, data) {}, // .on('fileuploadsend', func);

      // Callback for successful uploads:
      // done: function (e, data) {}, // .on('fileuploaddone', func);

      // Callback for failed (abort or error) uploads:
      // fail: function (e, data) {}, // .on('fileuploadfail', func);

      // Callback for completed (success, abort or error) requests:
      // always: function (e, data) {}, // .on('fileuploadalways', func);

      // Callback for upload progress events:
      // progress: function (e, data) {}, // .on('fileuploadprogress', func);

      // Callback for global upload progress events:
      // progressall: function (e, data) {}, // .on('fileuploadprogressall', func);

      // Callback for uploads start, equivalent to the global ajaxStart event:
      // start: function (e) {}, // .on('fileuploadstart', func);

      // Callback for uploads stop, equivalent to the global ajaxStop event:
      // stop: function (e) {}, // .on('fileuploadstop', func);

      // Callback for change events of the fileInput(s):
      // change: function (e, data) {}, // .on('fileuploadchange', func);

      // Callback for paste events to the pasteZone(s):
      // paste: function (e, data) {}, // .on('fileuploadpaste', func);

      // Callback for drop events of the dropZone(s):
      // drop: function (e, data) {}, // .on('fileuploaddrop', func);

      // Callback for dragover events of the dropZone(s):
      // dragover: function (e) {}, // .on('fileuploaddragover', func);

      // Callback before the start of each chunk upload request (before form data initialization):
      // chunkbeforesend: function (e, data) {}, // .on('fileuploadchunkbeforesend', func);

      // Callback for the start of each chunk upload request:
      // chunksend: function (e, data) {}, // .on('fileuploadchunksend', func);

      // Callback for successful chunk uploads:
      // chunkdone: function (e, data) {}, // .on('fileuploadchunkdone', func);

      // Callback for failed (abort or error) chunk uploads:
      // chunkfail: function (e, data) {}, // .on('fileuploadchunkfail', func);

      // Callback for completed (success, abort or error) chunk upload requests:
      // chunkalways: function (e, data) {}, // .on('fileuploadchunkalways', func);

      // The plugin options are used as settings object for the ajax calls.
      // The following are jQuery ajax settings required for the file uploads:
      processData: false,
      contentType: false,
      cache: false,
      timeout: 0
    },

    // jQuery versions before 1.8 require promise.pipe if the return value is
    // used, as promise.then in older versions has a different behavior, see:
    // https://blog.jquery.com/2012/08/09/jquery-1-8-released/
    // https://bugs.jquery.com/ticket/11010
    // https://github.com/blueimp/jQuery-File-Upload/pull/3435
    _promisePipe: (function () {
      var parts = $.fn.jquery.split('.');
      return Number(parts[0]) > 1 || Number(parts[1]) > 7 ? 'then' : 'pipe';
    })(),

    // A list of options that require reinitializing event listeners and/or
    // special initialization code:
    _specialOptions: [
      'fileInput',
      'dropZone',
      'pasteZone',
      'multipart',
      'forceIframeTransport'
    ],

    _blobSlice:
      $.support.blobSlice &&
      function () {
        var slice = this.slice || this.webkitSlice || this.mozSlice;
        return slice.apply(this, arguments);
      },

    _BitrateTimer: function () {
      this.timestamp = Date.now ? Date.now() : new Date().getTime();
      this.loaded = 0;
      this.bitrate = 0;
      this.getBitrate = function (now, loaded, interval) {
        var timeDiff = now - this.timestamp;
        if (!this.bitrate || !interval || timeDiff > interval) {
          this.bitrate = (loaded - this.loaded) * (1000 / timeDiff) * 8;
          this.loaded = loaded;
          this.timestamp = now;
        }
        return this.bitrate;
      };
    },

    _isXHRUpload: function (options) {
      return (
        !options.forceIframeTransport &&
        ((!options.multipart && $.support.xhrFileUpload) ||
          $.support.xhrFormDataFileUpload)
      );
    },

    _getFormData: function (options) {
      var formData;
      if ($.type(options.formData) === 'function') {
        return options.formData(options.form);
      }
      if ($.isArray(options.formData)) {
        return options.formData;
      }
      if ($.type(options.formData) === 'object') {
        formData = [];
        $.each(options.formData, function (name, value) {
          formData.push({ name: name, value: value });
        });
        return formData;
      }
      return [];
    },

    _getTotal: function (files) {
      var total = 0;
      $.each(files, function (index, file) {
        total += file.size || 1;
      });
      return total;
    },

    _initProgressObject: function (obj) {
      var progress = {
        loaded: 0,
        total: 0,
        bitrate: 0
      };
      if (obj._progress) {
        $.extend(obj._progress, progress);
      } else {
        obj._progress = progress;
      }
    },

    _initResponseObject: function (obj) {
      var prop;
      if (obj._response) {
        for (prop in obj._response) {
          if (Object.prototype.hasOwnProperty.call(obj._response, prop)) {
            delete obj._response[prop];
          }
        }
      } else {
        obj._response = {};
      }
    },

    _onProgress: function (e, data) {
      if (e.lengthComputable) {
        var now = Date.now ? Date.now() : new Date().getTime(),
          loaded;
        if (
          data._time &&
          data.progressInterval &&
          now - data._time < data.progressInterval &&
          e.loaded !== e.total
        ) {
          return;
        }
        data._time = now;
        loaded =
          Math.floor(
            (e.loaded / e.total) * (data.chunkSize || data._progress.total)
          ) + (data.uploadedBytes || 0);
        // Add the difference from the previously loaded state
        // to the global loaded counter:
        this._progress.loaded += loaded - data._progress.loaded;
        this._progress.bitrate = this._bitrateTimer.getBitrate(
          now,
          this._progress.loaded,
          data.bitrateInterval
        );
        data._progress.loaded = data.loaded = loaded;
        data._progress.bitrate = data.bitrate = data._bitrateTimer.getBitrate(
          now,
          loaded,
          data.bitrateInterval
        );
        // Trigger a custom progress event with a total data property set
        // to the file size(s) of the current upload and a loaded data
        // property calculated accordingly:
        this._trigger(
          'progress',
          $.Event('progress', { delegatedEvent: e }),
          data
        );
        // Trigger a global progress event for all current file uploads,
        // including ajax calls queued for sequential file uploads:
        this._trigger(
          'progressall',
          $.Event('progressall', { delegatedEvent: e }),
          this._progress
        );
      }
    },

    _initProgressListener: function (options) {
      var that = this,
        xhr = options.xhr ? options.xhr() : $.ajaxSettings.xhr();
      // Access to the native XHR object is required to add event listeners
      // for the upload progress event:
      if (xhr.upload) {
        $(xhr.upload).on('progress', function (e) {
          var oe = e.originalEvent;
          // Make sure the progress event properties get copied over:
          e.lengthComputable = oe.lengthComputable;
          e.loaded = oe.loaded;
          e.total = oe.total;
          that._onProgress(e, options);
        });
        options.xhr = function () {
          return xhr;
        };
      }
    },

    _deinitProgressListener: function (options) {
      var xhr = options.xhr ? options.xhr() : $.ajaxSettings.xhr();
      if (xhr.upload) {
        $(xhr.upload).off('progress');
      }
    },

    _isInstanceOf: function (type, obj) {
      // Cross-frame instanceof check
      return Object.prototype.toString.call(obj) === '[object ' + type + ']';
    },

    _getUniqueFilename: function (name, map) {
      // eslint-disable-next-line no-param-reassign
      name = String(name);
      if (map[name]) {
        // eslint-disable-next-line no-param-reassign
        name = name.replace(
          /(?: \(([\d]+)\))?(\.[^.]+)?$/,
          function (_, p1, p2) {
            var index = p1 ? Number(p1) + 1 : 1;
            var ext = p2 || '';
            return ' (' + index + ')' + ext;
          }
        );
        return this._getUniqueFilename(name, map);
      }
      map[name] = true;
      return name;
    },

    _initXHRData: function (options) {
      var that = this,
        formData,
        file = options.files[0],
        // Ignore non-multipart setting if not supported:
        multipart = options.multipart || !$.support.xhrFileUpload,
        paramName =
          $.type(options.paramName) === 'array'
            ? options.paramName[0]
            : options.paramName;
      options.headers = $.extend({}, options.headers);
      if (options.contentRange) {
        options.headers['Content-Range'] = options.contentRange;
      }
      if (!multipart || options.blob || !this._isInstanceOf('File', file)) {
        options.headers['Content-Disposition'] =
          'attachment; filename="' +
          encodeURI(file.uploadName || file.name) +
          '"';
      }
      if (!multipart) {
        options.contentType = file.type || 'application/octet-stream';
        options.data = options.blob || file;
      } else if ($.support.xhrFormDataFileUpload) {
        if (options.postMessage) {
          // window.postMessage does not allow sending FormData
          // objects, so we just add the File/Blob objects to
          // the formData array and let the postMessage window
          // create the FormData object out of this array:
          formData = this._getFormData(options);
          if (options.blob) {
            formData.push({
              name: paramName,
              value: options.blob
            });
          } else {
            $.each(options.files, function (index, file) {
              formData.push({
                name:
                  ($.type(options.paramName) === 'array' &&
                    options.paramName[index]) ||
                  paramName,
                value: file
              });
            });
          }
        } else {
          if (that._isInstanceOf('FormData', options.formData)) {
            formData = options.formData;
          } else {
            formData = new FormData();
            $.each(this._getFormData(options), function (index, field) {
              formData.append(field.name, field.value);
            });
          }
          if (options.blob) {
            formData.append(
              paramName,
              options.blob,
              file.uploadName || file.name
            );
          } else {
            $.each(options.files, function (index, file) {
              // This check allows the tests to run with
              // dummy objects:
              if (
                that._isInstanceOf('File', file) ||
                that._isInstanceOf('Blob', file)
              ) {
                var fileName = file.uploadName || file.name;
                if (options.uniqueFilenames) {
                  fileName = that._getUniqueFilename(
                    fileName,
                    options.uniqueFilenames
                  );
                }
                formData.append(
                  ($.type(options.paramName) === 'array' &&
                    options.paramName[index]) ||
                    paramName,
                  file,
                  fileName
                );
              }
            });
          }
        }
        options.data = formData;
      }
      // Blob reference is not needed anymore, free memory:
      options.blob = null;
    },

    _initIframeSettings: function (options) {
      var targetHost = $('<a></a>').prop('href', options.url).prop('host');
      // Setting the dataType to iframe enables the iframe transport:
      options.dataType = 'iframe ' + (options.dataType || '');
      // The iframe transport accepts a serialized array as form data:
      options.formData = this._getFormData(options);
      // Add redirect url to form data on cross-domain uploads:
      if (options.redirect && targetHost && targetHost !== location.host) {
        options.formData.push({
          name: options.redirectParamName || 'redirect',
          value: options.redirect
        });
      }
    },

    _initDataSettings: function (options) {
      if (this._isXHRUpload(options)) {
        if (!this._chunkedUpload(options, true)) {
          if (!options.data) {
            this._initXHRData(options);
          }
          this._initProgressListener(options);
        }
        if (options.postMessage) {
          // Setting the dataType to postmessage enables the
          // postMessage transport:
          options.dataType = 'postmessage ' + (options.dataType || '');
        }
      } else {
        this._initIframeSettings(options);
      }
    },

    _getParamName: function (options) {
      var fileInput = $(options.fileInput),
        paramName = options.paramName;
      if (!paramName) {
        paramName = [];
        fileInput.each(function () {
          var input = $(this),
            name = input.prop('name') || 'files[]',
            i = (input.prop('files') || [1]).length;
          while (i) {
            paramName.push(name);
            i -= 1;
          }
        });
        if (!paramName.length) {
          paramName = [fileInput.prop('name') || 'files[]'];
        }
      } else if (!$.isArray(paramName)) {
        paramName = [paramName];
      }
      return paramName;
    },

    _initFormSettings: function (options) {
      // Retrieve missing options from the input field and the
      // associated form, if available:
      if (!options.form || !options.form.length) {
        options.form = $(options.fileInput.prop('form'));
        // If the given file input doesn't have an associated form,
        // use the default widget file input's form:
        if (!options.form.length) {
          options.form = $(this.options.fileInput.prop('form'));
        }
      }
      options.paramName = this._getParamName(options);
      if (!options.url) {
        options.url = options.form.prop('action') || location.href;
      }
      // The HTTP request method must be "POST" or "PUT":
      options.type = (
        options.type ||
        ($.type(options.form.prop('method')) === 'string' &&
          options.form.prop('method')) ||
        ''
      ).toUpperCase();
      if (
        options.type !== 'POST' &&
        options.type !== 'PUT' &&
        options.type !== 'PATCH'
      ) {
        options.type = 'POST';
      }
      if (!options.formAcceptCharset) {
        options.formAcceptCharset = options.form.attr('accept-charset');
      }
    },

    _getAJAXSettings: function (data) {
      var options = $.extend({}, this.options, data);
      this._initFormSettings(options);
      this._initDataSettings(options);
      return options;
    },

    // jQuery 1.6 doesn't provide .state(),
    // while jQuery 1.8+ removed .isRejected() and .isResolved():
    _getDeferredState: function (deferred) {
      if (deferred.state) {
        return deferred.state();
      }
      if (deferred.isResolved()) {
        return 'resolved';
      }
      if (deferred.isRejected()) {
        return 'rejected';
      }
      return 'pending';
    },

    // Maps jqXHR callbacks to the equivalent
    // methods of the given Promise object:
    _enhancePromise: function (promise) {
      promise.success = promise.done;
      promise.error = promise.fail;
      promise.complete = promise.always;
      return promise;
    },

    // Creates and returns a Promise object enhanced with
    // the jqXHR methods abort, success, error and complete:
    _getXHRPromise: function (resolveOrReject, context, args) {
      var dfd = $.Deferred(),
        promise = dfd.promise();
      // eslint-disable-next-line no-param-reassign
      context = context || this.options.context || promise;
      if (resolveOrReject === true) {
        dfd.resolveWith(context, args);
      } else if (resolveOrReject === false) {
        dfd.rejectWith(context, args);
      }
      promise.abort = dfd.promise;
      return this._enhancePromise(promise);
    },

    // Adds convenience methods to the data callback argument:
    _addConvenienceMethods: function (e, data) {
      var that = this,
        getPromise = function (args) {
          return $.Deferred().resolveWith(that, args).promise();
        };
      data.process = function (resolveFunc, rejectFunc) {
        if (resolveFunc || rejectFunc) {
          data._processQueue = this._processQueue = (this._processQueue ||
            getPromise([this]))
            [that._promisePipe](function () {
              if (data.errorThrown) {
                return $.Deferred().rejectWith(that, [data]).promise();
              }
              return getPromise(arguments);
            })
            [that._promisePipe](resolveFunc, rejectFunc);
        }
        return this._processQueue || getPromise([this]);
      };
      data.submit = function () {
        if (this.state() !== 'pending') {
          data.jqXHR = this.jqXHR =
            that._trigger(
              'submit',
              $.Event('submit', { delegatedEvent: e }),
              this
            ) !== false && that._onSend(e, this);
        }
        return this.jqXHR || that._getXHRPromise();
      };
      data.abort = function () {
        if (this.jqXHR) {
          return this.jqXHR.abort();
        }
        this.errorThrown = 'abort';
        that._trigger('fail', null, this);
        return that._getXHRPromise(false);
      };
      data.state = function () {
        if (this.jqXHR) {
          return that._getDeferredState(this.jqXHR);
        }
        if (this._processQueue) {
          return that._getDeferredState(this._processQueue);
        }
      };
      data.processing = function () {
        return (
          !this.jqXHR &&
          this._processQueue &&
          that._getDeferredState(this._processQueue) === 'pending'
        );
      };
      data.progress = function () {
        return this._progress;
      };
      data.response = function () {
        return this._response;
      };
    },

    // Parses the Range header from the server response
    // and returns the uploaded bytes:
    _getUploadedBytes: function (jqXHR) {
      var range = jqXHR.getResponseHeader('Range'),
        parts = range && range.split('-'),
        upperBytesPos = parts && parts.length > 1 && parseInt(parts[1], 10);
      return upperBytesPos && upperBytesPos + 1;
    },

    // Uploads a file in multiple, sequential requests
    // by splitting the file up in multiple blob chunks.
    // If the second parameter is true, only tests if the file
    // should be uploaded in chunks, but does not invoke any
    // upload requests:
    _chunkedUpload: function (options, testOnly) {
      options.uploadedBytes = options.uploadedBytes || 0;
      var that = this,
        file = options.files[0],
        fs = file.size,
        ub = options.uploadedBytes,
        mcs = options.maxChunkSize || fs,
        slice = this._blobSlice,
        dfd = $.Deferred(),
        promise = dfd.promise(),
        jqXHR,
        upload;
      if (
        !(
          this._isXHRUpload(options) &&
          slice &&
          (ub || ($.type(mcs) === 'function' ? mcs(options) : mcs) < fs)
        ) ||
        options.data
      ) {
        return false;
      }
      if (testOnly) {
        return true;
      }
      if (ub >= fs) {
        file.error = options.i18n('uploadedBytes');
        return this._getXHRPromise(false, options.context, [
          null,
          'error',
          file.error
        ]);
      }
      // The chunk upload method:
      upload = function () {
        // Clone the options object for each chunk upload:
        var o = $.extend({}, options),
          currentLoaded = o._progress.loaded;
        o.blob = slice.call(
          file,
          ub,
          ub + ($.type(mcs) === 'function' ? mcs(o) : mcs),
          file.type
        );
        // Store the current chunk size, as the blob itself
        // will be dereferenced after data processing:
        o.chunkSize = o.blob.size;
        // Expose the chunk bytes position range:
        o.contentRange =
          'bytes ' + ub + '-' + (ub + o.chunkSize - 1) + '/' + fs;
        // Trigger chunkbeforesend to allow form data to be updated for this chunk
        that._trigger('chunkbeforesend', null, o);
        // Process the upload data (the blob and potential form data):
        that._initXHRData(o);
        // Add progress listeners for this chunk upload:
        that._initProgressListener(o);
        jqXHR = (
          (that._trigger('chunksend', null, o) !== false && $.ajax(o)) ||
          that._getXHRPromise(false, o.context)
        )
          .done(function (result, textStatus, jqXHR) {
            ub = that._getUploadedBytes(jqXHR) || ub + o.chunkSize;
            // Create a progress event if no final progress event
            // with loaded equaling total has been triggered
            // for this chunk:
            if (currentLoaded + o.chunkSize - o._progress.loaded) {
              that._onProgress(
                $.Event('progress', {
                  lengthComputable: true,
                  loaded: ub - o.uploadedBytes,
                  total: ub - o.uploadedBytes
                }),
                o
              );
            }
            options.uploadedBytes = o.uploadedBytes = ub;
            o.result = result;
            o.textStatus = textStatus;
            o.jqXHR = jqXHR;
            that._trigger('chunkdone', null, o);
            that._trigger('chunkalways', null, o);
            if (ub < fs) {
              // File upload not yet complete,
              // continue with the next chunk:
              upload();
            } else {
              dfd.resolveWith(o.context, [result, textStatus, jqXHR]);
            }
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            o.jqXHR = jqXHR;
            o.textStatus = textStatus;
            o.errorThrown = errorThrown;
            that._trigger('chunkfail', null, o);
            that._trigger('chunkalways', null, o);
            dfd.rejectWith(o.context, [jqXHR, textStatus, errorThrown]);
          })
          .always(function () {
            that._deinitProgressListener(o);
          });
      };
      this._enhancePromise(promise);
      promise.abort = function () {
        return jqXHR.abort();
      };
      upload();
      return promise;
    },

    _beforeSend: function (e, data) {
      if (this._active === 0) {
        // the start callback is triggered when an upload starts
        // and no other uploads are currently running,
        // equivalent to the global ajaxStart event:
        this._trigger('start');
        // Set timer for global bitrate progress calculation:
        this._bitrateTimer = new this._BitrateTimer();
        // Reset the global progress values:
        this._progress.loaded = this._progress.total = 0;
        this._progress.bitrate = 0;
      }
      // Make sure the container objects for the .response() and
      // .progress() methods on the data object are available
      // and reset to their initial state:
      this._initResponseObject(data);
      this._initProgressObject(data);
      data._progress.loaded = data.loaded = data.uploadedBytes || 0;
      data._progress.total = data.total = this._getTotal(data.files) || 1;
      data._progress.bitrate = data.bitrate = 0;
      this._active += 1;
      // Initialize the global progress values:
      this._progress.loaded += data.loaded;
      this._progress.total += data.total;
    },

    _onDone: function (result, textStatus, jqXHR, options) {
      var total = options._progress.total,
        response = options._response;
      if (options._progress.loaded < total) {
        // Create a progress event if no final progress event
        // with loaded equaling total has been triggered:
        this._onProgress(
          $.Event('progress', {
            lengthComputable: true,
            loaded: total,
            total: total
          }),
          options
        );
      }
      response.result = options.result = result;
      response.textStatus = options.textStatus = textStatus;
      response.jqXHR = options.jqXHR = jqXHR;
      this._trigger('done', null, options);
    },

    _onFail: function (jqXHR, textStatus, errorThrown, options) {
      var response = options._response;
      if (options.recalculateProgress) {
        // Remove the failed (error or abort) file upload from
        // the global progress calculation:
        this._progress.loaded -= options._progress.loaded;
        this._progress.total -= options._progress.total;
      }
      response.jqXHR = options.jqXHR = jqXHR;
      response.textStatus = options.textStatus = textStatus;
      response.errorThrown = options.errorThrown = errorThrown;
      this._trigger('fail', null, options);
    },

    _onAlways: function (jqXHRorResult, textStatus, jqXHRorError, options) {
      // jqXHRorResult, textStatus and jqXHRorError are added to the
      // options object via done and fail callbacks
      this._trigger('always', null, options);
    },

    _onSend: function (e, data) {
      if (!data.submit) {
        this._addConvenienceMethods(e, data);
      }
      var that = this,
        jqXHR,
        aborted,
        slot,
        pipe,
        options = that._getAJAXSettings(data),
        send = function () {
          that._sending += 1;
          // Set timer for bitrate progress calculation:
          options._bitrateTimer = new that._BitrateTimer();
          jqXHR =
            jqXHR ||
            (
              ((aborted ||
                that._trigger(
                  'send',
                  $.Event('send', { delegatedEvent: e }),
                  options
                ) === false) &&
                that._getXHRPromise(false, options.context, aborted)) ||
              that._chunkedUpload(options) ||
              $.ajax(options)
            )
              .done(function (result, textStatus, jqXHR) {
                that._onDone(result, textStatus, jqXHR, options);
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                that._onFail(jqXHR, textStatus, errorThrown, options);
              })
              .always(function (jqXHRorResult, textStatus, jqXHRorError) {
                that._deinitProgressListener(options);
                that._onAlways(
                  jqXHRorResult,
                  textStatus,
                  jqXHRorError,
                  options
                );
                that._sending -= 1;
                that._active -= 1;
                if (
                  options.limitConcurrentUploads &&
                  options.limitConcurrentUploads > that._sending
                ) {
                  // Start the next queued upload,
                  // that has not been aborted:
                  var nextSlot = that._slots.shift();
                  while (nextSlot) {
                    if (that._getDeferredState(nextSlot) === 'pending') {
                      nextSlot.resolve();
                      break;
                    }
                    nextSlot = that._slots.shift();
                  }
                }
                if (that._active === 0) {
                  // The stop callback is triggered when all uploads have
                  // been completed, equivalent to the global ajaxStop event:
                  that._trigger('stop');
                }
              });
          return jqXHR;
        };
      this._beforeSend(e, options);
      if (
        this.options.sequentialUploads ||
        (this.options.limitConcurrentUploads &&
          this.options.limitConcurrentUploads <= this._sending)
      ) {
        if (this.options.limitConcurrentUploads > 1) {
          slot = $.Deferred();
          this._slots.push(slot);
          pipe = slot[that._promisePipe](send);
        } else {
          this._sequence = this._sequence[that._promisePipe](send, send);
          pipe = this._sequence;
        }
        // Return the piped Promise object, enhanced with an abort method,
        // which is delegated to the jqXHR object of the current upload,
        // and jqXHR callbacks mapped to the equivalent Promise methods:
        pipe.abort = function () {
          aborted = [undefined, 'abort', 'abort'];
          if (!jqXHR) {
            if (slot) {
              slot.rejectWith(options.context, aborted);
            }
            return send();
          }
          return jqXHR.abort();
        };
        return this._enhancePromise(pipe);
      }
      return send();
    },

    _onAdd: function (e, data) {
      var that = this,
        result = true,
        options = $.extend({}, this.options, data),
        files = data.files,
        filesLength = files.length,
        limit = options.limitMultiFileUploads,
        limitSize = options.limitMultiFileUploadSize,
        overhead = options.limitMultiFileUploadSizeOverhead,
        batchSize = 0,
        paramName = this._getParamName(options),
        paramNameSet,
        paramNameSlice,
        fileSet,
        i,
        j = 0;
      if (!filesLength) {
        return false;
      }
      if (limitSize && files[0].size === undefined) {
        limitSize = undefined;
      }
      if (
        !(options.singleFileUploads || limit || limitSize) ||
        !this._isXHRUpload(options)
      ) {
        fileSet = [files];
        paramNameSet = [paramName];
      } else if (!(options.singleFileUploads || limitSize) && limit) {
        fileSet = [];
        paramNameSet = [];
        for (i = 0; i < filesLength; i += limit) {
          fileSet.push(files.slice(i, i + limit));
          paramNameSlice = paramName.slice(i, i + limit);
          if (!paramNameSlice.length) {
            paramNameSlice = paramName;
          }
          paramNameSet.push(paramNameSlice);
        }
      } else if (!options.singleFileUploads && limitSize) {
        fileSet = [];
        paramNameSet = [];
        for (i = 0; i < filesLength; i = i + 1) {
          batchSize += files[i].size + overhead;
          if (
            i + 1 === filesLength ||
            batchSize + files[i + 1].size + overhead > limitSize ||
            (limit && i + 1 - j >= limit)
          ) {
            fileSet.push(files.slice(j, i + 1));
            paramNameSlice = paramName.slice(j, i + 1);
            if (!paramNameSlice.length) {
              paramNameSlice = paramName;
            }
            paramNameSet.push(paramNameSlice);
            j = i + 1;
            batchSize = 0;
          }
        }
      } else {
        paramNameSet = paramName;
      }
      data.originalFiles = files;
      $.each(fileSet || files, function (index, element) {
        var newData = $.extend({}, data);
        newData.files = fileSet ? element : [element];
        newData.paramName = paramNameSet[index];
        that._initResponseObject(newData);
        that._initProgressObject(newData);
        that._addConvenienceMethods(e, newData);
        result = that._trigger(
          'add',
          $.Event('add', { delegatedEvent: e }),
          newData
        );
        return result;
      });
      return result;
    },

    _replaceFileInput: function (data) {
      var input = data.fileInput,
        inputClone = input.clone(true),
        restoreFocus = input.is(document.activeElement);
      // Add a reference for the new cloned file input to the data argument:
      data.fileInputClone = inputClone;
      $('<form></form>').append(inputClone)[0].reset();
      // Detaching allows to insert the fileInput on another form
      // without losing the file input value:
      input.after(inputClone).detach();
      // If the fileInput had focus before it was detached,
      // restore focus to the inputClone.
      if (restoreFocus) {
        inputClone.trigger('focus');
      }
      // Avoid memory leaks with the detached file input:
      $.cleanData(input.off('remove'));
      // Replace the original file input element in the fileInput
      // elements set with the clone, which has been copied including
      // event handlers:
      this.options.fileInput = this.options.fileInput.map(function (i, el) {
        if (el === input[0]) {
          return inputClone[0];
        }
        return el;
      });
      // If the widget has been initialized on the file input itself,
      // override this.element with the file input clone:
      if (input[0] === this.element[0]) {
        this.element = inputClone;
      }
    },

    _handleFileTreeEntry: function (entry, path) {
      var that = this,
        dfd = $.Deferred(),
        entries = [],
        dirReader,
        errorHandler = function (e) {
          if (e && !e.entry) {
            e.entry = entry;
          }
          // Since $.when returns immediately if one
          // Deferred is rejected, we use resolve instead.
          // This allows valid files and invalid items
          // to be returned together in one set:
          dfd.resolve([e]);
        },
        successHandler = function (entries) {
          that
            ._handleFileTreeEntries(entries, path + entry.name + '/')
            .done(function (files) {
              dfd.resolve(files);
            })
            .fail(errorHandler);
        },
        readEntries = function () {
          dirReader.readEntries(function (results) {
            if (!results.length) {
              successHandler(entries);
            } else {
              entries = entries.concat(results);
              readEntries();
            }
          }, errorHandler);
        };
      // eslint-disable-next-line no-param-reassign
      path = path || '';
      if (entry.isFile) {
        if (entry._file) {
          // Workaround for Chrome bug #149735
          entry._file.relativePath = path;
          dfd.resolve(entry._file);
        } else {
          entry.file(function (file) {
            file.relativePath = path;
            dfd.resolve(file);
          }, errorHandler);
        }
      } else if (entry.isDirectory) {
        dirReader = entry.createReader();
        readEntries();
      } else {
        // Return an empty list for file system items
        // other than files or directories:
        dfd.resolve([]);
      }
      return dfd.promise();
    },

    _handleFileTreeEntries: function (entries, path) {
      var that = this;
      return $.when
        .apply(
          $,
          $.map(entries, function (entry) {
            return that._handleFileTreeEntry(entry, path);
          })
        )
        [this._promisePipe](function () {
          return Array.prototype.concat.apply([], arguments);
        });
    },

    _getDroppedFiles: function (dataTransfer) {
      // eslint-disable-next-line no-param-reassign
      dataTransfer = dataTransfer || {};
      var items = dataTransfer.items;
      if (
        items &&
        items.length &&
        (items[0].webkitGetAsEntry || items[0].getAsEntry)
      ) {
        return this._handleFileTreeEntries(
          $.map(items, function (item) {
            var entry;
            if (item.webkitGetAsEntry) {
              entry = item.webkitGetAsEntry();
              if (entry) {
                // Workaround for Chrome bug #149735:
                entry._file = item.getAsFile();
              }
              return entry;
            }
            return item.getAsEntry();
          })
        );
      }
      return $.Deferred().resolve($.makeArray(dataTransfer.files)).promise();
    },

    _getSingleFileInputFiles: function (fileInput) {
      // eslint-disable-next-line no-param-reassign
      fileInput = $(fileInput);
      var entries = fileInput.prop('entries'),
        files,
        value;
      if (entries && entries.length) {
        return this._handleFileTreeEntries(entries);
      }
      files = $.makeArray(fileInput.prop('files'));
      if (!files.length) {
        value = fileInput.prop('value');
        if (!value) {
          return $.Deferred().resolve([]).promise();
        }
        // If the files property is not available, the browser does not
        // support the File API and we add a pseudo File object with
        // the input value as name with path information removed:
        files = [{ name: value.replace(/^.*\\/, '') }];
      } else if (files[0].name === undefined && files[0].fileName) {
        // File normalization for Safari 4 and Firefox 3:
        $.each(files, function (index, file) {
          file.name = file.fileName;
          file.size = file.fileSize;
        });
      }
      return $.Deferred().resolve(files).promise();
    },

    _getFileInputFiles: function (fileInput) {
      if (!(fileInput instanceof $) || fileInput.length === 1) {
        return this._getSingleFileInputFiles(fileInput);
      }
      return $.when
        .apply($, $.map(fileInput, this._getSingleFileInputFiles))
        [this._promisePipe](function () {
          return Array.prototype.concat.apply([], arguments);
        });
    },

    _onChange: function (e) {
      var that = this,
        data = {
          fileInput: $(e.target),
          form: $(e.target.form)
        };
      this._getFileInputFiles(data.fileInput).always(function (files) {
        data.files = files;
        if (that.options.replaceFileInput) {
          that._replaceFileInput(data);
        }
        if (
          that._trigger(
            'change',
            $.Event('change', { delegatedEvent: e }),
            data
          ) !== false
        ) {
          that._onAdd(e, data);
        }
      });
    },

    _onPaste: function (e) {
      var items =
          e.originalEvent &&
          e.originalEvent.clipboardData &&
          e.originalEvent.clipboardData.items,
        data = { files: [] };
      if (items && items.length) {
        $.each(items, function (index, item) {
          var file = item.getAsFile && item.getAsFile();
          if (file) {
            data.files.push(file);
          }
        });
        if (
          this._trigger(
            'paste',
            $.Event('paste', { delegatedEvent: e }),
            data
          ) !== false
        ) {
          this._onAdd(e, data);
        }
      }
    },

    _onDrop: function (e) {
      e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
      var that = this,
        dataTransfer = e.dataTransfer,
        data = {};
      if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
        e.preventDefault();
        this._getDroppedFiles(dataTransfer).always(function (files) {
          data.files = files;
          if (
            that._trigger(
              'drop',
              $.Event('drop', { delegatedEvent: e }),
              data
            ) !== false
          ) {
            that._onAdd(e, data);
          }
        });
      }
    },

    _onDragOver: getDragHandler('dragover'),

    _onDragEnter: getDragHandler('dragenter'),

    _onDragLeave: getDragHandler('dragleave'),

    _initEventHandlers: function () {
      if (this._isXHRUpload(this.options)) {
        this._on(this.options.dropZone, {
          dragover: this._onDragOver,
          drop: this._onDrop,
          // event.preventDefault() on dragenter is required for IE10+:
          dragenter: this._onDragEnter,
          // dragleave is not required, but added for completeness:
          dragleave: this._onDragLeave
        });
        this._on(this.options.pasteZone, {
          paste: this._onPaste
        });
      }
      if ($.support.fileInput) {
        this._on(this.options.fileInput, {
          change: this._onChange
        });
      }
    },

    _destroyEventHandlers: function () {
      this._off(this.options.dropZone, 'dragenter dragleave dragover drop');
      this._off(this.options.pasteZone, 'paste');
      this._off(this.options.fileInput, 'change');
    },

    _destroy: function () {
      this._destroyEventHandlers();
    },

    _setOption: function (key, value) {
      var reinit = $.inArray(key, this._specialOptions) !== -1;
      if (reinit) {
        this._destroyEventHandlers();
      }
      this._super(key, value);
      if (reinit) {
        this._initSpecialOptions();
        this._initEventHandlers();
      }
    },

    _initSpecialOptions: function () {
      var options = this.options;
      if (options.fileInput === undefined) {
        options.fileInput = this.element.is('input[type="file"]')
          ? this.element
          : this.element.find('input[type="file"]');
      } else if (!(options.fileInput instanceof $)) {
        options.fileInput = $(options.fileInput);
      }
      if (!(options.dropZone instanceof $)) {
        options.dropZone = $(options.dropZone);
      }
      if (!(options.pasteZone instanceof $)) {
        options.pasteZone = $(options.pasteZone);
      }
    },

    _getRegExp: function (str) {
      var parts = str.split('/'),
        modifiers = parts.pop();
      parts.shift();
      return new RegExp(parts.join('/'), modifiers);
    },

    _isRegExpOption: function (key, value) {
      return (
        key !== 'url' &&
        $.type(value) === 'string' &&
        /^\/.*\/[igm]{0,3}$/.test(value)
      );
    },

    _initDataAttributes: function () {
      var that = this,
        options = this.options,
        data = this.element.data();
      // Initialize options set via HTML5 data-attributes:
      $.each(this.element[0].attributes, function (index, attr) {
        var key = attr.name.toLowerCase(),
          value;
        if (/^data-/.test(key)) {
          // Convert hyphen-ated key to camelCase:
          key = key.slice(5).replace(/-[a-z]/g, function (str) {
            return str.charAt(1).toUpperCase();
          });
          value = data[key];
          if (that._isRegExpOption(key, value)) {
            value = that._getRegExp(value);
          }
          options[key] = value;
        }
      });
    },

    _create: function () {
      this._initDataAttributes();
      this._initSpecialOptions();
      this._slots = [];
      this._sequence = this._getXHRPromise(true);
      this._sending = this._active = 0;
      this._initProgressObject(this);
      this._initEventHandlers();
    },

    // This method is exposed to the widget API and allows to query
    // the number of active uploads:
    active: function () {
      return this._active;
    },

    // This method is exposed to the widget API and allows to query
    // the widget upload progress.
    // It returns an object with loaded, total and bitrate properties
    // for the running uploads:
    progress: function () {
      return this._progress;
    },

    // This method is exposed to the widget API and allows adding files
    // using the fileupload API. The data parameter accepts an object which
    // must have a files property and can contain additional options:
    // .fileupload('add', {files: filesList});
    add: function (data) {
      var that = this;
      if (!data || this.options.disabled) {
        return;
      }
      if (data.fileInput && !data.files) {
        this._getFileInputFiles(data.fileInput).always(function (files) {
          data.files = files;
          that._onAdd(null, data);
        });
      } else {
        data.files = $.makeArray(data.files);
        this._onAdd(null, data);
      }
    },

    // This method is exposed to the widget API and allows sending files
    // using the fileupload API. The data parameter accepts an object which
    // must have a files or fileInput property and can contain additional options:
    // .fileupload('send', {files: filesList});
    // The method returns a Promise object for the file upload call.
    send: function (data) {
      if (data && !this.options.disabled) {
        if (data.fileInput && !data.files) {
          var that = this,
            dfd = $.Deferred(),
            promise = dfd.promise(),
            jqXHR,
            aborted;
          promise.abort = function () {
            aborted = true;
            if (jqXHR) {
              return jqXHR.abort();
            }
            dfd.reject(null, 'abort', 'abort');
            return promise;
          };
          this._getFileInputFiles(data.fileInput).always(function (files) {
            if (aborted) {
              return;
            }
            if (!files.length) {
              dfd.reject();
              return;
            }
            data.files = files;
            jqXHR = that._onSend(null, data);
            jqXHR.then(
              function (result, textStatus, jqXHR) {
                dfd.resolve(result, textStatus, jqXHR);
              },
              function (jqXHR, textStatus, errorThrown) {
                dfd.reject(jqXHR, textStatus, errorThrown);
              }
            );
          });
          return this._enhancePromise(promise);
        }
        data.files = $.makeArray(data.files);
        if (data.files.length) {
          return this._onSend(null, data);
        }
      }
      return this._getXHRPromise(false, data && data.context);
    }
  });
});
/*
 * jQuery File Upload Processing Plugin
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2012, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, require */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['jquery', './jquery.fileupload'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS:
    factory(require('jquery'), require('./jquery.fileupload'));
  } else {
    // Browser globals:
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';

  var originalAdd = $.blueimp.fileupload.prototype.options.add;

  // The File Upload Processing plugin extends the fileupload widget
  // with file processing functionality:
  $.widget('blueimp.fileupload', $.blueimp.fileupload, {
    options: {
      // The list of processing actions:
      processQueue: [
        /*
                {
                    action: 'log',
                    type: 'debug'
                }
                */
      ],
      add: function (e, data) {
        var $this = $(this);
        data.process(function () {
          return $this.fileupload('process', data);
        });
        originalAdd.call(this, e, data);
      }
    },

    processActions: {
      /*
            log: function (data, options) {
                console[options.type](
                    'Processing "' + data.files[data.index].name + '"'
                );
            }
            */
    },

    _processFile: function (data, originalData) {
      var that = this,
        // eslint-disable-next-line new-cap
        dfd = $.Deferred().resolveWith(that, [data]),
        chain = dfd.promise();
      this._trigger('process', null, data);
      $.each(data.processQueue, function (i, settings) {
        var func = function (data) {
          if (originalData.errorThrown) {
            // eslint-disable-next-line new-cap
            return $.Deferred().rejectWith(that, [originalData]).promise();
          }
          return that.processActions[settings.action].call(
            that,
            data,
            settings
          );
        };
        chain = chain[that._promisePipe](func, settings.always && func);
      });
      chain
        .done(function () {
          that._trigger('processdone', null, data);
          that._trigger('processalways', null, data);
        })
        .fail(function () {
          that._trigger('processfail', null, data);
          that._trigger('processalways', null, data);
        });
      return chain;
    },

    // Replaces the settings of each processQueue item that
    // are strings starting with an "@", using the remaining
    // substring as key for the option map,
    // e.g. "@autoUpload" is replaced with options.autoUpload:
    _transformProcessQueue: function (options) {
      var processQueue = [];
      $.each(options.processQueue, function () {
        var settings = {},
          action = this.action,
          prefix = this.prefix === true ? action : this.prefix;
        $.each(this, function (key, value) {
          if ($.type(value) === 'string' && value.charAt(0) === '@') {
            settings[key] =
              options[
                value.slice(1) ||
                  (prefix
                    ? prefix + key.charAt(0).toUpperCase() + key.slice(1)
                    : key)
              ];
          } else {
            settings[key] = value;
          }
        });
        processQueue.push(settings);
      });
      options.processQueue = processQueue;
    },

    // Returns the number of files currently in the processing queue:
    processing: function () {
      return this._processing;
    },

    // Processes the files given as files property of the data parameter,
    // returns a Promise object that allows to bind callbacks:
    process: function (data) {
      var that = this,
        options = $.extend({}, this.options, data);
      if (options.processQueue && options.processQueue.length) {
        this._transformProcessQueue(options);
        if (this._processing === 0) {
          this._trigger('processstart');
        }
        $.each(data.files, function (index) {
          var opts = index ? $.extend({}, options) : options,
            func = function () {
              if (data.errorThrown) {
                // eslint-disable-next-line new-cap
                return $.Deferred().rejectWith(that, [data]).promise();
              }
              return that._processFile(opts, data);
            };
          opts.index = index;
          that._processing += 1;
          that._processingQueue = that._processingQueue[that._promisePipe](
            func,
            func
          ).always(function () {
            that._processing -= 1;
            if (that._processing === 0) {
              that._trigger('processstop');
            }
          });
        });
      }
      return this._processingQueue;
    },

    _create: function () {
      this._super();
      this._processing = 0;
      // eslint-disable-next-line new-cap
      this._processingQueue = $.Deferred().resolveWith(this).promise();
    }
  });
});
/*
 * jQuery File Upload Validation Plugin
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, require */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['jquery', './jquery.fileupload-process'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS:
    factory(require('jquery'), require('./jquery.fileupload-process'));
  } else {
    // Browser globals:
    factory(window.jQuery);
  }
})(function ($) {
  'use strict';

  // Append to the default processQueue:
  $.blueimp.fileupload.prototype.options.processQueue.push({
    action: 'validate',
    // Always trigger this action,
    // even if the previous action was rejected:
    always: true,
    // Options taken from the global options map:
    acceptFileTypes: '@',
    maxFileSize: '@',
    minFileSize: '@',
    maxNumberOfFiles: '@',
    disabled: '@disableValidation'
  });

  // The File Upload Validation plugin extends the fileupload widget
  // with file validation functionality:
  $.widget('blueimp.fileupload', $.blueimp.fileupload, {
    options: {
      /*
            // The regular expression for allowed file types, matches
            // against either file type or file name:
            acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
            // The maximum allowed file size in bytes:
            maxFileSize: 10000000, // 10 MB
            // The minimum allowed file size in bytes:
            minFileSize: undefined, // No minimal file size
            // The limit of files to be uploaded:
            maxNumberOfFiles: 10,
            */

      // Function returning the current number of files,
      // has to be overridden for maxNumberOfFiles validation:
      getNumberOfFiles: $.noop,

      // Error and info messages:
      messages: {
        maxNumberOfFiles: 'Maximum number of files exceeded',
        acceptFileTypes: 'File type not allowed',
        maxFileSize: 'File is too large',
        minFileSize: 'File is too small'
      }
    },

    processActions: {
      validate: function (data, options) {
        if (options.disabled) {
          return data;
        }
        // eslint-disable-next-line new-cap
        var dfd = $.Deferred(),
          settings = this.options,
          file = data.files[data.index],
          fileSize;
        if (options.minFileSize || options.maxFileSize) {
          fileSize = file.size;
        }
        if (
          $.type(options.maxNumberOfFiles) === 'number' &&
          (settings.getNumberOfFiles() || 0) + data.files.length >
            options.maxNumberOfFiles
        ) {
          file.error = settings.i18n('maxNumberOfFiles');
        } else if (
          options.acceptFileTypes &&
          !(
            options.acceptFileTypes.test(file.type) ||
            options.acceptFileTypes.test(file.name)
          )
        ) {
          file.error = settings.i18n('acceptFileTypes');
        } else if (fileSize > options.maxFileSize) {
          file.error = settings.i18n('maxFileSize');
        } else if (
          $.type(fileSize) === 'number' &&
          fileSize < options.minFileSize
        ) {
          file.error = settings.i18n('minFileSize');
        } else {
          delete file.error;
        }
        if (file.error || data.files.error) {
          data.files.error = true;
          dfd.rejectWith(this, [data]);
        } else {
          dfd.resolveWith(this, [data]);
        }
        return dfd.promise();
      }
    }
  });
});







var LocationControl = LocationControl || {};

LocationControl.AutoComplete = function(control) {
  function init() {
    setupAutoComplete();
  }

  function setupAutoComplete() {
    control.getElement().autocomplete({
      source: source,
      select: selectionMade,
    }).
      autocomplete('instance')._renderItem = renderItem;
  }

  function source(request, response) {
    control.geocode(request.term, response);
  }

  function selectionMade(e, itemWrapper) {
    var result = itemWrapper.item;
    e.preventDefault();
    control.resultSelected(result);
  }

  function renderItem($ul, item) {
    var version = $.ui.version.split('.'),
      $li = $('<li />');

    if (version[1] > 11) {
      var $ele = $('<div />').text(item.displayName);
      $ele.appendTo($li);
    } else {
      $li.text(item.displayName);
    }

    return $li.appendTo($ul);
  }

  init();
};
var LocationControl = LocationControl || {};

LocationControl.Control = function(provider, $element, onLocationSelect) {
  var fields = [],
    fieldNames = [
      'city',
      'country_long_name',
      'country_short_name',
      'latitude',
      'longitude',
      'state_short_name',
      'state_long_name',
      'postal_code',
    ];

  onLocationSelect = onLocationSelect || function() {};

  // Proxy these to the provider
  this.geocode = provider.geocode;
  this.reverseGeocode = provider.reverseGeocode;

  this.getElement = function() {
    return $element;
  };

  this.resultSelected = function(result) {
    provider.resultSelected(result, this.updateDataElement);
  };

  this.updateDataElement = function(location) {
    $.each(fields, function(_i, $field) {
      $field.val(location[$field.data('locationField')]);
    });

    $element.addClass('ran'); // Test hook
    $element.data('valid', true);
    $element.val(location.name);
    $element.blur();

    onLocationSelect(location);
  };

  function init() {
    initializeDataElements();
    cleanOnEdit();
  }

  function hiddenInputField(suffix) {
    var className = 'location-' + suffix.replace(/_/g, '-'),
      name = extractBaseName() + '[' + suffix + ']',
      $hiddenInput = $('[name="' + name +'"]');

    if ($hiddenInput.length === 0) {
      $hiddenInput = $('<input />').
        attr('type', 'hidden').
        attr('name', name);
    }

    $hiddenInput.
      data('locationField', suffix).
      addClass(className);

    return $hiddenInput;
  }

  function clean() {
    $.each(fields, function(_i, $field) { $field.val(''); });

    $element.addClass('ran'); // Test hook
    $element.data('valid', false);
  }

  function initializeDataElements() {
    var id = Date.now ? Date.now() : new Date().getTime(),
      $container = $('<span data-id="' + id + '" data-for="location-control"></span>');

    $element.data('valid', false);

    $.each(fieldNames, function(_i, fieldName) {
      fields.push(hiddenInputField(fieldName));
    });

    $.each(fields, function(_i, $field) { $container.append($field); });
    $container.insertAfter($element);
  }

  function cleanOnEdit() {
    $element.on('input', clean);
  }

  function extractBaseName() {
    return $element.attr('name').replace('[location]', '');
  }

  init();
};
(function($) {
  $.widget('gh.locationControl', {
    options: {
      locateMe: true,
      language: null,
      onLocationSelect: function() {},
      provider: 'Mapbox',
      type: 'city',
      locateMeText: 'Locate me',
      country: null, // All countries by default
    },

    _create: function() {
      var locateMe = this.element.data('locate-me'),
        onLocationSelect = this.options.onLocationSelect,
        providerName = this.element.data('provider') || this.options.provider,
        type = this.element.data('type') || this.options.type,
        locateMeText = this.options.locateMeText,
        language = this.element.data('language') || this.options.language,
        country = this.element.data('country') || this.options.country,
        provider = new LocationControl.Providers[providerName](type, language, country),
        control = new LocationControl.Control(
          provider,
          this.element,
          onLocationSelect
        );

      if (locateMe === undefined) {
        locateMe = this.options.locateMe;
      }

      if (locateMe) { new LocationControl.LocateMe(control, locateMeText); }

      new LocationControl.AutoComplete(control);
    },

    clear: function() {
      this.element.
        val('').
        blur(); // blur triggers
    },

    disable: function() {
      this.element.
        attr('disabled', true).
        addClass('disabled');
    },

    enable: function() {
      this.element.
        attr('disabled', false).
        removeClass('disabled');
    }
  });
})(jQuery);
var LocationControl = LocationControl || {};

LocationControl.LocateMe = function(control, text) {
  var $locateMe,
    $msg,
    ERRORS = {
      1: 'Permission denied',
      2: 'Position unavailable',
      3: 'Request timeout'
    };

  function init() {
    if (navigator && navigator.geolocation) {
      $locateMe = $('<a href="#" />').
        addClass('locate-me').
        text(text);

      $locateMe.on('click', locateMe);

      $msg = $('<span />');

      // This is added to preserve the spacing
      $('<label>&nbsp;</label>').insertAfter(control.getElement());

      $locateMe.insertAfter(control.getElement());
      $msg.insertAfter($locateMe);
    }
  }

  function locateMe(e) {
    e.preventDefault();

    var timeoutVal = 1000 * 60; // Wait for one minute

    navigator.geolocation.getCurrentPosition(
      displayPosition,
      displayError,
      { enableHighAccuracy: true, timeout: timeoutVal }
    );
  }

  function displayPosition(position) {
    control.reverseGeocode(position.coords.latitude, position.coords.longitude, callback);
  }

  function displayError(error) {
    $msg.addClass('error').text(ERRORS[error.code]);
    setTimeout(function() { $msg.removeClass('error').text(''); }, 6000);
  }

  function callback(data) {
    control.resultSelected(data[0]);
  }

  init();
};
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};

LocationControl.Providers.Mapbox = function(locationType, language, country) {
  this.geocode = function(term, callback) {
    var request = new LocationControl.Providers.Mapbox.Request({
      locationType: locationType,
      language: language,
      country: country,
    });
    request.autoComplete(term, callback);
  };

  this.reverseGeocode = function(latitude, longitude, callback) {
    var term = [longitude, latitude].join(','),
      request = new LocationControl.Providers.Mapbox.Request({
        locationType: locationType,
        language: language,
        country: country,
        limit: false,
      });
    request.autoComplete(term, callback);
  };

  this.resultSelected = function(autoCompletedResult, callback) {
    // Due to MapBox's licensing terms, we need to hit the permanent
    // endpoint when getting a location that will be saved.

    var storableResult =
      new LocationControl.Providers.Mapbox.StorableResult(autoCompletedResult, callback);
    storableResult.ensureStorable();
  };
};

var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Mapbox = LocationControl.Providers.Mapbox || {};

LocationControl.Providers.Mapbox.DummyResult = function(name) {
  this.city = null;
  this.country_long_name = null;
  this.country_short_name = null;
  this.displayName = name;
  this.id = 'dummy';
  this.latitude = null;
  this.longitude = null;
  this.name = name;
  this.postal_code = null;
  this.state_long_name = null;
  this.state_short_name = null;
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Mapbox = LocationControl.Providers.Mapbox || {};

LocationControl.Providers.Mapbox.Request = function(options) {
  var baseUrl = 'https://api.mapbox.com/geocoding/v5/',
    autoCompleteEndpoint = 'mapbox.places',
    permanentEndpoint = 'mapbox.places-permanent',
    options = options || {},
    limit = options.limit,
    language = options.language,
    locationType = options.locationType || 'city',
    country = options.country,
    typeConversion = {
      address: 'address,place,locality',
      city: 'place,locality',
      state: 'region,place,locality',
      country: 'country',
    },
    exactConversion = {
      city: 'place'
    };

  if (limit === undefined) {
    limit = true;
  }

  this.autoComplete = function(term, callback) {
    call(autoCompleteEndpoint, term, callback, false);
  };

  this.permanent = function(term, callback) {
    call(permanentEndpoint, term, callback, true);
  };

  function resultsFrom(data) {
    return $.map(data.features, function(datum) {
      return new LocationControl.Providers.Mapbox.Result(datum);
    });
  }

  function call(endpoint, term, callback, permanent) {
    $.ajax({
      url: url(endpoint, term),
      data: params(permanent),
      success: function(data) { callback(resultsFrom(data)); },
      error: function() { callback([]); },
    });
  }

  function url(endpoint, term) {
    return baseUrl + endpoint + '/' + term + '.json';
  }

  function params(permanent) {
    var paramsHash = {
      access_token: LocationControl.Providers.Mapbox.apiKey,
    };

    if (language) {
      paramsHash.language = language;
    }

    if (country) {
      paramsHash.country = country;
    }

    if (permanent) {
      if (limit) {
        paramsHash.limit = 1;
      }
      paramsHash.types = exactConversion[locationType] || locationType;
    } else {
      paramsHash.autocomplete = true;
      paramsHash.types = typeConversion[locationType];
      if (limit) {
        paramsHash.limit = 10;
      }
    }

    return paramsHash;
  }
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Mapbox = LocationControl.Providers.Mapbox || {};

LocationControl.Providers.Mapbox.Result = function(data) {
  setParts([data], this);
  if (data.context) { setParts(data.context, this); }

  function isType(part, partType) {
    return part.id.includes(partType) ||
      part.place_type && part.place_type.includes(partType);
  }

  function getShortCode(part, index) {
    if (part.properties && part.properties.short_code) {
      return getShortCode(part.properties, index);
    }

    var shortCode = part.short_code || "";

    if (shortCode.includes('-')) {
      shortCode = shortCode.split(/-/)[index];
    }

    return shortCode.toUpperCase();
  }

  function setParts(parts, result) {
    $.each(parts, function(_i, part) {
      if (isType(part, 'place')) {
        result.city = part.text;
      }

      if (isType(part, 'postcode')) {
        result.postal_code = part.text;
      }

      if (isType(part, 'region')) {
        result.state_long_name = part.text;
        result.state_short_name = getShortCode(part, 1);
      }

      if (isType(part, 'country')) {
        result.country_long_name = part.text;
        result.country_short_name = getShortCode(part, 0);
      }
    });
  }

  var placeName = data.place_name;

  if (data.text) {
    // Override place name only if
    // 1. It's not the same word for place, state and country
    // 2. There's a city already set
    if (this.city && this.state_long_name && this.country_long_name) {
      if ((this.city != this.state_long_name) || (this.state_long_name != this.country_long_name)) {
        placeName = [data.text, this.state_long_name, this.country_long_name].join(', ')
      }

      this.city = data.text;
    }
  }

  this.displayName = placeName;
  this.name = placeName;
  this.id = data.id;
  this.latitude = data.geometry.coordinates[1];
  this.longitude = data.geometry.coordinates[0];
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Mapbox = LocationControl.Providers.Mapbox || {};

LocationControl.Providers.Mapbox.StorableResult = function(autoCompletedResult, callback) {
  var autoCompletedName = autoCompletedResult.name;

  this.ensureStorable = function() {
    var type = autoCompletedResult.id.split('.')[0],
      request = new LocationControl.Providers.Mapbox.Request({
        locationType: type
      }),
      term = [autoCompletedResult.longitude, autoCompletedResult.latitude].join(',');

    request.permanent(term, invokeCallback);
  };

  function invokeCallback(results) {
    if (results.length > 0) {
      callbackWithResult(results);
    } else {
      callbackWithDummyResult();
    }
  }

  function callbackWithResult(results) {
    // Let's use the name the user picked
    var result = results[0];

    result.city = autoCompletedResult.city;
    result.country_long_name = autoCompletedResult.country_long_name;
    result.country_short_name = autoCompletedResult.country_short_name;
    result.displayName = autoCompletedResult.displayName;
    result.name = autoCompletedResult.name;
    result.postal_code = autoCompletedResult.postal_code;
    result.state_long_name = autoCompletedResult.state_long_name;
    result.state_short_name = autoCompletedResult.state_short_name;

    callback(result);
  }

  function callbackWithDummyResult() {
    var result =
      new LocationControl.Providers.Mapbox.DummyResult(autoCompletedName);
    callback(result);
  }
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};

LocationControl.Providers.Pelias = function(locationType) {
  this.geocode = function(term, callback) {
    var request = new LocationControl.Providers.Pelias.Request({locationType: locationType});
    request.autoComplete(term, callback);
  };

  this.reverseGeocode = function(latitude, longitude, callback) {
    var request = new LocationControl.Providers.Pelias.Request({
      locationType: 'locality,localadmin,borough,macrohood,postalcode,county'
    });
    request.reverseGeocode(latitude, longitude, callback);
  };

  this.resultSelected = function(autoCompletedResult, callback) {
    callback(autoCompletedResult);
  };
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Pelias = LocationControl.Providers.Pelias || {};

LocationControl.Providers.Pelias.DummyResult = function(name) {
  this.city = null;
  this.country_long_name = null;
  this.country_short_name = null;
  this.displayName = name;
  this.id = 'dummy';
  this.latitude = null;
  this.longitude = null;
  this.name = name;
  this.state_long_name = null;
  this.state_short_name = null;
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Pelias = LocationControl.Providers.Pelias || {};

LocationControl.Providers.Pelias.Request = function(options) {
  var autoCompleteEndpoint = 'v1/autocomplete',
    reverseEndpoint = 'v1/reverse',
    options = options || {},
    baseUrl = options.baseUrl || 'https://api.geocode.earth/',
    limit = options.limit,
    layers = options.locationType || 'coarse';

  this.autoComplete = function(term, callback) {
    var params = {
      text: term,
    };
    call(autoCompleteEndpoint, params, callback);
  };

  this.reverseGeocode = function(lat, lng, callback) {
    var params = {
      'point.lat': lat,
      'point.lon': lng,
    };
    call(reverseEndpoint, params, callback);
  };


  function resultsFrom(data) {
    return $.map(data.features, function(datum) {
      return new LocationControl.Providers.Pelias.Result(datum);
    });
  }

  function call(endpoint, params, callback) {
    $.ajax({
      url: url(endpoint, requestParams(params)),
      success: function(data) { callback(resultsFrom(data)); },
      error: function() { callback([]); },
    });
  }

  function url(endpoint, params) {
    return baseUrl + endpoint + '?' + params;
  }

  function requestParams(params) {
    var instanceParams = {
      api_key: LocationControl.Providers.Pelias.apiKey,
      layers: layers,
      size: limit
    };
    params = $.extend({}, instanceParams, params);

    return $.param(params);
  }
};
var LocationControl = LocationControl || {};
LocationControl.Providers = LocationControl.Providers || {};
LocationControl.Providers.Pelias = LocationControl.Providers.Pelias || {};

LocationControl.Providers.Pelias.Result = function(data) {
  var placeName = data.properties.label;

  this.id = data.properties.id;
  this.city = data.properties.name;

  this.state_long_name = data.properties.region;
  this.state_short_name = data.properties.region_a;

  this.country_long_name = data.properties.country;
  this.country_short_name = data.properties.country_a;

  if (this.city && this.state_long_name && this.country_long_name) {
    if (this.city !== this.state_long_name && this.state_long_name !== this.country_long_name) {
      placeName = [this.city, this.state_long_name, this.country_long_name].join(', ');
    }
  }

  this.displayName = placeName;
  this.name = placeName;
  this.latitude = data.geometry.coordinates[1];
  this.longitude = data.geometry.coordinates[0];
};
/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */

/* global jQuery */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function($) {
  'use strict';

  var readmore = 'readmore',
      defaults = {
        speed: 100,
        collapsedHeight: 200,
        heightMargin: 16,
        moreLink: '<a href="#">Read More</a>',
        lessLink: '<a href="#">Close</a>',
        embedCSS: true,
        blockCSS: 'display: block; width: 100%;',
        startOpen: false,

        // callbacks
        blockProcessed: function() {},
        beforeToggle: function() {},
        afterToggle: function() {}
      },
      cssEmbedded = {},
      uniqueIdCounter = 0;

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (! immediate) {
          func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  function uniqueId(prefix) {
    var id = ++uniqueIdCounter;

    return String(prefix == null ? 'rmjs-' : prefix) + id;
  }

  function setBoxHeights(element) {
    var el = element.clone().css({
          height: 'auto',
          width: element.width(),
          maxHeight: 'none',
          overflow: 'hidden'
        }).insertAfter(element),
        expandedHeight = el.outerHeight(),
        cssMaxHeight = parseInt(el.css({maxHeight: ''}).css('max-height').replace(/[^-\d\.]/g, ''), 10),
        defaultHeight = element.data('defaultHeight');

    el.remove();

    var collapsedHeight = cssMaxHeight || element.data('collapsedHeight') || defaultHeight;

    // Store our measurements.
    element.data({
      expandedHeight: expandedHeight,
      maxHeight: cssMaxHeight,
      collapsedHeight: collapsedHeight
    })
    // and disable any `max-height` property set in CSS
    .css({
      maxHeight: 'none'
    });
  }

  var resizeBoxes = debounce(function() {
    $('[data-readmore]').each(function() {
      var current = $(this),
          isExpanded = (current.attr('aria-expanded') === 'true');

      setBoxHeights(current);

      current.css({
        height: current.data( (isExpanded ? 'expandedHeight' : 'collapsedHeight') )
      });
    });
  }, 100);

  function embedCSS(options) {
    if (! cssEmbedded[options.selector]) {
      var styles = ' ';

      if (options.embedCSS && options.blockCSS !== '') {
        styles += options.selector + ' + [data-readmore-toggle], ' +
          options.selector + '[data-readmore]{' +
            options.blockCSS +
          '}';
      }

      // Include the transition CSS even if embedCSS is false
      styles += options.selector + '[data-readmore]{' +
        'transition: height ' + options.speed + 'ms;' +
        'overflow: hidden;' +
      '}';

      (function(d, u) {
        var css = d.createElement('style');
        css.type = 'text/css';

        if (css.styleSheet) {
          css.styleSheet.cssText = u;
        }
        else {
          css.appendChild(d.createTextNode(u));
        }

        d.getElementsByTagName('head')[0].appendChild(css);
      }(document, styles));

      cssEmbedded[options.selector] = true;
    }
  }

  function Readmore(element, options) {
    this.element = element;

    this.options = $.extend({}, defaults, options);

    embedCSS(this.options);

    this._defaults = defaults;
    this._name = readmore;

    this.init();

    // IE8 chokes on `window.addEventListener`, so need to test for support.
    if (window.addEventListener) {
      // Need to resize boxes when the page has fully loaded.
      window.addEventListener('load', resizeBoxes);
      window.addEventListener('resize', resizeBoxes);
    }
    else {
      window.attachEvent('load', resizeBoxes);
      window.attachEvent('resize', resizeBoxes);
    }
  }


  Readmore.prototype = {
    init: function() {
      var current = $(this.element);

      current.data({
        defaultHeight: this.options.collapsedHeight,
        heightMargin: this.options.heightMargin
      });

      setBoxHeights(current);

      var collapsedHeight = current.data('collapsedHeight'),
          heightMargin = current.data('heightMargin');

      if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
        // The block is shorter than the limit, so there's no need to truncate it.
        if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
          this.options.blockProcessed(current, false);
        }
        return true;
      }
      else {
        var id = current.attr('id') || uniqueId(),
            useLink = this.options.startOpen ? this.options.lessLink : this.options.moreLink;

        current.attr({
          'data-readmore': '',
          'aria-expanded': this.options.startOpen,
          'id': id
        });

        current.after($(useLink)
          .on('click', (function(_this) {
            return function(event) {
              _this.toggle(this, current[0], event);
            };
          })(this))
          .attr({
            'data-readmore-toggle': id,
            'aria-controls': id
          }));

        if (! this.options.startOpen) {
          current.css({
            height: collapsedHeight
          });
        }

        if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
          this.options.blockProcessed(current, true);
        }
      }
    },

    toggle: function(trigger, element, event) {
      if (event) {
        event.preventDefault();
      }

      if (! trigger) {
        trigger = $('[aria-controls="' + this.element.id + '"]')[0];
      }

      if (! element) {
        element = this.element;
      }

      var $element = $(element),
          newHeight = '',
          newLink = '',
          expanded = false,
          collapsedHeight = $element.data('collapsedHeight');

      if ($element[0].getBoundingClientRect().height <= collapsedHeight) {
        newHeight = $element.data('expandedHeight') + 'px';
        newLink = 'lessLink';
        expanded = true;
      }
      else {
        newHeight = collapsedHeight;
        newLink = 'moreLink';
      }

      // Fire beforeToggle callback
      // Since we determined the new "expanded" state above we're now out of sync
      // with our true current state, so we need to flip the value of `expanded`
      if (this.options.beforeToggle && typeof this.options.beforeToggle === 'function') {
        this.options.beforeToggle(trigger, $element, ! expanded);
      }

      $element.css({'height': newHeight});

      // Fire afterToggle callback
      $element.on('transitionend', (function(_this) {
        return function() {
          if (_this.options.afterToggle && typeof _this.options.afterToggle === 'function') {
            _this.options.afterToggle(trigger, $element, expanded);
          }

          $(this).attr({
            'aria-expanded': expanded
          }).off('transitionend');
        }
      })(this));

      $(trigger).replaceWith($(this.options[newLink])
        .on('click', (function(_this) {
            return function(event) {
              _this.toggle(this, element, event);
            };
          })(this))
        .attr({
          'data-readmore-toggle': $element.attr('id'),
          'aria-controls': $element.attr('id')
        }));
    },

    destroy: function() {
      $(this.element).each(function() {
        var current = $(this);

        current.attr({
          'data-readmore': null,
          'aria-expanded': null
        })
          .css({
            maxHeight: '',
            height: ''
          })
          .next('[data-readmore-toggle]')
          .remove();

        current.removeData();
      });
    }
  };


  $.fn.readmore = function(options) {
    var args = arguments,
        selector = this.selector;

    options = options || {};

    if (typeof options === 'object') {
      return this.each(function() {
        if ($.data(this, 'plugin_' + readmore)) {
          var instance = $.data(this, 'plugin_' + readmore);
          instance.destroy.apply(instance);
        }

        options.selector = selector;

        $.data(this, 'plugin_' + readmore, new Readmore(this, options));
      });
    }
    else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
      return this.each(function () {
        var instance = $.data(this, 'plugin_' + readmore);
        if (instance instanceof Readmore && typeof instance[options] === 'function') {
          instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }
      });
    }
  };

}));

/*global Greenhouse, documentReady */


















documentReady(function () {
  document.cookie = 'gh_tz=' + TimeZones.detect() + ';path=/';

  Tooltip.init();
  MoreInfo.init();
  Flash.fadeOutAfterDelay();

  prettyPrint();

  // For all cancel events, we want to kick the user back to the previous page
  $('#cancel').click(function () {
    Util.cancel();
  });

  $(window).resize(function () {
    $('.modal.ui-dialog-content').dialog('option', 'position', {
      my: 'center',
      at: 'center',
      of: window,
    });
  });

  if (Greenhouse.Translation.t && Greenhouse.Translation.tList) {
    // translate datepicker strings
    $.datepicker.setDefaults({
      closeText: Greenhouse.Translation.t('datepicker.closeText'),
      prevText: Greenhouse.Translation.t('datepicker.prevText'),
      nextText: Greenhouse.Translation.t('datepicker.nextText'),
      currentText: Greenhouse.Translation.t('datepicker.currentText'),
      weekHeader: Greenhouse.Translation.t('datepicker.weekHeader'),
      monthNames: Greenhouse.Translation.tList('date.month_names', null, true), // set month names
      monthNamesShort: Greenhouse.Translation.tList(
        'date.abbr_month_names',
        null,
        true
      ), // set short month names
      dayNames: Greenhouse.Translation.tList('date.day_names'), // set days names
      dayNamesShort: Greenhouse.Translation.tList('date.abbr_day_names'), // set short day names
      dayNamesMin: Greenhouse.Translation.tList('date.abbr_day_names_short'), // set more short days names
    });
  }
});

/**
 * Namespace defined for Form utils
 */
var FormUtil = {
  onEnterKey: function (elem, listener) {
    $(elem).on('keydown', function (e) {
      if (e.which === ENTER_KEY_CODE) {
        return listener(e);
      }
    });
  },
};

/**
 * Namespace defined for utility functions
 */
var Util = _.extend(Util || {}, {
  convertLtGtSymsToChar: function (text) {
    return text.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  },
  truncate: function (text, after_len) {
    return text.length > after_len
      ? text.substr(0, after_len - 3) + '...'
      : text;
  },
  // Returns the user to the previous page
  cancel: function () {
    history.back();
    return false;
  },
  /**
   * @param {Object} object
   * @param {String} methodName
   * @param {Array} args Arguments to be partially applied to method
   *
   * @return {Function}
   */
  bind: function (object, methodName, args) {
    var boundMethod = object[methodName].bind(object);
    return _.partial.apply(null, [boundMethod].concat(args));
  },
});

var View = {
  ClickableTable: {
    enforceSingleSelection: function (selector, callback) {
      var container = $(selector);
      // eslint-disable-next-line es5/no-es6-methods
      container.find('td, li').click(function () {
        // eslint-disable-next-line es5/no-es6-methods
        $.each(container.find('td, li'), function () {
          $(this).removeClass('selected');
        });
        $(this).addClass('selected');

        if (typeof callback === 'function') {
          callback.call(this);
        }
      });
    },
    reset: function (selector) {
      $(selector).find('td.selected, li.selected').removeClass('selected');
    },
    getSelection: function (selector) {
      return $(selector).find('td.selected, li.selected');
    },
    updateEmptyState: function (selector) {
      var wrapper = $(selector).parents('.clickable-wrapper');
      if ($(selector).find('td').length === 0) {
        wrapper.addClass('empty');
      } else {
        wrapper.removeClass('empty');
      }
    },
  },
};

/**
 * Fix issues where jQuery UI and TinyMCE/Select2 don't play nice with each other.
 * - Trying to insert a hyperlink while a modal was open would prevent the hyperlink modal's
 *   fields from being selectable.
 * - A select2 search box will not grab focus consistently.
 *
 * Sources:
 * - http://www.tinymce.com/develop/bugtracker_view.php?id=5917
 * - http://stackoverflow.com/a/18386569
 *
 * Updated for TinyMCE v5: https://www.tiny.cloud/docs/integrations/bootstrap/#usingtinymceinabootstrapdialog
 */
$.widget('ui.dialog', $.ui.dialog, {
  _allowInteraction: function (event) {
    return (
      !!$(event.target).closest(
        '.tox-tinymce, .tox-tinymce-aux, .moxman-container, .select2-drop'
      ).length || this._super(event)
    );
  },
});

/**
 * Patch $._evalUrl to always re-use the current page's nonce (but only for scripts on our CDN).
 *
 * Our legacy javascript has a pattern of using jQuery to fetch html from the server and add it to the page.
 * When that html includes script tags, jquery uses $._evalUrl to get the script contents via ajax and insert the
 * contents as an inline script tag (to ensure the scripts are evaluated synchronously).
 *
 * We want a strict CSP policy that does not allow inline scripts to run unless they have a nonce.
 *
 * $._evalUrl supports a nonce option to forward the nonce from the original node to the new inline script, but because
 * our html is fetched via xhr, the script tag from the ajax response has a different nonce than the original page's
 * policy.
 *
 * jQuery will stop transforming script tag with sources into inline scripts in the next major version (4.0) based on
 * this issue: https://github.com/jquery/jquery/issues/1895
 */
var oldEvalUrl = $._evalUrl;
$._evalUrl = function (url, options, doc) {
  var applicationEntrypoints = $('#application-entrypoint');
  if (applicationEntrypoints.length === 1) {
    var applicationEntrypoint = applicationEntrypoints[0];
    var isOurScript =
      new URL(applicationEntrypoint.src).hostname === new URL(url).hostname;
    if (isOurScript) {
      options.nonce = applicationEntrypoint.nonce;
    }
  }
  return oldEvalUrl(url, options, doc);
};
